(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) return;
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) processPreload(link);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") continue;
      for (const node of mutation.addedNodes) if (node.tagName === "LINK" && node.rel === "modulepreload") processPreload(node);
    }
  }).observe(document, {
    childList: true,
    subtree: true
  });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials") fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep) return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
function getDefaultExportFromCjs(x3) {
  return x3 && x3.__esModule && Object.prototype.hasOwnProperty.call(x3, "default") ? x3["default"] : x3;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
var react = { exports: {} };
var react_production_min = {};
var hasRequiredReact_production_min;
function requireReact_production_min() {
  if (hasRequiredReact_production_min) return react_production_min;
  hasRequiredReact_production_min = 1;
  var l2 = /* @__PURE__ */ Symbol.for("react.element"), n2 = /* @__PURE__ */ Symbol.for("react.portal"), p3 = /* @__PURE__ */ Symbol.for("react.fragment"), q2 = /* @__PURE__ */ Symbol.for("react.strict_mode"), r3 = /* @__PURE__ */ Symbol.for("react.profiler"), t2 = /* @__PURE__ */ Symbol.for("react.provider"), u2 = /* @__PURE__ */ Symbol.for("react.context"), v3 = /* @__PURE__ */ Symbol.for("react.forward_ref"), w2 = /* @__PURE__ */ Symbol.for("react.suspense"), x3 = /* @__PURE__ */ Symbol.for("react.memo"), y2 = /* @__PURE__ */ Symbol.for("react.lazy"), z2 = Symbol.iterator;
  function A2(a5) {
    if (null === a5 || "object" !== typeof a5) return null;
    a5 = z2 && a5[z2] || a5["@@iterator"];
    return "function" === typeof a5 ? a5 : null;
  }
  var B2 = { isMounted: function() {
    return false;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, C2 = Object.assign, D2 = {};
  function E2(a5, b6, e2) {
    this.props = a5;
    this.context = b6;
    this.refs = D2;
    this.updater = e2 || B2;
  }
  E2.prototype.isReactComponent = {};
  E2.prototype.setState = function(a5, b6) {
    if ("object" !== typeof a5 && "function" !== typeof a5 && null != a5) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a5, b6, "setState");
  };
  E2.prototype.forceUpdate = function(a5) {
    this.updater.enqueueForceUpdate(this, a5, "forceUpdate");
  };
  function F2() {
  }
  F2.prototype = E2.prototype;
  function G2(a5, b6, e2) {
    this.props = a5;
    this.context = b6;
    this.refs = D2;
    this.updater = e2 || B2;
  }
  var H3 = G2.prototype = new F2();
  H3.constructor = G2;
  C2(H3, E2.prototype);
  H3.isPureReactComponent = true;
  var I2 = Array.isArray, J2 = Object.prototype.hasOwnProperty, K2 = { current: null }, L2 = { key: true, ref: true, __self: true, __source: true };
  function M2(a5, b6, e2) {
    var d3, c2 = {}, k2 = null, h2 = null;
    if (null != b6) for (d3 in void 0 !== b6.ref && (h2 = b6.ref), void 0 !== b6.key && (k2 = "" + b6.key), b6) J2.call(b6, d3) && !L2.hasOwnProperty(d3) && (c2[d3] = b6[d3]);
    var g2 = arguments.length - 2;
    if (1 === g2) c2.children = e2;
    else if (1 < g2) {
      for (var f2 = Array(g2), m2 = 0; m2 < g2; m2++) f2[m2] = arguments[m2 + 2];
      c2.children = f2;
    }
    if (a5 && a5.defaultProps) for (d3 in g2 = a5.defaultProps, g2) void 0 === c2[d3] && (c2[d3] = g2[d3]);
    return { $$typeof: l2, type: a5, key: k2, ref: h2, props: c2, _owner: K2.current };
  }
  function N2(a5, b6) {
    return { $$typeof: l2, type: a5.type, key: b6, ref: a5.ref, props: a5.props, _owner: a5._owner };
  }
  function O3(a5) {
    return "object" === typeof a5 && null !== a5 && a5.$$typeof === l2;
  }
  function escape2(a5) {
    var b6 = { "=": "=0", ":": "=2" };
    return "$" + a5.replace(/[=:]/g, function(a6) {
      return b6[a6];
    });
  }
  var P3 = /\/+/g;
  function Q2(a5, b6) {
    return "object" === typeof a5 && null !== a5 && null != a5.key ? escape2("" + a5.key) : b6.toString(36);
  }
  function R2(a5, b6, e2, d3, c2) {
    var k2 = typeof a5;
    if ("undefined" === k2 || "boolean" === k2) a5 = null;
    var h2 = false;
    if (null === a5) h2 = true;
    else switch (k2) {
      case "string":
      case "number":
        h2 = true;
        break;
      case "object":
        switch (a5.$$typeof) {
          case l2:
          case n2:
            h2 = true;
        }
    }
    if (h2) return h2 = a5, c2 = c2(h2), a5 = "" === d3 ? "." + Q2(h2, 0) : d3, I2(c2) ? (e2 = "", null != a5 && (e2 = a5.replace(P3, "$&/") + "/"), R2(c2, b6, e2, "", function(a6) {
      return a6;
    })) : null != c2 && (O3(c2) && (c2 = N2(c2, e2 + (!c2.key || h2 && h2.key === c2.key ? "" : ("" + c2.key).replace(P3, "$&/") + "/") + a5)), b6.push(c2)), 1;
    h2 = 0;
    d3 = "" === d3 ? "." : d3 + ":";
    if (I2(a5)) for (var g2 = 0; g2 < a5.length; g2++) {
      k2 = a5[g2];
      var f2 = d3 + Q2(k2, g2);
      h2 += R2(k2, b6, e2, f2, c2);
    }
    else if (f2 = A2(a5), "function" === typeof f2) for (a5 = f2.call(a5), g2 = 0; !(k2 = a5.next()).done; ) k2 = k2.value, f2 = d3 + Q2(k2, g2++), h2 += R2(k2, b6, e2, f2, c2);
    else if ("object" === k2) throw b6 = String(a5), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b6 ? "object with keys {" + Object.keys(a5).join(", ") + "}" : b6) + "). If you meant to render a collection of children, use an array instead.");
    return h2;
  }
  function S2(a5, b6, e2) {
    if (null == a5) return a5;
    var d3 = [], c2 = 0;
    R2(a5, d3, "", "", function(a6) {
      return b6.call(e2, a6, c2++);
    });
    return d3;
  }
  function T2(a5) {
    if (-1 === a5._status) {
      var b6 = a5._result;
      b6 = b6();
      b6.then(function(b7) {
        if (0 === a5._status || -1 === a5._status) a5._status = 1, a5._result = b7;
      }, function(b7) {
        if (0 === a5._status || -1 === a5._status) a5._status = 2, a5._result = b7;
      });
      -1 === a5._status && (a5._status = 0, a5._result = b6);
    }
    if (1 === a5._status) return a5._result.default;
    throw a5._result;
  }
  var U2 = { current: null }, V3 = { transition: null }, W2 = { ReactCurrentDispatcher: U2, ReactCurrentBatchConfig: V3, ReactCurrentOwner: K2 };
  function X2() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  react_production_min.Children = { map: S2, forEach: function(a5, b6, e2) {
    S2(a5, function() {
      b6.apply(this, arguments);
    }, e2);
  }, count: function(a5) {
    var b6 = 0;
    S2(a5, function() {
      b6++;
    });
    return b6;
  }, toArray: function(a5) {
    return S2(a5, function(a6) {
      return a6;
    }) || [];
  }, only: function(a5) {
    if (!O3(a5)) throw Error("React.Children.only expected to receive a single React element child.");
    return a5;
  } };
  react_production_min.Component = E2;
  react_production_min.Fragment = p3;
  react_production_min.Profiler = r3;
  react_production_min.PureComponent = G2;
  react_production_min.StrictMode = q2;
  react_production_min.Suspense = w2;
  react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W2;
  react_production_min.act = X2;
  react_production_min.cloneElement = function(a5, b6, e2) {
    if (null === a5 || void 0 === a5) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a5 + ".");
    var d3 = C2({}, a5.props), c2 = a5.key, k2 = a5.ref, h2 = a5._owner;
    if (null != b6) {
      void 0 !== b6.ref && (k2 = b6.ref, h2 = K2.current);
      void 0 !== b6.key && (c2 = "" + b6.key);
      if (a5.type && a5.type.defaultProps) var g2 = a5.type.defaultProps;
      for (f2 in b6) J2.call(b6, f2) && !L2.hasOwnProperty(f2) && (d3[f2] = void 0 === b6[f2] && void 0 !== g2 ? g2[f2] : b6[f2]);
    }
    var f2 = arguments.length - 2;
    if (1 === f2) d3.children = e2;
    else if (1 < f2) {
      g2 = Array(f2);
      for (var m2 = 0; m2 < f2; m2++) g2[m2] = arguments[m2 + 2];
      d3.children = g2;
    }
    return { $$typeof: l2, type: a5.type, key: c2, ref: k2, props: d3, _owner: h2 };
  };
  react_production_min.createContext = function(a5) {
    a5 = { $$typeof: u2, _currentValue: a5, _currentValue2: a5, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null };
    a5.Provider = { $$typeof: t2, _context: a5 };
    return a5.Consumer = a5;
  };
  react_production_min.createElement = M2;
  react_production_min.createFactory = function(a5) {
    var b6 = M2.bind(null, a5);
    b6.type = a5;
    return b6;
  };
  react_production_min.createRef = function() {
    return { current: null };
  };
  react_production_min.forwardRef = function(a5) {
    return { $$typeof: v3, render: a5 };
  };
  react_production_min.isValidElement = O3;
  react_production_min.lazy = function(a5) {
    return { $$typeof: y2, _payload: { _status: -1, _result: a5 }, _init: T2 };
  };
  react_production_min.memo = function(a5, b6) {
    return { $$typeof: x3, type: a5, compare: void 0 === b6 ? null : b6 };
  };
  react_production_min.startTransition = function(a5) {
    var b6 = V3.transition;
    V3.transition = {};
    try {
      a5();
    } finally {
      V3.transition = b6;
    }
  };
  react_production_min.unstable_act = X2;
  react_production_min.useCallback = function(a5, b6) {
    return U2.current.useCallback(a5, b6);
  };
  react_production_min.useContext = function(a5) {
    return U2.current.useContext(a5);
  };
  react_production_min.useDebugValue = function() {
  };
  react_production_min.useDeferredValue = function(a5) {
    return U2.current.useDeferredValue(a5);
  };
  react_production_min.useEffect = function(a5, b6) {
    return U2.current.useEffect(a5, b6);
  };
  react_production_min.useId = function() {
    return U2.current.useId();
  };
  react_production_min.useImperativeHandle = function(a5, b6, e2) {
    return U2.current.useImperativeHandle(a5, b6, e2);
  };
  react_production_min.useInsertionEffect = function(a5, b6) {
    return U2.current.useInsertionEffect(a5, b6);
  };
  react_production_min.useLayoutEffect = function(a5, b6) {
    return U2.current.useLayoutEffect(a5, b6);
  };
  react_production_min.useMemo = function(a5, b6) {
    return U2.current.useMemo(a5, b6);
  };
  react_production_min.useReducer = function(a5, b6, e2) {
    return U2.current.useReducer(a5, b6, e2);
  };
  react_production_min.useRef = function(a5) {
    return U2.current.useRef(a5);
  };
  react_production_min.useState = function(a5) {
    return U2.current.useState(a5);
  };
  react_production_min.useSyncExternalStore = function(a5, b6, e2) {
    return U2.current.useSyncExternalStore(a5, b6, e2);
  };
  react_production_min.useTransition = function() {
    return U2.current.useTransition();
  };
  react_production_min.version = "18.3.1";
  return react_production_min;
}
var hasRequiredReact;
function requireReact() {
  if (hasRequiredReact) return react.exports;
  hasRequiredReact = 1;
  {
    react.exports = requireReact_production_min();
  }
  return react.exports;
}
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f2 = requireReact(), k2 = /* @__PURE__ */ Symbol.for("react.element"), l2 = /* @__PURE__ */ Symbol.for("react.fragment"), m2 = Object.prototype.hasOwnProperty, n2 = f2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p3 = { key: true, ref: true, __self: true, __source: true };
  function q2(c2, a5, g2) {
    var b6, d3 = {}, e2 = null, h2 = null;
    void 0 !== g2 && (e2 = "" + g2);
    void 0 !== a5.key && (e2 = "" + a5.key);
    void 0 !== a5.ref && (h2 = a5.ref);
    for (b6 in a5) m2.call(a5, b6) && !p3.hasOwnProperty(b6) && (d3[b6] = a5[b6]);
    if (c2 && c2.defaultProps) for (b6 in a5 = c2.defaultProps, a5) void 0 === d3[b6] && (d3[b6] = a5[b6]);
    return { $$typeof: k2, type: c2, key: e2, ref: h2, props: d3, _owner: n2.current };
  }
  reactJsxRuntime_production_min.Fragment = l2;
  reactJsxRuntime_production_min.jsx = q2;
  reactJsxRuntime_production_min.jsxs = q2;
  return reactJsxRuntime_production_min;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
var reactExports = requireReact();
const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
var client = {};
var reactDom = { exports: {} };
var reactDom_production_min = {};
var scheduler$1 = { exports: {} };
var scheduler_production_min$1 = {};
var hasRequiredScheduler_production_min$1;
function requireScheduler_production_min$1() {
  if (hasRequiredScheduler_production_min$1) return scheduler_production_min$1;
  hasRequiredScheduler_production_min$1 = 1;
  (function(exports$1) {
    function f2(a5, b6) {
      var c2 = a5.length;
      a5.push(b6);
      a: for (; 0 < c2; ) {
        var d3 = c2 - 1 >>> 1, e2 = a5[d3];
        if (0 < g2(e2, b6)) a5[d3] = b6, a5[c2] = e2, c2 = d3;
        else break a;
      }
    }
    function h2(a5) {
      return 0 === a5.length ? null : a5[0];
    }
    function k2(a5) {
      if (0 === a5.length) return null;
      var b6 = a5[0], c2 = a5.pop();
      if (c2 !== b6) {
        a5[0] = c2;
        a: for (var d3 = 0, e2 = a5.length, w2 = e2 >>> 1; d3 < w2; ) {
          var m2 = 2 * (d3 + 1) - 1, C2 = a5[m2], n2 = m2 + 1, x3 = a5[n2];
          if (0 > g2(C2, c2)) n2 < e2 && 0 > g2(x3, C2) ? (a5[d3] = x3, a5[n2] = c2, d3 = n2) : (a5[d3] = C2, a5[m2] = c2, d3 = m2);
          else if (n2 < e2 && 0 > g2(x3, c2)) a5[d3] = x3, a5[n2] = c2, d3 = n2;
          else break a;
        }
      }
      return b6;
    }
    function g2(a5, b6) {
      var c2 = a5.sortIndex - b6.sortIndex;
      return 0 !== c2 ? c2 : a5.id - b6.id;
    }
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var l2 = performance;
      exports$1.unstable_now = function() {
        return l2.now();
      };
    } else {
      var p3 = Date, q2 = p3.now();
      exports$1.unstable_now = function() {
        return p3.now() - q2;
      };
    }
    var r3 = [], t2 = [], u2 = 1, v3 = null, y2 = 3, z2 = false, A2 = false, B2 = false, D2 = "function" === typeof setTimeout ? setTimeout : null, E2 = "function" === typeof clearTimeout ? clearTimeout : null, F2 = "undefined" !== typeof setImmediate ? setImmediate : null;
    "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function G2(a5) {
      for (var b6 = h2(t2); null !== b6; ) {
        if (null === b6.callback) k2(t2);
        else if (b6.startTime <= a5) k2(t2), b6.sortIndex = b6.expirationTime, f2(r3, b6);
        else break;
        b6 = h2(t2);
      }
    }
    function H3(a5) {
      B2 = false;
      G2(a5);
      if (!A2) if (null !== h2(r3)) A2 = true, I2(J2);
      else {
        var b6 = h2(t2);
        null !== b6 && K2(H3, b6.startTime - a5);
      }
    }
    function J2(a5, b6) {
      A2 = false;
      B2 && (B2 = false, E2(L2), L2 = -1);
      z2 = true;
      var c2 = y2;
      try {
        G2(b6);
        for (v3 = h2(r3); null !== v3 && (!(v3.expirationTime > b6) || a5 && !M2()); ) {
          var d3 = v3.callback;
          if ("function" === typeof d3) {
            v3.callback = null;
            y2 = v3.priorityLevel;
            var e2 = d3(v3.expirationTime <= b6);
            b6 = exports$1.unstable_now();
            "function" === typeof e2 ? v3.callback = e2 : v3 === h2(r3) && k2(r3);
            G2(b6);
          } else k2(r3);
          v3 = h2(r3);
        }
        if (null !== v3) var w2 = true;
        else {
          var m2 = h2(t2);
          null !== m2 && K2(H3, m2.startTime - b6);
          w2 = false;
        }
        return w2;
      } finally {
        v3 = null, y2 = c2, z2 = false;
      }
    }
    var N2 = false, O3 = null, L2 = -1, P3 = 5, Q2 = -1;
    function M2() {
      return exports$1.unstable_now() - Q2 < P3 ? false : true;
    }
    function R2() {
      if (null !== O3) {
        var a5 = exports$1.unstable_now();
        Q2 = a5;
        var b6 = true;
        try {
          b6 = O3(true, a5);
        } finally {
          b6 ? S2() : (N2 = false, O3 = null);
        }
      } else N2 = false;
    }
    var S2;
    if ("function" === typeof F2) S2 = function() {
      F2(R2);
    };
    else if ("undefined" !== typeof MessageChannel) {
      var T2 = new MessageChannel(), U2 = T2.port2;
      T2.port1.onmessage = R2;
      S2 = function() {
        U2.postMessage(null);
      };
    } else S2 = function() {
      D2(R2, 0);
    };
    function I2(a5) {
      O3 = a5;
      N2 || (N2 = true, S2());
    }
    function K2(a5, b6) {
      L2 = D2(function() {
        a5(exports$1.unstable_now());
      }, b6);
    }
    exports$1.unstable_IdlePriority = 5;
    exports$1.unstable_ImmediatePriority = 1;
    exports$1.unstable_LowPriority = 4;
    exports$1.unstable_NormalPriority = 3;
    exports$1.unstable_Profiling = null;
    exports$1.unstable_UserBlockingPriority = 2;
    exports$1.unstable_cancelCallback = function(a5) {
      a5.callback = null;
    };
    exports$1.unstable_continueExecution = function() {
      A2 || z2 || (A2 = true, I2(J2));
    };
    exports$1.unstable_forceFrameRate = function(a5) {
      0 > a5 || 125 < a5 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P3 = 0 < a5 ? Math.floor(1e3 / a5) : 5;
    };
    exports$1.unstable_getCurrentPriorityLevel = function() {
      return y2;
    };
    exports$1.unstable_getFirstCallbackNode = function() {
      return h2(r3);
    };
    exports$1.unstable_next = function(a5) {
      switch (y2) {
        case 1:
        case 2:
        case 3:
          var b6 = 3;
          break;
        default:
          b6 = y2;
      }
      var c2 = y2;
      y2 = b6;
      try {
        return a5();
      } finally {
        y2 = c2;
      }
    };
    exports$1.unstable_pauseExecution = function() {
    };
    exports$1.unstable_requestPaint = function() {
    };
    exports$1.unstable_runWithPriority = function(a5, b6) {
      switch (a5) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          a5 = 3;
      }
      var c2 = y2;
      y2 = a5;
      try {
        return b6();
      } finally {
        y2 = c2;
      }
    };
    exports$1.unstable_scheduleCallback = function(a5, b6, c2) {
      var d3 = exports$1.unstable_now();
      "object" === typeof c2 && null !== c2 ? (c2 = c2.delay, c2 = "number" === typeof c2 && 0 < c2 ? d3 + c2 : d3) : c2 = d3;
      switch (a5) {
        case 1:
          var e2 = -1;
          break;
        case 2:
          e2 = 250;
          break;
        case 5:
          e2 = 1073741823;
          break;
        case 4:
          e2 = 1e4;
          break;
        default:
          e2 = 5e3;
      }
      e2 = c2 + e2;
      a5 = { id: u2++, callback: b6, priorityLevel: a5, startTime: c2, expirationTime: e2, sortIndex: -1 };
      c2 > d3 ? (a5.sortIndex = c2, f2(t2, a5), null === h2(r3) && a5 === h2(t2) && (B2 ? (E2(L2), L2 = -1) : B2 = true, K2(H3, c2 - d3))) : (a5.sortIndex = e2, f2(r3, a5), A2 || z2 || (A2 = true, I2(J2)));
      return a5;
    };
    exports$1.unstable_shouldYield = M2;
    exports$1.unstable_wrapCallback = function(a5) {
      var b6 = y2;
      return function() {
        var c2 = y2;
        y2 = b6;
        try {
          return a5.apply(this, arguments);
        } finally {
          y2 = c2;
        }
      };
    };
  })(scheduler_production_min$1);
  return scheduler_production_min$1;
}
var hasRequiredScheduler$1;
function requireScheduler$1() {
  if (hasRequiredScheduler$1) return scheduler$1.exports;
  hasRequiredScheduler$1 = 1;
  {
    scheduler$1.exports = requireScheduler_production_min$1();
  }
  return scheduler$1.exports;
}
var hasRequiredReactDom_production_min;
function requireReactDom_production_min() {
  if (hasRequiredReactDom_production_min) return reactDom_production_min;
  hasRequiredReactDom_production_min = 1;
  var aa = requireReact(), ca = requireScheduler$1();
  function p3(a5) {
    for (var b6 = "https://reactjs.org/docs/error-decoder.html?invariant=" + a5, c2 = 1; c2 < arguments.length; c2++) b6 += "&args[]=" + encodeURIComponent(arguments[c2]);
    return "Minified React error #" + a5 + "; visit " + b6 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var da = /* @__PURE__ */ new Set(), ea = {};
  function fa(a5, b6) {
    ha(a5, b6);
    ha(a5 + "Capture", b6);
  }
  function ha(a5, b6) {
    ea[a5] = b6;
    for (a5 = 0; a5 < b6.length; a5++) da.add(b6[a5]);
  }
  var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
  function oa(a5) {
    if (ja.call(ma, a5)) return true;
    if (ja.call(la, a5)) return false;
    if (ka.test(a5)) return ma[a5] = true;
    la[a5] = true;
    return false;
  }
  function pa(a5, b6, c2, d3) {
    if (null !== c2 && 0 === c2.type) return false;
    switch (typeof b6) {
      case "function":
      case "symbol":
        return true;
      case "boolean":
        if (d3) return false;
        if (null !== c2) return !c2.acceptsBooleans;
        a5 = a5.toLowerCase().slice(0, 5);
        return "data-" !== a5 && "aria-" !== a5;
      default:
        return false;
    }
  }
  function qa(a5, b6, c2, d3) {
    if (null === b6 || "undefined" === typeof b6 || pa(a5, b6, c2, d3)) return true;
    if (d3) return false;
    if (null !== c2) switch (c2.type) {
      case 3:
        return !b6;
      case 4:
        return false === b6;
      case 5:
        return isNaN(b6);
      case 6:
        return isNaN(b6) || 1 > b6;
    }
    return false;
  }
  function v3(a5, b6, c2, d3, e2, f2, g2) {
    this.acceptsBooleans = 2 === b6 || 3 === b6 || 4 === b6;
    this.attributeName = d3;
    this.attributeNamespace = e2;
    this.mustUseProperty = c2;
    this.propertyName = a5;
    this.type = b6;
    this.sanitizeURL = f2;
    this.removeEmptyString = g2;
  }
  var z2 = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a5) {
    z2[a5] = new v3(a5, 0, false, a5, null, false, false);
  });
  [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a5) {
    var b6 = a5[0];
    z2[b6] = new v3(b6, 1, false, a5[1], null, false, false);
  });
  ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a5) {
    z2[a5] = new v3(a5, 2, false, a5.toLowerCase(), null, false, false);
  });
  ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a5) {
    z2[a5] = new v3(a5, 2, false, a5, null, false, false);
  });
  "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a5) {
    z2[a5] = new v3(a5, 3, false, a5.toLowerCase(), null, false, false);
  });
  ["checked", "multiple", "muted", "selected"].forEach(function(a5) {
    z2[a5] = new v3(a5, 3, true, a5, null, false, false);
  });
  ["capture", "download"].forEach(function(a5) {
    z2[a5] = new v3(a5, 4, false, a5, null, false, false);
  });
  ["cols", "rows", "size", "span"].forEach(function(a5) {
    z2[a5] = new v3(a5, 6, false, a5, null, false, false);
  });
  ["rowSpan", "start"].forEach(function(a5) {
    z2[a5] = new v3(a5, 5, false, a5.toLowerCase(), null, false, false);
  });
  var ra = /[\-:]([a-z])/g;
  function sa(a5) {
    return a5[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a5) {
    var b6 = a5.replace(
      ra,
      sa
    );
    z2[b6] = new v3(b6, 1, false, a5, null, false, false);
  });
  "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a5) {
    var b6 = a5.replace(ra, sa);
    z2[b6] = new v3(b6, 1, false, a5, "http://www.w3.org/1999/xlink", false, false);
  });
  ["xml:base", "xml:lang", "xml:space"].forEach(function(a5) {
    var b6 = a5.replace(ra, sa);
    z2[b6] = new v3(b6, 1, false, a5, "http://www.w3.org/XML/1998/namespace", false, false);
  });
  ["tabIndex", "crossOrigin"].forEach(function(a5) {
    z2[a5] = new v3(a5, 1, false, a5.toLowerCase(), null, false, false);
  });
  z2.xlinkHref = new v3("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
  ["src", "href", "action", "formAction"].forEach(function(a5) {
    z2[a5] = new v3(a5, 1, false, a5.toLowerCase(), null, true, true);
  });
  function ta(a5, b6, c2, d3) {
    var e2 = z2.hasOwnProperty(b6) ? z2[b6] : null;
    if (null !== e2 ? 0 !== e2.type : d3 || !(2 < b6.length) || "o" !== b6[0] && "O" !== b6[0] || "n" !== b6[1] && "N" !== b6[1]) qa(b6, c2, e2, d3) && (c2 = null), d3 || null === e2 ? oa(b6) && (null === c2 ? a5.removeAttribute(b6) : a5.setAttribute(b6, "" + c2)) : e2.mustUseProperty ? a5[e2.propertyName] = null === c2 ? 3 === e2.type ? false : "" : c2 : (b6 = e2.attributeName, d3 = e2.attributeNamespace, null === c2 ? a5.removeAttribute(b6) : (e2 = e2.type, c2 = 3 === e2 || 4 === e2 && true === c2 ? "" : "" + c2, d3 ? a5.setAttributeNS(d3, b6, c2) : a5.setAttribute(b6, c2)));
  }
  var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = /* @__PURE__ */ Symbol.for("react.element"), wa = /* @__PURE__ */ Symbol.for("react.portal"), ya = /* @__PURE__ */ Symbol.for("react.fragment"), za = /* @__PURE__ */ Symbol.for("react.strict_mode"), Aa = /* @__PURE__ */ Symbol.for("react.profiler"), Ba = /* @__PURE__ */ Symbol.for("react.provider"), Ca = /* @__PURE__ */ Symbol.for("react.context"), Da = /* @__PURE__ */ Symbol.for("react.forward_ref"), Ea = /* @__PURE__ */ Symbol.for("react.suspense"), Fa = /* @__PURE__ */ Symbol.for("react.suspense_list"), Ga = /* @__PURE__ */ Symbol.for("react.memo"), Ha = /* @__PURE__ */ Symbol.for("react.lazy");
  var Ia = /* @__PURE__ */ Symbol.for("react.offscreen");
  var Ja = Symbol.iterator;
  function Ka(a5) {
    if (null === a5 || "object" !== typeof a5) return null;
    a5 = Ja && a5[Ja] || a5["@@iterator"];
    return "function" === typeof a5 ? a5 : null;
  }
  var A2 = Object.assign, La;
  function Ma(a5) {
    if (void 0 === La) try {
      throw Error();
    } catch (c2) {
      var b6 = c2.stack.trim().match(/\n( *(at )?)/);
      La = b6 && b6[1] || "";
    }
    return "\n" + La + a5;
  }
  var Na = false;
  function Oa(a5, b6) {
    if (!a5 || Na) return "";
    Na = true;
    var c2 = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (b6) if (b6 = function() {
        throw Error();
      }, Object.defineProperty(b6.prototype, "props", { set: function() {
        throw Error();
      } }), "object" === typeof Reflect && Reflect.construct) {
        try {
          Reflect.construct(b6, []);
        } catch (l2) {
          var d3 = l2;
        }
        Reflect.construct(a5, [], b6);
      } else {
        try {
          b6.call();
        } catch (l2) {
          d3 = l2;
        }
        a5.call(b6.prototype);
      }
      else {
        try {
          throw Error();
        } catch (l2) {
          d3 = l2;
        }
        a5();
      }
    } catch (l2) {
      if (l2 && d3 && "string" === typeof l2.stack) {
        for (var e2 = l2.stack.split("\n"), f2 = d3.stack.split("\n"), g2 = e2.length - 1, h2 = f2.length - 1; 1 <= g2 && 0 <= h2 && e2[g2] !== f2[h2]; ) h2--;
        for (; 1 <= g2 && 0 <= h2; g2--, h2--) if (e2[g2] !== f2[h2]) {
          if (1 !== g2 || 1 !== h2) {
            do
              if (g2--, h2--, 0 > h2 || e2[g2] !== f2[h2]) {
                var k2 = "\n" + e2[g2].replace(" at new ", " at ");
                a5.displayName && k2.includes("<anonymous>") && (k2 = k2.replace("<anonymous>", a5.displayName));
                return k2;
              }
            while (1 <= g2 && 0 <= h2);
          }
          break;
        }
      }
    } finally {
      Na = false, Error.prepareStackTrace = c2;
    }
    return (a5 = a5 ? a5.displayName || a5.name : "") ? Ma(a5) : "";
  }
  function Pa(a5) {
    switch (a5.tag) {
      case 5:
        return Ma(a5.type);
      case 16:
        return Ma("Lazy");
      case 13:
        return Ma("Suspense");
      case 19:
        return Ma("SuspenseList");
      case 0:
      case 2:
      case 15:
        return a5 = Oa(a5.type, false), a5;
      case 11:
        return a5 = Oa(a5.type.render, false), a5;
      case 1:
        return a5 = Oa(a5.type, true), a5;
      default:
        return "";
    }
  }
  function Qa(a5) {
    if (null == a5) return null;
    if ("function" === typeof a5) return a5.displayName || a5.name || null;
    if ("string" === typeof a5) return a5;
    switch (a5) {
      case ya:
        return "Fragment";
      case wa:
        return "Portal";
      case Aa:
        return "Profiler";
      case za:
        return "StrictMode";
      case Ea:
        return "Suspense";
      case Fa:
        return "SuspenseList";
    }
    if ("object" === typeof a5) switch (a5.$$typeof) {
      case Ca:
        return (a5.displayName || "Context") + ".Consumer";
      case Ba:
        return (a5._context.displayName || "Context") + ".Provider";
      case Da:
        var b6 = a5.render;
        a5 = a5.displayName;
        a5 || (a5 = b6.displayName || b6.name || "", a5 = "" !== a5 ? "ForwardRef(" + a5 + ")" : "ForwardRef");
        return a5;
      case Ga:
        return b6 = a5.displayName || null, null !== b6 ? b6 : Qa(a5.type) || "Memo";
      case Ha:
        b6 = a5._payload;
        a5 = a5._init;
        try {
          return Qa(a5(b6));
        } catch (c2) {
        }
    }
    return null;
  }
  function Ra(a5) {
    var b6 = a5.type;
    switch (a5.tag) {
      case 24:
        return "Cache";
      case 9:
        return (b6.displayName || "Context") + ".Consumer";
      case 10:
        return (b6._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return a5 = b6.render, a5 = a5.displayName || a5.name || "", b6.displayName || ("" !== a5 ? "ForwardRef(" + a5 + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return b6;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Qa(b6);
      case 8:
        return b6 === za ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if ("function" === typeof b6) return b6.displayName || b6.name || null;
        if ("string" === typeof b6) return b6;
    }
    return null;
  }
  function Sa(a5) {
    switch (typeof a5) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return a5;
      case "object":
        return a5;
      default:
        return "";
    }
  }
  function Ta(a5) {
    var b6 = a5.type;
    return (a5 = a5.nodeName) && "input" === a5.toLowerCase() && ("checkbox" === b6 || "radio" === b6);
  }
  function Ua(a5) {
    var b6 = Ta(a5) ? "checked" : "value", c2 = Object.getOwnPropertyDescriptor(a5.constructor.prototype, b6), d3 = "" + a5[b6];
    if (!a5.hasOwnProperty(b6) && "undefined" !== typeof c2 && "function" === typeof c2.get && "function" === typeof c2.set) {
      var e2 = c2.get, f2 = c2.set;
      Object.defineProperty(a5, b6, { configurable: true, get: function() {
        return e2.call(this);
      }, set: function(a6) {
        d3 = "" + a6;
        f2.call(this, a6);
      } });
      Object.defineProperty(a5, b6, { enumerable: c2.enumerable });
      return { getValue: function() {
        return d3;
      }, setValue: function(a6) {
        d3 = "" + a6;
      }, stopTracking: function() {
        a5._valueTracker = null;
        delete a5[b6];
      } };
    }
  }
  function Va(a5) {
    a5._valueTracker || (a5._valueTracker = Ua(a5));
  }
  function Wa(a5) {
    if (!a5) return false;
    var b6 = a5._valueTracker;
    if (!b6) return true;
    var c2 = b6.getValue();
    var d3 = "";
    a5 && (d3 = Ta(a5) ? a5.checked ? "true" : "false" : a5.value);
    a5 = d3;
    return a5 !== c2 ? (b6.setValue(a5), true) : false;
  }
  function Xa(a5) {
    a5 = a5 || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a5) return null;
    try {
      return a5.activeElement || a5.body;
    } catch (b6) {
      return a5.body;
    }
  }
  function Ya(a5, b6) {
    var c2 = b6.checked;
    return A2({}, b6, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c2 ? c2 : a5._wrapperState.initialChecked });
  }
  function Za(a5, b6) {
    var c2 = null == b6.defaultValue ? "" : b6.defaultValue, d3 = null != b6.checked ? b6.checked : b6.defaultChecked;
    c2 = Sa(null != b6.value ? b6.value : c2);
    a5._wrapperState = { initialChecked: d3, initialValue: c2, controlled: "checkbox" === b6.type || "radio" === b6.type ? null != b6.checked : null != b6.value };
  }
  function ab(a5, b6) {
    b6 = b6.checked;
    null != b6 && ta(a5, "checked", b6, false);
  }
  function bb(a5, b6) {
    ab(a5, b6);
    var c2 = Sa(b6.value), d3 = b6.type;
    if (null != c2) if ("number" === d3) {
      if (0 === c2 && "" === a5.value || a5.value != c2) a5.value = "" + c2;
    } else a5.value !== "" + c2 && (a5.value = "" + c2);
    else if ("submit" === d3 || "reset" === d3) {
      a5.removeAttribute("value");
      return;
    }
    b6.hasOwnProperty("value") ? cb(a5, b6.type, c2) : b6.hasOwnProperty("defaultValue") && cb(a5, b6.type, Sa(b6.defaultValue));
    null == b6.checked && null != b6.defaultChecked && (a5.defaultChecked = !!b6.defaultChecked);
  }
  function db(a5, b6, c2) {
    if (b6.hasOwnProperty("value") || b6.hasOwnProperty("defaultValue")) {
      var d3 = b6.type;
      if (!("submit" !== d3 && "reset" !== d3 || void 0 !== b6.value && null !== b6.value)) return;
      b6 = "" + a5._wrapperState.initialValue;
      c2 || b6 === a5.value || (a5.value = b6);
      a5.defaultValue = b6;
    }
    c2 = a5.name;
    "" !== c2 && (a5.name = "");
    a5.defaultChecked = !!a5._wrapperState.initialChecked;
    "" !== c2 && (a5.name = c2);
  }
  function cb(a5, b6, c2) {
    if ("number" !== b6 || Xa(a5.ownerDocument) !== a5) null == c2 ? a5.defaultValue = "" + a5._wrapperState.initialValue : a5.defaultValue !== "" + c2 && (a5.defaultValue = "" + c2);
  }
  var eb = Array.isArray;
  function fb(a5, b6, c2, d3) {
    a5 = a5.options;
    if (b6) {
      b6 = {};
      for (var e2 = 0; e2 < c2.length; e2++) b6["$" + c2[e2]] = true;
      for (c2 = 0; c2 < a5.length; c2++) e2 = b6.hasOwnProperty("$" + a5[c2].value), a5[c2].selected !== e2 && (a5[c2].selected = e2), e2 && d3 && (a5[c2].defaultSelected = true);
    } else {
      c2 = "" + Sa(c2);
      b6 = null;
      for (e2 = 0; e2 < a5.length; e2++) {
        if (a5[e2].value === c2) {
          a5[e2].selected = true;
          d3 && (a5[e2].defaultSelected = true);
          return;
        }
        null !== b6 || a5[e2].disabled || (b6 = a5[e2]);
      }
      null !== b6 && (b6.selected = true);
    }
  }
  function gb(a5, b6) {
    if (null != b6.dangerouslySetInnerHTML) throw Error(p3(91));
    return A2({}, b6, { value: void 0, defaultValue: void 0, children: "" + a5._wrapperState.initialValue });
  }
  function hb(a5, b6) {
    var c2 = b6.value;
    if (null == c2) {
      c2 = b6.children;
      b6 = b6.defaultValue;
      if (null != c2) {
        if (null != b6) throw Error(p3(92));
        if (eb(c2)) {
          if (1 < c2.length) throw Error(p3(93));
          c2 = c2[0];
        }
        b6 = c2;
      }
      null == b6 && (b6 = "");
      c2 = b6;
    }
    a5._wrapperState = { initialValue: Sa(c2) };
  }
  function ib(a5, b6) {
    var c2 = Sa(b6.value), d3 = Sa(b6.defaultValue);
    null != c2 && (c2 = "" + c2, c2 !== a5.value && (a5.value = c2), null == b6.defaultValue && a5.defaultValue !== c2 && (a5.defaultValue = c2));
    null != d3 && (a5.defaultValue = "" + d3);
  }
  function jb(a5) {
    var b6 = a5.textContent;
    b6 === a5._wrapperState.initialValue && "" !== b6 && null !== b6 && (a5.value = b6);
  }
  function kb(a5) {
    switch (a5) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function lb(a5, b6) {
    return null == a5 || "http://www.w3.org/1999/xhtml" === a5 ? kb(b6) : "http://www.w3.org/2000/svg" === a5 && "foreignObject" === b6 ? "http://www.w3.org/1999/xhtml" : a5;
  }
  var mb, nb = (function(a5) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b6, c2, d3, e2) {
      MSApp.execUnsafeLocalFunction(function() {
        return a5(b6, c2, d3, e2);
      });
    } : a5;
  })(function(a5, b6) {
    if ("http://www.w3.org/2000/svg" !== a5.namespaceURI || "innerHTML" in a5) a5.innerHTML = b6;
    else {
      mb = mb || document.createElement("div");
      mb.innerHTML = "<svg>" + b6.valueOf().toString() + "</svg>";
      for (b6 = mb.firstChild; a5.firstChild; ) a5.removeChild(a5.firstChild);
      for (; b6.firstChild; ) a5.appendChild(b6.firstChild);
    }
  });
  function ob(a5, b6) {
    if (b6) {
      var c2 = a5.firstChild;
      if (c2 && c2 === a5.lastChild && 3 === c2.nodeType) {
        c2.nodeValue = b6;
        return;
      }
    }
    a5.textContent = b6;
  }
  var pb = {
    animationIterationCount: true,
    aspectRatio: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridArea: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
  }, qb = ["Webkit", "ms", "Moz", "O"];
  Object.keys(pb).forEach(function(a5) {
    qb.forEach(function(b6) {
      b6 = b6 + a5.charAt(0).toUpperCase() + a5.substring(1);
      pb[b6] = pb[a5];
    });
  });
  function rb(a5, b6, c2) {
    return null == b6 || "boolean" === typeof b6 || "" === b6 ? "" : c2 || "number" !== typeof b6 || 0 === b6 || pb.hasOwnProperty(a5) && pb[a5] ? ("" + b6).trim() : b6 + "px";
  }
  function sb(a5, b6) {
    a5 = a5.style;
    for (var c2 in b6) if (b6.hasOwnProperty(c2)) {
      var d3 = 0 === c2.indexOf("--"), e2 = rb(c2, b6[c2], d3);
      "float" === c2 && (c2 = "cssFloat");
      d3 ? a5.setProperty(c2, e2) : a5[c2] = e2;
    }
  }
  var tb = A2({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
  function ub(a5, b6) {
    if (b6) {
      if (tb[a5] && (null != b6.children || null != b6.dangerouslySetInnerHTML)) throw Error(p3(137, a5));
      if (null != b6.dangerouslySetInnerHTML) {
        if (null != b6.children) throw Error(p3(60));
        if ("object" !== typeof b6.dangerouslySetInnerHTML || !("__html" in b6.dangerouslySetInnerHTML)) throw Error(p3(61));
      }
      if (null != b6.style && "object" !== typeof b6.style) throw Error(p3(62));
    }
  }
  function vb(a5, b6) {
    if (-1 === a5.indexOf("-")) return "string" === typeof b6.is;
    switch (a5) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return false;
      default:
        return true;
    }
  }
  var wb = null;
  function xb(a5) {
    a5 = a5.target || a5.srcElement || window;
    a5.correspondingUseElement && (a5 = a5.correspondingUseElement);
    return 3 === a5.nodeType ? a5.parentNode : a5;
  }
  var yb = null, zb = null, Ab = null;
  function Bb(a5) {
    if (a5 = Cb(a5)) {
      if ("function" !== typeof yb) throw Error(p3(280));
      var b6 = a5.stateNode;
      b6 && (b6 = Db(b6), yb(a5.stateNode, a5.type, b6));
    }
  }
  function Eb(a5) {
    zb ? Ab ? Ab.push(a5) : Ab = [a5] : zb = a5;
  }
  function Fb() {
    if (zb) {
      var a5 = zb, b6 = Ab;
      Ab = zb = null;
      Bb(a5);
      if (b6) for (a5 = 0; a5 < b6.length; a5++) Bb(b6[a5]);
    }
  }
  function Gb(a5, b6) {
    return a5(b6);
  }
  function Hb() {
  }
  var Ib = false;
  function Jb(a5, b6, c2) {
    if (Ib) return a5(b6, c2);
    Ib = true;
    try {
      return Gb(a5, b6, c2);
    } finally {
      if (Ib = false, null !== zb || null !== Ab) Hb(), Fb();
    }
  }
  function Kb(a5, b6) {
    var c2 = a5.stateNode;
    if (null === c2) return null;
    var d3 = Db(c2);
    if (null === d3) return null;
    c2 = d3[b6];
    a: switch (b6) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d3 = !d3.disabled) || (a5 = a5.type, d3 = !("button" === a5 || "input" === a5 || "select" === a5 || "textarea" === a5));
        a5 = !d3;
        break a;
      default:
        a5 = false;
    }
    if (a5) return null;
    if (c2 && "function" !== typeof c2) throw Error(p3(231, b6, typeof c2));
    return c2;
  }
  var Lb = false;
  if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", { get: function() {
      Lb = true;
    } });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
  } catch (a5) {
    Lb = false;
  }
  function Nb(a5, b6, c2, d3, e2, f2, g2, h2, k2) {
    var l2 = Array.prototype.slice.call(arguments, 3);
    try {
      b6.apply(c2, l2);
    } catch (m2) {
      this.onError(m2);
    }
  }
  var Ob = false, Pb = null, Qb = false, Rb = null, Sb = { onError: function(a5) {
    Ob = true;
    Pb = a5;
  } };
  function Tb(a5, b6, c2, d3, e2, f2, g2, h2, k2) {
    Ob = false;
    Pb = null;
    Nb.apply(Sb, arguments);
  }
  function Ub(a5, b6, c2, d3, e2, f2, g2, h2, k2) {
    Tb.apply(this, arguments);
    if (Ob) {
      if (Ob) {
        var l2 = Pb;
        Ob = false;
        Pb = null;
      } else throw Error(p3(198));
      Qb || (Qb = true, Rb = l2);
    }
  }
  function Vb(a5) {
    var b6 = a5, c2 = a5;
    if (a5.alternate) for (; b6.return; ) b6 = b6.return;
    else {
      a5 = b6;
      do
        b6 = a5, 0 !== (b6.flags & 4098) && (c2 = b6.return), a5 = b6.return;
      while (a5);
    }
    return 3 === b6.tag ? c2 : null;
  }
  function Wb(a5) {
    if (13 === a5.tag) {
      var b6 = a5.memoizedState;
      null === b6 && (a5 = a5.alternate, null !== a5 && (b6 = a5.memoizedState));
      if (null !== b6) return b6.dehydrated;
    }
    return null;
  }
  function Xb(a5) {
    if (Vb(a5) !== a5) throw Error(p3(188));
  }
  function Yb(a5) {
    var b6 = a5.alternate;
    if (!b6) {
      b6 = Vb(a5);
      if (null === b6) throw Error(p3(188));
      return b6 !== a5 ? null : a5;
    }
    for (var c2 = a5, d3 = b6; ; ) {
      var e2 = c2.return;
      if (null === e2) break;
      var f2 = e2.alternate;
      if (null === f2) {
        d3 = e2.return;
        if (null !== d3) {
          c2 = d3;
          continue;
        }
        break;
      }
      if (e2.child === f2.child) {
        for (f2 = e2.child; f2; ) {
          if (f2 === c2) return Xb(e2), a5;
          if (f2 === d3) return Xb(e2), b6;
          f2 = f2.sibling;
        }
        throw Error(p3(188));
      }
      if (c2.return !== d3.return) c2 = e2, d3 = f2;
      else {
        for (var g2 = false, h2 = e2.child; h2; ) {
          if (h2 === c2) {
            g2 = true;
            c2 = e2;
            d3 = f2;
            break;
          }
          if (h2 === d3) {
            g2 = true;
            d3 = e2;
            c2 = f2;
            break;
          }
          h2 = h2.sibling;
        }
        if (!g2) {
          for (h2 = f2.child; h2; ) {
            if (h2 === c2) {
              g2 = true;
              c2 = f2;
              d3 = e2;
              break;
            }
            if (h2 === d3) {
              g2 = true;
              d3 = f2;
              c2 = e2;
              break;
            }
            h2 = h2.sibling;
          }
          if (!g2) throw Error(p3(189));
        }
      }
      if (c2.alternate !== d3) throw Error(p3(190));
    }
    if (3 !== c2.tag) throw Error(p3(188));
    return c2.stateNode.current === c2 ? a5 : b6;
  }
  function Zb(a5) {
    a5 = Yb(a5);
    return null !== a5 ? $b(a5) : null;
  }
  function $b(a5) {
    if (5 === a5.tag || 6 === a5.tag) return a5;
    for (a5 = a5.child; null !== a5; ) {
      var b6 = $b(a5);
      if (null !== b6) return b6;
      a5 = a5.sibling;
    }
    return null;
  }
  var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B2 = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
  function mc(a5) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
      lc.onCommitFiberRoot(kc, a5, void 0, 128 === (a5.current.flags & 128));
    } catch (b6) {
    }
  }
  var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
  function nc(a5) {
    a5 >>>= 0;
    return 0 === a5 ? 32 : 31 - (pc(a5) / qc | 0) | 0;
  }
  var rc = 64, sc = 4194304;
  function tc(a5) {
    switch (a5 & -a5) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a5 & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return a5 & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return a5;
    }
  }
  function uc(a5, b6) {
    var c2 = a5.pendingLanes;
    if (0 === c2) return 0;
    var d3 = 0, e2 = a5.suspendedLanes, f2 = a5.pingedLanes, g2 = c2 & 268435455;
    if (0 !== g2) {
      var h2 = g2 & ~e2;
      0 !== h2 ? d3 = tc(h2) : (f2 &= g2, 0 !== f2 && (d3 = tc(f2)));
    } else g2 = c2 & ~e2, 0 !== g2 ? d3 = tc(g2) : 0 !== f2 && (d3 = tc(f2));
    if (0 === d3) return 0;
    if (0 !== b6 && b6 !== d3 && 0 === (b6 & e2) && (e2 = d3 & -d3, f2 = b6 & -b6, e2 >= f2 || 16 === e2 && 0 !== (f2 & 4194240))) return b6;
    0 !== (d3 & 4) && (d3 |= c2 & 16);
    b6 = a5.entangledLanes;
    if (0 !== b6) for (a5 = a5.entanglements, b6 &= d3; 0 < b6; ) c2 = 31 - oc(b6), e2 = 1 << c2, d3 |= a5[c2], b6 &= ~e2;
    return d3;
  }
  function vc(a5, b6) {
    switch (a5) {
      case 1:
      case 2:
      case 4:
        return b6 + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return b6 + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function wc(a5, b6) {
    for (var c2 = a5.suspendedLanes, d3 = a5.pingedLanes, e2 = a5.expirationTimes, f2 = a5.pendingLanes; 0 < f2; ) {
      var g2 = 31 - oc(f2), h2 = 1 << g2, k2 = e2[g2];
      if (-1 === k2) {
        if (0 === (h2 & c2) || 0 !== (h2 & d3)) e2[g2] = vc(h2, b6);
      } else k2 <= b6 && (a5.expiredLanes |= h2);
      f2 &= ~h2;
    }
  }
  function xc(a5) {
    a5 = a5.pendingLanes & -1073741825;
    return 0 !== a5 ? a5 : a5 & 1073741824 ? 1073741824 : 0;
  }
  function yc() {
    var a5 = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a5;
  }
  function zc(a5) {
    for (var b6 = [], c2 = 0; 31 > c2; c2++) b6.push(a5);
    return b6;
  }
  function Ac(a5, b6, c2) {
    a5.pendingLanes |= b6;
    536870912 !== b6 && (a5.suspendedLanes = 0, a5.pingedLanes = 0);
    a5 = a5.eventTimes;
    b6 = 31 - oc(b6);
    a5[b6] = c2;
  }
  function Bc(a5, b6) {
    var c2 = a5.pendingLanes & ~b6;
    a5.pendingLanes = b6;
    a5.suspendedLanes = 0;
    a5.pingedLanes = 0;
    a5.expiredLanes &= b6;
    a5.mutableReadLanes &= b6;
    a5.entangledLanes &= b6;
    b6 = a5.entanglements;
    var d3 = a5.eventTimes;
    for (a5 = a5.expirationTimes; 0 < c2; ) {
      var e2 = 31 - oc(c2), f2 = 1 << e2;
      b6[e2] = 0;
      d3[e2] = -1;
      a5[e2] = -1;
      c2 &= ~f2;
    }
  }
  function Cc(a5, b6) {
    var c2 = a5.entangledLanes |= b6;
    for (a5 = a5.entanglements; c2; ) {
      var d3 = 31 - oc(c2), e2 = 1 << d3;
      e2 & b6 | a5[d3] & b6 && (a5[d3] |= b6);
      c2 &= ~e2;
    }
  }
  var C2 = 0;
  function Dc(a5) {
    a5 &= -a5;
    return 1 < a5 ? 4 < a5 ? 0 !== (a5 & 268435455) ? 16 : 536870912 : 4 : 1;
  }
  var Ec, Fc, Gc, Hc, Ic, Jc = false, Kc = [], Lc = null, Mc = null, Nc = null, Oc = /* @__PURE__ */ new Map(), Pc = /* @__PURE__ */ new Map(), Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Sc(a5, b6) {
    switch (a5) {
      case "focusin":
      case "focusout":
        Lc = null;
        break;
      case "dragenter":
      case "dragleave":
        Mc = null;
        break;
      case "mouseover":
      case "mouseout":
        Nc = null;
        break;
      case "pointerover":
      case "pointerout":
        Oc.delete(b6.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Pc.delete(b6.pointerId);
    }
  }
  function Tc(a5, b6, c2, d3, e2, f2) {
    if (null === a5 || a5.nativeEvent !== f2) return a5 = { blockedOn: b6, domEventName: c2, eventSystemFlags: d3, nativeEvent: f2, targetContainers: [e2] }, null !== b6 && (b6 = Cb(b6), null !== b6 && Fc(b6)), a5;
    a5.eventSystemFlags |= d3;
    b6 = a5.targetContainers;
    null !== e2 && -1 === b6.indexOf(e2) && b6.push(e2);
    return a5;
  }
  function Uc(a5, b6, c2, d3, e2) {
    switch (b6) {
      case "focusin":
        return Lc = Tc(Lc, a5, b6, c2, d3, e2), true;
      case "dragenter":
        return Mc = Tc(Mc, a5, b6, c2, d3, e2), true;
      case "mouseover":
        return Nc = Tc(Nc, a5, b6, c2, d3, e2), true;
      case "pointerover":
        var f2 = e2.pointerId;
        Oc.set(f2, Tc(Oc.get(f2) || null, a5, b6, c2, d3, e2));
        return true;
      case "gotpointercapture":
        return f2 = e2.pointerId, Pc.set(f2, Tc(Pc.get(f2) || null, a5, b6, c2, d3, e2)), true;
    }
    return false;
  }
  function Vc(a5) {
    var b6 = Wc(a5.target);
    if (null !== b6) {
      var c2 = Vb(b6);
      if (null !== c2) {
        if (b6 = c2.tag, 13 === b6) {
          if (b6 = Wb(c2), null !== b6) {
            a5.blockedOn = b6;
            Ic(a5.priority, function() {
              Gc(c2);
            });
            return;
          }
        } else if (3 === b6 && c2.stateNode.current.memoizedState.isDehydrated) {
          a5.blockedOn = 3 === c2.tag ? c2.stateNode.containerInfo : null;
          return;
        }
      }
    }
    a5.blockedOn = null;
  }
  function Xc(a5) {
    if (null !== a5.blockedOn) return false;
    for (var b6 = a5.targetContainers; 0 < b6.length; ) {
      var c2 = Yc(a5.domEventName, a5.eventSystemFlags, b6[0], a5.nativeEvent);
      if (null === c2) {
        c2 = a5.nativeEvent;
        var d3 = new c2.constructor(c2.type, c2);
        wb = d3;
        c2.target.dispatchEvent(d3);
        wb = null;
      } else return b6 = Cb(c2), null !== b6 && Fc(b6), a5.blockedOn = c2, false;
      b6.shift();
    }
    return true;
  }
  function Zc(a5, b6, c2) {
    Xc(a5) && c2.delete(b6);
  }
  function $c() {
    Jc = false;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
  }
  function ad(a5, b6) {
    a5.blockedOn === b6 && (a5.blockedOn = null, Jc || (Jc = true, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
  }
  function bd(a5) {
    function b6(b7) {
      return ad(b7, a5);
    }
    if (0 < Kc.length) {
      ad(Kc[0], a5);
      for (var c2 = 1; c2 < Kc.length; c2++) {
        var d3 = Kc[c2];
        d3.blockedOn === a5 && (d3.blockedOn = null);
      }
    }
    null !== Lc && ad(Lc, a5);
    null !== Mc && ad(Mc, a5);
    null !== Nc && ad(Nc, a5);
    Oc.forEach(b6);
    Pc.forEach(b6);
    for (c2 = 0; c2 < Qc.length; c2++) d3 = Qc[c2], d3.blockedOn === a5 && (d3.blockedOn = null);
    for (; 0 < Qc.length && (c2 = Qc[0], null === c2.blockedOn); ) Vc(c2), null === c2.blockedOn && Qc.shift();
  }
  var cd = ua.ReactCurrentBatchConfig, dd = true;
  function ed(a5, b6, c2, d3) {
    var e2 = C2, f2 = cd.transition;
    cd.transition = null;
    try {
      C2 = 1, fd2(a5, b6, c2, d3);
    } finally {
      C2 = e2, cd.transition = f2;
    }
  }
  function gd(a5, b6, c2, d3) {
    var e2 = C2, f2 = cd.transition;
    cd.transition = null;
    try {
      C2 = 4, fd2(a5, b6, c2, d3);
    } finally {
      C2 = e2, cd.transition = f2;
    }
  }
  function fd2(a5, b6, c2, d3) {
    if (dd) {
      var e2 = Yc(a5, b6, c2, d3);
      if (null === e2) hd(a5, b6, d3, id, c2), Sc(a5, d3);
      else if (Uc(e2, a5, b6, c2, d3)) d3.stopPropagation();
      else if (Sc(a5, d3), b6 & 4 && -1 < Rc.indexOf(a5)) {
        for (; null !== e2; ) {
          var f2 = Cb(e2);
          null !== f2 && Ec(f2);
          f2 = Yc(a5, b6, c2, d3);
          null === f2 && hd(a5, b6, d3, id, c2);
          if (f2 === e2) break;
          e2 = f2;
        }
        null !== e2 && d3.stopPropagation();
      } else hd(a5, b6, d3, null, c2);
    }
  }
  var id = null;
  function Yc(a5, b6, c2, d3) {
    id = null;
    a5 = xb(d3);
    a5 = Wc(a5);
    if (null !== a5) if (b6 = Vb(a5), null === b6) a5 = null;
    else if (c2 = b6.tag, 13 === c2) {
      a5 = Wb(b6);
      if (null !== a5) return a5;
      a5 = null;
    } else if (3 === c2) {
      if (b6.stateNode.current.memoizedState.isDehydrated) return 3 === b6.tag ? b6.stateNode.containerInfo : null;
      a5 = null;
    } else b6 !== a5 && (a5 = null);
    id = a5;
    return null;
  }
  function jd(a5) {
    switch (a5) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (ec()) {
          case fc:
            return 1;
          case gc:
            return 4;
          case hc:
          case ic:
            return 16;
          case jc:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var kd = null, ld = null, md = null;
  function nd() {
    if (md) return md;
    var a5, b6 = ld, c2 = b6.length, d3, e2 = "value" in kd ? kd.value : kd.textContent, f2 = e2.length;
    for (a5 = 0; a5 < c2 && b6[a5] === e2[a5]; a5++) ;
    var g2 = c2 - a5;
    for (d3 = 1; d3 <= g2 && b6[c2 - d3] === e2[f2 - d3]; d3++) ;
    return md = e2.slice(a5, 1 < d3 ? 1 - d3 : void 0);
  }
  function od(a5) {
    var b6 = a5.keyCode;
    "charCode" in a5 ? (a5 = a5.charCode, 0 === a5 && 13 === b6 && (a5 = 13)) : a5 = b6;
    10 === a5 && (a5 = 13);
    return 32 <= a5 || 13 === a5 ? a5 : 0;
  }
  function pd() {
    return true;
  }
  function qd() {
    return false;
  }
  function rd(a5) {
    function b6(b7, d3, e2, f2, g2) {
      this._reactName = b7;
      this._targetInst = e2;
      this.type = d3;
      this.nativeEvent = f2;
      this.target = g2;
      this.currentTarget = null;
      for (var c2 in a5) a5.hasOwnProperty(c2) && (b7 = a5[c2], this[c2] = b7 ? b7(f2) : f2[c2]);
      this.isDefaultPrevented = (null != f2.defaultPrevented ? f2.defaultPrevented : false === f2.returnValue) ? pd : qd;
      this.isPropagationStopped = qd;
      return this;
    }
    A2(b6.prototype, { preventDefault: function() {
      this.defaultPrevented = true;
      var a6 = this.nativeEvent;
      a6 && (a6.preventDefault ? a6.preventDefault() : "unknown" !== typeof a6.returnValue && (a6.returnValue = false), this.isDefaultPrevented = pd);
    }, stopPropagation: function() {
      var a6 = this.nativeEvent;
      a6 && (a6.stopPropagation ? a6.stopPropagation() : "unknown" !== typeof a6.cancelBubble && (a6.cancelBubble = true), this.isPropagationStopped = pd);
    }, persist: function() {
    }, isPersistent: pd });
    return b6;
  }
  var sd = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a5) {
    return a5.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, td2 = rd(sd), ud = A2({}, sd, { view: 0, detail: 0 }), vd = rd(ud), wd, xd, yd, Ad = A2({}, ud, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: zd, button: 0, buttons: 0, relatedTarget: function(a5) {
    return void 0 === a5.relatedTarget ? a5.fromElement === a5.srcElement ? a5.toElement : a5.fromElement : a5.relatedTarget;
  }, movementX: function(a5) {
    if ("movementX" in a5) return a5.movementX;
    a5 !== yd && (yd && "mousemove" === a5.type ? (wd = a5.screenX - yd.screenX, xd = a5.screenY - yd.screenY) : xd = wd = 0, yd = a5);
    return wd;
  }, movementY: function(a5) {
    return "movementY" in a5 ? a5.movementY : xd;
  } }), Bd = rd(Ad), Cd = A2({}, Ad, { dataTransfer: 0 }), Dd = rd(Cd), Ed = A2({}, ud, { relatedTarget: 0 }), Fd = rd(Ed), Gd = A2({}, sd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Hd = rd(Gd), Id = A2({}, sd, { clipboardData: function(a5) {
    return "clipboardData" in a5 ? a5.clipboardData : window.clipboardData;
  } }), Jd = rd(Id), Kd = A2({}, sd, { data: 0 }), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Od = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function Pd(a5) {
    var b6 = this.nativeEvent;
    return b6.getModifierState ? b6.getModifierState(a5) : (a5 = Od[a5]) ? !!b6[a5] : false;
  }
  function zd() {
    return Pd;
  }
  var Qd = A2({}, ud, { key: function(a5) {
    if (a5.key) {
      var b6 = Md[a5.key] || a5.key;
      if ("Unidentified" !== b6) return b6;
    }
    return "keypress" === a5.type ? (a5 = od(a5), 13 === a5 ? "Enter" : String.fromCharCode(a5)) : "keydown" === a5.type || "keyup" === a5.type ? Nd[a5.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: zd, charCode: function(a5) {
    return "keypress" === a5.type ? od(a5) : 0;
  }, keyCode: function(a5) {
    return "keydown" === a5.type || "keyup" === a5.type ? a5.keyCode : 0;
  }, which: function(a5) {
    return "keypress" === a5.type ? od(a5) : "keydown" === a5.type || "keyup" === a5.type ? a5.keyCode : 0;
  } }), Rd = rd(Qd), Sd = A2({}, Ad, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Td = rd(Sd), Ud = A2({}, ud, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: zd }), Vd = rd(Ud), Wd = A2({}, sd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Xd = rd(Wd), Yd = A2({}, Ad, {
    deltaX: function(a5) {
      return "deltaX" in a5 ? a5.deltaX : "wheelDeltaX" in a5 ? -a5.wheelDeltaX : 0;
    },
    deltaY: function(a5) {
      return "deltaY" in a5 ? a5.deltaY : "wheelDeltaY" in a5 ? -a5.wheelDeltaY : "wheelDelta" in a5 ? -a5.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Zd = rd(Yd), $d = [9, 13, 27, 32], ae = ia && "CompositionEvent" in window, be = null;
  ia && "documentMode" in document && (be = document.documentMode);
  var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = false;
  function ge(a5, b6) {
    switch (a5) {
      case "keyup":
        return -1 !== $d.indexOf(b6.keyCode);
      case "keydown":
        return 229 !== b6.keyCode;
      case "keypress":
      case "mousedown":
      case "focusout":
        return true;
      default:
        return false;
    }
  }
  function he(a5) {
    a5 = a5.detail;
    return "object" === typeof a5 && "data" in a5 ? a5.data : null;
  }
  var ie = false;
  function je(a5, b6) {
    switch (a5) {
      case "compositionend":
        return he(b6);
      case "keypress":
        if (32 !== b6.which) return null;
        fe = true;
        return ee;
      case "textInput":
        return a5 = b6.data, a5 === ee && fe ? null : a5;
      default:
        return null;
    }
  }
  function ke(a5, b6) {
    if (ie) return "compositionend" === a5 || !ae && ge(a5, b6) ? (a5 = nd(), md = ld = kd = null, ie = false, a5) : null;
    switch (a5) {
      case "paste":
        return null;
      case "keypress":
        if (!(b6.ctrlKey || b6.altKey || b6.metaKey) || b6.ctrlKey && b6.altKey) {
          if (b6.char && 1 < b6.char.length) return b6.char;
          if (b6.which) return String.fromCharCode(b6.which);
        }
        return null;
      case "compositionend":
        return de && "ko" !== b6.locale ? null : b6.data;
      default:
        return null;
    }
  }
  var le = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
  function me(a5) {
    var b6 = a5 && a5.nodeName && a5.nodeName.toLowerCase();
    return "input" === b6 ? !!le[a5.type] : "textarea" === b6 ? true : false;
  }
  function ne(a5, b6, c2, d3) {
    Eb(d3);
    b6 = oe(b6, "onChange");
    0 < b6.length && (c2 = new td2("onChange", "change", null, c2, d3), a5.push({ event: c2, listeners: b6 }));
  }
  var pe = null, qe = null;
  function re2(a5) {
    se(a5, 0);
  }
  function te(a5) {
    var b6 = ue(a5);
    if (Wa(b6)) return a5;
  }
  function ve(a5, b6) {
    if ("change" === a5) return b6;
  }
  var we = false;
  if (ia) {
    var xe;
    if (ia) {
      var ye = "oninput" in document;
      if (!ye) {
        var ze = document.createElement("div");
        ze.setAttribute("oninput", "return;");
        ye = "function" === typeof ze.oninput;
      }
      xe = ye;
    } else xe = false;
    we = xe && (!document.documentMode || 9 < document.documentMode);
  }
  function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
  }
  function Be(a5) {
    if ("value" === a5.propertyName && te(qe)) {
      var b6 = [];
      ne(b6, qe, a5, xb(a5));
      Jb(re2, b6);
    }
  }
  function Ce(a5, b6, c2) {
    "focusin" === a5 ? (Ae(), pe = b6, qe = c2, pe.attachEvent("onpropertychange", Be)) : "focusout" === a5 && Ae();
  }
  function De(a5) {
    if ("selectionchange" === a5 || "keyup" === a5 || "keydown" === a5) return te(qe);
  }
  function Ee(a5, b6) {
    if ("click" === a5) return te(b6);
  }
  function Fe(a5, b6) {
    if ("input" === a5 || "change" === a5) return te(b6);
  }
  function Ge(a5, b6) {
    return a5 === b6 && (0 !== a5 || 1 / a5 === 1 / b6) || a5 !== a5 && b6 !== b6;
  }
  var He = "function" === typeof Object.is ? Object.is : Ge;
  function Ie(a5, b6) {
    if (He(a5, b6)) return true;
    if ("object" !== typeof a5 || null === a5 || "object" !== typeof b6 || null === b6) return false;
    var c2 = Object.keys(a5), d3 = Object.keys(b6);
    if (c2.length !== d3.length) return false;
    for (d3 = 0; d3 < c2.length; d3++) {
      var e2 = c2[d3];
      if (!ja.call(b6, e2) || !He(a5[e2], b6[e2])) return false;
    }
    return true;
  }
  function Je(a5) {
    for (; a5 && a5.firstChild; ) a5 = a5.firstChild;
    return a5;
  }
  function Ke(a5, b6) {
    var c2 = Je(a5);
    a5 = 0;
    for (var d3; c2; ) {
      if (3 === c2.nodeType) {
        d3 = a5 + c2.textContent.length;
        if (a5 <= b6 && d3 >= b6) return { node: c2, offset: b6 - a5 };
        a5 = d3;
      }
      a: {
        for (; c2; ) {
          if (c2.nextSibling) {
            c2 = c2.nextSibling;
            break a;
          }
          c2 = c2.parentNode;
        }
        c2 = void 0;
      }
      c2 = Je(c2);
    }
  }
  function Le(a5, b6) {
    return a5 && b6 ? a5 === b6 ? true : a5 && 3 === a5.nodeType ? false : b6 && 3 === b6.nodeType ? Le(a5, b6.parentNode) : "contains" in a5 ? a5.contains(b6) : a5.compareDocumentPosition ? !!(a5.compareDocumentPosition(b6) & 16) : false : false;
  }
  function Me() {
    for (var a5 = window, b6 = Xa(); b6 instanceof a5.HTMLIFrameElement; ) {
      try {
        var c2 = "string" === typeof b6.contentWindow.location.href;
      } catch (d3) {
        c2 = false;
      }
      if (c2) a5 = b6.contentWindow;
      else break;
      b6 = Xa(a5.document);
    }
    return b6;
  }
  function Ne(a5) {
    var b6 = a5 && a5.nodeName && a5.nodeName.toLowerCase();
    return b6 && ("input" === b6 && ("text" === a5.type || "search" === a5.type || "tel" === a5.type || "url" === a5.type || "password" === a5.type) || "textarea" === b6 || "true" === a5.contentEditable);
  }
  function Oe(a5) {
    var b6 = Me(), c2 = a5.focusedElem, d3 = a5.selectionRange;
    if (b6 !== c2 && c2 && c2.ownerDocument && Le(c2.ownerDocument.documentElement, c2)) {
      if (null !== d3 && Ne(c2)) {
        if (b6 = d3.start, a5 = d3.end, void 0 === a5 && (a5 = b6), "selectionStart" in c2) c2.selectionStart = b6, c2.selectionEnd = Math.min(a5, c2.value.length);
        else if (a5 = (b6 = c2.ownerDocument || document) && b6.defaultView || window, a5.getSelection) {
          a5 = a5.getSelection();
          var e2 = c2.textContent.length, f2 = Math.min(d3.start, e2);
          d3 = void 0 === d3.end ? f2 : Math.min(d3.end, e2);
          !a5.extend && f2 > d3 && (e2 = d3, d3 = f2, f2 = e2);
          e2 = Ke(c2, f2);
          var g2 = Ke(
            c2,
            d3
          );
          e2 && g2 && (1 !== a5.rangeCount || a5.anchorNode !== e2.node || a5.anchorOffset !== e2.offset || a5.focusNode !== g2.node || a5.focusOffset !== g2.offset) && (b6 = b6.createRange(), b6.setStart(e2.node, e2.offset), a5.removeAllRanges(), f2 > d3 ? (a5.addRange(b6), a5.extend(g2.node, g2.offset)) : (b6.setEnd(g2.node, g2.offset), a5.addRange(b6)));
        }
      }
      b6 = [];
      for (a5 = c2; a5 = a5.parentNode; ) 1 === a5.nodeType && b6.push({ element: a5, left: a5.scrollLeft, top: a5.scrollTop });
      "function" === typeof c2.focus && c2.focus();
      for (c2 = 0; c2 < b6.length; c2++) a5 = b6[c2], a5.element.scrollLeft = a5.left, a5.element.scrollTop = a5.top;
    }
  }
  var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = false;
  function Ue(a5, b6, c2) {
    var d3 = c2.window === c2 ? c2.document : 9 === c2.nodeType ? c2 : c2.ownerDocument;
    Te || null == Qe || Qe !== Xa(d3) || (d3 = Qe, "selectionStart" in d3 && Ne(d3) ? d3 = { start: d3.selectionStart, end: d3.selectionEnd } : (d3 = (d3.ownerDocument && d3.ownerDocument.defaultView || window).getSelection(), d3 = { anchorNode: d3.anchorNode, anchorOffset: d3.anchorOffset, focusNode: d3.focusNode, focusOffset: d3.focusOffset }), Se && Ie(Se, d3) || (Se = d3, d3 = oe(Re, "onSelect"), 0 < d3.length && (b6 = new td2("onSelect", "select", null, b6, c2), a5.push({ event: b6, listeners: d3 }), b6.target = Qe)));
  }
  function Ve(a5, b6) {
    var c2 = {};
    c2[a5.toLowerCase()] = b6.toLowerCase();
    c2["Webkit" + a5] = "webkit" + b6;
    c2["Moz" + a5] = "moz" + b6;
    return c2;
  }
  var We = { animationend: Ve("Animation", "AnimationEnd"), animationiteration: Ve("Animation", "AnimationIteration"), animationstart: Ve("Animation", "AnimationStart"), transitionend: Ve("Transition", "TransitionEnd") }, Xe = {}, Ye = {};
  ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
  function Ze(a5) {
    if (Xe[a5]) return Xe[a5];
    if (!We[a5]) return a5;
    var b6 = We[a5], c2;
    for (c2 in b6) if (b6.hasOwnProperty(c2) && c2 in Ye) return Xe[a5] = b6[c2];
    return a5;
  }
  var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = /* @__PURE__ */ new Map(), ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ff(a5, b6) {
    df.set(a5, b6);
    fa(b6, [a5]);
  }
  for (var gf = 0; gf < ef.length; gf++) {
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
  }
  ff($e, "onAnimationEnd");
  ff(af, "onAnimationIteration");
  ff(bf, "onAnimationStart");
  ff("dblclick", "onDoubleClick");
  ff("focusin", "onFocus");
  ff("focusout", "onBlur");
  ff(cf, "onTransitionEnd");
  ha("onMouseEnter", ["mouseout", "mouseover"]);
  ha("onMouseLeave", ["mouseout", "mouseover"]);
  ha("onPointerEnter", ["pointerout", "pointerover"]);
  ha("onPointerLeave", ["pointerout", "pointerover"]);
  fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
  fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
  fa("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
  fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
  fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
  fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
  function nf(a5, b6, c2) {
    var d3 = a5.type || "unknown-event";
    a5.currentTarget = c2;
    Ub(d3, b6, void 0, a5);
    a5.currentTarget = null;
  }
  function se(a5, b6) {
    b6 = 0 !== (b6 & 4);
    for (var c2 = 0; c2 < a5.length; c2++) {
      var d3 = a5[c2], e2 = d3.event;
      d3 = d3.listeners;
      a: {
        var f2 = void 0;
        if (b6) for (var g2 = d3.length - 1; 0 <= g2; g2--) {
          var h2 = d3[g2], k2 = h2.instance, l2 = h2.currentTarget;
          h2 = h2.listener;
          if (k2 !== f2 && e2.isPropagationStopped()) break a;
          nf(e2, h2, l2);
          f2 = k2;
        }
        else for (g2 = 0; g2 < d3.length; g2++) {
          h2 = d3[g2];
          k2 = h2.instance;
          l2 = h2.currentTarget;
          h2 = h2.listener;
          if (k2 !== f2 && e2.isPropagationStopped()) break a;
          nf(e2, h2, l2);
          f2 = k2;
        }
      }
    }
    if (Qb) throw a5 = Rb, Qb = false, Rb = null, a5;
  }
  function D2(a5, b6) {
    var c2 = b6[of];
    void 0 === c2 && (c2 = b6[of] = /* @__PURE__ */ new Set());
    var d3 = a5 + "__bubble";
    c2.has(d3) || (pf(b6, a5, 2, false), c2.add(d3));
  }
  function qf(a5, b6, c2) {
    var d3 = 0;
    b6 && (d3 |= 4);
    pf(c2, a5, d3, b6);
  }
  var rf = "_reactListening" + Math.random().toString(36).slice(2);
  function sf(a5) {
    if (!a5[rf]) {
      a5[rf] = true;
      da.forEach(function(b7) {
        "selectionchange" !== b7 && (mf.has(b7) || qf(b7, false, a5), qf(b7, true, a5));
      });
      var b6 = 9 === a5.nodeType ? a5 : a5.ownerDocument;
      null === b6 || b6[rf] || (b6[rf] = true, qf("selectionchange", false, b6));
    }
  }
  function pf(a5, b6, c2, d3) {
    switch (jd(b6)) {
      case 1:
        var e2 = ed;
        break;
      case 4:
        e2 = gd;
        break;
      default:
        e2 = fd2;
    }
    c2 = e2.bind(null, b6, c2, a5);
    e2 = void 0;
    !Lb || "touchstart" !== b6 && "touchmove" !== b6 && "wheel" !== b6 || (e2 = true);
    d3 ? void 0 !== e2 ? a5.addEventListener(b6, c2, { capture: true, passive: e2 }) : a5.addEventListener(b6, c2, true) : void 0 !== e2 ? a5.addEventListener(b6, c2, { passive: e2 }) : a5.addEventListener(b6, c2, false);
  }
  function hd(a5, b6, c2, d3, e2) {
    var f2 = d3;
    if (0 === (b6 & 1) && 0 === (b6 & 2) && null !== d3) a: for (; ; ) {
      if (null === d3) return;
      var g2 = d3.tag;
      if (3 === g2 || 4 === g2) {
        var h2 = d3.stateNode.containerInfo;
        if (h2 === e2 || 8 === h2.nodeType && h2.parentNode === e2) break;
        if (4 === g2) for (g2 = d3.return; null !== g2; ) {
          var k2 = g2.tag;
          if (3 === k2 || 4 === k2) {
            if (k2 = g2.stateNode.containerInfo, k2 === e2 || 8 === k2.nodeType && k2.parentNode === e2) return;
          }
          g2 = g2.return;
        }
        for (; null !== h2; ) {
          g2 = Wc(h2);
          if (null === g2) return;
          k2 = g2.tag;
          if (5 === k2 || 6 === k2) {
            d3 = f2 = g2;
            continue a;
          }
          h2 = h2.parentNode;
        }
      }
      d3 = d3.return;
    }
    Jb(function() {
      var d5 = f2, e3 = xb(c2), g3 = [];
      a: {
        var h3 = df.get(a5);
        if (void 0 !== h3) {
          var k3 = td2, n2 = a5;
          switch (a5) {
            case "keypress":
              if (0 === od(c2)) break a;
            case "keydown":
            case "keyup":
              k3 = Rd;
              break;
            case "focusin":
              n2 = "focus";
              k3 = Fd;
              break;
            case "focusout":
              n2 = "blur";
              k3 = Fd;
              break;
            case "beforeblur":
            case "afterblur":
              k3 = Fd;
              break;
            case "click":
              if (2 === c2.button) break a;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              k3 = Bd;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              k3 = Dd;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              k3 = Vd;
              break;
            case $e:
            case af:
            case bf:
              k3 = Hd;
              break;
            case cf:
              k3 = Xd;
              break;
            case "scroll":
              k3 = vd;
              break;
            case "wheel":
              k3 = Zd;
              break;
            case "copy":
            case "cut":
            case "paste":
              k3 = Jd;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              k3 = Td;
          }
          var t2 = 0 !== (b6 & 4), J2 = !t2 && "scroll" === a5, x3 = t2 ? null !== h3 ? h3 + "Capture" : null : h3;
          t2 = [];
          for (var w2 = d5, u2; null !== w2; ) {
            u2 = w2;
            var F2 = u2.stateNode;
            5 === u2.tag && null !== F2 && (u2 = F2, null !== x3 && (F2 = Kb(w2, x3), null != F2 && t2.push(tf(w2, F2, u2))));
            if (J2) break;
            w2 = w2.return;
          }
          0 < t2.length && (h3 = new k3(h3, n2, null, c2, e3), g3.push({ event: h3, listeners: t2 }));
        }
      }
      if (0 === (b6 & 7)) {
        a: {
          h3 = "mouseover" === a5 || "pointerover" === a5;
          k3 = "mouseout" === a5 || "pointerout" === a5;
          if (h3 && c2 !== wb && (n2 = c2.relatedTarget || c2.fromElement) && (Wc(n2) || n2[uf])) break a;
          if (k3 || h3) {
            h3 = e3.window === e3 ? e3 : (h3 = e3.ownerDocument) ? h3.defaultView || h3.parentWindow : window;
            if (k3) {
              if (n2 = c2.relatedTarget || c2.toElement, k3 = d5, n2 = n2 ? Wc(n2) : null, null !== n2 && (J2 = Vb(n2), n2 !== J2 || 5 !== n2.tag && 6 !== n2.tag)) n2 = null;
            } else k3 = null, n2 = d5;
            if (k3 !== n2) {
              t2 = Bd;
              F2 = "onMouseLeave";
              x3 = "onMouseEnter";
              w2 = "mouse";
              if ("pointerout" === a5 || "pointerover" === a5) t2 = Td, F2 = "onPointerLeave", x3 = "onPointerEnter", w2 = "pointer";
              J2 = null == k3 ? h3 : ue(k3);
              u2 = null == n2 ? h3 : ue(n2);
              h3 = new t2(F2, w2 + "leave", k3, c2, e3);
              h3.target = J2;
              h3.relatedTarget = u2;
              F2 = null;
              Wc(e3) === d5 && (t2 = new t2(x3, w2 + "enter", n2, c2, e3), t2.target = u2, t2.relatedTarget = J2, F2 = t2);
              J2 = F2;
              if (k3 && n2) b: {
                t2 = k3;
                x3 = n2;
                w2 = 0;
                for (u2 = t2; u2; u2 = vf(u2)) w2++;
                u2 = 0;
                for (F2 = x3; F2; F2 = vf(F2)) u2++;
                for (; 0 < w2 - u2; ) t2 = vf(t2), w2--;
                for (; 0 < u2 - w2; ) x3 = vf(x3), u2--;
                for (; w2--; ) {
                  if (t2 === x3 || null !== x3 && t2 === x3.alternate) break b;
                  t2 = vf(t2);
                  x3 = vf(x3);
                }
                t2 = null;
              }
              else t2 = null;
              null !== k3 && wf(g3, h3, k3, t2, false);
              null !== n2 && null !== J2 && wf(g3, J2, n2, t2, true);
            }
          }
        }
        a: {
          h3 = d5 ? ue(d5) : window;
          k3 = h3.nodeName && h3.nodeName.toLowerCase();
          if ("select" === k3 || "input" === k3 && "file" === h3.type) var na = ve;
          else if (me(h3)) if (we) na = Fe;
          else {
            na = De;
            var xa = Ce;
          }
          else (k3 = h3.nodeName) && "input" === k3.toLowerCase() && ("checkbox" === h3.type || "radio" === h3.type) && (na = Ee);
          if (na && (na = na(a5, d5))) {
            ne(g3, na, c2, e3);
            break a;
          }
          xa && xa(a5, h3, d5);
          "focusout" === a5 && (xa = h3._wrapperState) && xa.controlled && "number" === h3.type && cb(h3, "number", h3.value);
        }
        xa = d5 ? ue(d5) : window;
        switch (a5) {
          case "focusin":
            if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d5, Se = null;
            break;
          case "focusout":
            Se = Re = Qe = null;
            break;
          case "mousedown":
            Te = true;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Te = false;
            Ue(g3, c2, e3);
            break;
          case "selectionchange":
            if (Pe) break;
          case "keydown":
          case "keyup":
            Ue(g3, c2, e3);
        }
        var $a;
        if (ae) b: {
          switch (a5) {
            case "compositionstart":
              var ba = "onCompositionStart";
              break b;
            case "compositionend":
              ba = "onCompositionEnd";
              break b;
            case "compositionupdate":
              ba = "onCompositionUpdate";
              break b;
          }
          ba = void 0;
        }
        else ie ? ge(a5, c2) && (ba = "onCompositionEnd") : "keydown" === a5 && 229 === c2.keyCode && (ba = "onCompositionStart");
        ba && (de && "ko" !== c2.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e3, ld = "value" in kd ? kd.value : kd.textContent, ie = true)), xa = oe(d5, ba), 0 < xa.length && (ba = new Ld(ba, a5, null, c2, e3), g3.push({ event: ba, listeners: xa }), $a ? ba.data = $a : ($a = he(c2), null !== $a && (ba.data = $a))));
        if ($a = ce ? je(a5, c2) : ke(a5, c2)) d5 = oe(d5, "onBeforeInput"), 0 < d5.length && (e3 = new Ld("onBeforeInput", "beforeinput", null, c2, e3), g3.push({ event: e3, listeners: d5 }), e3.data = $a);
      }
      se(g3, b6);
    });
  }
  function tf(a5, b6, c2) {
    return { instance: a5, listener: b6, currentTarget: c2 };
  }
  function oe(a5, b6) {
    for (var c2 = b6 + "Capture", d3 = []; null !== a5; ) {
      var e2 = a5, f2 = e2.stateNode;
      5 === e2.tag && null !== f2 && (e2 = f2, f2 = Kb(a5, c2), null != f2 && d3.unshift(tf(a5, f2, e2)), f2 = Kb(a5, b6), null != f2 && d3.push(tf(a5, f2, e2)));
      a5 = a5.return;
    }
    return d3;
  }
  function vf(a5) {
    if (null === a5) return null;
    do
      a5 = a5.return;
    while (a5 && 5 !== a5.tag);
    return a5 ? a5 : null;
  }
  function wf(a5, b6, c2, d3, e2) {
    for (var f2 = b6._reactName, g2 = []; null !== c2 && c2 !== d3; ) {
      var h2 = c2, k2 = h2.alternate, l2 = h2.stateNode;
      if (null !== k2 && k2 === d3) break;
      5 === h2.tag && null !== l2 && (h2 = l2, e2 ? (k2 = Kb(c2, f2), null != k2 && g2.unshift(tf(c2, k2, h2))) : e2 || (k2 = Kb(c2, f2), null != k2 && g2.push(tf(c2, k2, h2))));
      c2 = c2.return;
    }
    0 !== g2.length && a5.push({ event: b6, listeners: g2 });
  }
  var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
  function zf(a5) {
    return ("string" === typeof a5 ? a5 : "" + a5).replace(xf, "\n").replace(yf, "");
  }
  function Af(a5, b6, c2) {
    b6 = zf(b6);
    if (zf(a5) !== b6 && c2) throw Error(p3(425));
  }
  function Bf() {
  }
  var Cf = null, Df = null;
  function Ef(a5, b6) {
    return "textarea" === a5 || "noscript" === a5 || "string" === typeof b6.children || "number" === typeof b6.children || "object" === typeof b6.dangerouslySetInnerHTML && null !== b6.dangerouslySetInnerHTML && null != b6.dangerouslySetInnerHTML.__html;
  }
  var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a5) {
    return Hf.resolve(null).then(a5).catch(If);
  } : Ff;
  function If(a5) {
    setTimeout(function() {
      throw a5;
    });
  }
  function Kf(a5, b6) {
    var c2 = b6, d3 = 0;
    do {
      var e2 = c2.nextSibling;
      a5.removeChild(c2);
      if (e2 && 8 === e2.nodeType) if (c2 = e2.data, "/$" === c2) {
        if (0 === d3) {
          a5.removeChild(e2);
          bd(b6);
          return;
        }
        d3--;
      } else "$" !== c2 && "$?" !== c2 && "$!" !== c2 || d3++;
      c2 = e2;
    } while (c2);
    bd(b6);
  }
  function Lf(a5) {
    for (; null != a5; a5 = a5.nextSibling) {
      var b6 = a5.nodeType;
      if (1 === b6 || 3 === b6) break;
      if (8 === b6) {
        b6 = a5.data;
        if ("$" === b6 || "$!" === b6 || "$?" === b6) break;
        if ("/$" === b6) return null;
      }
    }
    return a5;
  }
  function Mf(a5) {
    a5 = a5.previousSibling;
    for (var b6 = 0; a5; ) {
      if (8 === a5.nodeType) {
        var c2 = a5.data;
        if ("$" === c2 || "$!" === c2 || "$?" === c2) {
          if (0 === b6) return a5;
          b6--;
        } else "/$" === c2 && b6++;
      }
      a5 = a5.previousSibling;
    }
    return null;
  }
  var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
  function Wc(a5) {
    var b6 = a5[Of];
    if (b6) return b6;
    for (var c2 = a5.parentNode; c2; ) {
      if (b6 = c2[uf] || c2[Of]) {
        c2 = b6.alternate;
        if (null !== b6.child || null !== c2 && null !== c2.child) for (a5 = Mf(a5); null !== a5; ) {
          if (c2 = a5[Of]) return c2;
          a5 = Mf(a5);
        }
        return b6;
      }
      a5 = c2;
      c2 = a5.parentNode;
    }
    return null;
  }
  function Cb(a5) {
    a5 = a5[Of] || a5[uf];
    return !a5 || 5 !== a5.tag && 6 !== a5.tag && 13 !== a5.tag && 3 !== a5.tag ? null : a5;
  }
  function ue(a5) {
    if (5 === a5.tag || 6 === a5.tag) return a5.stateNode;
    throw Error(p3(33));
  }
  function Db(a5) {
    return a5[Pf] || null;
  }
  var Sf = [], Tf = -1;
  function Uf(a5) {
    return { current: a5 };
  }
  function E2(a5) {
    0 > Tf || (a5.current = Sf[Tf], Sf[Tf] = null, Tf--);
  }
  function G2(a5, b6) {
    Tf++;
    Sf[Tf] = a5.current;
    a5.current = b6;
  }
  var Vf = {}, H3 = Uf(Vf), Wf = Uf(false), Xf = Vf;
  function Yf(a5, b6) {
    var c2 = a5.type.contextTypes;
    if (!c2) return Vf;
    var d3 = a5.stateNode;
    if (d3 && d3.__reactInternalMemoizedUnmaskedChildContext === b6) return d3.__reactInternalMemoizedMaskedChildContext;
    var e2 = {}, f2;
    for (f2 in c2) e2[f2] = b6[f2];
    d3 && (a5 = a5.stateNode, a5.__reactInternalMemoizedUnmaskedChildContext = b6, a5.__reactInternalMemoizedMaskedChildContext = e2);
    return e2;
  }
  function Zf(a5) {
    a5 = a5.childContextTypes;
    return null !== a5 && void 0 !== a5;
  }
  function $f() {
    E2(Wf);
    E2(H3);
  }
  function ag2(a5, b6, c2) {
    if (H3.current !== Vf) throw Error(p3(168));
    G2(H3, b6);
    G2(Wf, c2);
  }
  function bg(a5, b6, c2) {
    var d3 = a5.stateNode;
    b6 = b6.childContextTypes;
    if ("function" !== typeof d3.getChildContext) return c2;
    d3 = d3.getChildContext();
    for (var e2 in d3) if (!(e2 in b6)) throw Error(p3(108, Ra(a5) || "Unknown", e2));
    return A2({}, c2, d3);
  }
  function cg2(a5) {
    a5 = (a5 = a5.stateNode) && a5.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H3.current;
    G2(H3, a5);
    G2(Wf, Wf.current);
    return true;
  }
  function dg2(a5, b6, c2) {
    var d3 = a5.stateNode;
    if (!d3) throw Error(p3(169));
    c2 ? (a5 = bg(a5, b6, Xf), d3.__reactInternalMemoizedMergedChildContext = a5, E2(Wf), E2(H3), G2(H3, a5)) : E2(Wf);
    G2(Wf, c2);
  }
  var eg = null, fg = false, gg2 = false;
  function hg2(a5) {
    null === eg ? eg = [a5] : eg.push(a5);
  }
  function ig2(a5) {
    fg = true;
    hg2(a5);
  }
  function jg() {
    if (!gg2 && null !== eg) {
      gg2 = true;
      var a5 = 0, b6 = C2;
      try {
        var c2 = eg;
        for (C2 = 1; a5 < c2.length; a5++) {
          var d3 = c2[a5];
          do
            d3 = d3(true);
          while (null !== d3);
        }
        eg = null;
        fg = false;
      } catch (e2) {
        throw null !== eg && (eg = eg.slice(a5 + 1)), ac(fc, jg), e2;
      } finally {
        C2 = b6, gg2 = false;
      }
    }
    return null;
  }
  var kg2 = [], lg = 0, mg = null, ng2 = 0, og2 = [], pg = 0, qg2 = null, rg2 = 1, sg2 = "";
  function tg(a5, b6) {
    kg2[lg++] = ng2;
    kg2[lg++] = mg;
    mg = a5;
    ng2 = b6;
  }
  function ug(a5, b6, c2) {
    og2[pg++] = rg2;
    og2[pg++] = sg2;
    og2[pg++] = qg2;
    qg2 = a5;
    var d3 = rg2;
    a5 = sg2;
    var e2 = 32 - oc(d3) - 1;
    d3 &= ~(1 << e2);
    c2 += 1;
    var f2 = 32 - oc(b6) + e2;
    if (30 < f2) {
      var g2 = e2 - e2 % 5;
      f2 = (d3 & (1 << g2) - 1).toString(32);
      d3 >>= g2;
      e2 -= g2;
      rg2 = 1 << 32 - oc(b6) + e2 | c2 << e2 | d3;
      sg2 = f2 + a5;
    } else rg2 = 1 << f2 | c2 << e2 | d3, sg2 = a5;
  }
  function vg(a5) {
    null !== a5.return && (tg(a5, 1), ug(a5, 1, 0));
  }
  function wg2(a5) {
    for (; a5 === mg; ) mg = kg2[--lg], kg2[lg] = null, ng2 = kg2[--lg], kg2[lg] = null;
    for (; a5 === qg2; ) qg2 = og2[--pg], og2[pg] = null, sg2 = og2[--pg], og2[pg] = null, rg2 = og2[--pg], og2[pg] = null;
  }
  var xg = null, yg2 = null, I2 = false, zg = null;
  function Ag2(a5, b6) {
    var c2 = Bg2(5, null, null, 0);
    c2.elementType = "DELETED";
    c2.stateNode = b6;
    c2.return = a5;
    b6 = a5.deletions;
    null === b6 ? (a5.deletions = [c2], a5.flags |= 16) : b6.push(c2);
  }
  function Cg2(a5, b6) {
    switch (a5.tag) {
      case 5:
        var c2 = a5.type;
        b6 = 1 !== b6.nodeType || c2.toLowerCase() !== b6.nodeName.toLowerCase() ? null : b6;
        return null !== b6 ? (a5.stateNode = b6, xg = a5, yg2 = Lf(b6.firstChild), true) : false;
      case 6:
        return b6 = "" === a5.pendingProps || 3 !== b6.nodeType ? null : b6, null !== b6 ? (a5.stateNode = b6, xg = a5, yg2 = null, true) : false;
      case 13:
        return b6 = 8 !== b6.nodeType ? null : b6, null !== b6 ? (c2 = null !== qg2 ? { id: rg2, overflow: sg2 } : null, a5.memoizedState = { dehydrated: b6, treeContext: c2, retryLane: 1073741824 }, c2 = Bg2(18, null, null, 0), c2.stateNode = b6, c2.return = a5, a5.child = c2, xg = a5, yg2 = null, true) : false;
      default:
        return false;
    }
  }
  function Dg2(a5) {
    return 0 !== (a5.mode & 1) && 0 === (a5.flags & 128);
  }
  function Eg2(a5) {
    if (I2) {
      var b6 = yg2;
      if (b6) {
        var c2 = b6;
        if (!Cg2(a5, b6)) {
          if (Dg2(a5)) throw Error(p3(418));
          b6 = Lf(c2.nextSibling);
          var d3 = xg;
          b6 && Cg2(a5, b6) ? Ag2(d3, c2) : (a5.flags = a5.flags & -4097 | 2, I2 = false, xg = a5);
        }
      } else {
        if (Dg2(a5)) throw Error(p3(418));
        a5.flags = a5.flags & -4097 | 2;
        I2 = false;
        xg = a5;
      }
    }
  }
  function Fg2(a5) {
    for (a5 = a5.return; null !== a5 && 5 !== a5.tag && 3 !== a5.tag && 13 !== a5.tag; ) a5 = a5.return;
    xg = a5;
  }
  function Gg2(a5) {
    if (a5 !== xg) return false;
    if (!I2) return Fg2(a5), I2 = true, false;
    var b6;
    (b6 = 3 !== a5.tag) && !(b6 = 5 !== a5.tag) && (b6 = a5.type, b6 = "head" !== b6 && "body" !== b6 && !Ef(a5.type, a5.memoizedProps));
    if (b6 && (b6 = yg2)) {
      if (Dg2(a5)) throw Hg(), Error(p3(418));
      for (; b6; ) Ag2(a5, b6), b6 = Lf(b6.nextSibling);
    }
    Fg2(a5);
    if (13 === a5.tag) {
      a5 = a5.memoizedState;
      a5 = null !== a5 ? a5.dehydrated : null;
      if (!a5) throw Error(p3(317));
      a: {
        a5 = a5.nextSibling;
        for (b6 = 0; a5; ) {
          if (8 === a5.nodeType) {
            var c2 = a5.data;
            if ("/$" === c2) {
              if (0 === b6) {
                yg2 = Lf(a5.nextSibling);
                break a;
              }
              b6--;
            } else "$" !== c2 && "$!" !== c2 && "$?" !== c2 || b6++;
          }
          a5 = a5.nextSibling;
        }
        yg2 = null;
      }
    } else yg2 = xg ? Lf(a5.stateNode.nextSibling) : null;
    return true;
  }
  function Hg() {
    for (var a5 = yg2; a5; ) a5 = Lf(a5.nextSibling);
  }
  function Ig2() {
    yg2 = xg = null;
    I2 = false;
  }
  function Jg2(a5) {
    null === zg ? zg = [a5] : zg.push(a5);
  }
  var Kg2 = ua.ReactCurrentBatchConfig;
  function Lg(a5, b6, c2) {
    a5 = c2.ref;
    if (null !== a5 && "function" !== typeof a5 && "object" !== typeof a5) {
      if (c2._owner) {
        c2 = c2._owner;
        if (c2) {
          if (1 !== c2.tag) throw Error(p3(309));
          var d3 = c2.stateNode;
        }
        if (!d3) throw Error(p3(147, a5));
        var e2 = d3, f2 = "" + a5;
        if (null !== b6 && null !== b6.ref && "function" === typeof b6.ref && b6.ref._stringRef === f2) return b6.ref;
        b6 = function(a6) {
          var b7 = e2.refs;
          null === a6 ? delete b7[f2] : b7[f2] = a6;
        };
        b6._stringRef = f2;
        return b6;
      }
      if ("string" !== typeof a5) throw Error(p3(284));
      if (!c2._owner) throw Error(p3(290, a5));
    }
    return a5;
  }
  function Mg2(a5, b6) {
    a5 = Object.prototype.toString.call(b6);
    throw Error(p3(31, "[object Object]" === a5 ? "object with keys {" + Object.keys(b6).join(", ") + "}" : a5));
  }
  function Ng2(a5) {
    var b6 = a5._init;
    return b6(a5._payload);
  }
  function Og2(a5) {
    function b6(b7, c5) {
      if (a5) {
        var d5 = b7.deletions;
        null === d5 ? (b7.deletions = [c5], b7.flags |= 16) : d5.push(c5);
      }
    }
    function c2(c5, d5) {
      if (!a5) return null;
      for (; null !== d5; ) b6(c5, d5), d5 = d5.sibling;
      return null;
    }
    function d3(a6, b7) {
      for (a6 = /* @__PURE__ */ new Map(); null !== b7; ) null !== b7.key ? a6.set(b7.key, b7) : a6.set(b7.index, b7), b7 = b7.sibling;
      return a6;
    }
    function e2(a6, b7) {
      a6 = Pg(a6, b7);
      a6.index = 0;
      a6.sibling = null;
      return a6;
    }
    function f2(b7, c5, d5) {
      b7.index = d5;
      if (!a5) return b7.flags |= 1048576, c5;
      d5 = b7.alternate;
      if (null !== d5) return d5 = d5.index, d5 < c5 ? (b7.flags |= 2, c5) : d5;
      b7.flags |= 2;
      return c5;
    }
    function g2(b7) {
      a5 && null === b7.alternate && (b7.flags |= 2);
      return b7;
    }
    function h2(a6, b7, c5, d5) {
      if (null === b7 || 6 !== b7.tag) return b7 = Qg2(c5, a6.mode, d5), b7.return = a6, b7;
      b7 = e2(b7, c5);
      b7.return = a6;
      return b7;
    }
    function k2(a6, b7, c5, d5) {
      var f3 = c5.type;
      if (f3 === ya) return m2(a6, b7, c5.props.children, d5, c5.key);
      if (null !== b7 && (b7.elementType === f3 || "object" === typeof f3 && null !== f3 && f3.$$typeof === Ha && Ng2(f3) === b7.type)) return d5 = e2(b7, c5.props), d5.ref = Lg(a6, b7, c5), d5.return = a6, d5;
      d5 = Rg2(c5.type, c5.key, c5.props, null, a6.mode, d5);
      d5.ref = Lg(a6, b7, c5);
      d5.return = a6;
      return d5;
    }
    function l2(a6, b7, c5, d5) {
      if (null === b7 || 4 !== b7.tag || b7.stateNode.containerInfo !== c5.containerInfo || b7.stateNode.implementation !== c5.implementation) return b7 = Sg2(c5, a6.mode, d5), b7.return = a6, b7;
      b7 = e2(b7, c5.children || []);
      b7.return = a6;
      return b7;
    }
    function m2(a6, b7, c5, d5, f3) {
      if (null === b7 || 7 !== b7.tag) return b7 = Tg2(c5, a6.mode, d5, f3), b7.return = a6, b7;
      b7 = e2(b7, c5);
      b7.return = a6;
      return b7;
    }
    function q2(a6, b7, c5) {
      if ("string" === typeof b7 && "" !== b7 || "number" === typeof b7) return b7 = Qg2("" + b7, a6.mode, c5), b7.return = a6, b7;
      if ("object" === typeof b7 && null !== b7) {
        switch (b7.$$typeof) {
          case va:
            return c5 = Rg2(b7.type, b7.key, b7.props, null, a6.mode, c5), c5.ref = Lg(a6, null, b7), c5.return = a6, c5;
          case wa:
            return b7 = Sg2(b7, a6.mode, c5), b7.return = a6, b7;
          case Ha:
            var d5 = b7._init;
            return q2(a6, d5(b7._payload), c5);
        }
        if (eb(b7) || Ka(b7)) return b7 = Tg2(b7, a6.mode, c5, null), b7.return = a6, b7;
        Mg2(a6, b7);
      }
      return null;
    }
    function r3(a6, b7, c5, d5) {
      var e3 = null !== b7 ? b7.key : null;
      if ("string" === typeof c5 && "" !== c5 || "number" === typeof c5) return null !== e3 ? null : h2(a6, b7, "" + c5, d5);
      if ("object" === typeof c5 && null !== c5) {
        switch (c5.$$typeof) {
          case va:
            return c5.key === e3 ? k2(a6, b7, c5, d5) : null;
          case wa:
            return c5.key === e3 ? l2(a6, b7, c5, d5) : null;
          case Ha:
            return e3 = c5._init, r3(
              a6,
              b7,
              e3(c5._payload),
              d5
            );
        }
        if (eb(c5) || Ka(c5)) return null !== e3 ? null : m2(a6, b7, c5, d5, null);
        Mg2(a6, c5);
      }
      return null;
    }
    function y2(a6, b7, c5, d5, e3) {
      if ("string" === typeof d5 && "" !== d5 || "number" === typeof d5) return a6 = a6.get(c5) || null, h2(b7, a6, "" + d5, e3);
      if ("object" === typeof d5 && null !== d5) {
        switch (d5.$$typeof) {
          case va:
            return a6 = a6.get(null === d5.key ? c5 : d5.key) || null, k2(b7, a6, d5, e3);
          case wa:
            return a6 = a6.get(null === d5.key ? c5 : d5.key) || null, l2(b7, a6, d5, e3);
          case Ha:
            var f3 = d5._init;
            return y2(a6, b7, c5, f3(d5._payload), e3);
        }
        if (eb(d5) || Ka(d5)) return a6 = a6.get(c5) || null, m2(b7, a6, d5, e3, null);
        Mg2(b7, d5);
      }
      return null;
    }
    function n2(e3, g3, h3, k3) {
      for (var l3 = null, m3 = null, u2 = g3, w2 = g3 = 0, x3 = null; null !== u2 && w2 < h3.length; w2++) {
        u2.index > w2 ? (x3 = u2, u2 = null) : x3 = u2.sibling;
        var n3 = r3(e3, u2, h3[w2], k3);
        if (null === n3) {
          null === u2 && (u2 = x3);
          break;
        }
        a5 && u2 && null === n3.alternate && b6(e3, u2);
        g3 = f2(n3, g3, w2);
        null === m3 ? l3 = n3 : m3.sibling = n3;
        m3 = n3;
        u2 = x3;
      }
      if (w2 === h3.length) return c2(e3, u2), I2 && tg(e3, w2), l3;
      if (null === u2) {
        for (; w2 < h3.length; w2++) u2 = q2(e3, h3[w2], k3), null !== u2 && (g3 = f2(u2, g3, w2), null === m3 ? l3 = u2 : m3.sibling = u2, m3 = u2);
        I2 && tg(e3, w2);
        return l3;
      }
      for (u2 = d3(e3, u2); w2 < h3.length; w2++) x3 = y2(u2, e3, w2, h3[w2], k3), null !== x3 && (a5 && null !== x3.alternate && u2.delete(null === x3.key ? w2 : x3.key), g3 = f2(x3, g3, w2), null === m3 ? l3 = x3 : m3.sibling = x3, m3 = x3);
      a5 && u2.forEach(function(a6) {
        return b6(e3, a6);
      });
      I2 && tg(e3, w2);
      return l3;
    }
    function t2(e3, g3, h3, k3) {
      var l3 = Ka(h3);
      if ("function" !== typeof l3) throw Error(p3(150));
      h3 = l3.call(h3);
      if (null == h3) throw Error(p3(151));
      for (var u2 = l3 = null, m3 = g3, w2 = g3 = 0, x3 = null, n3 = h3.next(); null !== m3 && !n3.done; w2++, n3 = h3.next()) {
        m3.index > w2 ? (x3 = m3, m3 = null) : x3 = m3.sibling;
        var t3 = r3(e3, m3, n3.value, k3);
        if (null === t3) {
          null === m3 && (m3 = x3);
          break;
        }
        a5 && m3 && null === t3.alternate && b6(e3, m3);
        g3 = f2(t3, g3, w2);
        null === u2 ? l3 = t3 : u2.sibling = t3;
        u2 = t3;
        m3 = x3;
      }
      if (n3.done) return c2(
        e3,
        m3
      ), I2 && tg(e3, w2), l3;
      if (null === m3) {
        for (; !n3.done; w2++, n3 = h3.next()) n3 = q2(e3, n3.value, k3), null !== n3 && (g3 = f2(n3, g3, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
        I2 && tg(e3, w2);
        return l3;
      }
      for (m3 = d3(e3, m3); !n3.done; w2++, n3 = h3.next()) n3 = y2(m3, e3, w2, n3.value, k3), null !== n3 && (a5 && null !== n3.alternate && m3.delete(null === n3.key ? w2 : n3.key), g3 = f2(n3, g3, w2), null === u2 ? l3 = n3 : u2.sibling = n3, u2 = n3);
      a5 && m3.forEach(function(a6) {
        return b6(e3, a6);
      });
      I2 && tg(e3, w2);
      return l3;
    }
    function J2(a6, d5, f3, h3) {
      "object" === typeof f3 && null !== f3 && f3.type === ya && null === f3.key && (f3 = f3.props.children);
      if ("object" === typeof f3 && null !== f3) {
        switch (f3.$$typeof) {
          case va:
            a: {
              for (var k3 = f3.key, l3 = d5; null !== l3; ) {
                if (l3.key === k3) {
                  k3 = f3.type;
                  if (k3 === ya) {
                    if (7 === l3.tag) {
                      c2(a6, l3.sibling);
                      d5 = e2(l3, f3.props.children);
                      d5.return = a6;
                      a6 = d5;
                      break a;
                    }
                  } else if (l3.elementType === k3 || "object" === typeof k3 && null !== k3 && k3.$$typeof === Ha && Ng2(k3) === l3.type) {
                    c2(a6, l3.sibling);
                    d5 = e2(l3, f3.props);
                    d5.ref = Lg(a6, l3, f3);
                    d5.return = a6;
                    a6 = d5;
                    break a;
                  }
                  c2(a6, l3);
                  break;
                } else b6(a6, l3);
                l3 = l3.sibling;
              }
              f3.type === ya ? (d5 = Tg2(f3.props.children, a6.mode, h3, f3.key), d5.return = a6, a6 = d5) : (h3 = Rg2(f3.type, f3.key, f3.props, null, a6.mode, h3), h3.ref = Lg(a6, d5, f3), h3.return = a6, a6 = h3);
            }
            return g2(a6);
          case wa:
            a: {
              for (l3 = f3.key; null !== d5; ) {
                if (d5.key === l3) if (4 === d5.tag && d5.stateNode.containerInfo === f3.containerInfo && d5.stateNode.implementation === f3.implementation) {
                  c2(a6, d5.sibling);
                  d5 = e2(d5, f3.children || []);
                  d5.return = a6;
                  a6 = d5;
                  break a;
                } else {
                  c2(a6, d5);
                  break;
                }
                else b6(a6, d5);
                d5 = d5.sibling;
              }
              d5 = Sg2(f3, a6.mode, h3);
              d5.return = a6;
              a6 = d5;
            }
            return g2(a6);
          case Ha:
            return l3 = f3._init, J2(a6, d5, l3(f3._payload), h3);
        }
        if (eb(f3)) return n2(a6, d5, f3, h3);
        if (Ka(f3)) return t2(a6, d5, f3, h3);
        Mg2(a6, f3);
      }
      return "string" === typeof f3 && "" !== f3 || "number" === typeof f3 ? (f3 = "" + f3, null !== d5 && 6 === d5.tag ? (c2(a6, d5.sibling), d5 = e2(d5, f3), d5.return = a6, a6 = d5) : (c2(a6, d5), d5 = Qg2(f3, a6.mode, h3), d5.return = a6, a6 = d5), g2(a6)) : c2(a6, d5);
    }
    return J2;
  }
  var Ug2 = Og2(true), Vg = Og2(false), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
  function $g() {
    Zg = Yg = Xg = null;
  }
  function ah(a5) {
    var b6 = Wg.current;
    E2(Wg);
    a5._currentValue = b6;
  }
  function bh(a5, b6, c2) {
    for (; null !== a5; ) {
      var d3 = a5.alternate;
      (a5.childLanes & b6) !== b6 ? (a5.childLanes |= b6, null !== d3 && (d3.childLanes |= b6)) : null !== d3 && (d3.childLanes & b6) !== b6 && (d3.childLanes |= b6);
      if (a5 === c2) break;
      a5 = a5.return;
    }
  }
  function ch(a5, b6) {
    Xg = a5;
    Zg = Yg = null;
    a5 = a5.dependencies;
    null !== a5 && null !== a5.firstContext && (0 !== (a5.lanes & b6) && (dh = true), a5.firstContext = null);
  }
  function eh(a5) {
    var b6 = a5._currentValue;
    if (Zg !== a5) if (a5 = { context: a5, memoizedValue: b6, next: null }, null === Yg) {
      if (null === Xg) throw Error(p3(308));
      Yg = a5;
      Xg.dependencies = { lanes: 0, firstContext: a5 };
    } else Yg = Yg.next = a5;
    return b6;
  }
  var fh = null;
  function gh(a5) {
    null === fh ? fh = [a5] : fh.push(a5);
  }
  function hh(a5, b6, c2, d3) {
    var e2 = b6.interleaved;
    null === e2 ? (c2.next = c2, gh(b6)) : (c2.next = e2.next, e2.next = c2);
    b6.interleaved = c2;
    return ih(a5, d3);
  }
  function ih(a5, b6) {
    a5.lanes |= b6;
    var c2 = a5.alternate;
    null !== c2 && (c2.lanes |= b6);
    c2 = a5;
    for (a5 = a5.return; null !== a5; ) a5.childLanes |= b6, c2 = a5.alternate, null !== c2 && (c2.childLanes |= b6), c2 = a5, a5 = a5.return;
    return 3 === c2.tag ? c2.stateNode : null;
  }
  var jh = false;
  function kh(a5) {
    a5.updateQueue = { baseState: a5.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function lh(a5, b6) {
    a5 = a5.updateQueue;
    b6.updateQueue === a5 && (b6.updateQueue = { baseState: a5.baseState, firstBaseUpdate: a5.firstBaseUpdate, lastBaseUpdate: a5.lastBaseUpdate, shared: a5.shared, effects: a5.effects });
  }
  function mh(a5, b6) {
    return { eventTime: a5, lane: b6, tag: 0, payload: null, callback: null, next: null };
  }
  function nh(a5, b6, c2) {
    var d3 = a5.updateQueue;
    if (null === d3) return null;
    d3 = d3.shared;
    if (0 !== (K2 & 2)) {
      var e2 = d3.pending;
      null === e2 ? b6.next = b6 : (b6.next = e2.next, e2.next = b6);
      d3.pending = b6;
      return ih(a5, c2);
    }
    e2 = d3.interleaved;
    null === e2 ? (b6.next = b6, gh(d3)) : (b6.next = e2.next, e2.next = b6);
    d3.interleaved = b6;
    return ih(a5, c2);
  }
  function oh(a5, b6, c2) {
    b6 = b6.updateQueue;
    if (null !== b6 && (b6 = b6.shared, 0 !== (c2 & 4194240))) {
      var d3 = b6.lanes;
      d3 &= a5.pendingLanes;
      c2 |= d3;
      b6.lanes = c2;
      Cc(a5, c2);
    }
  }
  function ph(a5, b6) {
    var c2 = a5.updateQueue, d3 = a5.alternate;
    if (null !== d3 && (d3 = d3.updateQueue, c2 === d3)) {
      var e2 = null, f2 = null;
      c2 = c2.firstBaseUpdate;
      if (null !== c2) {
        do {
          var g2 = { eventTime: c2.eventTime, lane: c2.lane, tag: c2.tag, payload: c2.payload, callback: c2.callback, next: null };
          null === f2 ? e2 = f2 = g2 : f2 = f2.next = g2;
          c2 = c2.next;
        } while (null !== c2);
        null === f2 ? e2 = f2 = b6 : f2 = f2.next = b6;
      } else e2 = f2 = b6;
      c2 = { baseState: d3.baseState, firstBaseUpdate: e2, lastBaseUpdate: f2, shared: d3.shared, effects: d3.effects };
      a5.updateQueue = c2;
      return;
    }
    a5 = c2.lastBaseUpdate;
    null === a5 ? c2.firstBaseUpdate = b6 : a5.next = b6;
    c2.lastBaseUpdate = b6;
  }
  function qh(a5, b6, c2, d3) {
    var e2 = a5.updateQueue;
    jh = false;
    var f2 = e2.firstBaseUpdate, g2 = e2.lastBaseUpdate, h2 = e2.shared.pending;
    if (null !== h2) {
      e2.shared.pending = null;
      var k2 = h2, l2 = k2.next;
      k2.next = null;
      null === g2 ? f2 = l2 : g2.next = l2;
      g2 = k2;
      var m2 = a5.alternate;
      null !== m2 && (m2 = m2.updateQueue, h2 = m2.lastBaseUpdate, h2 !== g2 && (null === h2 ? m2.firstBaseUpdate = l2 : h2.next = l2, m2.lastBaseUpdate = k2));
    }
    if (null !== f2) {
      var q2 = e2.baseState;
      g2 = 0;
      m2 = l2 = k2 = null;
      h2 = f2;
      do {
        var r3 = h2.lane, y2 = h2.eventTime;
        if ((d3 & r3) === r3) {
          null !== m2 && (m2 = m2.next = {
            eventTime: y2,
            lane: 0,
            tag: h2.tag,
            payload: h2.payload,
            callback: h2.callback,
            next: null
          });
          a: {
            var n2 = a5, t2 = h2;
            r3 = b6;
            y2 = c2;
            switch (t2.tag) {
              case 1:
                n2 = t2.payload;
                if ("function" === typeof n2) {
                  q2 = n2.call(y2, q2, r3);
                  break a;
                }
                q2 = n2;
                break a;
              case 3:
                n2.flags = n2.flags & -65537 | 128;
              case 0:
                n2 = t2.payload;
                r3 = "function" === typeof n2 ? n2.call(y2, q2, r3) : n2;
                if (null === r3 || void 0 === r3) break a;
                q2 = A2({}, q2, r3);
                break a;
              case 2:
                jh = true;
            }
          }
          null !== h2.callback && 0 !== h2.lane && (a5.flags |= 64, r3 = e2.effects, null === r3 ? e2.effects = [h2] : r3.push(h2));
        } else y2 = { eventTime: y2, lane: r3, tag: h2.tag, payload: h2.payload, callback: h2.callback, next: null }, null === m2 ? (l2 = m2 = y2, k2 = q2) : m2 = m2.next = y2, g2 |= r3;
        h2 = h2.next;
        if (null === h2) if (h2 = e2.shared.pending, null === h2) break;
        else r3 = h2, h2 = r3.next, r3.next = null, e2.lastBaseUpdate = r3, e2.shared.pending = null;
      } while (1);
      null === m2 && (k2 = q2);
      e2.baseState = k2;
      e2.firstBaseUpdate = l2;
      e2.lastBaseUpdate = m2;
      b6 = e2.shared.interleaved;
      if (null !== b6) {
        e2 = b6;
        do
          g2 |= e2.lane, e2 = e2.next;
        while (e2 !== b6);
      } else null === f2 && (e2.shared.lanes = 0);
      rh |= g2;
      a5.lanes = g2;
      a5.memoizedState = q2;
    }
  }
  function sh(a5, b6, c2) {
    a5 = b6.effects;
    b6.effects = null;
    if (null !== a5) for (b6 = 0; b6 < a5.length; b6++) {
      var d3 = a5[b6], e2 = d3.callback;
      if (null !== e2) {
        d3.callback = null;
        d3 = c2;
        if ("function" !== typeof e2) throw Error(p3(191, e2));
        e2.call(d3);
      }
    }
  }
  var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
  function xh(a5) {
    if (a5 === th) throw Error(p3(174));
    return a5;
  }
  function yh(a5, b6) {
    G2(wh, b6);
    G2(vh, a5);
    G2(uh, th);
    a5 = b6.nodeType;
    switch (a5) {
      case 9:
      case 11:
        b6 = (b6 = b6.documentElement) ? b6.namespaceURI : lb(null, "");
        break;
      default:
        a5 = 8 === a5 ? b6.parentNode : b6, b6 = a5.namespaceURI || null, a5 = a5.tagName, b6 = lb(b6, a5);
    }
    E2(uh);
    G2(uh, b6);
  }
  function zh() {
    E2(uh);
    E2(vh);
    E2(wh);
  }
  function Ah(a5) {
    xh(wh.current);
    var b6 = xh(uh.current);
    var c2 = lb(b6, a5.type);
    b6 !== c2 && (G2(vh, a5), G2(uh, c2));
  }
  function Bh(a5) {
    vh.current === a5 && (E2(uh), E2(vh));
  }
  var L2 = Uf(0);
  function Ch(a5) {
    for (var b6 = a5; null !== b6; ) {
      if (13 === b6.tag) {
        var c2 = b6.memoizedState;
        if (null !== c2 && (c2 = c2.dehydrated, null === c2 || "$?" === c2.data || "$!" === c2.data)) return b6;
      } else if (19 === b6.tag && void 0 !== b6.memoizedProps.revealOrder) {
        if (0 !== (b6.flags & 128)) return b6;
      } else if (null !== b6.child) {
        b6.child.return = b6;
        b6 = b6.child;
        continue;
      }
      if (b6 === a5) break;
      for (; null === b6.sibling; ) {
        if (null === b6.return || b6.return === a5) return null;
        b6 = b6.return;
      }
      b6.sibling.return = b6.return;
      b6 = b6.sibling;
    }
    return null;
  }
  var Dh = [];
  function Eh() {
    for (var a5 = 0; a5 < Dh.length; a5++) Dh[a5]._workInProgressVersionPrimary = null;
    Dh.length = 0;
  }
  var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M2 = null, N2 = null, O3 = null, Ih = false, Jh = false, Kh = 0, Lh = 0;
  function P3() {
    throw Error(p3(321));
  }
  function Mh(a5, b6) {
    if (null === b6) return false;
    for (var c2 = 0; c2 < b6.length && c2 < a5.length; c2++) if (!He(a5[c2], b6[c2])) return false;
    return true;
  }
  function Nh(a5, b6, c2, d3, e2, f2) {
    Hh = f2;
    M2 = b6;
    b6.memoizedState = null;
    b6.updateQueue = null;
    b6.lanes = 0;
    Fh.current = null === a5 || null === a5.memoizedState ? Oh : Ph;
    a5 = c2(d3, e2);
    if (Jh) {
      f2 = 0;
      do {
        Jh = false;
        Kh = 0;
        if (25 <= f2) throw Error(p3(301));
        f2 += 1;
        O3 = N2 = null;
        b6.updateQueue = null;
        Fh.current = Qh;
        a5 = c2(d3, e2);
      } while (Jh);
    }
    Fh.current = Rh;
    b6 = null !== N2 && null !== N2.next;
    Hh = 0;
    O3 = N2 = M2 = null;
    Ih = false;
    if (b6) throw Error(p3(300));
    return a5;
  }
  function Sh() {
    var a5 = 0 !== Kh;
    Kh = 0;
    return a5;
  }
  function Th() {
    var a5 = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    null === O3 ? M2.memoizedState = O3 = a5 : O3 = O3.next = a5;
    return O3;
  }
  function Uh() {
    if (null === N2) {
      var a5 = M2.alternate;
      a5 = null !== a5 ? a5.memoizedState : null;
    } else a5 = N2.next;
    var b6 = null === O3 ? M2.memoizedState : O3.next;
    if (null !== b6) O3 = b6, N2 = a5;
    else {
      if (null === a5) throw Error(p3(310));
      N2 = a5;
      a5 = { memoizedState: N2.memoizedState, baseState: N2.baseState, baseQueue: N2.baseQueue, queue: N2.queue, next: null };
      null === O3 ? M2.memoizedState = O3 = a5 : O3 = O3.next = a5;
    }
    return O3;
  }
  function Vh(a5, b6) {
    return "function" === typeof b6 ? b6(a5) : b6;
  }
  function Wh(a5) {
    var b6 = Uh(), c2 = b6.queue;
    if (null === c2) throw Error(p3(311));
    c2.lastRenderedReducer = a5;
    var d3 = N2, e2 = d3.baseQueue, f2 = c2.pending;
    if (null !== f2) {
      if (null !== e2) {
        var g2 = e2.next;
        e2.next = f2.next;
        f2.next = g2;
      }
      d3.baseQueue = e2 = f2;
      c2.pending = null;
    }
    if (null !== e2) {
      f2 = e2.next;
      d3 = d3.baseState;
      var h2 = g2 = null, k2 = null, l2 = f2;
      do {
        var m2 = l2.lane;
        if ((Hh & m2) === m2) null !== k2 && (k2 = k2.next = { lane: 0, action: l2.action, hasEagerState: l2.hasEagerState, eagerState: l2.eagerState, next: null }), d3 = l2.hasEagerState ? l2.eagerState : a5(d3, l2.action);
        else {
          var q2 = {
            lane: m2,
            action: l2.action,
            hasEagerState: l2.hasEagerState,
            eagerState: l2.eagerState,
            next: null
          };
          null === k2 ? (h2 = k2 = q2, g2 = d3) : k2 = k2.next = q2;
          M2.lanes |= m2;
          rh |= m2;
        }
        l2 = l2.next;
      } while (null !== l2 && l2 !== f2);
      null === k2 ? g2 = d3 : k2.next = h2;
      He(d3, b6.memoizedState) || (dh = true);
      b6.memoizedState = d3;
      b6.baseState = g2;
      b6.baseQueue = k2;
      c2.lastRenderedState = d3;
    }
    a5 = c2.interleaved;
    if (null !== a5) {
      e2 = a5;
      do
        f2 = e2.lane, M2.lanes |= f2, rh |= f2, e2 = e2.next;
      while (e2 !== a5);
    } else null === e2 && (c2.lanes = 0);
    return [b6.memoizedState, c2.dispatch];
  }
  function Xh(a5) {
    var b6 = Uh(), c2 = b6.queue;
    if (null === c2) throw Error(p3(311));
    c2.lastRenderedReducer = a5;
    var d3 = c2.dispatch, e2 = c2.pending, f2 = b6.memoizedState;
    if (null !== e2) {
      c2.pending = null;
      var g2 = e2 = e2.next;
      do
        f2 = a5(f2, g2.action), g2 = g2.next;
      while (g2 !== e2);
      He(f2, b6.memoizedState) || (dh = true);
      b6.memoizedState = f2;
      null === b6.baseQueue && (b6.baseState = f2);
      c2.lastRenderedState = f2;
    }
    return [f2, d3];
  }
  function Yh() {
  }
  function Zh(a5, b6) {
    var c2 = M2, d3 = Uh(), e2 = b6(), f2 = !He(d3.memoizedState, e2);
    f2 && (d3.memoizedState = e2, dh = true);
    d3 = d3.queue;
    $h(ai.bind(null, c2, d3, a5), [a5]);
    if (d3.getSnapshot !== b6 || f2 || null !== O3 && O3.memoizedState.tag & 1) {
      c2.flags |= 2048;
      bi(9, ci.bind(null, c2, d3, e2, b6), void 0, null);
      if (null === Q2) throw Error(p3(349));
      0 !== (Hh & 30) || di(c2, b6, e2);
    }
    return e2;
  }
  function di(a5, b6, c2) {
    a5.flags |= 16384;
    a5 = { getSnapshot: b6, value: c2 };
    b6 = M2.updateQueue;
    null === b6 ? (b6 = { lastEffect: null, stores: null }, M2.updateQueue = b6, b6.stores = [a5]) : (c2 = b6.stores, null === c2 ? b6.stores = [a5] : c2.push(a5));
  }
  function ci(a5, b6, c2, d3) {
    b6.value = c2;
    b6.getSnapshot = d3;
    ei(b6) && fi(a5);
  }
  function ai(a5, b6, c2) {
    return c2(function() {
      ei(b6) && fi(a5);
    });
  }
  function ei(a5) {
    var b6 = a5.getSnapshot;
    a5 = a5.value;
    try {
      var c2 = b6();
      return !He(a5, c2);
    } catch (d3) {
      return true;
    }
  }
  function fi(a5) {
    var b6 = ih(a5, 1);
    null !== b6 && gi(b6, a5, 1, -1);
  }
  function hi(a5) {
    var b6 = Th();
    "function" === typeof a5 && (a5 = a5());
    b6.memoizedState = b6.baseState = a5;
    a5 = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Vh, lastRenderedState: a5 };
    b6.queue = a5;
    a5 = a5.dispatch = ii.bind(null, M2, a5);
    return [b6.memoizedState, a5];
  }
  function bi(a5, b6, c2, d3) {
    a5 = { tag: a5, create: b6, destroy: c2, deps: d3, next: null };
    b6 = M2.updateQueue;
    null === b6 ? (b6 = { lastEffect: null, stores: null }, M2.updateQueue = b6, b6.lastEffect = a5.next = a5) : (c2 = b6.lastEffect, null === c2 ? b6.lastEffect = a5.next = a5 : (d3 = c2.next, c2.next = a5, a5.next = d3, b6.lastEffect = a5));
    return a5;
  }
  function ji() {
    return Uh().memoizedState;
  }
  function ki(a5, b6, c2, d3) {
    var e2 = Th();
    M2.flags |= a5;
    e2.memoizedState = bi(1 | b6, c2, void 0, void 0 === d3 ? null : d3);
  }
  function li(a5, b6, c2, d3) {
    var e2 = Uh();
    d3 = void 0 === d3 ? null : d3;
    var f2 = void 0;
    if (null !== N2) {
      var g2 = N2.memoizedState;
      f2 = g2.destroy;
      if (null !== d3 && Mh(d3, g2.deps)) {
        e2.memoizedState = bi(b6, c2, f2, d3);
        return;
      }
    }
    M2.flags |= a5;
    e2.memoizedState = bi(1 | b6, c2, f2, d3);
  }
  function mi(a5, b6) {
    return ki(8390656, 8, a5, b6);
  }
  function $h(a5, b6) {
    return li(2048, 8, a5, b6);
  }
  function ni(a5, b6) {
    return li(4, 2, a5, b6);
  }
  function oi(a5, b6) {
    return li(4, 4, a5, b6);
  }
  function pi(a5, b6) {
    if ("function" === typeof b6) return a5 = a5(), b6(a5), function() {
      b6(null);
    };
    if (null !== b6 && void 0 !== b6) return a5 = a5(), b6.current = a5, function() {
      b6.current = null;
    };
  }
  function qi(a5, b6, c2) {
    c2 = null !== c2 && void 0 !== c2 ? c2.concat([a5]) : null;
    return li(4, 4, pi.bind(null, b6, a5), c2);
  }
  function ri() {
  }
  function si(a5, b6) {
    var c2 = Uh();
    b6 = void 0 === b6 ? null : b6;
    var d3 = c2.memoizedState;
    if (null !== d3 && null !== b6 && Mh(b6, d3[1])) return d3[0];
    c2.memoizedState = [a5, b6];
    return a5;
  }
  function ti(a5, b6) {
    var c2 = Uh();
    b6 = void 0 === b6 ? null : b6;
    var d3 = c2.memoizedState;
    if (null !== d3 && null !== b6 && Mh(b6, d3[1])) return d3[0];
    a5 = a5();
    c2.memoizedState = [a5, b6];
    return a5;
  }
  function ui(a5, b6, c2) {
    if (0 === (Hh & 21)) return a5.baseState && (a5.baseState = false, dh = true), a5.memoizedState = c2;
    He(c2, b6) || (c2 = yc(), M2.lanes |= c2, rh |= c2, a5.baseState = true);
    return b6;
  }
  function vi(a5, b6) {
    var c2 = C2;
    C2 = 0 !== c2 && 4 > c2 ? c2 : 4;
    a5(true);
    var d3 = Gh.transition;
    Gh.transition = {};
    try {
      a5(false), b6();
    } finally {
      C2 = c2, Gh.transition = d3;
    }
  }
  function wi() {
    return Uh().memoizedState;
  }
  function xi(a5, b6, c2) {
    var d3 = yi(a5);
    c2 = { lane: d3, action: c2, hasEagerState: false, eagerState: null, next: null };
    if (zi(a5)) Ai(b6, c2);
    else if (c2 = hh(a5, b6, c2, d3), null !== c2) {
      var e2 = R2();
      gi(c2, a5, d3, e2);
      Bi(c2, b6, d3);
    }
  }
  function ii(a5, b6, c2) {
    var d3 = yi(a5), e2 = { lane: d3, action: c2, hasEagerState: false, eagerState: null, next: null };
    if (zi(a5)) Ai(b6, e2);
    else {
      var f2 = a5.alternate;
      if (0 === a5.lanes && (null === f2 || 0 === f2.lanes) && (f2 = b6.lastRenderedReducer, null !== f2)) try {
        var g2 = b6.lastRenderedState, h2 = f2(g2, c2);
        e2.hasEagerState = true;
        e2.eagerState = h2;
        if (He(h2, g2)) {
          var k2 = b6.interleaved;
          null === k2 ? (e2.next = e2, gh(b6)) : (e2.next = k2.next, k2.next = e2);
          b6.interleaved = e2;
          return;
        }
      } catch (l2) {
      } finally {
      }
      c2 = hh(a5, b6, e2, d3);
      null !== c2 && (e2 = R2(), gi(c2, a5, d3, e2), Bi(c2, b6, d3));
    }
  }
  function zi(a5) {
    var b6 = a5.alternate;
    return a5 === M2 || null !== b6 && b6 === M2;
  }
  function Ai(a5, b6) {
    Jh = Ih = true;
    var c2 = a5.pending;
    null === c2 ? b6.next = b6 : (b6.next = c2.next, c2.next = b6);
    a5.pending = b6;
  }
  function Bi(a5, b6, c2) {
    if (0 !== (c2 & 4194240)) {
      var d3 = b6.lanes;
      d3 &= a5.pendingLanes;
      c2 |= d3;
      b6.lanes = c2;
      Cc(a5, c2);
    }
  }
  var Rh = { readContext: eh, useCallback: P3, useContext: P3, useEffect: P3, useImperativeHandle: P3, useInsertionEffect: P3, useLayoutEffect: P3, useMemo: P3, useReducer: P3, useRef: P3, useState: P3, useDebugValue: P3, useDeferredValue: P3, useTransition: P3, useMutableSource: P3, useSyncExternalStore: P3, useId: P3, unstable_isNewReconciler: false }, Oh = { readContext: eh, useCallback: function(a5, b6) {
    Th().memoizedState = [a5, void 0 === b6 ? null : b6];
    return a5;
  }, useContext: eh, useEffect: mi, useImperativeHandle: function(a5, b6, c2) {
    c2 = null !== c2 && void 0 !== c2 ? c2.concat([a5]) : null;
    return ki(
      4194308,
      4,
      pi.bind(null, b6, a5),
      c2
    );
  }, useLayoutEffect: function(a5, b6) {
    return ki(4194308, 4, a5, b6);
  }, useInsertionEffect: function(a5, b6) {
    return ki(4, 2, a5, b6);
  }, useMemo: function(a5, b6) {
    var c2 = Th();
    b6 = void 0 === b6 ? null : b6;
    a5 = a5();
    c2.memoizedState = [a5, b6];
    return a5;
  }, useReducer: function(a5, b6, c2) {
    var d3 = Th();
    b6 = void 0 !== c2 ? c2(b6) : b6;
    d3.memoizedState = d3.baseState = b6;
    a5 = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: a5, lastRenderedState: b6 };
    d3.queue = a5;
    a5 = a5.dispatch = xi.bind(null, M2, a5);
    return [d3.memoizedState, a5];
  }, useRef: function(a5) {
    var b6 = Th();
    a5 = { current: a5 };
    return b6.memoizedState = a5;
  }, useState: hi, useDebugValue: ri, useDeferredValue: function(a5) {
    return Th().memoizedState = a5;
  }, useTransition: function() {
    var a5 = hi(false), b6 = a5[0];
    a5 = vi.bind(null, a5[1]);
    Th().memoizedState = a5;
    return [b6, a5];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(a5, b6, c2) {
    var d3 = M2, e2 = Th();
    if (I2) {
      if (void 0 === c2) throw Error(p3(407));
      c2 = c2();
    } else {
      c2 = b6();
      if (null === Q2) throw Error(p3(349));
      0 !== (Hh & 30) || di(d3, b6, c2);
    }
    e2.memoizedState = c2;
    var f2 = { value: c2, getSnapshot: b6 };
    e2.queue = f2;
    mi(ai.bind(
      null,
      d3,
      f2,
      a5
    ), [a5]);
    d3.flags |= 2048;
    bi(9, ci.bind(null, d3, f2, c2, b6), void 0, null);
    return c2;
  }, useId: function() {
    var a5 = Th(), b6 = Q2.identifierPrefix;
    if (I2) {
      var c2 = sg2;
      var d3 = rg2;
      c2 = (d3 & ~(1 << 32 - oc(d3) - 1)).toString(32) + c2;
      b6 = ":" + b6 + "R" + c2;
      c2 = Kh++;
      0 < c2 && (b6 += "H" + c2.toString(32));
      b6 += ":";
    } else c2 = Lh++, b6 = ":" + b6 + "r" + c2.toString(32) + ":";
    return a5.memoizedState = b6;
  }, unstable_isNewReconciler: false }, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
      return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a5) {
      var b6 = Uh();
      return ui(b6, N2.memoizedState, a5);
    },
    useTransition: function() {
      var a5 = Wh(Vh)[0], b6 = Uh().memoizedState;
      return [a5, b6];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: false
  }, Qh = { readContext: eh, useCallback: si, useContext: eh, useEffect: $h, useImperativeHandle: qi, useInsertionEffect: ni, useLayoutEffect: oi, useMemo: ti, useReducer: Xh, useRef: ji, useState: function() {
    return Xh(Vh);
  }, useDebugValue: ri, useDeferredValue: function(a5) {
    var b6 = Uh();
    return null === N2 ? b6.memoizedState = a5 : ui(b6, N2.memoizedState, a5);
  }, useTransition: function() {
    var a5 = Xh(Vh)[0], b6 = Uh().memoizedState;
    return [a5, b6];
  }, useMutableSource: Yh, useSyncExternalStore: Zh, useId: wi, unstable_isNewReconciler: false };
  function Ci(a5, b6) {
    if (a5 && a5.defaultProps) {
      b6 = A2({}, b6);
      a5 = a5.defaultProps;
      for (var c2 in a5) void 0 === b6[c2] && (b6[c2] = a5[c2]);
      return b6;
    }
    return b6;
  }
  function Di(a5, b6, c2, d3) {
    b6 = a5.memoizedState;
    c2 = c2(d3, b6);
    c2 = null === c2 || void 0 === c2 ? b6 : A2({}, b6, c2);
    a5.memoizedState = c2;
    0 === a5.lanes && (a5.updateQueue.baseState = c2);
  }
  var Ei = { isMounted: function(a5) {
    return (a5 = a5._reactInternals) ? Vb(a5) === a5 : false;
  }, enqueueSetState: function(a5, b6, c2) {
    a5 = a5._reactInternals;
    var d3 = R2(), e2 = yi(a5), f2 = mh(d3, e2);
    f2.payload = b6;
    void 0 !== c2 && null !== c2 && (f2.callback = c2);
    b6 = nh(a5, f2, e2);
    null !== b6 && (gi(b6, a5, e2, d3), oh(b6, a5, e2));
  }, enqueueReplaceState: function(a5, b6, c2) {
    a5 = a5._reactInternals;
    var d3 = R2(), e2 = yi(a5), f2 = mh(d3, e2);
    f2.tag = 1;
    f2.payload = b6;
    void 0 !== c2 && null !== c2 && (f2.callback = c2);
    b6 = nh(a5, f2, e2);
    null !== b6 && (gi(b6, a5, e2, d3), oh(b6, a5, e2));
  }, enqueueForceUpdate: function(a5, b6) {
    a5 = a5._reactInternals;
    var c2 = R2(), d3 = yi(a5), e2 = mh(c2, d3);
    e2.tag = 2;
    void 0 !== b6 && null !== b6 && (e2.callback = b6);
    b6 = nh(a5, e2, d3);
    null !== b6 && (gi(b6, a5, d3, c2), oh(b6, a5, d3));
  } };
  function Fi(a5, b6, c2, d3, e2, f2, g2) {
    a5 = a5.stateNode;
    return "function" === typeof a5.shouldComponentUpdate ? a5.shouldComponentUpdate(d3, f2, g2) : b6.prototype && b6.prototype.isPureReactComponent ? !Ie(c2, d3) || !Ie(e2, f2) : true;
  }
  function Gi(a5, b6, c2) {
    var d3 = false, e2 = Vf;
    var f2 = b6.contextType;
    "object" === typeof f2 && null !== f2 ? f2 = eh(f2) : (e2 = Zf(b6) ? Xf : H3.current, d3 = b6.contextTypes, f2 = (d3 = null !== d3 && void 0 !== d3) ? Yf(a5, e2) : Vf);
    b6 = new b6(c2, f2);
    a5.memoizedState = null !== b6.state && void 0 !== b6.state ? b6.state : null;
    b6.updater = Ei;
    a5.stateNode = b6;
    b6._reactInternals = a5;
    d3 && (a5 = a5.stateNode, a5.__reactInternalMemoizedUnmaskedChildContext = e2, a5.__reactInternalMemoizedMaskedChildContext = f2);
    return b6;
  }
  function Hi(a5, b6, c2, d3) {
    a5 = b6.state;
    "function" === typeof b6.componentWillReceiveProps && b6.componentWillReceiveProps(c2, d3);
    "function" === typeof b6.UNSAFE_componentWillReceiveProps && b6.UNSAFE_componentWillReceiveProps(c2, d3);
    b6.state !== a5 && Ei.enqueueReplaceState(b6, b6.state, null);
  }
  function Ii(a5, b6, c2, d3) {
    var e2 = a5.stateNode;
    e2.props = c2;
    e2.state = a5.memoizedState;
    e2.refs = {};
    kh(a5);
    var f2 = b6.contextType;
    "object" === typeof f2 && null !== f2 ? e2.context = eh(f2) : (f2 = Zf(b6) ? Xf : H3.current, e2.context = Yf(a5, f2));
    e2.state = a5.memoizedState;
    f2 = b6.getDerivedStateFromProps;
    "function" === typeof f2 && (Di(a5, b6, f2, c2), e2.state = a5.memoizedState);
    "function" === typeof b6.getDerivedStateFromProps || "function" === typeof e2.getSnapshotBeforeUpdate || "function" !== typeof e2.UNSAFE_componentWillMount && "function" !== typeof e2.componentWillMount || (b6 = e2.state, "function" === typeof e2.componentWillMount && e2.componentWillMount(), "function" === typeof e2.UNSAFE_componentWillMount && e2.UNSAFE_componentWillMount(), b6 !== e2.state && Ei.enqueueReplaceState(e2, e2.state, null), qh(a5, c2, e2, d3), e2.state = a5.memoizedState);
    "function" === typeof e2.componentDidMount && (a5.flags |= 4194308);
  }
  function Ji(a5, b6) {
    try {
      var c2 = "", d3 = b6;
      do
        c2 += Pa(d3), d3 = d3.return;
      while (d3);
      var e2 = c2;
    } catch (f2) {
      e2 = "\nError generating stack: " + f2.message + "\n" + f2.stack;
    }
    return { value: a5, source: b6, stack: e2, digest: null };
  }
  function Ki(a5, b6, c2) {
    return { value: a5, source: null, stack: null != c2 ? c2 : null, digest: null != b6 ? b6 : null };
  }
  function Li(a5, b6) {
    try {
      console.error(b6.value);
    } catch (c2) {
      setTimeout(function() {
        throw c2;
      });
    }
  }
  var Mi = "function" === typeof WeakMap ? WeakMap : Map;
  function Ni(a5, b6, c2) {
    c2 = mh(-1, c2);
    c2.tag = 3;
    c2.payload = { element: null };
    var d3 = b6.value;
    c2.callback = function() {
      Oi || (Oi = true, Pi = d3);
      Li(a5, b6);
    };
    return c2;
  }
  function Qi(a5, b6, c2) {
    c2 = mh(-1, c2);
    c2.tag = 3;
    var d3 = a5.type.getDerivedStateFromError;
    if ("function" === typeof d3) {
      var e2 = b6.value;
      c2.payload = function() {
        return d3(e2);
      };
      c2.callback = function() {
        Li(a5, b6);
      };
    }
    var f2 = a5.stateNode;
    null !== f2 && "function" === typeof f2.componentDidCatch && (c2.callback = function() {
      Li(a5, b6);
      "function" !== typeof d3 && (null === Ri ? Ri = /* @__PURE__ */ new Set([this]) : Ri.add(this));
      var c5 = b6.stack;
      this.componentDidCatch(b6.value, { componentStack: null !== c5 ? c5 : "" });
    });
    return c2;
  }
  function Si(a5, b6, c2) {
    var d3 = a5.pingCache;
    if (null === d3) {
      d3 = a5.pingCache = new Mi();
      var e2 = /* @__PURE__ */ new Set();
      d3.set(b6, e2);
    } else e2 = d3.get(b6), void 0 === e2 && (e2 = /* @__PURE__ */ new Set(), d3.set(b6, e2));
    e2.has(c2) || (e2.add(c2), a5 = Ti.bind(null, a5, b6, c2), b6.then(a5, a5));
  }
  function Ui(a5) {
    do {
      var b6;
      if (b6 = 13 === a5.tag) b6 = a5.memoizedState, b6 = null !== b6 ? null !== b6.dehydrated ? true : false : true;
      if (b6) return a5;
      a5 = a5.return;
    } while (null !== a5);
    return null;
  }
  function Vi(a5, b6, c2, d3, e2) {
    if (0 === (a5.mode & 1)) return a5 === b6 ? a5.flags |= 65536 : (a5.flags |= 128, c2.flags |= 131072, c2.flags &= -52805, 1 === c2.tag && (null === c2.alternate ? c2.tag = 17 : (b6 = mh(-1, 1), b6.tag = 2, nh(c2, b6, 1))), c2.lanes |= 1), a5;
    a5.flags |= 65536;
    a5.lanes = e2;
    return a5;
  }
  var Wi = ua.ReactCurrentOwner, dh = false;
  function Xi(a5, b6, c2, d3) {
    b6.child = null === a5 ? Vg(b6, null, c2, d3) : Ug2(b6, a5.child, c2, d3);
  }
  function Yi(a5, b6, c2, d3, e2) {
    c2 = c2.render;
    var f2 = b6.ref;
    ch(b6, e2);
    d3 = Nh(a5, b6, c2, d3, f2, e2);
    c2 = Sh();
    if (null !== a5 && !dh) return b6.updateQueue = a5.updateQueue, b6.flags &= -2053, a5.lanes &= ~e2, Zi(a5, b6, e2);
    I2 && c2 && vg(b6);
    b6.flags |= 1;
    Xi(a5, b6, d3, e2);
    return b6.child;
  }
  function $i(a5, b6, c2, d3, e2) {
    if (null === a5) {
      var f2 = c2.type;
      if ("function" === typeof f2 && !aj(f2) && void 0 === f2.defaultProps && null === c2.compare && void 0 === c2.defaultProps) return b6.tag = 15, b6.type = f2, bj(a5, b6, f2, d3, e2);
      a5 = Rg2(c2.type, null, d3, b6, b6.mode, e2);
      a5.ref = b6.ref;
      a5.return = b6;
      return b6.child = a5;
    }
    f2 = a5.child;
    if (0 === (a5.lanes & e2)) {
      var g2 = f2.memoizedProps;
      c2 = c2.compare;
      c2 = null !== c2 ? c2 : Ie;
      if (c2(g2, d3) && a5.ref === b6.ref) return Zi(a5, b6, e2);
    }
    b6.flags |= 1;
    a5 = Pg(f2, d3);
    a5.ref = b6.ref;
    a5.return = b6;
    return b6.child = a5;
  }
  function bj(a5, b6, c2, d3, e2) {
    if (null !== a5) {
      var f2 = a5.memoizedProps;
      if (Ie(f2, d3) && a5.ref === b6.ref) if (dh = false, b6.pendingProps = d3 = f2, 0 !== (a5.lanes & e2)) 0 !== (a5.flags & 131072) && (dh = true);
      else return b6.lanes = a5.lanes, Zi(a5, b6, e2);
    }
    return cj(a5, b6, c2, d3, e2);
  }
  function dj(a5, b6, c2) {
    var d3 = b6.pendingProps, e2 = d3.children, f2 = null !== a5 ? a5.memoizedState : null;
    if ("hidden" === d3.mode) if (0 === (b6.mode & 1)) b6.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, G2(ej, fj), fj |= c2;
    else {
      if (0 === (c2 & 1073741824)) return a5 = null !== f2 ? f2.baseLanes | c2 : c2, b6.lanes = b6.childLanes = 1073741824, b6.memoizedState = { baseLanes: a5, cachePool: null, transitions: null }, b6.updateQueue = null, G2(ej, fj), fj |= a5, null;
      b6.memoizedState = { baseLanes: 0, cachePool: null, transitions: null };
      d3 = null !== f2 ? f2.baseLanes : c2;
      G2(ej, fj);
      fj |= d3;
    }
    else null !== f2 ? (d3 = f2.baseLanes | c2, b6.memoizedState = null) : d3 = c2, G2(ej, fj), fj |= d3;
    Xi(a5, b6, e2, c2);
    return b6.child;
  }
  function gj(a5, b6) {
    var c2 = b6.ref;
    if (null === a5 && null !== c2 || null !== a5 && a5.ref !== c2) b6.flags |= 512, b6.flags |= 2097152;
  }
  function cj(a5, b6, c2, d3, e2) {
    var f2 = Zf(c2) ? Xf : H3.current;
    f2 = Yf(b6, f2);
    ch(b6, e2);
    c2 = Nh(a5, b6, c2, d3, f2, e2);
    d3 = Sh();
    if (null !== a5 && !dh) return b6.updateQueue = a5.updateQueue, b6.flags &= -2053, a5.lanes &= ~e2, Zi(a5, b6, e2);
    I2 && d3 && vg(b6);
    b6.flags |= 1;
    Xi(a5, b6, c2, e2);
    return b6.child;
  }
  function hj(a5, b6, c2, d3, e2) {
    if (Zf(c2)) {
      var f2 = true;
      cg2(b6);
    } else f2 = false;
    ch(b6, e2);
    if (null === b6.stateNode) ij(a5, b6), Gi(b6, c2, d3), Ii(b6, c2, d3, e2), d3 = true;
    else if (null === a5) {
      var g2 = b6.stateNode, h2 = b6.memoizedProps;
      g2.props = h2;
      var k2 = g2.context, l2 = c2.contextType;
      "object" === typeof l2 && null !== l2 ? l2 = eh(l2) : (l2 = Zf(c2) ? Xf : H3.current, l2 = Yf(b6, l2));
      var m2 = c2.getDerivedStateFromProps, q2 = "function" === typeof m2 || "function" === typeof g2.getSnapshotBeforeUpdate;
      q2 || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h2 !== d3 || k2 !== l2) && Hi(b6, g2, d3, l2);
      jh = false;
      var r3 = b6.memoizedState;
      g2.state = r3;
      qh(b6, d3, g2, e2);
      k2 = b6.memoizedState;
      h2 !== d3 || r3 !== k2 || Wf.current || jh ? ("function" === typeof m2 && (Di(b6, c2, m2, d3), k2 = b6.memoizedState), (h2 = jh || Fi(b6, c2, h2, d3, r3, k2, l2)) ? (q2 || "function" !== typeof g2.UNSAFE_componentWillMount && "function" !== typeof g2.componentWillMount || ("function" === typeof g2.componentWillMount && g2.componentWillMount(), "function" === typeof g2.UNSAFE_componentWillMount && g2.UNSAFE_componentWillMount()), "function" === typeof g2.componentDidMount && (b6.flags |= 4194308)) : ("function" === typeof g2.componentDidMount && (b6.flags |= 4194308), b6.memoizedProps = d3, b6.memoizedState = k2), g2.props = d3, g2.state = k2, g2.context = l2, d3 = h2) : ("function" === typeof g2.componentDidMount && (b6.flags |= 4194308), d3 = false);
    } else {
      g2 = b6.stateNode;
      lh(a5, b6);
      h2 = b6.memoizedProps;
      l2 = b6.type === b6.elementType ? h2 : Ci(b6.type, h2);
      g2.props = l2;
      q2 = b6.pendingProps;
      r3 = g2.context;
      k2 = c2.contextType;
      "object" === typeof k2 && null !== k2 ? k2 = eh(k2) : (k2 = Zf(c2) ? Xf : H3.current, k2 = Yf(b6, k2));
      var y2 = c2.getDerivedStateFromProps;
      (m2 = "function" === typeof y2 || "function" === typeof g2.getSnapshotBeforeUpdate) || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h2 !== q2 || r3 !== k2) && Hi(b6, g2, d3, k2);
      jh = false;
      r3 = b6.memoizedState;
      g2.state = r3;
      qh(b6, d3, g2, e2);
      var n2 = b6.memoizedState;
      h2 !== q2 || r3 !== n2 || Wf.current || jh ? ("function" === typeof y2 && (Di(b6, c2, y2, d3), n2 = b6.memoizedState), (l2 = jh || Fi(b6, c2, l2, d3, r3, n2, k2) || false) ? (m2 || "function" !== typeof g2.UNSAFE_componentWillUpdate && "function" !== typeof g2.componentWillUpdate || ("function" === typeof g2.componentWillUpdate && g2.componentWillUpdate(d3, n2, k2), "function" === typeof g2.UNSAFE_componentWillUpdate && g2.UNSAFE_componentWillUpdate(d3, n2, k2)), "function" === typeof g2.componentDidUpdate && (b6.flags |= 4), "function" === typeof g2.getSnapshotBeforeUpdate && (b6.flags |= 1024)) : ("function" !== typeof g2.componentDidUpdate || h2 === a5.memoizedProps && r3 === a5.memoizedState || (b6.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h2 === a5.memoizedProps && r3 === a5.memoizedState || (b6.flags |= 1024), b6.memoizedProps = d3, b6.memoizedState = n2), g2.props = d3, g2.state = n2, g2.context = k2, d3 = l2) : ("function" !== typeof g2.componentDidUpdate || h2 === a5.memoizedProps && r3 === a5.memoizedState || (b6.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h2 === a5.memoizedProps && r3 === a5.memoizedState || (b6.flags |= 1024), d3 = false);
    }
    return jj(a5, b6, c2, d3, f2, e2);
  }
  function jj(a5, b6, c2, d3, e2, f2) {
    gj(a5, b6);
    var g2 = 0 !== (b6.flags & 128);
    if (!d3 && !g2) return e2 && dg2(b6, c2, false), Zi(a5, b6, f2);
    d3 = b6.stateNode;
    Wi.current = b6;
    var h2 = g2 && "function" !== typeof c2.getDerivedStateFromError ? null : d3.render();
    b6.flags |= 1;
    null !== a5 && g2 ? (b6.child = Ug2(b6, a5.child, null, f2), b6.child = Ug2(b6, null, h2, f2)) : Xi(a5, b6, h2, f2);
    b6.memoizedState = d3.state;
    e2 && dg2(b6, c2, true);
    return b6.child;
  }
  function kj(a5) {
    var b6 = a5.stateNode;
    b6.pendingContext ? ag2(a5, b6.pendingContext, b6.pendingContext !== b6.context) : b6.context && ag2(a5, b6.context, false);
    yh(a5, b6.containerInfo);
  }
  function lj(a5, b6, c2, d3, e2) {
    Ig2();
    Jg2(e2);
    b6.flags |= 256;
    Xi(a5, b6, c2, d3);
    return b6.child;
  }
  var mj = { dehydrated: null, treeContext: null, retryLane: 0 };
  function nj(a5) {
    return { baseLanes: a5, cachePool: null, transitions: null };
  }
  function oj(a5, b6, c2) {
    var d3 = b6.pendingProps, e2 = L2.current, f2 = false, g2 = 0 !== (b6.flags & 128), h2;
    (h2 = g2) || (h2 = null !== a5 && null === a5.memoizedState ? false : 0 !== (e2 & 2));
    if (h2) f2 = true, b6.flags &= -129;
    else if (null === a5 || null !== a5.memoizedState) e2 |= 1;
    G2(L2, e2 & 1);
    if (null === a5) {
      Eg2(b6);
      a5 = b6.memoizedState;
      if (null !== a5 && (a5 = a5.dehydrated, null !== a5)) return 0 === (b6.mode & 1) ? b6.lanes = 1 : "$!" === a5.data ? b6.lanes = 8 : b6.lanes = 1073741824, null;
      g2 = d3.children;
      a5 = d3.fallback;
      return f2 ? (d3 = b6.mode, f2 = b6.child, g2 = { mode: "hidden", children: g2 }, 0 === (d3 & 1) && null !== f2 ? (f2.childLanes = 0, f2.pendingProps = g2) : f2 = pj(g2, d3, 0, null), a5 = Tg2(a5, d3, c2, null), f2.return = b6, a5.return = b6, f2.sibling = a5, b6.child = f2, b6.child.memoizedState = nj(c2), b6.memoizedState = mj, a5) : qj(b6, g2);
    }
    e2 = a5.memoizedState;
    if (null !== e2 && (h2 = e2.dehydrated, null !== h2)) return rj(a5, b6, g2, d3, h2, e2, c2);
    if (f2) {
      f2 = d3.fallback;
      g2 = b6.mode;
      e2 = a5.child;
      h2 = e2.sibling;
      var k2 = { mode: "hidden", children: d3.children };
      0 === (g2 & 1) && b6.child !== e2 ? (d3 = b6.child, d3.childLanes = 0, d3.pendingProps = k2, b6.deletions = null) : (d3 = Pg(e2, k2), d3.subtreeFlags = e2.subtreeFlags & 14680064);
      null !== h2 ? f2 = Pg(h2, f2) : (f2 = Tg2(f2, g2, c2, null), f2.flags |= 2);
      f2.return = b6;
      d3.return = b6;
      d3.sibling = f2;
      b6.child = d3;
      d3 = f2;
      f2 = b6.child;
      g2 = a5.child.memoizedState;
      g2 = null === g2 ? nj(c2) : { baseLanes: g2.baseLanes | c2, cachePool: null, transitions: g2.transitions };
      f2.memoizedState = g2;
      f2.childLanes = a5.childLanes & ~c2;
      b6.memoizedState = mj;
      return d3;
    }
    f2 = a5.child;
    a5 = f2.sibling;
    d3 = Pg(f2, { mode: "visible", children: d3.children });
    0 === (b6.mode & 1) && (d3.lanes = c2);
    d3.return = b6;
    d3.sibling = null;
    null !== a5 && (c2 = b6.deletions, null === c2 ? (b6.deletions = [a5], b6.flags |= 16) : c2.push(a5));
    b6.child = d3;
    b6.memoizedState = null;
    return d3;
  }
  function qj(a5, b6) {
    b6 = pj({ mode: "visible", children: b6 }, a5.mode, 0, null);
    b6.return = a5;
    return a5.child = b6;
  }
  function sj(a5, b6, c2, d3) {
    null !== d3 && Jg2(d3);
    Ug2(b6, a5.child, null, c2);
    a5 = qj(b6, b6.pendingProps.children);
    a5.flags |= 2;
    b6.memoizedState = null;
    return a5;
  }
  function rj(a5, b6, c2, d3, e2, f2, g2) {
    if (c2) {
      if (b6.flags & 256) return b6.flags &= -257, d3 = Ki(Error(p3(422))), sj(a5, b6, g2, d3);
      if (null !== b6.memoizedState) return b6.child = a5.child, b6.flags |= 128, null;
      f2 = d3.fallback;
      e2 = b6.mode;
      d3 = pj({ mode: "visible", children: d3.children }, e2, 0, null);
      f2 = Tg2(f2, e2, g2, null);
      f2.flags |= 2;
      d3.return = b6;
      f2.return = b6;
      d3.sibling = f2;
      b6.child = d3;
      0 !== (b6.mode & 1) && Ug2(b6, a5.child, null, g2);
      b6.child.memoizedState = nj(g2);
      b6.memoizedState = mj;
      return f2;
    }
    if (0 === (b6.mode & 1)) return sj(a5, b6, g2, null);
    if ("$!" === e2.data) {
      d3 = e2.nextSibling && e2.nextSibling.dataset;
      if (d3) var h2 = d3.dgst;
      d3 = h2;
      f2 = Error(p3(419));
      d3 = Ki(f2, d3, void 0);
      return sj(a5, b6, g2, d3);
    }
    h2 = 0 !== (g2 & a5.childLanes);
    if (dh || h2) {
      d3 = Q2;
      if (null !== d3) {
        switch (g2 & -g2) {
          case 4:
            e2 = 2;
            break;
          case 16:
            e2 = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            e2 = 32;
            break;
          case 536870912:
            e2 = 268435456;
            break;
          default:
            e2 = 0;
        }
        e2 = 0 !== (e2 & (d3.suspendedLanes | g2)) ? 0 : e2;
        0 !== e2 && e2 !== f2.retryLane && (f2.retryLane = e2, ih(a5, e2), gi(d3, a5, e2, -1));
      }
      tj();
      d3 = Ki(Error(p3(421)));
      return sj(a5, b6, g2, d3);
    }
    if ("$?" === e2.data) return b6.flags |= 128, b6.child = a5.child, b6 = uj.bind(null, a5), e2._reactRetry = b6, null;
    a5 = f2.treeContext;
    yg2 = Lf(e2.nextSibling);
    xg = b6;
    I2 = true;
    zg = null;
    null !== a5 && (og2[pg++] = rg2, og2[pg++] = sg2, og2[pg++] = qg2, rg2 = a5.id, sg2 = a5.overflow, qg2 = b6);
    b6 = qj(b6, d3.children);
    b6.flags |= 4096;
    return b6;
  }
  function vj(a5, b6, c2) {
    a5.lanes |= b6;
    var d3 = a5.alternate;
    null !== d3 && (d3.lanes |= b6);
    bh(a5.return, b6, c2);
  }
  function wj(a5, b6, c2, d3, e2) {
    var f2 = a5.memoizedState;
    null === f2 ? a5.memoizedState = { isBackwards: b6, rendering: null, renderingStartTime: 0, last: d3, tail: c2, tailMode: e2 } : (f2.isBackwards = b6, f2.rendering = null, f2.renderingStartTime = 0, f2.last = d3, f2.tail = c2, f2.tailMode = e2);
  }
  function xj(a5, b6, c2) {
    var d3 = b6.pendingProps, e2 = d3.revealOrder, f2 = d3.tail;
    Xi(a5, b6, d3.children, c2);
    d3 = L2.current;
    if (0 !== (d3 & 2)) d3 = d3 & 1 | 2, b6.flags |= 128;
    else {
      if (null !== a5 && 0 !== (a5.flags & 128)) a: for (a5 = b6.child; null !== a5; ) {
        if (13 === a5.tag) null !== a5.memoizedState && vj(a5, c2, b6);
        else if (19 === a5.tag) vj(a5, c2, b6);
        else if (null !== a5.child) {
          a5.child.return = a5;
          a5 = a5.child;
          continue;
        }
        if (a5 === b6) break a;
        for (; null === a5.sibling; ) {
          if (null === a5.return || a5.return === b6) break a;
          a5 = a5.return;
        }
        a5.sibling.return = a5.return;
        a5 = a5.sibling;
      }
      d3 &= 1;
    }
    G2(L2, d3);
    if (0 === (b6.mode & 1)) b6.memoizedState = null;
    else switch (e2) {
      case "forwards":
        c2 = b6.child;
        for (e2 = null; null !== c2; ) a5 = c2.alternate, null !== a5 && null === Ch(a5) && (e2 = c2), c2 = c2.sibling;
        c2 = e2;
        null === c2 ? (e2 = b6.child, b6.child = null) : (e2 = c2.sibling, c2.sibling = null);
        wj(b6, false, e2, c2, f2);
        break;
      case "backwards":
        c2 = null;
        e2 = b6.child;
        for (b6.child = null; null !== e2; ) {
          a5 = e2.alternate;
          if (null !== a5 && null === Ch(a5)) {
            b6.child = e2;
            break;
          }
          a5 = e2.sibling;
          e2.sibling = c2;
          c2 = e2;
          e2 = a5;
        }
        wj(b6, true, c2, null, f2);
        break;
      case "together":
        wj(b6, false, null, null, void 0);
        break;
      default:
        b6.memoizedState = null;
    }
    return b6.child;
  }
  function ij(a5, b6) {
    0 === (b6.mode & 1) && null !== a5 && (a5.alternate = null, b6.alternate = null, b6.flags |= 2);
  }
  function Zi(a5, b6, c2) {
    null !== a5 && (b6.dependencies = a5.dependencies);
    rh |= b6.lanes;
    if (0 === (c2 & b6.childLanes)) return null;
    if (null !== a5 && b6.child !== a5.child) throw Error(p3(153));
    if (null !== b6.child) {
      a5 = b6.child;
      c2 = Pg(a5, a5.pendingProps);
      b6.child = c2;
      for (c2.return = b6; null !== a5.sibling; ) a5 = a5.sibling, c2 = c2.sibling = Pg(a5, a5.pendingProps), c2.return = b6;
      c2.sibling = null;
    }
    return b6.child;
  }
  function yj(a5, b6, c2) {
    switch (b6.tag) {
      case 3:
        kj(b6);
        Ig2();
        break;
      case 5:
        Ah(b6);
        break;
      case 1:
        Zf(b6.type) && cg2(b6);
        break;
      case 4:
        yh(b6, b6.stateNode.containerInfo);
        break;
      case 10:
        var d3 = b6.type._context, e2 = b6.memoizedProps.value;
        G2(Wg, d3._currentValue);
        d3._currentValue = e2;
        break;
      case 13:
        d3 = b6.memoizedState;
        if (null !== d3) {
          if (null !== d3.dehydrated) return G2(L2, L2.current & 1), b6.flags |= 128, null;
          if (0 !== (c2 & b6.child.childLanes)) return oj(a5, b6, c2);
          G2(L2, L2.current & 1);
          a5 = Zi(a5, b6, c2);
          return null !== a5 ? a5.sibling : null;
        }
        G2(L2, L2.current & 1);
        break;
      case 19:
        d3 = 0 !== (c2 & b6.childLanes);
        if (0 !== (a5.flags & 128)) {
          if (d3) return xj(a5, b6, c2);
          b6.flags |= 128;
        }
        e2 = b6.memoizedState;
        null !== e2 && (e2.rendering = null, e2.tail = null, e2.lastEffect = null);
        G2(L2, L2.current);
        if (d3) break;
        else return null;
      case 22:
      case 23:
        return b6.lanes = 0, dj(a5, b6, c2);
    }
    return Zi(a5, b6, c2);
  }
  var zj, Aj, Bj, Cj;
  zj = function(a5, b6) {
    for (var c2 = b6.child; null !== c2; ) {
      if (5 === c2.tag || 6 === c2.tag) a5.appendChild(c2.stateNode);
      else if (4 !== c2.tag && null !== c2.child) {
        c2.child.return = c2;
        c2 = c2.child;
        continue;
      }
      if (c2 === b6) break;
      for (; null === c2.sibling; ) {
        if (null === c2.return || c2.return === b6) return;
        c2 = c2.return;
      }
      c2.sibling.return = c2.return;
      c2 = c2.sibling;
    }
  };
  Aj = function() {
  };
  Bj = function(a5, b6, c2, d3) {
    var e2 = a5.memoizedProps;
    if (e2 !== d3) {
      a5 = b6.stateNode;
      xh(uh.current);
      var f2 = null;
      switch (c2) {
        case "input":
          e2 = Ya(a5, e2);
          d3 = Ya(a5, d3);
          f2 = [];
          break;
        case "select":
          e2 = A2({}, e2, { value: void 0 });
          d3 = A2({}, d3, { value: void 0 });
          f2 = [];
          break;
        case "textarea":
          e2 = gb(a5, e2);
          d3 = gb(a5, d3);
          f2 = [];
          break;
        default:
          "function" !== typeof e2.onClick && "function" === typeof d3.onClick && (a5.onclick = Bf);
      }
      ub(c2, d3);
      var g2;
      c2 = null;
      for (l2 in e2) if (!d3.hasOwnProperty(l2) && e2.hasOwnProperty(l2) && null != e2[l2]) if ("style" === l2) {
        var h2 = e2[l2];
        for (g2 in h2) h2.hasOwnProperty(g2) && (c2 || (c2 = {}), c2[g2] = "");
      } else "dangerouslySetInnerHTML" !== l2 && "children" !== l2 && "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && "autoFocus" !== l2 && (ea.hasOwnProperty(l2) ? f2 || (f2 = []) : (f2 = f2 || []).push(l2, null));
      for (l2 in d3) {
        var k2 = d3[l2];
        h2 = null != e2 ? e2[l2] : void 0;
        if (d3.hasOwnProperty(l2) && k2 !== h2 && (null != k2 || null != h2)) if ("style" === l2) if (h2) {
          for (g2 in h2) !h2.hasOwnProperty(g2) || k2 && k2.hasOwnProperty(g2) || (c2 || (c2 = {}), c2[g2] = "");
          for (g2 in k2) k2.hasOwnProperty(g2) && h2[g2] !== k2[g2] && (c2 || (c2 = {}), c2[g2] = k2[g2]);
        } else c2 || (f2 || (f2 = []), f2.push(
          l2,
          c2
        )), c2 = k2;
        else "dangerouslySetInnerHTML" === l2 ? (k2 = k2 ? k2.__html : void 0, h2 = h2 ? h2.__html : void 0, null != k2 && h2 !== k2 && (f2 = f2 || []).push(l2, k2)) : "children" === l2 ? "string" !== typeof k2 && "number" !== typeof k2 || (f2 = f2 || []).push(l2, "" + k2) : "suppressContentEditableWarning" !== l2 && "suppressHydrationWarning" !== l2 && (ea.hasOwnProperty(l2) ? (null != k2 && "onScroll" === l2 && D2("scroll", a5), f2 || h2 === k2 || (f2 = [])) : (f2 = f2 || []).push(l2, k2));
      }
      c2 && (f2 = f2 || []).push("style", c2);
      var l2 = f2;
      if (b6.updateQueue = l2) b6.flags |= 4;
    }
  };
  Cj = function(a5, b6, c2, d3) {
    c2 !== d3 && (b6.flags |= 4);
  };
  function Dj(a5, b6) {
    if (!I2) switch (a5.tailMode) {
      case "hidden":
        b6 = a5.tail;
        for (var c2 = null; null !== b6; ) null !== b6.alternate && (c2 = b6), b6 = b6.sibling;
        null === c2 ? a5.tail = null : c2.sibling = null;
        break;
      case "collapsed":
        c2 = a5.tail;
        for (var d3 = null; null !== c2; ) null !== c2.alternate && (d3 = c2), c2 = c2.sibling;
        null === d3 ? b6 || null === a5.tail ? a5.tail = null : a5.tail.sibling = null : d3.sibling = null;
    }
  }
  function S2(a5) {
    var b6 = null !== a5.alternate && a5.alternate.child === a5.child, c2 = 0, d3 = 0;
    if (b6) for (var e2 = a5.child; null !== e2; ) c2 |= e2.lanes | e2.childLanes, d3 |= e2.subtreeFlags & 14680064, d3 |= e2.flags & 14680064, e2.return = a5, e2 = e2.sibling;
    else for (e2 = a5.child; null !== e2; ) c2 |= e2.lanes | e2.childLanes, d3 |= e2.subtreeFlags, d3 |= e2.flags, e2.return = a5, e2 = e2.sibling;
    a5.subtreeFlags |= d3;
    a5.childLanes = c2;
    return b6;
  }
  function Ej(a5, b6, c2) {
    var d3 = b6.pendingProps;
    wg2(b6);
    switch (b6.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return S2(b6), null;
      case 1:
        return Zf(b6.type) && $f(), S2(b6), null;
      case 3:
        d3 = b6.stateNode;
        zh();
        E2(Wf);
        E2(H3);
        Eh();
        d3.pendingContext && (d3.context = d3.pendingContext, d3.pendingContext = null);
        if (null === a5 || null === a5.child) Gg2(b6) ? b6.flags |= 4 : null === a5 || a5.memoizedState.isDehydrated && 0 === (b6.flags & 256) || (b6.flags |= 1024, null !== zg && (Fj(zg), zg = null));
        Aj(a5, b6);
        S2(b6);
        return null;
      case 5:
        Bh(b6);
        var e2 = xh(wh.current);
        c2 = b6.type;
        if (null !== a5 && null != b6.stateNode) Bj(a5, b6, c2, d3, e2), a5.ref !== b6.ref && (b6.flags |= 512, b6.flags |= 2097152);
        else {
          if (!d3) {
            if (null === b6.stateNode) throw Error(p3(166));
            S2(b6);
            return null;
          }
          a5 = xh(uh.current);
          if (Gg2(b6)) {
            d3 = b6.stateNode;
            c2 = b6.type;
            var f2 = b6.memoizedProps;
            d3[Of] = b6;
            d3[Pf] = f2;
            a5 = 0 !== (b6.mode & 1);
            switch (c2) {
              case "dialog":
                D2("cancel", d3);
                D2("close", d3);
                break;
              case "iframe":
              case "object":
              case "embed":
                D2("load", d3);
                break;
              case "video":
              case "audio":
                for (e2 = 0; e2 < lf.length; e2++) D2(lf[e2], d3);
                break;
              case "source":
                D2("error", d3);
                break;
              case "img":
              case "image":
              case "link":
                D2(
                  "error",
                  d3
                );
                D2("load", d3);
                break;
              case "details":
                D2("toggle", d3);
                break;
              case "input":
                Za(d3, f2);
                D2("invalid", d3);
                break;
              case "select":
                d3._wrapperState = { wasMultiple: !!f2.multiple };
                D2("invalid", d3);
                break;
              case "textarea":
                hb(d3, f2), D2("invalid", d3);
            }
            ub(c2, f2);
            e2 = null;
            for (var g2 in f2) if (f2.hasOwnProperty(g2)) {
              var h2 = f2[g2];
              "children" === g2 ? "string" === typeof h2 ? d3.textContent !== h2 && (true !== f2.suppressHydrationWarning && Af(d3.textContent, h2, a5), e2 = ["children", h2]) : "number" === typeof h2 && d3.textContent !== "" + h2 && (true !== f2.suppressHydrationWarning && Af(
                d3.textContent,
                h2,
                a5
              ), e2 = ["children", "" + h2]) : ea.hasOwnProperty(g2) && null != h2 && "onScroll" === g2 && D2("scroll", d3);
            }
            switch (c2) {
              case "input":
                Va(d3);
                db(d3, f2, true);
                break;
              case "textarea":
                Va(d3);
                jb(d3);
                break;
              case "select":
              case "option":
                break;
              default:
                "function" === typeof f2.onClick && (d3.onclick = Bf);
            }
            d3 = e2;
            b6.updateQueue = d3;
            null !== d3 && (b6.flags |= 4);
          } else {
            g2 = 9 === e2.nodeType ? e2 : e2.ownerDocument;
            "http://www.w3.org/1999/xhtml" === a5 && (a5 = kb(c2));
            "http://www.w3.org/1999/xhtml" === a5 ? "script" === c2 ? (a5 = g2.createElement("div"), a5.innerHTML = "<script><\/script>", a5 = a5.removeChild(a5.firstChild)) : "string" === typeof d3.is ? a5 = g2.createElement(c2, { is: d3.is }) : (a5 = g2.createElement(c2), "select" === c2 && (g2 = a5, d3.multiple ? g2.multiple = true : d3.size && (g2.size = d3.size))) : a5 = g2.createElementNS(a5, c2);
            a5[Of] = b6;
            a5[Pf] = d3;
            zj(a5, b6, false, false);
            b6.stateNode = a5;
            a: {
              g2 = vb(c2, d3);
              switch (c2) {
                case "dialog":
                  D2("cancel", a5);
                  D2("close", a5);
                  e2 = d3;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  D2("load", a5);
                  e2 = d3;
                  break;
                case "video":
                case "audio":
                  for (e2 = 0; e2 < lf.length; e2++) D2(lf[e2], a5);
                  e2 = d3;
                  break;
                case "source":
                  D2("error", a5);
                  e2 = d3;
                  break;
                case "img":
                case "image":
                case "link":
                  D2(
                    "error",
                    a5
                  );
                  D2("load", a5);
                  e2 = d3;
                  break;
                case "details":
                  D2("toggle", a5);
                  e2 = d3;
                  break;
                case "input":
                  Za(a5, d3);
                  e2 = Ya(a5, d3);
                  D2("invalid", a5);
                  break;
                case "option":
                  e2 = d3;
                  break;
                case "select":
                  a5._wrapperState = { wasMultiple: !!d3.multiple };
                  e2 = A2({}, d3, { value: void 0 });
                  D2("invalid", a5);
                  break;
                case "textarea":
                  hb(a5, d3);
                  e2 = gb(a5, d3);
                  D2("invalid", a5);
                  break;
                default:
                  e2 = d3;
              }
              ub(c2, e2);
              h2 = e2;
              for (f2 in h2) if (h2.hasOwnProperty(f2)) {
                var k2 = h2[f2];
                "style" === f2 ? sb(a5, k2) : "dangerouslySetInnerHTML" === f2 ? (k2 = k2 ? k2.__html : void 0, null != k2 && nb(a5, k2)) : "children" === f2 ? "string" === typeof k2 ? ("textarea" !== c2 || "" !== k2) && ob(a5, k2) : "number" === typeof k2 && ob(a5, "" + k2) : "suppressContentEditableWarning" !== f2 && "suppressHydrationWarning" !== f2 && "autoFocus" !== f2 && (ea.hasOwnProperty(f2) ? null != k2 && "onScroll" === f2 && D2("scroll", a5) : null != k2 && ta(a5, f2, k2, g2));
              }
              switch (c2) {
                case "input":
                  Va(a5);
                  db(a5, d3, false);
                  break;
                case "textarea":
                  Va(a5);
                  jb(a5);
                  break;
                case "option":
                  null != d3.value && a5.setAttribute("value", "" + Sa(d3.value));
                  break;
                case "select":
                  a5.multiple = !!d3.multiple;
                  f2 = d3.value;
                  null != f2 ? fb(a5, !!d3.multiple, f2, false) : null != d3.defaultValue && fb(
                    a5,
                    !!d3.multiple,
                    d3.defaultValue,
                    true
                  );
                  break;
                default:
                  "function" === typeof e2.onClick && (a5.onclick = Bf);
              }
              switch (c2) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  d3 = !!d3.autoFocus;
                  break a;
                case "img":
                  d3 = true;
                  break a;
                default:
                  d3 = false;
              }
            }
            d3 && (b6.flags |= 4);
          }
          null !== b6.ref && (b6.flags |= 512, b6.flags |= 2097152);
        }
        S2(b6);
        return null;
      case 6:
        if (a5 && null != b6.stateNode) Cj(a5, b6, a5.memoizedProps, d3);
        else {
          if ("string" !== typeof d3 && null === b6.stateNode) throw Error(p3(166));
          c2 = xh(wh.current);
          xh(uh.current);
          if (Gg2(b6)) {
            d3 = b6.stateNode;
            c2 = b6.memoizedProps;
            d3[Of] = b6;
            if (f2 = d3.nodeValue !== c2) {
              if (a5 = xg, null !== a5) switch (a5.tag) {
                case 3:
                  Af(d3.nodeValue, c2, 0 !== (a5.mode & 1));
                  break;
                case 5:
                  true !== a5.memoizedProps.suppressHydrationWarning && Af(d3.nodeValue, c2, 0 !== (a5.mode & 1));
              }
            }
            f2 && (b6.flags |= 4);
          } else d3 = (9 === c2.nodeType ? c2 : c2.ownerDocument).createTextNode(d3), d3[Of] = b6, b6.stateNode = d3;
        }
        S2(b6);
        return null;
      case 13:
        E2(L2);
        d3 = b6.memoizedState;
        if (null === a5 || null !== a5.memoizedState && null !== a5.memoizedState.dehydrated) {
          if (I2 && null !== yg2 && 0 !== (b6.mode & 1) && 0 === (b6.flags & 128)) Hg(), Ig2(), b6.flags |= 98560, f2 = false;
          else if (f2 = Gg2(b6), null !== d3 && null !== d3.dehydrated) {
            if (null === a5) {
              if (!f2) throw Error(p3(318));
              f2 = b6.memoizedState;
              f2 = null !== f2 ? f2.dehydrated : null;
              if (!f2) throw Error(p3(317));
              f2[Of] = b6;
            } else Ig2(), 0 === (b6.flags & 128) && (b6.memoizedState = null), b6.flags |= 4;
            S2(b6);
            f2 = false;
          } else null !== zg && (Fj(zg), zg = null), f2 = true;
          if (!f2) return b6.flags & 65536 ? b6 : null;
        }
        if (0 !== (b6.flags & 128)) return b6.lanes = c2, b6;
        d3 = null !== d3;
        d3 !== (null !== a5 && null !== a5.memoizedState) && d3 && (b6.child.flags |= 8192, 0 !== (b6.mode & 1) && (null === a5 || 0 !== (L2.current & 1) ? 0 === T2 && (T2 = 3) : tj()));
        null !== b6.updateQueue && (b6.flags |= 4);
        S2(b6);
        return null;
      case 4:
        return zh(), Aj(a5, b6), null === a5 && sf(b6.stateNode.containerInfo), S2(b6), null;
      case 10:
        return ah(b6.type._context), S2(b6), null;
      case 17:
        return Zf(b6.type) && $f(), S2(b6), null;
      case 19:
        E2(L2);
        f2 = b6.memoizedState;
        if (null === f2) return S2(b6), null;
        d3 = 0 !== (b6.flags & 128);
        g2 = f2.rendering;
        if (null === g2) if (d3) Dj(f2, false);
        else {
          if (0 !== T2 || null !== a5 && 0 !== (a5.flags & 128)) for (a5 = b6.child; null !== a5; ) {
            g2 = Ch(a5);
            if (null !== g2) {
              b6.flags |= 128;
              Dj(f2, false);
              d3 = g2.updateQueue;
              null !== d3 && (b6.updateQueue = d3, b6.flags |= 4);
              b6.subtreeFlags = 0;
              d3 = c2;
              for (c2 = b6.child; null !== c2; ) f2 = c2, a5 = d3, f2.flags &= 14680066, g2 = f2.alternate, null === g2 ? (f2.childLanes = 0, f2.lanes = a5, f2.child = null, f2.subtreeFlags = 0, f2.memoizedProps = null, f2.memoizedState = null, f2.updateQueue = null, f2.dependencies = null, f2.stateNode = null) : (f2.childLanes = g2.childLanes, f2.lanes = g2.lanes, f2.child = g2.child, f2.subtreeFlags = 0, f2.deletions = null, f2.memoizedProps = g2.memoizedProps, f2.memoizedState = g2.memoizedState, f2.updateQueue = g2.updateQueue, f2.type = g2.type, a5 = g2.dependencies, f2.dependencies = null === a5 ? null : { lanes: a5.lanes, firstContext: a5.firstContext }), c2 = c2.sibling;
              G2(L2, L2.current & 1 | 2);
              return b6.child;
            }
            a5 = a5.sibling;
          }
          null !== f2.tail && B2() > Gj && (b6.flags |= 128, d3 = true, Dj(f2, false), b6.lanes = 4194304);
        }
        else {
          if (!d3) if (a5 = Ch(g2), null !== a5) {
            if (b6.flags |= 128, d3 = true, c2 = a5.updateQueue, null !== c2 && (b6.updateQueue = c2, b6.flags |= 4), Dj(f2, true), null === f2.tail && "hidden" === f2.tailMode && !g2.alternate && !I2) return S2(b6), null;
          } else 2 * B2() - f2.renderingStartTime > Gj && 1073741824 !== c2 && (b6.flags |= 128, d3 = true, Dj(f2, false), b6.lanes = 4194304);
          f2.isBackwards ? (g2.sibling = b6.child, b6.child = g2) : (c2 = f2.last, null !== c2 ? c2.sibling = g2 : b6.child = g2, f2.last = g2);
        }
        if (null !== f2.tail) return b6 = f2.tail, f2.rendering = b6, f2.tail = b6.sibling, f2.renderingStartTime = B2(), b6.sibling = null, c2 = L2.current, G2(L2, d3 ? c2 & 1 | 2 : c2 & 1), b6;
        S2(b6);
        return null;
      case 22:
      case 23:
        return Hj(), d3 = null !== b6.memoizedState, null !== a5 && null !== a5.memoizedState !== d3 && (b6.flags |= 8192), d3 && 0 !== (b6.mode & 1) ? 0 !== (fj & 1073741824) && (S2(b6), b6.subtreeFlags & 6 && (b6.flags |= 8192)) : S2(b6), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(p3(156, b6.tag));
  }
  function Ij(a5, b6) {
    wg2(b6);
    switch (b6.tag) {
      case 1:
        return Zf(b6.type) && $f(), a5 = b6.flags, a5 & 65536 ? (b6.flags = a5 & -65537 | 128, b6) : null;
      case 3:
        return zh(), E2(Wf), E2(H3), Eh(), a5 = b6.flags, 0 !== (a5 & 65536) && 0 === (a5 & 128) ? (b6.flags = a5 & -65537 | 128, b6) : null;
      case 5:
        return Bh(b6), null;
      case 13:
        E2(L2);
        a5 = b6.memoizedState;
        if (null !== a5 && null !== a5.dehydrated) {
          if (null === b6.alternate) throw Error(p3(340));
          Ig2();
        }
        a5 = b6.flags;
        return a5 & 65536 ? (b6.flags = a5 & -65537 | 128, b6) : null;
      case 19:
        return E2(L2), null;
      case 4:
        return zh(), null;
      case 10:
        return ah(b6.type._context), null;
      case 22:
      case 23:
        return Hj(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Jj = false, U2 = false, Kj = "function" === typeof WeakSet ? WeakSet : Set, V3 = null;
  function Lj(a5, b6) {
    var c2 = a5.ref;
    if (null !== c2) if ("function" === typeof c2) try {
      c2(null);
    } catch (d3) {
      W2(a5, b6, d3);
    }
    else c2.current = null;
  }
  function Mj(a5, b6, c2) {
    try {
      c2();
    } catch (d3) {
      W2(a5, b6, d3);
    }
  }
  var Nj = false;
  function Oj(a5, b6) {
    Cf = dd;
    a5 = Me();
    if (Ne(a5)) {
      if ("selectionStart" in a5) var c2 = { start: a5.selectionStart, end: a5.selectionEnd };
      else a: {
        c2 = (c2 = a5.ownerDocument) && c2.defaultView || window;
        var d3 = c2.getSelection && c2.getSelection();
        if (d3 && 0 !== d3.rangeCount) {
          c2 = d3.anchorNode;
          var e2 = d3.anchorOffset, f2 = d3.focusNode;
          d3 = d3.focusOffset;
          try {
            c2.nodeType, f2.nodeType;
          } catch (F2) {
            c2 = null;
            break a;
          }
          var g2 = 0, h2 = -1, k2 = -1, l2 = 0, m2 = 0, q2 = a5, r3 = null;
          b: for (; ; ) {
            for (var y2; ; ) {
              q2 !== c2 || 0 !== e2 && 3 !== q2.nodeType || (h2 = g2 + e2);
              q2 !== f2 || 0 !== d3 && 3 !== q2.nodeType || (k2 = g2 + d3);
              3 === q2.nodeType && (g2 += q2.nodeValue.length);
              if (null === (y2 = q2.firstChild)) break;
              r3 = q2;
              q2 = y2;
            }
            for (; ; ) {
              if (q2 === a5) break b;
              r3 === c2 && ++l2 === e2 && (h2 = g2);
              r3 === f2 && ++m2 === d3 && (k2 = g2);
              if (null !== (y2 = q2.nextSibling)) break;
              q2 = r3;
              r3 = q2.parentNode;
            }
            q2 = y2;
          }
          c2 = -1 === h2 || -1 === k2 ? null : { start: h2, end: k2 };
        } else c2 = null;
      }
      c2 = c2 || { start: 0, end: 0 };
    } else c2 = null;
    Df = { focusedElem: a5, selectionRange: c2 };
    dd = false;
    for (V3 = b6; null !== V3; ) if (b6 = V3, a5 = b6.child, 0 !== (b6.subtreeFlags & 1028) && null !== a5) a5.return = b6, V3 = a5;
    else for (; null !== V3; ) {
      b6 = V3;
      try {
        var n2 = b6.alternate;
        if (0 !== (b6.flags & 1024)) switch (b6.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (null !== n2) {
              var t2 = n2.memoizedProps, J2 = n2.memoizedState, x3 = b6.stateNode, w2 = x3.getSnapshotBeforeUpdate(b6.elementType === b6.type ? t2 : Ci(b6.type, t2), J2);
              x3.__reactInternalSnapshotBeforeUpdate = w2;
            }
            break;
          case 3:
            var u2 = b6.stateNode.containerInfo;
            1 === u2.nodeType ? u2.textContent = "" : 9 === u2.nodeType && u2.documentElement && u2.removeChild(u2.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(p3(163));
        }
      } catch (F2) {
        W2(b6, b6.return, F2);
      }
      a5 = b6.sibling;
      if (null !== a5) {
        a5.return = b6.return;
        V3 = a5;
        break;
      }
      V3 = b6.return;
    }
    n2 = Nj;
    Nj = false;
    return n2;
  }
  function Pj(a5, b6, c2) {
    var d3 = b6.updateQueue;
    d3 = null !== d3 ? d3.lastEffect : null;
    if (null !== d3) {
      var e2 = d3 = d3.next;
      do {
        if ((e2.tag & a5) === a5) {
          var f2 = e2.destroy;
          e2.destroy = void 0;
          void 0 !== f2 && Mj(b6, c2, f2);
        }
        e2 = e2.next;
      } while (e2 !== d3);
    }
  }
  function Qj(a5, b6) {
    b6 = b6.updateQueue;
    b6 = null !== b6 ? b6.lastEffect : null;
    if (null !== b6) {
      var c2 = b6 = b6.next;
      do {
        if ((c2.tag & a5) === a5) {
          var d3 = c2.create;
          c2.destroy = d3();
        }
        c2 = c2.next;
      } while (c2 !== b6);
    }
  }
  function Rj(a5) {
    var b6 = a5.ref;
    if (null !== b6) {
      var c2 = a5.stateNode;
      switch (a5.tag) {
        case 5:
          a5 = c2;
          break;
        default:
          a5 = c2;
      }
      "function" === typeof b6 ? b6(a5) : b6.current = a5;
    }
  }
  function Sj(a5) {
    var b6 = a5.alternate;
    null !== b6 && (a5.alternate = null, Sj(b6));
    a5.child = null;
    a5.deletions = null;
    a5.sibling = null;
    5 === a5.tag && (b6 = a5.stateNode, null !== b6 && (delete b6[Of], delete b6[Pf], delete b6[of], delete b6[Qf], delete b6[Rf]));
    a5.stateNode = null;
    a5.return = null;
    a5.dependencies = null;
    a5.memoizedProps = null;
    a5.memoizedState = null;
    a5.pendingProps = null;
    a5.stateNode = null;
    a5.updateQueue = null;
  }
  function Tj(a5) {
    return 5 === a5.tag || 3 === a5.tag || 4 === a5.tag;
  }
  function Uj(a5) {
    a: for (; ; ) {
      for (; null === a5.sibling; ) {
        if (null === a5.return || Tj(a5.return)) return null;
        a5 = a5.return;
      }
      a5.sibling.return = a5.return;
      for (a5 = a5.sibling; 5 !== a5.tag && 6 !== a5.tag && 18 !== a5.tag; ) {
        if (a5.flags & 2) continue a;
        if (null === a5.child || 4 === a5.tag) continue a;
        else a5.child.return = a5, a5 = a5.child;
      }
      if (!(a5.flags & 2)) return a5.stateNode;
    }
  }
  function Vj(a5, b6, c2) {
    var d3 = a5.tag;
    if (5 === d3 || 6 === d3) a5 = a5.stateNode, b6 ? 8 === c2.nodeType ? c2.parentNode.insertBefore(a5, b6) : c2.insertBefore(a5, b6) : (8 === c2.nodeType ? (b6 = c2.parentNode, b6.insertBefore(a5, c2)) : (b6 = c2, b6.appendChild(a5)), c2 = c2._reactRootContainer, null !== c2 && void 0 !== c2 || null !== b6.onclick || (b6.onclick = Bf));
    else if (4 !== d3 && (a5 = a5.child, null !== a5)) for (Vj(a5, b6, c2), a5 = a5.sibling; null !== a5; ) Vj(a5, b6, c2), a5 = a5.sibling;
  }
  function Wj(a5, b6, c2) {
    var d3 = a5.tag;
    if (5 === d3 || 6 === d3) a5 = a5.stateNode, b6 ? c2.insertBefore(a5, b6) : c2.appendChild(a5);
    else if (4 !== d3 && (a5 = a5.child, null !== a5)) for (Wj(a5, b6, c2), a5 = a5.sibling; null !== a5; ) Wj(a5, b6, c2), a5 = a5.sibling;
  }
  var X2 = null, Xj = false;
  function Yj(a5, b6, c2) {
    for (c2 = c2.child; null !== c2; ) Zj(a5, b6, c2), c2 = c2.sibling;
  }
  function Zj(a5, b6, c2) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
      lc.onCommitFiberUnmount(kc, c2);
    } catch (h2) {
    }
    switch (c2.tag) {
      case 5:
        U2 || Lj(c2, b6);
      case 6:
        var d3 = X2, e2 = Xj;
        X2 = null;
        Yj(a5, b6, c2);
        X2 = d3;
        Xj = e2;
        null !== X2 && (Xj ? (a5 = X2, c2 = c2.stateNode, 8 === a5.nodeType ? a5.parentNode.removeChild(c2) : a5.removeChild(c2)) : X2.removeChild(c2.stateNode));
        break;
      case 18:
        null !== X2 && (Xj ? (a5 = X2, c2 = c2.stateNode, 8 === a5.nodeType ? Kf(a5.parentNode, c2) : 1 === a5.nodeType && Kf(a5, c2), bd(a5)) : Kf(X2, c2.stateNode));
        break;
      case 4:
        d3 = X2;
        e2 = Xj;
        X2 = c2.stateNode.containerInfo;
        Xj = true;
        Yj(a5, b6, c2);
        X2 = d3;
        Xj = e2;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!U2 && (d3 = c2.updateQueue, null !== d3 && (d3 = d3.lastEffect, null !== d3))) {
          e2 = d3 = d3.next;
          do {
            var f2 = e2, g2 = f2.destroy;
            f2 = f2.tag;
            void 0 !== g2 && (0 !== (f2 & 2) ? Mj(c2, b6, g2) : 0 !== (f2 & 4) && Mj(c2, b6, g2));
            e2 = e2.next;
          } while (e2 !== d3);
        }
        Yj(a5, b6, c2);
        break;
      case 1:
        if (!U2 && (Lj(c2, b6), d3 = c2.stateNode, "function" === typeof d3.componentWillUnmount)) try {
          d3.props = c2.memoizedProps, d3.state = c2.memoizedState, d3.componentWillUnmount();
        } catch (h2) {
          W2(c2, b6, h2);
        }
        Yj(a5, b6, c2);
        break;
      case 21:
        Yj(a5, b6, c2);
        break;
      case 22:
        c2.mode & 1 ? (U2 = (d3 = U2) || null !== c2.memoizedState, Yj(a5, b6, c2), U2 = d3) : Yj(a5, b6, c2);
        break;
      default:
        Yj(a5, b6, c2);
    }
  }
  function ak(a5) {
    var b6 = a5.updateQueue;
    if (null !== b6) {
      a5.updateQueue = null;
      var c2 = a5.stateNode;
      null === c2 && (c2 = a5.stateNode = new Kj());
      b6.forEach(function(b7) {
        var d3 = bk.bind(null, a5, b7);
        c2.has(b7) || (c2.add(b7), b7.then(d3, d3));
      });
    }
  }
  function ck(a5, b6) {
    var c2 = b6.deletions;
    if (null !== c2) for (var d3 = 0; d3 < c2.length; d3++) {
      var e2 = c2[d3];
      try {
        var f2 = a5, g2 = b6, h2 = g2;
        a: for (; null !== h2; ) {
          switch (h2.tag) {
            case 5:
              X2 = h2.stateNode;
              Xj = false;
              break a;
            case 3:
              X2 = h2.stateNode.containerInfo;
              Xj = true;
              break a;
            case 4:
              X2 = h2.stateNode.containerInfo;
              Xj = true;
              break a;
          }
          h2 = h2.return;
        }
        if (null === X2) throw Error(p3(160));
        Zj(f2, g2, e2);
        X2 = null;
        Xj = false;
        var k2 = e2.alternate;
        null !== k2 && (k2.return = null);
        e2.return = null;
      } catch (l2) {
        W2(e2, b6, l2);
      }
    }
    if (b6.subtreeFlags & 12854) for (b6 = b6.child; null !== b6; ) dk(b6, a5), b6 = b6.sibling;
  }
  function dk(a5, b6) {
    var c2 = a5.alternate, d3 = a5.flags;
    switch (a5.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        ck(b6, a5);
        ek(a5);
        if (d3 & 4) {
          try {
            Pj(3, a5, a5.return), Qj(3, a5);
          } catch (t2) {
            W2(a5, a5.return, t2);
          }
          try {
            Pj(5, a5, a5.return);
          } catch (t2) {
            W2(a5, a5.return, t2);
          }
        }
        break;
      case 1:
        ck(b6, a5);
        ek(a5);
        d3 & 512 && null !== c2 && Lj(c2, c2.return);
        break;
      case 5:
        ck(b6, a5);
        ek(a5);
        d3 & 512 && null !== c2 && Lj(c2, c2.return);
        if (a5.flags & 32) {
          var e2 = a5.stateNode;
          try {
            ob(e2, "");
          } catch (t2) {
            W2(a5, a5.return, t2);
          }
        }
        if (d3 & 4 && (e2 = a5.stateNode, null != e2)) {
          var f2 = a5.memoizedProps, g2 = null !== c2 ? c2.memoizedProps : f2, h2 = a5.type, k2 = a5.updateQueue;
          a5.updateQueue = null;
          if (null !== k2) try {
            "input" === h2 && "radio" === f2.type && null != f2.name && ab(e2, f2);
            vb(h2, g2);
            var l2 = vb(h2, f2);
            for (g2 = 0; g2 < k2.length; g2 += 2) {
              var m2 = k2[g2], q2 = k2[g2 + 1];
              "style" === m2 ? sb(e2, q2) : "dangerouslySetInnerHTML" === m2 ? nb(e2, q2) : "children" === m2 ? ob(e2, q2) : ta(e2, m2, q2, l2);
            }
            switch (h2) {
              case "input":
                bb(e2, f2);
                break;
              case "textarea":
                ib(e2, f2);
                break;
              case "select":
                var r3 = e2._wrapperState.wasMultiple;
                e2._wrapperState.wasMultiple = !!f2.multiple;
                var y2 = f2.value;
                null != y2 ? fb(e2, !!f2.multiple, y2, false) : r3 !== !!f2.multiple && (null != f2.defaultValue ? fb(
                  e2,
                  !!f2.multiple,
                  f2.defaultValue,
                  true
                ) : fb(e2, !!f2.multiple, f2.multiple ? [] : "", false));
            }
            e2[Pf] = f2;
          } catch (t2) {
            W2(a5, a5.return, t2);
          }
        }
        break;
      case 6:
        ck(b6, a5);
        ek(a5);
        if (d3 & 4) {
          if (null === a5.stateNode) throw Error(p3(162));
          e2 = a5.stateNode;
          f2 = a5.memoizedProps;
          try {
            e2.nodeValue = f2;
          } catch (t2) {
            W2(a5, a5.return, t2);
          }
        }
        break;
      case 3:
        ck(b6, a5);
        ek(a5);
        if (d3 & 4 && null !== c2 && c2.memoizedState.isDehydrated) try {
          bd(b6.containerInfo);
        } catch (t2) {
          W2(a5, a5.return, t2);
        }
        break;
      case 4:
        ck(b6, a5);
        ek(a5);
        break;
      case 13:
        ck(b6, a5);
        ek(a5);
        e2 = a5.child;
        e2.flags & 8192 && (f2 = null !== e2.memoizedState, e2.stateNode.isHidden = f2, !f2 || null !== e2.alternate && null !== e2.alternate.memoizedState || (fk = B2()));
        d3 & 4 && ak(a5);
        break;
      case 22:
        m2 = null !== c2 && null !== c2.memoizedState;
        a5.mode & 1 ? (U2 = (l2 = U2) || m2, ck(b6, a5), U2 = l2) : ck(b6, a5);
        ek(a5);
        if (d3 & 8192) {
          l2 = null !== a5.memoizedState;
          if ((a5.stateNode.isHidden = l2) && !m2 && 0 !== (a5.mode & 1)) for (V3 = a5, m2 = a5.child; null !== m2; ) {
            for (q2 = V3 = m2; null !== V3; ) {
              r3 = V3;
              y2 = r3.child;
              switch (r3.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Pj(4, r3, r3.return);
                  break;
                case 1:
                  Lj(r3, r3.return);
                  var n2 = r3.stateNode;
                  if ("function" === typeof n2.componentWillUnmount) {
                    d3 = r3;
                    c2 = r3.return;
                    try {
                      b6 = d3, n2.props = b6.memoizedProps, n2.state = b6.memoizedState, n2.componentWillUnmount();
                    } catch (t2) {
                      W2(d3, c2, t2);
                    }
                  }
                  break;
                case 5:
                  Lj(r3, r3.return);
                  break;
                case 22:
                  if (null !== r3.memoizedState) {
                    gk(q2);
                    continue;
                  }
              }
              null !== y2 ? (y2.return = r3, V3 = y2) : gk(q2);
            }
            m2 = m2.sibling;
          }
          a: for (m2 = null, q2 = a5; ; ) {
            if (5 === q2.tag) {
              if (null === m2) {
                m2 = q2;
                try {
                  e2 = q2.stateNode, l2 ? (f2 = e2.style, "function" === typeof f2.setProperty ? f2.setProperty("display", "none", "important") : f2.display = "none") : (h2 = q2.stateNode, k2 = q2.memoizedProps.style, g2 = void 0 !== k2 && null !== k2 && k2.hasOwnProperty("display") ? k2.display : null, h2.style.display = rb("display", g2));
                } catch (t2) {
                  W2(a5, a5.return, t2);
                }
              }
            } else if (6 === q2.tag) {
              if (null === m2) try {
                q2.stateNode.nodeValue = l2 ? "" : q2.memoizedProps;
              } catch (t2) {
                W2(a5, a5.return, t2);
              }
            } else if ((22 !== q2.tag && 23 !== q2.tag || null === q2.memoizedState || q2 === a5) && null !== q2.child) {
              q2.child.return = q2;
              q2 = q2.child;
              continue;
            }
            if (q2 === a5) break a;
            for (; null === q2.sibling; ) {
              if (null === q2.return || q2.return === a5) break a;
              m2 === q2 && (m2 = null);
              q2 = q2.return;
            }
            m2 === q2 && (m2 = null);
            q2.sibling.return = q2.return;
            q2 = q2.sibling;
          }
        }
        break;
      case 19:
        ck(b6, a5);
        ek(a5);
        d3 & 4 && ak(a5);
        break;
      case 21:
        break;
      default:
        ck(
          b6,
          a5
        ), ek(a5);
    }
  }
  function ek(a5) {
    var b6 = a5.flags;
    if (b6 & 2) {
      try {
        a: {
          for (var c2 = a5.return; null !== c2; ) {
            if (Tj(c2)) {
              var d3 = c2;
              break a;
            }
            c2 = c2.return;
          }
          throw Error(p3(160));
        }
        switch (d3.tag) {
          case 5:
            var e2 = d3.stateNode;
            d3.flags & 32 && (ob(e2, ""), d3.flags &= -33);
            var f2 = Uj(a5);
            Wj(a5, f2, e2);
            break;
          case 3:
          case 4:
            var g2 = d3.stateNode.containerInfo, h2 = Uj(a5);
            Vj(a5, h2, g2);
            break;
          default:
            throw Error(p3(161));
        }
      } catch (k2) {
        W2(a5, a5.return, k2);
      }
      a5.flags &= -3;
    }
    b6 & 4096 && (a5.flags &= -4097);
  }
  function hk(a5, b6, c2) {
    V3 = a5;
    ik(a5);
  }
  function ik(a5, b6, c2) {
    for (var d3 = 0 !== (a5.mode & 1); null !== V3; ) {
      var e2 = V3, f2 = e2.child;
      if (22 === e2.tag && d3) {
        var g2 = null !== e2.memoizedState || Jj;
        if (!g2) {
          var h2 = e2.alternate, k2 = null !== h2 && null !== h2.memoizedState || U2;
          h2 = Jj;
          var l2 = U2;
          Jj = g2;
          if ((U2 = k2) && !l2) for (V3 = e2; null !== V3; ) g2 = V3, k2 = g2.child, 22 === g2.tag && null !== g2.memoizedState ? jk(e2) : null !== k2 ? (k2.return = g2, V3 = k2) : jk(e2);
          for (; null !== f2; ) V3 = f2, ik(f2), f2 = f2.sibling;
          V3 = e2;
          Jj = h2;
          U2 = l2;
        }
        kk(a5);
      } else 0 !== (e2.subtreeFlags & 8772) && null !== f2 ? (f2.return = e2, V3 = f2) : kk(a5);
    }
  }
  function kk(a5) {
    for (; null !== V3; ) {
      var b6 = V3;
      if (0 !== (b6.flags & 8772)) {
        var c2 = b6.alternate;
        try {
          if (0 !== (b6.flags & 8772)) switch (b6.tag) {
            case 0:
            case 11:
            case 15:
              U2 || Qj(5, b6);
              break;
            case 1:
              var d3 = b6.stateNode;
              if (b6.flags & 4 && !U2) if (null === c2) d3.componentDidMount();
              else {
                var e2 = b6.elementType === b6.type ? c2.memoizedProps : Ci(b6.type, c2.memoizedProps);
                d3.componentDidUpdate(e2, c2.memoizedState, d3.__reactInternalSnapshotBeforeUpdate);
              }
              var f2 = b6.updateQueue;
              null !== f2 && sh(b6, f2, d3);
              break;
            case 3:
              var g2 = b6.updateQueue;
              if (null !== g2) {
                c2 = null;
                if (null !== b6.child) switch (b6.child.tag) {
                  case 5:
                    c2 = b6.child.stateNode;
                    break;
                  case 1:
                    c2 = b6.child.stateNode;
                }
                sh(b6, g2, c2);
              }
              break;
            case 5:
              var h2 = b6.stateNode;
              if (null === c2 && b6.flags & 4) {
                c2 = h2;
                var k2 = b6.memoizedProps;
                switch (b6.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    k2.autoFocus && c2.focus();
                    break;
                  case "img":
                    k2.src && (c2.src = k2.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (null === b6.memoizedState) {
                var l2 = b6.alternate;
                if (null !== l2) {
                  var m2 = l2.memoizedState;
                  if (null !== m2) {
                    var q2 = m2.dehydrated;
                    null !== q2 && bd(q2);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(p3(163));
          }
          U2 || b6.flags & 512 && Rj(b6);
        } catch (r3) {
          W2(b6, b6.return, r3);
        }
      }
      if (b6 === a5) {
        V3 = null;
        break;
      }
      c2 = b6.sibling;
      if (null !== c2) {
        c2.return = b6.return;
        V3 = c2;
        break;
      }
      V3 = b6.return;
    }
  }
  function gk(a5) {
    for (; null !== V3; ) {
      var b6 = V3;
      if (b6 === a5) {
        V3 = null;
        break;
      }
      var c2 = b6.sibling;
      if (null !== c2) {
        c2.return = b6.return;
        V3 = c2;
        break;
      }
      V3 = b6.return;
    }
  }
  function jk(a5) {
    for (; null !== V3; ) {
      var b6 = V3;
      try {
        switch (b6.tag) {
          case 0:
          case 11:
          case 15:
            var c2 = b6.return;
            try {
              Qj(4, b6);
            } catch (k2) {
              W2(b6, c2, k2);
            }
            break;
          case 1:
            var d3 = b6.stateNode;
            if ("function" === typeof d3.componentDidMount) {
              var e2 = b6.return;
              try {
                d3.componentDidMount();
              } catch (k2) {
                W2(b6, e2, k2);
              }
            }
            var f2 = b6.return;
            try {
              Rj(b6);
            } catch (k2) {
              W2(b6, f2, k2);
            }
            break;
          case 5:
            var g2 = b6.return;
            try {
              Rj(b6);
            } catch (k2) {
              W2(b6, g2, k2);
            }
        }
      } catch (k2) {
        W2(b6, b6.return, k2);
      }
      if (b6 === a5) {
        V3 = null;
        break;
      }
      var h2 = b6.sibling;
      if (null !== h2) {
        h2.return = b6.return;
        V3 = h2;
        break;
      }
      V3 = b6.return;
    }
  }
  var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K2 = 0, Q2 = null, Y2 = null, Z2 = 0, fj = 0, ej = Uf(0), T2 = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = false, Pi = null, Ri = null, vk = false, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
  function R2() {
    return 0 !== (K2 & 6) ? B2() : -1 !== Ak ? Ak : Ak = B2();
  }
  function yi(a5) {
    if (0 === (a5.mode & 1)) return 1;
    if (0 !== (K2 & 2) && 0 !== Z2) return Z2 & -Z2;
    if (null !== Kg2.transition) return 0 === Bk && (Bk = yc()), Bk;
    a5 = C2;
    if (0 !== a5) return a5;
    a5 = window.event;
    a5 = void 0 === a5 ? 16 : jd(a5.type);
    return a5;
  }
  function gi(a5, b6, c2, d3) {
    if (50 < yk) throw yk = 0, zk = null, Error(p3(185));
    Ac(a5, c2, d3);
    if (0 === (K2 & 2) || a5 !== Q2) a5 === Q2 && (0 === (K2 & 2) && (qk |= c2), 4 === T2 && Ck(a5, Z2)), Dk(a5, d3), 1 === c2 && 0 === K2 && 0 === (b6.mode & 1) && (Gj = B2() + 500, fg && jg());
  }
  function Dk(a5, b6) {
    var c2 = a5.callbackNode;
    wc(a5, b6);
    var d3 = uc(a5, a5 === Q2 ? Z2 : 0);
    if (0 === d3) null !== c2 && bc(c2), a5.callbackNode = null, a5.callbackPriority = 0;
    else if (b6 = d3 & -d3, a5.callbackPriority !== b6) {
      null != c2 && bc(c2);
      if (1 === b6) 0 === a5.tag ? ig2(Ek.bind(null, a5)) : hg2(Ek.bind(null, a5)), Jf(function() {
        0 === (K2 & 6) && jg();
      }), c2 = null;
      else {
        switch (Dc(d3)) {
          case 1:
            c2 = fc;
            break;
          case 4:
            c2 = gc;
            break;
          case 16:
            c2 = hc;
            break;
          case 536870912:
            c2 = jc;
            break;
          default:
            c2 = hc;
        }
        c2 = Fk(c2, Gk.bind(null, a5));
      }
      a5.callbackPriority = b6;
      a5.callbackNode = c2;
    }
  }
  function Gk(a5, b6) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K2 & 6)) throw Error(p3(327));
    var c2 = a5.callbackNode;
    if (Hk() && a5.callbackNode !== c2) return null;
    var d3 = uc(a5, a5 === Q2 ? Z2 : 0);
    if (0 === d3) return null;
    if (0 !== (d3 & 30) || 0 !== (d3 & a5.expiredLanes) || b6) b6 = Ik(a5, d3);
    else {
      b6 = d3;
      var e2 = K2;
      K2 |= 2;
      var f2 = Jk();
      if (Q2 !== a5 || Z2 !== b6) uk = null, Gj = B2() + 500, Kk(a5, b6);
      do
        try {
          Lk();
          break;
        } catch (h2) {
          Mk(a5, h2);
        }
      while (1);
      $g();
      mk.current = f2;
      K2 = e2;
      null !== Y2 ? b6 = 0 : (Q2 = null, Z2 = 0, b6 = T2);
    }
    if (0 !== b6) {
      2 === b6 && (e2 = xc(a5), 0 !== e2 && (d3 = e2, b6 = Nk(a5, e2)));
      if (1 === b6) throw c2 = pk, Kk(a5, 0), Ck(a5, d3), Dk(a5, B2()), c2;
      if (6 === b6) Ck(a5, d3);
      else {
        e2 = a5.current.alternate;
        if (0 === (d3 & 30) && !Ok(e2) && (b6 = Ik(a5, d3), 2 === b6 && (f2 = xc(a5), 0 !== f2 && (d3 = f2, b6 = Nk(a5, f2))), 1 === b6)) throw c2 = pk, Kk(a5, 0), Ck(a5, d3), Dk(a5, B2()), c2;
        a5.finishedWork = e2;
        a5.finishedLanes = d3;
        switch (b6) {
          case 0:
          case 1:
            throw Error(p3(345));
          case 2:
            Pk(a5, tk, uk);
            break;
          case 3:
            Ck(a5, d3);
            if ((d3 & 130023424) === d3 && (b6 = fk + 500 - B2(), 10 < b6)) {
              if (0 !== uc(a5, 0)) break;
              e2 = a5.suspendedLanes;
              if ((e2 & d3) !== d3) {
                R2();
                a5.pingedLanes |= a5.suspendedLanes & e2;
                break;
              }
              a5.timeoutHandle = Ff(Pk.bind(null, a5, tk, uk), b6);
              break;
            }
            Pk(a5, tk, uk);
            break;
          case 4:
            Ck(a5, d3);
            if ((d3 & 4194240) === d3) break;
            b6 = a5.eventTimes;
            for (e2 = -1; 0 < d3; ) {
              var g2 = 31 - oc(d3);
              f2 = 1 << g2;
              g2 = b6[g2];
              g2 > e2 && (e2 = g2);
              d3 &= ~f2;
            }
            d3 = e2;
            d3 = B2() - d3;
            d3 = (120 > d3 ? 120 : 480 > d3 ? 480 : 1080 > d3 ? 1080 : 1920 > d3 ? 1920 : 3e3 > d3 ? 3e3 : 4320 > d3 ? 4320 : 1960 * lk(d3 / 1960)) - d3;
            if (10 < d3) {
              a5.timeoutHandle = Ff(Pk.bind(null, a5, tk, uk), d3);
              break;
            }
            Pk(a5, tk, uk);
            break;
          case 5:
            Pk(a5, tk, uk);
            break;
          default:
            throw Error(p3(329));
        }
      }
    }
    Dk(a5, B2());
    return a5.callbackNode === c2 ? Gk.bind(null, a5) : null;
  }
  function Nk(a5, b6) {
    var c2 = sk;
    a5.current.memoizedState.isDehydrated && (Kk(a5, b6).flags |= 256);
    a5 = Ik(a5, b6);
    2 !== a5 && (b6 = tk, tk = c2, null !== b6 && Fj(b6));
    return a5;
  }
  function Fj(a5) {
    null === tk ? tk = a5 : tk.push.apply(tk, a5);
  }
  function Ok(a5) {
    for (var b6 = a5; ; ) {
      if (b6.flags & 16384) {
        var c2 = b6.updateQueue;
        if (null !== c2 && (c2 = c2.stores, null !== c2)) for (var d3 = 0; d3 < c2.length; d3++) {
          var e2 = c2[d3], f2 = e2.getSnapshot;
          e2 = e2.value;
          try {
            if (!He(f2(), e2)) return false;
          } catch (g2) {
            return false;
          }
        }
      }
      c2 = b6.child;
      if (b6.subtreeFlags & 16384 && null !== c2) c2.return = b6, b6 = c2;
      else {
        if (b6 === a5) break;
        for (; null === b6.sibling; ) {
          if (null === b6.return || b6.return === a5) return true;
          b6 = b6.return;
        }
        b6.sibling.return = b6.return;
        b6 = b6.sibling;
      }
    }
    return true;
  }
  function Ck(a5, b6) {
    b6 &= ~rk;
    b6 &= ~qk;
    a5.suspendedLanes |= b6;
    a5.pingedLanes &= ~b6;
    for (a5 = a5.expirationTimes; 0 < b6; ) {
      var c2 = 31 - oc(b6), d3 = 1 << c2;
      a5[c2] = -1;
      b6 &= ~d3;
    }
  }
  function Ek(a5) {
    if (0 !== (K2 & 6)) throw Error(p3(327));
    Hk();
    var b6 = uc(a5, 0);
    if (0 === (b6 & 1)) return Dk(a5, B2()), null;
    var c2 = Ik(a5, b6);
    if (0 !== a5.tag && 2 === c2) {
      var d3 = xc(a5);
      0 !== d3 && (b6 = d3, c2 = Nk(a5, d3));
    }
    if (1 === c2) throw c2 = pk, Kk(a5, 0), Ck(a5, b6), Dk(a5, B2()), c2;
    if (6 === c2) throw Error(p3(345));
    a5.finishedWork = a5.current.alternate;
    a5.finishedLanes = b6;
    Pk(a5, tk, uk);
    Dk(a5, B2());
    return null;
  }
  function Qk(a5, b6) {
    var c2 = K2;
    K2 |= 1;
    try {
      return a5(b6);
    } finally {
      K2 = c2, 0 === K2 && (Gj = B2() + 500, fg && jg());
    }
  }
  function Rk(a5) {
    null !== wk && 0 === wk.tag && 0 === (K2 & 6) && Hk();
    var b6 = K2;
    K2 |= 1;
    var c2 = ok.transition, d3 = C2;
    try {
      if (ok.transition = null, C2 = 1, a5) return a5();
    } finally {
      C2 = d3, ok.transition = c2, K2 = b6, 0 === (K2 & 6) && jg();
    }
  }
  function Hj() {
    fj = ej.current;
    E2(ej);
  }
  function Kk(a5, b6) {
    a5.finishedWork = null;
    a5.finishedLanes = 0;
    var c2 = a5.timeoutHandle;
    -1 !== c2 && (a5.timeoutHandle = -1, Gf(c2));
    if (null !== Y2) for (c2 = Y2.return; null !== c2; ) {
      var d3 = c2;
      wg2(d3);
      switch (d3.tag) {
        case 1:
          d3 = d3.type.childContextTypes;
          null !== d3 && void 0 !== d3 && $f();
          break;
        case 3:
          zh();
          E2(Wf);
          E2(H3);
          Eh();
          break;
        case 5:
          Bh(d3);
          break;
        case 4:
          zh();
          break;
        case 13:
          E2(L2);
          break;
        case 19:
          E2(L2);
          break;
        case 10:
          ah(d3.type._context);
          break;
        case 22:
        case 23:
          Hj();
      }
      c2 = c2.return;
    }
    Q2 = a5;
    Y2 = a5 = Pg(a5.current, null);
    Z2 = fj = b6;
    T2 = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
      for (b6 = 0; b6 < fh.length; b6++) if (c2 = fh[b6], d3 = c2.interleaved, null !== d3) {
        c2.interleaved = null;
        var e2 = d3.next, f2 = c2.pending;
        if (null !== f2) {
          var g2 = f2.next;
          f2.next = e2;
          d3.next = g2;
        }
        c2.pending = d3;
      }
      fh = null;
    }
    return a5;
  }
  function Mk(a5, b6) {
    do {
      var c2 = Y2;
      try {
        $g();
        Fh.current = Rh;
        if (Ih) {
          for (var d3 = M2.memoizedState; null !== d3; ) {
            var e2 = d3.queue;
            null !== e2 && (e2.pending = null);
            d3 = d3.next;
          }
          Ih = false;
        }
        Hh = 0;
        O3 = N2 = M2 = null;
        Jh = false;
        Kh = 0;
        nk.current = null;
        if (null === c2 || null === c2.return) {
          T2 = 1;
          pk = b6;
          Y2 = null;
          break;
        }
        a: {
          var f2 = a5, g2 = c2.return, h2 = c2, k2 = b6;
          b6 = Z2;
          h2.flags |= 32768;
          if (null !== k2 && "object" === typeof k2 && "function" === typeof k2.then) {
            var l2 = k2, m2 = h2, q2 = m2.tag;
            if (0 === (m2.mode & 1) && (0 === q2 || 11 === q2 || 15 === q2)) {
              var r3 = m2.alternate;
              r3 ? (m2.updateQueue = r3.updateQueue, m2.memoizedState = r3.memoizedState, m2.lanes = r3.lanes) : (m2.updateQueue = null, m2.memoizedState = null);
            }
            var y2 = Ui(g2);
            if (null !== y2) {
              y2.flags &= -257;
              Vi(y2, g2, h2, f2, b6);
              y2.mode & 1 && Si(f2, l2, b6);
              b6 = y2;
              k2 = l2;
              var n2 = b6.updateQueue;
              if (null === n2) {
                var t2 = /* @__PURE__ */ new Set();
                t2.add(k2);
                b6.updateQueue = t2;
              } else n2.add(k2);
              break a;
            } else {
              if (0 === (b6 & 1)) {
                Si(f2, l2, b6);
                tj();
                break a;
              }
              k2 = Error(p3(426));
            }
          } else if (I2 && h2.mode & 1) {
            var J2 = Ui(g2);
            if (null !== J2) {
              0 === (J2.flags & 65536) && (J2.flags |= 256);
              Vi(J2, g2, h2, f2, b6);
              Jg2(Ji(k2, h2));
              break a;
            }
          }
          f2 = k2 = Ji(k2, h2);
          4 !== T2 && (T2 = 2);
          null === sk ? sk = [f2] : sk.push(f2);
          f2 = g2;
          do {
            switch (f2.tag) {
              case 3:
                f2.flags |= 65536;
                b6 &= -b6;
                f2.lanes |= b6;
                var x3 = Ni(f2, k2, b6);
                ph(f2, x3);
                break a;
              case 1:
                h2 = k2;
                var w2 = f2.type, u2 = f2.stateNode;
                if (0 === (f2.flags & 128) && ("function" === typeof w2.getDerivedStateFromError || null !== u2 && "function" === typeof u2.componentDidCatch && (null === Ri || !Ri.has(u2)))) {
                  f2.flags |= 65536;
                  b6 &= -b6;
                  f2.lanes |= b6;
                  var F2 = Qi(f2, h2, b6);
                  ph(f2, F2);
                  break a;
                }
            }
            f2 = f2.return;
          } while (null !== f2);
        }
        Sk(c2);
      } catch (na) {
        b6 = na;
        Y2 === c2 && null !== c2 && (Y2 = c2 = c2.return);
        continue;
      }
      break;
    } while (1);
  }
  function Jk() {
    var a5 = mk.current;
    mk.current = Rh;
    return null === a5 ? Rh : a5;
  }
  function tj() {
    if (0 === T2 || 3 === T2 || 2 === T2) T2 = 4;
    null === Q2 || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q2, Z2);
  }
  function Ik(a5, b6) {
    var c2 = K2;
    K2 |= 2;
    var d3 = Jk();
    if (Q2 !== a5 || Z2 !== b6) uk = null, Kk(a5, b6);
    do
      try {
        Tk();
        break;
      } catch (e2) {
        Mk(a5, e2);
      }
    while (1);
    $g();
    K2 = c2;
    mk.current = d3;
    if (null !== Y2) throw Error(p3(261));
    Q2 = null;
    Z2 = 0;
    return T2;
  }
  function Tk() {
    for (; null !== Y2; ) Uk(Y2);
  }
  function Lk() {
    for (; null !== Y2 && !cc(); ) Uk(Y2);
  }
  function Uk(a5) {
    var b6 = Vk(a5.alternate, a5, fj);
    a5.memoizedProps = a5.pendingProps;
    null === b6 ? Sk(a5) : Y2 = b6;
    nk.current = null;
  }
  function Sk(a5) {
    var b6 = a5;
    do {
      var c2 = b6.alternate;
      a5 = b6.return;
      if (0 === (b6.flags & 32768)) {
        if (c2 = Ej(c2, b6, fj), null !== c2) {
          Y2 = c2;
          return;
        }
      } else {
        c2 = Ij(c2, b6);
        if (null !== c2) {
          c2.flags &= 32767;
          Y2 = c2;
          return;
        }
        if (null !== a5) a5.flags |= 32768, a5.subtreeFlags = 0, a5.deletions = null;
        else {
          T2 = 6;
          Y2 = null;
          return;
        }
      }
      b6 = b6.sibling;
      if (null !== b6) {
        Y2 = b6;
        return;
      }
      Y2 = b6 = a5;
    } while (null !== b6);
    0 === T2 && (T2 = 5);
  }
  function Pk(a5, b6, c2) {
    var d3 = C2, e2 = ok.transition;
    try {
      ok.transition = null, C2 = 1, Wk(a5, b6, c2, d3);
    } finally {
      ok.transition = e2, C2 = d3;
    }
    return null;
  }
  function Wk(a5, b6, c2, d3) {
    do
      Hk();
    while (null !== wk);
    if (0 !== (K2 & 6)) throw Error(p3(327));
    c2 = a5.finishedWork;
    var e2 = a5.finishedLanes;
    if (null === c2) return null;
    a5.finishedWork = null;
    a5.finishedLanes = 0;
    if (c2 === a5.current) throw Error(p3(177));
    a5.callbackNode = null;
    a5.callbackPriority = 0;
    var f2 = c2.lanes | c2.childLanes;
    Bc(a5, f2);
    a5 === Q2 && (Y2 = Q2 = null, Z2 = 0);
    0 === (c2.subtreeFlags & 2064) && 0 === (c2.flags & 2064) || vk || (vk = true, Fk(hc, function() {
      Hk();
      return null;
    }));
    f2 = 0 !== (c2.flags & 15990);
    if (0 !== (c2.subtreeFlags & 15990) || f2) {
      f2 = ok.transition;
      ok.transition = null;
      var g2 = C2;
      C2 = 1;
      var h2 = K2;
      K2 |= 4;
      nk.current = null;
      Oj(a5, c2);
      dk(c2, a5);
      Oe(Df);
      dd = !!Cf;
      Df = Cf = null;
      a5.current = c2;
      hk(c2);
      dc();
      K2 = h2;
      C2 = g2;
      ok.transition = f2;
    } else a5.current = c2;
    vk && (vk = false, wk = a5, xk = e2);
    f2 = a5.pendingLanes;
    0 === f2 && (Ri = null);
    mc(c2.stateNode);
    Dk(a5, B2());
    if (null !== b6) for (d3 = a5.onRecoverableError, c2 = 0; c2 < b6.length; c2++) e2 = b6[c2], d3(e2.value, { componentStack: e2.stack, digest: e2.digest });
    if (Oi) throw Oi = false, a5 = Pi, Pi = null, a5;
    0 !== (xk & 1) && 0 !== a5.tag && Hk();
    f2 = a5.pendingLanes;
    0 !== (f2 & 1) ? a5 === zk ? yk++ : (yk = 0, zk = a5) : yk = 0;
    jg();
    return null;
  }
  function Hk() {
    if (null !== wk) {
      var a5 = Dc(xk), b6 = ok.transition, c2 = C2;
      try {
        ok.transition = null;
        C2 = 16 > a5 ? 16 : a5;
        if (null === wk) var d3 = false;
        else {
          a5 = wk;
          wk = null;
          xk = 0;
          if (0 !== (K2 & 6)) throw Error(p3(331));
          var e2 = K2;
          K2 |= 4;
          for (V3 = a5.current; null !== V3; ) {
            var f2 = V3, g2 = f2.child;
            if (0 !== (V3.flags & 16)) {
              var h2 = f2.deletions;
              if (null !== h2) {
                for (var k2 = 0; k2 < h2.length; k2++) {
                  var l2 = h2[k2];
                  for (V3 = l2; null !== V3; ) {
                    var m2 = V3;
                    switch (m2.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Pj(8, m2, f2);
                    }
                    var q2 = m2.child;
                    if (null !== q2) q2.return = m2, V3 = q2;
                    else for (; null !== V3; ) {
                      m2 = V3;
                      var r3 = m2.sibling, y2 = m2.return;
                      Sj(m2);
                      if (m2 === l2) {
                        V3 = null;
                        break;
                      }
                      if (null !== r3) {
                        r3.return = y2;
                        V3 = r3;
                        break;
                      }
                      V3 = y2;
                    }
                  }
                }
                var n2 = f2.alternate;
                if (null !== n2) {
                  var t2 = n2.child;
                  if (null !== t2) {
                    n2.child = null;
                    do {
                      var J2 = t2.sibling;
                      t2.sibling = null;
                      t2 = J2;
                    } while (null !== t2);
                  }
                }
                V3 = f2;
              }
            }
            if (0 !== (f2.subtreeFlags & 2064) && null !== g2) g2.return = f2, V3 = g2;
            else b: for (; null !== V3; ) {
              f2 = V3;
              if (0 !== (f2.flags & 2048)) switch (f2.tag) {
                case 0:
                case 11:
                case 15:
                  Pj(9, f2, f2.return);
              }
              var x3 = f2.sibling;
              if (null !== x3) {
                x3.return = f2.return;
                V3 = x3;
                break b;
              }
              V3 = f2.return;
            }
          }
          var w2 = a5.current;
          for (V3 = w2; null !== V3; ) {
            g2 = V3;
            var u2 = g2.child;
            if (0 !== (g2.subtreeFlags & 2064) && null !== u2) u2.return = g2, V3 = u2;
            else b: for (g2 = w2; null !== V3; ) {
              h2 = V3;
              if (0 !== (h2.flags & 2048)) try {
                switch (h2.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Qj(9, h2);
                }
              } catch (na) {
                W2(h2, h2.return, na);
              }
              if (h2 === g2) {
                V3 = null;
                break b;
              }
              var F2 = h2.sibling;
              if (null !== F2) {
                F2.return = h2.return;
                V3 = F2;
                break b;
              }
              V3 = h2.return;
            }
          }
          K2 = e2;
          jg();
          if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
            lc.onPostCommitFiberRoot(kc, a5);
          } catch (na) {
          }
          d3 = true;
        }
        return d3;
      } finally {
        C2 = c2, ok.transition = b6;
      }
    }
    return false;
  }
  function Xk(a5, b6, c2) {
    b6 = Ji(c2, b6);
    b6 = Ni(a5, b6, 1);
    a5 = nh(a5, b6, 1);
    b6 = R2();
    null !== a5 && (Ac(a5, 1, b6), Dk(a5, b6));
  }
  function W2(a5, b6, c2) {
    if (3 === a5.tag) Xk(a5, a5, c2);
    else for (; null !== b6; ) {
      if (3 === b6.tag) {
        Xk(b6, a5, c2);
        break;
      } else if (1 === b6.tag) {
        var d3 = b6.stateNode;
        if ("function" === typeof b6.type.getDerivedStateFromError || "function" === typeof d3.componentDidCatch && (null === Ri || !Ri.has(d3))) {
          a5 = Ji(c2, a5);
          a5 = Qi(b6, a5, 1);
          b6 = nh(b6, a5, 1);
          a5 = R2();
          null !== b6 && (Ac(b6, 1, a5), Dk(b6, a5));
          break;
        }
      }
      b6 = b6.return;
    }
  }
  function Ti(a5, b6, c2) {
    var d3 = a5.pingCache;
    null !== d3 && d3.delete(b6);
    b6 = R2();
    a5.pingedLanes |= a5.suspendedLanes & c2;
    Q2 === a5 && (Z2 & c2) === c2 && (4 === T2 || 3 === T2 && (Z2 & 130023424) === Z2 && 500 > B2() - fk ? Kk(a5, 0) : rk |= c2);
    Dk(a5, b6);
  }
  function Yk(a5, b6) {
    0 === b6 && (0 === (a5.mode & 1) ? b6 = 1 : (b6 = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c2 = R2();
    a5 = ih(a5, b6);
    null !== a5 && (Ac(a5, b6, c2), Dk(a5, c2));
  }
  function uj(a5) {
    var b6 = a5.memoizedState, c2 = 0;
    null !== b6 && (c2 = b6.retryLane);
    Yk(a5, c2);
  }
  function bk(a5, b6) {
    var c2 = 0;
    switch (a5.tag) {
      case 13:
        var d3 = a5.stateNode;
        var e2 = a5.memoizedState;
        null !== e2 && (c2 = e2.retryLane);
        break;
      case 19:
        d3 = a5.stateNode;
        break;
      default:
        throw Error(p3(314));
    }
    null !== d3 && d3.delete(b6);
    Yk(a5, c2);
  }
  var Vk;
  Vk = function(a5, b6, c2) {
    if (null !== a5) if (a5.memoizedProps !== b6.pendingProps || Wf.current) dh = true;
    else {
      if (0 === (a5.lanes & c2) && 0 === (b6.flags & 128)) return dh = false, yj(a5, b6, c2);
      dh = 0 !== (a5.flags & 131072) ? true : false;
    }
    else dh = false, I2 && 0 !== (b6.flags & 1048576) && ug(b6, ng2, b6.index);
    b6.lanes = 0;
    switch (b6.tag) {
      case 2:
        var d3 = b6.type;
        ij(a5, b6);
        a5 = b6.pendingProps;
        var e2 = Yf(b6, H3.current);
        ch(b6, c2);
        e2 = Nh(null, b6, d3, a5, e2, c2);
        var f2 = Sh();
        b6.flags |= 1;
        "object" === typeof e2 && null !== e2 && "function" === typeof e2.render && void 0 === e2.$$typeof ? (b6.tag = 1, b6.memoizedState = null, b6.updateQueue = null, Zf(d3) ? (f2 = true, cg2(b6)) : f2 = false, b6.memoizedState = null !== e2.state && void 0 !== e2.state ? e2.state : null, kh(b6), e2.updater = Ei, b6.stateNode = e2, e2._reactInternals = b6, Ii(b6, d3, a5, c2), b6 = jj(null, b6, d3, true, f2, c2)) : (b6.tag = 0, I2 && f2 && vg(b6), Xi(null, b6, e2, c2), b6 = b6.child);
        return b6;
      case 16:
        d3 = b6.elementType;
        a: {
          ij(a5, b6);
          a5 = b6.pendingProps;
          e2 = d3._init;
          d3 = e2(d3._payload);
          b6.type = d3;
          e2 = b6.tag = Zk(d3);
          a5 = Ci(d3, a5);
          switch (e2) {
            case 0:
              b6 = cj(null, b6, d3, a5, c2);
              break a;
            case 1:
              b6 = hj(null, b6, d3, a5, c2);
              break a;
            case 11:
              b6 = Yi(null, b6, d3, a5, c2);
              break a;
            case 14:
              b6 = $i(null, b6, d3, Ci(d3.type, a5), c2);
              break a;
          }
          throw Error(p3(
            306,
            d3,
            ""
          ));
        }
        return b6;
      case 0:
        return d3 = b6.type, e2 = b6.pendingProps, e2 = b6.elementType === d3 ? e2 : Ci(d3, e2), cj(a5, b6, d3, e2, c2);
      case 1:
        return d3 = b6.type, e2 = b6.pendingProps, e2 = b6.elementType === d3 ? e2 : Ci(d3, e2), hj(a5, b6, d3, e2, c2);
      case 3:
        a: {
          kj(b6);
          if (null === a5) throw Error(p3(387));
          d3 = b6.pendingProps;
          f2 = b6.memoizedState;
          e2 = f2.element;
          lh(a5, b6);
          qh(b6, d3, null, c2);
          var g2 = b6.memoizedState;
          d3 = g2.element;
          if (f2.isDehydrated) if (f2 = { element: d3, isDehydrated: false, cache: g2.cache, pendingSuspenseBoundaries: g2.pendingSuspenseBoundaries, transitions: g2.transitions }, b6.updateQueue.baseState = f2, b6.memoizedState = f2, b6.flags & 256) {
            e2 = Ji(Error(p3(423)), b6);
            b6 = lj(a5, b6, d3, c2, e2);
            break a;
          } else if (d3 !== e2) {
            e2 = Ji(Error(p3(424)), b6);
            b6 = lj(a5, b6, d3, c2, e2);
            break a;
          } else for (yg2 = Lf(b6.stateNode.containerInfo.firstChild), xg = b6, I2 = true, zg = null, c2 = Vg(b6, null, d3, c2), b6.child = c2; c2; ) c2.flags = c2.flags & -3 | 4096, c2 = c2.sibling;
          else {
            Ig2();
            if (d3 === e2) {
              b6 = Zi(a5, b6, c2);
              break a;
            }
            Xi(a5, b6, d3, c2);
          }
          b6 = b6.child;
        }
        return b6;
      case 5:
        return Ah(b6), null === a5 && Eg2(b6), d3 = b6.type, e2 = b6.pendingProps, f2 = null !== a5 ? a5.memoizedProps : null, g2 = e2.children, Ef(d3, e2) ? g2 = null : null !== f2 && Ef(d3, f2) && (b6.flags |= 32), gj(a5, b6), Xi(a5, b6, g2, c2), b6.child;
      case 6:
        return null === a5 && Eg2(b6), null;
      case 13:
        return oj(a5, b6, c2);
      case 4:
        return yh(b6, b6.stateNode.containerInfo), d3 = b6.pendingProps, null === a5 ? b6.child = Ug2(b6, null, d3, c2) : Xi(a5, b6, d3, c2), b6.child;
      case 11:
        return d3 = b6.type, e2 = b6.pendingProps, e2 = b6.elementType === d3 ? e2 : Ci(d3, e2), Yi(a5, b6, d3, e2, c2);
      case 7:
        return Xi(a5, b6, b6.pendingProps, c2), b6.child;
      case 8:
        return Xi(a5, b6, b6.pendingProps.children, c2), b6.child;
      case 12:
        return Xi(a5, b6, b6.pendingProps.children, c2), b6.child;
      case 10:
        a: {
          d3 = b6.type._context;
          e2 = b6.pendingProps;
          f2 = b6.memoizedProps;
          g2 = e2.value;
          G2(Wg, d3._currentValue);
          d3._currentValue = g2;
          if (null !== f2) if (He(f2.value, g2)) {
            if (f2.children === e2.children && !Wf.current) {
              b6 = Zi(a5, b6, c2);
              break a;
            }
          } else for (f2 = b6.child, null !== f2 && (f2.return = b6); null !== f2; ) {
            var h2 = f2.dependencies;
            if (null !== h2) {
              g2 = f2.child;
              for (var k2 = h2.firstContext; null !== k2; ) {
                if (k2.context === d3) {
                  if (1 === f2.tag) {
                    k2 = mh(-1, c2 & -c2);
                    k2.tag = 2;
                    var l2 = f2.updateQueue;
                    if (null !== l2) {
                      l2 = l2.shared;
                      var m2 = l2.pending;
                      null === m2 ? k2.next = k2 : (k2.next = m2.next, m2.next = k2);
                      l2.pending = k2;
                    }
                  }
                  f2.lanes |= c2;
                  k2 = f2.alternate;
                  null !== k2 && (k2.lanes |= c2);
                  bh(
                    f2.return,
                    c2,
                    b6
                  );
                  h2.lanes |= c2;
                  break;
                }
                k2 = k2.next;
              }
            } else if (10 === f2.tag) g2 = f2.type === b6.type ? null : f2.child;
            else if (18 === f2.tag) {
              g2 = f2.return;
              if (null === g2) throw Error(p3(341));
              g2.lanes |= c2;
              h2 = g2.alternate;
              null !== h2 && (h2.lanes |= c2);
              bh(g2, c2, b6);
              g2 = f2.sibling;
            } else g2 = f2.child;
            if (null !== g2) g2.return = f2;
            else for (g2 = f2; null !== g2; ) {
              if (g2 === b6) {
                g2 = null;
                break;
              }
              f2 = g2.sibling;
              if (null !== f2) {
                f2.return = g2.return;
                g2 = f2;
                break;
              }
              g2 = g2.return;
            }
            f2 = g2;
          }
          Xi(a5, b6, e2.children, c2);
          b6 = b6.child;
        }
        return b6;
      case 9:
        return e2 = b6.type, d3 = b6.pendingProps.children, ch(b6, c2), e2 = eh(e2), d3 = d3(e2), b6.flags |= 1, Xi(a5, b6, d3, c2), b6.child;
      case 14:
        return d3 = b6.type, e2 = Ci(d3, b6.pendingProps), e2 = Ci(d3.type, e2), $i(a5, b6, d3, e2, c2);
      case 15:
        return bj(a5, b6, b6.type, b6.pendingProps, c2);
      case 17:
        return d3 = b6.type, e2 = b6.pendingProps, e2 = b6.elementType === d3 ? e2 : Ci(d3, e2), ij(a5, b6), b6.tag = 1, Zf(d3) ? (a5 = true, cg2(b6)) : a5 = false, ch(b6, c2), Gi(b6, d3, e2), Ii(b6, d3, e2, c2), jj(null, b6, d3, true, a5, c2);
      case 19:
        return xj(a5, b6, c2);
      case 22:
        return dj(a5, b6, c2);
    }
    throw Error(p3(156, b6.tag));
  };
  function Fk(a5, b6) {
    return ac(a5, b6);
  }
  function $k(a5, b6, c2, d3) {
    this.tag = a5;
    this.key = c2;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b6;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d3;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
  }
  function Bg2(a5, b6, c2, d3) {
    return new $k(a5, b6, c2, d3);
  }
  function aj(a5) {
    a5 = a5.prototype;
    return !(!a5 || !a5.isReactComponent);
  }
  function Zk(a5) {
    if ("function" === typeof a5) return aj(a5) ? 1 : 0;
    if (void 0 !== a5 && null !== a5) {
      a5 = a5.$$typeof;
      if (a5 === Da) return 11;
      if (a5 === Ga) return 14;
    }
    return 2;
  }
  function Pg(a5, b6) {
    var c2 = a5.alternate;
    null === c2 ? (c2 = Bg2(a5.tag, b6, a5.key, a5.mode), c2.elementType = a5.elementType, c2.type = a5.type, c2.stateNode = a5.stateNode, c2.alternate = a5, a5.alternate = c2) : (c2.pendingProps = b6, c2.type = a5.type, c2.flags = 0, c2.subtreeFlags = 0, c2.deletions = null);
    c2.flags = a5.flags & 14680064;
    c2.childLanes = a5.childLanes;
    c2.lanes = a5.lanes;
    c2.child = a5.child;
    c2.memoizedProps = a5.memoizedProps;
    c2.memoizedState = a5.memoizedState;
    c2.updateQueue = a5.updateQueue;
    b6 = a5.dependencies;
    c2.dependencies = null === b6 ? null : { lanes: b6.lanes, firstContext: b6.firstContext };
    c2.sibling = a5.sibling;
    c2.index = a5.index;
    c2.ref = a5.ref;
    return c2;
  }
  function Rg2(a5, b6, c2, d3, e2, f2) {
    var g2 = 2;
    d3 = a5;
    if ("function" === typeof a5) aj(a5) && (g2 = 1);
    else if ("string" === typeof a5) g2 = 5;
    else a: switch (a5) {
      case ya:
        return Tg2(c2.children, e2, f2, b6);
      case za:
        g2 = 8;
        e2 |= 8;
        break;
      case Aa:
        return a5 = Bg2(12, c2, b6, e2 | 2), a5.elementType = Aa, a5.lanes = f2, a5;
      case Ea:
        return a5 = Bg2(13, c2, b6, e2), a5.elementType = Ea, a5.lanes = f2, a5;
      case Fa:
        return a5 = Bg2(19, c2, b6, e2), a5.elementType = Fa, a5.lanes = f2, a5;
      case Ia:
        return pj(c2, e2, f2, b6);
      default:
        if ("object" === typeof a5 && null !== a5) switch (a5.$$typeof) {
          case Ba:
            g2 = 10;
            break a;
          case Ca:
            g2 = 9;
            break a;
          case Da:
            g2 = 11;
            break a;
          case Ga:
            g2 = 14;
            break a;
          case Ha:
            g2 = 16;
            d3 = null;
            break a;
        }
        throw Error(p3(130, null == a5 ? a5 : typeof a5, ""));
    }
    b6 = Bg2(g2, c2, b6, e2);
    b6.elementType = a5;
    b6.type = d3;
    b6.lanes = f2;
    return b6;
  }
  function Tg2(a5, b6, c2, d3) {
    a5 = Bg2(7, a5, d3, b6);
    a5.lanes = c2;
    return a5;
  }
  function pj(a5, b6, c2, d3) {
    a5 = Bg2(22, a5, d3, b6);
    a5.elementType = Ia;
    a5.lanes = c2;
    a5.stateNode = { isHidden: false };
    return a5;
  }
  function Qg2(a5, b6, c2) {
    a5 = Bg2(6, a5, null, b6);
    a5.lanes = c2;
    return a5;
  }
  function Sg2(a5, b6, c2) {
    b6 = Bg2(4, null !== a5.children ? a5.children : [], a5.key, b6);
    b6.lanes = c2;
    b6.stateNode = { containerInfo: a5.containerInfo, pendingChildren: null, implementation: a5.implementation };
    return b6;
  }
  function al(a5, b6, c2, d3, e2) {
    this.tag = b6;
    this.containerInfo = a5;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d3;
    this.onRecoverableError = e2;
    this.mutableSourceEagerHydrationData = null;
  }
  function bl(a5, b6, c2, d3, e2, f2, g2, h2, k2) {
    a5 = new al(a5, b6, c2, h2, k2);
    1 === b6 ? (b6 = 1, true === f2 && (b6 |= 8)) : b6 = 0;
    f2 = Bg2(3, null, null, b6);
    a5.current = f2;
    f2.stateNode = a5;
    f2.memoizedState = { element: d3, isDehydrated: c2, cache: null, transitions: null, pendingSuspenseBoundaries: null };
    kh(f2);
    return a5;
  }
  function cl(a5, b6, c2) {
    var d3 = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return { $$typeof: wa, key: null == d3 ? null : "" + d3, children: a5, containerInfo: b6, implementation: c2 };
  }
  function dl(a5) {
    if (!a5) return Vf;
    a5 = a5._reactInternals;
    a: {
      if (Vb(a5) !== a5 || 1 !== a5.tag) throw Error(p3(170));
      var b6 = a5;
      do {
        switch (b6.tag) {
          case 3:
            b6 = b6.stateNode.context;
            break a;
          case 1:
            if (Zf(b6.type)) {
              b6 = b6.stateNode.__reactInternalMemoizedMergedChildContext;
              break a;
            }
        }
        b6 = b6.return;
      } while (null !== b6);
      throw Error(p3(171));
    }
    if (1 === a5.tag) {
      var c2 = a5.type;
      if (Zf(c2)) return bg(a5, c2, b6);
    }
    return b6;
  }
  function el(a5, b6, c2, d3, e2, f2, g2, h2, k2) {
    a5 = bl(c2, d3, true, a5, e2, f2, g2, h2, k2);
    a5.context = dl(null);
    c2 = a5.current;
    d3 = R2();
    e2 = yi(c2);
    f2 = mh(d3, e2);
    f2.callback = void 0 !== b6 && null !== b6 ? b6 : null;
    nh(c2, f2, e2);
    a5.current.lanes = e2;
    Ac(a5, e2, d3);
    Dk(a5, d3);
    return a5;
  }
  function fl2(a5, b6, c2, d3) {
    var e2 = b6.current, f2 = R2(), g2 = yi(e2);
    c2 = dl(c2);
    null === b6.context ? b6.context = c2 : b6.pendingContext = c2;
    b6 = mh(f2, g2);
    b6.payload = { element: a5 };
    d3 = void 0 === d3 ? null : d3;
    null !== d3 && (b6.callback = d3);
    a5 = nh(e2, b6, g2);
    null !== a5 && (gi(a5, e2, g2, f2), oh(a5, e2, g2));
    return g2;
  }
  function gl(a5) {
    a5 = a5.current;
    if (!a5.child) return null;
    switch (a5.child.tag) {
      case 5:
        return a5.child.stateNode;
      default:
        return a5.child.stateNode;
    }
  }
  function hl(a5, b6) {
    a5 = a5.memoizedState;
    if (null !== a5 && null !== a5.dehydrated) {
      var c2 = a5.retryLane;
      a5.retryLane = 0 !== c2 && c2 < b6 ? c2 : b6;
    }
  }
  function il(a5, b6) {
    hl(a5, b6);
    (a5 = a5.alternate) && hl(a5, b6);
  }
  function jl() {
    return null;
  }
  var kl = "function" === typeof reportError ? reportError : function(a5) {
    console.error(a5);
  };
  function ll(a5) {
    this._internalRoot = a5;
  }
  ml.prototype.render = ll.prototype.render = function(a5) {
    var b6 = this._internalRoot;
    if (null === b6) throw Error(p3(409));
    fl2(a5, b6, null, null);
  };
  ml.prototype.unmount = ll.prototype.unmount = function() {
    var a5 = this._internalRoot;
    if (null !== a5) {
      this._internalRoot = null;
      var b6 = a5.containerInfo;
      Rk(function() {
        fl2(null, a5, null, null);
      });
      b6[uf] = null;
    }
  };
  function ml(a5) {
    this._internalRoot = a5;
  }
  ml.prototype.unstable_scheduleHydration = function(a5) {
    if (a5) {
      var b6 = Hc();
      a5 = { blockedOn: null, target: a5, priority: b6 };
      for (var c2 = 0; c2 < Qc.length && 0 !== b6 && b6 < Qc[c2].priority; c2++) ;
      Qc.splice(c2, 0, a5);
      0 === c2 && Vc(a5);
    }
  };
  function nl(a5) {
    return !(!a5 || 1 !== a5.nodeType && 9 !== a5.nodeType && 11 !== a5.nodeType);
  }
  function ol(a5) {
    return !(!a5 || 1 !== a5.nodeType && 9 !== a5.nodeType && 11 !== a5.nodeType && (8 !== a5.nodeType || " react-mount-point-unstable " !== a5.nodeValue));
  }
  function pl() {
  }
  function ql(a5, b6, c2, d3, e2) {
    if (e2) {
      if ("function" === typeof d3) {
        var f2 = d3;
        d3 = function() {
          var a6 = gl(g2);
          f2.call(a6);
        };
      }
      var g2 = el(b6, d3, a5, 0, null, false, false, "", pl);
      a5._reactRootContainer = g2;
      a5[uf] = g2.current;
      sf(8 === a5.nodeType ? a5.parentNode : a5);
      Rk();
      return g2;
    }
    for (; e2 = a5.lastChild; ) a5.removeChild(e2);
    if ("function" === typeof d3) {
      var h2 = d3;
      d3 = function() {
        var a6 = gl(k2);
        h2.call(a6);
      };
    }
    var k2 = bl(a5, 0, false, null, null, false, false, "", pl);
    a5._reactRootContainer = k2;
    a5[uf] = k2.current;
    sf(8 === a5.nodeType ? a5.parentNode : a5);
    Rk(function() {
      fl2(b6, k2, c2, d3);
    });
    return k2;
  }
  function rl(a5, b6, c2, d3, e2) {
    var f2 = c2._reactRootContainer;
    if (f2) {
      var g2 = f2;
      if ("function" === typeof e2) {
        var h2 = e2;
        e2 = function() {
          var a6 = gl(g2);
          h2.call(a6);
        };
      }
      fl2(b6, g2, a5, e2);
    } else g2 = ql(c2, b6, a5, e2, d3);
    return gl(g2);
  }
  Ec = function(a5) {
    switch (a5.tag) {
      case 3:
        var b6 = a5.stateNode;
        if (b6.current.memoizedState.isDehydrated) {
          var c2 = tc(b6.pendingLanes);
          0 !== c2 && (Cc(b6, c2 | 1), Dk(b6, B2()), 0 === (K2 & 6) && (Gj = B2() + 500, jg()));
        }
        break;
      case 13:
        Rk(function() {
          var b7 = ih(a5, 1);
          if (null !== b7) {
            var c5 = R2();
            gi(b7, a5, 1, c5);
          }
        }), il(a5, 1);
    }
  };
  Fc = function(a5) {
    if (13 === a5.tag) {
      var b6 = ih(a5, 134217728);
      if (null !== b6) {
        var c2 = R2();
        gi(b6, a5, 134217728, c2);
      }
      il(a5, 134217728);
    }
  };
  Gc = function(a5) {
    if (13 === a5.tag) {
      var b6 = yi(a5), c2 = ih(a5, b6);
      if (null !== c2) {
        var d3 = R2();
        gi(c2, a5, b6, d3);
      }
      il(a5, b6);
    }
  };
  Hc = function() {
    return C2;
  };
  Ic = function(a5, b6) {
    var c2 = C2;
    try {
      return C2 = a5, b6();
    } finally {
      C2 = c2;
    }
  };
  yb = function(a5, b6, c2) {
    switch (b6) {
      case "input":
        bb(a5, c2);
        b6 = c2.name;
        if ("radio" === c2.type && null != b6) {
          for (c2 = a5; c2.parentNode; ) c2 = c2.parentNode;
          c2 = c2.querySelectorAll("input[name=" + JSON.stringify("" + b6) + '][type="radio"]');
          for (b6 = 0; b6 < c2.length; b6++) {
            var d3 = c2[b6];
            if (d3 !== a5 && d3.form === a5.form) {
              var e2 = Db(d3);
              if (!e2) throw Error(p3(90));
              Wa(d3);
              bb(d3, e2);
            }
          }
        }
        break;
      case "textarea":
        ib(a5, c2);
        break;
      case "select":
        b6 = c2.value, null != b6 && fb(a5, !!c2.multiple, b6, false);
    }
  };
  Gb = Qk;
  Hb = Rk;
  var sl = { usingClientEntryPoint: false, Events: [Cb, ue, Db, Eb, Fb, Qk] }, tl = { findFiberByHostInstance: Wc, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" };
  var ul = { bundleType: tl.bundleType, version: tl.version, rendererPackageName: tl.rendererPackageName, rendererConfig: tl.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ua.ReactCurrentDispatcher, findHostInstanceByFiber: function(a5) {
    a5 = Zb(a5);
    return null === a5 ? null : a5.stateNode;
  }, findFiberByHostInstance: tl.findFiberByHostInstance || jl, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
      kc = vl.inject(ul), lc = vl;
    } catch (a5) {
    }
  }
  reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
  reactDom_production_min.createPortal = function(a5, b6) {
    var c2 = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b6)) throw Error(p3(200));
    return cl(a5, b6, null, c2);
  };
  reactDom_production_min.createRoot = function(a5, b6) {
    if (!nl(a5)) throw Error(p3(299));
    var c2 = false, d3 = "", e2 = kl;
    null !== b6 && void 0 !== b6 && (true === b6.unstable_strictMode && (c2 = true), void 0 !== b6.identifierPrefix && (d3 = b6.identifierPrefix), void 0 !== b6.onRecoverableError && (e2 = b6.onRecoverableError));
    b6 = bl(a5, 1, false, null, null, c2, false, d3, e2);
    a5[uf] = b6.current;
    sf(8 === a5.nodeType ? a5.parentNode : a5);
    return new ll(b6);
  };
  reactDom_production_min.findDOMNode = function(a5) {
    if (null == a5) return null;
    if (1 === a5.nodeType) return a5;
    var b6 = a5._reactInternals;
    if (void 0 === b6) {
      if ("function" === typeof a5.render) throw Error(p3(188));
      a5 = Object.keys(a5).join(",");
      throw Error(p3(268, a5));
    }
    a5 = Zb(b6);
    a5 = null === a5 ? null : a5.stateNode;
    return a5;
  };
  reactDom_production_min.flushSync = function(a5) {
    return Rk(a5);
  };
  reactDom_production_min.hydrate = function(a5, b6, c2) {
    if (!ol(b6)) throw Error(p3(200));
    return rl(null, a5, b6, true, c2);
  };
  reactDom_production_min.hydrateRoot = function(a5, b6, c2) {
    if (!nl(a5)) throw Error(p3(405));
    var d3 = null != c2 && c2.hydratedSources || null, e2 = false, f2 = "", g2 = kl;
    null !== c2 && void 0 !== c2 && (true === c2.unstable_strictMode && (e2 = true), void 0 !== c2.identifierPrefix && (f2 = c2.identifierPrefix), void 0 !== c2.onRecoverableError && (g2 = c2.onRecoverableError));
    b6 = el(b6, null, a5, 1, null != c2 ? c2 : null, e2, false, f2, g2);
    a5[uf] = b6.current;
    sf(a5);
    if (d3) for (a5 = 0; a5 < d3.length; a5++) c2 = d3[a5], e2 = c2._getVersion, e2 = e2(c2._source), null == b6.mutableSourceEagerHydrationData ? b6.mutableSourceEagerHydrationData = [c2, e2] : b6.mutableSourceEagerHydrationData.push(
      c2,
      e2
    );
    return new ml(b6);
  };
  reactDom_production_min.render = function(a5, b6, c2) {
    if (!ol(b6)) throw Error(p3(200));
    return rl(null, a5, b6, false, c2);
  };
  reactDom_production_min.unmountComponentAtNode = function(a5) {
    if (!ol(a5)) throw Error(p3(40));
    return a5._reactRootContainer ? (Rk(function() {
      rl(null, null, a5, false, function() {
        a5._reactRootContainer = null;
        a5[uf] = null;
      });
    }), true) : false;
  };
  reactDom_production_min.unstable_batchedUpdates = Qk;
  reactDom_production_min.unstable_renderSubtreeIntoContainer = function(a5, b6, c2, d3) {
    if (!ol(c2)) throw Error(p3(200));
    if (null == a5 || void 0 === a5._reactInternals) throw Error(p3(38));
    return rl(a5, b6, c2, false, d3);
  };
  reactDom_production_min.version = "18.3.1-next-f1338f8080-20240426";
  return reactDom_production_min;
}
var hasRequiredReactDom;
function requireReactDom() {
  if (hasRequiredReactDom) return reactDom.exports;
  hasRequiredReactDom = 1;
  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
      return;
    }
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }
  {
    checkDCE();
    reactDom.exports = requireReactDom_production_min();
  }
  return reactDom.exports;
}
var hasRequiredClient;
function requireClient() {
  if (hasRequiredClient) return client;
  hasRequiredClient = 1;
  var m2 = requireReactDom();
  {
    client.createRoot = m2.createRoot;
    client.hydrateRoot = m2.hydrateRoot;
  }
  return client;
}
var clientExports = requireClient();
const REVISION = "173";
const MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 };
const TOUCH = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 };
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const CullFaceFrontBack = 3;
const BasicShadowMap = 0;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const ConstantColorFactor = 211;
const OneMinusConstantColorFactor = 212;
const ConstantAlphaFactor = 213;
const OneMinusConstantAlphaFactor = 214;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const AgXToneMapping = 6;
const NeutralToneMapping = 7;
const AttachedBindMode = "attached";
const DetachedBindMode = "detached";
const UVMapping = 300;
const CubeReflectionMapping = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const RepeatWrapping = 1e3;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipMapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const NearestMipMapLinearFilter = 1005;
const LinearFilter = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipMapNearestFilter = 1007;
const LinearMipmapLinearFilter = 1008;
const LinearMipMapLinearFilter = 1008;
const UnsignedByteType = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedInt248Type = 1020;
const UnsignedInt5999Type = 35902;
const AlphaFormat = 1021;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const LuminanceFormat = 1024;
const LuminanceAlphaFormat = 1025;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBIntegerFormat = 1032;
const RGBAIntegerFormat = 1033;
const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const RGB_BPTC_SIGNED_Format = 36494;
const RGB_BPTC_UNSIGNED_Format = 36495;
const RED_RGTC1_Format = 36283;
const SIGNED_RED_RGTC1_Format = 36284;
const RED_GREEN_RGTC2_Format = 36285;
const SIGNED_RED_GREEN_RGTC2_Format = 36286;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const TrianglesDrawMode = 0;
const TriangleStripDrawMode = 1;
const TriangleFanDrawMode = 2;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const RGBDepthPacking = 3202;
const RGDepthPacking = 3203;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;
const NoColorSpace = "";
const SRGBColorSpace$1 = "srgb";
const LinearSRGBColorSpace$1 = "srgb-linear";
const LinearTransfer = "linear";
const SRGBTransfer = "srgb";
const ZeroStencilOp = 0;
const KeepStencilOp = 7680;
const ReplaceStencilOp = 7681;
const IncrementStencilOp = 7682;
const DecrementStencilOp = 7683;
const IncrementWrapStencilOp = 34055;
const DecrementWrapStencilOp = 34056;
const InvertStencilOp = 5386;
const NeverStencilFunc = 512;
const LessStencilFunc = 513;
const EqualStencilFunc = 514;
const LessEqualStencilFunc = 515;
const GreaterStencilFunc = 516;
const NotEqualStencilFunc = 517;
const GreaterEqualStencilFunc = 518;
const AlwaysStencilFunc = 519;
const NeverCompare = 512;
const LessCompare = 513;
const EqualCompare = 514;
const LessEqualCompare = 515;
const GreaterCompare = 516;
const NotEqualCompare = 517;
const GreaterEqualCompare = 518;
const AlwaysCompare = 519;
const StaticDrawUsage = 35044;
const DynamicDrawUsage = 35048;
const StreamDrawUsage = 35040;
const StaticReadUsage = 35045;
const DynamicReadUsage = 35049;
const StreamReadUsage = 35041;
const StaticCopyUsage = 35046;
const DynamicCopyUsage = 35050;
const StreamCopyUsage = 35042;
const GLSL1 = "100";
const GLSL3 = "300 es";
const WebGLCoordinateSystem = 2e3;
const WebGPUCoordinateSystem = 2001;
const TimestampQuery = {
  COMPUTE: "compute",
  RENDER: "render"
};
let EventDispatcher$2 = class EventDispatcher {
  addEventListener(type, listener) {
    if (this._listeners === void 0) this._listeners = {};
    const listeners = this._listeners;
    if (listeners[type] === void 0) {
      listeners[type] = [];
    }
    if (listeners[type].indexOf(listener) === -1) {
      listeners[type].push(listener);
    }
  }
  hasEventListener(type, listener) {
    const listeners = this._listeners;
    if (listeners === void 0) return false;
    return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
  }
  removeEventListener(type, listener) {
    const listeners = this._listeners;
    if (listeners === void 0) return;
    const listenerArray = listeners[type];
    if (listenerArray !== void 0) {
      const index = listenerArray.indexOf(listener);
      if (index !== -1) {
        listenerArray.splice(index, 1);
      }
    }
  }
  dispatchEvent(event) {
    const listeners = this._listeners;
    if (listeners === void 0) return;
    const listenerArray = listeners[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array = listenerArray.slice(0);
      for (let i2 = 0, l2 = array.length; i2 < l2; i2++) {
        array[i2].call(this, event);
      }
      event.target = null;
    }
  }
};
const _lut$1 = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let _seed = 1234567;
const DEG2RAD$2 = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;
function generateUUID$1() {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d22 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  const uuid = _lut$1[d0 & 255] + _lut$1[d0 >> 8 & 255] + _lut$1[d0 >> 16 & 255] + _lut$1[d0 >> 24 & 255] + "-" + _lut$1[d1 & 255] + _lut$1[d1 >> 8 & 255] + "-" + _lut$1[d1 >> 16 & 15 | 64] + _lut$1[d1 >> 24 & 255] + "-" + _lut$1[d22 & 63 | 128] + _lut$1[d22 >> 8 & 255] + "-" + _lut$1[d22 >> 16 & 255] + _lut$1[d22 >> 24 & 255] + _lut$1[d3 & 255] + _lut$1[d3 >> 8 & 255] + _lut$1[d3 >> 16 & 255] + _lut$1[d3 >> 24 & 255];
  return uuid.toLowerCase();
}
function clamp$4(value, min, max2) {
  return Math.max(min, Math.min(max2, value));
}
function euclideanModulo(n2, m2) {
  return (n2 % m2 + m2) % m2;
}
function mapLinear(x3, a1, a22, b1, b22) {
  return b1 + (x3 - a1) * (b22 - b1) / (a22 - a1);
}
function inverseLerp(x3, y2, value) {
  if (x3 !== y2) {
    return (value - x3) / (y2 - x3);
  } else {
    return 0;
  }
}
function lerp(x3, y2, t2) {
  return (1 - t2) * x3 + t2 * y2;
}
function damp$1(x3, y2, lambda, dt) {
  return lerp(x3, y2, 1 - Math.exp(-lambda * dt));
}
function pingpong(x3, length = 1) {
  return length - Math.abs(euclideanModulo(x3, length * 2) - length);
}
function smoothstep(x3, min, max2) {
  if (x3 <= min) return 0;
  if (x3 >= max2) return 1;
  x3 = (x3 - min) / (max2 - min);
  return x3 * x3 * (3 - 2 * x3);
}
function smootherstep(x3, min, max2) {
  if (x3 <= min) return 0;
  if (x3 >= max2) return 1;
  x3 = (x3 - min) / (max2 - min);
  return x3 * x3 * x3 * (x3 * (x3 * 6 - 15) + 10);
}
function randInt(low, high) {
  return low + Math.floor(Math.random() * (high - low + 1));
}
function randFloat(low, high) {
  return low + Math.random() * (high - low);
}
function randFloatSpread(range) {
  return range * (0.5 - Math.random());
}
function seededRandom(s2) {
  if (s2 !== void 0) _seed = s2;
  let t2 = _seed += 1831565813;
  t2 = Math.imul(t2 ^ t2 >>> 15, t2 | 1);
  t2 ^= t2 + Math.imul(t2 ^ t2 >>> 7, t2 | 61);
  return ((t2 ^ t2 >>> 14) >>> 0) / 4294967296;
}
function degToRad(degrees) {
  return degrees * DEG2RAD$2;
}
function radToDeg(radians) {
  return radians * RAD2DEG;
}
function isPowerOfTwo(value) {
  return (value & value - 1) === 0 && value !== 0;
}
function ceilPowerOfTwo(value) {
  return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function floorPowerOfTwo(value) {
  return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function setQuaternionFromProperEuler(q2, a5, b6, c2, order) {
  const cos = Math.cos;
  const sin = Math.sin;
  const c22 = cos(b6 / 2);
  const s2 = sin(b6 / 2);
  const c13 = cos((a5 + c2) / 2);
  const s13 = sin((a5 + c2) / 2);
  const c1_3 = cos((a5 - c2) / 2);
  const s1_3 = sin((a5 - c2) / 2);
  const c3_1 = cos((c2 - a5) / 2);
  const s3_1 = sin((c2 - a5) / 2);
  switch (order) {
    case "XYX":
      q2.set(c22 * s13, s2 * c1_3, s2 * s1_3, c22 * c13);
      break;
    case "YZY":
      q2.set(s2 * s1_3, c22 * s13, s2 * c1_3, c22 * c13);
      break;
    case "ZXZ":
      q2.set(s2 * c1_3, s2 * s1_3, c22 * s13, c22 * c13);
      break;
    case "XZX":
      q2.set(c22 * s13, s2 * s3_1, s2 * c3_1, c22 * c13);
      break;
    case "YXY":
      q2.set(s2 * c3_1, c22 * s13, s2 * s3_1, c22 * c13);
      break;
    case "ZYZ":
      q2.set(s2 * s3_1, s2 * c3_1, c22 * s13, c22 * c13);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
  }
}
function denormalize(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;
    case Uint32Array:
      return value / 4294967295;
    case Uint16Array:
      return value / 65535;
    case Uint8Array:
      return value / 255;
    case Int32Array:
      return Math.max(value / 2147483647, -1);
    case Int16Array:
      return Math.max(value / 32767, -1);
    case Int8Array:
      return Math.max(value / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function normalize$1(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;
    case Uint32Array:
      return Math.round(value * 4294967295);
    case Uint16Array:
      return Math.round(value * 65535);
    case Uint8Array:
      return Math.round(value * 255);
    case Int32Array:
      return Math.round(value * 2147483647);
    case Int16Array:
      return Math.round(value * 32767);
    case Int8Array:
      return Math.round(value * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const MathUtils = {
  DEG2RAD: DEG2RAD$2,
  RAD2DEG,
  generateUUID: generateUUID$1,
  clamp: clamp$4,
  euclideanModulo,
  mapLinear,
  inverseLerp,
  lerp,
  damp: damp$1,
  pingpong,
  smoothstep,
  smootherstep,
  randInt,
  randFloat,
  randFloatSpread,
  seededRandom,
  degToRad,
  radToDeg,
  isPowerOfTwo,
  ceilPowerOfTwo,
  floorPowerOfTwo,
  setQuaternionFromProperEuler,
  normalize: normalize$1,
  denormalize
};
class Vector2 {
  constructor(x3 = 0, y2 = 0) {
    Vector2.prototype.isVector2 = true;
    this.x = x3;
    this.y = y2;
  }
  get width() {
    return this.x;
  }
  set width(value) {
    this.x = value;
  }
  get height() {
    return this.y;
  }
  set height(value) {
    this.y = value;
  }
  set(x3, y2) {
    this.x = x3;
    this.y = y2;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    return this;
  }
  setX(x3) {
    this.x = x3;
    return this;
  }
  setY(y2) {
    this.y = y2;
    return this;
  }
  setComponent(index, value) {
    switch (index) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      default:
        throw new Error("index is out of range: " + index);
    }
    return this;
  }
  getComponent(index) {
    switch (index) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + index);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(v3) {
    this.x = v3.x;
    this.y = v3.y;
    return this;
  }
  add(v3) {
    this.x += v3.x;
    this.y += v3.y;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    return this;
  }
  addVectors(a5, b6) {
    this.x = a5.x + b6.x;
    this.y = a5.y + b6.y;
    return this;
  }
  addScaledVector(v3, s2) {
    this.x += v3.x * s2;
    this.y += v3.y * s2;
    return this;
  }
  sub(v3) {
    this.x -= v3.x;
    this.y -= v3.y;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    return this;
  }
  subVectors(a5, b6) {
    this.x = a5.x - b6.x;
    this.y = a5.y - b6.y;
    return this;
  }
  multiply(v3) {
    this.x *= v3.x;
    this.y *= v3.y;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    return this;
  }
  divide(v3) {
    this.x /= v3.x;
    this.y /= v3.y;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  applyMatrix3(m2) {
    const x3 = this.x, y2 = this.y;
    const e2 = m2.elements;
    this.x = e2[0] * x3 + e2[3] * y2 + e2[6];
    this.y = e2[1] * x3 + e2[4] * y2 + e2[7];
    return this;
  }
  min(v3) {
    this.x = Math.min(this.x, v3.x);
    this.y = Math.min(this.y, v3.y);
    return this;
  }
  max(v3) {
    this.x = Math.max(this.x, v3.x);
    this.y = Math.max(this.y, v3.y);
    return this;
  }
  clamp(min, max2) {
    this.x = clamp$4(this.x, min.x, max2.x);
    this.y = clamp$4(this.y, min.y, max2.y);
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = clamp$4(this.x, minVal, maxVal);
    this.y = clamp$4(this.y, minVal, maxVal);
    return this;
  }
  clampLength(min, max2) {
    const length = this.length();
    return this.divideScalar(length || 1).multiplyScalar(clamp$4(length, min, max2));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    return this;
  }
  dot(v3) {
    return this.x * v3.x + this.y * v3.y;
  }
  cross(v3) {
    return this.x * v3.y - this.y * v3.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    const angle = Math.atan2(-this.y, -this.x) + Math.PI;
    return angle;
  }
  angleTo(v3) {
    const denominator = Math.sqrt(this.lengthSq() * v3.lengthSq());
    if (denominator === 0) return Math.PI / 2;
    const theta = this.dot(v3) / denominator;
    return Math.acos(clamp$4(theta, -1, 1));
  }
  distanceTo(v3) {
    return Math.sqrt(this.distanceToSquared(v3));
  }
  distanceToSquared(v3) {
    const dx = this.x - v3.x, dy = this.y - v3.y;
    return dx * dx + dy * dy;
  }
  manhattanDistanceTo(v3) {
    return Math.abs(this.x - v3.x) + Math.abs(this.y - v3.y);
  }
  setLength(length) {
    return this.normalize().multiplyScalar(length);
  }
  lerp(v3, alpha) {
    this.x += (v3.x - this.x) * alpha;
    this.y += (v3.y - this.y) * alpha;
    return this;
  }
  lerpVectors(v1, v22, alpha) {
    this.x = v1.x + (v22.x - v1.x) * alpha;
    this.y = v1.y + (v22.y - v1.y) * alpha;
    return this;
  }
  equals(v3) {
    return v3.x === this.x && v3.y === this.y;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    return array;
  }
  fromBufferAttribute(attribute, index) {
    this.x = attribute.getX(index);
    this.y = attribute.getY(index);
    return this;
  }
  rotateAround(center, angle) {
    const c2 = Math.cos(angle), s2 = Math.sin(angle);
    const x3 = this.x - center.x;
    const y2 = this.y - center.y;
    this.x = x3 * c2 - y2 * s2 + center.x;
    this.y = x3 * s2 + y2 * c2 + center.y;
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
  }
}
class Matrix3 {
  constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    Matrix3.prototype.isMatrix3 = true;
    this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ];
    if (n11 !== void 0) {
      this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
  }
  set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    const te = this.elements;
    te[0] = n11;
    te[1] = n21;
    te[2] = n31;
    te[3] = n12;
    te[4] = n22;
    te[5] = n32;
    te[6] = n13;
    te[7] = n23;
    te[8] = n33;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    );
    return this;
  }
  copy(m2) {
    const te = this.elements;
    const me = m2.elements;
    te[0] = me[0];
    te[1] = me[1];
    te[2] = me[2];
    te[3] = me[3];
    te[4] = me[4];
    te[5] = me[5];
    te[6] = me[6];
    te[7] = me[7];
    te[8] = me[8];
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrix3Column(this, 0);
    yAxis.setFromMatrix3Column(this, 1);
    zAxis.setFromMatrix3Column(this, 2);
    return this;
  }
  setFromMatrix4(m2) {
    const me = m2.elements;
    this.set(
      me[0],
      me[4],
      me[8],
      me[1],
      me[5],
      me[9],
      me[2],
      me[6],
      me[10]
    );
    return this;
  }
  multiply(m2) {
    return this.multiplyMatrices(this, m2);
  }
  premultiply(m2) {
    return this.multiplyMatrices(m2, this);
  }
  multiplyMatrices(a5, b6) {
    const ae = a5.elements;
    const be = b6.elements;
    const te = this.elements;
    const a11 = ae[0], a12 = ae[3], a13 = ae[6];
    const a21 = ae[1], a22 = ae[4], a23 = ae[7];
    const a31 = ae[2], a32 = ae[5], a33 = ae[8];
    const b11 = be[0], b12 = be[3], b13 = be[6];
    const b21 = be[1], b22 = be[4], b23 = be[7];
    const b31 = be[2], b32 = be[5], b33 = be[8];
    te[0] = a11 * b11 + a12 * b21 + a13 * b31;
    te[3] = a11 * b12 + a12 * b22 + a13 * b32;
    te[6] = a11 * b13 + a12 * b23 + a13 * b33;
    te[1] = a21 * b11 + a22 * b21 + a23 * b31;
    te[4] = a21 * b12 + a22 * b22 + a23 * b32;
    te[7] = a21 * b13 + a22 * b23 + a23 * b33;
    te[2] = a31 * b11 + a32 * b21 + a33 * b31;
    te[5] = a31 * b12 + a32 * b22 + a33 * b32;
    te[8] = a31 * b13 + a32 * b23 + a33 * b33;
    return this;
  }
  multiplyScalar(s2) {
    const te = this.elements;
    te[0] *= s2;
    te[3] *= s2;
    te[6] *= s2;
    te[1] *= s2;
    te[4] *= s2;
    te[7] *= s2;
    te[2] *= s2;
    te[5] *= s2;
    te[8] *= s2;
    return this;
  }
  determinant() {
    const te = this.elements;
    const a5 = te[0], b6 = te[1], c2 = te[2], d3 = te[3], e2 = te[4], f2 = te[5], g2 = te[6], h2 = te[7], i2 = te[8];
    return a5 * e2 * i2 - a5 * f2 * h2 - b6 * d3 * i2 + b6 * f2 * g2 + c2 * d3 * h2 - c2 * e2 * g2;
  }
  invert() {
    const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
    if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te[0] = t11 * detInv;
    te[1] = (n31 * n23 - n33 * n21) * detInv;
    te[2] = (n32 * n21 - n31 * n22) * detInv;
    te[3] = t12 * detInv;
    te[4] = (n33 * n11 - n31 * n13) * detInv;
    te[5] = (n31 * n12 - n32 * n11) * detInv;
    te[6] = t13 * detInv;
    te[7] = (n21 * n13 - n23 * n11) * detInv;
    te[8] = (n22 * n11 - n21 * n12) * detInv;
    return this;
  }
  transpose() {
    let tmp2;
    const m2 = this.elements;
    tmp2 = m2[1];
    m2[1] = m2[3];
    m2[3] = tmp2;
    tmp2 = m2[2];
    m2[2] = m2[6];
    m2[6] = tmp2;
    tmp2 = m2[5];
    m2[5] = m2[7];
    m2[7] = tmp2;
    return this;
  }
  getNormalMatrix(matrix4) {
    return this.setFromMatrix4(matrix4).invert().transpose();
  }
  transposeIntoArray(r3) {
    const m2 = this.elements;
    r3[0] = m2[0];
    r3[1] = m2[3];
    r3[2] = m2[6];
    r3[3] = m2[1];
    r3[4] = m2[4];
    r3[5] = m2[7];
    r3[6] = m2[2];
    r3[7] = m2[5];
    r3[8] = m2[8];
    return this;
  }
  setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
    const c2 = Math.cos(rotation);
    const s2 = Math.sin(rotation);
    this.set(
      sx * c2,
      sx * s2,
      -sx * (c2 * cx + s2 * cy) + cx + tx,
      -sy * s2,
      sy * c2,
      -sy * (-s2 * cx + c2 * cy) + cy + ty,
      0,
      0,
      1
    );
    return this;
  }
  //
  scale(sx, sy) {
    this.premultiply(_m3.makeScale(sx, sy));
    return this;
  }
  rotate(theta) {
    this.premultiply(_m3.makeRotation(-theta));
    return this;
  }
  translate(tx, ty) {
    this.premultiply(_m3.makeTranslation(tx, ty));
    return this;
  }
  // for 2D Transforms
  makeTranslation(x3, y2) {
    if (x3.isVector2) {
      this.set(
        1,
        0,
        x3.x,
        0,
        1,
        x3.y,
        0,
        0,
        1
      );
    } else {
      this.set(
        1,
        0,
        x3,
        0,
        1,
        y2,
        0,
        0,
        1
      );
    }
    return this;
  }
  makeRotation(theta) {
    const c2 = Math.cos(theta);
    const s2 = Math.sin(theta);
    this.set(
      c2,
      -s2,
      0,
      s2,
      c2,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeScale(x3, y2) {
    this.set(
      x3,
      0,
      0,
      0,
      y2,
      0,
      0,
      0,
      1
    );
    return this;
  }
  //
  equals(matrix) {
    const te = this.elements;
    const me = matrix.elements;
    for (let i2 = 0; i2 < 9; i2++) {
      if (te[i2] !== me[i2]) return false;
    }
    return true;
  }
  fromArray(array, offset = 0) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.elements[i2] = array[i2 + offset];
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const te = this.elements;
    array[offset] = te[0];
    array[offset + 1] = te[1];
    array[offset + 2] = te[2];
    array[offset + 3] = te[3];
    array[offset + 4] = te[4];
    array[offset + 5] = te[5];
    array[offset + 6] = te[6];
    array[offset + 7] = te[7];
    array[offset + 8] = te[8];
    return array;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const _m3 = /* @__PURE__ */ new Matrix3();
function arrayNeedsUint32(array) {
  for (let i2 = array.length - 1; i2 >= 0; --i2) {
    if (array[i2] >= 65535) return true;
  }
  return false;
}
const TYPED_ARRAYS = {
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
};
function getTypedArray(type, buffer) {
  return new TYPED_ARRAYS[type](buffer);
}
function createElementNS(name) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
function createCanvasElement() {
  const canvas = createElementNS("canvas");
  canvas.style.display = "block";
  return canvas;
}
const _cache = {};
function warnOnce(message) {
  if (message in _cache) return;
  _cache[message] = true;
  console.warn(message);
}
function probeAsync(gl, sync2, interval) {
  return new Promise(function(resolve2, reject) {
    function probe() {
      switch (gl.clientWaitSync(sync2, gl.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case gl.WAIT_FAILED:
          reject();
          break;
        case gl.TIMEOUT_EXPIRED:
          setTimeout(probe, interval);
          break;
        default:
          resolve2();
      }
    }
    setTimeout(probe, interval);
  });
}
function toNormalizedProjectionMatrix(projectionMatrix) {
  const m2 = projectionMatrix.elements;
  m2[2] = 0.5 * m2[2] + 0.5 * m2[3];
  m2[6] = 0.5 * m2[6] + 0.5 * m2[7];
  m2[10] = 0.5 * m2[10] + 0.5 * m2[11];
  m2[14] = 0.5 * m2[14] + 0.5 * m2[15];
}
function toReversedProjectionMatrix(projectionMatrix) {
  const m2 = projectionMatrix.elements;
  const isPerspectiveMatrix = m2[11] === -1;
  if (isPerspectiveMatrix) {
    m2[10] = -m2[10] - 1;
    m2[14] = -m2[14];
  } else {
    m2[10] = -m2[10];
    m2[14] = -m2[14] + 1;
  }
}
const LINEAR_REC709_TO_XYZ = /* @__PURE__ */ new Matrix3().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
);
const XYZ_TO_LINEAR_REC709 = /* @__PURE__ */ new Matrix3().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function createColorManagement() {
  const ColorManagement2 = {
    enabled: true,
    workingColorSpace: LinearSRGBColorSpace$1,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(color, sourceColorSpace, targetColorSpace) {
      if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {
        return color;
      }
      if (this.spaces[sourceColorSpace].transfer === SRGBTransfer) {
        color.r = SRGBToLinear(color.r);
        color.g = SRGBToLinear(color.g);
        color.b = SRGBToLinear(color.b);
      }
      if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
        color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
        color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
      }
      if (this.spaces[targetColorSpace].transfer === SRGBTransfer) {
        color.r = LinearToSRGB(color.r);
        color.g = LinearToSRGB(color.g);
        color.b = LinearToSRGB(color.b);
      }
      return color;
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
      return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
      return this.convert(color, sourceColorSpace, this.workingColorSpace);
    },
    getPrimaries: function(colorSpace) {
      return this.spaces[colorSpace].primaries;
    },
    getTransfer: function(colorSpace) {
      if (colorSpace === NoColorSpace) return LinearTransfer;
      return this.spaces[colorSpace].transfer;
    },
    getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
      return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
    },
    define: function(colorSpaces) {
      Object.assign(this.spaces, colorSpaces);
    },
    // Internal APIs
    _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
      return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(colorSpace) {
      return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
      return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
    }
  };
  const REC709_PRIMARIES = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06];
  const REC709_LUMINANCE_COEFFICIENTS = [0.2126, 0.7152, 0.0722];
  const D65 = [0.3127, 0.329];
  ColorManagement2.define({
    [LinearSRGBColorSpace$1]: {
      primaries: REC709_PRIMARIES,
      whitePoint: D65,
      transfer: LinearTransfer,
      toXYZ: LINEAR_REC709_TO_XYZ,
      fromXYZ: XYZ_TO_LINEAR_REC709,
      luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
      workingColorSpaceConfig: { unpackColorSpace: SRGBColorSpace$1 },
      outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace$1 }
    },
    [SRGBColorSpace$1]: {
      primaries: REC709_PRIMARIES,
      whitePoint: D65,
      transfer: SRGBTransfer,
      toXYZ: LINEAR_REC709_TO_XYZ,
      fromXYZ: XYZ_TO_LINEAR_REC709,
      luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
      outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace$1 }
    }
  });
  return ColorManagement2;
}
const ColorManagement = /* @__PURE__ */ createColorManagement();
function SRGBToLinear(c2) {
  return c2 < 0.04045 ? c2 * 0.0773993808 : Math.pow(c2 * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(c2) {
  return c2 < 31308e-7 ? c2 * 12.92 : 1.055 * Math.pow(c2, 0.41666) - 0.055;
}
let _canvas;
class ImageUtils {
  static getDataURL(image) {
    if (/^data:/i.test(image.src)) {
      return image.src;
    }
    if (typeof HTMLCanvasElement === "undefined") {
      return image.src;
    }
    let canvas;
    if (image instanceof HTMLCanvasElement) {
      canvas = image;
    } else {
      if (_canvas === void 0) _canvas = createElementNS("canvas");
      _canvas.width = image.width;
      _canvas.height = image.height;
      const context4 = _canvas.getContext("2d");
      if (image instanceof ImageData) {
        context4.putImageData(image, 0, 0);
      } else {
        context4.drawImage(image, 0, 0, image.width, image.height);
      }
      canvas = _canvas;
    }
    return canvas.toDataURL("image/png");
  }
  static sRGBToLinear(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
      const canvas = createElementNS("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const context4 = canvas.getContext("2d");
      context4.drawImage(image, 0, 0, image.width, image.height);
      const imageData = context4.getImageData(0, 0, image.width, image.height);
      const data = imageData.data;
      for (let i2 = 0; i2 < data.length; i2++) {
        data[i2] = SRGBToLinear(data[i2] / 255) * 255;
      }
      context4.putImageData(imageData, 0, 0);
      return canvas;
    } else if (image.data) {
      const data = image.data.slice(0);
      for (let i2 = 0; i2 < data.length; i2++) {
        if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) {
          data[i2] = Math.floor(SRGBToLinear(data[i2] / 255) * 255);
        } else {
          data[i2] = SRGBToLinear(data[i2]);
        }
      }
      return {
        data,
        width: image.width,
        height: image.height
      };
    } else {
      console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
      return image;
    }
  }
}
let _sourceId = 0;
class Source {
  constructor(data = null) {
    this.isSource = true;
    Object.defineProperty(this, "id", { value: _sourceId++ });
    this.uuid = generateUUID$1();
    this.data = data;
    this.dataReady = true;
    this.version = 0;
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (!isRootObject && meta.images[this.uuid] !== void 0) {
      return meta.images[this.uuid];
    }
    const output = {
      uuid: this.uuid,
      url: ""
    };
    const data = this.data;
    if (data !== null) {
      let url;
      if (Array.isArray(data)) {
        url = [];
        for (let i2 = 0, l2 = data.length; i2 < l2; i2++) {
          if (data[i2].isDataTexture) {
            url.push(serializeImage(data[i2].image));
          } else {
            url.push(serializeImage(data[i2]));
          }
        }
      } else {
        url = serializeImage(data);
      }
      output.url = url;
    }
    if (!isRootObject) {
      meta.images[this.uuid] = output;
    }
    return output;
  }
}
function serializeImage(image) {
  if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
    return ImageUtils.getDataURL(image);
  } else {
    if (image.data) {
      return {
        data: Array.from(image.data),
        width: image.width,
        height: image.height,
        type: image.data.constructor.name
      };
    } else {
      console.warn("THREE.Texture: Unable to serialize Texture.");
      return {};
    }
  }
}
let _textureId = 0;
class Texture extends EventDispatcher$2 {
  constructor(image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace) {
    super();
    this.isTexture = true;
    Object.defineProperty(this, "id", { value: _textureId++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.source = new Source(image);
    this.mipmaps = [];
    this.mapping = mapping;
    this.channel = 0;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.anisotropy = anisotropy;
    this.format = format;
    this.internalFormat = null;
    this.type = type;
    this.offset = new Vector2(0, 0);
    this.repeat = new Vector2(1, 1);
    this.center = new Vector2(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new Matrix3();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4;
    this.colorSpace = colorSpace;
    this.userData = {};
    this.version = 0;
    this.onUpdate = null;
    this.renderTarget = null;
    this.isRenderTargetTexture = false;
    this.pmremVersion = 0;
  }
  get image() {
    return this.source.data;
  }
  set image(value = null) {
    this.source.data = value;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.source = source.source;
    this.mipmaps = source.mipmaps.slice(0);
    this.mapping = source.mapping;
    this.channel = source.channel;
    this.wrapS = source.wrapS;
    this.wrapT = source.wrapT;
    this.magFilter = source.magFilter;
    this.minFilter = source.minFilter;
    this.anisotropy = source.anisotropy;
    this.format = source.format;
    this.internalFormat = source.internalFormat;
    this.type = source.type;
    this.offset.copy(source.offset);
    this.repeat.copy(source.repeat);
    this.center.copy(source.center);
    this.rotation = source.rotation;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrix.copy(source.matrix);
    this.generateMipmaps = source.generateMipmaps;
    this.premultiplyAlpha = source.premultiplyAlpha;
    this.flipY = source.flipY;
    this.unpackAlignment = source.unpackAlignment;
    this.colorSpace = source.colorSpace;
    this.renderTarget = source.renderTarget;
    this.isRenderTargetTexture = source.isRenderTargetTexture;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    this.needsUpdate = true;
    return this;
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (!isRootObject && meta.textures[this.uuid] !== void 0) {
      return meta.textures[this.uuid];
    }
    const output = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(meta).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    if (Object.keys(this.userData).length > 0) output.userData = this.userData;
    if (!isRootObject) {
      meta.textures[this.uuid] = output;
    }
    return output;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(uv) {
    if (this.mapping !== UVMapping) return uv;
    uv.applyMatrix3(this.matrix);
    if (uv.x < 0 || uv.x > 1) {
      switch (this.wrapS) {
        case RepeatWrapping:
          uv.x = uv.x - Math.floor(uv.x);
          break;
        case ClampToEdgeWrapping:
          uv.x = uv.x < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.x) % 2) === 1) {
            uv.x = Math.ceil(uv.x) - uv.x;
          } else {
            uv.x = uv.x - Math.floor(uv.x);
          }
          break;
      }
    }
    if (uv.y < 0 || uv.y > 1) {
      switch (this.wrapT) {
        case RepeatWrapping:
          uv.y = uv.y - Math.floor(uv.y);
          break;
        case ClampToEdgeWrapping:
          uv.y = uv.y < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.y) % 2) === 1) {
            uv.y = Math.ceil(uv.y) - uv.y;
          } else {
            uv.y = uv.y - Math.floor(uv.y);
          }
          break;
      }
    }
    if (this.flipY) {
      uv.y = 1 - uv.y;
    }
    return uv;
  }
  set needsUpdate(value) {
    if (value === true) {
      this.version++;
      this.source.needsUpdate = true;
    }
  }
  set needsPMREMUpdate(value) {
    if (value === true) {
      this.pmremVersion++;
    }
  }
}
Texture.DEFAULT_IMAGE = null;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.DEFAULT_ANISOTROPY = 1;
class Vector4 {
  constructor(x3 = 0, y2 = 0, z2 = 0, w2 = 1) {
    Vector4.prototype.isVector4 = true;
    this.x = x3;
    this.y = y2;
    this.z = z2;
    this.w = w2;
  }
  get width() {
    return this.z;
  }
  set width(value) {
    this.z = value;
  }
  get height() {
    return this.w;
  }
  set height(value) {
    this.w = value;
  }
  set(x3, y2, z2, w2) {
    this.x = x3;
    this.y = y2;
    this.z = z2;
    this.w = w2;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    this.w = scalar;
    return this;
  }
  setX(x3) {
    this.x = x3;
    return this;
  }
  setY(y2) {
    this.y = y2;
    return this;
  }
  setZ(z2) {
    this.z = z2;
    return this;
  }
  setW(w2) {
    this.w = w2;
    return this;
  }
  setComponent(index, value) {
    switch (index) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      case 3:
        this.w = value;
        break;
      default:
        throw new Error("index is out of range: " + index);
    }
    return this;
  }
  getComponent(index) {
    switch (index) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + index);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(v3) {
    this.x = v3.x;
    this.y = v3.y;
    this.z = v3.z;
    this.w = v3.w !== void 0 ? v3.w : 1;
    return this;
  }
  add(v3) {
    this.x += v3.x;
    this.y += v3.y;
    this.z += v3.z;
    this.w += v3.w;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    this.z += s2;
    this.w += s2;
    return this;
  }
  addVectors(a5, b6) {
    this.x = a5.x + b6.x;
    this.y = a5.y + b6.y;
    this.z = a5.z + b6.z;
    this.w = a5.w + b6.w;
    return this;
  }
  addScaledVector(v3, s2) {
    this.x += v3.x * s2;
    this.y += v3.y * s2;
    this.z += v3.z * s2;
    this.w += v3.w * s2;
    return this;
  }
  sub(v3) {
    this.x -= v3.x;
    this.y -= v3.y;
    this.z -= v3.z;
    this.w -= v3.w;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    this.z -= s2;
    this.w -= s2;
    return this;
  }
  subVectors(a5, b6) {
    this.x = a5.x - b6.x;
    this.y = a5.y - b6.y;
    this.z = a5.z - b6.z;
    this.w = a5.w - b6.w;
    return this;
  }
  multiply(v3) {
    this.x *= v3.x;
    this.y *= v3.y;
    this.z *= v3.z;
    this.w *= v3.w;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    this.w *= scalar;
    return this;
  }
  applyMatrix4(m2) {
    const x3 = this.x, y2 = this.y, z2 = this.z, w2 = this.w;
    const e2 = m2.elements;
    this.x = e2[0] * x3 + e2[4] * y2 + e2[8] * z2 + e2[12] * w2;
    this.y = e2[1] * x3 + e2[5] * y2 + e2[9] * z2 + e2[13] * w2;
    this.z = e2[2] * x3 + e2[6] * y2 + e2[10] * z2 + e2[14] * w2;
    this.w = e2[3] * x3 + e2[7] * y2 + e2[11] * z2 + e2[15] * w2;
    return this;
  }
  divide(v3) {
    this.x /= v3.x;
    this.y /= v3.y;
    this.z /= v3.z;
    this.w /= v3.w;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  setAxisAngleFromQuaternion(q2) {
    this.w = 2 * Math.acos(q2.w);
    const s2 = Math.sqrt(1 - q2.w * q2.w);
    if (s2 < 1e-4) {
      this.x = 1;
      this.y = 0;
      this.z = 0;
    } else {
      this.x = q2.x / s2;
      this.y = q2.y / s2;
      this.z = q2.z / s2;
    }
    return this;
  }
  setAxisAngleFromRotationMatrix(m2) {
    let angle, x3, y2, z2;
    const epsilon = 0.01, epsilon2 = 0.1, te = m2.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
    if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
      if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
        this.set(1, 0, 0, 0);
        return this;
      }
      angle = Math.PI;
      const xx = (m11 + 1) / 2;
      const yy = (m22 + 1) / 2;
      const zz = (m33 + 1) / 2;
      const xy = (m12 + m21) / 4;
      const xz = (m13 + m31) / 4;
      const yz = (m23 + m32) / 4;
      if (xx > yy && xx > zz) {
        if (xx < epsilon) {
          x3 = 0;
          y2 = 0.707106781;
          z2 = 0.707106781;
        } else {
          x3 = Math.sqrt(xx);
          y2 = xy / x3;
          z2 = xz / x3;
        }
      } else if (yy > zz) {
        if (yy < epsilon) {
          x3 = 0.707106781;
          y2 = 0;
          z2 = 0.707106781;
        } else {
          y2 = Math.sqrt(yy);
          x3 = xy / y2;
          z2 = yz / y2;
        }
      } else {
        if (zz < epsilon) {
          x3 = 0.707106781;
          y2 = 0.707106781;
          z2 = 0;
        } else {
          z2 = Math.sqrt(zz);
          x3 = xz / z2;
          y2 = yz / z2;
        }
      }
      this.set(x3, y2, z2, angle);
      return this;
    }
    let s2 = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12));
    if (Math.abs(s2) < 1e-3) s2 = 1;
    this.x = (m32 - m23) / s2;
    this.y = (m13 - m31) / s2;
    this.z = (m21 - m12) / s2;
    this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
    return this;
  }
  setFromMatrixPosition(m2) {
    const e2 = m2.elements;
    this.x = e2[12];
    this.y = e2[13];
    this.z = e2[14];
    this.w = e2[15];
    return this;
  }
  min(v3) {
    this.x = Math.min(this.x, v3.x);
    this.y = Math.min(this.y, v3.y);
    this.z = Math.min(this.z, v3.z);
    this.w = Math.min(this.w, v3.w);
    return this;
  }
  max(v3) {
    this.x = Math.max(this.x, v3.x);
    this.y = Math.max(this.y, v3.y);
    this.z = Math.max(this.z, v3.z);
    this.w = Math.max(this.w, v3.w);
    return this;
  }
  clamp(min, max2) {
    this.x = clamp$4(this.x, min.x, max2.x);
    this.y = clamp$4(this.y, min.y, max2.y);
    this.z = clamp$4(this.z, min.z, max2.z);
    this.w = clamp$4(this.w, min.w, max2.w);
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = clamp$4(this.x, minVal, maxVal);
    this.y = clamp$4(this.y, minVal, maxVal);
    this.z = clamp$4(this.z, minVal, maxVal);
    this.w = clamp$4(this.w, minVal, maxVal);
    return this;
  }
  clampLength(min, max2) {
    const length = this.length();
    return this.divideScalar(length || 1).multiplyScalar(clamp$4(length, min, max2));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    this.w = Math.floor(this.w);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    this.w = Math.ceil(this.w);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    this.w = Math.round(this.w);
    return this;
  }
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    this.z = Math.trunc(this.z);
    this.w = Math.trunc(this.w);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    this.w = -this.w;
    return this;
  }
  dot(v3) {
    return this.x * v3.x + this.y * v3.y + this.z * v3.z + this.w * v3.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length) {
    return this.normalize().multiplyScalar(length);
  }
  lerp(v3, alpha) {
    this.x += (v3.x - this.x) * alpha;
    this.y += (v3.y - this.y) * alpha;
    this.z += (v3.z - this.z) * alpha;
    this.w += (v3.w - this.w) * alpha;
    return this;
  }
  lerpVectors(v1, v22, alpha) {
    this.x = v1.x + (v22.x - v1.x) * alpha;
    this.y = v1.y + (v22.y - v1.y) * alpha;
    this.z = v1.z + (v22.z - v1.z) * alpha;
    this.w = v1.w + (v22.w - v1.w) * alpha;
    return this;
  }
  equals(v3) {
    return v3.x === this.x && v3.y === this.y && v3.z === this.z && v3.w === this.w;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];
    this.w = array[offset + 3];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;
    array[offset + 3] = this.w;
    return array;
  }
  fromBufferAttribute(attribute, index) {
    this.x = attribute.getX(index);
    this.y = attribute.getY(index);
    this.z = attribute.getZ(index);
    this.w = attribute.getW(index);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    this.w = Math.random();
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
    yield this.z;
    yield this.w;
  }
}
class RenderTarget extends EventDispatcher$2 {
  constructor(width = 1, height = 1, options = {}) {
    super();
    this.isRenderTarget = true;
    this.width = width;
    this.height = height;
    this.depth = 1;
    this.scissor = new Vector4(0, 0, width, height);
    this.scissorTest = false;
    this.viewport = new Vector4(0, 0, width, height);
    const image = { width, height, depth: 1 };
    options = Object.assign({
      generateMipmaps: false,
      internalFormat: null,
      minFilter: LinearFilter,
      depthBuffer: true,
      stencilBuffer: false,
      resolveDepthBuffer: true,
      resolveStencilBuffer: true,
      depthTexture: null,
      samples: 0,
      count: 1
    }, options);
    const texture = new Texture(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
    texture.flipY = false;
    texture.generateMipmaps = options.generateMipmaps;
    texture.internalFormat = options.internalFormat;
    this.textures = [];
    const count = options.count;
    for (let i2 = 0; i2 < count; i2++) {
      this.textures[i2] = texture.clone();
      this.textures[i2].isRenderTargetTexture = true;
      this.textures[i2].renderTarget = this;
    }
    this.depthBuffer = options.depthBuffer;
    this.stencilBuffer = options.stencilBuffer;
    this.resolveDepthBuffer = options.resolveDepthBuffer;
    this.resolveStencilBuffer = options.resolveStencilBuffer;
    this._depthTexture = null;
    this.depthTexture = options.depthTexture;
    this.samples = options.samples;
  }
  get texture() {
    return this.textures[0];
  }
  set texture(value) {
    this.textures[0] = value;
  }
  set depthTexture(current) {
    if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
    if (current !== null) current.renderTarget = this;
    this._depthTexture = current;
  }
  get depthTexture() {
    return this._depthTexture;
  }
  setSize(width, height, depth = 1) {
    if (this.width !== width || this.height !== height || this.depth !== depth) {
      this.width = width;
      this.height = height;
      this.depth = depth;
      for (let i2 = 0, il = this.textures.length; i2 < il; i2++) {
        this.textures[i2].image.width = width;
        this.textures[i2].image.height = height;
        this.textures[i2].image.depth = depth;
      }
      this.dispose();
    }
    this.viewport.set(0, 0, width, height);
    this.scissor.set(0, 0, width, height);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.width = source.width;
    this.height = source.height;
    this.depth = source.depth;
    this.scissor.copy(source.scissor);
    this.scissorTest = source.scissorTest;
    this.viewport.copy(source.viewport);
    this.textures.length = 0;
    for (let i2 = 0, il = source.textures.length; i2 < il; i2++) {
      this.textures[i2] = source.textures[i2].clone();
      this.textures[i2].isRenderTargetTexture = true;
      this.textures[i2].renderTarget = this;
    }
    const image = Object.assign({}, source.texture.image);
    this.texture.source = new Source(image);
    this.depthBuffer = source.depthBuffer;
    this.stencilBuffer = source.stencilBuffer;
    this.resolveDepthBuffer = source.resolveDepthBuffer;
    this.resolveStencilBuffer = source.resolveStencilBuffer;
    if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
    this.samples = source.samples;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class WebGLRenderTarget extends RenderTarget {
  constructor(width = 1, height = 1, options = {}) {
    super(width, height, options);
    this.isWebGLRenderTarget = true;
  }
}
class DataArrayTexture extends Texture {
  constructor(data = null, width = 1, height = 1, depth = 1) {
    super(null);
    this.isDataArrayTexture = true;
    this.image = { data, width, height, depth };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.layerUpdates = /* @__PURE__ */ new Set();
  }
  addLayerUpdate(layerIndex) {
    this.layerUpdates.add(layerIndex);
  }
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class WebGLArrayRenderTarget extends WebGLRenderTarget {
  constructor(width = 1, height = 1, depth = 1, options = {}) {
    super(width, height, options);
    this.isWebGLArrayRenderTarget = true;
    this.depth = depth;
    this.texture = new DataArrayTexture(null, width, height, depth);
    this.texture.isRenderTargetTexture = true;
  }
}
class Data3DTexture extends Texture {
  constructor(data = null, width = 1, height = 1, depth = 1) {
    super(null);
    this.isData3DTexture = true;
    this.image = { data, width, height, depth };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
  }
}
class WebGL3DRenderTarget extends WebGLRenderTarget {
  constructor(width = 1, height = 1, depth = 1, options = {}) {
    super(width, height, options);
    this.isWebGL3DRenderTarget = true;
    this.depth = depth;
    this.texture = new Data3DTexture(null, width, height, depth);
    this.texture.isRenderTargetTexture = true;
  }
}
class Quaternion {
  constructor(x3 = 0, y2 = 0, z2 = 0, w2 = 1) {
    this.isQuaternion = true;
    this._x = x3;
    this._y = y2;
    this._z = z2;
    this._w = w2;
  }
  static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t2) {
    let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
    if (t2 === 0) {
      dst[dstOffset + 0] = x0;
      dst[dstOffset + 1] = y0;
      dst[dstOffset + 2] = z0;
      dst[dstOffset + 3] = w0;
      return;
    }
    if (t2 === 1) {
      dst[dstOffset + 0] = x1;
      dst[dstOffset + 1] = y1;
      dst[dstOffset + 2] = z1;
      dst[dstOffset + 3] = w1;
      return;
    }
    if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
      let s2 = 1 - t2;
      const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
      if (sqrSin > Number.EPSILON) {
        const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
        s2 = Math.sin(s2 * len) / sin;
        t2 = Math.sin(t2 * len) / sin;
      }
      const tDir = t2 * dir;
      x0 = x0 * s2 + x1 * tDir;
      y0 = y0 * s2 + y1 * tDir;
      z0 = z0 * s2 + z1 * tDir;
      w0 = w0 * s2 + w1 * tDir;
      if (s2 === 1 - t2) {
        const f2 = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
        x0 *= f2;
        y0 *= f2;
        z0 *= f2;
        w0 *= f2;
      }
    }
    dst[dstOffset] = x0;
    dst[dstOffset + 1] = y0;
    dst[dstOffset + 2] = z0;
    dst[dstOffset + 3] = w0;
  }
  static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
    const x0 = src0[srcOffset0];
    const y0 = src0[srcOffset0 + 1];
    const z0 = src0[srcOffset0 + 2];
    const w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1];
    const y1 = src1[srcOffset1 + 1];
    const z1 = src1[srcOffset1 + 2];
    const w1 = src1[srcOffset1 + 3];
    dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
    dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
    dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
    dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
    return dst;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(value) {
    this._w = value;
    this._onChangeCallback();
  }
  set(x3, y2, z2, w2) {
    this._x = x3;
    this._y = y2;
    this._z = z2;
    this._w = w2;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(quaternion) {
    this._x = quaternion.x;
    this._y = quaternion.y;
    this._z = quaternion.z;
    this._w = quaternion.w;
    this._onChangeCallback();
    return this;
  }
  setFromEuler(euler, update2 = true) {
    const x3 = euler._x, y2 = euler._y, z2 = euler._z, order = euler._order;
    const cos = Math.cos;
    const sin = Math.sin;
    const c1 = cos(x3 / 2);
    const c2 = cos(y2 / 2);
    const c32 = cos(z2 / 2);
    const s1 = sin(x3 / 2);
    const s2 = sin(y2 / 2);
    const s3 = sin(z2 / 2);
    switch (order) {
      case "XYZ":
        this._x = s1 * c2 * c32 + c1 * s2 * s3;
        this._y = c1 * s2 * c32 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c32;
        this._w = c1 * c2 * c32 - s1 * s2 * s3;
        break;
      case "YXZ":
        this._x = s1 * c2 * c32 + c1 * s2 * s3;
        this._y = c1 * s2 * c32 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c32;
        this._w = c1 * c2 * c32 + s1 * s2 * s3;
        break;
      case "ZXY":
        this._x = s1 * c2 * c32 - c1 * s2 * s3;
        this._y = c1 * s2 * c32 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c32;
        this._w = c1 * c2 * c32 - s1 * s2 * s3;
        break;
      case "ZYX":
        this._x = s1 * c2 * c32 - c1 * s2 * s3;
        this._y = c1 * s2 * c32 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c32;
        this._w = c1 * c2 * c32 + s1 * s2 * s3;
        break;
      case "YZX":
        this._x = s1 * c2 * c32 + c1 * s2 * s3;
        this._y = c1 * s2 * c32 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c32;
        this._w = c1 * c2 * c32 - s1 * s2 * s3;
        break;
      case "XZY":
        this._x = s1 * c2 * c32 - c1 * s2 * s3;
        this._y = c1 * s2 * c32 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c32;
        this._w = c1 * c2 * c32 + s1 * s2 * s3;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
    }
    if (update2 === true) this._onChangeCallback();
    return this;
  }
  setFromAxisAngle(axis, angle) {
    const halfAngle = angle / 2, s2 = Math.sin(halfAngle);
    this._x = axis.x * s2;
    this._y = axis.y * s2;
    this._z = axis.z * s2;
    this._w = Math.cos(halfAngle);
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m2) {
    const te = m2.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
    if (trace > 0) {
      const s2 = 0.5 / Math.sqrt(trace + 1);
      this._w = 0.25 / s2;
      this._x = (m32 - m23) * s2;
      this._y = (m13 - m31) * s2;
      this._z = (m21 - m12) * s2;
    } else if (m11 > m22 && m11 > m33) {
      const s2 = 2 * Math.sqrt(1 + m11 - m22 - m33);
      this._w = (m32 - m23) / s2;
      this._x = 0.25 * s2;
      this._y = (m12 + m21) / s2;
      this._z = (m13 + m31) / s2;
    } else if (m22 > m33) {
      const s2 = 2 * Math.sqrt(1 + m22 - m11 - m33);
      this._w = (m13 - m31) / s2;
      this._x = (m12 + m21) / s2;
      this._y = 0.25 * s2;
      this._z = (m23 + m32) / s2;
    } else {
      const s2 = 2 * Math.sqrt(1 + m33 - m11 - m22);
      this._w = (m21 - m12) / s2;
      this._x = (m13 + m31) / s2;
      this._y = (m23 + m32) / s2;
      this._z = 0.25 * s2;
    }
    this._onChangeCallback();
    return this;
  }
  setFromUnitVectors(vFrom, vTo) {
    let r3 = vFrom.dot(vTo) + 1;
    if (r3 < Number.EPSILON) {
      r3 = 0;
      if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
        this._x = -vFrom.y;
        this._y = vFrom.x;
        this._z = 0;
        this._w = r3;
      } else {
        this._x = 0;
        this._y = -vFrom.z;
        this._z = vFrom.y;
        this._w = r3;
      }
    } else {
      this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
      this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
      this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
      this._w = r3;
    }
    return this.normalize();
  }
  angleTo(q2) {
    return 2 * Math.acos(Math.abs(clamp$4(this.dot(q2), -1, 1)));
  }
  rotateTowards(q2, step) {
    const angle = this.angleTo(q2);
    if (angle === 0) return this;
    const t2 = Math.min(1, step / angle);
    this.slerp(q2, t2);
    return this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    this._x *= -1;
    this._y *= -1;
    this._z *= -1;
    this._onChangeCallback();
    return this;
  }
  dot(v3) {
    return this._x * v3._x + this._y * v3._y + this._z * v3._z + this._w * v3._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let l2 = this.length();
    if (l2 === 0) {
      this._x = 0;
      this._y = 0;
      this._z = 0;
      this._w = 1;
    } else {
      l2 = 1 / l2;
      this._x = this._x * l2;
      this._y = this._y * l2;
      this._z = this._z * l2;
      this._w = this._w * l2;
    }
    this._onChangeCallback();
    return this;
  }
  multiply(q2) {
    return this.multiplyQuaternions(this, q2);
  }
  premultiply(q2) {
    return this.multiplyQuaternions(q2, this);
  }
  multiplyQuaternions(a5, b6) {
    const qax = a5._x, qay = a5._y, qaz = a5._z, qaw = a5._w;
    const qbx = b6._x, qby = b6._y, qbz = b6._z, qbw = b6._w;
    this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
    this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
    this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
    this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
    this._onChangeCallback();
    return this;
  }
  slerp(qb, t2) {
    if (t2 === 0) return this;
    if (t2 === 1) return this.copy(qb);
    const x3 = this._x, y2 = this._y, z2 = this._z, w2 = this._w;
    let cosHalfTheta = w2 * qb._w + x3 * qb._x + y2 * qb._y + z2 * qb._z;
    if (cosHalfTheta < 0) {
      this._w = -qb._w;
      this._x = -qb._x;
      this._y = -qb._y;
      this._z = -qb._z;
      cosHalfTheta = -cosHalfTheta;
    } else {
      this.copy(qb);
    }
    if (cosHalfTheta >= 1) {
      this._w = w2;
      this._x = x3;
      this._y = y2;
      this._z = z2;
      return this;
    }
    const sqrSinHalfTheta = 1 - cosHalfTheta * cosHalfTheta;
    if (sqrSinHalfTheta <= Number.EPSILON) {
      const s2 = 1 - t2;
      this._w = s2 * w2 + t2 * this._w;
      this._x = s2 * x3 + t2 * this._x;
      this._y = s2 * y2 + t2 * this._y;
      this._z = s2 * z2 + t2 * this._z;
      this.normalize();
      return this;
    }
    const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
    const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
    const ratioA = Math.sin((1 - t2) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t2 * halfTheta) / sinHalfTheta;
    this._w = w2 * ratioA + this._w * ratioB;
    this._x = x3 * ratioA + this._x * ratioB;
    this._y = y2 * ratioA + this._y * ratioB;
    this._z = z2 * ratioA + this._z * ratioB;
    this._onChangeCallback();
    return this;
  }
  slerpQuaternions(qa, qb, t2) {
    return this.copy(qa).slerp(qb, t2);
  }
  random() {
    const theta1 = 2 * Math.PI * Math.random();
    const theta2 = 2 * Math.PI * Math.random();
    const x0 = Math.random();
    const r1 = Math.sqrt(1 - x0);
    const r22 = Math.sqrt(x0);
    return this.set(
      r1 * Math.sin(theta1),
      r1 * Math.cos(theta1),
      r22 * Math.sin(theta2),
      r22 * Math.cos(theta2)
    );
  }
  equals(quaternion) {
    return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
  }
  fromArray(array, offset = 0) {
    this._x = array[offset];
    this._y = array[offset + 1];
    this._z = array[offset + 2];
    this._w = array[offset + 3];
    this._onChangeCallback();
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._w;
    return array;
  }
  fromBufferAttribute(attribute, index) {
    this._x = attribute.getX(index);
    this._y = attribute.getY(index);
    this._z = attribute.getZ(index);
    this._w = attribute.getW(index);
    this._onChangeCallback();
    return this;
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x;
    yield this._y;
    yield this._z;
    yield this._w;
  }
}
class Vector3 {
  constructor(x3 = 0, y2 = 0, z2 = 0) {
    Vector3.prototype.isVector3 = true;
    this.x = x3;
    this.y = y2;
    this.z = z2;
  }
  set(x3, y2, z2) {
    if (z2 === void 0) z2 = this.z;
    this.x = x3;
    this.y = y2;
    this.z = z2;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    return this;
  }
  setX(x3) {
    this.x = x3;
    return this;
  }
  setY(y2) {
    this.y = y2;
    return this;
  }
  setZ(z2) {
    this.z = z2;
    return this;
  }
  setComponent(index, value) {
    switch (index) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      default:
        throw new Error("index is out of range: " + index);
    }
    return this;
  }
  getComponent(index) {
    switch (index) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + index);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(v3) {
    this.x = v3.x;
    this.y = v3.y;
    this.z = v3.z;
    return this;
  }
  add(v3) {
    this.x += v3.x;
    this.y += v3.y;
    this.z += v3.z;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    this.z += s2;
    return this;
  }
  addVectors(a5, b6) {
    this.x = a5.x + b6.x;
    this.y = a5.y + b6.y;
    this.z = a5.z + b6.z;
    return this;
  }
  addScaledVector(v3, s2) {
    this.x += v3.x * s2;
    this.y += v3.y * s2;
    this.z += v3.z * s2;
    return this;
  }
  sub(v3) {
    this.x -= v3.x;
    this.y -= v3.y;
    this.z -= v3.z;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    this.z -= s2;
    return this;
  }
  subVectors(a5, b6) {
    this.x = a5.x - b6.x;
    this.y = a5.y - b6.y;
    this.z = a5.z - b6.z;
    return this;
  }
  multiply(v3) {
    this.x *= v3.x;
    this.y *= v3.y;
    this.z *= v3.z;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    return this;
  }
  multiplyVectors(a5, b6) {
    this.x = a5.x * b6.x;
    this.y = a5.y * b6.y;
    this.z = a5.z * b6.z;
    return this;
  }
  applyEuler(euler) {
    return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
  }
  applyAxisAngle(axis, angle) {
    return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle));
  }
  applyMatrix3(m2) {
    const x3 = this.x, y2 = this.y, z2 = this.z;
    const e2 = m2.elements;
    this.x = e2[0] * x3 + e2[3] * y2 + e2[6] * z2;
    this.y = e2[1] * x3 + e2[4] * y2 + e2[7] * z2;
    this.z = e2[2] * x3 + e2[5] * y2 + e2[8] * z2;
    return this;
  }
  applyNormalMatrix(m2) {
    return this.applyMatrix3(m2).normalize();
  }
  applyMatrix4(m2) {
    const x3 = this.x, y2 = this.y, z2 = this.z;
    const e2 = m2.elements;
    const w2 = 1 / (e2[3] * x3 + e2[7] * y2 + e2[11] * z2 + e2[15]);
    this.x = (e2[0] * x3 + e2[4] * y2 + e2[8] * z2 + e2[12]) * w2;
    this.y = (e2[1] * x3 + e2[5] * y2 + e2[9] * z2 + e2[13]) * w2;
    this.z = (e2[2] * x3 + e2[6] * y2 + e2[10] * z2 + e2[14]) * w2;
    return this;
  }
  applyQuaternion(q2) {
    const vx = this.x, vy = this.y, vz = this.z;
    const qx = q2.x, qy = q2.y, qz = q2.z, qw = q2.w;
    const tx = 2 * (qy * vz - qz * vy);
    const ty = 2 * (qz * vx - qx * vz);
    const tz = 2 * (qx * vy - qy * vx);
    this.x = vx + qw * tx + qy * tz - qz * ty;
    this.y = vy + qw * ty + qz * tx - qx * tz;
    this.z = vz + qw * tz + qx * ty - qy * tx;
    return this;
  }
  project(camera) {
    return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
  }
  unproject(camera) {
    return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
  }
  transformDirection(m2) {
    const x3 = this.x, y2 = this.y, z2 = this.z;
    const e2 = m2.elements;
    this.x = e2[0] * x3 + e2[4] * y2 + e2[8] * z2;
    this.y = e2[1] * x3 + e2[5] * y2 + e2[9] * z2;
    this.z = e2[2] * x3 + e2[6] * y2 + e2[10] * z2;
    return this.normalize();
  }
  divide(v3) {
    this.x /= v3.x;
    this.y /= v3.y;
    this.z /= v3.z;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  min(v3) {
    this.x = Math.min(this.x, v3.x);
    this.y = Math.min(this.y, v3.y);
    this.z = Math.min(this.z, v3.z);
    return this;
  }
  max(v3) {
    this.x = Math.max(this.x, v3.x);
    this.y = Math.max(this.y, v3.y);
    this.z = Math.max(this.z, v3.z);
    return this;
  }
  clamp(min, max2) {
    this.x = clamp$4(this.x, min.x, max2.x);
    this.y = clamp$4(this.y, min.y, max2.y);
    this.z = clamp$4(this.z, min.z, max2.z);
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = clamp$4(this.x, minVal, maxVal);
    this.y = clamp$4(this.y, minVal, maxVal);
    this.z = clamp$4(this.z, minVal, maxVal);
    return this;
  }
  clampLength(min, max2) {
    const length = this.length();
    return this.divideScalar(length || 1).multiplyScalar(clamp$4(length, min, max2));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    return this;
  }
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    this.z = Math.trunc(this.z);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    return this;
  }
  dot(v3) {
    return this.x * v3.x + this.y * v3.y + this.z * v3.z;
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length) {
    return this.normalize().multiplyScalar(length);
  }
  lerp(v3, alpha) {
    this.x += (v3.x - this.x) * alpha;
    this.y += (v3.y - this.y) * alpha;
    this.z += (v3.z - this.z) * alpha;
    return this;
  }
  lerpVectors(v1, v22, alpha) {
    this.x = v1.x + (v22.x - v1.x) * alpha;
    this.y = v1.y + (v22.y - v1.y) * alpha;
    this.z = v1.z + (v22.z - v1.z) * alpha;
    return this;
  }
  cross(v3) {
    return this.crossVectors(this, v3);
  }
  crossVectors(a5, b6) {
    const ax = a5.x, ay = a5.y, az = a5.z;
    const bx = b6.x, by = b6.y, bz = b6.z;
    this.x = ay * bz - az * by;
    this.y = az * bx - ax * bz;
    this.z = ax * by - ay * bx;
    return this;
  }
  projectOnVector(v3) {
    const denominator = v3.lengthSq();
    if (denominator === 0) return this.set(0, 0, 0);
    const scalar = v3.dot(this) / denominator;
    return this.copy(v3).multiplyScalar(scalar);
  }
  projectOnPlane(planeNormal) {
    _vector$c.copy(this).projectOnVector(planeNormal);
    return this.sub(_vector$c);
  }
  reflect(normal) {
    return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
  }
  angleTo(v3) {
    const denominator = Math.sqrt(this.lengthSq() * v3.lengthSq());
    if (denominator === 0) return Math.PI / 2;
    const theta = this.dot(v3) / denominator;
    return Math.acos(clamp$4(theta, -1, 1));
  }
  distanceTo(v3) {
    return Math.sqrt(this.distanceToSquared(v3));
  }
  distanceToSquared(v3) {
    const dx = this.x - v3.x, dy = this.y - v3.y, dz = this.z - v3.z;
    return dx * dx + dy * dy + dz * dz;
  }
  manhattanDistanceTo(v3) {
    return Math.abs(this.x - v3.x) + Math.abs(this.y - v3.y) + Math.abs(this.z - v3.z);
  }
  setFromSpherical(s2) {
    return this.setFromSphericalCoords(s2.radius, s2.phi, s2.theta);
  }
  setFromSphericalCoords(radius, phi, theta) {
    const sinPhiRadius = Math.sin(phi) * radius;
    this.x = sinPhiRadius * Math.sin(theta);
    this.y = Math.cos(phi) * radius;
    this.z = sinPhiRadius * Math.cos(theta);
    return this;
  }
  setFromCylindrical(c2) {
    return this.setFromCylindricalCoords(c2.radius, c2.theta, c2.y);
  }
  setFromCylindricalCoords(radius, theta, y2) {
    this.x = radius * Math.sin(theta);
    this.y = y2;
    this.z = radius * Math.cos(theta);
    return this;
  }
  setFromMatrixPosition(m2) {
    const e2 = m2.elements;
    this.x = e2[12];
    this.y = e2[13];
    this.z = e2[14];
    return this;
  }
  setFromMatrixScale(m2) {
    const sx = this.setFromMatrixColumn(m2, 0).length();
    const sy = this.setFromMatrixColumn(m2, 1).length();
    const sz = this.setFromMatrixColumn(m2, 2).length();
    this.x = sx;
    this.y = sy;
    this.z = sz;
    return this;
  }
  setFromMatrixColumn(m2, index) {
    return this.fromArray(m2.elements, index * 4);
  }
  setFromMatrix3Column(m2, index) {
    return this.fromArray(m2.elements, index * 3);
  }
  setFromEuler(e2) {
    this.x = e2._x;
    this.y = e2._y;
    this.z = e2._z;
    return this;
  }
  setFromColor(c2) {
    this.x = c2.r;
    this.y = c2.g;
    this.z = c2.b;
    return this;
  }
  equals(v3) {
    return v3.x === this.x && v3.y === this.y && v3.z === this.z;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;
    return array;
  }
  fromBufferAttribute(attribute, index) {
    this.x = attribute.getX(index);
    this.y = attribute.getY(index);
    this.z = attribute.getZ(index);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    return this;
  }
  randomDirection() {
    const theta = Math.random() * Math.PI * 2;
    const u2 = Math.random() * 2 - 1;
    const c2 = Math.sqrt(1 - u2 * u2);
    this.x = c2 * Math.cos(theta);
    this.y = u2;
    this.z = c2 * Math.sin(theta);
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
    yield this.z;
  }
}
const _vector$c = /* @__PURE__ */ new Vector3();
const _quaternion$4 = /* @__PURE__ */ new Quaternion();
class Box3 {
  constructor(min = new Vector3(Infinity, Infinity, Infinity), max2 = new Vector3(-Infinity, -Infinity, -Infinity)) {
    this.isBox3 = true;
    this.min = min;
    this.max = max2;
  }
  set(min, max2) {
    this.min.copy(min);
    this.max.copy(max2);
    return this;
  }
  setFromArray(array) {
    this.makeEmpty();
    for (let i2 = 0, il = array.length; i2 < il; i2 += 3) {
      this.expandByPoint(_vector$b.fromArray(array, i2));
    }
    return this;
  }
  setFromBufferAttribute(attribute) {
    this.makeEmpty();
    for (let i2 = 0, il = attribute.count; i2 < il; i2++) {
      this.expandByPoint(_vector$b.fromBufferAttribute(attribute, i2));
    }
    return this;
  }
  setFromPoints(points) {
    this.makeEmpty();
    for (let i2 = 0, il = points.length; i2 < il; i2++) {
      this.expandByPoint(points[i2]);
    }
    return this;
  }
  setFromCenterAndSize(center, size) {
    const halfSize = _vector$b.copy(size).multiplyScalar(0.5);
    this.min.copy(center).sub(halfSize);
    this.max.copy(center).add(halfSize);
    return this;
  }
  setFromObject(object, precise = false) {
    this.makeEmpty();
    return this.expandByObject(object, precise);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(box) {
    this.min.copy(box.min);
    this.max.copy(box.max);
    return this;
  }
  makeEmpty() {
    this.min.x = this.min.y = this.min.z = Infinity;
    this.max.x = this.max.y = this.max.z = -Infinity;
    return this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(target) {
    return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(target) {
    return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
  }
  expandByPoint(point) {
    this.min.min(point);
    this.max.max(point);
    return this;
  }
  expandByVector(vector) {
    this.min.sub(vector);
    this.max.add(vector);
    return this;
  }
  expandByScalar(scalar) {
    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);
    return this;
  }
  expandByObject(object, precise = false) {
    object.updateWorldMatrix(false, false);
    const geometry = object.geometry;
    if (geometry !== void 0) {
      const positionAttribute = geometry.getAttribute("position");
      if (precise === true && positionAttribute !== void 0 && object.isInstancedMesh !== true) {
        for (let i2 = 0, l2 = positionAttribute.count; i2 < l2; i2++) {
          if (object.isMesh === true) {
            object.getVertexPosition(i2, _vector$b);
          } else {
            _vector$b.fromBufferAttribute(positionAttribute, i2);
          }
          _vector$b.applyMatrix4(object.matrixWorld);
          this.expandByPoint(_vector$b);
        }
      } else {
        if (object.boundingBox !== void 0) {
          if (object.boundingBox === null) {
            object.computeBoundingBox();
          }
          _box$4.copy(object.boundingBox);
        } else {
          if (geometry.boundingBox === null) {
            geometry.computeBoundingBox();
          }
          _box$4.copy(geometry.boundingBox);
        }
        _box$4.applyMatrix4(object.matrixWorld);
        this.union(_box$4);
      }
    }
    const children = object.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      this.expandByObject(children[i2], precise);
    }
    return this;
  }
  containsPoint(point) {
    return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
  }
  containsBox(box) {
    return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
  }
  getParameter(point, target) {
    return target.set(
      (point.x - this.min.x) / (this.max.x - this.min.x),
      (point.y - this.min.y) / (this.max.y - this.min.y),
      (point.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(box) {
    return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
  }
  intersectsSphere(sphere) {
    this.clampPoint(sphere.center, _vector$b);
    return _vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
  }
  intersectsPlane(plane) {
    let min, max2;
    if (plane.normal.x > 0) {
      min = plane.normal.x * this.min.x;
      max2 = plane.normal.x * this.max.x;
    } else {
      min = plane.normal.x * this.max.x;
      max2 = plane.normal.x * this.min.x;
    }
    if (plane.normal.y > 0) {
      min += plane.normal.y * this.min.y;
      max2 += plane.normal.y * this.max.y;
    } else {
      min += plane.normal.y * this.max.y;
      max2 += plane.normal.y * this.min.y;
    }
    if (plane.normal.z > 0) {
      min += plane.normal.z * this.min.z;
      max2 += plane.normal.z * this.max.z;
    } else {
      min += plane.normal.z * this.max.z;
      max2 += plane.normal.z * this.min.z;
    }
    return min <= -plane.constant && max2 >= -plane.constant;
  }
  intersectsTriangle(triangle) {
    if (this.isEmpty()) {
      return false;
    }
    this.getCenter(_center);
    _extents.subVectors(this.max, _center);
    _v0$2.subVectors(triangle.a, _center);
    _v1$7.subVectors(triangle.b, _center);
    _v2$4.subVectors(triangle.c, _center);
    _f0.subVectors(_v1$7, _v0$2);
    _f1.subVectors(_v2$4, _v1$7);
    _f2.subVectors(_v0$2, _v2$4);
    let axes = [
      0,
      -_f0.z,
      _f0.y,
      0,
      -_f1.z,
      _f1.y,
      0,
      -_f2.z,
      _f2.y,
      _f0.z,
      0,
      -_f0.x,
      _f1.z,
      0,
      -_f1.x,
      _f2.z,
      0,
      -_f2.x,
      -_f0.y,
      _f0.x,
      0,
      -_f1.y,
      _f1.x,
      0,
      -_f2.y,
      _f2.x,
      0
    ];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
      return false;
    }
    axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
      return false;
    }
    _triangleNormal.crossVectors(_f0, _f1);
    axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];
    return satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents);
  }
  clampPoint(point, target) {
    return target.copy(point).clamp(this.min, this.max);
  }
  distanceToPoint(point) {
    return this.clampPoint(point, _vector$b).distanceTo(point);
  }
  getBoundingSphere(target) {
    if (this.isEmpty()) {
      target.makeEmpty();
    } else {
      this.getCenter(target.center);
      target.radius = this.getSize(_vector$b).length() * 0.5;
    }
    return target;
  }
  intersect(box) {
    this.min.max(box.min);
    this.max.min(box.max);
    if (this.isEmpty()) this.makeEmpty();
    return this;
  }
  union(box) {
    this.min.min(box.min);
    this.max.max(box.max);
    return this;
  }
  applyMatrix4(matrix) {
    if (this.isEmpty()) return this;
    _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix);
    _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix);
    _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix);
    _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix);
    _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix);
    _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix);
    _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix);
    _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix);
    this.setFromPoints(_points);
    return this;
  }
  translate(offset) {
    this.min.add(offset);
    this.max.add(offset);
    return this;
  }
  equals(box) {
    return box.min.equals(this.min) && box.max.equals(this.max);
  }
}
const _points = [
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3()
];
const _vector$b = /* @__PURE__ */ new Vector3();
const _box$4 = /* @__PURE__ */ new Box3();
const _v0$2 = /* @__PURE__ */ new Vector3();
const _v1$7 = /* @__PURE__ */ new Vector3();
const _v2$4 = /* @__PURE__ */ new Vector3();
const _f0 = /* @__PURE__ */ new Vector3();
const _f1 = /* @__PURE__ */ new Vector3();
const _f2 = /* @__PURE__ */ new Vector3();
const _center = /* @__PURE__ */ new Vector3();
const _extents = /* @__PURE__ */ new Vector3();
const _triangleNormal = /* @__PURE__ */ new Vector3();
const _testAxis = /* @__PURE__ */ new Vector3();
function satForAxes(axes, v0, v1, v22, extents) {
  for (let i2 = 0, j3 = axes.length - 3; i2 <= j3; i2 += 3) {
    _testAxis.fromArray(axes, i2);
    const r3 = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
    const p0 = v0.dot(_testAxis);
    const p1 = v1.dot(_testAxis);
    const p22 = v22.dot(_testAxis);
    if (Math.max(-Math.max(p0, p1, p22), Math.min(p0, p1, p22)) > r3) {
      return false;
    }
  }
  return true;
}
const _box$3 = /* @__PURE__ */ new Box3();
const _v1$6 = /* @__PURE__ */ new Vector3();
const _v2$3 = /* @__PURE__ */ new Vector3();
class Sphere {
  constructor(center = new Vector3(), radius = -1) {
    this.isSphere = true;
    this.center = center;
    this.radius = radius;
  }
  set(center, radius) {
    this.center.copy(center);
    this.radius = radius;
    return this;
  }
  setFromPoints(points, optionalCenter) {
    const center = this.center;
    if (optionalCenter !== void 0) {
      center.copy(optionalCenter);
    } else {
      _box$3.setFromPoints(points).getCenter(center);
    }
    let maxRadiusSq = 0;
    for (let i2 = 0, il = points.length; i2 < il; i2++) {
      maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i2]));
    }
    this.radius = Math.sqrt(maxRadiusSq);
    return this;
  }
  copy(sphere) {
    this.center.copy(sphere.center);
    this.radius = sphere.radius;
    return this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    this.center.set(0, 0, 0);
    this.radius = -1;
    return this;
  }
  containsPoint(point) {
    return point.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(point) {
    return point.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(sphere) {
    const radiusSum = this.radius + sphere.radius;
    return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
  }
  intersectsBox(box) {
    return box.intersectsSphere(this);
  }
  intersectsPlane(plane) {
    return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(point, target) {
    const deltaLengthSq = this.center.distanceToSquared(point);
    target.copy(point);
    if (deltaLengthSq > this.radius * this.radius) {
      target.sub(this.center).normalize();
      target.multiplyScalar(this.radius).add(this.center);
    }
    return target;
  }
  getBoundingBox(target) {
    if (this.isEmpty()) {
      target.makeEmpty();
      return target;
    }
    target.set(this.center, this.center);
    target.expandByScalar(this.radius);
    return target;
  }
  applyMatrix4(matrix) {
    this.center.applyMatrix4(matrix);
    this.radius = this.radius * matrix.getMaxScaleOnAxis();
    return this;
  }
  translate(offset) {
    this.center.add(offset);
    return this;
  }
  expandByPoint(point) {
    if (this.isEmpty()) {
      this.center.copy(point);
      this.radius = 0;
      return this;
    }
    _v1$6.subVectors(point, this.center);
    const lengthSq = _v1$6.lengthSq();
    if (lengthSq > this.radius * this.radius) {
      const length = Math.sqrt(lengthSq);
      const delta = (length - this.radius) * 0.5;
      this.center.addScaledVector(_v1$6, delta / length);
      this.radius += delta;
    }
    return this;
  }
  union(sphere) {
    if (sphere.isEmpty()) {
      return this;
    }
    if (this.isEmpty()) {
      this.copy(sphere);
      return this;
    }
    if (this.center.equals(sphere.center) === true) {
      this.radius = Math.max(this.radius, sphere.radius);
    } else {
      _v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
      this.expandByPoint(_v1$6.copy(sphere.center).add(_v2$3));
      this.expandByPoint(_v1$6.copy(sphere.center).sub(_v2$3));
    }
    return this;
  }
  equals(sphere) {
    return sphere.center.equals(this.center) && sphere.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _vector$a = /* @__PURE__ */ new Vector3();
const _segCenter = /* @__PURE__ */ new Vector3();
const _segDir = /* @__PURE__ */ new Vector3();
const _diff = /* @__PURE__ */ new Vector3();
const _edge1 = /* @__PURE__ */ new Vector3();
const _edge2 = /* @__PURE__ */ new Vector3();
const _normal$1 = /* @__PURE__ */ new Vector3();
class Ray {
  constructor(origin2 = new Vector3(), direction = new Vector3(0, 0, -1)) {
    this.origin = origin2;
    this.direction = direction;
  }
  set(origin2, direction) {
    this.origin.copy(origin2);
    this.direction.copy(direction);
    return this;
  }
  copy(ray) {
    this.origin.copy(ray.origin);
    this.direction.copy(ray.direction);
    return this;
  }
  at(t2, target) {
    return target.copy(this.origin).addScaledVector(this.direction, t2);
  }
  lookAt(v3) {
    this.direction.copy(v3).sub(this.origin).normalize();
    return this;
  }
  recast(t2) {
    this.origin.copy(this.at(t2, _vector$a));
    return this;
  }
  closestPointToPoint(point, target) {
    target.subVectors(point, this.origin);
    const directionDistance = target.dot(this.direction);
    if (directionDistance < 0) {
      return target.copy(this.origin);
    }
    return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
  }
  distanceToPoint(point) {
    return Math.sqrt(this.distanceSqToPoint(point));
  }
  distanceSqToPoint(point) {
    const directionDistance = _vector$a.subVectors(point, this.origin).dot(this.direction);
    if (directionDistance < 0) {
      return this.origin.distanceToSquared(point);
    }
    _vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
    return _vector$a.distanceToSquared(point);
  }
  distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
    _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
    _segDir.copy(v1).sub(v0).normalize();
    _diff.copy(this.origin).sub(_segCenter);
    const segExtent = v0.distanceTo(v1) * 0.5;
    const a01 = -this.direction.dot(_segDir);
    const b0 = _diff.dot(this.direction);
    const b1 = -_diff.dot(_segDir);
    const c2 = _diff.lengthSq();
    const det = Math.abs(1 - a01 * a01);
    let s0, s1, sqrDist, extDet;
    if (det > 0) {
      s0 = a01 * b1 - b0;
      s1 = a01 * b0 - b1;
      extDet = segExtent * det;
      if (s0 >= 0) {
        if (s1 >= -extDet) {
          if (s1 <= extDet) {
            const invDet = 1 / det;
            s0 *= invDet;
            s1 *= invDet;
            sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c2;
          } else {
            s1 = segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
          }
        } else {
          s1 = -segExtent;
          s0 = Math.max(0, -(a01 * s1 + b0));
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        }
      } else {
        if (s1 <= -extDet) {
          s0 = Math.max(0, -(-a01 * segExtent + b0));
          s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        } else if (s1 <= extDet) {
          s0 = 0;
          s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = s1 * (s1 + 2 * b1) + c2;
        } else {
          s0 = Math.max(0, -(a01 * segExtent + b0));
          s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        }
      }
    } else {
      s1 = a01 > 0 ? -segExtent : segExtent;
      s0 = Math.max(0, -(a01 * s1 + b0));
      sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
    }
    if (optionalPointOnRay) {
      optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
    }
    if (optionalPointOnSegment) {
      optionalPointOnSegment.copy(_segCenter).addScaledVector(_segDir, s1);
    }
    return sqrDist;
  }
  intersectSphere(sphere, target) {
    _vector$a.subVectors(sphere.center, this.origin);
    const tca = _vector$a.dot(this.direction);
    const d22 = _vector$a.dot(_vector$a) - tca * tca;
    const radius2 = sphere.radius * sphere.radius;
    if (d22 > radius2) return null;
    const thc = Math.sqrt(radius2 - d22);
    const t0 = tca - thc;
    const t1 = tca + thc;
    if (t1 < 0) return null;
    if (t0 < 0) return this.at(t1, target);
    return this.at(t0, target);
  }
  intersectsSphere(sphere) {
    return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
  }
  distanceToPlane(plane) {
    const denominator = plane.normal.dot(this.direction);
    if (denominator === 0) {
      if (plane.distanceToPoint(this.origin) === 0) {
        return 0;
      }
      return null;
    }
    const t2 = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
    return t2 >= 0 ? t2 : null;
  }
  intersectPlane(plane, target) {
    const t2 = this.distanceToPlane(plane);
    if (t2 === null) {
      return null;
    }
    return this.at(t2, target);
  }
  intersectsPlane(plane) {
    const distToPoint = plane.distanceToPoint(this.origin);
    if (distToPoint === 0) {
      return true;
    }
    const denominator = plane.normal.dot(this.direction);
    if (denominator * distToPoint < 0) {
      return true;
    }
    return false;
  }
  intersectBox(box, target) {
    let tmin, tmax, tymin, tymax, tzmin, tzmax;
    const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
    const origin2 = this.origin;
    if (invdirx >= 0) {
      tmin = (box.min.x - origin2.x) * invdirx;
      tmax = (box.max.x - origin2.x) * invdirx;
    } else {
      tmin = (box.max.x - origin2.x) * invdirx;
      tmax = (box.min.x - origin2.x) * invdirx;
    }
    if (invdiry >= 0) {
      tymin = (box.min.y - origin2.y) * invdiry;
      tymax = (box.max.y - origin2.y) * invdiry;
    } else {
      tymin = (box.max.y - origin2.y) * invdiry;
      tymax = (box.min.y - origin2.y) * invdiry;
    }
    if (tmin > tymax || tymin > tmax) return null;
    if (tymin > tmin || isNaN(tmin)) tmin = tymin;
    if (tymax < tmax || isNaN(tmax)) tmax = tymax;
    if (invdirz >= 0) {
      tzmin = (box.min.z - origin2.z) * invdirz;
      tzmax = (box.max.z - origin2.z) * invdirz;
    } else {
      tzmin = (box.max.z - origin2.z) * invdirz;
      tzmax = (box.min.z - origin2.z) * invdirz;
    }
    if (tmin > tzmax || tzmin > tmax) return null;
    if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
    if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
    if (tmax < 0) return null;
    return this.at(tmin >= 0 ? tmin : tmax, target);
  }
  intersectsBox(box) {
    return this.intersectBox(box, _vector$a) !== null;
  }
  intersectTriangle(a5, b6, c2, backfaceCulling, target) {
    _edge1.subVectors(b6, a5);
    _edge2.subVectors(c2, a5);
    _normal$1.crossVectors(_edge1, _edge2);
    let DdN = this.direction.dot(_normal$1);
    let sign2;
    if (DdN > 0) {
      if (backfaceCulling) return null;
      sign2 = 1;
    } else if (DdN < 0) {
      sign2 = -1;
      DdN = -DdN;
    } else {
      return null;
    }
    _diff.subVectors(this.origin, a5);
    const DdQxE2 = sign2 * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
    if (DdQxE2 < 0) {
      return null;
    }
    const DdE1xQ = sign2 * this.direction.dot(_edge1.cross(_diff));
    if (DdE1xQ < 0) {
      return null;
    }
    if (DdQxE2 + DdE1xQ > DdN) {
      return null;
    }
    const QdN = -sign2 * _diff.dot(_normal$1);
    if (QdN < 0) {
      return null;
    }
    return this.at(QdN / DdN, target);
  }
  applyMatrix4(matrix4) {
    this.origin.applyMatrix4(matrix4);
    this.direction.transformDirection(matrix4);
    return this;
  }
  equals(ray) {
    return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Matrix4 {
  constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
    Matrix4.prototype.isMatrix4 = true;
    this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ];
    if (n11 !== void 0) {
      this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
  }
  set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
    const te = this.elements;
    te[0] = n11;
    te[4] = n12;
    te[8] = n13;
    te[12] = n14;
    te[1] = n21;
    te[5] = n22;
    te[9] = n23;
    te[13] = n24;
    te[2] = n31;
    te[6] = n32;
    te[10] = n33;
    te[14] = n34;
    te[3] = n41;
    te[7] = n42;
    te[11] = n43;
    te[15] = n44;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  clone() {
    return new Matrix4().fromArray(this.elements);
  }
  copy(m2) {
    const te = this.elements;
    const me = m2.elements;
    te[0] = me[0];
    te[1] = me[1];
    te[2] = me[2];
    te[3] = me[3];
    te[4] = me[4];
    te[5] = me[5];
    te[6] = me[6];
    te[7] = me[7];
    te[8] = me[8];
    te[9] = me[9];
    te[10] = me[10];
    te[11] = me[11];
    te[12] = me[12];
    te[13] = me[13];
    te[14] = me[14];
    te[15] = me[15];
    return this;
  }
  copyPosition(m2) {
    const te = this.elements, me = m2.elements;
    te[12] = me[12];
    te[13] = me[13];
    te[14] = me[14];
    return this;
  }
  setFromMatrix3(m2) {
    const me = m2.elements;
    this.set(
      me[0],
      me[3],
      me[6],
      0,
      me[1],
      me[4],
      me[7],
      0,
      me[2],
      me[5],
      me[8],
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrixColumn(this, 0);
    yAxis.setFromMatrixColumn(this, 1);
    zAxis.setFromMatrixColumn(this, 2);
    return this;
  }
  makeBasis(xAxis, yAxis, zAxis) {
    this.set(
      xAxis.x,
      yAxis.x,
      zAxis.x,
      0,
      xAxis.y,
      yAxis.y,
      zAxis.y,
      0,
      xAxis.z,
      yAxis.z,
      zAxis.z,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractRotation(m2) {
    const te = this.elements;
    const me = m2.elements;
    const scaleX = 1 / _v1$5.setFromMatrixColumn(m2, 0).length();
    const scaleY = 1 / _v1$5.setFromMatrixColumn(m2, 1).length();
    const scaleZ = 1 / _v1$5.setFromMatrixColumn(m2, 2).length();
    te[0] = me[0] * scaleX;
    te[1] = me[1] * scaleX;
    te[2] = me[2] * scaleX;
    te[3] = 0;
    te[4] = me[4] * scaleY;
    te[5] = me[5] * scaleY;
    te[6] = me[6] * scaleY;
    te[7] = 0;
    te[8] = me[8] * scaleZ;
    te[9] = me[9] * scaleZ;
    te[10] = me[10] * scaleZ;
    te[11] = 0;
    te[12] = 0;
    te[13] = 0;
    te[14] = 0;
    te[15] = 1;
    return this;
  }
  makeRotationFromEuler(euler) {
    const te = this.elements;
    const x3 = euler.x, y2 = euler.y, z2 = euler.z;
    const a5 = Math.cos(x3), b6 = Math.sin(x3);
    const c2 = Math.cos(y2), d3 = Math.sin(y2);
    const e2 = Math.cos(z2), f2 = Math.sin(z2);
    if (euler.order === "XYZ") {
      const ae = a5 * e2, af = a5 * f2, be = b6 * e2, bf = b6 * f2;
      te[0] = c2 * e2;
      te[4] = -c2 * f2;
      te[8] = d3;
      te[1] = af + be * d3;
      te[5] = ae - bf * d3;
      te[9] = -b6 * c2;
      te[2] = bf - ae * d3;
      te[6] = be + af * d3;
      te[10] = a5 * c2;
    } else if (euler.order === "YXZ") {
      const ce = c2 * e2, cf = c2 * f2, de = d3 * e2, df = d3 * f2;
      te[0] = ce + df * b6;
      te[4] = de * b6 - cf;
      te[8] = a5 * d3;
      te[1] = a5 * f2;
      te[5] = a5 * e2;
      te[9] = -b6;
      te[2] = cf * b6 - de;
      te[6] = df + ce * b6;
      te[10] = a5 * c2;
    } else if (euler.order === "ZXY") {
      const ce = c2 * e2, cf = c2 * f2, de = d3 * e2, df = d3 * f2;
      te[0] = ce - df * b6;
      te[4] = -a5 * f2;
      te[8] = de + cf * b6;
      te[1] = cf + de * b6;
      te[5] = a5 * e2;
      te[9] = df - ce * b6;
      te[2] = -a5 * d3;
      te[6] = b6;
      te[10] = a5 * c2;
    } else if (euler.order === "ZYX") {
      const ae = a5 * e2, af = a5 * f2, be = b6 * e2, bf = b6 * f2;
      te[0] = c2 * e2;
      te[4] = be * d3 - af;
      te[8] = ae * d3 + bf;
      te[1] = c2 * f2;
      te[5] = bf * d3 + ae;
      te[9] = af * d3 - be;
      te[2] = -d3;
      te[6] = b6 * c2;
      te[10] = a5 * c2;
    } else if (euler.order === "YZX") {
      const ac = a5 * c2, ad = a5 * d3, bc = b6 * c2, bd = b6 * d3;
      te[0] = c2 * e2;
      te[4] = bd - ac * f2;
      te[8] = bc * f2 + ad;
      te[1] = f2;
      te[5] = a5 * e2;
      te[9] = -b6 * e2;
      te[2] = -d3 * e2;
      te[6] = ad * f2 + bc;
      te[10] = ac - bd * f2;
    } else if (euler.order === "XZY") {
      const ac = a5 * c2, ad = a5 * d3, bc = b6 * c2, bd = b6 * d3;
      te[0] = c2 * e2;
      te[4] = -f2;
      te[8] = d3 * e2;
      te[1] = ac * f2 + bd;
      te[5] = a5 * e2;
      te[9] = ad * f2 - bc;
      te[2] = bc * f2 - ad;
      te[6] = b6 * e2;
      te[10] = bd * f2 + ac;
    }
    te[3] = 0;
    te[7] = 0;
    te[11] = 0;
    te[12] = 0;
    te[13] = 0;
    te[14] = 0;
    te[15] = 1;
    return this;
  }
  makeRotationFromQuaternion(q2) {
    return this.compose(_zero, q2, _one);
  }
  lookAt(eye, target, up) {
    const te = this.elements;
    _z.subVectors(eye, target);
    if (_z.lengthSq() === 0) {
      _z.z = 1;
    }
    _z.normalize();
    _x.crossVectors(up, _z);
    if (_x.lengthSq() === 0) {
      if (Math.abs(up.z) === 1) {
        _z.x += 1e-4;
      } else {
        _z.z += 1e-4;
      }
      _z.normalize();
      _x.crossVectors(up, _z);
    }
    _x.normalize();
    _y.crossVectors(_z, _x);
    te[0] = _x.x;
    te[4] = _y.x;
    te[8] = _z.x;
    te[1] = _x.y;
    te[5] = _y.y;
    te[9] = _z.y;
    te[2] = _x.z;
    te[6] = _y.z;
    te[10] = _z.z;
    return this;
  }
  multiply(m2) {
    return this.multiplyMatrices(this, m2);
  }
  premultiply(m2) {
    return this.multiplyMatrices(m2, this);
  }
  multiplyMatrices(a5, b6) {
    const ae = a5.elements;
    const be = b6.elements;
    const te = this.elements;
    const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
    const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
    const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
    const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
    const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
    const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
    const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
    const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
    te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
    te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
    te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
    te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
    return this;
  }
  multiplyScalar(s2) {
    const te = this.elements;
    te[0] *= s2;
    te[4] *= s2;
    te[8] *= s2;
    te[12] *= s2;
    te[1] *= s2;
    te[5] *= s2;
    te[9] *= s2;
    te[13] *= s2;
    te[2] *= s2;
    te[6] *= s2;
    te[10] *= s2;
    te[14] *= s2;
    te[3] *= s2;
    te[7] *= s2;
    te[11] *= s2;
    te[15] *= s2;
    return this;
  }
  determinant() {
    const te = this.elements;
    const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
    const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
    const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
    const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
    return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
  }
  transpose() {
    const te = this.elements;
    let tmp2;
    tmp2 = te[1];
    te[1] = te[4];
    te[4] = tmp2;
    tmp2 = te[2];
    te[2] = te[8];
    te[8] = tmp2;
    tmp2 = te[6];
    te[6] = te[9];
    te[9] = tmp2;
    tmp2 = te[3];
    te[3] = te[12];
    te[12] = tmp2;
    tmp2 = te[7];
    te[7] = te[13];
    te[13] = tmp2;
    tmp2 = te[11];
    te[11] = te[14];
    te[14] = tmp2;
    return this;
  }
  setPosition(x3, y2, z2) {
    const te = this.elements;
    if (x3.isVector3) {
      te[12] = x3.x;
      te[13] = x3.y;
      te[14] = x3.z;
    } else {
      te[12] = x3;
      te[13] = y2;
      te[14] = z2;
    }
    return this;
  }
  invert() {
    const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
    const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
    if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te[0] = t11 * detInv;
    te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
    te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
    te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
    te[4] = t12 * detInv;
    te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
    te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
    te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
    te[8] = t13 * detInv;
    te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
    te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
    te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
    te[12] = t14 * detInv;
    te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
    te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
    te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
    return this;
  }
  scale(v3) {
    const te = this.elements;
    const x3 = v3.x, y2 = v3.y, z2 = v3.z;
    te[0] *= x3;
    te[4] *= y2;
    te[8] *= z2;
    te[1] *= x3;
    te[5] *= y2;
    te[9] *= z2;
    te[2] *= x3;
    te[6] *= y2;
    te[10] *= z2;
    te[3] *= x3;
    te[7] *= y2;
    te[11] *= z2;
    return this;
  }
  getMaxScaleOnAxis() {
    const te = this.elements;
    const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
    const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
    const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
    return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
  }
  makeTranslation(x3, y2, z2) {
    if (x3.isVector3) {
      this.set(
        1,
        0,
        0,
        x3.x,
        0,
        1,
        0,
        x3.y,
        0,
        0,
        1,
        x3.z,
        0,
        0,
        0,
        1
      );
    } else {
      this.set(
        1,
        0,
        0,
        x3,
        0,
        1,
        0,
        y2,
        0,
        0,
        1,
        z2,
        0,
        0,
        0,
        1
      );
    }
    return this;
  }
  makeRotationX(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      1,
      0,
      0,
      0,
      0,
      c2,
      -s2,
      0,
      0,
      s2,
      c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationY(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c2,
      0,
      s2,
      0,
      0,
      1,
      0,
      0,
      -s2,
      0,
      c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationZ(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c2,
      -s2,
      0,
      0,
      s2,
      c2,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationAxis(axis, angle) {
    const c2 = Math.cos(angle);
    const s2 = Math.sin(angle);
    const t2 = 1 - c2;
    const x3 = axis.x, y2 = axis.y, z2 = axis.z;
    const tx = t2 * x3, ty = t2 * y2;
    this.set(
      tx * x3 + c2,
      tx * y2 - s2 * z2,
      tx * z2 + s2 * y2,
      0,
      tx * y2 + s2 * z2,
      ty * y2 + c2,
      ty * z2 - s2 * x3,
      0,
      tx * z2 - s2 * y2,
      ty * z2 + s2 * x3,
      t2 * z2 * z2 + c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeScale(x3, y2, z2) {
    this.set(
      x3,
      0,
      0,
      0,
      0,
      y2,
      0,
      0,
      0,
      0,
      z2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeShear(xy, xz, yx, yz, zx, zy) {
    this.set(
      1,
      yx,
      zx,
      0,
      xy,
      1,
      zy,
      0,
      xz,
      yz,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  compose(position, quaternion, scale) {
    const te = this.elements;
    const x3 = quaternion._x, y2 = quaternion._y, z2 = quaternion._z, w2 = quaternion._w;
    const x22 = x3 + x3, y22 = y2 + y2, z22 = z2 + z2;
    const xx = x3 * x22, xy = x3 * y22, xz = x3 * z22;
    const yy = y2 * y22, yz = y2 * z22, zz = z2 * z22;
    const wx = w2 * x22, wy = w2 * y22, wz = w2 * z22;
    const sx = scale.x, sy = scale.y, sz = scale.z;
    te[0] = (1 - (yy + zz)) * sx;
    te[1] = (xy + wz) * sx;
    te[2] = (xz - wy) * sx;
    te[3] = 0;
    te[4] = (xy - wz) * sy;
    te[5] = (1 - (xx + zz)) * sy;
    te[6] = (yz + wx) * sy;
    te[7] = 0;
    te[8] = (xz + wy) * sz;
    te[9] = (yz - wx) * sz;
    te[10] = (1 - (xx + yy)) * sz;
    te[11] = 0;
    te[12] = position.x;
    te[13] = position.y;
    te[14] = position.z;
    te[15] = 1;
    return this;
  }
  decompose(position, quaternion, scale) {
    const te = this.elements;
    let sx = _v1$5.set(te[0], te[1], te[2]).length();
    const sy = _v1$5.set(te[4], te[5], te[6]).length();
    const sz = _v1$5.set(te[8], te[9], te[10]).length();
    const det = this.determinant();
    if (det < 0) sx = -sx;
    position.x = te[12];
    position.y = te[13];
    position.z = te[14];
    _m1$2$1.copy(this);
    const invSX = 1 / sx;
    const invSY = 1 / sy;
    const invSZ = 1 / sz;
    _m1$2$1.elements[0] *= invSX;
    _m1$2$1.elements[1] *= invSX;
    _m1$2$1.elements[2] *= invSX;
    _m1$2$1.elements[4] *= invSY;
    _m1$2$1.elements[5] *= invSY;
    _m1$2$1.elements[6] *= invSY;
    _m1$2$1.elements[8] *= invSZ;
    _m1$2$1.elements[9] *= invSZ;
    _m1$2$1.elements[10] *= invSZ;
    quaternion.setFromRotationMatrix(_m1$2$1);
    scale.x = sx;
    scale.y = sy;
    scale.z = sz;
    return this;
  }
  makePerspective(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem) {
    const te = this.elements;
    const x3 = 2 * near / (right - left);
    const y2 = 2 * near / (top - bottom);
    const a5 = (right + left) / (right - left);
    const b6 = (top + bottom) / (top - bottom);
    let c2, d3;
    if (coordinateSystem === WebGLCoordinateSystem) {
      c2 = -(far + near) / (far - near);
      d3 = -2 * far * near / (far - near);
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      c2 = -far / (far - near);
      d3 = -far * near / (far - near);
    } else {
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
    }
    te[0] = x3;
    te[4] = 0;
    te[8] = a5;
    te[12] = 0;
    te[1] = 0;
    te[5] = y2;
    te[9] = b6;
    te[13] = 0;
    te[2] = 0;
    te[6] = 0;
    te[10] = c2;
    te[14] = d3;
    te[3] = 0;
    te[7] = 0;
    te[11] = -1;
    te[15] = 0;
    return this;
  }
  makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem) {
    const te = this.elements;
    const w2 = 1 / (right - left);
    const h2 = 1 / (top - bottom);
    const p3 = 1 / (far - near);
    const x3 = (right + left) * w2;
    const y2 = (top + bottom) * h2;
    let z2, zInv;
    if (coordinateSystem === WebGLCoordinateSystem) {
      z2 = (far + near) * p3;
      zInv = -2 * p3;
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      z2 = near * p3;
      zInv = -1 * p3;
    } else {
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
    }
    te[0] = 2 * w2;
    te[4] = 0;
    te[8] = 0;
    te[12] = -x3;
    te[1] = 0;
    te[5] = 2 * h2;
    te[9] = 0;
    te[13] = -y2;
    te[2] = 0;
    te[6] = 0;
    te[10] = zInv;
    te[14] = -z2;
    te[3] = 0;
    te[7] = 0;
    te[11] = 0;
    te[15] = 1;
    return this;
  }
  equals(matrix) {
    const te = this.elements;
    const me = matrix.elements;
    for (let i2 = 0; i2 < 16; i2++) {
      if (te[i2] !== me[i2]) return false;
    }
    return true;
  }
  fromArray(array, offset = 0) {
    for (let i2 = 0; i2 < 16; i2++) {
      this.elements[i2] = array[i2 + offset];
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const te = this.elements;
    array[offset] = te[0];
    array[offset + 1] = te[1];
    array[offset + 2] = te[2];
    array[offset + 3] = te[3];
    array[offset + 4] = te[4];
    array[offset + 5] = te[5];
    array[offset + 6] = te[6];
    array[offset + 7] = te[7];
    array[offset + 8] = te[8];
    array[offset + 9] = te[9];
    array[offset + 10] = te[10];
    array[offset + 11] = te[11];
    array[offset + 12] = te[12];
    array[offset + 13] = te[13];
    array[offset + 14] = te[14];
    array[offset + 15] = te[15];
    return array;
  }
}
const _v1$5 = /* @__PURE__ */ new Vector3();
const _m1$2$1 = /* @__PURE__ */ new Matrix4();
const _zero = /* @__PURE__ */ new Vector3(0, 0, 0);
const _one = /* @__PURE__ */ new Vector3(1, 1, 1);
const _x = /* @__PURE__ */ new Vector3();
const _y = /* @__PURE__ */ new Vector3();
const _z = /* @__PURE__ */ new Vector3();
const _matrix$2 = /* @__PURE__ */ new Matrix4();
const _quaternion$3 = /* @__PURE__ */ new Quaternion();
class Euler {
  constructor(x3 = 0, y2 = 0, z2 = 0, order = Euler.DEFAULT_ORDER) {
    this.isEuler = true;
    this._x = x3;
    this._y = y2;
    this._z = z2;
    this._order = order;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(value) {
    this._order = value;
    this._onChangeCallback();
  }
  set(x3, y2, z2, order = this._order) {
    this._x = x3;
    this._y = y2;
    this._z = z2;
    this._order = order;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(euler) {
    this._x = euler._x;
    this._y = euler._y;
    this._z = euler._z;
    this._order = euler._order;
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m2, order = this._order, update2 = true) {
    const te = m2.elements;
    const m11 = te[0], m12 = te[4], m13 = te[8];
    const m21 = te[1], m22 = te[5], m23 = te[9];
    const m31 = te[2], m32 = te[6], m33 = te[10];
    switch (order) {
      case "XYZ":
        this._y = Math.asin(clamp$4(m13, -1, 1));
        if (Math.abs(m13) < 0.9999999) {
          this._x = Math.atan2(-m23, m33);
          this._z = Math.atan2(-m12, m11);
        } else {
          this._x = Math.atan2(m32, m22);
          this._z = 0;
        }
        break;
      case "YXZ":
        this._x = Math.asin(-clamp$4(m23, -1, 1));
        if (Math.abs(m23) < 0.9999999) {
          this._y = Math.atan2(m13, m33);
          this._z = Math.atan2(m21, m22);
        } else {
          this._y = Math.atan2(-m31, m11);
          this._z = 0;
        }
        break;
      case "ZXY":
        this._x = Math.asin(clamp$4(m32, -1, 1));
        if (Math.abs(m32) < 0.9999999) {
          this._y = Math.atan2(-m31, m33);
          this._z = Math.atan2(-m12, m22);
        } else {
          this._y = 0;
          this._z = Math.atan2(m21, m11);
        }
        break;
      case "ZYX":
        this._y = Math.asin(-clamp$4(m31, -1, 1));
        if (Math.abs(m31) < 0.9999999) {
          this._x = Math.atan2(m32, m33);
          this._z = Math.atan2(m21, m11);
        } else {
          this._x = 0;
          this._z = Math.atan2(-m12, m22);
        }
        break;
      case "YZX":
        this._z = Math.asin(clamp$4(m21, -1, 1));
        if (Math.abs(m21) < 0.9999999) {
          this._x = Math.atan2(-m23, m22);
          this._y = Math.atan2(-m31, m11);
        } else {
          this._x = 0;
          this._y = Math.atan2(m13, m33);
        }
        break;
      case "XZY":
        this._z = Math.asin(-clamp$4(m12, -1, 1));
        if (Math.abs(m12) < 0.9999999) {
          this._x = Math.atan2(m32, m22);
          this._y = Math.atan2(m13, m11);
        } else {
          this._x = Math.atan2(-m23, m33);
          this._y = 0;
        }
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
    }
    this._order = order;
    if (update2 === true) this._onChangeCallback();
    return this;
  }
  setFromQuaternion(q2, order, update2) {
    _matrix$2.makeRotationFromQuaternion(q2);
    return this.setFromRotationMatrix(_matrix$2, order, update2);
  }
  setFromVector3(v3, order = this._order) {
    return this.set(v3.x, v3.y, v3.z, order);
  }
  reorder(newOrder) {
    _quaternion$3.setFromEuler(this);
    return this.setFromQuaternion(_quaternion$3, newOrder);
  }
  equals(euler) {
    return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
  }
  fromArray(array) {
    this._x = array[0];
    this._y = array[1];
    this._z = array[2];
    if (array[3] !== void 0) this._order = array[3];
    this._onChangeCallback();
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._order;
    return array;
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x;
    yield this._y;
    yield this._z;
    yield this._order;
  }
}
Euler.DEFAULT_ORDER = "XYZ";
class Layers {
  constructor() {
    this.mask = 1 | 0;
  }
  set(channel) {
    this.mask = (1 << channel | 0) >>> 0;
  }
  enable(channel) {
    this.mask |= 1 << channel | 0;
  }
  enableAll() {
    this.mask = 4294967295 | 0;
  }
  toggle(channel) {
    this.mask ^= 1 << channel | 0;
  }
  disable(channel) {
    this.mask &= ~(1 << channel | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(layers) {
    return (this.mask & layers.mask) !== 0;
  }
  isEnabled(channel) {
    return (this.mask & (1 << channel | 0)) !== 0;
  }
}
let _object3DId = 0;
const _v1$4 = /* @__PURE__ */ new Vector3();
const _q1$1 = /* @__PURE__ */ new Quaternion();
const _m1$1$1 = /* @__PURE__ */ new Matrix4();
const _target = /* @__PURE__ */ new Vector3();
const _position$3 = /* @__PURE__ */ new Vector3();
const _scale$2 = /* @__PURE__ */ new Vector3();
const _quaternion$2 = /* @__PURE__ */ new Quaternion();
const _xAxis = /* @__PURE__ */ new Vector3(1, 0, 0);
const _yAxis = /* @__PURE__ */ new Vector3(0, 1, 0);
const _zAxis = /* @__PURE__ */ new Vector3(0, 0, 1);
const _addedEvent = { type: "added" };
const _removedEvent = { type: "removed" };
const _childaddedEvent = { type: "childadded", child: null };
const _childremovedEvent = { type: "childremoved", child: null };
class Object3D extends EventDispatcher$2 {
  constructor() {
    super();
    this.isObject3D = true;
    Object.defineProperty(this, "id", { value: _object3DId++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.type = "Object3D";
    this.parent = null;
    this.children = [];
    this.up = Object3D.DEFAULT_UP.clone();
    const position = new Vector3();
    const rotation = new Euler();
    const quaternion = new Quaternion();
    const scale = new Vector3(1, 1, 1);
    function onRotationChange() {
      quaternion.setFromEuler(rotation, false);
    }
    function onQuaternionChange() {
      rotation.setFromQuaternion(quaternion, void 0, false);
    }
    rotation._onChange(onRotationChange);
    quaternion._onChange(onQuaternionChange);
    Object.defineProperties(this, {
      position: {
        configurable: true,
        enumerable: true,
        value: position
      },
      rotation: {
        configurable: true,
        enumerable: true,
        value: rotation
      },
      quaternion: {
        configurable: true,
        enumerable: true,
        value: quaternion
      },
      scale: {
        configurable: true,
        enumerable: true,
        value: scale
      },
      modelViewMatrix: {
        value: new Matrix4()
      },
      normalMatrix: {
        value: new Matrix3()
      }
    });
    this.matrix = new Matrix4();
    this.matrixWorld = new Matrix4();
    this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;
    this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE;
    this.matrixWorldNeedsUpdate = false;
    this.layers = new Layers();
    this.visible = true;
    this.castShadow = false;
    this.receiveShadow = false;
    this.frustumCulled = true;
    this.renderOrder = 0;
    this.animations = [];
    this.userData = {};
  }
  onBeforeShadow() {
  }
  onAfterShadow() {
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(matrix) {
    if (this.matrixAutoUpdate) this.updateMatrix();
    this.matrix.premultiply(matrix);
    this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(q2) {
    this.quaternion.premultiply(q2);
    return this;
  }
  setRotationFromAxisAngle(axis, angle) {
    this.quaternion.setFromAxisAngle(axis, angle);
  }
  setRotationFromEuler(euler) {
    this.quaternion.setFromEuler(euler, true);
  }
  setRotationFromMatrix(m2) {
    this.quaternion.setFromRotationMatrix(m2);
  }
  setRotationFromQuaternion(q2) {
    this.quaternion.copy(q2);
  }
  rotateOnAxis(axis, angle) {
    _q1$1.setFromAxisAngle(axis, angle);
    this.quaternion.multiply(_q1$1);
    return this;
  }
  rotateOnWorldAxis(axis, angle) {
    _q1$1.setFromAxisAngle(axis, angle);
    this.quaternion.premultiply(_q1$1);
    return this;
  }
  rotateX(angle) {
    return this.rotateOnAxis(_xAxis, angle);
  }
  rotateY(angle) {
    return this.rotateOnAxis(_yAxis, angle);
  }
  rotateZ(angle) {
    return this.rotateOnAxis(_zAxis, angle);
  }
  translateOnAxis(axis, distance) {
    _v1$4.copy(axis).applyQuaternion(this.quaternion);
    this.position.add(_v1$4.multiplyScalar(distance));
    return this;
  }
  translateX(distance) {
    return this.translateOnAxis(_xAxis, distance);
  }
  translateY(distance) {
    return this.translateOnAxis(_yAxis, distance);
  }
  translateZ(distance) {
    return this.translateOnAxis(_zAxis, distance);
  }
  localToWorld(vector) {
    this.updateWorldMatrix(true, false);
    return vector.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(vector) {
    this.updateWorldMatrix(true, false);
    return vector.applyMatrix4(_m1$1$1.copy(this.matrixWorld).invert());
  }
  lookAt(x3, y2, z2) {
    if (x3.isVector3) {
      _target.copy(x3);
    } else {
      _target.set(x3, y2, z2);
    }
    const parent = this.parent;
    this.updateWorldMatrix(true, false);
    _position$3.setFromMatrixPosition(this.matrixWorld);
    if (this.isCamera || this.isLight) {
      _m1$1$1.lookAt(_position$3, _target, this.up);
    } else {
      _m1$1$1.lookAt(_target, _position$3, this.up);
    }
    this.quaternion.setFromRotationMatrix(_m1$1$1);
    if (parent) {
      _m1$1$1.extractRotation(parent.matrixWorld);
      _q1$1.setFromRotationMatrix(_m1$1$1);
      this.quaternion.premultiply(_q1$1.invert());
    }
  }
  add(object) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.add(arguments[i2]);
      }
      return this;
    }
    if (object === this) {
      console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
      return this;
    }
    if (object && object.isObject3D) {
      object.removeFromParent();
      object.parent = this;
      this.children.push(object);
      object.dispatchEvent(_addedEvent);
      _childaddedEvent.child = object;
      this.dispatchEvent(_childaddedEvent);
      _childaddedEvent.child = null;
    } else {
      console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
    }
    return this;
  }
  remove(object) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.remove(arguments[i2]);
      }
      return this;
    }
    const index = this.children.indexOf(object);
    if (index !== -1) {
      object.parent = null;
      this.children.splice(index, 1);
      object.dispatchEvent(_removedEvent);
      _childremovedEvent.child = object;
      this.dispatchEvent(_childremovedEvent);
      _childremovedEvent.child = null;
    }
    return this;
  }
  removeFromParent() {
    const parent = this.parent;
    if (parent !== null) {
      parent.remove(this);
    }
    return this;
  }
  clear() {
    return this.remove(...this.children);
  }
  attach(object) {
    this.updateWorldMatrix(true, false);
    _m1$1$1.copy(this.matrixWorld).invert();
    if (object.parent !== null) {
      object.parent.updateWorldMatrix(true, false);
      _m1$1$1.multiply(object.parent.matrixWorld);
    }
    object.applyMatrix4(_m1$1$1);
    object.removeFromParent();
    object.parent = this;
    this.children.push(object);
    object.updateWorldMatrix(false, true);
    object.dispatchEvent(_addedEvent);
    _childaddedEvent.child = object;
    this.dispatchEvent(_childaddedEvent);
    _childaddedEvent.child = null;
    return this;
  }
  getObjectById(id) {
    return this.getObjectByProperty("id", id);
  }
  getObjectByName(name) {
    return this.getObjectByProperty("name", name);
  }
  getObjectByProperty(name, value) {
    if (this[name] === value) return this;
    for (let i2 = 0, l2 = this.children.length; i2 < l2; i2++) {
      const child = this.children[i2];
      const object = child.getObjectByProperty(name, value);
      if (object !== void 0) {
        return object;
      }
    }
    return void 0;
  }
  getObjectsByProperty(name, value, result = []) {
    if (this[name] === value) result.push(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].getObjectsByProperty(name, value, result);
    }
    return result;
  }
  getWorldPosition(target) {
    this.updateWorldMatrix(true, false);
    return target.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(target) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, target, _scale$2);
    return target;
  }
  getWorldScale(target) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, _quaternion$2, target);
    return target;
  }
  getWorldDirection(target) {
    this.updateWorldMatrix(true, false);
    const e2 = this.matrixWorld.elements;
    return target.set(e2[8], e2[9], e2[10]).normalize();
  }
  raycast() {
  }
  traverse(callback) {
    callback(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].traverse(callback);
    }
  }
  traverseVisible(callback) {
    if (this.visible === false) return;
    callback(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].traverseVisible(callback);
    }
  }
  traverseAncestors(callback) {
    const parent = this.parent;
    if (parent !== null) {
      callback(parent);
      parent.traverseAncestors(callback);
    }
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale);
    this.matrixWorldNeedsUpdate = true;
  }
  updateMatrixWorld(force) {
    if (this.matrixAutoUpdate) this.updateMatrix();
    if (this.matrixWorldNeedsUpdate || force) {
      if (this.matrixWorldAutoUpdate === true) {
        if (this.parent === null) {
          this.matrixWorld.copy(this.matrix);
        } else {
          this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
      }
      this.matrixWorldNeedsUpdate = false;
      force = true;
    }
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      const child = children[i2];
      child.updateMatrixWorld(force);
    }
  }
  updateWorldMatrix(updateParents, updateChildren) {
    const parent = this.parent;
    if (updateParents === true && parent !== null) {
      parent.updateWorldMatrix(true, false);
    }
    if (this.matrixAutoUpdate) this.updateMatrix();
    if (this.matrixWorldAutoUpdate === true) {
      if (this.parent === null) {
        this.matrixWorld.copy(this.matrix);
      } else {
        this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
      }
    }
    if (updateChildren === true) {
      const children = this.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        const child = children[i2];
        child.updateWorldMatrix(false, true);
      }
    }
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    const output = {};
    if (isRootObject) {
      meta = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {},
        nodes: {}
      };
      output.metadata = {
        version: 4.6,
        type: "Object",
        generator: "Object3D.toJSON"
      };
    }
    const object = {};
    object.uuid = this.uuid;
    object.type = this.type;
    if (this.name !== "") object.name = this.name;
    if (this.castShadow === true) object.castShadow = true;
    if (this.receiveShadow === true) object.receiveShadow = true;
    if (this.visible === false) object.visible = false;
    if (this.frustumCulled === false) object.frustumCulled = false;
    if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
    if (Object.keys(this.userData).length > 0) object.userData = this.userData;
    object.layers = this.layers.mask;
    object.matrix = this.matrix.toArray();
    object.up = this.up.toArray();
    if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
    if (this.isInstancedMesh) {
      object.type = "InstancedMesh";
      object.count = this.count;
      object.instanceMatrix = this.instanceMatrix.toJSON();
      if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
    }
    if (this.isBatchedMesh) {
      object.type = "BatchedMesh";
      object.perObjectFrustumCulled = this.perObjectFrustumCulled;
      object.sortObjects = this.sortObjects;
      object.drawRanges = this._drawRanges;
      object.reservedRanges = this._reservedRanges;
      object.visibility = this._visibility;
      object.active = this._active;
      object.bounds = this._bounds.map((bound) => ({
        boxInitialized: bound.boxInitialized,
        boxMin: bound.box.min.toArray(),
        boxMax: bound.box.max.toArray(),
        sphereInitialized: bound.sphereInitialized,
        sphereRadius: bound.sphere.radius,
        sphereCenter: bound.sphere.center.toArray()
      }));
      object.maxInstanceCount = this._maxInstanceCount;
      object.maxVertexCount = this._maxVertexCount;
      object.maxIndexCount = this._maxIndexCount;
      object.geometryInitialized = this._geometryInitialized;
      object.geometryCount = this._geometryCount;
      object.matricesTexture = this._matricesTexture.toJSON(meta);
      if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
      if (this.boundingSphere !== null) {
        object.boundingSphere = {
          center: object.boundingSphere.center.toArray(),
          radius: object.boundingSphere.radius
        };
      }
      if (this.boundingBox !== null) {
        object.boundingBox = {
          min: object.boundingBox.min.toArray(),
          max: object.boundingBox.max.toArray()
        };
      }
    }
    function serialize(library, element) {
      if (library[element.uuid] === void 0) {
        library[element.uuid] = element.toJSON(meta);
      }
      return element.uuid;
    }
    if (this.isScene) {
      if (this.background) {
        if (this.background.isColor) {
          object.background = this.background.toJSON();
        } else if (this.background.isTexture) {
          object.background = this.background.toJSON(meta).uuid;
        }
      }
      if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) {
        object.environment = this.environment.toJSON(meta).uuid;
      }
    } else if (this.isMesh || this.isLine || this.isPoints) {
      object.geometry = serialize(meta.geometries, this.geometry);
      const parameters = this.geometry.parameters;
      if (parameters !== void 0 && parameters.shapes !== void 0) {
        const shapes = parameters.shapes;
        if (Array.isArray(shapes)) {
          for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
            const shape = shapes[i2];
            serialize(meta.shapes, shape);
          }
        } else {
          serialize(meta.shapes, shapes);
        }
      }
    }
    if (this.isSkinnedMesh) {
      object.bindMode = this.bindMode;
      object.bindMatrix = this.bindMatrix.toArray();
      if (this.skeleton !== void 0) {
        serialize(meta.skeletons, this.skeleton);
        object.skeleton = this.skeleton.uuid;
      }
    }
    if (this.material !== void 0) {
      if (Array.isArray(this.material)) {
        const uuids = [];
        for (let i2 = 0, l2 = this.material.length; i2 < l2; i2++) {
          uuids.push(serialize(meta.materials, this.material[i2]));
        }
        object.material = uuids;
      } else {
        object.material = serialize(meta.materials, this.material);
      }
    }
    if (this.children.length > 0) {
      object.children = [];
      for (let i2 = 0; i2 < this.children.length; i2++) {
        object.children.push(this.children[i2].toJSON(meta).object);
      }
    }
    if (this.animations.length > 0) {
      object.animations = [];
      for (let i2 = 0; i2 < this.animations.length; i2++) {
        const animation = this.animations[i2];
        object.animations.push(serialize(meta.animations, animation));
      }
    }
    if (isRootObject) {
      const geometries = extractFromCache(meta.geometries);
      const materials = extractFromCache(meta.materials);
      const textures = extractFromCache(meta.textures);
      const images = extractFromCache(meta.images);
      const shapes = extractFromCache(meta.shapes);
      const skeletons = extractFromCache(meta.skeletons);
      const animations = extractFromCache(meta.animations);
      const nodes = extractFromCache(meta.nodes);
      if (geometries.length > 0) output.geometries = geometries;
      if (materials.length > 0) output.materials = materials;
      if (textures.length > 0) output.textures = textures;
      if (images.length > 0) output.images = images;
      if (shapes.length > 0) output.shapes = shapes;
      if (skeletons.length > 0) output.skeletons = skeletons;
      if (animations.length > 0) output.animations = animations;
      if (nodes.length > 0) output.nodes = nodes;
    }
    output.object = object;
    return output;
    function extractFromCache(cache) {
      const values = [];
      for (const key in cache) {
        const data = cache[key];
        delete data.metadata;
        values.push(data);
      }
      return values;
    }
  }
  clone(recursive) {
    return new this.constructor().copy(this, recursive);
  }
  copy(source, recursive = true) {
    this.name = source.name;
    this.up.copy(source.up);
    this.position.copy(source.position);
    this.rotation.order = source.rotation.order;
    this.quaternion.copy(source.quaternion);
    this.scale.copy(source.scale);
    this.matrix.copy(source.matrix);
    this.matrixWorld.copy(source.matrixWorld);
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
    this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
    this.layers.mask = source.layers.mask;
    this.visible = source.visible;
    this.castShadow = source.castShadow;
    this.receiveShadow = source.receiveShadow;
    this.frustumCulled = source.frustumCulled;
    this.renderOrder = source.renderOrder;
    this.animations = source.animations.slice();
    this.userData = JSON.parse(JSON.stringify(source.userData));
    if (recursive === true) {
      for (let i2 = 0; i2 < source.children.length; i2++) {
        const child = source.children[i2];
        this.add(child.clone());
      }
    }
    return this;
  }
}
Object3D.DEFAULT_UP = /* @__PURE__ */ new Vector3(0, 1, 0);
Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;
Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const _v0$1 = /* @__PURE__ */ new Vector3();
const _v1$3 = /* @__PURE__ */ new Vector3();
const _v2$2 = /* @__PURE__ */ new Vector3();
const _v3$2 = /* @__PURE__ */ new Vector3();
const _vab = /* @__PURE__ */ new Vector3();
const _vac = /* @__PURE__ */ new Vector3();
const _vbc = /* @__PURE__ */ new Vector3();
const _vap = /* @__PURE__ */ new Vector3();
const _vbp = /* @__PURE__ */ new Vector3();
const _vcp = /* @__PURE__ */ new Vector3();
const _v40 = /* @__PURE__ */ new Vector4();
const _v41 = /* @__PURE__ */ new Vector4();
const _v42 = /* @__PURE__ */ new Vector4();
class Triangle {
  constructor(a5 = new Vector3(), b6 = new Vector3(), c2 = new Vector3()) {
    this.a = a5;
    this.b = b6;
    this.c = c2;
  }
  static getNormal(a5, b6, c2, target) {
    target.subVectors(c2, b6);
    _v0$1.subVectors(a5, b6);
    target.cross(_v0$1);
    const targetLengthSq = target.lengthSq();
    if (targetLengthSq > 0) {
      return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
    }
    return target.set(0, 0, 0);
  }
  // static/instance method to calculate barycentric coordinates
  // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
  static getBarycoord(point, a5, b6, c2, target) {
    _v0$1.subVectors(c2, a5);
    _v1$3.subVectors(b6, a5);
    _v2$2.subVectors(point, a5);
    const dot00 = _v0$1.dot(_v0$1);
    const dot01 = _v0$1.dot(_v1$3);
    const dot02 = _v0$1.dot(_v2$2);
    const dot11 = _v1$3.dot(_v1$3);
    const dot12 = _v1$3.dot(_v2$2);
    const denom = dot00 * dot11 - dot01 * dot01;
    if (denom === 0) {
      target.set(0, 0, 0);
      return null;
    }
    const invDenom = 1 / denom;
    const u2 = (dot11 * dot02 - dot01 * dot12) * invDenom;
    const v3 = (dot00 * dot12 - dot01 * dot02) * invDenom;
    return target.set(1 - u2 - v3, v3, u2);
  }
  static containsPoint(point, a5, b6, c2) {
    if (this.getBarycoord(point, a5, b6, c2, _v3$2) === null) {
      return false;
    }
    return _v3$2.x >= 0 && _v3$2.y >= 0 && _v3$2.x + _v3$2.y <= 1;
  }
  static getInterpolation(point, p1, p22, p3, v1, v22, v3, target) {
    if (this.getBarycoord(point, p1, p22, p3, _v3$2) === null) {
      target.x = 0;
      target.y = 0;
      if ("z" in target) target.z = 0;
      if ("w" in target) target.w = 0;
      return null;
    }
    target.setScalar(0);
    target.addScaledVector(v1, _v3$2.x);
    target.addScaledVector(v22, _v3$2.y);
    target.addScaledVector(v3, _v3$2.z);
    return target;
  }
  static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
    _v40.setScalar(0);
    _v41.setScalar(0);
    _v42.setScalar(0);
    _v40.fromBufferAttribute(attr, i1);
    _v41.fromBufferAttribute(attr, i2);
    _v42.fromBufferAttribute(attr, i3);
    target.setScalar(0);
    target.addScaledVector(_v40, barycoord.x);
    target.addScaledVector(_v41, barycoord.y);
    target.addScaledVector(_v42, barycoord.z);
    return target;
  }
  static isFrontFacing(a5, b6, c2, direction) {
    _v0$1.subVectors(c2, b6);
    _v1$3.subVectors(a5, b6);
    return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
  }
  set(a5, b6, c2) {
    this.a.copy(a5);
    this.b.copy(b6);
    this.c.copy(c2);
    return this;
  }
  setFromPointsAndIndices(points, i0, i1, i2) {
    this.a.copy(points[i0]);
    this.b.copy(points[i1]);
    this.c.copy(points[i2]);
    return this;
  }
  setFromAttributeAndIndices(attribute, i0, i1, i2) {
    this.a.fromBufferAttribute(attribute, i0);
    this.b.fromBufferAttribute(attribute, i1);
    this.c.fromBufferAttribute(attribute, i2);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(triangle) {
    this.a.copy(triangle.a);
    this.b.copy(triangle.b);
    this.c.copy(triangle.c);
    return this;
  }
  getArea() {
    _v0$1.subVectors(this.c, this.b);
    _v1$3.subVectors(this.a, this.b);
    return _v0$1.cross(_v1$3).length() * 0.5;
  }
  getMidpoint(target) {
    return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(target) {
    return Triangle.getNormal(this.a, this.b, this.c, target);
  }
  getPlane(target) {
    return target.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(point, target) {
    return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
  }
  getInterpolation(point, v1, v22, v3, target) {
    return Triangle.getInterpolation(point, this.a, this.b, this.c, v1, v22, v3, target);
  }
  containsPoint(point) {
    return Triangle.containsPoint(point, this.a, this.b, this.c);
  }
  isFrontFacing(direction) {
    return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
  }
  intersectsBox(box) {
    return box.intersectsTriangle(this);
  }
  closestPointToPoint(p3, target) {
    const a5 = this.a, b6 = this.b, c2 = this.c;
    let v3, w2;
    _vab.subVectors(b6, a5);
    _vac.subVectors(c2, a5);
    _vap.subVectors(p3, a5);
    const d1 = _vab.dot(_vap);
    const d22 = _vac.dot(_vap);
    if (d1 <= 0 && d22 <= 0) {
      return target.copy(a5);
    }
    _vbp.subVectors(p3, b6);
    const d3 = _vab.dot(_vbp);
    const d42 = _vac.dot(_vbp);
    if (d3 >= 0 && d42 <= d3) {
      return target.copy(b6);
    }
    const vc = d1 * d42 - d3 * d22;
    if (vc <= 0 && d1 >= 0 && d3 <= 0) {
      v3 = d1 / (d1 - d3);
      return target.copy(a5).addScaledVector(_vab, v3);
    }
    _vcp.subVectors(p3, c2);
    const d5 = _vab.dot(_vcp);
    const d6 = _vac.dot(_vcp);
    if (d6 >= 0 && d5 <= d6) {
      return target.copy(c2);
    }
    const vb = d5 * d22 - d1 * d6;
    if (vb <= 0 && d22 >= 0 && d6 <= 0) {
      w2 = d22 / (d22 - d6);
      return target.copy(a5).addScaledVector(_vac, w2);
    }
    const va = d3 * d6 - d5 * d42;
    if (va <= 0 && d42 - d3 >= 0 && d5 - d6 >= 0) {
      _vbc.subVectors(c2, b6);
      w2 = (d42 - d3) / (d42 - d3 + (d5 - d6));
      return target.copy(b6).addScaledVector(_vbc, w2);
    }
    const denom = 1 / (va + vb + vc);
    v3 = vb * denom;
    w2 = vc * denom;
    return target.copy(a5).addScaledVector(_vab, v3).addScaledVector(_vac, w2);
  }
  equals(triangle) {
    return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
  }
}
const _colorKeywords = {
  "aliceblue": 15792383,
  "antiquewhite": 16444375,
  "aqua": 65535,
  "aquamarine": 8388564,
  "azure": 15794175,
  "beige": 16119260,
  "bisque": 16770244,
  "black": 0,
  "blanchedalmond": 16772045,
  "blue": 255,
  "blueviolet": 9055202,
  "brown": 10824234,
  "burlywood": 14596231,
  "cadetblue": 6266528,
  "chartreuse": 8388352,
  "chocolate": 13789470,
  "coral": 16744272,
  "cornflowerblue": 6591981,
  "cornsilk": 16775388,
  "crimson": 14423100,
  "cyan": 65535,
  "darkblue": 139,
  "darkcyan": 35723,
  "darkgoldenrod": 12092939,
  "darkgray": 11119017,
  "darkgreen": 25600,
  "darkgrey": 11119017,
  "darkkhaki": 12433259,
  "darkmagenta": 9109643,
  "darkolivegreen": 5597999,
  "darkorange": 16747520,
  "darkorchid": 10040012,
  "darkred": 9109504,
  "darksalmon": 15308410,
  "darkseagreen": 9419919,
  "darkslateblue": 4734347,
  "darkslategray": 3100495,
  "darkslategrey": 3100495,
  "darkturquoise": 52945,
  "darkviolet": 9699539,
  "deeppink": 16716947,
  "deepskyblue": 49151,
  "dimgray": 6908265,
  "dimgrey": 6908265,
  "dodgerblue": 2003199,
  "firebrick": 11674146,
  "floralwhite": 16775920,
  "forestgreen": 2263842,
  "fuchsia": 16711935,
  "gainsboro": 14474460,
  "ghostwhite": 16316671,
  "gold": 16766720,
  "goldenrod": 14329120,
  "gray": 8421504,
  "green": 32768,
  "greenyellow": 11403055,
  "grey": 8421504,
  "honeydew": 15794160,
  "hotpink": 16738740,
  "indianred": 13458524,
  "indigo": 4915330,
  "ivory": 16777200,
  "khaki": 15787660,
  "lavender": 15132410,
  "lavenderblush": 16773365,
  "lawngreen": 8190976,
  "lemonchiffon": 16775885,
  "lightblue": 11393254,
  "lightcoral": 15761536,
  "lightcyan": 14745599,
  "lightgoldenrodyellow": 16448210,
  "lightgray": 13882323,
  "lightgreen": 9498256,
  "lightgrey": 13882323,
  "lightpink": 16758465,
  "lightsalmon": 16752762,
  "lightseagreen": 2142890,
  "lightskyblue": 8900346,
  "lightslategray": 7833753,
  "lightslategrey": 7833753,
  "lightsteelblue": 11584734,
  "lightyellow": 16777184,
  "lime": 65280,
  "limegreen": 3329330,
  "linen": 16445670,
  "magenta": 16711935,
  "maroon": 8388608,
  "mediumaquamarine": 6737322,
  "mediumblue": 205,
  "mediumorchid": 12211667,
  "mediumpurple": 9662683,
  "mediumseagreen": 3978097,
  "mediumslateblue": 8087790,
  "mediumspringgreen": 64154,
  "mediumturquoise": 4772300,
  "mediumvioletred": 13047173,
  "midnightblue": 1644912,
  "mintcream": 16121850,
  "mistyrose": 16770273,
  "moccasin": 16770229,
  "navajowhite": 16768685,
  "navy": 128,
  "oldlace": 16643558,
  "olive": 8421376,
  "olivedrab": 7048739,
  "orange": 16753920,
  "orangered": 16729344,
  "orchid": 14315734,
  "palegoldenrod": 15657130,
  "palegreen": 10025880,
  "paleturquoise": 11529966,
  "palevioletred": 14381203,
  "papayawhip": 16773077,
  "peachpuff": 16767673,
  "peru": 13468991,
  "pink": 16761035,
  "plum": 14524637,
  "powderblue": 11591910,
  "purple": 8388736,
  "rebeccapurple": 6697881,
  "red": 16711680,
  "rosybrown": 12357519,
  "royalblue": 4286945,
  "saddlebrown": 9127187,
  "salmon": 16416882,
  "sandybrown": 16032864,
  "seagreen": 3050327,
  "seashell": 16774638,
  "sienna": 10506797,
  "silver": 12632256,
  "skyblue": 8900331,
  "slateblue": 6970061,
  "slategray": 7372944,
  "slategrey": 7372944,
  "snow": 16775930,
  "springgreen": 65407,
  "steelblue": 4620980,
  "tan": 13808780,
  "teal": 32896,
  "thistle": 14204888,
  "tomato": 16737095,
  "turquoise": 4251856,
  "violet": 15631086,
  "wheat": 16113331,
  "white": 16777215,
  "whitesmoke": 16119285,
  "yellow": 16776960,
  "yellowgreen": 10145074
};
const _hslA = { h: 0, s: 0, l: 0 };
const _hslB = { h: 0, s: 0, l: 0 };
function hue2rgb$1(p3, q2, t2) {
  if (t2 < 0) t2 += 1;
  if (t2 > 1) t2 -= 1;
  if (t2 < 1 / 6) return p3 + (q2 - p3) * 6 * t2;
  if (t2 < 1 / 2) return q2;
  if (t2 < 2 / 3) return p3 + (q2 - p3) * 6 * (2 / 3 - t2);
  return p3;
}
class Color {
  constructor(r3, g2, b6) {
    this.isColor = true;
    this.r = 1;
    this.g = 1;
    this.b = 1;
    return this.set(r3, g2, b6);
  }
  set(r3, g2, b6) {
    if (g2 === void 0 && b6 === void 0) {
      const value = r3;
      if (value && value.isColor) {
        this.copy(value);
      } else if (typeof value === "number") {
        this.setHex(value);
      } else if (typeof value === "string") {
        this.setStyle(value);
      }
    } else {
      this.setRGB(r3, g2, b6);
    }
    return this;
  }
  setScalar(scalar) {
    this.r = scalar;
    this.g = scalar;
    this.b = scalar;
    return this;
  }
  setHex(hex, colorSpace = SRGBColorSpace$1) {
    hex = Math.floor(hex);
    this.r = (hex >> 16 & 255) / 255;
    this.g = (hex >> 8 & 255) / 255;
    this.b = (hex & 255) / 255;
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  setRGB(r3, g2, b6, colorSpace = ColorManagement.workingColorSpace) {
    this.r = r3;
    this.g = g2;
    this.b = b6;
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  setHSL(h2, s2, l2, colorSpace = ColorManagement.workingColorSpace) {
    h2 = euclideanModulo(h2, 1);
    s2 = clamp$4(s2, 0, 1);
    l2 = clamp$4(l2, 0, 1);
    if (s2 === 0) {
      this.r = this.g = this.b = l2;
    } else {
      const p3 = l2 <= 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
      const q2 = 2 * l2 - p3;
      this.r = hue2rgb$1(q2, p3, h2 + 1 / 3);
      this.g = hue2rgb$1(q2, p3, h2);
      this.b = hue2rgb$1(q2, p3, h2 - 1 / 3);
    }
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  setStyle(style, colorSpace = SRGBColorSpace$1) {
    function handleAlpha(string) {
      if (string === void 0) return;
      if (parseFloat(string) < 1) {
        console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
      }
    }
    let m2;
    if (m2 = /^(\w+)\(([^\)]*)\)/.exec(style)) {
      let color;
      const name = m2[1];
      const components = m2[2];
      switch (name) {
        case "rgb":
        case "rgba":
          if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            handleAlpha(color[4]);
            return this.setRGB(
              Math.min(255, parseInt(color[1], 10)) / 255,
              Math.min(255, parseInt(color[2], 10)) / 255,
              Math.min(255, parseInt(color[3], 10)) / 255,
              colorSpace
            );
          }
          if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            handleAlpha(color[4]);
            return this.setRGB(
              Math.min(100, parseInt(color[1], 10)) / 100,
              Math.min(100, parseInt(color[2], 10)) / 100,
              Math.min(100, parseInt(color[3], 10)) / 100,
              colorSpace
            );
          }
          break;
        case "hsl":
        case "hsla":
          if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            handleAlpha(color[4]);
            return this.setHSL(
              parseFloat(color[1]) / 360,
              parseFloat(color[2]) / 100,
              parseFloat(color[3]) / 100,
              colorSpace
            );
          }
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + style);
      }
    } else if (m2 = /^\#([A-Fa-f\d]+)$/.exec(style)) {
      const hex = m2[1];
      const size = hex.length;
      if (size === 3) {
        return this.setRGB(
          parseInt(hex.charAt(0), 16) / 15,
          parseInt(hex.charAt(1), 16) / 15,
          parseInt(hex.charAt(2), 16) / 15,
          colorSpace
        );
      } else if (size === 6) {
        return this.setHex(parseInt(hex, 16), colorSpace);
      } else {
        console.warn("THREE.Color: Invalid hex color " + style);
      }
    } else if (style && style.length > 0) {
      return this.setColorName(style, colorSpace);
    }
    return this;
  }
  setColorName(style, colorSpace = SRGBColorSpace$1) {
    const hex = _colorKeywords[style.toLowerCase()];
    if (hex !== void 0) {
      this.setHex(hex, colorSpace);
    } else {
      console.warn("THREE.Color: Unknown color " + style);
    }
    return this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(color) {
    this.r = color.r;
    this.g = color.g;
    this.b = color.b;
    return this;
  }
  copySRGBToLinear(color) {
    this.r = SRGBToLinear(color.r);
    this.g = SRGBToLinear(color.g);
    this.b = SRGBToLinear(color.b);
    return this;
  }
  copyLinearToSRGB(color) {
    this.r = LinearToSRGB(color.r);
    this.g = LinearToSRGB(color.g);
    this.b = LinearToSRGB(color.b);
    return this;
  }
  convertSRGBToLinear() {
    this.copySRGBToLinear(this);
    return this;
  }
  convertLinearToSRGB() {
    this.copyLinearToSRGB(this);
    return this;
  }
  getHex(colorSpace = SRGBColorSpace$1) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);
    return Math.round(clamp$4(_color.r * 255, 0, 255)) * 65536 + Math.round(clamp$4(_color.g * 255, 0, 255)) * 256 + Math.round(clamp$4(_color.b * 255, 0, 255));
  }
  getHexString(colorSpace = SRGBColorSpace$1) {
    return ("000000" + this.getHex(colorSpace).toString(16)).slice(-6);
  }
  getHSL(target, colorSpace = ColorManagement.workingColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);
    const r3 = _color.r, g2 = _color.g, b6 = _color.b;
    const max2 = Math.max(r3, g2, b6);
    const min = Math.min(r3, g2, b6);
    let hue, saturation;
    const lightness = (min + max2) / 2;
    if (min === max2) {
      hue = 0;
      saturation = 0;
    } else {
      const delta = max2 - min;
      saturation = lightness <= 0.5 ? delta / (max2 + min) : delta / (2 - max2 - min);
      switch (max2) {
        case r3:
          hue = (g2 - b6) / delta + (g2 < b6 ? 6 : 0);
          break;
        case g2:
          hue = (b6 - r3) / delta + 2;
          break;
        case b6:
          hue = (r3 - g2) / delta + 4;
          break;
      }
      hue /= 6;
    }
    target.h = hue;
    target.s = saturation;
    target.l = lightness;
    return target;
  }
  getRGB(target, colorSpace = ColorManagement.workingColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);
    target.r = _color.r;
    target.g = _color.g;
    target.b = _color.b;
    return target;
  }
  getStyle(colorSpace = SRGBColorSpace$1) {
    ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);
    const r3 = _color.r, g2 = _color.g, b6 = _color.b;
    if (colorSpace !== SRGBColorSpace$1) {
      return `color(${colorSpace} ${r3.toFixed(3)} ${g2.toFixed(3)} ${b6.toFixed(3)})`;
    }
    return `rgb(${Math.round(r3 * 255)},${Math.round(g2 * 255)},${Math.round(b6 * 255)})`;
  }
  offsetHSL(h2, s2, l2) {
    this.getHSL(_hslA);
    return this.setHSL(_hslA.h + h2, _hslA.s + s2, _hslA.l + l2);
  }
  add(color) {
    this.r += color.r;
    this.g += color.g;
    this.b += color.b;
    return this;
  }
  addColors(color1, color2) {
    this.r = color1.r + color2.r;
    this.g = color1.g + color2.g;
    this.b = color1.b + color2.b;
    return this;
  }
  addScalar(s2) {
    this.r += s2;
    this.g += s2;
    this.b += s2;
    return this;
  }
  sub(color) {
    this.r = Math.max(0, this.r - color.r);
    this.g = Math.max(0, this.g - color.g);
    this.b = Math.max(0, this.b - color.b);
    return this;
  }
  multiply(color) {
    this.r *= color.r;
    this.g *= color.g;
    this.b *= color.b;
    return this;
  }
  multiplyScalar(s2) {
    this.r *= s2;
    this.g *= s2;
    this.b *= s2;
    return this;
  }
  lerp(color, alpha) {
    this.r += (color.r - this.r) * alpha;
    this.g += (color.g - this.g) * alpha;
    this.b += (color.b - this.b) * alpha;
    return this;
  }
  lerpColors(color1, color2, alpha) {
    this.r = color1.r + (color2.r - color1.r) * alpha;
    this.g = color1.g + (color2.g - color1.g) * alpha;
    this.b = color1.b + (color2.b - color1.b) * alpha;
    return this;
  }
  lerpHSL(color, alpha) {
    this.getHSL(_hslA);
    color.getHSL(_hslB);
    const h2 = lerp(_hslA.h, _hslB.h, alpha);
    const s2 = lerp(_hslA.s, _hslB.s, alpha);
    const l2 = lerp(_hslA.l, _hslB.l, alpha);
    this.setHSL(h2, s2, l2);
    return this;
  }
  setFromVector3(v3) {
    this.r = v3.x;
    this.g = v3.y;
    this.b = v3.z;
    return this;
  }
  applyMatrix3(m2) {
    const r3 = this.r, g2 = this.g, b6 = this.b;
    const e2 = m2.elements;
    this.r = e2[0] * r3 + e2[3] * g2 + e2[6] * b6;
    this.g = e2[1] * r3 + e2[4] * g2 + e2[7] * b6;
    this.b = e2[2] * r3 + e2[5] * g2 + e2[8] * b6;
    return this;
  }
  equals(c2) {
    return c2.r === this.r && c2.g === this.g && c2.b === this.b;
  }
  fromArray(array, offset = 0) {
    this.r = array[offset];
    this.g = array[offset + 1];
    this.b = array[offset + 2];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.r;
    array[offset + 1] = this.g;
    array[offset + 2] = this.b;
    return array;
  }
  fromBufferAttribute(attribute, index) {
    this.r = attribute.getX(index);
    this.g = attribute.getY(index);
    this.b = attribute.getZ(index);
    return this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r;
    yield this.g;
    yield this.b;
  }
}
const _color = /* @__PURE__ */ new Color();
Color.NAMES = _colorKeywords;
let _materialId = 0;
class Material extends EventDispatcher$2 {
  constructor() {
    super();
    this.isMaterial = true;
    Object.defineProperty(this, "id", { value: _materialId++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.type = "Material";
    this.blending = NormalBlending;
    this.side = FrontSide;
    this.vertexColors = false;
    this.opacity = 1;
    this.transparent = false;
    this.alphaHash = false;
    this.blendSrc = SrcAlphaFactor;
    this.blendDst = OneMinusSrcAlphaFactor;
    this.blendEquation = AddEquation;
    this.blendSrcAlpha = null;
    this.blendDstAlpha = null;
    this.blendEquationAlpha = null;
    this.blendColor = new Color(0, 0, 0);
    this.blendAlpha = 0;
    this.depthFunc = LessEqualDepth;
    this.depthTest = true;
    this.depthWrite = true;
    this.stencilWriteMask = 255;
    this.stencilFunc = AlwaysStencilFunc;
    this.stencilRef = 0;
    this.stencilFuncMask = 255;
    this.stencilFail = KeepStencilOp;
    this.stencilZFail = KeepStencilOp;
    this.stencilZPass = KeepStencilOp;
    this.stencilWrite = false;
    this.clippingPlanes = null;
    this.clipIntersection = false;
    this.clipShadows = false;
    this.shadowSide = null;
    this.colorWrite = true;
    this.precision = null;
    this.polygonOffset = false;
    this.polygonOffsetFactor = 0;
    this.polygonOffsetUnits = 0;
    this.dithering = false;
    this.alphaToCoverage = false;
    this.premultipliedAlpha = false;
    this.forceSinglePass = false;
    this.visible = true;
    this.toneMapped = true;
    this.userData = {};
    this.version = 0;
    this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(value) {
    if (this._alphaTest > 0 !== value > 0) {
      this.version++;
    }
    this._alphaTest = value;
  }
  // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
  onBeforeRender() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(values) {
    if (values === void 0) return;
    for (const key in values) {
      const newValue = values[key];
      if (newValue === void 0) {
        console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
        continue;
      }
      const currentValue = this[key];
      if (currentValue === void 0) {
        console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
        continue;
      }
      if (currentValue && currentValue.isColor) {
        currentValue.set(newValue);
      } else if (currentValue && currentValue.isVector3 && (newValue && newValue.isVector3)) {
        currentValue.copy(newValue);
      } else {
        this[key] = newValue;
      }
    }
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (isRootObject) {
      meta = {
        textures: {},
        images: {}
      };
    }
    const data = {
      metadata: {
        version: 4.6,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    data.uuid = this.uuid;
    data.type = this.type;
    if (this.name !== "") data.name = this.name;
    if (this.color && this.color.isColor) data.color = this.color.getHex();
    if (this.roughness !== void 0) data.roughness = this.roughness;
    if (this.metalness !== void 0) data.metalness = this.metalness;
    if (this.sheen !== void 0) data.sheen = this.sheen;
    if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
    if (this.sheenRoughness !== void 0) data.sheenRoughness = this.sheenRoughness;
    if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
    if (this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
    if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
    if (this.specularIntensity !== void 0) data.specularIntensity = this.specularIntensity;
    if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
    if (this.shininess !== void 0) data.shininess = this.shininess;
    if (this.clearcoat !== void 0) data.clearcoat = this.clearcoat;
    if (this.clearcoatRoughness !== void 0) data.clearcoatRoughness = this.clearcoatRoughness;
    if (this.clearcoatMap && this.clearcoatMap.isTexture) {
      data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
    }
    if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
      data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
    }
    if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
      data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
      data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
    }
    if (this.dispersion !== void 0) data.dispersion = this.dispersion;
    if (this.iridescence !== void 0) data.iridescence = this.iridescence;
    if (this.iridescenceIOR !== void 0) data.iridescenceIOR = this.iridescenceIOR;
    if (this.iridescenceThicknessRange !== void 0) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
    if (this.iridescenceMap && this.iridescenceMap.isTexture) {
      data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
    }
    if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) {
      data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
    }
    if (this.anisotropy !== void 0) data.anisotropy = this.anisotropy;
    if (this.anisotropyRotation !== void 0) data.anisotropyRotation = this.anisotropyRotation;
    if (this.anisotropyMap && this.anisotropyMap.isTexture) {
      data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
    }
    if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
    if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
    if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
    if (this.lightMap && this.lightMap.isTexture) {
      data.lightMap = this.lightMap.toJSON(meta).uuid;
      data.lightMapIntensity = this.lightMapIntensity;
    }
    if (this.aoMap && this.aoMap.isTexture) {
      data.aoMap = this.aoMap.toJSON(meta).uuid;
      data.aoMapIntensity = this.aoMapIntensity;
    }
    if (this.bumpMap && this.bumpMap.isTexture) {
      data.bumpMap = this.bumpMap.toJSON(meta).uuid;
      data.bumpScale = this.bumpScale;
    }
    if (this.normalMap && this.normalMap.isTexture) {
      data.normalMap = this.normalMap.toJSON(meta).uuid;
      data.normalMapType = this.normalMapType;
      data.normalScale = this.normalScale.toArray();
    }
    if (this.displacementMap && this.displacementMap.isTexture) {
      data.displacementMap = this.displacementMap.toJSON(meta).uuid;
      data.displacementScale = this.displacementScale;
      data.displacementBias = this.displacementBias;
    }
    if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
    if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
    if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
    if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
    if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
    if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
    if (this.envMap && this.envMap.isTexture) {
      data.envMap = this.envMap.toJSON(meta).uuid;
      if (this.combine !== void 0) data.combine = this.combine;
    }
    if (this.envMapRotation !== void 0) data.envMapRotation = this.envMapRotation.toArray();
    if (this.envMapIntensity !== void 0) data.envMapIntensity = this.envMapIntensity;
    if (this.reflectivity !== void 0) data.reflectivity = this.reflectivity;
    if (this.refractionRatio !== void 0) data.refractionRatio = this.refractionRatio;
    if (this.gradientMap && this.gradientMap.isTexture) {
      data.gradientMap = this.gradientMap.toJSON(meta).uuid;
    }
    if (this.transmission !== void 0) data.transmission = this.transmission;
    if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
    if (this.thickness !== void 0) data.thickness = this.thickness;
    if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
    if (this.attenuationDistance !== void 0 && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
    if (this.attenuationColor !== void 0) data.attenuationColor = this.attenuationColor.getHex();
    if (this.size !== void 0) data.size = this.size;
    if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
    if (this.sizeAttenuation !== void 0) data.sizeAttenuation = this.sizeAttenuation;
    if (this.blending !== NormalBlending) data.blending = this.blending;
    if (this.side !== FrontSide) data.side = this.side;
    if (this.vertexColors === true) data.vertexColors = true;
    if (this.opacity < 1) data.opacity = this.opacity;
    if (this.transparent === true) data.transparent = true;
    if (this.blendSrc !== SrcAlphaFactor) data.blendSrc = this.blendSrc;
    if (this.blendDst !== OneMinusSrcAlphaFactor) data.blendDst = this.blendDst;
    if (this.blendEquation !== AddEquation) data.blendEquation = this.blendEquation;
    if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
    if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
    if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
    if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
    if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
    if (this.depthFunc !== LessEqualDepth) data.depthFunc = this.depthFunc;
    if (this.depthTest === false) data.depthTest = this.depthTest;
    if (this.depthWrite === false) data.depthWrite = this.depthWrite;
    if (this.colorWrite === false) data.colorWrite = this.colorWrite;
    if (this.stencilWriteMask !== 255) data.stencilWriteMask = this.stencilWriteMask;
    if (this.stencilFunc !== AlwaysStencilFunc) data.stencilFunc = this.stencilFunc;
    if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
    if (this.stencilFuncMask !== 255) data.stencilFuncMask = this.stencilFuncMask;
    if (this.stencilFail !== KeepStencilOp) data.stencilFail = this.stencilFail;
    if (this.stencilZFail !== KeepStencilOp) data.stencilZFail = this.stencilZFail;
    if (this.stencilZPass !== KeepStencilOp) data.stencilZPass = this.stencilZPass;
    if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
    if (this.rotation !== void 0 && this.rotation !== 0) data.rotation = this.rotation;
    if (this.polygonOffset === true) data.polygonOffset = true;
    if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
    if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
    if (this.linewidth !== void 0 && this.linewidth !== 1) data.linewidth = this.linewidth;
    if (this.dashSize !== void 0) data.dashSize = this.dashSize;
    if (this.gapSize !== void 0) data.gapSize = this.gapSize;
    if (this.scale !== void 0) data.scale = this.scale;
    if (this.dithering === true) data.dithering = true;
    if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
    if (this.alphaHash === true) data.alphaHash = true;
    if (this.alphaToCoverage === true) data.alphaToCoverage = true;
    if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
    if (this.forceSinglePass === true) data.forceSinglePass = true;
    if (this.wireframe === true) data.wireframe = true;
    if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
    if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
    if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
    if (this.flatShading === true) data.flatShading = true;
    if (this.visible === false) data.visible = false;
    if (this.toneMapped === false) data.toneMapped = false;
    if (this.fog === false) data.fog = false;
    if (Object.keys(this.userData).length > 0) data.userData = this.userData;
    function extractFromCache(cache) {
      const values = [];
      for (const key in cache) {
        const data2 = cache[key];
        delete data2.metadata;
        values.push(data2);
      }
      return values;
    }
    if (isRootObject) {
      const textures = extractFromCache(meta.textures);
      const images = extractFromCache(meta.images);
      if (textures.length > 0) data.textures = textures;
      if (images.length > 0) data.images = images;
    }
    return data;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.blending = source.blending;
    this.side = source.side;
    this.vertexColors = source.vertexColors;
    this.opacity = source.opacity;
    this.transparent = source.transparent;
    this.blendSrc = source.blendSrc;
    this.blendDst = source.blendDst;
    this.blendEquation = source.blendEquation;
    this.blendSrcAlpha = source.blendSrcAlpha;
    this.blendDstAlpha = source.blendDstAlpha;
    this.blendEquationAlpha = source.blendEquationAlpha;
    this.blendColor.copy(source.blendColor);
    this.blendAlpha = source.blendAlpha;
    this.depthFunc = source.depthFunc;
    this.depthTest = source.depthTest;
    this.depthWrite = source.depthWrite;
    this.stencilWriteMask = source.stencilWriteMask;
    this.stencilFunc = source.stencilFunc;
    this.stencilRef = source.stencilRef;
    this.stencilFuncMask = source.stencilFuncMask;
    this.stencilFail = source.stencilFail;
    this.stencilZFail = source.stencilZFail;
    this.stencilZPass = source.stencilZPass;
    this.stencilWrite = source.stencilWrite;
    const srcPlanes = source.clippingPlanes;
    let dstPlanes = null;
    if (srcPlanes !== null) {
      const n2 = srcPlanes.length;
      dstPlanes = new Array(n2);
      for (let i2 = 0; i2 !== n2; ++i2) {
        dstPlanes[i2] = srcPlanes[i2].clone();
      }
    }
    this.clippingPlanes = dstPlanes;
    this.clipIntersection = source.clipIntersection;
    this.clipShadows = source.clipShadows;
    this.shadowSide = source.shadowSide;
    this.colorWrite = source.colorWrite;
    this.precision = source.precision;
    this.polygonOffset = source.polygonOffset;
    this.polygonOffsetFactor = source.polygonOffsetFactor;
    this.polygonOffsetUnits = source.polygonOffsetUnits;
    this.dithering = source.dithering;
    this.alphaTest = source.alphaTest;
    this.alphaHash = source.alphaHash;
    this.alphaToCoverage = source.alphaToCoverage;
    this.premultipliedAlpha = source.premultipliedAlpha;
    this.forceSinglePass = source.forceSinglePass;
    this.visible = source.visible;
    this.toneMapped = source.toneMapped;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  onBuild() {
    console.warn("Material: onBuild() has been removed.");
  }
}
class MeshBasicMaterial extends Material {
  constructor(parameters) {
    super();
    this.isMeshBasicMaterial = true;
    this.type = "MeshBasicMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new Euler();
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapRotation.copy(source.envMapRotation);
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.fog = source.fog;
    return this;
  }
}
const _tables = /* @__PURE__ */ _generateTables();
function _generateTables() {
  const buffer = new ArrayBuffer(4);
  const floatView = new Float32Array(buffer);
  const uint32View = new Uint32Array(buffer);
  const baseTable = new Uint32Array(512);
  const shiftTable = new Uint32Array(512);
  for (let i2 = 0; i2 < 256; ++i2) {
    const e2 = i2 - 127;
    if (e2 < -27) {
      baseTable[i2] = 0;
      baseTable[i2 | 256] = 32768;
      shiftTable[i2] = 24;
      shiftTable[i2 | 256] = 24;
    } else if (e2 < -14) {
      baseTable[i2] = 1024 >> -e2 - 14;
      baseTable[i2 | 256] = 1024 >> -e2 - 14 | 32768;
      shiftTable[i2] = -e2 - 1;
      shiftTable[i2 | 256] = -e2 - 1;
    } else if (e2 <= 15) {
      baseTable[i2] = e2 + 15 << 10;
      baseTable[i2 | 256] = e2 + 15 << 10 | 32768;
      shiftTable[i2] = 13;
      shiftTable[i2 | 256] = 13;
    } else if (e2 < 128) {
      baseTable[i2] = 31744;
      baseTable[i2 | 256] = 64512;
      shiftTable[i2] = 24;
      shiftTable[i2 | 256] = 24;
    } else {
      baseTable[i2] = 31744;
      baseTable[i2 | 256] = 64512;
      shiftTable[i2] = 13;
      shiftTable[i2 | 256] = 13;
    }
  }
  const mantissaTable = new Uint32Array(2048);
  const exponentTable = new Uint32Array(64);
  const offsetTable = new Uint32Array(64);
  for (let i2 = 1; i2 < 1024; ++i2) {
    let m2 = i2 << 13;
    let e2 = 0;
    while ((m2 & 8388608) === 0) {
      m2 <<= 1;
      e2 -= 8388608;
    }
    m2 &= -8388609;
    e2 += 947912704;
    mantissaTable[i2] = m2 | e2;
  }
  for (let i2 = 1024; i2 < 2048; ++i2) {
    mantissaTable[i2] = 939524096 + (i2 - 1024 << 13);
  }
  for (let i2 = 1; i2 < 31; ++i2) {
    exponentTable[i2] = i2 << 23;
  }
  exponentTable[31] = 1199570944;
  exponentTable[32] = 2147483648;
  for (let i2 = 33; i2 < 63; ++i2) {
    exponentTable[i2] = 2147483648 + (i2 - 32 << 23);
  }
  exponentTable[63] = 3347054592;
  for (let i2 = 1; i2 < 64; ++i2) {
    if (i2 !== 32) {
      offsetTable[i2] = 1024;
    }
  }
  return {
    floatView,
    uint32View,
    baseTable,
    shiftTable,
    mantissaTable,
    exponentTable,
    offsetTable
  };
}
function toHalfFloat(val) {
  if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
  val = clamp$4(val, -65504, 65504);
  _tables.floatView[0] = val;
  const f2 = _tables.uint32View[0];
  const e2 = f2 >> 23 & 511;
  return _tables.baseTable[e2] + ((f2 & 8388607) >> _tables.shiftTable[e2]);
}
function fromHalfFloat(val) {
  const m2 = val >> 10;
  _tables.uint32View[0] = _tables.mantissaTable[_tables.offsetTable[m2] + (val & 1023)] + _tables.exponentTable[m2];
  return _tables.floatView[0];
}
const DataUtils = {
  toHalfFloat,
  fromHalfFloat
};
const _vector$9 = /* @__PURE__ */ new Vector3();
const _vector2$1 = /* @__PURE__ */ new Vector2();
let _id$2 = 0;
class BufferAttribute {
  constructor(array, itemSize, normalized = false) {
    if (Array.isArray(array)) {
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    }
    this.isBufferAttribute = true;
    Object.defineProperty(this, "id", { value: _id$2++ });
    this.name = "";
    this.array = array;
    this.itemSize = itemSize;
    this.count = array !== void 0 ? array.length / itemSize : 0;
    this.normalized = normalized;
    this.usage = StaticDrawUsage;
    this.updateRanges = [];
    this.gpuType = FloatType;
    this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  addUpdateRange(start2, count) {
    this.updateRanges.push({ start: start2, count });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(source) {
    this.name = source.name;
    this.array = new source.array.constructor(source.array);
    this.itemSize = source.itemSize;
    this.count = source.count;
    this.normalized = source.normalized;
    this.usage = source.usage;
    this.gpuType = source.gpuType;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.itemSize;
    index2 *= attribute.itemSize;
    for (let i2 = 0, l2 = this.itemSize; i2 < l2; i2++) {
      this.array[index1 + i2] = attribute.array[index2 + i2];
    }
    return this;
  }
  copyArray(array) {
    this.array.set(array);
    return this;
  }
  applyMatrix3(m2) {
    if (this.itemSize === 2) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector2$1.fromBufferAttribute(this, i2);
        _vector2$1.applyMatrix3(m2);
        this.setXY(i2, _vector2$1.x, _vector2$1.y);
      }
    } else if (this.itemSize === 3) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector$9.fromBufferAttribute(this, i2);
        _vector$9.applyMatrix3(m2);
        this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
      }
    }
    return this;
  }
  applyMatrix4(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9.fromBufferAttribute(this, i2);
      _vector$9.applyMatrix4(m2);
      this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  applyNormalMatrix(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9.fromBufferAttribute(this, i2);
      _vector$9.applyNormalMatrix(m2);
      this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  transformDirection(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9.fromBufferAttribute(this, i2);
      _vector$9.transformDirection(m2);
      this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  getComponent(index, component) {
    let value = this.array[index * this.itemSize + component];
    if (this.normalized) value = denormalize(value, this.array);
    return value;
  }
  setComponent(index, component, value) {
    if (this.normalized) value = normalize$1(value, this.array);
    this.array[index * this.itemSize + component] = value;
    return this;
  }
  getX(index) {
    let x3 = this.array[index * this.itemSize];
    if (this.normalized) x3 = denormalize(x3, this.array);
    return x3;
  }
  setX(index, x3) {
    if (this.normalized) x3 = normalize$1(x3, this.array);
    this.array[index * this.itemSize] = x3;
    return this;
  }
  getY(index) {
    let y2 = this.array[index * this.itemSize + 1];
    if (this.normalized) y2 = denormalize(y2, this.array);
    return y2;
  }
  setY(index, y2) {
    if (this.normalized) y2 = normalize$1(y2, this.array);
    this.array[index * this.itemSize + 1] = y2;
    return this;
  }
  getZ(index) {
    let z2 = this.array[index * this.itemSize + 2];
    if (this.normalized) z2 = denormalize(z2, this.array);
    return z2;
  }
  setZ(index, z2) {
    if (this.normalized) z2 = normalize$1(z2, this.array);
    this.array[index * this.itemSize + 2] = z2;
    return this;
  }
  getW(index) {
    let w2 = this.array[index * this.itemSize + 3];
    if (this.normalized) w2 = denormalize(w2, this.array);
    return w2;
  }
  setW(index, w2) {
    if (this.normalized) w2 = normalize$1(w2, this.array);
    this.array[index * this.itemSize + 3] = w2;
    return this;
  }
  setXY(index, x3, y2) {
    index *= this.itemSize;
    if (this.normalized) {
      x3 = normalize$1(x3, this.array);
      y2 = normalize$1(y2, this.array);
    }
    this.array[index + 0] = x3;
    this.array[index + 1] = y2;
    return this;
  }
  setXYZ(index, x3, y2, z2) {
    index *= this.itemSize;
    if (this.normalized) {
      x3 = normalize$1(x3, this.array);
      y2 = normalize$1(y2, this.array);
      z2 = normalize$1(z2, this.array);
    }
    this.array[index + 0] = x3;
    this.array[index + 1] = y2;
    this.array[index + 2] = z2;
    return this;
  }
  setXYZW(index, x3, y2, z2, w2) {
    index *= this.itemSize;
    if (this.normalized) {
      x3 = normalize$1(x3, this.array);
      y2 = normalize$1(y2, this.array);
      z2 = normalize$1(z2, this.array);
      w2 = normalize$1(w2, this.array);
    }
    this.array[index + 0] = x3;
    this.array[index + 1] = y2;
    this.array[index + 2] = z2;
    this.array[index + 3] = w2;
    return this;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const data = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    if (this.name !== "") data.name = this.name;
    if (this.usage !== StaticDrawUsage) data.usage = this.usage;
    return data;
  }
}
class Int8BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Int8Array(array), itemSize, normalized);
  }
}
class Uint8BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Uint8Array(array), itemSize, normalized);
  }
}
class Uint8ClampedBufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Uint8ClampedArray(array), itemSize, normalized);
  }
}
class Int16BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Int16Array(array), itemSize, normalized);
  }
}
class Uint16BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Uint16Array(array), itemSize, normalized);
  }
}
class Int32BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Int32Array(array), itemSize, normalized);
  }
}
class Uint32BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Uint32Array(array), itemSize, normalized);
  }
}
class Float16BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Uint16Array(array), itemSize, normalized);
    this.isFloat16BufferAttribute = true;
  }
  getX(index) {
    let x3 = fromHalfFloat(this.array[index * this.itemSize]);
    if (this.normalized) x3 = denormalize(x3, this.array);
    return x3;
  }
  setX(index, x3) {
    if (this.normalized) x3 = normalize$1(x3, this.array);
    this.array[index * this.itemSize] = toHalfFloat(x3);
    return this;
  }
  getY(index) {
    let y2 = fromHalfFloat(this.array[index * this.itemSize + 1]);
    if (this.normalized) y2 = denormalize(y2, this.array);
    return y2;
  }
  setY(index, y2) {
    if (this.normalized) y2 = normalize$1(y2, this.array);
    this.array[index * this.itemSize + 1] = toHalfFloat(y2);
    return this;
  }
  getZ(index) {
    let z2 = fromHalfFloat(this.array[index * this.itemSize + 2]);
    if (this.normalized) z2 = denormalize(z2, this.array);
    return z2;
  }
  setZ(index, z2) {
    if (this.normalized) z2 = normalize$1(z2, this.array);
    this.array[index * this.itemSize + 2] = toHalfFloat(z2);
    return this;
  }
  getW(index) {
    let w2 = fromHalfFloat(this.array[index * this.itemSize + 3]);
    if (this.normalized) w2 = denormalize(w2, this.array);
    return w2;
  }
  setW(index, w2) {
    if (this.normalized) w2 = normalize$1(w2, this.array);
    this.array[index * this.itemSize + 3] = toHalfFloat(w2);
    return this;
  }
  setXY(index, x3, y2) {
    index *= this.itemSize;
    if (this.normalized) {
      x3 = normalize$1(x3, this.array);
      y2 = normalize$1(y2, this.array);
    }
    this.array[index + 0] = toHalfFloat(x3);
    this.array[index + 1] = toHalfFloat(y2);
    return this;
  }
  setXYZ(index, x3, y2, z2) {
    index *= this.itemSize;
    if (this.normalized) {
      x3 = normalize$1(x3, this.array);
      y2 = normalize$1(y2, this.array);
      z2 = normalize$1(z2, this.array);
    }
    this.array[index + 0] = toHalfFloat(x3);
    this.array[index + 1] = toHalfFloat(y2);
    this.array[index + 2] = toHalfFloat(z2);
    return this;
  }
  setXYZW(index, x3, y2, z2, w2) {
    index *= this.itemSize;
    if (this.normalized) {
      x3 = normalize$1(x3, this.array);
      y2 = normalize$1(y2, this.array);
      z2 = normalize$1(z2, this.array);
      w2 = normalize$1(w2, this.array);
    }
    this.array[index + 0] = toHalfFloat(x3);
    this.array[index + 1] = toHalfFloat(y2);
    this.array[index + 2] = toHalfFloat(z2);
    this.array[index + 3] = toHalfFloat(w2);
    return this;
  }
}
class Float32BufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized) {
    super(new Float32Array(array), itemSize, normalized);
  }
}
let _id$1 = 0;
const _m1$3 = /* @__PURE__ */ new Matrix4();
const _obj = /* @__PURE__ */ new Object3D();
const _offset = /* @__PURE__ */ new Vector3();
const _box$2 = /* @__PURE__ */ new Box3();
const _boxMorphTargets = /* @__PURE__ */ new Box3();
const _vector$8 = /* @__PURE__ */ new Vector3();
class BufferGeometry extends EventDispatcher$2 {
  constructor() {
    super();
    this.isBufferGeometry = true;
    Object.defineProperty(this, "id", { value: _id$1++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.type = "BufferGeometry";
    this.index = null;
    this.indirect = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.morphTargetsRelative = false;
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    this.drawRange = { start: 0, count: Infinity };
    this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(index) {
    if (Array.isArray(index)) {
      this.index = new (arrayNeedsUint32(index) ? Uint32BufferAttribute : Uint16BufferAttribute)(index, 1);
    } else {
      this.index = index;
    }
    return this;
  }
  setIndirect(indirect) {
    this.indirect = indirect;
    return this;
  }
  getIndirect() {
    return this.indirect;
  }
  getAttribute(name) {
    return this.attributes[name];
  }
  setAttribute(name, attribute) {
    this.attributes[name] = attribute;
    return this;
  }
  deleteAttribute(name) {
    delete this.attributes[name];
    return this;
  }
  hasAttribute(name) {
    return this.attributes[name] !== void 0;
  }
  addGroup(start2, count, materialIndex = 0) {
    this.groups.push({
      start: start2,
      count,
      materialIndex
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(start2, count) {
    this.drawRange.start = start2;
    this.drawRange.count = count;
  }
  applyMatrix4(matrix) {
    const position = this.attributes.position;
    if (position !== void 0) {
      position.applyMatrix4(matrix);
      position.needsUpdate = true;
    }
    const normal = this.attributes.normal;
    if (normal !== void 0) {
      const normalMatrix = new Matrix3().getNormalMatrix(matrix);
      normal.applyNormalMatrix(normalMatrix);
      normal.needsUpdate = true;
    }
    const tangent = this.attributes.tangent;
    if (tangent !== void 0) {
      tangent.transformDirection(matrix);
      tangent.needsUpdate = true;
    }
    if (this.boundingBox !== null) {
      this.computeBoundingBox();
    }
    if (this.boundingSphere !== null) {
      this.computeBoundingSphere();
    }
    return this;
  }
  applyQuaternion(q2) {
    _m1$3.makeRotationFromQuaternion(q2);
    this.applyMatrix4(_m1$3);
    return this;
  }
  rotateX(angle) {
    _m1$3.makeRotationX(angle);
    this.applyMatrix4(_m1$3);
    return this;
  }
  rotateY(angle) {
    _m1$3.makeRotationY(angle);
    this.applyMatrix4(_m1$3);
    return this;
  }
  rotateZ(angle) {
    _m1$3.makeRotationZ(angle);
    this.applyMatrix4(_m1$3);
    return this;
  }
  translate(x3, y2, z2) {
    _m1$3.makeTranslation(x3, y2, z2);
    this.applyMatrix4(_m1$3);
    return this;
  }
  scale(x3, y2, z2) {
    _m1$3.makeScale(x3, y2, z2);
    this.applyMatrix4(_m1$3);
    return this;
  }
  lookAt(vector) {
    _obj.lookAt(vector);
    _obj.updateMatrix();
    this.applyMatrix4(_obj.matrix);
    return this;
  }
  center() {
    this.computeBoundingBox();
    this.boundingBox.getCenter(_offset).negate();
    this.translate(_offset.x, _offset.y, _offset.z);
    return this;
  }
  setFromPoints(points) {
    const positionAttribute = this.getAttribute("position");
    if (positionAttribute === void 0) {
      const position = [];
      for (let i2 = 0, l2 = points.length; i2 < l2; i2++) {
        const point = points[i2];
        position.push(point.x, point.y, point.z || 0);
      }
      this.setAttribute("position", new Float32BufferAttribute(position, 3));
    } else {
      const l2 = Math.min(points.length, positionAttribute.count);
      for (let i2 = 0; i2 < l2; i2++) {
        const point = points[i2];
        positionAttribute.setXYZ(i2, point.x, point.y, point.z || 0);
      }
      if (points.length > positionAttribute.count) {
        console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.");
      }
      positionAttribute.needsUpdate = true;
    }
    return this;
  }
  computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Box3();
    }
    const position = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position && position.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this);
      this.boundingBox.set(
        new Vector3(-Infinity, -Infinity, -Infinity),
        new Vector3(Infinity, Infinity, Infinity)
      );
      return;
    }
    if (position !== void 0) {
      this.boundingBox.setFromBufferAttribute(position);
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          _box$2.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8.addVectors(this.boundingBox.min, _box$2.min);
            this.boundingBox.expandByPoint(_vector$8);
            _vector$8.addVectors(this.boundingBox.max, _box$2.max);
            this.boundingBox.expandByPoint(_vector$8);
          } else {
            this.boundingBox.expandByPoint(_box$2.min);
            this.boundingBox.expandByPoint(_box$2.max);
          }
        }
      }
    } else {
      this.boundingBox.makeEmpty();
    }
    if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeBoundingSphere() {
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere();
    }
    const position = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position && position.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this);
      this.boundingSphere.set(new Vector3(), Infinity);
      return;
    }
    if (position) {
      const center = this.boundingSphere.center;
      _box$2.setFromBufferAttribute(position);
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          _boxMorphTargets.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8.addVectors(_box$2.min, _boxMorphTargets.min);
            _box$2.expandByPoint(_vector$8);
            _vector$8.addVectors(_box$2.max, _boxMorphTargets.max);
            _box$2.expandByPoint(_vector$8);
          } else {
            _box$2.expandByPoint(_boxMorphTargets.min);
            _box$2.expandByPoint(_boxMorphTargets.max);
          }
        }
      }
      _box$2.getCenter(center);
      let maxRadiusSq = 0;
      for (let i2 = 0, il = position.count; i2 < il; i2++) {
        _vector$8.fromBufferAttribute(position, i2);
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
      }
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          const morphTargetsRelative = this.morphTargetsRelative;
          for (let j3 = 0, jl = morphAttribute.count; j3 < jl; j3++) {
            _vector$8.fromBufferAttribute(morphAttribute, j3);
            if (morphTargetsRelative) {
              _offset.fromBufferAttribute(position, j3);
              _vector$8.add(_offset);
            }
            maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
          }
        }
      }
      this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
      if (isNaN(this.boundingSphere.radius)) {
        console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
      }
    }
  }
  computeTangents() {
    const index = this.index;
    const attributes = this.attributes;
    if (index === null || attributes.position === void 0 || attributes.normal === void 0 || attributes.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const positionAttribute = attributes.position;
    const normalAttribute = attributes.normal;
    const uvAttribute = attributes.uv;
    if (this.hasAttribute("tangent") === false) {
      this.setAttribute("tangent", new BufferAttribute(new Float32Array(4 * positionAttribute.count), 4));
    }
    const tangentAttribute = this.getAttribute("tangent");
    const tan1 = [], tan2 = [];
    for (let i2 = 0; i2 < positionAttribute.count; i2++) {
      tan1[i2] = new Vector3();
      tan2[i2] = new Vector3();
    }
    const vA2 = new Vector3(), vB = new Vector3(), vC = new Vector3(), uvA = new Vector2(), uvB = new Vector2(), uvC = new Vector2(), sdir = new Vector3(), tdir = new Vector3();
    function handleTriangle(a5, b6, c2) {
      vA2.fromBufferAttribute(positionAttribute, a5);
      vB.fromBufferAttribute(positionAttribute, b6);
      vC.fromBufferAttribute(positionAttribute, c2);
      uvA.fromBufferAttribute(uvAttribute, a5);
      uvB.fromBufferAttribute(uvAttribute, b6);
      uvC.fromBufferAttribute(uvAttribute, c2);
      vB.sub(vA2);
      vC.sub(vA2);
      uvB.sub(uvA);
      uvC.sub(uvA);
      const r3 = 1 / (uvB.x * uvC.y - uvC.x * uvB.y);
      if (!isFinite(r3)) return;
      sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r3);
      tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r3);
      tan1[a5].add(sdir);
      tan1[b6].add(sdir);
      tan1[c2].add(sdir);
      tan2[a5].add(tdir);
      tan2[b6].add(tdir);
      tan2[c2].add(tdir);
    }
    let groups = this.groups;
    if (groups.length === 0) {
      groups = [{
        start: 0,
        count: index.count
      }];
    }
    for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
      const group = groups[i2];
      const start2 = group.start;
      const count = group.count;
      for (let j3 = start2, jl = start2 + count; j3 < jl; j3 += 3) {
        handleTriangle(
          index.getX(j3 + 0),
          index.getX(j3 + 1),
          index.getX(j3 + 2)
        );
      }
    }
    const tmp2 = new Vector3(), tmp22 = new Vector3();
    const n2 = new Vector3(), n22 = new Vector3();
    function handleVertex(v3) {
      n2.fromBufferAttribute(normalAttribute, v3);
      n22.copy(n2);
      const t2 = tan1[v3];
      tmp2.copy(t2);
      tmp2.sub(n2.multiplyScalar(n2.dot(t2))).normalize();
      tmp22.crossVectors(n22, t2);
      const test = tmp22.dot(tan2[v3]);
      const w2 = test < 0 ? -1 : 1;
      tangentAttribute.setXYZW(v3, tmp2.x, tmp2.y, tmp2.z, w2);
    }
    for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
      const group = groups[i2];
      const start2 = group.start;
      const count = group.count;
      for (let j3 = start2, jl = start2 + count; j3 < jl; j3 += 3) {
        handleVertex(index.getX(j3 + 0));
        handleVertex(index.getX(j3 + 1));
        handleVertex(index.getX(j3 + 2));
      }
    }
  }
  computeVertexNormals() {
    const index = this.index;
    const positionAttribute = this.getAttribute("position");
    if (positionAttribute !== void 0) {
      let normalAttribute = this.getAttribute("normal");
      if (normalAttribute === void 0) {
        normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
        this.setAttribute("normal", normalAttribute);
      } else {
        for (let i2 = 0, il = normalAttribute.count; i2 < il; i2++) {
          normalAttribute.setXYZ(i2, 0, 0, 0);
        }
      }
      const pA2 = new Vector3(), pB = new Vector3(), pC = new Vector3();
      const nA2 = new Vector3(), nB = new Vector3(), nC = new Vector3();
      const cb = new Vector3(), ab = new Vector3();
      if (index) {
        for (let i2 = 0, il = index.count; i2 < il; i2 += 3) {
          const vA2 = index.getX(i2 + 0);
          const vB = index.getX(i2 + 1);
          const vC = index.getX(i2 + 2);
          pA2.fromBufferAttribute(positionAttribute, vA2);
          pB.fromBufferAttribute(positionAttribute, vB);
          pC.fromBufferAttribute(positionAttribute, vC);
          cb.subVectors(pC, pB);
          ab.subVectors(pA2, pB);
          cb.cross(ab);
          nA2.fromBufferAttribute(normalAttribute, vA2);
          nB.fromBufferAttribute(normalAttribute, vB);
          nC.fromBufferAttribute(normalAttribute, vC);
          nA2.add(cb);
          nB.add(cb);
          nC.add(cb);
          normalAttribute.setXYZ(vA2, nA2.x, nA2.y, nA2.z);
          normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
          normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
        }
      } else {
        for (let i2 = 0, il = positionAttribute.count; i2 < il; i2 += 3) {
          pA2.fromBufferAttribute(positionAttribute, i2 + 0);
          pB.fromBufferAttribute(positionAttribute, i2 + 1);
          pC.fromBufferAttribute(positionAttribute, i2 + 2);
          cb.subVectors(pC, pB);
          ab.subVectors(pA2, pB);
          cb.cross(ab);
          normalAttribute.setXYZ(i2 + 0, cb.x, cb.y, cb.z);
          normalAttribute.setXYZ(i2 + 1, cb.x, cb.y, cb.z);
          normalAttribute.setXYZ(i2 + 2, cb.x, cb.y, cb.z);
        }
      }
      this.normalizeNormals();
      normalAttribute.needsUpdate = true;
    }
  }
  normalizeNormals() {
    const normals = this.attributes.normal;
    for (let i2 = 0, il = normals.count; i2 < il; i2++) {
      _vector$8.fromBufferAttribute(normals, i2);
      _vector$8.normalize();
      normals.setXYZ(i2, _vector$8.x, _vector$8.y, _vector$8.z);
    }
  }
  toNonIndexed() {
    function convertBufferAttribute(attribute, indices2) {
      const array = attribute.array;
      const itemSize = attribute.itemSize;
      const normalized = attribute.normalized;
      const array2 = new array.constructor(indices2.length * itemSize);
      let index = 0, index2 = 0;
      for (let i2 = 0, l2 = indices2.length; i2 < l2; i2++) {
        if (attribute.isInterleavedBufferAttribute) {
          index = indices2[i2] * attribute.data.stride + attribute.offset;
        } else {
          index = indices2[i2] * itemSize;
        }
        for (let j3 = 0; j3 < itemSize; j3++) {
          array2[index2++] = array[index++];
        }
      }
      return new BufferAttribute(array2, itemSize, normalized);
    }
    if (this.index === null) {
      console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
      return this;
    }
    const geometry2 = new BufferGeometry();
    const indices = this.index.array;
    const attributes = this.attributes;
    for (const name in attributes) {
      const attribute = attributes[name];
      const newAttribute = convertBufferAttribute(attribute, indices);
      geometry2.setAttribute(name, newAttribute);
    }
    const morphAttributes = this.morphAttributes;
    for (const name in morphAttributes) {
      const morphArray = [];
      const morphAttribute = morphAttributes[name];
      for (let i2 = 0, il = morphAttribute.length; i2 < il; i2++) {
        const attribute = morphAttribute[i2];
        const newAttribute = convertBufferAttribute(attribute, indices);
        morphArray.push(newAttribute);
      }
      geometry2.morphAttributes[name] = morphArray;
    }
    geometry2.morphTargetsRelative = this.morphTargetsRelative;
    const groups = this.groups;
    for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
      const group = groups[i2];
      geometry2.addGroup(group.start, group.count, group.materialIndex);
    }
    return geometry2;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    data.uuid = this.uuid;
    data.type = this.type;
    if (this.name !== "") data.name = this.name;
    if (Object.keys(this.userData).length > 0) data.userData = this.userData;
    if (this.parameters !== void 0) {
      const parameters = this.parameters;
      for (const key in parameters) {
        if (parameters[key] !== void 0) data[key] = parameters[key];
      }
      return data;
    }
    data.data = { attributes: {} };
    const index = this.index;
    if (index !== null) {
      data.data.index = {
        type: index.array.constructor.name,
        array: Array.prototype.slice.call(index.array)
      };
    }
    const attributes = this.attributes;
    for (const key in attributes) {
      const attribute = attributes[key];
      data.data.attributes[key] = attribute.toJSON(data.data);
    }
    const morphAttributes = {};
    let hasMorphAttributes = false;
    for (const key in this.morphAttributes) {
      const attributeArray = this.morphAttributes[key];
      const array = [];
      for (let i2 = 0, il = attributeArray.length; i2 < il; i2++) {
        const attribute = attributeArray[i2];
        array.push(attribute.toJSON(data.data));
      }
      if (array.length > 0) {
        morphAttributes[key] = array;
        hasMorphAttributes = true;
      }
    }
    if (hasMorphAttributes) {
      data.data.morphAttributes = morphAttributes;
      data.data.morphTargetsRelative = this.morphTargetsRelative;
    }
    const groups = this.groups;
    if (groups.length > 0) {
      data.data.groups = JSON.parse(JSON.stringify(groups));
    }
    const boundingSphere = this.boundingSphere;
    if (boundingSphere !== null) {
      data.data.boundingSphere = {
        center: boundingSphere.center.toArray(),
        radius: boundingSphere.radius
      };
    }
    return data;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    const data = {};
    this.name = source.name;
    const index = source.index;
    if (index !== null) {
      this.setIndex(index.clone(data));
    }
    const attributes = source.attributes;
    for (const name in attributes) {
      const attribute = attributes[name];
      this.setAttribute(name, attribute.clone(data));
    }
    const morphAttributes = source.morphAttributes;
    for (const name in morphAttributes) {
      const array = [];
      const morphAttribute = morphAttributes[name];
      for (let i2 = 0, l2 = morphAttribute.length; i2 < l2; i2++) {
        array.push(morphAttribute[i2].clone(data));
      }
      this.morphAttributes[name] = array;
    }
    this.morphTargetsRelative = source.morphTargetsRelative;
    const groups = source.groups;
    for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
      const group = groups[i2];
      this.addGroup(group.start, group.count, group.materialIndex);
    }
    const boundingBox = source.boundingBox;
    if (boundingBox !== null) {
      this.boundingBox = boundingBox.clone();
    }
    const boundingSphere = source.boundingSphere;
    if (boundingSphere !== null) {
      this.boundingSphere = boundingSphere.clone();
    }
    this.drawRange.start = source.drawRange.start;
    this.drawRange.count = source.drawRange.count;
    this.userData = source.userData;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const _inverseMatrix$3 = /* @__PURE__ */ new Matrix4();
const _ray$3 = /* @__PURE__ */ new Ray();
const _sphere$6 = /* @__PURE__ */ new Sphere();
const _sphereHitAt = /* @__PURE__ */ new Vector3();
const _vA$1 = /* @__PURE__ */ new Vector3();
const _vB$1 = /* @__PURE__ */ new Vector3();
const _vC$1 = /* @__PURE__ */ new Vector3();
const _tempA = /* @__PURE__ */ new Vector3();
const _morphA = /* @__PURE__ */ new Vector3();
const _intersectionPoint = /* @__PURE__ */ new Vector3();
const _intersectionPointWorld = /* @__PURE__ */ new Vector3();
class Mesh extends Object3D {
  constructor(geometry = new BufferGeometry(), material = new MeshBasicMaterial()) {
    super();
    this.isMesh = true;
    this.type = "Mesh";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.morphTargetInfluences !== void 0) {
      this.morphTargetInfluences = source.morphTargetInfluences.slice();
    }
    if (source.morphTargetDictionary !== void 0) {
      this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
    }
    this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
    this.geometry = source.geometry;
    return this;
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    const morphAttributes = geometry.morphAttributes;
    const keys = Object.keys(morphAttributes);
    if (keys.length > 0) {
      const morphAttribute = morphAttributes[keys[0]];
      if (morphAttribute !== void 0) {
        this.morphTargetInfluences = [];
        this.morphTargetDictionary = {};
        for (let m2 = 0, ml = morphAttribute.length; m2 < ml; m2++) {
          const name = morphAttribute[m2].name || String(m2);
          this.morphTargetInfluences.push(0);
          this.morphTargetDictionary[name] = m2;
        }
      }
    }
  }
  getVertexPosition(index, target) {
    const geometry = this.geometry;
    const position = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    target.fromBufferAttribute(position, index);
    const morphInfluences = this.morphTargetInfluences;
    if (morphPosition && morphInfluences) {
      _morphA.set(0, 0, 0);
      for (let i2 = 0, il = morphPosition.length; i2 < il; i2++) {
        const influence = morphInfluences[i2];
        const morphAttribute = morphPosition[i2];
        if (influence === 0) continue;
        _tempA.fromBufferAttribute(morphAttribute, index);
        if (morphTargetsRelative) {
          _morphA.addScaledVector(_tempA, influence);
        } else {
          _morphA.addScaledVector(_tempA.sub(target), influence);
        }
      }
      target.add(_morphA);
    }
    return target;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const material = this.material;
    const matrixWorld = this.matrixWorld;
    if (material === void 0) return;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$6.copy(geometry.boundingSphere);
    _sphere$6.applyMatrix4(matrixWorld);
    _ray$3.copy(raycaster.ray).recast(raycaster.near);
    if (_sphere$6.containsPoint(_ray$3.origin) === false) {
      if (_ray$3.intersectSphere(_sphere$6, _sphereHitAt) === null) return;
      if (_ray$3.origin.distanceToSquared(_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
    }
    _inverseMatrix$3.copy(matrixWorld).invert();
    _ray$3.copy(raycaster.ray).applyMatrix4(_inverseMatrix$3);
    if (geometry.boundingBox !== null) {
      if (_ray$3.intersectsBox(geometry.boundingBox) === false) return;
    }
    this._computeIntersections(raycaster, intersects2, _ray$3);
  }
  _computeIntersections(raycaster, intersects2, rayLocalSpace) {
    let intersection;
    const geometry = this.geometry;
    const material = this.material;
    const index = geometry.index;
    const position = geometry.attributes.position;
    const uv = geometry.attributes.uv;
    const uv1 = geometry.attributes.uv1;
    const normal = geometry.attributes.normal;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    if (index !== null) {
      if (Array.isArray(material)) {
        for (let i2 = 0, il = groups.length; i2 < il; i2++) {
          const group = groups[i2];
          const groupMaterial = material[group.materialIndex];
          const start2 = Math.max(group.start, drawRange.start);
          const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
          for (let j3 = start2, jl = end; j3 < jl; j3 += 3) {
            const a5 = index.getX(j3);
            const b6 = index.getX(j3 + 1);
            const c2 = index.getX(j3 + 2);
            intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a5, b6, c2);
            if (intersection) {
              intersection.faceIndex = Math.floor(j3 / 3);
              intersection.face.materialIndex = group.materialIndex;
              intersects2.push(intersection);
            }
          }
        }
      } else {
        const start2 = Math.max(0, drawRange.start);
        const end = Math.min(index.count, drawRange.start + drawRange.count);
        for (let i2 = start2, il = end; i2 < il; i2 += 3) {
          const a5 = index.getX(i2);
          const b6 = index.getX(i2 + 1);
          const c2 = index.getX(i2 + 2);
          intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a5, b6, c2);
          if (intersection) {
            intersection.faceIndex = Math.floor(i2 / 3);
            intersects2.push(intersection);
          }
        }
      }
    } else if (position !== void 0) {
      if (Array.isArray(material)) {
        for (let i2 = 0, il = groups.length; i2 < il; i2++) {
          const group = groups[i2];
          const groupMaterial = material[group.materialIndex];
          const start2 = Math.max(group.start, drawRange.start);
          const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
          for (let j3 = start2, jl = end; j3 < jl; j3 += 3) {
            const a5 = j3;
            const b6 = j3 + 1;
            const c2 = j3 + 2;
            intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a5, b6, c2);
            if (intersection) {
              intersection.faceIndex = Math.floor(j3 / 3);
              intersection.face.materialIndex = group.materialIndex;
              intersects2.push(intersection);
            }
          }
        }
      } else {
        const start2 = Math.max(0, drawRange.start);
        const end = Math.min(position.count, drawRange.start + drawRange.count);
        for (let i2 = start2, il = end; i2 < il; i2 += 3) {
          const a5 = i2;
          const b6 = i2 + 1;
          const c2 = i2 + 2;
          intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a5, b6, c2);
          if (intersection) {
            intersection.faceIndex = Math.floor(i2 / 3);
            intersects2.push(intersection);
          }
        }
      }
    }
  }
}
function checkIntersection$1(object, material, raycaster, ray, pA2, pB, pC, point) {
  let intersect2;
  if (material.side === BackSide) {
    intersect2 = ray.intersectTriangle(pC, pB, pA2, true, point);
  } else {
    intersect2 = ray.intersectTriangle(pA2, pB, pC, material.side === FrontSide, point);
  }
  if (intersect2 === null) return null;
  _intersectionPointWorld.copy(point);
  _intersectionPointWorld.applyMatrix4(object.matrixWorld);
  const distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
  if (distance < raycaster.near || distance > raycaster.far) return null;
  return {
    distance,
    point: _intersectionPointWorld.clone(),
    object
  };
}
function checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a5, b6, c2) {
  object.getVertexPosition(a5, _vA$1);
  object.getVertexPosition(b6, _vB$1);
  object.getVertexPosition(c2, _vC$1);
  const intersection = checkIntersection$1(object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint);
  if (intersection) {
    const barycoord = new Vector3();
    Triangle.getBarycoord(_intersectionPoint, _vA$1, _vB$1, _vC$1, barycoord);
    if (uv) {
      intersection.uv = Triangle.getInterpolatedAttribute(uv, a5, b6, c2, barycoord, new Vector2());
    }
    if (uv1) {
      intersection.uv1 = Triangle.getInterpolatedAttribute(uv1, a5, b6, c2, barycoord, new Vector2());
    }
    if (normal) {
      intersection.normal = Triangle.getInterpolatedAttribute(normal, a5, b6, c2, barycoord, new Vector3());
      if (intersection.normal.dot(ray.direction) > 0) {
        intersection.normal.multiplyScalar(-1);
      }
    }
    const face = {
      a: a5,
      b: b6,
      c: c2,
      normal: new Vector3(),
      materialIndex: 0
    };
    Triangle.getNormal(_vA$1, _vB$1, _vC$1, face.normal);
    intersection.face = face;
    intersection.barycoord = barycoord;
  }
  return intersection;
}
class BoxGeometry extends BufferGeometry {
  constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1) {
    super();
    this.type = "BoxGeometry";
    this.parameters = {
      width,
      height,
      depth,
      widthSegments,
      heightSegments,
      depthSegments
    };
    const scope = this;
    widthSegments = Math.floor(widthSegments);
    heightSegments = Math.floor(heightSegments);
    depthSegments = Math.floor(depthSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let numberOfVertices = 0;
    let groupStart = 0;
    buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0);
    buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1);
    buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2);
    buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3);
    buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4);
    buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5);
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function buildPlane(u2, v3, w2, udir, vdir, width2, height2, depth2, gridX, gridY, materialIndex) {
      const segmentWidth = width2 / gridX;
      const segmentHeight = height2 / gridY;
      const widthHalf = width2 / 2;
      const heightHalf = height2 / 2;
      const depthHalf = depth2 / 2;
      const gridX1 = gridX + 1;
      const gridY1 = gridY + 1;
      let vertexCounter = 0;
      let groupCount = 0;
      const vector = new Vector3();
      for (let iy = 0; iy < gridY1; iy++) {
        const y2 = iy * segmentHeight - heightHalf;
        for (let ix = 0; ix < gridX1; ix++) {
          const x3 = ix * segmentWidth - widthHalf;
          vector[u2] = x3 * udir;
          vector[v3] = y2 * vdir;
          vector[w2] = depthHalf;
          vertices.push(vector.x, vector.y, vector.z);
          vector[u2] = 0;
          vector[v3] = 0;
          vector[w2] = depth2 > 0 ? 1 : -1;
          normals.push(vector.x, vector.y, vector.z);
          uvs.push(ix / gridX);
          uvs.push(1 - iy / gridY);
          vertexCounter += 1;
        }
      }
      for (let iy = 0; iy < gridY; iy++) {
        for (let ix = 0; ix < gridX; ix++) {
          const a5 = numberOfVertices + ix + gridX1 * iy;
          const b6 = numberOfVertices + ix + gridX1 * (iy + 1);
          const c2 = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
          const d3 = numberOfVertices + (ix + 1) + gridX1 * iy;
          indices.push(a5, b6, d3);
          indices.push(b6, c2, d3);
          groupCount += 6;
        }
      }
      scope.addGroup(groupStart, groupCount, materialIndex);
      groupStart += groupCount;
      numberOfVertices += vertexCounter;
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
  }
}
function cloneUniforms(src) {
  const dst = {};
  for (const u2 in src) {
    dst[u2] = {};
    for (const p3 in src[u2]) {
      const property = src[u2][p3];
      if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
        if (property.isRenderTargetTexture) {
          console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
          dst[u2][p3] = null;
        } else {
          dst[u2][p3] = property.clone();
        }
      } else if (Array.isArray(property)) {
        dst[u2][p3] = property.slice();
      } else {
        dst[u2][p3] = property;
      }
    }
  }
  return dst;
}
function mergeUniforms(uniforms) {
  const merged = {};
  for (let u2 = 0; u2 < uniforms.length; u2++) {
    const tmp2 = cloneUniforms(uniforms[u2]);
    for (const p3 in tmp2) {
      merged[p3] = tmp2[p3];
    }
  }
  return merged;
}
function cloneUniformsGroups(src) {
  const dst = [];
  for (let u2 = 0; u2 < src.length; u2++) {
    dst.push(src[u2].clone());
  }
  return dst;
}
function getUnlitUniformColorSpace(renderer) {
  const currentRenderTarget = renderer.getRenderTarget();
  if (currentRenderTarget === null) {
    return renderer.outputColorSpace;
  }
  if (currentRenderTarget.isXRRenderTarget === true) {
    return currentRenderTarget.texture.colorSpace;
  }
  return ColorManagement.workingColorSpace;
}
const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };
var default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class ShaderMaterial extends Material {
  constructor(parameters) {
    super();
    this.isShaderMaterial = true;
    this.type = "ShaderMaterial";
    this.defines = {};
    this.uniforms = {};
    this.uniformsGroups = [];
    this.vertexShader = default_vertex;
    this.fragmentShader = default_fragment;
    this.linewidth = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.lights = false;
    this.clipping = false;
    this.forceSinglePass = true;
    this.extensions = {
      clipCullDistance: false,
      // set to use vertex shader clipping
      multiDraw: false
      // set to use vertex shader multi_draw / enable gl_DrawID
    };
    this.defaultAttributeValues = {
      "color": [1, 1, 1],
      "uv": [0, 0],
      "uv1": [0, 0]
    };
    this.index0AttributeName = void 0;
    this.uniformsNeedUpdate = false;
    this.glslVersion = null;
    if (parameters !== void 0) {
      this.setValues(parameters);
    }
  }
  copy(source) {
    super.copy(source);
    this.fragmentShader = source.fragmentShader;
    this.vertexShader = source.vertexShader;
    this.uniforms = cloneUniforms(source.uniforms);
    this.uniformsGroups = cloneUniformsGroups(source.uniformsGroups);
    this.defines = Object.assign({}, source.defines);
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.fog = source.fog;
    this.lights = source.lights;
    this.clipping = source.clipping;
    this.extensions = Object.assign({}, source.extensions);
    this.glslVersion = source.glslVersion;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.glslVersion = this.glslVersion;
    data.uniforms = {};
    for (const name in this.uniforms) {
      const uniform = this.uniforms[name];
      const value = uniform.value;
      if (value && value.isTexture) {
        data.uniforms[name] = {
          type: "t",
          value: value.toJSON(meta).uuid
        };
      } else if (value && value.isColor) {
        data.uniforms[name] = {
          type: "c",
          value: value.getHex()
        };
      } else if (value && value.isVector2) {
        data.uniforms[name] = {
          type: "v2",
          value: value.toArray()
        };
      } else if (value && value.isVector3) {
        data.uniforms[name] = {
          type: "v3",
          value: value.toArray()
        };
      } else if (value && value.isVector4) {
        data.uniforms[name] = {
          type: "v4",
          value: value.toArray()
        };
      } else if (value && value.isMatrix3) {
        data.uniforms[name] = {
          type: "m3",
          value: value.toArray()
        };
      } else if (value && value.isMatrix4) {
        data.uniforms[name] = {
          type: "m4",
          value: value.toArray()
        };
      } else {
        data.uniforms[name] = {
          value
        };
      }
    }
    if (Object.keys(this.defines).length > 0) data.defines = this.defines;
    data.vertexShader = this.vertexShader;
    data.fragmentShader = this.fragmentShader;
    data.lights = this.lights;
    data.clipping = this.clipping;
    const extensions2 = {};
    for (const key in this.extensions) {
      if (this.extensions[key] === true) extensions2[key] = true;
    }
    if (Object.keys(extensions2).length > 0) data.extensions = extensions2;
    return data;
  }
}
class Camera extends Object3D {
  constructor() {
    super();
    this.isCamera = true;
    this.type = "Camera";
    this.matrixWorldInverse = new Matrix4();
    this.projectionMatrix = new Matrix4();
    this.projectionMatrixInverse = new Matrix4();
    this.coordinateSystem = WebGLCoordinateSystem;
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.matrixWorldInverse.copy(source.matrixWorldInverse);
    this.projectionMatrix.copy(source.projectionMatrix);
    this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
    this.coordinateSystem = source.coordinateSystem;
    return this;
  }
  getWorldDirection(target) {
    return super.getWorldDirection(target).negate();
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(updateParents, updateChildren) {
    super.updateWorldMatrix(updateParents, updateChildren);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _v3$1 = /* @__PURE__ */ new Vector3();
const _minTarget = /* @__PURE__ */ new Vector2();
const _maxTarget = /* @__PURE__ */ new Vector2();
class PerspectiveCamera extends Camera {
  constructor(fov2 = 50, aspect2 = 1, near = 0.1, far = 2e3) {
    super();
    this.isPerspectiveCamera = true;
    this.type = "PerspectiveCamera";
    this.fov = fov2;
    this.zoom = 1;
    this.near = near;
    this.far = far;
    this.focus = 10;
    this.aspect = aspect2;
    this.view = null;
    this.filmGauge = 35;
    this.filmOffset = 0;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.fov = source.fov;
    this.zoom = source.zoom;
    this.near = source.near;
    this.far = source.far;
    this.focus = source.focus;
    this.aspect = source.aspect;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    this.filmGauge = source.filmGauge;
    this.filmOffset = source.filmOffset;
    return this;
  }
  /**
   * Sets the FOV by focal length in respect to the current .filmGauge.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(focalLength) {
    const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
    this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
    this.updateProjectionMatrix();
  }
  /**
   * Calculates the focal length from the current .fov and .filmGauge.
   *
   * @returns {number}
   */
  getFocalLength() {
    const vExtentSlope = Math.tan(DEG2RAD$2 * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / vExtentSlope;
  }
  getEffectiveFOV() {
    return RAD2DEG * 2 * Math.atan(
      Math.tan(DEG2RAD$2 * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
   *
   * @param {number} distance
   * @param {Vector2} minTarget
   * @param {Vector2} maxTarget
   */
  getViewBounds(distance, minTarget, maxTarget) {
    _v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
    minTarget.set(_v3$1.x, _v3$1.y).multiplyScalar(-distance / _v3$1.z);
    _v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
    maxTarget.set(_v3$1.x, _v3$1.y).multiplyScalar(-distance / _v3$1.z);
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   *
   * @param {number} distance
   * @param {Vector2} target - Vector2 target used to store result where x is width and y is height.
   * @returns {Vector2}
   */
  getViewSize(distance, target) {
    this.getViewBounds(distance, _minTarget, _maxTarget);
    return target.subVectors(_maxTarget, _minTarget);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *
   * then for each monitor you would call it like this
   *
   *   const w = 1920;
   *   const h = 1080;
   *   const fullWidth = w * 3;
   *   const fullHeight = h * 2;
   *
   *   --A--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   *   --B--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   *   --C--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   *   --D--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   *   --E--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   *   --F--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   *
   *   Note there is no reason monitors have to be the same size or in a grid.
   *
   * @param {number} fullWidth
   * @param {number} fullHeight
   * @param {number} x
   * @param {number} y
   * @param {number} width
   * @param {number} height
   */
  setViewOffset(fullWidth, fullHeight, x3, y2, width, height) {
    this.aspect = fullWidth / fullHeight;
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x3;
    this.view.offsetY = y2;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const near = this.near;
    let top = near * Math.tan(DEG2RAD$2 * 0.5 * this.fov) / this.zoom;
    let height = 2 * top;
    let width = this.aspect * height;
    let left = -0.5 * width;
    const view = this.view;
    if (this.view !== null && this.view.enabled) {
      const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
      left += view.offsetX * width / fullWidth;
      top -= view.offsetY * height / fullHeight;
      width *= view.width / fullWidth;
      height *= view.height / fullHeight;
    }
    const skew = this.filmOffset;
    if (skew !== 0) left += near * skew / this.getFilmWidth();
    this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.fov = this.fov;
    data.object.zoom = this.zoom;
    data.object.near = this.near;
    data.object.far = this.far;
    data.object.focus = this.focus;
    data.object.aspect = this.aspect;
    if (this.view !== null) data.object.view = Object.assign({}, this.view);
    data.object.filmGauge = this.filmGauge;
    data.object.filmOffset = this.filmOffset;
    return data;
  }
}
const fov = -90;
const aspect = 1;
class CubeCamera extends Object3D {
  constructor(near, far, renderTarget) {
    super();
    this.type = "CubeCamera";
    this.renderTarget = renderTarget;
    this.coordinateSystem = null;
    this.activeMipmapLevel = 0;
    const cameraPX = new PerspectiveCamera(fov, aspect, near, far);
    cameraPX.layers = this.layers;
    this.add(cameraPX);
    const cameraNX = new PerspectiveCamera(fov, aspect, near, far);
    cameraNX.layers = this.layers;
    this.add(cameraNX);
    const cameraPY = new PerspectiveCamera(fov, aspect, near, far);
    cameraPY.layers = this.layers;
    this.add(cameraPY);
    const cameraNY = new PerspectiveCamera(fov, aspect, near, far);
    cameraNY.layers = this.layers;
    this.add(cameraNY);
    const cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraPZ.layers = this.layers;
    this.add(cameraPZ);
    const cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraNZ.layers = this.layers;
    this.add(cameraNZ);
  }
  updateCoordinateSystem() {
    const coordinateSystem = this.coordinateSystem;
    const cameras = this.children.concat();
    const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
    for (const camera of cameras) this.remove(camera);
    if (coordinateSystem === WebGLCoordinateSystem) {
      cameraPX.up.set(0, 1, 0);
      cameraPX.lookAt(1, 0, 0);
      cameraNX.up.set(0, 1, 0);
      cameraNX.lookAt(-1, 0, 0);
      cameraPY.up.set(0, 0, -1);
      cameraPY.lookAt(0, 1, 0);
      cameraNY.up.set(0, 0, 1);
      cameraNY.lookAt(0, -1, 0);
      cameraPZ.up.set(0, 1, 0);
      cameraPZ.lookAt(0, 0, 1);
      cameraNZ.up.set(0, 1, 0);
      cameraNZ.lookAt(0, 0, -1);
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      cameraPX.up.set(0, -1, 0);
      cameraPX.lookAt(-1, 0, 0);
      cameraNX.up.set(0, -1, 0);
      cameraNX.lookAt(1, 0, 0);
      cameraPY.up.set(0, 0, 1);
      cameraPY.lookAt(0, 1, 0);
      cameraNY.up.set(0, 0, -1);
      cameraNY.lookAt(0, -1, 0);
      cameraPZ.up.set(0, -1, 0);
      cameraPZ.lookAt(0, 0, 1);
      cameraNZ.up.set(0, -1, 0);
      cameraNZ.lookAt(0, 0, -1);
    } else {
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
    }
    for (const camera of cameras) {
      this.add(camera);
      camera.updateMatrixWorld();
    }
  }
  update(renderer, scene) {
    if (this.parent === null) this.updateMatrixWorld();
    const { renderTarget, activeMipmapLevel } = this;
    if (this.coordinateSystem !== renderer.coordinateSystem) {
      this.coordinateSystem = renderer.coordinateSystem;
      this.updateCoordinateSystem();
    }
    const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
    const currentRenderTarget = renderer.getRenderTarget();
    const currentActiveCubeFace = renderer.getActiveCubeFace();
    const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
    const currentXrEnabled = renderer.xr.enabled;
    renderer.xr.enabled = false;
    const generateMipmaps = renderTarget.texture.generateMipmaps;
    renderTarget.texture.generateMipmaps = false;
    renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
    renderer.render(scene, cameraPX);
    renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
    renderer.render(scene, cameraNX);
    renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
    renderer.render(scene, cameraPY);
    renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
    renderer.render(scene, cameraNY);
    renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
    renderer.render(scene, cameraPZ);
    renderTarget.texture.generateMipmaps = generateMipmaps;
    renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
    renderer.render(scene, cameraNZ);
    renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
    renderer.xr.enabled = currentXrEnabled;
    renderTarget.texture.needsPMREMUpdate = true;
  }
}
class CubeTexture extends Texture {
  constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace) {
    images = images !== void 0 ? images : [];
    mapping = mapping !== void 0 ? mapping : CubeReflectionMapping;
    super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
    this.isCubeTexture = true;
    this.flipY = false;
  }
  get images() {
    return this.image;
  }
  set images(value) {
    this.image = value;
  }
}
class WebGLCubeRenderTarget extends WebGLRenderTarget {
  constructor(size = 1, options = {}) {
    super(size, size, options);
    this.isWebGLCubeRenderTarget = true;
    const image = { width: size, height: size, depth: 1 };
    const images = [image, image, image, image, image, image];
    this.texture = new CubeTexture(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
    this.texture.isRenderTargetTexture = true;
    this.texture.generateMipmaps = options.generateMipmaps !== void 0 ? options.generateMipmaps : false;
    this.texture.minFilter = options.minFilter !== void 0 ? options.minFilter : LinearFilter;
  }
  fromEquirectangularTexture(renderer, texture) {
    this.texture.type = texture.type;
    this.texture.colorSpace = texture.colorSpace;
    this.texture.generateMipmaps = texture.generateMipmaps;
    this.texture.minFilter = texture.minFilter;
    this.texture.magFilter = texture.magFilter;
    const shader = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    };
    const geometry = new BoxGeometry(5, 5, 5);
    const material = new ShaderMaterial({
      name: "CubemapFromEquirect",
      uniforms: cloneUniforms(shader.uniforms),
      vertexShader: shader.vertexShader,
      fragmentShader: shader.fragmentShader,
      side: BackSide,
      blending: NoBlending
    });
    material.uniforms.tEquirect.value = texture;
    const mesh = new Mesh(geometry, material);
    const currentMinFilter = texture.minFilter;
    if (texture.minFilter === LinearMipmapLinearFilter) texture.minFilter = LinearFilter;
    const camera = new CubeCamera(1, 10, this);
    camera.update(renderer, mesh);
    texture.minFilter = currentMinFilter;
    mesh.geometry.dispose();
    mesh.material.dispose();
    return this;
  }
  clear(renderer, color, depth, stencil) {
    const currentRenderTarget = renderer.getRenderTarget();
    for (let i2 = 0; i2 < 6; i2++) {
      renderer.setRenderTarget(this, i2);
      renderer.clear(color, depth, stencil);
    }
    renderer.setRenderTarget(currentRenderTarget);
  }
}
class Group extends Object3D {
  constructor() {
    super();
    this.isGroup = true;
    this.type = "Group";
  }
}
const _moveEvent = { type: "move" };
class WebXRController {
  constructor() {
    this._targetRay = null;
    this._grip = null;
    this._hand = null;
  }
  getHandSpace() {
    if (this._hand === null) {
      this._hand = new Group();
      this._hand.matrixAutoUpdate = false;
      this._hand.visible = false;
      this._hand.joints = {};
      this._hand.inputState = { pinching: false };
    }
    return this._hand;
  }
  getTargetRaySpace() {
    if (this._targetRay === null) {
      this._targetRay = new Group();
      this._targetRay.matrixAutoUpdate = false;
      this._targetRay.visible = false;
      this._targetRay.hasLinearVelocity = false;
      this._targetRay.linearVelocity = new Vector3();
      this._targetRay.hasAngularVelocity = false;
      this._targetRay.angularVelocity = new Vector3();
    }
    return this._targetRay;
  }
  getGripSpace() {
    if (this._grip === null) {
      this._grip = new Group();
      this._grip.matrixAutoUpdate = false;
      this._grip.visible = false;
      this._grip.hasLinearVelocity = false;
      this._grip.linearVelocity = new Vector3();
      this._grip.hasAngularVelocity = false;
      this._grip.angularVelocity = new Vector3();
    }
    return this._grip;
  }
  dispatchEvent(event) {
    if (this._targetRay !== null) {
      this._targetRay.dispatchEvent(event);
    }
    if (this._grip !== null) {
      this._grip.dispatchEvent(event);
    }
    if (this._hand !== null) {
      this._hand.dispatchEvent(event);
    }
    return this;
  }
  connect(inputSource) {
    if (inputSource && inputSource.hand) {
      const hand = this._hand;
      if (hand) {
        for (const inputjoint of inputSource.hand.values()) {
          this._getHandJoint(hand, inputjoint);
        }
      }
    }
    this.dispatchEvent({ type: "connected", data: inputSource });
    return this;
  }
  disconnect(inputSource) {
    this.dispatchEvent({ type: "disconnected", data: inputSource });
    if (this._targetRay !== null) {
      this._targetRay.visible = false;
    }
    if (this._grip !== null) {
      this._grip.visible = false;
    }
    if (this._hand !== null) {
      this._hand.visible = false;
    }
    return this;
  }
  update(inputSource, frame, referenceSpace) {
    let inputPose = null;
    let gripPose = null;
    let handPose = null;
    const targetRay = this._targetRay;
    const grip = this._grip;
    const hand = this._hand;
    if (inputSource && frame.session.visibilityState !== "visible-blurred") {
      if (hand && inputSource.hand) {
        handPose = true;
        for (const inputjoint of inputSource.hand.values()) {
          const jointPose = frame.getJointPose(inputjoint, referenceSpace);
          const joint = this._getHandJoint(hand, inputjoint);
          if (jointPose !== null) {
            joint.matrix.fromArray(jointPose.transform.matrix);
            joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
            joint.matrixWorldNeedsUpdate = true;
            joint.jointRadius = jointPose.radius;
          }
          joint.visible = jointPose !== null;
        }
        const indexTip = hand.joints["index-finger-tip"];
        const thumbTip = hand.joints["thumb-tip"];
        const distance = indexTip.position.distanceTo(thumbTip.position);
        const distanceToPinch = 0.02;
        const threshold = 5e-3;
        if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
          hand.inputState.pinching = false;
          this.dispatchEvent({
            type: "pinchend",
            handedness: inputSource.handedness,
            target: this
          });
        } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
          hand.inputState.pinching = true;
          this.dispatchEvent({
            type: "pinchstart",
            handedness: inputSource.handedness,
            target: this
          });
        }
      } else {
        if (grip !== null && inputSource.gripSpace) {
          gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
          if (gripPose !== null) {
            grip.matrix.fromArray(gripPose.transform.matrix);
            grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
            grip.matrixWorldNeedsUpdate = true;
            if (gripPose.linearVelocity) {
              grip.hasLinearVelocity = true;
              grip.linearVelocity.copy(gripPose.linearVelocity);
            } else {
              grip.hasLinearVelocity = false;
            }
            if (gripPose.angularVelocity) {
              grip.hasAngularVelocity = true;
              grip.angularVelocity.copy(gripPose.angularVelocity);
            } else {
              grip.hasAngularVelocity = false;
            }
          }
        }
      }
      if (targetRay !== null) {
        inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
        if (inputPose === null && gripPose !== null) {
          inputPose = gripPose;
        }
        if (inputPose !== null) {
          targetRay.matrix.fromArray(inputPose.transform.matrix);
          targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
          targetRay.matrixWorldNeedsUpdate = true;
          if (inputPose.linearVelocity) {
            targetRay.hasLinearVelocity = true;
            targetRay.linearVelocity.copy(inputPose.linearVelocity);
          } else {
            targetRay.hasLinearVelocity = false;
          }
          if (inputPose.angularVelocity) {
            targetRay.hasAngularVelocity = true;
            targetRay.angularVelocity.copy(inputPose.angularVelocity);
          } else {
            targetRay.hasAngularVelocity = false;
          }
          this.dispatchEvent(_moveEvent);
        }
      }
    }
    if (targetRay !== null) {
      targetRay.visible = inputPose !== null;
    }
    if (grip !== null) {
      grip.visible = gripPose !== null;
    }
    if (hand !== null) {
      hand.visible = handPose !== null;
    }
    return this;
  }
  // private method
  _getHandJoint(hand, inputjoint) {
    if (hand.joints[inputjoint.jointName] === void 0) {
      const joint = new Group();
      joint.matrixAutoUpdate = false;
      joint.visible = false;
      hand.joints[inputjoint.jointName] = joint;
      hand.add(joint);
    }
    return hand.joints[inputjoint.jointName];
  }
}
class FogExp2 {
  constructor(color, density = 25e-5) {
    this.isFogExp2 = true;
    this.name = "";
    this.color = new Color(color);
    this.density = density;
  }
  clone() {
    return new FogExp2(this.color, this.density);
  }
  toJSON() {
    return {
      type: "FogExp2",
      name: this.name,
      color: this.color.getHex(),
      density: this.density
    };
  }
}
class Fog {
  constructor(color, near = 1, far = 1e3) {
    this.isFog = true;
    this.name = "";
    this.color = new Color(color);
    this.near = near;
    this.far = far;
  }
  clone() {
    return new Fog(this.color, this.near, this.far);
  }
  toJSON() {
    return {
      type: "Fog",
      name: this.name,
      color: this.color.getHex(),
      near: this.near,
      far: this.far
    };
  }
}
class Scene extends Object3D {
  constructor() {
    super();
    this.isScene = true;
    this.type = "Scene";
    this.background = null;
    this.environment = null;
    this.fog = null;
    this.backgroundBlurriness = 0;
    this.backgroundIntensity = 1;
    this.backgroundRotation = new Euler();
    this.environmentIntensity = 1;
    this.environmentRotation = new Euler();
    this.overrideMaterial = null;
    if (typeof __THREE_DEVTOOLS__ !== "undefined") {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.background !== null) this.background = source.background.clone();
    if (source.environment !== null) this.environment = source.environment.clone();
    if (source.fog !== null) this.fog = source.fog.clone();
    this.backgroundBlurriness = source.backgroundBlurriness;
    this.backgroundIntensity = source.backgroundIntensity;
    this.backgroundRotation.copy(source.backgroundRotation);
    this.environmentIntensity = source.environmentIntensity;
    this.environmentRotation.copy(source.environmentRotation);
    if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    if (this.fog !== null) data.object.fog = this.fog.toJSON();
    if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
    if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
    data.object.backgroundRotation = this.backgroundRotation.toArray();
    if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
    data.object.environmentRotation = this.environmentRotation.toArray();
    return data;
  }
}
class InterleavedBuffer {
  constructor(array, stride) {
    this.isInterleavedBuffer = true;
    this.array = array;
    this.stride = stride;
    this.count = array !== void 0 ? array.length / stride : 0;
    this.usage = StaticDrawUsage;
    this.updateRanges = [];
    this.version = 0;
    this.uuid = generateUUID$1();
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  addUpdateRange(start2, count) {
    this.updateRanges.push({ start: start2, count });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(source) {
    this.array = new source.array.constructor(source.array);
    this.count = source.count;
    this.stride = source.stride;
    this.usage = source.usage;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.stride;
    index2 *= attribute.stride;
    for (let i2 = 0, l2 = this.stride; i2 < l2; i2++) {
      this.array[index1 + i2] = attribute.array[index2 + i2];
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  clone(data) {
    if (data.arrayBuffers === void 0) {
      data.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID$1();
    }
    if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
    }
    const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
    const ib = new this.constructor(array, this.stride);
    ib.setUsage(this.usage);
    return ib;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  toJSON(data) {
    if (data.arrayBuffers === void 0) {
      data.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID$1();
    }
    if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
    }
    return {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
const _vector$7 = /* @__PURE__ */ new Vector3();
class InterleavedBufferAttribute {
  constructor(interleavedBuffer, itemSize, offset, normalized = false) {
    this.isInterleavedBufferAttribute = true;
    this.name = "";
    this.data = interleavedBuffer;
    this.itemSize = itemSize;
    this.offset = offset;
    this.normalized = normalized;
  }
  get count() {
    return this.data.count;
  }
  get array() {
    return this.data.array;
  }
  set needsUpdate(value) {
    this.data.needsUpdate = value;
  }
  applyMatrix4(m2) {
    for (let i2 = 0, l2 = this.data.count; i2 < l2; i2++) {
      _vector$7.fromBufferAttribute(this, i2);
      _vector$7.applyMatrix4(m2);
      this.setXYZ(i2, _vector$7.x, _vector$7.y, _vector$7.z);
    }
    return this;
  }
  applyNormalMatrix(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$7.fromBufferAttribute(this, i2);
      _vector$7.applyNormalMatrix(m2);
      this.setXYZ(i2, _vector$7.x, _vector$7.y, _vector$7.z);
    }
    return this;
  }
  transformDirection(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$7.fromBufferAttribute(this, i2);
      _vector$7.transformDirection(m2);
      this.setXYZ(i2, _vector$7.x, _vector$7.y, _vector$7.z);
    }
    return this;
  }
  getComponent(index, component) {
    let value = this.array[index * this.data.stride + this.offset + component];
    if (this.normalized) value = denormalize(value, this.array);
    return value;
  }
  setComponent(index, component, value) {
    if (this.normalized) value = normalize$1(value, this.array);
    this.data.array[index * this.data.stride + this.offset + component] = value;
    return this;
  }
  setX(index, x3) {
    if (this.normalized) x3 = normalize$1(x3, this.array);
    this.data.array[index * this.data.stride + this.offset] = x3;
    return this;
  }
  setY(index, y2) {
    if (this.normalized) y2 = normalize$1(y2, this.array);
    this.data.array[index * this.data.stride + this.offset + 1] = y2;
    return this;
  }
  setZ(index, z2) {
    if (this.normalized) z2 = normalize$1(z2, this.array);
    this.data.array[index * this.data.stride + this.offset + 2] = z2;
    return this;
  }
  setW(index, w2) {
    if (this.normalized) w2 = normalize$1(w2, this.array);
    this.data.array[index * this.data.stride + this.offset + 3] = w2;
    return this;
  }
  getX(index) {
    let x3 = this.data.array[index * this.data.stride + this.offset];
    if (this.normalized) x3 = denormalize(x3, this.array);
    return x3;
  }
  getY(index) {
    let y2 = this.data.array[index * this.data.stride + this.offset + 1];
    if (this.normalized) y2 = denormalize(y2, this.array);
    return y2;
  }
  getZ(index) {
    let z2 = this.data.array[index * this.data.stride + this.offset + 2];
    if (this.normalized) z2 = denormalize(z2, this.array);
    return z2;
  }
  getW(index) {
    let w2 = this.data.array[index * this.data.stride + this.offset + 3];
    if (this.normalized) w2 = denormalize(w2, this.array);
    return w2;
  }
  setXY(index, x3, y2) {
    index = index * this.data.stride + this.offset;
    if (this.normalized) {
      x3 = normalize$1(x3, this.array);
      y2 = normalize$1(y2, this.array);
    }
    this.data.array[index + 0] = x3;
    this.data.array[index + 1] = y2;
    return this;
  }
  setXYZ(index, x3, y2, z2) {
    index = index * this.data.stride + this.offset;
    if (this.normalized) {
      x3 = normalize$1(x3, this.array);
      y2 = normalize$1(y2, this.array);
      z2 = normalize$1(z2, this.array);
    }
    this.data.array[index + 0] = x3;
    this.data.array[index + 1] = y2;
    this.data.array[index + 2] = z2;
    return this;
  }
  setXYZW(index, x3, y2, z2, w2) {
    index = index * this.data.stride + this.offset;
    if (this.normalized) {
      x3 = normalize$1(x3, this.array);
      y2 = normalize$1(y2, this.array);
      z2 = normalize$1(z2, this.array);
      w2 = normalize$1(w2, this.array);
    }
    this.data.array[index + 0] = x3;
    this.data.array[index + 1] = y2;
    this.data.array[index + 2] = z2;
    this.data.array[index + 3] = w2;
    return this;
  }
  clone(data) {
    if (data === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const array = [];
      for (let i2 = 0; i2 < this.count; i2++) {
        const index = i2 * this.data.stride + this.offset;
        for (let j3 = 0; j3 < this.itemSize; j3++) {
          array.push(this.data.array[index + j3]);
        }
      }
      return new BufferAttribute(new this.array.constructor(array), this.itemSize, this.normalized);
    } else {
      if (data.interleavedBuffers === void 0) {
        data.interleavedBuffers = {};
      }
      if (data.interleavedBuffers[this.data.uuid] === void 0) {
        data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
      }
      return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
  }
  toJSON(data) {
    if (data === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const array = [];
      for (let i2 = 0; i2 < this.count; i2++) {
        const index = i2 * this.data.stride + this.offset;
        for (let j3 = 0; j3 < this.itemSize; j3++) {
          array.push(this.data.array[index + j3]);
        }
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array,
        normalized: this.normalized
      };
    } else {
      if (data.interleavedBuffers === void 0) {
        data.interleavedBuffers = {};
      }
      if (data.interleavedBuffers[this.data.uuid] === void 0) {
        data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
      }
      return {
        isInterleavedBufferAttribute: true,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
    }
  }
}
class SpriteMaterial extends Material {
  constructor(parameters) {
    super();
    this.isSpriteMaterial = true;
    this.type = "SpriteMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.alphaMap = null;
    this.rotation = 0;
    this.sizeAttenuation = true;
    this.transparent = true;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.rotation = source.rotation;
    this.sizeAttenuation = source.sizeAttenuation;
    this.fog = source.fog;
    return this;
  }
}
let _geometry;
const _intersectPoint = /* @__PURE__ */ new Vector3();
const _worldScale = /* @__PURE__ */ new Vector3();
const _mvPosition = /* @__PURE__ */ new Vector3();
const _alignedPosition = /* @__PURE__ */ new Vector2();
const _rotatedPosition = /* @__PURE__ */ new Vector2();
const _viewWorldMatrix = /* @__PURE__ */ new Matrix4();
const _vA = /* @__PURE__ */ new Vector3();
const _vB = /* @__PURE__ */ new Vector3();
const _vC = /* @__PURE__ */ new Vector3();
const _uvA = /* @__PURE__ */ new Vector2();
const _uvB = /* @__PURE__ */ new Vector2();
const _uvC = /* @__PURE__ */ new Vector2();
class Sprite extends Object3D {
  constructor(material = new SpriteMaterial()) {
    super();
    this.isSprite = true;
    this.type = "Sprite";
    if (_geometry === void 0) {
      _geometry = new BufferGeometry();
      const float32Array = new Float32Array([
        -0.5,
        -0.5,
        0,
        0,
        0,
        0.5,
        -0.5,
        0,
        1,
        0,
        0.5,
        0.5,
        0,
        1,
        1,
        -0.5,
        0.5,
        0,
        0,
        1
      ]);
      const interleavedBuffer = new InterleavedBuffer(float32Array, 5);
      _geometry.setIndex([0, 1, 2, 0, 2, 3]);
      _geometry.setAttribute("position", new InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
      _geometry.setAttribute("uv", new InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
    }
    this.geometry = _geometry;
    this.material = material;
    this.center = new Vector2(0.5, 0.5);
  }
  raycast(raycaster, intersects2) {
    if (raycaster.camera === null) {
      console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
    }
    _worldScale.setFromMatrixScale(this.matrixWorld);
    _viewWorldMatrix.copy(raycaster.camera.matrixWorld);
    this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
    _mvPosition.setFromMatrixPosition(this.modelViewMatrix);
    if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) {
      _worldScale.multiplyScalar(-_mvPosition.z);
    }
    const rotation = this.material.rotation;
    let sin, cos;
    if (rotation !== 0) {
      cos = Math.cos(rotation);
      sin = Math.sin(rotation);
    }
    const center = this.center;
    transformVertex(_vA.set(-0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
    transformVertex(_vB.set(0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
    transformVertex(_vC.set(0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
    _uvA.set(0, 0);
    _uvB.set(1, 0);
    _uvC.set(1, 1);
    let intersect2 = raycaster.ray.intersectTriangle(_vA, _vB, _vC, false, _intersectPoint);
    if (intersect2 === null) {
      transformVertex(_vB.set(-0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
      _uvB.set(0, 1);
      intersect2 = raycaster.ray.intersectTriangle(_vA, _vC, _vB, false, _intersectPoint);
      if (intersect2 === null) {
        return;
      }
    }
    const distance = raycaster.ray.origin.distanceTo(_intersectPoint);
    if (distance < raycaster.near || distance > raycaster.far) return;
    intersects2.push({
      distance,
      point: _intersectPoint.clone(),
      uv: Triangle.getInterpolation(_intersectPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2()),
      face: null,
      object: this
    });
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.center !== void 0) this.center.copy(source.center);
    this.material = source.material;
    return this;
  }
}
function transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
  _alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
  if (sin !== void 0) {
    _rotatedPosition.x = cos * _alignedPosition.x - sin * _alignedPosition.y;
    _rotatedPosition.y = sin * _alignedPosition.x + cos * _alignedPosition.y;
  } else {
    _rotatedPosition.copy(_alignedPosition);
  }
  vertexPosition.copy(mvPosition);
  vertexPosition.x += _rotatedPosition.x;
  vertexPosition.y += _rotatedPosition.y;
  vertexPosition.applyMatrix4(_viewWorldMatrix);
}
const _v1$2 = /* @__PURE__ */ new Vector3();
const _v2$1$1 = /* @__PURE__ */ new Vector3();
class LOD extends Object3D {
  constructor() {
    super();
    this._currentLevel = 0;
    this.type = "LOD";
    Object.defineProperties(this, {
      levels: {
        enumerable: true,
        value: []
      },
      isLOD: {
        value: true
      }
    });
    this.autoUpdate = true;
  }
  copy(source) {
    super.copy(source, false);
    const levels = source.levels;
    for (let i2 = 0, l2 = levels.length; i2 < l2; i2++) {
      const level = levels[i2];
      this.addLevel(level.object.clone(), level.distance, level.hysteresis);
    }
    this.autoUpdate = source.autoUpdate;
    return this;
  }
  addLevel(object, distance = 0, hysteresis = 0) {
    distance = Math.abs(distance);
    const levels = this.levels;
    let l2;
    for (l2 = 0; l2 < levels.length; l2++) {
      if (distance < levels[l2].distance) {
        break;
      }
    }
    levels.splice(l2, 0, { distance, hysteresis, object });
    this.add(object);
    return this;
  }
  removeLevel(distance) {
    const levels = this.levels;
    for (let i2 = 0; i2 < levels.length; i2++) {
      if (levels[i2].distance === distance) {
        const removedElements = levels.splice(i2, 1);
        this.remove(removedElements[0].object);
        return true;
      }
    }
    return false;
  }
  getCurrentLevel() {
    return this._currentLevel;
  }
  getObjectForDistance(distance) {
    const levels = this.levels;
    if (levels.length > 0) {
      let i2, l2;
      for (i2 = 1, l2 = levels.length; i2 < l2; i2++) {
        let levelDistance = levels[i2].distance;
        if (levels[i2].object.visible) {
          levelDistance -= levelDistance * levels[i2].hysteresis;
        }
        if (distance < levelDistance) {
          break;
        }
      }
      return levels[i2 - 1].object;
    }
    return null;
  }
  raycast(raycaster, intersects2) {
    const levels = this.levels;
    if (levels.length > 0) {
      _v1$2.setFromMatrixPosition(this.matrixWorld);
      const distance = raycaster.ray.origin.distanceTo(_v1$2);
      this.getObjectForDistance(distance).raycast(raycaster, intersects2);
    }
  }
  update(camera) {
    const levels = this.levels;
    if (levels.length > 1) {
      _v1$2.setFromMatrixPosition(camera.matrixWorld);
      _v2$1$1.setFromMatrixPosition(this.matrixWorld);
      const distance = _v1$2.distanceTo(_v2$1$1) / camera.zoom;
      levels[0].object.visible = true;
      let i2, l2;
      for (i2 = 1, l2 = levels.length; i2 < l2; i2++) {
        let levelDistance = levels[i2].distance;
        if (levels[i2].object.visible) {
          levelDistance -= levelDistance * levels[i2].hysteresis;
        }
        if (distance >= levelDistance) {
          levels[i2 - 1].object.visible = false;
          levels[i2].object.visible = true;
        } else {
          break;
        }
      }
      this._currentLevel = i2 - 1;
      for (; i2 < l2; i2++) {
        levels[i2].object.visible = false;
      }
    }
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    if (this.autoUpdate === false) data.object.autoUpdate = false;
    data.object.levels = [];
    const levels = this.levels;
    for (let i2 = 0, l2 = levels.length; i2 < l2; i2++) {
      const level = levels[i2];
      data.object.levels.push({
        object: level.object.uuid,
        distance: level.distance,
        hysteresis: level.hysteresis
      });
    }
    return data;
  }
}
const _basePosition = /* @__PURE__ */ new Vector3();
const _skinIndex = /* @__PURE__ */ new Vector4();
const _skinWeight = /* @__PURE__ */ new Vector4();
const _vector3$1 = /* @__PURE__ */ new Vector3();
const _matrix4$1 = /* @__PURE__ */ new Matrix4();
const _vertex = /* @__PURE__ */ new Vector3();
const _sphere$5 = /* @__PURE__ */ new Sphere();
const _inverseMatrix$2 = /* @__PURE__ */ new Matrix4();
const _ray$2 = /* @__PURE__ */ new Ray();
class SkinnedMesh extends Mesh {
  constructor(geometry, material) {
    super(geometry, material);
    this.isSkinnedMesh = true;
    this.type = "SkinnedMesh";
    this.bindMode = AttachedBindMode;
    this.bindMatrix = new Matrix4();
    this.bindMatrixInverse = new Matrix4();
    this.boundingBox = null;
    this.boundingSphere = null;
  }
  computeBoundingBox() {
    const geometry = this.geometry;
    if (this.boundingBox === null) {
      this.boundingBox = new Box3();
    }
    this.boundingBox.makeEmpty();
    const positionAttribute = geometry.getAttribute("position");
    for (let i2 = 0; i2 < positionAttribute.count; i2++) {
      this.getVertexPosition(i2, _vertex);
      this.boundingBox.expandByPoint(_vertex);
    }
  }
  computeBoundingSphere() {
    const geometry = this.geometry;
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere();
    }
    this.boundingSphere.makeEmpty();
    const positionAttribute = geometry.getAttribute("position");
    for (let i2 = 0; i2 < positionAttribute.count; i2++) {
      this.getVertexPosition(i2, _vertex);
      this.boundingSphere.expandByPoint(_vertex);
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.bindMode = source.bindMode;
    this.bindMatrix.copy(source.bindMatrix);
    this.bindMatrixInverse.copy(source.bindMatrixInverse);
    this.skeleton = source.skeleton;
    if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
    if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
    return this;
  }
  raycast(raycaster, intersects2) {
    const material = this.material;
    const matrixWorld = this.matrixWorld;
    if (material === void 0) return;
    if (this.boundingSphere === null) this.computeBoundingSphere();
    _sphere$5.copy(this.boundingSphere);
    _sphere$5.applyMatrix4(matrixWorld);
    if (raycaster.ray.intersectsSphere(_sphere$5) === false) return;
    _inverseMatrix$2.copy(matrixWorld).invert();
    _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2);
    if (this.boundingBox !== null) {
      if (_ray$2.intersectsBox(this.boundingBox) === false) return;
    }
    this._computeIntersections(raycaster, intersects2, _ray$2);
  }
  getVertexPosition(index, target) {
    super.getVertexPosition(index, target);
    this.applyBoneTransform(index, target);
    return target;
  }
  bind(skeleton, bindMatrix) {
    this.skeleton = skeleton;
    if (bindMatrix === void 0) {
      this.updateMatrixWorld(true);
      this.skeleton.calculateInverses();
      bindMatrix = this.matrixWorld;
    }
    this.bindMatrix.copy(bindMatrix);
    this.bindMatrixInverse.copy(bindMatrix).invert();
  }
  pose() {
    this.skeleton.pose();
  }
  normalizeSkinWeights() {
    const vector = new Vector4();
    const skinWeight = this.geometry.attributes.skinWeight;
    for (let i2 = 0, l2 = skinWeight.count; i2 < l2; i2++) {
      vector.fromBufferAttribute(skinWeight, i2);
      const scale = 1 / vector.manhattanLength();
      if (scale !== Infinity) {
        vector.multiplyScalar(scale);
      } else {
        vector.set(1, 0, 0, 0);
      }
      skinWeight.setXYZW(i2, vector.x, vector.y, vector.z, vector.w);
    }
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    if (this.bindMode === AttachedBindMode) {
      this.bindMatrixInverse.copy(this.matrixWorld).invert();
    } else if (this.bindMode === DetachedBindMode) {
      this.bindMatrixInverse.copy(this.bindMatrix).invert();
    } else {
      console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
  }
  applyBoneTransform(index, vector) {
    const skeleton = this.skeleton;
    const geometry = this.geometry;
    _skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
    _skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
    _basePosition.copy(vector).applyMatrix4(this.bindMatrix);
    vector.set(0, 0, 0);
    for (let i2 = 0; i2 < 4; i2++) {
      const weight = _skinWeight.getComponent(i2);
      if (weight !== 0) {
        const boneIndex = _skinIndex.getComponent(i2);
        _matrix4$1.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
        vector.addScaledVector(_vector3$1.copy(_basePosition).applyMatrix4(_matrix4$1), weight);
      }
    }
    return vector.applyMatrix4(this.bindMatrixInverse);
  }
}
class Bone extends Object3D {
  constructor() {
    super();
    this.isBone = true;
    this.type = "Bone";
  }
}
class DataTexture extends Texture {
  constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, colorSpace) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
    this.isDataTexture = true;
    this.image = { data, width, height };
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
  }
}
const _offsetMatrix = /* @__PURE__ */ new Matrix4();
const _identityMatrix$1 = /* @__PURE__ */ new Matrix4();
class Skeleton {
  constructor(bones = [], boneInverses = []) {
    this.uuid = generateUUID$1();
    this.bones = bones.slice(0);
    this.boneInverses = boneInverses;
    this.boneMatrices = null;
    this.boneTexture = null;
    this.init();
  }
  init() {
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    this.boneMatrices = new Float32Array(bones.length * 16);
    if (boneInverses.length === 0) {
      this.calculateInverses();
    } else {
      if (bones.length !== boneInverses.length) {
        console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
        this.boneInverses = [];
        for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
          this.boneInverses.push(new Matrix4());
        }
      }
    }
  }
  calculateInverses() {
    this.boneInverses.length = 0;
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const inverse = new Matrix4();
      if (this.bones[i2]) {
        inverse.copy(this.bones[i2].matrixWorld).invert();
      }
      this.boneInverses.push(inverse);
    }
  }
  pose() {
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const bone = this.bones[i2];
      if (bone) {
        bone.matrixWorld.copy(this.boneInverses[i2]).invert();
      }
    }
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const bone = this.bones[i2];
      if (bone) {
        if (bone.parent && bone.parent.isBone) {
          bone.matrix.copy(bone.parent.matrixWorld).invert();
          bone.matrix.multiply(bone.matrixWorld);
        } else {
          bone.matrix.copy(bone.matrixWorld);
        }
        bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
      }
    }
  }
  update() {
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    const boneMatrices = this.boneMatrices;
    const boneTexture = this.boneTexture;
    for (let i2 = 0, il = bones.length; i2 < il; i2++) {
      const matrix = bones[i2] ? bones[i2].matrixWorld : _identityMatrix$1;
      _offsetMatrix.multiplyMatrices(matrix, boneInverses[i2]);
      _offsetMatrix.toArray(boneMatrices, i2 * 16);
    }
    if (boneTexture !== null) {
      boneTexture.needsUpdate = true;
    }
  }
  clone() {
    return new Skeleton(this.bones, this.boneInverses);
  }
  computeBoneTexture() {
    let size = Math.sqrt(this.bones.length * 4);
    size = Math.ceil(size / 4) * 4;
    size = Math.max(size, 4);
    const boneMatrices = new Float32Array(size * size * 4);
    boneMatrices.set(this.boneMatrices);
    const boneTexture = new DataTexture(boneMatrices, size, size, RGBAFormat, FloatType);
    boneTexture.needsUpdate = true;
    this.boneMatrices = boneMatrices;
    this.boneTexture = boneTexture;
    return this;
  }
  getBoneByName(name) {
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const bone = this.bones[i2];
      if (bone.name === name) {
        return bone;
      }
    }
    return void 0;
  }
  dispose() {
    if (this.boneTexture !== null) {
      this.boneTexture.dispose();
      this.boneTexture = null;
    }
  }
  fromJSON(json, bones) {
    this.uuid = json.uuid;
    for (let i2 = 0, l2 = json.bones.length; i2 < l2; i2++) {
      const uuid = json.bones[i2];
      let bone = bones[uuid];
      if (bone === void 0) {
        console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
        bone = new Bone();
      }
      this.bones.push(bone);
      this.boneInverses.push(new Matrix4().fromArray(json.boneInverses[i2]));
    }
    this.init();
    return this;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.6,
        type: "Skeleton",
        generator: "Skeleton.toJSON"
      },
      bones: [],
      boneInverses: []
    };
    data.uuid = this.uuid;
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    for (let i2 = 0, l2 = bones.length; i2 < l2; i2++) {
      const bone = bones[i2];
      data.bones.push(bone.uuid);
      const boneInverse = boneInverses[i2];
      data.boneInverses.push(boneInverse.toArray());
    }
    return data;
  }
}
class InstancedBufferAttribute extends BufferAttribute {
  constructor(array, itemSize, normalized, meshPerAttribute = 1) {
    super(array, itemSize, normalized);
    this.isInstancedBufferAttribute = true;
    this.meshPerAttribute = meshPerAttribute;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.meshPerAttribute = this.meshPerAttribute;
    data.isInstancedBufferAttribute = true;
    return data;
  }
}
const _instanceLocalMatrix = /* @__PURE__ */ new Matrix4();
const _instanceWorldMatrix = /* @__PURE__ */ new Matrix4();
const _instanceIntersects = [];
const _box3 = /* @__PURE__ */ new Box3();
const _identity = /* @__PURE__ */ new Matrix4();
const _mesh$1 = /* @__PURE__ */ new Mesh();
const _sphere$4 = /* @__PURE__ */ new Sphere();
class InstancedMesh extends Mesh {
  constructor(geometry, material, count) {
    super(geometry, material);
    this.isInstancedMesh = true;
    this.instanceMatrix = new InstancedBufferAttribute(new Float32Array(count * 16), 16);
    this.instanceColor = null;
    this.morphTexture = null;
    this.count = count;
    this.boundingBox = null;
    this.boundingSphere = null;
    for (let i2 = 0; i2 < count; i2++) {
      this.setMatrixAt(i2, _identity);
    }
  }
  computeBoundingBox() {
    const geometry = this.geometry;
    const count = this.count;
    if (this.boundingBox === null) {
      this.boundingBox = new Box3();
    }
    if (geometry.boundingBox === null) {
      geometry.computeBoundingBox();
    }
    this.boundingBox.makeEmpty();
    for (let i2 = 0; i2 < count; i2++) {
      this.getMatrixAt(i2, _instanceLocalMatrix);
      _box3.copy(geometry.boundingBox).applyMatrix4(_instanceLocalMatrix);
      this.boundingBox.union(_box3);
    }
  }
  computeBoundingSphere() {
    const geometry = this.geometry;
    const count = this.count;
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere();
    }
    if (geometry.boundingSphere === null) {
      geometry.computeBoundingSphere();
    }
    this.boundingSphere.makeEmpty();
    for (let i2 = 0; i2 < count; i2++) {
      this.getMatrixAt(i2, _instanceLocalMatrix);
      _sphere$4.copy(geometry.boundingSphere).applyMatrix4(_instanceLocalMatrix);
      this.boundingSphere.union(_sphere$4);
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.instanceMatrix.copy(source.instanceMatrix);
    if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
    if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
    this.count = source.count;
    if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
    if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
    return this;
  }
  getColorAt(index, color) {
    color.fromArray(this.instanceColor.array, index * 3);
  }
  getMatrixAt(index, matrix) {
    matrix.fromArray(this.instanceMatrix.array, index * 16);
  }
  getMorphAt(index, object) {
    const objectInfluences = object.morphTargetInfluences;
    const array = this.morphTexture.source.data.data;
    const len = objectInfluences.length + 1;
    const dataIndex = index * len + 1;
    for (let i2 = 0; i2 < objectInfluences.length; i2++) {
      objectInfluences[i2] = array[dataIndex + i2];
    }
  }
  raycast(raycaster, intersects2) {
    const matrixWorld = this.matrixWorld;
    const raycastTimes = this.count;
    _mesh$1.geometry = this.geometry;
    _mesh$1.material = this.material;
    if (_mesh$1.material === void 0) return;
    if (this.boundingSphere === null) this.computeBoundingSphere();
    _sphere$4.copy(this.boundingSphere);
    _sphere$4.applyMatrix4(matrixWorld);
    if (raycaster.ray.intersectsSphere(_sphere$4) === false) return;
    for (let instanceId = 0; instanceId < raycastTimes; instanceId++) {
      this.getMatrixAt(instanceId, _instanceLocalMatrix);
      _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);
      _mesh$1.matrixWorld = _instanceWorldMatrix;
      _mesh$1.raycast(raycaster, _instanceIntersects);
      for (let i2 = 0, l2 = _instanceIntersects.length; i2 < l2; i2++) {
        const intersect2 = _instanceIntersects[i2];
        intersect2.instanceId = instanceId;
        intersect2.object = this;
        intersects2.push(intersect2);
      }
      _instanceIntersects.length = 0;
    }
  }
  setColorAt(index, color) {
    if (this.instanceColor === null) {
      this.instanceColor = new InstancedBufferAttribute(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
    }
    color.toArray(this.instanceColor.array, index * 3);
  }
  setMatrixAt(index, matrix) {
    matrix.toArray(this.instanceMatrix.array, index * 16);
  }
  setMorphAt(index, object) {
    const objectInfluences = object.morphTargetInfluences;
    const len = objectInfluences.length + 1;
    if (this.morphTexture === null) {
      this.morphTexture = new DataTexture(new Float32Array(len * this.count), len, this.count, RedFormat, FloatType);
    }
    const array = this.morphTexture.source.data.data;
    let morphInfluencesSum = 0;
    for (let i2 = 0; i2 < objectInfluences.length; i2++) {
      morphInfluencesSum += objectInfluences[i2];
    }
    const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
    const dataIndex = len * index;
    array[dataIndex] = morphBaseInfluence;
    array.set(objectInfluences, dataIndex + 1);
  }
  updateMorphTargets() {
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
    if (this.morphTexture !== null) {
      this.morphTexture.dispose();
      this.morphTexture = null;
    }
    return this;
  }
}
const _vector1 = /* @__PURE__ */ new Vector3();
const _vector2 = /* @__PURE__ */ new Vector3();
const _normalMatrix = /* @__PURE__ */ new Matrix3();
class Plane {
  constructor(normal = new Vector3(1, 0, 0), constant = 0) {
    this.isPlane = true;
    this.normal = normal;
    this.constant = constant;
  }
  set(normal, constant) {
    this.normal.copy(normal);
    this.constant = constant;
    return this;
  }
  setComponents(x3, y2, z2, w2) {
    this.normal.set(x3, y2, z2);
    this.constant = w2;
    return this;
  }
  setFromNormalAndCoplanarPoint(normal, point) {
    this.normal.copy(normal);
    this.constant = -point.dot(this.normal);
    return this;
  }
  setFromCoplanarPoints(a5, b6, c2) {
    const normal = _vector1.subVectors(c2, b6).cross(_vector2.subVectors(a5, b6)).normalize();
    this.setFromNormalAndCoplanarPoint(normal, a5);
    return this;
  }
  copy(plane) {
    this.normal.copy(plane.normal);
    this.constant = plane.constant;
    return this;
  }
  normalize() {
    const inverseNormalLength = 1 / this.normal.length();
    this.normal.multiplyScalar(inverseNormalLength);
    this.constant *= inverseNormalLength;
    return this;
  }
  negate() {
    this.constant *= -1;
    this.normal.negate();
    return this;
  }
  distanceToPoint(point) {
    return this.normal.dot(point) + this.constant;
  }
  distanceToSphere(sphere) {
    return this.distanceToPoint(sphere.center) - sphere.radius;
  }
  projectPoint(point, target) {
    return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
  }
  intersectLine(line, target) {
    const direction = line.delta(_vector1);
    const denominator = this.normal.dot(direction);
    if (denominator === 0) {
      if (this.distanceToPoint(line.start) === 0) {
        return target.copy(line.start);
      }
      return null;
    }
    const t2 = -(line.start.dot(this.normal) + this.constant) / denominator;
    if (t2 < 0 || t2 > 1) {
      return null;
    }
    return target.copy(line.start).addScaledVector(direction, t2);
  }
  intersectsLine(line) {
    const startSign = this.distanceToPoint(line.start);
    const endSign = this.distanceToPoint(line.end);
    return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
  }
  intersectsBox(box) {
    return box.intersectsPlane(this);
  }
  intersectsSphere(sphere) {
    return sphere.intersectsPlane(this);
  }
  coplanarPoint(target) {
    return target.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(matrix, optionalNormalMatrix) {
    const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);
    const referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
    const normal = this.normal.applyMatrix3(normalMatrix).normalize();
    this.constant = -referencePoint.dot(normal);
    return this;
  }
  translate(offset) {
    this.constant -= offset.dot(this.normal);
    return this;
  }
  equals(plane) {
    return plane.normal.equals(this.normal) && plane.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _sphere$3 = /* @__PURE__ */ new Sphere();
const _vector$6 = /* @__PURE__ */ new Vector3();
class Frustum {
  constructor(p0 = new Plane(), p1 = new Plane(), p22 = new Plane(), p3 = new Plane(), p4 = new Plane(), p5 = new Plane()) {
    this.planes = [p0, p1, p22, p3, p4, p5];
  }
  set(p0, p1, p22, p3, p4, p5) {
    const planes = this.planes;
    planes[0].copy(p0);
    planes[1].copy(p1);
    planes[2].copy(p22);
    planes[3].copy(p3);
    planes[4].copy(p4);
    planes[5].copy(p5);
    return this;
  }
  copy(frustum) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      planes[i2].copy(frustum.planes[i2]);
    }
    return this;
  }
  setFromProjectionMatrix(m2, coordinateSystem = WebGLCoordinateSystem) {
    const planes = this.planes;
    const me = m2.elements;
    const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
    const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
    const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
    const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
    planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
    planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
    planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
    planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
    planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
    if (coordinateSystem === WebGLCoordinateSystem) {
      planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      planes[5].setComponents(me2, me6, me10, me14).normalize();
    } else {
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
    }
    return this;
  }
  intersectsObject(object) {
    if (object.boundingSphere !== void 0) {
      if (object.boundingSphere === null) object.computeBoundingSphere();
      _sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
    } else {
      const geometry = object.geometry;
      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
      _sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
    }
    return this.intersectsSphere(_sphere$3);
  }
  intersectsSprite(sprite) {
    _sphere$3.center.set(0, 0, 0);
    _sphere$3.radius = 0.7071067811865476;
    _sphere$3.applyMatrix4(sprite.matrixWorld);
    return this.intersectsSphere(_sphere$3);
  }
  intersectsSphere(sphere) {
    const planes = this.planes;
    const center = sphere.center;
    const negRadius = -sphere.radius;
    for (let i2 = 0; i2 < 6; i2++) {
      const distance = planes[i2].distanceToPoint(center);
      if (distance < negRadius) {
        return false;
      }
    }
    return true;
  }
  intersectsBox(box) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      const plane = planes[i2];
      _vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
      _vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
      _vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
      if (plane.distanceToPoint(_vector$6) < 0) {
        return false;
      }
    }
    return true;
  }
  containsPoint(point) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      if (planes[i2].distanceToPoint(point) < 0) {
        return false;
      }
    }
    return true;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
function ascIdSort(a5, b6) {
  return a5 - b6;
}
function sortOpaque(a5, b6) {
  return a5.z - b6.z;
}
function sortTransparent(a5, b6) {
  return b6.z - a5.z;
}
class MultiDrawRenderList {
  constructor() {
    this.index = 0;
    this.pool = [];
    this.list = [];
  }
  push(start2, count, z2, index) {
    const pool = this.pool;
    const list = this.list;
    if (this.index >= pool.length) {
      pool.push({
        start: -1,
        count: -1,
        z: -1,
        index: -1
      });
    }
    const item = pool[this.index];
    list.push(item);
    this.index++;
    item.start = start2;
    item.count = count;
    item.z = z2;
    item.index = index;
  }
  reset() {
    this.list.length = 0;
    this.index = 0;
  }
}
const _matrix$1 = /* @__PURE__ */ new Matrix4();
const _whiteColor = /* @__PURE__ */ new Color(1, 1, 1);
const _frustum = /* @__PURE__ */ new Frustum();
const _box$1 = /* @__PURE__ */ new Box3();
const _sphere$2 = /* @__PURE__ */ new Sphere();
const _vector$5 = /* @__PURE__ */ new Vector3();
const _forward = /* @__PURE__ */ new Vector3();
const _temp = /* @__PURE__ */ new Vector3();
const _renderList = /* @__PURE__ */ new MultiDrawRenderList();
const _mesh = /* @__PURE__ */ new Mesh();
const _batchIntersects = [];
function copyAttributeData(src, target, targetOffset = 0) {
  const itemSize = target.itemSize;
  if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
    const vertexCount = src.count;
    for (let i2 = 0; i2 < vertexCount; i2++) {
      for (let c2 = 0; c2 < itemSize; c2++) {
        target.setComponent(i2 + targetOffset, c2, src.getComponent(i2, c2));
      }
    }
  } else {
    target.array.set(src.array, targetOffset * itemSize);
  }
  target.needsUpdate = true;
}
function copyArrayContents(src, target) {
  if (src.constructor !== target.constructor) {
    const len = Math.min(src.length, target.length);
    for (let i2 = 0; i2 < len; i2++) {
      target[i2] = src[i2];
    }
  } else {
    const len = Math.min(src.length, target.length);
    target.set(new src.constructor(src.buffer, 0, len));
  }
}
class BatchedMesh extends Mesh {
  get maxInstanceCount() {
    return this._maxInstanceCount;
  }
  get instanceCount() {
    return this._instanceInfo.length - this._availableInstanceIds.length;
  }
  get unusedVertexCount() {
    return this._maxVertexCount - this._nextVertexStart;
  }
  get unusedIndexCount() {
    return this._maxIndexCount - this._nextIndexStart;
  }
  constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material) {
    super(new BufferGeometry(), material);
    this.isBatchedMesh = true;
    this.perObjectFrustumCulled = true;
    this.sortObjects = true;
    this.boundingBox = null;
    this.boundingSphere = null;
    this.customSort = null;
    this._instanceInfo = [];
    this._geometryInfo = [];
    this._availableInstanceIds = [];
    this._availableGeometryIds = [];
    this._nextIndexStart = 0;
    this._nextVertexStart = 0;
    this._geometryCount = 0;
    this._visibilityChanged = true;
    this._geometryInitialized = false;
    this._maxInstanceCount = maxInstanceCount;
    this._maxVertexCount = maxVertexCount;
    this._maxIndexCount = maxIndexCount;
    this._multiDrawCounts = new Int32Array(maxInstanceCount);
    this._multiDrawStarts = new Int32Array(maxInstanceCount);
    this._multiDrawCount = 0;
    this._multiDrawInstances = null;
    this._matricesTexture = null;
    this._indirectTexture = null;
    this._colorsTexture = null;
    this._initMatricesTexture();
    this._initIndirectTexture();
  }
  _initMatricesTexture() {
    let size = Math.sqrt(this._maxInstanceCount * 4);
    size = Math.ceil(size / 4) * 4;
    size = Math.max(size, 4);
    const matricesArray = new Float32Array(size * size * 4);
    const matricesTexture = new DataTexture(matricesArray, size, size, RGBAFormat, FloatType);
    this._matricesTexture = matricesTexture;
  }
  _initIndirectTexture() {
    let size = Math.sqrt(this._maxInstanceCount);
    size = Math.ceil(size);
    const indirectArray = new Uint32Array(size * size);
    const indirectTexture = new DataTexture(indirectArray, size, size, RedIntegerFormat, UnsignedIntType);
    this._indirectTexture = indirectTexture;
  }
  _initColorsTexture() {
    let size = Math.sqrt(this._maxInstanceCount);
    size = Math.ceil(size);
    const colorsArray = new Float32Array(size * size * 4).fill(1);
    const colorsTexture = new DataTexture(colorsArray, size, size, RGBAFormat, FloatType);
    colorsTexture.colorSpace = ColorManagement.workingColorSpace;
    this._colorsTexture = colorsTexture;
  }
  _initializeGeometry(reference) {
    const geometry = this.geometry;
    const maxVertexCount = this._maxVertexCount;
    const maxIndexCount = this._maxIndexCount;
    if (this._geometryInitialized === false) {
      for (const attributeName in reference.attributes) {
        const srcAttribute = reference.getAttribute(attributeName);
        const { array, itemSize, normalized } = srcAttribute;
        const dstArray = new array.constructor(maxVertexCount * itemSize);
        const dstAttribute = new BufferAttribute(dstArray, itemSize, normalized);
        geometry.setAttribute(attributeName, dstAttribute);
      }
      if (reference.getIndex() !== null) {
        const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
        geometry.setIndex(new BufferAttribute(indexArray, 1));
      }
      this._geometryInitialized = true;
    }
  }
  // Make sure the geometry is compatible with the existing combined geometry attributes
  _validateGeometry(geometry) {
    const batchGeometry = this.geometry;
    if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) {
      throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
    }
    for (const attributeName in batchGeometry.attributes) {
      if (!geometry.hasAttribute(attributeName)) {
        throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
      }
      const srcAttribute = geometry.getAttribute(attributeName);
      const dstAttribute = batchGeometry.getAttribute(attributeName);
      if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) {
        throw new Error("THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.");
      }
    }
  }
  validateInstanceId(instanceId) {
    const instanceInfo = this._instanceInfo;
    if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) {
      throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
  }
  validateGeometryId(geometryId) {
    const geometryInfoList = this._geometryInfo;
    if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) {
      throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
  }
  setCustomSort(func) {
    this.customSort = func;
    return this;
  }
  computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Box3();
    }
    const boundingBox = this.boundingBox;
    const instanceInfo = this._instanceInfo;
    boundingBox.makeEmpty();
    for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
      if (instanceInfo[i2].active === false) continue;
      const geometryId = instanceInfo[i2].geometryIndex;
      this.getMatrixAt(i2, _matrix$1);
      this.getBoundingBoxAt(geometryId, _box$1).applyMatrix4(_matrix$1);
      boundingBox.union(_box$1);
    }
  }
  computeBoundingSphere() {
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere();
    }
    const boundingSphere = this.boundingSphere;
    const instanceInfo = this._instanceInfo;
    boundingSphere.makeEmpty();
    for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
      if (instanceInfo[i2].active === false) continue;
      const geometryId = instanceInfo[i2].geometryIndex;
      this.getMatrixAt(i2, _matrix$1);
      this.getBoundingSphereAt(geometryId, _sphere$2).applyMatrix4(_matrix$1);
      boundingSphere.union(_sphere$2);
    }
  }
  addInstance(geometryId) {
    const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
    if (atCapacity && this._availableInstanceIds.length === 0) {
      throw new Error("THREE.BatchedMesh: Maximum item count reached.");
    }
    const instanceInfo = {
      visible: true,
      active: true,
      geometryIndex: geometryId
    };
    let drawId = null;
    if (this._availableInstanceIds.length > 0) {
      this._availableInstanceIds.sort(ascIdSort);
      drawId = this._availableInstanceIds.shift();
      this._instanceInfo[drawId] = instanceInfo;
    } else {
      drawId = this._instanceInfo.length;
      this._instanceInfo.push(instanceInfo);
    }
    const matricesTexture = this._matricesTexture;
    _matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
    matricesTexture.needsUpdate = true;
    const colorsTexture = this._colorsTexture;
    if (colorsTexture) {
      _whiteColor.toArray(colorsTexture.image.data, drawId * 4);
      colorsTexture.needsUpdate = true;
    }
    this._visibilityChanged = true;
    return drawId;
  }
  addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
    this._initializeGeometry(geometry);
    this._validateGeometry(geometry);
    const geometryInfo = {
      // geometry information
      vertexStart: -1,
      vertexCount: -1,
      reservedVertexCount: -1,
      indexStart: -1,
      indexCount: -1,
      reservedIndexCount: -1,
      // draw range information
      start: -1,
      count: -1,
      // state
      boundingBox: null,
      boundingSphere: null,
      active: true
    };
    const geometryInfoList = this._geometryInfo;
    geometryInfo.vertexStart = this._nextVertexStart;
    geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute("position").count : reservedVertexCount;
    const index = geometry.getIndex();
    const hasIndex = index !== null;
    if (hasIndex) {
      geometryInfo.indexStart = this._nextIndexStart;
      geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
    }
    if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) {
      throw new Error("THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.");
    }
    let geometryId;
    if (this._availableGeometryIds.length > 0) {
      this._availableGeometryIds.sort(ascIdSort);
      geometryId = this._availableGeometryIds.shift();
      geometryInfoList[geometryId] = geometryInfo;
    } else {
      geometryId = this._geometryCount;
      this._geometryCount++;
      geometryInfoList.push(geometryInfo);
    }
    this.setGeometryAt(geometryId, geometry);
    this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
    this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
    return geometryId;
  }
  setGeometryAt(geometryId, geometry) {
    if (geometryId >= this._geometryCount) {
      throw new Error("THREE.BatchedMesh: Maximum geometry count reached.");
    }
    this._validateGeometry(geometry);
    const batchGeometry = this.geometry;
    const hasIndex = batchGeometry.getIndex() !== null;
    const dstIndex = batchGeometry.getIndex();
    const srcIndex = geometry.getIndex();
    const geometryInfo = this._geometryInfo[geometryId];
    if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) {
      throw new Error("THREE.BatchedMesh: Reserved space not large enough for provided geometry.");
    }
    const vertexStart = geometryInfo.vertexStart;
    const reservedVertexCount = geometryInfo.reservedVertexCount;
    geometryInfo.vertexCount = geometry.getAttribute("position").count;
    for (const attributeName in batchGeometry.attributes) {
      const srcAttribute = geometry.getAttribute(attributeName);
      const dstAttribute = batchGeometry.getAttribute(attributeName);
      copyAttributeData(srcAttribute, dstAttribute, vertexStart);
      const itemSize = srcAttribute.itemSize;
      for (let i2 = srcAttribute.count, l2 = reservedVertexCount; i2 < l2; i2++) {
        const index = vertexStart + i2;
        for (let c2 = 0; c2 < itemSize; c2++) {
          dstAttribute.setComponent(index, c2, 0);
        }
      }
      dstAttribute.needsUpdate = true;
      dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
    }
    if (hasIndex) {
      const indexStart = geometryInfo.indexStart;
      const reservedIndexCount = geometryInfo.reservedIndexCount;
      geometryInfo.indexCount = geometry.getIndex().count;
      for (let i2 = 0; i2 < srcIndex.count; i2++) {
        dstIndex.setX(indexStart + i2, vertexStart + srcIndex.getX(i2));
      }
      for (let i2 = srcIndex.count, l2 = reservedIndexCount; i2 < l2; i2++) {
        dstIndex.setX(indexStart + i2, vertexStart);
      }
      dstIndex.needsUpdate = true;
      dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
    }
    geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
    geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
    geometryInfo.boundingBox = null;
    if (geometry.boundingBox !== null) {
      geometryInfo.boundingBox = geometry.boundingBox.clone();
    }
    geometryInfo.boundingSphere = null;
    if (geometry.boundingSphere !== null) {
      geometryInfo.boundingSphere = geometry.boundingSphere.clone();
    }
    this._visibilityChanged = true;
    return geometryId;
  }
  deleteGeometry(geometryId) {
    const geometryInfoList = this._geometryInfo;
    if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) {
      return this;
    }
    const instanceInfo = this._instanceInfo;
    for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
      if (instanceInfo[i2].active && instanceInfo[i2].geometryIndex === geometryId) {
        this.deleteInstance(i2);
      }
    }
    geometryInfoList[geometryId].active = false;
    this._availableGeometryIds.push(geometryId);
    this._visibilityChanged = true;
    return this;
  }
  deleteInstance(instanceId) {
    this.validateInstanceId(instanceId);
    this._instanceInfo[instanceId].active = false;
    this._availableInstanceIds.push(instanceId);
    this._visibilityChanged = true;
    return this;
  }
  optimize() {
    let nextVertexStart = 0;
    let nextIndexStart = 0;
    const geometryInfoList = this._geometryInfo;
    const indices = geometryInfoList.map((e2, i2) => i2).sort((a5, b6) => {
      return geometryInfoList[a5].vertexStart - geometryInfoList[b6].vertexStart;
    });
    const geometry = this.geometry;
    for (let i2 = 0, l2 = geometryInfoList.length; i2 < l2; i2++) {
      const index = indices[i2];
      const geometryInfo = geometryInfoList[index];
      if (geometryInfo.active === false) {
        continue;
      }
      if (geometry.index !== null) {
        if (geometryInfo.indexStart !== nextIndexStart) {
          const { indexStart, vertexStart, reservedIndexCount } = geometryInfo;
          const index2 = geometry.index;
          const array = index2.array;
          const elementDelta = nextVertexStart - vertexStart;
          for (let j3 = indexStart; j3 < indexStart + reservedIndexCount; j3++) {
            array[j3] = array[j3] + elementDelta;
          }
          index2.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
          index2.addUpdateRange(nextIndexStart, reservedIndexCount);
          geometryInfo.indexStart = nextIndexStart;
        }
        nextIndexStart += geometryInfo.reservedIndexCount;
      }
      if (geometryInfo.vertexStart !== nextVertexStart) {
        const { vertexStart, reservedVertexCount } = geometryInfo;
        const attributes = geometry.attributes;
        for (const key in attributes) {
          const attribute = attributes[key];
          const { array, itemSize } = attribute;
          array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
          attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
        }
        geometryInfo.vertexStart = nextVertexStart;
      }
      nextVertexStart += geometryInfo.reservedVertexCount;
      geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
      this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
      this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
    }
    return this;
  }
  // get bounding box and compute it if it doesn't exist
  getBoundingBoxAt(geometryId, target) {
    if (geometryId >= this._geometryCount) {
      return null;
    }
    const geometry = this.geometry;
    const geometryInfo = this._geometryInfo[geometryId];
    if (geometryInfo.boundingBox === null) {
      const box = new Box3();
      const index = geometry.index;
      const position = geometry.attributes.position;
      for (let i2 = geometryInfo.start, l2 = geometryInfo.start + geometryInfo.count; i2 < l2; i2++) {
        let iv = i2;
        if (index) {
          iv = index.getX(iv);
        }
        box.expandByPoint(_vector$5.fromBufferAttribute(position, iv));
      }
      geometryInfo.boundingBox = box;
    }
    target.copy(geometryInfo.boundingBox);
    return target;
  }
  // get bounding sphere and compute it if it doesn't exist
  getBoundingSphereAt(geometryId, target) {
    if (geometryId >= this._geometryCount) {
      return null;
    }
    const geometry = this.geometry;
    const geometryInfo = this._geometryInfo[geometryId];
    if (geometryInfo.boundingSphere === null) {
      const sphere = new Sphere();
      this.getBoundingBoxAt(geometryId, _box$1);
      _box$1.getCenter(sphere.center);
      const index = geometry.index;
      const position = geometry.attributes.position;
      let maxRadiusSq = 0;
      for (let i2 = geometryInfo.start, l2 = geometryInfo.start + geometryInfo.count; i2 < l2; i2++) {
        let iv = i2;
        if (index) {
          iv = index.getX(iv);
        }
        _vector$5.fromBufferAttribute(position, iv);
        maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared(_vector$5));
      }
      sphere.radius = Math.sqrt(maxRadiusSq);
      geometryInfo.boundingSphere = sphere;
    }
    target.copy(geometryInfo.boundingSphere);
    return target;
  }
  setMatrixAt(instanceId, matrix) {
    this.validateInstanceId(instanceId);
    const matricesTexture = this._matricesTexture;
    const matricesArray = this._matricesTexture.image.data;
    matrix.toArray(matricesArray, instanceId * 16);
    matricesTexture.needsUpdate = true;
    return this;
  }
  getMatrixAt(instanceId, matrix) {
    this.validateInstanceId(instanceId);
    return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
  }
  setColorAt(instanceId, color) {
    this.validateInstanceId(instanceId);
    if (this._colorsTexture === null) {
      this._initColorsTexture();
    }
    color.toArray(this._colorsTexture.image.data, instanceId * 4);
    this._colorsTexture.needsUpdate = true;
    return this;
  }
  getColorAt(instanceId, color) {
    this.validateInstanceId(instanceId);
    return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
  }
  setVisibleAt(instanceId, value) {
    this.validateInstanceId(instanceId);
    if (this._instanceInfo[instanceId].visible === value) {
      return this;
    }
    this._instanceInfo[instanceId].visible = value;
    this._visibilityChanged = true;
    return this;
  }
  getVisibleAt(instanceId) {
    this.validateInstanceId(instanceId);
    return this._instanceInfo[instanceId].visible;
  }
  setGeometryIdAt(instanceId, geometryId) {
    this.validateInstanceId(instanceId);
    this.validateGeometryId(geometryId);
    this._instanceInfo[instanceId].geometryIndex = geometryId;
    return this;
  }
  getGeometryIdAt(instanceId) {
    this.validateInstanceId(instanceId);
    return this._instanceInfo[instanceId].geometryIndex;
  }
  getGeometryRangeAt(geometryId, target = {}) {
    this.validateGeometryId(geometryId);
    const geometryInfo = this._geometryInfo[geometryId];
    target.vertexStart = geometryInfo.vertexStart;
    target.vertexCount = geometryInfo.vertexCount;
    target.reservedVertexCount = geometryInfo.reservedVertexCount;
    target.indexStart = geometryInfo.indexStart;
    target.indexCount = geometryInfo.indexCount;
    target.reservedIndexCount = geometryInfo.reservedIndexCount;
    target.start = geometryInfo.start;
    target.count = geometryInfo.count;
    return target;
  }
  setInstanceCount(maxInstanceCount) {
    const availableInstanceIds = this._availableInstanceIds;
    const instanceInfo = this._instanceInfo;
    availableInstanceIds.sort(ascIdSort);
    while (availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length) {
      instanceInfo.pop();
      availableInstanceIds.pop();
    }
    if (maxInstanceCount < instanceInfo.length) {
      throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
    }
    const multiDrawCounts = new Int32Array(maxInstanceCount);
    const multiDrawStarts = new Int32Array(maxInstanceCount);
    copyArrayContents(this._multiDrawCounts, multiDrawCounts);
    copyArrayContents(this._multiDrawStarts, multiDrawStarts);
    this._multiDrawCounts = multiDrawCounts;
    this._multiDrawStarts = multiDrawStarts;
    this._maxInstanceCount = maxInstanceCount;
    const indirectTexture = this._indirectTexture;
    const matricesTexture = this._matricesTexture;
    const colorsTexture = this._colorsTexture;
    indirectTexture.dispose();
    this._initIndirectTexture();
    copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
    matricesTexture.dispose();
    this._initMatricesTexture();
    copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
    if (colorsTexture) {
      colorsTexture.dispose();
      this._initColorsTexture();
      copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
    }
  }
  setGeometrySize(maxVertexCount, maxIndexCount) {
    const validRanges = [...this._geometryInfo].filter((info) => info.active);
    const requiredVertexLength = Math.max(...validRanges.map((range) => range.vertexStart + range.reservedVertexCount));
    if (requiredVertexLength > maxVertexCount) {
      throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
    }
    if (this.geometry.index) {
      const requiredIndexLength = Math.max(...validRanges.map((range) => range.indexStart + range.reservedIndexCount));
      if (requiredIndexLength > maxIndexCount) {
        throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
      }
    }
    const oldGeometry = this.geometry;
    oldGeometry.dispose();
    this._maxVertexCount = maxVertexCount;
    this._maxIndexCount = maxIndexCount;
    if (this._geometryInitialized) {
      this._geometryInitialized = false;
      this.geometry = new BufferGeometry();
      this._initializeGeometry(oldGeometry);
    }
    const geometry = this.geometry;
    if (oldGeometry.index) {
      copyArrayContents(oldGeometry.index.array, geometry.index.array);
    }
    for (const key in oldGeometry.attributes) {
      copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
  }
  raycast(raycaster, intersects2) {
    const instanceInfo = this._instanceInfo;
    const geometryInfoList = this._geometryInfo;
    const matrixWorld = this.matrixWorld;
    const batchGeometry = this.geometry;
    _mesh.material = this.material;
    _mesh.geometry.index = batchGeometry.index;
    _mesh.geometry.attributes = batchGeometry.attributes;
    if (_mesh.geometry.boundingBox === null) {
      _mesh.geometry.boundingBox = new Box3();
    }
    if (_mesh.geometry.boundingSphere === null) {
      _mesh.geometry.boundingSphere = new Sphere();
    }
    for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
      if (!instanceInfo[i2].visible || !instanceInfo[i2].active) {
        continue;
      }
      const geometryId = instanceInfo[i2].geometryIndex;
      const geometryInfo = geometryInfoList[geometryId];
      _mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
      this.getMatrixAt(i2, _mesh.matrixWorld).premultiply(matrixWorld);
      this.getBoundingBoxAt(geometryId, _mesh.geometry.boundingBox);
      this.getBoundingSphereAt(geometryId, _mesh.geometry.boundingSphere);
      _mesh.raycast(raycaster, _batchIntersects);
      for (let j3 = 0, l3 = _batchIntersects.length; j3 < l3; j3++) {
        const intersect2 = _batchIntersects[j3];
        intersect2.object = this;
        intersect2.batchId = i2;
        intersects2.push(intersect2);
      }
      _batchIntersects.length = 0;
    }
    _mesh.material = null;
    _mesh.geometry.index = null;
    _mesh.geometry.attributes = {};
    _mesh.geometry.setDrawRange(0, Infinity);
  }
  copy(source) {
    super.copy(source);
    this.geometry = source.geometry.clone();
    this.perObjectFrustumCulled = source.perObjectFrustumCulled;
    this.sortObjects = source.sortObjects;
    this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
    this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
    this._geometryInfo = source._geometryInfo.map((info) => ({
      ...info,
      boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
      boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
    }));
    this._instanceInfo = source._instanceInfo.map((info) => ({ ...info }));
    this._maxInstanceCount = source._maxInstanceCount;
    this._maxVertexCount = source._maxVertexCount;
    this._maxIndexCount = source._maxIndexCount;
    this._geometryInitialized = source._geometryInitialized;
    this._geometryCount = source._geometryCount;
    this._multiDrawCounts = source._multiDrawCounts.slice();
    this._multiDrawStarts = source._multiDrawStarts.slice();
    this._matricesTexture = source._matricesTexture.clone();
    this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
    if (this._colorsTexture !== null) {
      this._colorsTexture = source._colorsTexture.clone();
      this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
    }
    return this;
  }
  dispose() {
    this.geometry.dispose();
    this._matricesTexture.dispose();
    this._matricesTexture = null;
    this._indirectTexture.dispose();
    this._indirectTexture = null;
    if (this._colorsTexture !== null) {
      this._colorsTexture.dispose();
      this._colorsTexture = null;
    }
    return this;
  }
  onBeforeRender(renderer, scene, camera, geometry, material) {
    if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) {
      return;
    }
    const index = geometry.getIndex();
    const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
    const instanceInfo = this._instanceInfo;
    const multiDrawStarts = this._multiDrawStarts;
    const multiDrawCounts = this._multiDrawCounts;
    const geometryInfoList = this._geometryInfo;
    const perObjectFrustumCulled = this.perObjectFrustumCulled;
    const indirectTexture = this._indirectTexture;
    const indirectArray = indirectTexture.image.data;
    if (perObjectFrustumCulled) {
      _matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
      _frustum.setFromProjectionMatrix(
        _matrix$1,
        renderer.coordinateSystem
      );
    }
    let multiDrawCount = 0;
    if (this.sortObjects) {
      _matrix$1.copy(this.matrixWorld).invert();
      _vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4(_matrix$1);
      _forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection(_matrix$1);
      for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
        if (instanceInfo[i2].visible && instanceInfo[i2].active) {
          const geometryId = instanceInfo[i2].geometryIndex;
          this.getMatrixAt(i2, _matrix$1);
          this.getBoundingSphereAt(geometryId, _sphere$2).applyMatrix4(_matrix$1);
          let culled = false;
          if (perObjectFrustumCulled) {
            culled = !_frustum.intersectsSphere(_sphere$2);
          }
          if (!culled) {
            const geometryInfo = geometryInfoList[geometryId];
            const z2 = _temp.subVectors(_sphere$2.center, _vector$5).dot(_forward);
            _renderList.push(geometryInfo.start, geometryInfo.count, z2, i2);
          }
        }
      }
      const list = _renderList.list;
      const customSort = this.customSort;
      if (customSort === null) {
        list.sort(material.transparent ? sortTransparent : sortOpaque);
      } else {
        customSort.call(this, list, camera);
      }
      for (let i2 = 0, l2 = list.length; i2 < l2; i2++) {
        const item = list[i2];
        multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
        multiDrawCounts[multiDrawCount] = item.count;
        indirectArray[multiDrawCount] = item.index;
        multiDrawCount++;
      }
      _renderList.reset();
    } else {
      for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
        if (instanceInfo[i2].visible && instanceInfo[i2].active) {
          const geometryId = instanceInfo[i2].geometryIndex;
          let culled = false;
          if (perObjectFrustumCulled) {
            this.getMatrixAt(i2, _matrix$1);
            this.getBoundingSphereAt(geometryId, _sphere$2).applyMatrix4(_matrix$1);
            culled = !_frustum.intersectsSphere(_sphere$2);
          }
          if (!culled) {
            const geometryInfo = geometryInfoList[geometryId];
            multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
            multiDrawCounts[multiDrawCount] = geometryInfo.count;
            indirectArray[multiDrawCount] = i2;
            multiDrawCount++;
          }
        }
      }
    }
    indirectTexture.needsUpdate = true;
    this._multiDrawCount = multiDrawCount;
    this._visibilityChanged = false;
  }
  onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial) {
    this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
  }
}
class LineBasicMaterial extends Material {
  constructor(parameters) {
    super();
    this.isLineBasicMaterial = true;
    this.type = "LineBasicMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.linewidth = 1;
    this.linecap = "round";
    this.linejoin = "round";
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.linewidth = source.linewidth;
    this.linecap = source.linecap;
    this.linejoin = source.linejoin;
    this.fog = source.fog;
    return this;
  }
}
const _vStart = /* @__PURE__ */ new Vector3();
const _vEnd = /* @__PURE__ */ new Vector3();
const _inverseMatrix$1 = /* @__PURE__ */ new Matrix4();
const _ray$1 = /* @__PURE__ */ new Ray();
const _sphere$1$1 = /* @__PURE__ */ new Sphere();
const _intersectPointOnRay = /* @__PURE__ */ new Vector3();
const _intersectPointOnSegment = /* @__PURE__ */ new Vector3();
class Line extends Object3D {
  constructor(geometry = new BufferGeometry(), material = new LineBasicMaterial()) {
    super();
    this.isLine = true;
    this.type = "Line";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
    this.geometry = source.geometry;
    return this;
  }
  computeLineDistances() {
    const geometry = this.geometry;
    if (geometry.index === null) {
      const positionAttribute = geometry.attributes.position;
      const lineDistances = [0];
      for (let i2 = 1, l2 = positionAttribute.count; i2 < l2; i2++) {
        _vStart.fromBufferAttribute(positionAttribute, i2 - 1);
        _vEnd.fromBufferAttribute(positionAttribute, i2);
        lineDistances[i2] = lineDistances[i2 - 1];
        lineDistances[i2] += _vStart.distanceTo(_vEnd);
      }
      geometry.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
    } else {
      console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    }
    return this;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold = raycaster.params.Line.threshold;
    const drawRange = geometry.drawRange;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$1$1.copy(geometry.boundingSphere);
    _sphere$1$1.applyMatrix4(matrixWorld);
    _sphere$1$1.radius += threshold;
    if (raycaster.ray.intersectsSphere(_sphere$1$1) === false) return;
    _inverseMatrix$1.copy(matrixWorld).invert();
    _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
    const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    const step = this.isLineSegments ? 2 : 1;
    const index = geometry.index;
    const attributes = geometry.attributes;
    const positionAttribute = attributes.position;
    if (index !== null) {
      const start2 = Math.max(0, drawRange.start);
      const end = Math.min(index.count, drawRange.start + drawRange.count);
      for (let i2 = start2, l2 = end - 1; i2 < l2; i2 += step) {
        const a5 = index.getX(i2);
        const b6 = index.getX(i2 + 1);
        const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, a5, b6, i2);
        if (intersect2) {
          intersects2.push(intersect2);
        }
      }
      if (this.isLineLoop) {
        const a5 = index.getX(end - 1);
        const b6 = index.getX(start2);
        const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, a5, b6, end - 1);
        if (intersect2) {
          intersects2.push(intersect2);
        }
      }
    } else {
      const start2 = Math.max(0, drawRange.start);
      const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
      for (let i2 = start2, l2 = end - 1; i2 < l2; i2 += step) {
        const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, i2, i2 + 1, i2);
        if (intersect2) {
          intersects2.push(intersect2);
        }
      }
      if (this.isLineLoop) {
        const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, end - 1, start2, end - 1);
        if (intersect2) {
          intersects2.push(intersect2);
        }
      }
    }
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    const morphAttributes = geometry.morphAttributes;
    const keys = Object.keys(morphAttributes);
    if (keys.length > 0) {
      const morphAttribute = morphAttributes[keys[0]];
      if (morphAttribute !== void 0) {
        this.morphTargetInfluences = [];
        this.morphTargetDictionary = {};
        for (let m2 = 0, ml = morphAttribute.length; m2 < ml; m2++) {
          const name = morphAttribute[m2].name || String(m2);
          this.morphTargetInfluences.push(0);
          this.morphTargetDictionary[name] = m2;
        }
      }
    }
  }
}
function checkIntersection(object, raycaster, ray, thresholdSq, a5, b6, i2) {
  const positionAttribute = object.geometry.attributes.position;
  _vStart.fromBufferAttribute(positionAttribute, a5);
  _vEnd.fromBufferAttribute(positionAttribute, b6);
  const distSq = ray.distanceSqToSegment(_vStart, _vEnd, _intersectPointOnRay, _intersectPointOnSegment);
  if (distSq > thresholdSq) return;
  _intersectPointOnRay.applyMatrix4(object.matrixWorld);
  const distance = raycaster.ray.origin.distanceTo(_intersectPointOnRay);
  if (distance < raycaster.near || distance > raycaster.far) return;
  return {
    distance,
    // What do we want? intersection point on the ray or on the segment??
    // point: raycaster.ray.at( distance ),
    point: _intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
    index: i2,
    face: null,
    faceIndex: null,
    barycoord: null,
    object
  };
}
const _start = /* @__PURE__ */ new Vector3();
const _end = /* @__PURE__ */ new Vector3();
class LineSegments extends Line {
  constructor(geometry, material) {
    super(geometry, material);
    this.isLineSegments = true;
    this.type = "LineSegments";
  }
  computeLineDistances() {
    const geometry = this.geometry;
    if (geometry.index === null) {
      const positionAttribute = geometry.attributes.position;
      const lineDistances = [];
      for (let i2 = 0, l2 = positionAttribute.count; i2 < l2; i2 += 2) {
        _start.fromBufferAttribute(positionAttribute, i2);
        _end.fromBufferAttribute(positionAttribute, i2 + 1);
        lineDistances[i2] = i2 === 0 ? 0 : lineDistances[i2 - 1];
        lineDistances[i2 + 1] = lineDistances[i2] + _start.distanceTo(_end);
      }
      geometry.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
    } else {
      console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    }
    return this;
  }
}
class LineLoop extends Line {
  constructor(geometry, material) {
    super(geometry, material);
    this.isLineLoop = true;
    this.type = "LineLoop";
  }
}
class PointsMaterial extends Material {
  constructor(parameters) {
    super();
    this.isPointsMaterial = true;
    this.type = "PointsMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.alphaMap = null;
    this.size = 1;
    this.sizeAttenuation = true;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.size = source.size;
    this.sizeAttenuation = source.sizeAttenuation;
    this.fog = source.fog;
    return this;
  }
}
const _inverseMatrix = /* @__PURE__ */ new Matrix4();
const _ray = /* @__PURE__ */ new Ray();
const _sphere$7 = /* @__PURE__ */ new Sphere();
const _position$2 = /* @__PURE__ */ new Vector3();
class Points extends Object3D {
  constructor(geometry = new BufferGeometry(), material = new PointsMaterial()) {
    super();
    this.isPoints = true;
    this.type = "Points";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
    this.geometry = source.geometry;
    return this;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold = raycaster.params.Points.threshold;
    const drawRange = geometry.drawRange;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$7.copy(geometry.boundingSphere);
    _sphere$7.applyMatrix4(matrixWorld);
    _sphere$7.radius += threshold;
    if (raycaster.ray.intersectsSphere(_sphere$7) === false) return;
    _inverseMatrix.copy(matrixWorld).invert();
    _ray.copy(raycaster.ray).applyMatrix4(_inverseMatrix);
    const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    const index = geometry.index;
    const attributes = geometry.attributes;
    const positionAttribute = attributes.position;
    if (index !== null) {
      const start2 = Math.max(0, drawRange.start);
      const end = Math.min(index.count, drawRange.start + drawRange.count);
      for (let i2 = start2, il = end; i2 < il; i2++) {
        const a5 = index.getX(i2);
        _position$2.fromBufferAttribute(positionAttribute, a5);
        testPoint(_position$2, a5, localThresholdSq, matrixWorld, raycaster, intersects2, this);
      }
    } else {
      const start2 = Math.max(0, drawRange.start);
      const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
      for (let i2 = start2, l2 = end; i2 < l2; i2++) {
        _position$2.fromBufferAttribute(positionAttribute, i2);
        testPoint(_position$2, i2, localThresholdSq, matrixWorld, raycaster, intersects2, this);
      }
    }
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    const morphAttributes = geometry.morphAttributes;
    const keys = Object.keys(morphAttributes);
    if (keys.length > 0) {
      const morphAttribute = morphAttributes[keys[0]];
      if (morphAttribute !== void 0) {
        this.morphTargetInfluences = [];
        this.morphTargetDictionary = {};
        for (let m2 = 0, ml = morphAttribute.length; m2 < ml; m2++) {
          const name = morphAttribute[m2].name || String(m2);
          this.morphTargetInfluences.push(0);
          this.morphTargetDictionary[name] = m2;
        }
      }
    }
  }
}
function testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects2, object) {
  const rayPointDistanceSq = _ray.distanceSqToPoint(point);
  if (rayPointDistanceSq < localThresholdSq) {
    const intersectPoint = new Vector3();
    _ray.closestPointToPoint(point, intersectPoint);
    intersectPoint.applyMatrix4(matrixWorld);
    const distance = raycaster.ray.origin.distanceTo(intersectPoint);
    if (distance < raycaster.near || distance > raycaster.far) return;
    intersects2.push({
      distance,
      distanceToRay: Math.sqrt(rayPointDistanceSq),
      point: intersectPoint,
      index,
      face: null,
      faceIndex: null,
      barycoord: null,
      object
    });
  }
}
class VideoTexture extends Texture {
  constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.isVideoTexture = true;
    this.minFilter = minFilter !== void 0 ? minFilter : LinearFilter;
    this.magFilter = magFilter !== void 0 ? magFilter : LinearFilter;
    this.generateMipmaps = false;
    const scope = this;
    function updateVideo() {
      scope.needsUpdate = true;
      video.requestVideoFrameCallback(updateVideo);
    }
    if ("requestVideoFrameCallback" in video) {
      video.requestVideoFrameCallback(updateVideo);
    }
  }
  clone() {
    return new this.constructor(this.image).copy(this);
  }
  update() {
    const video = this.image;
    const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
    if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) {
      this.needsUpdate = true;
    }
  }
}
class VideoFrameTexture extends VideoTexture {
  constructor(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super({}, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.isVideoFrameTexture = true;
  }
  update() {
  }
  clone() {
    return new this.constructor().copy(this);
  }
  setFrame(frame) {
    this.image = frame;
    this.needsUpdate = true;
  }
}
class FramebufferTexture extends Texture {
  constructor(width, height) {
    super({ width, height });
    this.isFramebufferTexture = true;
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.generateMipmaps = false;
    this.needsUpdate = true;
  }
}
class CompressedTexture extends Texture {
  constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
    this.isCompressedTexture = true;
    this.image = { width, height };
    this.mipmaps = mipmaps;
    this.flipY = false;
    this.generateMipmaps = false;
  }
}
class CompressedArrayTexture extends CompressedTexture {
  constructor(mipmaps, width, height, depth, format, type) {
    super(mipmaps, width, height, format, type);
    this.isCompressedArrayTexture = true;
    this.image.depth = depth;
    this.wrapR = ClampToEdgeWrapping;
    this.layerUpdates = /* @__PURE__ */ new Set();
  }
  addLayerUpdate(layerIndex) {
    this.layerUpdates.add(layerIndex);
  }
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class CompressedCubeTexture extends CompressedTexture {
  constructor(images, format, type) {
    super(void 0, images[0].width, images[0].height, format, type, CubeReflectionMapping);
    this.isCompressedCubeTexture = true;
    this.isCubeTexture = true;
    this.image = images;
  }
}
class CanvasTexture extends Texture {
  constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.isCanvasTexture = true;
    this.needsUpdate = true;
  }
}
class DepthTexture extends Texture {
  constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = DepthFormat) {
    if (format !== DepthFormat && format !== DepthStencilFormat) {
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    }
    if (type === void 0 && format === DepthFormat) type = UnsignedIntType;
    if (type === void 0 && format === DepthStencilFormat) type = UnsignedInt248Type;
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.isDepthTexture = true;
    this.image = { width, height };
    this.magFilter = magFilter !== void 0 ? magFilter : NearestFilter;
    this.minFilter = minFilter !== void 0 ? minFilter : NearestFilter;
    this.flipY = false;
    this.generateMipmaps = false;
    this.compareFunction = null;
  }
  copy(source) {
    super.copy(source);
    this.compareFunction = source.compareFunction;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
    return data;
  }
}
class Curve {
  constructor() {
    this.type = "Curve";
    this.arcLengthDivisions = 200;
  }
  // Virtual base class method to overwrite and implement in subclasses
  //	- t [0 .. 1]
  getPoint() {
    console.warn("THREE.Curve: .getPoint() not implemented.");
    return null;
  }
  // Get point at relative position in curve according to arc length
  // - u [0 .. 1]
  getPointAt(u2, optionalTarget) {
    const t2 = this.getUtoTmapping(u2);
    return this.getPoint(t2, optionalTarget);
  }
  // Get sequence of points using getPoint( t )
  getPoints(divisions = 5) {
    const points = [];
    for (let d3 = 0; d3 <= divisions; d3++) {
      points.push(this.getPoint(d3 / divisions));
    }
    return points;
  }
  // Get sequence of points using getPointAt( u )
  getSpacedPoints(divisions = 5) {
    const points = [];
    for (let d3 = 0; d3 <= divisions; d3++) {
      points.push(this.getPointAt(d3 / divisions));
    }
    return points;
  }
  // Get total curve arc length
  getLength() {
    const lengths = this.getLengths();
    return lengths[lengths.length - 1];
  }
  // Get list of cumulative segment lengths
  getLengths(divisions = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {
      return this.cacheArcLengths;
    }
    this.needsUpdate = false;
    const cache = [];
    let current, last = this.getPoint(0);
    let sum = 0;
    cache.push(0);
    for (let p3 = 1; p3 <= divisions; p3++) {
      current = this.getPoint(p3 / divisions);
      sum += current.distanceTo(last);
      cache.push(sum);
      last = current;
    }
    this.cacheArcLengths = cache;
    return cache;
  }
  updateArcLengths() {
    this.needsUpdate = true;
    this.getLengths();
  }
  // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
  getUtoTmapping(u2, distance) {
    const arcLengths = this.getLengths();
    let i2 = 0;
    const il = arcLengths.length;
    let targetArcLength;
    if (distance) {
      targetArcLength = distance;
    } else {
      targetArcLength = u2 * arcLengths[il - 1];
    }
    let low = 0, high = il - 1, comparison;
    while (low <= high) {
      i2 = Math.floor(low + (high - low) / 2);
      comparison = arcLengths[i2] - targetArcLength;
      if (comparison < 0) {
        low = i2 + 1;
      } else if (comparison > 0) {
        high = i2 - 1;
      } else {
        high = i2;
        break;
      }
    }
    i2 = high;
    if (arcLengths[i2] === targetArcLength) {
      return i2 / (il - 1);
    }
    const lengthBefore = arcLengths[i2];
    const lengthAfter = arcLengths[i2 + 1];
    const segmentLength = lengthAfter - lengthBefore;
    const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
    const t2 = (i2 + segmentFraction) / (il - 1);
    return t2;
  }
  // Returns a unit vector tangent at t
  // In case any sub curve does not implement its tangent derivation,
  // 2 points a small delta apart will be used to find its gradient
  // which seems to give a reasonable approximation
  getTangent(t2, optionalTarget) {
    const delta = 1e-4;
    let t1 = t2 - delta;
    let t22 = t2 + delta;
    if (t1 < 0) t1 = 0;
    if (t22 > 1) t22 = 1;
    const pt1 = this.getPoint(t1);
    const pt2 = this.getPoint(t22);
    const tangent = optionalTarget || (pt1.isVector2 ? new Vector2() : new Vector3());
    tangent.copy(pt2).sub(pt1).normalize();
    return tangent;
  }
  getTangentAt(u2, optionalTarget) {
    const t2 = this.getUtoTmapping(u2);
    return this.getTangent(t2, optionalTarget);
  }
  computeFrenetFrames(segments, closed) {
    const normal = new Vector3();
    const tangents = [];
    const normals = [];
    const binormals = [];
    const vec = new Vector3();
    const mat2 = new Matrix4();
    for (let i2 = 0; i2 <= segments; i2++) {
      const u2 = i2 / segments;
      tangents[i2] = this.getTangentAt(u2, new Vector3());
    }
    normals[0] = new Vector3();
    binormals[0] = new Vector3();
    let min = Number.MAX_VALUE;
    const tx = Math.abs(tangents[0].x);
    const ty = Math.abs(tangents[0].y);
    const tz = Math.abs(tangents[0].z);
    if (tx <= min) {
      min = tx;
      normal.set(1, 0, 0);
    }
    if (ty <= min) {
      min = ty;
      normal.set(0, 1, 0);
    }
    if (tz <= min) {
      normal.set(0, 0, 1);
    }
    vec.crossVectors(tangents[0], normal).normalize();
    normals[0].crossVectors(tangents[0], vec);
    binormals[0].crossVectors(tangents[0], normals[0]);
    for (let i2 = 1; i2 <= segments; i2++) {
      normals[i2] = normals[i2 - 1].clone();
      binormals[i2] = binormals[i2 - 1].clone();
      vec.crossVectors(tangents[i2 - 1], tangents[i2]);
      if (vec.length() > Number.EPSILON) {
        vec.normalize();
        const theta = Math.acos(clamp$4(tangents[i2 - 1].dot(tangents[i2]), -1, 1));
        normals[i2].applyMatrix4(mat2.makeRotationAxis(vec, theta));
      }
      binormals[i2].crossVectors(tangents[i2], normals[i2]);
    }
    if (closed === true) {
      let theta = Math.acos(clamp$4(normals[0].dot(normals[segments]), -1, 1));
      theta /= segments;
      if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {
        theta = -theta;
      }
      for (let i2 = 1; i2 <= segments; i2++) {
        normals[i2].applyMatrix4(mat2.makeRotationAxis(tangents[i2], theta * i2));
        binormals[i2].crossVectors(tangents[i2], normals[i2]);
      }
    }
    return {
      tangents,
      normals,
      binormals
    };
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.arcLengthDivisions = source.arcLengthDivisions;
    return this;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.6,
        type: "Curve",
        generator: "Curve.toJSON"
      }
    };
    data.arcLengthDivisions = this.arcLengthDivisions;
    data.type = this.type;
    return data;
  }
  fromJSON(json) {
    this.arcLengthDivisions = json.arcLengthDivisions;
    return this;
  }
}
class EllipseCurve extends Curve {
  constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0) {
    super();
    this.isEllipseCurve = true;
    this.type = "EllipseCurve";
    this.aX = aX;
    this.aY = aY;
    this.xRadius = xRadius;
    this.yRadius = yRadius;
    this.aStartAngle = aStartAngle;
    this.aEndAngle = aEndAngle;
    this.aClockwise = aClockwise;
    this.aRotation = aRotation;
  }
  getPoint(t2, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const twoPi = Math.PI * 2;
    let deltaAngle2 = this.aEndAngle - this.aStartAngle;
    const samePoints = Math.abs(deltaAngle2) < Number.EPSILON;
    while (deltaAngle2 < 0) deltaAngle2 += twoPi;
    while (deltaAngle2 > twoPi) deltaAngle2 -= twoPi;
    if (deltaAngle2 < Number.EPSILON) {
      if (samePoints) {
        deltaAngle2 = 0;
      } else {
        deltaAngle2 = twoPi;
      }
    }
    if (this.aClockwise === true && !samePoints) {
      if (deltaAngle2 === twoPi) {
        deltaAngle2 = -twoPi;
      } else {
        deltaAngle2 = deltaAngle2 - twoPi;
      }
    }
    const angle = this.aStartAngle + t2 * deltaAngle2;
    let x3 = this.aX + this.xRadius * Math.cos(angle);
    let y2 = this.aY + this.yRadius * Math.sin(angle);
    if (this.aRotation !== 0) {
      const cos = Math.cos(this.aRotation);
      const sin = Math.sin(this.aRotation);
      const tx = x3 - this.aX;
      const ty = y2 - this.aY;
      x3 = tx * cos - ty * sin + this.aX;
      y2 = tx * sin + ty * cos + this.aY;
    }
    return point.set(x3, y2);
  }
  copy(source) {
    super.copy(source);
    this.aX = source.aX;
    this.aY = source.aY;
    this.xRadius = source.xRadius;
    this.yRadius = source.yRadius;
    this.aStartAngle = source.aStartAngle;
    this.aEndAngle = source.aEndAngle;
    this.aClockwise = source.aClockwise;
    this.aRotation = source.aRotation;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.aX = this.aX;
    data.aY = this.aY;
    data.xRadius = this.xRadius;
    data.yRadius = this.yRadius;
    data.aStartAngle = this.aStartAngle;
    data.aEndAngle = this.aEndAngle;
    data.aClockwise = this.aClockwise;
    data.aRotation = this.aRotation;
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.aX = json.aX;
    this.aY = json.aY;
    this.xRadius = json.xRadius;
    this.yRadius = json.yRadius;
    this.aStartAngle = json.aStartAngle;
    this.aEndAngle = json.aEndAngle;
    this.aClockwise = json.aClockwise;
    this.aRotation = json.aRotation;
    return this;
  }
}
class ArcCurve extends EllipseCurve {
  constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    this.isArcCurve = true;
    this.type = "ArcCurve";
  }
}
function CubicPoly() {
  let c0 = 0, c1 = 0, c2 = 0, c32 = 0;
  function init4(x0, x1, t0, t1) {
    c0 = x0;
    c1 = t0;
    c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
    c32 = 2 * x0 - 2 * x1 + t0 + t1;
  }
  return {
    initCatmullRom: function(x0, x1, x22, x3, tension) {
      init4(x1, x22, tension * (x22 - x0), tension * (x3 - x1));
    },
    initNonuniformCatmullRom: function(x0, x1, x22, x3, dt0, dt1, dt2) {
      let t1 = (x1 - x0) / dt0 - (x22 - x0) / (dt0 + dt1) + (x22 - x1) / dt1;
      let t2 = (x22 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x22) / dt2;
      t1 *= dt1;
      t2 *= dt1;
      init4(x1, x22, t1, t2);
    },
    calc: function(t2) {
      const t22 = t2 * t2;
      const t3 = t22 * t2;
      return c0 + c1 * t2 + c2 * t22 + c32 * t3;
    }
  };
}
const tmp = /* @__PURE__ */ new Vector3();
const px = /* @__PURE__ */ new CubicPoly();
const py = /* @__PURE__ */ new CubicPoly();
const pz = /* @__PURE__ */ new CubicPoly();
class CatmullRomCurve3 extends Curve {
  constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5) {
    super();
    this.isCatmullRomCurve3 = true;
    this.type = "CatmullRomCurve3";
    this.points = points;
    this.closed = closed;
    this.curveType = curveType;
    this.tension = tension;
  }
  getPoint(t2, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    const points = this.points;
    const l2 = points.length;
    const p3 = (l2 - (this.closed ? 0 : 1)) * t2;
    let intPoint = Math.floor(p3);
    let weight = p3 - intPoint;
    if (this.closed) {
      intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l2) + 1) * l2;
    } else if (weight === 0 && intPoint === l2 - 1) {
      intPoint = l2 - 2;
      weight = 1;
    }
    let p0, p32;
    if (this.closed || intPoint > 0) {
      p0 = points[(intPoint - 1) % l2];
    } else {
      tmp.subVectors(points[0], points[1]).add(points[0]);
      p0 = tmp;
    }
    const p1 = points[intPoint % l2];
    const p22 = points[(intPoint + 1) % l2];
    if (this.closed || intPoint + 2 < l2) {
      p32 = points[(intPoint + 2) % l2];
    } else {
      tmp.subVectors(points[l2 - 1], points[l2 - 2]).add(points[l2 - 1]);
      p32 = tmp;
    }
    if (this.curveType === "centripetal" || this.curveType === "chordal") {
      const pow = this.curveType === "chordal" ? 0.5 : 0.25;
      let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
      let dt1 = Math.pow(p1.distanceToSquared(p22), pow);
      let dt2 = Math.pow(p22.distanceToSquared(p32), pow);
      if (dt1 < 1e-4) dt1 = 1;
      if (dt0 < 1e-4) dt0 = dt1;
      if (dt2 < 1e-4) dt2 = dt1;
      px.initNonuniformCatmullRom(p0.x, p1.x, p22.x, p32.x, dt0, dt1, dt2);
      py.initNonuniformCatmullRom(p0.y, p1.y, p22.y, p32.y, dt0, dt1, dt2);
      pz.initNonuniformCatmullRom(p0.z, p1.z, p22.z, p32.z, dt0, dt1, dt2);
    } else if (this.curveType === "catmullrom") {
      px.initCatmullRom(p0.x, p1.x, p22.x, p32.x, this.tension);
      py.initCatmullRom(p0.y, p1.y, p22.y, p32.y, this.tension);
      pz.initCatmullRom(p0.z, p1.z, p22.z, p32.z, this.tension);
    }
    point.set(
      px.calc(weight),
      py.calc(weight),
      pz.calc(weight)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
      const point = source.points[i2];
      this.points.push(point.clone());
    }
    this.closed = source.closed;
    this.curveType = source.curveType;
    this.tension = source.tension;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.points = [];
    for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
      const point = this.points[i2];
      data.points.push(point.toArray());
    }
    data.closed = this.closed;
    data.curveType = this.curveType;
    data.tension = this.tension;
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
      const point = json.points[i2];
      this.points.push(new Vector3().fromArray(point));
    }
    this.closed = json.closed;
    this.curveType = json.curveType;
    this.tension = json.tension;
    return this;
  }
}
function CatmullRom(t2, p0, p1, p22, p3) {
  const v0 = (p22 - p0) * 0.5;
  const v1 = (p3 - p1) * 0.5;
  const t22 = t2 * t2;
  const t3 = t2 * t22;
  return (2 * p1 - 2 * p22 + v0 + v1) * t3 + (-3 * p1 + 3 * p22 - 2 * v0 - v1) * t22 + v0 * t2 + p1;
}
function QuadraticBezierP0(t2, p3) {
  const k2 = 1 - t2;
  return k2 * k2 * p3;
}
function QuadraticBezierP1(t2, p3) {
  return 2 * (1 - t2) * t2 * p3;
}
function QuadraticBezierP2(t2, p3) {
  return t2 * t2 * p3;
}
function QuadraticBezier(t2, p0, p1, p22) {
  return QuadraticBezierP0(t2, p0) + QuadraticBezierP1(t2, p1) + QuadraticBezierP2(t2, p22);
}
function CubicBezierP0(t2, p3) {
  const k2 = 1 - t2;
  return k2 * k2 * k2 * p3;
}
function CubicBezierP1(t2, p3) {
  const k2 = 1 - t2;
  return 3 * k2 * k2 * t2 * p3;
}
function CubicBezierP2(t2, p3) {
  return 3 * (1 - t2) * t2 * t2 * p3;
}
function CubicBezierP3(t2, p3) {
  return t2 * t2 * t2 * p3;
}
function CubicBezier(t2, p0, p1, p22, p3) {
  return CubicBezierP0(t2, p0) + CubicBezierP1(t2, p1) + CubicBezierP2(t2, p22) + CubicBezierP3(t2, p3);
}
class CubicBezierCurve extends Curve {
  constructor(v0 = new Vector2(), v1 = new Vector2(), v22 = new Vector2(), v3 = new Vector2()) {
    super();
    this.isCubicBezierCurve = true;
    this.type = "CubicBezierCurve";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v22;
    this.v3 = v3;
  }
  getPoint(t2, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v22 = this.v2, v3 = this.v3;
    point.set(
      CubicBezier(t2, v0.x, v1.x, v22.x, v3.x),
      CubicBezier(t2, v0.y, v1.y, v22.y, v3.y)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
}
class CubicBezierCurve3 extends Curve {
  constructor(v0 = new Vector3(), v1 = new Vector3(), v22 = new Vector3(), v3 = new Vector3()) {
    super();
    this.isCubicBezierCurve3 = true;
    this.type = "CubicBezierCurve3";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v22;
    this.v3 = v3;
  }
  getPoint(t2, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v22 = this.v2, v3 = this.v3;
    point.set(
      CubicBezier(t2, v0.x, v1.x, v22.x, v3.x),
      CubicBezier(t2, v0.y, v1.y, v22.y, v3.y),
      CubicBezier(t2, v0.z, v1.z, v22.z, v3.z)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
}
class LineCurve extends Curve {
  constructor(v1 = new Vector2(), v22 = new Vector2()) {
    super();
    this.isLineCurve = true;
    this.type = "LineCurve";
    this.v1 = v1;
    this.v2 = v22;
  }
  getPoint(t2, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    if (t2 === 1) {
      point.copy(this.v2);
    } else {
      point.copy(this.v2).sub(this.v1);
      point.multiplyScalar(t2).add(this.v1);
    }
    return point;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(u2, optionalTarget) {
    return this.getPoint(u2, optionalTarget);
  }
  getTangent(t2, optionalTarget = new Vector2()) {
    return optionalTarget.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(u2, optionalTarget) {
    return this.getTangent(u2, optionalTarget);
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
class LineCurve3 extends Curve {
  constructor(v1 = new Vector3(), v22 = new Vector3()) {
    super();
    this.isLineCurve3 = true;
    this.type = "LineCurve3";
    this.v1 = v1;
    this.v2 = v22;
  }
  getPoint(t2, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    if (t2 === 1) {
      point.copy(this.v2);
    } else {
      point.copy(this.v2).sub(this.v1);
      point.multiplyScalar(t2).add(this.v1);
    }
    return point;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(u2, optionalTarget) {
    return this.getPoint(u2, optionalTarget);
  }
  getTangent(t2, optionalTarget = new Vector3()) {
    return optionalTarget.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(u2, optionalTarget) {
    return this.getTangent(u2, optionalTarget);
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
class QuadraticBezierCurve extends Curve {
  constructor(v0 = new Vector2(), v1 = new Vector2(), v22 = new Vector2()) {
    super();
    this.isQuadraticBezierCurve = true;
    this.type = "QuadraticBezierCurve";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v22;
  }
  getPoint(t2, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v22 = this.v2;
    point.set(
      QuadraticBezier(t2, v0.x, v1.x, v22.x),
      QuadraticBezier(t2, v0.y, v1.y, v22.y)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
class QuadraticBezierCurve3 extends Curve {
  constructor(v0 = new Vector3(), v1 = new Vector3(), v22 = new Vector3()) {
    super();
    this.isQuadraticBezierCurve3 = true;
    this.type = "QuadraticBezierCurve3";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v22;
  }
  getPoint(t2, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v22 = this.v2;
    point.set(
      QuadraticBezier(t2, v0.x, v1.x, v22.x),
      QuadraticBezier(t2, v0.y, v1.y, v22.y),
      QuadraticBezier(t2, v0.z, v1.z, v22.z)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
class SplineCurve extends Curve {
  constructor(points = []) {
    super();
    this.isSplineCurve = true;
    this.type = "SplineCurve";
    this.points = points;
  }
  getPoint(t2, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const points = this.points;
    const p3 = (points.length - 1) * t2;
    const intPoint = Math.floor(p3);
    const weight = p3 - intPoint;
    const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
    const p1 = points[intPoint];
    const p22 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
    const p32 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
    point.set(
      CatmullRom(weight, p0.x, p1.x, p22.x, p32.x),
      CatmullRom(weight, p0.y, p1.y, p22.y, p32.y)
    );
    return point;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
      const point = source.points[i2];
      this.points.push(point.clone());
    }
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.points = [];
    for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
      const point = this.points[i2];
      data.points.push(point.toArray());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
      const point = json.points[i2];
      this.points.push(new Vector2().fromArray(point));
    }
    return this;
  }
}
var Curves = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcCurve,
  CatmullRomCurve3,
  CubicBezierCurve,
  CubicBezierCurve3,
  EllipseCurve,
  LineCurve,
  LineCurve3,
  QuadraticBezierCurve,
  QuadraticBezierCurve3,
  SplineCurve
});
class CurvePath extends Curve {
  constructor() {
    super();
    this.type = "CurvePath";
    this.curves = [];
    this.autoClose = false;
  }
  add(curve) {
    this.curves.push(curve);
  }
  closePath() {
    const startPoint = this.curves[0].getPoint(0);
    const endPoint = this.curves[this.curves.length - 1].getPoint(1);
    if (!startPoint.equals(endPoint)) {
      const lineType = startPoint.isVector2 === true ? "LineCurve" : "LineCurve3";
      this.curves.push(new Curves[lineType](endPoint, startPoint));
    }
    return this;
  }
  // To get accurate point with reference to
  // entire path distance at time t,
  // following has to be done:
  // 1. Length of each sub path have to be known
  // 2. Locate and identify type of curve
  // 3. Get t for the curve
  // 4. Return curve.getPointAt(t')
  getPoint(t2, optionalTarget) {
    const d3 = t2 * this.getLength();
    const curveLengths = this.getCurveLengths();
    let i2 = 0;
    while (i2 < curveLengths.length) {
      if (curveLengths[i2] >= d3) {
        const diff = curveLengths[i2] - d3;
        const curve = this.curves[i2];
        const segmentLength = curve.getLength();
        const u2 = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
        return curve.getPointAt(u2, optionalTarget);
      }
      i2++;
    }
    return null;
  }
  // We cannot use the default THREE.Curve getPoint() with getLength() because in
  // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
  // getPoint() depends on getLength
  getLength() {
    const lens = this.getCurveLengths();
    return lens[lens.length - 1];
  }
  // cacheLengths must be recalculated.
  updateArcLengths() {
    this.needsUpdate = true;
    this.cacheLengths = null;
    this.getCurveLengths();
  }
  // Compute lengths and cache them
  // We cannot overwrite getLengths() because UtoT mapping uses it.
  getCurveLengths() {
    if (this.cacheLengths && this.cacheLengths.length === this.curves.length) {
      return this.cacheLengths;
    }
    const lengths = [];
    let sums = 0;
    for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
      sums += this.curves[i2].getLength();
      lengths.push(sums);
    }
    this.cacheLengths = lengths;
    return lengths;
  }
  getSpacedPoints(divisions = 40) {
    const points = [];
    for (let i2 = 0; i2 <= divisions; i2++) {
      points.push(this.getPoint(i2 / divisions));
    }
    if (this.autoClose) {
      points.push(points[0]);
    }
    return points;
  }
  getPoints(divisions = 12) {
    const points = [];
    let last;
    for (let i2 = 0, curves = this.curves; i2 < curves.length; i2++) {
      const curve = curves[i2];
      const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
      const pts = curve.getPoints(resolution);
      for (let j3 = 0; j3 < pts.length; j3++) {
        const point = pts[j3];
        if (last && last.equals(point)) continue;
        points.push(point);
        last = point;
      }
    }
    if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) {
      points.push(points[0]);
    }
    return points;
  }
  copy(source) {
    super.copy(source);
    this.curves = [];
    for (let i2 = 0, l2 = source.curves.length; i2 < l2; i2++) {
      const curve = source.curves[i2];
      this.curves.push(curve.clone());
    }
    this.autoClose = source.autoClose;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.autoClose = this.autoClose;
    data.curves = [];
    for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
      const curve = this.curves[i2];
      data.curves.push(curve.toJSON());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.autoClose = json.autoClose;
    this.curves = [];
    for (let i2 = 0, l2 = json.curves.length; i2 < l2; i2++) {
      const curve = json.curves[i2];
      this.curves.push(new Curves[curve.type]().fromJSON(curve));
    }
    return this;
  }
}
class Path extends CurvePath {
  constructor(points) {
    super();
    this.type = "Path";
    this.currentPoint = new Vector2();
    if (points) {
      this.setFromPoints(points);
    }
  }
  setFromPoints(points) {
    this.moveTo(points[0].x, points[0].y);
    for (let i2 = 1, l2 = points.length; i2 < l2; i2++) {
      this.lineTo(points[i2].x, points[i2].y);
    }
    return this;
  }
  moveTo(x3, y2) {
    this.currentPoint.set(x3, y2);
    return this;
  }
  lineTo(x3, y2) {
    const curve = new LineCurve(this.currentPoint.clone(), new Vector2(x3, y2));
    this.curves.push(curve);
    this.currentPoint.set(x3, y2);
    return this;
  }
  quadraticCurveTo(aCPx, aCPy, aX, aY) {
    const curve = new QuadraticBezierCurve(
      this.currentPoint.clone(),
      new Vector2(aCPx, aCPy),
      new Vector2(aX, aY)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX, aY);
    return this;
  }
  bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
    const curve = new CubicBezierCurve(
      this.currentPoint.clone(),
      new Vector2(aCP1x, aCP1y),
      new Vector2(aCP2x, aCP2y),
      new Vector2(aX, aY)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX, aY);
    return this;
  }
  splineThru(pts) {
    const npts = [this.currentPoint.clone()].concat(pts);
    const curve = new SplineCurve(npts);
    this.curves.push(curve);
    this.currentPoint.copy(pts[pts.length - 1]);
    return this;
  }
  arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    const x0 = this.currentPoint.x;
    const y0 = this.currentPoint.y;
    this.absarc(
      aX + x0,
      aY + y0,
      aRadius,
      aStartAngle,
      aEndAngle,
      aClockwise
    );
    return this;
  }
  absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    return this;
  }
  ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const x0 = this.currentPoint.x;
    const y0 = this.currentPoint.y;
    this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    return this;
  }
  absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const curve = new EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    if (this.curves.length > 0) {
      const firstPoint = curve.getPoint(0);
      if (!firstPoint.equals(this.currentPoint)) {
        this.lineTo(firstPoint.x, firstPoint.y);
      }
    }
    this.curves.push(curve);
    const lastPoint = curve.getPoint(1);
    this.currentPoint.copy(lastPoint);
    return this;
  }
  copy(source) {
    super.copy(source);
    this.currentPoint.copy(source.currentPoint);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.currentPoint = this.currentPoint.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.currentPoint.fromArray(json.currentPoint);
    return this;
  }
}
class LatheGeometry extends BufferGeometry {
  constructor(points = [new Vector2(0, -0.5), new Vector2(0.5, 0), new Vector2(0, 0.5)], segments = 12, phiStart = 0, phiLength = Math.PI * 2) {
    super();
    this.type = "LatheGeometry";
    this.parameters = {
      points,
      segments,
      phiStart,
      phiLength
    };
    segments = Math.floor(segments);
    phiLength = clamp$4(phiLength, 0, Math.PI * 2);
    const indices = [];
    const vertices = [];
    const uvs = [];
    const initNormals = [];
    const normals = [];
    const inverseSegments = 1 / segments;
    const vertex2 = new Vector3();
    const uv = new Vector2();
    const normal = new Vector3();
    const curNormal = new Vector3();
    const prevNormal = new Vector3();
    let dx = 0;
    let dy = 0;
    for (let j3 = 0; j3 <= points.length - 1; j3++) {
      switch (j3) {
        case 0:
          dx = points[j3 + 1].x - points[j3].x;
          dy = points[j3 + 1].y - points[j3].y;
          normal.x = dy * 1;
          normal.y = -dx;
          normal.z = dy * 0;
          prevNormal.copy(normal);
          normal.normalize();
          initNormals.push(normal.x, normal.y, normal.z);
          break;
        case points.length - 1:
          initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
          break;
        default:
          dx = points[j3 + 1].x - points[j3].x;
          dy = points[j3 + 1].y - points[j3].y;
          normal.x = dy * 1;
          normal.y = -dx;
          normal.z = dy * 0;
          curNormal.copy(normal);
          normal.x += prevNormal.x;
          normal.y += prevNormal.y;
          normal.z += prevNormal.z;
          normal.normalize();
          initNormals.push(normal.x, normal.y, normal.z);
          prevNormal.copy(curNormal);
      }
    }
    for (let i2 = 0; i2 <= segments; i2++) {
      const phi = phiStart + i2 * inverseSegments * phiLength;
      const sin = Math.sin(phi);
      const cos = Math.cos(phi);
      for (let j3 = 0; j3 <= points.length - 1; j3++) {
        vertex2.x = points[j3].x * sin;
        vertex2.y = points[j3].y;
        vertex2.z = points[j3].x * cos;
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        uv.x = i2 / segments;
        uv.y = j3 / (points.length - 1);
        uvs.push(uv.x, uv.y);
        const x3 = initNormals[3 * j3 + 0] * sin;
        const y2 = initNormals[3 * j3 + 1];
        const z2 = initNormals[3 * j3 + 0] * cos;
        normals.push(x3, y2, z2);
      }
    }
    for (let i2 = 0; i2 < segments; i2++) {
      for (let j3 = 0; j3 < points.length - 1; j3++) {
        const base = j3 + i2 * points.length;
        const a5 = base;
        const b6 = base + points.length;
        const c2 = base + points.length + 1;
        const d3 = base + 1;
        indices.push(a5, b6, d3);
        indices.push(c2, d3, b6);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new LatheGeometry(data.points, data.segments, data.phiStart, data.phiLength);
  }
}
class CapsuleGeometry extends LatheGeometry {
  constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8) {
    const path = new Path();
    path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
    path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
    super(path.getPoints(capSegments), radialSegments);
    this.type = "CapsuleGeometry";
    this.parameters = {
      radius,
      length,
      capSegments,
      radialSegments
    };
  }
  static fromJSON(data) {
    return new CapsuleGeometry(data.radius, data.length, data.capSegments, data.radialSegments);
  }
}
class CircleGeometry extends BufferGeometry {
  constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "CircleGeometry";
    this.parameters = {
      radius,
      segments,
      thetaStart,
      thetaLength
    };
    segments = Math.max(3, segments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const vertex2 = new Vector3();
    const uv = new Vector2();
    vertices.push(0, 0, 0);
    normals.push(0, 0, 1);
    uvs.push(0.5, 0.5);
    for (let s2 = 0, i2 = 3; s2 <= segments; s2++, i2 += 3) {
      const segment = thetaStart + s2 / segments * thetaLength;
      vertex2.x = radius * Math.cos(segment);
      vertex2.y = radius * Math.sin(segment);
      vertices.push(vertex2.x, vertex2.y, vertex2.z);
      normals.push(0, 0, 1);
      uv.x = (vertices[i2] / radius + 1) / 2;
      uv.y = (vertices[i2 + 1] / radius + 1) / 2;
      uvs.push(uv.x, uv.y);
    }
    for (let i2 = 1; i2 <= segments; i2++) {
      indices.push(i2, i2 + 1, 0);
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new CircleGeometry(data.radius, data.segments, data.thetaStart, data.thetaLength);
  }
}
class CylinderGeometry extends BufferGeometry {
  constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "CylinderGeometry";
    this.parameters = {
      radiusTop,
      radiusBottom,
      height,
      radialSegments,
      heightSegments,
      openEnded,
      thetaStart,
      thetaLength
    };
    const scope = this;
    radialSegments = Math.floor(radialSegments);
    heightSegments = Math.floor(heightSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let index = 0;
    const indexArray = [];
    const halfHeight = height / 2;
    let groupStart = 0;
    generateTorso();
    if (openEnded === false) {
      if (radiusTop > 0) generateCap(true);
      if (radiusBottom > 0) generateCap(false);
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function generateTorso() {
      const normal = new Vector3();
      const vertex2 = new Vector3();
      let groupCount = 0;
      const slope = (radiusBottom - radiusTop) / height;
      for (let y2 = 0; y2 <= heightSegments; y2++) {
        const indexRow = [];
        const v3 = y2 / heightSegments;
        const radius = v3 * (radiusBottom - radiusTop) + radiusTop;
        for (let x3 = 0; x3 <= radialSegments; x3++) {
          const u2 = x3 / radialSegments;
          const theta = u2 * thetaLength + thetaStart;
          const sinTheta = Math.sin(theta);
          const cosTheta = Math.cos(theta);
          vertex2.x = radius * sinTheta;
          vertex2.y = -v3 * height + halfHeight;
          vertex2.z = radius * cosTheta;
          vertices.push(vertex2.x, vertex2.y, vertex2.z);
          normal.set(sinTheta, slope, cosTheta).normalize();
          normals.push(normal.x, normal.y, normal.z);
          uvs.push(u2, 1 - v3);
          indexRow.push(index++);
        }
        indexArray.push(indexRow);
      }
      for (let x3 = 0; x3 < radialSegments; x3++) {
        for (let y2 = 0; y2 < heightSegments; y2++) {
          const a5 = indexArray[y2][x3];
          const b6 = indexArray[y2 + 1][x3];
          const c2 = indexArray[y2 + 1][x3 + 1];
          const d3 = indexArray[y2][x3 + 1];
          if (radiusTop > 0 || y2 !== 0) {
            indices.push(a5, b6, d3);
            groupCount += 3;
          }
          if (radiusBottom > 0 || y2 !== heightSegments - 1) {
            indices.push(b6, c2, d3);
            groupCount += 3;
          }
        }
      }
      scope.addGroup(groupStart, groupCount, 0);
      groupStart += groupCount;
    }
    function generateCap(top) {
      const centerIndexStart = index;
      const uv = new Vector2();
      const vertex2 = new Vector3();
      let groupCount = 0;
      const radius = top === true ? radiusTop : radiusBottom;
      const sign2 = top === true ? 1 : -1;
      for (let x3 = 1; x3 <= radialSegments; x3++) {
        vertices.push(0, halfHeight * sign2, 0);
        normals.push(0, sign2, 0);
        uvs.push(0.5, 0.5);
        index++;
      }
      const centerIndexEnd = index;
      for (let x3 = 0; x3 <= radialSegments; x3++) {
        const u2 = x3 / radialSegments;
        const theta = u2 * thetaLength + thetaStart;
        const cosTheta = Math.cos(theta);
        const sinTheta = Math.sin(theta);
        vertex2.x = radius * sinTheta;
        vertex2.y = halfHeight * sign2;
        vertex2.z = radius * cosTheta;
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normals.push(0, sign2, 0);
        uv.x = cosTheta * 0.5 + 0.5;
        uv.y = sinTheta * 0.5 * sign2 + 0.5;
        uvs.push(uv.x, uv.y);
        index++;
      }
      for (let x3 = 0; x3 < radialSegments; x3++) {
        const c2 = centerIndexStart + x3;
        const i2 = centerIndexEnd + x3;
        if (top === true) {
          indices.push(i2, i2 + 1, c2);
        } else {
          indices.push(i2 + 1, i2, c2);
        }
        groupCount += 3;
      }
      scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
      groupStart += groupCount;
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
  }
}
class ConeGeometry extends CylinderGeometry {
  constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
    super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    this.type = "ConeGeometry";
    this.parameters = {
      radius,
      height,
      radialSegments,
      heightSegments,
      openEnded,
      thetaStart,
      thetaLength
    };
  }
  static fromJSON(data) {
    return new ConeGeometry(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
  }
}
class PolyhedronGeometry extends BufferGeometry {
  constructor(vertices = [], indices = [], radius = 1, detail = 0) {
    super();
    this.type = "PolyhedronGeometry";
    this.parameters = {
      vertices,
      indices,
      radius,
      detail
    };
    const vertexBuffer = [];
    const uvBuffer = [];
    subdivide(detail);
    applyRadius(radius);
    generateUVs();
    this.setAttribute("position", new Float32BufferAttribute(vertexBuffer, 3));
    this.setAttribute("normal", new Float32BufferAttribute(vertexBuffer.slice(), 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvBuffer, 2));
    if (detail === 0) {
      this.computeVertexNormals();
    } else {
      this.normalizeNormals();
    }
    function subdivide(detail2) {
      const a5 = new Vector3();
      const b6 = new Vector3();
      const c2 = new Vector3();
      for (let i2 = 0; i2 < indices.length; i2 += 3) {
        getVertexByIndex(indices[i2 + 0], a5);
        getVertexByIndex(indices[i2 + 1], b6);
        getVertexByIndex(indices[i2 + 2], c2);
        subdivideFace(a5, b6, c2, detail2);
      }
    }
    function subdivideFace(a5, b6, c2, detail2) {
      const cols = detail2 + 1;
      const v3 = [];
      for (let i2 = 0; i2 <= cols; i2++) {
        v3[i2] = [];
        const aj = a5.clone().lerp(c2, i2 / cols);
        const bj = b6.clone().lerp(c2, i2 / cols);
        const rows = cols - i2;
        for (let j3 = 0; j3 <= rows; j3++) {
          if (j3 === 0 && i2 === cols) {
            v3[i2][j3] = aj;
          } else {
            v3[i2][j3] = aj.clone().lerp(bj, j3 / rows);
          }
        }
      }
      for (let i2 = 0; i2 < cols; i2++) {
        for (let j3 = 0; j3 < 2 * (cols - i2) - 1; j3++) {
          const k2 = Math.floor(j3 / 2);
          if (j3 % 2 === 0) {
            pushVertex(v3[i2][k2 + 1]);
            pushVertex(v3[i2 + 1][k2]);
            pushVertex(v3[i2][k2]);
          } else {
            pushVertex(v3[i2][k2 + 1]);
            pushVertex(v3[i2 + 1][k2 + 1]);
            pushVertex(v3[i2 + 1][k2]);
          }
        }
      }
    }
    function applyRadius(radius2) {
      const vertex2 = new Vector3();
      for (let i2 = 0; i2 < vertexBuffer.length; i2 += 3) {
        vertex2.x = vertexBuffer[i2 + 0];
        vertex2.y = vertexBuffer[i2 + 1];
        vertex2.z = vertexBuffer[i2 + 2];
        vertex2.normalize().multiplyScalar(radius2);
        vertexBuffer[i2 + 0] = vertex2.x;
        vertexBuffer[i2 + 1] = vertex2.y;
        vertexBuffer[i2 + 2] = vertex2.z;
      }
    }
    function generateUVs() {
      const vertex2 = new Vector3();
      for (let i2 = 0; i2 < vertexBuffer.length; i2 += 3) {
        vertex2.x = vertexBuffer[i2 + 0];
        vertex2.y = vertexBuffer[i2 + 1];
        vertex2.z = vertexBuffer[i2 + 2];
        const u2 = azimuth(vertex2) / 2 / Math.PI + 0.5;
        const v3 = inclination(vertex2) / Math.PI + 0.5;
        uvBuffer.push(u2, 1 - v3);
      }
      correctUVs();
      correctSeam();
    }
    function correctSeam() {
      for (let i2 = 0; i2 < uvBuffer.length; i2 += 6) {
        const x0 = uvBuffer[i2 + 0];
        const x1 = uvBuffer[i2 + 2];
        const x22 = uvBuffer[i2 + 4];
        const max2 = Math.max(x0, x1, x22);
        const min = Math.min(x0, x1, x22);
        if (max2 > 0.9 && min < 0.1) {
          if (x0 < 0.2) uvBuffer[i2 + 0] += 1;
          if (x1 < 0.2) uvBuffer[i2 + 2] += 1;
          if (x22 < 0.2) uvBuffer[i2 + 4] += 1;
        }
      }
    }
    function pushVertex(vertex2) {
      vertexBuffer.push(vertex2.x, vertex2.y, vertex2.z);
    }
    function getVertexByIndex(index, vertex2) {
      const stride = index * 3;
      vertex2.x = vertices[stride + 0];
      vertex2.y = vertices[stride + 1];
      vertex2.z = vertices[stride + 2];
    }
    function correctUVs() {
      const a5 = new Vector3();
      const b6 = new Vector3();
      const c2 = new Vector3();
      const centroid = new Vector3();
      const uvA = new Vector2();
      const uvB = new Vector2();
      const uvC = new Vector2();
      for (let i2 = 0, j3 = 0; i2 < vertexBuffer.length; i2 += 9, j3 += 6) {
        a5.set(vertexBuffer[i2 + 0], vertexBuffer[i2 + 1], vertexBuffer[i2 + 2]);
        b6.set(vertexBuffer[i2 + 3], vertexBuffer[i2 + 4], vertexBuffer[i2 + 5]);
        c2.set(vertexBuffer[i2 + 6], vertexBuffer[i2 + 7], vertexBuffer[i2 + 8]);
        uvA.set(uvBuffer[j3 + 0], uvBuffer[j3 + 1]);
        uvB.set(uvBuffer[j3 + 2], uvBuffer[j3 + 3]);
        uvC.set(uvBuffer[j3 + 4], uvBuffer[j3 + 5]);
        centroid.copy(a5).add(b6).add(c2).divideScalar(3);
        const azi = azimuth(centroid);
        correctUV(uvA, j3 + 0, a5, azi);
        correctUV(uvB, j3 + 2, b6, azi);
        correctUV(uvC, j3 + 4, c2, azi);
      }
    }
    function correctUV(uv, stride, vector, azimuth2) {
      if (azimuth2 < 0 && uv.x === 1) {
        uvBuffer[stride] = uv.x - 1;
      }
      if (vector.x === 0 && vector.z === 0) {
        uvBuffer[stride] = azimuth2 / 2 / Math.PI + 0.5;
      }
    }
    function azimuth(vector) {
      return Math.atan2(vector.z, -vector.x);
    }
    function inclination(vector) {
      return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new PolyhedronGeometry(data.vertices, data.indices, data.radius, data.details);
  }
}
class DodecahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const t2 = (1 + Math.sqrt(5)) / 2;
    const r3 = 1 / t2;
    const vertices = [
      // (±1, ±1, ±1)
      -1,
      -1,
      -1,
      -1,
      -1,
      1,
      -1,
      1,
      -1,
      -1,
      1,
      1,
      1,
      -1,
      -1,
      1,
      -1,
      1,
      1,
      1,
      -1,
      1,
      1,
      1,
      // (0, ±1/φ, ±φ)
      0,
      -r3,
      -t2,
      0,
      -r3,
      t2,
      0,
      r3,
      -t2,
      0,
      r3,
      t2,
      // (±1/φ, ±φ, 0)
      -r3,
      -t2,
      0,
      -r3,
      t2,
      0,
      r3,
      -t2,
      0,
      r3,
      t2,
      0,
      // (±φ, 0, ±1/φ)
      -t2,
      0,
      -r3,
      t2,
      0,
      -r3,
      -t2,
      0,
      r3,
      t2,
      0,
      r3
    ];
    const indices = [
      3,
      11,
      7,
      3,
      7,
      15,
      3,
      15,
      13,
      7,
      19,
      17,
      7,
      17,
      6,
      7,
      6,
      15,
      17,
      4,
      8,
      17,
      8,
      10,
      17,
      10,
      6,
      8,
      0,
      16,
      8,
      16,
      2,
      8,
      2,
      10,
      0,
      12,
      1,
      0,
      1,
      18,
      0,
      18,
      16,
      6,
      10,
      2,
      6,
      2,
      13,
      6,
      13,
      15,
      2,
      16,
      18,
      2,
      18,
      3,
      2,
      3,
      13,
      18,
      1,
      9,
      18,
      9,
      11,
      18,
      11,
      3,
      4,
      14,
      12,
      4,
      12,
      0,
      4,
      0,
      8,
      11,
      9,
      5,
      11,
      5,
      19,
      11,
      19,
      7,
      19,
      5,
      14,
      19,
      14,
      4,
      19,
      4,
      17,
      1,
      12,
      14,
      1,
      14,
      5,
      1,
      5,
      9
    ];
    super(vertices, indices, radius, detail);
    this.type = "DodecahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data) {
    return new DodecahedronGeometry(data.radius, data.detail);
  }
}
const _v0$3 = /* @__PURE__ */ new Vector3();
const _v1$1 = /* @__PURE__ */ new Vector3();
const _normal = /* @__PURE__ */ new Vector3();
const _triangle = /* @__PURE__ */ new Triangle();
class EdgesGeometry extends BufferGeometry {
  constructor(geometry = null, thresholdAngle = 1) {
    super();
    this.type = "EdgesGeometry";
    this.parameters = {
      geometry,
      thresholdAngle
    };
    if (geometry !== null) {
      const precisionPoints = 4;
      const precision = Math.pow(10, precisionPoints);
      const thresholdDot = Math.cos(DEG2RAD$2 * thresholdAngle);
      const indexAttr = geometry.getIndex();
      const positionAttr = geometry.getAttribute("position");
      const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
      const indexArr = [0, 0, 0];
      const vertKeys = ["a", "b", "c"];
      const hashes = new Array(3);
      const edgeData = {};
      const vertices = [];
      for (let i2 = 0; i2 < indexCount; i2 += 3) {
        if (indexAttr) {
          indexArr[0] = indexAttr.getX(i2);
          indexArr[1] = indexAttr.getX(i2 + 1);
          indexArr[2] = indexAttr.getX(i2 + 2);
        } else {
          indexArr[0] = i2;
          indexArr[1] = i2 + 1;
          indexArr[2] = i2 + 2;
        }
        const { a: a5, b: b6, c: c2 } = _triangle;
        a5.fromBufferAttribute(positionAttr, indexArr[0]);
        b6.fromBufferAttribute(positionAttr, indexArr[1]);
        c2.fromBufferAttribute(positionAttr, indexArr[2]);
        _triangle.getNormal(_normal);
        hashes[0] = `${Math.round(a5.x * precision)},${Math.round(a5.y * precision)},${Math.round(a5.z * precision)}`;
        hashes[1] = `${Math.round(b6.x * precision)},${Math.round(b6.y * precision)},${Math.round(b6.z * precision)}`;
        hashes[2] = `${Math.round(c2.x * precision)},${Math.round(c2.y * precision)},${Math.round(c2.z * precision)}`;
        if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) {
          continue;
        }
        for (let j3 = 0; j3 < 3; j3++) {
          const jNext = (j3 + 1) % 3;
          const vecHash0 = hashes[j3];
          const vecHash1 = hashes[jNext];
          const v0 = _triangle[vertKeys[j3]];
          const v1 = _triangle[vertKeys[jNext]];
          const hash = `${vecHash0}_${vecHash1}`;
          const reverseHash = `${vecHash1}_${vecHash0}`;
          if (reverseHash in edgeData && edgeData[reverseHash]) {
            if (_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
              vertices.push(v0.x, v0.y, v0.z);
              vertices.push(v1.x, v1.y, v1.z);
            }
            edgeData[reverseHash] = null;
          } else if (!(hash in edgeData)) {
            edgeData[hash] = {
              index0: indexArr[j3],
              index1: indexArr[jNext],
              normal: _normal.clone()
            };
          }
        }
      }
      for (const key in edgeData) {
        if (edgeData[key]) {
          const { index0, index1 } = edgeData[key];
          _v0$3.fromBufferAttribute(positionAttr, index0);
          _v1$1.fromBufferAttribute(positionAttr, index1);
          vertices.push(_v0$3.x, _v0$3.y, _v0$3.z);
          vertices.push(_v1$1.x, _v1$1.y, _v1$1.z);
        }
      }
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
}
class Shape extends Path {
  constructor(points) {
    super(points);
    this.uuid = generateUUID$1();
    this.type = "Shape";
    this.holes = [];
  }
  getPointsHoles(divisions) {
    const holesPts = [];
    for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
      holesPts[i2] = this.holes[i2].getPoints(divisions);
    }
    return holesPts;
  }
  // get points of shape and holes (keypoints based on segments parameter)
  extractPoints(divisions) {
    return {
      shape: this.getPoints(divisions),
      holes: this.getPointsHoles(divisions)
    };
  }
  copy(source) {
    super.copy(source);
    this.holes = [];
    for (let i2 = 0, l2 = source.holes.length; i2 < l2; i2++) {
      const hole = source.holes[i2];
      this.holes.push(hole.clone());
    }
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.uuid = this.uuid;
    data.holes = [];
    for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
      const hole = this.holes[i2];
      data.holes.push(hole.toJSON());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.uuid = json.uuid;
    this.holes = [];
    for (let i2 = 0, l2 = json.holes.length; i2 < l2; i2++) {
      const hole = json.holes[i2];
      this.holes.push(new Path().fromJSON(hole));
    }
    return this;
  }
}
const Earcut = {
  triangulate: function(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, maxX, maxY, x3, y2, invSize;
    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
    if (data.length > 80 * dim) {
      minX = maxX = data[0];
      minY = maxY = data[1];
      for (let i2 = dim; i2 < outerLen; i2 += dim) {
        x3 = data[i2];
        y2 = data[i2 + 1];
        if (x3 < minX) minX = x3;
        if (y2 < minY) minY = y2;
        if (x3 > maxX) maxX = x3;
        if (y2 > maxY) maxY = y2;
      }
      invSize = Math.max(maxX - minX, maxY - minY);
      invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
  }
};
function linkedList(data, start2, end, dim, clockwise) {
  let i2, last;
  if (clockwise === signedArea(data, start2, end, dim) > 0) {
    for (i2 = start2; i2 < end; i2 += dim) last = insertNode(i2, data[i2], data[i2 + 1], last);
  } else {
    for (i2 = end - dim; i2 >= start2; i2 -= dim) last = insertNode(i2, data[i2], data[i2 + 1], last);
  }
  if (last && equals(last, last.next)) {
    removeNode(last);
    last = last.next;
  }
  return last;
}
function filterPoints(start2, end) {
  if (!start2) return start2;
  if (!end) end = start2;
  let p3 = start2, again;
  do {
    again = false;
    if (!p3.steiner && (equals(p3, p3.next) || area(p3.prev, p3, p3.next) === 0)) {
      removeNode(p3);
      p3 = end = p3.prev;
      if (p3 === p3.next) break;
      again = true;
    } else {
      p3 = p3.next;
    }
  } while (again || p3 !== end);
  return end;
}
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
  if (!ear) return;
  if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
  let stop2 = ear, prev, next;
  while (ear.prev !== ear.next) {
    prev = ear.prev;
    next = ear.next;
    if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
      triangles.push(prev.i / dim | 0);
      triangles.push(ear.i / dim | 0);
      triangles.push(next.i / dim | 0);
      removeNode(ear);
      ear = next.next;
      stop2 = next.next;
      continue;
    }
    ear = next;
    if (ear === stop2) {
      if (!pass) {
        earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
      } else if (pass === 1) {
        ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
        earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
      } else if (pass === 2) {
        splitEarcut(ear, triangles, dim, minX, minY, invSize);
      }
      break;
    }
  }
}
function isEar(ear) {
  const a5 = ear.prev, b6 = ear, c2 = ear.next;
  if (area(a5, b6, c2) >= 0) return false;
  const ax = a5.x, bx = b6.x, cx = c2.x, ay = a5.y, by = b6.y, cy = c2.y;
  const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
  let p3 = c2.next;
  while (p3 !== a5) {
    if (p3.x >= x0 && p3.x <= x1 && p3.y >= y0 && p3.y <= y1 && pointInTriangle(ax, ay, bx, by, cx, cy, p3.x, p3.y) && area(p3.prev, p3, p3.next) >= 0) return false;
    p3 = p3.next;
  }
  return true;
}
function isEarHashed(ear, minX, minY, invSize) {
  const a5 = ear.prev, b6 = ear, c2 = ear.next;
  if (area(a5, b6, c2) >= 0) return false;
  const ax = a5.x, bx = b6.x, cx = c2.x, ay = a5.y, by = b6.y, cy = c2.y;
  const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
  const minZ = zOrder(x0, y0, minX, minY, invSize), maxZ = zOrder(x1, y1, minX, minY, invSize);
  let p3 = ear.prevZ, n2 = ear.nextZ;
  while (p3 && p3.z >= minZ && n2 && n2.z <= maxZ) {
    if (p3.x >= x0 && p3.x <= x1 && p3.y >= y0 && p3.y <= y1 && p3 !== a5 && p3 !== c2 && pointInTriangle(ax, ay, bx, by, cx, cy, p3.x, p3.y) && area(p3.prev, p3, p3.next) >= 0) return false;
    p3 = p3.prevZ;
    if (n2.x >= x0 && n2.x <= x1 && n2.y >= y0 && n2.y <= y1 && n2 !== a5 && n2 !== c2 && pointInTriangle(ax, ay, bx, by, cx, cy, n2.x, n2.y) && area(n2.prev, n2, n2.next) >= 0) return false;
    n2 = n2.nextZ;
  }
  while (p3 && p3.z >= minZ) {
    if (p3.x >= x0 && p3.x <= x1 && p3.y >= y0 && p3.y <= y1 && p3 !== a5 && p3 !== c2 && pointInTriangle(ax, ay, bx, by, cx, cy, p3.x, p3.y) && area(p3.prev, p3, p3.next) >= 0) return false;
    p3 = p3.prevZ;
  }
  while (n2 && n2.z <= maxZ) {
    if (n2.x >= x0 && n2.x <= x1 && n2.y >= y0 && n2.y <= y1 && n2 !== a5 && n2 !== c2 && pointInTriangle(ax, ay, bx, by, cx, cy, n2.x, n2.y) && area(n2.prev, n2, n2.next) >= 0) return false;
    n2 = n2.nextZ;
  }
  return true;
}
function cureLocalIntersections(start2, triangles, dim) {
  let p3 = start2;
  do {
    const a5 = p3.prev, b6 = p3.next.next;
    if (!equals(a5, b6) && intersects(a5, p3, p3.next, b6) && locallyInside(a5, b6) && locallyInside(b6, a5)) {
      triangles.push(a5.i / dim | 0);
      triangles.push(p3.i / dim | 0);
      triangles.push(b6.i / dim | 0);
      removeNode(p3);
      removeNode(p3.next);
      p3 = start2 = b6;
    }
    p3 = p3.next;
  } while (p3 !== start2);
  return filterPoints(p3);
}
function splitEarcut(start2, triangles, dim, minX, minY, invSize) {
  let a5 = start2;
  do {
    let b6 = a5.next.next;
    while (b6 !== a5.prev) {
      if (a5.i !== b6.i && isValidDiagonal(a5, b6)) {
        let c2 = splitPolygon(a5, b6);
        a5 = filterPoints(a5, a5.next);
        c2 = filterPoints(c2, c2.next);
        earcutLinked(a5, triangles, dim, minX, minY, invSize, 0);
        earcutLinked(c2, triangles, dim, minX, minY, invSize, 0);
        return;
      }
      b6 = b6.next;
    }
    a5 = a5.next;
  } while (a5 !== start2);
}
function eliminateHoles(data, holeIndices, outerNode, dim) {
  const queue2 = [];
  let i2, len, start2, end, list;
  for (i2 = 0, len = holeIndices.length; i2 < len; i2++) {
    start2 = holeIndices[i2] * dim;
    end = i2 < len - 1 ? holeIndices[i2 + 1] * dim : data.length;
    list = linkedList(data, start2, end, dim, false);
    if (list === list.next) list.steiner = true;
    queue2.push(getLeftmost(list));
  }
  queue2.sort(compareX);
  for (i2 = 0; i2 < queue2.length; i2++) {
    outerNode = eliminateHole(queue2[i2], outerNode);
  }
  return outerNode;
}
function compareX(a5, b6) {
  return a5.x - b6.x;
}
function eliminateHole(hole, outerNode) {
  const bridge = findHoleBridge(hole, outerNode);
  if (!bridge) {
    return outerNode;
  }
  const bridgeReverse = splitPolygon(bridge, hole);
  filterPoints(bridgeReverse, bridgeReverse.next);
  return filterPoints(bridge, bridge.next);
}
function findHoleBridge(hole, outerNode) {
  let p3 = outerNode, qx = -Infinity, m2;
  const hx = hole.x, hy = hole.y;
  do {
    if (hy <= p3.y && hy >= p3.next.y && p3.next.y !== p3.y) {
      const x3 = p3.x + (hy - p3.y) * (p3.next.x - p3.x) / (p3.next.y - p3.y);
      if (x3 <= hx && x3 > qx) {
        qx = x3;
        m2 = p3.x < p3.next.x ? p3 : p3.next;
        if (x3 === hx) return m2;
      }
    }
    p3 = p3.next;
  } while (p3 !== outerNode);
  if (!m2) return null;
  const stop2 = m2, mx = m2.x, my = m2.y;
  let tanMin = Infinity, tan;
  p3 = m2;
  do {
    if (hx >= p3.x && p3.x >= mx && hx !== p3.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p3.x, p3.y)) {
      tan = Math.abs(hy - p3.y) / (hx - p3.x);
      if (locallyInside(p3, hole) && (tan < tanMin || tan === tanMin && (p3.x > m2.x || p3.x === m2.x && sectorContainsSector(m2, p3)))) {
        m2 = p3;
        tanMin = tan;
      }
    }
    p3 = p3.next;
  } while (p3 !== stop2);
  return m2;
}
function sectorContainsSector(m2, p3) {
  return area(m2.prev, m2, p3.prev) < 0 && area(p3.next, m2, m2.next) < 0;
}
function indexCurve(start2, minX, minY, invSize) {
  let p3 = start2;
  do {
    if (p3.z === 0) p3.z = zOrder(p3.x, p3.y, minX, minY, invSize);
    p3.prevZ = p3.prev;
    p3.nextZ = p3.next;
    p3 = p3.next;
  } while (p3 !== start2);
  p3.prevZ.nextZ = null;
  p3.prevZ = null;
  sortLinked(p3);
}
function sortLinked(list) {
  let i2, p3, q2, e2, tail, numMerges, pSize, qSize, inSize = 1;
  do {
    p3 = list;
    list = null;
    tail = null;
    numMerges = 0;
    while (p3) {
      numMerges++;
      q2 = p3;
      pSize = 0;
      for (i2 = 0; i2 < inSize; i2++) {
        pSize++;
        q2 = q2.nextZ;
        if (!q2) break;
      }
      qSize = inSize;
      while (pSize > 0 || qSize > 0 && q2) {
        if (pSize !== 0 && (qSize === 0 || !q2 || p3.z <= q2.z)) {
          e2 = p3;
          p3 = p3.nextZ;
          pSize--;
        } else {
          e2 = q2;
          q2 = q2.nextZ;
          qSize--;
        }
        if (tail) tail.nextZ = e2;
        else list = e2;
        e2.prevZ = tail;
        tail = e2;
      }
      p3 = q2;
    }
    tail.nextZ = null;
    inSize *= 2;
  } while (numMerges > 1);
  return list;
}
function zOrder(x3, y2, minX, minY, invSize) {
  x3 = (x3 - minX) * invSize | 0;
  y2 = (y2 - minY) * invSize | 0;
  x3 = (x3 | x3 << 8) & 16711935;
  x3 = (x3 | x3 << 4) & 252645135;
  x3 = (x3 | x3 << 2) & 858993459;
  x3 = (x3 | x3 << 1) & 1431655765;
  y2 = (y2 | y2 << 8) & 16711935;
  y2 = (y2 | y2 << 4) & 252645135;
  y2 = (y2 | y2 << 2) & 858993459;
  y2 = (y2 | y2 << 1) & 1431655765;
  return x3 | y2 << 1;
}
function getLeftmost(start2) {
  let p3 = start2, leftmost = start2;
  do {
    if (p3.x < leftmost.x || p3.x === leftmost.x && p3.y < leftmost.y) leftmost = p3;
    p3 = p3.next;
  } while (p3 !== start2);
  return leftmost;
}
function pointInTriangle(ax, ay, bx, by, cx, cy, px2, py2) {
  return (cx - px2) * (ay - py2) >= (ax - px2) * (cy - py2) && (ax - px2) * (by - py2) >= (bx - px2) * (ay - py2) && (bx - px2) * (cy - py2) >= (cx - px2) * (by - py2);
}
function isValidDiagonal(a5, b6) {
  return a5.next.i !== b6.i && a5.prev.i !== b6.i && !intersectsPolygon(a5, b6) && // doesn't intersect other edges
  (locallyInside(a5, b6) && locallyInside(b6, a5) && middleInside(a5, b6) && // locally visible
  (area(a5.prev, a5, b6.prev) || area(a5, b6.prev, b6)) || // does not create opposite-facing sectors
  equals(a5, b6) && area(a5.prev, a5, a5.next) > 0 && area(b6.prev, b6, b6.next) > 0);
}
function area(p3, q2, r3) {
  return (q2.y - p3.y) * (r3.x - q2.x) - (q2.x - p3.x) * (r3.y - q2.y);
}
function equals(p1, p22) {
  return p1.x === p22.x && p1.y === p22.y;
}
function intersects(p1, q1, p22, q2) {
  const o1 = sign(area(p1, q1, p22));
  const o2 = sign(area(p1, q1, q2));
  const o3 = sign(area(p22, q2, p1));
  const o4 = sign(area(p22, q2, q1));
  if (o1 !== o2 && o3 !== o4) return true;
  if (o1 === 0 && onSegment(p1, p22, q1)) return true;
  if (o2 === 0 && onSegment(p1, q2, q1)) return true;
  if (o3 === 0 && onSegment(p22, p1, q2)) return true;
  if (o4 === 0 && onSegment(p22, q1, q2)) return true;
  return false;
}
function onSegment(p3, q2, r3) {
  return q2.x <= Math.max(p3.x, r3.x) && q2.x >= Math.min(p3.x, r3.x) && q2.y <= Math.max(p3.y, r3.y) && q2.y >= Math.min(p3.y, r3.y);
}
function sign(num) {
  return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function intersectsPolygon(a5, b6) {
  let p3 = a5;
  do {
    if (p3.i !== a5.i && p3.next.i !== a5.i && p3.i !== b6.i && p3.next.i !== b6.i && intersects(p3, p3.next, a5, b6)) return true;
    p3 = p3.next;
  } while (p3 !== a5);
  return false;
}
function locallyInside(a5, b6) {
  return area(a5.prev, a5, a5.next) < 0 ? area(a5, b6, a5.next) >= 0 && area(a5, a5.prev, b6) >= 0 : area(a5, b6, a5.prev) < 0 || area(a5, a5.next, b6) < 0;
}
function middleInside(a5, b6) {
  let p3 = a5, inside = false;
  const px2 = (a5.x + b6.x) / 2, py2 = (a5.y + b6.y) / 2;
  do {
    if (p3.y > py2 !== p3.next.y > py2 && p3.next.y !== p3.y && px2 < (p3.next.x - p3.x) * (py2 - p3.y) / (p3.next.y - p3.y) + p3.x)
      inside = !inside;
    p3 = p3.next;
  } while (p3 !== a5);
  return inside;
}
function splitPolygon(a5, b6) {
  const a22 = new Node(a5.i, a5.x, a5.y), b22 = new Node(b6.i, b6.x, b6.y), an = a5.next, bp = b6.prev;
  a5.next = b6;
  b6.prev = a5;
  a22.next = an;
  an.prev = a22;
  b22.next = a22;
  a22.prev = b22;
  bp.next = b22;
  b22.prev = bp;
  return b22;
}
function insertNode(i2, x3, y2, last) {
  const p3 = new Node(i2, x3, y2);
  if (!last) {
    p3.prev = p3;
    p3.next = p3;
  } else {
    p3.next = last.next;
    p3.prev = last;
    last.next.prev = p3;
    last.next = p3;
  }
  return p3;
}
function removeNode(p3) {
  p3.next.prev = p3.prev;
  p3.prev.next = p3.next;
  if (p3.prevZ) p3.prevZ.nextZ = p3.nextZ;
  if (p3.nextZ) p3.nextZ.prevZ = p3.prevZ;
}
function Node(i2, x3, y2) {
  this.i = i2;
  this.x = x3;
  this.y = y2;
  this.prev = null;
  this.next = null;
  this.z = 0;
  this.prevZ = null;
  this.nextZ = null;
  this.steiner = false;
}
function signedArea(data, start2, end, dim) {
  let sum = 0;
  for (let i2 = start2, j3 = end - dim; i2 < end; i2 += dim) {
    sum += (data[j3] - data[i2]) * (data[i2 + 1] + data[j3 + 1]);
    j3 = i2;
  }
  return sum;
}
class ShapeUtils {
  // calculate area of the contour polygon
  static area(contour) {
    const n2 = contour.length;
    let a5 = 0;
    for (let p3 = n2 - 1, q2 = 0; q2 < n2; p3 = q2++) {
      a5 += contour[p3].x * contour[q2].y - contour[q2].x * contour[p3].y;
    }
    return a5 * 0.5;
  }
  static isClockWise(pts) {
    return ShapeUtils.area(pts) < 0;
  }
  static triangulateShape(contour, holes) {
    const vertices = [];
    const holeIndices = [];
    const faces = [];
    removeDupEndPts(contour);
    addContour(vertices, contour);
    let holeIndex = contour.length;
    holes.forEach(removeDupEndPts);
    for (let i2 = 0; i2 < holes.length; i2++) {
      holeIndices.push(holeIndex);
      holeIndex += holes[i2].length;
      addContour(vertices, holes[i2]);
    }
    const triangles = Earcut.triangulate(vertices, holeIndices);
    for (let i2 = 0; i2 < triangles.length; i2 += 3) {
      faces.push(triangles.slice(i2, i2 + 3));
    }
    return faces;
  }
}
function removeDupEndPts(points) {
  const l2 = points.length;
  if (l2 > 2 && points[l2 - 1].equals(points[0])) {
    points.pop();
  }
}
function addContour(vertices, contour) {
  for (let i2 = 0; i2 < contour.length; i2++) {
    vertices.push(contour[i2].x);
    vertices.push(contour[i2].y);
  }
}
class ExtrudeGeometry extends BufferGeometry {
  constructor(shapes = new Shape([new Vector2(0.5, 0.5), new Vector2(-0.5, 0.5), new Vector2(-0.5, -0.5), new Vector2(0.5, -0.5)]), options = {}) {
    super();
    this.type = "ExtrudeGeometry";
    this.parameters = {
      shapes,
      options
    };
    shapes = Array.isArray(shapes) ? shapes : [shapes];
    const scope = this;
    const verticesArray = [];
    const uvArray = [];
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape = shapes[i2];
      addShape(shape);
    }
    this.setAttribute("position", new Float32BufferAttribute(verticesArray, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvArray, 2));
    this.computeVertexNormals();
    function addShape(shape) {
      const placeholder = [];
      const curveSegments = options.curveSegments !== void 0 ? options.curveSegments : 12;
      const steps = options.steps !== void 0 ? options.steps : 1;
      const depth = options.depth !== void 0 ? options.depth : 1;
      let bevelEnabled = options.bevelEnabled !== void 0 ? options.bevelEnabled : true;
      let bevelThickness = options.bevelThickness !== void 0 ? options.bevelThickness : 0.2;
      let bevelSize = options.bevelSize !== void 0 ? options.bevelSize : bevelThickness - 0.1;
      let bevelOffset = options.bevelOffset !== void 0 ? options.bevelOffset : 0;
      let bevelSegments = options.bevelSegments !== void 0 ? options.bevelSegments : 3;
      const extrudePath = options.extrudePath;
      const uvgen = options.UVGenerator !== void 0 ? options.UVGenerator : WorldUVGenerator;
      let extrudePts, extrudeByPath = false;
      let splineTube, binormal, normal, position2;
      if (extrudePath) {
        extrudePts = extrudePath.getSpacedPoints(steps);
        extrudeByPath = true;
        bevelEnabled = false;
        splineTube = extrudePath.computeFrenetFrames(steps, false);
        binormal = new Vector3();
        normal = new Vector3();
        position2 = new Vector3();
      }
      if (!bevelEnabled) {
        bevelSegments = 0;
        bevelThickness = 0;
        bevelSize = 0;
        bevelOffset = 0;
      }
      const shapePoints = shape.extractPoints(curveSegments);
      let vertices = shapePoints.shape;
      const holes = shapePoints.holes;
      const reverse = !ShapeUtils.isClockWise(vertices);
      if (reverse) {
        vertices = vertices.reverse();
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          if (ShapeUtils.isClockWise(ahole)) {
            holes[h2] = ahole.reverse();
          }
        }
      }
      const faces = ShapeUtils.triangulateShape(vertices, holes);
      const contour = vertices;
      for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
        const ahole = holes[h2];
        vertices = vertices.concat(ahole);
      }
      function scalePt2(pt, vec, size) {
        if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
        return pt.clone().addScaledVector(vec, size);
      }
      const vlen = vertices.length, flen = faces.length;
      function getBevelVec(inPt, inPrev, inNext) {
        let v_trans_x, v_trans_y, shrink_by;
        const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
        const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
        const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
        const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
        if (Math.abs(collinear0) > Number.EPSILON) {
          const v_prev_len = Math.sqrt(v_prev_lensq);
          const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
          const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
          const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
          const ptNextShift_x = inNext.x - v_next_y / v_next_len;
          const ptNextShift_y = inNext.y + v_next_x / v_next_len;
          const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
          v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
          v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
          const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
          if (v_trans_lensq <= 2) {
            return new Vector2(v_trans_x, v_trans_y);
          } else {
            shrink_by = Math.sqrt(v_trans_lensq / 2);
          }
        } else {
          let direction_eq = false;
          if (v_prev_x > Number.EPSILON) {
            if (v_next_x > Number.EPSILON) {
              direction_eq = true;
            }
          } else {
            if (v_prev_x < -Number.EPSILON) {
              if (v_next_x < -Number.EPSILON) {
                direction_eq = true;
              }
            } else {
              if (Math.sign(v_prev_y) === Math.sign(v_next_y)) {
                direction_eq = true;
              }
            }
          }
          if (direction_eq) {
            v_trans_x = -v_prev_y;
            v_trans_y = v_prev_x;
            shrink_by = Math.sqrt(v_prev_lensq);
          } else {
            v_trans_x = v_prev_x;
            v_trans_y = v_prev_y;
            shrink_by = Math.sqrt(v_prev_lensq / 2);
          }
        }
        return new Vector2(v_trans_x / shrink_by, v_trans_y / shrink_by);
      }
      const contourMovements = [];
      for (let i2 = 0, il = contour.length, j3 = il - 1, k2 = i2 + 1; i2 < il; i2++, j3++, k2++) {
        if (j3 === il) j3 = 0;
        if (k2 === il) k2 = 0;
        contourMovements[i2] = getBevelVec(contour[i2], contour[j3], contour[k2]);
      }
      const holesMovements = [];
      let oneHoleMovements, verticesMovements = contourMovements.concat();
      for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
        const ahole = holes[h2];
        oneHoleMovements = [];
        for (let i2 = 0, il = ahole.length, j3 = il - 1, k2 = i2 + 1; i2 < il; i2++, j3++, k2++) {
          if (j3 === il) j3 = 0;
          if (k2 === il) k2 = 0;
          oneHoleMovements[i2] = getBevelVec(ahole[i2], ahole[j3], ahole[k2]);
        }
        holesMovements.push(oneHoleMovements);
        verticesMovements = verticesMovements.concat(oneHoleMovements);
      }
      for (let b6 = 0; b6 < bevelSegments; b6++) {
        const t2 = b6 / bevelSegments;
        const z2 = bevelThickness * Math.cos(t2 * Math.PI / 2);
        const bs2 = bevelSize * Math.sin(t2 * Math.PI / 2) + bevelOffset;
        for (let i2 = 0, il = contour.length; i2 < il; i2++) {
          const vert = scalePt2(contour[i2], contourMovements[i2], bs2);
          v3(vert.x, vert.y, -z2);
        }
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          oneHoleMovements = holesMovements[h2];
          for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
            const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs2);
            v3(vert.x, vert.y, -z2);
          }
        }
      }
      const bs = bevelSize + bevelOffset;
      for (let i2 = 0; i2 < vlen; i2++) {
        const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs) : vertices[i2];
        if (!extrudeByPath) {
          v3(vert.x, vert.y, 0);
        } else {
          normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
          binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
          position2.copy(extrudePts[0]).add(normal).add(binormal);
          v3(position2.x, position2.y, position2.z);
        }
      }
      for (let s2 = 1; s2 <= steps; s2++) {
        for (let i2 = 0; i2 < vlen; i2++) {
          const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs) : vertices[i2];
          if (!extrudeByPath) {
            v3(vert.x, vert.y, depth / steps * s2);
          } else {
            normal.copy(splineTube.normals[s2]).multiplyScalar(vert.x);
            binormal.copy(splineTube.binormals[s2]).multiplyScalar(vert.y);
            position2.copy(extrudePts[s2]).add(normal).add(binormal);
            v3(position2.x, position2.y, position2.z);
          }
        }
      }
      for (let b6 = bevelSegments - 1; b6 >= 0; b6--) {
        const t2 = b6 / bevelSegments;
        const z2 = bevelThickness * Math.cos(t2 * Math.PI / 2);
        const bs2 = bevelSize * Math.sin(t2 * Math.PI / 2) + bevelOffset;
        for (let i2 = 0, il = contour.length; i2 < il; i2++) {
          const vert = scalePt2(contour[i2], contourMovements[i2], bs2);
          v3(vert.x, vert.y, depth + z2);
        }
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          oneHoleMovements = holesMovements[h2];
          for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
            const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs2);
            if (!extrudeByPath) {
              v3(vert.x, vert.y, depth + z2);
            } else {
              v3(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z2);
            }
          }
        }
      }
      buildLidFaces();
      buildSideFaces();
      function buildLidFaces() {
        const start2 = verticesArray.length / 3;
        if (bevelEnabled) {
          let layer = 0;
          let offset = vlen * layer;
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[2] + offset, face[1] + offset, face[0] + offset);
          }
          layer = steps + bevelSegments * 2;
          offset = vlen * layer;
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[0] + offset, face[1] + offset, face[2] + offset);
          }
        } else {
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[2], face[1], face[0]);
          }
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
          }
        }
        scope.addGroup(start2, verticesArray.length / 3 - start2, 0);
      }
      function buildSideFaces() {
        const start2 = verticesArray.length / 3;
        let layeroffset = 0;
        sidewalls(contour, layeroffset);
        layeroffset += contour.length;
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          sidewalls(ahole, layeroffset);
          layeroffset += ahole.length;
        }
        scope.addGroup(start2, verticesArray.length / 3 - start2, 1);
      }
      function sidewalls(contour2, layeroffset) {
        let i2 = contour2.length;
        while (--i2 >= 0) {
          const j3 = i2;
          let k2 = i2 - 1;
          if (k2 < 0) k2 = contour2.length - 1;
          for (let s2 = 0, sl = steps + bevelSegments * 2; s2 < sl; s2++) {
            const slen1 = vlen * s2;
            const slen2 = vlen * (s2 + 1);
            const a5 = layeroffset + j3 + slen1, b6 = layeroffset + k2 + slen1, c2 = layeroffset + k2 + slen2, d3 = layeroffset + j3 + slen2;
            f4(a5, b6, c2, d3);
          }
        }
      }
      function v3(x3, y2, z2) {
        placeholder.push(x3);
        placeholder.push(y2);
        placeholder.push(z2);
      }
      function f3(a5, b6, c2) {
        addVertex(a5);
        addVertex(b6);
        addVertex(c2);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[2]);
      }
      function f4(a5, b6, c2, d3) {
        addVertex(a5);
        addVertex(b6);
        addVertex(d3);
        addVertex(b6);
        addVertex(c2);
        addVertex(d3);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[3]);
        addUV(uvs[1]);
        addUV(uvs[2]);
        addUV(uvs[3]);
      }
      function addVertex(index) {
        verticesArray.push(placeholder[index * 3 + 0]);
        verticesArray.push(placeholder[index * 3 + 1]);
        verticesArray.push(placeholder[index * 3 + 2]);
      }
      function addUV(vector2) {
        uvArray.push(vector2.x);
        uvArray.push(vector2.y);
      }
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    const shapes = this.parameters.shapes;
    const options = this.parameters.options;
    return toJSON$1(shapes, options, data);
  }
  static fromJSON(data, shapes) {
    const geometryShapes = [];
    for (let j3 = 0, jl = data.shapes.length; j3 < jl; j3++) {
      const shape = shapes[data.shapes[j3]];
      geometryShapes.push(shape);
    }
    const extrudePath = data.options.extrudePath;
    if (extrudePath !== void 0) {
      data.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
    }
    return new ExtrudeGeometry(geometryShapes, data.options);
  }
}
const WorldUVGenerator = {
  generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    return [
      new Vector2(a_x, a_y),
      new Vector2(b_x, b_y),
      new Vector2(c_x, c_y)
    ];
  },
  generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const a_z = vertices[indexA * 3 + 2];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const b_z = vertices[indexB * 3 + 2];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    const c_z = vertices[indexC * 3 + 2];
    const d_x = vertices[indexD * 3];
    const d_y = vertices[indexD * 3 + 1];
    const d_z = vertices[indexD * 3 + 2];
    if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) {
      return [
        new Vector2(a_x, 1 - a_z),
        new Vector2(b_x, 1 - b_z),
        new Vector2(c_x, 1 - c_z),
        new Vector2(d_x, 1 - d_z)
      ];
    } else {
      return [
        new Vector2(a_y, 1 - a_z),
        new Vector2(b_y, 1 - b_z),
        new Vector2(c_y, 1 - c_z),
        new Vector2(d_y, 1 - d_z)
      ];
    }
  }
};
function toJSON$1(shapes, options, data) {
  data.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape = shapes[i2];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }
  data.options = Object.assign({}, options);
  if (options.extrudePath !== void 0) data.options.extrudePath = options.extrudePath.toJSON();
  return data;
}
class IcosahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const t2 = (1 + Math.sqrt(5)) / 2;
    const vertices = [
      -1,
      t2,
      0,
      1,
      t2,
      0,
      -1,
      -t2,
      0,
      1,
      -t2,
      0,
      0,
      -1,
      t2,
      0,
      1,
      t2,
      0,
      -1,
      -t2,
      0,
      1,
      -t2,
      t2,
      0,
      -1,
      t2,
      0,
      1,
      -t2,
      0,
      -1,
      -t2,
      0,
      1
    ];
    const indices = [
      0,
      11,
      5,
      0,
      5,
      1,
      0,
      1,
      7,
      0,
      7,
      10,
      0,
      10,
      11,
      1,
      5,
      9,
      5,
      11,
      4,
      11,
      10,
      2,
      10,
      7,
      6,
      7,
      1,
      8,
      3,
      9,
      4,
      3,
      4,
      2,
      3,
      2,
      6,
      3,
      6,
      8,
      3,
      8,
      9,
      4,
      9,
      5,
      2,
      4,
      11,
      6,
      2,
      10,
      8,
      6,
      7,
      9,
      8,
      1
    ];
    super(vertices, indices, radius, detail);
    this.type = "IcosahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data) {
    return new IcosahedronGeometry(data.radius, data.detail);
  }
}
class OctahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const vertices = [
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1
    ];
    const indices = [
      0,
      2,
      4,
      0,
      4,
      3,
      0,
      3,
      5,
      0,
      5,
      2,
      1,
      2,
      5,
      1,
      5,
      3,
      1,
      3,
      4,
      1,
      4,
      2
    ];
    super(vertices, indices, radius, detail);
    this.type = "OctahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data) {
    return new OctahedronGeometry(data.radius, data.detail);
  }
}
class PlaneGeometry extends BufferGeometry {
  constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1) {
    super();
    this.type = "PlaneGeometry";
    this.parameters = {
      width,
      height,
      widthSegments,
      heightSegments
    };
    const width_half = width / 2;
    const height_half = height / 2;
    const gridX = Math.floor(widthSegments);
    const gridY = Math.floor(heightSegments);
    const gridX1 = gridX + 1;
    const gridY1 = gridY + 1;
    const segment_width = width / gridX;
    const segment_height = height / gridY;
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    for (let iy = 0; iy < gridY1; iy++) {
      const y2 = iy * segment_height - height_half;
      for (let ix = 0; ix < gridX1; ix++) {
        const x3 = ix * segment_width - width_half;
        vertices.push(x3, -y2, 0);
        normals.push(0, 0, 1);
        uvs.push(ix / gridX);
        uvs.push(1 - iy / gridY);
      }
    }
    for (let iy = 0; iy < gridY; iy++) {
      for (let ix = 0; ix < gridX; ix++) {
        const a5 = ix + gridX1 * iy;
        const b6 = ix + gridX1 * (iy + 1);
        const c2 = ix + 1 + gridX1 * (iy + 1);
        const d3 = ix + 1 + gridX1 * iy;
        indices.push(a5, b6, d3);
        indices.push(b6, c2, d3);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
  }
}
class RingGeometry extends BufferGeometry {
  constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "RingGeometry";
    this.parameters = {
      innerRadius,
      outerRadius,
      thetaSegments,
      phiSegments,
      thetaStart,
      thetaLength
    };
    thetaSegments = Math.max(3, thetaSegments);
    phiSegments = Math.max(1, phiSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let radius = innerRadius;
    const radiusStep = (outerRadius - innerRadius) / phiSegments;
    const vertex2 = new Vector3();
    const uv = new Vector2();
    for (let j3 = 0; j3 <= phiSegments; j3++) {
      for (let i2 = 0; i2 <= thetaSegments; i2++) {
        const segment = thetaStart + i2 / thetaSegments * thetaLength;
        vertex2.x = radius * Math.cos(segment);
        vertex2.y = radius * Math.sin(segment);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normals.push(0, 0, 1);
        uv.x = (vertex2.x / outerRadius + 1) / 2;
        uv.y = (vertex2.y / outerRadius + 1) / 2;
        uvs.push(uv.x, uv.y);
      }
      radius += radiusStep;
    }
    for (let j3 = 0; j3 < phiSegments; j3++) {
      const thetaSegmentLevel = j3 * (thetaSegments + 1);
      for (let i2 = 0; i2 < thetaSegments; i2++) {
        const segment = i2 + thetaSegmentLevel;
        const a5 = segment;
        const b6 = segment + thetaSegments + 1;
        const c2 = segment + thetaSegments + 2;
        const d3 = segment + 1;
        indices.push(a5, b6, d3);
        indices.push(b6, c2, d3);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new RingGeometry(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
  }
}
class ShapeGeometry extends BufferGeometry {
  constructor(shapes = new Shape([new Vector2(0, 0.5), new Vector2(-0.5, -0.5), new Vector2(0.5, -0.5)]), curveSegments = 12) {
    super();
    this.type = "ShapeGeometry";
    this.parameters = {
      shapes,
      curveSegments
    };
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let groupStart = 0;
    let groupCount = 0;
    if (Array.isArray(shapes) === false) {
      addShape(shapes);
    } else {
      for (let i2 = 0; i2 < shapes.length; i2++) {
        addShape(shapes[i2]);
        this.addGroup(groupStart, groupCount, i2);
        groupStart += groupCount;
        groupCount = 0;
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function addShape(shape) {
      const indexOffset = vertices.length / 3;
      const points = shape.extractPoints(curveSegments);
      let shapeVertices = points.shape;
      const shapeHoles = points.holes;
      if (ShapeUtils.isClockWise(shapeVertices) === false) {
        shapeVertices = shapeVertices.reverse();
      }
      for (let i2 = 0, l2 = shapeHoles.length; i2 < l2; i2++) {
        const shapeHole = shapeHoles[i2];
        if (ShapeUtils.isClockWise(shapeHole) === true) {
          shapeHoles[i2] = shapeHole.reverse();
        }
      }
      const faces = ShapeUtils.triangulateShape(shapeVertices, shapeHoles);
      for (let i2 = 0, l2 = shapeHoles.length; i2 < l2; i2++) {
        const shapeHole = shapeHoles[i2];
        shapeVertices = shapeVertices.concat(shapeHole);
      }
      for (let i2 = 0, l2 = shapeVertices.length; i2 < l2; i2++) {
        const vertex2 = shapeVertices[i2];
        vertices.push(vertex2.x, vertex2.y, 0);
        normals.push(0, 0, 1);
        uvs.push(vertex2.x, vertex2.y);
      }
      for (let i2 = 0, l2 = faces.length; i2 < l2; i2++) {
        const face = faces[i2];
        const a5 = face[0] + indexOffset;
        const b6 = face[1] + indexOffset;
        const c2 = face[2] + indexOffset;
        indices.push(a5, b6, c2);
        groupCount += 3;
      }
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    const shapes = this.parameters.shapes;
    return toJSON(shapes, data);
  }
  static fromJSON(data, shapes) {
    const geometryShapes = [];
    for (let j3 = 0, jl = data.shapes.length; j3 < jl; j3++) {
      const shape = shapes[data.shapes[j3]];
      geometryShapes.push(shape);
    }
    return new ShapeGeometry(geometryShapes, data.curveSegments);
  }
}
function toJSON(shapes, data) {
  data.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape = shapes[i2];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }
  return data;
}
class SphereGeometry extends BufferGeometry {
  constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI) {
    super();
    this.type = "SphereGeometry";
    this.parameters = {
      radius,
      widthSegments,
      heightSegments,
      phiStart,
      phiLength,
      thetaStart,
      thetaLength
    };
    widthSegments = Math.max(3, Math.floor(widthSegments));
    heightSegments = Math.max(2, Math.floor(heightSegments));
    const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
    let index = 0;
    const grid = [];
    const vertex2 = new Vector3();
    const normal = new Vector3();
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    for (let iy = 0; iy <= heightSegments; iy++) {
      const verticesRow = [];
      const v3 = iy / heightSegments;
      let uOffset = 0;
      if (iy === 0 && thetaStart === 0) {
        uOffset = 0.5 / widthSegments;
      } else if (iy === heightSegments && thetaEnd === Math.PI) {
        uOffset = -0.5 / widthSegments;
      }
      for (let ix = 0; ix <= widthSegments; ix++) {
        const u2 = ix / widthSegments;
        vertex2.x = -radius * Math.cos(phiStart + u2 * phiLength) * Math.sin(thetaStart + v3 * thetaLength);
        vertex2.y = radius * Math.cos(thetaStart + v3 * thetaLength);
        vertex2.z = radius * Math.sin(phiStart + u2 * phiLength) * Math.sin(thetaStart + v3 * thetaLength);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normal.copy(vertex2).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(u2 + uOffset, 1 - v3);
        verticesRow.push(index++);
      }
      grid.push(verticesRow);
    }
    for (let iy = 0; iy < heightSegments; iy++) {
      for (let ix = 0; ix < widthSegments; ix++) {
        const a5 = grid[iy][ix + 1];
        const b6 = grid[iy][ix];
        const c2 = grid[iy + 1][ix];
        const d3 = grid[iy + 1][ix + 1];
        if (iy !== 0 || thetaStart > 0) indices.push(a5, b6, d3);
        if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b6, c2, d3);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new SphereGeometry(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
  }
}
class TetrahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const vertices = [
      1,
      1,
      1,
      -1,
      -1,
      1,
      -1,
      1,
      -1,
      1,
      -1,
      -1
    ];
    const indices = [
      2,
      1,
      0,
      0,
      3,
      2,
      1,
      3,
      0,
      2,
      3,
      1
    ];
    super(vertices, indices, radius, detail);
    this.type = "TetrahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data) {
    return new TetrahedronGeometry(data.radius, data.detail);
  }
}
class TorusGeometry extends BufferGeometry {
  constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2) {
    super();
    this.type = "TorusGeometry";
    this.parameters = {
      radius,
      tube,
      radialSegments,
      tubularSegments,
      arc
    };
    radialSegments = Math.floor(radialSegments);
    tubularSegments = Math.floor(tubularSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const center = new Vector3();
    const vertex2 = new Vector3();
    const normal = new Vector3();
    for (let j3 = 0; j3 <= radialSegments; j3++) {
      for (let i2 = 0; i2 <= tubularSegments; i2++) {
        const u2 = i2 / tubularSegments * arc;
        const v3 = j3 / radialSegments * Math.PI * 2;
        vertex2.x = (radius + tube * Math.cos(v3)) * Math.cos(u2);
        vertex2.y = (radius + tube * Math.cos(v3)) * Math.sin(u2);
        vertex2.z = tube * Math.sin(v3);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        center.x = radius * Math.cos(u2);
        center.y = radius * Math.sin(u2);
        normal.subVectors(vertex2, center).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(i2 / tubularSegments);
        uvs.push(j3 / radialSegments);
      }
    }
    for (let j3 = 1; j3 <= radialSegments; j3++) {
      for (let i2 = 1; i2 <= tubularSegments; i2++) {
        const a5 = (tubularSegments + 1) * j3 + i2 - 1;
        const b6 = (tubularSegments + 1) * (j3 - 1) + i2 - 1;
        const c2 = (tubularSegments + 1) * (j3 - 1) + i2;
        const d3 = (tubularSegments + 1) * j3 + i2;
        indices.push(a5, b6, d3);
        indices.push(b6, c2, d3);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
  }
}
class TorusKnotGeometry extends BufferGeometry {
  constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p3 = 2, q2 = 3) {
    super();
    this.type = "TorusKnotGeometry";
    this.parameters = {
      radius,
      tube,
      tubularSegments,
      radialSegments,
      p: p3,
      q: q2
    };
    tubularSegments = Math.floor(tubularSegments);
    radialSegments = Math.floor(radialSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const vertex2 = new Vector3();
    const normal = new Vector3();
    const P1 = new Vector3();
    const P22 = new Vector3();
    const B2 = new Vector3();
    const T2 = new Vector3();
    const N2 = new Vector3();
    for (let i2 = 0; i2 <= tubularSegments; ++i2) {
      const u2 = i2 / tubularSegments * p3 * Math.PI * 2;
      calculatePositionOnCurve(u2, p3, q2, radius, P1);
      calculatePositionOnCurve(u2 + 0.01, p3, q2, radius, P22);
      T2.subVectors(P22, P1);
      N2.addVectors(P22, P1);
      B2.crossVectors(T2, N2);
      N2.crossVectors(B2, T2);
      B2.normalize();
      N2.normalize();
      for (let j3 = 0; j3 <= radialSegments; ++j3) {
        const v3 = j3 / radialSegments * Math.PI * 2;
        const cx = -tube * Math.cos(v3);
        const cy = tube * Math.sin(v3);
        vertex2.x = P1.x + (cx * N2.x + cy * B2.x);
        vertex2.y = P1.y + (cx * N2.y + cy * B2.y);
        vertex2.z = P1.z + (cx * N2.z + cy * B2.z);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normal.subVectors(vertex2, P1).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(i2 / tubularSegments);
        uvs.push(j3 / radialSegments);
      }
    }
    for (let j3 = 1; j3 <= tubularSegments; j3++) {
      for (let i2 = 1; i2 <= radialSegments; i2++) {
        const a5 = (radialSegments + 1) * (j3 - 1) + (i2 - 1);
        const b6 = (radialSegments + 1) * j3 + (i2 - 1);
        const c2 = (radialSegments + 1) * j3 + i2;
        const d3 = (radialSegments + 1) * (j3 - 1) + i2;
        indices.push(a5, b6, d3);
        indices.push(b6, c2, d3);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function calculatePositionOnCurve(u2, p4, q3, radius2, position) {
      const cu = Math.cos(u2);
      const su = Math.sin(u2);
      const quOverP = q3 / p4 * u2;
      const cs = Math.cos(quOverP);
      position.x = radius2 * (2 + cs) * 0.5 * cu;
      position.y = radius2 * (2 + cs) * su * 0.5;
      position.z = radius2 * Math.sin(quOverP) * 0.5;
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new TorusKnotGeometry(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
  }
}
class TubeGeometry extends BufferGeometry {
  constructor(path = new QuadraticBezierCurve3(new Vector3(-1, -1, 0), new Vector3(-1, 1, 0), new Vector3(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false) {
    super();
    this.type = "TubeGeometry";
    this.parameters = {
      path,
      tubularSegments,
      radius,
      radialSegments,
      closed
    };
    const frames = path.computeFrenetFrames(tubularSegments, closed);
    this.tangents = frames.tangents;
    this.normals = frames.normals;
    this.binormals = frames.binormals;
    const vertex2 = new Vector3();
    const normal = new Vector3();
    const uv = new Vector2();
    let P3 = new Vector3();
    const vertices = [];
    const normals = [];
    const uvs = [];
    const indices = [];
    generateBufferData();
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function generateBufferData() {
      for (let i2 = 0; i2 < tubularSegments; i2++) {
        generateSegment(i2);
      }
      generateSegment(closed === false ? tubularSegments : 0);
      generateUVs();
      generateIndices();
    }
    function generateSegment(i2) {
      P3 = path.getPointAt(i2 / tubularSegments, P3);
      const N2 = frames.normals[i2];
      const B2 = frames.binormals[i2];
      for (let j3 = 0; j3 <= radialSegments; j3++) {
        const v3 = j3 / radialSegments * Math.PI * 2;
        const sin = Math.sin(v3);
        const cos = -Math.cos(v3);
        normal.x = cos * N2.x + sin * B2.x;
        normal.y = cos * N2.y + sin * B2.y;
        normal.z = cos * N2.z + sin * B2.z;
        normal.normalize();
        normals.push(normal.x, normal.y, normal.z);
        vertex2.x = P3.x + radius * normal.x;
        vertex2.y = P3.y + radius * normal.y;
        vertex2.z = P3.z + radius * normal.z;
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
      }
    }
    function generateIndices() {
      for (let j3 = 1; j3 <= tubularSegments; j3++) {
        for (let i2 = 1; i2 <= radialSegments; i2++) {
          const a5 = (radialSegments + 1) * (j3 - 1) + (i2 - 1);
          const b6 = (radialSegments + 1) * j3 + (i2 - 1);
          const c2 = (radialSegments + 1) * j3 + i2;
          const d3 = (radialSegments + 1) * (j3 - 1) + i2;
          indices.push(a5, b6, d3);
          indices.push(b6, c2, d3);
        }
      }
    }
    function generateUVs() {
      for (let i2 = 0; i2 <= tubularSegments; i2++) {
        for (let j3 = 0; j3 <= radialSegments; j3++) {
          uv.x = i2 / tubularSegments;
          uv.y = j3 / radialSegments;
          uvs.push(uv.x, uv.y);
        }
      }
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.path = this.parameters.path.toJSON();
    return data;
  }
  static fromJSON(data) {
    return new TubeGeometry(
      new Curves[data.path.type]().fromJSON(data.path),
      data.tubularSegments,
      data.radius,
      data.radialSegments,
      data.closed
    );
  }
}
class WireframeGeometry extends BufferGeometry {
  constructor(geometry = null) {
    super();
    this.type = "WireframeGeometry";
    this.parameters = {
      geometry
    };
    if (geometry !== null) {
      const vertices = [];
      const edges = /* @__PURE__ */ new Set();
      const start2 = new Vector3();
      const end = new Vector3();
      if (geometry.index !== null) {
        const position = geometry.attributes.position;
        const indices = geometry.index;
        let groups = geometry.groups;
        if (groups.length === 0) {
          groups = [{ start: 0, count: indices.count, materialIndex: 0 }];
        }
        for (let o2 = 0, ol = groups.length; o2 < ol; ++o2) {
          const group = groups[o2];
          const groupStart = group.start;
          const groupCount = group.count;
          for (let i2 = groupStart, l2 = groupStart + groupCount; i2 < l2; i2 += 3) {
            for (let j3 = 0; j3 < 3; j3++) {
              const index1 = indices.getX(i2 + j3);
              const index2 = indices.getX(i2 + (j3 + 1) % 3);
              start2.fromBufferAttribute(position, index1);
              end.fromBufferAttribute(position, index2);
              if (isUniqueEdge(start2, end, edges) === true) {
                vertices.push(start2.x, start2.y, start2.z);
                vertices.push(end.x, end.y, end.z);
              }
            }
          }
        }
      } else {
        const position = geometry.attributes.position;
        for (let i2 = 0, l2 = position.count / 3; i2 < l2; i2++) {
          for (let j3 = 0; j3 < 3; j3++) {
            const index1 = 3 * i2 + j3;
            const index2 = 3 * i2 + (j3 + 1) % 3;
            start2.fromBufferAttribute(position, index1);
            end.fromBufferAttribute(position, index2);
            if (isUniqueEdge(start2, end, edges) === true) {
              vertices.push(start2.x, start2.y, start2.z);
              vertices.push(end.x, end.y, end.z);
            }
          }
        }
      }
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
}
function isUniqueEdge(start2, end, edges) {
  const hash1 = `${start2.x},${start2.y},${start2.z}-${end.x},${end.y},${end.z}`;
  const hash2 = `${end.x},${end.y},${end.z}-${start2.x},${start2.y},${start2.z}`;
  if (edges.has(hash1) === true || edges.has(hash2) === true) {
    return false;
  } else {
    edges.add(hash1);
    edges.add(hash2);
    return true;
  }
}
var Geometries = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BoxGeometry,
  CapsuleGeometry,
  CircleGeometry,
  ConeGeometry,
  CylinderGeometry,
  DodecahedronGeometry,
  EdgesGeometry,
  ExtrudeGeometry,
  IcosahedronGeometry,
  LatheGeometry,
  OctahedronGeometry,
  PlaneGeometry,
  PolyhedronGeometry,
  RingGeometry,
  ShapeGeometry,
  SphereGeometry,
  TetrahedronGeometry,
  TorusGeometry,
  TorusKnotGeometry,
  TubeGeometry,
  WireframeGeometry
});
class ShadowMaterial extends Material {
  constructor(parameters) {
    super();
    this.isShadowMaterial = true;
    this.type = "ShadowMaterial";
    this.color = new Color(0);
    this.transparent = true;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.fog = source.fog;
    return this;
  }
}
class RawShaderMaterial extends ShaderMaterial {
  constructor(parameters) {
    super(parameters);
    this.isRawShaderMaterial = true;
    this.type = "RawShaderMaterial";
  }
}
class MeshStandardMaterial extends Material {
  constructor(parameters) {
    super();
    this.isMeshStandardMaterial = true;
    this.type = "MeshStandardMaterial";
    this.defines = { "STANDARD": "" };
    this.color = new Color(16777215);
    this.roughness = 1;
    this.metalness = 0;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.roughnessMap = null;
    this.metalnessMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new Euler();
    this.envMapIntensity = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "STANDARD": "" };
    this.color.copy(source.color);
    this.roughness = source.roughness;
    this.metalness = source.metalness;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.roughnessMap = source.roughnessMap;
    this.metalnessMap = source.metalnessMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapRotation.copy(source.envMapRotation);
    this.envMapIntensity = source.envMapIntensity;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    this.fog = source.fog;
    return this;
  }
}
class MeshPhysicalMaterial extends MeshStandardMaterial {
  constructor(parameters) {
    super();
    this.isMeshPhysicalMaterial = true;
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.type = "MeshPhysicalMaterial";
    this.anisotropyRotation = 0;
    this.anisotropyMap = null;
    this.clearcoatMap = null;
    this.clearcoatRoughness = 0;
    this.clearcoatRoughnessMap = null;
    this.clearcoatNormalScale = new Vector2(1, 1);
    this.clearcoatNormalMap = null;
    this.ior = 1.5;
    Object.defineProperty(this, "reflectivity", {
      get: function() {
        return clamp$4(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(reflectivity) {
        this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
      }
    });
    this.iridescenceMap = null;
    this.iridescenceIOR = 1.3;
    this.iridescenceThicknessRange = [100, 400];
    this.iridescenceThicknessMap = null;
    this.sheenColor = new Color(0);
    this.sheenColorMap = null;
    this.sheenRoughness = 1;
    this.sheenRoughnessMap = null;
    this.transmissionMap = null;
    this.thickness = 0;
    this.thicknessMap = null;
    this.attenuationDistance = Infinity;
    this.attenuationColor = new Color(1, 1, 1);
    this.specularIntensity = 1;
    this.specularIntensityMap = null;
    this.specularColor = new Color(1, 1, 1);
    this.specularColorMap = null;
    this._anisotropy = 0;
    this._clearcoat = 0;
    this._dispersion = 0;
    this._iridescence = 0;
    this._sheen = 0;
    this._transmission = 0;
    this.setValues(parameters);
  }
  get anisotropy() {
    return this._anisotropy;
  }
  set anisotropy(value) {
    if (this._anisotropy > 0 !== value > 0) {
      this.version++;
    }
    this._anisotropy = value;
  }
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(value) {
    if (this._clearcoat > 0 !== value > 0) {
      this.version++;
    }
    this._clearcoat = value;
  }
  get iridescence() {
    return this._iridescence;
  }
  set iridescence(value) {
    if (this._iridescence > 0 !== value > 0) {
      this.version++;
    }
    this._iridescence = value;
  }
  get dispersion() {
    return this._dispersion;
  }
  set dispersion(value) {
    if (this._dispersion > 0 !== value > 0) {
      this.version++;
    }
    this._dispersion = value;
  }
  get sheen() {
    return this._sheen;
  }
  set sheen(value) {
    if (this._sheen > 0 !== value > 0) {
      this.version++;
    }
    this._sheen = value;
  }
  get transmission() {
    return this._transmission;
  }
  set transmission(value) {
    if (this._transmission > 0 !== value > 0) {
      this.version++;
    }
    this._transmission = value;
  }
  copy(source) {
    super.copy(source);
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.anisotropy = source.anisotropy;
    this.anisotropyRotation = source.anisotropyRotation;
    this.anisotropyMap = source.anisotropyMap;
    this.clearcoat = source.clearcoat;
    this.clearcoatMap = source.clearcoatMap;
    this.clearcoatRoughness = source.clearcoatRoughness;
    this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
    this.clearcoatNormalMap = source.clearcoatNormalMap;
    this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
    this.dispersion = source.dispersion;
    this.ior = source.ior;
    this.iridescence = source.iridescence;
    this.iridescenceMap = source.iridescenceMap;
    this.iridescenceIOR = source.iridescenceIOR;
    this.iridescenceThicknessRange = [...source.iridescenceThicknessRange];
    this.iridescenceThicknessMap = source.iridescenceThicknessMap;
    this.sheen = source.sheen;
    this.sheenColor.copy(source.sheenColor);
    this.sheenColorMap = source.sheenColorMap;
    this.sheenRoughness = source.sheenRoughness;
    this.sheenRoughnessMap = source.sheenRoughnessMap;
    this.transmission = source.transmission;
    this.transmissionMap = source.transmissionMap;
    this.thickness = source.thickness;
    this.thicknessMap = source.thicknessMap;
    this.attenuationDistance = source.attenuationDistance;
    this.attenuationColor.copy(source.attenuationColor);
    this.specularIntensity = source.specularIntensity;
    this.specularIntensityMap = source.specularIntensityMap;
    this.specularColor.copy(source.specularColor);
    this.specularColorMap = source.specularColorMap;
    return this;
  }
}
class MeshPhongMaterial extends Material {
  constructor(parameters) {
    super();
    this.isMeshPhongMaterial = true;
    this.type = "MeshPhongMaterial";
    this.color = new Color(16777215);
    this.specular = new Color(1118481);
    this.shininess = 30;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new Euler();
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.specular.copy(source.specular);
    this.shininess = source.shininess;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapRotation.copy(source.envMapRotation);
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    this.fog = source.fog;
    return this;
  }
}
class MeshToonMaterial extends Material {
  constructor(parameters) {
    super();
    this.isMeshToonMaterial = true;
    this.defines = { "TOON": "" };
    this.type = "MeshToonMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.gradientMap = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.gradientMap = source.gradientMap;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.fog = source.fog;
    return this;
  }
}
class MeshNormalMaterial extends Material {
  constructor(parameters) {
    super();
    this.isMeshNormalMaterial = true;
    this.type = "MeshNormalMaterial";
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.flatShading = source.flatShading;
    return this;
  }
}
class MeshLambertMaterial extends Material {
  constructor(parameters) {
    super();
    this.isMeshLambertMaterial = true;
    this.type = "MeshLambertMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new Euler();
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapRotation.copy(source.envMapRotation);
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    this.fog = source.fog;
    return this;
  }
}
class MeshDepthMaterial extends Material {
  constructor(parameters) {
    super();
    this.isMeshDepthMaterial = true;
    this.type = "MeshDepthMaterial";
    this.depthPacking = BasicDepthPacking;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.depthPacking = source.depthPacking;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    return this;
  }
}
class MeshDistanceMaterial extends Material {
  constructor(parameters) {
    super();
    this.isMeshDistanceMaterial = true;
    this.type = "MeshDistanceMaterial";
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    return this;
  }
}
class MeshMatcapMaterial extends Material {
  constructor(parameters) {
    super();
    this.isMeshMatcapMaterial = true;
    this.defines = { "MATCAP": "" };
    this.type = "MeshMatcapMaterial";
    this.color = new Color(16777215);
    this.matcap = null;
    this.map = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.flatShading = false;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "MATCAP": "" };
    this.color.copy(source.color);
    this.matcap = source.matcap;
    this.map = source.map;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.flatShading = source.flatShading;
    this.fog = source.fog;
    return this;
  }
}
class LineDashedMaterial extends LineBasicMaterial {
  constructor(parameters) {
    super();
    this.isLineDashedMaterial = true;
    this.type = "LineDashedMaterial";
    this.scale = 1;
    this.dashSize = 3;
    this.gapSize = 1;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.scale = source.scale;
    this.dashSize = source.dashSize;
    this.gapSize = source.gapSize;
    return this;
  }
}
function convertArray(array, type, forceClone) {
  if (!array || // let 'undefined' and 'null' pass
  !forceClone && array.constructor === type) return array;
  if (typeof type.BYTES_PER_ELEMENT === "number") {
    return new type(array);
  }
  return Array.prototype.slice.call(array);
}
function isTypedArray(object) {
  return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
function getKeyframeOrder(times) {
  function compareTime(i2, j3) {
    return times[i2] - times[j3];
  }
  const n2 = times.length;
  const result = new Array(n2);
  for (let i2 = 0; i2 !== n2; ++i2) result[i2] = i2;
  result.sort(compareTime);
  return result;
}
function sortedArray(values, stride, order) {
  const nValues = values.length;
  const result = new values.constructor(nValues);
  for (let i2 = 0, dstOffset = 0; dstOffset !== nValues; ++i2) {
    const srcOffset = order[i2] * stride;
    for (let j3 = 0; j3 !== stride; ++j3) {
      result[dstOffset++] = values[srcOffset + j3];
    }
  }
  return result;
}
function flattenJSON(jsonKeys, times, values, valuePropertyName) {
  let i2 = 1, key = jsonKeys[0];
  while (key !== void 0 && key[valuePropertyName] === void 0) {
    key = jsonKeys[i2++];
  }
  if (key === void 0) return;
  let value = key[valuePropertyName];
  if (value === void 0) return;
  if (Array.isArray(value)) {
    do {
      value = key[valuePropertyName];
      if (value !== void 0) {
        times.push(key.time);
        values.push.apply(values, value);
      }
      key = jsonKeys[i2++];
    } while (key !== void 0);
  } else if (value.toArray !== void 0) {
    do {
      value = key[valuePropertyName];
      if (value !== void 0) {
        times.push(key.time);
        value.toArray(values, values.length);
      }
      key = jsonKeys[i2++];
    } while (key !== void 0);
  } else {
    do {
      value = key[valuePropertyName];
      if (value !== void 0) {
        times.push(key.time);
        values.push(value);
      }
      key = jsonKeys[i2++];
    } while (key !== void 0);
  }
}
function subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
  const clip = sourceClip.clone();
  clip.name = name;
  const tracks = [];
  for (let i2 = 0; i2 < clip.tracks.length; ++i2) {
    const track = clip.tracks[i2];
    const valueSize = track.getValueSize();
    const times = [];
    const values = [];
    for (let j3 = 0; j3 < track.times.length; ++j3) {
      const frame = track.times[j3] * fps;
      if (frame < startFrame || frame >= endFrame) continue;
      times.push(track.times[j3]);
      for (let k2 = 0; k2 < valueSize; ++k2) {
        values.push(track.values[j3 * valueSize + k2]);
      }
    }
    if (times.length === 0) continue;
    track.times = convertArray(times, track.times.constructor);
    track.values = convertArray(values, track.values.constructor);
    tracks.push(track);
  }
  clip.tracks = tracks;
  let minStartTime = Infinity;
  for (let i2 = 0; i2 < clip.tracks.length; ++i2) {
    if (minStartTime > clip.tracks[i2].times[0]) {
      minStartTime = clip.tracks[i2].times[0];
    }
  }
  for (let i2 = 0; i2 < clip.tracks.length; ++i2) {
    clip.tracks[i2].shift(-1 * minStartTime);
  }
  clip.resetDuration();
  return clip;
}
function makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
  if (fps <= 0) fps = 30;
  const numTracks = referenceClip.tracks.length;
  const referenceTime = referenceFrame / fps;
  for (let i2 = 0; i2 < numTracks; ++i2) {
    const referenceTrack = referenceClip.tracks[i2];
    const referenceTrackType = referenceTrack.ValueTypeName;
    if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
    const targetTrack = targetClip.tracks.find(function(track) {
      return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
    });
    if (targetTrack === void 0) continue;
    let referenceOffset = 0;
    const referenceValueSize = referenceTrack.getValueSize();
    if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
      referenceOffset = referenceValueSize / 3;
    }
    let targetOffset = 0;
    const targetValueSize = targetTrack.getValueSize();
    if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
      targetOffset = targetValueSize / 3;
    }
    const lastIndex = referenceTrack.times.length - 1;
    let referenceValue;
    if (referenceTime <= referenceTrack.times[0]) {
      const startIndex = referenceOffset;
      const endIndex = referenceValueSize - referenceOffset;
      referenceValue = referenceTrack.values.slice(startIndex, endIndex);
    } else if (referenceTime >= referenceTrack.times[lastIndex]) {
      const startIndex = lastIndex * referenceValueSize + referenceOffset;
      const endIndex = startIndex + referenceValueSize - referenceOffset;
      referenceValue = referenceTrack.values.slice(startIndex, endIndex);
    } else {
      const interpolant = referenceTrack.createInterpolant();
      const startIndex = referenceOffset;
      const endIndex = referenceValueSize - referenceOffset;
      interpolant.evaluate(referenceTime);
      referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
    }
    if (referenceTrackType === "quaternion") {
      const referenceQuat = new Quaternion().fromArray(referenceValue).normalize().conjugate();
      referenceQuat.toArray(referenceValue);
    }
    const numTimes = targetTrack.times.length;
    for (let j3 = 0; j3 < numTimes; ++j3) {
      const valueStart = j3 * targetValueSize + targetOffset;
      if (referenceTrackType === "quaternion") {
        Quaternion.multiplyQuaternionsFlat(
          targetTrack.values,
          valueStart,
          referenceValue,
          0,
          targetTrack.values,
          valueStart
        );
      } else {
        const valueEnd = targetValueSize - targetOffset * 2;
        for (let k2 = 0; k2 < valueEnd; ++k2) {
          targetTrack.values[valueStart + k2] -= referenceValue[k2];
        }
      }
    }
  }
  targetClip.blendMode = AdditiveAnimationBlendMode;
  return targetClip;
}
const AnimationUtils = {
  convertArray,
  isTypedArray,
  getKeyframeOrder,
  sortedArray,
  flattenJSON,
  subclip,
  makeClipAdditive
};
class Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    this.parameterPositions = parameterPositions;
    this._cachedIndex = 0;
    this.resultBuffer = resultBuffer !== void 0 ? resultBuffer : new sampleValues.constructor(sampleSize);
    this.sampleValues = sampleValues;
    this.valueSize = sampleSize;
    this.settings = null;
    this.DefaultSettings_ = {};
  }
  evaluate(t2) {
    const pp = this.parameterPositions;
    let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
    validate_interval: {
      seek: {
        let right;
        linear_scan: {
          forward_scan: if (!(t2 < t1)) {
            for (let giveUpAt = i1 + 2; ; ) {
              if (t1 === void 0) {
                if (t2 < t0) break forward_scan;
                i1 = pp.length;
                this._cachedIndex = i1;
                return this.copySampleValue_(i1 - 1);
              }
              if (i1 === giveUpAt) break;
              t0 = t1;
              t1 = pp[++i1];
              if (t2 < t1) {
                break seek;
              }
            }
            right = pp.length;
            break linear_scan;
          }
          if (!(t2 >= t0)) {
            const t1global = pp[1];
            if (t2 < t1global) {
              i1 = 2;
              t0 = t1global;
            }
            for (let giveUpAt = i1 - 2; ; ) {
              if (t0 === void 0) {
                this._cachedIndex = 0;
                return this.copySampleValue_(0);
              }
              if (i1 === giveUpAt) break;
              t1 = t0;
              t0 = pp[--i1 - 1];
              if (t2 >= t0) {
                break seek;
              }
            }
            right = i1;
            i1 = 0;
            break linear_scan;
          }
          break validate_interval;
        }
        while (i1 < right) {
          const mid = i1 + right >>> 1;
          if (t2 < pp[mid]) {
            right = mid;
          } else {
            i1 = mid + 1;
          }
        }
        t1 = pp[i1];
        t0 = pp[i1 - 1];
        if (t0 === void 0) {
          this._cachedIndex = 0;
          return this.copySampleValue_(0);
        }
        if (t1 === void 0) {
          i1 = pp.length;
          this._cachedIndex = i1;
          return this.copySampleValue_(i1 - 1);
        }
      }
      this._cachedIndex = i1;
      this.intervalChanged_(i1, t0, t1);
    }
    return this.interpolate_(i1, t0, t2, t1);
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  copySampleValue_(index) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = values[offset + i2];
    }
    return result;
  }
  // Template methods for derived classes:
  interpolate_() {
    throw new Error("call to abstract method");
  }
  intervalChanged_() {
  }
}
class CubicInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    this._weightPrev = -0;
    this._offsetPrev = -0;
    this._weightNext = -0;
    this._offsetNext = -0;
    this.DefaultSettings_ = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
  }
  intervalChanged_(i1, t0, t1) {
    const pp = this.parameterPositions;
    let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
    if (tPrev === void 0) {
      switch (this.getSettings_().endingStart) {
        case ZeroSlopeEnding:
          iPrev = i1;
          tPrev = 2 * t0 - t1;
          break;
        case WrapAroundEnding:
          iPrev = pp.length - 2;
          tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
          break;
        default:
          iPrev = i1;
          tPrev = t1;
      }
    }
    if (tNext === void 0) {
      switch (this.getSettings_().endingEnd) {
        case ZeroSlopeEnding:
          iNext = i1;
          tNext = 2 * t1 - t0;
          break;
        case WrapAroundEnding:
          iNext = 1;
          tNext = t1 + pp[1] - pp[0];
          break;
        default:
          iNext = i1 - 1;
          tNext = t0;
      }
    }
    const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
    this._weightPrev = halfDt / (t0 - tPrev);
    this._weightNext = halfDt / (tNext - t1);
    this._offsetPrev = iPrev * stride;
    this._offsetNext = iNext * stride;
  }
  interpolate_(i1, t0, t2, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p3 = (t2 - t0) / (t1 - t0), pp = p3 * p3, ppp = pp * p3;
    const sP = -wP * ppp + 2 * wP * pp - wP * p3;
    const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p3 + 1;
    const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p3;
    const sN = wN * ppp - wN * pp;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = sP * values[oP + i2] + s0 * values[o0 + i2] + s1 * values[o1 + i2] + sN * values[oN + i2];
    }
    return result;
  }
}
class LinearInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t2, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t2 - t0) / (t1 - t0), weight0 = 1 - weight1;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = values[offset0 + i2] * weight0 + values[offset1 + i2] * weight1;
    }
    return result;
  }
}
class DiscreteInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1) {
    return this.copySampleValue_(i1 - 1);
  }
}
class KeyframeTrack {
  constructor(name, times, values, interpolation) {
    if (name === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (times === void 0 || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
    this.name = name;
    this.times = convertArray(times, this.TimeBufferType);
    this.values = convertArray(values, this.ValueBufferType);
    this.setInterpolation(interpolation || this.DefaultInterpolation);
  }
  // Serialization (in static context, because of constructor invocation
  // and automatic invocation of .toJSON):
  static toJSON(track) {
    const trackType = track.constructor;
    let json;
    if (trackType.toJSON !== this.toJSON) {
      json = trackType.toJSON(track);
    } else {
      json = {
        "name": track.name,
        "times": convertArray(track.times, Array),
        "values": convertArray(track.values, Array)
      };
      const interpolation = track.getInterpolation();
      if (interpolation !== track.DefaultInterpolation) {
        json.interpolation = interpolation;
      }
    }
    json.type = track.ValueTypeName;
    return json;
  }
  InterpolantFactoryMethodDiscrete(result) {
    return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodLinear(result) {
    return new LinearInterpolant(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodSmooth(result) {
    return new CubicInterpolant(this.times, this.values, this.getValueSize(), result);
  }
  setInterpolation(interpolation) {
    let factoryMethod;
    switch (interpolation) {
      case InterpolateDiscrete:
        factoryMethod = this.InterpolantFactoryMethodDiscrete;
        break;
      case InterpolateLinear:
        factoryMethod = this.InterpolantFactoryMethodLinear;
        break;
      case InterpolateSmooth:
        factoryMethod = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (factoryMethod === void 0) {
      const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0) {
        if (interpolation !== this.DefaultInterpolation) {
          this.setInterpolation(this.DefaultInterpolation);
        } else {
          throw new Error(message);
        }
      }
      console.warn("THREE.KeyframeTrack:", message);
      return this;
    }
    this.createInterpolant = factoryMethod;
    return this;
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return InterpolateDiscrete;
      case this.InterpolantFactoryMethodLinear:
        return InterpolateLinear;
      case this.InterpolantFactoryMethodSmooth:
        return InterpolateSmooth;
    }
  }
  getValueSize() {
    return this.values.length / this.times.length;
  }
  // move all keyframes either forwards or backwards in time
  shift(timeOffset) {
    if (timeOffset !== 0) {
      const times = this.times;
      for (let i2 = 0, n2 = times.length; i2 !== n2; ++i2) {
        times[i2] += timeOffset;
      }
    }
    return this;
  }
  // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
  scale(timeScale) {
    if (timeScale !== 1) {
      const times = this.times;
      for (let i2 = 0, n2 = times.length; i2 !== n2; ++i2) {
        times[i2] *= timeScale;
      }
    }
    return this;
  }
  // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
  // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
  trim(startTime, endTime) {
    const times = this.times, nKeys = times.length;
    let from = 0, to2 = nKeys - 1;
    while (from !== nKeys && times[from] < startTime) {
      ++from;
    }
    while (to2 !== -1 && times[to2] > endTime) {
      --to2;
    }
    ++to2;
    if (from !== 0 || to2 !== nKeys) {
      if (from >= to2) {
        to2 = Math.max(to2, 1);
        from = to2 - 1;
      }
      const stride = this.getValueSize();
      this.times = times.slice(from, to2);
      this.values = this.values.slice(from * stride, to2 * stride);
    }
    return this;
  }
  // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
  validate() {
    let valid = true;
    const valueSize = this.getValueSize();
    if (valueSize - Math.floor(valueSize) !== 0) {
      console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
      valid = false;
    }
    const times = this.times, values = this.values, nKeys = times.length;
    if (nKeys === 0) {
      console.error("THREE.KeyframeTrack: Track is empty.", this);
      valid = false;
    }
    let prevTime = null;
    for (let i2 = 0; i2 !== nKeys; i2++) {
      const currTime = times[i2];
      if (typeof currTime === "number" && isNaN(currTime)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i2, currTime);
        valid = false;
        break;
      }
      if (prevTime !== null && prevTime > currTime) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, i2, currTime, prevTime);
        valid = false;
        break;
      }
      prevTime = currTime;
    }
    if (values !== void 0) {
      if (isTypedArray(values)) {
        for (let i2 = 0, n2 = values.length; i2 !== n2; ++i2) {
          const value = values[i2];
          if (isNaN(value)) {
            console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i2, value);
            valid = false;
            break;
          }
        }
      }
    }
    return valid;
  }
  // removes equivalent sequential keys as common in morph target sequences
  // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
  optimize() {
    const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times.length - 1;
    let writeIndex = 1;
    for (let i2 = 1; i2 < lastIndex; ++i2) {
      let keep = false;
      const time = times[i2];
      const timeNext = times[i2 + 1];
      if (time !== timeNext && (i2 !== 1 || time !== times[0])) {
        if (!smoothInterpolation) {
          const offset = i2 * stride, offsetP = offset - stride, offsetN = offset + stride;
          for (let j3 = 0; j3 !== stride; ++j3) {
            const value = values[offset + j3];
            if (value !== values[offsetP + j3] || value !== values[offsetN + j3]) {
              keep = true;
              break;
            }
          }
        } else {
          keep = true;
        }
      }
      if (keep) {
        if (i2 !== writeIndex) {
          times[writeIndex] = times[i2];
          const readOffset = i2 * stride, writeOffset = writeIndex * stride;
          for (let j3 = 0; j3 !== stride; ++j3) {
            values[writeOffset + j3] = values[readOffset + j3];
          }
        }
        ++writeIndex;
      }
    }
    if (lastIndex > 0) {
      times[writeIndex] = times[lastIndex];
      for (let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j3 = 0; j3 !== stride; ++j3) {
        values[writeOffset + j3] = values[readOffset + j3];
      }
      ++writeIndex;
    }
    if (writeIndex !== times.length) {
      this.times = times.slice(0, writeIndex);
      this.values = values.slice(0, writeIndex * stride);
    } else {
      this.times = times;
      this.values = values;
    }
    return this;
  }
  clone() {
    const times = this.times.slice();
    const values = this.values.slice();
    const TypedKeyframeTrack = this.constructor;
    const track = new TypedKeyframeTrack(this.name, times, values);
    track.createInterpolant = this.createInterpolant;
    return track;
  }
}
KeyframeTrack.prototype.TimeBufferType = Float32Array;
KeyframeTrack.prototype.ValueBufferType = Float32Array;
KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
class BooleanKeyframeTrack extends KeyframeTrack {
  // No interpolation parameter because only InterpolateDiscrete is valid.
  constructor(name, times, values) {
    super(name, times, values);
  }
}
BooleanKeyframeTrack.prototype.ValueTypeName = "bool";
BooleanKeyframeTrack.prototype.ValueBufferType = Array;
BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class ColorKeyframeTrack extends KeyframeTrack {
}
ColorKeyframeTrack.prototype.ValueTypeName = "color";
class NumberKeyframeTrack extends KeyframeTrack {
}
NumberKeyframeTrack.prototype.ValueTypeName = "number";
class QuaternionLinearInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t2, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t2 - t0) / (t1 - t0);
    let offset = i1 * stride;
    for (let end = offset + stride; offset !== end; offset += 4) {
      Quaternion.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
    }
    return result;
  }
}
class QuaternionKeyframeTrack extends KeyframeTrack {
  InterpolantFactoryMethodLinear(result) {
    return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
  }
}
QuaternionKeyframeTrack.prototype.ValueTypeName = "quaternion";
QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class StringKeyframeTrack extends KeyframeTrack {
  // No interpolation parameter because only InterpolateDiscrete is valid.
  constructor(name, times, values) {
    super(name, times, values);
  }
}
StringKeyframeTrack.prototype.ValueTypeName = "string";
StringKeyframeTrack.prototype.ValueBufferType = Array;
StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class VectorKeyframeTrack extends KeyframeTrack {
}
VectorKeyframeTrack.prototype.ValueTypeName = "vector";
class AnimationClip {
  constructor(name = "", duration = -1, tracks = [], blendMode = NormalAnimationBlendMode) {
    this.name = name;
    this.tracks = tracks;
    this.duration = duration;
    this.blendMode = blendMode;
    this.uuid = generateUUID$1();
    if (this.duration < 0) {
      this.resetDuration();
    }
  }
  static parse(json) {
    const tracks = [], jsonTracks = json.tracks, frameTime = 1 / (json.fps || 1);
    for (let i2 = 0, n2 = jsonTracks.length; i2 !== n2; ++i2) {
      tracks.push(parseKeyframeTrack(jsonTracks[i2]).scale(frameTime));
    }
    const clip = new this(json.name, json.duration, tracks, json.blendMode);
    clip.uuid = json.uuid;
    return clip;
  }
  static toJSON(clip) {
    const tracks = [], clipTracks = clip.tracks;
    const json = {
      "name": clip.name,
      "duration": clip.duration,
      "tracks": tracks,
      "uuid": clip.uuid,
      "blendMode": clip.blendMode
    };
    for (let i2 = 0, n2 = clipTracks.length; i2 !== n2; ++i2) {
      tracks.push(KeyframeTrack.toJSON(clipTracks[i2]));
    }
    return json;
  }
  static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
    const numMorphTargets = morphTargetSequence.length;
    const tracks = [];
    for (let i2 = 0; i2 < numMorphTargets; i2++) {
      let times = [];
      let values = [];
      times.push(
        (i2 + numMorphTargets - 1) % numMorphTargets,
        i2,
        (i2 + 1) % numMorphTargets
      );
      values.push(0, 1, 0);
      const order = getKeyframeOrder(times);
      times = sortedArray(times, 1, order);
      values = sortedArray(values, 1, order);
      if (!noLoop && times[0] === 0) {
        times.push(numMorphTargets);
        values.push(values[0]);
      }
      tracks.push(
        new NumberKeyframeTrack(
          ".morphTargetInfluences[" + morphTargetSequence[i2].name + "]",
          times,
          values
        ).scale(1 / fps)
      );
    }
    return new this(name, -1, tracks);
  }
  static findByName(objectOrClipArray, name) {
    let clipArray = objectOrClipArray;
    if (!Array.isArray(objectOrClipArray)) {
      const o2 = objectOrClipArray;
      clipArray = o2.geometry && o2.geometry.animations || o2.animations;
    }
    for (let i2 = 0; i2 < clipArray.length; i2++) {
      if (clipArray[i2].name === name) {
        return clipArray[i2];
      }
    }
    return null;
  }
  static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
    const animationToMorphTargets = {};
    const pattern = /^([\w-]*?)([\d]+)$/;
    for (let i2 = 0, il = morphTargets.length; i2 < il; i2++) {
      const morphTarget = morphTargets[i2];
      const parts = morphTarget.name.match(pattern);
      if (parts && parts.length > 1) {
        const name = parts[1];
        let animationMorphTargets = animationToMorphTargets[name];
        if (!animationMorphTargets) {
          animationToMorphTargets[name] = animationMorphTargets = [];
        }
        animationMorphTargets.push(morphTarget);
      }
    }
    const clips = [];
    for (const name in animationToMorphTargets) {
      clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
    }
    return clips;
  }
  // parse the animation.hierarchy format
  static parseAnimation(animation, bones) {
    if (!animation) {
      console.error("THREE.AnimationClip: No animation in JSONLoader data.");
      return null;
    }
    const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
      if (animationKeys.length !== 0) {
        const times = [];
        const values = [];
        flattenJSON(animationKeys, times, values, propertyName);
        if (times.length !== 0) {
          destTracks.push(new trackType(trackName, times, values));
        }
      }
    };
    const tracks = [];
    const clipName = animation.name || "default";
    const fps = animation.fps || 30;
    const blendMode = animation.blendMode;
    let duration = animation.length || -1;
    const hierarchyTracks = animation.hierarchy || [];
    for (let h2 = 0; h2 < hierarchyTracks.length; h2++) {
      const animationKeys = hierarchyTracks[h2].keys;
      if (!animationKeys || animationKeys.length === 0) continue;
      if (animationKeys[0].morphTargets) {
        const morphTargetNames = {};
        let k2;
        for (k2 = 0; k2 < animationKeys.length; k2++) {
          if (animationKeys[k2].morphTargets) {
            for (let m2 = 0; m2 < animationKeys[k2].morphTargets.length; m2++) {
              morphTargetNames[animationKeys[k2].morphTargets[m2]] = -1;
            }
          }
        }
        for (const morphTargetName in morphTargetNames) {
          const times = [];
          const values = [];
          for (let m2 = 0; m2 !== animationKeys[k2].morphTargets.length; ++m2) {
            const animationKey = animationKeys[k2];
            times.push(animationKey.time);
            values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
          }
          tracks.push(new NumberKeyframeTrack(".morphTargetInfluence[" + morphTargetName + "]", times, values));
        }
        duration = morphTargetNames.length * fps;
      } else {
        const boneName = ".bones[" + bones[h2].name + "]";
        addNonemptyTrack(
          VectorKeyframeTrack,
          boneName + ".position",
          animationKeys,
          "pos",
          tracks
        );
        addNonemptyTrack(
          QuaternionKeyframeTrack,
          boneName + ".quaternion",
          animationKeys,
          "rot",
          tracks
        );
        addNonemptyTrack(
          VectorKeyframeTrack,
          boneName + ".scale",
          animationKeys,
          "scl",
          tracks
        );
      }
    }
    if (tracks.length === 0) {
      return null;
    }
    const clip = new this(clipName, duration, tracks, blendMode);
    return clip;
  }
  resetDuration() {
    const tracks = this.tracks;
    let duration = 0;
    for (let i2 = 0, n2 = tracks.length; i2 !== n2; ++i2) {
      const track = this.tracks[i2];
      duration = Math.max(duration, track.times[track.times.length - 1]);
    }
    this.duration = duration;
    return this;
  }
  trim() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].trim(0, this.duration);
    }
    return this;
  }
  validate() {
    let valid = true;
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      valid = valid && this.tracks[i2].validate();
    }
    return valid;
  }
  optimize() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].optimize();
    }
    return this;
  }
  clone() {
    const tracks = [];
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      tracks.push(this.tracks[i2].clone());
    }
    return new this.constructor(this.name, this.duration, tracks, this.blendMode);
  }
  toJSON() {
    return this.constructor.toJSON(this);
  }
}
function getTrackTypeForValueTypeName(typeName) {
  switch (typeName.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return NumberKeyframeTrack;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return VectorKeyframeTrack;
    case "color":
      return ColorKeyframeTrack;
    case "quaternion":
      return QuaternionKeyframeTrack;
    case "bool":
    case "boolean":
      return BooleanKeyframeTrack;
    case "string":
      return StringKeyframeTrack;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function parseKeyframeTrack(json) {
  if (json.type === void 0) {
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  }
  const trackType = getTrackTypeForValueTypeName(json.type);
  if (json.times === void 0) {
    const times = [], values = [];
    flattenJSON(json.keys, times, values, "value");
    json.times = times;
    json.values = values;
  }
  if (trackType.parse !== void 0) {
    return trackType.parse(json);
  } else {
    return new trackType(json.name, json.times, json.values, json.interpolation);
  }
}
const Cache = {
  enabled: false,
  files: {},
  add: function(key, file) {
    if (this.enabled === false) return;
    this.files[key] = file;
  },
  get: function(key) {
    if (this.enabled === false) return;
    return this.files[key];
  },
  remove: function(key) {
    delete this.files[key];
  },
  clear: function() {
    this.files = {};
  }
};
class LoadingManager {
  constructor(onLoad, onProgress, onError) {
    const scope = this;
    let isLoading = false;
    let itemsLoaded = 0;
    let itemsTotal = 0;
    let urlModifier = void 0;
    const handlers = [];
    this.onStart = void 0;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url) {
      itemsTotal++;
      if (isLoading === false) {
        if (scope.onStart !== void 0) {
          scope.onStart(url, itemsLoaded, itemsTotal);
        }
      }
      isLoading = true;
    };
    this.itemEnd = function(url) {
      itemsLoaded++;
      if (scope.onProgress !== void 0) {
        scope.onProgress(url, itemsLoaded, itemsTotal);
      }
      if (itemsLoaded === itemsTotal) {
        isLoading = false;
        if (scope.onLoad !== void 0) {
          scope.onLoad();
        }
      }
    };
    this.itemError = function(url) {
      if (scope.onError !== void 0) {
        scope.onError(url);
      }
    };
    this.resolveURL = function(url) {
      if (urlModifier) {
        return urlModifier(url);
      }
      return url;
    };
    this.setURLModifier = function(transform) {
      urlModifier = transform;
      return this;
    };
    this.addHandler = function(regex, loader) {
      handlers.push(regex, loader);
      return this;
    };
    this.removeHandler = function(regex) {
      const index = handlers.indexOf(regex);
      if (index !== -1) {
        handlers.splice(index, 2);
      }
      return this;
    };
    this.getHandler = function(file) {
      for (let i2 = 0, l2 = handlers.length; i2 < l2; i2 += 2) {
        const regex = handlers[i2];
        const loader = handlers[i2 + 1];
        if (regex.global) regex.lastIndex = 0;
        if (regex.test(file)) {
          return loader;
        }
      }
      return null;
    };
  }
}
const DefaultLoadingManager = /* @__PURE__ */ new LoadingManager();
class Loader {
  constructor(manager) {
    this.manager = manager !== void 0 ? manager : DefaultLoadingManager;
    this.crossOrigin = "anonymous";
    this.withCredentials = false;
    this.path = "";
    this.resourcePath = "";
    this.requestHeader = {};
  }
  load() {
  }
  loadAsync(url, onProgress) {
    const scope = this;
    return new Promise(function(resolve2, reject) {
      scope.load(url, resolve2, onProgress, reject);
    });
  }
  parse() {
  }
  setCrossOrigin(crossOrigin) {
    this.crossOrigin = crossOrigin;
    return this;
  }
  setWithCredentials(value) {
    this.withCredentials = value;
    return this;
  }
  setPath(path) {
    this.path = path;
    return this;
  }
  setResourcePath(resourcePath) {
    this.resourcePath = resourcePath;
    return this;
  }
  setRequestHeader(requestHeader) {
    this.requestHeader = requestHeader;
    return this;
  }
}
Loader.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const loading = {};
class HttpError extends Error {
  constructor(message, response) {
    super(message);
    this.response = response;
  }
}
class FileLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    if (url === void 0) url = "";
    if (this.path !== void 0) url = this.path + url;
    url = this.manager.resolveURL(url);
    const cached = Cache.get(url);
    if (cached !== void 0) {
      this.manager.itemStart(url);
      setTimeout(() => {
        if (onLoad) onLoad(cached);
        this.manager.itemEnd(url);
      }, 0);
      return cached;
    }
    if (loading[url] !== void 0) {
      loading[url].push({
        onLoad,
        onProgress,
        onError
      });
      return;
    }
    loading[url] = [];
    loading[url].push({
      onLoad,
      onProgress,
      onError
    });
    const req = new Request(url, {
      headers: new Headers(this.requestHeader),
      credentials: this.withCredentials ? "include" : "same-origin"
      // An abort controller could be added within a future PR
    });
    const mimeType = this.mimeType;
    const responseType = this.responseType;
    fetch(req).then((response) => {
      if (response.status === 200 || response.status === 0) {
        if (response.status === 0) {
          console.warn("THREE.FileLoader: HTTP Status 0 received.");
        }
        if (typeof ReadableStream === "undefined" || response.body === void 0 || response.body.getReader === void 0) {
          return response;
        }
        const callbacks = loading[url];
        const reader = response.body.getReader();
        const contentLength = response.headers.get("X-File-Size") || response.headers.get("Content-Length");
        const total = contentLength ? parseInt(contentLength) : 0;
        const lengthComputable = total !== 0;
        let loaded = 0;
        const stream = new ReadableStream({
          start(controller) {
            readData();
            function readData() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                } else {
                  loaded += value.byteLength;
                  const event = new ProgressEvent("progress", { lengthComputable, loaded, total });
                  for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
                    const callback = callbacks[i2];
                    if (callback.onProgress) callback.onProgress(event);
                  }
                  controller.enqueue(value);
                  readData();
                }
              }, (e2) => {
                controller.error(e2);
              });
            }
          }
        });
        return new Response(stream);
      } else {
        throw new HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
      }
    }).then((response) => {
      switch (responseType) {
        case "arraybuffer":
          return response.arrayBuffer();
        case "blob":
          return response.blob();
        case "document":
          return response.text().then((text) => {
            const parser = new DOMParser();
            return parser.parseFromString(text, mimeType);
          });
        case "json":
          return response.json();
        default:
          if (mimeType === void 0) {
            return response.text();
          } else {
            const re2 = /charset="?([^;"\s]*)"?/i;
            const exec = re2.exec(mimeType);
            const label = exec && exec[1] ? exec[1].toLowerCase() : void 0;
            const decoder = new TextDecoder(label);
            return response.arrayBuffer().then((ab) => decoder.decode(ab));
          }
      }
    }).then((data) => {
      Cache.add(url, data);
      const callbacks = loading[url];
      delete loading[url];
      for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
        const callback = callbacks[i2];
        if (callback.onLoad) callback.onLoad(data);
      }
    }).catch((err) => {
      const callbacks = loading[url];
      if (callbacks === void 0) {
        this.manager.itemError(url);
        throw err;
      }
      delete loading[url];
      for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
        const callback = callbacks[i2];
        if (callback.onError) callback.onError(err);
      }
      this.manager.itemError(url);
    }).finally(() => {
      this.manager.itemEnd(url);
    });
    this.manager.itemStart(url);
  }
  setResponseType(value) {
    this.responseType = value;
    return this;
  }
  setMimeType(value) {
    this.mimeType = value;
    return this;
  }
}
class AnimationLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader(this.manager);
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(text) {
      try {
        onLoad(scope.parse(JSON.parse(text)));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  parse(json) {
    const animations = [];
    for (let i2 = 0; i2 < json.length; i2++) {
      const clip = AnimationClip.parse(json[i2]);
      animations.push(clip);
    }
    return animations;
  }
}
class CompressedTextureLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const images = [];
    const texture = new CompressedTexture();
    const loader = new FileLoader(this.manager);
    loader.setPath(this.path);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(scope.withCredentials);
    let loaded = 0;
    function loadTexture(i2) {
      loader.load(url[i2], function(buffer) {
        const texDatas = scope.parse(buffer, true);
        images[i2] = {
          width: texDatas.width,
          height: texDatas.height,
          format: texDatas.format,
          mipmaps: texDatas.mipmaps
        };
        loaded += 1;
        if (loaded === 6) {
          if (texDatas.mipmapCount === 1) texture.minFilter = LinearFilter;
          texture.image = images;
          texture.format = texDatas.format;
          texture.needsUpdate = true;
          if (onLoad) onLoad(texture);
        }
      }, onProgress, onError);
    }
    if (Array.isArray(url)) {
      for (let i2 = 0, il = url.length; i2 < il; ++i2) {
        loadTexture(i2);
      }
    } else {
      loader.load(url, function(buffer) {
        const texDatas = scope.parse(buffer, true);
        if (texDatas.isCubemap) {
          const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
          for (let f2 = 0; f2 < faces; f2++) {
            images[f2] = { mipmaps: [] };
            for (let i2 = 0; i2 < texDatas.mipmapCount; i2++) {
              images[f2].mipmaps.push(texDatas.mipmaps[f2 * texDatas.mipmapCount + i2]);
              images[f2].format = texDatas.format;
              images[f2].width = texDatas.width;
              images[f2].height = texDatas.height;
            }
          }
          texture.image = images;
        } else {
          texture.image.width = texDatas.width;
          texture.image.height = texDatas.height;
          texture.mipmaps = texDatas.mipmaps;
        }
        if (texDatas.mipmapCount === 1) {
          texture.minFilter = LinearFilter;
        }
        texture.format = texDatas.format;
        texture.needsUpdate = true;
        if (onLoad) onLoad(texture);
      }, onProgress, onError);
    }
    return texture;
  }
}
class ImageLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    if (this.path !== void 0) url = this.path + url;
    url = this.manager.resolveURL(url);
    const scope = this;
    const cached = Cache.get(url);
    if (cached !== void 0) {
      scope.manager.itemStart(url);
      setTimeout(function() {
        if (onLoad) onLoad(cached);
        scope.manager.itemEnd(url);
      }, 0);
      return cached;
    }
    const image = createElementNS("img");
    function onImageLoad() {
      removeEventListeners();
      Cache.add(url, this);
      if (onLoad) onLoad(this);
      scope.manager.itemEnd(url);
    }
    function onImageError(event) {
      removeEventListeners();
      if (onError) onError(event);
      scope.manager.itemError(url);
      scope.manager.itemEnd(url);
    }
    function removeEventListeners() {
      image.removeEventListener("load", onImageLoad, false);
      image.removeEventListener("error", onImageError, false);
    }
    image.addEventListener("load", onImageLoad, false);
    image.addEventListener("error", onImageError, false);
    if (url.slice(0, 5) !== "data:") {
      if (this.crossOrigin !== void 0) image.crossOrigin = this.crossOrigin;
    }
    scope.manager.itemStart(url);
    image.src = url;
    return image;
  }
}
class CubeTextureLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(urls, onLoad, onProgress, onError) {
    const texture = new CubeTexture();
    texture.colorSpace = SRGBColorSpace$1;
    const loader = new ImageLoader(this.manager);
    loader.setCrossOrigin(this.crossOrigin);
    loader.setPath(this.path);
    let loaded = 0;
    function loadTexture(i2) {
      loader.load(urls[i2], function(image) {
        texture.images[i2] = image;
        loaded++;
        if (loaded === 6) {
          texture.needsUpdate = true;
          if (onLoad) onLoad(texture);
        }
      }, void 0, onError);
    }
    for (let i2 = 0; i2 < urls.length; ++i2) {
      loadTexture(i2);
    }
    return texture;
  }
}
class DataTextureLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const texture = new DataTexture();
    const loader = new FileLoader(this.manager);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(this.requestHeader);
    loader.setPath(this.path);
    loader.setWithCredentials(scope.withCredentials);
    loader.load(url, function(buffer) {
      let texData;
      try {
        texData = scope.parse(buffer);
      } catch (error2) {
        if (onError !== void 0) {
          onError(error2);
        } else {
          console.error(error2);
          return;
        }
      }
      if (texData.image !== void 0) {
        texture.image = texData.image;
      } else if (texData.data !== void 0) {
        texture.image.width = texData.width;
        texture.image.height = texData.height;
        texture.image.data = texData.data;
      }
      texture.wrapS = texData.wrapS !== void 0 ? texData.wrapS : ClampToEdgeWrapping;
      texture.wrapT = texData.wrapT !== void 0 ? texData.wrapT : ClampToEdgeWrapping;
      texture.magFilter = texData.magFilter !== void 0 ? texData.magFilter : LinearFilter;
      texture.minFilter = texData.minFilter !== void 0 ? texData.minFilter : LinearFilter;
      texture.anisotropy = texData.anisotropy !== void 0 ? texData.anisotropy : 1;
      if (texData.colorSpace !== void 0) {
        texture.colorSpace = texData.colorSpace;
      }
      if (texData.flipY !== void 0) {
        texture.flipY = texData.flipY;
      }
      if (texData.format !== void 0) {
        texture.format = texData.format;
      }
      if (texData.type !== void 0) {
        texture.type = texData.type;
      }
      if (texData.mipmaps !== void 0) {
        texture.mipmaps = texData.mipmaps;
        texture.minFilter = LinearMipmapLinearFilter;
      }
      if (texData.mipmapCount === 1) {
        texture.minFilter = LinearFilter;
      }
      if (texData.generateMipmaps !== void 0) {
        texture.generateMipmaps = texData.generateMipmaps;
      }
      texture.needsUpdate = true;
      if (onLoad) onLoad(texture, texData);
    }, onProgress, onError);
    return texture;
  }
}
class TextureLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const texture = new Texture();
    const loader = new ImageLoader(this.manager);
    loader.setCrossOrigin(this.crossOrigin);
    loader.setPath(this.path);
    loader.load(url, function(image) {
      texture.image = image;
      texture.needsUpdate = true;
      if (onLoad !== void 0) {
        onLoad(texture);
      }
    }, onProgress, onError);
    return texture;
  }
}
class Light extends Object3D {
  constructor(color, intensity = 1) {
    super();
    this.isLight = true;
    this.type = "Light";
    this.color = new Color(color);
    this.intensity = intensity;
  }
  dispose() {
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.color.copy(source.color);
    this.intensity = source.intensity;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.color = this.color.getHex();
    data.object.intensity = this.intensity;
    if (this.groundColor !== void 0) data.object.groundColor = this.groundColor.getHex();
    if (this.distance !== void 0) data.object.distance = this.distance;
    if (this.angle !== void 0) data.object.angle = this.angle;
    if (this.decay !== void 0) data.object.decay = this.decay;
    if (this.penumbra !== void 0) data.object.penumbra = this.penumbra;
    if (this.shadow !== void 0) data.object.shadow = this.shadow.toJSON();
    if (this.target !== void 0) data.object.target = this.target.uuid;
    return data;
  }
}
class HemisphereLight extends Light {
  constructor(skyColor, groundColor, intensity) {
    super(skyColor, intensity);
    this.isHemisphereLight = true;
    this.type = "HemisphereLight";
    this.position.copy(Object3D.DEFAULT_UP);
    this.updateMatrix();
    this.groundColor = new Color(groundColor);
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.groundColor.copy(source.groundColor);
    return this;
  }
}
const _projScreenMatrix$1 = /* @__PURE__ */ new Matrix4();
const _lightPositionWorld$1 = /* @__PURE__ */ new Vector3();
const _lookTarget$1 = /* @__PURE__ */ new Vector3();
class LightShadow {
  constructor(camera) {
    this.camera = camera;
    this.intensity = 1;
    this.bias = 0;
    this.normalBias = 0;
    this.radius = 1;
    this.blurSamples = 8;
    this.mapSize = new Vector2(512, 512);
    this.map = null;
    this.mapPass = null;
    this.matrix = new Matrix4();
    this.autoUpdate = true;
    this.needsUpdate = false;
    this._frustum = new Frustum();
    this._frameExtents = new Vector2(1, 1);
    this._viewportCount = 1;
    this._viewports = [
      new Vector4(0, 0, 1, 1)
    ];
  }
  getViewportCount() {
    return this._viewportCount;
  }
  getFrustum() {
    return this._frustum;
  }
  updateMatrices(light) {
    const shadowCamera = this.camera;
    const shadowMatrix = this.matrix;
    _lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
    shadowCamera.position.copy(_lightPositionWorld$1);
    _lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
    shadowCamera.lookAt(_lookTarget$1);
    shadowCamera.updateMatrixWorld();
    _projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix$1);
    shadowMatrix.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    );
    shadowMatrix.multiply(_projScreenMatrix$1);
  }
  getViewport(viewportIndex) {
    return this._viewports[viewportIndex];
  }
  getFrameExtents() {
    return this._frameExtents;
  }
  dispose() {
    if (this.map) {
      this.map.dispose();
    }
    if (this.mapPass) {
      this.mapPass.dispose();
    }
  }
  copy(source) {
    this.camera = source.camera.clone();
    this.intensity = source.intensity;
    this.bias = source.bias;
    this.radius = source.radius;
    this.mapSize.copy(source.mapSize);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const object = {};
    if (this.intensity !== 1) object.intensity = this.intensity;
    if (this.bias !== 0) object.bias = this.bias;
    if (this.normalBias !== 0) object.normalBias = this.normalBias;
    if (this.radius !== 1) object.radius = this.radius;
    if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
    object.camera = this.camera.toJSON(false).object;
    delete object.camera.matrix;
    return object;
  }
}
class SpotLightShadow extends LightShadow {
  constructor() {
    super(new PerspectiveCamera(50, 1, 0.5, 500));
    this.isSpotLightShadow = true;
    this.focus = 1;
  }
  updateMatrices(light) {
    const camera = this.camera;
    const fov2 = RAD2DEG * 2 * light.angle * this.focus;
    const aspect2 = this.mapSize.width / this.mapSize.height;
    const far = light.distance || camera.far;
    if (fov2 !== camera.fov || aspect2 !== camera.aspect || far !== camera.far) {
      camera.fov = fov2;
      camera.aspect = aspect2;
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    super.updateMatrices(light);
  }
  copy(source) {
    super.copy(source);
    this.focus = source.focus;
    return this;
  }
}
class SpotLight extends Light {
  constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2) {
    super(color, intensity);
    this.isSpotLight = true;
    this.type = "SpotLight";
    this.position.copy(Object3D.DEFAULT_UP);
    this.updateMatrix();
    this.target = new Object3D();
    this.distance = distance;
    this.angle = angle;
    this.penumbra = penumbra;
    this.decay = decay;
    this.map = null;
    this.shadow = new SpotLightShadow();
  }
  get power() {
    return this.intensity * Math.PI;
  }
  set power(power) {
    this.intensity = power / Math.PI;
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.distance = source.distance;
    this.angle = source.angle;
    this.penumbra = source.penumbra;
    this.decay = source.decay;
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
}
const _projScreenMatrix = /* @__PURE__ */ new Matrix4();
const _lightPositionWorld = /* @__PURE__ */ new Vector3();
const _lookTarget = /* @__PURE__ */ new Vector3();
class PointLightShadow extends LightShadow {
  constructor() {
    super(new PerspectiveCamera(90, 1, 0.5, 500));
    this.isPointLightShadow = true;
    this._frameExtents = new Vector2(4, 2);
    this._viewportCount = 6;
    this._viewports = [
      // These viewports map a cube-map onto a 2D texture with the
      // following orientation:
      //
      //  xzXZ
      //   y Y
      //
      // X - Positive x direction
      // x - Negative x direction
      // Y - Positive y direction
      // y - Negative y direction
      // Z - Positive z direction
      // z - Negative z direction
      // positive X
      new Vector4(2, 1, 1, 1),
      // negative X
      new Vector4(0, 1, 1, 1),
      // positive Z
      new Vector4(3, 1, 1, 1),
      // negative Z
      new Vector4(1, 1, 1, 1),
      // positive Y
      new Vector4(3, 0, 1, 1),
      // negative Y
      new Vector4(1, 0, 1, 1)
    ];
    this._cubeDirections = [
      new Vector3(1, 0, 0),
      new Vector3(-1, 0, 0),
      new Vector3(0, 0, 1),
      new Vector3(0, 0, -1),
      new Vector3(0, 1, 0),
      new Vector3(0, -1, 0)
    ];
    this._cubeUps = [
      new Vector3(0, 1, 0),
      new Vector3(0, 1, 0),
      new Vector3(0, 1, 0),
      new Vector3(0, 1, 0),
      new Vector3(0, 0, 1),
      new Vector3(0, 0, -1)
    ];
  }
  updateMatrices(light, viewportIndex = 0) {
    const camera = this.camera;
    const shadowMatrix = this.matrix;
    const far = light.distance || camera.far;
    if (far !== camera.far) {
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    _lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
    camera.position.copy(_lightPositionWorld);
    _lookTarget.copy(camera.position);
    _lookTarget.add(this._cubeDirections[viewportIndex]);
    camera.up.copy(this._cubeUps[viewportIndex]);
    camera.lookAt(_lookTarget);
    camera.updateMatrixWorld();
    shadowMatrix.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z);
    _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix);
  }
}
class PointLight extends Light {
  constructor(color, intensity, distance = 0, decay = 2) {
    super(color, intensity);
    this.isPointLight = true;
    this.type = "PointLight";
    this.distance = distance;
    this.decay = decay;
    this.shadow = new PointLightShadow();
  }
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(power) {
    this.intensity = power / (4 * Math.PI);
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.distance = source.distance;
    this.decay = source.decay;
    this.shadow = source.shadow.clone();
    return this;
  }
}
class OrthographicCamera extends Camera {
  constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2e3) {
    super();
    this.isOrthographicCamera = true;
    this.type = "OrthographicCamera";
    this.zoom = 1;
    this.view = null;
    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
    this.near = near;
    this.far = far;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.left = source.left;
    this.right = source.right;
    this.top = source.top;
    this.bottom = source.bottom;
    this.near = source.near;
    this.far = source.far;
    this.zoom = source.zoom;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    return this;
  }
  setViewOffset(fullWidth, fullHeight, x3, y2, width, height) {
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x3;
    this.view.offsetY = y2;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const dx = (this.right - this.left) / (2 * this.zoom);
    const dy = (this.top - this.bottom) / (2 * this.zoom);
    const cx = (this.right + this.left) / 2;
    const cy = (this.top + this.bottom) / 2;
    let left = cx - dx;
    let right = cx + dx;
    let top = cy + dy;
    let bottom = cy - dy;
    if (this.view !== null && this.view.enabled) {
      const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
      const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      left += scaleW * this.view.offsetX;
      right = left + scaleW * this.view.width;
      top -= scaleH * this.view.offsetY;
      bottom = top - scaleH * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.zoom = this.zoom;
    data.object.left = this.left;
    data.object.right = this.right;
    data.object.top = this.top;
    data.object.bottom = this.bottom;
    data.object.near = this.near;
    data.object.far = this.far;
    if (this.view !== null) data.object.view = Object.assign({}, this.view);
    return data;
  }
}
class DirectionalLightShadow extends LightShadow {
  constructor() {
    super(new OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
    this.isDirectionalLightShadow = true;
  }
}
class DirectionalLight extends Light {
  constructor(color, intensity) {
    super(color, intensity);
    this.isDirectionalLight = true;
    this.type = "DirectionalLight";
    this.position.copy(Object3D.DEFAULT_UP);
    this.updateMatrix();
    this.target = new Object3D();
    this.shadow = new DirectionalLightShadow();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
}
class AmbientLight extends Light {
  constructor(color, intensity) {
    super(color, intensity);
    this.isAmbientLight = true;
    this.type = "AmbientLight";
  }
}
class RectAreaLight extends Light {
  constructor(color, intensity, width = 10, height = 10) {
    super(color, intensity);
    this.isRectAreaLight = true;
    this.type = "RectAreaLight";
    this.width = width;
    this.height = height;
  }
  get power() {
    return this.intensity * this.width * this.height * Math.PI;
  }
  set power(power) {
    this.intensity = power / (this.width * this.height * Math.PI);
  }
  copy(source) {
    super.copy(source);
    this.width = source.width;
    this.height = source.height;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.width = this.width;
    data.object.height = this.height;
    return data;
  }
}
class SphericalHarmonics3 {
  constructor() {
    this.isSphericalHarmonics3 = true;
    this.coefficients = [];
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients.push(new Vector3());
    }
  }
  set(coefficients) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].copy(coefficients[i2]);
    }
    return this;
  }
  zero() {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].set(0, 0, 0);
    }
    return this;
  }
  // get the radiance in the direction of the normal
  // target is a Vector3
  getAt(normal, target) {
    const x3 = normal.x, y2 = normal.y, z2 = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.282095);
    target.addScaledVector(coeff[1], 0.488603 * y2);
    target.addScaledVector(coeff[2], 0.488603 * z2);
    target.addScaledVector(coeff[3], 0.488603 * x3);
    target.addScaledVector(coeff[4], 1.092548 * (x3 * y2));
    target.addScaledVector(coeff[5], 1.092548 * (y2 * z2));
    target.addScaledVector(coeff[6], 0.315392 * (3 * z2 * z2 - 1));
    target.addScaledVector(coeff[7], 1.092548 * (x3 * z2));
    target.addScaledVector(coeff[8], 0.546274 * (x3 * x3 - y2 * y2));
    return target;
  }
  // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
  // target is a Vector3
  // https://graphics.stanford.edu/papers/envmap/envmap.pdf
  getIrradianceAt(normal, target) {
    const x3 = normal.x, y2 = normal.y, z2 = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.886227);
    target.addScaledVector(coeff[1], 2 * 0.511664 * y2);
    target.addScaledVector(coeff[2], 2 * 0.511664 * z2);
    target.addScaledVector(coeff[3], 2 * 0.511664 * x3);
    target.addScaledVector(coeff[4], 2 * 0.429043 * x3 * y2);
    target.addScaledVector(coeff[5], 2 * 0.429043 * y2 * z2);
    target.addScaledVector(coeff[6], 0.743125 * z2 * z2 - 0.247708);
    target.addScaledVector(coeff[7], 2 * 0.429043 * x3 * z2);
    target.addScaledVector(coeff[8], 0.429043 * (x3 * x3 - y2 * y2));
    return target;
  }
  add(sh) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].add(sh.coefficients[i2]);
    }
    return this;
  }
  addScaledSH(sh, s2) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].addScaledVector(sh.coefficients[i2], s2);
    }
    return this;
  }
  scale(s2) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].multiplyScalar(s2);
    }
    return this;
  }
  lerp(sh, alpha) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].lerp(sh.coefficients[i2], alpha);
    }
    return this;
  }
  equals(sh) {
    for (let i2 = 0; i2 < 9; i2++) {
      if (!this.coefficients[i2].equals(sh.coefficients[i2])) {
        return false;
      }
    }
    return true;
  }
  copy(sh) {
    return this.set(sh.coefficients);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(array, offset = 0) {
    const coefficients = this.coefficients;
    for (let i2 = 0; i2 < 9; i2++) {
      coefficients[i2].fromArray(array, offset + i2 * 3);
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const coefficients = this.coefficients;
    for (let i2 = 0; i2 < 9; i2++) {
      coefficients[i2].toArray(array, offset + i2 * 3);
    }
    return array;
  }
  // evaluate the basis functions
  // shBasis is an Array[ 9 ]
  static getBasisAt(normal, shBasis) {
    const x3 = normal.x, y2 = normal.y, z2 = normal.z;
    shBasis[0] = 0.282095;
    shBasis[1] = 0.488603 * y2;
    shBasis[2] = 0.488603 * z2;
    shBasis[3] = 0.488603 * x3;
    shBasis[4] = 1.092548 * x3 * y2;
    shBasis[5] = 1.092548 * y2 * z2;
    shBasis[6] = 0.315392 * (3 * z2 * z2 - 1);
    shBasis[7] = 1.092548 * x3 * z2;
    shBasis[8] = 0.546274 * (x3 * x3 - y2 * y2);
  }
}
class LightProbe extends Light {
  constructor(sh = new SphericalHarmonics3(), intensity = 1) {
    super(void 0, intensity);
    this.isLightProbe = true;
    this.sh = sh;
  }
  copy(source) {
    super.copy(source);
    this.sh.copy(source.sh);
    return this;
  }
  fromJSON(json) {
    this.intensity = json.intensity;
    this.sh.fromArray(json.sh);
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.sh = this.sh.toArray();
    return data;
  }
}
class MaterialLoader extends Loader {
  constructor(manager) {
    super(manager);
    this.textures = {};
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader(scope.manager);
    loader.setPath(scope.path);
    loader.setRequestHeader(scope.requestHeader);
    loader.setWithCredentials(scope.withCredentials);
    loader.load(url, function(text) {
      try {
        onLoad(scope.parse(JSON.parse(text)));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  parse(json) {
    const textures = this.textures;
    function getTexture(name) {
      if (textures[name] === void 0) {
        console.warn("THREE.MaterialLoader: Undefined texture", name);
      }
      return textures[name];
    }
    const material = this.createMaterialFromType(json.type);
    if (json.uuid !== void 0) material.uuid = json.uuid;
    if (json.name !== void 0) material.name = json.name;
    if (json.color !== void 0 && material.color !== void 0) material.color.setHex(json.color);
    if (json.roughness !== void 0) material.roughness = json.roughness;
    if (json.metalness !== void 0) material.metalness = json.metalness;
    if (json.sheen !== void 0) material.sheen = json.sheen;
    if (json.sheenColor !== void 0) material.sheenColor = new Color().setHex(json.sheenColor);
    if (json.sheenRoughness !== void 0) material.sheenRoughness = json.sheenRoughness;
    if (json.emissive !== void 0 && material.emissive !== void 0) material.emissive.setHex(json.emissive);
    if (json.specular !== void 0 && material.specular !== void 0) material.specular.setHex(json.specular);
    if (json.specularIntensity !== void 0) material.specularIntensity = json.specularIntensity;
    if (json.specularColor !== void 0 && material.specularColor !== void 0) material.specularColor.setHex(json.specularColor);
    if (json.shininess !== void 0) material.shininess = json.shininess;
    if (json.clearcoat !== void 0) material.clearcoat = json.clearcoat;
    if (json.clearcoatRoughness !== void 0) material.clearcoatRoughness = json.clearcoatRoughness;
    if (json.dispersion !== void 0) material.dispersion = json.dispersion;
    if (json.iridescence !== void 0) material.iridescence = json.iridescence;
    if (json.iridescenceIOR !== void 0) material.iridescenceIOR = json.iridescenceIOR;
    if (json.iridescenceThicknessRange !== void 0) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
    if (json.transmission !== void 0) material.transmission = json.transmission;
    if (json.thickness !== void 0) material.thickness = json.thickness;
    if (json.attenuationDistance !== void 0) material.attenuationDistance = json.attenuationDistance;
    if (json.attenuationColor !== void 0 && material.attenuationColor !== void 0) material.attenuationColor.setHex(json.attenuationColor);
    if (json.anisotropy !== void 0) material.anisotropy = json.anisotropy;
    if (json.anisotropyRotation !== void 0) material.anisotropyRotation = json.anisotropyRotation;
    if (json.fog !== void 0) material.fog = json.fog;
    if (json.flatShading !== void 0) material.flatShading = json.flatShading;
    if (json.blending !== void 0) material.blending = json.blending;
    if (json.combine !== void 0) material.combine = json.combine;
    if (json.side !== void 0) material.side = json.side;
    if (json.shadowSide !== void 0) material.shadowSide = json.shadowSide;
    if (json.opacity !== void 0) material.opacity = json.opacity;
    if (json.transparent !== void 0) material.transparent = json.transparent;
    if (json.alphaTest !== void 0) material.alphaTest = json.alphaTest;
    if (json.alphaHash !== void 0) material.alphaHash = json.alphaHash;
    if (json.depthFunc !== void 0) material.depthFunc = json.depthFunc;
    if (json.depthTest !== void 0) material.depthTest = json.depthTest;
    if (json.depthWrite !== void 0) material.depthWrite = json.depthWrite;
    if (json.colorWrite !== void 0) material.colorWrite = json.colorWrite;
    if (json.blendSrc !== void 0) material.blendSrc = json.blendSrc;
    if (json.blendDst !== void 0) material.blendDst = json.blendDst;
    if (json.blendEquation !== void 0) material.blendEquation = json.blendEquation;
    if (json.blendSrcAlpha !== void 0) material.blendSrcAlpha = json.blendSrcAlpha;
    if (json.blendDstAlpha !== void 0) material.blendDstAlpha = json.blendDstAlpha;
    if (json.blendEquationAlpha !== void 0) material.blendEquationAlpha = json.blendEquationAlpha;
    if (json.blendColor !== void 0 && material.blendColor !== void 0) material.blendColor.setHex(json.blendColor);
    if (json.blendAlpha !== void 0) material.blendAlpha = json.blendAlpha;
    if (json.stencilWriteMask !== void 0) material.stencilWriteMask = json.stencilWriteMask;
    if (json.stencilFunc !== void 0) material.stencilFunc = json.stencilFunc;
    if (json.stencilRef !== void 0) material.stencilRef = json.stencilRef;
    if (json.stencilFuncMask !== void 0) material.stencilFuncMask = json.stencilFuncMask;
    if (json.stencilFail !== void 0) material.stencilFail = json.stencilFail;
    if (json.stencilZFail !== void 0) material.stencilZFail = json.stencilZFail;
    if (json.stencilZPass !== void 0) material.stencilZPass = json.stencilZPass;
    if (json.stencilWrite !== void 0) material.stencilWrite = json.stencilWrite;
    if (json.wireframe !== void 0) material.wireframe = json.wireframe;
    if (json.wireframeLinewidth !== void 0) material.wireframeLinewidth = json.wireframeLinewidth;
    if (json.wireframeLinecap !== void 0) material.wireframeLinecap = json.wireframeLinecap;
    if (json.wireframeLinejoin !== void 0) material.wireframeLinejoin = json.wireframeLinejoin;
    if (json.rotation !== void 0) material.rotation = json.rotation;
    if (json.linewidth !== void 0) material.linewidth = json.linewidth;
    if (json.dashSize !== void 0) material.dashSize = json.dashSize;
    if (json.gapSize !== void 0) material.gapSize = json.gapSize;
    if (json.scale !== void 0) material.scale = json.scale;
    if (json.polygonOffset !== void 0) material.polygonOffset = json.polygonOffset;
    if (json.polygonOffsetFactor !== void 0) material.polygonOffsetFactor = json.polygonOffsetFactor;
    if (json.polygonOffsetUnits !== void 0) material.polygonOffsetUnits = json.polygonOffsetUnits;
    if (json.dithering !== void 0) material.dithering = json.dithering;
    if (json.alphaToCoverage !== void 0) material.alphaToCoverage = json.alphaToCoverage;
    if (json.premultipliedAlpha !== void 0) material.premultipliedAlpha = json.premultipliedAlpha;
    if (json.forceSinglePass !== void 0) material.forceSinglePass = json.forceSinglePass;
    if (json.visible !== void 0) material.visible = json.visible;
    if (json.toneMapped !== void 0) material.toneMapped = json.toneMapped;
    if (json.userData !== void 0) material.userData = json.userData;
    if (json.vertexColors !== void 0) {
      if (typeof json.vertexColors === "number") {
        material.vertexColors = json.vertexColors > 0 ? true : false;
      } else {
        material.vertexColors = json.vertexColors;
      }
    }
    if (json.uniforms !== void 0) {
      for (const name in json.uniforms) {
        const uniform = json.uniforms[name];
        material.uniforms[name] = {};
        switch (uniform.type) {
          case "t":
            material.uniforms[name].value = getTexture(uniform.value);
            break;
          case "c":
            material.uniforms[name].value = new Color().setHex(uniform.value);
            break;
          case "v2":
            material.uniforms[name].value = new Vector2().fromArray(uniform.value);
            break;
          case "v3":
            material.uniforms[name].value = new Vector3().fromArray(uniform.value);
            break;
          case "v4":
            material.uniforms[name].value = new Vector4().fromArray(uniform.value);
            break;
          case "m3":
            material.uniforms[name].value = new Matrix3().fromArray(uniform.value);
            break;
          case "m4":
            material.uniforms[name].value = new Matrix4().fromArray(uniform.value);
            break;
          default:
            material.uniforms[name].value = uniform.value;
        }
      }
    }
    if (json.defines !== void 0) material.defines = json.defines;
    if (json.vertexShader !== void 0) material.vertexShader = json.vertexShader;
    if (json.fragmentShader !== void 0) material.fragmentShader = json.fragmentShader;
    if (json.glslVersion !== void 0) material.glslVersion = json.glslVersion;
    if (json.extensions !== void 0) {
      for (const key in json.extensions) {
        material.extensions[key] = json.extensions[key];
      }
    }
    if (json.lights !== void 0) material.lights = json.lights;
    if (json.clipping !== void 0) material.clipping = json.clipping;
    if (json.size !== void 0) material.size = json.size;
    if (json.sizeAttenuation !== void 0) material.sizeAttenuation = json.sizeAttenuation;
    if (json.map !== void 0) material.map = getTexture(json.map);
    if (json.matcap !== void 0) material.matcap = getTexture(json.matcap);
    if (json.alphaMap !== void 0) material.alphaMap = getTexture(json.alphaMap);
    if (json.bumpMap !== void 0) material.bumpMap = getTexture(json.bumpMap);
    if (json.bumpScale !== void 0) material.bumpScale = json.bumpScale;
    if (json.normalMap !== void 0) material.normalMap = getTexture(json.normalMap);
    if (json.normalMapType !== void 0) material.normalMapType = json.normalMapType;
    if (json.normalScale !== void 0) {
      let normalScale = json.normalScale;
      if (Array.isArray(normalScale) === false) {
        normalScale = [normalScale, normalScale];
      }
      material.normalScale = new Vector2().fromArray(normalScale);
    }
    if (json.displacementMap !== void 0) material.displacementMap = getTexture(json.displacementMap);
    if (json.displacementScale !== void 0) material.displacementScale = json.displacementScale;
    if (json.displacementBias !== void 0) material.displacementBias = json.displacementBias;
    if (json.roughnessMap !== void 0) material.roughnessMap = getTexture(json.roughnessMap);
    if (json.metalnessMap !== void 0) material.metalnessMap = getTexture(json.metalnessMap);
    if (json.emissiveMap !== void 0) material.emissiveMap = getTexture(json.emissiveMap);
    if (json.emissiveIntensity !== void 0) material.emissiveIntensity = json.emissiveIntensity;
    if (json.specularMap !== void 0) material.specularMap = getTexture(json.specularMap);
    if (json.specularIntensityMap !== void 0) material.specularIntensityMap = getTexture(json.specularIntensityMap);
    if (json.specularColorMap !== void 0) material.specularColorMap = getTexture(json.specularColorMap);
    if (json.envMap !== void 0) material.envMap = getTexture(json.envMap);
    if (json.envMapRotation !== void 0) material.envMapRotation.fromArray(json.envMapRotation);
    if (json.envMapIntensity !== void 0) material.envMapIntensity = json.envMapIntensity;
    if (json.reflectivity !== void 0) material.reflectivity = json.reflectivity;
    if (json.refractionRatio !== void 0) material.refractionRatio = json.refractionRatio;
    if (json.lightMap !== void 0) material.lightMap = getTexture(json.lightMap);
    if (json.lightMapIntensity !== void 0) material.lightMapIntensity = json.lightMapIntensity;
    if (json.aoMap !== void 0) material.aoMap = getTexture(json.aoMap);
    if (json.aoMapIntensity !== void 0) material.aoMapIntensity = json.aoMapIntensity;
    if (json.gradientMap !== void 0) material.gradientMap = getTexture(json.gradientMap);
    if (json.clearcoatMap !== void 0) material.clearcoatMap = getTexture(json.clearcoatMap);
    if (json.clearcoatRoughnessMap !== void 0) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
    if (json.clearcoatNormalMap !== void 0) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
    if (json.clearcoatNormalScale !== void 0) material.clearcoatNormalScale = new Vector2().fromArray(json.clearcoatNormalScale);
    if (json.iridescenceMap !== void 0) material.iridescenceMap = getTexture(json.iridescenceMap);
    if (json.iridescenceThicknessMap !== void 0) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
    if (json.transmissionMap !== void 0) material.transmissionMap = getTexture(json.transmissionMap);
    if (json.thicknessMap !== void 0) material.thicknessMap = getTexture(json.thicknessMap);
    if (json.anisotropyMap !== void 0) material.anisotropyMap = getTexture(json.anisotropyMap);
    if (json.sheenColorMap !== void 0) material.sheenColorMap = getTexture(json.sheenColorMap);
    if (json.sheenRoughnessMap !== void 0) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
    return material;
  }
  setTextures(value) {
    this.textures = value;
    return this;
  }
  createMaterialFromType(type) {
    return MaterialLoader.createMaterialFromType(type);
  }
  static createMaterialFromType(type) {
    const materialLib = {
      ShadowMaterial,
      SpriteMaterial,
      RawShaderMaterial,
      ShaderMaterial,
      PointsMaterial,
      MeshPhysicalMaterial,
      MeshStandardMaterial,
      MeshPhongMaterial,
      MeshToonMaterial,
      MeshNormalMaterial,
      MeshLambertMaterial,
      MeshDepthMaterial,
      MeshDistanceMaterial,
      MeshBasicMaterial,
      MeshMatcapMaterial,
      LineDashedMaterial,
      LineBasicMaterial,
      Material
    };
    return new materialLib[type]();
  }
}
class LoaderUtils {
  static decodeText(array) {
    console.warn("THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.");
    if (typeof TextDecoder !== "undefined") {
      return new TextDecoder().decode(array);
    }
    let s2 = "";
    for (let i2 = 0, il = array.length; i2 < il; i2++) {
      s2 += String.fromCharCode(array[i2]);
    }
    try {
      return decodeURIComponent(escape(s2));
    } catch (e2) {
      return s2;
    }
  }
  static extractUrlBase(url) {
    const index = url.lastIndexOf("/");
    if (index === -1) return "./";
    return url.slice(0, index + 1);
  }
  static resolveURL(url, path) {
    if (typeof url !== "string" || url === "") return "";
    if (/^https?:\/\//i.test(path) && /^\//.test(url)) {
      path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
    }
    if (/^(https?:)?\/\//i.test(url)) return url;
    if (/^data:.*,.*$/i.test(url)) return url;
    if (/^blob:.*$/i.test(url)) return url;
    return path + url;
  }
}
class InstancedBufferGeometry extends BufferGeometry {
  constructor() {
    super();
    this.isInstancedBufferGeometry = true;
    this.type = "InstancedBufferGeometry";
    this.instanceCount = Infinity;
  }
  copy(source) {
    super.copy(source);
    this.instanceCount = source.instanceCount;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.instanceCount = this.instanceCount;
    data.isInstancedBufferGeometry = true;
    return data;
  }
}
class BufferGeometryLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader(scope.manager);
    loader.setPath(scope.path);
    loader.setRequestHeader(scope.requestHeader);
    loader.setWithCredentials(scope.withCredentials);
    loader.load(url, function(text) {
      try {
        onLoad(scope.parse(JSON.parse(text)));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  parse(json) {
    const interleavedBufferMap = {};
    const arrayBufferMap = {};
    function getInterleavedBuffer(json2, uuid) {
      if (interleavedBufferMap[uuid] !== void 0) return interleavedBufferMap[uuid];
      const interleavedBuffers = json2.interleavedBuffers;
      const interleavedBuffer = interleavedBuffers[uuid];
      const buffer = getArrayBuffer(json2, interleavedBuffer.buffer);
      const array = getTypedArray(interleavedBuffer.type, buffer);
      const ib = new InterleavedBuffer(array, interleavedBuffer.stride);
      ib.uuid = interleavedBuffer.uuid;
      interleavedBufferMap[uuid] = ib;
      return ib;
    }
    function getArrayBuffer(json2, uuid) {
      if (arrayBufferMap[uuid] !== void 0) return arrayBufferMap[uuid];
      const arrayBuffers = json2.arrayBuffers;
      const arrayBuffer = arrayBuffers[uuid];
      const ab = new Uint32Array(arrayBuffer).buffer;
      arrayBufferMap[uuid] = ab;
      return ab;
    }
    const geometry = json.isInstancedBufferGeometry ? new InstancedBufferGeometry() : new BufferGeometry();
    const index = json.data.index;
    if (index !== void 0) {
      const typedArray = getTypedArray(index.type, index.array);
      geometry.setIndex(new BufferAttribute(typedArray, 1));
    }
    const attributes = json.data.attributes;
    for (const key in attributes) {
      const attribute = attributes[key];
      let bufferAttribute;
      if (attribute.isInterleavedBufferAttribute) {
        const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
        bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
      } else {
        const typedArray = getTypedArray(attribute.type, attribute.array);
        const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? InstancedBufferAttribute : BufferAttribute;
        bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
      }
      if (attribute.name !== void 0) bufferAttribute.name = attribute.name;
      if (attribute.usage !== void 0) bufferAttribute.setUsage(attribute.usage);
      geometry.setAttribute(key, bufferAttribute);
    }
    const morphAttributes = json.data.morphAttributes;
    if (morphAttributes) {
      for (const key in morphAttributes) {
        const attributeArray = morphAttributes[key];
        const array = [];
        for (let i2 = 0, il = attributeArray.length; i2 < il; i2++) {
          const attribute = attributeArray[i2];
          let bufferAttribute;
          if (attribute.isInterleavedBufferAttribute) {
            const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
            bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
          } else {
            const typedArray = getTypedArray(attribute.type, attribute.array);
            bufferAttribute = new BufferAttribute(typedArray, attribute.itemSize, attribute.normalized);
          }
          if (attribute.name !== void 0) bufferAttribute.name = attribute.name;
          array.push(bufferAttribute);
        }
        geometry.morphAttributes[key] = array;
      }
    }
    const morphTargetsRelative = json.data.morphTargetsRelative;
    if (morphTargetsRelative) {
      geometry.morphTargetsRelative = true;
    }
    const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
    if (groups !== void 0) {
      for (let i2 = 0, n2 = groups.length; i2 !== n2; ++i2) {
        const group = groups[i2];
        geometry.addGroup(group.start, group.count, group.materialIndex);
      }
    }
    const boundingSphere = json.data.boundingSphere;
    if (boundingSphere !== void 0) {
      const center = new Vector3();
      if (boundingSphere.center !== void 0) {
        center.fromArray(boundingSphere.center);
      }
      geometry.boundingSphere = new Sphere(center, boundingSphere.radius);
    }
    if (json.name) geometry.name = json.name;
    if (json.userData) geometry.userData = json.userData;
    return geometry;
  }
}
class ObjectLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const path = this.path === "" ? LoaderUtils.extractUrlBase(url) : this.path;
    this.resourcePath = this.resourcePath || path;
    const loader = new FileLoader(this.manager);
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(text) {
      let json = null;
      try {
        json = JSON.parse(text);
      } catch (error2) {
        if (onError !== void 0) onError(error2);
        console.error("THREE:ObjectLoader: Can't parse " + url + ".", error2.message);
        return;
      }
      const metadata = json.metadata;
      if (metadata === void 0 || metadata.type === void 0 || metadata.type.toLowerCase() === "geometry") {
        if (onError !== void 0) onError(new Error("THREE.ObjectLoader: Can't load " + url));
        console.error("THREE.ObjectLoader: Can't load " + url);
        return;
      }
      scope.parse(json, onLoad);
    }, onProgress, onError);
  }
  async loadAsync(url, onProgress) {
    const scope = this;
    const path = this.path === "" ? LoaderUtils.extractUrlBase(url) : this.path;
    this.resourcePath = this.resourcePath || path;
    const loader = new FileLoader(this.manager);
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    const text = await loader.loadAsync(url, onProgress);
    const json = JSON.parse(text);
    const metadata = json.metadata;
    if (metadata === void 0 || metadata.type === void 0 || metadata.type.toLowerCase() === "geometry") {
      throw new Error("THREE.ObjectLoader: Can't load " + url);
    }
    return await scope.parseAsync(json);
  }
  parse(json, onLoad) {
    const animations = this.parseAnimations(json.animations);
    const shapes = this.parseShapes(json.shapes);
    const geometries = this.parseGeometries(json.geometries, shapes);
    const images = this.parseImages(json.images, function() {
      if (onLoad !== void 0) onLoad(object);
    });
    const textures = this.parseTextures(json.textures, images);
    const materials = this.parseMaterials(json.materials, textures);
    const object = this.parseObject(json.object, geometries, materials, textures, animations);
    const skeletons = this.parseSkeletons(json.skeletons, object);
    this.bindSkeletons(object, skeletons);
    this.bindLightTargets(object);
    if (onLoad !== void 0) {
      let hasImages = false;
      for (const uuid in images) {
        if (images[uuid].data instanceof HTMLImageElement) {
          hasImages = true;
          break;
        }
      }
      if (hasImages === false) onLoad(object);
    }
    return object;
  }
  async parseAsync(json) {
    const animations = this.parseAnimations(json.animations);
    const shapes = this.parseShapes(json.shapes);
    const geometries = this.parseGeometries(json.geometries, shapes);
    const images = await this.parseImagesAsync(json.images);
    const textures = this.parseTextures(json.textures, images);
    const materials = this.parseMaterials(json.materials, textures);
    const object = this.parseObject(json.object, geometries, materials, textures, animations);
    const skeletons = this.parseSkeletons(json.skeletons, object);
    this.bindSkeletons(object, skeletons);
    this.bindLightTargets(object);
    return object;
  }
  parseShapes(json) {
    const shapes = {};
    if (json !== void 0) {
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const shape = new Shape().fromJSON(json[i2]);
        shapes[shape.uuid] = shape;
      }
    }
    return shapes;
  }
  parseSkeletons(json, object) {
    const skeletons = {};
    const bones = {};
    object.traverse(function(child) {
      if (child.isBone) bones[child.uuid] = child;
    });
    if (json !== void 0) {
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const skeleton = new Skeleton().fromJSON(json[i2], bones);
        skeletons[skeleton.uuid] = skeleton;
      }
    }
    return skeletons;
  }
  parseGeometries(json, shapes) {
    const geometries = {};
    if (json !== void 0) {
      const bufferGeometryLoader = new BufferGeometryLoader();
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        let geometry;
        const data = json[i2];
        switch (data.type) {
          case "BufferGeometry":
          case "InstancedBufferGeometry":
            geometry = bufferGeometryLoader.parse(data);
            break;
          default:
            if (data.type in Geometries) {
              geometry = Geometries[data.type].fromJSON(data, shapes);
            } else {
              console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
            }
        }
        geometry.uuid = data.uuid;
        if (data.name !== void 0) geometry.name = data.name;
        if (data.userData !== void 0) geometry.userData = data.userData;
        geometries[data.uuid] = geometry;
      }
    }
    return geometries;
  }
  parseMaterials(json, textures) {
    const cache = {};
    const materials = {};
    if (json !== void 0) {
      const loader = new MaterialLoader();
      loader.setTextures(textures);
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const data = json[i2];
        if (cache[data.uuid] === void 0) {
          cache[data.uuid] = loader.parse(data);
        }
        materials[data.uuid] = cache[data.uuid];
      }
    }
    return materials;
  }
  parseAnimations(json) {
    const animations = {};
    if (json !== void 0) {
      for (let i2 = 0; i2 < json.length; i2++) {
        const data = json[i2];
        const clip = AnimationClip.parse(data);
        animations[clip.uuid] = clip;
      }
    }
    return animations;
  }
  parseImages(json, onLoad) {
    const scope = this;
    const images = {};
    let loader;
    function loadImage(url) {
      scope.manager.itemStart(url);
      return loader.load(url, function() {
        scope.manager.itemEnd(url);
      }, void 0, function() {
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      });
    }
    function deserializeImage(image) {
      if (typeof image === "string") {
        const url = image;
        const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
        return loadImage(path);
      } else {
        if (image.data) {
          return {
            data: getTypedArray(image.type, image.data),
            width: image.width,
            height: image.height
          };
        } else {
          return null;
        }
      }
    }
    if (json !== void 0 && json.length > 0) {
      const manager = new LoadingManager(onLoad);
      loader = new ImageLoader(manager);
      loader.setCrossOrigin(this.crossOrigin);
      for (let i2 = 0, il = json.length; i2 < il; i2++) {
        const image = json[i2];
        const url = image.url;
        if (Array.isArray(url)) {
          const imageArray = [];
          for (let j3 = 0, jl = url.length; j3 < jl; j3++) {
            const currentUrl = url[j3];
            const deserializedImage = deserializeImage(currentUrl);
            if (deserializedImage !== null) {
              if (deserializedImage instanceof HTMLImageElement) {
                imageArray.push(deserializedImage);
              } else {
                imageArray.push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
              }
            }
          }
          images[image.uuid] = new Source(imageArray);
        } else {
          const deserializedImage = deserializeImage(image.url);
          images[image.uuid] = new Source(deserializedImage);
        }
      }
    }
    return images;
  }
  async parseImagesAsync(json) {
    const scope = this;
    const images = {};
    let loader;
    async function deserializeImage(image) {
      if (typeof image === "string") {
        const url = image;
        const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
        return await loader.loadAsync(path);
      } else {
        if (image.data) {
          return {
            data: getTypedArray(image.type, image.data),
            width: image.width,
            height: image.height
          };
        } else {
          return null;
        }
      }
    }
    if (json !== void 0 && json.length > 0) {
      loader = new ImageLoader(this.manager);
      loader.setCrossOrigin(this.crossOrigin);
      for (let i2 = 0, il = json.length; i2 < il; i2++) {
        const image = json[i2];
        const url = image.url;
        if (Array.isArray(url)) {
          const imageArray = [];
          for (let j3 = 0, jl = url.length; j3 < jl; j3++) {
            const currentUrl = url[j3];
            const deserializedImage = await deserializeImage(currentUrl);
            if (deserializedImage !== null) {
              if (deserializedImage instanceof HTMLImageElement) {
                imageArray.push(deserializedImage);
              } else {
                imageArray.push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
              }
            }
          }
          images[image.uuid] = new Source(imageArray);
        } else {
          const deserializedImage = await deserializeImage(image.url);
          images[image.uuid] = new Source(deserializedImage);
        }
      }
    }
    return images;
  }
  parseTextures(json, images) {
    function parseConstant(value, type) {
      if (typeof value === "number") return value;
      console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
      return type[value];
    }
    const textures = {};
    if (json !== void 0) {
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const data = json[i2];
        if (data.image === void 0) {
          console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
        }
        if (images[data.image] === void 0) {
          console.warn("THREE.ObjectLoader: Undefined image", data.image);
        }
        const source = images[data.image];
        const image = source.data;
        let texture;
        if (Array.isArray(image)) {
          texture = new CubeTexture();
          if (image.length === 6) texture.needsUpdate = true;
        } else {
          if (image && image.data) {
            texture = new DataTexture();
          } else {
            texture = new Texture();
          }
          if (image) texture.needsUpdate = true;
        }
        texture.source = source;
        texture.uuid = data.uuid;
        if (data.name !== void 0) texture.name = data.name;
        if (data.mapping !== void 0) texture.mapping = parseConstant(data.mapping, TEXTURE_MAPPING);
        if (data.channel !== void 0) texture.channel = data.channel;
        if (data.offset !== void 0) texture.offset.fromArray(data.offset);
        if (data.repeat !== void 0) texture.repeat.fromArray(data.repeat);
        if (data.center !== void 0) texture.center.fromArray(data.center);
        if (data.rotation !== void 0) texture.rotation = data.rotation;
        if (data.wrap !== void 0) {
          texture.wrapS = parseConstant(data.wrap[0], TEXTURE_WRAPPING);
          texture.wrapT = parseConstant(data.wrap[1], TEXTURE_WRAPPING);
        }
        if (data.format !== void 0) texture.format = data.format;
        if (data.internalFormat !== void 0) texture.internalFormat = data.internalFormat;
        if (data.type !== void 0) texture.type = data.type;
        if (data.colorSpace !== void 0) texture.colorSpace = data.colorSpace;
        if (data.minFilter !== void 0) texture.minFilter = parseConstant(data.minFilter, TEXTURE_FILTER);
        if (data.magFilter !== void 0) texture.magFilter = parseConstant(data.magFilter, TEXTURE_FILTER);
        if (data.anisotropy !== void 0) texture.anisotropy = data.anisotropy;
        if (data.flipY !== void 0) texture.flipY = data.flipY;
        if (data.generateMipmaps !== void 0) texture.generateMipmaps = data.generateMipmaps;
        if (data.premultiplyAlpha !== void 0) texture.premultiplyAlpha = data.premultiplyAlpha;
        if (data.unpackAlignment !== void 0) texture.unpackAlignment = data.unpackAlignment;
        if (data.compareFunction !== void 0) texture.compareFunction = data.compareFunction;
        if (data.userData !== void 0) texture.userData = data.userData;
        textures[data.uuid] = texture;
      }
    }
    return textures;
  }
  parseObject(data, geometries, materials, textures, animations) {
    let object;
    function getGeometry(name) {
      if (geometries[name] === void 0) {
        console.warn("THREE.ObjectLoader: Undefined geometry", name);
      }
      return geometries[name];
    }
    function getMaterial(name) {
      if (name === void 0) return void 0;
      if (Array.isArray(name)) {
        const array = [];
        for (let i2 = 0, l2 = name.length; i2 < l2; i2++) {
          const uuid = name[i2];
          if (materials[uuid] === void 0) {
            console.warn("THREE.ObjectLoader: Undefined material", uuid);
          }
          array.push(materials[uuid]);
        }
        return array;
      }
      if (materials[name] === void 0) {
        console.warn("THREE.ObjectLoader: Undefined material", name);
      }
      return materials[name];
    }
    function getTexture(uuid) {
      if (textures[uuid] === void 0) {
        console.warn("THREE.ObjectLoader: Undefined texture", uuid);
      }
      return textures[uuid];
    }
    let geometry, material;
    switch (data.type) {
      case "Scene":
        object = new Scene();
        if (data.background !== void 0) {
          if (Number.isInteger(data.background)) {
            object.background = new Color(data.background);
          } else {
            object.background = getTexture(data.background);
          }
        }
        if (data.environment !== void 0) {
          object.environment = getTexture(data.environment);
        }
        if (data.fog !== void 0) {
          if (data.fog.type === "Fog") {
            object.fog = new Fog(data.fog.color, data.fog.near, data.fog.far);
          } else if (data.fog.type === "FogExp2") {
            object.fog = new FogExp2(data.fog.color, data.fog.density);
          }
          if (data.fog.name !== "") {
            object.fog.name = data.fog.name;
          }
        }
        if (data.backgroundBlurriness !== void 0) object.backgroundBlurriness = data.backgroundBlurriness;
        if (data.backgroundIntensity !== void 0) object.backgroundIntensity = data.backgroundIntensity;
        if (data.backgroundRotation !== void 0) object.backgroundRotation.fromArray(data.backgroundRotation);
        if (data.environmentIntensity !== void 0) object.environmentIntensity = data.environmentIntensity;
        if (data.environmentRotation !== void 0) object.environmentRotation.fromArray(data.environmentRotation);
        break;
      case "PerspectiveCamera":
        object = new PerspectiveCamera(data.fov, data.aspect, data.near, data.far);
        if (data.focus !== void 0) object.focus = data.focus;
        if (data.zoom !== void 0) object.zoom = data.zoom;
        if (data.filmGauge !== void 0) object.filmGauge = data.filmGauge;
        if (data.filmOffset !== void 0) object.filmOffset = data.filmOffset;
        if (data.view !== void 0) object.view = Object.assign({}, data.view);
        break;
      case "OrthographicCamera":
        object = new OrthographicCamera(data.left, data.right, data.top, data.bottom, data.near, data.far);
        if (data.zoom !== void 0) object.zoom = data.zoom;
        if (data.view !== void 0) object.view = Object.assign({}, data.view);
        break;
      case "AmbientLight":
        object = new AmbientLight(data.color, data.intensity);
        break;
      case "DirectionalLight":
        object = new DirectionalLight(data.color, data.intensity);
        object.target = data.target || "";
        break;
      case "PointLight":
        object = new PointLight(data.color, data.intensity, data.distance, data.decay);
        break;
      case "RectAreaLight":
        object = new RectAreaLight(data.color, data.intensity, data.width, data.height);
        break;
      case "SpotLight":
        object = new SpotLight(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
        object.target = data.target || "";
        break;
      case "HemisphereLight":
        object = new HemisphereLight(data.color, data.groundColor, data.intensity);
        break;
      case "LightProbe":
        object = new LightProbe().fromJSON(data);
        break;
      case "SkinnedMesh":
        geometry = getGeometry(data.geometry);
        material = getMaterial(data.material);
        object = new SkinnedMesh(geometry, material);
        if (data.bindMode !== void 0) object.bindMode = data.bindMode;
        if (data.bindMatrix !== void 0) object.bindMatrix.fromArray(data.bindMatrix);
        if (data.skeleton !== void 0) object.skeleton = data.skeleton;
        break;
      case "Mesh":
        geometry = getGeometry(data.geometry);
        material = getMaterial(data.material);
        object = new Mesh(geometry, material);
        break;
      case "InstancedMesh":
        geometry = getGeometry(data.geometry);
        material = getMaterial(data.material);
        const count = data.count;
        const instanceMatrix = data.instanceMatrix;
        const instanceColor = data.instanceColor;
        object = new InstancedMesh(geometry, material, count);
        object.instanceMatrix = new InstancedBufferAttribute(new Float32Array(instanceMatrix.array), 16);
        if (instanceColor !== void 0) object.instanceColor = new InstancedBufferAttribute(new Float32Array(instanceColor.array), instanceColor.itemSize);
        break;
      case "BatchedMesh":
        geometry = getGeometry(data.geometry);
        material = getMaterial(data.material);
        object = new BatchedMesh(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
        object.geometry = geometry;
        object.perObjectFrustumCulled = data.perObjectFrustumCulled;
        object.sortObjects = data.sortObjects;
        object._drawRanges = data.drawRanges;
        object._reservedRanges = data.reservedRanges;
        object._visibility = data.visibility;
        object._active = data.active;
        object._bounds = data.bounds.map((bound) => {
          const box = new Box3();
          box.min.fromArray(bound.boxMin);
          box.max.fromArray(bound.boxMax);
          const sphere = new Sphere();
          sphere.radius = bound.sphereRadius;
          sphere.center.fromArray(bound.sphereCenter);
          return {
            boxInitialized: bound.boxInitialized,
            box,
            sphereInitialized: bound.sphereInitialized,
            sphere
          };
        });
        object._maxInstanceCount = data.maxInstanceCount;
        object._maxVertexCount = data.maxVertexCount;
        object._maxIndexCount = data.maxIndexCount;
        object._geometryInitialized = data.geometryInitialized;
        object._geometryCount = data.geometryCount;
        object._matricesTexture = getTexture(data.matricesTexture.uuid);
        if (data.colorsTexture !== void 0) object._colorsTexture = getTexture(data.colorsTexture.uuid);
        break;
      case "LOD":
        object = new LOD();
        break;
      case "Line":
        object = new Line(getGeometry(data.geometry), getMaterial(data.material));
        break;
      case "LineLoop":
        object = new LineLoop(getGeometry(data.geometry), getMaterial(data.material));
        break;
      case "LineSegments":
        object = new LineSegments(getGeometry(data.geometry), getMaterial(data.material));
        break;
      case "PointCloud":
      case "Points":
        object = new Points(getGeometry(data.geometry), getMaterial(data.material));
        break;
      case "Sprite":
        object = new Sprite(getMaterial(data.material));
        break;
      case "Group":
        object = new Group();
        break;
      case "Bone":
        object = new Bone();
        break;
      default:
        object = new Object3D();
    }
    object.uuid = data.uuid;
    if (data.name !== void 0) object.name = data.name;
    if (data.matrix !== void 0) {
      object.matrix.fromArray(data.matrix);
      if (data.matrixAutoUpdate !== void 0) object.matrixAutoUpdate = data.matrixAutoUpdate;
      if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
    } else {
      if (data.position !== void 0) object.position.fromArray(data.position);
      if (data.rotation !== void 0) object.rotation.fromArray(data.rotation);
      if (data.quaternion !== void 0) object.quaternion.fromArray(data.quaternion);
      if (data.scale !== void 0) object.scale.fromArray(data.scale);
    }
    if (data.up !== void 0) object.up.fromArray(data.up);
    if (data.castShadow !== void 0) object.castShadow = data.castShadow;
    if (data.receiveShadow !== void 0) object.receiveShadow = data.receiveShadow;
    if (data.shadow) {
      if (data.shadow.intensity !== void 0) object.shadow.intensity = data.shadow.intensity;
      if (data.shadow.bias !== void 0) object.shadow.bias = data.shadow.bias;
      if (data.shadow.normalBias !== void 0) object.shadow.normalBias = data.shadow.normalBias;
      if (data.shadow.radius !== void 0) object.shadow.radius = data.shadow.radius;
      if (data.shadow.mapSize !== void 0) object.shadow.mapSize.fromArray(data.shadow.mapSize);
      if (data.shadow.camera !== void 0) object.shadow.camera = this.parseObject(data.shadow.camera);
    }
    if (data.visible !== void 0) object.visible = data.visible;
    if (data.frustumCulled !== void 0) object.frustumCulled = data.frustumCulled;
    if (data.renderOrder !== void 0) object.renderOrder = data.renderOrder;
    if (data.userData !== void 0) object.userData = data.userData;
    if (data.layers !== void 0) object.layers.mask = data.layers;
    if (data.children !== void 0) {
      const children = data.children;
      for (let i2 = 0; i2 < children.length; i2++) {
        object.add(this.parseObject(children[i2], geometries, materials, textures, animations));
      }
    }
    if (data.animations !== void 0) {
      const objectAnimations = data.animations;
      for (let i2 = 0; i2 < objectAnimations.length; i2++) {
        const uuid = objectAnimations[i2];
        object.animations.push(animations[uuid]);
      }
    }
    if (data.type === "LOD") {
      if (data.autoUpdate !== void 0) object.autoUpdate = data.autoUpdate;
      const levels = data.levels;
      for (let l2 = 0; l2 < levels.length; l2++) {
        const level = levels[l2];
        const child = object.getObjectByProperty("uuid", level.object);
        if (child !== void 0) {
          object.addLevel(child, level.distance, level.hysteresis);
        }
      }
    }
    return object;
  }
  bindSkeletons(object, skeletons) {
    if (Object.keys(skeletons).length === 0) return;
    object.traverse(function(child) {
      if (child.isSkinnedMesh === true && child.skeleton !== void 0) {
        const skeleton = skeletons[child.skeleton];
        if (skeleton === void 0) {
          console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
        } else {
          child.bind(skeleton, child.bindMatrix);
        }
      }
    });
  }
  bindLightTargets(object) {
    object.traverse(function(child) {
      if (child.isDirectionalLight || child.isSpotLight) {
        const uuid = child.target;
        const target = object.getObjectByProperty("uuid", uuid);
        if (target !== void 0) {
          child.target = target;
        } else {
          child.target = new Object3D();
        }
      }
    });
  }
}
const TEXTURE_MAPPING = {
  UVMapping,
  CubeReflectionMapping,
  CubeRefractionMapping,
  EquirectangularReflectionMapping,
  EquirectangularRefractionMapping,
  CubeUVReflectionMapping
};
const TEXTURE_WRAPPING = {
  RepeatWrapping,
  ClampToEdgeWrapping,
  MirroredRepeatWrapping
};
const TEXTURE_FILTER = {
  NearestFilter,
  NearestMipmapNearestFilter,
  NearestMipmapLinearFilter,
  LinearFilter,
  LinearMipmapNearestFilter,
  LinearMipmapLinearFilter
};
class ImageBitmapLoader extends Loader {
  constructor(manager) {
    super(manager);
    this.isImageBitmapLoader = true;
    if (typeof createImageBitmap === "undefined") {
      console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
    }
    if (typeof fetch === "undefined") {
      console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
    }
    this.options = { premultiplyAlpha: "none" };
  }
  setOptions(options) {
    this.options = options;
    return this;
  }
  load(url, onLoad, onProgress, onError) {
    if (url === void 0) url = "";
    if (this.path !== void 0) url = this.path + url;
    url = this.manager.resolveURL(url);
    const scope = this;
    const cached = Cache.get(url);
    if (cached !== void 0) {
      scope.manager.itemStart(url);
      if (cached.then) {
        cached.then((imageBitmap) => {
          if (onLoad) onLoad(imageBitmap);
          scope.manager.itemEnd(url);
        }).catch((e2) => {
          if (onError) onError(e2);
        });
        return;
      }
      setTimeout(function() {
        if (onLoad) onLoad(cached);
        scope.manager.itemEnd(url);
      }, 0);
      return cached;
    }
    const fetchOptions = {};
    fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
    fetchOptions.headers = this.requestHeader;
    const promise = fetch(url, fetchOptions).then(function(res) {
      return res.blob();
    }).then(function(blob) {
      return createImageBitmap(blob, Object.assign(scope.options, { colorSpaceConversion: "none" }));
    }).then(function(imageBitmap) {
      Cache.add(url, imageBitmap);
      if (onLoad) onLoad(imageBitmap);
      scope.manager.itemEnd(url);
      return imageBitmap;
    }).catch(function(e2) {
      if (onError) onError(e2);
      Cache.remove(url);
      scope.manager.itemError(url);
      scope.manager.itemEnd(url);
    });
    Cache.add(url, promise);
    scope.manager.itemStart(url);
  }
}
let _context$1;
class AudioContext {
  static getContext() {
    if (_context$1 === void 0) {
      _context$1 = new (window.AudioContext || window.webkitAudioContext)();
    }
    return _context$1;
  }
  static setContext(value) {
    _context$1 = value;
  }
}
class AudioLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader(this.manager);
    loader.setResponseType("arraybuffer");
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(buffer) {
      try {
        const bufferCopy = buffer.slice(0);
        const context4 = AudioContext.getContext();
        context4.decodeAudioData(bufferCopy, function(audioBuffer) {
          onLoad(audioBuffer);
        }).catch(handleError);
      } catch (e2) {
        handleError(e2);
      }
    }, onProgress, onError);
    function handleError(e2) {
      if (onError) {
        onError(e2);
      } else {
        console.error(e2);
      }
      scope.manager.itemError(url);
    }
  }
}
const _eyeRight = /* @__PURE__ */ new Matrix4();
const _eyeLeft = /* @__PURE__ */ new Matrix4();
const _projectionMatrix = /* @__PURE__ */ new Matrix4();
class StereoCamera {
  constructor() {
    this.type = "StereoCamera";
    this.aspect = 1;
    this.eyeSep = 0.064;
    this.cameraL = new PerspectiveCamera();
    this.cameraL.layers.enable(1);
    this.cameraL.matrixAutoUpdate = false;
    this.cameraR = new PerspectiveCamera();
    this.cameraR.layers.enable(2);
    this.cameraR.matrixAutoUpdate = false;
    this._cache = {
      focus: null,
      fov: null,
      aspect: null,
      near: null,
      far: null,
      zoom: null,
      eyeSep: null
    };
  }
  update(camera) {
    const cache = this._cache;
    const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
    if (needsUpdate) {
      cache.focus = camera.focus;
      cache.fov = camera.fov;
      cache.aspect = camera.aspect * this.aspect;
      cache.near = camera.near;
      cache.far = camera.far;
      cache.zoom = camera.zoom;
      cache.eyeSep = this.eyeSep;
      _projectionMatrix.copy(camera.projectionMatrix);
      const eyeSepHalf = cache.eyeSep / 2;
      const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
      const ymax = cache.near * Math.tan(DEG2RAD$2 * cache.fov * 0.5) / cache.zoom;
      let xmin, xmax;
      _eyeLeft.elements[12] = -eyeSepHalf;
      _eyeRight.elements[12] = eyeSepHalf;
      xmin = -ymax * cache.aspect + eyeSepOnProjection;
      xmax = ymax * cache.aspect + eyeSepOnProjection;
      _projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
      _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
      this.cameraL.projectionMatrix.copy(_projectionMatrix);
      xmin = -ymax * cache.aspect - eyeSepOnProjection;
      xmax = ymax * cache.aspect - eyeSepOnProjection;
      _projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
      _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
      this.cameraR.projectionMatrix.copy(_projectionMatrix);
    }
    this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply(_eyeLeft);
    this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply(_eyeRight);
  }
}
class ArrayCamera extends PerspectiveCamera {
  constructor(array = []) {
    super();
    this.isArrayCamera = true;
    this.cameras = array;
    this.index = 0;
  }
}
class Clock {
  constructor(autoStart = true) {
    this.autoStart = autoStart;
    this.startTime = 0;
    this.oldTime = 0;
    this.elapsedTime = 0;
    this.running = false;
  }
  start() {
    this.startTime = now$2();
    this.oldTime = this.startTime;
    this.elapsedTime = 0;
    this.running = true;
  }
  stop() {
    this.getElapsedTime();
    this.running = false;
    this.autoStart = false;
  }
  getElapsedTime() {
    this.getDelta();
    return this.elapsedTime;
  }
  getDelta() {
    let diff = 0;
    if (this.autoStart && !this.running) {
      this.start();
      return 0;
    }
    if (this.running) {
      const newTime = now$2();
      diff = (newTime - this.oldTime) / 1e3;
      this.oldTime = newTime;
      this.elapsedTime += diff;
    }
    return diff;
  }
}
function now$2() {
  return performance.now();
}
const _position$1$1 = /* @__PURE__ */ new Vector3();
const _quaternion$1 = /* @__PURE__ */ new Quaternion();
const _scale$1 = /* @__PURE__ */ new Vector3();
const _orientation$1 = /* @__PURE__ */ new Vector3();
class AudioListener extends Object3D {
  constructor() {
    super();
    this.type = "AudioListener";
    this.context = AudioContext.getContext();
    this.gain = this.context.createGain();
    this.gain.connect(this.context.destination);
    this.filter = null;
    this.timeDelta = 0;
    this._clock = new Clock();
  }
  getInput() {
    return this.gain;
  }
  removeFilter() {
    if (this.filter !== null) {
      this.gain.disconnect(this.filter);
      this.filter.disconnect(this.context.destination);
      this.gain.connect(this.context.destination);
      this.filter = null;
    }
    return this;
  }
  getFilter() {
    return this.filter;
  }
  setFilter(value) {
    if (this.filter !== null) {
      this.gain.disconnect(this.filter);
      this.filter.disconnect(this.context.destination);
    } else {
      this.gain.disconnect(this.context.destination);
    }
    this.filter = value;
    this.gain.connect(this.filter);
    this.filter.connect(this.context.destination);
    return this;
  }
  getMasterVolume() {
    return this.gain.gain.value;
  }
  setMasterVolume(value) {
    this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
    return this;
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    const listener = this.context.listener;
    const up = this.up;
    this.timeDelta = this._clock.getDelta();
    this.matrixWorld.decompose(_position$1$1, _quaternion$1, _scale$1);
    _orientation$1.set(0, 0, -1).applyQuaternion(_quaternion$1);
    if (listener.positionX) {
      const endTime = this.context.currentTime + this.timeDelta;
      listener.positionX.linearRampToValueAtTime(_position$1$1.x, endTime);
      listener.positionY.linearRampToValueAtTime(_position$1$1.y, endTime);
      listener.positionZ.linearRampToValueAtTime(_position$1$1.z, endTime);
      listener.forwardX.linearRampToValueAtTime(_orientation$1.x, endTime);
      listener.forwardY.linearRampToValueAtTime(_orientation$1.y, endTime);
      listener.forwardZ.linearRampToValueAtTime(_orientation$1.z, endTime);
      listener.upX.linearRampToValueAtTime(up.x, endTime);
      listener.upY.linearRampToValueAtTime(up.y, endTime);
      listener.upZ.linearRampToValueAtTime(up.z, endTime);
    } else {
      listener.setPosition(_position$1$1.x, _position$1$1.y, _position$1$1.z);
      listener.setOrientation(_orientation$1.x, _orientation$1.y, _orientation$1.z, up.x, up.y, up.z);
    }
  }
}
class Audio extends Object3D {
  constructor(listener) {
    super();
    this.type = "Audio";
    this.listener = listener;
    this.context = listener.context;
    this.gain = this.context.createGain();
    this.gain.connect(listener.getInput());
    this.autoplay = false;
    this.buffer = null;
    this.detune = 0;
    this.loop = false;
    this.loopStart = 0;
    this.loopEnd = 0;
    this.offset = 0;
    this.duration = void 0;
    this.playbackRate = 1;
    this.isPlaying = false;
    this.hasPlaybackControl = true;
    this.source = null;
    this.sourceType = "empty";
    this._startedAt = 0;
    this._progress = 0;
    this._connected = false;
    this.filters = [];
  }
  getOutput() {
    return this.gain;
  }
  setNodeSource(audioNode) {
    this.hasPlaybackControl = false;
    this.sourceType = "audioNode";
    this.source = audioNode;
    this.connect();
    return this;
  }
  setMediaElementSource(mediaElement) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaNode";
    this.source = this.context.createMediaElementSource(mediaElement);
    this.connect();
    return this;
  }
  setMediaStreamSource(mediaStream) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaStreamNode";
    this.source = this.context.createMediaStreamSource(mediaStream);
    this.connect();
    return this;
  }
  setBuffer(audioBuffer) {
    this.buffer = audioBuffer;
    this.sourceType = "buffer";
    if (this.autoplay) this.play();
    return this;
  }
  play(delay = 0) {
    if (this.isPlaying === true) {
      console.warn("THREE.Audio: Audio is already playing.");
      return;
    }
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._startedAt = this.context.currentTime + delay;
    const source = this.context.createBufferSource();
    source.buffer = this.buffer;
    source.loop = this.loop;
    source.loopStart = this.loopStart;
    source.loopEnd = this.loopEnd;
    source.onended = this.onEnded.bind(this);
    source.start(this._startedAt, this._progress + this.offset, this.duration);
    this.isPlaying = true;
    this.source = source;
    this.setDetune(this.detune);
    this.setPlaybackRate(this.playbackRate);
    return this.connect();
  }
  pause() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    if (this.isPlaying === true) {
      this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
      if (this.loop === true) {
        this._progress = this._progress % (this.duration || this.buffer.duration);
      }
      this.source.stop();
      this.source.onended = null;
      this.isPlaying = false;
    }
    return this;
  }
  stop(delay = 0) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._progress = 0;
    if (this.source !== null) {
      this.source.stop(this.context.currentTime + delay);
      this.source.onended = null;
    }
    this.isPlaying = false;
    return this;
  }
  connect() {
    if (this.filters.length > 0) {
      this.source.connect(this.filters[0]);
      for (let i2 = 1, l2 = this.filters.length; i2 < l2; i2++) {
        this.filters[i2 - 1].connect(this.filters[i2]);
      }
      this.filters[this.filters.length - 1].connect(this.getOutput());
    } else {
      this.source.connect(this.getOutput());
    }
    this._connected = true;
    return this;
  }
  disconnect() {
    if (this._connected === false) {
      return;
    }
    if (this.filters.length > 0) {
      this.source.disconnect(this.filters[0]);
      for (let i2 = 1, l2 = this.filters.length; i2 < l2; i2++) {
        this.filters[i2 - 1].disconnect(this.filters[i2]);
      }
      this.filters[this.filters.length - 1].disconnect(this.getOutput());
    } else {
      this.source.disconnect(this.getOutput());
    }
    this._connected = false;
    return this;
  }
  getFilters() {
    return this.filters;
  }
  setFilters(value) {
    if (!value) value = [];
    if (this._connected === true) {
      this.disconnect();
      this.filters = value.slice();
      this.connect();
    } else {
      this.filters = value.slice();
    }
    return this;
  }
  setDetune(value) {
    this.detune = value;
    if (this.isPlaying === true && this.source.detune !== void 0) {
      this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
    }
    return this;
  }
  getDetune() {
    return this.detune;
  }
  getFilter() {
    return this.getFilters()[0];
  }
  setFilter(filter) {
    return this.setFilters(filter ? [filter] : []);
  }
  setPlaybackRate(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.playbackRate = value;
    if (this.isPlaying === true) {
      this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
    }
    return this;
  }
  getPlaybackRate() {
    return this.playbackRate;
  }
  onEnded() {
    this.isPlaying = false;
    this._progress = 0;
  }
  getLoop() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return false;
    }
    return this.loop;
  }
  setLoop(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.loop = value;
    if (this.isPlaying === true) {
      this.source.loop = this.loop;
    }
    return this;
  }
  setLoopStart(value) {
    this.loopStart = value;
    return this;
  }
  setLoopEnd(value) {
    this.loopEnd = value;
    return this;
  }
  getVolume() {
    return this.gain.gain.value;
  }
  setVolume(value) {
    this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
    return this;
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.sourceType !== "buffer") {
      console.warn("THREE.Audio: Audio source type cannot be copied.");
      return this;
    }
    this.autoplay = source.autoplay;
    this.buffer = source.buffer;
    this.detune = source.detune;
    this.loop = source.loop;
    this.loopStart = source.loopStart;
    this.loopEnd = source.loopEnd;
    this.offset = source.offset;
    this.duration = source.duration;
    this.playbackRate = source.playbackRate;
    this.hasPlaybackControl = source.hasPlaybackControl;
    this.sourceType = source.sourceType;
    this.filters = source.filters.slice();
    return this;
  }
  clone(recursive) {
    return new this.constructor(this.listener).copy(this, recursive);
  }
}
const _position$4 = /* @__PURE__ */ new Vector3();
const _quaternion$5 = /* @__PURE__ */ new Quaternion();
const _scale$3 = /* @__PURE__ */ new Vector3();
const _orientation = /* @__PURE__ */ new Vector3();
class PositionalAudio extends Audio {
  constructor(listener) {
    super(listener);
    this.panner = this.context.createPanner();
    this.panner.panningModel = "HRTF";
    this.panner.connect(this.gain);
  }
  connect() {
    super.connect();
    this.panner.connect(this.gain);
  }
  disconnect() {
    super.disconnect();
    this.panner.disconnect(this.gain);
  }
  getOutput() {
    return this.panner;
  }
  getRefDistance() {
    return this.panner.refDistance;
  }
  setRefDistance(value) {
    this.panner.refDistance = value;
    return this;
  }
  getRolloffFactor() {
    return this.panner.rolloffFactor;
  }
  setRolloffFactor(value) {
    this.panner.rolloffFactor = value;
    return this;
  }
  getDistanceModel() {
    return this.panner.distanceModel;
  }
  setDistanceModel(value) {
    this.panner.distanceModel = value;
    return this;
  }
  getMaxDistance() {
    return this.panner.maxDistance;
  }
  setMaxDistance(value) {
    this.panner.maxDistance = value;
    return this;
  }
  setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
    this.panner.coneInnerAngle = coneInnerAngle;
    this.panner.coneOuterAngle = coneOuterAngle;
    this.panner.coneOuterGain = coneOuterGain;
    return this;
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    if (this.hasPlaybackControl === true && this.isPlaying === false) return;
    this.matrixWorld.decompose(_position$4, _quaternion$5, _scale$3);
    _orientation.set(0, 0, 1).applyQuaternion(_quaternion$5);
    const panner = this.panner;
    if (panner.positionX) {
      const endTime = this.context.currentTime + this.listener.timeDelta;
      panner.positionX.linearRampToValueAtTime(_position$4.x, endTime);
      panner.positionY.linearRampToValueAtTime(_position$4.y, endTime);
      panner.positionZ.linearRampToValueAtTime(_position$4.z, endTime);
      panner.orientationX.linearRampToValueAtTime(_orientation.x, endTime);
      panner.orientationY.linearRampToValueAtTime(_orientation.y, endTime);
      panner.orientationZ.linearRampToValueAtTime(_orientation.z, endTime);
    } else {
      panner.setPosition(_position$4.x, _position$4.y, _position$4.z);
      panner.setOrientation(_orientation.x, _orientation.y, _orientation.z);
    }
  }
}
class AudioAnalyser {
  constructor(audio, fftSize = 2048) {
    this.analyser = audio.context.createAnalyser();
    this.analyser.fftSize = fftSize;
    this.data = new Uint8Array(this.analyser.frequencyBinCount);
    audio.getOutput().connect(this.analyser);
  }
  getFrequencyData() {
    this.analyser.getByteFrequencyData(this.data);
    return this.data;
  }
  getAverageFrequency() {
    let value = 0;
    const data = this.getFrequencyData();
    for (let i2 = 0; i2 < data.length; i2++) {
      value += data[i2];
    }
    return value / data.length;
  }
}
class PropertyMixer {
  constructor(binding, typeName, valueSize) {
    this.binding = binding;
    this.valueSize = valueSize;
    let mixFunction, mixFunctionAdditive, setIdentity;
    switch (typeName) {
      case "quaternion":
        mixFunction = this._slerp;
        mixFunctionAdditive = this._slerpAdditive;
        setIdentity = this._setAdditiveIdentityQuaternion;
        this.buffer = new Float64Array(valueSize * 6);
        this._workIndex = 5;
        break;
      case "string":
      case "bool":
        mixFunction = this._select;
        mixFunctionAdditive = this._select;
        setIdentity = this._setAdditiveIdentityOther;
        this.buffer = new Array(valueSize * 5);
        break;
      default:
        mixFunction = this._lerp;
        mixFunctionAdditive = this._lerpAdditive;
        setIdentity = this._setAdditiveIdentityNumeric;
        this.buffer = new Float64Array(valueSize * 5);
    }
    this._mixBufferRegion = mixFunction;
    this._mixBufferRegionAdditive = mixFunctionAdditive;
    this._setIdentity = setIdentity;
    this._origIndex = 3;
    this._addIndex = 4;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    this.useCount = 0;
    this.referenceCount = 0;
  }
  // accumulate data in the 'incoming' region into 'accu<i>'
  accumulate(accuIndex, weight) {
    const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
    let currentWeight = this.cumulativeWeight;
    if (currentWeight === 0) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer[offset + i2] = buffer[i2];
      }
      currentWeight = weight;
    } else {
      currentWeight += weight;
      const mix = weight / currentWeight;
      this._mixBufferRegion(buffer, offset, 0, mix, stride);
    }
    this.cumulativeWeight = currentWeight;
  }
  // accumulate data in the 'incoming' region into 'add'
  accumulateAdditive(weight) {
    const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
    if (this.cumulativeWeightAdditive === 0) {
      this._setIdentity();
    }
    this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
    this.cumulativeWeightAdditive += weight;
  }
  // apply the state of 'accu<i>' to the binding when accus differ
  apply(accuIndex) {
    const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    if (weight < 1) {
      const originalValueOffset = stride * this._origIndex;
      this._mixBufferRegion(
        buffer,
        offset,
        originalValueOffset,
        1 - weight,
        stride
      );
    }
    if (weightAdditive > 0) {
      this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
    }
    for (let i2 = stride, e2 = stride + stride; i2 !== e2; ++i2) {
      if (buffer[i2] !== buffer[i2 + stride]) {
        binding.setValue(buffer, offset);
        break;
      }
    }
  }
  // remember the state of the bound property and copy it to both accus
  saveOriginalState() {
    const binding = this.binding;
    const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
    binding.getValue(buffer, originalValueOffset);
    for (let i2 = stride, e2 = originalValueOffset; i2 !== e2; ++i2) {
      buffer[i2] = buffer[originalValueOffset + i2 % stride];
    }
    this._setIdentity();
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
  }
  // apply the state previously taken via 'saveOriginalState' to the binding
  restoreOriginalState() {
    const originalValueOffset = this.valueSize * 3;
    this.binding.setValue(this.buffer, originalValueOffset);
  }
  _setAdditiveIdentityNumeric() {
    const startIndex = this._addIndex * this.valueSize;
    const endIndex = startIndex + this.valueSize;
    for (let i2 = startIndex; i2 < endIndex; i2++) {
      this.buffer[i2] = 0;
    }
  }
  _setAdditiveIdentityQuaternion() {
    this._setAdditiveIdentityNumeric();
    this.buffer[this._addIndex * this.valueSize + 3] = 1;
  }
  _setAdditiveIdentityOther() {
    const startIndex = this._origIndex * this.valueSize;
    const targetIndex = this._addIndex * this.valueSize;
    for (let i2 = 0; i2 < this.valueSize; i2++) {
      this.buffer[targetIndex + i2] = this.buffer[startIndex + i2];
    }
  }
  // mix functions
  _select(buffer, dstOffset, srcOffset, t2, stride) {
    if (t2 >= 0.5) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer[dstOffset + i2] = buffer[srcOffset + i2];
      }
    }
  }
  _slerp(buffer, dstOffset, srcOffset, t2) {
    Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t2);
  }
  _slerpAdditive(buffer, dstOffset, srcOffset, t2, stride) {
    const workOffset = this._workIndex * stride;
    Quaternion.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
    Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t2);
  }
  _lerp(buffer, dstOffset, srcOffset, t2, stride) {
    const s2 = 1 - t2;
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j3 = dstOffset + i2;
      buffer[j3] = buffer[j3] * s2 + buffer[srcOffset + i2] * t2;
    }
  }
  _lerpAdditive(buffer, dstOffset, srcOffset, t2, stride) {
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j3 = dstOffset + i2;
      buffer[j3] = buffer[j3] + buffer[srcOffset + i2] * t2;
    }
  }
}
const _RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const _reservedRe = new RegExp("[" + _RESERVED_CHARS_RE + "]", "g");
const _wordChar = "[^" + _RESERVED_CHARS_RE + "]";
const _wordCharOrDot = "[^" + _RESERVED_CHARS_RE.replace("\\.", "") + "]";
const _directoryRe = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", _wordChar);
const _nodeRe = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", _wordCharOrDot);
const _objectRe = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _wordChar);
const _propertyRe = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _wordChar);
const _trackRe = new RegExp(
  "^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + "$"
);
const _supportedObjectNames = ["material", "materials", "bones", "map"];
class Composite {
  constructor(targetGroup, path, optionalParsedPath) {
    const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path);
    this._targetGroup = targetGroup;
    this._bindings = targetGroup.subscribe_(path, parsedPath);
  }
  getValue(array, offset) {
    this.bind();
    const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
    if (binding !== void 0) binding.getValue(array, offset);
  }
  setValue(array, offset) {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].setValue(array, offset);
    }
  }
  bind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].bind();
    }
  }
  unbind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].unbind();
    }
  }
}
class PropertyBinding {
  constructor(rootNode, path, parsedPath) {
    this.path = path;
    this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
    this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName);
    this.rootNode = rootNode;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
  static create(root2, path, parsedPath) {
    if (!(root2 && root2.isAnimationObjectGroup)) {
      return new PropertyBinding(root2, path, parsedPath);
    } else {
      return new PropertyBinding.Composite(root2, path, parsedPath);
    }
  }
  /**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name Node name to be sanitized.
   * @return {string}
   */
  static sanitizeNodeName(name) {
    return name.replace(/\s/g, "_").replace(_reservedRe, "");
  }
  static parseTrackName(trackName) {
    const matches = _trackRe.exec(trackName);
    if (matches === null) {
      throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
    }
    const results = {
      // directoryName: matches[ 1 ], // (tschw) currently unused
      nodeName: matches[2],
      objectName: matches[3],
      objectIndex: matches[4],
      propertyName: matches[5],
      // required
      propertyIndex: matches[6]
    };
    const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
    if (lastDot !== void 0 && lastDot !== -1) {
      const objectName = results.nodeName.substring(lastDot + 1);
      if (_supportedObjectNames.indexOf(objectName) !== -1) {
        results.nodeName = results.nodeName.substring(0, lastDot);
        results.objectName = objectName;
      }
    }
    if (results.propertyName === null || results.propertyName.length === 0) {
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
    }
    return results;
  }
  static findNode(root2, nodeName) {
    if (nodeName === void 0 || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root2.name || nodeName === root2.uuid) {
      return root2;
    }
    if (root2.skeleton) {
      const bone = root2.skeleton.getBoneByName(nodeName);
      if (bone !== void 0) {
        return bone;
      }
    }
    if (root2.children) {
      const searchNodeSubtree = function(children) {
        for (let i2 = 0; i2 < children.length; i2++) {
          const childNode = children[i2];
          if (childNode.name === nodeName || childNode.uuid === nodeName) {
            return childNode;
          }
          const result = searchNodeSubtree(childNode.children);
          if (result) return result;
        }
        return null;
      };
      const subTreeNode = searchNodeSubtree(root2.children);
      if (subTreeNode) {
        return subTreeNode;
      }
    }
    return null;
  }
  // these are used to "bind" a nonexistent property
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  // Getters
  _getValue_direct(buffer, offset) {
    buffer[offset] = this.targetObject[this.propertyName];
  }
  _getValue_array(buffer, offset) {
    const source = this.resolvedProperty;
    for (let i2 = 0, n2 = source.length; i2 !== n2; ++i2) {
      buffer[offset++] = source[i2];
    }
  }
  _getValue_arrayElement(buffer, offset) {
    buffer[offset] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(buffer, offset) {
    this.resolvedProperty.toArray(buffer, offset);
  }
  // Direct
  _setValue_direct(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
  }
  _setValue_direct_setNeedsUpdate(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // EntireArray
  _setValue_array(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset++];
    }
  }
  _setValue_array_setNeedsUpdate(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset++];
    }
    this.targetObject.needsUpdate = true;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset++];
    }
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // ArrayElement
  _setValue_arrayElement(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
  }
  _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // HasToFromArray
  _setValue_fromArray(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
  }
  _setValue_fromArray_setNeedsUpdate(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
    this.targetObject.needsUpdate = true;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _getValue_unbound(targetArray, offset) {
    this.bind();
    this.getValue(targetArray, offset);
  }
  _setValue_unbound(sourceArray, offset) {
    this.bind();
    this.setValue(sourceArray, offset);
  }
  // create getter / setter pair for a property in the scene graph
  bind() {
    let targetObject = this.node;
    const parsedPath = this.parsedPath;
    const objectName = parsedPath.objectName;
    const propertyName = parsedPath.propertyName;
    let propertyIndex = parsedPath.propertyIndex;
    if (!targetObject) {
      targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName);
      this.node = targetObject;
    }
    this.getValue = this._getValue_unavailable;
    this.setValue = this._setValue_unavailable;
    if (!targetObject) {
      console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
      return;
    }
    if (objectName) {
      let objectIndex = parsedPath.objectIndex;
      switch (objectName) {
        case "materials":
          if (!targetObject.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!targetObject.material.materials) {
            console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          targetObject = targetObject.material.materials;
          break;
        case "bones":
          if (!targetObject.skeleton) {
            console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          targetObject = targetObject.skeleton.bones;
          for (let i2 = 0; i2 < targetObject.length; i2++) {
            if (targetObject[i2].name === objectIndex) {
              objectIndex = i2;
              break;
            }
          }
          break;
        case "map":
          if ("map" in targetObject) {
            targetObject = targetObject.map;
            break;
          }
          if (!targetObject.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!targetObject.material.map) {
            console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
            return;
          }
          targetObject = targetObject.material.map;
          break;
        default:
          if (targetObject[objectName] === void 0) {
            console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          targetObject = targetObject[objectName];
      }
      if (objectIndex !== void 0) {
        if (targetObject[objectIndex] === void 0) {
          console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
          return;
        }
        targetObject = targetObject[objectIndex];
      }
    }
    const nodeProperty = targetObject[propertyName];
    if (nodeProperty === void 0) {
      const nodeName = parsedPath.nodeName;
      console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
      return;
    }
    let versioning = this.Versioning.None;
    this.targetObject = targetObject;
    if (targetObject.isMaterial === true) {
      versioning = this.Versioning.NeedsUpdate;
    } else if (targetObject.isObject3D === true) {
      versioning = this.Versioning.MatrixWorldNeedsUpdate;
    }
    let bindingType = this.BindingType.Direct;
    if (propertyIndex !== void 0) {
      if (propertyName === "morphTargetInfluences") {
        if (!targetObject.geometry) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (!targetObject.geometry.morphAttributes) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
          return;
        }
        if (targetObject.morphTargetDictionary[propertyIndex] !== void 0) {
          propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
        }
      }
      bindingType = this.BindingType.ArrayElement;
      this.resolvedProperty = nodeProperty;
      this.propertyIndex = propertyIndex;
    } else if (nodeProperty.fromArray !== void 0 && nodeProperty.toArray !== void 0) {
      bindingType = this.BindingType.HasFromToArray;
      this.resolvedProperty = nodeProperty;
    } else if (Array.isArray(nodeProperty)) {
      bindingType = this.BindingType.EntireArray;
      this.resolvedProperty = nodeProperty;
    } else {
      this.propertyName = propertyName;
    }
    this.getValue = this.GetterByBindingType[bindingType];
    this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
  }
  unbind() {
    this.node = null;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
}
PropertyBinding.Composite = Composite;
PropertyBinding.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
PropertyBinding.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
PropertyBinding.prototype.GetterByBindingType = [
  PropertyBinding.prototype._getValue_direct,
  PropertyBinding.prototype._getValue_array,
  PropertyBinding.prototype._getValue_arrayElement,
  PropertyBinding.prototype._getValue_toArray
];
PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
  [
    // Direct
    PropertyBinding.prototype._setValue_direct,
    PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
    PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    // EntireArray
    PropertyBinding.prototype._setValue_array,
    PropertyBinding.prototype._setValue_array_setNeedsUpdate,
    PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    // ArrayElement
    PropertyBinding.prototype._setValue_arrayElement,
    PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
    PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    // HasToFromArray
    PropertyBinding.prototype._setValue_fromArray,
    PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
    PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class AnimationObjectGroup {
  constructor() {
    this.isAnimationObjectGroup = true;
    this.uuid = generateUUID$1();
    this._objects = Array.prototype.slice.call(arguments);
    this.nCachedObjects_ = 0;
    const indices = {};
    this._indicesByUUID = indices;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      indices[arguments[i2].uuid] = i2;
    }
    this._paths = [];
    this._parsedPaths = [];
    this._bindings = [];
    this._bindingsIndicesByPath = {};
    const scope = this;
    this.stats = {
      objects: {
        get total() {
          return scope._objects.length;
        },
        get inUse() {
          return this.total - scope.nCachedObjects_;
        }
      },
      get bindingsPerObject() {
        return scope._bindings.length;
      }
    };
  }
  add() {
    const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
    let knownObject = void 0, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      const object = arguments[i2], uuid = object.uuid;
      let index = indicesByUUID[uuid];
      if (index === void 0) {
        index = nObjects++;
        indicesByUUID[uuid] = index;
        objects.push(object);
        for (let j3 = 0, m2 = nBindings; j3 !== m2; ++j3) {
          bindings[j3].push(new PropertyBinding(object, paths[j3], parsedPaths[j3]));
        }
      } else if (index < nCachedObjects) {
        knownObject = objects[index];
        const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
        indicesByUUID[lastCachedObject.uuid] = index;
        objects[index] = lastCachedObject;
        indicesByUUID[uuid] = firstActiveIndex;
        objects[firstActiveIndex] = object;
        for (let j3 = 0, m2 = nBindings; j3 !== m2; ++j3) {
          const bindingsForPath = bindings[j3], lastCached = bindingsForPath[firstActiveIndex];
          let binding = bindingsForPath[index];
          bindingsForPath[index] = lastCached;
          if (binding === void 0) {
            binding = new PropertyBinding(object, paths[j3], parsedPaths[j3]);
          }
          bindingsForPath[firstActiveIndex] = binding;
        }
      } else if (objects[index] !== knownObject) {
        console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
      }
    }
    this.nCachedObjects_ = nCachedObjects;
  }
  remove() {
    const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
    let nCachedObjects = this.nCachedObjects_;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      const object = arguments[i2], uuid = object.uuid, index = indicesByUUID[uuid];
      if (index !== void 0 && index >= nCachedObjects) {
        const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
        indicesByUUID[firstActiveObject.uuid] = index;
        objects[index] = firstActiveObject;
        indicesByUUID[uuid] = lastCachedIndex;
        objects[lastCachedIndex] = object;
        for (let j3 = 0, m2 = nBindings; j3 !== m2; ++j3) {
          const bindingsForPath = bindings[j3], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
          bindingsForPath[index] = firstActive;
          bindingsForPath[lastCachedIndex] = binding;
        }
      }
    }
    this.nCachedObjects_ = nCachedObjects;
  }
  // remove & forget
  uncache() {
    const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
    let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      const object = arguments[i2], uuid = object.uuid, index = indicesByUUID[uuid];
      if (index !== void 0) {
        delete indicesByUUID[uuid];
        if (index < nCachedObjects) {
          const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
          indicesByUUID[lastCachedObject.uuid] = index;
          objects[index] = lastCachedObject;
          indicesByUUID[lastObject.uuid] = firstActiveIndex;
          objects[firstActiveIndex] = lastObject;
          objects.pop();
          for (let j3 = 0, m2 = nBindings; j3 !== m2; ++j3) {
            const bindingsForPath = bindings[j3], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
            bindingsForPath[index] = lastCached;
            bindingsForPath[firstActiveIndex] = last;
            bindingsForPath.pop();
          }
        } else {
          const lastIndex = --nObjects, lastObject = objects[lastIndex];
          if (lastIndex > 0) {
            indicesByUUID[lastObject.uuid] = index;
          }
          objects[index] = lastObject;
          objects.pop();
          for (let j3 = 0, m2 = nBindings; j3 !== m2; ++j3) {
            const bindingsForPath = bindings[j3];
            bindingsForPath[index] = bindingsForPath[lastIndex];
            bindingsForPath.pop();
          }
        }
      }
    }
    this.nCachedObjects_ = nCachedObjects;
  }
  // Internal interface used by befriended PropertyBinding.Composite:
  subscribe_(path, parsedPath) {
    const indicesByPath = this._bindingsIndicesByPath;
    let index = indicesByPath[path];
    const bindings = this._bindings;
    if (index !== void 0) return bindings[index];
    const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
    index = bindings.length;
    indicesByPath[path] = index;
    paths.push(path);
    parsedPaths.push(parsedPath);
    bindings.push(bindingsForPath);
    for (let i2 = nCachedObjects, n2 = objects.length; i2 !== n2; ++i2) {
      const object = objects[i2];
      bindingsForPath[i2] = new PropertyBinding(object, path, parsedPath);
    }
    return bindingsForPath;
  }
  unsubscribe_(path) {
    const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
    if (index !== void 0) {
      const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
      indicesByPath[lastBindingsPath] = index;
      bindings[index] = lastBindings;
      bindings.pop();
      parsedPaths[index] = parsedPaths[lastBindingsIndex];
      parsedPaths.pop();
      paths[index] = paths[lastBindingsIndex];
      paths.pop();
    }
  }
}
class AnimationAction {
  constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode) {
    this._mixer = mixer;
    this._clip = clip;
    this._localRoot = localRoot;
    this.blendMode = blendMode;
    const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
    const interpolantSettings = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const interpolant = tracks[i2].createInterpolant(null);
      interpolants[i2] = interpolant;
      interpolant.settings = interpolantSettings;
    }
    this._interpolantSettings = interpolantSettings;
    this._interpolants = interpolants;
    this._propertyBindings = new Array(nTracks);
    this._cacheIndex = null;
    this._byClipCacheIndex = null;
    this._timeScaleInterpolant = null;
    this._weightInterpolant = null;
    this.loop = LoopRepeat;
    this._loopCount = -1;
    this._startTime = null;
    this.time = 0;
    this.timeScale = 1;
    this._effectiveTimeScale = 1;
    this.weight = 1;
    this._effectiveWeight = 1;
    this.repetitions = Infinity;
    this.paused = false;
    this.enabled = true;
    this.clampWhenFinished = false;
    this.zeroSlopeAtStart = true;
    this.zeroSlopeAtEnd = true;
  }
  // State & Scheduling
  play() {
    this._mixer._activateAction(this);
    return this;
  }
  stop() {
    this._mixer._deactivateAction(this);
    return this.reset();
  }
  reset() {
    this.paused = false;
    this.enabled = true;
    this.time = 0;
    this._loopCount = -1;
    this._startTime = null;
    return this.stopFading().stopWarping();
  }
  isRunning() {
    return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
  }
  // return true when play has been called
  isScheduled() {
    return this._mixer._isActiveAction(this);
  }
  startAt(time) {
    this._startTime = time;
    return this;
  }
  setLoop(mode, repetitions) {
    this.loop = mode;
    this.repetitions = repetitions;
    return this;
  }
  // Weight
  // set the weight stopping any scheduled fading
  // although .enabled = false yields an effective weight of zero, this
  // method does *not* change .enabled, because it would be confusing
  setEffectiveWeight(weight) {
    this.weight = weight;
    this._effectiveWeight = this.enabled ? weight : 0;
    return this.stopFading();
  }
  // return the weight considering fading and .enabled
  getEffectiveWeight() {
    return this._effectiveWeight;
  }
  fadeIn(duration) {
    return this._scheduleFading(duration, 0, 1);
  }
  fadeOut(duration) {
    return this._scheduleFading(duration, 1, 0);
  }
  crossFadeFrom(fadeOutAction, duration, warp) {
    fadeOutAction.fadeOut(duration);
    this.fadeIn(duration);
    if (warp) {
      const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
      fadeOutAction.warp(1, startEndRatio, duration);
      this.warp(endStartRatio, 1, duration);
    }
    return this;
  }
  crossFadeTo(fadeInAction, duration, warp) {
    return fadeInAction.crossFadeFrom(this, duration, warp);
  }
  stopFading() {
    const weightInterpolant = this._weightInterpolant;
    if (weightInterpolant !== null) {
      this._weightInterpolant = null;
      this._mixer._takeBackControlInterpolant(weightInterpolant);
    }
    return this;
  }
  // Time Scale Control
  // set the time scale stopping any scheduled warping
  // although .paused = true yields an effective time scale of zero, this
  // method does *not* change .paused, because it would be confusing
  setEffectiveTimeScale(timeScale) {
    this.timeScale = timeScale;
    this._effectiveTimeScale = this.paused ? 0 : timeScale;
    return this.stopWarping();
  }
  // return the time scale considering warping and .paused
  getEffectiveTimeScale() {
    return this._effectiveTimeScale;
  }
  setDuration(duration) {
    this.timeScale = this._clip.duration / duration;
    return this.stopWarping();
  }
  syncWith(action) {
    this.time = action.time;
    this.timeScale = action.timeScale;
    return this.stopWarping();
  }
  halt(duration) {
    return this.warp(this._effectiveTimeScale, 0, duration);
  }
  warp(startTimeScale, endTimeScale, duration) {
    const mixer = this._mixer, now2 = mixer.time, timeScale = this.timeScale;
    let interpolant = this._timeScaleInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._timeScaleInterpolant = interpolant;
    }
    const times = interpolant.parameterPositions, values = interpolant.sampleValues;
    times[0] = now2;
    times[1] = now2 + duration;
    values[0] = startTimeScale / timeScale;
    values[1] = endTimeScale / timeScale;
    return this;
  }
  stopWarping() {
    const timeScaleInterpolant = this._timeScaleInterpolant;
    if (timeScaleInterpolant !== null) {
      this._timeScaleInterpolant = null;
      this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
    }
    return this;
  }
  // Object Accessors
  getMixer() {
    return this._mixer;
  }
  getClip() {
    return this._clip;
  }
  getRoot() {
    return this._localRoot || this._mixer._root;
  }
  // Interna
  _update(time, deltaTime, timeDirection, accuIndex) {
    if (!this.enabled) {
      this._updateWeight(time);
      return;
    }
    const startTime = this._startTime;
    if (startTime !== null) {
      const timeRunning = (time - startTime) * timeDirection;
      if (timeRunning < 0 || timeDirection === 0) {
        deltaTime = 0;
      } else {
        this._startTime = null;
        deltaTime = timeDirection * timeRunning;
      }
    }
    deltaTime *= this._updateTimeScale(time);
    const clipTime = this._updateTime(deltaTime);
    const weight = this._updateWeight(time);
    if (weight > 0) {
      const interpolants = this._interpolants;
      const propertyMixers = this._propertyBindings;
      switch (this.blendMode) {
        case AdditiveAnimationBlendMode:
          for (let j3 = 0, m2 = interpolants.length; j3 !== m2; ++j3) {
            interpolants[j3].evaluate(clipTime);
            propertyMixers[j3].accumulateAdditive(weight);
          }
          break;
        case NormalAnimationBlendMode:
        default:
          for (let j3 = 0, m2 = interpolants.length; j3 !== m2; ++j3) {
            interpolants[j3].evaluate(clipTime);
            propertyMixers[j3].accumulate(accuIndex, weight);
          }
      }
    }
  }
  _updateWeight(time) {
    let weight = 0;
    if (this.enabled) {
      weight = this.weight;
      const interpolant = this._weightInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time)[0];
        weight *= interpolantValue;
        if (time > interpolant.parameterPositions[1]) {
          this.stopFading();
          if (interpolantValue === 0) {
            this.enabled = false;
          }
        }
      }
    }
    this._effectiveWeight = weight;
    return weight;
  }
  _updateTimeScale(time) {
    let timeScale = 0;
    if (!this.paused) {
      timeScale = this.timeScale;
      const interpolant = this._timeScaleInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time)[0];
        timeScale *= interpolantValue;
        if (time > interpolant.parameterPositions[1]) {
          this.stopWarping();
          if (timeScale === 0) {
            this.paused = true;
          } else {
            this.timeScale = timeScale;
          }
        }
      }
    }
    this._effectiveTimeScale = timeScale;
    return timeScale;
  }
  _updateTime(deltaTime) {
    const duration = this._clip.duration;
    const loop2 = this.loop;
    let time = this.time + deltaTime;
    let loopCount = this._loopCount;
    const pingPong = loop2 === LoopPingPong;
    if (deltaTime === 0) {
      if (loopCount === -1) return time;
      return pingPong && (loopCount & 1) === 1 ? duration - time : time;
    }
    if (loop2 === LoopOnce) {
      if (loopCount === -1) {
        this._loopCount = 0;
        this._setEndings(true, true, false);
      }
      handle_stop: {
        if (time >= duration) {
          time = duration;
        } else if (time < 0) {
          time = 0;
        } else {
          this.time = time;
          break handle_stop;
        }
        if (this.clampWhenFinished) this.paused = true;
        else this.enabled = false;
        this.time = time;
        this._mixer.dispatchEvent({
          type: "finished",
          action: this,
          direction: deltaTime < 0 ? -1 : 1
        });
      }
    } else {
      if (loopCount === -1) {
        if (deltaTime >= 0) {
          loopCount = 0;
          this._setEndings(true, this.repetitions === 0, pingPong);
        } else {
          this._setEndings(this.repetitions === 0, true, pingPong);
        }
      }
      if (time >= duration || time < 0) {
        const loopDelta = Math.floor(time / duration);
        time -= duration * loopDelta;
        loopCount += Math.abs(loopDelta);
        const pending = this.repetitions - loopCount;
        if (pending <= 0) {
          if (this.clampWhenFinished) this.paused = true;
          else this.enabled = false;
          time = deltaTime > 0 ? duration : 0;
          this.time = time;
          this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: deltaTime > 0 ? 1 : -1
          });
        } else {
          if (pending === 1) {
            const atStart = deltaTime < 0;
            this._setEndings(atStart, !atStart, pingPong);
          } else {
            this._setEndings(false, false, pingPong);
          }
          this._loopCount = loopCount;
          this.time = time;
          this._mixer.dispatchEvent({
            type: "loop",
            action: this,
            loopDelta
          });
        }
      } else {
        this.time = time;
      }
      if (pingPong && (loopCount & 1) === 1) {
        return duration - time;
      }
    }
    return time;
  }
  _setEndings(atStart, atEnd, pingPong) {
    const settings = this._interpolantSettings;
    if (pingPong) {
      settings.endingStart = ZeroSlopeEnding;
      settings.endingEnd = ZeroSlopeEnding;
    } else {
      if (atStart) {
        settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings.endingStart = WrapAroundEnding;
      }
      if (atEnd) {
        settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings.endingEnd = WrapAroundEnding;
      }
    }
  }
  _scheduleFading(duration, weightNow, weightThen) {
    const mixer = this._mixer, now2 = mixer.time;
    let interpolant = this._weightInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._weightInterpolant = interpolant;
    }
    const times = interpolant.parameterPositions, values = interpolant.sampleValues;
    times[0] = now2;
    values[0] = weightNow;
    times[1] = now2 + duration;
    values[1] = weightThen;
    return this;
  }
}
const _controlInterpolantsResultBuffer = new Float32Array(1);
class AnimationMixer extends EventDispatcher$2 {
  constructor(root2) {
    super();
    this._root = root2;
    this._initMemoryManager();
    this._accuIndex = 0;
    this.time = 0;
    this.timeScale = 1;
  }
  _bindAction(action, prototypeAction) {
    const root2 = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root2.uuid, bindingsByRoot = this._bindingsByRootAndName;
    let bindingsByName = bindingsByRoot[rootUuid];
    if (bindingsByName === void 0) {
      bindingsByName = {};
      bindingsByRoot[rootUuid] = bindingsByName;
    }
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const track = tracks[i2], trackName = track.name;
      let binding = bindingsByName[trackName];
      if (binding !== void 0) {
        ++binding.referenceCount;
        bindings[i2] = binding;
      } else {
        binding = bindings[i2];
        if (binding !== void 0) {
          if (binding._cacheIndex === null) {
            ++binding.referenceCount;
            this._addInactiveBinding(binding, rootUuid, trackName);
          }
          continue;
        }
        const path = prototypeAction && prototypeAction._propertyBindings[i2].binding.parsedPath;
        binding = new PropertyMixer(
          PropertyBinding.create(root2, trackName, path),
          track.ValueTypeName,
          track.getValueSize()
        );
        ++binding.referenceCount;
        this._addInactiveBinding(binding, rootUuid, trackName);
        bindings[i2] = binding;
      }
      interpolants[i2].resultBuffer = binding.buffer;
    }
  }
  _activateAction(action) {
    if (!this._isActiveAction(action)) {
      if (action._cacheIndex === null) {
        const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
        this._bindAction(
          action,
          actionsForClip && actionsForClip.knownActions[0]
        );
        this._addInactiveAction(action, clipUuid, rootUuid);
      }
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (binding.useCount++ === 0) {
          this._lendBinding(binding);
          binding.saveOriginalState();
        }
      }
      this._lendAction(action);
    }
  }
  _deactivateAction(action) {
    if (this._isActiveAction(action)) {
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (--binding.useCount === 0) {
          binding.restoreOriginalState();
          this._takeBackBinding(binding);
        }
      }
      this._takeBackAction(action);
    }
  }
  // Memory manager
  _initMemoryManager() {
    this._actions = [];
    this._nActiveActions = 0;
    this._actionsByClip = {};
    this._bindings = [];
    this._nActiveBindings = 0;
    this._bindingsByRootAndName = {};
    this._controlInterpolants = [];
    this._nActiveControlInterpolants = 0;
    const scope = this;
    this.stats = {
      actions: {
        get total() {
          return scope._actions.length;
        },
        get inUse() {
          return scope._nActiveActions;
        }
      },
      bindings: {
        get total() {
          return scope._bindings.length;
        },
        get inUse() {
          return scope._nActiveBindings;
        }
      },
      controlInterpolants: {
        get total() {
          return scope._controlInterpolants.length;
        },
        get inUse() {
          return scope._nActiveControlInterpolants;
        }
      }
    };
  }
  // Memory management for AnimationAction objects
  _isActiveAction(action) {
    const index = action._cacheIndex;
    return index !== null && index < this._nActiveActions;
  }
  _addInactiveAction(action, clipUuid, rootUuid) {
    const actions = this._actions, actionsByClip = this._actionsByClip;
    let actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip === void 0) {
      actionsForClip = {
        knownActions: [action],
        actionByRoot: {}
      };
      action._byClipCacheIndex = 0;
      actionsByClip[clipUuid] = actionsForClip;
    } else {
      const knownActions = actionsForClip.knownActions;
      action._byClipCacheIndex = knownActions.length;
      knownActions.push(action);
    }
    action._cacheIndex = actions.length;
    actions.push(action);
    actionsForClip.actionByRoot[rootUuid] = action;
  }
  _removeInactiveAction(action) {
    const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
    lastInactiveAction._cacheIndex = cacheIndex;
    actions[cacheIndex] = lastInactiveAction;
    actions.pop();
    action._cacheIndex = null;
    const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
    lastKnownAction._byClipCacheIndex = byClipCacheIndex;
    knownActionsForClip[byClipCacheIndex] = lastKnownAction;
    knownActionsForClip.pop();
    action._byClipCacheIndex = null;
    const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
    delete actionByRoot[rootUuid];
    if (knownActionsForClip.length === 0) {
      delete actionsByClip[clipUuid];
    }
    this._removeInactiveBindingsForAction(action);
  }
  _removeInactiveBindingsForAction(action) {
    const bindings = action._propertyBindings;
    for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
      const binding = bindings[i2];
      if (--binding.referenceCount === 0) {
        this._removeInactiveBinding(binding);
      }
    }
  }
  _lendAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
    action._cacheIndex = lastActiveIndex;
    actions[lastActiveIndex] = action;
    firstInactiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = firstInactiveAction;
  }
  _takeBackAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
    action._cacheIndex = firstInactiveIndex;
    actions[firstInactiveIndex] = action;
    lastActiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = lastActiveAction;
  }
  // Memory management for PropertyMixer objects
  _addInactiveBinding(binding, rootUuid, trackName) {
    const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
    let bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName === void 0) {
      bindingByName = {};
      bindingsByRoot[rootUuid] = bindingByName;
    }
    bindingByName[trackName] = binding;
    binding._cacheIndex = bindings.length;
    bindings.push(binding);
  }
  _removeInactiveBinding(binding) {
    const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
    lastInactiveBinding._cacheIndex = cacheIndex;
    bindings[cacheIndex] = lastInactiveBinding;
    bindings.pop();
    delete bindingByName[trackName];
    if (Object.keys(bindingByName).length === 0) {
      delete bindingsByRoot[rootUuid];
    }
  }
  _lendBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
    binding._cacheIndex = lastActiveIndex;
    bindings[lastActiveIndex] = binding;
    firstInactiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = firstInactiveBinding;
  }
  _takeBackBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
    binding._cacheIndex = firstInactiveIndex;
    bindings[firstInactiveIndex] = binding;
    lastActiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = lastActiveBinding;
  }
  // Memory management of Interpolants for weight and time scale
  _lendControlInterpolant() {
    const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
    let interpolant = interpolants[lastActiveIndex];
    if (interpolant === void 0) {
      interpolant = new LinearInterpolant(
        new Float32Array(2),
        new Float32Array(2),
        1,
        _controlInterpolantsResultBuffer
      );
      interpolant.__cacheIndex = lastActiveIndex;
      interpolants[lastActiveIndex] = interpolant;
    }
    return interpolant;
  }
  _takeBackControlInterpolant(interpolant) {
    const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
    interpolant.__cacheIndex = firstInactiveIndex;
    interpolants[firstInactiveIndex] = interpolant;
    lastActiveInterpolant.__cacheIndex = prevIndex;
    interpolants[prevIndex] = lastActiveInterpolant;
  }
  // return an action for a clip optionally using a custom root target
  // object (this method allocates a lot of dynamic memory in case a
  // previously unknown clip/root combination is specified)
  clipAction(clip, optionalRoot, blendMode) {
    const root2 = optionalRoot || this._root, rootUuid = root2.uuid;
    let clipObject = typeof clip === "string" ? AnimationClip.findByName(root2, clip) : clip;
    const clipUuid = clipObject !== null ? clipObject.uuid : clip;
    const actionsForClip = this._actionsByClip[clipUuid];
    let prototypeAction = null;
    if (blendMode === void 0) {
      if (clipObject !== null) {
        blendMode = clipObject.blendMode;
      } else {
        blendMode = NormalAnimationBlendMode;
      }
    }
    if (actionsForClip !== void 0) {
      const existingAction = actionsForClip.actionByRoot[rootUuid];
      if (existingAction !== void 0 && existingAction.blendMode === blendMode) {
        return existingAction;
      }
      prototypeAction = actionsForClip.knownActions[0];
      if (clipObject === null)
        clipObject = prototypeAction._clip;
    }
    if (clipObject === null) return null;
    const newAction = new AnimationAction(this, clipObject, optionalRoot, blendMode);
    this._bindAction(newAction, prototypeAction);
    this._addInactiveAction(newAction, clipUuid, rootUuid);
    return newAction;
  }
  // get an existing action
  existingAction(clip, optionalRoot) {
    const root2 = optionalRoot || this._root, rootUuid = root2.uuid, clipObject = typeof clip === "string" ? AnimationClip.findByName(root2, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      return actionsForClip.actionByRoot[rootUuid] || null;
    }
    return null;
  }
  // deactivates all previously scheduled actions
  stopAllAction() {
    const actions = this._actions, nActions = this._nActiveActions;
    for (let i2 = nActions - 1; i2 >= 0; --i2) {
      actions[i2].stop();
    }
    return this;
  }
  // advance the time and update apply the animation
  update(deltaTime) {
    deltaTime *= this.timeScale;
    const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
    for (let i2 = 0; i2 !== nActions; ++i2) {
      const action = actions[i2];
      action._update(time, deltaTime, timeDirection, accuIndex);
    }
    const bindings = this._bindings, nBindings = this._nActiveBindings;
    for (let i2 = 0; i2 !== nBindings; ++i2) {
      bindings[i2].apply(accuIndex);
    }
    return this;
  }
  // Allows you to seek to a specific time in an animation.
  setTime(timeInSeconds) {
    this.time = 0;
    for (let i2 = 0; i2 < this._actions.length; i2++) {
      this._actions[i2].time = 0;
    }
    return this.update(timeInSeconds);
  }
  // return this mixer's root target object
  getRoot() {
    return this._root;
  }
  // free all resources specific to a particular clip
  uncacheClip(clip) {
    const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      const actionsToRemove = actionsForClip.knownActions;
      for (let i2 = 0, n2 = actionsToRemove.length; i2 !== n2; ++i2) {
        const action = actionsToRemove[i2];
        this._deactivateAction(action);
        const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
        action._cacheIndex = null;
        action._byClipCacheIndex = null;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        this._removeInactiveBindingsForAction(action);
      }
      delete actionsByClip[clipUuid];
    }
  }
  // free all resources specific to a particular root target object
  uncacheRoot(root2) {
    const rootUuid = root2.uuid, actionsByClip = this._actionsByClip;
    for (const clipUuid in actionsByClip) {
      const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
      if (action !== void 0) {
        this._deactivateAction(action);
        this._removeInactiveAction(action);
      }
    }
    const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName !== void 0) {
      for (const trackName in bindingByName) {
        const binding = bindingByName[trackName];
        binding.restoreOriginalState();
        this._removeInactiveBinding(binding);
      }
    }
  }
  // remove a targeted clip from the cache
  uncacheAction(clip, optionalRoot) {
    const action = this.existingAction(clip, optionalRoot);
    if (action !== null) {
      this._deactivateAction(action);
      this._removeInactiveAction(action);
    }
  }
}
class RenderTarget3D extends RenderTarget {
  constructor(width = 1, height = 1, depth = 1, options = {}) {
    super(width, height, options);
    this.isRenderTarget3D = true;
    this.depth = depth;
    this.texture = new Data3DTexture(null, width, height, depth);
    this.texture.isRenderTargetTexture = true;
  }
}
class RenderTargetArray extends RenderTarget {
  constructor(width = 1, height = 1, depth = 1, options = {}) {
    super(width, height, options);
    this.isRenderTargetArray = true;
    this.depth = depth;
    this.texture = new DataArrayTexture(null, width, height, depth);
    this.texture.isRenderTargetTexture = true;
  }
}
class Uniform {
  constructor(value) {
    this.value = value;
  }
  clone() {
    return new Uniform(this.value.clone === void 0 ? this.value : this.value.clone());
  }
}
let _id$3 = 0;
class UniformsGroup extends EventDispatcher$2 {
  constructor() {
    super();
    this.isUniformsGroup = true;
    Object.defineProperty(this, "id", { value: _id$3++ });
    this.name = "";
    this.usage = StaticDrawUsage;
    this.uniforms = [];
  }
  add(uniform) {
    this.uniforms.push(uniform);
    return this;
  }
  remove(uniform) {
    const index = this.uniforms.indexOf(uniform);
    if (index !== -1) this.uniforms.splice(index, 1);
    return this;
  }
  setName(name) {
    this.name = name;
    return this;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
    return this;
  }
  copy(source) {
    this.name = source.name;
    this.usage = source.usage;
    const uniformsSource = source.uniforms;
    this.uniforms.length = 0;
    for (let i2 = 0, l2 = uniformsSource.length; i2 < l2; i2++) {
      const uniforms = Array.isArray(uniformsSource[i2]) ? uniformsSource[i2] : [uniformsSource[i2]];
      for (let j3 = 0; j3 < uniforms.length; j3++) {
        this.uniforms.push(uniforms[j3].clone());
      }
    }
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class InstancedInterleavedBuffer extends InterleavedBuffer {
  constructor(array, stride, meshPerAttribute = 1) {
    super(array, stride);
    this.isInstancedInterleavedBuffer = true;
    this.meshPerAttribute = meshPerAttribute;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  clone(data) {
    const ib = super.clone(data);
    ib.meshPerAttribute = this.meshPerAttribute;
    return ib;
  }
  toJSON(data) {
    const json = super.toJSON(data);
    json.isInstancedInterleavedBuffer = true;
    json.meshPerAttribute = this.meshPerAttribute;
    return json;
  }
}
class GLBufferAttribute {
  constructor(buffer, type, itemSize, elementSize, count) {
    this.isGLBufferAttribute = true;
    this.name = "";
    this.buffer = buffer;
    this.type = type;
    this.itemSize = itemSize;
    this.elementSize = elementSize;
    this.count = count;
    this.version = 0;
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  setBuffer(buffer) {
    this.buffer = buffer;
    return this;
  }
  setType(type, elementSize) {
    this.type = type;
    this.elementSize = elementSize;
    return this;
  }
  setItemSize(itemSize) {
    this.itemSize = itemSize;
    return this;
  }
  setCount(count) {
    this.count = count;
    return this;
  }
}
const _matrix = /* @__PURE__ */ new Matrix4();
class Raycaster {
  constructor(origin2, direction, near = 0, far = Infinity) {
    this.ray = new Ray(origin2, direction);
    this.near = near;
    this.far = far;
    this.camera = null;
    this.layers = new Layers();
    this.params = {
      Mesh: {},
      Line: { threshold: 1 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };
  }
  set(origin2, direction) {
    this.ray.set(origin2, direction);
  }
  setFromCamera(coords, camera) {
    if (camera.isPerspectiveCamera) {
      this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
      this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
      this.camera = camera;
    } else if (camera.isOrthographicCamera) {
      this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
      this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
      this.camera = camera;
    } else {
      console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
  }
  setFromXRController(controller) {
    _matrix.identity().extractRotation(controller.matrixWorld);
    this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
    this.ray.direction.set(0, 0, -1).applyMatrix4(_matrix);
    return this;
  }
  intersectObject(object, recursive = true, intersects2 = []) {
    intersect(object, this, intersects2, recursive);
    intersects2.sort(ascSort);
    return intersects2;
  }
  intersectObjects(objects, recursive = true, intersects2 = []) {
    for (let i2 = 0, l2 = objects.length; i2 < l2; i2++) {
      intersect(objects[i2], this, intersects2, recursive);
    }
    intersects2.sort(ascSort);
    return intersects2;
  }
}
function ascSort(a5, b6) {
  return a5.distance - b6.distance;
}
function intersect(object, raycaster, intersects2, recursive) {
  let propagate = true;
  if (object.layers.test(raycaster.layers)) {
    const result = object.raycast(raycaster, intersects2);
    if (result === false) propagate = false;
  }
  if (propagate === true && recursive === true) {
    const children = object.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      intersect(children[i2], raycaster, intersects2, true);
    }
  }
}
class Spherical {
  constructor(radius = 1, phi = 0, theta = 0) {
    this.radius = radius;
    this.phi = phi;
    this.theta = theta;
    return this;
  }
  set(radius, phi, theta) {
    this.radius = radius;
    this.phi = phi;
    this.theta = theta;
    return this;
  }
  copy(other) {
    this.radius = other.radius;
    this.phi = other.phi;
    this.theta = other.theta;
    return this;
  }
  // restrict phi to be between EPS and PI-EPS
  makeSafe() {
    const EPS = 1e-6;
    this.phi = clamp$4(this.phi, EPS, Math.PI - EPS);
    return this;
  }
  setFromVector3(v3) {
    return this.setFromCartesianCoords(v3.x, v3.y, v3.z);
  }
  setFromCartesianCoords(x3, y2, z2) {
    this.radius = Math.sqrt(x3 * x3 + y2 * y2 + z2 * z2);
    if (this.radius === 0) {
      this.theta = 0;
      this.phi = 0;
    } else {
      this.theta = Math.atan2(x3, z2);
      this.phi = Math.acos(clamp$4(y2 / this.radius, -1, 1));
    }
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Cylindrical {
  constructor(radius = 1, theta = 0, y2 = 0) {
    this.radius = radius;
    this.theta = theta;
    this.y = y2;
    return this;
  }
  set(radius, theta, y2) {
    this.radius = radius;
    this.theta = theta;
    this.y = y2;
    return this;
  }
  copy(other) {
    this.radius = other.radius;
    this.theta = other.theta;
    this.y = other.y;
    return this;
  }
  setFromVector3(v3) {
    return this.setFromCartesianCoords(v3.x, v3.y, v3.z);
  }
  setFromCartesianCoords(x3, y2, z2) {
    this.radius = Math.sqrt(x3 * x3 + z2 * z2);
    this.theta = Math.atan2(x3, z2);
    this.y = y2;
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Matrix2 {
  constructor(n11, n12, n21, n22) {
    Matrix2.prototype.isMatrix2 = true;
    this.elements = [
      1,
      0,
      0,
      1
    ];
    if (n11 !== void 0) {
      this.set(n11, n12, n21, n22);
    }
  }
  identity() {
    this.set(
      1,
      0,
      0,
      1
    );
    return this;
  }
  fromArray(array, offset = 0) {
    for (let i2 = 0; i2 < 4; i2++) {
      this.elements[i2] = array[i2 + offset];
    }
    return this;
  }
  set(n11, n12, n21, n22) {
    const te = this.elements;
    te[0] = n11;
    te[2] = n12;
    te[1] = n21;
    te[3] = n22;
    return this;
  }
}
const _vector$4 = /* @__PURE__ */ new Vector2();
class Box2 {
  constructor(min = new Vector2(Infinity, Infinity), max2 = new Vector2(-Infinity, -Infinity)) {
    this.isBox2 = true;
    this.min = min;
    this.max = max2;
  }
  set(min, max2) {
    this.min.copy(min);
    this.max.copy(max2);
    return this;
  }
  setFromPoints(points) {
    this.makeEmpty();
    for (let i2 = 0, il = points.length; i2 < il; i2++) {
      this.expandByPoint(points[i2]);
    }
    return this;
  }
  setFromCenterAndSize(center, size) {
    const halfSize = _vector$4.copy(size).multiplyScalar(0.5);
    this.min.copy(center).sub(halfSize);
    this.max.copy(center).add(halfSize);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(box) {
    this.min.copy(box.min);
    this.max.copy(box.max);
    return this;
  }
  makeEmpty() {
    this.min.x = this.min.y = Infinity;
    this.max.x = this.max.y = -Infinity;
    return this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y;
  }
  getCenter(target) {
    return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(target) {
    return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
  }
  expandByPoint(point) {
    this.min.min(point);
    this.max.max(point);
    return this;
  }
  expandByVector(vector) {
    this.min.sub(vector);
    this.max.add(vector);
    return this;
  }
  expandByScalar(scalar) {
    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);
    return this;
  }
  containsPoint(point) {
    return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
  }
  containsBox(box) {
    return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
  }
  getParameter(point, target) {
    return target.set(
      (point.x - this.min.x) / (this.max.x - this.min.x),
      (point.y - this.min.y) / (this.max.y - this.min.y)
    );
  }
  intersectsBox(box) {
    return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
  }
  clampPoint(point, target) {
    return target.copy(point).clamp(this.min, this.max);
  }
  distanceToPoint(point) {
    return this.clampPoint(point, _vector$4).distanceTo(point);
  }
  intersect(box) {
    this.min.max(box.min);
    this.max.min(box.max);
    if (this.isEmpty()) this.makeEmpty();
    return this;
  }
  union(box) {
    this.min.min(box.min);
    this.max.max(box.max);
    return this;
  }
  translate(offset) {
    this.min.add(offset);
    this.max.add(offset);
    return this;
  }
  equals(box) {
    return box.min.equals(this.min) && box.max.equals(this.max);
  }
}
const _startP = /* @__PURE__ */ new Vector3();
const _startEnd = /* @__PURE__ */ new Vector3();
class Line3 {
  constructor(start2 = new Vector3(), end = new Vector3()) {
    this.start = start2;
    this.end = end;
  }
  set(start2, end) {
    this.start.copy(start2);
    this.end.copy(end);
    return this;
  }
  copy(line) {
    this.start.copy(line.start);
    this.end.copy(line.end);
    return this;
  }
  getCenter(target) {
    return target.addVectors(this.start, this.end).multiplyScalar(0.5);
  }
  delta(target) {
    return target.subVectors(this.end, this.start);
  }
  distanceSq() {
    return this.start.distanceToSquared(this.end);
  }
  distance() {
    return this.start.distanceTo(this.end);
  }
  at(t2, target) {
    return this.delta(target).multiplyScalar(t2).add(this.start);
  }
  closestPointToPointParameter(point, clampToLine) {
    _startP.subVectors(point, this.start);
    _startEnd.subVectors(this.end, this.start);
    const startEnd2 = _startEnd.dot(_startEnd);
    const startEnd_startP = _startEnd.dot(_startP);
    let t2 = startEnd_startP / startEnd2;
    if (clampToLine) {
      t2 = clamp$4(t2, 0, 1);
    }
    return t2;
  }
  closestPointToPoint(point, clampToLine, target) {
    const t2 = this.closestPointToPointParameter(point, clampToLine);
    return this.delta(target).multiplyScalar(t2).add(this.start);
  }
  applyMatrix4(matrix) {
    this.start.applyMatrix4(matrix);
    this.end.applyMatrix4(matrix);
    return this;
  }
  equals(line) {
    return line.start.equals(this.start) && line.end.equals(this.end);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _vector$3 = /* @__PURE__ */ new Vector3();
class SpotLightHelper extends Object3D {
  constructor(light, color) {
    super();
    this.light = light;
    this.matrixAutoUpdate = false;
    this.color = color;
    this.type = "SpotLightHelper";
    const geometry = new BufferGeometry();
    const positions = [
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      0,
      1,
      0,
      0,
      0,
      -1,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      1,
      0,
      0,
      0,
      0,
      -1,
      1
    ];
    for (let i2 = 0, j3 = 1, l2 = 32; i2 < l2; i2++, j3++) {
      const p1 = i2 / l2 * Math.PI * 2;
      const p22 = j3 / l2 * Math.PI * 2;
      positions.push(
        Math.cos(p1),
        Math.sin(p1),
        1,
        Math.cos(p22),
        Math.sin(p22),
        1
      );
    }
    geometry.setAttribute("position", new Float32BufferAttribute(positions, 3));
    const material = new LineBasicMaterial({ fog: false, toneMapped: false });
    this.cone = new LineSegments(geometry, material);
    this.add(this.cone);
    this.update();
  }
  dispose() {
    this.cone.geometry.dispose();
    this.cone.material.dispose();
  }
  update() {
    this.light.updateWorldMatrix(true, false);
    this.light.target.updateWorldMatrix(true, false);
    if (this.parent) {
      this.parent.updateWorldMatrix(true);
      this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
    } else {
      this.matrix.copy(this.light.matrixWorld);
    }
    this.matrixWorld.copy(this.light.matrixWorld);
    const coneLength = this.light.distance ? this.light.distance : 1e3;
    const coneWidth = coneLength * Math.tan(this.light.angle);
    this.cone.scale.set(coneWidth, coneWidth, coneLength);
    _vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
    this.cone.lookAt(_vector$3);
    if (this.color !== void 0) {
      this.cone.material.color.set(this.color);
    } else {
      this.cone.material.color.copy(this.light.color);
    }
  }
}
const _vector$2 = /* @__PURE__ */ new Vector3();
const _boneMatrix = /* @__PURE__ */ new Matrix4();
const _matrixWorldInv = /* @__PURE__ */ new Matrix4();
class SkeletonHelper extends LineSegments {
  constructor(object) {
    const bones = getBoneList(object);
    const geometry = new BufferGeometry();
    const vertices = [];
    const colors3 = [];
    const color1 = new Color(0, 0, 1);
    const color2 = new Color(0, 1, 0);
    for (let i2 = 0; i2 < bones.length; i2++) {
      const bone = bones[i2];
      if (bone.parent && bone.parent.isBone) {
        vertices.push(0, 0, 0);
        vertices.push(0, 0, 0);
        colors3.push(color1.r, color1.g, color1.b);
        colors3.push(color2.r, color2.g, color2.b);
      }
    }
    geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute(colors3, 3));
    const material = new LineBasicMaterial({ vertexColors: true, depthTest: false, depthWrite: false, toneMapped: false, transparent: true });
    super(geometry, material);
    this.isSkeletonHelper = true;
    this.type = "SkeletonHelper";
    this.root = object;
    this.bones = bones;
    this.matrix = object.matrixWorld;
    this.matrixAutoUpdate = false;
  }
  updateMatrixWorld(force) {
    const bones = this.bones;
    const geometry = this.geometry;
    const position = geometry.getAttribute("position");
    _matrixWorldInv.copy(this.root.matrixWorld).invert();
    for (let i2 = 0, j3 = 0; i2 < bones.length; i2++) {
      const bone = bones[i2];
      if (bone.parent && bone.parent.isBone) {
        _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);
        _vector$2.setFromMatrixPosition(_boneMatrix);
        position.setXYZ(j3, _vector$2.x, _vector$2.y, _vector$2.z);
        _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);
        _vector$2.setFromMatrixPosition(_boneMatrix);
        position.setXYZ(j3 + 1, _vector$2.x, _vector$2.y, _vector$2.z);
        j3 += 2;
      }
    }
    geometry.getAttribute("position").needsUpdate = true;
    super.updateMatrixWorld(force);
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
function getBoneList(object) {
  const boneList = [];
  if (object.isBone === true) {
    boneList.push(object);
  }
  for (let i2 = 0; i2 < object.children.length; i2++) {
    boneList.push.apply(boneList, getBoneList(object.children[i2]));
  }
  return boneList;
}
class PointLightHelper extends Mesh {
  constructor(light, sphereSize, color) {
    const geometry = new SphereGeometry(sphereSize, 4, 2);
    const material = new MeshBasicMaterial({ wireframe: true, fog: false, toneMapped: false });
    super(geometry, material);
    this.light = light;
    this.color = color;
    this.type = "PointLightHelper";
    this.matrix = this.light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.update();
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
  update() {
    this.light.updateWorldMatrix(true, false);
    if (this.color !== void 0) {
      this.material.color.set(this.color);
    } else {
      this.material.color.copy(this.light.color);
    }
  }
}
const _vector$1 = /* @__PURE__ */ new Vector3();
const _color1 = /* @__PURE__ */ new Color();
const _color2 = /* @__PURE__ */ new Color();
class HemisphereLightHelper extends Object3D {
  constructor(light, size, color) {
    super();
    this.light = light;
    this.matrix = light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.color = color;
    this.type = "HemisphereLightHelper";
    const geometry = new OctahedronGeometry(size);
    geometry.rotateY(Math.PI * 0.5);
    this.material = new MeshBasicMaterial({ wireframe: true, fog: false, toneMapped: false });
    if (this.color === void 0) this.material.vertexColors = true;
    const position = geometry.getAttribute("position");
    const colors3 = new Float32Array(position.count * 3);
    geometry.setAttribute("color", new BufferAttribute(colors3, 3));
    this.add(new Mesh(geometry, this.material));
    this.update();
  }
  dispose() {
    this.children[0].geometry.dispose();
    this.children[0].material.dispose();
  }
  update() {
    const mesh = this.children[0];
    if (this.color !== void 0) {
      this.material.color.set(this.color);
    } else {
      const colors3 = mesh.geometry.getAttribute("color");
      _color1.copy(this.light.color);
      _color2.copy(this.light.groundColor);
      for (let i2 = 0, l2 = colors3.count; i2 < l2; i2++) {
        const color = i2 < l2 / 2 ? _color1 : _color2;
        colors3.setXYZ(i2, color.r, color.g, color.b);
      }
      colors3.needsUpdate = true;
    }
    this.light.updateWorldMatrix(true, false);
    mesh.lookAt(_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
  }
}
class GridHelper extends LineSegments {
  constructor(size = 10, divisions = 10, color1 = 4473924, color2 = 8947848) {
    color1 = new Color(color1);
    color2 = new Color(color2);
    const center = divisions / 2;
    const step = size / divisions;
    const halfSize = size / 2;
    const vertices = [], colors3 = [];
    for (let i2 = 0, j3 = 0, k2 = -halfSize; i2 <= divisions; i2++, k2 += step) {
      vertices.push(-halfSize, 0, k2, halfSize, 0, k2);
      vertices.push(k2, 0, -halfSize, k2, 0, halfSize);
      const color = i2 === center ? color1 : color2;
      color.toArray(colors3, j3);
      j3 += 3;
      color.toArray(colors3, j3);
      j3 += 3;
      color.toArray(colors3, j3);
      j3 += 3;
      color.toArray(colors3, j3);
      j3 += 3;
    }
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute(colors3, 3));
    const material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });
    super(geometry, material);
    this.type = "GridHelper";
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
class PolarGridHelper extends LineSegments {
  constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 4473924, color2 = 8947848) {
    color1 = new Color(color1);
    color2 = new Color(color2);
    const vertices = [];
    const colors3 = [];
    if (sectors > 1) {
      for (let i2 = 0; i2 < sectors; i2++) {
        const v3 = i2 / sectors * (Math.PI * 2);
        const x3 = Math.sin(v3) * radius;
        const z2 = Math.cos(v3) * radius;
        vertices.push(0, 0, 0);
        vertices.push(x3, 0, z2);
        const color = i2 & 1 ? color1 : color2;
        colors3.push(color.r, color.g, color.b);
        colors3.push(color.r, color.g, color.b);
      }
    }
    for (let i2 = 0; i2 < rings; i2++) {
      const color = i2 & 1 ? color1 : color2;
      const r3 = radius - radius / rings * i2;
      for (let j3 = 0; j3 < divisions; j3++) {
        let v3 = j3 / divisions * (Math.PI * 2);
        let x3 = Math.sin(v3) * r3;
        let z2 = Math.cos(v3) * r3;
        vertices.push(x3, 0, z2);
        colors3.push(color.r, color.g, color.b);
        v3 = (j3 + 1) / divisions * (Math.PI * 2);
        x3 = Math.sin(v3) * r3;
        z2 = Math.cos(v3) * r3;
        vertices.push(x3, 0, z2);
        colors3.push(color.r, color.g, color.b);
      }
    }
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute(colors3, 3));
    const material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });
    super(geometry, material);
    this.type = "PolarGridHelper";
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
const _v1 = /* @__PURE__ */ new Vector3();
const _v2$5 = /* @__PURE__ */ new Vector3();
const _v3 = /* @__PURE__ */ new Vector3();
class DirectionalLightHelper extends Object3D {
  constructor(light, size, color) {
    super();
    this.light = light;
    this.matrix = light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.color = color;
    this.type = "DirectionalLightHelper";
    if (size === void 0) size = 1;
    let geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute([
      -size,
      size,
      0,
      size,
      size,
      0,
      size,
      -size,
      0,
      -size,
      -size,
      0,
      -size,
      size,
      0
    ], 3));
    const material = new LineBasicMaterial({ fog: false, toneMapped: false });
    this.lightPlane = new Line(geometry, material);
    this.add(this.lightPlane);
    geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute([0, 0, 0, 0, 0, 1], 3));
    this.targetLine = new Line(geometry, material);
    this.add(this.targetLine);
    this.update();
  }
  dispose() {
    this.lightPlane.geometry.dispose();
    this.lightPlane.material.dispose();
    this.targetLine.geometry.dispose();
    this.targetLine.material.dispose();
  }
  update() {
    this.light.updateWorldMatrix(true, false);
    this.light.target.updateWorldMatrix(true, false);
    _v1.setFromMatrixPosition(this.light.matrixWorld);
    _v2$5.setFromMatrixPosition(this.light.target.matrixWorld);
    _v3.subVectors(_v2$5, _v1);
    this.lightPlane.lookAt(_v2$5);
    if (this.color !== void 0) {
      this.lightPlane.material.color.set(this.color);
      this.targetLine.material.color.set(this.color);
    } else {
      this.lightPlane.material.color.copy(this.light.color);
      this.targetLine.material.color.copy(this.light.color);
    }
    this.targetLine.lookAt(_v2$5);
    this.targetLine.scale.z = _v3.length();
  }
}
const _vector = /* @__PURE__ */ new Vector3();
const _camera = /* @__PURE__ */ new Camera();
class CameraHelper extends LineSegments {
  constructor(camera) {
    const geometry = new BufferGeometry();
    const material = new LineBasicMaterial({ color: 16777215, vertexColors: true, toneMapped: false });
    const vertices = [];
    const colors3 = [];
    const pointMap = {};
    addLine("n1", "n2");
    addLine("n2", "n4");
    addLine("n4", "n3");
    addLine("n3", "n1");
    addLine("f1", "f2");
    addLine("f2", "f4");
    addLine("f4", "f3");
    addLine("f3", "f1");
    addLine("n1", "f1");
    addLine("n2", "f2");
    addLine("n3", "f3");
    addLine("n4", "f4");
    addLine("p", "n1");
    addLine("p", "n2");
    addLine("p", "n3");
    addLine("p", "n4");
    addLine("u1", "u2");
    addLine("u2", "u3");
    addLine("u3", "u1");
    addLine("c", "t");
    addLine("p", "c");
    addLine("cn1", "cn2");
    addLine("cn3", "cn4");
    addLine("cf1", "cf2");
    addLine("cf3", "cf4");
    function addLine(a5, b6) {
      addPoint(a5);
      addPoint(b6);
    }
    function addPoint(id) {
      vertices.push(0, 0, 0);
      colors3.push(0, 0, 0);
      if (pointMap[id] === void 0) {
        pointMap[id] = [];
      }
      pointMap[id].push(vertices.length / 3 - 1);
    }
    geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute(colors3, 3));
    super(geometry, material);
    this.type = "CameraHelper";
    this.camera = camera;
    if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
    this.matrix = camera.matrixWorld;
    this.matrixAutoUpdate = false;
    this.pointMap = pointMap;
    this.update();
    const colorFrustum = new Color(16755200);
    const colorCone = new Color(16711680);
    const colorUp = new Color(43775);
    const colorTarget = new Color(16777215);
    const colorCross = new Color(3355443);
    this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
  }
  setColors(frustum, cone, up, target, cross) {
    const geometry = this.geometry;
    const colorAttribute = geometry.getAttribute("color");
    colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(25, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(27, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(29, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(31, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(32, up.r, up.g, up.b);
    colorAttribute.setXYZ(33, up.r, up.g, up.b);
    colorAttribute.setXYZ(34, up.r, up.g, up.b);
    colorAttribute.setXYZ(35, up.r, up.g, up.b);
    colorAttribute.setXYZ(36, up.r, up.g, up.b);
    colorAttribute.setXYZ(37, up.r, up.g, up.b);
    colorAttribute.setXYZ(38, target.r, target.g, target.b);
    colorAttribute.setXYZ(39, target.r, target.g, target.b);
    colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(41, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(43, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(45, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(47, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(49, cross.r, cross.g, cross.b);
    colorAttribute.needsUpdate = true;
  }
  update() {
    const geometry = this.geometry;
    const pointMap = this.pointMap;
    const w2 = 1, h2 = 1;
    _camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
    const nearZ = this.camera.coordinateSystem === WebGLCoordinateSystem ? -1 : 0;
    setPoint("c", pointMap, geometry, _camera, 0, 0, nearZ);
    setPoint("t", pointMap, geometry, _camera, 0, 0, 1);
    setPoint("n1", pointMap, geometry, _camera, -w2, -h2, nearZ);
    setPoint("n2", pointMap, geometry, _camera, w2, -h2, nearZ);
    setPoint("n3", pointMap, geometry, _camera, -w2, h2, nearZ);
    setPoint("n4", pointMap, geometry, _camera, w2, h2, nearZ);
    setPoint("f1", pointMap, geometry, _camera, -w2, -h2, 1);
    setPoint("f2", pointMap, geometry, _camera, w2, -h2, 1);
    setPoint("f3", pointMap, geometry, _camera, -w2, h2, 1);
    setPoint("f4", pointMap, geometry, _camera, w2, h2, 1);
    setPoint("u1", pointMap, geometry, _camera, w2 * 0.7, h2 * 1.1, nearZ);
    setPoint("u2", pointMap, geometry, _camera, -w2 * 0.7, h2 * 1.1, nearZ);
    setPoint("u3", pointMap, geometry, _camera, 0, h2 * 2, nearZ);
    setPoint("cf1", pointMap, geometry, _camera, -w2, 0, 1);
    setPoint("cf2", pointMap, geometry, _camera, w2, 0, 1);
    setPoint("cf3", pointMap, geometry, _camera, 0, -h2, 1);
    setPoint("cf4", pointMap, geometry, _camera, 0, h2, 1);
    setPoint("cn1", pointMap, geometry, _camera, -w2, 0, nearZ);
    setPoint("cn2", pointMap, geometry, _camera, w2, 0, nearZ);
    setPoint("cn3", pointMap, geometry, _camera, 0, -h2, nearZ);
    setPoint("cn4", pointMap, geometry, _camera, 0, h2, nearZ);
    geometry.getAttribute("position").needsUpdate = true;
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
function setPoint(point, pointMap, geometry, camera, x3, y2, z2) {
  _vector.set(x3, y2, z2).unproject(camera);
  const points = pointMap[point];
  if (points !== void 0) {
    const position = geometry.getAttribute("position");
    for (let i2 = 0, l2 = points.length; i2 < l2; i2++) {
      position.setXYZ(points[i2], _vector.x, _vector.y, _vector.z);
    }
  }
}
const _box = /* @__PURE__ */ new Box3();
class BoxHelper extends LineSegments {
  constructor(object, color = 16776960) {
    const indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
    const positions = new Float32Array(8 * 3);
    const geometry = new BufferGeometry();
    geometry.setIndex(new BufferAttribute(indices, 1));
    geometry.setAttribute("position", new BufferAttribute(positions, 3));
    super(geometry, new LineBasicMaterial({ color, toneMapped: false }));
    this.object = object;
    this.type = "BoxHelper";
    this.matrixAutoUpdate = false;
    this.update();
  }
  update(object) {
    if (object !== void 0) {
      console.warn("THREE.BoxHelper: .update() has no longer arguments.");
    }
    if (this.object !== void 0) {
      _box.setFromObject(this.object);
    }
    if (_box.isEmpty()) return;
    const min = _box.min;
    const max2 = _box.max;
    const position = this.geometry.attributes.position;
    const array = position.array;
    array[0] = max2.x;
    array[1] = max2.y;
    array[2] = max2.z;
    array[3] = min.x;
    array[4] = max2.y;
    array[5] = max2.z;
    array[6] = min.x;
    array[7] = min.y;
    array[8] = max2.z;
    array[9] = max2.x;
    array[10] = min.y;
    array[11] = max2.z;
    array[12] = max2.x;
    array[13] = max2.y;
    array[14] = min.z;
    array[15] = min.x;
    array[16] = max2.y;
    array[17] = min.z;
    array[18] = min.x;
    array[19] = min.y;
    array[20] = min.z;
    array[21] = max2.x;
    array[22] = min.y;
    array[23] = min.z;
    position.needsUpdate = true;
    this.geometry.computeBoundingSphere();
  }
  setFromObject(object) {
    this.object = object;
    this.update();
    return this;
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.object = source.object;
    return this;
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
class Box3Helper extends LineSegments {
  constructor(box, color = 16776960) {
    const indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
    const positions = [1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1];
    const geometry = new BufferGeometry();
    geometry.setIndex(new BufferAttribute(indices, 1));
    geometry.setAttribute("position", new Float32BufferAttribute(positions, 3));
    super(geometry, new LineBasicMaterial({ color, toneMapped: false }));
    this.box = box;
    this.type = "Box3Helper";
    this.geometry.computeBoundingSphere();
  }
  updateMatrixWorld(force) {
    const box = this.box;
    if (box.isEmpty()) return;
    box.getCenter(this.position);
    box.getSize(this.scale);
    this.scale.multiplyScalar(0.5);
    super.updateMatrixWorld(force);
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
class PlaneHelper extends Line {
  constructor(plane, size = 1, hex = 16776960) {
    const color = hex;
    const positions = [1, -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0];
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute(positions, 3));
    geometry.computeBoundingSphere();
    super(geometry, new LineBasicMaterial({ color, toneMapped: false }));
    this.type = "PlaneHelper";
    this.plane = plane;
    this.size = size;
    const positions2 = [1, 1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0];
    const geometry2 = new BufferGeometry();
    geometry2.setAttribute("position", new Float32BufferAttribute(positions2, 3));
    geometry2.computeBoundingSphere();
    this.add(new Mesh(geometry2, new MeshBasicMaterial({ color, opacity: 0.2, transparent: true, depthWrite: false, toneMapped: false })));
  }
  updateMatrixWorld(force) {
    this.position.set(0, 0, 0);
    this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
    this.lookAt(this.plane.normal);
    this.translateZ(-this.plane.constant);
    super.updateMatrixWorld(force);
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
    this.children[0].geometry.dispose();
    this.children[0].material.dispose();
  }
}
const _axis = /* @__PURE__ */ new Vector3();
let _lineGeometry, _coneGeometry;
class ArrowHelper extends Object3D {
  // dir is assumed to be normalized
  constructor(dir = new Vector3(0, 0, 1), origin2 = new Vector3(0, 0, 0), length = 1, color = 16776960, headLength = length * 0.2, headWidth = headLength * 0.2) {
    super();
    this.type = "ArrowHelper";
    if (_lineGeometry === void 0) {
      _lineGeometry = new BufferGeometry();
      _lineGeometry.setAttribute("position", new Float32BufferAttribute([0, 0, 0, 0, 1, 0], 3));
      _coneGeometry = new CylinderGeometry(0, 0.5, 1, 5, 1);
      _coneGeometry.translate(0, -0.5, 0);
    }
    this.position.copy(origin2);
    this.line = new Line(_lineGeometry, new LineBasicMaterial({ color, toneMapped: false }));
    this.line.matrixAutoUpdate = false;
    this.add(this.line);
    this.cone = new Mesh(_coneGeometry, new MeshBasicMaterial({ color, toneMapped: false }));
    this.cone.matrixAutoUpdate = false;
    this.add(this.cone);
    this.setDirection(dir);
    this.setLength(length, headLength, headWidth);
  }
  setDirection(dir) {
    if (dir.y > 0.99999) {
      this.quaternion.set(0, 0, 0, 1);
    } else if (dir.y < -0.99999) {
      this.quaternion.set(1, 0, 0, 0);
    } else {
      _axis.set(dir.z, 0, -dir.x).normalize();
      const radians = Math.acos(dir.y);
      this.quaternion.setFromAxisAngle(_axis, radians);
    }
  }
  setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
    this.line.scale.set(1, Math.max(1e-4, length - headLength), 1);
    this.line.updateMatrix();
    this.cone.scale.set(headWidth, headLength, headWidth);
    this.cone.position.y = length;
    this.cone.updateMatrix();
  }
  setColor(color) {
    this.line.material.color.set(color);
    this.cone.material.color.set(color);
  }
  copy(source) {
    super.copy(source, false);
    this.line.copy(source.line);
    this.cone.copy(source.cone);
    return this;
  }
  dispose() {
    this.line.geometry.dispose();
    this.line.material.dispose();
    this.cone.geometry.dispose();
    this.cone.material.dispose();
  }
}
class AxesHelper extends LineSegments {
  constructor(size = 1) {
    const vertices = [
      0,
      0,
      0,
      size,
      0,
      0,
      0,
      0,
      0,
      0,
      size,
      0,
      0,
      0,
      0,
      0,
      0,
      size
    ];
    const colors3 = [
      1,
      0,
      0,
      1,
      0.6,
      0,
      0,
      1,
      0,
      0.6,
      1,
      0,
      0,
      0,
      1,
      0,
      0.6,
      1
    ];
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute(colors3, 3));
    const material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });
    super(geometry, material);
    this.type = "AxesHelper";
  }
  setColors(xAxisColor, yAxisColor, zAxisColor) {
    const color = new Color();
    const array = this.geometry.attributes.color.array;
    color.set(xAxisColor);
    color.toArray(array, 0);
    color.toArray(array, 3);
    color.set(yAxisColor);
    color.toArray(array, 6);
    color.toArray(array, 9);
    color.set(zAxisColor);
    color.toArray(array, 12);
    color.toArray(array, 15);
    this.geometry.attributes.color.needsUpdate = true;
    return this;
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
class ShapePath {
  constructor() {
    this.type = "ShapePath";
    this.color = new Color();
    this.subPaths = [];
    this.currentPath = null;
  }
  moveTo(x3, y2) {
    this.currentPath = new Path();
    this.subPaths.push(this.currentPath);
    this.currentPath.moveTo(x3, y2);
    return this;
  }
  lineTo(x3, y2) {
    this.currentPath.lineTo(x3, y2);
    return this;
  }
  quadraticCurveTo(aCPx, aCPy, aX, aY) {
    this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
    return this;
  }
  bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
    this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
    return this;
  }
  splineThru(pts) {
    this.currentPath.splineThru(pts);
    return this;
  }
  toShapes(isCCW) {
    function toShapesNoHoles(inSubpaths) {
      const shapes2 = [];
      for (let i2 = 0, l2 = inSubpaths.length; i2 < l2; i2++) {
        const tmpPath2 = inSubpaths[i2];
        const tmpShape2 = new Shape();
        tmpShape2.curves = tmpPath2.curves;
        shapes2.push(tmpShape2);
      }
      return shapes2;
    }
    function isPointInsidePolygon(inPt, inPolygon) {
      const polyLen = inPolygon.length;
      let inside = false;
      for (let p3 = polyLen - 1, q2 = 0; q2 < polyLen; p3 = q2++) {
        let edgeLowPt = inPolygon[p3];
        let edgeHighPt = inPolygon[q2];
        let edgeDx = edgeHighPt.x - edgeLowPt.x;
        let edgeDy = edgeHighPt.y - edgeLowPt.y;
        if (Math.abs(edgeDy) > Number.EPSILON) {
          if (edgeDy < 0) {
            edgeLowPt = inPolygon[q2];
            edgeDx = -edgeDx;
            edgeHighPt = inPolygon[p3];
            edgeDy = -edgeDy;
          }
          if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
          if (inPt.y === edgeLowPt.y) {
            if (inPt.x === edgeLowPt.x) return true;
          } else {
            const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
            if (perpEdge === 0) return true;
            if (perpEdge < 0) continue;
            inside = !inside;
          }
        } else {
          if (inPt.y !== edgeLowPt.y) continue;
          if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true;
        }
      }
      return inside;
    }
    const isClockWise = ShapeUtils.isClockWise;
    const subPaths = this.subPaths;
    if (subPaths.length === 0) return [];
    let solid, tmpPath, tmpShape;
    const shapes = [];
    if (subPaths.length === 1) {
      tmpPath = subPaths[0];
      tmpShape = new Shape();
      tmpShape.curves = tmpPath.curves;
      shapes.push(tmpShape);
      return shapes;
    }
    let holesFirst = !isClockWise(subPaths[0].getPoints());
    holesFirst = isCCW ? !holesFirst : holesFirst;
    const betterShapeHoles = [];
    const newShapes = [];
    let newShapeHoles = [];
    let mainIdx = 0;
    let tmpPoints;
    newShapes[mainIdx] = void 0;
    newShapeHoles[mainIdx] = [];
    for (let i2 = 0, l2 = subPaths.length; i2 < l2; i2++) {
      tmpPath = subPaths[i2];
      tmpPoints = tmpPath.getPoints();
      solid = isClockWise(tmpPoints);
      solid = isCCW ? !solid : solid;
      if (solid) {
        if (!holesFirst && newShapes[mainIdx]) mainIdx++;
        newShapes[mainIdx] = { s: new Shape(), p: tmpPoints };
        newShapes[mainIdx].s.curves = tmpPath.curves;
        if (holesFirst) mainIdx++;
        newShapeHoles[mainIdx] = [];
      } else {
        newShapeHoles[mainIdx].push({ h: tmpPath, p: tmpPoints[0] });
      }
    }
    if (!newShapes[0]) return toShapesNoHoles(subPaths);
    if (newShapes.length > 1) {
      let ambiguous = false;
      let toChange = 0;
      for (let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++) {
        betterShapeHoles[sIdx] = [];
      }
      for (let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++) {
        const sho = newShapeHoles[sIdx];
        for (let hIdx = 0; hIdx < sho.length; hIdx++) {
          const ho = sho[hIdx];
          let hole_unassigned = true;
          for (let s2Idx = 0; s2Idx < newShapes.length; s2Idx++) {
            if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
              if (sIdx !== s2Idx) toChange++;
              if (hole_unassigned) {
                hole_unassigned = false;
                betterShapeHoles[s2Idx].push(ho);
              } else {
                ambiguous = true;
              }
            }
          }
          if (hole_unassigned) {
            betterShapeHoles[sIdx].push(ho);
          }
        }
      }
      if (toChange > 0 && ambiguous === false) {
        newShapeHoles = betterShapeHoles;
      }
    }
    let tmpHoles;
    for (let i2 = 0, il = newShapes.length; i2 < il; i2++) {
      tmpShape = newShapes[i2].s;
      shapes.push(tmpShape);
      tmpHoles = newShapeHoles[i2];
      for (let j3 = 0, jl = tmpHoles.length; j3 < jl; j3++) {
        tmpShape.holes.push(tmpHoles[j3].h);
      }
    }
    return shapes;
  }
}
class Controls extends EventDispatcher$2 {
  constructor(object, domElement = null) {
    super();
    this.object = object;
    this.domElement = domElement;
    this.enabled = true;
    this.state = -1;
    this.keys = {};
    this.mouseButtons = { LEFT: null, MIDDLE: null, RIGHT: null };
    this.touches = { ONE: null, TWO: null };
  }
  connect() {
  }
  disconnect() {
  }
  dispose() {
  }
  update() {
  }
}
function contain(texture, aspect2) {
  const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
  if (imageAspect > aspect2) {
    texture.repeat.x = 1;
    texture.repeat.y = imageAspect / aspect2;
    texture.offset.x = 0;
    texture.offset.y = (1 - texture.repeat.y) / 2;
  } else {
    texture.repeat.x = aspect2 / imageAspect;
    texture.repeat.y = 1;
    texture.offset.x = (1 - texture.repeat.x) / 2;
    texture.offset.y = 0;
  }
  return texture;
}
function cover(texture, aspect2) {
  const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
  if (imageAspect > aspect2) {
    texture.repeat.x = aspect2 / imageAspect;
    texture.repeat.y = 1;
    texture.offset.x = (1 - texture.repeat.x) / 2;
    texture.offset.y = 0;
  } else {
    texture.repeat.x = 1;
    texture.repeat.y = imageAspect / aspect2;
    texture.offset.x = 0;
    texture.offset.y = (1 - texture.repeat.y) / 2;
  }
  return texture;
}
function fill(texture) {
  texture.repeat.x = 1;
  texture.repeat.y = 1;
  texture.offset.x = 0;
  texture.offset.y = 0;
  return texture;
}
function getByteLength(width, height, format, type) {
  const typeByteLength = getTextureTypeByteLength(type);
  switch (format) {
    // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
    case AlphaFormat:
      return width * height;
    case LuminanceFormat:
      return width * height;
    case LuminanceAlphaFormat:
      return width * height * 2;
    case RedFormat:
      return width * height / typeByteLength.components * typeByteLength.byteLength;
    case RedIntegerFormat:
      return width * height / typeByteLength.components * typeByteLength.byteLength;
    case RGFormat:
      return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
    case RGIntegerFormat:
      return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
    case RGBFormat:
      return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
    case RGBAFormat:
      return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
    case RGBAIntegerFormat:
      return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
    case RGB_S3TC_DXT1_Format:
    case RGBA_S3TC_DXT1_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
    case RGBA_S3TC_DXT3_Format:
    case RGBA_S3TC_DXT5_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
    case RGB_PVRTC_2BPPV1_Format:
    case RGBA_PVRTC_2BPPV1_Format:
      return Math.max(width, 16) * Math.max(height, 8) / 4;
    case RGB_PVRTC_4BPPV1_Format:
    case RGBA_PVRTC_4BPPV1_Format:
      return Math.max(width, 8) * Math.max(height, 8) / 2;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
    case RGB_ETC1_Format:
    case RGB_ETC2_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
    case RGBA_ETC2_EAC_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
    case RGBA_ASTC_4x4_Format:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
    case RGBA_ASTC_5x4_Format:
      return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
    case RGBA_ASTC_5x5_Format:
      return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_6x5_Format:
      return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_6x6_Format:
      return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
    case RGBA_ASTC_8x5_Format:
      return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_8x6_Format:
      return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
    case RGBA_ASTC_8x8_Format:
      return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
    case RGBA_ASTC_10x5_Format:
      return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_10x6_Format:
      return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
    case RGBA_ASTC_10x8_Format:
      return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
    case RGBA_ASTC_10x10_Format:
      return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
    case RGBA_ASTC_12x10_Format:
      return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
    case RGBA_ASTC_12x12_Format:
      return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
    case RGBA_BPTC_Format:
    case RGB_BPTC_SIGNED_Format:
    case RGB_BPTC_UNSIGNED_Format:
      return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
    case RED_RGTC1_Format:
    case SIGNED_RED_RGTC1_Format:
      return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
    case RED_GREEN_RGTC2_Format:
    case SIGNED_RED_GREEN_RGTC2_Format:
      return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
  }
  throw new Error(
    `Unable to determine texture byte length for ${format} format.`
  );
}
function getTextureTypeByteLength(type) {
  switch (type) {
    case UnsignedByteType:
    case ByteType:
      return { byteLength: 1, components: 1 };
    case UnsignedShortType:
    case ShortType:
    case HalfFloatType:
      return { byteLength: 2, components: 1 };
    case UnsignedShort4444Type:
    case UnsignedShort5551Type:
      return { byteLength: 2, components: 4 };
    case UnsignedIntType:
    case IntType:
    case FloatType:
      return { byteLength: 4, components: 1 };
    case UnsignedInt5999Type:
      return { byteLength: 4, components: 3 };
  }
  throw new Error(`Unknown texture type ${type}.`);
}
const TextureUtils = {
  contain,
  cover,
  fill,
  getByteLength
};
if (typeof __THREE_DEVTOOLS__ !== "undefined") {
  __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
    revision: REVISION
  } }));
}
if (typeof window !== "undefined") {
  if (window.__THREE__) {
    console.warn("WARNING: Multiple instances of Three.js being imported.");
  } else {
    window.__THREE__ = REVISION;
  }
}
function WebGLAnimation() {
  let context4 = null;
  let isAnimating = false;
  let animationLoop = null;
  let requestId = null;
  function onAnimationFrame(time, frame) {
    animationLoop(time, frame);
    requestId = context4.requestAnimationFrame(onAnimationFrame);
  }
  return {
    start: function() {
      if (isAnimating === true) return;
      if (animationLoop === null) return;
      requestId = context4.requestAnimationFrame(onAnimationFrame);
      isAnimating = true;
    },
    stop: function() {
      context4.cancelAnimationFrame(requestId);
      isAnimating = false;
    },
    setAnimationLoop: function(callback) {
      animationLoop = callback;
    },
    setContext: function(value) {
      context4 = value;
    }
  };
}
function WebGLAttributes(gl) {
  const buffers = /* @__PURE__ */ new WeakMap();
  function createBuffer(attribute, bufferType) {
    const array = attribute.array;
    const usage = attribute.usage;
    const size = array.byteLength;
    const buffer = gl.createBuffer();
    gl.bindBuffer(bufferType, buffer);
    gl.bufferData(bufferType, array, usage);
    attribute.onUploadCallback();
    let type;
    if (array instanceof Float32Array) {
      type = gl.FLOAT;
    } else if (array instanceof Uint16Array) {
      if (attribute.isFloat16BufferAttribute) {
        type = gl.HALF_FLOAT;
      } else {
        type = gl.UNSIGNED_SHORT;
      }
    } else if (array instanceof Int16Array) {
      type = gl.SHORT;
    } else if (array instanceof Uint32Array) {
      type = gl.UNSIGNED_INT;
    } else if (array instanceof Int32Array) {
      type = gl.INT;
    } else if (array instanceof Int8Array) {
      type = gl.BYTE;
    } else if (array instanceof Uint8Array) {
      type = gl.UNSIGNED_BYTE;
    } else if (array instanceof Uint8ClampedArray) {
      type = gl.UNSIGNED_BYTE;
    } else {
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
    }
    return {
      buffer,
      type,
      bytesPerElement: array.BYTES_PER_ELEMENT,
      version: attribute.version,
      size
    };
  }
  function updateBuffer(buffer, attribute, bufferType) {
    const array = attribute.array;
    const updateRanges = attribute.updateRanges;
    gl.bindBuffer(bufferType, buffer);
    if (updateRanges.length === 0) {
      gl.bufferSubData(bufferType, 0, array);
    } else {
      updateRanges.sort((a5, b6) => a5.start - b6.start);
      let mergeIndex = 0;
      for (let i2 = 1; i2 < updateRanges.length; i2++) {
        const previousRange = updateRanges[mergeIndex];
        const range = updateRanges[i2];
        if (range.start <= previousRange.start + previousRange.count + 1) {
          previousRange.count = Math.max(
            previousRange.count,
            range.start + range.count - previousRange.start
          );
        } else {
          ++mergeIndex;
          updateRanges[mergeIndex] = range;
        }
      }
      updateRanges.length = mergeIndex + 1;
      for (let i2 = 0, l2 = updateRanges.length; i2 < l2; i2++) {
        const range = updateRanges[i2];
        gl.bufferSubData(
          bufferType,
          range.start * array.BYTES_PER_ELEMENT,
          array,
          range.start,
          range.count
        );
      }
      attribute.clearUpdateRanges();
    }
    attribute.onUploadCallback();
  }
  function get(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    return buffers.get(attribute);
  }
  function remove(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    const data = buffers.get(attribute);
    if (data) {
      gl.deleteBuffer(data.buffer);
      buffers.delete(attribute);
    }
  }
  function update2(attribute, bufferType) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    if (attribute.isGLBufferAttribute) {
      const cached = buffers.get(attribute);
      if (!cached || cached.version < attribute.version) {
        buffers.set(attribute, {
          buffer: attribute.buffer,
          type: attribute.type,
          bytesPerElement: attribute.elementSize,
          version: attribute.version
        });
      }
      return;
    }
    const data = buffers.get(attribute);
    if (data === void 0) {
      buffers.set(attribute, createBuffer(attribute, bufferType));
    } else if (data.version < attribute.version) {
      if (data.size !== attribute.array.byteLength) {
        throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
      }
      updateBuffer(data.buffer, attribute, bufferType);
      data.version = attribute.version;
    }
  }
  return {
    get,
    remove,
    update: update2
  };
}
var alphahash_fragment = "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif";
var alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var alphatest_fragment = "#ifdef USE_ALPHATEST\n	#ifdef ALPHA_TO_COVERAGE\n	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n	if ( diffuseColor.a == 0.0 ) discard;\n	#else\n	if ( diffuseColor.a < alphaTest ) discard;\n	#endif\n#endif";
var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var batching_pars_vertex = "#ifdef USE_BATCHING\n	#if ! defined( GL_ANGLE_multi_draw )\n	#define gl_DrawID _gl_DrawID\n	uniform int _gl_DrawID;\n	#endif\n	uniform highp sampler2D batchingTexture;\n	uniform highp usampler2D batchingIdTexture;\n	mat4 getBatchingMatrix( const in float i ) {\n		int size = textureSize( batchingTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n	float getIndirectIndex( const in int i ) {\n		int size = textureSize( batchingIdTexture, 0 ).x;\n		int x = i % size;\n		int y = i / size;\n		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n	}\n#endif\n#ifdef USE_BATCHING_COLOR\n	uniform sampler2D batchingColorTexture;\n	vec3 getBatchingColor( const in float i ) {\n		int size = textureSize( batchingColorTexture, 0 ).x;\n		int j = int( i );\n		int x = j % size;\n		int y = j / size;\n		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n	}\n#endif";
var batching_vertex = "#ifdef USE_BATCHING\n	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif";
var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#ifdef ALPHA_TO_COVERAGE\n		float distanceToPlane, distanceGradient;\n		float clipOpacity = 1.0;\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n			distanceGradient = fwidth( distanceToPlane ) / 2.0;\n			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			if ( clipOpacity == 0.0 ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			float unionClipOpacity = 1.0;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n				distanceGradient = fwidth( distanceToPlane ) / 2.0;\n				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			}\n			#pragma unroll_loop_end\n			clipOpacity *= 1.0 - unionClipOpacity;\n		#endif\n		diffuseColor.a *= clipOpacity;\n		if ( diffuseColor.a == 0.0 ) discard;\n	#else\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			bool clipped = true;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n			}\n			#pragma unroll_loop_end\n			if ( clipped ) discard;\n		#endif\n	#endif\n#endif";
var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	varying vec3 vColor;\n#endif";
var color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n	vColor.xyz *= batchingColor.xyz;\n#endif";
var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n	vec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n	mat3 bm = mat3( batchingMatrix );\n	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n	transformedNormal = bm * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = bm * transformedTangent;\n	#endif\n#endif\n#ifdef USE_INSTANCING\n	mat3 im = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n	transformedNormal = im * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = im * transformedTangent;\n	#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n		emissiveColor = sRGBTransferEOTF( emissiveColor );\n	#endif\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform mat3 envMapRotation;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if ( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n	material.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	if( material.anisotropy == 0.0 ) {\n		anisotropyV = vec2( 1.0, 0.0 );\n	} else {\n		anisotropyV /= material.anisotropy;\n		material.anisotropy = saturate( material.anisotropy );\n	}\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	float dispersion;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	vFragDepth = 1.0 + gl_Position.w;\n	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
var map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n	float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n	}\n#endif";
var morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	#ifndef USE_INSTANCING_MORPH\n		uniform float morphTargetBaseInfluence;\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	#endif\n	uniform sampler2DArray morphTargetsTexture;\n	uniform ivec2 morphTargetsTextureSize;\n	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n		int y = texelIndex / morphTargetsTextureSize.x;\n		int x = texelIndex - y * morphTargetsTextureSize.x;\n		ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n		return texelFetch( morphTargetsTexture, morphUV, 0 );\n	}\n#endif";
var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n	if( v <= 0.0 )\n		return vec4( 0., 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec4( 1., 1., 1., 1. );\n	float vuf;\n	float af = modf( v * PackFactors.a, vuf );\n	float bf = modf( vuf * ShiftRight8, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n	if( v <= 0.0 )\n		return vec3( 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec3( 1., 1., 1. );\n	float vuf;\n	float bf = modf( v * PackFactors.b, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n	if( v <= 0.0 )\n		return vec2( 0., 0. );\n	if( v >= 1.0 )\n		return vec2( 1., 1. );\n	float vuf;\n	float gf = modf( v * 256., vuf );\n	return vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n	return dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n	mvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		\n		float lightToPositionLength = length( lightToPosition );\n		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;\n			vec3 bd3D = normalize( lightToPosition );\n			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n				shadow = (\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n				) * ( 1.0 / 9.0 );\n			#else\n				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n			#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n#endif";
var shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	mat4 getBoneMatrix( const in float i ) {\n		int size = textureSize( boneTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n#endif";
var skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n	vec3( 1.6605, - 0.1246, - 0.0182 ),\n	vec3( - 0.5876, 1.1329, - 0.1006 ),\n	vec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n	vec3( 0.6274, 0.0691, 0.0164 ),\n	vec3( 0.3293, 0.9195, 0.0880 ),\n	vec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n	vec3 x2 = x * x;\n	vec3 x4 = x2 * x2;\n	return + 15.5 * x4 * x2\n		- 40.14 * x4 * x\n		+ 31.96 * x4\n		- 6.868 * x2 * x\n		+ 0.4298 * x2\n		+ 0.1191 * x\n		- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n	const mat3 AgXInsetMatrix = mat3(\n		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n	);\n	const mat3 AgXOutsetMatrix = mat3(\n		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n	);\n	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;\n	color *= toneMappingExposure;\n	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n	color = AgXInsetMatrix * color;\n	color = max( color, 1e-10 );	color = log2( color );\n	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n	color = clamp( color, 0.0, 1.0 );\n	color = agxDefaultContrastApprox( color );\n	color = AgXOutsetMatrix * color;\n	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n	color = clamp( color, 0.0, 1.0 );\n	return color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n	const float StartCompression = 0.8 - 0.04;\n	const float Desaturation = 0.15;\n	color *= toneMappingExposure;\n	float x = min( color.r, min( color.g, color.b ) );\n	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n	color -= offset;\n	float peak = max( color.r, max( color.g, color.b ) );\n	if ( peak < StartCompression ) return color;\n	float d = 1. - StartCompression;\n	float newPeak = 1. - d * d / ( peak + d - StartCompression );\n	color *= newPeak / peak;\n	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n	return mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec4 transmittedLight;\n		vec3 transmittance;\n		#ifdef USE_DISPERSION\n			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n			for ( int i = 0; i < 3; i ++ ) {\n				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n				vec3 refractedRayExit = position + transmissionRay;\n				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n				vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n				refractionCoords += 1.0;\n				refractionCoords /= 2.0;\n				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n				transmittedLight[ i ] = transmissionSample[ i ];\n				transmittedLight.a += transmissionSample.a;\n				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n			}\n			transmittedLight.a /= 3.0;\n		#else\n			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n			vec3 refractedRayExit = position + transmissionRay;\n			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n			vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n			refractionCoords += 1.0;\n			refractionCoords /= 2.0;\n			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		#endif\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
var uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_BATCHING\n		worldPosition = batchingMatrix * worldPosition;\n	#endif\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#elif DEPTH_PACKING == 3202\n		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n	#elif DEPTH_PACKING == 3203\n		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n	#endif\n}";
const vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n	uniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix[ 3 ];\n	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const ShaderChunk = {
  alphahash_fragment,
  alphahash_pars_fragment,
  alphamap_fragment,
  alphamap_pars_fragment,
  alphatest_fragment,
  alphatest_pars_fragment,
  aomap_fragment,
  aomap_pars_fragment,
  batching_pars_vertex,
  batching_vertex,
  begin_vertex,
  beginnormal_vertex,
  bsdfs,
  iridescence_fragment,
  bumpmap_pars_fragment,
  clipping_planes_fragment,
  clipping_planes_pars_fragment,
  clipping_planes_pars_vertex,
  clipping_planes_vertex,
  color_fragment,
  color_pars_fragment,
  color_pars_vertex,
  color_vertex,
  common,
  cube_uv_reflection_fragment,
  defaultnormal_vertex,
  displacementmap_pars_vertex,
  displacementmap_vertex,
  emissivemap_fragment,
  emissivemap_pars_fragment,
  colorspace_fragment,
  colorspace_pars_fragment,
  envmap_fragment,
  envmap_common_pars_fragment,
  envmap_pars_fragment,
  envmap_pars_vertex,
  envmap_physical_pars_fragment,
  envmap_vertex,
  fog_vertex,
  fog_pars_vertex,
  fog_fragment,
  fog_pars_fragment,
  gradientmap_pars_fragment,
  lightmap_pars_fragment,
  lights_lambert_fragment,
  lights_lambert_pars_fragment,
  lights_pars_begin,
  lights_toon_fragment,
  lights_toon_pars_fragment,
  lights_phong_fragment,
  lights_phong_pars_fragment,
  lights_physical_fragment,
  lights_physical_pars_fragment,
  lights_fragment_begin,
  lights_fragment_maps,
  lights_fragment_end,
  logdepthbuf_fragment,
  logdepthbuf_pars_fragment,
  logdepthbuf_pars_vertex,
  logdepthbuf_vertex,
  map_fragment,
  map_pars_fragment,
  map_particle_fragment,
  map_particle_pars_fragment,
  metalnessmap_fragment,
  metalnessmap_pars_fragment,
  morphinstance_vertex,
  morphcolor_vertex,
  morphnormal_vertex,
  morphtarget_pars_vertex,
  morphtarget_vertex,
  normal_fragment_begin,
  normal_fragment_maps,
  normal_pars_fragment,
  normal_pars_vertex,
  normal_vertex,
  normalmap_pars_fragment,
  clearcoat_normal_fragment_begin,
  clearcoat_normal_fragment_maps,
  clearcoat_pars_fragment,
  iridescence_pars_fragment,
  opaque_fragment,
  packing,
  premultiplied_alpha_fragment,
  project_vertex,
  dithering_fragment,
  dithering_pars_fragment,
  roughnessmap_fragment,
  roughnessmap_pars_fragment,
  shadowmap_pars_fragment,
  shadowmap_pars_vertex,
  shadowmap_vertex,
  shadowmask_pars_fragment,
  skinbase_vertex,
  skinning_pars_vertex,
  skinning_vertex,
  skinnormal_vertex,
  specularmap_fragment,
  specularmap_pars_fragment,
  tonemapping_fragment,
  tonemapping_pars_fragment,
  transmission_fragment,
  transmission_pars_fragment,
  uv_pars_fragment,
  uv_pars_vertex,
  uv_vertex,
  worldpos_vertex,
  background_vert: vertex$h,
  background_frag: fragment$h,
  backgroundCube_vert: vertex$g,
  backgroundCube_frag: fragment$g,
  cube_vert: vertex$f,
  cube_frag: fragment$f,
  depth_vert: vertex$e,
  depth_frag: fragment$e,
  distanceRGBA_vert: vertex$d,
  distanceRGBA_frag: fragment$d,
  equirect_vert: vertex$c,
  equirect_frag: fragment$c,
  linedashed_vert: vertex$b,
  linedashed_frag: fragment$b,
  meshbasic_vert: vertex$a,
  meshbasic_frag: fragment$a,
  meshlambert_vert: vertex$9,
  meshlambert_frag: fragment$9,
  meshmatcap_vert: vertex$8,
  meshmatcap_frag: fragment$8,
  meshnormal_vert: vertex$7,
  meshnormal_frag: fragment$7,
  meshphong_vert: vertex$6,
  meshphong_frag: fragment$6,
  meshphysical_vert: vertex$5,
  meshphysical_frag: fragment$5,
  meshtoon_vert: vertex$4,
  meshtoon_frag: fragment$4,
  points_vert: vertex$3,
  points_frag: fragment$3,
  shadow_vert: vertex$2,
  shadow_frag: fragment$2,
  sprite_vert: vertex$1,
  sprite_frag: fragment$1
};
const UniformsLib = {
  common: {
    diffuse: { value: /* @__PURE__ */ new Color(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null },
    specularMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  envmap: {
    envMap: { value: null },
    envMapRotation: { value: /* @__PURE__ */ new Matrix3() },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 }
    // basic, lambert, phong
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 },
    aoMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 },
    lightMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    normalScale: { value: /* @__PURE__ */ new Vector2(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  emissivemap: {
    emissiveMap: { value: null },
    emissiveMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  metalnessmap: {
    metalnessMap: { value: null },
    metalnessMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  roughnessmap: {
    roughnessMap: { value: null },
    roughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new Color(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new Color(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new Matrix3() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new Color(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new Vector2(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
    alphaTest: { value: 0 }
  }
};
const ShaderLib = {
  basic: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.meshbasic_vert,
    fragmentShader: ShaderChunk.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshlambert_vert,
    fragmentShader: ShaderChunk.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) },
        specular: { value: /* @__PURE__ */ new Color(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: ShaderChunk.meshphong_vert,
    fragmentShader: ShaderChunk.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.roughnessmap,
      UniformsLib.metalnessmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.gradientmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshtoon_vert,
    fragmentShader: ShaderChunk.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: ShaderChunk.meshmatcap_vert,
    fragmentShader: ShaderChunk.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.points,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.points_vert,
    fragmentShader: ShaderChunk.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: ShaderChunk.linedashed_vert,
    fragmentShader: ShaderChunk.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap
    ]),
    vertexShader: ShaderChunk.depth_vert,
    fragmentShader: ShaderChunk.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.meshnormal_vert,
    fragmentShader: ShaderChunk.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.sprite,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.sprite_vert,
    fragmentShader: ShaderChunk.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new Matrix3() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: ShaderChunk.background_vert,
    fragmentShader: ShaderChunk.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 },
      backgroundRotation: { value: /* @__PURE__ */ new Matrix3() }
    },
    vertexShader: ShaderChunk.backgroundCube_vert,
    fragmentShader: ShaderChunk.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: ShaderChunk.cube_vert,
    fragmentShader: ShaderChunk.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: ShaderChunk.equirect_vert,
    fragmentShader: ShaderChunk.equirect_frag
  },
  distanceRGBA: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new Vector3() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: ShaderChunk.distanceRGBA_vert,
    fragmentShader: ShaderChunk.distanceRGBA_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.lights,
      UniformsLib.fog,
      {
        color: { value: /* @__PURE__ */ new Color(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.shadow_vert,
    fragmentShader: ShaderChunk.shadow_frag
  }
};
ShaderLib.physical = {
  uniforms: /* @__PURE__ */ mergeUniforms([
    ShaderLib.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new Vector2(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      dispersion: { value: 0 },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new Color(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new Vector2() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new Color(0) },
      specularColor: { value: /* @__PURE__ */ new Color(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      anisotropyVector: { value: /* @__PURE__ */ new Vector2() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new Matrix3() }
    }
  ]),
  vertexShader: ShaderChunk.meshphysical_vert,
  fragmentShader: ShaderChunk.meshphysical_frag
};
const _rgb = { r: 0, b: 0, g: 0 };
const _e1$1 = /* @__PURE__ */ new Euler();
const _m1$1 = /* @__PURE__ */ new Matrix4();
function WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
  const clearColor = new Color(0);
  let clearAlpha = alpha === true ? 0 : 1;
  let planeMesh;
  let boxMesh;
  let currentBackground = null;
  let currentBackgroundVersion = 0;
  let currentTonemapping = null;
  function getBackground(scene) {
    let background = scene.isScene === true ? scene.background : null;
    if (background && background.isTexture) {
      const usePMREM = scene.backgroundBlurriness > 0;
      background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
    }
    return background;
  }
  function render3(scene) {
    let forceClear = false;
    const background = getBackground(scene);
    if (background === null) {
      setClear(clearColor, clearAlpha);
    } else if (background && background.isColor) {
      setClear(background, 1);
      forceClear = true;
    }
    const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
    if (environmentBlendMode === "additive") {
      state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
    } else if (environmentBlendMode === "alpha-blend") {
      state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
    }
    if (renderer.autoClear || forceClear) {
      state.buffers.depth.setTest(true);
      state.buffers.depth.setMask(true);
      state.buffers.color.setMask(true);
      renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
    }
  }
  function addToRenderList(renderList, scene) {
    const background = getBackground(scene);
    if (background && (background.isCubeTexture || background.mapping === CubeUVReflectionMapping)) {
      if (boxMesh === void 0) {
        boxMesh = new Mesh(
          new BoxGeometry(1, 1, 1),
          new ShaderMaterial({
            name: "BackgroundCubeMaterial",
            uniforms: cloneUniforms(ShaderLib.backgroundCube.uniforms),
            vertexShader: ShaderLib.backgroundCube.vertexShader,
            fragmentShader: ShaderLib.backgroundCube.fragmentShader,
            side: BackSide,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        boxMesh.geometry.deleteAttribute("normal");
        boxMesh.geometry.deleteAttribute("uv");
        boxMesh.onBeforeRender = function(renderer2, scene2, camera) {
          this.matrixWorld.copyPosition(camera.matrixWorld);
        };
        Object.defineProperty(boxMesh.material, "envMap", {
          get: function() {
            return this.uniforms.envMap.value;
          }
        });
        objects.update(boxMesh);
      }
      _e1$1.copy(scene.backgroundRotation);
      _e1$1.x *= -1;
      _e1$1.y *= -1;
      _e1$1.z *= -1;
      if (background.isCubeTexture && background.isRenderTargetTexture === false) {
        _e1$1.y *= -1;
        _e1$1.z *= -1;
      }
      boxMesh.material.uniforms.envMap.value = background;
      boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
      boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
      boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
      boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4(_m1$1.makeRotationFromEuler(_e1$1));
      boxMesh.material.toneMapped = ColorManagement.getTransfer(background.colorSpace) !== SRGBTransfer;
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        boxMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      boxMesh.layers.enableAll();
      renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
    } else if (background && background.isTexture) {
      if (planeMesh === void 0) {
        planeMesh = new Mesh(
          new PlaneGeometry(2, 2),
          new ShaderMaterial({
            name: "BackgroundMaterial",
            uniforms: cloneUniforms(ShaderLib.background.uniforms),
            vertexShader: ShaderLib.background.vertexShader,
            fragmentShader: ShaderLib.background.fragmentShader,
            side: FrontSide,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        planeMesh.geometry.deleteAttribute("normal");
        Object.defineProperty(planeMesh.material, "map", {
          get: function() {
            return this.uniforms.t2D.value;
          }
        });
        objects.update(planeMesh);
      }
      planeMesh.material.uniforms.t2D.value = background;
      planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
      planeMesh.material.toneMapped = ColorManagement.getTransfer(background.colorSpace) !== SRGBTransfer;
      if (background.matrixAutoUpdate === true) {
        background.updateMatrix();
      }
      planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        planeMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      planeMesh.layers.enableAll();
      renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
    }
  }
  function setClear(color, alpha2) {
    color.getRGB(_rgb, getUnlitUniformColorSpace(renderer));
    state.buffers.color.setClear(_rgb.r, _rgb.g, _rgb.b, alpha2, premultipliedAlpha);
  }
  function dispose2() {
    if (boxMesh !== void 0) {
      boxMesh.geometry.dispose();
      boxMesh.material.dispose();
      boxMesh = void 0;
    }
    if (planeMesh !== void 0) {
      planeMesh.geometry.dispose();
      planeMesh.material.dispose();
      planeMesh = void 0;
    }
  }
  return {
    getClearColor: function() {
      return clearColor;
    },
    setClearColor: function(color, alpha2 = 1) {
      clearColor.set(color);
      clearAlpha = alpha2;
      setClear(clearColor, clearAlpha);
    },
    getClearAlpha: function() {
      return clearAlpha;
    },
    setClearAlpha: function(alpha2) {
      clearAlpha = alpha2;
      setClear(clearColor, clearAlpha);
    },
    render: render3,
    addToRenderList,
    dispose: dispose2
  };
}
function WebGLBindingStates(gl, attributes) {
  const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
  const bindingStates = {};
  const defaultState = createBindingState(null);
  let currentState = defaultState;
  let forceUpdate = false;
  function setup(object, material, program, geometry, index) {
    let updateBuffers = false;
    const state = getBindingState(geometry, program, material);
    if (currentState !== state) {
      currentState = state;
      bindVertexArrayObject(currentState.object);
    }
    updateBuffers = needsUpdate(object, geometry, program, index);
    if (updateBuffers) saveCache(object, geometry, program, index);
    if (index !== null) {
      attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
    }
    if (updateBuffers || forceUpdate) {
      forceUpdate = false;
      setupVertexAttributes(object, material, program, geometry);
      if (index !== null) {
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
      }
    }
  }
  function createVertexArrayObject() {
    return gl.createVertexArray();
  }
  function bindVertexArrayObject(vao) {
    return gl.bindVertexArray(vao);
  }
  function deleteVertexArrayObject(vao) {
    return gl.deleteVertexArray(vao);
  }
  function getBindingState(geometry, program, material) {
    const wireframe = material.wireframe === true;
    let programMap = bindingStates[geometry.id];
    if (programMap === void 0) {
      programMap = {};
      bindingStates[geometry.id] = programMap;
    }
    let stateMap = programMap[program.id];
    if (stateMap === void 0) {
      stateMap = {};
      programMap[program.id] = stateMap;
    }
    let state = stateMap[wireframe];
    if (state === void 0) {
      state = createBindingState(createVertexArrayObject());
      stateMap[wireframe] = state;
    }
    return state;
  }
  function createBindingState(vao) {
    const newAttributes = [];
    const enabledAttributes = [];
    const attributeDivisors = [];
    for (let i2 = 0; i2 < maxVertexAttributes; i2++) {
      newAttributes[i2] = 0;
      enabledAttributes[i2] = 0;
      attributeDivisors[i2] = 0;
    }
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: false,
      newAttributes,
      enabledAttributes,
      attributeDivisors,
      object: vao,
      attributes: {},
      index: null
    };
  }
  function needsUpdate(object, geometry, program, index) {
    const cachedAttributes = currentState.attributes;
    const geometryAttributes = geometry.attributes;
    let attributesNum = 0;
    const programAttributes = program.getAttributes();
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        const cachedAttribute = cachedAttributes[name];
        let geometryAttribute = geometryAttributes[name];
        if (geometryAttribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
        }
        if (cachedAttribute === void 0) return true;
        if (cachedAttribute.attribute !== geometryAttribute) return true;
        if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
        attributesNum++;
      }
    }
    if (currentState.attributesNum !== attributesNum) return true;
    if (currentState.index !== index) return true;
    return false;
  }
  function saveCache(object, geometry, program, index) {
    const cache = {};
    const attributes2 = geometry.attributes;
    let attributesNum = 0;
    const programAttributes = program.getAttributes();
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        let attribute = attributes2[name];
        if (attribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
        }
        const data = {};
        data.attribute = attribute;
        if (attribute && attribute.data) {
          data.data = attribute.data;
        }
        cache[name] = data;
        attributesNum++;
      }
    }
    currentState.attributes = cache;
    currentState.attributesNum = attributesNum;
    currentState.index = index;
  }
  function initAttributes() {
    const newAttributes = currentState.newAttributes;
    for (let i2 = 0, il = newAttributes.length; i2 < il; i2++) {
      newAttributes[i2] = 0;
    }
  }
  function enableAttribute(attribute) {
    enableAttributeAndDivisor(attribute, 0);
  }
  function enableAttributeAndDivisor(attribute, meshPerAttribute) {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    const attributeDivisors = currentState.attributeDivisors;
    newAttributes[attribute] = 1;
    if (enabledAttributes[attribute] === 0) {
      gl.enableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 1;
    }
    if (attributeDivisors[attribute] !== meshPerAttribute) {
      gl.vertexAttribDivisor(attribute, meshPerAttribute);
      attributeDivisors[attribute] = meshPerAttribute;
    }
  }
  function disableUnusedAttributes() {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    for (let i2 = 0, il = enabledAttributes.length; i2 < il; i2++) {
      if (enabledAttributes[i2] !== newAttributes[i2]) {
        gl.disableVertexAttribArray(i2);
        enabledAttributes[i2] = 0;
      }
    }
  }
  function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
    if (integer === true) {
      gl.vertexAttribIPointer(index, size, type, stride, offset);
    } else {
      gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
  }
  function setupVertexAttributes(object, material, program, geometry) {
    initAttributes();
    const geometryAttributes = geometry.attributes;
    const programAttributes = program.getAttributes();
    const materialDefaultAttributeValues = material.defaultAttributeValues;
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        let geometryAttribute = geometryAttributes[name];
        if (geometryAttribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
        }
        if (geometryAttribute !== void 0) {
          const normalized = geometryAttribute.normalized;
          const size = geometryAttribute.itemSize;
          const attribute = attributes.get(geometryAttribute);
          if (attribute === void 0) continue;
          const buffer = attribute.buffer;
          const type = attribute.type;
          const bytesPerElement = attribute.bytesPerElement;
          const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === IntType;
          if (geometryAttribute.isInterleavedBufferAttribute) {
            const data = geometryAttribute.data;
            const stride = data.stride;
            const offset = geometryAttribute.offset;
            if (data.isInstancedInterleavedBuffer) {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttributeAndDivisor(programAttribute.location + i2, data.meshPerAttribute);
              }
              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = data.meshPerAttribute * data.count;
              }
            } else {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttribute(programAttribute.location + i2);
              }
            }
            gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
            for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
              vertexAttribPointer(
                programAttribute.location + i2,
                size / programAttribute.locationSize,
                type,
                normalized,
                stride * bytesPerElement,
                (offset + size / programAttribute.locationSize * i2) * bytesPerElement,
                integer
              );
            }
          } else {
            if (geometryAttribute.isInstancedBufferAttribute) {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttributeAndDivisor(programAttribute.location + i2, geometryAttribute.meshPerAttribute);
              }
              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
              }
            } else {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttribute(programAttribute.location + i2);
              }
            }
            gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
            for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
              vertexAttribPointer(
                programAttribute.location + i2,
                size / programAttribute.locationSize,
                type,
                normalized,
                size * bytesPerElement,
                size / programAttribute.locationSize * i2 * bytesPerElement,
                integer
              );
            }
          }
        } else if (materialDefaultAttributeValues !== void 0) {
          const value = materialDefaultAttributeValues[name];
          if (value !== void 0) {
            switch (value.length) {
              case 2:
                gl.vertexAttrib2fv(programAttribute.location, value);
                break;
              case 3:
                gl.vertexAttrib3fv(programAttribute.location, value);
                break;
              case 4:
                gl.vertexAttrib4fv(programAttribute.location, value);
                break;
              default:
                gl.vertexAttrib1fv(programAttribute.location, value);
            }
          }
        }
      }
    }
    disableUnusedAttributes();
  }
  function dispose2() {
    reset();
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      for (const programId in programMap) {
        const stateMap = programMap[programId];
        for (const wireframe in stateMap) {
          deleteVertexArrayObject(stateMap[wireframe].object);
          delete stateMap[wireframe];
        }
        delete programMap[programId];
      }
      delete bindingStates[geometryId];
    }
  }
  function releaseStatesOfGeometry(geometry) {
    if (bindingStates[geometry.id] === void 0) return;
    const programMap = bindingStates[geometry.id];
    for (const programId in programMap) {
      const stateMap = programMap[programId];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[programId];
    }
    delete bindingStates[geometry.id];
  }
  function releaseStatesOfProgram(program) {
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      if (programMap[program.id] === void 0) continue;
      const stateMap = programMap[program.id];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[program.id];
    }
  }
  function reset() {
    resetDefaultState();
    forceUpdate = true;
    if (currentState === defaultState) return;
    currentState = defaultState;
    bindVertexArrayObject(currentState.object);
  }
  function resetDefaultState() {
    defaultState.geometry = null;
    defaultState.program = null;
    defaultState.wireframe = false;
  }
  return {
    setup,
    reset,
    resetDefaultState,
    dispose: dispose2,
    releaseStatesOfGeometry,
    releaseStatesOfProgram,
    initAttributes,
    enableAttribute,
    disableUnusedAttributes
  };
}
function WebGLBufferRenderer(gl, extensions2, info) {
  let mode;
  function setMode(value) {
    mode = value;
  }
  function render3(start2, count) {
    gl.drawArrays(mode, start2, count);
    info.update(count, mode, 1);
  }
  function renderInstances(start2, count, primcount) {
    if (primcount === 0) return;
    gl.drawArraysInstanced(mode, start2, count, primcount);
    info.update(count, mode, primcount);
  }
  function renderMultiDraw(starts, counts, drawCount) {
    if (drawCount === 0) return;
    const extension = extensions2.get("WEBGL_multi_draw");
    extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
    let elementCount = 0;
    for (let i2 = 0; i2 < drawCount; i2++) {
      elementCount += counts[i2];
    }
    info.update(elementCount, mode, 1);
  }
  function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
    if (drawCount === 0) return;
    const extension = extensions2.get("WEBGL_multi_draw");
    if (extension === null) {
      for (let i2 = 0; i2 < starts.length; i2++) {
        renderInstances(starts[i2], counts[i2], primcount[i2]);
      }
    } else {
      extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
      let elementCount = 0;
      for (let i2 = 0; i2 < drawCount; i2++) {
        elementCount += counts[i2] * primcount[i2];
      }
      info.update(elementCount, mode, 1);
    }
  }
  this.setMode = setMode;
  this.render = render3;
  this.renderInstances = renderInstances;
  this.renderMultiDraw = renderMultiDraw;
  this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function WebGLCapabilities(gl, extensions2, parameters, utils) {
  let maxAnisotropy;
  function getMaxAnisotropy() {
    if (maxAnisotropy !== void 0) return maxAnisotropy;
    if (extensions2.has("EXT_texture_filter_anisotropic") === true) {
      const extension = extensions2.get("EXT_texture_filter_anisotropic");
      maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else {
      maxAnisotropy = 0;
    }
    return maxAnisotropy;
  }
  function textureFormatReadable(textureFormat) {
    if (textureFormat !== RGBAFormat && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
      return false;
    }
    return true;
  }
  function textureTypeReadable(textureType) {
    const halfFloatSupportedByExt = textureType === HalfFloatType && (extensions2.has("EXT_color_buffer_half_float") || extensions2.has("EXT_color_buffer_float"));
    if (textureType !== UnsignedByteType && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
    textureType !== FloatType && !halfFloatSupportedByExt) {
      return false;
    }
    return true;
  }
  function getMaxPrecision(precision2) {
    if (precision2 === "highp") {
      if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) {
        return "highp";
      }
      precision2 = "mediump";
    }
    if (precision2 === "mediump") {
      if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) {
        return "mediump";
      }
    }
    return "lowp";
  }
  let precision = parameters.precision !== void 0 ? parameters.precision : "highp";
  const maxPrecision = getMaxPrecision(precision);
  if (maxPrecision !== precision) {
    console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
    precision = maxPrecision;
  }
  const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
  const reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions2.has("EXT_clip_control");
  const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
  const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
  const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
  const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
  const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
  const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
  const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
  const vertexTextures = maxVertexTextures > 0;
  const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
  return {
    isWebGL2: true,
    // keeping this for backwards compatibility
    getMaxAnisotropy,
    getMaxPrecision,
    textureFormatReadable,
    textureTypeReadable,
    precision,
    logarithmicDepthBuffer,
    reverseDepthBuffer,
    maxTextures,
    maxVertexTextures,
    maxTextureSize,
    maxCubemapSize,
    maxAttributes,
    maxVertexUniforms,
    maxVaryings,
    maxFragmentUniforms,
    vertexTextures,
    maxSamples
  };
}
function WebGLClipping(properties) {
  const scope = this;
  let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
  const plane = new Plane(), viewNormalMatrix = new Matrix3(), uniform = { value: null, needsUpdate: false };
  this.uniform = uniform;
  this.numPlanes = 0;
  this.numIntersection = 0;
  this.init = function(planes, enableLocalClipping) {
    const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    numGlobalPlanes !== 0 || localClippingEnabled;
    localClippingEnabled = enableLocalClipping;
    numGlobalPlanes = planes.length;
    return enabled;
  };
  this.beginShadows = function() {
    renderingShadows = true;
    projectPlanes(null);
  };
  this.endShadows = function() {
    renderingShadows = false;
  };
  this.setGlobalState = function(planes, camera) {
    globalState = projectPlanes(planes, camera, 0);
  };
  this.setState = function(material, camera, useCache) {
    const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
    const materialProperties = properties.get(material);
    if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
      if (renderingShadows) {
        projectPlanes(null);
      } else {
        resetGlobalState();
      }
    } else {
      const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
      let dstArray = materialProperties.clippingState || null;
      uniform.value = dstArray;
      dstArray = projectPlanes(planes, camera, lGlobal, useCache);
      for (let i2 = 0; i2 !== lGlobal; ++i2) {
        dstArray[i2] = globalState[i2];
      }
      materialProperties.clippingState = dstArray;
      this.numIntersection = clipIntersection ? this.numPlanes : 0;
      this.numPlanes += nGlobal;
    }
  };
  function resetGlobalState() {
    if (uniform.value !== globalState) {
      uniform.value = globalState;
      uniform.needsUpdate = numGlobalPlanes > 0;
    }
    scope.numPlanes = numGlobalPlanes;
    scope.numIntersection = 0;
  }
  function projectPlanes(planes, camera, dstOffset, skipTransform) {
    const nPlanes = planes !== null ? planes.length : 0;
    let dstArray = null;
    if (nPlanes !== 0) {
      dstArray = uniform.value;
      if (skipTransform !== true || dstArray === null) {
        const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
        viewNormalMatrix.getNormalMatrix(viewMatrix);
        if (dstArray === null || dstArray.length < flatSize) {
          dstArray = new Float32Array(flatSize);
        }
        for (let i2 = 0, i4 = dstOffset; i2 !== nPlanes; ++i2, i4 += 4) {
          plane.copy(planes[i2]).applyMatrix4(viewMatrix, viewNormalMatrix);
          plane.normal.toArray(dstArray, i4);
          dstArray[i4 + 3] = plane.constant;
        }
      }
      uniform.value = dstArray;
      uniform.needsUpdate = true;
    }
    scope.numPlanes = nPlanes;
    scope.numIntersection = 0;
    return dstArray;
  }
}
function WebGLCubeMaps(renderer) {
  let cubemaps = /* @__PURE__ */ new WeakMap();
  function mapTextureMapping(texture, mapping) {
    if (mapping === EquirectangularReflectionMapping) {
      texture.mapping = CubeReflectionMapping;
    } else if (mapping === EquirectangularRefractionMapping) {
      texture.mapping = CubeRefractionMapping;
    }
    return texture;
  }
  function get(texture) {
    if (texture && texture.isTexture) {
      const mapping = texture.mapping;
      if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {
        if (cubemaps.has(texture)) {
          const cubemap = cubemaps.get(texture).texture;
          return mapTextureMapping(cubemap, texture.mapping);
        } else {
          const image = texture.image;
          if (image && image.height > 0) {
            const renderTarget = new WebGLCubeRenderTarget(image.height);
            renderTarget.fromEquirectangularTexture(renderer, texture);
            cubemaps.set(texture, renderTarget);
            texture.addEventListener("dispose", onTextureDispose);
            return mapTextureMapping(renderTarget.texture, texture.mapping);
          } else {
            return null;
          }
        }
      }
    }
    return texture;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemap = cubemaps.get(texture);
    if (cubemap !== void 0) {
      cubemaps.delete(texture);
      cubemap.dispose();
    }
  }
  function dispose2() {
    cubemaps = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose: dispose2
  };
}
const LOD_MIN = 4;
const EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582];
const MAX_SAMPLES = 20;
const _flatCamera = /* @__PURE__ */ new OrthographicCamera();
const _clearColor = /* @__PURE__ */ new Color();
let _oldTarget = null;
let _oldActiveCubeFace = 0;
let _oldActiveMipmapLevel = 0;
let _oldXrEnabled = false;
const PHI = (1 + Math.sqrt(5)) / 2;
const INV_PHI = 1 / PHI;
const _axisDirections = [
  /* @__PURE__ */ new Vector3(-PHI, INV_PHI, 0),
  /* @__PURE__ */ new Vector3(PHI, INV_PHI, 0),
  /* @__PURE__ */ new Vector3(-INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector3(INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector3(0, PHI, -INV_PHI),
  /* @__PURE__ */ new Vector3(0, PHI, INV_PHI),
  /* @__PURE__ */ new Vector3(-1, 1, -1),
  /* @__PURE__ */ new Vector3(1, 1, -1),
  /* @__PURE__ */ new Vector3(-1, 1, 1),
  /* @__PURE__ */ new Vector3(1, 1, 1)
];
class PMREMGenerator {
  constructor(renderer) {
    this._renderer = renderer;
    this._pingPongRenderTarget = null;
    this._lodMax = 0;
    this._cubeSize = 0;
    this._lodPlanes = [];
    this._sizeLods = [];
    this._sigmas = [];
    this._blurMaterial = null;
    this._cubemapMaterial = null;
    this._equirectMaterial = null;
    this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   *
   * @param {Scene} scene
   * @param {number} sigma
   * @param {number} near
   * @param {number} far
   * @return {WebGLRenderTarget}
   */
  fromScene(scene, sigma = 0, near = 0.1, far = 100) {
    _oldTarget = this._renderer.getRenderTarget();
    _oldActiveCubeFace = this._renderer.getActiveCubeFace();
    _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
    _oldXrEnabled = this._renderer.xr.enabled;
    this._renderer.xr.enabled = false;
    this._setSize(256);
    const cubeUVRenderTarget = this._allocateTargets();
    cubeUVRenderTarget.depthBuffer = true;
    this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
    if (sigma > 0) {
      this._blur(cubeUVRenderTarget, 0, 0, sigma);
    }
    this._applyPMREM(cubeUVRenderTarget);
    this._cleanup(cubeUVRenderTarget);
    return cubeUVRenderTarget;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   * The smallest supported equirectangular image size is 64 x 32.
   *
   * @param {Texture} equirectangular
   * @param {WebGLRenderTarget} [renderTarget=null] - Optional render target.
   * @return {WebGLRenderTarget}
   */
  fromEquirectangular(equirectangular, renderTarget = null) {
    return this._fromTexture(equirectangular, renderTarget);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   * The smallest supported cube size is 16 x 16.
   *
   * @param {Texture} cubemap
   * @param {null} [renderTarget=null] - Optional render target.
   * @return {WebGLRenderTarget}
   */
  fromCubemap(cubemap, renderTarget = null) {
    return this._fromTexture(cubemap, renderTarget);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    if (this._cubemapMaterial === null) {
      this._cubemapMaterial = _getCubemapMaterial();
      this._compileMaterial(this._cubemapMaterial);
    }
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    if (this._equirectMaterial === null) {
      this._equirectMaterial = _getEquirectMaterial();
      this._compileMaterial(this._equirectMaterial);
    }
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose();
    if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
    if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
  }
  // private interface
  _setSize(cubeSize) {
    this._lodMax = Math.floor(Math.log2(cubeSize));
    this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    if (this._blurMaterial !== null) this._blurMaterial.dispose();
    if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
    for (let i2 = 0; i2 < this._lodPlanes.length; i2++) {
      this._lodPlanes[i2].dispose();
    }
  }
  _cleanup(outputTarget) {
    this._renderer.setRenderTarget(_oldTarget, _oldActiveCubeFace, _oldActiveMipmapLevel);
    this._renderer.xr.enabled = _oldXrEnabled;
    outputTarget.scissorTest = false;
    _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
  }
  _fromTexture(texture, renderTarget) {
    if (texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping) {
      this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
    } else {
      this._setSize(texture.image.width / 4);
    }
    _oldTarget = this._renderer.getRenderTarget();
    _oldActiveCubeFace = this._renderer.getActiveCubeFace();
    _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
    _oldXrEnabled = this._renderer.xr.enabled;
    this._renderer.xr.enabled = false;
    const cubeUVRenderTarget = renderTarget || this._allocateTargets();
    this._textureToCubeUV(texture, cubeUVRenderTarget);
    this._applyPMREM(cubeUVRenderTarget);
    this._cleanup(cubeUVRenderTarget);
    return cubeUVRenderTarget;
  }
  _allocateTargets() {
    const width = 3 * Math.max(this._cubeSize, 16 * 7);
    const height = 4 * this._cubeSize;
    const params = {
      magFilter: LinearFilter,
      minFilter: LinearFilter,
      generateMipmaps: false,
      type: HalfFloatType,
      format: RGBAFormat,
      colorSpace: LinearSRGBColorSpace$1,
      depthBuffer: false
    };
    const cubeUVRenderTarget = _createRenderTarget(width, height, params);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
      if (this._pingPongRenderTarget !== null) {
        this._dispose();
      }
      this._pingPongRenderTarget = _createRenderTarget(width, height, params);
      const { _lodMax } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes(_lodMax));
      this._blurMaterial = _getBlurShader(_lodMax, width, height);
    }
    return cubeUVRenderTarget;
  }
  _compileMaterial(material) {
    const tmpMesh = new Mesh(this._lodPlanes[0], material);
    this._renderer.compile(tmpMesh, _flatCamera);
  }
  _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
    const fov2 = 90;
    const aspect2 = 1;
    const cubeCamera = new PerspectiveCamera(fov2, aspect2, near, far);
    const upSign = [1, -1, 1, 1, 1, 1];
    const forwardSign = [1, 1, 1, -1, -1, -1];
    const renderer = this._renderer;
    const originalAutoClear = renderer.autoClear;
    const toneMapping = renderer.toneMapping;
    renderer.getClearColor(_clearColor);
    renderer.toneMapping = NoToneMapping;
    renderer.autoClear = false;
    const backgroundMaterial = new MeshBasicMaterial({
      name: "PMREM.Background",
      side: BackSide,
      depthWrite: false,
      depthTest: false
    });
    const backgroundBox = new Mesh(new BoxGeometry(), backgroundMaterial);
    let useSolidColor = false;
    const background = scene.background;
    if (background) {
      if (background.isColor) {
        backgroundMaterial.color.copy(background);
        scene.background = null;
        useSolidColor = true;
      }
    } else {
      backgroundMaterial.color.copy(_clearColor);
      useSolidColor = true;
    }
    for (let i2 = 0; i2 < 6; i2++) {
      const col2 = i2 % 3;
      if (col2 === 0) {
        cubeCamera.up.set(0, upSign[i2], 0);
        cubeCamera.lookAt(forwardSign[i2], 0, 0);
      } else if (col2 === 1) {
        cubeCamera.up.set(0, 0, upSign[i2]);
        cubeCamera.lookAt(0, forwardSign[i2], 0);
      } else {
        cubeCamera.up.set(0, upSign[i2], 0);
        cubeCamera.lookAt(0, 0, forwardSign[i2]);
      }
      const size = this._cubeSize;
      _setViewport(cubeUVRenderTarget, col2 * size, i2 > 2 ? size : 0, size, size);
      renderer.setRenderTarget(cubeUVRenderTarget);
      if (useSolidColor) {
        renderer.render(backgroundBox, cubeCamera);
      }
      renderer.render(scene, cubeCamera);
    }
    backgroundBox.geometry.dispose();
    backgroundBox.material.dispose();
    renderer.toneMapping = toneMapping;
    renderer.autoClear = originalAutoClear;
    scene.background = background;
  }
  _textureToCubeUV(texture, cubeUVRenderTarget) {
    const renderer = this._renderer;
    const isCubeTexture2 = texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping;
    if (isCubeTexture2) {
      if (this._cubemapMaterial === null) {
        this._cubemapMaterial = _getCubemapMaterial();
      }
      this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
    } else {
      if (this._equirectMaterial === null) {
        this._equirectMaterial = _getEquirectMaterial();
      }
    }
    const material = isCubeTexture2 ? this._cubemapMaterial : this._equirectMaterial;
    const mesh = new Mesh(this._lodPlanes[0], material);
    const uniforms = material.uniforms;
    uniforms["envMap"].value = texture;
    const size = this._cubeSize;
    _setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
    renderer.setRenderTarget(cubeUVRenderTarget);
    renderer.render(mesh, _flatCamera);
  }
  _applyPMREM(cubeUVRenderTarget) {
    const renderer = this._renderer;
    const autoClear = renderer.autoClear;
    renderer.autoClear = false;
    const n2 = this._lodPlanes.length;
    for (let i2 = 1; i2 < n2; i2++) {
      const sigma = Math.sqrt(this._sigmas[i2] * this._sigmas[i2] - this._sigmas[i2 - 1] * this._sigmas[i2 - 1]);
      const poleAxis = _axisDirections[(n2 - i2 - 1) % _axisDirections.length];
      this._blur(cubeUVRenderTarget, i2 - 1, i2, sigma, poleAxis);
    }
    renderer.autoClear = autoClear;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   *
   * @param {WebGLRenderTarget} cubeUVRenderTarget
   * @param {number} lodIn
   * @param {number} lodOut
   * @param {number} sigma
   * @param {Vector3} [poleAxis]
   */
  _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
    const pingPongRenderTarget = this._pingPongRenderTarget;
    this._halfBlur(
      cubeUVRenderTarget,
      pingPongRenderTarget,
      lodIn,
      lodOut,
      sigma,
      "latitudinal",
      poleAxis
    );
    this._halfBlur(
      pingPongRenderTarget,
      cubeUVRenderTarget,
      lodOut,
      lodOut,
      sigma,
      "longitudinal",
      poleAxis
    );
  }
  _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
    const renderer = this._renderer;
    const blurMaterial = this._blurMaterial;
    if (direction !== "latitudinal" && direction !== "longitudinal") {
      console.error(
        "blur direction must be either latitudinal or longitudinal!"
      );
    }
    const STANDARD_DEVIATIONS = 3;
    const blurMesh = new Mesh(this._lodPlanes[lodOut], blurMaterial);
    const blurUniforms = blurMaterial.uniforms;
    const pixels = this._sizeLods[lodIn] - 1;
    const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
    const sigmaPixels = sigmaRadians / radiansPerPixel;
    const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;
    if (samples > MAX_SAMPLES) {
      console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${MAX_SAMPLES}`);
    }
    const weights = [];
    let sum = 0;
    for (let i2 = 0; i2 < MAX_SAMPLES; ++i2) {
      const x4 = i2 / sigmaPixels;
      const weight = Math.exp(-x4 * x4 / 2);
      weights.push(weight);
      if (i2 === 0) {
        sum += weight;
      } else if (i2 < samples) {
        sum += 2 * weight;
      }
    }
    for (let i2 = 0; i2 < weights.length; i2++) {
      weights[i2] = weights[i2] / sum;
    }
    blurUniforms["envMap"].value = targetIn.texture;
    blurUniforms["samples"].value = samples;
    blurUniforms["weights"].value = weights;
    blurUniforms["latitudinal"].value = direction === "latitudinal";
    if (poleAxis) {
      blurUniforms["poleAxis"].value = poleAxis;
    }
    const { _lodMax } = this;
    blurUniforms["dTheta"].value = radiansPerPixel;
    blurUniforms["mipInt"].value = _lodMax - lodIn;
    const outputSize = this._sizeLods[lodOut];
    const x3 = 3 * outputSize * (lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0);
    const y2 = 4 * (this._cubeSize - outputSize);
    _setViewport(targetOut, x3, y2, 3 * outputSize, 2 * outputSize);
    renderer.setRenderTarget(targetOut);
    renderer.render(blurMesh, _flatCamera);
  }
}
function _createPlanes(lodMax) {
  const lodPlanes = [];
  const sizeLods = [];
  const sigmas = [];
  let lod = lodMax;
  const totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
  for (let i2 = 0; i2 < totalLods; i2++) {
    const sizeLod = Math.pow(2, lod);
    sizeLods.push(sizeLod);
    let sigma = 1 / sizeLod;
    if (i2 > lodMax - LOD_MIN) {
      sigma = EXTRA_LOD_SIGMA[i2 - lodMax + LOD_MIN - 1];
    } else if (i2 === 0) {
      sigma = 0;
    }
    sigmas.push(sigma);
    const texelSize = 1 / (sizeLod - 2);
    const min = -texelSize;
    const max2 = 1 + texelSize;
    const uv1 = [min, min, max2, min, max2, max2, min, min, max2, max2, min, max2];
    const cubeFaces = 6;
    const vertices = 6;
    const positionSize = 3;
    const uvSize = 2;
    const faceIndexSize = 1;
    const position = new Float32Array(positionSize * vertices * cubeFaces);
    const uv = new Float32Array(uvSize * vertices * cubeFaces);
    const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
    for (let face = 0; face < cubeFaces; face++) {
      const x3 = face % 3 * 2 / 3 - 1;
      const y2 = face > 2 ? 0 : -1;
      const coordinates = [
        x3,
        y2,
        0,
        x3 + 2 / 3,
        y2,
        0,
        x3 + 2 / 3,
        y2 + 1,
        0,
        x3,
        y2,
        0,
        x3 + 2 / 3,
        y2 + 1,
        0,
        x3,
        y2 + 1,
        0
      ];
      position.set(coordinates, positionSize * vertices * face);
      uv.set(uv1, uvSize * vertices * face);
      const fill2 = [face, face, face, face, face, face];
      faceIndex.set(fill2, faceIndexSize * vertices * face);
    }
    const planes = new BufferGeometry();
    planes.setAttribute("position", new BufferAttribute(position, positionSize));
    planes.setAttribute("uv", new BufferAttribute(uv, uvSize));
    planes.setAttribute("faceIndex", new BufferAttribute(faceIndex, faceIndexSize));
    lodPlanes.push(planes);
    if (lod > LOD_MIN) {
      lod--;
    }
  }
  return { lodPlanes, sizeLods, sigmas };
}
function _createRenderTarget(width, height, params) {
  const cubeUVRenderTarget = new WebGLRenderTarget(width, height, params);
  cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
  cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
  cubeUVRenderTarget.scissorTest = true;
  return cubeUVRenderTarget;
}
function _setViewport(target, x3, y2, width, height) {
  target.viewport.set(x3, y2, width, height);
  target.scissor.set(x3, y2, width, height);
}
function _getBlurShader(lodMax, width, height) {
  const weights = new Float32Array(MAX_SAMPLES);
  const poleAxis = new Vector3(0, 1, 0);
  const shaderMaterial = new ShaderMaterial({
    name: "SphericalGaussianBlur",
    defines: {
      "n": MAX_SAMPLES,
      "CUBEUV_TEXEL_WIDTH": 1 / width,
      "CUBEUV_TEXEL_HEIGHT": 1 / height,
      "CUBEUV_MAX_MIP": `${lodMax}.0`
    },
    uniforms: {
      "envMap": { value: null },
      "samples": { value: 1 },
      "weights": { value: weights },
      "latitudinal": { value: false },
      "dTheta": { value: 0 },
      "mipInt": { value: 0 },
      "poleAxis": { value: poleAxis }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
  return shaderMaterial;
}
function _getEquirectMaterial() {
  return new ShaderMaterial({
    name: "EquirectangularToCubeUV",
    uniforms: {
      "envMap": { value: null }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
}
function _getCubemapMaterial() {
  return new ShaderMaterial({
    name: "CubemapToCubeUV",
    uniforms: {
      "envMap": { value: null },
      "flipEnvMap": { value: -1 }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
}
function _getCommonVertexShader() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function WebGLCubeUVMaps(renderer) {
  let cubeUVmaps = /* @__PURE__ */ new WeakMap();
  let pmremGenerator = null;
  function get(texture) {
    if (texture && texture.isTexture) {
      const mapping = texture.mapping;
      const isEquirectMap = mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping;
      const isCubeMap = mapping === CubeReflectionMapping || mapping === CubeRefractionMapping;
      if (isEquirectMap || isCubeMap) {
        let renderTarget = cubeUVmaps.get(texture);
        const currentPMREMVersion = renderTarget !== void 0 ? renderTarget.texture.pmremVersion : 0;
        if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
          if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);
          renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
          renderTarget.texture.pmremVersion = texture.pmremVersion;
          cubeUVmaps.set(texture, renderTarget);
          return renderTarget.texture;
        } else {
          if (renderTarget !== void 0) {
            return renderTarget.texture;
          } else {
            const image = texture.image;
            if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
              if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);
              renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
              renderTarget.texture.pmremVersion = texture.pmremVersion;
              cubeUVmaps.set(texture, renderTarget);
              texture.addEventListener("dispose", onTextureDispose);
              return renderTarget.texture;
            } else {
              return null;
            }
          }
        }
      }
    }
    return texture;
  }
  function isCubeTextureComplete(image) {
    let count = 0;
    const length = 6;
    for (let i2 = 0; i2 < length; i2++) {
      if (image[i2] !== void 0) count++;
    }
    return count === length;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemapUV = cubeUVmaps.get(texture);
    if (cubemapUV !== void 0) {
      cubeUVmaps.delete(texture);
      cubemapUV.dispose();
    }
  }
  function dispose2() {
    cubeUVmaps = /* @__PURE__ */ new WeakMap();
    if (pmremGenerator !== null) {
      pmremGenerator.dispose();
      pmremGenerator = null;
    }
  }
  return {
    get,
    dispose: dispose2
  };
}
function WebGLExtensions(gl) {
  const extensions2 = {};
  function getExtension2(name) {
    if (extensions2[name] !== void 0) {
      return extensions2[name];
    }
    let extension;
    switch (name) {
      case "WEBGL_depth_texture":
        extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        extension = gl.getExtension(name);
    }
    extensions2[name] = extension;
    return extension;
  }
  return {
    has: function(name) {
      return getExtension2(name) !== null;
    },
    init: function() {
      getExtension2("EXT_color_buffer_float");
      getExtension2("WEBGL_clip_cull_distance");
      getExtension2("OES_texture_float_linear");
      getExtension2("EXT_color_buffer_half_float");
      getExtension2("WEBGL_multisampled_render_to_texture");
      getExtension2("WEBGL_render_shared_exponent");
    },
    get: function(name) {
      const extension = getExtension2(name);
      if (extension === null) {
        warnOnce("THREE.WebGLRenderer: " + name + " extension not supported.");
      }
      return extension;
    }
  };
}
function WebGLGeometries(gl, attributes, info, bindingStates) {
  const geometries = {};
  const wireframeAttributes = /* @__PURE__ */ new WeakMap();
  function onGeometryDispose(event) {
    const geometry = event.target;
    if (geometry.index !== null) {
      attributes.remove(geometry.index);
    }
    for (const name in geometry.attributes) {
      attributes.remove(geometry.attributes[name]);
    }
    geometry.removeEventListener("dispose", onGeometryDispose);
    delete geometries[geometry.id];
    const attribute = wireframeAttributes.get(geometry);
    if (attribute) {
      attributes.remove(attribute);
      wireframeAttributes.delete(geometry);
    }
    bindingStates.releaseStatesOfGeometry(geometry);
    if (geometry.isInstancedBufferGeometry === true) {
      delete geometry._maxInstanceCount;
    }
    info.memory.geometries--;
  }
  function get(object, geometry) {
    if (geometries[geometry.id] === true) return geometry;
    geometry.addEventListener("dispose", onGeometryDispose);
    geometries[geometry.id] = true;
    info.memory.geometries++;
    return geometry;
  }
  function update2(geometry) {
    const geometryAttributes = geometry.attributes;
    for (const name in geometryAttributes) {
      attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
  }
  function updateWireframeAttribute(geometry) {
    const indices = [];
    const geometryIndex = geometry.index;
    const geometryPosition = geometry.attributes.position;
    let version2 = 0;
    if (geometryIndex !== null) {
      const array = geometryIndex.array;
      version2 = geometryIndex.version;
      for (let i2 = 0, l2 = array.length; i2 < l2; i2 += 3) {
        const a5 = array[i2 + 0];
        const b6 = array[i2 + 1];
        const c2 = array[i2 + 2];
        indices.push(a5, b6, b6, c2, c2, a5);
      }
    } else if (geometryPosition !== void 0) {
      const array = geometryPosition.array;
      version2 = geometryPosition.version;
      for (let i2 = 0, l2 = array.length / 3 - 1; i2 < l2; i2 += 3) {
        const a5 = i2 + 0;
        const b6 = i2 + 1;
        const c2 = i2 + 2;
        indices.push(a5, b6, b6, c2, c2, a5);
      }
    } else {
      return;
    }
    const attribute = new (arrayNeedsUint32(indices) ? Uint32BufferAttribute : Uint16BufferAttribute)(indices, 1);
    attribute.version = version2;
    const previousAttribute = wireframeAttributes.get(geometry);
    if (previousAttribute) attributes.remove(previousAttribute);
    wireframeAttributes.set(geometry, attribute);
  }
  function getWireframeAttribute(geometry) {
    const currentAttribute = wireframeAttributes.get(geometry);
    if (currentAttribute) {
      const geometryIndex = geometry.index;
      if (geometryIndex !== null) {
        if (currentAttribute.version < geometryIndex.version) {
          updateWireframeAttribute(geometry);
        }
      }
    } else {
      updateWireframeAttribute(geometry);
    }
    return wireframeAttributes.get(geometry);
  }
  return {
    get,
    update: update2,
    getWireframeAttribute
  };
}
function WebGLIndexedBufferRenderer(gl, extensions2, info) {
  let mode;
  function setMode(value) {
    mode = value;
  }
  let type, bytesPerElement;
  function setIndex(value) {
    type = value.type;
    bytesPerElement = value.bytesPerElement;
  }
  function render3(start2, count) {
    gl.drawElements(mode, count, type, start2 * bytesPerElement);
    info.update(count, mode, 1);
  }
  function renderInstances(start2, count, primcount) {
    if (primcount === 0) return;
    gl.drawElementsInstanced(mode, count, type, start2 * bytesPerElement, primcount);
    info.update(count, mode, primcount);
  }
  function renderMultiDraw(starts, counts, drawCount) {
    if (drawCount === 0) return;
    const extension = extensions2.get("WEBGL_multi_draw");
    extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
    let elementCount = 0;
    for (let i2 = 0; i2 < drawCount; i2++) {
      elementCount += counts[i2];
    }
    info.update(elementCount, mode, 1);
  }
  function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
    if (drawCount === 0) return;
    const extension = extensions2.get("WEBGL_multi_draw");
    if (extension === null) {
      for (let i2 = 0; i2 < starts.length; i2++) {
        renderInstances(starts[i2] / bytesPerElement, counts[i2], primcount[i2]);
      }
    } else {
      extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
      let elementCount = 0;
      for (let i2 = 0; i2 < drawCount; i2++) {
        elementCount += counts[i2] * primcount[i2];
      }
      info.update(elementCount, mode, 1);
    }
  }
  this.setMode = setMode;
  this.setIndex = setIndex;
  this.render = render3;
  this.renderInstances = renderInstances;
  this.renderMultiDraw = renderMultiDraw;
  this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function WebGLInfo(gl) {
  const memory = {
    geometries: 0,
    textures: 0
  };
  const render3 = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function update2(count, mode, instanceCount) {
    render3.calls++;
    switch (mode) {
      case gl.TRIANGLES:
        render3.triangles += instanceCount * (count / 3);
        break;
      case gl.LINES:
        render3.lines += instanceCount * (count / 2);
        break;
      case gl.LINE_STRIP:
        render3.lines += instanceCount * (count - 1);
        break;
      case gl.LINE_LOOP:
        render3.lines += instanceCount * count;
        break;
      case gl.POINTS:
        render3.points += instanceCount * count;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
        break;
    }
  }
  function reset() {
    render3.calls = 0;
    render3.triangles = 0;
    render3.points = 0;
    render3.lines = 0;
  }
  return {
    memory,
    render: render3,
    programs: null,
    autoReset: true,
    reset,
    update: update2
  };
}
function WebGLMorphtargets(gl, capabilities, textures) {
  const morphTextures = /* @__PURE__ */ new WeakMap();
  const morph = new Vector4();
  function update2(object, geometry, program) {
    const objectInfluences = object.morphTargetInfluences;
    const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
    let entry = morphTextures.get(geometry);
    if (entry === void 0 || entry.count !== morphTargetsCount) {
      let disposeTexture2 = function() {
        texture.dispose();
        morphTextures.delete(geometry);
        geometry.removeEventListener("dispose", disposeTexture2);
      };
      var disposeTexture = disposeTexture2;
      if (entry !== void 0) entry.texture.dispose();
      const hasMorphPosition = geometry.morphAttributes.position !== void 0;
      const hasMorphNormals = geometry.morphAttributes.normal !== void 0;
      const hasMorphColors = geometry.morphAttributes.color !== void 0;
      const morphTargets = geometry.morphAttributes.position || [];
      const morphNormals = geometry.morphAttributes.normal || [];
      const morphColors = geometry.morphAttributes.color || [];
      let vertexDataCount = 0;
      if (hasMorphPosition === true) vertexDataCount = 1;
      if (hasMorphNormals === true) vertexDataCount = 2;
      if (hasMorphColors === true) vertexDataCount = 3;
      let width = geometry.attributes.position.count * vertexDataCount;
      let height = 1;
      if (width > capabilities.maxTextureSize) {
        height = Math.ceil(width / capabilities.maxTextureSize);
        width = capabilities.maxTextureSize;
      }
      const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
      const texture = new DataArrayTexture(buffer, width, height, morphTargetsCount);
      texture.type = FloatType;
      texture.needsUpdate = true;
      const vertexDataStride = vertexDataCount * 4;
      for (let i2 = 0; i2 < morphTargetsCount; i2++) {
        const morphTarget = morphTargets[i2];
        const morphNormal = morphNormals[i2];
        const morphColor = morphColors[i2];
        const offset = width * height * 4 * i2;
        for (let j3 = 0; j3 < morphTarget.count; j3++) {
          const stride = j3 * vertexDataStride;
          if (hasMorphPosition === true) {
            morph.fromBufferAttribute(morphTarget, j3);
            buffer[offset + stride + 0] = morph.x;
            buffer[offset + stride + 1] = morph.y;
            buffer[offset + stride + 2] = morph.z;
            buffer[offset + stride + 3] = 0;
          }
          if (hasMorphNormals === true) {
            morph.fromBufferAttribute(morphNormal, j3);
            buffer[offset + stride + 4] = morph.x;
            buffer[offset + stride + 5] = morph.y;
            buffer[offset + stride + 6] = morph.z;
            buffer[offset + stride + 7] = 0;
          }
          if (hasMorphColors === true) {
            morph.fromBufferAttribute(morphColor, j3);
            buffer[offset + stride + 8] = morph.x;
            buffer[offset + stride + 9] = morph.y;
            buffer[offset + stride + 10] = morph.z;
            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
          }
        }
      }
      entry = {
        count: morphTargetsCount,
        texture,
        size: new Vector2(width, height)
      };
      morphTextures.set(geometry, entry);
      geometry.addEventListener("dispose", disposeTexture2);
    }
    if (object.isInstancedMesh === true && object.morphTexture !== null) {
      program.getUniforms().setValue(gl, "morphTexture", object.morphTexture, textures);
    } else {
      let morphInfluencesSum = 0;
      for (let i2 = 0; i2 < objectInfluences.length; i2++) {
        morphInfluencesSum += objectInfluences[i2];
      }
      const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
      program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
      program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
    }
    program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
    program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
  }
  return {
    update: update2
  };
}
function WebGLObjects(gl, geometries, attributes, info) {
  let updateMap = /* @__PURE__ */ new WeakMap();
  function update2(object) {
    const frame = info.render.frame;
    const geometry = object.geometry;
    const buffergeometry = geometries.get(object, geometry);
    if (updateMap.get(buffergeometry) !== frame) {
      geometries.update(buffergeometry);
      updateMap.set(buffergeometry, frame);
    }
    if (object.isInstancedMesh) {
      if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) {
        object.addEventListener("dispose", onInstancedMeshDispose);
      }
      if (updateMap.get(object) !== frame) {
        attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
        if (object.instanceColor !== null) {
          attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
        }
        updateMap.set(object, frame);
      }
    }
    if (object.isSkinnedMesh) {
      const skeleton = object.skeleton;
      if (updateMap.get(skeleton) !== frame) {
        skeleton.update();
        updateMap.set(skeleton, frame);
      }
    }
    return buffergeometry;
  }
  function dispose2() {
    updateMap = /* @__PURE__ */ new WeakMap();
  }
  function onInstancedMeshDispose(event) {
    const instancedMesh = event.target;
    instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
    attributes.remove(instancedMesh.instanceMatrix);
    if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
  }
  return {
    update: update2,
    dispose: dispose2
  };
}
const emptyTexture = /* @__PURE__ */ new Texture();
const emptyShadowTexture = /* @__PURE__ */ new DepthTexture(1, 1);
const emptyArrayTexture = /* @__PURE__ */ new DataArrayTexture();
const empty3dTexture = /* @__PURE__ */ new Data3DTexture();
const emptyCubeTexture = /* @__PURE__ */ new CubeTexture();
const arrayCacheF32 = [];
const arrayCacheI32 = [];
const mat4array = new Float32Array(16);
const mat3array = new Float32Array(9);
const mat2array = new Float32Array(4);
function flatten(array, nBlocks, blockSize) {
  const firstElem = array[0];
  if (firstElem <= 0 || firstElem > 0) return array;
  const n2 = nBlocks * blockSize;
  let r3 = arrayCacheF32[n2];
  if (r3 === void 0) {
    r3 = new Float32Array(n2);
    arrayCacheF32[n2] = r3;
  }
  if (nBlocks !== 0) {
    firstElem.toArray(r3, 0);
    for (let i2 = 1, offset = 0; i2 !== nBlocks; ++i2) {
      offset += blockSize;
      array[i2].toArray(r3, offset);
    }
  }
  return r3;
}
function arraysEqual(a5, b6) {
  if (a5.length !== b6.length) return false;
  for (let i2 = 0, l2 = a5.length; i2 < l2; i2++) {
    if (a5[i2] !== b6[i2]) return false;
  }
  return true;
}
function copyArray(a5, b6) {
  for (let i2 = 0, l2 = b6.length; i2 < l2; i2++) {
    a5[i2] = b6[i2];
  }
}
function allocTexUnits(textures, n2) {
  let r3 = arrayCacheI32[n2];
  if (r3 === void 0) {
    r3 = new Int32Array(n2);
    arrayCacheI32[n2] = r3;
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    r3[i2] = textures.allocateTextureUnit();
  }
  return r3;
}
function setValueV1f(gl, v3) {
  const cache = this.cache;
  if (cache[0] === v3) return;
  gl.uniform1f(this.addr, v3);
  cache[0] = v3;
}
function setValueV2f(gl, v3) {
  const cache = this.cache;
  if (v3.x !== void 0) {
    if (cache[0] !== v3.x || cache[1] !== v3.y) {
      gl.uniform2f(this.addr, v3.x, v3.y);
      cache[0] = v3.x;
      cache[1] = v3.y;
    }
  } else {
    if (arraysEqual(cache, v3)) return;
    gl.uniform2fv(this.addr, v3);
    copyArray(cache, v3);
  }
}
function setValueV3f(gl, v3) {
  const cache = this.cache;
  if (v3.x !== void 0) {
    if (cache[0] !== v3.x || cache[1] !== v3.y || cache[2] !== v3.z) {
      gl.uniform3f(this.addr, v3.x, v3.y, v3.z);
      cache[0] = v3.x;
      cache[1] = v3.y;
      cache[2] = v3.z;
    }
  } else if (v3.r !== void 0) {
    if (cache[0] !== v3.r || cache[1] !== v3.g || cache[2] !== v3.b) {
      gl.uniform3f(this.addr, v3.r, v3.g, v3.b);
      cache[0] = v3.r;
      cache[1] = v3.g;
      cache[2] = v3.b;
    }
  } else {
    if (arraysEqual(cache, v3)) return;
    gl.uniform3fv(this.addr, v3);
    copyArray(cache, v3);
  }
}
function setValueV4f(gl, v3) {
  const cache = this.cache;
  if (v3.x !== void 0) {
    if (cache[0] !== v3.x || cache[1] !== v3.y || cache[2] !== v3.z || cache[3] !== v3.w) {
      gl.uniform4f(this.addr, v3.x, v3.y, v3.z, v3.w);
      cache[0] = v3.x;
      cache[1] = v3.y;
      cache[2] = v3.z;
      cache[3] = v3.w;
    }
  } else {
    if (arraysEqual(cache, v3)) return;
    gl.uniform4fv(this.addr, v3);
    copyArray(cache, v3);
  }
}
function setValueM2(gl, v3) {
  const cache = this.cache;
  const elements = v3.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v3)) return;
    gl.uniformMatrix2fv(this.addr, false, v3);
    copyArray(cache, v3);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat2array.set(elements);
    gl.uniformMatrix2fv(this.addr, false, mat2array);
    copyArray(cache, elements);
  }
}
function setValueM3(gl, v3) {
  const cache = this.cache;
  const elements = v3.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v3)) return;
    gl.uniformMatrix3fv(this.addr, false, v3);
    copyArray(cache, v3);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat3array.set(elements);
    gl.uniformMatrix3fv(this.addr, false, mat3array);
    copyArray(cache, elements);
  }
}
function setValueM4(gl, v3) {
  const cache = this.cache;
  const elements = v3.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v3)) return;
    gl.uniformMatrix4fv(this.addr, false, v3);
    copyArray(cache, v3);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat4array.set(elements);
    gl.uniformMatrix4fv(this.addr, false, mat4array);
    copyArray(cache, elements);
  }
}
function setValueV1i(gl, v3) {
  const cache = this.cache;
  if (cache[0] === v3) return;
  gl.uniform1i(this.addr, v3);
  cache[0] = v3;
}
function setValueV2i(gl, v3) {
  const cache = this.cache;
  if (v3.x !== void 0) {
    if (cache[0] !== v3.x || cache[1] !== v3.y) {
      gl.uniform2i(this.addr, v3.x, v3.y);
      cache[0] = v3.x;
      cache[1] = v3.y;
    }
  } else {
    if (arraysEqual(cache, v3)) return;
    gl.uniform2iv(this.addr, v3);
    copyArray(cache, v3);
  }
}
function setValueV3i(gl, v3) {
  const cache = this.cache;
  if (v3.x !== void 0) {
    if (cache[0] !== v3.x || cache[1] !== v3.y || cache[2] !== v3.z) {
      gl.uniform3i(this.addr, v3.x, v3.y, v3.z);
      cache[0] = v3.x;
      cache[1] = v3.y;
      cache[2] = v3.z;
    }
  } else {
    if (arraysEqual(cache, v3)) return;
    gl.uniform3iv(this.addr, v3);
    copyArray(cache, v3);
  }
}
function setValueV4i(gl, v3) {
  const cache = this.cache;
  if (v3.x !== void 0) {
    if (cache[0] !== v3.x || cache[1] !== v3.y || cache[2] !== v3.z || cache[3] !== v3.w) {
      gl.uniform4i(this.addr, v3.x, v3.y, v3.z, v3.w);
      cache[0] = v3.x;
      cache[1] = v3.y;
      cache[2] = v3.z;
      cache[3] = v3.w;
    }
  } else {
    if (arraysEqual(cache, v3)) return;
    gl.uniform4iv(this.addr, v3);
    copyArray(cache, v3);
  }
}
function setValueV1ui(gl, v3) {
  const cache = this.cache;
  if (cache[0] === v3) return;
  gl.uniform1ui(this.addr, v3);
  cache[0] = v3;
}
function setValueV2ui(gl, v3) {
  const cache = this.cache;
  if (v3.x !== void 0) {
    if (cache[0] !== v3.x || cache[1] !== v3.y) {
      gl.uniform2ui(this.addr, v3.x, v3.y);
      cache[0] = v3.x;
      cache[1] = v3.y;
    }
  } else {
    if (arraysEqual(cache, v3)) return;
    gl.uniform2uiv(this.addr, v3);
    copyArray(cache, v3);
  }
}
function setValueV3ui(gl, v3) {
  const cache = this.cache;
  if (v3.x !== void 0) {
    if (cache[0] !== v3.x || cache[1] !== v3.y || cache[2] !== v3.z) {
      gl.uniform3ui(this.addr, v3.x, v3.y, v3.z);
      cache[0] = v3.x;
      cache[1] = v3.y;
      cache[2] = v3.z;
    }
  } else {
    if (arraysEqual(cache, v3)) return;
    gl.uniform3uiv(this.addr, v3);
    copyArray(cache, v3);
  }
}
function setValueV4ui(gl, v3) {
  const cache = this.cache;
  if (v3.x !== void 0) {
    if (cache[0] !== v3.x || cache[1] !== v3.y || cache[2] !== v3.z || cache[3] !== v3.w) {
      gl.uniform4ui(this.addr, v3.x, v3.y, v3.z, v3.w);
      cache[0] = v3.x;
      cache[1] = v3.y;
      cache[2] = v3.z;
      cache[3] = v3.w;
    }
  } else {
    if (arraysEqual(cache, v3)) return;
    gl.uniform4uiv(this.addr, v3);
    copyArray(cache, v3);
  }
}
function setValueT1(gl, v3, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  let emptyTexture2D;
  if (this.type === gl.SAMPLER_2D_SHADOW) {
    emptyShadowTexture.compareFunction = LessEqualCompare;
    emptyTexture2D = emptyShadowTexture;
  } else {
    emptyTexture2D = emptyTexture;
  }
  textures.setTexture2D(v3 || emptyTexture2D, unit);
}
function setValueT3D1(gl, v3, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture3D(v3 || empty3dTexture, unit);
}
function setValueT6(gl, v3, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTextureCube(v3 || emptyCubeTexture, unit);
}
function setValueT2DArray1(gl, v3, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture2DArray(v3 || emptyArrayTexture, unit);
}
function getSingularSetter(type) {
  switch (type) {
    case 5126:
      return setValueV1f;
    // FLOAT
    case 35664:
      return setValueV2f;
    // _VEC2
    case 35665:
      return setValueV3f;
    // _VEC3
    case 35666:
      return setValueV4f;
    // _VEC4
    case 35674:
      return setValueM2;
    // _MAT2
    case 35675:
      return setValueM3;
    // _MAT3
    case 35676:
      return setValueM4;
    // _MAT4
    case 5124:
    case 35670:
      return setValueV1i;
    // INT, BOOL
    case 35667:
    case 35671:
      return setValueV2i;
    // _VEC2
    case 35668:
    case 35672:
      return setValueV3i;
    // _VEC3
    case 35669:
    case 35673:
      return setValueV4i;
    // _VEC4
    case 5125:
      return setValueV1ui;
    // UINT
    case 36294:
      return setValueV2ui;
    // _VEC2
    case 36295:
      return setValueV3ui;
    // _VEC3
    case 36296:
      return setValueV4ui;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return setValueT1;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return setValueT3D1;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return setValueT6;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return setValueT2DArray1;
  }
}
function setValueV1fArray(gl, v3) {
  gl.uniform1fv(this.addr, v3);
}
function setValueV2fArray(gl, v3) {
  const data = flatten(v3, this.size, 2);
  gl.uniform2fv(this.addr, data);
}
function setValueV3fArray(gl, v3) {
  const data = flatten(v3, this.size, 3);
  gl.uniform3fv(this.addr, data);
}
function setValueV4fArray(gl, v3) {
  const data = flatten(v3, this.size, 4);
  gl.uniform4fv(this.addr, data);
}
function setValueM2Array(gl, v3) {
  const data = flatten(v3, this.size, 4);
  gl.uniformMatrix2fv(this.addr, false, data);
}
function setValueM3Array(gl, v3) {
  const data = flatten(v3, this.size, 9);
  gl.uniformMatrix3fv(this.addr, false, data);
}
function setValueM4Array(gl, v3) {
  const data = flatten(v3, this.size, 16);
  gl.uniformMatrix4fv(this.addr, false, data);
}
function setValueV1iArray(gl, v3) {
  gl.uniform1iv(this.addr, v3);
}
function setValueV2iArray(gl, v3) {
  gl.uniform2iv(this.addr, v3);
}
function setValueV3iArray(gl, v3) {
  gl.uniform3iv(this.addr, v3);
}
function setValueV4iArray(gl, v3) {
  gl.uniform4iv(this.addr, v3);
}
function setValueV1uiArray(gl, v3) {
  gl.uniform1uiv(this.addr, v3);
}
function setValueV2uiArray(gl, v3) {
  gl.uniform2uiv(this.addr, v3);
}
function setValueV3uiArray(gl, v3) {
  gl.uniform3uiv(this.addr, v3);
}
function setValueV4uiArray(gl, v3) {
  gl.uniform4uiv(this.addr, v3);
}
function setValueT1Array(gl, v3, textures) {
  const cache = this.cache;
  const n2 = v3.length;
  const units = allocTexUnits(textures, n2);
  if (!arraysEqual(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray(cache, units);
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTexture2D(v3[i2] || emptyTexture, units[i2]);
  }
}
function setValueT3DArray(gl, v3, textures) {
  const cache = this.cache;
  const n2 = v3.length;
  const units = allocTexUnits(textures, n2);
  if (!arraysEqual(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray(cache, units);
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTexture3D(v3[i2] || empty3dTexture, units[i2]);
  }
}
function setValueT6Array(gl, v3, textures) {
  const cache = this.cache;
  const n2 = v3.length;
  const units = allocTexUnits(textures, n2);
  if (!arraysEqual(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray(cache, units);
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTextureCube(v3[i2] || emptyCubeTexture, units[i2]);
  }
}
function setValueT2DArrayArray(gl, v3, textures) {
  const cache = this.cache;
  const n2 = v3.length;
  const units = allocTexUnits(textures, n2);
  if (!arraysEqual(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray(cache, units);
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTexture2DArray(v3[i2] || emptyArrayTexture, units[i2]);
  }
}
function getPureArraySetter(type) {
  switch (type) {
    case 5126:
      return setValueV1fArray;
    // FLOAT
    case 35664:
      return setValueV2fArray;
    // _VEC2
    case 35665:
      return setValueV3fArray;
    // _VEC3
    case 35666:
      return setValueV4fArray;
    // _VEC4
    case 35674:
      return setValueM2Array;
    // _MAT2
    case 35675:
      return setValueM3Array;
    // _MAT3
    case 35676:
      return setValueM4Array;
    // _MAT4
    case 5124:
    case 35670:
      return setValueV1iArray;
    // INT, BOOL
    case 35667:
    case 35671:
      return setValueV2iArray;
    // _VEC2
    case 35668:
    case 35672:
      return setValueV3iArray;
    // _VEC3
    case 35669:
    case 35673:
      return setValueV4iArray;
    // _VEC4
    case 5125:
      return setValueV1uiArray;
    // UINT
    case 36294:
      return setValueV2uiArray;
    // _VEC2
    case 36295:
      return setValueV3uiArray;
    // _VEC3
    case 36296:
      return setValueV4uiArray;
    // _VEC4
    case 35678:
    // SAMPLER_2D
    case 36198:
    // SAMPLER_EXTERNAL_OES
    case 36298:
    // INT_SAMPLER_2D
    case 36306:
    // UNSIGNED_INT_SAMPLER_2D
    case 35682:
      return setValueT1Array;
    case 35679:
    // SAMPLER_3D
    case 36299:
    // INT_SAMPLER_3D
    case 36307:
      return setValueT3DArray;
    case 35680:
    // SAMPLER_CUBE
    case 36300:
    // INT_SAMPLER_CUBE
    case 36308:
    // UNSIGNED_INT_SAMPLER_CUBE
    case 36293:
      return setValueT6Array;
    case 36289:
    // SAMPLER_2D_ARRAY
    case 36303:
    // INT_SAMPLER_2D_ARRAY
    case 36311:
    // UNSIGNED_INT_SAMPLER_2D_ARRAY
    case 36292:
      return setValueT2DArrayArray;
  }
}
class SingleUniform {
  constructor(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.type = activeInfo.type;
    this.setValue = getSingularSetter(activeInfo.type);
  }
}
class PureArrayUniform {
  constructor(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.type = activeInfo.type;
    this.size = activeInfo.size;
    this.setValue = getPureArraySetter(activeInfo.type);
  }
}
class StructuredUniform {
  constructor(id) {
    this.id = id;
    this.seq = [];
    this.map = {};
  }
  setValue(gl, value, textures) {
    const seq = this.seq;
    for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
      const u2 = seq[i2];
      u2.setValue(gl, value[u2.id], textures);
    }
  }
}
const RePathPart = /(\w+)(\])?(\[|\.)?/g;
function addUniform(container, uniformObject) {
  container.seq.push(uniformObject);
  container.map[uniformObject.id] = uniformObject;
}
function parseUniform(activeInfo, addr, container) {
  const path = activeInfo.name, pathLength = path.length;
  RePathPart.lastIndex = 0;
  while (true) {
    const match = RePathPart.exec(path), matchEnd = RePathPart.lastIndex;
    let id = match[1];
    const idIsIndex = match[2] === "]", subscript = match[3];
    if (idIsIndex) id = id | 0;
    if (subscript === void 0 || subscript === "[" && matchEnd + 2 === pathLength) {
      addUniform(container, subscript === void 0 ? new SingleUniform(id, activeInfo, addr) : new PureArrayUniform(id, activeInfo, addr));
      break;
    } else {
      const map = container.map;
      let next = map[id];
      if (next === void 0) {
        next = new StructuredUniform(id);
        addUniform(container, next);
      }
      container = next;
    }
  }
}
class WebGLUniforms {
  constructor(gl, program) {
    this.seq = [];
    this.map = {};
    const n2 = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for (let i2 = 0; i2 < n2; ++i2) {
      const info = gl.getActiveUniform(program, i2), addr = gl.getUniformLocation(program, info.name);
      parseUniform(info, addr, this);
    }
  }
  setValue(gl, name, value, textures) {
    const u2 = this.map[name];
    if (u2 !== void 0) u2.setValue(gl, value, textures);
  }
  setOptional(gl, object, name) {
    const v3 = object[name];
    if (v3 !== void 0) this.setValue(gl, name, v3);
  }
  static upload(gl, seq, values, textures) {
    for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
      const u2 = seq[i2], v3 = values[u2.id];
      if (v3.needsUpdate !== false) {
        u2.setValue(gl, v3.value, textures);
      }
    }
  }
  static seqWithValue(seq, values) {
    const r3 = [];
    for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
      const u2 = seq[i2];
      if (u2.id in values) r3.push(u2);
    }
    return r3;
  }
}
function WebGLShader(gl, type, string) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, string);
  gl.compileShader(shader);
  return shader;
}
const COMPLETION_STATUS_KHR = 37297;
let programIdCount = 0;
function handleSource(string, errorLine) {
  const lines = string.split("\n");
  const lines2 = [];
  const from = Math.max(errorLine - 6, 0);
  const to2 = Math.min(errorLine + 6, lines.length);
  for (let i2 = from; i2 < to2; i2++) {
    const line = i2 + 1;
    lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i2]}`);
  }
  return lines2.join("\n");
}
const _m0 = /* @__PURE__ */ new Matrix3();
function getEncodingComponents(colorSpace) {
  ColorManagement._getMatrix(_m0, ColorManagement.workingColorSpace, colorSpace);
  const encodingMatrix = `mat3( ${_m0.elements.map((v3) => v3.toFixed(4))} )`;
  switch (ColorManagement.getTransfer(colorSpace)) {
    case LinearTransfer:
      return [encodingMatrix, "LinearTransferOETF"];
    case SRGBTransfer:
      return [encodingMatrix, "sRGBTransferOETF"];
    default:
      console.warn("THREE.WebGLProgram: Unsupported color space: ", colorSpace);
      return [encodingMatrix, "LinearTransferOETF"];
  }
}
function getShaderErrors(gl, shader, type) {
  const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
  const errors = gl.getShaderInfoLog(shader).trim();
  if (status && errors === "") return "";
  const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
  if (errorMatches) {
    const errorLine = parseInt(errorMatches[1]);
    return type.toUpperCase() + "\n\n" + errors + "\n\n" + handleSource(gl.getShaderSource(shader), errorLine);
  } else {
    return errors;
  }
}
function getTexelEncodingFunction(functionName, colorSpace) {
  const components = getEncodingComponents(colorSpace);
  return [
    `vec4 ${functionName}( vec4 value ) {`,
    `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
    "}"
  ].join("\n");
}
function getToneMappingFunction(functionName, toneMapping) {
  let toneMappingName;
  switch (toneMapping) {
    case LinearToneMapping:
      toneMappingName = "Linear";
      break;
    case ReinhardToneMapping:
      toneMappingName = "Reinhard";
      break;
    case CineonToneMapping:
      toneMappingName = "Cineon";
      break;
    case ACESFilmicToneMapping:
      toneMappingName = "ACESFilmic";
      break;
    case AgXToneMapping:
      toneMappingName = "AgX";
      break;
    case NeutralToneMapping:
      toneMappingName = "Neutral";
      break;
    case CustomToneMapping:
      toneMappingName = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
      toneMappingName = "Linear";
  }
  return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
const _v0 = /* @__PURE__ */ new Vector3();
function getLuminanceFunction() {
  ColorManagement.getLuminanceCoefficients(_v0);
  const r3 = _v0.x.toFixed(4);
  const g2 = _v0.y.toFixed(4);
  const b6 = _v0.z.toFixed(4);
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${r3}, ${g2}, ${b6} );`,
    "	return dot( weights, rgb );",
    "}"
  ].join("\n");
}
function generateVertexExtensions(parameters) {
  const chunks = [
    parameters.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
    parameters.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
  ];
  return chunks.filter(filterEmptyLine).join("\n");
}
function generateDefines(defines) {
  const chunks = [];
  for (const name in defines) {
    const value = defines[name];
    if (value === false) continue;
    chunks.push("#define " + name + " " + value);
  }
  return chunks.join("\n");
}
function fetchAttributeLocations(gl, program) {
  const attributes = {};
  const n2 = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
  for (let i2 = 0; i2 < n2; i2++) {
    const info = gl.getActiveAttrib(program, i2);
    const name = info.name;
    let locationSize = 1;
    if (info.type === gl.FLOAT_MAT2) locationSize = 2;
    if (info.type === gl.FLOAT_MAT3) locationSize = 3;
    if (info.type === gl.FLOAT_MAT4) locationSize = 4;
    attributes[name] = {
      type: info.type,
      location: gl.getAttribLocation(program, name),
      locationSize
    };
  }
  return attributes;
}
function filterEmptyLine(string) {
  return string !== "";
}
function replaceLightNums(string, parameters) {
  const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
  return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function replaceClippingPlaneNums(string, parameters) {
  return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes(string) {
  return string.replace(includePattern, includeReplacer);
}
const shaderChunkMap = /* @__PURE__ */ new Map();
function includeReplacer(match, include) {
  let string = ShaderChunk[include];
  if (string === void 0) {
    const newInclude = shaderChunkMap.get(include);
    if (newInclude !== void 0) {
      string = ShaderChunk[newInclude];
      console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
    } else {
      throw new Error("Can not resolve #include <" + include + ">");
    }
  }
  return resolveIncludes(string);
}
const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops(string) {
  return string.replace(unrollLoopPattern, loopReplacer);
}
function loopReplacer(match, start2, end, snippet) {
  let string = "";
  for (let i2 = parseInt(start2); i2 < parseInt(end); i2++) {
    string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i2 + " ]").replace(/UNROLLED_LOOP_INDEX/g, i2);
  }
  return string;
}
function generatePrecision(parameters) {
  let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
  if (parameters.precision === "highp") {
    precisionstring += "\n#define HIGH_PRECISION";
  } else if (parameters.precision === "mediump") {
    precisionstring += "\n#define MEDIUM_PRECISION";
  } else if (parameters.precision === "lowp") {
    precisionstring += "\n#define LOW_PRECISION";
  }
  return precisionstring;
}
function generateShadowMapTypeDefine(parameters) {
  let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
  if (parameters.shadowMapType === PCFShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
  } else if (parameters.shadowMapType === PCFSoftShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
  } else if (parameters.shadowMapType === VSMShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
  }
  return shadowMapTypeDefine;
}
function generateEnvMapTypeDefine(parameters) {
  let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeReflectionMapping:
      case CubeRefractionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE";
        break;
      case CubeUVReflectionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  }
  return envMapTypeDefine;
}
function generateEnvMapModeDefine(parameters) {
  let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeRefractionMapping:
        envMapModeDefine = "ENVMAP_MODE_REFRACTION";
        break;
    }
  }
  return envMapModeDefine;
}
function generateEnvMapBlendingDefine(parameters) {
  let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
  if (parameters.envMap) {
    switch (parameters.combine) {
      case MultiplyOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case MixOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
        break;
      case AddOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
        break;
    }
  }
  return envMapBlendingDefine;
}
function generateCubeUVSize(parameters) {
  const imageHeight = parameters.envMapCubeUVHeight;
  if (imageHeight === null) return null;
  const maxMip = Math.log2(imageHeight) - 2;
  const texelHeight = 1 / imageHeight;
  const texelWidth = 1 / (3 * Math.max(Math.pow(2, maxMip), 7 * 16));
  return { texelWidth, texelHeight, maxMip };
}
function WebGLProgram(renderer, cacheKey2, parameters, bindingStates) {
  const gl = renderer.getContext();
  const defines = parameters.defines;
  let vertexShader2 = parameters.vertexShader;
  let fragmentShader2 = parameters.fragmentShader;
  const shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
  const envMapTypeDefine = generateEnvMapTypeDefine(parameters);
  const envMapModeDefine = generateEnvMapModeDefine(parameters);
  const envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
  const envMapCubeUVSize = generateCubeUVSize(parameters);
  const customVertexExtensions = generateVertexExtensions(parameters);
  const customDefines = generateDefines(defines);
  const program = gl.createProgram();
  let prefixVertex, prefixFragment;
  let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
  if (parameters.isRawShaderMaterial) {
    prefixVertex = [
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixVertex.length > 0) {
      prefixVertex += "\n";
    }
    prefixFragment = [
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixFragment.length > 0) {
      prefixFragment += "\n";
    }
  } else {
    prefixVertex = [
      generatePrecision(parameters),
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
      parameters.batching ? "#define USE_BATCHING" : "",
      parameters.batchingColor ? "#define USE_BATCHING_COLOR" : "",
      parameters.instancing ? "#define USE_INSTANCING" : "",
      parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
      parameters.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
      parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
      parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
      parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
      parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
      parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
      //
      parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
      parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
      parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
      parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
      parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
      parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
      parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
      parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
      parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
      parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
      parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
      parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
      parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
      parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
      parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
      parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
      parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
      parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
      parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
      parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
      parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
      parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
      parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
      //
      parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
      parameters.vertexColors ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUv1s ? "#define USE_UV1" : "",
      parameters.vertexUv2s ? "#define USE_UV2" : "",
      parameters.vertexUv3s ? "#define USE_UV3" : "",
      parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.skinning ? "#define USE_SKINNING" : "",
      parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
      parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
      parameters.morphColors ? "#define USE_MORPHCOLORS" : "",
      parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
      parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
      parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
      "uniform mat4 modelMatrix;",
      "uniform mat4 modelViewMatrix;",
      "uniform mat4 projectionMatrix;",
      "uniform mat4 viewMatrix;",
      "uniform mat3 normalMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      "#ifdef USE_INSTANCING",
      "	attribute mat4 instanceMatrix;",
      "#endif",
      "#ifdef USE_INSTANCING_COLOR",
      "	attribute vec3 instanceColor;",
      "#endif",
      "#ifdef USE_INSTANCING_MORPH",
      "	uniform sampler2D morphTexture;",
      "#endif",
      "attribute vec3 position;",
      "attribute vec3 normal;",
      "attribute vec2 uv;",
      "#ifdef USE_UV1",
      "	attribute vec2 uv1;",
      "#endif",
      "#ifdef USE_UV2",
      "	attribute vec2 uv2;",
      "#endif",
      "#ifdef USE_UV3",
      "	attribute vec2 uv3;",
      "#endif",
      "#ifdef USE_TANGENT",
      "	attribute vec4 tangent;",
      "#endif",
      "#if defined( USE_COLOR_ALPHA )",
      "	attribute vec4 color;",
      "#elif defined( USE_COLOR )",
      "	attribute vec3 color;",
      "#endif",
      "#ifdef USE_SKINNING",
      "	attribute vec4 skinIndex;",
      "	attribute vec4 skinWeight;",
      "#endif",
      "\n"
    ].filter(filterEmptyLine).join("\n");
    prefixFragment = [
      generatePrecision(parameters),
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.matcap ? "#define USE_MATCAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapTypeDefine : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.envMap ? "#define " + envMapBlendingDefine : "",
      envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
      envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
      envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
      parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
      parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
      parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.dispersion ? "#define USE_DISPERSION" : "",
      parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
      parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
      parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.alphaTest ? "#define USE_ALPHATEST" : "",
      parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
      parameters.sheen ? "#define USE_SHEEN" : "",
      parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
      parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
      parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUv1s ? "#define USE_UV1" : "",
      parameters.vertexUv2s ? "#define USE_UV2" : "",
      parameters.vertexUv3s ? "#define USE_UV3" : "",
      parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
      parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
      parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
      parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
      parameters.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
      "uniform mat4 viewMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      parameters.toneMapping !== NoToneMapping ? "#define TONE_MAPPING" : "",
      parameters.toneMapping !== NoToneMapping ? ShaderChunk["tonemapping_pars_fragment"] : "",
      // this code is required here because it is used by the toneMapping() function defined below
      parameters.toneMapping !== NoToneMapping ? getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
      parameters.dithering ? "#define DITHERING" : "",
      parameters.opaque ? "#define OPAQUE" : "",
      ShaderChunk["colorspace_pars_fragment"],
      // this code is required here because it is used by the various encoding/decoding function defined below
      getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
      getLuminanceFunction(),
      parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
      "\n"
    ].filter(filterEmptyLine).join("\n");
  }
  vertexShader2 = resolveIncludes(vertexShader2);
  vertexShader2 = replaceLightNums(vertexShader2, parameters);
  vertexShader2 = replaceClippingPlaneNums(vertexShader2, parameters);
  fragmentShader2 = resolveIncludes(fragmentShader2);
  fragmentShader2 = replaceLightNums(fragmentShader2, parameters);
  fragmentShader2 = replaceClippingPlaneNums(fragmentShader2, parameters);
  vertexShader2 = unrollLoops(vertexShader2);
  fragmentShader2 = unrollLoops(fragmentShader2);
  if (parameters.isRawShaderMaterial !== true) {
    versionString = "#version 300 es\n";
    prefixVertex = [
      customVertexExtensions,
      "#define attribute in",
      "#define varying out",
      "#define texture2D texture"
    ].join("\n") + "\n" + prefixVertex;
    prefixFragment = [
      "#define varying in",
      parameters.glslVersion === GLSL3 ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
      parameters.glslVersion === GLSL3 ? "" : "#define gl_FragColor pc_fragColor",
      "#define gl_FragDepthEXT gl_FragDepth",
      "#define texture2D texture",
      "#define textureCube texture",
      "#define texture2DProj textureProj",
      "#define texture2DLodEXT textureLod",
      "#define texture2DProjLodEXT textureProjLod",
      "#define textureCubeLodEXT textureLod",
      "#define texture2DGradEXT textureGrad",
      "#define texture2DProjGradEXT textureProjGrad",
      "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + prefixFragment;
  }
  const vertexGlsl = versionString + prefixVertex + vertexShader2;
  const fragmentGlsl = versionString + prefixFragment + fragmentShader2;
  const glVertexShader = WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
  const glFragmentShader = WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
  gl.attachShader(program, glVertexShader);
  gl.attachShader(program, glFragmentShader);
  if (parameters.index0AttributeName !== void 0) {
    gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
  } else if (parameters.morphTargets === true) {
    gl.bindAttribLocation(program, 0, "position");
  }
  gl.linkProgram(program);
  function onFirstUse(self2) {
    if (renderer.debug.checkShaderErrors) {
      const programLog = gl.getProgramInfoLog(program).trim();
      const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
      const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
      let runnable = true;
      let haveDiagnostics = true;
      if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
        runnable = false;
        if (typeof renderer.debug.onShaderError === "function") {
          renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
        } else {
          const vertexErrors = getShaderErrors(gl, glVertexShader, "vertex");
          const fragmentErrors = getShaderErrors(gl, glFragmentShader, "fragment");
          console.error(
            "THREE.WebGLProgram: Shader Error " + gl.getError() + " - VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\nMaterial Name: " + self2.name + "\nMaterial Type: " + self2.type + "\n\nProgram Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors
          );
        }
      } else if (programLog !== "") {
        console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
      } else if (vertexLog === "" || fragmentLog === "") {
        haveDiagnostics = false;
      }
      if (haveDiagnostics) {
        self2.diagnostics = {
          runnable,
          programLog,
          vertexShader: {
            log: vertexLog,
            prefix: prefixVertex
          },
          fragmentShader: {
            log: fragmentLog,
            prefix: prefixFragment
          }
        };
      }
    }
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    cachedUniforms = new WebGLUniforms(gl, program);
    cachedAttributes = fetchAttributeLocations(gl, program);
  }
  let cachedUniforms;
  this.getUniforms = function() {
    if (cachedUniforms === void 0) {
      onFirstUse(this);
    }
    return cachedUniforms;
  };
  let cachedAttributes;
  this.getAttributes = function() {
    if (cachedAttributes === void 0) {
      onFirstUse(this);
    }
    return cachedAttributes;
  };
  let programReady = parameters.rendererExtensionParallelShaderCompile === false;
  this.isReady = function() {
    if (programReady === false) {
      programReady = gl.getProgramParameter(program, COMPLETION_STATUS_KHR);
    }
    return programReady;
  };
  this.destroy = function() {
    bindingStates.releaseStatesOfProgram(this);
    gl.deleteProgram(program);
    this.program = void 0;
  };
  this.type = parameters.shaderType;
  this.name = parameters.shaderName;
  this.id = programIdCount++;
  this.cacheKey = cacheKey2;
  this.usedTimes = 1;
  this.program = program;
  this.vertexShader = glVertexShader;
  this.fragmentShader = glFragmentShader;
  return this;
}
let _id = 0;
class WebGLShaderCache {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map();
    this.materialCache = /* @__PURE__ */ new Map();
  }
  update(material) {
    const vertexShader2 = material.vertexShader;
    const fragmentShader2 = material.fragmentShader;
    const vertexShaderStage = this._getShaderStage(vertexShader2);
    const fragmentShaderStage = this._getShaderStage(fragmentShader2);
    const materialShaders = this._getShaderCacheForMaterial(material);
    if (materialShaders.has(vertexShaderStage) === false) {
      materialShaders.add(vertexShaderStage);
      vertexShaderStage.usedTimes++;
    }
    if (materialShaders.has(fragmentShaderStage) === false) {
      materialShaders.add(fragmentShaderStage);
      fragmentShaderStage.usedTimes++;
    }
    return this;
  }
  remove(material) {
    const materialShaders = this.materialCache.get(material);
    for (const shaderStage of materialShaders) {
      shaderStage.usedTimes--;
      if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
    }
    this.materialCache.delete(material);
    return this;
  }
  getVertexShaderID(material) {
    return this._getShaderStage(material.vertexShader).id;
  }
  getFragmentShaderID(material) {
    return this._getShaderStage(material.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear();
    this.materialCache.clear();
  }
  _getShaderCacheForMaterial(material) {
    const cache = this.materialCache;
    let set = cache.get(material);
    if (set === void 0) {
      set = /* @__PURE__ */ new Set();
      cache.set(material, set);
    }
    return set;
  }
  _getShaderStage(code) {
    const cache = this.shaderCache;
    let stage = cache.get(code);
    if (stage === void 0) {
      stage = new WebGLShaderStage(code);
      cache.set(code, stage);
    }
    return stage;
  }
}
class WebGLShaderStage {
  constructor(code) {
    this.id = _id++;
    this.code = code;
    this.usedTimes = 0;
  }
}
function WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions2, capabilities, bindingStates, clipping) {
  const _programLayers = new Layers();
  const _customShaders = new WebGLShaderCache();
  const _activeChannels = /* @__PURE__ */ new Set();
  const programs = [];
  const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
  const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
  let precision = capabilities.precision;
  const shaderIDs = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function getChannel(value) {
    _activeChannels.add(value);
    if (value === 0) return "uv";
    return `uv${value}`;
  }
  function getParameters(material, lights, shadows, scene, object) {
    const fog = scene.fog;
    const geometry = object.geometry;
    const environment = material.isMeshStandardMaterial ? scene.environment : null;
    const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
    const envMapCubeUVHeight = !!envMap && envMap.mapping === CubeUVReflectionMapping ? envMap.image.height : null;
    const shaderID = shaderIDs[material.type];
    if (material.precision !== null) {
      precision = capabilities.getMaxPrecision(material.precision);
      if (precision !== material.precision) {
        console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
      }
    }
    const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
    let morphTextureStride = 0;
    if (geometry.morphAttributes.position !== void 0) morphTextureStride = 1;
    if (geometry.morphAttributes.normal !== void 0) morphTextureStride = 2;
    if (geometry.morphAttributes.color !== void 0) morphTextureStride = 3;
    let vertexShader2, fragmentShader2;
    let customVertexShaderID, customFragmentShaderID;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      vertexShader2 = shader.vertexShader;
      fragmentShader2 = shader.fragmentShader;
    } else {
      vertexShader2 = material.vertexShader;
      fragmentShader2 = material.fragmentShader;
      _customShaders.update(material);
      customVertexShaderID = _customShaders.getVertexShaderID(material);
      customFragmentShaderID = _customShaders.getFragmentShaderID(material);
    }
    const currentRenderTarget = renderer.getRenderTarget();
    const reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
    const IS_INSTANCEDMESH = object.isInstancedMesh === true;
    const IS_BATCHEDMESH = object.isBatchedMesh === true;
    const HAS_MAP = !!material.map;
    const HAS_MATCAP = !!material.matcap;
    const HAS_ENVMAP = !!envMap;
    const HAS_AOMAP = !!material.aoMap;
    const HAS_LIGHTMAP = !!material.lightMap;
    const HAS_BUMPMAP = !!material.bumpMap;
    const HAS_NORMALMAP = !!material.normalMap;
    const HAS_DISPLACEMENTMAP = !!material.displacementMap;
    const HAS_EMISSIVEMAP = !!material.emissiveMap;
    const HAS_METALNESSMAP = !!material.metalnessMap;
    const HAS_ROUGHNESSMAP = !!material.roughnessMap;
    const HAS_ANISOTROPY = material.anisotropy > 0;
    const HAS_CLEARCOAT = material.clearcoat > 0;
    const HAS_DISPERSION = material.dispersion > 0;
    const HAS_IRIDESCENCE = material.iridescence > 0;
    const HAS_SHEEN = material.sheen > 0;
    const HAS_TRANSMISSION = material.transmission > 0;
    const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
    const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
    const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
    const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
    const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
    const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
    const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
    const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
    const HAS_SPECULARMAP = !!material.specularMap;
    const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
    const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
    const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
    const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
    const HAS_GRADIENTMAP = !!material.gradientMap;
    const HAS_ALPHAMAP = !!material.alphaMap;
    const HAS_ALPHATEST = material.alphaTest > 0;
    const HAS_ALPHAHASH = !!material.alphaHash;
    const HAS_EXTENSIONS = !!material.extensions;
    let toneMapping = NoToneMapping;
    if (material.toneMapped) {
      if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) {
        toneMapping = renderer.toneMapping;
      }
    }
    const parameters = {
      shaderID,
      shaderType: material.type,
      shaderName: material.name,
      vertexShader: vertexShader2,
      fragmentShader: fragmentShader2,
      defines: material.defines,
      customVertexShaderID,
      customFragmentShaderID,
      isRawShaderMaterial: material.isRawShaderMaterial === true,
      glslVersion: material.glslVersion,
      precision,
      batching: IS_BATCHEDMESH,
      batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
      instancing: IS_INSTANCEDMESH,
      instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
      instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
      supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
      outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace$1,
      alphaToCoverage: !!material.alphaToCoverage,
      map: HAS_MAP,
      matcap: HAS_MATCAP,
      envMap: HAS_ENVMAP,
      envMapMode: HAS_ENVMAP && envMap.mapping,
      envMapCubeUVHeight,
      aoMap: HAS_AOMAP,
      lightMap: HAS_LIGHTMAP,
      bumpMap: HAS_BUMPMAP,
      normalMap: HAS_NORMALMAP,
      displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
      emissiveMap: HAS_EMISSIVEMAP,
      normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === ObjectSpaceNormalMap,
      normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === TangentSpaceNormalMap,
      metalnessMap: HAS_METALNESSMAP,
      roughnessMap: HAS_ROUGHNESSMAP,
      anisotropy: HAS_ANISOTROPY,
      anisotropyMap: HAS_ANISOTROPYMAP,
      clearcoat: HAS_CLEARCOAT,
      clearcoatMap: HAS_CLEARCOATMAP,
      clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
      clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
      dispersion: HAS_DISPERSION,
      iridescence: HAS_IRIDESCENCE,
      iridescenceMap: HAS_IRIDESCENCEMAP,
      iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
      sheen: HAS_SHEEN,
      sheenColorMap: HAS_SHEEN_COLORMAP,
      sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
      specularMap: HAS_SPECULARMAP,
      specularColorMap: HAS_SPECULAR_COLORMAP,
      specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
      transmission: HAS_TRANSMISSION,
      transmissionMap: HAS_TRANSMISSIONMAP,
      thicknessMap: HAS_THICKNESSMAP,
      gradientMap: HAS_GRADIENTMAP,
      opaque: material.transparent === false && material.blending === NormalBlending && material.alphaToCoverage === false,
      alphaMap: HAS_ALPHAMAP,
      alphaTest: HAS_ALPHATEST,
      alphaHash: HAS_ALPHAHASH,
      combine: material.combine,
      //
      mapUv: HAS_MAP && getChannel(material.map.channel),
      aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
      lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
      bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
      normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
      displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
      emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
      metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
      roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
      anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
      clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
      clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
      iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
      iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
      sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
      sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
      specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
      specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
      specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
      transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
      thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
      alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
      //
      vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
      vertexColors: material.vertexColors,
      vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
      pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
      fog: !!fog,
      useFog: material.fog === true,
      fogExp2: !!fog && fog.isFogExp2,
      flatShading: material.flatShading === true,
      sizeAttenuation: material.sizeAttenuation === true,
      logarithmicDepthBuffer,
      reverseDepthBuffer,
      skinning: object.isSkinnedMesh === true,
      morphTargets: geometry.morphAttributes.position !== void 0,
      morphNormals: geometry.morphAttributes.normal !== void 0,
      morphColors: geometry.morphAttributes.color !== void 0,
      morphTargetsCount,
      morphTextureStride,
      numDirLights: lights.directional.length,
      numPointLights: lights.point.length,
      numSpotLights: lights.spot.length,
      numSpotLightMaps: lights.spotLightMap.length,
      numRectAreaLights: lights.rectArea.length,
      numHemiLights: lights.hemi.length,
      numDirLightShadows: lights.directionalShadowMap.length,
      numPointLightShadows: lights.pointShadowMap.length,
      numSpotLightShadows: lights.spotShadowMap.length,
      numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
      numLightProbes: lights.numLightProbes,
      numClippingPlanes: clipping.numPlanes,
      numClipIntersection: clipping.numIntersection,
      dithering: material.dithering,
      shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
      shadowMapType: renderer.shadowMap.type,
      toneMapping,
      decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && ColorManagement.getTransfer(material.map.colorSpace) === SRGBTransfer,
      decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && ColorManagement.getTransfer(material.emissiveMap.colorSpace) === SRGBTransfer,
      premultipliedAlpha: material.premultipliedAlpha,
      doubleSided: material.side === DoubleSide,
      flipSided: material.side === BackSide,
      useDepthPacking: material.depthPacking >= 0,
      depthPacking: material.depthPacking || 0,
      index0AttributeName: material.index0AttributeName,
      extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions2.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions2.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: extensions2.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: material.customProgramCacheKey()
    };
    parameters.vertexUv1s = _activeChannels.has(1);
    parameters.vertexUv2s = _activeChannels.has(2);
    parameters.vertexUv3s = _activeChannels.has(3);
    _activeChannels.clear();
    return parameters;
  }
  function getProgramCacheKey(parameters) {
    const array = [];
    if (parameters.shaderID) {
      array.push(parameters.shaderID);
    } else {
      array.push(parameters.customVertexShaderID);
      array.push(parameters.customFragmentShaderID);
    }
    if (parameters.defines !== void 0) {
      for (const name in parameters.defines) {
        array.push(name);
        array.push(parameters.defines[name]);
      }
    }
    if (parameters.isRawShaderMaterial === false) {
      getProgramCacheKeyParameters(array, parameters);
      getProgramCacheKeyBooleans(array, parameters);
      array.push(renderer.outputColorSpace);
    }
    array.push(parameters.customProgramCacheKey);
    return array.join();
  }
  function getProgramCacheKeyParameters(array, parameters) {
    array.push(parameters.precision);
    array.push(parameters.outputColorSpace);
    array.push(parameters.envMapMode);
    array.push(parameters.envMapCubeUVHeight);
    array.push(parameters.mapUv);
    array.push(parameters.alphaMapUv);
    array.push(parameters.lightMapUv);
    array.push(parameters.aoMapUv);
    array.push(parameters.bumpMapUv);
    array.push(parameters.normalMapUv);
    array.push(parameters.displacementMapUv);
    array.push(parameters.emissiveMapUv);
    array.push(parameters.metalnessMapUv);
    array.push(parameters.roughnessMapUv);
    array.push(parameters.anisotropyMapUv);
    array.push(parameters.clearcoatMapUv);
    array.push(parameters.clearcoatNormalMapUv);
    array.push(parameters.clearcoatRoughnessMapUv);
    array.push(parameters.iridescenceMapUv);
    array.push(parameters.iridescenceThicknessMapUv);
    array.push(parameters.sheenColorMapUv);
    array.push(parameters.sheenRoughnessMapUv);
    array.push(parameters.specularMapUv);
    array.push(parameters.specularColorMapUv);
    array.push(parameters.specularIntensityMapUv);
    array.push(parameters.transmissionMapUv);
    array.push(parameters.thicknessMapUv);
    array.push(parameters.combine);
    array.push(parameters.fogExp2);
    array.push(parameters.sizeAttenuation);
    array.push(parameters.morphTargetsCount);
    array.push(parameters.morphAttributeCount);
    array.push(parameters.numDirLights);
    array.push(parameters.numPointLights);
    array.push(parameters.numSpotLights);
    array.push(parameters.numSpotLightMaps);
    array.push(parameters.numHemiLights);
    array.push(parameters.numRectAreaLights);
    array.push(parameters.numDirLightShadows);
    array.push(parameters.numPointLightShadows);
    array.push(parameters.numSpotLightShadows);
    array.push(parameters.numSpotLightShadowsWithMaps);
    array.push(parameters.numLightProbes);
    array.push(parameters.shadowMapType);
    array.push(parameters.toneMapping);
    array.push(parameters.numClippingPlanes);
    array.push(parameters.numClipIntersection);
    array.push(parameters.depthPacking);
  }
  function getProgramCacheKeyBooleans(array, parameters) {
    _programLayers.disableAll();
    if (parameters.supportsVertexTextures)
      _programLayers.enable(0);
    if (parameters.instancing)
      _programLayers.enable(1);
    if (parameters.instancingColor)
      _programLayers.enable(2);
    if (parameters.instancingMorph)
      _programLayers.enable(3);
    if (parameters.matcap)
      _programLayers.enable(4);
    if (parameters.envMap)
      _programLayers.enable(5);
    if (parameters.normalMapObjectSpace)
      _programLayers.enable(6);
    if (parameters.normalMapTangentSpace)
      _programLayers.enable(7);
    if (parameters.clearcoat)
      _programLayers.enable(8);
    if (parameters.iridescence)
      _programLayers.enable(9);
    if (parameters.alphaTest)
      _programLayers.enable(10);
    if (parameters.vertexColors)
      _programLayers.enable(11);
    if (parameters.vertexAlphas)
      _programLayers.enable(12);
    if (parameters.vertexUv1s)
      _programLayers.enable(13);
    if (parameters.vertexUv2s)
      _programLayers.enable(14);
    if (parameters.vertexUv3s)
      _programLayers.enable(15);
    if (parameters.vertexTangents)
      _programLayers.enable(16);
    if (parameters.anisotropy)
      _programLayers.enable(17);
    if (parameters.alphaHash)
      _programLayers.enable(18);
    if (parameters.batching)
      _programLayers.enable(19);
    if (parameters.dispersion)
      _programLayers.enable(20);
    if (parameters.batchingColor)
      _programLayers.enable(21);
    array.push(_programLayers.mask);
    _programLayers.disableAll();
    if (parameters.fog)
      _programLayers.enable(0);
    if (parameters.useFog)
      _programLayers.enable(1);
    if (parameters.flatShading)
      _programLayers.enable(2);
    if (parameters.logarithmicDepthBuffer)
      _programLayers.enable(3);
    if (parameters.reverseDepthBuffer)
      _programLayers.enable(4);
    if (parameters.skinning)
      _programLayers.enable(5);
    if (parameters.morphTargets)
      _programLayers.enable(6);
    if (parameters.morphNormals)
      _programLayers.enable(7);
    if (parameters.morphColors)
      _programLayers.enable(8);
    if (parameters.premultipliedAlpha)
      _programLayers.enable(9);
    if (parameters.shadowMapEnabled)
      _programLayers.enable(10);
    if (parameters.doubleSided)
      _programLayers.enable(11);
    if (parameters.flipSided)
      _programLayers.enable(12);
    if (parameters.useDepthPacking)
      _programLayers.enable(13);
    if (parameters.dithering)
      _programLayers.enable(14);
    if (parameters.transmission)
      _programLayers.enable(15);
    if (parameters.sheen)
      _programLayers.enable(16);
    if (parameters.opaque)
      _programLayers.enable(17);
    if (parameters.pointsUvs)
      _programLayers.enable(18);
    if (parameters.decodeVideoTexture)
      _programLayers.enable(19);
    if (parameters.decodeVideoTextureEmissive)
      _programLayers.enable(20);
    if (parameters.alphaToCoverage)
      _programLayers.enable(21);
    array.push(_programLayers.mask);
  }
  function getUniforms(material) {
    const shaderID = shaderIDs[material.type];
    let uniforms;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      uniforms = UniformsUtils.clone(shader.uniforms);
    } else {
      uniforms = material.uniforms;
    }
    return uniforms;
  }
  function acquireProgram(parameters, cacheKey2) {
    let program;
    for (let p3 = 0, pl = programs.length; p3 < pl; p3++) {
      const preexistingProgram = programs[p3];
      if (preexistingProgram.cacheKey === cacheKey2) {
        program = preexistingProgram;
        ++program.usedTimes;
        break;
      }
    }
    if (program === void 0) {
      program = new WebGLProgram(renderer, cacheKey2, parameters, bindingStates);
      programs.push(program);
    }
    return program;
  }
  function releaseProgram(program) {
    if (--program.usedTimes === 0) {
      const i2 = programs.indexOf(program);
      programs[i2] = programs[programs.length - 1];
      programs.pop();
      program.destroy();
    }
  }
  function releaseShaderCache(material) {
    _customShaders.remove(material);
  }
  function dispose2() {
    _customShaders.dispose();
  }
  return {
    getParameters,
    getProgramCacheKey,
    getUniforms,
    acquireProgram,
    releaseProgram,
    releaseShaderCache,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs,
    dispose: dispose2
  };
}
function WebGLProperties() {
  let properties = /* @__PURE__ */ new WeakMap();
  function has(object) {
    return properties.has(object);
  }
  function get(object) {
    let map = properties.get(object);
    if (map === void 0) {
      map = {};
      properties.set(object, map);
    }
    return map;
  }
  function remove(object) {
    properties.delete(object);
  }
  function update2(object, key, value) {
    properties.get(object)[key] = value;
  }
  function dispose2() {
    properties = /* @__PURE__ */ new WeakMap();
  }
  return {
    has,
    get,
    remove,
    update: update2,
    dispose: dispose2
  };
}
function painterSortStable(a5, b6) {
  if (a5.groupOrder !== b6.groupOrder) {
    return a5.groupOrder - b6.groupOrder;
  } else if (a5.renderOrder !== b6.renderOrder) {
    return a5.renderOrder - b6.renderOrder;
  } else if (a5.material.id !== b6.material.id) {
    return a5.material.id - b6.material.id;
  } else if (a5.z !== b6.z) {
    return a5.z - b6.z;
  } else {
    return a5.id - b6.id;
  }
}
function reversePainterSortStable(a5, b6) {
  if (a5.groupOrder !== b6.groupOrder) {
    return a5.groupOrder - b6.groupOrder;
  } else if (a5.renderOrder !== b6.renderOrder) {
    return a5.renderOrder - b6.renderOrder;
  } else if (a5.z !== b6.z) {
    return b6.z - a5.z;
  } else {
    return a5.id - b6.id;
  }
}
function WebGLRenderList() {
  const renderItems = [];
  let renderItemsIndex = 0;
  const opaque = [];
  const transmissive = [];
  const transparent = [];
  function init4() {
    renderItemsIndex = 0;
    opaque.length = 0;
    transmissive.length = 0;
    transparent.length = 0;
  }
  function getNextRenderItem(object, geometry, material, groupOrder, z2, group) {
    let renderItem = renderItems[renderItemsIndex];
    if (renderItem === void 0) {
      renderItem = {
        id: object.id,
        object,
        geometry,
        material,
        groupOrder,
        renderOrder: object.renderOrder,
        z: z2,
        group
      };
      renderItems[renderItemsIndex] = renderItem;
    } else {
      renderItem.id = object.id;
      renderItem.object = object;
      renderItem.geometry = geometry;
      renderItem.material = material;
      renderItem.groupOrder = groupOrder;
      renderItem.renderOrder = object.renderOrder;
      renderItem.z = z2;
      renderItem.group = group;
    }
    renderItemsIndex++;
    return renderItem;
  }
  function push(object, geometry, material, groupOrder, z2, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z2, group);
    if (material.transmission > 0) {
      transmissive.push(renderItem);
    } else if (material.transparent === true) {
      transparent.push(renderItem);
    } else {
      opaque.push(renderItem);
    }
  }
  function unshift(object, geometry, material, groupOrder, z2, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z2, group);
    if (material.transmission > 0) {
      transmissive.unshift(renderItem);
    } else if (material.transparent === true) {
      transparent.unshift(renderItem);
    } else {
      opaque.unshift(renderItem);
    }
  }
  function sort(customOpaqueSort, customTransparentSort) {
    if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
    if (transmissive.length > 1) transmissive.sort(customTransparentSort || reversePainterSortStable);
    if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
  }
  function finish() {
    for (let i2 = renderItemsIndex, il = renderItems.length; i2 < il; i2++) {
      const renderItem = renderItems[i2];
      if (renderItem.id === null) break;
      renderItem.id = null;
      renderItem.object = null;
      renderItem.geometry = null;
      renderItem.material = null;
      renderItem.group = null;
    }
  }
  return {
    opaque,
    transmissive,
    transparent,
    init: init4,
    push,
    unshift,
    finish,
    sort
  };
}
function WebGLRenderLists() {
  let lists = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth) {
    const listArray = lists.get(scene);
    let list;
    if (listArray === void 0) {
      list = new WebGLRenderList();
      lists.set(scene, [list]);
    } else {
      if (renderCallDepth >= listArray.length) {
        list = new WebGLRenderList();
        listArray.push(list);
      } else {
        list = listArray[renderCallDepth];
      }
    }
    return list;
  }
  function dispose2() {
    lists = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose: dispose2
  };
}
function UniformsCache() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            direction: new Vector3(),
            color: new Color()
          };
          break;
        case "SpotLight":
          uniforms = {
            position: new Vector3(),
            direction: new Vector3(),
            color: new Color(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          uniforms = {
            position: new Vector3(),
            color: new Color(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          uniforms = {
            direction: new Vector3(),
            skyColor: new Color(),
            groundColor: new Color()
          };
          break;
        case "RectAreaLight":
          uniforms = {
            color: new Color(),
            position: new Vector3(),
            halfWidth: new Vector3(),
            halfHeight: new Vector3()
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
function ShadowUniformsCache() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;
        case "SpotLight":
          uniforms = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;
        case "PointLight":
          uniforms = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
let nextVersion = 0;
function shadowCastingAndTexturingLightsFirst(lightA, lightB) {
  return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function WebGLLights(extensions2) {
  const cache = new UniformsCache();
  const shadowCache = ShadowUniformsCache();
  const state = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let i2 = 0; i2 < 9; i2++) state.probe.push(new Vector3());
  const vector3 = new Vector3();
  const matrix4 = new Matrix4();
  const matrix42 = new Matrix4();
  function setup(lights) {
    let r3 = 0, g2 = 0, b6 = 0;
    for (let i2 = 0; i2 < 9; i2++) state.probe[i2].set(0, 0, 0);
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    let numDirectionalShadows = 0;
    let numPointShadows = 0;
    let numSpotShadows = 0;
    let numSpotMaps = 0;
    let numSpotShadowsWithMaps = 0;
    let numLightProbes = 0;
    lights.sort(shadowCastingAndTexturingLightsFirst);
    for (let i2 = 0, l2 = lights.length; i2 < l2; i2++) {
      const light = lights[i2];
      const color = light.color;
      const intensity = light.intensity;
      const distance = light.distance;
      const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
      if (light.isAmbientLight) {
        r3 += color.r * intensity;
        g2 += color.g * intensity;
        b6 += color.b * intensity;
      } else if (light.isLightProbe) {
        for (let j3 = 0; j3 < 9; j3++) {
          state.probe[j3].addScaledVector(light.sh.coefficients[j3], intensity);
        }
        numLightProbes++;
      } else if (light.isDirectionalLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity);
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowIntensity = shadow.intensity;
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.directionalShadow[directionalLength] = shadowUniforms;
          state.directionalShadowMap[directionalLength] = shadowMap;
          state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
          numDirectionalShadows++;
        }
        state.directional[directionalLength] = uniforms;
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = cache.get(light);
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.color.copy(color).multiplyScalar(intensity);
        uniforms.distance = distance;
        uniforms.coneCos = Math.cos(light.angle);
        uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
        uniforms.decay = light.decay;
        state.spot[spotLength] = uniforms;
        const shadow = light.shadow;
        if (light.map) {
          state.spotLightMap[numSpotMaps] = light.map;
          numSpotMaps++;
          shadow.updateMatrices(light);
          if (light.castShadow) numSpotShadowsWithMaps++;
        }
        state.spotLightMatrix[spotLength] = shadow.matrix;
        if (light.castShadow) {
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowIntensity = shadow.intensity;
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.spotShadow[spotLength] = shadowUniforms;
          state.spotShadowMap[spotLength] = shadowMap;
          numSpotShadows++;
        }
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(color).multiplyScalar(intensity);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        state.rectArea[rectAreaLength] = uniforms;
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity);
        uniforms.distance = light.distance;
        uniforms.decay = light.decay;
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowIntensity = shadow.intensity;
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          shadowUniforms.shadowCameraNear = shadow.camera.near;
          shadowUniforms.shadowCameraFar = shadow.camera.far;
          state.pointShadow[pointLength] = shadowUniforms;
          state.pointShadowMap[pointLength] = shadowMap;
          state.pointShadowMatrix[pointLength] = light.shadow.matrix;
          numPointShadows++;
        }
        state.point[pointLength] = uniforms;
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = cache.get(light);
        uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
        uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
        state.hemi[hemiLength] = uniforms;
        hemiLength++;
      }
    }
    if (rectAreaLength > 0) {
      if (extensions2.has("OES_texture_float_linear") === true) {
        state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
        state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
      } else {
        state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
        state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
      }
    }
    state.ambient[0] = r3;
    state.ambient[1] = g2;
    state.ambient[2] = b6;
    const hash = state.hash;
    if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
      state.directional.length = directionalLength;
      state.spot.length = spotLength;
      state.rectArea.length = rectAreaLength;
      state.point.length = pointLength;
      state.hemi.length = hemiLength;
      state.directionalShadow.length = numDirectionalShadows;
      state.directionalShadowMap.length = numDirectionalShadows;
      state.pointShadow.length = numPointShadows;
      state.pointShadowMap.length = numPointShadows;
      state.spotShadow.length = numSpotShadows;
      state.spotShadowMap.length = numSpotShadows;
      state.directionalShadowMatrix.length = numDirectionalShadows;
      state.pointShadowMatrix.length = numPointShadows;
      state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
      state.spotLightMap.length = numSpotMaps;
      state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
      state.numLightProbes = numLightProbes;
      hash.directionalLength = directionalLength;
      hash.pointLength = pointLength;
      hash.spotLength = spotLength;
      hash.rectAreaLength = rectAreaLength;
      hash.hemiLength = hemiLength;
      hash.numDirectionalShadows = numDirectionalShadows;
      hash.numPointShadows = numPointShadows;
      hash.numSpotShadows = numSpotShadows;
      hash.numSpotMaps = numSpotMaps;
      hash.numLightProbes = numLightProbes;
      state.version = nextVersion++;
    }
  }
  function setupView(lights, camera) {
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    const viewMatrix = camera.matrixWorldInverse;
    for (let i2 = 0, l2 = lights.length; i2 < l2; i2++) {
      const light = lights[i2];
      if (light.isDirectionalLight) {
        const uniforms = state.directional[directionalLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = state.spot[spotLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = state.rectArea[rectAreaLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        matrix42.identity();
        matrix4.copy(light.matrixWorld);
        matrix4.premultiply(viewMatrix);
        matrix42.extractRotation(matrix4);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        uniforms.halfWidth.applyMatrix4(matrix42);
        uniforms.halfHeight.applyMatrix4(matrix42);
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = state.point[pointLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = state.hemi[hemiLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        uniforms.direction.transformDirection(viewMatrix);
        hemiLength++;
      }
    }
  }
  return {
    setup,
    setupView,
    state
  };
}
function WebGLRenderState(extensions2) {
  const lights = new WebGLLights(extensions2);
  const lightsArray = [];
  const shadowsArray = [];
  function init4(camera) {
    state.camera = camera;
    lightsArray.length = 0;
    shadowsArray.length = 0;
  }
  function pushLight(light) {
    lightsArray.push(light);
  }
  function pushShadow(shadowLight) {
    shadowsArray.push(shadowLight);
  }
  function setupLights() {
    lights.setup(lightsArray);
  }
  function setupLightsView(camera) {
    lights.setupView(lightsArray, camera);
  }
  const state = {
    lightsArray,
    shadowsArray,
    camera: null,
    lights,
    transmissionRenderTarget: {}
  };
  return {
    init: init4,
    state,
    setupLights,
    setupLightsView,
    pushLight,
    pushShadow
  };
}
function WebGLRenderStates(extensions2) {
  let renderStates = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth = 0) {
    const renderStateArray = renderStates.get(scene);
    let renderState;
    if (renderStateArray === void 0) {
      renderState = new WebGLRenderState(extensions2);
      renderStates.set(scene, [renderState]);
    } else {
      if (renderCallDepth >= renderStateArray.length) {
        renderState = new WebGLRenderState(extensions2);
        renderStateArray.push(renderState);
      } else {
        renderState = renderStateArray[renderCallDepth];
      }
    }
    return renderState;
  }
  function dispose2() {
    renderStates = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose: dispose2
  };
}
const vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function WebGLShadowMap(renderer, objects, capabilities) {
  let _frustum2 = new Frustum();
  const _shadowMapSize = new Vector2(), _viewportSize = new Vector2(), _viewport = new Vector4(), _depthMaterial = new MeshDepthMaterial({ depthPacking: RGBADepthPacking }), _distanceMaterial = new MeshDistanceMaterial(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
  const shadowSide = { [FrontSide]: BackSide, [BackSide]: FrontSide, [DoubleSide]: DoubleSide };
  const shadowMaterialVertical = new ShaderMaterial({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Vector2() },
      radius: { value: 4 }
    },
    vertexShader: vertex,
    fragmentShader: fragment
  });
  const shadowMaterialHorizontal = shadowMaterialVertical.clone();
  shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
  const fullScreenTri = new BufferGeometry();
  fullScreenTri.setAttribute(
    "position",
    new BufferAttribute(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const fullScreenMesh = new Mesh(fullScreenTri, shadowMaterialVertical);
  const scope = this;
  this.enabled = false;
  this.autoUpdate = true;
  this.needsUpdate = false;
  this.type = PCFShadowMap;
  let _previousType = this.type;
  this.render = function(lights, scene, camera) {
    if (scope.enabled === false) return;
    if (scope.autoUpdate === false && scope.needsUpdate === false) return;
    if (lights.length === 0) return;
    const currentRenderTarget = renderer.getRenderTarget();
    const activeCubeFace = renderer.getActiveCubeFace();
    const activeMipmapLevel = renderer.getActiveMipmapLevel();
    const _state = renderer.state;
    _state.setBlending(NoBlending);
    _state.buffers.color.setClear(1, 1, 1, 1);
    _state.buffers.depth.setTest(true);
    _state.setScissorTest(false);
    const toVSM = _previousType !== VSMShadowMap && this.type === VSMShadowMap;
    const fromVSM = _previousType === VSMShadowMap && this.type !== VSMShadowMap;
    for (let i2 = 0, il = lights.length; i2 < il; i2++) {
      const light = lights[i2];
      const shadow = light.shadow;
      if (shadow === void 0) {
        console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
        continue;
      }
      if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
      _shadowMapSize.copy(shadow.mapSize);
      const shadowFrameExtents = shadow.getFrameExtents();
      _shadowMapSize.multiply(shadowFrameExtents);
      _viewportSize.copy(shadow.mapSize);
      if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
        if (_shadowMapSize.x > _maxTextureSize) {
          _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
          _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
          shadow.mapSize.x = _viewportSize.x;
        }
        if (_shadowMapSize.y > _maxTextureSize) {
          _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
          _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
          shadow.mapSize.y = _viewportSize.y;
        }
      }
      if (shadow.map === null || toVSM === true || fromVSM === true) {
        const pars = this.type !== VSMShadowMap ? { minFilter: NearestFilter, magFilter: NearestFilter } : {};
        if (shadow.map !== null) {
          shadow.map.dispose();
        }
        shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.map.texture.name = light.name + ".shadowMap";
        shadow.camera.updateProjectionMatrix();
      }
      renderer.setRenderTarget(shadow.map);
      renderer.clear();
      const viewportCount = shadow.getViewportCount();
      for (let vp = 0; vp < viewportCount; vp++) {
        const viewport = shadow.getViewport(vp);
        _viewport.set(
          _viewportSize.x * viewport.x,
          _viewportSize.y * viewport.y,
          _viewportSize.x * viewport.z,
          _viewportSize.y * viewport.w
        );
        _state.viewport(_viewport);
        shadow.updateMatrices(light, vp);
        _frustum2 = shadow.getFrustum();
        renderObject(scene, camera, shadow.camera, light, this.type);
      }
      if (shadow.isPointLightShadow !== true && this.type === VSMShadowMap) {
        VSMPass(shadow, camera);
      }
      shadow.needsUpdate = false;
    }
    _previousType = this.type;
    scope.needsUpdate = false;
    renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
  };
  function VSMPass(shadow, camera) {
    const geometry = objects.update(fullScreenMesh);
    if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
      shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
      shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
      shadowMaterialVertical.needsUpdate = true;
      shadowMaterialHorizontal.needsUpdate = true;
    }
    if (shadow.mapPass === null) {
      shadow.mapPass = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y);
    }
    shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
    shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialVertical.uniforms.radius.value = shadow.radius;
    renderer.setRenderTarget(shadow.mapPass);
    renderer.clear();
    renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
    shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
    shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
    renderer.setRenderTarget(shadow.map);
    renderer.clear();
    renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
  }
  function getDepthMaterial(object, material, light, type) {
    let result = null;
    const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
    if (customMaterial !== void 0) {
      result = customMaterial;
    } else {
      result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
      if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
        const keyA = result.uuid, keyB = material.uuid;
        let materialsForVariant = _materialCache[keyA];
        if (materialsForVariant === void 0) {
          materialsForVariant = {};
          _materialCache[keyA] = materialsForVariant;
        }
        let cachedMaterial = materialsForVariant[keyB];
        if (cachedMaterial === void 0) {
          cachedMaterial = result.clone();
          materialsForVariant[keyB] = cachedMaterial;
          material.addEventListener("dispose", onMaterialDispose);
        }
        result = cachedMaterial;
      }
    }
    result.visible = material.visible;
    result.wireframe = material.wireframe;
    if (type === VSMShadowMap) {
      result.side = material.shadowSide !== null ? material.shadowSide : material.side;
    } else {
      result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
    }
    result.alphaMap = material.alphaMap;
    result.alphaTest = material.alphaTest;
    result.map = material.map;
    result.clipShadows = material.clipShadows;
    result.clippingPlanes = material.clippingPlanes;
    result.clipIntersection = material.clipIntersection;
    result.displacementMap = material.displacementMap;
    result.displacementScale = material.displacementScale;
    result.displacementBias = material.displacementBias;
    result.wireframeLinewidth = material.wireframeLinewidth;
    result.linewidth = material.linewidth;
    if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
      const materialProperties = renderer.properties.get(result);
      materialProperties.light = light;
    }
    return result;
  }
  function renderObject(object, camera, shadowCamera, light, type) {
    if (object.visible === false) return;
    const visible = object.layers.test(camera.layers);
    if (visible && (object.isMesh || object.isLine || object.isPoints)) {
      if ((object.castShadow || object.receiveShadow && type === VSMShadowMap) && (!object.frustumCulled || _frustum2.intersectsObject(object))) {
        object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
        const geometry = objects.update(object);
        const material = object.material;
        if (Array.isArray(material)) {
          const groups = geometry.groups;
          for (let k2 = 0, kl = groups.length; k2 < kl; k2++) {
            const group = groups[k2];
            const groupMaterial = material[group.materialIndex];
            if (groupMaterial && groupMaterial.visible) {
              const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
              object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
              renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
              object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
            }
          }
        } else if (material.visible) {
          const depthMaterial = getDepthMaterial(object, material, light, type);
          object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
          renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
          object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
        }
      }
    }
    const children = object.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      renderObject(children[i2], camera, shadowCamera, light, type);
    }
  }
  function onMaterialDispose(event) {
    const material = event.target;
    material.removeEventListener("dispose", onMaterialDispose);
    for (const id in _materialCache) {
      const cache = _materialCache[id];
      const uuid = event.target.uuid;
      if (uuid in cache) {
        const shadowMaterial = cache[uuid];
        shadowMaterial.dispose();
        delete cache[uuid];
      }
    }
  }
}
const reversedFuncs = {
  [NeverDepth]: AlwaysDepth,
  [LessDepth]: GreaterDepth,
  [EqualDepth]: NotEqualDepth,
  [LessEqualDepth]: GreaterEqualDepth,
  [AlwaysDepth]: NeverDepth,
  [GreaterDepth]: LessDepth,
  [NotEqualDepth]: EqualDepth,
  [GreaterEqualDepth]: LessEqualDepth
};
function WebGLState(gl, extensions2) {
  function ColorBuffer() {
    let locked = false;
    const color = new Vector4();
    let currentColorMask = null;
    const currentColorClear = new Vector4(0, 0, 0, 0);
    return {
      setMask: function(colorMask) {
        if (currentColorMask !== colorMask && !locked) {
          gl.colorMask(colorMask, colorMask, colorMask, colorMask);
          currentColorMask = colorMask;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(r3, g2, b6, a5, premultipliedAlpha) {
        if (premultipliedAlpha === true) {
          r3 *= a5;
          g2 *= a5;
          b6 *= a5;
        }
        color.set(r3, g2, b6, a5);
        if (currentColorClear.equals(color) === false) {
          gl.clearColor(r3, g2, b6, a5);
          currentColorClear.copy(color);
        }
      },
      reset: function() {
        locked = false;
        currentColorMask = null;
        currentColorClear.set(-1, 0, 0, 0);
      }
    };
  }
  function DepthBuffer() {
    let locked = false;
    let reversed = false;
    let currentDepthMask = null;
    let currentDepthFunc = null;
    let currentDepthClear = null;
    return {
      setReversed: function(value) {
        if (reversed !== value) {
          const ext = extensions2.get("EXT_clip_control");
          if (reversed) {
            ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
          } else {
            ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
          }
          const oldDepth = currentDepthClear;
          currentDepthClear = null;
          this.setClear(oldDepth);
        }
        reversed = value;
      },
      getReversed: function() {
        return reversed;
      },
      setTest: function(depthTest) {
        if (depthTest) {
          enable(gl.DEPTH_TEST);
        } else {
          disable(gl.DEPTH_TEST);
        }
      },
      setMask: function(depthMask) {
        if (currentDepthMask !== depthMask && !locked) {
          gl.depthMask(depthMask);
          currentDepthMask = depthMask;
        }
      },
      setFunc: function(depthFunc) {
        if (reversed) depthFunc = reversedFuncs[depthFunc];
        if (currentDepthFunc !== depthFunc) {
          switch (depthFunc) {
            case NeverDepth:
              gl.depthFunc(gl.NEVER);
              break;
            case AlwaysDepth:
              gl.depthFunc(gl.ALWAYS);
              break;
            case LessDepth:
              gl.depthFunc(gl.LESS);
              break;
            case LessEqualDepth:
              gl.depthFunc(gl.LEQUAL);
              break;
            case EqualDepth:
              gl.depthFunc(gl.EQUAL);
              break;
            case GreaterEqualDepth:
              gl.depthFunc(gl.GEQUAL);
              break;
            case GreaterDepth:
              gl.depthFunc(gl.GREATER);
              break;
            case NotEqualDepth:
              gl.depthFunc(gl.NOTEQUAL);
              break;
            default:
              gl.depthFunc(gl.LEQUAL);
          }
          currentDepthFunc = depthFunc;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(depth) {
        if (currentDepthClear !== depth) {
          if (reversed) {
            depth = 1 - depth;
          }
          gl.clearDepth(depth);
          currentDepthClear = depth;
        }
      },
      reset: function() {
        locked = false;
        currentDepthMask = null;
        currentDepthFunc = null;
        currentDepthClear = null;
        reversed = false;
      }
    };
  }
  function StencilBuffer() {
    let locked = false;
    let currentStencilMask = null;
    let currentStencilFunc = null;
    let currentStencilRef = null;
    let currentStencilFuncMask = null;
    let currentStencilFail = null;
    let currentStencilZFail = null;
    let currentStencilZPass = null;
    let currentStencilClear = null;
    return {
      setTest: function(stencilTest) {
        if (!locked) {
          if (stencilTest) {
            enable(gl.STENCIL_TEST);
          } else {
            disable(gl.STENCIL_TEST);
          }
        }
      },
      setMask: function(stencilMask) {
        if (currentStencilMask !== stencilMask && !locked) {
          gl.stencilMask(stencilMask);
          currentStencilMask = stencilMask;
        }
      },
      setFunc: function(stencilFunc, stencilRef, stencilMask) {
        if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
          gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
          currentStencilFunc = stencilFunc;
          currentStencilRef = stencilRef;
          currentStencilFuncMask = stencilMask;
        }
      },
      setOp: function(stencilFail, stencilZFail, stencilZPass) {
        if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
          gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
          currentStencilFail = stencilFail;
          currentStencilZFail = stencilZFail;
          currentStencilZPass = stencilZPass;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(stencil) {
        if (currentStencilClear !== stencil) {
          gl.clearStencil(stencil);
          currentStencilClear = stencil;
        }
      },
      reset: function() {
        locked = false;
        currentStencilMask = null;
        currentStencilFunc = null;
        currentStencilRef = null;
        currentStencilFuncMask = null;
        currentStencilFail = null;
        currentStencilZFail = null;
        currentStencilZPass = null;
        currentStencilClear = null;
      }
    };
  }
  const colorBuffer = new ColorBuffer();
  const depthBuffer = new DepthBuffer();
  const stencilBuffer = new StencilBuffer();
  const uboBindings = /* @__PURE__ */ new WeakMap();
  const uboProgramMap = /* @__PURE__ */ new WeakMap();
  let enabledCapabilities = {};
  let currentBoundFramebuffers = {};
  let currentDrawbuffers = /* @__PURE__ */ new WeakMap();
  let defaultDrawbuffers = [];
  let currentProgram = null;
  let currentBlendingEnabled = false;
  let currentBlending = null;
  let currentBlendEquation = null;
  let currentBlendSrc = null;
  let currentBlendDst = null;
  let currentBlendEquationAlpha = null;
  let currentBlendSrcAlpha = null;
  let currentBlendDstAlpha = null;
  let currentBlendColor = new Color(0, 0, 0);
  let currentBlendAlpha = 0;
  let currentPremultipledAlpha = false;
  let currentFlipSided = null;
  let currentCullFace = null;
  let currentLineWidth = null;
  let currentPolygonOffsetFactor = null;
  let currentPolygonOffsetUnits = null;
  const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let lineWidthAvailable = false;
  let version2 = 0;
  const glVersion = gl.getParameter(gl.VERSION);
  if (glVersion.indexOf("WebGL") !== -1) {
    version2 = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version2 >= 1;
  } else if (glVersion.indexOf("OpenGL ES") !== -1) {
    version2 = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version2 >= 2;
  }
  let currentTextureSlot = null;
  let currentBoundTextures = {};
  const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
  const viewportParam = gl.getParameter(gl.VIEWPORT);
  const currentScissor = new Vector4().fromArray(scissorParam);
  const currentViewport = new Vector4().fromArray(viewportParam);
  function createTexture(type, target, count, dimensions) {
    const data = new Uint8Array(4);
    const texture = gl.createTexture();
    gl.bindTexture(type, texture);
    gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    for (let i2 = 0; i2 < count; i2++) {
      if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) {
        gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
      } else {
        gl.texImage2D(target + i2, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
      }
    }
    return texture;
  }
  const emptyTextures = {};
  emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
  emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
  emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
  emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
  colorBuffer.setClear(0, 0, 0, 1);
  depthBuffer.setClear(1);
  stencilBuffer.setClear(0);
  enable(gl.DEPTH_TEST);
  depthBuffer.setFunc(LessEqualDepth);
  setFlipSided(false);
  setCullFace(CullFaceBack);
  enable(gl.CULL_FACE);
  setBlending(NoBlending);
  function enable(id) {
    if (enabledCapabilities[id] !== true) {
      gl.enable(id);
      enabledCapabilities[id] = true;
    }
  }
  function disable(id) {
    if (enabledCapabilities[id] !== false) {
      gl.disable(id);
      enabledCapabilities[id] = false;
    }
  }
  function bindFramebuffer(target, framebuffer) {
    if (currentBoundFramebuffers[target] !== framebuffer) {
      gl.bindFramebuffer(target, framebuffer);
      currentBoundFramebuffers[target] = framebuffer;
      if (target === gl.DRAW_FRAMEBUFFER) {
        currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
      }
      if (target === gl.FRAMEBUFFER) {
        currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
      }
      return true;
    }
    return false;
  }
  function drawBuffers(renderTarget, framebuffer) {
    let drawBuffers2 = defaultDrawbuffers;
    let needsUpdate = false;
    if (renderTarget) {
      drawBuffers2 = currentDrawbuffers.get(framebuffer);
      if (drawBuffers2 === void 0) {
        drawBuffers2 = [];
        currentDrawbuffers.set(framebuffer, drawBuffers2);
      }
      const textures = renderTarget.textures;
      if (drawBuffers2.length !== textures.length || drawBuffers2[0] !== gl.COLOR_ATTACHMENT0) {
        for (let i2 = 0, il = textures.length; i2 < il; i2++) {
          drawBuffers2[i2] = gl.COLOR_ATTACHMENT0 + i2;
        }
        drawBuffers2.length = textures.length;
        needsUpdate = true;
      }
    } else {
      if (drawBuffers2[0] !== gl.BACK) {
        drawBuffers2[0] = gl.BACK;
        needsUpdate = true;
      }
    }
    if (needsUpdate) {
      gl.drawBuffers(drawBuffers2);
    }
  }
  function useProgram(program) {
    if (currentProgram !== program) {
      gl.useProgram(program);
      currentProgram = program;
      return true;
    }
    return false;
  }
  const equationToGL = {
    [AddEquation]: gl.FUNC_ADD,
    [SubtractEquation]: gl.FUNC_SUBTRACT,
    [ReverseSubtractEquation]: gl.FUNC_REVERSE_SUBTRACT
  };
  equationToGL[MinEquation] = gl.MIN;
  equationToGL[MaxEquation] = gl.MAX;
  const factorToGL = {
    [ZeroFactor]: gl.ZERO,
    [OneFactor]: gl.ONE,
    [SrcColorFactor]: gl.SRC_COLOR,
    [SrcAlphaFactor]: gl.SRC_ALPHA,
    [SrcAlphaSaturateFactor]: gl.SRC_ALPHA_SATURATE,
    [DstColorFactor]: gl.DST_COLOR,
    [DstAlphaFactor]: gl.DST_ALPHA,
    [OneMinusSrcColorFactor]: gl.ONE_MINUS_SRC_COLOR,
    [OneMinusSrcAlphaFactor]: gl.ONE_MINUS_SRC_ALPHA,
    [OneMinusDstColorFactor]: gl.ONE_MINUS_DST_COLOR,
    [OneMinusDstAlphaFactor]: gl.ONE_MINUS_DST_ALPHA,
    [ConstantColorFactor]: gl.CONSTANT_COLOR,
    [OneMinusConstantColorFactor]: gl.ONE_MINUS_CONSTANT_COLOR,
    [ConstantAlphaFactor]: gl.CONSTANT_ALPHA,
    [OneMinusConstantAlphaFactor]: gl.ONE_MINUS_CONSTANT_ALPHA
  };
  function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
    if (blending === NoBlending) {
      if (currentBlendingEnabled === true) {
        disable(gl.BLEND);
        currentBlendingEnabled = false;
      }
      return;
    }
    if (currentBlendingEnabled === false) {
      enable(gl.BLEND);
      currentBlendingEnabled = true;
    }
    if (blending !== CustomBlending) {
      if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
        if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {
          gl.blendEquation(gl.FUNC_ADD);
          currentBlendEquation = AddEquation;
          currentBlendEquationAlpha = AddEquation;
        }
        if (premultipliedAlpha) {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending:
              gl.blendFunc(gl.ONE, gl.ONE);
              break;
            case SubtractiveBlending:
              gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
              break;
            case MultiplyBlending:
              gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        } else {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending:
              gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
              break;
            case SubtractiveBlending:
              gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
              break;
            case MultiplyBlending:
              gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        }
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor.set(0, 0, 0);
        currentBlendAlpha = 0;
        currentBlending = blending;
        currentPremultipledAlpha = premultipliedAlpha;
      }
      return;
    }
    blendEquationAlpha = blendEquationAlpha || blendEquation;
    blendSrcAlpha = blendSrcAlpha || blendSrc;
    blendDstAlpha = blendDstAlpha || blendDst;
    if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
      gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
      currentBlendEquation = blendEquation;
      currentBlendEquationAlpha = blendEquationAlpha;
    }
    if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
      gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
      currentBlendSrc = blendSrc;
      currentBlendDst = blendDst;
      currentBlendSrcAlpha = blendSrcAlpha;
      currentBlendDstAlpha = blendDstAlpha;
    }
    if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
      gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
      currentBlendColor.copy(blendColor);
      currentBlendAlpha = blendAlpha;
    }
    currentBlending = blending;
    currentPremultipledAlpha = false;
  }
  function setMaterial(material, frontFaceCW) {
    material.side === DoubleSide ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
    let flipSided = material.side === BackSide;
    if (frontFaceCW) flipSided = !flipSided;
    setFlipSided(flipSided);
    material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
    depthBuffer.setFunc(material.depthFunc);
    depthBuffer.setTest(material.depthTest);
    depthBuffer.setMask(material.depthWrite);
    colorBuffer.setMask(material.colorWrite);
    const stencilWrite = material.stencilWrite;
    stencilBuffer.setTest(stencilWrite);
    if (stencilWrite) {
      stencilBuffer.setMask(material.stencilWriteMask);
      stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
      stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
    }
    setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
    material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function setFlipSided(flipSided) {
    if (currentFlipSided !== flipSided) {
      if (flipSided) {
        gl.frontFace(gl.CW);
      } else {
        gl.frontFace(gl.CCW);
      }
      currentFlipSided = flipSided;
    }
  }
  function setCullFace(cullFace) {
    if (cullFace !== CullFaceNone) {
      enable(gl.CULL_FACE);
      if (cullFace !== currentCullFace) {
        if (cullFace === CullFaceBack) {
          gl.cullFace(gl.BACK);
        } else if (cullFace === CullFaceFront) {
          gl.cullFace(gl.FRONT);
        } else {
          gl.cullFace(gl.FRONT_AND_BACK);
        }
      }
    } else {
      disable(gl.CULL_FACE);
    }
    currentCullFace = cullFace;
  }
  function setLineWidth(width) {
    if (width !== currentLineWidth) {
      if (lineWidthAvailable) gl.lineWidth(width);
      currentLineWidth = width;
    }
  }
  function setPolygonOffset(polygonOffset, factor, units) {
    if (polygonOffset) {
      enable(gl.POLYGON_OFFSET_FILL);
      if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
        gl.polygonOffset(factor, units);
        currentPolygonOffsetFactor = factor;
        currentPolygonOffsetUnits = units;
      }
    } else {
      disable(gl.POLYGON_OFFSET_FILL);
    }
  }
  function setScissorTest(scissorTest) {
    if (scissorTest) {
      enable(gl.SCISSOR_TEST);
    } else {
      disable(gl.SCISSOR_TEST);
    }
  }
  function activeTexture(webglSlot) {
    if (webglSlot === void 0) webglSlot = gl.TEXTURE0 + maxTextures - 1;
    if (currentTextureSlot !== webglSlot) {
      gl.activeTexture(webglSlot);
      currentTextureSlot = webglSlot;
    }
  }
  function bindTexture(webglType, webglTexture, webglSlot) {
    if (webglSlot === void 0) {
      if (currentTextureSlot === null) {
        webglSlot = gl.TEXTURE0 + maxTextures - 1;
      } else {
        webglSlot = currentTextureSlot;
      }
    }
    let boundTexture = currentBoundTextures[webglSlot];
    if (boundTexture === void 0) {
      boundTexture = { type: void 0, texture: void 0 };
      currentBoundTextures[webglSlot] = boundTexture;
    }
    if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
      if (currentTextureSlot !== webglSlot) {
        gl.activeTexture(webglSlot);
        currentTextureSlot = webglSlot;
      }
      gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
      boundTexture.type = webglType;
      boundTexture.texture = webglTexture;
    }
  }
  function unbindTexture() {
    const boundTexture = currentBoundTextures[currentTextureSlot];
    if (boundTexture !== void 0 && boundTexture.type !== void 0) {
      gl.bindTexture(boundTexture.type, null);
      boundTexture.type = void 0;
      boundTexture.texture = void 0;
    }
  }
  function compressedTexImage2D() {
    try {
      gl.compressedTexImage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function compressedTexImage3D() {
    try {
      gl.compressedTexImage3D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texSubImage2D() {
    try {
      gl.texSubImage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texSubImage3D() {
    try {
      gl.texSubImage3D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function compressedTexSubImage2D() {
    try {
      gl.compressedTexSubImage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function compressedTexSubImage3D() {
    try {
      gl.compressedTexSubImage3D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texStorage2D() {
    try {
      gl.texStorage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texStorage3D() {
    try {
      gl.texStorage3D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texImage2D() {
    try {
      gl.texImage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texImage3D() {
    try {
      gl.texImage3D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function scissor(scissor2) {
    if (currentScissor.equals(scissor2) === false) {
      gl.scissor(scissor2.x, scissor2.y, scissor2.z, scissor2.w);
      currentScissor.copy(scissor2);
    }
  }
  function viewport(viewport2) {
    if (currentViewport.equals(viewport2) === false) {
      gl.viewport(viewport2.x, viewport2.y, viewport2.z, viewport2.w);
      currentViewport.copy(viewport2);
    }
  }
  function updateUBOMapping(uniformsGroup, program) {
    let mapping = uboProgramMap.get(program);
    if (mapping === void 0) {
      mapping = /* @__PURE__ */ new WeakMap();
      uboProgramMap.set(program, mapping);
    }
    let blockIndex = mapping.get(uniformsGroup);
    if (blockIndex === void 0) {
      blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
      mapping.set(uniformsGroup, blockIndex);
    }
  }
  function uniformBlockBinding(uniformsGroup, program) {
    const mapping = uboProgramMap.get(program);
    const blockIndex = mapping.get(uniformsGroup);
    if (uboBindings.get(program) !== blockIndex) {
      gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
      uboBindings.set(program, blockIndex);
    }
  }
  function reset() {
    gl.disable(gl.BLEND);
    gl.disable(gl.CULL_FACE);
    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.POLYGON_OFFSET_FILL);
    gl.disable(gl.SCISSOR_TEST);
    gl.disable(gl.STENCIL_TEST);
    gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    gl.blendEquation(gl.FUNC_ADD);
    gl.blendFunc(gl.ONE, gl.ZERO);
    gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
    gl.blendColor(0, 0, 0, 0);
    gl.colorMask(true, true, true, true);
    gl.clearColor(0, 0, 0, 0);
    gl.depthMask(true);
    gl.depthFunc(gl.LESS);
    depthBuffer.setReversed(false);
    gl.clearDepth(1);
    gl.stencilMask(4294967295);
    gl.stencilFunc(gl.ALWAYS, 0, 4294967295);
    gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    gl.clearStencil(0);
    gl.cullFace(gl.BACK);
    gl.frontFace(gl.CCW);
    gl.polygonOffset(0, 0);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
    gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
    gl.useProgram(null);
    gl.lineWidth(1);
    gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
    enabledCapabilities = {};
    currentTextureSlot = null;
    currentBoundTextures = {};
    currentBoundFramebuffers = {};
    currentDrawbuffers = /* @__PURE__ */ new WeakMap();
    defaultDrawbuffers = [];
    currentProgram = null;
    currentBlendingEnabled = false;
    currentBlending = null;
    currentBlendEquation = null;
    currentBlendSrc = null;
    currentBlendDst = null;
    currentBlendEquationAlpha = null;
    currentBlendSrcAlpha = null;
    currentBlendDstAlpha = null;
    currentBlendColor = new Color(0, 0, 0);
    currentBlendAlpha = 0;
    currentPremultipledAlpha = false;
    currentFlipSided = null;
    currentCullFace = null;
    currentLineWidth = null;
    currentPolygonOffsetFactor = null;
    currentPolygonOffsetUnits = null;
    currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
    currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
    colorBuffer.reset();
    depthBuffer.reset();
    stencilBuffer.reset();
  }
  return {
    buffers: {
      color: colorBuffer,
      depth: depthBuffer,
      stencil: stencilBuffer
    },
    enable,
    disable,
    bindFramebuffer,
    drawBuffers,
    useProgram,
    setBlending,
    setMaterial,
    setFlipSided,
    setCullFace,
    setLineWidth,
    setPolygonOffset,
    setScissorTest,
    activeTexture,
    bindTexture,
    unbindTexture,
    compressedTexImage2D,
    compressedTexImage3D,
    texImage2D,
    texImage3D,
    updateUBOMapping,
    uniformBlockBinding,
    texStorage2D,
    texStorage3D,
    texSubImage2D,
    texSubImage3D,
    compressedTexSubImage2D,
    compressedTexSubImage3D,
    scissor,
    viewport,
    reset
  };
}
function WebGLTextures(_gl, extensions2, state, properties, capabilities, utils, info) {
  const multisampledRTTExt = extensions2.has("WEBGL_multisampled_render_to_texture") ? extensions2.get("WEBGL_multisampled_render_to_texture") : null;
  const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
  const _imageDimensions = new Vector2();
  const _videoTextures = /* @__PURE__ */ new WeakMap();
  let _canvas2;
  const _sources = /* @__PURE__ */ new WeakMap();
  let useOffscreenCanvas = false;
  try {
    useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch (err) {
  }
  function createCanvas(width, height) {
    return useOffscreenCanvas ? (
      // eslint-disable-next-line compat/compat
      new OffscreenCanvas(width, height)
    ) : createElementNS("canvas");
  }
  function resizeImage(image, needsNewCanvas, maxSize) {
    let scale = 1;
    const dimensions = getDimensions(image);
    if (dimensions.width > maxSize || dimensions.height > maxSize) {
      scale = maxSize / Math.max(dimensions.width, dimensions.height);
    }
    if (scale < 1) {
      if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap || typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
        const width = Math.floor(scale * dimensions.width);
        const height = Math.floor(scale * dimensions.height);
        if (_canvas2 === void 0) _canvas2 = createCanvas(width, height);
        const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas2;
        canvas.width = width;
        canvas.height = height;
        const context4 = canvas.getContext("2d");
        context4.drawImage(image, 0, 0, width, height);
        console.warn("THREE.WebGLRenderer: Texture has been resized from (" + dimensions.width + "x" + dimensions.height + ") to (" + width + "x" + height + ").");
        return canvas;
      } else {
        if ("data" in image) {
          console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + dimensions.width + "x" + dimensions.height + ").");
        }
        return image;
      }
    }
    return image;
  }
  function textureNeedsGenerateMipmaps(texture) {
    return texture.generateMipmaps;
  }
  function generateMipmap(target) {
    _gl.generateMipmap(target);
  }
  function getTargetType(texture) {
    if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
    if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
    if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
    return _gl.TEXTURE_2D;
  }
  function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
    if (internalFormatName !== null) {
      if (_gl[internalFormatName] !== void 0) return _gl[internalFormatName];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
    }
    let internalFormat = glFormat;
    if (glFormat === _gl.RED) {
      if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
      if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
    }
    if (glFormat === _gl.RED_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.R8I;
      if (glType === _gl.SHORT) internalFormat = _gl.R16I;
      if (glType === _gl.INT) internalFormat = _gl.R32I;
    }
    if (glFormat === _gl.RG) {
      if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
      if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
    }
    if (glFormat === _gl.RG_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
      if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
      if (glType === _gl.INT) internalFormat = _gl.RG32I;
    }
    if (glFormat === _gl.RGB_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
      if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
      if (glType === _gl.INT) internalFormat = _gl.RGB32I;
    }
    if (glFormat === _gl.RGBA_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
      if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
      if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
    }
    if (glFormat === _gl.RGB) {
      if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
    }
    if (glFormat === _gl.RGBA) {
      const transfer = forceLinearTransfer ? LinearTransfer : ColorManagement.getTransfer(colorSpace);
      if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
      if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === SRGBTransfer ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
      if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
      if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
    }
    if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) {
      extensions2.get("EXT_color_buffer_float");
    }
    return internalFormat;
  }
  function getInternalDepthFormat(useStencil, depthType) {
    let glInternalFormat;
    if (useStencil) {
      if (depthType === null || depthType === UnsignedIntType || depthType === UnsignedInt248Type) {
        glInternalFormat = _gl.DEPTH24_STENCIL8;
      } else if (depthType === FloatType) {
        glInternalFormat = _gl.DEPTH32F_STENCIL8;
      } else if (depthType === UnsignedShortType) {
        glInternalFormat = _gl.DEPTH24_STENCIL8;
        console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.");
      }
    } else {
      if (depthType === null || depthType === UnsignedIntType || depthType === UnsignedInt248Type) {
        glInternalFormat = _gl.DEPTH_COMPONENT24;
      } else if (depthType === FloatType) {
        glInternalFormat = _gl.DEPTH_COMPONENT32F;
      } else if (depthType === UnsignedShortType) {
        glInternalFormat = _gl.DEPTH_COMPONENT16;
      }
    }
    return glInternalFormat;
  }
  function getMipLevels(texture, image) {
    if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {
      return Math.log2(Math.max(image.width, image.height)) + 1;
    } else if (texture.mipmaps !== void 0 && texture.mipmaps.length > 0) {
      return texture.mipmaps.length;
    } else if (texture.isCompressedTexture && Array.isArray(texture.image)) {
      return image.mipmaps.length;
    } else {
      return 1;
    }
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    deallocateTexture(texture);
    if (texture.isVideoTexture) {
      _videoTextures.delete(texture);
    }
  }
  function onRenderTargetDispose(event) {
    const renderTarget = event.target;
    renderTarget.removeEventListener("dispose", onRenderTargetDispose);
    deallocateRenderTarget(renderTarget);
  }
  function deallocateTexture(texture) {
    const textureProperties = properties.get(texture);
    if (textureProperties.__webglInit === void 0) return;
    const source = texture.source;
    const webglTextures = _sources.get(source);
    if (webglTextures) {
      const webglTexture = webglTextures[textureProperties.__cacheKey];
      webglTexture.usedTimes--;
      if (webglTexture.usedTimes === 0) {
        deleteTexture(texture);
      }
      if (Object.keys(webglTextures).length === 0) {
        _sources.delete(source);
      }
    }
    properties.remove(texture);
  }
  function deleteTexture(texture) {
    const textureProperties = properties.get(texture);
    _gl.deleteTexture(textureProperties.__webglTexture);
    const source = texture.source;
    const webglTextures = _sources.get(source);
    delete webglTextures[textureProperties.__cacheKey];
    info.memory.textures--;
  }
  function deallocateRenderTarget(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    if (renderTarget.depthTexture) {
      renderTarget.depthTexture.dispose();
      properties.remove(renderTarget.depthTexture);
    }
    if (renderTarget.isWebGLCubeRenderTarget) {
      for (let i2 = 0; i2 < 6; i2++) {
        if (Array.isArray(renderTargetProperties.__webglFramebuffer[i2])) {
          for (let level = 0; level < renderTargetProperties.__webglFramebuffer[i2].length; level++) _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i2][level]);
        } else {
          _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i2]);
        }
        if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i2]);
      }
    } else {
      if (Array.isArray(renderTargetProperties.__webglFramebuffer)) {
        for (let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++) _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
      } else {
        _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
      }
      if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
      if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
      if (renderTargetProperties.__webglColorRenderbuffer) {
        for (let i2 = 0; i2 < renderTargetProperties.__webglColorRenderbuffer.length; i2++) {
          if (renderTargetProperties.__webglColorRenderbuffer[i2]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i2]);
        }
      }
      if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
    }
    const textures = renderTarget.textures;
    for (let i2 = 0, il = textures.length; i2 < il; i2++) {
      const attachmentProperties = properties.get(textures[i2]);
      if (attachmentProperties.__webglTexture) {
        _gl.deleteTexture(attachmentProperties.__webglTexture);
        info.memory.textures--;
      }
      properties.remove(textures[i2]);
    }
    properties.remove(renderTarget);
  }
  let textureUnits = 0;
  function resetTextureUnits() {
    textureUnits = 0;
  }
  function allocateTextureUnit() {
    const textureUnit = textureUnits;
    if (textureUnit >= capabilities.maxTextures) {
      console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + capabilities.maxTextures);
    }
    textureUnits += 1;
    return textureUnit;
  }
  function getTextureCacheKey(texture) {
    const array = [];
    array.push(texture.wrapS);
    array.push(texture.wrapT);
    array.push(texture.wrapR || 0);
    array.push(texture.magFilter);
    array.push(texture.minFilter);
    array.push(texture.anisotropy);
    array.push(texture.internalFormat);
    array.push(texture.format);
    array.push(texture.type);
    array.push(texture.generateMipmaps);
    array.push(texture.premultiplyAlpha);
    array.push(texture.flipY);
    array.push(texture.unpackAlignment);
    array.push(texture.colorSpace);
    return array.join();
  }
  function setTexture2D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.isVideoTexture) updateVideoTexture(texture);
    if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
      const image = texture.image;
      if (image === null) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      } else if (image.complete === false) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      } else {
        uploadTexture(textureProperties, texture, slot);
        return;
      }
    }
    state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  function setTexture2DArray(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  function setTexture3D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  function setTextureCube(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadCubeTexture(textureProperties, texture, slot);
      return;
    }
    state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  const wrappingToGL = {
    [RepeatWrapping]: _gl.REPEAT,
    [ClampToEdgeWrapping]: _gl.CLAMP_TO_EDGE,
    [MirroredRepeatWrapping]: _gl.MIRRORED_REPEAT
  };
  const filterToGL = {
    [NearestFilter]: _gl.NEAREST,
    [NearestMipmapNearestFilter]: _gl.NEAREST_MIPMAP_NEAREST,
    [NearestMipmapLinearFilter]: _gl.NEAREST_MIPMAP_LINEAR,
    [LinearFilter]: _gl.LINEAR,
    [LinearMipmapNearestFilter]: _gl.LINEAR_MIPMAP_NEAREST,
    [LinearMipmapLinearFilter]: _gl.LINEAR_MIPMAP_LINEAR
  };
  const compareToGL = {
    [NeverCompare]: _gl.NEVER,
    [AlwaysCompare]: _gl.ALWAYS,
    [LessCompare]: _gl.LESS,
    [LessEqualCompare]: _gl.LEQUAL,
    [EqualCompare]: _gl.EQUAL,
    [GreaterEqualCompare]: _gl.GEQUAL,
    [GreaterCompare]: _gl.GREATER,
    [NotEqualCompare]: _gl.NOTEQUAL
  };
  function setTextureParameters(textureType, texture) {
    if (texture.type === FloatType && extensions2.has("OES_texture_float_linear") === false && (texture.magFilter === LinearFilter || texture.magFilter === LinearMipmapNearestFilter || texture.magFilter === NearestMipmapLinearFilter || texture.magFilter === LinearMipmapLinearFilter || texture.minFilter === LinearFilter || texture.minFilter === LinearMipmapNearestFilter || texture.minFilter === NearestMipmapLinearFilter || texture.minFilter === LinearMipmapLinearFilter)) {
      console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.");
    }
    _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
    _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
    if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) {
      _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
    }
    _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
    _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
    if (texture.compareFunction) {
      _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
      _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
    }
    if (extensions2.has("EXT_texture_filter_anisotropic") === true) {
      if (texture.magFilter === NearestFilter) return;
      if (texture.minFilter !== NearestMipmapLinearFilter && texture.minFilter !== LinearMipmapLinearFilter) return;
      if (texture.type === FloatType && extensions2.has("OES_texture_float_linear") === false) return;
      if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
        const extension = extensions2.get("EXT_texture_filter_anisotropic");
        _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
        properties.get(texture).__currentAnisotropy = texture.anisotropy;
      }
    }
  }
  function initTexture(textureProperties, texture) {
    let forceUpload = false;
    if (textureProperties.__webglInit === void 0) {
      textureProperties.__webglInit = true;
      texture.addEventListener("dispose", onTextureDispose);
    }
    const source = texture.source;
    let webglTextures = _sources.get(source);
    if (webglTextures === void 0) {
      webglTextures = {};
      _sources.set(source, webglTextures);
    }
    const textureCacheKey = getTextureCacheKey(texture);
    if (textureCacheKey !== textureProperties.__cacheKey) {
      if (webglTextures[textureCacheKey] === void 0) {
        webglTextures[textureCacheKey] = {
          texture: _gl.createTexture(),
          usedTimes: 0
        };
        info.memory.textures++;
        forceUpload = true;
      }
      webglTextures[textureCacheKey].usedTimes++;
      const webglTexture = webglTextures[textureProperties.__cacheKey];
      if (webglTexture !== void 0) {
        webglTextures[textureProperties.__cacheKey].usedTimes--;
        if (webglTexture.usedTimes === 0) {
          deleteTexture(texture);
        }
      }
      textureProperties.__cacheKey = textureCacheKey;
      textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
    }
    return forceUpload;
  }
  function uploadTexture(textureProperties, texture, slot) {
    let textureType = _gl.TEXTURE_2D;
    if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
    if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
    const forceUpload = initTexture(textureProperties, texture);
    const source = texture.source;
    state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    const sourceProperties = properties.get(source);
    if (source.version !== sourceProperties.__version || forceUpload === true) {
      state.activeTexture(_gl.TEXTURE0 + slot);
      const workingPrimaries = ColorManagement.getPrimaries(ColorManagement.workingColorSpace);
      const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(texture.colorSpace);
      const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
      _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
      _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
      _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
      _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
      let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
      image = verifyColorSpace(texture, image);
      const glFormat = utils.convert(texture.format, texture.colorSpace);
      const glType = utils.convert(texture.type);
      let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
      setTextureParameters(textureType, texture);
      let mipmap;
      const mipmaps = texture.mipmaps;
      const useTexStorage = texture.isVideoTexture !== true;
      const allocateMemory = sourceProperties.__version === void 0 || forceUpload === true;
      const dataReady = source.dataReady;
      const levels = getMipLevels(texture, image);
      if (texture.isDepthTexture) {
        glInternalFormat = getInternalDepthFormat(texture.format === DepthStencilFormat, texture.type);
        if (allocateMemory) {
          if (useTexStorage) {
            state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
          } else {
            state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
          }
        }
      } else if (texture.isDataTexture) {
        if (mipmaps.length > 0) {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
          }
          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
            }
            if (dataReady) {
              state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
            }
          } else {
            state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
          }
        }
      } else if (texture.isCompressedTexture) {
        if (texture.isCompressedArrayTexture) {
          if (useTexStorage && allocateMemory) {
            state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (texture.format !== RGBAFormat) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  if (dataReady) {
                    if (texture.layerUpdates.size > 0) {
                      const layerByteLength = getByteLength(mipmap.width, mipmap.height, texture.format, texture.type);
                      for (const layerIndex of texture.layerUpdates) {
                        const layerData = mipmap.data.subarray(
                          layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT,
                          (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT
                        );
                        state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i2, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                      }
                      texture.clearLayerUpdates();
                    } else {
                      state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i2, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                    }
                  }
                } else {
                  state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i2, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i2, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage3D(_gl.TEXTURE_2D_ARRAY, i2, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        } else {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (texture.format !== RGBAFormat) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  if (dataReady) {
                    state.compressedTexSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                  }
                } else {
                  state.compressedTexImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        }
      } else if (texture.isDataArrayTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
          }
          if (dataReady) {
            if (texture.layerUpdates.size > 0) {
              const layerByteLength = getByteLength(image.width, image.height, texture.format, texture.type);
              for (const layerIndex of texture.layerUpdates) {
                const layerData = image.data.subarray(
                  layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT,
                  (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT
                );
                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
              }
              texture.clearLayerUpdates();
            } else {
              state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
            }
          }
        } else {
          state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        }
      } else if (texture.isData3DTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
          }
          if (dataReady) {
            state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
          }
        } else {
          state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        }
      } else if (texture.isFramebufferTexture) {
        if (allocateMemory) {
          if (useTexStorage) {
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
          } else {
            let width = image.width, height = image.height;
            for (let i2 = 0; i2 < levels; i2++) {
              state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, width, height, 0, glFormat, glType, null);
              width >>= 1;
              height >>= 1;
            }
          }
        }
      } else {
        if (mipmaps.length > 0) {
          if (useTexStorage && allocateMemory) {
            const dimensions = getDimensions(mipmaps[0]);
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, glFormat, glType, mipmap);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, glFormat, glType, mipmap);
            }
          }
          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              const dimensions = getDimensions(image);
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
            }
            if (dataReady) {
              state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
            }
          } else {
            state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
          }
        }
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(textureType);
      }
      sourceProperties.__version = source.version;
      if (texture.onUpdate) texture.onUpdate(texture);
    }
    textureProperties.__version = texture.version;
  }
  function uploadCubeTexture(textureProperties, texture, slot) {
    if (texture.image.length !== 6) return;
    const forceUpload = initTexture(textureProperties, texture);
    const source = texture.source;
    state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    const sourceProperties = properties.get(source);
    if (source.version !== sourceProperties.__version || forceUpload === true) {
      state.activeTexture(_gl.TEXTURE0 + slot);
      const workingPrimaries = ColorManagement.getPrimaries(ColorManagement.workingColorSpace);
      const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(texture.colorSpace);
      const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
      _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
      _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
      _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
      _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
      const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
      const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
      const cubeImage = [];
      for (let i2 = 0; i2 < 6; i2++) {
        if (!isCompressed && !isDataTexture) {
          cubeImage[i2] = resizeImage(texture.image[i2], true, capabilities.maxCubemapSize);
        } else {
          cubeImage[i2] = isDataTexture ? texture.image[i2].image : texture.image[i2];
        }
        cubeImage[i2] = verifyColorSpace(texture, cubeImage[i2]);
      }
      const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
      const useTexStorage = texture.isVideoTexture !== true;
      const allocateMemory = sourceProperties.__version === void 0 || forceUpload === true;
      const dataReady = source.dataReady;
      let levels = getMipLevels(texture, image);
      setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
      let mipmaps;
      if (isCompressed) {
        if (useTexStorage && allocateMemory) {
          state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
        }
        for (let i2 = 0; i2 < 6; i2++) {
          mipmaps = cubeImage[i2].mipmaps;
          for (let j3 = 0; j3 < mipmaps.length; j3++) {
            const mipmap = mipmaps[j3];
            if (texture.format !== RGBAFormat) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  if (dataReady) {
                    state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j3, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                  }
                } else {
                  state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j3, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j3, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j3, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        }
      } else {
        mipmaps = texture.mipmaps;
        if (useTexStorage && allocateMemory) {
          if (mipmaps.length > 0) levels++;
          const dimensions = getDimensions(cubeImage[0]);
          state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
        }
        for (let i2 = 0; i2 < 6; i2++) {
          if (isDataTexture) {
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, cubeImage[i2].width, cubeImage[i2].height, glFormat, glType, cubeImage[i2].data);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, cubeImage[i2].width, cubeImage[i2].height, 0, glFormat, glType, cubeImage[i2].data);
            }
            for (let j3 = 0; j3 < mipmaps.length; j3++) {
              const mipmap = mipmaps[j3];
              const mipmapImage = mipmap.image[i2].image;
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j3 + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j3 + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
              }
            }
          } else {
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, glFormat, glType, cubeImage[i2]);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, glFormat, glType, cubeImage[i2]);
            }
            for (let j3 = 0; j3 < mipmaps.length; j3++) {
              const mipmap = mipmaps[j3];
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j3 + 1, 0, 0, glFormat, glType, mipmap.image[i2]);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j3 + 1, glInternalFormat, glFormat, glType, mipmap.image[i2]);
              }
            }
          }
        }
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(_gl.TEXTURE_CUBE_MAP);
      }
      sourceProperties.__version = source.version;
      if (texture.onUpdate) texture.onUpdate(texture);
    }
    textureProperties.__version = texture.version;
  }
  function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
    const glFormat = utils.convert(texture.format, texture.colorSpace);
    const glType = utils.convert(texture.type);
    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    textureProperties.__renderTarget = renderTarget;
    if (!renderTargetProperties.__hasExternalTextures) {
      const width = Math.max(1, renderTarget.width >> level);
      const height = Math.max(1, renderTarget.height >> level);
      if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) {
        state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
      } else {
        state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
      }
    }
    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
    if (useMultisampledRTT(renderTarget)) {
      multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
    } else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) {
      _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
    }
    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
  }
  function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
    if (renderTarget.depthBuffer) {
      const depthTexture = renderTarget.depthTexture;
      const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
      const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
      const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
      const samples = getRenderTargetSamples(renderTarget);
      const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
      if (isUseMultisampledRTT) {
        multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else if (isMultisample) {
        _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
      }
      _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
    } else {
      const textures = renderTarget.textures;
      for (let i2 = 0; i2 < textures.length; i2++) {
        const texture = textures[i2];
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const samples = getRenderTargetSamples(renderTarget);
        if (isMultisample && useMultisampledRTT(renderTarget) === false) {
          _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else if (useMultisampledRTT(renderTarget)) {
          multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else {
          _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
        }
      }
    }
    _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
  }
  function setupDepthTexture(framebuffer, renderTarget) {
    const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
    if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
    if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    }
    const textureProperties = properties.get(renderTarget.depthTexture);
    textureProperties.__renderTarget = renderTarget;
    if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
      renderTarget.depthTexture.image.width = renderTarget.width;
      renderTarget.depthTexture.image.height = renderTarget.height;
      renderTarget.depthTexture.needsUpdate = true;
    }
    setTexture2D(renderTarget.depthTexture, 0);
    const webglDepthTexture = textureProperties.__webglTexture;
    const samples = getRenderTargetSamples(renderTarget);
    if (renderTarget.depthTexture.format === DepthFormat) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
      }
    } else if (renderTarget.depthTexture.format === DepthStencilFormat) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
      }
    } else {
      throw new Error("Unknown depthTexture format");
    }
  }
  function setupDepthRenderbuffer(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
      const depthTexture = renderTarget.depthTexture;
      if (renderTargetProperties.__depthDisposeCallback) {
        renderTargetProperties.__depthDisposeCallback();
      }
      if (depthTexture) {
        const disposeEvent = () => {
          delete renderTargetProperties.__boundDepthTexture;
          delete renderTargetProperties.__depthDisposeCallback;
          depthTexture.removeEventListener("dispose", disposeEvent);
        };
        depthTexture.addEventListener("dispose", disposeEvent);
        renderTargetProperties.__depthDisposeCallback = disposeEvent;
      }
      renderTargetProperties.__boundDepthTexture = depthTexture;
    }
    if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
      if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
      setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
    } else {
      if (isCube) {
        renderTargetProperties.__webglDepthbuffer = [];
        for (let i2 = 0; i2 < 6; i2++) {
          state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i2]);
          if (renderTargetProperties.__webglDepthbuffer[i2] === void 0) {
            renderTargetProperties.__webglDepthbuffer[i2] = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i2], renderTarget, false);
          } else {
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderbuffer = renderTargetProperties.__webglDepthbuffer[i2];
            _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
          }
        }
      } else {
        state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
        if (renderTargetProperties.__webglDepthbuffer === void 0) {
          renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        } else {
          const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
          const renderbuffer = renderTargetProperties.__webglDepthbuffer;
          _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
          _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        }
      }
    }
    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
  }
  function rebindTextures(renderTarget, colorTexture, depthTexture) {
    const renderTargetProperties = properties.get(renderTarget);
    if (colorTexture !== void 0) {
      setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
    }
    if (depthTexture !== void 0) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function setupRenderTarget(renderTarget) {
    const texture = renderTarget.texture;
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    renderTarget.addEventListener("dispose", onRenderTargetDispose);
    const textures = renderTarget.textures;
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    const isMultipleRenderTargets = textures.length > 1;
    if (!isMultipleRenderTargets) {
      if (textureProperties.__webglTexture === void 0) {
        textureProperties.__webglTexture = _gl.createTexture();
      }
      textureProperties.__version = texture.version;
      info.memory.textures++;
    }
    if (isCube) {
      renderTargetProperties.__webglFramebuffer = [];
      for (let i2 = 0; i2 < 6; i2++) {
        if (texture.mipmaps && texture.mipmaps.length > 0) {
          renderTargetProperties.__webglFramebuffer[i2] = [];
          for (let level = 0; level < texture.mipmaps.length; level++) {
            renderTargetProperties.__webglFramebuffer[i2][level] = _gl.createFramebuffer();
          }
        } else {
          renderTargetProperties.__webglFramebuffer[i2] = _gl.createFramebuffer();
        }
      }
    } else {
      if (texture.mipmaps && texture.mipmaps.length > 0) {
        renderTargetProperties.__webglFramebuffer = [];
        for (let level = 0; level < texture.mipmaps.length; level++) {
          renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
        }
      } else {
        renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
      }
      if (isMultipleRenderTargets) {
        for (let i2 = 0, il = textures.length; i2 < il; i2++) {
          const attachmentProperties = properties.get(textures[i2]);
          if (attachmentProperties.__webglTexture === void 0) {
            attachmentProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
          }
        }
      }
      if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
        renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
        renderTargetProperties.__webglColorRenderbuffer = [];
        state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        for (let i2 = 0; i2 < textures.length; i2++) {
          const texture2 = textures[i2];
          renderTargetProperties.__webglColorRenderbuffer[i2] = _gl.createRenderbuffer();
          _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
          const glFormat = utils.convert(texture2.format, texture2.colorSpace);
          const glType = utils.convert(texture2.type);
          const glInternalFormat = getInternalFormat(texture2.internalFormat, glFormat, glType, texture2.colorSpace, renderTarget.isXRRenderTarget === true);
          const samples = getRenderTargetSamples(renderTarget);
          _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
          _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
        if (renderTarget.depthBuffer) {
          renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
      }
    }
    if (isCube) {
      state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
      setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
      for (let i2 = 0; i2 < 6; i2++) {
        if (texture.mipmaps && texture.mipmaps.length > 0) {
          for (let level = 0; level < texture.mipmaps.length; level++) {
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i2][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, level);
          }
        } else {
          setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i2], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0);
        }
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(_gl.TEXTURE_CUBE_MAP);
      }
      state.unbindTexture();
    } else if (isMultipleRenderTargets) {
      for (let i2 = 0, il = textures.length; i2 < il; i2++) {
        const attachment = textures[i2];
        const attachmentProperties = properties.get(attachment);
        state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
        setTextureParameters(_gl.TEXTURE_2D, attachment);
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, 0);
        if (textureNeedsGenerateMipmaps(attachment)) {
          generateMipmap(_gl.TEXTURE_2D);
        }
      }
      state.unbindTexture();
    } else {
      let glTextureType = _gl.TEXTURE_2D;
      if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
        glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
      }
      state.bindTexture(glTextureType, textureProperties.__webglTexture);
      setTextureParameters(glTextureType, texture);
      if (texture.mipmaps && texture.mipmaps.length > 0) {
        for (let level = 0; level < texture.mipmaps.length; level++) {
          setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
        }
      } else {
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(glTextureType);
      }
      state.unbindTexture();
    }
    if (renderTarget.depthBuffer) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function updateRenderTargetMipmap(renderTarget) {
    const textures = renderTarget.textures;
    for (let i2 = 0, il = textures.length; i2 < il; i2++) {
      const texture = textures[i2];
      if (textureNeedsGenerateMipmaps(texture)) {
        const targetType = getTargetType(renderTarget);
        const webglTexture = properties.get(texture).__webglTexture;
        state.bindTexture(targetType, webglTexture);
        generateMipmap(targetType);
        state.unbindTexture();
      }
    }
  }
  const invalidationArrayRead = [];
  const invalidationArrayDraw = [];
  function updateMultisampleRenderTarget(renderTarget) {
    if (renderTarget.samples > 0) {
      if (useMultisampledRTT(renderTarget) === false) {
        const textures = renderTarget.textures;
        const width = renderTarget.width;
        const height = renderTarget.height;
        let mask = _gl.COLOR_BUFFER_BIT;
        const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
        const renderTargetProperties = properties.get(renderTarget);
        const isMultipleRenderTargets = textures.length > 1;
        if (isMultipleRenderTargets) {
          for (let i2 = 0; i2 < textures.length; i2++) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, null);
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, null, 0);
          }
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
        for (let i2 = 0; i2 < textures.length; i2++) {
          if (renderTarget.resolveDepthBuffer) {
            if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
            if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
          }
          if (isMultipleRenderTargets) {
            _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
            const webglTexture = properties.get(textures[i2]).__webglTexture;
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
          }
          _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
          if (supportsInvalidateFramebuffer === true) {
            invalidationArrayRead.length = 0;
            invalidationArrayDraw.length = 0;
            invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i2);
            if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
              invalidationArrayRead.push(depthStyle);
              invalidationArrayDraw.push(depthStyle);
              _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
            }
            _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
          }
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
        if (isMultipleRenderTargets) {
          for (let i2 = 0; i2 < textures.length; i2++) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
            const webglTexture = properties.get(textures[i2]).__webglTexture;
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, webglTexture, 0);
          }
        }
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
      } else {
        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
          const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
          _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [depthStyle]);
        }
      }
    }
  }
  function getRenderTargetSamples(renderTarget) {
    return Math.min(capabilities.maxSamples, renderTarget.samples);
  }
  function useMultisampledRTT(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    return renderTarget.samples > 0 && extensions2.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
  }
  function updateVideoTexture(texture) {
    const frame = info.render.frame;
    if (_videoTextures.get(texture) !== frame) {
      _videoTextures.set(texture, frame);
      texture.update();
    }
  }
  function verifyColorSpace(texture, image) {
    const colorSpace = texture.colorSpace;
    const format = texture.format;
    const type = texture.type;
    if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
    if (colorSpace !== LinearSRGBColorSpace$1 && colorSpace !== NoColorSpace) {
      if (ColorManagement.getTransfer(colorSpace) === SRGBTransfer) {
        if (format !== RGBAFormat || type !== UnsignedByteType) {
          console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
        }
      } else {
        console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace);
      }
    }
    return image;
  }
  function getDimensions(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement) {
      _imageDimensions.width = image.naturalWidth || image.width;
      _imageDimensions.height = image.naturalHeight || image.height;
    } else if (typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
      _imageDimensions.width = image.displayWidth;
      _imageDimensions.height = image.displayHeight;
    } else {
      _imageDimensions.width = image.width;
      _imageDimensions.height = image.height;
    }
    return _imageDimensions;
  }
  this.allocateTextureUnit = allocateTextureUnit;
  this.resetTextureUnits = resetTextureUnits;
  this.setTexture2D = setTexture2D;
  this.setTexture2DArray = setTexture2DArray;
  this.setTexture3D = setTexture3D;
  this.setTextureCube = setTextureCube;
  this.rebindTextures = rebindTextures;
  this.setupRenderTarget = setupRenderTarget;
  this.updateRenderTargetMipmap = updateRenderTargetMipmap;
  this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
  this.setupDepthRenderbuffer = setupDepthRenderbuffer;
  this.setupFrameBufferTexture = setupFrameBufferTexture;
  this.useMultisampledRTT = useMultisampledRTT;
}
function WebGLUtils(gl, extensions2) {
  function convert(p3, colorSpace = NoColorSpace) {
    let extension;
    const transfer = ColorManagement.getTransfer(colorSpace);
    if (p3 === UnsignedByteType) return gl.UNSIGNED_BYTE;
    if (p3 === UnsignedShort4444Type) return gl.UNSIGNED_SHORT_4_4_4_4;
    if (p3 === UnsignedShort5551Type) return gl.UNSIGNED_SHORT_5_5_5_1;
    if (p3 === UnsignedInt5999Type) return gl.UNSIGNED_INT_5_9_9_9_REV;
    if (p3 === ByteType) return gl.BYTE;
    if (p3 === ShortType) return gl.SHORT;
    if (p3 === UnsignedShortType) return gl.UNSIGNED_SHORT;
    if (p3 === IntType) return gl.INT;
    if (p3 === UnsignedIntType) return gl.UNSIGNED_INT;
    if (p3 === FloatType) return gl.FLOAT;
    if (p3 === HalfFloatType) return gl.HALF_FLOAT;
    if (p3 === AlphaFormat) return gl.ALPHA;
    if (p3 === RGBFormat) return gl.RGB;
    if (p3 === RGBAFormat) return gl.RGBA;
    if (p3 === LuminanceFormat) return gl.LUMINANCE;
    if (p3 === LuminanceAlphaFormat) return gl.LUMINANCE_ALPHA;
    if (p3 === DepthFormat) return gl.DEPTH_COMPONENT;
    if (p3 === DepthStencilFormat) return gl.DEPTH_STENCIL;
    if (p3 === RedFormat) return gl.RED;
    if (p3 === RedIntegerFormat) return gl.RED_INTEGER;
    if (p3 === RGFormat) return gl.RG;
    if (p3 === RGIntegerFormat) return gl.RG_INTEGER;
    if (p3 === RGBAIntegerFormat) return gl.RGBA_INTEGER;
    if (p3 === RGB_S3TC_DXT1_Format || p3 === RGBA_S3TC_DXT1_Format || p3 === RGBA_S3TC_DXT3_Format || p3 === RGBA_S3TC_DXT5_Format) {
      if (transfer === SRGBTransfer) {
        extension = extensions2.get("WEBGL_compressed_texture_s3tc_srgb");
        if (extension !== null) {
          if (p3 === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (p3 === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (p3 === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (p3 === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      } else {
        extension = extensions2.get("WEBGL_compressed_texture_s3tc");
        if (extension !== null) {
          if (p3 === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
          if (p3 === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          if (p3 === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          if (p3 === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      }
    }
    if (p3 === RGB_PVRTC_4BPPV1_Format || p3 === RGB_PVRTC_2BPPV1_Format || p3 === RGBA_PVRTC_4BPPV1_Format || p3 === RGBA_PVRTC_2BPPV1_Format) {
      extension = extensions2.get("WEBGL_compressed_texture_pvrtc");
      if (extension !== null) {
        if (p3 === RGB_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (p3 === RGB_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (p3 === RGBA_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (p3 === RGBA_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else {
        return null;
      }
    }
    if (p3 === RGB_ETC1_Format || p3 === RGB_ETC2_Format || p3 === RGBA_ETC2_EAC_Format) {
      extension = extensions2.get("WEBGL_compressed_texture_etc");
      if (extension !== null) {
        if (p3 === RGB_ETC1_Format || p3 === RGB_ETC2_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
        if (p3 === RGBA_ETC2_EAC_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
      } else {
        return null;
      }
    }
    if (p3 === RGBA_ASTC_4x4_Format || p3 === RGBA_ASTC_5x4_Format || p3 === RGBA_ASTC_5x5_Format || p3 === RGBA_ASTC_6x5_Format || p3 === RGBA_ASTC_6x6_Format || p3 === RGBA_ASTC_8x5_Format || p3 === RGBA_ASTC_8x6_Format || p3 === RGBA_ASTC_8x8_Format || p3 === RGBA_ASTC_10x5_Format || p3 === RGBA_ASTC_10x6_Format || p3 === RGBA_ASTC_10x8_Format || p3 === RGBA_ASTC_10x10_Format || p3 === RGBA_ASTC_12x10_Format || p3 === RGBA_ASTC_12x12_Format) {
      extension = extensions2.get("WEBGL_compressed_texture_astc");
      if (extension !== null) {
        if (p3 === RGBA_ASTC_4x4_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (p3 === RGBA_ASTC_5x4_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (p3 === RGBA_ASTC_5x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (p3 === RGBA_ASTC_6x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (p3 === RGBA_ASTC_6x6_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (p3 === RGBA_ASTC_8x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (p3 === RGBA_ASTC_8x6_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (p3 === RGBA_ASTC_8x8_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (p3 === RGBA_ASTC_10x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (p3 === RGBA_ASTC_10x6_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (p3 === RGBA_ASTC_10x8_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (p3 === RGBA_ASTC_10x10_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (p3 === RGBA_ASTC_12x10_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (p3 === RGBA_ASTC_12x12_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else {
        return null;
      }
    }
    if (p3 === RGBA_BPTC_Format || p3 === RGB_BPTC_SIGNED_Format || p3 === RGB_BPTC_UNSIGNED_Format) {
      extension = extensions2.get("EXT_texture_compression_bptc");
      if (extension !== null) {
        if (p3 === RGBA_BPTC_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        if (p3 === RGB_BPTC_SIGNED_Format) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        if (p3 === RGB_BPTC_UNSIGNED_Format) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
      } else {
        return null;
      }
    }
    if (p3 === RED_RGTC1_Format || p3 === SIGNED_RED_RGTC1_Format || p3 === RED_GREEN_RGTC2_Format || p3 === SIGNED_RED_GREEN_RGTC2_Format) {
      extension = extensions2.get("EXT_texture_compression_rgtc");
      if (extension !== null) {
        if (p3 === RGBA_BPTC_Format) return extension.COMPRESSED_RED_RGTC1_EXT;
        if (p3 === SIGNED_RED_RGTC1_Format) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (p3 === RED_GREEN_RGTC2_Format) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (p3 === SIGNED_RED_GREEN_RGTC2_Format) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else {
        return null;
      }
    }
    if (p3 === UnsignedInt248Type) return gl.UNSIGNED_INT_24_8;
    return gl[p3] !== void 0 ? gl[p3] : null;
  }
  return { convert };
}
const _occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const _occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class WebXRDepthSensing {
  constructor() {
    this.texture = null;
    this.mesh = null;
    this.depthNear = 0;
    this.depthFar = 0;
  }
  init(renderer, depthData, renderState) {
    if (this.texture === null) {
      const texture = new Texture();
      const texProps = renderer.properties.get(texture);
      texProps.__webglTexture = depthData.texture;
      if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
        this.depthNear = depthData.depthNear;
        this.depthFar = depthData.depthFar;
      }
      this.texture = texture;
    }
  }
  getMesh(cameraXR) {
    if (this.texture !== null) {
      if (this.mesh === null) {
        const viewport = cameraXR.cameras[0].viewport;
        const material = new ShaderMaterial({
          vertexShader: _occlusion_vertex,
          fragmentShader: _occlusion_fragment,
          uniforms: {
            depthColor: { value: this.texture },
            depthWidth: { value: viewport.z },
            depthHeight: { value: viewport.w }
          }
        });
        this.mesh = new Mesh(new PlaneGeometry(20, 20), material);
      }
    }
    return this.mesh;
  }
  reset() {
    this.texture = null;
    this.mesh = null;
  }
  getDepthTexture() {
    return this.texture;
  }
}
class WebXRManager extends EventDispatcher$2 {
  constructor(renderer, gl) {
    super();
    const scope = this;
    let session = null;
    let framebufferScaleFactor = 1;
    let referenceSpace = null;
    let referenceSpaceType = "local-floor";
    let foveation = 1;
    let customReferenceSpace = null;
    let pose = null;
    let glBinding = null;
    let glProjLayer = null;
    let glBaseLayer = null;
    let xrFrame = null;
    const depthSensing = new WebXRDepthSensing();
    const attributes = gl.getContextAttributes();
    let initialRenderTarget = null;
    let newRenderTarget = null;
    const controllers = [];
    const controllerInputSources = [];
    const currentSize = new Vector2();
    let currentPixelRatio = null;
    const cameraL = new PerspectiveCamera();
    cameraL.viewport = new Vector4();
    const cameraR = new PerspectiveCamera();
    cameraR.viewport = new Vector4();
    const cameras = [cameraL, cameraR];
    const cameraXR = new ArrayCamera();
    let _currentDepthNear = null;
    let _currentDepthFar = null;
    this.cameraAutoUpdate = true;
    this.enabled = false;
    this.isPresenting = false;
    this.getController = function(index) {
      let controller = controllers[index];
      if (controller === void 0) {
        controller = new WebXRController();
        controllers[index] = controller;
      }
      return controller.getTargetRaySpace();
    };
    this.getControllerGrip = function(index) {
      let controller = controllers[index];
      if (controller === void 0) {
        controller = new WebXRController();
        controllers[index] = controller;
      }
      return controller.getGripSpace();
    };
    this.getHand = function(index) {
      let controller = controllers[index];
      if (controller === void 0) {
        controller = new WebXRController();
        controllers[index] = controller;
      }
      return controller.getHandSpace();
    };
    function onSessionEvent(event) {
      const controllerIndex = controllerInputSources.indexOf(event.inputSource);
      if (controllerIndex === -1) {
        return;
      }
      const controller = controllers[controllerIndex];
      if (controller !== void 0) {
        controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
        controller.dispatchEvent({ type: event.type, data: event.inputSource });
      }
    }
    function onSessionEnd() {
      session.removeEventListener("select", onSessionEvent);
      session.removeEventListener("selectstart", onSessionEvent);
      session.removeEventListener("selectend", onSessionEvent);
      session.removeEventListener("squeeze", onSessionEvent);
      session.removeEventListener("squeezestart", onSessionEvent);
      session.removeEventListener("squeezeend", onSessionEvent);
      session.removeEventListener("end", onSessionEnd);
      session.removeEventListener("inputsourceschange", onInputSourcesChange);
      for (let i2 = 0; i2 < controllers.length; i2++) {
        const inputSource = controllerInputSources[i2];
        if (inputSource === null) continue;
        controllerInputSources[i2] = null;
        controllers[i2].disconnect(inputSource);
      }
      _currentDepthNear = null;
      _currentDepthFar = null;
      depthSensing.reset();
      renderer.setRenderTarget(initialRenderTarget);
      glBaseLayer = null;
      glProjLayer = null;
      glBinding = null;
      session = null;
      newRenderTarget = null;
      animation.stop();
      scope.isPresenting = false;
      renderer.setPixelRatio(currentPixelRatio);
      renderer.setSize(currentSize.width, currentSize.height, false);
      scope.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(value) {
      framebufferScaleFactor = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
      }
    };
    this.setReferenceSpaceType = function(value) {
      referenceSpaceType = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
      }
    };
    this.getReferenceSpace = function() {
      return customReferenceSpace || referenceSpace;
    };
    this.setReferenceSpace = function(space) {
      customReferenceSpace = space;
    };
    this.getBaseLayer = function() {
      return glProjLayer !== null ? glProjLayer : glBaseLayer;
    };
    this.getBinding = function() {
      return glBinding;
    };
    this.getFrame = function() {
      return xrFrame;
    };
    this.getSession = function() {
      return session;
    };
    this.setSession = async function(value) {
      session = value;
      if (session !== null) {
        initialRenderTarget = renderer.getRenderTarget();
        session.addEventListener("select", onSessionEvent);
        session.addEventListener("selectstart", onSessionEvent);
        session.addEventListener("selectend", onSessionEvent);
        session.addEventListener("squeeze", onSessionEvent);
        session.addEventListener("squeezestart", onSessionEvent);
        session.addEventListener("squeezeend", onSessionEvent);
        session.addEventListener("end", onSessionEnd);
        session.addEventListener("inputsourceschange", onInputSourcesChange);
        if (attributes.xrCompatible !== true) {
          await gl.makeXRCompatible();
        }
        currentPixelRatio = renderer.getPixelRatio();
        renderer.getSize(currentSize);
        const useLayers = typeof XRWebGLBinding !== "undefined" && "createProjectionLayer" in XRWebGLBinding.prototype;
        if (!useLayers) {
          const layerInit = {
            antialias: attributes.antialias,
            alpha: true,
            depth: attributes.depth,
            stencil: attributes.stencil,
            framebufferScaleFactor
          };
          glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
          session.updateRenderState({ baseLayer: glBaseLayer });
          renderer.setPixelRatio(1);
          renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
          newRenderTarget = new WebGLRenderTarget(
            glBaseLayer.framebufferWidth,
            glBaseLayer.framebufferHeight,
            {
              format: RGBAFormat,
              type: UnsignedByteType,
              colorSpace: renderer.outputColorSpace,
              stencilBuffer: attributes.stencil
            }
          );
        } else {
          let depthFormat = null;
          let depthType = null;
          let glDepthFormat = null;
          if (attributes.depth) {
            glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
            depthFormat = attributes.stencil ? DepthStencilFormat : DepthFormat;
            depthType = attributes.stencil ? UnsignedInt248Type : UnsignedIntType;
          }
          const projectionlayerInit = {
            colorFormat: gl.RGBA8,
            depthFormat: glDepthFormat,
            scaleFactor: framebufferScaleFactor
          };
          glBinding = new XRWebGLBinding(session, gl);
          glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
          session.updateRenderState({ layers: [glProjLayer] });
          renderer.setPixelRatio(1);
          renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
          newRenderTarget = new WebGLRenderTarget(
            glProjLayer.textureWidth,
            glProjLayer.textureHeight,
            {
              format: RGBAFormat,
              type: UnsignedByteType,
              depthTexture: new DepthTexture(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, void 0, void 0, void 0, void 0, void 0, void 0, depthFormat),
              stencilBuffer: attributes.stencil,
              colorSpace: renderer.outputColorSpace,
              samples: attributes.antialias ? 4 : 0,
              resolveDepthBuffer: glProjLayer.ignoreDepthValues === false
            }
          );
        }
        newRenderTarget.isXRRenderTarget = true;
        this.setFoveation(foveation);
        customReferenceSpace = null;
        referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
        animation.setContext(session);
        animation.start();
        scope.isPresenting = true;
        scope.dispatchEvent({ type: "sessionstart" });
      }
    };
    this.getEnvironmentBlendMode = function() {
      if (session !== null) {
        return session.environmentBlendMode;
      }
    };
    this.getDepthTexture = function() {
      return depthSensing.getDepthTexture();
    };
    function onInputSourcesChange(event) {
      for (let i2 = 0; i2 < event.removed.length; i2++) {
        const inputSource = event.removed[i2];
        const index = controllerInputSources.indexOf(inputSource);
        if (index >= 0) {
          controllerInputSources[index] = null;
          controllers[index].disconnect(inputSource);
        }
      }
      for (let i2 = 0; i2 < event.added.length; i2++) {
        const inputSource = event.added[i2];
        let controllerIndex = controllerInputSources.indexOf(inputSource);
        if (controllerIndex === -1) {
          for (let i3 = 0; i3 < controllers.length; i3++) {
            if (i3 >= controllerInputSources.length) {
              controllerInputSources.push(inputSource);
              controllerIndex = i3;
              break;
            } else if (controllerInputSources[i3] === null) {
              controllerInputSources[i3] = inputSource;
              controllerIndex = i3;
              break;
            }
          }
          if (controllerIndex === -1) break;
        }
        const controller = controllers[controllerIndex];
        if (controller) {
          controller.connect(inputSource);
        }
      }
    }
    const cameraLPos = new Vector3();
    const cameraRPos = new Vector3();
    function setProjectionFromUnion(camera, cameraL2, cameraR2) {
      cameraLPos.setFromMatrixPosition(cameraL2.matrixWorld);
      cameraRPos.setFromMatrixPosition(cameraR2.matrixWorld);
      const ipd = cameraLPos.distanceTo(cameraRPos);
      const projL = cameraL2.projectionMatrix.elements;
      const projR = cameraR2.projectionMatrix.elements;
      const near = projL[14] / (projL[10] - 1);
      const far = projL[14] / (projL[10] + 1);
      const topFov = (projL[9] + 1) / projL[5];
      const bottomFov = (projL[9] - 1) / projL[5];
      const leftFov = (projL[8] - 1) / projL[0];
      const rightFov = (projR[8] + 1) / projR[0];
      const left = near * leftFov;
      const right = near * rightFov;
      const zOffset = ipd / (-leftFov + rightFov);
      const xOffset = zOffset * -leftFov;
      cameraL2.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
      camera.translateX(xOffset);
      camera.translateZ(zOffset);
      camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
      if (projL[10] === -1) {
        camera.projectionMatrix.copy(cameraL2.projectionMatrix);
        camera.projectionMatrixInverse.copy(cameraL2.projectionMatrixInverse);
      } else {
        const near2 = near + zOffset;
        const far2 = far + zOffset;
        const left2 = left - xOffset;
        const right2 = right + (ipd - xOffset);
        const top2 = topFov * far / far2 * near2;
        const bottom2 = bottomFov * far / far2 * near2;
        camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
      }
    }
    function updateCamera2(camera, parent) {
      if (parent === null) {
        camera.matrixWorld.copy(camera.matrix);
      } else {
        camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
      }
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    }
    this.updateCamera = function(camera) {
      if (session === null) return;
      let depthNear = camera.near;
      let depthFar = camera.far;
      if (depthSensing.texture !== null) {
        if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
        if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
      }
      cameraXR.near = cameraR.near = cameraL.near = depthNear;
      cameraXR.far = cameraR.far = cameraL.far = depthFar;
      if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
        session.updateRenderState({
          depthNear: cameraXR.near,
          depthFar: cameraXR.far
        });
        _currentDepthNear = cameraXR.near;
        _currentDepthFar = cameraXR.far;
      }
      cameraL.layers.mask = camera.layers.mask | 2;
      cameraR.layers.mask = camera.layers.mask | 4;
      cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
      const parent = camera.parent;
      const cameras2 = cameraXR.cameras;
      updateCamera2(cameraXR, parent);
      for (let i2 = 0; i2 < cameras2.length; i2++) {
        updateCamera2(cameras2[i2], parent);
      }
      if (cameras2.length === 2) {
        setProjectionFromUnion(cameraXR, cameraL, cameraR);
      } else {
        cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
      }
      updateUserCamera(camera, cameraXR, parent);
    };
    function updateUserCamera(camera, cameraXR2, parent) {
      if (parent === null) {
        camera.matrix.copy(cameraXR2.matrixWorld);
      } else {
        camera.matrix.copy(parent.matrixWorld);
        camera.matrix.invert();
        camera.matrix.multiply(cameraXR2.matrixWorld);
      }
      camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
      camera.updateMatrixWorld(true);
      camera.projectionMatrix.copy(cameraXR2.projectionMatrix);
      camera.projectionMatrixInverse.copy(cameraXR2.projectionMatrixInverse);
      if (camera.isPerspectiveCamera) {
        camera.fov = RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
        camera.zoom = 1;
      }
    }
    this.getCamera = function() {
      return cameraXR;
    };
    this.getFoveation = function() {
      if (glProjLayer === null && glBaseLayer === null) {
        return void 0;
      }
      return foveation;
    };
    this.setFoveation = function(value) {
      foveation = value;
      if (glProjLayer !== null) {
        glProjLayer.fixedFoveation = value;
      }
      if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== void 0) {
        glBaseLayer.fixedFoveation = value;
      }
    };
    this.hasDepthSensing = function() {
      return depthSensing.texture !== null;
    };
    this.getDepthSensingMesh = function() {
      return depthSensing.getMesh(cameraXR);
    };
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time, frame) {
      pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
      xrFrame = frame;
      if (pose !== null) {
        const views = pose.views;
        if (glBaseLayer !== null) {
          renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
          renderer.setRenderTarget(newRenderTarget);
        }
        let cameraXRNeedsUpdate = false;
        if (views.length !== cameraXR.cameras.length) {
          cameraXR.cameras.length = 0;
          cameraXRNeedsUpdate = true;
        }
        for (let i2 = 0; i2 < views.length; i2++) {
          const view = views[i2];
          let viewport = null;
          if (glBaseLayer !== null) {
            viewport = glBaseLayer.getViewport(view);
          } else {
            const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
            viewport = glSubImage.viewport;
            if (i2 === 0) {
              renderer.setRenderTargetTextures(
                newRenderTarget,
                glSubImage.colorTexture,
                glProjLayer.ignoreDepthValues ? void 0 : glSubImage.depthStencilTexture
              );
              renderer.setRenderTarget(newRenderTarget);
            }
          }
          let camera = cameras[i2];
          if (camera === void 0) {
            camera = new PerspectiveCamera();
            camera.layers.enable(i2);
            camera.viewport = new Vector4();
            cameras[i2] = camera;
          }
          camera.matrix.fromArray(view.transform.matrix);
          camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
          camera.projectionMatrix.fromArray(view.projectionMatrix);
          camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
          camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
          if (i2 === 0) {
            cameraXR.matrix.copy(camera.matrix);
            cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
          }
          if (cameraXRNeedsUpdate === true) {
            cameraXR.cameras.push(camera);
          }
        }
        const enabledFeatures = session.enabledFeatures;
        const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes("depth-sensing") && session.depthUsage == "gpu-optimized";
        if (gpuDepthSensingEnabled && glBinding) {
          const depthData = glBinding.getDepthInformation(views[0]);
          if (depthData && depthData.isValid && depthData.texture) {
            depthSensing.init(renderer, depthData, session.renderState);
          }
        }
      }
      for (let i2 = 0; i2 < controllers.length; i2++) {
        const inputSource = controllerInputSources[i2];
        const controller = controllers[i2];
        if (inputSource !== null && controller !== void 0) {
          controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
        }
      }
      if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
      if (frame.detectedPlanes) {
        scope.dispatchEvent({ type: "planesdetected", data: frame });
      }
      xrFrame = null;
    }
    const animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    this.setAnimationLoop = function(callback) {
      onAnimationFrameCallback = callback;
    };
    this.dispose = function() {
    };
  }
}
const _e1 = /* @__PURE__ */ new Euler();
const _m1$2 = /* @__PURE__ */ new Matrix4();
function WebGLMaterials(renderer, properties) {
  function refreshTransformUniform(map, uniform) {
    if (map.matrixAutoUpdate === true) {
      map.updateMatrix();
    }
    uniform.value.copy(map.matrix);
  }
  function refreshFogUniforms(uniforms, fog) {
    fog.color.getRGB(uniforms.fogColor.value, getUnlitUniformColorSpace(renderer));
    if (fog.isFog) {
      uniforms.fogNear.value = fog.near;
      uniforms.fogFar.value = fog.far;
    } else if (fog.isFogExp2) {
      uniforms.fogDensity.value = fog.density;
    }
  }
  function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
    if (material.isMeshBasicMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshLambertMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshToonMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsToon(uniforms, material);
    } else if (material.isMeshPhongMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsPhong(uniforms, material);
    } else if (material.isMeshStandardMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsStandard(uniforms, material);
      if (material.isMeshPhysicalMaterial) {
        refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
      }
    } else if (material.isMeshMatcapMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsMatcap(uniforms, material);
    } else if (material.isMeshDepthMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshDistanceMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsDistance(uniforms, material);
    } else if (material.isMeshNormalMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isLineBasicMaterial) {
      refreshUniformsLine(uniforms, material);
      if (material.isLineDashedMaterial) {
        refreshUniformsDash(uniforms, material);
      }
    } else if (material.isPointsMaterial) {
      refreshUniformsPoints(uniforms, material, pixelRatio, height);
    } else if (material.isSpriteMaterial) {
      refreshUniformsSprites(uniforms, material);
    } else if (material.isShadowMaterial) {
      uniforms.color.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
    } else if (material.isShaderMaterial) {
      material.uniformsNeedUpdate = false;
    }
  }
  function refreshUniformsCommon(uniforms, material) {
    uniforms.opacity.value = material.opacity;
    if (material.color) {
      uniforms.diffuse.value.copy(material.color);
    }
    if (material.emissive) {
      uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
    }
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.mapTransform);
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
      refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide) {
        uniforms.bumpScale.value *= -1;
      }
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide) {
        uniforms.normalScale.value.negate();
      }
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
      refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
    }
    if (material.specularMap) {
      uniforms.specularMap.value = material.specularMap;
      refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
    const materialProperties = properties.get(material);
    const envMap = materialProperties.envMap;
    const envMapRotation = materialProperties.envMapRotation;
    if (envMap) {
      uniforms.envMap.value = envMap;
      _e1.copy(envMapRotation);
      _e1.x *= -1;
      _e1.y *= -1;
      _e1.z *= -1;
      if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
        _e1.y *= -1;
        _e1.z *= -1;
      }
      uniforms.envMapRotation.value.setFromMatrix4(_m1$2.makeRotationFromEuler(_e1));
      uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
      uniforms.reflectivity.value = material.reflectivity;
      uniforms.ior.value = material.ior;
      uniforms.refractionRatio.value = material.refractionRatio;
    }
    if (material.lightMap) {
      uniforms.lightMap.value = material.lightMap;
      uniforms.lightMapIntensity.value = material.lightMapIntensity;
      refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
    }
    if (material.aoMap) {
      uniforms.aoMap.value = material.aoMap;
      uniforms.aoMapIntensity.value = material.aoMapIntensity;
      refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
    }
  }
  function refreshUniformsLine(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.mapTransform);
    }
  }
  function refreshUniformsDash(uniforms, material) {
    uniforms.dashSize.value = material.dashSize;
    uniforms.totalSize.value = material.dashSize + material.gapSize;
    uniforms.scale.value = material.scale;
  }
  function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.size.value = material.size * pixelRatio;
    uniforms.scale.value = height * 0.5;
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.uvTransform);
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
      refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
  }
  function refreshUniformsSprites(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.rotation.value = material.rotation;
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.mapTransform);
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
      refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
  }
  function refreshUniformsPhong(uniforms, material) {
    uniforms.specular.value.copy(material.specular);
    uniforms.shininess.value = Math.max(material.shininess, 1e-4);
  }
  function refreshUniformsToon(uniforms, material) {
    if (material.gradientMap) {
      uniforms.gradientMap.value = material.gradientMap;
    }
  }
  function refreshUniformsStandard(uniforms, material) {
    uniforms.metalness.value = material.metalness;
    if (material.metalnessMap) {
      uniforms.metalnessMap.value = material.metalnessMap;
      refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
    }
    uniforms.roughness.value = material.roughness;
    if (material.roughnessMap) {
      uniforms.roughnessMap.value = material.roughnessMap;
      refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
    }
    if (material.envMap) {
      uniforms.envMapIntensity.value = material.envMapIntensity;
    }
  }
  function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
    uniforms.ior.value = material.ior;
    if (material.sheen > 0) {
      uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
      uniforms.sheenRoughness.value = material.sheenRoughness;
      if (material.sheenColorMap) {
        uniforms.sheenColorMap.value = material.sheenColorMap;
        refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
      }
      if (material.sheenRoughnessMap) {
        uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
        refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
      }
    }
    if (material.clearcoat > 0) {
      uniforms.clearcoat.value = material.clearcoat;
      uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
      if (material.clearcoatMap) {
        uniforms.clearcoatMap.value = material.clearcoatMap;
        refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
      }
      if (material.clearcoatRoughnessMap) {
        uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
        refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
      }
      if (material.clearcoatNormalMap) {
        uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
        refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
        uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
        if (material.side === BackSide) {
          uniforms.clearcoatNormalScale.value.negate();
        }
      }
    }
    if (material.dispersion > 0) {
      uniforms.dispersion.value = material.dispersion;
    }
    if (material.iridescence > 0) {
      uniforms.iridescence.value = material.iridescence;
      uniforms.iridescenceIOR.value = material.iridescenceIOR;
      uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
      uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
      if (material.iridescenceMap) {
        uniforms.iridescenceMap.value = material.iridescenceMap;
        refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
      }
      if (material.iridescenceThicknessMap) {
        uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
        refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
      }
    }
    if (material.transmission > 0) {
      uniforms.transmission.value = material.transmission;
      uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
      uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
      if (material.transmissionMap) {
        uniforms.transmissionMap.value = material.transmissionMap;
        refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
      }
      uniforms.thickness.value = material.thickness;
      if (material.thicknessMap) {
        uniforms.thicknessMap.value = material.thicknessMap;
        refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
      }
      uniforms.attenuationDistance.value = material.attenuationDistance;
      uniforms.attenuationColor.value.copy(material.attenuationColor);
    }
    if (material.anisotropy > 0) {
      uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
      if (material.anisotropyMap) {
        uniforms.anisotropyMap.value = material.anisotropyMap;
        refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
      }
    }
    uniforms.specularIntensity.value = material.specularIntensity;
    uniforms.specularColor.value.copy(material.specularColor);
    if (material.specularColorMap) {
      uniforms.specularColorMap.value = material.specularColorMap;
      refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
    }
    if (material.specularIntensityMap) {
      uniforms.specularIntensityMap.value = material.specularIntensityMap;
      refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
    }
  }
  function refreshUniformsMatcap(uniforms, material) {
    if (material.matcap) {
      uniforms.matcap.value = material.matcap;
    }
  }
  function refreshUniformsDistance(uniforms, material) {
    const light = properties.get(material).light;
    uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
    uniforms.nearDistance.value = light.shadow.camera.near;
    uniforms.farDistance.value = light.shadow.camera.far;
  }
  return {
    refreshFogUniforms,
    refreshMaterialUniforms
  };
}
function WebGLUniformsGroups(gl, info, capabilities, state) {
  let buffers = {};
  let updateList = {};
  let allocatedBindingPoints = [];
  const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS);
  function bind(uniformsGroup, program) {
    const webglProgram = program.program;
    state.uniformBlockBinding(uniformsGroup, webglProgram);
  }
  function update2(uniformsGroup, program) {
    let buffer = buffers[uniformsGroup.id];
    if (buffer === void 0) {
      prepareUniformsGroup(uniformsGroup);
      buffer = createBuffer(uniformsGroup);
      buffers[uniformsGroup.id] = buffer;
      uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
    }
    const webglProgram = program.program;
    state.updateUBOMapping(uniformsGroup, webglProgram);
    const frame = info.render.frame;
    if (updateList[uniformsGroup.id] !== frame) {
      updateBufferData(uniformsGroup);
      updateList[uniformsGroup.id] = frame;
    }
  }
  function createBuffer(uniformsGroup) {
    const bindingPointIndex = allocateBindingPointIndex();
    uniformsGroup.__bindingPointIndex = bindingPointIndex;
    const buffer = gl.createBuffer();
    const size = uniformsGroup.__size;
    const usage = uniformsGroup.usage;
    gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
    gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
    gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
    return buffer;
  }
  function allocateBindingPointIndex() {
    for (let i2 = 0; i2 < maxBindingPoints; i2++) {
      if (allocatedBindingPoints.indexOf(i2) === -1) {
        allocatedBindingPoints.push(i2);
        return i2;
      }
    }
    console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
    return 0;
  }
  function updateBufferData(uniformsGroup) {
    const buffer = buffers[uniformsGroup.id];
    const uniforms = uniformsGroup.uniforms;
    const cache = uniformsGroup.__cache;
    gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
    for (let i2 = 0, il = uniforms.length; i2 < il; i2++) {
      const uniformArray = Array.isArray(uniforms[i2]) ? uniforms[i2] : [uniforms[i2]];
      for (let j3 = 0, jl = uniformArray.length; j3 < jl; j3++) {
        const uniform = uniformArray[j3];
        if (hasUniformChanged(uniform, i2, j3, cache) === true) {
          const offset = uniform.__offset;
          const values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];
          let arrayOffset = 0;
          for (let k2 = 0; k2 < values.length; k2++) {
            const value = values[k2];
            const info2 = getUniformSize(value);
            if (typeof value === "number" || typeof value === "boolean") {
              uniform.__data[0] = value;
              gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
            } else if (value.isMatrix3) {
              uniform.__data[0] = value.elements[0];
              uniform.__data[1] = value.elements[1];
              uniform.__data[2] = value.elements[2];
              uniform.__data[3] = 0;
              uniform.__data[4] = value.elements[3];
              uniform.__data[5] = value.elements[4];
              uniform.__data[6] = value.elements[5];
              uniform.__data[7] = 0;
              uniform.__data[8] = value.elements[6];
              uniform.__data[9] = value.elements[7];
              uniform.__data[10] = value.elements[8];
              uniform.__data[11] = 0;
            } else {
              value.toArray(uniform.__data, arrayOffset);
              arrayOffset += info2.storage / Float32Array.BYTES_PER_ELEMENT;
            }
          }
          gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
        }
      }
    }
    gl.bindBuffer(gl.UNIFORM_BUFFER, null);
  }
  function hasUniformChanged(uniform, index, indexArray, cache) {
    const value = uniform.value;
    const indexString = index + "_" + indexArray;
    if (cache[indexString] === void 0) {
      if (typeof value === "number" || typeof value === "boolean") {
        cache[indexString] = value;
      } else {
        cache[indexString] = value.clone();
      }
      return true;
    } else {
      const cachedObject = cache[indexString];
      if (typeof value === "number" || typeof value === "boolean") {
        if (cachedObject !== value) {
          cache[indexString] = value;
          return true;
        }
      } else {
        if (cachedObject.equals(value) === false) {
          cachedObject.copy(value);
          return true;
        }
      }
    }
    return false;
  }
  function prepareUniformsGroup(uniformsGroup) {
    const uniforms = uniformsGroup.uniforms;
    let offset = 0;
    const chunkSize = 16;
    for (let i2 = 0, l2 = uniforms.length; i2 < l2; i2++) {
      const uniformArray = Array.isArray(uniforms[i2]) ? uniforms[i2] : [uniforms[i2]];
      for (let j3 = 0, jl = uniformArray.length; j3 < jl; j3++) {
        const uniform = uniformArray[j3];
        const values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];
        for (let k2 = 0, kl = values.length; k2 < kl; k2++) {
          const value = values[k2];
          const info2 = getUniformSize(value);
          const chunkOffset2 = offset % chunkSize;
          const chunkPadding = chunkOffset2 % info2.boundary;
          const chunkStart = chunkOffset2 + chunkPadding;
          offset += chunkPadding;
          if (chunkStart !== 0 && chunkSize - chunkStart < info2.storage) {
            offset += chunkSize - chunkStart;
          }
          uniform.__data = new Float32Array(info2.storage / Float32Array.BYTES_PER_ELEMENT);
          uniform.__offset = offset;
          offset += info2.storage;
        }
      }
    }
    const chunkOffset = offset % chunkSize;
    if (chunkOffset > 0) offset += chunkSize - chunkOffset;
    uniformsGroup.__size = offset;
    uniformsGroup.__cache = {};
    return this;
  }
  function getUniformSize(value) {
    const info2 = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    if (typeof value === "number" || typeof value === "boolean") {
      info2.boundary = 4;
      info2.storage = 4;
    } else if (value.isVector2) {
      info2.boundary = 8;
      info2.storage = 8;
    } else if (value.isVector3 || value.isColor) {
      info2.boundary = 16;
      info2.storage = 12;
    } else if (value.isVector4) {
      info2.boundary = 16;
      info2.storage = 16;
    } else if (value.isMatrix3) {
      info2.boundary = 48;
      info2.storage = 48;
    } else if (value.isMatrix4) {
      info2.boundary = 64;
      info2.storage = 64;
    } else if (value.isTexture) {
      console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
    } else {
      console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
    }
    return info2;
  }
  function onUniformsGroupsDispose(event) {
    const uniformsGroup = event.target;
    uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
    const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
    allocatedBindingPoints.splice(index, 1);
    gl.deleteBuffer(buffers[uniformsGroup.id]);
    delete buffers[uniformsGroup.id];
    delete updateList[uniformsGroup.id];
  }
  function dispose2() {
    for (const id in buffers) {
      gl.deleteBuffer(buffers[id]);
    }
    allocatedBindingPoints = [];
    buffers = {};
    updateList = {};
  }
  return {
    bind,
    update: update2,
    dispose: dispose2
  };
}
class WebGLRenderer {
  constructor(parameters = {}) {
    const {
      canvas = createCanvasElement(),
      context: context4 = null,
      depth = true,
      stencil = false,
      alpha = false,
      antialias = false,
      premultipliedAlpha = true,
      preserveDrawingBuffer = false,
      powerPreference = "default",
      failIfMajorPerformanceCaveat = false,
      reverseDepthBuffer = false
    } = parameters;
    this.isWebGLRenderer = true;
    let _alpha;
    if (context4 !== null) {
      if (typeof WebGLRenderingContext !== "undefined" && context4 instanceof WebGLRenderingContext) {
        throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
      }
      _alpha = context4.getContextAttributes().alpha;
    } else {
      _alpha = alpha;
    }
    const uintClearColor = new Uint32Array(4);
    const intClearColor = new Int32Array(4);
    let currentRenderList = null;
    let currentRenderState = null;
    const renderListStack = [];
    const renderStateStack = [];
    this.domElement = canvas;
    this.debug = {
      /**
       * Enables error checking and reporting when shader programs are being compiled
       * @type {boolean}
       */
      checkShaderErrors: true,
      /**
       * Callback for custom error reporting.
       * @type {?Function}
       */
      onShaderError: null
    };
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    this.sortObjects = true;
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    this._outputColorSpace = SRGBColorSpace$1;
    this.toneMapping = NoToneMapping;
    this.toneMappingExposure = 1;
    const _this = this;
    let _isContextLost = false;
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new Vector4();
    const _currentScissor = new Vector4();
    let _currentScissorTest = null;
    const _currentClearColor = new Color(0);
    let _currentClearAlpha = 0;
    let _width = canvas.width;
    let _height = canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new Vector4(0, 0, _width, _height);
    const _scissor = new Vector4(0, 0, _width, _height);
    let _scissorTest = false;
    const _frustum2 = new Frustum();
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    this.transmissionResolutionScale = 1;
    const _currentProjectionMatrix = new Matrix4();
    const _projScreenMatrix2 = new Matrix4();
    const _vector32 = new Vector3();
    const _vector4 = new Vector4();
    const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };
    let _renderBackground = false;
    function getTargetPixelRatio() {
      return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    let _gl = context4;
    function getContext(contextName, contextAttributes) {
      return canvas.getContext(contextName, contextAttributes);
    }
    try {
      const contextAttributes = {
        alpha: true,
        depth,
        stencil,
        antialias,
        premultipliedAlpha,
        preserveDrawingBuffer,
        powerPreference,
        failIfMajorPerformanceCaveat
      };
      if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${REVISION}`);
      canvas.addEventListener("webglcontextlost", onContextLost, false);
      canvas.addEventListener("webglcontextrestored", onContextRestore, false);
      canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
      if (_gl === null) {
        const contextName = "webgl2";
        _gl = getContext(contextName, contextAttributes);
        if (_gl === null) {
          if (getContext(contextName)) {
            throw new Error("Error creating WebGL context with your selected attributes.");
          } else {
            throw new Error("Error creating WebGL context.");
          }
        }
      }
    } catch (error2) {
      console.error("THREE.WebGLRenderer: " + error2.message);
      throw error2;
    }
    let extensions2, capabilities, state, info;
    let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping, shadowMap;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates, uniformsGroups;
    function initGLContext() {
      extensions2 = new WebGLExtensions(_gl);
      extensions2.init();
      utils = new WebGLUtils(_gl, extensions2);
      capabilities = new WebGLCapabilities(_gl, extensions2, parameters, utils);
      state = new WebGLState(_gl, extensions2);
      if (capabilities.reverseDepthBuffer && reverseDepthBuffer) {
        state.buffers.depth.setReversed(true);
      }
      info = new WebGLInfo(_gl);
      properties = new WebGLProperties();
      textures = new WebGLTextures(_gl, extensions2, state, properties, capabilities, utils, info);
      cubemaps = new WebGLCubeMaps(_this);
      cubeuvmaps = new WebGLCubeUVMaps(_this);
      attributes = new WebGLAttributes(_gl);
      bindingStates = new WebGLBindingStates(_gl, attributes);
      geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
      objects = new WebGLObjects(_gl, geometries, attributes, info);
      morphtargets = new WebGLMorphtargets(_gl, capabilities, textures);
      clipping = new WebGLClipping(properties);
      programCache = new WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions2, capabilities, bindingStates, clipping);
      materials = new WebGLMaterials(_this, properties);
      renderLists = new WebGLRenderLists();
      renderStates = new WebGLRenderStates(extensions2);
      background = new WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
      shadowMap = new WebGLShadowMap(_this, objects, capabilities);
      uniformsGroups = new WebGLUniformsGroups(_gl, info, capabilities, state);
      bufferRenderer = new WebGLBufferRenderer(_gl, extensions2, info);
      indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions2, info);
      info.programs = programCache.programs;
      _this.capabilities = capabilities;
      _this.extensions = extensions2;
      _this.properties = properties;
      _this.renderLists = renderLists;
      _this.shadowMap = shadowMap;
      _this.state = state;
      _this.info = info;
    }
    initGLContext();
    const xr = new WebXRManager(_this, _gl);
    this.xr = xr;
    this.getContext = function() {
      return _gl;
    };
    this.getContextAttributes = function() {
      return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
      const extension = extensions2.get("WEBGL_lose_context");
      if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
      const extension = extensions2.get("WEBGL_lose_context");
      if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
      return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
      if (value === void 0) return;
      _pixelRatio = value;
      this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
      return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle = true) {
      if (xr.isPresenting) {
        console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
        return;
      }
      _width = width;
      _height = height;
      canvas.width = Math.floor(width * _pixelRatio);
      canvas.height = Math.floor(height * _pixelRatio);
      if (updateStyle === true) {
        canvas.style.width = width + "px";
        canvas.style.height = height + "px";
      }
      this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
      return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
      _width = width;
      _height = height;
      _pixelRatio = pixelRatio;
      canvas.width = Math.floor(width * pixelRatio);
      canvas.height = Math.floor(height * pixelRatio);
      this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
      return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
      return target.copy(_viewport);
    };
    this.setViewport = function(x3, y2, width, height) {
      if (x3.isVector4) {
        _viewport.set(x3.x, x3.y, x3.z, x3.w);
      } else {
        _viewport.set(x3, y2, width, height);
      }
      state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
    };
    this.getScissor = function(target) {
      return target.copy(_scissor);
    };
    this.setScissor = function(x3, y2, width, height) {
      if (x3.isVector4) {
        _scissor.set(x3.x, x3.y, x3.z, x3.w);
      } else {
        _scissor.set(x3, y2, width, height);
      }
      state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
    };
    this.getScissorTest = function() {
      return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
      state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
      _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
      _transparentSort = method;
    };
    this.getClearColor = function(target) {
      return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
      background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
      return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
      background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color = true, depth2 = true, stencil2 = true) {
      let bits2 = 0;
      if (color) {
        let isIntegerFormat = false;
        if (_currentRenderTarget !== null) {
          const targetFormat = _currentRenderTarget.texture.format;
          isIntegerFormat = targetFormat === RGBAIntegerFormat || targetFormat === RGIntegerFormat || targetFormat === RedIntegerFormat;
        }
        if (isIntegerFormat) {
          const targetType = _currentRenderTarget.texture.type;
          const isUnsignedType = targetType === UnsignedByteType || targetType === UnsignedIntType || targetType === UnsignedShortType || targetType === UnsignedInt248Type || targetType === UnsignedShort4444Type || targetType === UnsignedShort5551Type;
          const clearColor = background.getClearColor();
          const a5 = background.getClearAlpha();
          const r3 = clearColor.r;
          const g2 = clearColor.g;
          const b6 = clearColor.b;
          if (isUnsignedType) {
            uintClearColor[0] = r3;
            uintClearColor[1] = g2;
            uintClearColor[2] = b6;
            uintClearColor[3] = a5;
            _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
          } else {
            intClearColor[0] = r3;
            intClearColor[1] = g2;
            intClearColor[2] = b6;
            intClearColor[3] = a5;
            _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
          }
        } else {
          bits2 |= _gl.COLOR_BUFFER_BIT;
        }
      }
      if (depth2) {
        bits2 |= _gl.DEPTH_BUFFER_BIT;
      }
      if (stencil2) {
        bits2 |= _gl.STENCIL_BUFFER_BIT;
        this.state.buffers.stencil.setMask(4294967295);
      }
      _gl.clear(bits2);
    };
    this.clearColor = function() {
      this.clear(true, false, false);
    };
    this.clearDepth = function() {
      this.clear(false, true, false);
    };
    this.clearStencil = function() {
      this.clear(false, false, true);
    };
    this.dispose = function() {
      canvas.removeEventListener("webglcontextlost", onContextLost, false);
      canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
      canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
      background.dispose();
      renderLists.dispose();
      renderStates.dispose();
      properties.dispose();
      cubemaps.dispose();
      cubeuvmaps.dispose();
      objects.dispose();
      bindingStates.dispose();
      uniformsGroups.dispose();
      programCache.dispose();
      xr.dispose();
      xr.removeEventListener("sessionstart", onXRSessionStart);
      xr.removeEventListener("sessionend", onXRSessionEnd);
      animation.stop();
    };
    function onContextLost(event) {
      event.preventDefault();
      console.log("THREE.WebGLRenderer: Context Lost.");
      _isContextLost = true;
    }
    function onContextRestore() {
      console.log("THREE.WebGLRenderer: Context Restored.");
      _isContextLost = false;
      const infoAutoReset = info.autoReset;
      const shadowMapEnabled = shadowMap.enabled;
      const shadowMapAutoUpdate = shadowMap.autoUpdate;
      const shadowMapNeedsUpdate = shadowMap.needsUpdate;
      const shadowMapType = shadowMap.type;
      initGLContext();
      info.autoReset = infoAutoReset;
      shadowMap.enabled = shadowMapEnabled;
      shadowMap.autoUpdate = shadowMapAutoUpdate;
      shadowMap.needsUpdate = shadowMapNeedsUpdate;
      shadowMap.type = shadowMapType;
    }
    function onContextCreationError(event) {
      console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
    }
    function onMaterialDispose(event) {
      const material = event.target;
      material.removeEventListener("dispose", onMaterialDispose);
      deallocateMaterial(material);
    }
    function deallocateMaterial(material) {
      releaseMaterialProgramReferences(material);
      properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
      const programs = properties.get(material).programs;
      if (programs !== void 0) {
        programs.forEach(function(program) {
          programCache.releaseProgram(program);
        });
        if (material.isShaderMaterial) {
          programCache.releaseShaderCache(material);
        }
      }
    }
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
      if (scene === null) scene = _emptyScene;
      const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
      const program = setProgram(camera, scene, geometry, material, object);
      state.setMaterial(material, frontFaceCW);
      let index = geometry.index;
      let rangeFactor = 1;
      if (material.wireframe === true) {
        index = geometries.getWireframeAttribute(geometry);
        if (index === void 0) return;
        rangeFactor = 2;
      }
      const drawRange = geometry.drawRange;
      const position = geometry.attributes.position;
      let drawStart = drawRange.start * rangeFactor;
      let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
      if (group !== null) {
        drawStart = Math.max(drawStart, group.start * rangeFactor);
        drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
      }
      if (index !== null) {
        drawStart = Math.max(drawStart, 0);
        drawEnd = Math.min(drawEnd, index.count);
      } else if (position !== void 0 && position !== null) {
        drawStart = Math.max(drawStart, 0);
        drawEnd = Math.min(drawEnd, position.count);
      }
      const drawCount = drawEnd - drawStart;
      if (drawCount < 0 || drawCount === Infinity) return;
      bindingStates.setup(object, material, program, geometry, index);
      let attribute;
      let renderer = bufferRenderer;
      if (index !== null) {
        attribute = attributes.get(index);
        renderer = indexedBufferRenderer;
        renderer.setIndex(attribute);
      }
      if (object.isMesh) {
        if (material.wireframe === true) {
          state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
          renderer.setMode(_gl.LINES);
        } else {
          renderer.setMode(_gl.TRIANGLES);
        }
      } else if (object.isLine) {
        let lineWidth = material.linewidth;
        if (lineWidth === void 0) lineWidth = 1;
        state.setLineWidth(lineWidth * getTargetPixelRatio());
        if (object.isLineSegments) {
          renderer.setMode(_gl.LINES);
        } else if (object.isLineLoop) {
          renderer.setMode(_gl.LINE_LOOP);
        } else {
          renderer.setMode(_gl.LINE_STRIP);
        }
      } else if (object.isPoints) {
        renderer.setMode(_gl.POINTS);
      } else if (object.isSprite) {
        renderer.setMode(_gl.TRIANGLES);
      }
      if (object.isBatchedMesh) {
        if (object._multiDrawInstances !== null) {
          renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
        } else {
          if (!extensions2.get("WEBGL_multi_draw")) {
            const starts = object._multiDrawStarts;
            const counts = object._multiDrawCounts;
            const drawCount2 = object._multiDrawCount;
            const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
            const uniforms = properties.get(material).currentProgram.getUniforms();
            for (let i2 = 0; i2 < drawCount2; i2++) {
              uniforms.setValue(_gl, "_gl_DrawID", i2);
              renderer.render(starts[i2] / bytesPerElement, counts[i2]);
            }
          } else {
            renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
          }
        }
      } else if (object.isInstancedMesh) {
        renderer.renderInstances(drawStart, drawCount, object.count);
      } else if (geometry.isInstancedBufferGeometry) {
        const maxInstanceCount = geometry._maxInstanceCount !== void 0 ? geometry._maxInstanceCount : Infinity;
        const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
        renderer.renderInstances(drawStart, drawCount, instanceCount);
      } else {
        renderer.render(drawStart, drawCount);
      }
    };
    function prepareMaterial(material, scene, object) {
      if (material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false) {
        material.side = BackSide;
        material.needsUpdate = true;
        getProgram(material, scene, object);
        material.side = FrontSide;
        material.needsUpdate = true;
        getProgram(material, scene, object);
        material.side = DoubleSide;
      } else {
        getProgram(material, scene, object);
      }
    }
    this.compile = function(scene, camera, targetScene = null) {
      if (targetScene === null) targetScene = scene;
      currentRenderState = renderStates.get(targetScene);
      currentRenderState.init(camera);
      renderStateStack.push(currentRenderState);
      targetScene.traverseVisible(function(object) {
        if (object.isLight && object.layers.test(camera.layers)) {
          currentRenderState.pushLight(object);
          if (object.castShadow) {
            currentRenderState.pushShadow(object);
          }
        }
      });
      if (scene !== targetScene) {
        scene.traverseVisible(function(object) {
          if (object.isLight && object.layers.test(camera.layers)) {
            currentRenderState.pushLight(object);
            if (object.castShadow) {
              currentRenderState.pushShadow(object);
            }
          }
        });
      }
      currentRenderState.setupLights();
      const materials2 = /* @__PURE__ */ new Set();
      scene.traverse(function(object) {
        if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) {
          return;
        }
        const material = object.material;
        if (material) {
          if (Array.isArray(material)) {
            for (let i2 = 0; i2 < material.length; i2++) {
              const material2 = material[i2];
              prepareMaterial(material2, targetScene, object);
              materials2.add(material2);
            }
          } else {
            prepareMaterial(material, targetScene, object);
            materials2.add(material);
          }
        }
      });
      renderStateStack.pop();
      currentRenderState = null;
      return materials2;
    };
    this.compileAsync = function(scene, camera, targetScene = null) {
      const materials2 = this.compile(scene, camera, targetScene);
      return new Promise((resolve2) => {
        function checkMaterialsReady() {
          materials2.forEach(function(material) {
            const materialProperties = properties.get(material);
            const program = materialProperties.currentProgram;
            if (program.isReady()) {
              materials2.delete(material);
            }
          });
          if (materials2.size === 0) {
            resolve2(scene);
            return;
          }
          setTimeout(checkMaterialsReady, 10);
        }
        if (extensions2.get("KHR_parallel_shader_compile") !== null) {
          checkMaterialsReady();
        } else {
          setTimeout(checkMaterialsReady, 10);
        }
      });
    };
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
      if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    function onXRSessionStart() {
      animation.stop();
    }
    function onXRSessionEnd() {
      animation.start();
    }
    const animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof self !== "undefined") animation.setContext(self);
    this.setAnimationLoop = function(callback) {
      onAnimationFrameCallback = callback;
      xr.setAnimationLoop(callback);
      callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener("sessionstart", onXRSessionStart);
    xr.addEventListener("sessionend", onXRSessionEnd);
    this.render = function(scene, camera) {
      if (camera !== void 0 && camera.isCamera !== true) {
        console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        return;
      }
      if (_isContextLost === true) return;
      if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
      if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
      if (xr.enabled === true && xr.isPresenting === true) {
        if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
        camera = xr.getCamera();
      }
      if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
      currentRenderState = renderStates.get(scene, renderStateStack.length);
      currentRenderState.init(camera);
      renderStateStack.push(currentRenderState);
      _projScreenMatrix2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
      _frustum2.setFromProjectionMatrix(_projScreenMatrix2);
      _localClippingEnabled = this.localClippingEnabled;
      _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
      currentRenderList = renderLists.get(scene, renderListStack.length);
      currentRenderList.init();
      renderListStack.push(currentRenderList);
      if (xr.enabled === true && xr.isPresenting === true) {
        const depthSensingMesh = _this.xr.getDepthSensingMesh();
        if (depthSensingMesh !== null) {
          projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
        }
      }
      projectObject(scene, camera, 0, _this.sortObjects);
      currentRenderList.finish();
      if (_this.sortObjects === true) {
        currentRenderList.sort(_opaqueSort, _transparentSort);
      }
      _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
      if (_renderBackground) {
        background.addToRenderList(currentRenderList, scene);
      }
      this.info.render.frame++;
      if (_clippingEnabled === true) clipping.beginShadows();
      const shadowsArray = currentRenderState.state.shadowsArray;
      shadowMap.render(shadowsArray, scene, camera);
      if (_clippingEnabled === true) clipping.endShadows();
      if (this.info.autoReset === true) this.info.reset();
      const opaqueObjects = currentRenderList.opaque;
      const transmissiveObjects = currentRenderList.transmissive;
      currentRenderState.setupLights();
      if (camera.isArrayCamera) {
        const cameras = camera.cameras;
        if (transmissiveObjects.length > 0) {
          for (let i2 = 0, l2 = cameras.length; i2 < l2; i2++) {
            const camera2 = cameras[i2];
            renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
          }
        }
        if (_renderBackground) background.render(scene);
        for (let i2 = 0, l2 = cameras.length; i2 < l2; i2++) {
          const camera2 = cameras[i2];
          renderScene(currentRenderList, scene, camera2, camera2.viewport);
        }
      } else {
        if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
        if (_renderBackground) background.render(scene);
        renderScene(currentRenderList, scene, camera);
      }
      if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
        textures.updateMultisampleRenderTarget(_currentRenderTarget);
        textures.updateRenderTargetMipmap(_currentRenderTarget);
      }
      if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
      bindingStates.resetDefaultState();
      _currentMaterialId = -1;
      _currentCamera = null;
      renderStateStack.pop();
      if (renderStateStack.length > 0) {
        currentRenderState = renderStateStack[renderStateStack.length - 1];
        if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
      } else {
        currentRenderState = null;
      }
      renderListStack.pop();
      if (renderListStack.length > 0) {
        currentRenderList = renderListStack[renderListStack.length - 1];
      } else {
        currentRenderList = null;
      }
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
      if (object.visible === false) return;
      const visible = object.layers.test(camera.layers);
      if (visible) {
        if (object.isGroup) {
          groupOrder = object.renderOrder;
        } else if (object.isLOD) {
          if (object.autoUpdate === true) object.update(camera);
        } else if (object.isLight) {
          currentRenderState.pushLight(object);
          if (object.castShadow) {
            currentRenderState.pushShadow(object);
          }
        } else if (object.isSprite) {
          if (!object.frustumCulled || _frustum2.intersectsSprite(object)) {
            if (sortObjects) {
              _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
            }
            const geometry = objects.update(object);
            const material = object.material;
            if (material.visible) {
              currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
            }
          }
        } else if (object.isMesh || object.isLine || object.isPoints) {
          if (!object.frustumCulled || _frustum2.intersectsObject(object)) {
            const geometry = objects.update(object);
            const material = object.material;
            if (sortObjects) {
              if (object.boundingSphere !== void 0) {
                if (object.boundingSphere === null) object.computeBoundingSphere();
                _vector4.copy(object.boundingSphere.center);
              } else {
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                _vector4.copy(geometry.boundingSphere.center);
              }
              _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
            }
            if (Array.isArray(material)) {
              const groups = geometry.groups;
              for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
                const group = groups[i2];
                const groupMaterial = material[group.materialIndex];
                if (groupMaterial && groupMaterial.visible) {
                  currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                }
              }
            } else if (material.visible) {
              currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
            }
          }
        }
      }
      const children = object.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        projectObject(children[i2], camera, groupOrder, sortObjects);
      }
    }
    function renderScene(currentRenderList2, scene, camera, viewport) {
      const opaqueObjects = currentRenderList2.opaque;
      const transmissiveObjects = currentRenderList2.transmissive;
      const transparentObjects = currentRenderList2.transparent;
      currentRenderState.setupLightsView(camera);
      if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
      if (viewport) state.viewport(_currentViewport.copy(viewport));
      if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
      if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
      if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
      state.buffers.depth.setTest(true);
      state.buffers.depth.setMask(true);
      state.buffers.color.setMask(true);
      state.setPolygonOffset(false);
    }
    function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
      const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
      if (overrideMaterial !== null) {
        return;
      }
      if (currentRenderState.state.transmissionRenderTarget[camera.id] === void 0) {
        currentRenderState.state.transmissionRenderTarget[camera.id] = new WebGLRenderTarget(1, 1, {
          generateMipmaps: true,
          type: extensions2.has("EXT_color_buffer_half_float") || extensions2.has("EXT_color_buffer_float") ? HalfFloatType : UnsignedByteType,
          minFilter: LinearMipmapLinearFilter,
          samples: 4,
          stencilBuffer: stencil,
          resolveDepthBuffer: false,
          resolveStencilBuffer: false,
          colorSpace: ColorManagement.workingColorSpace
        });
      }
      const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
      const activeViewport = camera.viewport || _currentViewport;
      transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
      const currentRenderTarget = _this.getRenderTarget();
      _this.setRenderTarget(transmissionRenderTarget);
      _this.getClearColor(_currentClearColor);
      _currentClearAlpha = _this.getClearAlpha();
      if (_currentClearAlpha < 1) _this.setClearColor(16777215, 0.5);
      _this.clear();
      if (_renderBackground) background.render(scene);
      const currentToneMapping = _this.toneMapping;
      _this.toneMapping = NoToneMapping;
      const currentCameraViewport = camera.viewport;
      if (camera.viewport !== void 0) camera.viewport = void 0;
      currentRenderState.setupLightsView(camera);
      if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
      renderObjects(opaqueObjects, scene, camera);
      textures.updateMultisampleRenderTarget(transmissionRenderTarget);
      textures.updateRenderTargetMipmap(transmissionRenderTarget);
      if (extensions2.has("WEBGL_multisampled_render_to_texture") === false) {
        let renderTargetNeedsUpdate = false;
        for (let i2 = 0, l2 = transmissiveObjects.length; i2 < l2; i2++) {
          const renderItem = transmissiveObjects[i2];
          const object = renderItem.object;
          const geometry = renderItem.geometry;
          const material = renderItem.material;
          const group = renderItem.group;
          if (material.side === DoubleSide && object.layers.test(camera.layers)) {
            const currentSide = material.side;
            material.side = BackSide;
            material.needsUpdate = true;
            renderObject(object, scene, camera, geometry, material, group);
            material.side = currentSide;
            material.needsUpdate = true;
            renderTargetNeedsUpdate = true;
          }
        }
        if (renderTargetNeedsUpdate === true) {
          textures.updateMultisampleRenderTarget(transmissionRenderTarget);
          textures.updateRenderTargetMipmap(transmissionRenderTarget);
        }
      }
      _this.setRenderTarget(currentRenderTarget);
      _this.setClearColor(_currentClearColor, _currentClearAlpha);
      if (currentCameraViewport !== void 0) camera.viewport = currentCameraViewport;
      _this.toneMapping = currentToneMapping;
    }
    function renderObjects(renderList, scene, camera) {
      const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
      for (let i2 = 0, l2 = renderList.length; i2 < l2; i2++) {
        const renderItem = renderList[i2];
        const object = renderItem.object;
        const geometry = renderItem.geometry;
        const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
        const group = renderItem.group;
        if (object.layers.test(camera.layers)) {
          renderObject(object, scene, camera, geometry, material, group);
        }
      }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
      object.onBeforeRender(_this, scene, camera, geometry, material, group);
      object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
      object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
      material.onBeforeRender(_this, scene, camera, geometry, object, group);
      if (material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false) {
        material.side = BackSide;
        material.needsUpdate = true;
        _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        material.side = FrontSide;
        material.needsUpdate = true;
        _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        material.side = DoubleSide;
      } else {
        _this.renderBufferDirect(camera, scene, geometry, material, object, group);
      }
      object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
      if (scene.isScene !== true) scene = _emptyScene;
      const materialProperties = properties.get(material);
      const lights = currentRenderState.state.lights;
      const shadowsArray = currentRenderState.state.shadowsArray;
      const lightsStateVersion = lights.state.version;
      const parameters2 = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
      const programCacheKey = programCache.getProgramCacheKey(parameters2);
      let programs = materialProperties.programs;
      materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
      materialProperties.fog = scene.fog;
      materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
      materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
      if (programs === void 0) {
        material.addEventListener("dispose", onMaterialDispose);
        programs = /* @__PURE__ */ new Map();
        materialProperties.programs = programs;
      }
      let program = programs.get(programCacheKey);
      if (program !== void 0) {
        if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
          updateCommonMaterialProperties(material, parameters2);
          return program;
        }
      } else {
        parameters2.uniforms = programCache.getUniforms(material);
        material.onBeforeCompile(parameters2, _this);
        program = programCache.acquireProgram(parameters2, programCacheKey);
        programs.set(programCacheKey, program);
        materialProperties.uniforms = parameters2.uniforms;
      }
      const uniforms = materialProperties.uniforms;
      if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
        uniforms.clippingPlanes = clipping.uniform;
      }
      updateCommonMaterialProperties(material, parameters2);
      materialProperties.needsLights = materialNeedsLights(material);
      materialProperties.lightsStateVersion = lightsStateVersion;
      if (materialProperties.needsLights) {
        uniforms.ambientLightColor.value = lights.state.ambient;
        uniforms.lightProbe.value = lights.state.probe;
        uniforms.directionalLights.value = lights.state.directional;
        uniforms.directionalLightShadows.value = lights.state.directionalShadow;
        uniforms.spotLights.value = lights.state.spot;
        uniforms.spotLightShadows.value = lights.state.spotShadow;
        uniforms.rectAreaLights.value = lights.state.rectArea;
        uniforms.ltc_1.value = lights.state.rectAreaLTC1;
        uniforms.ltc_2.value = lights.state.rectAreaLTC2;
        uniforms.pointLights.value = lights.state.point;
        uniforms.pointLightShadows.value = lights.state.pointShadow;
        uniforms.hemisphereLights.value = lights.state.hemi;
        uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
        uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
        uniforms.spotShadowMap.value = lights.state.spotShadowMap;
        uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
        uniforms.spotLightMap.value = lights.state.spotLightMap;
        uniforms.pointShadowMap.value = lights.state.pointShadowMap;
        uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
      }
      materialProperties.currentProgram = program;
      materialProperties.uniformsList = null;
      return program;
    }
    function getUniformList(materialProperties) {
      if (materialProperties.uniformsList === null) {
        const progUniforms = materialProperties.currentProgram.getUniforms();
        materialProperties.uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
      }
      return materialProperties.uniformsList;
    }
    function updateCommonMaterialProperties(material, parameters2) {
      const materialProperties = properties.get(material);
      materialProperties.outputColorSpace = parameters2.outputColorSpace;
      materialProperties.batching = parameters2.batching;
      materialProperties.batchingColor = parameters2.batchingColor;
      materialProperties.instancing = parameters2.instancing;
      materialProperties.instancingColor = parameters2.instancingColor;
      materialProperties.instancingMorph = parameters2.instancingMorph;
      materialProperties.skinning = parameters2.skinning;
      materialProperties.morphTargets = parameters2.morphTargets;
      materialProperties.morphNormals = parameters2.morphNormals;
      materialProperties.morphColors = parameters2.morphColors;
      materialProperties.morphTargetsCount = parameters2.morphTargetsCount;
      materialProperties.numClippingPlanes = parameters2.numClippingPlanes;
      materialProperties.numIntersection = parameters2.numClipIntersection;
      materialProperties.vertexAlphas = parameters2.vertexAlphas;
      materialProperties.vertexTangents = parameters2.vertexTangents;
      materialProperties.toneMapping = parameters2.toneMapping;
    }
    function setProgram(camera, scene, geometry, material, object) {
      if (scene.isScene !== true) scene = _emptyScene;
      textures.resetTextureUnits();
      const fog = scene.fog;
      const environment = material.isMeshStandardMaterial ? scene.environment : null;
      const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace$1;
      const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
      const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
      const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
      const morphTargets = !!geometry.morphAttributes.position;
      const morphNormals = !!geometry.morphAttributes.normal;
      const morphColors = !!geometry.morphAttributes.color;
      let toneMapping = NoToneMapping;
      if (material.toneMapped) {
        if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) {
          toneMapping = _this.toneMapping;
        }
      }
      const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
      const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
      const materialProperties = properties.get(material);
      const lights = currentRenderState.state.lights;
      if (_clippingEnabled === true) {
        if (_localClippingEnabled === true || camera !== _currentCamera) {
          const useCache = camera === _currentCamera && material.id === _currentMaterialId;
          clipping.setState(material, camera, useCache);
        }
      }
      let needsProgramChange = false;
      if (material.version === materialProperties.__version) {
        if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) {
          needsProgramChange = true;
        } else if (materialProperties.outputColorSpace !== colorSpace) {
          needsProgramChange = true;
        } else if (object.isBatchedMesh && materialProperties.batching === false) {
          needsProgramChange = true;
        } else if (!object.isBatchedMesh && materialProperties.batching === true) {
          needsProgramChange = true;
        } else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) {
          needsProgramChange = true;
        } else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancing === false) {
          needsProgramChange = true;
        } else if (!object.isInstancedMesh && materialProperties.instancing === true) {
          needsProgramChange = true;
        } else if (object.isSkinnedMesh && materialProperties.skinning === false) {
          needsProgramChange = true;
        } else if (!object.isSkinnedMesh && materialProperties.skinning === true) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) {
          needsProgramChange = true;
        } else if (materialProperties.envMap !== envMap) {
          needsProgramChange = true;
        } else if (material.fog === true && materialProperties.fog !== fog) {
          needsProgramChange = true;
        } else if (materialProperties.numClippingPlanes !== void 0 && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {
          needsProgramChange = true;
        } else if (materialProperties.vertexAlphas !== vertexAlphas) {
          needsProgramChange = true;
        } else if (materialProperties.vertexTangents !== vertexTangents) {
          needsProgramChange = true;
        } else if (materialProperties.morphTargets !== morphTargets) {
          needsProgramChange = true;
        } else if (materialProperties.morphNormals !== morphNormals) {
          needsProgramChange = true;
        } else if (materialProperties.morphColors !== morphColors) {
          needsProgramChange = true;
        } else if (materialProperties.toneMapping !== toneMapping) {
          needsProgramChange = true;
        } else if (materialProperties.morphTargetsCount !== morphTargetsCount) {
          needsProgramChange = true;
        }
      } else {
        needsProgramChange = true;
        materialProperties.__version = material.version;
      }
      let program = materialProperties.currentProgram;
      if (needsProgramChange === true) {
        program = getProgram(material, scene, object);
      }
      let refreshProgram = false;
      let refreshMaterial = false;
      let refreshLights = false;
      const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
      if (state.useProgram(program.program)) {
        refreshProgram = true;
        refreshMaterial = true;
        refreshLights = true;
      }
      if (material.id !== _currentMaterialId) {
        _currentMaterialId = material.id;
        refreshMaterial = true;
      }
      if (refreshProgram || _currentCamera !== camera) {
        const reverseDepthBuffer2 = state.buffers.depth.getReversed();
        if (reverseDepthBuffer2) {
          _currentProjectionMatrix.copy(camera.projectionMatrix);
          toNormalizedProjectionMatrix(_currentProjectionMatrix);
          toReversedProjectionMatrix(_currentProjectionMatrix);
          p_uniforms.setValue(_gl, "projectionMatrix", _currentProjectionMatrix);
        } else {
          p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
        }
        p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
        const uCamPos = p_uniforms.map.cameraPosition;
        if (uCamPos !== void 0) {
          uCamPos.setValue(_gl, _vector32.setFromMatrixPosition(camera.matrixWorld));
        }
        if (capabilities.logarithmicDepthBuffer) {
          p_uniforms.setValue(
            _gl,
            "logDepthBufFC",
            2 / (Math.log(camera.far + 1) / Math.LN2)
          );
        }
        if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {
          p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
        }
        if (_currentCamera !== camera) {
          _currentCamera = camera;
          refreshMaterial = true;
          refreshLights = true;
        }
      }
      if (object.isSkinnedMesh) {
        p_uniforms.setOptional(_gl, object, "bindMatrix");
        p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
        const skeleton = object.skeleton;
        if (skeleton) {
          if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
          p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
        }
      }
      if (object.isBatchedMesh) {
        p_uniforms.setOptional(_gl, object, "batchingTexture");
        p_uniforms.setValue(_gl, "batchingTexture", object._matricesTexture, textures);
        p_uniforms.setOptional(_gl, object, "batchingIdTexture");
        p_uniforms.setValue(_gl, "batchingIdTexture", object._indirectTexture, textures);
        p_uniforms.setOptional(_gl, object, "batchingColorTexture");
        if (object._colorsTexture !== null) {
          p_uniforms.setValue(_gl, "batchingColorTexture", object._colorsTexture, textures);
        }
      }
      const morphAttributes = geometry.morphAttributes;
      if (morphAttributes.position !== void 0 || morphAttributes.normal !== void 0 || morphAttributes.color !== void 0) {
        morphtargets.update(object, geometry, program);
      }
      if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
        materialProperties.receiveShadow = object.receiveShadow;
        p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
      }
      if (material.isMeshGouraudMaterial && material.envMap !== null) {
        m_uniforms.envMap.value = envMap;
        m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
      }
      if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) {
        m_uniforms.envMapIntensity.value = scene.environmentIntensity;
      }
      if (refreshMaterial) {
        p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
        if (materialProperties.needsLights) {
          markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
        }
        if (fog && material.fog === true) {
          materials.refreshFogUniforms(m_uniforms, fog);
        }
        materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
        WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
      }
      if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
        WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
        material.uniformsNeedUpdate = false;
      }
      if (material.isSpriteMaterial) {
        p_uniforms.setValue(_gl, "center", object.center);
      }
      p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
      p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
      p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
      if (material.isShaderMaterial || material.isRawShaderMaterial) {
        const groups = material.uniformsGroups;
        for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
          const group = groups[i2];
          uniformsGroups.update(group, program);
          uniformsGroups.bind(group, program);
        }
      }
      return program;
    }
    function markUniformsLightsNeedsUpdate(uniforms, value) {
      uniforms.ambientLightColor.needsUpdate = value;
      uniforms.lightProbe.needsUpdate = value;
      uniforms.directionalLights.needsUpdate = value;
      uniforms.directionalLightShadows.needsUpdate = value;
      uniforms.pointLights.needsUpdate = value;
      uniforms.pointLightShadows.needsUpdate = value;
      uniforms.spotLights.needsUpdate = value;
      uniforms.spotLightShadows.needsUpdate = value;
      uniforms.rectAreaLights.needsUpdate = value;
      uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
      return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
      return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
      return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
      return _currentRenderTarget;
    };
    this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
      properties.get(renderTarget.texture).__webglTexture = colorTexture;
      properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
      const renderTargetProperties = properties.get(renderTarget);
      renderTargetProperties.__hasExternalTextures = true;
      renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === void 0;
      if (!renderTargetProperties.__autoAllocateDepthBuffer) {
        if (extensions2.has("WEBGL_multisampled_render_to_texture") === true) {
          console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
          renderTargetProperties.__useRenderToTexture = false;
        }
      }
    };
    this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
      const renderTargetProperties = properties.get(renderTarget);
      renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
      renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === void 0;
    };
    const _scratchFrameBuffer = _gl.createFramebuffer();
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
      _currentRenderTarget = renderTarget;
      _currentActiveCubeFace = activeCubeFace;
      _currentActiveMipmapLevel = activeMipmapLevel;
      let useDefaultFramebuffer = true;
      let framebuffer = null;
      let isCube = false;
      let isRenderTarget3D = false;
      if (renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTargetProperties.__useDefaultFramebuffer !== void 0) {
          state.bindFramebuffer(_gl.FRAMEBUFFER, null);
          useDefaultFramebuffer = false;
        } else if (renderTargetProperties.__webglFramebuffer === void 0) {
          textures.setupRenderTarget(renderTarget);
        } else if (renderTargetProperties.__hasExternalTextures) {
          textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
        } else if (renderTarget.depthBuffer) {
          const depthTexture = renderTarget.depthTexture;
          if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
            if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) {
              throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
            }
            textures.setupDepthRenderbuffer(renderTarget);
          }
        }
        const texture = renderTarget.texture;
        if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
          isRenderTarget3D = true;
        }
        const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget) {
          if (Array.isArray(__webglFramebuffer[activeCubeFace])) {
            framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
          } else {
            framebuffer = __webglFramebuffer[activeCubeFace];
          }
          isCube = true;
        } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) {
          framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
        } else {
          if (Array.isArray(__webglFramebuffer)) {
            framebuffer = __webglFramebuffer[activeMipmapLevel];
          } else {
            framebuffer = __webglFramebuffer;
          }
        }
        _currentViewport.copy(renderTarget.viewport);
        _currentScissor.copy(renderTarget.scissor);
        _currentScissorTest = renderTarget.scissorTest;
      } else {
        _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
        _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
        _currentScissorTest = _scissorTest;
      }
      if (activeMipmapLevel !== 0) {
        framebuffer = _scratchFrameBuffer;
      }
      const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
      if (framebufferBound && useDefaultFramebuffer) {
        state.drawBuffers(renderTarget, framebuffer);
      }
      state.viewport(_currentViewport);
      state.scissor(_currentScissor);
      state.setScissorTest(_currentScissorTest);
      if (isCube) {
        const textureProperties = properties.get(renderTarget.texture);
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
      } else if (isRenderTarget3D) {
        const textureProperties = properties.get(renderTarget.texture);
        const layer = activeCubeFace;
        _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel, layer);
      } else if (renderTarget !== null && activeMipmapLevel !== 0) {
        const textureProperties = properties.get(renderTarget.texture);
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
      }
      _currentMaterialId = -1;
    };
    this.readRenderTargetPixels = function(renderTarget, x3, y2, width, height, buffer, activeCubeFaceIndex) {
      if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        return;
      }
      let framebuffer = properties.get(renderTarget).__webglFramebuffer;
      if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
        framebuffer = framebuffer[activeCubeFaceIndex];
      }
      if (framebuffer) {
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        try {
          const texture = renderTarget.texture;
          const textureFormat = texture.format;
          const textureType = texture.type;
          if (!capabilities.textureFormatReadable(textureFormat)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            return;
          }
          if (!capabilities.textureTypeReadable(textureType)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            return;
          }
          if (x3 >= 0 && x3 <= renderTarget.width - width && (y2 >= 0 && y2 <= renderTarget.height - height)) {
            _gl.readPixels(x3, y2, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
          }
        } finally {
          const framebuffer2 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
          state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer2);
        }
      }
    };
    this.readRenderTargetPixelsAsync = async function(renderTarget, x3, y2, width, height, buffer, activeCubeFaceIndex) {
      if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
        throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      }
      let framebuffer = properties.get(renderTarget).__webglFramebuffer;
      if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
        framebuffer = framebuffer[activeCubeFaceIndex];
      }
      if (framebuffer) {
        const texture = renderTarget.texture;
        const textureFormat = texture.format;
        const textureType = texture.type;
        if (!capabilities.textureFormatReadable(textureFormat)) {
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
        }
        if (!capabilities.textureTypeReadable(textureType)) {
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
        }
        if (x3 >= 0 && x3 <= renderTarget.width - width && (y2 >= 0 && y2 <= renderTarget.height - height)) {
          state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
          const glBuffer = _gl.createBuffer();
          _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
          _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
          _gl.readPixels(x3, y2, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
          const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
          state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
          const sync2 = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
          _gl.flush();
          await probeAsync(_gl, sync2, 4);
          _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
          _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
          _gl.deleteBuffer(glBuffer);
          _gl.deleteSync(sync2);
          return buffer;
        } else {
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
        }
      }
    };
    this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
      if (texture.isTexture !== true) {
        warnOnce("WebGLRenderer: copyFramebufferToTexture function signature has changed.");
        position = arguments[0] || null;
        texture = arguments[1];
      }
      const levelScale = Math.pow(2, -level);
      const width = Math.floor(texture.image.width * levelScale);
      const height = Math.floor(texture.image.height * levelScale);
      const x3 = position !== null ? position.x : 0;
      const y2 = position !== null ? position.y : 0;
      textures.setTexture2D(texture, 0);
      _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x3, y2, width, height);
      state.unbindTexture();
    };
    const _srcFramebuffer = _gl.createFramebuffer();
    const _dstFramebuffer = _gl.createFramebuffer();
    this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
      if (srcTexture.isTexture !== true) {
        warnOnce("WebGLRenderer: copyTextureToTexture function signature has changed.");
        dstPosition = arguments[0] || null;
        srcTexture = arguments[1];
        dstTexture = arguments[2];
        dstLevel = arguments[3] || 0;
        srcRegion = null;
      }
      if (dstLevel === null) {
        if (srcLevel !== 0) {
          warnOnce("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.");
          dstLevel = srcLevel;
          srcLevel = 0;
        } else {
          dstLevel = 0;
        }
      }
      let width, height, depth2, minX, minY, minZ;
      let dstX, dstY, dstZ;
      const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
      if (srcRegion !== null) {
        width = srcRegion.max.x - srcRegion.min.x;
        height = srcRegion.max.y - srcRegion.min.y;
        depth2 = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
        minX = srcRegion.min.x;
        minY = srcRegion.min.y;
        minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
      } else {
        const levelScale = Math.pow(2, -srcLevel);
        width = Math.floor(image.width * levelScale);
        height = Math.floor(image.height * levelScale);
        if (srcTexture.isDataArrayTexture) {
          depth2 = image.depth;
        } else if (srcTexture.isData3DTexture) {
          depth2 = Math.floor(image.depth * levelScale);
        } else {
          depth2 = 1;
        }
        minX = 0;
        minY = 0;
        minZ = 0;
      }
      if (dstPosition !== null) {
        dstX = dstPosition.x;
        dstY = dstPosition.y;
        dstZ = dstPosition.z;
      } else {
        dstX = 0;
        dstY = 0;
        dstZ = 0;
      }
      const glFormat = utils.convert(dstTexture.format);
      const glType = utils.convert(dstTexture.type);
      let glTarget;
      if (dstTexture.isData3DTexture) {
        textures.setTexture3D(dstTexture, 0);
        glTarget = _gl.TEXTURE_3D;
      } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
        textures.setTexture2DArray(dstTexture, 0);
        glTarget = _gl.TEXTURE_2D_ARRAY;
      } else {
        textures.setTexture2D(dstTexture, 0);
        glTarget = _gl.TEXTURE_2D;
      }
      _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
      _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
      _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
      const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
      const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
      const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
      const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
      const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
      _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
      _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
      _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
      _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
      _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
      const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
      const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
      if (srcTexture.isDepthTexture) {
        const srcTextureProperties = properties.get(srcTexture);
        const dstTextureProperties = properties.get(dstTexture);
        const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
        const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
        for (let i2 = 0; i2 < depth2; i2++) {
          if (isSrc3D) {
            _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i2);
            _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i2);
          }
          _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
      } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
        const srcTextureProperties = properties.get(srcTexture);
        const dstTextureProperties = properties.get(dstTexture);
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
        for (let i2 = 0; i2 < depth2; i2++) {
          if (isSrc3D) {
            _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i2);
          } else {
            _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
          }
          if (isDst3D) {
            _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i2);
          } else {
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
          }
          if (srcLevel !== 0) {
            _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
          } else if (isDst3D) {
            _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i2, minX, minY, width, height);
          } else {
            _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
          }
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
      } else {
        if (isDst3D) {
          if (srcTexture.isDataTexture || srcTexture.isData3DTexture) {
            _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, glType, image.data);
          } else if (dstTexture.isCompressedArrayTexture) {
            _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, image.data);
          } else {
            _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, glType, image);
          }
        } else {
          if (srcTexture.isDataTexture) {
            _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
          } else if (srcTexture.isCompressedTexture) {
            _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
          } else {
            _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
          }
        }
      }
      _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
      _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
      _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
      _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
      _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
      if (dstLevel === 0 && dstTexture.generateMipmaps) {
        _gl.generateMipmap(glTarget);
      }
      state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
      if (srcTexture.isTexture !== true) {
        warnOnce("WebGLRenderer: copyTextureToTexture3D function signature has changed.");
        srcRegion = arguments[0] || null;
        dstPosition = arguments[1] || null;
        srcTexture = arguments[2];
        dstTexture = arguments[3];
        level = arguments[4] || 0;
      }
      warnOnce('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
      return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
    };
    this.initRenderTarget = function(target) {
      if (properties.get(target).__webglFramebuffer === void 0) {
        textures.setupRenderTarget(target);
      }
    };
    this.initTexture = function(texture) {
      if (texture.isCubeTexture) {
        textures.setTextureCube(texture, 0);
      } else if (texture.isData3DTexture) {
        textures.setTexture3D(texture, 0);
      } else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
        textures.setTexture2DArray(texture, 0);
      } else {
        textures.setTexture2D(texture, 0);
      }
      state.unbindTexture();
    };
    this.resetState = function() {
      _currentActiveCubeFace = 0;
      _currentActiveMipmapLevel = 0;
      _currentRenderTarget = null;
      state.reset();
      bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== "undefined") {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
  }
  get coordinateSystem() {
    return WebGLCoordinateSystem;
  }
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(colorSpace) {
    this._outputColorSpace = colorSpace;
    const gl = this.getContext();
    gl.drawingBufferColorspace = ColorManagement._getDrawingBufferColorSpace(colorSpace);
    gl.unpackColorSpace = ColorManagement._getUnpackColorSpace();
  }
}
const THREE$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACESFilmicToneMapping,
  AddEquation,
  AddOperation,
  AdditiveAnimationBlendMode,
  AdditiveBlending,
  AgXToneMapping,
  AlphaFormat,
  AlwaysCompare,
  AlwaysDepth,
  AlwaysStencilFunc,
  AmbientLight,
  AnimationAction,
  AnimationClip,
  AnimationLoader,
  AnimationMixer,
  AnimationObjectGroup,
  AnimationUtils,
  ArcCurve,
  ArrayCamera,
  ArrowHelper,
  AttachedBindMode,
  Audio,
  AudioAnalyser,
  AudioContext,
  AudioListener,
  AudioLoader,
  AxesHelper,
  BackSide,
  BasicDepthPacking,
  BasicShadowMap,
  BatchedMesh,
  Bone,
  BooleanKeyframeTrack,
  Box2,
  Box3,
  Box3Helper,
  BoxGeometry,
  BoxHelper,
  BufferAttribute,
  BufferGeometry,
  BufferGeometryLoader,
  ByteType,
  Cache,
  Camera,
  CameraHelper,
  CanvasTexture,
  CapsuleGeometry,
  CatmullRomCurve3,
  CineonToneMapping,
  CircleGeometry,
  ClampToEdgeWrapping,
  Clock,
  Color,
  ColorKeyframeTrack,
  ColorManagement,
  CompressedArrayTexture,
  CompressedCubeTexture,
  CompressedTexture,
  CompressedTextureLoader,
  ConeGeometry,
  ConstantAlphaFactor,
  ConstantColorFactor,
  Controls,
  CubeCamera,
  CubeReflectionMapping,
  CubeRefractionMapping,
  CubeTexture,
  CubeTextureLoader,
  CubeUVReflectionMapping,
  CubicBezierCurve,
  CubicBezierCurve3,
  CubicInterpolant,
  CullFaceBack,
  CullFaceFront,
  CullFaceFrontBack,
  CullFaceNone,
  Curve,
  CurvePath,
  CustomBlending,
  CustomToneMapping,
  CylinderGeometry,
  Cylindrical,
  Data3DTexture,
  DataArrayTexture,
  DataTexture,
  DataTextureLoader,
  DataUtils,
  DecrementStencilOp,
  DecrementWrapStencilOp,
  DefaultLoadingManager,
  DepthFormat,
  DepthStencilFormat,
  DepthTexture,
  DetachedBindMode,
  DirectionalLight,
  DirectionalLightHelper,
  DiscreteInterpolant,
  DodecahedronGeometry,
  DoubleSide,
  DstAlphaFactor,
  DstColorFactor,
  DynamicCopyUsage,
  DynamicDrawUsage,
  DynamicReadUsage,
  EdgesGeometry,
  EllipseCurve,
  EqualCompare,
  EqualDepth,
  EqualStencilFunc,
  EquirectangularReflectionMapping,
  EquirectangularRefractionMapping,
  Euler,
  EventDispatcher: EventDispatcher$2,
  ExtrudeGeometry,
  FileLoader,
  Float16BufferAttribute,
  Float32BufferAttribute,
  FloatType,
  Fog,
  FogExp2,
  FramebufferTexture,
  FrontSide,
  Frustum,
  GLBufferAttribute,
  GLSL1,
  GLSL3,
  GreaterCompare,
  GreaterDepth,
  GreaterEqualCompare,
  GreaterEqualDepth,
  GreaterEqualStencilFunc,
  GreaterStencilFunc,
  GridHelper,
  Group,
  HalfFloatType,
  HemisphereLight,
  HemisphereLightHelper,
  IcosahedronGeometry,
  ImageBitmapLoader,
  ImageLoader,
  ImageUtils,
  IncrementStencilOp,
  IncrementWrapStencilOp,
  InstancedBufferAttribute,
  InstancedBufferGeometry,
  InstancedInterleavedBuffer,
  InstancedMesh,
  Int16BufferAttribute,
  Int32BufferAttribute,
  Int8BufferAttribute,
  IntType,
  InterleavedBuffer,
  InterleavedBufferAttribute,
  Interpolant,
  InterpolateDiscrete,
  InterpolateLinear,
  InterpolateSmooth,
  InvertStencilOp,
  KeepStencilOp,
  KeyframeTrack,
  LOD,
  LatheGeometry,
  Layers,
  LessCompare,
  LessDepth,
  LessEqualCompare,
  LessEqualDepth,
  LessEqualStencilFunc,
  LessStencilFunc,
  Light,
  LightProbe,
  Line,
  Line3,
  LineBasicMaterial,
  LineCurve,
  LineCurve3,
  LineDashedMaterial,
  LineLoop,
  LineSegments,
  LinearFilter,
  LinearInterpolant,
  LinearMipMapLinearFilter,
  LinearMipMapNearestFilter,
  LinearMipmapLinearFilter,
  LinearMipmapNearestFilter,
  LinearSRGBColorSpace: LinearSRGBColorSpace$1,
  LinearToneMapping,
  LinearTransfer,
  Loader,
  LoaderUtils,
  LoadingManager,
  LoopOnce,
  LoopPingPong,
  LoopRepeat,
  LuminanceAlphaFormat,
  LuminanceFormat,
  MOUSE,
  Material,
  MaterialLoader,
  MathUtils,
  Matrix2,
  Matrix3,
  Matrix4,
  MaxEquation,
  Mesh,
  MeshBasicMaterial,
  MeshDepthMaterial,
  MeshDistanceMaterial,
  MeshLambertMaterial,
  MeshMatcapMaterial,
  MeshNormalMaterial,
  MeshPhongMaterial,
  MeshPhysicalMaterial,
  MeshStandardMaterial,
  MeshToonMaterial,
  MinEquation,
  MirroredRepeatWrapping,
  MixOperation,
  MultiplyBlending,
  MultiplyOperation,
  NearestFilter,
  NearestMipMapLinearFilter,
  NearestMipMapNearestFilter,
  NearestMipmapLinearFilter,
  NearestMipmapNearestFilter,
  NeutralToneMapping,
  NeverCompare,
  NeverDepth,
  NeverStencilFunc,
  NoBlending,
  NoColorSpace,
  NoToneMapping,
  NormalAnimationBlendMode,
  NormalBlending,
  NotEqualCompare,
  NotEqualDepth,
  NotEqualStencilFunc,
  NumberKeyframeTrack,
  Object3D,
  ObjectLoader,
  ObjectSpaceNormalMap,
  OctahedronGeometry,
  OneFactor,
  OneMinusConstantAlphaFactor,
  OneMinusConstantColorFactor,
  OneMinusDstAlphaFactor,
  OneMinusDstColorFactor,
  OneMinusSrcAlphaFactor,
  OneMinusSrcColorFactor,
  OrthographicCamera,
  PCFShadowMap,
  PCFSoftShadowMap,
  PMREMGenerator,
  Path,
  PerspectiveCamera,
  Plane,
  PlaneGeometry,
  PlaneHelper,
  PointLight,
  PointLightHelper,
  Points,
  PointsMaterial,
  PolarGridHelper,
  PolyhedronGeometry,
  PositionalAudio,
  PropertyBinding,
  PropertyMixer,
  QuadraticBezierCurve,
  QuadraticBezierCurve3,
  Quaternion,
  QuaternionKeyframeTrack,
  QuaternionLinearInterpolant,
  RED_GREEN_RGTC2_Format,
  RED_RGTC1_Format,
  REVISION,
  RGBADepthPacking,
  RGBAFormat,
  RGBAIntegerFormat,
  RGBA_ASTC_10x10_Format,
  RGBA_ASTC_10x5_Format,
  RGBA_ASTC_10x6_Format,
  RGBA_ASTC_10x8_Format,
  RGBA_ASTC_12x10_Format,
  RGBA_ASTC_12x12_Format,
  RGBA_ASTC_4x4_Format,
  RGBA_ASTC_5x4_Format,
  RGBA_ASTC_5x5_Format,
  RGBA_ASTC_6x5_Format,
  RGBA_ASTC_6x6_Format,
  RGBA_ASTC_8x5_Format,
  RGBA_ASTC_8x6_Format,
  RGBA_ASTC_8x8_Format,
  RGBA_BPTC_Format,
  RGBA_ETC2_EAC_Format,
  RGBA_PVRTC_2BPPV1_Format,
  RGBA_PVRTC_4BPPV1_Format,
  RGBA_S3TC_DXT1_Format,
  RGBA_S3TC_DXT3_Format,
  RGBA_S3TC_DXT5_Format,
  RGBDepthPacking,
  RGBFormat,
  RGBIntegerFormat,
  RGB_BPTC_SIGNED_Format,
  RGB_BPTC_UNSIGNED_Format,
  RGB_ETC1_Format,
  RGB_ETC2_Format,
  RGB_PVRTC_2BPPV1_Format,
  RGB_PVRTC_4BPPV1_Format,
  RGB_S3TC_DXT1_Format,
  RGDepthPacking,
  RGFormat,
  RGIntegerFormat,
  RawShaderMaterial,
  Ray,
  Raycaster,
  RectAreaLight,
  RedFormat,
  RedIntegerFormat,
  ReinhardToneMapping,
  RenderTarget,
  RenderTarget3D,
  RenderTargetArray,
  RepeatWrapping,
  ReplaceStencilOp,
  ReverseSubtractEquation,
  RingGeometry,
  SIGNED_RED_GREEN_RGTC2_Format,
  SIGNED_RED_RGTC1_Format,
  SRGBColorSpace: SRGBColorSpace$1,
  SRGBTransfer,
  Scene,
  ShaderChunk,
  ShaderLib,
  ShaderMaterial,
  ShadowMaterial,
  Shape,
  ShapeGeometry,
  ShapePath,
  ShapeUtils,
  ShortType,
  Skeleton,
  SkeletonHelper,
  SkinnedMesh,
  Source,
  Sphere,
  SphereGeometry,
  Spherical,
  SphericalHarmonics3,
  SplineCurve,
  SpotLight,
  SpotLightHelper,
  Sprite,
  SpriteMaterial,
  SrcAlphaFactor,
  SrcAlphaSaturateFactor,
  SrcColorFactor,
  StaticCopyUsage,
  StaticDrawUsage,
  StaticReadUsage,
  StereoCamera,
  StreamCopyUsage,
  StreamDrawUsage,
  StreamReadUsage,
  StringKeyframeTrack,
  SubtractEquation,
  SubtractiveBlending,
  TOUCH,
  TangentSpaceNormalMap,
  TetrahedronGeometry,
  Texture,
  TextureLoader,
  TextureUtils,
  TimestampQuery,
  TorusGeometry,
  TorusKnotGeometry,
  Triangle,
  TriangleFanDrawMode,
  TriangleStripDrawMode,
  TrianglesDrawMode,
  TubeGeometry,
  UVMapping,
  Uint16BufferAttribute,
  Uint32BufferAttribute,
  Uint8BufferAttribute,
  Uint8ClampedBufferAttribute,
  Uniform,
  UniformsGroup,
  UniformsLib,
  UniformsUtils,
  UnsignedByteType,
  UnsignedInt248Type,
  UnsignedInt5999Type,
  UnsignedIntType,
  UnsignedShort4444Type,
  UnsignedShort5551Type,
  UnsignedShortType,
  VSMShadowMap,
  Vector2,
  Vector3,
  Vector4,
  VectorKeyframeTrack,
  VideoFrameTexture,
  VideoTexture,
  WebGL3DRenderTarget,
  WebGLArrayRenderTarget,
  WebGLCoordinateSystem,
  WebGLCubeRenderTarget,
  WebGLRenderTarget,
  WebGLRenderer,
  WebGLUtils,
  WebGPUCoordinateSystem,
  WebXRController,
  WireframeGeometry,
  WrapAroundEnding,
  ZeroCurvatureEnding,
  ZeroFactor,
  ZeroSlopeEnding,
  ZeroStencilOp,
  createCanvasElement
}, Symbol.toStringTag, { value: "Module" }));
var constants = { exports: {} };
var reactReconcilerConstants_production_min = {};
var hasRequiredReactReconcilerConstants_production_min;
function requireReactReconcilerConstants_production_min() {
  if (hasRequiredReactReconcilerConstants_production_min) return reactReconcilerConstants_production_min;
  hasRequiredReactReconcilerConstants_production_min = 1;
  reactReconcilerConstants_production_min.ConcurrentRoot = 1;
  reactReconcilerConstants_production_min.ContinuousEventPriority = 4;
  reactReconcilerConstants_production_min.DefaultEventPriority = 16;
  reactReconcilerConstants_production_min.DiscreteEventPriority = 1;
  reactReconcilerConstants_production_min.IdleEventPriority = 536870912;
  reactReconcilerConstants_production_min.LegacyRoot = 0;
  return reactReconcilerConstants_production_min;
}
var hasRequiredConstants;
function requireConstants() {
  if (hasRequiredConstants) return constants.exports;
  hasRequiredConstants = 1;
  {
    constants.exports = requireReactReconcilerConstants_production_min();
  }
  return constants.exports;
}
var constantsExports = requireConstants();
function createStore$3(createState) {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribeWithSelector = (listener, selector3 = getState, equalityFn = Object.is) => {
    console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
    let currentSlice = selector3(state);
    function listenerToAdd() {
      const nextSlice = selector3(state);
      if (!equalityFn(currentSlice, nextSlice)) {
        const previousSlice = currentSlice;
        listener(currentSlice = nextSlice, previousSlice);
      }
    }
    listeners.add(listenerToAdd);
    return () => listeners.delete(listenerToAdd);
  };
  const subscribe = (listener, selector3, equalityFn) => {
    if (selector3 || equalityFn) {
      return subscribeWithSelector(listener, selector3, equalityFn);
    }
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(setState, getState, api);
  return api;
}
const isSSR$1 = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
const useIsomorphicLayoutEffect$3 = isSSR$1 ? reactExports.useEffect : reactExports.useLayoutEffect;
function create$1(createState) {
  const api = typeof createState === "function" ? createStore$3(createState) : createState;
  const useStore2 = (selector3 = api.getState, equalityFn = Object.is) => {
    const [, forceUpdate] = reactExports.useReducer((c2) => c2 + 1, 0);
    const state = api.getState();
    const stateRef = reactExports.useRef(state);
    const selectorRef = reactExports.useRef(selector3);
    const equalityFnRef = reactExports.useRef(equalityFn);
    const erroredRef = reactExports.useRef(false);
    const currentSliceRef = reactExports.useRef();
    if (currentSliceRef.current === void 0) {
      currentSliceRef.current = selector3(state);
    }
    let newStateSlice;
    let hasNewStateSlice = false;
    if (stateRef.current !== state || selectorRef.current !== selector3 || equalityFnRef.current !== equalityFn || erroredRef.current) {
      newStateSlice = selector3(state);
      hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
    }
    useIsomorphicLayoutEffect$3(() => {
      if (hasNewStateSlice) {
        currentSliceRef.current = newStateSlice;
      }
      stateRef.current = state;
      selectorRef.current = selector3;
      equalityFnRef.current = equalityFn;
      erroredRef.current = false;
    });
    const stateBeforeSubscriptionRef = reactExports.useRef(state);
    useIsomorphicLayoutEffect$3(() => {
      const listener = () => {
        try {
          const nextState = api.getState();
          const nextStateSlice = selectorRef.current(nextState);
          if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
            stateRef.current = nextState;
            currentSliceRef.current = nextStateSlice;
            forceUpdate();
          }
        } catch (error2) {
          erroredRef.current = true;
          forceUpdate();
        }
      };
      const unsubscribe = api.subscribe(listener);
      if (api.getState() !== stateBeforeSubscriptionRef.current) {
        listener();
      }
      return unsubscribe;
    }, []);
    const sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
    reactExports.useDebugValue(sliceToReturn);
    return sliceToReturn;
  };
  Object.assign(useStore2, api);
  useStore2[Symbol.iterator] = function() {
    console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
    const items = [useStore2, api];
    return {
      next() {
        const done = items.length <= 0;
        return { value: items.shift(), done };
      }
    };
  };
  return useStore2;
}
const isPromise$1 = (promise) => typeof promise === "object" && typeof promise.then === "function";
const globalCache$1 = [];
function shallowEqualArrays$1(arrA, arrB, equal = (a5, b6) => a5 === b6) {
  if (arrA === arrB) return true;
  if (!arrA || !arrB) return false;
  const len = arrA.length;
  if (arrB.length !== len) return false;
  for (let i2 = 0; i2 < len; i2++) if (!equal(arrA[i2], arrB[i2])) return false;
  return true;
}
function query$1(fn, keys = null, preload3 = false, config3 = {}) {
  if (keys === null) keys = [fn];
  for (const entry2 of globalCache$1) {
    if (shallowEqualArrays$1(keys, entry2.keys, entry2.equal)) {
      if (preload3) return void 0;
      if (Object.prototype.hasOwnProperty.call(entry2, "error")) throw entry2.error;
      if (Object.prototype.hasOwnProperty.call(entry2, "response")) {
        if (config3.lifespan && config3.lifespan > 0) {
          if (entry2.timeout) clearTimeout(entry2.timeout);
          entry2.timeout = setTimeout(entry2.remove, config3.lifespan);
        }
        return entry2.response;
      }
      if (!preload3) throw entry2.promise;
    }
  }
  const entry = {
    keys,
    equal: config3.equal,
    remove: () => {
      const index = globalCache$1.indexOf(entry);
      if (index !== -1) globalCache$1.splice(index, 1);
    },
    promise: (
      // Execute the promise
      (isPromise$1(fn) ? fn : fn(...keys)).then((response) => {
        entry.response = response;
        if (config3.lifespan && config3.lifespan > 0) {
          entry.timeout = setTimeout(entry.remove, config3.lifespan);
        }
      }).catch((error2) => entry.error = error2)
    )
  };
  globalCache$1.push(entry);
  if (!preload3) throw entry.promise;
  return void 0;
}
const suspend$1 = (fn, keys, config3) => query$1(fn, keys, false, config3);
const preload = (fn, keys, config3) => void query$1(fn, keys, true, config3);
const clear = (keys) => {
  if (keys === void 0 || keys.length === 0) globalCache$1.splice(0, globalCache$1.length);
  else {
    const entry = globalCache$1.find((entry2) => shallowEqualArrays$1(keys, entry2.keys, entry2.equal));
    if (entry) entry.remove();
  }
};
var reactReconciler = { exports: {} };
var scheduler = { exports: {} };
var scheduler_production_min = {};
var hasRequiredScheduler_production_min;
function requireScheduler_production_min() {
  if (hasRequiredScheduler_production_min) return scheduler_production_min;
  hasRequiredScheduler_production_min = 1;
  (function(exports$1) {
    function f2(a5, b6) {
      var c2 = a5.length;
      a5.push(b6);
      a: for (; 0 < c2; ) {
        var d3 = c2 - 1 >>> 1, e2 = a5[d3];
        if (0 < g2(e2, b6)) a5[d3] = b6, a5[c2] = e2, c2 = d3;
        else break a;
      }
    }
    function h2(a5) {
      return 0 === a5.length ? null : a5[0];
    }
    function k2(a5) {
      if (0 === a5.length) return null;
      var b6 = a5[0], c2 = a5.pop();
      if (c2 !== b6) {
        a5[0] = c2;
        a: for (var d3 = 0, e2 = a5.length, w2 = e2 >>> 1; d3 < w2; ) {
          var m2 = 2 * (d3 + 1) - 1, C2 = a5[m2], n2 = m2 + 1, x3 = a5[n2];
          if (0 > g2(C2, c2)) n2 < e2 && 0 > g2(x3, C2) ? (a5[d3] = x3, a5[n2] = c2, d3 = n2) : (a5[d3] = C2, a5[m2] = c2, d3 = m2);
          else if (n2 < e2 && 0 > g2(x3, c2)) a5[d3] = x3, a5[n2] = c2, d3 = n2;
          else break a;
        }
      }
      return b6;
    }
    function g2(a5, b6) {
      var c2 = a5.sortIndex - b6.sortIndex;
      return 0 !== c2 ? c2 : a5.id - b6.id;
    }
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var l2 = performance;
      exports$1.unstable_now = function() {
        return l2.now();
      };
    } else {
      var p3 = Date, q2 = p3.now();
      exports$1.unstable_now = function() {
        return p3.now() - q2;
      };
    }
    var r3 = [], t2 = [], u2 = 1, v3 = null, y2 = 3, z2 = false, A2 = false, B2 = false, D2 = "function" === typeof setTimeout ? setTimeout : null, E2 = "function" === typeof clearTimeout ? clearTimeout : null, F2 = "undefined" !== typeof setImmediate ? setImmediate : null;
    "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function G2(a5) {
      for (var b6 = h2(t2); null !== b6; ) {
        if (null === b6.callback) k2(t2);
        else if (b6.startTime <= a5) k2(t2), b6.sortIndex = b6.expirationTime, f2(r3, b6);
        else break;
        b6 = h2(t2);
      }
    }
    function H3(a5) {
      B2 = false;
      G2(a5);
      if (!A2) if (null !== h2(r3)) A2 = true, I2(J2);
      else {
        var b6 = h2(t2);
        null !== b6 && K2(H3, b6.startTime - a5);
      }
    }
    function J2(a5, b6) {
      A2 = false;
      B2 && (B2 = false, E2(L2), L2 = -1);
      z2 = true;
      var c2 = y2;
      try {
        G2(b6);
        for (v3 = h2(r3); null !== v3 && (!(v3.expirationTime > b6) || a5 && !M2()); ) {
          var d3 = v3.callback;
          if ("function" === typeof d3) {
            v3.callback = null;
            y2 = v3.priorityLevel;
            var e2 = d3(v3.expirationTime <= b6);
            b6 = exports$1.unstable_now();
            "function" === typeof e2 ? v3.callback = e2 : v3 === h2(r3) && k2(r3);
            G2(b6);
          } else k2(r3);
          v3 = h2(r3);
        }
        if (null !== v3) var w2 = true;
        else {
          var m2 = h2(t2);
          null !== m2 && K2(H3, m2.startTime - b6);
          w2 = false;
        }
        return w2;
      } finally {
        v3 = null, y2 = c2, z2 = false;
      }
    }
    var N2 = false, O3 = null, L2 = -1, P3 = 5, Q2 = -1;
    function M2() {
      return exports$1.unstable_now() - Q2 < P3 ? false : true;
    }
    function R2() {
      if (null !== O3) {
        var a5 = exports$1.unstable_now();
        Q2 = a5;
        var b6 = true;
        try {
          b6 = O3(true, a5);
        } finally {
          b6 ? S2() : (N2 = false, O3 = null);
        }
      } else N2 = false;
    }
    var S2;
    if ("function" === typeof F2) S2 = function() {
      F2(R2);
    };
    else if ("undefined" !== typeof MessageChannel) {
      var T2 = new MessageChannel(), U2 = T2.port2;
      T2.port1.onmessage = R2;
      S2 = function() {
        U2.postMessage(null);
      };
    } else S2 = function() {
      D2(R2, 0);
    };
    function I2(a5) {
      O3 = a5;
      N2 || (N2 = true, S2());
    }
    function K2(a5, b6) {
      L2 = D2(function() {
        a5(exports$1.unstable_now());
      }, b6);
    }
    exports$1.unstable_IdlePriority = 5;
    exports$1.unstable_ImmediatePriority = 1;
    exports$1.unstable_LowPriority = 4;
    exports$1.unstable_NormalPriority = 3;
    exports$1.unstable_Profiling = null;
    exports$1.unstable_UserBlockingPriority = 2;
    exports$1.unstable_cancelCallback = function(a5) {
      a5.callback = null;
    };
    exports$1.unstable_continueExecution = function() {
      A2 || z2 || (A2 = true, I2(J2));
    };
    exports$1.unstable_forceFrameRate = function(a5) {
      0 > a5 || 125 < a5 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P3 = 0 < a5 ? Math.floor(1e3 / a5) : 5;
    };
    exports$1.unstable_getCurrentPriorityLevel = function() {
      return y2;
    };
    exports$1.unstable_getFirstCallbackNode = function() {
      return h2(r3);
    };
    exports$1.unstable_next = function(a5) {
      switch (y2) {
        case 1:
        case 2:
        case 3:
          var b6 = 3;
          break;
        default:
          b6 = y2;
      }
      var c2 = y2;
      y2 = b6;
      try {
        return a5();
      } finally {
        y2 = c2;
      }
    };
    exports$1.unstable_pauseExecution = function() {
    };
    exports$1.unstable_requestPaint = function() {
    };
    exports$1.unstable_runWithPriority = function(a5, b6) {
      switch (a5) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          a5 = 3;
      }
      var c2 = y2;
      y2 = a5;
      try {
        return b6();
      } finally {
        y2 = c2;
      }
    };
    exports$1.unstable_scheduleCallback = function(a5, b6, c2) {
      var d3 = exports$1.unstable_now();
      "object" === typeof c2 && null !== c2 ? (c2 = c2.delay, c2 = "number" === typeof c2 && 0 < c2 ? d3 + c2 : d3) : c2 = d3;
      switch (a5) {
        case 1:
          var e2 = -1;
          break;
        case 2:
          e2 = 250;
          break;
        case 5:
          e2 = 1073741823;
          break;
        case 4:
          e2 = 1e4;
          break;
        default:
          e2 = 5e3;
      }
      e2 = c2 + e2;
      a5 = { id: u2++, callback: b6, priorityLevel: a5, startTime: c2, expirationTime: e2, sortIndex: -1 };
      c2 > d3 ? (a5.sortIndex = c2, f2(t2, a5), null === h2(r3) && a5 === h2(t2) && (B2 ? (E2(L2), L2 = -1) : B2 = true, K2(H3, c2 - d3))) : (a5.sortIndex = e2, f2(r3, a5), A2 || z2 || (A2 = true, I2(J2)));
      return a5;
    };
    exports$1.unstable_shouldYield = M2;
    exports$1.unstable_wrapCallback = function(a5) {
      var b6 = y2;
      return function() {
        var c2 = y2;
        y2 = b6;
        try {
          return a5.apply(this, arguments);
        } finally {
          y2 = c2;
        }
      };
    };
  })(scheduler_production_min);
  return scheduler_production_min;
}
var hasRequiredScheduler;
function requireScheduler() {
  if (hasRequiredScheduler) return scheduler.exports;
  hasRequiredScheduler = 1;
  {
    scheduler.exports = requireScheduler_production_min();
  }
  return scheduler.exports;
}
var reactReconciler_production_min;
var hasRequiredReactReconciler_production_min;
function requireReactReconciler_production_min() {
  if (hasRequiredReactReconciler_production_min) return reactReconciler_production_min;
  hasRequiredReactReconciler_production_min = 1;
  reactReconciler_production_min = function $$$reconciler($$$hostConfig) {
    var exports$1 = {};
    var aa = requireReact(), ba = requireScheduler(), ca = Object.assign;
    function n2(a5) {
      for (var b6 = "https://reactjs.org/docs/error-decoder.html?invariant=" + a5, c2 = 1; c2 < arguments.length; c2++) b6 += "&args[]=" + encodeURIComponent(arguments[c2]);
      return "Minified React error #" + a5 + "; visit " + b6 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var ea = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, fa = /* @__PURE__ */ Symbol.for("react.element"), ha = /* @__PURE__ */ Symbol.for("react.portal"), ia = /* @__PURE__ */ Symbol.for("react.fragment"), ja = /* @__PURE__ */ Symbol.for("react.strict_mode"), ka = /* @__PURE__ */ Symbol.for("react.profiler"), la = /* @__PURE__ */ Symbol.for("react.provider"), ma = /* @__PURE__ */ Symbol.for("react.context"), na = /* @__PURE__ */ Symbol.for("react.forward_ref"), oa = /* @__PURE__ */ Symbol.for("react.suspense"), pa = /* @__PURE__ */ Symbol.for("react.suspense_list"), qa = /* @__PURE__ */ Symbol.for("react.memo"), ra = /* @__PURE__ */ Symbol.for("react.lazy");
    var sa = /* @__PURE__ */ Symbol.for("react.offscreen");
    var ta = Symbol.iterator;
    function ua(a5) {
      if (null === a5 || "object" !== typeof a5) return null;
      a5 = ta && a5[ta] || a5["@@iterator"];
      return "function" === typeof a5 ? a5 : null;
    }
    function va(a5) {
      if (null == a5) return null;
      if ("function" === typeof a5) return a5.displayName || a5.name || null;
      if ("string" === typeof a5) return a5;
      switch (a5) {
        case ia:
          return "Fragment";
        case ha:
          return "Portal";
        case ka:
          return "Profiler";
        case ja:
          return "StrictMode";
        case oa:
          return "Suspense";
        case pa:
          return "SuspenseList";
      }
      if ("object" === typeof a5) switch (a5.$$typeof) {
        case ma:
          return (a5.displayName || "Context") + ".Consumer";
        case la:
          return (a5._context.displayName || "Context") + ".Provider";
        case na:
          var b6 = a5.render;
          a5 = a5.displayName;
          a5 || (a5 = b6.displayName || b6.name || "", a5 = "" !== a5 ? "ForwardRef(" + a5 + ")" : "ForwardRef");
          return a5;
        case qa:
          return b6 = a5.displayName || null, null !== b6 ? b6 : va(a5.type) || "Memo";
        case ra:
          b6 = a5._payload;
          a5 = a5._init;
          try {
            return va(a5(b6));
          } catch (c2) {
          }
      }
      return null;
    }
    function xa(a5) {
      var b6 = a5.type;
      switch (a5.tag) {
        case 24:
          return "Cache";
        case 9:
          return (b6.displayName || "Context") + ".Consumer";
        case 10:
          return (b6._context.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return a5 = b6.render, a5 = a5.displayName || a5.name || "", b6.displayName || ("" !== a5 ? "ForwardRef(" + a5 + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 5:
          return b6;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return va(b6);
        case 8:
          return b6 === ja ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
          if ("function" === typeof b6) return b6.displayName || b6.name || null;
          if ("string" === typeof b6) return b6;
      }
      return null;
    }
    function ya(a5) {
      var b6 = a5, c2 = a5;
      if (a5.alternate) for (; b6.return; ) b6 = b6.return;
      else {
        a5 = b6;
        do
          b6 = a5, 0 !== (b6.flags & 4098) && (c2 = b6.return), a5 = b6.return;
        while (a5);
      }
      return 3 === b6.tag ? c2 : null;
    }
    function za(a5) {
      if (ya(a5) !== a5) throw Error(n2(188));
    }
    function Aa(a5) {
      var b6 = a5.alternate;
      if (!b6) {
        b6 = ya(a5);
        if (null === b6) throw Error(n2(188));
        return b6 !== a5 ? null : a5;
      }
      for (var c2 = a5, d3 = b6; ; ) {
        var e2 = c2.return;
        if (null === e2) break;
        var f2 = e2.alternate;
        if (null === f2) {
          d3 = e2.return;
          if (null !== d3) {
            c2 = d3;
            continue;
          }
          break;
        }
        if (e2.child === f2.child) {
          for (f2 = e2.child; f2; ) {
            if (f2 === c2) return za(e2), a5;
            if (f2 === d3) return za(e2), b6;
            f2 = f2.sibling;
          }
          throw Error(n2(188));
        }
        if (c2.return !== d3.return) c2 = e2, d3 = f2;
        else {
          for (var g2 = false, h2 = e2.child; h2; ) {
            if (h2 === c2) {
              g2 = true;
              c2 = e2;
              d3 = f2;
              break;
            }
            if (h2 === d3) {
              g2 = true;
              d3 = e2;
              c2 = f2;
              break;
            }
            h2 = h2.sibling;
          }
          if (!g2) {
            for (h2 = f2.child; h2; ) {
              if (h2 === c2) {
                g2 = true;
                c2 = f2;
                d3 = e2;
                break;
              }
              if (h2 === d3) {
                g2 = true;
                d3 = f2;
                c2 = e2;
                break;
              }
              h2 = h2.sibling;
            }
            if (!g2) throw Error(n2(189));
          }
        }
        if (c2.alternate !== d3) throw Error(n2(190));
      }
      if (3 !== c2.tag) throw Error(n2(188));
      return c2.stateNode.current === c2 ? a5 : b6;
    }
    function Ba(a5) {
      a5 = Aa(a5);
      return null !== a5 ? Ca(a5) : null;
    }
    function Ca(a5) {
      if (5 === a5.tag || 6 === a5.tag) return a5;
      for (a5 = a5.child; null !== a5; ) {
        var b6 = Ca(a5);
        if (null !== b6) return b6;
        a5 = a5.sibling;
      }
      return null;
    }
    function Da(a5) {
      if (5 === a5.tag || 6 === a5.tag) return a5;
      for (a5 = a5.child; null !== a5; ) {
        if (4 !== a5.tag) {
          var b6 = Da(a5);
          if (null !== b6) return b6;
        }
        a5 = a5.sibling;
      }
      return null;
    }
    var Ea = Array.isArray, Fa = $$$hostConfig.getPublicInstance, Ga = $$$hostConfig.getRootHostContext, Ha = $$$hostConfig.getChildHostContext, Ia = $$$hostConfig.prepareForCommit, Ja = $$$hostConfig.resetAfterCommit, Ka = $$$hostConfig.createInstance, La = $$$hostConfig.appendInitialChild, Ma = $$$hostConfig.finalizeInitialChildren, Na = $$$hostConfig.prepareUpdate, Oa = $$$hostConfig.shouldSetTextContent, Pa = $$$hostConfig.createTextInstance, Qa = $$$hostConfig.scheduleTimeout, Ra = $$$hostConfig.cancelTimeout, Sa = $$$hostConfig.noTimeout, Ta = $$$hostConfig.isPrimaryRenderer, Ua = $$$hostConfig.supportsMutation, Va = $$$hostConfig.supportsPersistence, p3 = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab = $$$hostConfig.scheduleMicrotask, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Db = $$$hostConfig.cloneHiddenInstance, Eb = $$$hostConfig.cloneHiddenTextInstance, Fb = $$$hostConfig.canHydrateInstance, Gb = $$$hostConfig.canHydrateTextInstance, Hb = $$$hostConfig.canHydrateSuspenseInstance, Ib = $$$hostConfig.isSuspenseInstancePending, Jb = $$$hostConfig.isSuspenseInstanceFallback, Kb = $$$hostConfig.registerSuspenseInstanceRetry, Lb = $$$hostConfig.getNextHydratableSibling, Mb = $$$hostConfig.getFirstHydratableChild, Nb = $$$hostConfig.getFirstHydratableChildWithinContainer, Ob = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Pb = $$$hostConfig.hydrateInstance, Qb = $$$hostConfig.hydrateTextInstance, Rb = $$$hostConfig.hydrateSuspenseInstance, Sb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Tb = $$$hostConfig.commitHydratedContainer, Ub = $$$hostConfig.commitHydratedSuspenseInstance, Vb = $$$hostConfig.clearSuspenseBoundary, Wb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Xb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, Yb = $$$hostConfig.didNotMatchHydratedContainerTextInstance, Zb = $$$hostConfig.didNotMatchHydratedTextInstance, $b;
    function ac(a5) {
      if (void 0 === $b) try {
        throw Error();
      } catch (c2) {
        var b6 = c2.stack.trim().match(/\n( *(at )?)/);
        $b = b6 && b6[1] || "";
      }
      return "\n" + $b + a5;
    }
    var bc = false;
    function cc(a5, b6) {
      if (!a5 || bc) return "";
      bc = true;
      var c2 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        if (b6) if (b6 = function() {
          throw Error();
        }, Object.defineProperty(b6.prototype, "props", { set: function() {
          throw Error();
        } }), "object" === typeof Reflect && Reflect.construct) {
          try {
            Reflect.construct(b6, []);
          } catch (l2) {
            var d3 = l2;
          }
          Reflect.construct(a5, [], b6);
        } else {
          try {
            b6.call();
          } catch (l2) {
            d3 = l2;
          }
          a5.call(b6.prototype);
        }
        else {
          try {
            throw Error();
          } catch (l2) {
            d3 = l2;
          }
          a5();
        }
      } catch (l2) {
        if (l2 && d3 && "string" === typeof l2.stack) {
          for (var e2 = l2.stack.split("\n"), f2 = d3.stack.split("\n"), g2 = e2.length - 1, h2 = f2.length - 1; 1 <= g2 && 0 <= h2 && e2[g2] !== f2[h2]; ) h2--;
          for (; 1 <= g2 && 0 <= h2; g2--, h2--) if (e2[g2] !== f2[h2]) {
            if (1 !== g2 || 1 !== h2) {
              do
                if (g2--, h2--, 0 > h2 || e2[g2] !== f2[h2]) {
                  var k2 = "\n" + e2[g2].replace(" at new ", " at ");
                  a5.displayName && k2.includes("<anonymous>") && (k2 = k2.replace("<anonymous>", a5.displayName));
                  return k2;
                }
              while (1 <= g2 && 0 <= h2);
            }
            break;
          }
        }
      } finally {
        bc = false, Error.prepareStackTrace = c2;
      }
      return (a5 = a5 ? a5.displayName || a5.name : "") ? ac(a5) : "";
    }
    var dc = Object.prototype.hasOwnProperty, ec = [], fc = -1;
    function gc(a5) {
      return { current: a5 };
    }
    function x3(a5) {
      0 > fc || (a5.current = ec[fc], ec[fc] = null, fc--);
    }
    function y2(a5, b6) {
      fc++;
      ec[fc] = a5.current;
      a5.current = b6;
    }
    var hc = {}, A2 = gc(hc), B2 = gc(false), ic = hc;
    function jc(a5, b6) {
      var c2 = a5.type.contextTypes;
      if (!c2) return hc;
      var d3 = a5.stateNode;
      if (d3 && d3.__reactInternalMemoizedUnmaskedChildContext === b6) return d3.__reactInternalMemoizedMaskedChildContext;
      var e2 = {}, f2;
      for (f2 in c2) e2[f2] = b6[f2];
      d3 && (a5 = a5.stateNode, a5.__reactInternalMemoizedUnmaskedChildContext = b6, a5.__reactInternalMemoizedMaskedChildContext = e2);
      return e2;
    }
    function C2(a5) {
      a5 = a5.childContextTypes;
      return null !== a5 && void 0 !== a5;
    }
    function kc() {
      x3(B2);
      x3(A2);
    }
    function lc(a5, b6, c2) {
      if (A2.current !== hc) throw Error(n2(168));
      y2(A2, b6);
      y2(B2, c2);
    }
    function mc(a5, b6, c2) {
      var d3 = a5.stateNode;
      b6 = b6.childContextTypes;
      if ("function" !== typeof d3.getChildContext) return c2;
      d3 = d3.getChildContext();
      for (var e2 in d3) if (!(e2 in b6)) throw Error(n2(108, xa(a5) || "Unknown", e2));
      return ca({}, c2, d3);
    }
    function nc(a5) {
      a5 = (a5 = a5.stateNode) && a5.__reactInternalMemoizedMergedChildContext || hc;
      ic = A2.current;
      y2(A2, a5);
      y2(B2, B2.current);
      return true;
    }
    function oc(a5, b6, c2) {
      var d3 = a5.stateNode;
      if (!d3) throw Error(n2(169));
      c2 ? (a5 = mc(a5, b6, ic), d3.__reactInternalMemoizedMergedChildContext = a5, x3(B2), x3(A2), y2(A2, a5)) : x3(B2);
      y2(B2, c2);
    }
    var qc = Math.clz32 ? Math.clz32 : pc, rc = Math.log, sc = Math.LN2;
    function pc(a5) {
      a5 >>>= 0;
      return 0 === a5 ? 32 : 31 - (rc(a5) / sc | 0) | 0;
    }
    var tc = 64, uc = 4194304;
    function vc(a5) {
      switch (a5 & -a5) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return a5 & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return a5 & 130023424;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 1073741824;
        default:
          return a5;
      }
    }
    function wc(a5, b6) {
      var c2 = a5.pendingLanes;
      if (0 === c2) return 0;
      var d3 = 0, e2 = a5.suspendedLanes, f2 = a5.pingedLanes, g2 = c2 & 268435455;
      if (0 !== g2) {
        var h2 = g2 & ~e2;
        0 !== h2 ? d3 = vc(h2) : (f2 &= g2, 0 !== f2 && (d3 = vc(f2)));
      } else g2 = c2 & ~e2, 0 !== g2 ? d3 = vc(g2) : 0 !== f2 && (d3 = vc(f2));
      if (0 === d3) return 0;
      if (0 !== b6 && b6 !== d3 && 0 === (b6 & e2) && (e2 = d3 & -d3, f2 = b6 & -b6, e2 >= f2 || 16 === e2 && 0 !== (f2 & 4194240))) return b6;
      0 !== (d3 & 4) && (d3 |= c2 & 16);
      b6 = a5.entangledLanes;
      if (0 !== b6) for (a5 = a5.entanglements, b6 &= d3; 0 < b6; ) c2 = 31 - qc(b6), e2 = 1 << c2, d3 |= a5[c2], b6 &= ~e2;
      return d3;
    }
    function xc(a5, b6) {
      switch (a5) {
        case 1:
        case 2:
        case 4:
          return b6 + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return b6 + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return -1;
      }
    }
    function yc(a5, b6) {
      for (var c2 = a5.suspendedLanes, d3 = a5.pingedLanes, e2 = a5.expirationTimes, f2 = a5.pendingLanes; 0 < f2; ) {
        var g2 = 31 - qc(f2), h2 = 1 << g2, k2 = e2[g2];
        if (-1 === k2) {
          if (0 === (h2 & c2) || 0 !== (h2 & d3)) e2[g2] = xc(h2, b6);
        } else k2 <= b6 && (a5.expiredLanes |= h2);
        f2 &= ~h2;
      }
    }
    function zc(a5) {
      a5 = a5.pendingLanes & -1073741825;
      return 0 !== a5 ? a5 : a5 & 1073741824 ? 1073741824 : 0;
    }
    function Ac(a5) {
      for (var b6 = [], c2 = 0; 31 > c2; c2++) b6.push(a5);
      return b6;
    }
    function Bc(a5, b6, c2) {
      a5.pendingLanes |= b6;
      536870912 !== b6 && (a5.suspendedLanes = 0, a5.pingedLanes = 0);
      a5 = a5.eventTimes;
      b6 = 31 - qc(b6);
      a5[b6] = c2;
    }
    function Cc(a5, b6) {
      var c2 = a5.pendingLanes & ~b6;
      a5.pendingLanes = b6;
      a5.suspendedLanes = 0;
      a5.pingedLanes = 0;
      a5.expiredLanes &= b6;
      a5.mutableReadLanes &= b6;
      a5.entangledLanes &= b6;
      b6 = a5.entanglements;
      var d3 = a5.eventTimes;
      for (a5 = a5.expirationTimes; 0 < c2; ) {
        var e2 = 31 - qc(c2), f2 = 1 << e2;
        b6[e2] = 0;
        d3[e2] = -1;
        a5[e2] = -1;
        c2 &= ~f2;
      }
    }
    function Dc(a5, b6) {
      var c2 = a5.entangledLanes |= b6;
      for (a5 = a5.entanglements; c2; ) {
        var d3 = 31 - qc(c2), e2 = 1 << d3;
        e2 & b6 | a5[d3] & b6 && (a5[d3] |= b6);
        c2 &= ~e2;
      }
    }
    var D2 = 0;
    function Ec(a5) {
      a5 &= -a5;
      return 1 < a5 ? 4 < a5 ? 0 !== (a5 & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Fc = ba.unstable_scheduleCallback, Gc = ba.unstable_cancelCallback, Hc = ba.unstable_shouldYield, Ic = ba.unstable_requestPaint, E2 = ba.unstable_now, Jc = ba.unstable_ImmediatePriority, Kc = ba.unstable_UserBlockingPriority, Lc = ba.unstable_NormalPriority, Mc = ba.unstable_IdlePriority, Nc = null, Oc = null;
    function Pc(a5) {
      if (Oc && "function" === typeof Oc.onCommitFiberRoot) try {
        Oc.onCommitFiberRoot(Nc, a5, void 0, 128 === (a5.current.flags & 128));
      } catch (b6) {
      }
    }
    function Qc(a5, b6) {
      return a5 === b6 && (0 !== a5 || 1 / a5 === 1 / b6) || a5 !== a5 && b6 !== b6;
    }
    var Rc = "function" === typeof Object.is ? Object.is : Qc, Sc = null, Tc = false, Uc = false;
    function Vc(a5) {
      null === Sc ? Sc = [a5] : Sc.push(a5);
    }
    function Wc(a5) {
      Tc = true;
      Vc(a5);
    }
    function Xc() {
      if (!Uc && null !== Sc) {
        Uc = true;
        var a5 = 0, b6 = D2;
        try {
          var c2 = Sc;
          for (D2 = 1; a5 < c2.length; a5++) {
            var d3 = c2[a5];
            do
              d3 = d3(true);
            while (null !== d3);
          }
          Sc = null;
          Tc = false;
        } catch (e2) {
          throw null !== Sc && (Sc = Sc.slice(a5 + 1)), Fc(Jc, Xc), e2;
        } finally {
          D2 = b6, Uc = false;
        }
      }
      return null;
    }
    var Yc = ea.ReactCurrentBatchConfig;
    function Zc(a5, b6) {
      if (Rc(a5, b6)) return true;
      if ("object" !== typeof a5 || null === a5 || "object" !== typeof b6 || null === b6) return false;
      var c2 = Object.keys(a5), d3 = Object.keys(b6);
      if (c2.length !== d3.length) return false;
      for (d3 = 0; d3 < c2.length; d3++) {
        var e2 = c2[d3];
        if (!dc.call(b6, e2) || !Rc(a5[e2], b6[e2])) return false;
      }
      return true;
    }
    function $c(a5) {
      switch (a5.tag) {
        case 5:
          return ac(a5.type);
        case 16:
          return ac("Lazy");
        case 13:
          return ac("Suspense");
        case 19:
          return ac("SuspenseList");
        case 0:
        case 2:
        case 15:
          return a5 = cc(a5.type, false), a5;
        case 11:
          return a5 = cc(a5.type.render, false), a5;
        case 1:
          return a5 = cc(a5.type, true), a5;
        default:
          return "";
      }
    }
    function ad(a5, b6) {
      if (a5 && a5.defaultProps) {
        b6 = ca({}, b6);
        a5 = a5.defaultProps;
        for (var c2 in a5) void 0 === b6[c2] && (b6[c2] = a5[c2]);
        return b6;
      }
      return b6;
    }
    var bd = gc(null), cd = null, dd = null, ed = null;
    function fd2() {
      ed = dd = cd = null;
    }
    function gd(a5, b6, c2) {
      Ta ? (y2(bd, b6._currentValue), b6._currentValue = c2) : (y2(bd, b6._currentValue2), b6._currentValue2 = c2);
    }
    function hd(a5) {
      var b6 = bd.current;
      x3(bd);
      Ta ? a5._currentValue = b6 : a5._currentValue2 = b6;
    }
    function id(a5, b6, c2) {
      for (; null !== a5; ) {
        var d3 = a5.alternate;
        (a5.childLanes & b6) !== b6 ? (a5.childLanes |= b6, null !== d3 && (d3.childLanes |= b6)) : null !== d3 && (d3.childLanes & b6) !== b6 && (d3.childLanes |= b6);
        if (a5 === c2) break;
        a5 = a5.return;
      }
    }
    function jd(a5, b6) {
      cd = a5;
      ed = dd = null;
      a5 = a5.dependencies;
      null !== a5 && null !== a5.firstContext && (0 !== (a5.lanes & b6) && (kd = true), a5.firstContext = null);
    }
    function ld(a5) {
      var b6 = Ta ? a5._currentValue : a5._currentValue2;
      if (ed !== a5) if (a5 = { context: a5, memoizedValue: b6, next: null }, null === dd) {
        if (null === cd) throw Error(n2(308));
        dd = a5;
        cd.dependencies = { lanes: 0, firstContext: a5 };
      } else dd = dd.next = a5;
      return b6;
    }
    var md = null, nd = false;
    function od(a5) {
      a5.updateQueue = { baseState: a5.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
    }
    function pd(a5, b6) {
      a5 = a5.updateQueue;
      b6.updateQueue === a5 && (b6.updateQueue = { baseState: a5.baseState, firstBaseUpdate: a5.firstBaseUpdate, lastBaseUpdate: a5.lastBaseUpdate, shared: a5.shared, effects: a5.effects });
    }
    function qd(a5, b6) {
      return { eventTime: a5, lane: b6, tag: 0, payload: null, callback: null, next: null };
    }
    function rd(a5, b6) {
      var c2 = a5.updateQueue;
      null !== c2 && (c2 = c2.shared, null !== F2 && 0 !== (a5.mode & 1) && 0 === (G2 & 2) ? (a5 = c2.interleaved, null === a5 ? (b6.next = b6, null === md ? md = [c2] : md.push(c2)) : (b6.next = a5.next, a5.next = b6), c2.interleaved = b6) : (a5 = c2.pending, null === a5 ? b6.next = b6 : (b6.next = a5.next, a5.next = b6), c2.pending = b6));
    }
    function sd(a5, b6, c2) {
      b6 = b6.updateQueue;
      if (null !== b6 && (b6 = b6.shared, 0 !== (c2 & 4194240))) {
        var d3 = b6.lanes;
        d3 &= a5.pendingLanes;
        c2 |= d3;
        b6.lanes = c2;
        Dc(a5, c2);
      }
    }
    function td2(a5, b6) {
      var c2 = a5.updateQueue, d3 = a5.alternate;
      if (null !== d3 && (d3 = d3.updateQueue, c2 === d3)) {
        var e2 = null, f2 = null;
        c2 = c2.firstBaseUpdate;
        if (null !== c2) {
          do {
            var g2 = { eventTime: c2.eventTime, lane: c2.lane, tag: c2.tag, payload: c2.payload, callback: c2.callback, next: null };
            null === f2 ? e2 = f2 = g2 : f2 = f2.next = g2;
            c2 = c2.next;
          } while (null !== c2);
          null === f2 ? e2 = f2 = b6 : f2 = f2.next = b6;
        } else e2 = f2 = b6;
        c2 = { baseState: d3.baseState, firstBaseUpdate: e2, lastBaseUpdate: f2, shared: d3.shared, effects: d3.effects };
        a5.updateQueue = c2;
        return;
      }
      a5 = c2.lastBaseUpdate;
      null === a5 ? c2.firstBaseUpdate = b6 : a5.next = b6;
      c2.lastBaseUpdate = b6;
    }
    function ud(a5, b6, c2, d3) {
      var e2 = a5.updateQueue;
      nd = false;
      var f2 = e2.firstBaseUpdate, g2 = e2.lastBaseUpdate, h2 = e2.shared.pending;
      if (null !== h2) {
        e2.shared.pending = null;
        var k2 = h2, l2 = k2.next;
        k2.next = null;
        null === g2 ? f2 = l2 : g2.next = l2;
        g2 = k2;
        var m2 = a5.alternate;
        null !== m2 && (m2 = m2.updateQueue, h2 = m2.lastBaseUpdate, h2 !== g2 && (null === h2 ? m2.firstBaseUpdate = l2 : h2.next = l2, m2.lastBaseUpdate = k2));
      }
      if (null !== f2) {
        var v3 = e2.baseState;
        g2 = 0;
        m2 = l2 = k2 = null;
        h2 = f2;
        do {
          var r3 = h2.lane, z2 = h2.eventTime;
          if ((d3 & r3) === r3) {
            null !== m2 && (m2 = m2.next = {
              eventTime: z2,
              lane: 0,
              tag: h2.tag,
              payload: h2.payload,
              callback: h2.callback,
              next: null
            });
            a: {
              var q2 = a5, N2 = h2;
              r3 = b6;
              z2 = c2;
              switch (N2.tag) {
                case 1:
                  q2 = N2.payload;
                  if ("function" === typeof q2) {
                    v3 = q2.call(z2, v3, r3);
                    break a;
                  }
                  v3 = q2;
                  break a;
                case 3:
                  q2.flags = q2.flags & -65537 | 128;
                case 0:
                  q2 = N2.payload;
                  r3 = "function" === typeof q2 ? q2.call(z2, v3, r3) : q2;
                  if (null === r3 || void 0 === r3) break a;
                  v3 = ca({}, v3, r3);
                  break a;
                case 2:
                  nd = true;
              }
            }
            null !== h2.callback && 0 !== h2.lane && (a5.flags |= 64, r3 = e2.effects, null === r3 ? e2.effects = [h2] : r3.push(h2));
          } else z2 = { eventTime: z2, lane: r3, tag: h2.tag, payload: h2.payload, callback: h2.callback, next: null }, null === m2 ? (l2 = m2 = z2, k2 = v3) : m2 = m2.next = z2, g2 |= r3;
          h2 = h2.next;
          if (null === h2) if (h2 = e2.shared.pending, null === h2) break;
          else r3 = h2, h2 = r3.next, r3.next = null, e2.lastBaseUpdate = r3, e2.shared.pending = null;
        } while (1);
        null === m2 && (k2 = v3);
        e2.baseState = k2;
        e2.firstBaseUpdate = l2;
        e2.lastBaseUpdate = m2;
        b6 = e2.shared.interleaved;
        if (null !== b6) {
          e2 = b6;
          do
            g2 |= e2.lane, e2 = e2.next;
          while (e2 !== b6);
        } else null === f2 && (e2.shared.lanes = 0);
        vd |= g2;
        a5.lanes = g2;
        a5.memoizedState = v3;
      }
    }
    function wd(a5, b6, c2) {
      a5 = b6.effects;
      b6.effects = null;
      if (null !== a5) for (b6 = 0; b6 < a5.length; b6++) {
        var d3 = a5[b6], e2 = d3.callback;
        if (null !== e2) {
          d3.callback = null;
          d3 = c2;
          if ("function" !== typeof e2) throw Error(n2(191, e2));
          e2.call(d3);
        }
      }
    }
    var xd = new aa.Component().refs;
    function yd(a5, b6, c2, d3) {
      b6 = a5.memoizedState;
      c2 = c2(d3, b6);
      c2 = null === c2 || void 0 === c2 ? b6 : ca({}, b6, c2);
      a5.memoizedState = c2;
      0 === a5.lanes && (a5.updateQueue.baseState = c2);
    }
    var Bd = { isMounted: function(a5) {
      return (a5 = a5._reactInternals) ? ya(a5) === a5 : false;
    }, enqueueSetState: function(a5, b6, c2) {
      a5 = a5._reactInternals;
      var d3 = H3(), e2 = zd(a5), f2 = qd(d3, e2);
      f2.payload = b6;
      void 0 !== c2 && null !== c2 && (f2.callback = c2);
      rd(a5, f2);
      b6 = Ad(a5, e2, d3);
      null !== b6 && sd(b6, a5, e2);
    }, enqueueReplaceState: function(a5, b6, c2) {
      a5 = a5._reactInternals;
      var d3 = H3(), e2 = zd(a5), f2 = qd(d3, e2);
      f2.tag = 1;
      f2.payload = b6;
      void 0 !== c2 && null !== c2 && (f2.callback = c2);
      rd(a5, f2);
      b6 = Ad(a5, e2, d3);
      null !== b6 && sd(b6, a5, e2);
    }, enqueueForceUpdate: function(a5, b6) {
      a5 = a5._reactInternals;
      var c2 = H3(), d3 = zd(a5), e2 = qd(
        c2,
        d3
      );
      e2.tag = 2;
      void 0 !== b6 && null !== b6 && (e2.callback = b6);
      rd(a5, e2);
      b6 = Ad(a5, d3, c2);
      null !== b6 && sd(b6, a5, d3);
    } };
    function Cd(a5, b6, c2, d3, e2, f2, g2) {
      a5 = a5.stateNode;
      return "function" === typeof a5.shouldComponentUpdate ? a5.shouldComponentUpdate(d3, f2, g2) : b6.prototype && b6.prototype.isPureReactComponent ? !Zc(c2, d3) || !Zc(e2, f2) : true;
    }
    function Dd(a5, b6, c2) {
      var d3 = false, e2 = hc;
      var f2 = b6.contextType;
      "object" === typeof f2 && null !== f2 ? f2 = ld(f2) : (e2 = C2(b6) ? ic : A2.current, d3 = b6.contextTypes, f2 = (d3 = null !== d3 && void 0 !== d3) ? jc(a5, e2) : hc);
      b6 = new b6(c2, f2);
      a5.memoizedState = null !== b6.state && void 0 !== b6.state ? b6.state : null;
      b6.updater = Bd;
      a5.stateNode = b6;
      b6._reactInternals = a5;
      d3 && (a5 = a5.stateNode, a5.__reactInternalMemoizedUnmaskedChildContext = e2, a5.__reactInternalMemoizedMaskedChildContext = f2);
      return b6;
    }
    function Ed(a5, b6, c2, d3) {
      a5 = b6.state;
      "function" === typeof b6.componentWillReceiveProps && b6.componentWillReceiveProps(c2, d3);
      "function" === typeof b6.UNSAFE_componentWillReceiveProps && b6.UNSAFE_componentWillReceiveProps(c2, d3);
      b6.state !== a5 && Bd.enqueueReplaceState(b6, b6.state, null);
    }
    function Fd(a5, b6, c2, d3) {
      var e2 = a5.stateNode;
      e2.props = c2;
      e2.state = a5.memoizedState;
      e2.refs = xd;
      od(a5);
      var f2 = b6.contextType;
      "object" === typeof f2 && null !== f2 ? e2.context = ld(f2) : (f2 = C2(b6) ? ic : A2.current, e2.context = jc(a5, f2));
      e2.state = a5.memoizedState;
      f2 = b6.getDerivedStateFromProps;
      "function" === typeof f2 && (yd(a5, b6, f2, c2), e2.state = a5.memoizedState);
      "function" === typeof b6.getDerivedStateFromProps || "function" === typeof e2.getSnapshotBeforeUpdate || "function" !== typeof e2.UNSAFE_componentWillMount && "function" !== typeof e2.componentWillMount || (b6 = e2.state, "function" === typeof e2.componentWillMount && e2.componentWillMount(), "function" === typeof e2.UNSAFE_componentWillMount && e2.UNSAFE_componentWillMount(), b6 !== e2.state && Bd.enqueueReplaceState(e2, e2.state, null), ud(a5, c2, e2, d3), e2.state = a5.memoizedState);
      "function" === typeof e2.componentDidMount && (a5.flags |= 4194308);
    }
    var Gd = [], Hd = 0, Id = null, Jd = 0, Kd = [], Ld = 0, Md = null, Nd = 1, Od = "";
    function Pd(a5, b6) {
      Gd[Hd++] = Jd;
      Gd[Hd++] = Id;
      Id = a5;
      Jd = b6;
    }
    function Qd(a5, b6, c2) {
      Kd[Ld++] = Nd;
      Kd[Ld++] = Od;
      Kd[Ld++] = Md;
      Md = a5;
      var d3 = Nd;
      a5 = Od;
      var e2 = 32 - qc(d3) - 1;
      d3 &= ~(1 << e2);
      c2 += 1;
      var f2 = 32 - qc(b6) + e2;
      if (30 < f2) {
        var g2 = e2 - e2 % 5;
        f2 = (d3 & (1 << g2) - 1).toString(32);
        d3 >>= g2;
        e2 -= g2;
        Nd = 1 << 32 - qc(b6) + e2 | c2 << e2 | d3;
        Od = f2 + a5;
      } else Nd = 1 << f2 | c2 << e2 | d3, Od = a5;
    }
    function Rd(a5) {
      null !== a5.return && (Pd(a5, 1), Qd(a5, 1, 0));
    }
    function Sd(a5) {
      for (; a5 === Id; ) Id = Gd[--Hd], Gd[Hd] = null, Jd = Gd[--Hd], Gd[Hd] = null;
      for (; a5 === Md; ) Md = Kd[--Ld], Kd[Ld] = null, Od = Kd[--Ld], Kd[Ld] = null, Nd = Kd[--Ld], Kd[Ld] = null;
    }
    var Td = null, Ud = null, I2 = false, Vd = false, Wd = null;
    function Xd(a5, b6) {
      var c2 = Yd(5, null, null, 0);
      c2.elementType = "DELETED";
      c2.stateNode = b6;
      c2.return = a5;
      b6 = a5.deletions;
      null === b6 ? (a5.deletions = [c2], a5.flags |= 16) : b6.push(c2);
    }
    function Zd(a5, b6) {
      switch (a5.tag) {
        case 5:
          return b6 = Fb(b6, a5.type, a5.pendingProps), null !== b6 ? (a5.stateNode = b6, Td = a5, Ud = Mb(b6), true) : false;
        case 6:
          return b6 = Gb(b6, a5.pendingProps), null !== b6 ? (a5.stateNode = b6, Td = a5, Ud = null, true) : false;
        case 13:
          b6 = Hb(b6);
          if (null !== b6) {
            var c2 = null !== Md ? { id: Nd, overflow: Od } : null;
            a5.memoizedState = { dehydrated: b6, treeContext: c2, retryLane: 1073741824 };
            c2 = Yd(18, null, null, 0);
            c2.stateNode = b6;
            c2.return = a5;
            a5.child = c2;
            Td = a5;
            Ud = null;
            return true;
          }
          return false;
        default:
          return false;
      }
    }
    function $d(a5) {
      return 0 !== (a5.mode & 1) && 0 === (a5.flags & 128);
    }
    function ae(a5) {
      if (I2) {
        var b6 = Ud;
        if (b6) {
          var c2 = b6;
          if (!Zd(a5, b6)) {
            if ($d(a5)) throw Error(n2(418));
            b6 = Lb(c2);
            var d3 = Td;
            b6 && Zd(a5, b6) ? Xd(d3, c2) : (a5.flags = a5.flags & -4097 | 2, I2 = false, Td = a5);
          }
        } else {
          if ($d(a5)) throw Error(n2(418));
          a5.flags = a5.flags & -4097 | 2;
          I2 = false;
          Td = a5;
        }
      }
    }
    function be(a5) {
      for (a5 = a5.return; null !== a5 && 5 !== a5.tag && 3 !== a5.tag && 13 !== a5.tag; ) a5 = a5.return;
      Td = a5;
    }
    function ce(a5) {
      if (!p3 || a5 !== Td) return false;
      if (!I2) return be(a5), I2 = true, false;
      if (3 !== a5.tag && (5 !== a5.tag || Xb(a5.type) && !Oa(a5.type, a5.memoizedProps))) {
        var b6 = Ud;
        if (b6) {
          if ($d(a5)) {
            for (a5 = Ud; a5; ) a5 = Lb(a5);
            throw Error(n2(418));
          }
          for (; b6; ) Xd(a5, b6), b6 = Lb(b6);
        }
      }
      be(a5);
      if (13 === a5.tag) {
        if (!p3) throw Error(n2(316));
        a5 = a5.memoizedState;
        a5 = null !== a5 ? a5.dehydrated : null;
        if (!a5) throw Error(n2(317));
        Ud = Sb(a5);
      } else Ud = Td ? Lb(a5.stateNode) : null;
      return true;
    }
    function de() {
      p3 && (Ud = Td = null, Vd = I2 = false);
    }
    function ee(a5) {
      null === Wd ? Wd = [a5] : Wd.push(a5);
    }
    function fe(a5, b6, c2) {
      a5 = c2.ref;
      if (null !== a5 && "function" !== typeof a5 && "object" !== typeof a5) {
        if (c2._owner) {
          c2 = c2._owner;
          if (c2) {
            if (1 !== c2.tag) throw Error(n2(309));
            var d3 = c2.stateNode;
          }
          if (!d3) throw Error(n2(147, a5));
          var e2 = d3, f2 = "" + a5;
          if (null !== b6 && null !== b6.ref && "function" === typeof b6.ref && b6.ref._stringRef === f2) return b6.ref;
          b6 = function(a6) {
            var b7 = e2.refs;
            b7 === xd && (b7 = e2.refs = {});
            null === a6 ? delete b7[f2] : b7[f2] = a6;
          };
          b6._stringRef = f2;
          return b6;
        }
        if ("string" !== typeof a5) throw Error(n2(284));
        if (!c2._owner) throw Error(n2(290, a5));
      }
      return a5;
    }
    function ge(a5, b6) {
      a5 = Object.prototype.toString.call(b6);
      throw Error(n2(31, "[object Object]" === a5 ? "object with keys {" + Object.keys(b6).join(", ") + "}" : a5));
    }
    function he(a5) {
      var b6 = a5._init;
      return b6(a5._payload);
    }
    function ie(a5) {
      function b6(b7, c5) {
        if (a5) {
          var d5 = b7.deletions;
          null === d5 ? (b7.deletions = [c5], b7.flags |= 16) : d5.push(c5);
        }
      }
      function c2(c5, d5) {
        if (!a5) return null;
        for (; null !== d5; ) b6(c5, d5), d5 = d5.sibling;
        return null;
      }
      function d3(a6, b7) {
        for (a6 = /* @__PURE__ */ new Map(); null !== b7; ) null !== b7.key ? a6.set(b7.key, b7) : a6.set(b7.index, b7), b7 = b7.sibling;
        return a6;
      }
      function e2(a6, b7) {
        a6 = je(a6, b7);
        a6.index = 0;
        a6.sibling = null;
        return a6;
      }
      function f2(b7, c5, d5) {
        b7.index = d5;
        if (!a5) return b7.flags |= 1048576, c5;
        d5 = b7.alternate;
        if (null !== d5) return d5 = d5.index, d5 < c5 ? (b7.flags |= 2, c5) : d5;
        b7.flags |= 2;
        return c5;
      }
      function g2(b7) {
        a5 && null === b7.alternate && (b7.flags |= 2);
        return b7;
      }
      function h2(a6, b7, c5, d5) {
        if (null === b7 || 6 !== b7.tag) return b7 = ke(c5, a6.mode, d5), b7.return = a6, b7;
        b7 = e2(b7, c5);
        b7.return = a6;
        return b7;
      }
      function k2(a6, b7, c5, d5) {
        var f3 = c5.type;
        if (f3 === ia) return m2(a6, b7, c5.props.children, d5, c5.key);
        if (null !== b7 && (b7.elementType === f3 || "object" === typeof f3 && null !== f3 && f3.$$typeof === ra && he(f3) === b7.type)) return d5 = e2(b7, c5.props), d5.ref = fe(a6, b7, c5), d5.return = a6, d5;
        d5 = le(c5.type, c5.key, c5.props, null, a6.mode, d5);
        d5.ref = fe(a6, b7, c5);
        d5.return = a6;
        return d5;
      }
      function l2(a6, b7, c5, d5) {
        if (null === b7 || 4 !== b7.tag || b7.stateNode.containerInfo !== c5.containerInfo || b7.stateNode.implementation !== c5.implementation) return b7 = me(c5, a6.mode, d5), b7.return = a6, b7;
        b7 = e2(b7, c5.children || []);
        b7.return = a6;
        return b7;
      }
      function m2(a6, b7, c5, d5, f3) {
        if (null === b7 || 7 !== b7.tag) return b7 = ne(c5, a6.mode, d5, f3), b7.return = a6, b7;
        b7 = e2(b7, c5);
        b7.return = a6;
        return b7;
      }
      function v3(a6, b7, c5) {
        if ("string" === typeof b7 && "" !== b7 || "number" === typeof b7) return b7 = ke("" + b7, a6.mode, c5), b7.return = a6, b7;
        if ("object" === typeof b7 && null !== b7) {
          switch (b7.$$typeof) {
            case fa:
              return c5 = le(b7.type, b7.key, b7.props, null, a6.mode, c5), c5.ref = fe(a6, null, b7), c5.return = a6, c5;
            case ha:
              return b7 = me(b7, a6.mode, c5), b7.return = a6, b7;
            case ra:
              var d5 = b7._init;
              return v3(a6, d5(b7._payload), c5);
          }
          if (Ea(b7) || ua(b7)) return b7 = ne(b7, a6.mode, c5, null), b7.return = a6, b7;
          ge(a6, b7);
        }
        return null;
      }
      function r3(a6, b7, c5, d5) {
        var e3 = null !== b7 ? b7.key : null;
        if ("string" === typeof c5 && "" !== c5 || "number" === typeof c5) return null !== e3 ? null : h2(a6, b7, "" + c5, d5);
        if ("object" === typeof c5 && null !== c5) {
          switch (c5.$$typeof) {
            case fa:
              return c5.key === e3 ? k2(a6, b7, c5, d5) : null;
            case ha:
              return c5.key === e3 ? l2(a6, b7, c5, d5) : null;
            case ra:
              return e3 = c5._init, r3(
                a6,
                b7,
                e3(c5._payload),
                d5
              );
          }
          if (Ea(c5) || ua(c5)) return null !== e3 ? null : m2(a6, b7, c5, d5, null);
          ge(a6, c5);
        }
        return null;
      }
      function z2(a6, b7, c5, d5, e3) {
        if ("string" === typeof d5 && "" !== d5 || "number" === typeof d5) return a6 = a6.get(c5) || null, h2(b7, a6, "" + d5, e3);
        if ("object" === typeof d5 && null !== d5) {
          switch (d5.$$typeof) {
            case fa:
              return a6 = a6.get(null === d5.key ? c5 : d5.key) || null, k2(b7, a6, d5, e3);
            case ha:
              return a6 = a6.get(null === d5.key ? c5 : d5.key) || null, l2(b7, a6, d5, e3);
            case ra:
              var f3 = d5._init;
              return z2(a6, b7, c5, f3(d5._payload), e3);
          }
          if (Ea(d5) || ua(d5)) return a6 = a6.get(c5) || null, m2(b7, a6, d5, e3, null);
          ge(b7, d5);
        }
        return null;
      }
      function q2(e3, g3, h3, k3) {
        for (var l3 = null, m3 = null, w2 = g3, u2 = g3 = 0, t2 = null; null !== w2 && u2 < h3.length; u2++) {
          w2.index > u2 ? (t2 = w2, w2 = null) : t2 = w2.sibling;
          var q3 = r3(e3, w2, h3[u2], k3);
          if (null === q3) {
            null === w2 && (w2 = t2);
            break;
          }
          a5 && w2 && null === q3.alternate && b6(e3, w2);
          g3 = f2(q3, g3, u2);
          null === m3 ? l3 = q3 : m3.sibling = q3;
          m3 = q3;
          w2 = t2;
        }
        if (u2 === h3.length) return c2(e3, w2), I2 && Pd(e3, u2), l3;
        if (null === w2) {
          for (; u2 < h3.length; u2++) w2 = v3(e3, h3[u2], k3), null !== w2 && (g3 = f2(w2, g3, u2), null === m3 ? l3 = w2 : m3.sibling = w2, m3 = w2);
          I2 && Pd(e3, u2);
          return l3;
        }
        for (w2 = d3(e3, w2); u2 < h3.length; u2++) t2 = z2(w2, e3, u2, h3[u2], k3), null !== t2 && (a5 && null !== t2.alternate && w2.delete(null === t2.key ? u2 : t2.key), g3 = f2(t2, g3, u2), null === m3 ? l3 = t2 : m3.sibling = t2, m3 = t2);
        a5 && w2.forEach(function(a6) {
          return b6(e3, a6);
        });
        I2 && Pd(e3, u2);
        return l3;
      }
      function N2(e3, g3, h3, k3) {
        var l3 = ua(h3);
        if ("function" !== typeof l3) throw Error(n2(150));
        h3 = l3.call(h3);
        if (null == h3) throw Error(n2(151));
        for (var w2 = l3 = null, m3 = g3, u2 = g3 = 0, q3 = null, t2 = h3.next(); null !== m3 && !t2.done; u2++, t2 = h3.next()) {
          m3.index > u2 ? (q3 = m3, m3 = null) : q3 = m3.sibling;
          var V3 = r3(e3, m3, t2.value, k3);
          if (null === V3) {
            null === m3 && (m3 = q3);
            break;
          }
          a5 && m3 && null === V3.alternate && b6(e3, m3);
          g3 = f2(V3, g3, u2);
          null === w2 ? l3 = V3 : w2.sibling = V3;
          w2 = V3;
          m3 = q3;
        }
        if (t2.done) return c2(
          e3,
          m3
        ), I2 && Pd(e3, u2), l3;
        if (null === m3) {
          for (; !t2.done; u2++, t2 = h3.next()) t2 = v3(e3, t2.value, k3), null !== t2 && (g3 = f2(t2, g3, u2), null === w2 ? l3 = t2 : w2.sibling = t2, w2 = t2);
          I2 && Pd(e3, u2);
          return l3;
        }
        for (m3 = d3(e3, m3); !t2.done; u2++, t2 = h3.next()) t2 = z2(m3, e3, u2, t2.value, k3), null !== t2 && (a5 && null !== t2.alternate && m3.delete(null === t2.key ? u2 : t2.key), g3 = f2(t2, g3, u2), null === w2 ? l3 = t2 : w2.sibling = t2, w2 = t2);
        a5 && m3.forEach(function(a6) {
          return b6(e3, a6);
        });
        I2 && Pd(e3, u2);
        return l3;
      }
      function da(a6, d5, f3, h3) {
        "object" === typeof f3 && null !== f3 && f3.type === ia && null === f3.key && (f3 = f3.props.children);
        if ("object" === typeof f3 && null !== f3) {
          switch (f3.$$typeof) {
            case fa:
              a: {
                for (var k3 = f3.key, l3 = d5; null !== l3; ) {
                  if (l3.key === k3) {
                    k3 = f3.type;
                    if (k3 === ia) {
                      if (7 === l3.tag) {
                        c2(a6, l3.sibling);
                        d5 = e2(l3, f3.props.children);
                        d5.return = a6;
                        a6 = d5;
                        break a;
                      }
                    } else if (l3.elementType === k3 || "object" === typeof k3 && null !== k3 && k3.$$typeof === ra && he(k3) === l3.type) {
                      c2(a6, l3.sibling);
                      d5 = e2(l3, f3.props);
                      d5.ref = fe(a6, l3, f3);
                      d5.return = a6;
                      a6 = d5;
                      break a;
                    }
                    c2(a6, l3);
                    break;
                  } else b6(a6, l3);
                  l3 = l3.sibling;
                }
                f3.type === ia ? (d5 = ne(f3.props.children, a6.mode, h3, f3.key), d5.return = a6, a6 = d5) : (h3 = le(f3.type, f3.key, f3.props, null, a6.mode, h3), h3.ref = fe(a6, d5, f3), h3.return = a6, a6 = h3);
              }
              return g2(a6);
            case ha:
              a: {
                for (l3 = f3.key; null !== d5; ) {
                  if (d5.key === l3) if (4 === d5.tag && d5.stateNode.containerInfo === f3.containerInfo && d5.stateNode.implementation === f3.implementation) {
                    c2(a6, d5.sibling);
                    d5 = e2(d5, f3.children || []);
                    d5.return = a6;
                    a6 = d5;
                    break a;
                  } else {
                    c2(a6, d5);
                    break;
                  }
                  else b6(a6, d5);
                  d5 = d5.sibling;
                }
                d5 = me(f3, a6.mode, h3);
                d5.return = a6;
                a6 = d5;
              }
              return g2(a6);
            case ra:
              return l3 = f3._init, da(a6, d5, l3(f3._payload), h3);
          }
          if (Ea(f3)) return q2(a6, d5, f3, h3);
          if (ua(f3)) return N2(a6, d5, f3, h3);
          ge(a6, f3);
        }
        return "string" === typeof f3 && "" !== f3 || "number" === typeof f3 ? (f3 = "" + f3, null !== d5 && 6 === d5.tag ? (c2(a6, d5.sibling), d5 = e2(d5, f3), d5.return = a6, a6 = d5) : (c2(a6, d5), d5 = ke(f3, a6.mode, h3), d5.return = a6, a6 = d5), g2(a6)) : c2(a6, d5);
      }
      return da;
    }
    var oe = ie(true), pe = ie(false), qe = {}, re2 = gc(qe), se = gc(qe), te = gc(qe);
    function ue(a5) {
      if (a5 === qe) throw Error(n2(174));
      return a5;
    }
    function ve(a5, b6) {
      y2(te, b6);
      y2(se, a5);
      y2(re2, qe);
      a5 = Ga(b6);
      x3(re2);
      y2(re2, a5);
    }
    function we() {
      x3(re2);
      x3(se);
      x3(te);
    }
    function xe(a5) {
      var b6 = ue(te.current), c2 = ue(re2.current);
      b6 = Ha(c2, a5.type, b6);
      c2 !== b6 && (y2(se, a5), y2(re2, b6));
    }
    function ye(a5) {
      se.current === a5 && (x3(re2), x3(se));
    }
    var J2 = gc(0);
    function ze(a5) {
      for (var b6 = a5; null !== b6; ) {
        if (13 === b6.tag) {
          var c2 = b6.memoizedState;
          if (null !== c2 && (c2 = c2.dehydrated, null === c2 || Ib(c2) || Jb(c2))) return b6;
        } else if (19 === b6.tag && void 0 !== b6.memoizedProps.revealOrder) {
          if (0 !== (b6.flags & 128)) return b6;
        } else if (null !== b6.child) {
          b6.child.return = b6;
          b6 = b6.child;
          continue;
        }
        if (b6 === a5) break;
        for (; null === b6.sibling; ) {
          if (null === b6.return || b6.return === a5) return null;
          b6 = b6.return;
        }
        b6.sibling.return = b6.return;
        b6 = b6.sibling;
      }
      return null;
    }
    var Ae = [];
    function Be() {
      for (var a5 = 0; a5 < Ae.length; a5++) {
        var b6 = Ae[a5];
        Ta ? b6._workInProgressVersionPrimary = null : b6._workInProgressVersionSecondary = null;
      }
      Ae.length = 0;
    }
    var Ce = ea.ReactCurrentDispatcher, De = ea.ReactCurrentBatchConfig, Ee = 0, K2 = null, L2 = null, M2 = null, Fe = false, Ge = false, He = 0, Ie = 0;
    function O3() {
      throw Error(n2(321));
    }
    function Je(a5, b6) {
      if (null === b6) return false;
      for (var c2 = 0; c2 < b6.length && c2 < a5.length; c2++) if (!Rc(a5[c2], b6[c2])) return false;
      return true;
    }
    function Ke(a5, b6, c2, d3, e2, f2) {
      Ee = f2;
      K2 = b6;
      b6.memoizedState = null;
      b6.updateQueue = null;
      b6.lanes = 0;
      Ce.current = null === a5 || null === a5.memoizedState ? Le : Me;
      a5 = c2(d3, e2);
      if (Ge) {
        f2 = 0;
        do {
          Ge = false;
          He = 0;
          if (25 <= f2) throw Error(n2(301));
          f2 += 1;
          M2 = L2 = null;
          b6.updateQueue = null;
          Ce.current = Ne;
          a5 = c2(d3, e2);
        } while (Ge);
      }
      Ce.current = Oe;
      b6 = null !== L2 && null !== L2.next;
      Ee = 0;
      M2 = L2 = K2 = null;
      Fe = false;
      if (b6) throw Error(n2(300));
      return a5;
    }
    function Pe() {
      var a5 = 0 !== He;
      He = 0;
      return a5;
    }
    function Qe() {
      var a5 = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
      null === M2 ? K2.memoizedState = M2 = a5 : M2 = M2.next = a5;
      return M2;
    }
    function Re() {
      if (null === L2) {
        var a5 = K2.alternate;
        a5 = null !== a5 ? a5.memoizedState : null;
      } else a5 = L2.next;
      var b6 = null === M2 ? K2.memoizedState : M2.next;
      if (null !== b6) M2 = b6, L2 = a5;
      else {
        if (null === a5) throw Error(n2(310));
        L2 = a5;
        a5 = { memoizedState: L2.memoizedState, baseState: L2.baseState, baseQueue: L2.baseQueue, queue: L2.queue, next: null };
        null === M2 ? K2.memoizedState = M2 = a5 : M2 = M2.next = a5;
      }
      return M2;
    }
    function Se(a5, b6) {
      return "function" === typeof b6 ? b6(a5) : b6;
    }
    function Te(a5) {
      var b6 = Re(), c2 = b6.queue;
      if (null === c2) throw Error(n2(311));
      c2.lastRenderedReducer = a5;
      var d3 = L2, e2 = d3.baseQueue, f2 = c2.pending;
      if (null !== f2) {
        if (null !== e2) {
          var g2 = e2.next;
          e2.next = f2.next;
          f2.next = g2;
        }
        d3.baseQueue = e2 = f2;
        c2.pending = null;
      }
      if (null !== e2) {
        f2 = e2.next;
        d3 = d3.baseState;
        var h2 = g2 = null, k2 = null, l2 = f2;
        do {
          var m2 = l2.lane;
          if ((Ee & m2) === m2) null !== k2 && (k2 = k2.next = { lane: 0, action: l2.action, hasEagerState: l2.hasEagerState, eagerState: l2.eagerState, next: null }), d3 = l2.hasEagerState ? l2.eagerState : a5(d3, l2.action);
          else {
            var v3 = {
              lane: m2,
              action: l2.action,
              hasEagerState: l2.hasEagerState,
              eagerState: l2.eagerState,
              next: null
            };
            null === k2 ? (h2 = k2 = v3, g2 = d3) : k2 = k2.next = v3;
            K2.lanes |= m2;
            vd |= m2;
          }
          l2 = l2.next;
        } while (null !== l2 && l2 !== f2);
        null === k2 ? g2 = d3 : k2.next = h2;
        Rc(d3, b6.memoizedState) || (kd = true);
        b6.memoizedState = d3;
        b6.baseState = g2;
        b6.baseQueue = k2;
        c2.lastRenderedState = d3;
      }
      a5 = c2.interleaved;
      if (null !== a5) {
        e2 = a5;
        do
          f2 = e2.lane, K2.lanes |= f2, vd |= f2, e2 = e2.next;
        while (e2 !== a5);
      } else null === e2 && (c2.lanes = 0);
      return [b6.memoizedState, c2.dispatch];
    }
    function Ue(a5) {
      var b6 = Re(), c2 = b6.queue;
      if (null === c2) throw Error(n2(311));
      c2.lastRenderedReducer = a5;
      var d3 = c2.dispatch, e2 = c2.pending, f2 = b6.memoizedState;
      if (null !== e2) {
        c2.pending = null;
        var g2 = e2 = e2.next;
        do
          f2 = a5(f2, g2.action), g2 = g2.next;
        while (g2 !== e2);
        Rc(f2, b6.memoizedState) || (kd = true);
        b6.memoizedState = f2;
        null === b6.baseQueue && (b6.baseState = f2);
        c2.lastRenderedState = f2;
      }
      return [f2, d3];
    }
    function Ve() {
    }
    function We(a5, b6) {
      var c2 = K2, d3 = Re(), e2 = b6(), f2 = !Rc(d3.memoizedState, e2);
      f2 && (d3.memoizedState = e2, kd = true);
      d3 = d3.queue;
      Xe(Ye.bind(null, c2, d3, a5), [a5]);
      if (d3.getSnapshot !== b6 || f2 || null !== M2 && M2.memoizedState.tag & 1) {
        c2.flags |= 2048;
        Ze(9, $e.bind(null, c2, d3, e2, b6), void 0, null);
        if (null === F2) throw Error(n2(349));
        0 !== (Ee & 30) || af(c2, b6, e2);
      }
      return e2;
    }
    function af(a5, b6, c2) {
      a5.flags |= 16384;
      a5 = { getSnapshot: b6, value: c2 };
      b6 = K2.updateQueue;
      null === b6 ? (b6 = { lastEffect: null, stores: null }, K2.updateQueue = b6, b6.stores = [a5]) : (c2 = b6.stores, null === c2 ? b6.stores = [a5] : c2.push(a5));
    }
    function $e(a5, b6, c2, d3) {
      b6.value = c2;
      b6.getSnapshot = d3;
      bf(b6) && Ad(a5, 1, -1);
    }
    function Ye(a5, b6, c2) {
      return c2(function() {
        bf(b6) && Ad(a5, 1, -1);
      });
    }
    function bf(a5) {
      var b6 = a5.getSnapshot;
      a5 = a5.value;
      try {
        var c2 = b6();
        return !Rc(a5, c2);
      } catch (d3) {
        return true;
      }
    }
    function cf(a5) {
      var b6 = Qe();
      "function" === typeof a5 && (a5 = a5());
      b6.memoizedState = b6.baseState = a5;
      a5 = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Se, lastRenderedState: a5 };
      b6.queue = a5;
      a5 = a5.dispatch = df.bind(null, K2, a5);
      return [b6.memoizedState, a5];
    }
    function Ze(a5, b6, c2, d3) {
      a5 = { tag: a5, create: b6, destroy: c2, deps: d3, next: null };
      b6 = K2.updateQueue;
      null === b6 ? (b6 = { lastEffect: null, stores: null }, K2.updateQueue = b6, b6.lastEffect = a5.next = a5) : (c2 = b6.lastEffect, null === c2 ? b6.lastEffect = a5.next = a5 : (d3 = c2.next, c2.next = a5, a5.next = d3, b6.lastEffect = a5));
      return a5;
    }
    function ef() {
      return Re().memoizedState;
    }
    function ff(a5, b6, c2, d3) {
      var e2 = Qe();
      K2.flags |= a5;
      e2.memoizedState = Ze(1 | b6, c2, void 0, void 0 === d3 ? null : d3);
    }
    function gf(a5, b6, c2, d3) {
      var e2 = Re();
      d3 = void 0 === d3 ? null : d3;
      var f2 = void 0;
      if (null !== L2) {
        var g2 = L2.memoizedState;
        f2 = g2.destroy;
        if (null !== d3 && Je(d3, g2.deps)) {
          e2.memoizedState = Ze(b6, c2, f2, d3);
          return;
        }
      }
      K2.flags |= a5;
      e2.memoizedState = Ze(1 | b6, c2, f2, d3);
    }
    function hf(a5, b6) {
      return ff(8390656, 8, a5, b6);
    }
    function Xe(a5, b6) {
      return gf(2048, 8, a5, b6);
    }
    function jf(a5, b6) {
      return gf(4, 2, a5, b6);
    }
    function kf(a5, b6) {
      return gf(4, 4, a5, b6);
    }
    function lf(a5, b6) {
      if ("function" === typeof b6) return a5 = a5(), b6(a5), function() {
        b6(null);
      };
      if (null !== b6 && void 0 !== b6) return a5 = a5(), b6.current = a5, function() {
        b6.current = null;
      };
    }
    function mf(a5, b6, c2) {
      c2 = null !== c2 && void 0 !== c2 ? c2.concat([a5]) : null;
      return gf(4, 4, lf.bind(null, b6, a5), c2);
    }
    function nf() {
    }
    function of(a5, b6) {
      var c2 = Re();
      b6 = void 0 === b6 ? null : b6;
      var d3 = c2.memoizedState;
      if (null !== d3 && null !== b6 && Je(b6, d3[1])) return d3[0];
      c2.memoizedState = [a5, b6];
      return a5;
    }
    function pf(a5, b6) {
      var c2 = Re();
      b6 = void 0 === b6 ? null : b6;
      var d3 = c2.memoizedState;
      if (null !== d3 && null !== b6 && Je(b6, d3[1])) return d3[0];
      a5 = a5();
      c2.memoizedState = [a5, b6];
      return a5;
    }
    function qf(a5, b6) {
      var c2 = D2;
      D2 = 0 !== c2 && 4 > c2 ? c2 : 4;
      a5(true);
      var d3 = De.transition;
      De.transition = {};
      try {
        a5(false), b6();
      } finally {
        D2 = c2, De.transition = d3;
      }
    }
    function rf() {
      return Re().memoizedState;
    }
    function sf(a5, b6, c2) {
      var d3 = zd(a5);
      c2 = { lane: d3, action: c2, hasEagerState: false, eagerState: null, next: null };
      tf(a5) ? uf(b6, c2) : (vf(a5, b6, c2), c2 = H3(), a5 = Ad(a5, d3, c2), null !== a5 && wf(a5, b6, d3));
    }
    function df(a5, b6, c2) {
      var d3 = zd(a5), e2 = { lane: d3, action: c2, hasEagerState: false, eagerState: null, next: null };
      if (tf(a5)) uf(b6, e2);
      else {
        vf(a5, b6, e2);
        var f2 = a5.alternate;
        if (0 === a5.lanes && (null === f2 || 0 === f2.lanes) && (f2 = b6.lastRenderedReducer, null !== f2)) try {
          var g2 = b6.lastRenderedState, h2 = f2(g2, c2);
          e2.hasEagerState = true;
          e2.eagerState = h2;
          if (Rc(h2, g2)) return;
        } catch (k2) {
        } finally {
        }
        c2 = H3();
        a5 = Ad(a5, d3, c2);
        null !== a5 && wf(a5, b6, d3);
      }
    }
    function tf(a5) {
      var b6 = a5.alternate;
      return a5 === K2 || null !== b6 && b6 === K2;
    }
    function uf(a5, b6) {
      Ge = Fe = true;
      var c2 = a5.pending;
      null === c2 ? b6.next = b6 : (b6.next = c2.next, c2.next = b6);
      a5.pending = b6;
    }
    function vf(a5, b6, c2) {
      null !== F2 && 0 !== (a5.mode & 1) && 0 === (G2 & 2) ? (a5 = b6.interleaved, null === a5 ? (c2.next = c2, null === md ? md = [b6] : md.push(b6)) : (c2.next = a5.next, a5.next = c2), b6.interleaved = c2) : (a5 = b6.pending, null === a5 ? c2.next = c2 : (c2.next = a5.next, a5.next = c2), b6.pending = c2);
    }
    function wf(a5, b6, c2) {
      if (0 !== (c2 & 4194240)) {
        var d3 = b6.lanes;
        d3 &= a5.pendingLanes;
        c2 |= d3;
        b6.lanes = c2;
        Dc(a5, c2);
      }
    }
    var Oe = { readContext: ld, useCallback: O3, useContext: O3, useEffect: O3, useImperativeHandle: O3, useInsertionEffect: O3, useLayoutEffect: O3, useMemo: O3, useReducer: O3, useRef: O3, useState: O3, useDebugValue: O3, useDeferredValue: O3, useTransition: O3, useMutableSource: O3, useSyncExternalStore: O3, useId: O3, unstable_isNewReconciler: false }, Le = { readContext: ld, useCallback: function(a5, b6) {
      Qe().memoizedState = [a5, void 0 === b6 ? null : b6];
      return a5;
    }, useContext: ld, useEffect: hf, useImperativeHandle: function(a5, b6, c2) {
      c2 = null !== c2 && void 0 !== c2 ? c2.concat([a5]) : null;
      return ff(
        4194308,
        4,
        lf.bind(null, b6, a5),
        c2
      );
    }, useLayoutEffect: function(a5, b6) {
      return ff(4194308, 4, a5, b6);
    }, useInsertionEffect: function(a5, b6) {
      return ff(4, 2, a5, b6);
    }, useMemo: function(a5, b6) {
      var c2 = Qe();
      b6 = void 0 === b6 ? null : b6;
      a5 = a5();
      c2.memoizedState = [a5, b6];
      return a5;
    }, useReducer: function(a5, b6, c2) {
      var d3 = Qe();
      b6 = void 0 !== c2 ? c2(b6) : b6;
      d3.memoizedState = d3.baseState = b6;
      a5 = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: a5, lastRenderedState: b6 };
      d3.queue = a5;
      a5 = a5.dispatch = sf.bind(null, K2, a5);
      return [d3.memoizedState, a5];
    }, useRef: function(a5) {
      var b6 = Qe();
      a5 = { current: a5 };
      return b6.memoizedState = a5;
    }, useState: cf, useDebugValue: nf, useDeferredValue: function(a5) {
      var b6 = cf(a5), c2 = b6[0], d3 = b6[1];
      hf(function() {
        var b7 = De.transition;
        De.transition = {};
        try {
          d3(a5);
        } finally {
          De.transition = b7;
        }
      }, [a5]);
      return c2;
    }, useTransition: function() {
      var a5 = cf(false), b6 = a5[0];
      a5 = qf.bind(null, a5[1]);
      Qe().memoizedState = a5;
      return [b6, a5];
    }, useMutableSource: function() {
    }, useSyncExternalStore: function(a5, b6, c2) {
      var d3 = K2, e2 = Qe();
      if (I2) {
        if (void 0 === c2) throw Error(n2(407));
        c2 = c2();
      } else {
        c2 = b6();
        if (null === F2) throw Error(n2(349));
        0 !== (Ee & 30) || af(d3, b6, c2);
      }
      e2.memoizedState = c2;
      var f2 = { value: c2, getSnapshot: b6 };
      e2.queue = f2;
      hf(Ye.bind(null, d3, f2, a5), [a5]);
      d3.flags |= 2048;
      Ze(9, $e.bind(null, d3, f2, c2, b6), void 0, null);
      return c2;
    }, useId: function() {
      var a5 = Qe(), b6 = F2.identifierPrefix;
      if (I2) {
        var c2 = Od;
        var d3 = Nd;
        c2 = (d3 & ~(1 << 32 - qc(d3) - 1)).toString(32) + c2;
        b6 = ":" + b6 + "R" + c2;
        c2 = He++;
        0 < c2 && (b6 += "H" + c2.toString(32));
        b6 += ":";
      } else c2 = Ie++, b6 = ":" + b6 + "r" + c2.toString(32) + ":";
      return a5.memoizedState = b6;
    }, unstable_isNewReconciler: false }, Me = {
      readContext: ld,
      useCallback: of,
      useContext: ld,
      useEffect: Xe,
      useImperativeHandle: mf,
      useInsertionEffect: jf,
      useLayoutEffect: kf,
      useMemo: pf,
      useReducer: Te,
      useRef: ef,
      useState: function() {
        return Te(Se);
      },
      useDebugValue: nf,
      useDeferredValue: function(a5) {
        var b6 = Te(Se), c2 = b6[0], d3 = b6[1];
        Xe(function() {
          var b7 = De.transition;
          De.transition = {};
          try {
            d3(a5);
          } finally {
            De.transition = b7;
          }
        }, [a5]);
        return c2;
      },
      useTransition: function() {
        var a5 = Te(Se)[0], b6 = Re().memoizedState;
        return [a5, b6];
      },
      useMutableSource: Ve,
      useSyncExternalStore: We,
      useId: rf,
      unstable_isNewReconciler: false
    }, Ne = {
      readContext: ld,
      useCallback: of,
      useContext: ld,
      useEffect: Xe,
      useImperativeHandle: mf,
      useInsertionEffect: jf,
      useLayoutEffect: kf,
      useMemo: pf,
      useReducer: Ue,
      useRef: ef,
      useState: function() {
        return Ue(Se);
      },
      useDebugValue: nf,
      useDeferredValue: function(a5) {
        var b6 = Ue(Se), c2 = b6[0], d3 = b6[1];
        Xe(function() {
          var b7 = De.transition;
          De.transition = {};
          try {
            d3(a5);
          } finally {
            De.transition = b7;
          }
        }, [a5]);
        return c2;
      },
      useTransition: function() {
        var a5 = Ue(Se)[0], b6 = Re().memoizedState;
        return [a5, b6];
      },
      useMutableSource: Ve,
      useSyncExternalStore: We,
      useId: rf,
      unstable_isNewReconciler: false
    };
    function xf(a5, b6) {
      try {
        var c2 = "", d3 = b6;
        do
          c2 += $c(d3), d3 = d3.return;
        while (d3);
        var e2 = c2;
      } catch (f2) {
        e2 = "\nError generating stack: " + f2.message + "\n" + f2.stack;
      }
      return { value: a5, source: b6, stack: e2 };
    }
    function yf(a5, b6) {
      try {
        console.error(b6.value);
      } catch (c2) {
        setTimeout(function() {
          throw c2;
        });
      }
    }
    var zf = "function" === typeof WeakMap ? WeakMap : Map;
    function Af(a5, b6, c2) {
      c2 = qd(-1, c2);
      c2.tag = 3;
      c2.payload = { element: null };
      var d3 = b6.value;
      c2.callback = function() {
        Bf || (Bf = true, Cf = d3);
        yf(a5, b6);
      };
      return c2;
    }
    function Df(a5, b6, c2) {
      c2 = qd(-1, c2);
      c2.tag = 3;
      var d3 = a5.type.getDerivedStateFromError;
      if ("function" === typeof d3) {
        var e2 = b6.value;
        c2.payload = function() {
          return d3(e2);
        };
        c2.callback = function() {
          yf(a5, b6);
        };
      }
      var f2 = a5.stateNode;
      null !== f2 && "function" === typeof f2.componentDidCatch && (c2.callback = function() {
        yf(a5, b6);
        "function" !== typeof d3 && (null === Ef ? Ef = /* @__PURE__ */ new Set([this]) : Ef.add(this));
        var c5 = b6.stack;
        this.componentDidCatch(b6.value, { componentStack: null !== c5 ? c5 : "" });
      });
      return c2;
    }
    function Ff(a5, b6, c2) {
      var d3 = a5.pingCache;
      if (null === d3) {
        d3 = a5.pingCache = new zf();
        var e2 = /* @__PURE__ */ new Set();
        d3.set(b6, e2);
      } else e2 = d3.get(b6), void 0 === e2 && (e2 = /* @__PURE__ */ new Set(), d3.set(b6, e2));
      e2.has(c2) || (e2.add(c2), a5 = Gf.bind(null, a5, b6, c2), b6.then(a5, a5));
    }
    function Hf(a5) {
      do {
        var b6;
        if (b6 = 13 === a5.tag) b6 = a5.memoizedState, b6 = null !== b6 ? null !== b6.dehydrated ? true : false : true;
        if (b6) return a5;
        a5 = a5.return;
      } while (null !== a5);
      return null;
    }
    function If(a5, b6, c2, d3, e2) {
      if (0 === (a5.mode & 1)) return a5 === b6 ? a5.flags |= 65536 : (a5.flags |= 128, c2.flags |= 131072, c2.flags &= -52805, 1 === c2.tag && (null === c2.alternate ? c2.tag = 17 : (b6 = qd(-1, 1), b6.tag = 2, rd(c2, b6))), c2.lanes |= 1), a5;
      a5.flags |= 65536;
      a5.lanes = e2;
      return a5;
    }
    function Jf(a5) {
      a5.flags |= 4;
    }
    function Kf(a5, b6) {
      if (null !== a5 && a5.child === b6.child) return true;
      if (0 !== (b6.flags & 16)) return false;
      for (a5 = b6.child; null !== a5; ) {
        if (0 !== (a5.flags & 12854) || 0 !== (a5.subtreeFlags & 12854)) return false;
        a5 = a5.sibling;
      }
      return true;
    }
    var Lf, Mf, Nf, Of;
    if (Ua) Lf = function(a5, b6) {
      for (var c2 = b6.child; null !== c2; ) {
        if (5 === c2.tag || 6 === c2.tag) La(a5, c2.stateNode);
        else if (4 !== c2.tag && null !== c2.child) {
          c2.child.return = c2;
          c2 = c2.child;
          continue;
        }
        if (c2 === b6) break;
        for (; null === c2.sibling; ) {
          if (null === c2.return || c2.return === b6) return;
          c2 = c2.return;
        }
        c2.sibling.return = c2.return;
        c2 = c2.sibling;
      }
    }, Mf = function() {
    }, Nf = function(a5, b6, c2, d3, e2) {
      a5 = a5.memoizedProps;
      if (a5 !== d3) {
        var f2 = b6.stateNode, g2 = ue(re2.current);
        c2 = Na(f2, c2, a5, d3, e2, g2);
        (b6.updateQueue = c2) && Jf(b6);
      }
    }, Of = function(a5, b6, c2, d3) {
      c2 !== d3 && Jf(b6);
    };
    else if (Va) {
      Lf = function(a5, b6, c2, d3) {
        for (var e2 = b6.child; null !== e2; ) {
          if (5 === e2.tag) {
            var f2 = e2.stateNode;
            c2 && d3 && (f2 = Db(f2, e2.type, e2.memoizedProps, e2));
            La(a5, f2);
          } else if (6 === e2.tag) f2 = e2.stateNode, c2 && d3 && (f2 = Eb(f2, e2.memoizedProps, e2)), La(a5, f2);
          else if (4 !== e2.tag) {
            if (22 === e2.tag && null !== e2.memoizedState) f2 = e2.child, null !== f2 && (f2.return = e2), Lf(a5, e2, true, true);
            else if (null !== e2.child) {
              e2.child.return = e2;
              e2 = e2.child;
              continue;
            }
          }
          if (e2 === b6) break;
          for (; null === e2.sibling; ) {
            if (null === e2.return || e2.return === b6) return;
            e2 = e2.return;
          }
          e2.sibling.return = e2.return;
          e2 = e2.sibling;
        }
      };
      var Pf = function(a5, b6, c2, d3) {
        for (var e2 = b6.child; null !== e2; ) {
          if (5 === e2.tag) {
            var f2 = e2.stateNode;
            c2 && d3 && (f2 = Db(f2, e2.type, e2.memoizedProps, e2));
            Ab(a5, f2);
          } else if (6 === e2.tag) f2 = e2.stateNode, c2 && d3 && (f2 = Eb(f2, e2.memoizedProps, e2)), Ab(a5, f2);
          else if (4 !== e2.tag) {
            if (22 === e2.tag && null !== e2.memoizedState) f2 = e2.child, null !== f2 && (f2.return = e2), Pf(a5, e2, true, true);
            else if (null !== e2.child) {
              e2.child.return = e2;
              e2 = e2.child;
              continue;
            }
          }
          if (e2 === b6) break;
          for (; null === e2.sibling; ) {
            if (null === e2.return || e2.return === b6) return;
            e2 = e2.return;
          }
          e2.sibling.return = e2.return;
          e2 = e2.sibling;
        }
      };
      Mf = function(a5, b6) {
        var c2 = b6.stateNode;
        if (!Kf(a5, b6)) {
          a5 = c2.containerInfo;
          var d3 = zb(a5);
          Pf(d3, b6, false, false);
          c2.pendingChildren = d3;
          Jf(b6);
          Bb(a5, d3);
        }
      };
      Nf = function(a5, b6, c2, d3, e2) {
        var f2 = a5.stateNode, g2 = a5.memoizedProps;
        if ((a5 = Kf(a5, b6)) && g2 === d3) b6.stateNode = f2;
        else {
          var h2 = b6.stateNode, k2 = ue(re2.current), l2 = null;
          g2 !== d3 && (l2 = Na(h2, c2, g2, d3, e2, k2));
          a5 && null === l2 ? b6.stateNode = f2 : (f2 = yb(f2, l2, c2, g2, d3, b6, a5, h2), Ma(f2, c2, d3, e2, k2) && Jf(b6), b6.stateNode = f2, a5 ? Jf(b6) : Lf(f2, b6, false, false));
        }
      };
      Of = function(a5, b6, c2, d3) {
        c2 !== d3 ? (a5 = ue(te.current), c2 = ue(re2.current), b6.stateNode = Pa(d3, a5, c2, b6), Jf(b6)) : b6.stateNode = a5.stateNode;
      };
    } else Mf = function() {
    }, Nf = function() {
    }, Of = function() {
    };
    function Qf(a5, b6) {
      if (!I2) switch (a5.tailMode) {
        case "hidden":
          b6 = a5.tail;
          for (var c2 = null; null !== b6; ) null !== b6.alternate && (c2 = b6), b6 = b6.sibling;
          null === c2 ? a5.tail = null : c2.sibling = null;
          break;
        case "collapsed":
          c2 = a5.tail;
          for (var d3 = null; null !== c2; ) null !== c2.alternate && (d3 = c2), c2 = c2.sibling;
          null === d3 ? b6 || null === a5.tail ? a5.tail = null : a5.tail.sibling = null : d3.sibling = null;
      }
    }
    function P3(a5) {
      var b6 = null !== a5.alternate && a5.alternate.child === a5.child, c2 = 0, d3 = 0;
      if (b6) for (var e2 = a5.child; null !== e2; ) c2 |= e2.lanes | e2.childLanes, d3 |= e2.subtreeFlags & 14680064, d3 |= e2.flags & 14680064, e2.return = a5, e2 = e2.sibling;
      else for (e2 = a5.child; null !== e2; ) c2 |= e2.lanes | e2.childLanes, d3 |= e2.subtreeFlags, d3 |= e2.flags, e2.return = a5, e2 = e2.sibling;
      a5.subtreeFlags |= d3;
      a5.childLanes = c2;
      return b6;
    }
    function Rf(a5, b6, c2) {
      var d3 = b6.pendingProps;
      Sd(b6);
      switch (b6.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return P3(b6), null;
        case 1:
          return C2(b6.type) && kc(), P3(b6), null;
        case 3:
          d3 = b6.stateNode;
          we();
          x3(B2);
          x3(A2);
          Be();
          d3.pendingContext && (d3.context = d3.pendingContext, d3.pendingContext = null);
          if (null === a5 || null === a5.child) ce(b6) ? Jf(b6) : null === a5 || a5.memoizedState.isDehydrated && 0 === (b6.flags & 256) || (b6.flags |= 1024, null !== Wd && (Sf(Wd), Wd = null));
          Mf(a5, b6);
          P3(b6);
          return null;
        case 5:
          ye(b6);
          c2 = ue(te.current);
          var e2 = b6.type;
          if (null !== a5 && null != b6.stateNode) Nf(a5, b6, e2, d3, c2), a5.ref !== b6.ref && (b6.flags |= 512, b6.flags |= 2097152);
          else {
            if (!d3) {
              if (null === b6.stateNode) throw Error(n2(166));
              P3(b6);
              return null;
            }
            a5 = ue(re2.current);
            if (ce(b6)) {
              if (!p3) throw Error(n2(175));
              a5 = Pb(b6.stateNode, b6.type, b6.memoizedProps, c2, a5, b6, !Vd);
              b6.updateQueue = a5;
              null !== a5 && Jf(b6);
            } else {
              var f2 = Ka(e2, d3, c2, a5, b6);
              Lf(f2, b6, false, false);
              b6.stateNode = f2;
              Ma(f2, e2, d3, c2, a5) && Jf(b6);
            }
            null !== b6.ref && (b6.flags |= 512, b6.flags |= 2097152);
          }
          P3(b6);
          return null;
        case 6:
          if (a5 && null != b6.stateNode) Of(a5, b6, a5.memoizedProps, d3);
          else {
            if ("string" !== typeof d3 && null === b6.stateNode) throw Error(n2(166));
            a5 = ue(te.current);
            c2 = ue(re2.current);
            if (ce(b6)) {
              if (!p3) throw Error(n2(176));
              a5 = b6.stateNode;
              d3 = b6.memoizedProps;
              if (c2 = Qb(a5, d3, b6, !Vd)) {
                if (e2 = Td, null !== e2) switch (f2 = 0 !== (e2.mode & 1), e2.tag) {
                  case 3:
                    Yb(e2.stateNode.containerInfo, a5, d3, f2);
                    break;
                  case 5:
                    Zb(e2.type, e2.memoizedProps, e2.stateNode, a5, d3, f2);
                }
              }
              c2 && Jf(b6);
            } else b6.stateNode = Pa(d3, a5, c2, b6);
          }
          P3(b6);
          return null;
        case 13:
          x3(J2);
          d3 = b6.memoizedState;
          if (I2 && null !== Ud && 0 !== (b6.mode & 1) && 0 === (b6.flags & 128)) {
            for (a5 = Ud; a5; ) a5 = Lb(a5);
            de();
            b6.flags |= 98560;
            return b6;
          }
          if (null !== d3 && null !== d3.dehydrated) {
            d3 = ce(b6);
            if (null === a5) {
              if (!d3) throw Error(n2(318));
              if (!p3) throw Error(n2(344));
              a5 = b6.memoizedState;
              a5 = null !== a5 ? a5.dehydrated : null;
              if (!a5) throw Error(n2(317));
              Rb(a5, b6);
            } else de(), 0 === (b6.flags & 128) && (b6.memoizedState = null), b6.flags |= 4;
            P3(b6);
            return null;
          }
          null !== Wd && (Sf(Wd), Wd = null);
          if (0 !== (b6.flags & 128)) return b6.lanes = c2, b6;
          d3 = null !== d3;
          c2 = false;
          null === a5 ? ce(b6) : c2 = null !== a5.memoizedState;
          d3 && !c2 && (b6.child.flags |= 8192, 0 !== (b6.mode & 1) && (null === a5 || 0 !== (J2.current & 1) ? 0 === Q2 && (Q2 = 3) : Tf()));
          null !== b6.updateQueue && (b6.flags |= 4);
          P3(b6);
          return null;
        case 4:
          return we(), Mf(a5, b6), null === a5 && Xa(b6.stateNode.containerInfo), P3(b6), null;
        case 10:
          return hd(b6.type._context), P3(b6), null;
        case 17:
          return C2(b6.type) && kc(), P3(b6), null;
        case 19:
          x3(J2);
          e2 = b6.memoizedState;
          if (null === e2) return P3(b6), null;
          d3 = 0 !== (b6.flags & 128);
          f2 = e2.rendering;
          if (null === f2) if (d3) Qf(e2, false);
          else {
            if (0 !== Q2 || null !== a5 && 0 !== (a5.flags & 128)) for (a5 = b6.child; null !== a5; ) {
              f2 = ze(a5);
              if (null !== f2) {
                b6.flags |= 128;
                Qf(e2, false);
                a5 = f2.updateQueue;
                null !== a5 && (b6.updateQueue = a5, b6.flags |= 4);
                b6.subtreeFlags = 0;
                a5 = c2;
                for (d3 = b6.child; null !== d3; ) c2 = d3, e2 = a5, c2.flags &= 14680066, f2 = c2.alternate, null === f2 ? (c2.childLanes = 0, c2.lanes = e2, c2.child = null, c2.subtreeFlags = 0, c2.memoizedProps = null, c2.memoizedState = null, c2.updateQueue = null, c2.dependencies = null, c2.stateNode = null) : (c2.childLanes = f2.childLanes, c2.lanes = f2.lanes, c2.child = f2.child, c2.subtreeFlags = 0, c2.deletions = null, c2.memoizedProps = f2.memoizedProps, c2.memoizedState = f2.memoizedState, c2.updateQueue = f2.updateQueue, c2.type = f2.type, e2 = f2.dependencies, c2.dependencies = null === e2 ? null : { lanes: e2.lanes, firstContext: e2.firstContext }), d3 = d3.sibling;
                y2(J2, J2.current & 1 | 2);
                return b6.child;
              }
              a5 = a5.sibling;
            }
            null !== e2.tail && E2() > Uf && (b6.flags |= 128, d3 = true, Qf(e2, false), b6.lanes = 4194304);
          }
          else {
            if (!d3) if (a5 = ze(f2), null !== a5) {
              if (b6.flags |= 128, d3 = true, a5 = a5.updateQueue, null !== a5 && (b6.updateQueue = a5, b6.flags |= 4), Qf(e2, true), null === e2.tail && "hidden" === e2.tailMode && !f2.alternate && !I2) return P3(b6), null;
            } else 2 * E2() - e2.renderingStartTime > Uf && 1073741824 !== c2 && (b6.flags |= 128, d3 = true, Qf(e2, false), b6.lanes = 4194304);
            e2.isBackwards ? (f2.sibling = b6.child, b6.child = f2) : (a5 = e2.last, null !== a5 ? a5.sibling = f2 : b6.child = f2, e2.last = f2);
          }
          if (null !== e2.tail) return b6 = e2.tail, e2.rendering = b6, e2.tail = b6.sibling, e2.renderingStartTime = E2(), b6.sibling = null, a5 = J2.current, y2(J2, d3 ? a5 & 1 | 2 : a5 & 1), b6;
          P3(b6);
          return null;
        case 22:
        case 23:
          return Vf(), d3 = null !== b6.memoizedState, null !== a5 && null !== a5.memoizedState !== d3 && (b6.flags |= 8192), d3 && 0 !== (b6.mode & 1) ? 0 !== (Wf & 1073741824) && (P3(b6), Ua && b6.subtreeFlags & 6 && (b6.flags |= 8192)) : P3(b6), null;
        case 24:
          return null;
        case 25:
          return null;
      }
      throw Error(n2(156, b6.tag));
    }
    var Xf = ea.ReactCurrentOwner, kd = false;
    function R2(a5, b6, c2, d3) {
      b6.child = null === a5 ? pe(b6, null, c2, d3) : oe(b6, a5.child, c2, d3);
    }
    function Yf(a5, b6, c2, d3, e2) {
      c2 = c2.render;
      var f2 = b6.ref;
      jd(b6, e2);
      d3 = Ke(a5, b6, c2, d3, f2, e2);
      c2 = Pe();
      if (null !== a5 && !kd) return b6.updateQueue = a5.updateQueue, b6.flags &= -2053, a5.lanes &= ~e2, Zf(a5, b6, e2);
      I2 && c2 && Rd(b6);
      b6.flags |= 1;
      R2(a5, b6, d3, e2);
      return b6.child;
    }
    function $f(a5, b6, c2, d3, e2) {
      if (null === a5) {
        var f2 = c2.type;
        if ("function" === typeof f2 && !ag2(f2) && void 0 === f2.defaultProps && null === c2.compare && void 0 === c2.defaultProps) return b6.tag = 15, b6.type = f2, bg(a5, b6, f2, d3, e2);
        a5 = le(c2.type, null, d3, b6, b6.mode, e2);
        a5.ref = b6.ref;
        a5.return = b6;
        return b6.child = a5;
      }
      f2 = a5.child;
      if (0 === (a5.lanes & e2)) {
        var g2 = f2.memoizedProps;
        c2 = c2.compare;
        c2 = null !== c2 ? c2 : Zc;
        if (c2(g2, d3) && a5.ref === b6.ref) return Zf(a5, b6, e2);
      }
      b6.flags |= 1;
      a5 = je(f2, d3);
      a5.ref = b6.ref;
      a5.return = b6;
      return b6.child = a5;
    }
    function bg(a5, b6, c2, d3, e2) {
      if (null !== a5 && Zc(a5.memoizedProps, d3) && a5.ref === b6.ref) if (kd = false, 0 !== (a5.lanes & e2)) 0 !== (a5.flags & 131072) && (kd = true);
      else return b6.lanes = a5.lanes, Zf(a5, b6, e2);
      return cg2(a5, b6, c2, d3, e2);
    }
    function dg2(a5, b6, c2) {
      var d3 = b6.pendingProps, e2 = d3.children, f2 = null !== a5 ? a5.memoizedState : null;
      if ("hidden" === d3.mode) if (0 === (b6.mode & 1)) b6.memoizedState = { baseLanes: 0, cachePool: null }, y2(eg, Wf), Wf |= c2;
      else if (0 !== (c2 & 1073741824)) b6.memoizedState = { baseLanes: 0, cachePool: null }, d3 = null !== f2 ? f2.baseLanes : c2, y2(eg, Wf), Wf |= d3;
      else return a5 = null !== f2 ? f2.baseLanes | c2 : c2, b6.lanes = b6.childLanes = 1073741824, b6.memoizedState = { baseLanes: a5, cachePool: null }, b6.updateQueue = null, y2(eg, Wf), Wf |= a5, null;
      else null !== f2 ? (d3 = f2.baseLanes | c2, b6.memoizedState = null) : d3 = c2, y2(eg, Wf), Wf |= d3;
      R2(a5, b6, e2, c2);
      return b6.child;
    }
    function fg(a5, b6) {
      var c2 = b6.ref;
      if (null === a5 && null !== c2 || null !== a5 && a5.ref !== c2) b6.flags |= 512, b6.flags |= 2097152;
    }
    function cg2(a5, b6, c2, d3, e2) {
      var f2 = C2(c2) ? ic : A2.current;
      f2 = jc(b6, f2);
      jd(b6, e2);
      c2 = Ke(a5, b6, c2, d3, f2, e2);
      d3 = Pe();
      if (null !== a5 && !kd) return b6.updateQueue = a5.updateQueue, b6.flags &= -2053, a5.lanes &= ~e2, Zf(a5, b6, e2);
      I2 && d3 && Rd(b6);
      b6.flags |= 1;
      R2(a5, b6, c2, e2);
      return b6.child;
    }
    function gg2(a5, b6, c2, d3, e2) {
      if (C2(c2)) {
        var f2 = true;
        nc(b6);
      } else f2 = false;
      jd(b6, e2);
      if (null === b6.stateNode) null !== a5 && (a5.alternate = null, b6.alternate = null, b6.flags |= 2), Dd(b6, c2, d3), Fd(b6, c2, d3, e2), d3 = true;
      else if (null === a5) {
        var g2 = b6.stateNode, h2 = b6.memoizedProps;
        g2.props = h2;
        var k2 = g2.context, l2 = c2.contextType;
        "object" === typeof l2 && null !== l2 ? l2 = ld(l2) : (l2 = C2(c2) ? ic : A2.current, l2 = jc(b6, l2));
        var m2 = c2.getDerivedStateFromProps, v3 = "function" === typeof m2 || "function" === typeof g2.getSnapshotBeforeUpdate;
        v3 || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h2 !== d3 || k2 !== l2) && Ed(b6, g2, d3, l2);
        nd = false;
        var r3 = b6.memoizedState;
        g2.state = r3;
        ud(b6, d3, g2, e2);
        k2 = b6.memoizedState;
        h2 !== d3 || r3 !== k2 || B2.current || nd ? ("function" === typeof m2 && (yd(b6, c2, m2, d3), k2 = b6.memoizedState), (h2 = nd || Cd(b6, c2, h2, d3, r3, k2, l2)) ? (v3 || "function" !== typeof g2.UNSAFE_componentWillMount && "function" !== typeof g2.componentWillMount || ("function" === typeof g2.componentWillMount && g2.componentWillMount(), "function" === typeof g2.UNSAFE_componentWillMount && g2.UNSAFE_componentWillMount()), "function" === typeof g2.componentDidMount && (b6.flags |= 4194308)) : ("function" === typeof g2.componentDidMount && (b6.flags |= 4194308), b6.memoizedProps = d3, b6.memoizedState = k2), g2.props = d3, g2.state = k2, g2.context = l2, d3 = h2) : ("function" === typeof g2.componentDidMount && (b6.flags |= 4194308), d3 = false);
      } else {
        g2 = b6.stateNode;
        pd(a5, b6);
        h2 = b6.memoizedProps;
        l2 = b6.type === b6.elementType ? h2 : ad(b6.type, h2);
        g2.props = l2;
        v3 = b6.pendingProps;
        r3 = g2.context;
        k2 = c2.contextType;
        "object" === typeof k2 && null !== k2 ? k2 = ld(k2) : (k2 = C2(c2) ? ic : A2.current, k2 = jc(b6, k2));
        var z2 = c2.getDerivedStateFromProps;
        (m2 = "function" === typeof z2 || "function" === typeof g2.getSnapshotBeforeUpdate) || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h2 !== v3 || r3 !== k2) && Ed(b6, g2, d3, k2);
        nd = false;
        r3 = b6.memoizedState;
        g2.state = r3;
        ud(b6, d3, g2, e2);
        var q2 = b6.memoizedState;
        h2 !== v3 || r3 !== q2 || B2.current || nd ? ("function" === typeof z2 && (yd(b6, c2, z2, d3), q2 = b6.memoizedState), (l2 = nd || Cd(b6, c2, l2, d3, r3, q2, k2) || false) ? (m2 || "function" !== typeof g2.UNSAFE_componentWillUpdate && "function" !== typeof g2.componentWillUpdate || ("function" === typeof g2.componentWillUpdate && g2.componentWillUpdate(
          d3,
          q2,
          k2
        ), "function" === typeof g2.UNSAFE_componentWillUpdate && g2.UNSAFE_componentWillUpdate(d3, q2, k2)), "function" === typeof g2.componentDidUpdate && (b6.flags |= 4), "function" === typeof g2.getSnapshotBeforeUpdate && (b6.flags |= 1024)) : ("function" !== typeof g2.componentDidUpdate || h2 === a5.memoizedProps && r3 === a5.memoizedState || (b6.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h2 === a5.memoizedProps && r3 === a5.memoizedState || (b6.flags |= 1024), b6.memoizedProps = d3, b6.memoizedState = q2), g2.props = d3, g2.state = q2, g2.context = k2, d3 = l2) : ("function" !== typeof g2.componentDidUpdate || h2 === a5.memoizedProps && r3 === a5.memoizedState || (b6.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h2 === a5.memoizedProps && r3 === a5.memoizedState || (b6.flags |= 1024), d3 = false);
      }
      return hg2(a5, b6, c2, d3, f2, e2);
    }
    function hg2(a5, b6, c2, d3, e2, f2) {
      fg(a5, b6);
      var g2 = 0 !== (b6.flags & 128);
      if (!d3 && !g2) return e2 && oc(b6, c2, false), Zf(a5, b6, f2);
      d3 = b6.stateNode;
      Xf.current = b6;
      var h2 = g2 && "function" !== typeof c2.getDerivedStateFromError ? null : d3.render();
      b6.flags |= 1;
      null !== a5 && g2 ? (b6.child = oe(b6, a5.child, null, f2), b6.child = oe(b6, null, h2, f2)) : R2(a5, b6, h2, f2);
      b6.memoizedState = d3.state;
      e2 && oc(b6, c2, true);
      return b6.child;
    }
    function ig2(a5) {
      var b6 = a5.stateNode;
      b6.pendingContext ? lc(a5, b6.pendingContext, b6.pendingContext !== b6.context) : b6.context && lc(a5, b6.context, false);
      ve(a5, b6.containerInfo);
    }
    function jg(a5, b6, c2, d3, e2) {
      de();
      ee(e2);
      b6.flags |= 256;
      R2(a5, b6, c2, d3);
      return b6.child;
    }
    var kg2 = { dehydrated: null, treeContext: null, retryLane: 0 };
    function lg(a5) {
      return { baseLanes: a5, cachePool: null };
    }
    function mg(a5, b6, c2) {
      var d3 = b6.pendingProps, e2 = J2.current, f2 = false, g2 = 0 !== (b6.flags & 128), h2;
      (h2 = g2) || (h2 = null !== a5 && null === a5.memoizedState ? false : 0 !== (e2 & 2));
      if (h2) f2 = true, b6.flags &= -129;
      else if (null === a5 || null !== a5.memoizedState) e2 |= 1;
      y2(J2, e2 & 1);
      if (null === a5) {
        ae(b6);
        a5 = b6.memoizedState;
        if (null !== a5 && (a5 = a5.dehydrated, null !== a5)) return 0 === (b6.mode & 1) ? b6.lanes = 1 : Jb(a5) ? b6.lanes = 8 : b6.lanes = 1073741824, null;
        e2 = d3.children;
        a5 = d3.fallback;
        return f2 ? (d3 = b6.mode, f2 = b6.child, e2 = { mode: "hidden", children: e2 }, 0 === (d3 & 1) && null !== f2 ? (f2.childLanes = 0, f2.pendingProps = e2) : f2 = ng2(e2, d3, 0, null), a5 = ne(a5, d3, c2, null), f2.return = b6, a5.return = b6, f2.sibling = a5, b6.child = f2, b6.child.memoizedState = lg(c2), b6.memoizedState = kg2, a5) : og2(b6, e2);
      }
      e2 = a5.memoizedState;
      if (null !== e2) {
        h2 = e2.dehydrated;
        if (null !== h2) {
          if (g2) {
            if (b6.flags & 256) return b6.flags &= -257, pg(a5, b6, c2, Error(n2(422)));
            if (null !== b6.memoizedState) return b6.child = a5.child, b6.flags |= 128, null;
            f2 = d3.fallback;
            e2 = b6.mode;
            d3 = ng2({ mode: "visible", children: d3.children }, e2, 0, null);
            f2 = ne(f2, e2, c2, null);
            f2.flags |= 2;
            d3.return = b6;
            f2.return = b6;
            d3.sibling = f2;
            b6.child = d3;
            0 !== (b6.mode & 1) && oe(
              b6,
              a5.child,
              null,
              c2
            );
            b6.child.memoizedState = lg(c2);
            b6.memoizedState = kg2;
            return f2;
          }
          if (0 === (b6.mode & 1)) b6 = pg(a5, b6, c2, null);
          else if (Jb(h2)) b6 = pg(a5, b6, c2, Error(n2(419)));
          else if (d3 = 0 !== (c2 & a5.childLanes), kd || d3) {
            d3 = F2;
            if (null !== d3) {
              switch (c2 & -c2) {
                case 4:
                  f2 = 2;
                  break;
                case 16:
                  f2 = 8;
                  break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                  f2 = 32;
                  break;
                case 536870912:
                  f2 = 268435456;
                  break;
                default:
                  f2 = 0;
              }
              d3 = 0 !== (f2 & (d3.suspendedLanes | c2)) ? 0 : f2;
              0 !== d3 && d3 !== e2.retryLane && (e2.retryLane = d3, Ad(a5, d3, -1));
            }
            Tf();
            b6 = pg(a5, b6, c2, Error(n2(421)));
          } else Ib(h2) ? (b6.flags |= 128, b6.child = a5.child, b6 = qg2.bind(null, a5), Kb(h2, b6), b6 = null) : (c2 = e2.treeContext, p3 && (Ud = Ob(h2), Td = b6, I2 = true, Wd = null, Vd = false, null !== c2 && (Kd[Ld++] = Nd, Kd[Ld++] = Od, Kd[Ld++] = Md, Nd = c2.id, Od = c2.overflow, Md = b6)), b6 = og2(b6, b6.pendingProps.children), b6.flags |= 4096);
          return b6;
        }
        if (f2) return d3 = rg2(a5, b6, d3.children, d3.fallback, c2), f2 = b6.child, e2 = a5.child.memoizedState, f2.memoizedState = null === e2 ? lg(c2) : { baseLanes: e2.baseLanes | c2, cachePool: null }, f2.childLanes = a5.childLanes & ~c2, b6.memoizedState = kg2, d3;
        c2 = sg2(a5, b6, d3.children, c2);
        b6.memoizedState = null;
        return c2;
      }
      if (f2) return d3 = rg2(a5, b6, d3.children, d3.fallback, c2), f2 = b6.child, e2 = a5.child.memoizedState, f2.memoizedState = null === e2 ? lg(c2) : { baseLanes: e2.baseLanes | c2, cachePool: null }, f2.childLanes = a5.childLanes & ~c2, b6.memoizedState = kg2, d3;
      c2 = sg2(a5, b6, d3.children, c2);
      b6.memoizedState = null;
      return c2;
    }
    function og2(a5, b6) {
      b6 = ng2({ mode: "visible", children: b6 }, a5.mode, 0, null);
      b6.return = a5;
      return a5.child = b6;
    }
    function sg2(a5, b6, c2, d3) {
      var e2 = a5.child;
      a5 = e2.sibling;
      c2 = je(e2, { mode: "visible", children: c2 });
      0 === (b6.mode & 1) && (c2.lanes = d3);
      c2.return = b6;
      c2.sibling = null;
      null !== a5 && (d3 = b6.deletions, null === d3 ? (b6.deletions = [a5], b6.flags |= 16) : d3.push(a5));
      return b6.child = c2;
    }
    function rg2(a5, b6, c2, d3, e2) {
      var f2 = b6.mode;
      a5 = a5.child;
      var g2 = a5.sibling, h2 = { mode: "hidden", children: c2 };
      0 === (f2 & 1) && b6.child !== a5 ? (c2 = b6.child, c2.childLanes = 0, c2.pendingProps = h2, b6.deletions = null) : (c2 = je(a5, h2), c2.subtreeFlags = a5.subtreeFlags & 14680064);
      null !== g2 ? d3 = je(g2, d3) : (d3 = ne(d3, f2, e2, null), d3.flags |= 2);
      d3.return = b6;
      c2.return = b6;
      c2.sibling = d3;
      b6.child = c2;
      return d3;
    }
    function pg(a5, b6, c2, d3) {
      null !== d3 && ee(d3);
      oe(b6, a5.child, null, c2);
      a5 = og2(b6, b6.pendingProps.children);
      a5.flags |= 2;
      b6.memoizedState = null;
      return a5;
    }
    function tg(a5, b6, c2) {
      a5.lanes |= b6;
      var d3 = a5.alternate;
      null !== d3 && (d3.lanes |= b6);
      id(a5.return, b6, c2);
    }
    function ug(a5, b6, c2, d3, e2) {
      var f2 = a5.memoizedState;
      null === f2 ? a5.memoizedState = { isBackwards: b6, rendering: null, renderingStartTime: 0, last: d3, tail: c2, tailMode: e2 } : (f2.isBackwards = b6, f2.rendering = null, f2.renderingStartTime = 0, f2.last = d3, f2.tail = c2, f2.tailMode = e2);
    }
    function vg(a5, b6, c2) {
      var d3 = b6.pendingProps, e2 = d3.revealOrder, f2 = d3.tail;
      R2(a5, b6, d3.children, c2);
      d3 = J2.current;
      if (0 !== (d3 & 2)) d3 = d3 & 1 | 2, b6.flags |= 128;
      else {
        if (null !== a5 && 0 !== (a5.flags & 128)) a: for (a5 = b6.child; null !== a5; ) {
          if (13 === a5.tag) null !== a5.memoizedState && tg(a5, c2, b6);
          else if (19 === a5.tag) tg(a5, c2, b6);
          else if (null !== a5.child) {
            a5.child.return = a5;
            a5 = a5.child;
            continue;
          }
          if (a5 === b6) break a;
          for (; null === a5.sibling; ) {
            if (null === a5.return || a5.return === b6) break a;
            a5 = a5.return;
          }
          a5.sibling.return = a5.return;
          a5 = a5.sibling;
        }
        d3 &= 1;
      }
      y2(J2, d3);
      if (0 === (b6.mode & 1)) b6.memoizedState = null;
      else switch (e2) {
        case "forwards":
          c2 = b6.child;
          for (e2 = null; null !== c2; ) a5 = c2.alternate, null !== a5 && null === ze(a5) && (e2 = c2), c2 = c2.sibling;
          c2 = e2;
          null === c2 ? (e2 = b6.child, b6.child = null) : (e2 = c2.sibling, c2.sibling = null);
          ug(b6, false, e2, c2, f2);
          break;
        case "backwards":
          c2 = null;
          e2 = b6.child;
          for (b6.child = null; null !== e2; ) {
            a5 = e2.alternate;
            if (null !== a5 && null === ze(a5)) {
              b6.child = e2;
              break;
            }
            a5 = e2.sibling;
            e2.sibling = c2;
            c2 = e2;
            e2 = a5;
          }
          ug(b6, true, c2, null, f2);
          break;
        case "together":
          ug(b6, false, null, null, void 0);
          break;
        default:
          b6.memoizedState = null;
      }
      return b6.child;
    }
    function Zf(a5, b6, c2) {
      null !== a5 && (b6.dependencies = a5.dependencies);
      vd |= b6.lanes;
      if (0 === (c2 & b6.childLanes)) return null;
      if (null !== a5 && b6.child !== a5.child) throw Error(n2(153));
      if (null !== b6.child) {
        a5 = b6.child;
        c2 = je(a5, a5.pendingProps);
        b6.child = c2;
        for (c2.return = b6; null !== a5.sibling; ) a5 = a5.sibling, c2 = c2.sibling = je(a5, a5.pendingProps), c2.return = b6;
        c2.sibling = null;
      }
      return b6.child;
    }
    function wg2(a5, b6, c2) {
      switch (b6.tag) {
        case 3:
          ig2(b6);
          de();
          break;
        case 5:
          xe(b6);
          break;
        case 1:
          C2(b6.type) && nc(b6);
          break;
        case 4:
          ve(b6, b6.stateNode.containerInfo);
          break;
        case 10:
          gd(b6, b6.type._context, b6.memoizedProps.value);
          break;
        case 13:
          var d3 = b6.memoizedState;
          if (null !== d3) {
            if (null !== d3.dehydrated) return y2(J2, J2.current & 1), b6.flags |= 128, null;
            if (0 !== (c2 & b6.child.childLanes)) return mg(a5, b6, c2);
            y2(J2, J2.current & 1);
            a5 = Zf(a5, b6, c2);
            return null !== a5 ? a5.sibling : null;
          }
          y2(J2, J2.current & 1);
          break;
        case 19:
          d3 = 0 !== (c2 & b6.childLanes);
          if (0 !== (a5.flags & 128)) {
            if (d3) return vg(
              a5,
              b6,
              c2
            );
            b6.flags |= 128;
          }
          var e2 = b6.memoizedState;
          null !== e2 && (e2.rendering = null, e2.tail = null, e2.lastEffect = null);
          y2(J2, J2.current);
          if (d3) break;
          else return null;
        case 22:
        case 23:
          return b6.lanes = 0, dg2(a5, b6, c2);
      }
      return Zf(a5, b6, c2);
    }
    function xg(a5, b6) {
      Sd(b6);
      switch (b6.tag) {
        case 1:
          return C2(b6.type) && kc(), a5 = b6.flags, a5 & 65536 ? (b6.flags = a5 & -65537 | 128, b6) : null;
        case 3:
          return we(), x3(B2), x3(A2), Be(), a5 = b6.flags, 0 !== (a5 & 65536) && 0 === (a5 & 128) ? (b6.flags = a5 & -65537 | 128, b6) : null;
        case 5:
          return ye(b6), null;
        case 13:
          x3(J2);
          a5 = b6.memoizedState;
          if (null !== a5 && null !== a5.dehydrated) {
            if (null === b6.alternate) throw Error(n2(340));
            de();
          }
          a5 = b6.flags;
          return a5 & 65536 ? (b6.flags = a5 & -65537 | 128, b6) : null;
        case 19:
          return x3(J2), null;
        case 4:
          return we(), null;
        case 10:
          return hd(b6.type._context), null;
        case 22:
        case 23:
          return Vf(), null;
        case 24:
          return null;
        default:
          return null;
      }
    }
    var yg2 = false, zg = false, Ag2 = "function" === typeof WeakSet ? WeakSet : Set, S2 = null;
    function Bg2(a5, b6) {
      var c2 = a5.ref;
      if (null !== c2) if ("function" === typeof c2) try {
        c2(null);
      } catch (d3) {
        T2(a5, b6, d3);
      }
      else c2.current = null;
    }
    function Cg2(a5, b6, c2) {
      try {
        c2();
      } catch (d3) {
        T2(a5, b6, d3);
      }
    }
    var Dg2 = false;
    function Eg2(a5, b6) {
      Ia(a5.containerInfo);
      for (S2 = b6; null !== S2; ) if (a5 = S2, b6 = a5.child, 0 !== (a5.subtreeFlags & 1028) && null !== b6) b6.return = a5, S2 = b6;
      else for (; null !== S2; ) {
        a5 = S2;
        try {
          var c2 = a5.alternate;
          if (0 !== (a5.flags & 1024)) switch (a5.tag) {
            case 0:
            case 11:
            case 15:
              break;
            case 1:
              if (null !== c2) {
                var d3 = c2.memoizedProps, e2 = c2.memoizedState, f2 = a5.stateNode, g2 = f2.getSnapshotBeforeUpdate(a5.elementType === a5.type ? d3 : ad(a5.type, d3), e2);
                f2.__reactInternalSnapshotBeforeUpdate = g2;
              }
              break;
            case 3:
              Ua && xb(a5.stateNode.containerInfo);
              break;
            case 5:
            case 6:
            case 4:
            case 17:
              break;
            default:
              throw Error(n2(163));
          }
        } catch (h2) {
          T2(a5, a5.return, h2);
        }
        b6 = a5.sibling;
        if (null !== b6) {
          b6.return = a5.return;
          S2 = b6;
          break;
        }
        S2 = a5.return;
      }
      c2 = Dg2;
      Dg2 = false;
      return c2;
    }
    function Fg2(a5, b6, c2) {
      var d3 = b6.updateQueue;
      d3 = null !== d3 ? d3.lastEffect : null;
      if (null !== d3) {
        var e2 = d3 = d3.next;
        do {
          if ((e2.tag & a5) === a5) {
            var f2 = e2.destroy;
            e2.destroy = void 0;
            void 0 !== f2 && Cg2(b6, c2, f2);
          }
          e2 = e2.next;
        } while (e2 !== d3);
      }
    }
    function Gg2(a5, b6) {
      b6 = b6.updateQueue;
      b6 = null !== b6 ? b6.lastEffect : null;
      if (null !== b6) {
        var c2 = b6 = b6.next;
        do {
          if ((c2.tag & a5) === a5) {
            var d3 = c2.create;
            c2.destroy = d3();
          }
          c2 = c2.next;
        } while (c2 !== b6);
      }
    }
    function Hg(a5) {
      var b6 = a5.ref;
      if (null !== b6) {
        var c2 = a5.stateNode;
        switch (a5.tag) {
          case 5:
            a5 = Fa(c2);
            break;
          default:
            a5 = c2;
        }
        "function" === typeof b6 ? b6(a5) : b6.current = a5;
      }
    }
    function Ig2(a5, b6, c2) {
      if (Oc && "function" === typeof Oc.onCommitFiberUnmount) try {
        Oc.onCommitFiberUnmount(Nc, b6);
      } catch (g2) {
      }
      switch (b6.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          a5 = b6.updateQueue;
          if (null !== a5 && (a5 = a5.lastEffect, null !== a5)) {
            var d3 = a5 = a5.next;
            do {
              var e2 = d3, f2 = e2.destroy;
              e2 = e2.tag;
              void 0 !== f2 && (0 !== (e2 & 2) ? Cg2(b6, c2, f2) : 0 !== (e2 & 4) && Cg2(b6, c2, f2));
              d3 = d3.next;
            } while (d3 !== a5);
          }
          break;
        case 1:
          Bg2(b6, c2);
          a5 = b6.stateNode;
          if ("function" === typeof a5.componentWillUnmount) try {
            a5.props = b6.memoizedProps, a5.state = b6.memoizedState, a5.componentWillUnmount();
          } catch (g2) {
            T2(
              b6,
              c2,
              g2
            );
          }
          break;
        case 5:
          Bg2(b6, c2);
          break;
        case 4:
          Ua ? Jg2(a5, b6, c2) : Va && Va && (b6 = b6.stateNode.containerInfo, c2 = zb(b6), Cb(b6, c2));
      }
    }
    function Kg2(a5, b6, c2) {
      for (var d3 = b6; ; ) if (Ig2(a5, d3, c2), null === d3.child || Ua && 4 === d3.tag) {
        if (d3 === b6) break;
        for (; null === d3.sibling; ) {
          if (null === d3.return || d3.return === b6) return;
          d3 = d3.return;
        }
        d3.sibling.return = d3.return;
        d3 = d3.sibling;
      } else d3.child.return = d3, d3 = d3.child;
    }
    function Lg(a5) {
      var b6 = a5.alternate;
      null !== b6 && (a5.alternate = null, Lg(b6));
      a5.child = null;
      a5.deletions = null;
      a5.sibling = null;
      5 === a5.tag && (b6 = a5.stateNode, null !== b6 && Za(b6));
      a5.stateNode = null;
      a5.return = null;
      a5.dependencies = null;
      a5.memoizedProps = null;
      a5.memoizedState = null;
      a5.pendingProps = null;
      a5.stateNode = null;
      a5.updateQueue = null;
    }
    function Mg2(a5) {
      return 5 === a5.tag || 3 === a5.tag || 4 === a5.tag;
    }
    function Ng2(a5) {
      a: for (; ; ) {
        for (; null === a5.sibling; ) {
          if (null === a5.return || Mg2(a5.return)) return null;
          a5 = a5.return;
        }
        a5.sibling.return = a5.return;
        for (a5 = a5.sibling; 5 !== a5.tag && 6 !== a5.tag && 18 !== a5.tag; ) {
          if (a5.flags & 2) continue a;
          if (null === a5.child || 4 === a5.tag) continue a;
          else a5.child.return = a5, a5 = a5.child;
        }
        if (!(a5.flags & 2)) return a5.stateNode;
      }
    }
    function Og2(a5) {
      if (Ua) {
        a: {
          for (var b6 = a5.return; null !== b6; ) {
            if (Mg2(b6)) break a;
            b6 = b6.return;
          }
          throw Error(n2(160));
        }
        var c2 = b6;
        switch (c2.tag) {
          case 5:
            b6 = c2.stateNode;
            c2.flags & 32 && (sb(b6), c2.flags &= -33);
            c2 = Ng2(a5);
            Pg(a5, c2, b6);
            break;
          case 3:
          case 4:
            b6 = c2.stateNode.containerInfo;
            c2 = Ng2(a5);
            Qg2(a5, c2, b6);
            break;
          default:
            throw Error(n2(161));
        }
      }
    }
    function Qg2(a5, b6, c2) {
      var d3 = a5.tag;
      if (5 === d3 || 6 === d3) a5 = a5.stateNode, b6 ? pb(c2, a5, b6) : kb(c2, a5);
      else if (4 !== d3 && (a5 = a5.child, null !== a5)) for (Qg2(a5, b6, c2), a5 = a5.sibling; null !== a5; ) Qg2(a5, b6, c2), a5 = a5.sibling;
    }
    function Pg(a5, b6, c2) {
      var d3 = a5.tag;
      if (5 === d3 || 6 === d3) a5 = a5.stateNode, b6 ? ob(c2, a5, b6) : jb(c2, a5);
      else if (4 !== d3 && (a5 = a5.child, null !== a5)) for (Pg(a5, b6, c2), a5 = a5.sibling; null !== a5; ) Pg(a5, b6, c2), a5 = a5.sibling;
    }
    function Jg2(a5, b6, c2) {
      for (var d3 = b6, e2 = false, f2, g2; ; ) {
        if (!e2) {
          e2 = d3.return;
          a: for (; ; ) {
            if (null === e2) throw Error(n2(160));
            f2 = e2.stateNode;
            switch (e2.tag) {
              case 5:
                g2 = false;
                break a;
              case 3:
                f2 = f2.containerInfo;
                g2 = true;
                break a;
              case 4:
                f2 = f2.containerInfo;
                g2 = true;
                break a;
            }
            e2 = e2.return;
          }
          e2 = true;
        }
        if (5 === d3.tag || 6 === d3.tag) Kg2(a5, d3, c2), g2 ? rb(f2, d3.stateNode) : qb(f2, d3.stateNode);
        else if (18 === d3.tag) g2 ? Wb(f2, d3.stateNode) : Vb(f2, d3.stateNode);
        else if (4 === d3.tag) {
          if (null !== d3.child) {
            f2 = d3.stateNode.containerInfo;
            g2 = true;
            d3.child.return = d3;
            d3 = d3.child;
            continue;
          }
        } else if (Ig2(a5, d3, c2), null !== d3.child) {
          d3.child.return = d3;
          d3 = d3.child;
          continue;
        }
        if (d3 === b6) break;
        for (; null === d3.sibling; ) {
          if (null === d3.return || d3.return === b6) return;
          d3 = d3.return;
          4 === d3.tag && (e2 = false);
        }
        d3.sibling.return = d3.return;
        d3 = d3.sibling;
      }
    }
    function Rg2(a5, b6) {
      if (Ua) {
        switch (b6.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
            Fg2(3, b6, b6.return);
            Gg2(3, b6);
            Fg2(5, b6, b6.return);
            return;
          case 1:
            return;
          case 5:
            var c2 = b6.stateNode;
            if (null != c2) {
              var d3 = b6.memoizedProps;
              a5 = null !== a5 ? a5.memoizedProps : d3;
              var e2 = b6.type, f2 = b6.updateQueue;
              b6.updateQueue = null;
              null !== f2 && nb(c2, f2, e2, a5, d3, b6);
            }
            return;
          case 6:
            if (null === b6.stateNode) throw Error(n2(162));
            c2 = b6.memoizedProps;
            lb(b6.stateNode, null !== a5 ? a5.memoizedProps : c2, c2);
            return;
          case 3:
            p3 && null !== a5 && a5.memoizedState.isDehydrated && Tb(b6.stateNode.containerInfo);
            return;
          case 12:
            return;
          case 13:
            Sg2(b6);
            return;
          case 19:
            Sg2(b6);
            return;
          case 17:
            return;
        }
        throw Error(n2(163));
      }
      switch (b6.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Fg2(3, b6, b6.return);
          Gg2(3, b6);
          Fg2(5, b6, b6.return);
          return;
        case 12:
          return;
        case 13:
          Sg2(b6);
          return;
        case 19:
          Sg2(b6);
          return;
        case 3:
          p3 && null !== a5 && a5.memoizedState.isDehydrated && Tb(b6.stateNode.containerInfo);
          break;
        case 22:
        case 23:
          return;
      }
      a: if (Va) {
        switch (b6.tag) {
          case 1:
          case 5:
          case 6:
            break a;
          case 3:
          case 4:
            b6 = b6.stateNode;
            Cb(b6.containerInfo, b6.pendingChildren);
            break a;
        }
        throw Error(n2(163));
      }
    }
    function Sg2(a5) {
      var b6 = a5.updateQueue;
      if (null !== b6) {
        a5.updateQueue = null;
        var c2 = a5.stateNode;
        null === c2 && (c2 = a5.stateNode = new Ag2());
        b6.forEach(function(b7) {
          var d3 = Tg2.bind(null, a5, b7);
          c2.has(b7) || (c2.add(b7), b7.then(d3, d3));
        });
      }
    }
    function Ug2(a5, b6) {
      for (S2 = b6; null !== S2; ) {
        b6 = S2;
        var c2 = b6.deletions;
        if (null !== c2) for (var d3 = 0; d3 < c2.length; d3++) {
          var e2 = c2[d3];
          try {
            var f2 = a5;
            Ua ? Jg2(f2, e2, b6) : Kg2(f2, e2, b6);
            var g2 = e2.alternate;
            null !== g2 && (g2.return = null);
            e2.return = null;
          } catch (wa) {
            T2(e2, b6, wa);
          }
        }
        c2 = b6.child;
        if (0 !== (b6.subtreeFlags & 12854) && null !== c2) c2.return = b6, S2 = c2;
        else for (; null !== S2; ) {
          b6 = S2;
          try {
            var h2 = b6.flags;
            h2 & 32 && Ua && sb(b6.stateNode);
            if (h2 & 512) {
              var k2 = b6.alternate;
              if (null !== k2) {
                var l2 = k2.ref;
                null !== l2 && ("function" === typeof l2 ? l2(null) : l2.current = null);
              }
            }
            if (h2 & 8192) switch (b6.tag) {
              case 13:
                if (null !== b6.memoizedState) {
                  var m2 = b6.alternate;
                  if (null === m2 || null === m2.memoizedState) Vg = E2();
                }
                break;
              case 22:
                var v3 = null !== b6.memoizedState, r3 = b6.alternate, z2 = null !== r3 && null !== r3.memoizedState;
                c2 = b6;
                if (Ua) {
                  a: if (d3 = c2, e2 = v3, f2 = null, Ua) for (var q2 = d3; ; ) {
                    if (5 === q2.tag) {
                      if (null === f2) {
                        f2 = q2;
                        var N2 = q2.stateNode;
                        e2 ? tb(N2) : vb(q2.stateNode, q2.memoizedProps);
                      }
                    } else if (6 === q2.tag) {
                      if (null === f2) {
                        var da = q2.stateNode;
                        e2 ? ub(da) : wb(da, q2.memoizedProps);
                      }
                    } else if ((22 !== q2.tag && 23 !== q2.tag || null === q2.memoizedState || q2 === d3) && null !== q2.child) {
                      q2.child.return = q2;
                      q2 = q2.child;
                      continue;
                    }
                    if (q2 === d3) break;
                    for (; null === q2.sibling; ) {
                      if (null === q2.return || q2.return === d3) break a;
                      f2 === q2 && (f2 = null);
                      q2 = q2.return;
                    }
                    f2 === q2 && (f2 = null);
                    q2.sibling.return = q2.return;
                    q2 = q2.sibling;
                  }
                }
                if (v3 && !z2 && 0 !== (c2.mode & 1)) {
                  S2 = c2;
                  for (var t2 = c2.child; null !== t2; ) {
                    for (c2 = S2 = t2; null !== S2; ) {
                      d3 = S2;
                      var w2 = d3.child;
                      switch (d3.tag) {
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                          Fg2(4, d3, d3.return);
                          break;
                        case 1:
                          Bg2(d3, d3.return);
                          var u2 = d3.stateNode;
                          if ("function" === typeof u2.componentWillUnmount) {
                            var V3 = d3.return;
                            try {
                              u2.props = d3.memoizedProps, u2.state = d3.memoizedState, u2.componentWillUnmount();
                            } catch (wa) {
                              T2(
                                d3,
                                V3,
                                wa
                              );
                            }
                          }
                          break;
                        case 5:
                          Bg2(d3, d3.return);
                          break;
                        case 22:
                          if (null !== d3.memoizedState) {
                            Wg(c2);
                            continue;
                          }
                      }
                      null !== w2 ? (w2.return = d3, S2 = w2) : Wg(c2);
                    }
                    t2 = t2.sibling;
                  }
                }
            }
            switch (h2 & 4102) {
              case 2:
                Og2(b6);
                b6.flags &= -3;
                break;
              case 6:
                Og2(b6);
                b6.flags &= -3;
                Rg2(b6.alternate, b6);
                break;
              case 4096:
                b6.flags &= -4097;
                break;
              case 4100:
                b6.flags &= -4097;
                Rg2(b6.alternate, b6);
                break;
              case 4:
                Rg2(b6.alternate, b6);
            }
          } catch (wa) {
            T2(b6, b6.return, wa);
          }
          c2 = b6.sibling;
          if (null !== c2) {
            c2.return = b6.return;
            S2 = c2;
            break;
          }
          S2 = b6.return;
        }
      }
    }
    function Xg(a5, b6, c2) {
      S2 = a5;
      Yg(a5);
    }
    function Yg(a5, b6, c2) {
      for (var d3 = 0 !== (a5.mode & 1); null !== S2; ) {
        var e2 = S2, f2 = e2.child;
        if (22 === e2.tag && d3) {
          var g2 = null !== e2.memoizedState || yg2;
          if (!g2) {
            var h2 = e2.alternate, k2 = null !== h2 && null !== h2.memoizedState || zg;
            h2 = yg2;
            var l2 = zg;
            yg2 = g2;
            if ((zg = k2) && !l2) for (S2 = e2; null !== S2; ) g2 = S2, k2 = g2.child, 22 === g2.tag && null !== g2.memoizedState ? Zg(e2) : null !== k2 ? (k2.return = g2, S2 = k2) : Zg(e2);
            for (; null !== f2; ) S2 = f2, Yg(f2), f2 = f2.sibling;
            S2 = e2;
            yg2 = h2;
            zg = l2;
          }
          $g(a5);
        } else 0 !== (e2.subtreeFlags & 8772) && null !== f2 ? (f2.return = e2, S2 = f2) : $g(a5);
      }
    }
    function $g(a5) {
      for (; null !== S2; ) {
        var b6 = S2;
        if (0 !== (b6.flags & 8772)) {
          var c2 = b6.alternate;
          try {
            if (0 !== (b6.flags & 8772)) switch (b6.tag) {
              case 0:
              case 11:
              case 15:
                zg || Gg2(5, b6);
                break;
              case 1:
                var d3 = b6.stateNode;
                if (b6.flags & 4 && !zg) if (null === c2) d3.componentDidMount();
                else {
                  var e2 = b6.elementType === b6.type ? c2.memoizedProps : ad(b6.type, c2.memoizedProps);
                  d3.componentDidUpdate(e2, c2.memoizedState, d3.__reactInternalSnapshotBeforeUpdate);
                }
                var f2 = b6.updateQueue;
                null !== f2 && wd(b6, f2, d3);
                break;
              case 3:
                var g2 = b6.updateQueue;
                if (null !== g2) {
                  c2 = null;
                  if (null !== b6.child) switch (b6.child.tag) {
                    case 5:
                      c2 = Fa(b6.child.stateNode);
                      break;
                    case 1:
                      c2 = b6.child.stateNode;
                  }
                  wd(b6, g2, c2);
                }
                break;
              case 5:
                var h2 = b6.stateNode;
                null === c2 && b6.flags & 4 && mb(h2, b6.type, b6.memoizedProps, b6);
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (p3 && null === b6.memoizedState) {
                  var k2 = b6.alternate;
                  if (null !== k2) {
                    var l2 = k2.memoizedState;
                    if (null !== l2) {
                      var m2 = l2.dehydrated;
                      null !== m2 && Ub(m2);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
                break;
              default:
                throw Error(n2(163));
            }
            zg || b6.flags & 512 && Hg(b6);
          } catch (v3) {
            T2(b6, b6.return, v3);
          }
        }
        if (b6 === a5) {
          S2 = null;
          break;
        }
        c2 = b6.sibling;
        if (null !== c2) {
          c2.return = b6.return;
          S2 = c2;
          break;
        }
        S2 = b6.return;
      }
    }
    function Wg(a5) {
      for (; null !== S2; ) {
        var b6 = S2;
        if (b6 === a5) {
          S2 = null;
          break;
        }
        var c2 = b6.sibling;
        if (null !== c2) {
          c2.return = b6.return;
          S2 = c2;
          break;
        }
        S2 = b6.return;
      }
    }
    function Zg(a5) {
      for (; null !== S2; ) {
        var b6 = S2;
        try {
          switch (b6.tag) {
            case 0:
            case 11:
            case 15:
              var c2 = b6.return;
              try {
                Gg2(4, b6);
              } catch (k2) {
                T2(b6, c2, k2);
              }
              break;
            case 1:
              var d3 = b6.stateNode;
              if ("function" === typeof d3.componentDidMount) {
                var e2 = b6.return;
                try {
                  d3.componentDidMount();
                } catch (k2) {
                  T2(b6, e2, k2);
                }
              }
              var f2 = b6.return;
              try {
                Hg(b6);
              } catch (k2) {
                T2(b6, f2, k2);
              }
              break;
            case 5:
              var g2 = b6.return;
              try {
                Hg(b6);
              } catch (k2) {
                T2(b6, g2, k2);
              }
          }
        } catch (k2) {
          T2(b6, b6.return, k2);
        }
        if (b6 === a5) {
          S2 = null;
          break;
        }
        var h2 = b6.sibling;
        if (null !== h2) {
          h2.return = b6.return;
          S2 = h2;
          break;
        }
        S2 = b6.return;
      }
    }
    var ah = 0, bh = 1, ch = 2, dh = 3, eh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
      var fh = Symbol.for;
      ah = fh("selector.component");
      bh = fh("selector.has_pseudo_class");
      ch = fh("selector.role");
      dh = fh("selector.test_id");
      eh = fh("selector.text");
    }
    function gh(a5) {
      var b6 = Wa(a5);
      if (null != b6) {
        if ("string" !== typeof b6.memoizedProps["data-testname"]) throw Error(n2(364));
        return b6;
      }
      a5 = cb(a5);
      if (null === a5) throw Error(n2(362));
      return a5.stateNode.current;
    }
    function hh(a5, b6) {
      switch (b6.$$typeof) {
        case ah:
          if (a5.type === b6.value) return true;
          break;
        case bh:
          a: {
            b6 = b6.value;
            a5 = [a5, 0];
            for (var c2 = 0; c2 < a5.length; ) {
              var d3 = a5[c2++], e2 = a5[c2++], f2 = b6[e2];
              if (5 !== d3.tag || !fb(d3)) {
                for (; null != f2 && hh(d3, f2); ) e2++, f2 = b6[e2];
                if (e2 === b6.length) {
                  b6 = true;
                  break a;
                } else for (d3 = d3.child; null !== d3; ) a5.push(d3, e2), d3 = d3.sibling;
              }
            }
            b6 = false;
          }
          return b6;
        case ch:
          if (5 === a5.tag && gb(a5.stateNode, b6.value)) return true;
          break;
        case eh:
          if (5 === a5.tag || 6 === a5.tag) {
            if (a5 = eb(a5), null !== a5 && 0 <= a5.indexOf(b6.value)) return true;
          }
          break;
        case dh:
          if (5 === a5.tag && (a5 = a5.memoizedProps["data-testname"], "string" === typeof a5 && a5.toLowerCase() === b6.value.toLowerCase())) return true;
          break;
        default:
          throw Error(n2(365));
      }
      return false;
    }
    function ih(a5) {
      switch (a5.$$typeof) {
        case ah:
          return "<" + (va(a5.value) || "Unknown") + ">";
        case bh:
          return ":has(" + (ih(a5) || "") + ")";
        case ch:
          return '[role="' + a5.value + '"]';
        case eh:
          return '"' + a5.value + '"';
        case dh:
          return '[data-testname="' + a5.value + '"]';
        default:
          throw Error(n2(365));
      }
    }
    function jh(a5, b6) {
      var c2 = [];
      a5 = [a5, 0];
      for (var d3 = 0; d3 < a5.length; ) {
        var e2 = a5[d3++], f2 = a5[d3++], g2 = b6[f2];
        if (5 !== e2.tag || !fb(e2)) {
          for (; null != g2 && hh(e2, g2); ) f2++, g2 = b6[f2];
          if (f2 === b6.length) c2.push(e2);
          else for (e2 = e2.child; null !== e2; ) a5.push(e2, f2), e2 = e2.sibling;
        }
      }
      return c2;
    }
    function kh(a5, b6) {
      if (!bb) throw Error(n2(363));
      a5 = gh(a5);
      a5 = jh(a5, b6);
      b6 = [];
      a5 = Array.from(a5);
      for (var c2 = 0; c2 < a5.length; ) {
        var d3 = a5[c2++];
        if (5 === d3.tag) fb(d3) || b6.push(d3.stateNode);
        else for (d3 = d3.child; null !== d3; ) a5.push(d3), d3 = d3.sibling;
      }
      return b6;
    }
    var lh = Math.ceil, mh = ea.ReactCurrentDispatcher, nh = ea.ReactCurrentOwner, U2 = ea.ReactCurrentBatchConfig, G2 = 0, F2 = null, W2 = null, X2 = 0, Wf = 0, eg = gc(0), Q2 = 0, oh = null, vd = 0, ph = 0, qh = 0, rh = null, Y2 = null, Vg = 0, Uf = Infinity;
    function sh() {
      Uf = E2() + 500;
    }
    var Bf = false, Cf = null, Ef = null, th = false, uh = null, vh = 0, wh = 0, xh = null, yh = -1, zh = 0;
    function H3() {
      return 0 !== (G2 & 6) ? E2() : -1 !== yh ? yh : yh = E2();
    }
    function zd(a5) {
      if (0 === (a5.mode & 1)) return 1;
      if (0 !== (G2 & 2) && 0 !== X2) return X2 & -X2;
      if (null !== Yc.transition) return 0 === zh && (a5 = tc, tc <<= 1, 0 === (tc & 4194240) && (tc = 64), zh = a5), zh;
      a5 = D2;
      return 0 !== a5 ? a5 : Ya();
    }
    function Ad(a5, b6, c2) {
      if (50 < wh) throw wh = 0, xh = null, Error(n2(185));
      var d3 = Ah(a5, b6);
      if (null === d3) return null;
      Bc(d3, b6, c2);
      if (0 === (G2 & 2) || d3 !== F2) d3 === F2 && (0 === (G2 & 2) && (ph |= b6), 4 === Q2 && Bh(d3, X2)), Z2(d3, c2), 1 === b6 && 0 === G2 && 0 === (a5.mode & 1) && (sh(), Tc && Xc());
      return d3;
    }
    function Ah(a5, b6) {
      a5.lanes |= b6;
      var c2 = a5.alternate;
      null !== c2 && (c2.lanes |= b6);
      c2 = a5;
      for (a5 = a5.return; null !== a5; ) a5.childLanes |= b6, c2 = a5.alternate, null !== c2 && (c2.childLanes |= b6), c2 = a5, a5 = a5.return;
      return 3 === c2.tag ? c2.stateNode : null;
    }
    function Z2(a5, b6) {
      var c2 = a5.callbackNode;
      yc(a5, b6);
      var d3 = wc(a5, a5 === F2 ? X2 : 0);
      if (0 === d3) null !== c2 && Gc(c2), a5.callbackNode = null, a5.callbackPriority = 0;
      else if (b6 = d3 & -d3, a5.callbackPriority !== b6) {
        null != c2 && Gc(c2);
        if (1 === b6) 0 === a5.tag ? Wc(Ch.bind(null, a5)) : Vc(Ch.bind(null, a5)), $a ? ab(function() {
          0 === G2 && Xc();
        }) : Fc(Jc, Xc), c2 = null;
        else {
          switch (Ec(d3)) {
            case 1:
              c2 = Jc;
              break;
            case 4:
              c2 = Kc;
              break;
            case 16:
              c2 = Lc;
              break;
            case 536870912:
              c2 = Mc;
              break;
            default:
              c2 = Lc;
          }
          c2 = Dh(c2, Eh.bind(null, a5));
        }
        a5.callbackPriority = b6;
        a5.callbackNode = c2;
      }
    }
    function Eh(a5, b6) {
      yh = -1;
      zh = 0;
      if (0 !== (G2 & 6)) throw Error(n2(327));
      var c2 = a5.callbackNode;
      if (Fh() && a5.callbackNode !== c2) return null;
      var d3 = wc(a5, a5 === F2 ? X2 : 0);
      if (0 === d3) return null;
      if (0 !== (d3 & 30) || 0 !== (d3 & a5.expiredLanes) || b6) b6 = Gh(a5, d3);
      else {
        b6 = d3;
        var e2 = G2;
        G2 |= 2;
        var f2 = Hh();
        if (F2 !== a5 || X2 !== b6) sh(), Ih(a5, b6);
        do
          try {
            Jh();
            break;
          } catch (h2) {
            Kh(a5, h2);
          }
        while (1);
        fd2();
        mh.current = f2;
        G2 = e2;
        null !== W2 ? b6 = 0 : (F2 = null, X2 = 0, b6 = Q2);
      }
      if (0 !== b6) {
        2 === b6 && (e2 = zc(a5), 0 !== e2 && (d3 = e2, b6 = Lh(a5, e2)));
        if (1 === b6) throw c2 = oh, Ih(a5, 0), Bh(a5, d3), Z2(a5, E2()), c2;
        if (6 === b6) Bh(a5, d3);
        else {
          e2 = a5.current.alternate;
          if (0 === (d3 & 30) && !Mh(e2) && (b6 = Gh(a5, d3), 2 === b6 && (f2 = zc(a5), 0 !== f2 && (d3 = f2, b6 = Lh(a5, f2))), 1 === b6)) throw c2 = oh, Ih(a5, 0), Bh(a5, d3), Z2(a5, E2()), c2;
          a5.finishedWork = e2;
          a5.finishedLanes = d3;
          switch (b6) {
            case 0:
            case 1:
              throw Error(n2(345));
            case 2:
              Nh(a5, Y2);
              break;
            case 3:
              Bh(a5, d3);
              if ((d3 & 130023424) === d3 && (b6 = Vg + 500 - E2(), 10 < b6)) {
                if (0 !== wc(a5, 0)) break;
                e2 = a5.suspendedLanes;
                if ((e2 & d3) !== d3) {
                  H3();
                  a5.pingedLanes |= a5.suspendedLanes & e2;
                  break;
                }
                a5.timeoutHandle = Qa(Nh.bind(null, a5, Y2), b6);
                break;
              }
              Nh(a5, Y2);
              break;
            case 4:
              Bh(a5, d3);
              if ((d3 & 4194240) === d3) break;
              b6 = a5.eventTimes;
              for (e2 = -1; 0 < d3; ) {
                var g2 = 31 - qc(d3);
                f2 = 1 << g2;
                g2 = b6[g2];
                g2 > e2 && (e2 = g2);
                d3 &= ~f2;
              }
              d3 = e2;
              d3 = E2() - d3;
              d3 = (120 > d3 ? 120 : 480 > d3 ? 480 : 1080 > d3 ? 1080 : 1920 > d3 ? 1920 : 3e3 > d3 ? 3e3 : 4320 > d3 ? 4320 : 1960 * lh(d3 / 1960)) - d3;
              if (10 < d3) {
                a5.timeoutHandle = Qa(Nh.bind(null, a5, Y2), d3);
                break;
              }
              Nh(a5, Y2);
              break;
            case 5:
              Nh(a5, Y2);
              break;
            default:
              throw Error(n2(329));
          }
        }
      }
      Z2(a5, E2());
      return a5.callbackNode === c2 ? Eh.bind(null, a5) : null;
    }
    function Lh(a5, b6) {
      var c2 = rh;
      a5.current.memoizedState.isDehydrated && (Ih(a5, b6).flags |= 256);
      a5 = Gh(a5, b6);
      2 !== a5 && (b6 = Y2, Y2 = c2, null !== b6 && Sf(b6));
      return a5;
    }
    function Sf(a5) {
      null === Y2 ? Y2 = a5 : Y2.push.apply(Y2, a5);
    }
    function Mh(a5) {
      for (var b6 = a5; ; ) {
        if (b6.flags & 16384) {
          var c2 = b6.updateQueue;
          if (null !== c2 && (c2 = c2.stores, null !== c2)) for (var d3 = 0; d3 < c2.length; d3++) {
            var e2 = c2[d3], f2 = e2.getSnapshot;
            e2 = e2.value;
            try {
              if (!Rc(f2(), e2)) return false;
            } catch (g2) {
              return false;
            }
          }
        }
        c2 = b6.child;
        if (b6.subtreeFlags & 16384 && null !== c2) c2.return = b6, b6 = c2;
        else {
          if (b6 === a5) break;
          for (; null === b6.sibling; ) {
            if (null === b6.return || b6.return === a5) return true;
            b6 = b6.return;
          }
          b6.sibling.return = b6.return;
          b6 = b6.sibling;
        }
      }
      return true;
    }
    function Bh(a5, b6) {
      b6 &= ~qh;
      b6 &= ~ph;
      a5.suspendedLanes |= b6;
      a5.pingedLanes &= ~b6;
      for (a5 = a5.expirationTimes; 0 < b6; ) {
        var c2 = 31 - qc(b6), d3 = 1 << c2;
        a5[c2] = -1;
        b6 &= ~d3;
      }
    }
    function Ch(a5) {
      if (0 !== (G2 & 6)) throw Error(n2(327));
      Fh();
      var b6 = wc(a5, 0);
      if (0 === (b6 & 1)) return Z2(a5, E2()), null;
      var c2 = Gh(a5, b6);
      if (0 !== a5.tag && 2 === c2) {
        var d3 = zc(a5);
        0 !== d3 && (b6 = d3, c2 = Lh(a5, d3));
      }
      if (1 === c2) throw c2 = oh, Ih(a5, 0), Bh(a5, b6), Z2(a5, E2()), c2;
      if (6 === c2) throw Error(n2(345));
      a5.finishedWork = a5.current.alternate;
      a5.finishedLanes = b6;
      Nh(a5, Y2);
      Z2(a5, E2());
      return null;
    }
    function Oh(a5) {
      null !== uh && 0 === uh.tag && 0 === (G2 & 6) && Fh();
      var b6 = G2;
      G2 |= 1;
      var c2 = U2.transition, d3 = D2;
      try {
        if (U2.transition = null, D2 = 1, a5) return a5();
      } finally {
        D2 = d3, U2.transition = c2, G2 = b6, 0 === (G2 & 6) && Xc();
      }
    }
    function Vf() {
      Wf = eg.current;
      x3(eg);
    }
    function Ih(a5, b6) {
      a5.finishedWork = null;
      a5.finishedLanes = 0;
      var c2 = a5.timeoutHandle;
      c2 !== Sa && (a5.timeoutHandle = Sa, Ra(c2));
      if (null !== W2) for (c2 = W2.return; null !== c2; ) {
        var d3 = c2;
        Sd(d3);
        switch (d3.tag) {
          case 1:
            d3 = d3.type.childContextTypes;
            null !== d3 && void 0 !== d3 && kc();
            break;
          case 3:
            we();
            x3(B2);
            x3(A2);
            Be();
            break;
          case 5:
            ye(d3);
            break;
          case 4:
            we();
            break;
          case 13:
            x3(J2);
            break;
          case 19:
            x3(J2);
            break;
          case 10:
            hd(d3.type._context);
            break;
          case 22:
          case 23:
            Vf();
        }
        c2 = c2.return;
      }
      F2 = a5;
      W2 = a5 = je(a5.current, null);
      X2 = Wf = b6;
      Q2 = 0;
      oh = null;
      qh = ph = vd = 0;
      Y2 = rh = null;
      if (null !== md) {
        for (b6 = 0; b6 < md.length; b6++) if (c2 = md[b6], d3 = c2.interleaved, null !== d3) {
          c2.interleaved = null;
          var e2 = d3.next, f2 = c2.pending;
          if (null !== f2) {
            var g2 = f2.next;
            f2.next = e2;
            d3.next = g2;
          }
          c2.pending = d3;
        }
        md = null;
      }
      return a5;
    }
    function Kh(a5, b6) {
      do {
        var c2 = W2;
        try {
          fd2();
          Ce.current = Oe;
          if (Fe) {
            for (var d3 = K2.memoizedState; null !== d3; ) {
              var e2 = d3.queue;
              null !== e2 && (e2.pending = null);
              d3 = d3.next;
            }
            Fe = false;
          }
          Ee = 0;
          M2 = L2 = K2 = null;
          Ge = false;
          He = 0;
          nh.current = null;
          if (null === c2 || null === c2.return) {
            Q2 = 1;
            oh = b6;
            W2 = null;
            break;
          }
          a: {
            var f2 = a5, g2 = c2.return, h2 = c2, k2 = b6;
            b6 = X2;
            h2.flags |= 32768;
            if (null !== k2 && "object" === typeof k2 && "function" === typeof k2.then) {
              var l2 = k2, m2 = h2, v3 = m2.tag;
              if (0 === (m2.mode & 1) && (0 === v3 || 11 === v3 || 15 === v3)) {
                var r3 = m2.alternate;
                r3 ? (m2.updateQueue = r3.updateQueue, m2.memoizedState = r3.memoizedState, m2.lanes = r3.lanes) : (m2.updateQueue = null, m2.memoizedState = null);
              }
              var z2 = Hf(g2);
              if (null !== z2) {
                z2.flags &= -257;
                If(z2, g2, h2, f2, b6);
                z2.mode & 1 && Ff(f2, l2, b6);
                b6 = z2;
                k2 = l2;
                var q2 = b6.updateQueue;
                if (null === q2) {
                  var N2 = /* @__PURE__ */ new Set();
                  N2.add(k2);
                  b6.updateQueue = N2;
                } else q2.add(k2);
                break a;
              } else {
                if (0 === (b6 & 1)) {
                  Ff(f2, l2, b6);
                  Tf();
                  break a;
                }
                k2 = Error(n2(426));
              }
            } else if (I2 && h2.mode & 1) {
              var da = Hf(g2);
              if (null !== da) {
                0 === (da.flags & 65536) && (da.flags |= 256);
                If(da, g2, h2, f2, b6);
                ee(k2);
                break a;
              }
            }
            f2 = k2;
            4 !== Q2 && (Q2 = 2);
            null === rh ? rh = [f2] : rh.push(f2);
            k2 = xf(k2, h2);
            h2 = g2;
            do {
              switch (h2.tag) {
                case 3:
                  h2.flags |= 65536;
                  b6 &= -b6;
                  h2.lanes |= b6;
                  var t2 = Af(h2, k2, b6);
                  td2(h2, t2);
                  break a;
                case 1:
                  f2 = k2;
                  var w2 = h2.type, u2 = h2.stateNode;
                  if (0 === (h2.flags & 128) && ("function" === typeof w2.getDerivedStateFromError || null !== u2 && "function" === typeof u2.componentDidCatch && (null === Ef || !Ef.has(u2)))) {
                    h2.flags |= 65536;
                    b6 &= -b6;
                    h2.lanes |= b6;
                    var V3 = Df(h2, f2, b6);
                    td2(h2, V3);
                    break a;
                  }
              }
              h2 = h2.return;
            } while (null !== h2);
          }
          Ph(c2);
        } catch (wa) {
          b6 = wa;
          W2 === c2 && null !== c2 && (W2 = c2 = c2.return);
          continue;
        }
        break;
      } while (1);
    }
    function Hh() {
      var a5 = mh.current;
      mh.current = Oe;
      return null === a5 ? Oe : a5;
    }
    function Tf() {
      if (0 === Q2 || 3 === Q2 || 2 === Q2) Q2 = 4;
      null === F2 || 0 === (vd & 268435455) && 0 === (ph & 268435455) || Bh(F2, X2);
    }
    function Gh(a5, b6) {
      var c2 = G2;
      G2 |= 2;
      var d3 = Hh();
      F2 === a5 && X2 === b6 || Ih(a5, b6);
      do
        try {
          Qh();
          break;
        } catch (e2) {
          Kh(a5, e2);
        }
      while (1);
      fd2();
      G2 = c2;
      mh.current = d3;
      if (null !== W2) throw Error(n2(261));
      F2 = null;
      X2 = 0;
      return Q2;
    }
    function Qh() {
      for (; null !== W2; ) Rh(W2);
    }
    function Jh() {
      for (; null !== W2 && !Hc(); ) Rh(W2);
    }
    function Rh(a5) {
      var b6 = Sh(a5.alternate, a5, Wf);
      a5.memoizedProps = a5.pendingProps;
      null === b6 ? Ph(a5) : W2 = b6;
      nh.current = null;
    }
    function Ph(a5) {
      var b6 = a5;
      do {
        var c2 = b6.alternate;
        a5 = b6.return;
        if (0 === (b6.flags & 32768)) {
          if (c2 = Rf(c2, b6, Wf), null !== c2) {
            W2 = c2;
            return;
          }
        } else {
          c2 = xg(c2, b6);
          if (null !== c2) {
            c2.flags &= 32767;
            W2 = c2;
            return;
          }
          if (null !== a5) a5.flags |= 32768, a5.subtreeFlags = 0, a5.deletions = null;
          else {
            Q2 = 6;
            W2 = null;
            return;
          }
        }
        b6 = b6.sibling;
        if (null !== b6) {
          W2 = b6;
          return;
        }
        W2 = b6 = a5;
      } while (null !== b6);
      0 === Q2 && (Q2 = 5);
    }
    function Nh(a5, b6) {
      var c2 = D2, d3 = U2.transition;
      try {
        U2.transition = null, D2 = 1, Th(a5, b6, c2);
      } finally {
        U2.transition = d3, D2 = c2;
      }
      return null;
    }
    function Th(a5, b6, c2) {
      do
        Fh();
      while (null !== uh);
      if (0 !== (G2 & 6)) throw Error(n2(327));
      var d3 = a5.finishedWork, e2 = a5.finishedLanes;
      if (null === d3) return null;
      a5.finishedWork = null;
      a5.finishedLanes = 0;
      if (d3 === a5.current) throw Error(n2(177));
      a5.callbackNode = null;
      a5.callbackPriority = 0;
      var f2 = d3.lanes | d3.childLanes;
      Cc(a5, f2);
      a5 === F2 && (W2 = F2 = null, X2 = 0);
      0 === (d3.subtreeFlags & 2064) && 0 === (d3.flags & 2064) || th || (th = true, Dh(Lc, function() {
        Fh();
        return null;
      }));
      f2 = 0 !== (d3.flags & 15990);
      if (0 !== (d3.subtreeFlags & 15990) || f2) {
        f2 = U2.transition;
        U2.transition = null;
        var g2 = D2;
        D2 = 1;
        var h2 = G2;
        G2 |= 4;
        nh.current = null;
        Eg2(a5, d3);
        Ug2(a5, d3);
        Ja(a5.containerInfo);
        a5.current = d3;
        Xg(d3);
        Ic();
        G2 = h2;
        D2 = g2;
        U2.transition = f2;
      } else a5.current = d3;
      th && (th = false, uh = a5, vh = e2);
      f2 = a5.pendingLanes;
      0 === f2 && (Ef = null);
      Pc(d3.stateNode);
      Z2(a5, E2());
      if (null !== b6) for (c2 = a5.onRecoverableError, d3 = 0; d3 < b6.length; d3++) c2(b6[d3]);
      if (Bf) throw Bf = false, a5 = Cf, Cf = null, a5;
      0 !== (vh & 1) && 0 !== a5.tag && Fh();
      f2 = a5.pendingLanes;
      0 !== (f2 & 1) ? a5 === xh ? wh++ : (wh = 0, xh = a5) : wh = 0;
      Xc();
      return null;
    }
    function Fh() {
      if (null !== uh) {
        var a5 = Ec(vh), b6 = U2.transition, c2 = D2;
        try {
          U2.transition = null;
          D2 = 16 > a5 ? 16 : a5;
          if (null === uh) var d3 = false;
          else {
            a5 = uh;
            uh = null;
            vh = 0;
            if (0 !== (G2 & 6)) throw Error(n2(331));
            var e2 = G2;
            G2 |= 4;
            for (S2 = a5.current; null !== S2; ) {
              var f2 = S2, g2 = f2.child;
              if (0 !== (S2.flags & 16)) {
                var h2 = f2.deletions;
                if (null !== h2) {
                  for (var k2 = 0; k2 < h2.length; k2++) {
                    var l2 = h2[k2];
                    for (S2 = l2; null !== S2; ) {
                      var m2 = S2;
                      switch (m2.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Fg2(8, m2, f2);
                      }
                      var v3 = m2.child;
                      if (null !== v3) v3.return = m2, S2 = v3;
                      else for (; null !== S2; ) {
                        m2 = S2;
                        var r3 = m2.sibling, z2 = m2.return;
                        Lg(m2);
                        if (m2 === l2) {
                          S2 = null;
                          break;
                        }
                        if (null !== r3) {
                          r3.return = z2;
                          S2 = r3;
                          break;
                        }
                        S2 = z2;
                      }
                    }
                  }
                  var q2 = f2.alternate;
                  if (null !== q2) {
                    var N2 = q2.child;
                    if (null !== N2) {
                      q2.child = null;
                      do {
                        var da = N2.sibling;
                        N2.sibling = null;
                        N2 = da;
                      } while (null !== N2);
                    }
                  }
                  S2 = f2;
                }
              }
              if (0 !== (f2.subtreeFlags & 2064) && null !== g2) g2.return = f2, S2 = g2;
              else b: for (; null !== S2; ) {
                f2 = S2;
                if (0 !== (f2.flags & 2048)) switch (f2.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Fg2(9, f2, f2.return);
                }
                var t2 = f2.sibling;
                if (null !== t2) {
                  t2.return = f2.return;
                  S2 = t2;
                  break b;
                }
                S2 = f2.return;
              }
            }
            var w2 = a5.current;
            for (S2 = w2; null !== S2; ) {
              g2 = S2;
              var u2 = g2.child;
              if (0 !== (g2.subtreeFlags & 2064) && null !== u2) u2.return = g2, S2 = u2;
              else b: for (g2 = w2; null !== S2; ) {
                h2 = S2;
                if (0 !== (h2.flags & 2048)) try {
                  switch (h2.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Gg2(9, h2);
                  }
                } catch (wa) {
                  T2(h2, h2.return, wa);
                }
                if (h2 === g2) {
                  S2 = null;
                  break b;
                }
                var V3 = h2.sibling;
                if (null !== V3) {
                  V3.return = h2.return;
                  S2 = V3;
                  break b;
                }
                S2 = h2.return;
              }
            }
            G2 = e2;
            Xc();
            if (Oc && "function" === typeof Oc.onPostCommitFiberRoot) try {
              Oc.onPostCommitFiberRoot(Nc, a5);
            } catch (wa) {
            }
            d3 = true;
          }
          return d3;
        } finally {
          D2 = c2, U2.transition = b6;
        }
      }
      return false;
    }
    function Uh(a5, b6, c2) {
      b6 = xf(c2, b6);
      b6 = Af(a5, b6, 1);
      rd(a5, b6);
      b6 = H3();
      a5 = Ah(a5, 1);
      null !== a5 && (Bc(a5, 1, b6), Z2(a5, b6));
    }
    function T2(a5, b6, c2) {
      if (3 === a5.tag) Uh(a5, a5, c2);
      else for (; null !== b6; ) {
        if (3 === b6.tag) {
          Uh(b6, a5, c2);
          break;
        } else if (1 === b6.tag) {
          var d3 = b6.stateNode;
          if ("function" === typeof b6.type.getDerivedStateFromError || "function" === typeof d3.componentDidCatch && (null === Ef || !Ef.has(d3))) {
            a5 = xf(c2, a5);
            a5 = Df(b6, a5, 1);
            rd(b6, a5);
            a5 = H3();
            b6 = Ah(b6, 1);
            null !== b6 && (Bc(b6, 1, a5), Z2(b6, a5));
            break;
          }
        }
        b6 = b6.return;
      }
    }
    function Gf(a5, b6, c2) {
      var d3 = a5.pingCache;
      null !== d3 && d3.delete(b6);
      b6 = H3();
      a5.pingedLanes |= a5.suspendedLanes & c2;
      F2 === a5 && (X2 & c2) === c2 && (4 === Q2 || 3 === Q2 && (X2 & 130023424) === X2 && 500 > E2() - Vg ? Ih(a5, 0) : qh |= c2);
      Z2(a5, b6);
    }
    function Vh(a5, b6) {
      0 === b6 && (0 === (a5.mode & 1) ? b6 = 1 : (b6 = uc, uc <<= 1, 0 === (uc & 130023424) && (uc = 4194304)));
      var c2 = H3();
      a5 = Ah(a5, b6);
      null !== a5 && (Bc(a5, b6, c2), Z2(a5, c2));
    }
    function qg2(a5) {
      var b6 = a5.memoizedState, c2 = 0;
      null !== b6 && (c2 = b6.retryLane);
      Vh(a5, c2);
    }
    function Tg2(a5, b6) {
      var c2 = 0;
      switch (a5.tag) {
        case 13:
          var d3 = a5.stateNode;
          var e2 = a5.memoizedState;
          null !== e2 && (c2 = e2.retryLane);
          break;
        case 19:
          d3 = a5.stateNode;
          break;
        default:
          throw Error(n2(314));
      }
      null !== d3 && d3.delete(b6);
      Vh(a5, c2);
    }
    var Sh;
    Sh = function(a5, b6, c2) {
      if (null !== a5) if (a5.memoizedProps !== b6.pendingProps || B2.current) kd = true;
      else {
        if (0 === (a5.lanes & c2) && 0 === (b6.flags & 128)) return kd = false, wg2(a5, b6, c2);
        kd = 0 !== (a5.flags & 131072) ? true : false;
      }
      else kd = false, I2 && 0 !== (b6.flags & 1048576) && Qd(b6, Jd, b6.index);
      b6.lanes = 0;
      switch (b6.tag) {
        case 2:
          var d3 = b6.type;
          null !== a5 && (a5.alternate = null, b6.alternate = null, b6.flags |= 2);
          a5 = b6.pendingProps;
          var e2 = jc(b6, A2.current);
          jd(b6, c2);
          e2 = Ke(null, b6, d3, a5, e2, c2);
          var f2 = Pe();
          b6.flags |= 1;
          "object" === typeof e2 && null !== e2 && "function" === typeof e2.render && void 0 === e2.$$typeof ? (b6.tag = 1, b6.memoizedState = null, b6.updateQueue = null, C2(d3) ? (f2 = true, nc(b6)) : f2 = false, b6.memoizedState = null !== e2.state && void 0 !== e2.state ? e2.state : null, od(b6), e2.updater = Bd, b6.stateNode = e2, e2._reactInternals = b6, Fd(b6, d3, a5, c2), b6 = hg2(null, b6, d3, true, f2, c2)) : (b6.tag = 0, I2 && f2 && Rd(b6), R2(null, b6, e2, c2), b6 = b6.child);
          return b6;
        case 16:
          d3 = b6.elementType;
          a: {
            null !== a5 && (a5.alternate = null, b6.alternate = null, b6.flags |= 2);
            a5 = b6.pendingProps;
            e2 = d3._init;
            d3 = e2(d3._payload);
            b6.type = d3;
            e2 = b6.tag = Wh(d3);
            a5 = ad(d3, a5);
            switch (e2) {
              case 0:
                b6 = cg2(null, b6, d3, a5, c2);
                break a;
              case 1:
                b6 = gg2(
                  null,
                  b6,
                  d3,
                  a5,
                  c2
                );
                break a;
              case 11:
                b6 = Yf(null, b6, d3, a5, c2);
                break a;
              case 14:
                b6 = $f(null, b6, d3, ad(d3.type, a5), c2);
                break a;
            }
            throw Error(n2(306, d3, ""));
          }
          return b6;
        case 0:
          return d3 = b6.type, e2 = b6.pendingProps, e2 = b6.elementType === d3 ? e2 : ad(d3, e2), cg2(a5, b6, d3, e2, c2);
        case 1:
          return d3 = b6.type, e2 = b6.pendingProps, e2 = b6.elementType === d3 ? e2 : ad(d3, e2), gg2(a5, b6, d3, e2, c2);
        case 3:
          a: {
            ig2(b6);
            if (null === a5) throw Error(n2(387));
            d3 = b6.pendingProps;
            f2 = b6.memoizedState;
            e2 = f2.element;
            pd(a5, b6);
            ud(b6, d3, null, c2);
            var g2 = b6.memoizedState;
            d3 = g2.element;
            if (p3 && f2.isDehydrated) if (f2 = {
              element: d3,
              isDehydrated: false,
              cache: g2.cache,
              transitions: g2.transitions
            }, b6.updateQueue.baseState = f2, b6.memoizedState = f2, b6.flags & 256) {
              e2 = Error(n2(423));
              b6 = jg(a5, b6, d3, c2, e2);
              break a;
            } else if (d3 !== e2) {
              e2 = Error(n2(424));
              b6 = jg(a5, b6, d3, c2, e2);
              break a;
            } else for (p3 && (Ud = Nb(b6.stateNode.containerInfo), Td = b6, I2 = true, Wd = null, Vd = false), c2 = pe(b6, null, d3, c2), b6.child = c2; c2; ) c2.flags = c2.flags & -3 | 4096, c2 = c2.sibling;
            else {
              de();
              if (d3 === e2) {
                b6 = Zf(a5, b6, c2);
                break a;
              }
              R2(a5, b6, d3, c2);
            }
            b6 = b6.child;
          }
          return b6;
        case 5:
          return xe(b6), null === a5 && ae(b6), d3 = b6.type, e2 = b6.pendingProps, f2 = null !== a5 ? a5.memoizedProps : null, g2 = e2.children, Oa(d3, e2) ? g2 = null : null !== f2 && Oa(d3, f2) && (b6.flags |= 32), fg(a5, b6), R2(a5, b6, g2, c2), b6.child;
        case 6:
          return null === a5 && ae(b6), null;
        case 13:
          return mg(a5, b6, c2);
        case 4:
          return ve(b6, b6.stateNode.containerInfo), d3 = b6.pendingProps, null === a5 ? b6.child = oe(b6, null, d3, c2) : R2(a5, b6, d3, c2), b6.child;
        case 11:
          return d3 = b6.type, e2 = b6.pendingProps, e2 = b6.elementType === d3 ? e2 : ad(d3, e2), Yf(a5, b6, d3, e2, c2);
        case 7:
          return R2(a5, b6, b6.pendingProps, c2), b6.child;
        case 8:
          return R2(a5, b6, b6.pendingProps.children, c2), b6.child;
        case 12:
          return R2(a5, b6, b6.pendingProps.children, c2), b6.child;
        case 10:
          a: {
            d3 = b6.type._context;
            e2 = b6.pendingProps;
            f2 = b6.memoizedProps;
            g2 = e2.value;
            gd(b6, d3, g2);
            if (null !== f2) if (Rc(f2.value, g2)) {
              if (f2.children === e2.children && !B2.current) {
                b6 = Zf(a5, b6, c2);
                break a;
              }
            } else for (f2 = b6.child, null !== f2 && (f2.return = b6); null !== f2; ) {
              var h2 = f2.dependencies;
              if (null !== h2) {
                g2 = f2.child;
                for (var k2 = h2.firstContext; null !== k2; ) {
                  if (k2.context === d3) {
                    if (1 === f2.tag) {
                      k2 = qd(-1, c2 & -c2);
                      k2.tag = 2;
                      var l2 = f2.updateQueue;
                      if (null !== l2) {
                        l2 = l2.shared;
                        var m2 = l2.pending;
                        null === m2 ? k2.next = k2 : (k2.next = m2.next, m2.next = k2);
                        l2.pending = k2;
                      }
                    }
                    f2.lanes |= c2;
                    k2 = f2.alternate;
                    null !== k2 && (k2.lanes |= c2);
                    id(f2.return, c2, b6);
                    h2.lanes |= c2;
                    break;
                  }
                  k2 = k2.next;
                }
              } else if (10 === f2.tag) g2 = f2.type === b6.type ? null : f2.child;
              else if (18 === f2.tag) {
                g2 = f2.return;
                if (null === g2) throw Error(n2(341));
                g2.lanes |= c2;
                h2 = g2.alternate;
                null !== h2 && (h2.lanes |= c2);
                id(g2, c2, b6);
                g2 = f2.sibling;
              } else g2 = f2.child;
              if (null !== g2) g2.return = f2;
              else for (g2 = f2; null !== g2; ) {
                if (g2 === b6) {
                  g2 = null;
                  break;
                }
                f2 = g2.sibling;
                if (null !== f2) {
                  f2.return = g2.return;
                  g2 = f2;
                  break;
                }
                g2 = g2.return;
              }
              f2 = g2;
            }
            R2(a5, b6, e2.children, c2);
            b6 = b6.child;
          }
          return b6;
        case 9:
          return e2 = b6.type, d3 = b6.pendingProps.children, jd(b6, c2), e2 = ld(e2), d3 = d3(e2), b6.flags |= 1, R2(a5, b6, d3, c2), b6.child;
        case 14:
          return d3 = b6.type, e2 = ad(d3, b6.pendingProps), e2 = ad(d3.type, e2), $f(a5, b6, d3, e2, c2);
        case 15:
          return bg(a5, b6, b6.type, b6.pendingProps, c2);
        case 17:
          return d3 = b6.type, e2 = b6.pendingProps, e2 = b6.elementType === d3 ? e2 : ad(d3, e2), null !== a5 && (a5.alternate = null, b6.alternate = null, b6.flags |= 2), b6.tag = 1, C2(d3) ? (a5 = true, nc(b6)) : a5 = false, jd(b6, c2), Dd(b6, d3, e2), Fd(b6, d3, e2, c2), hg2(null, b6, d3, true, a5, c2);
        case 19:
          return vg(a5, b6, c2);
        case 22:
          return dg2(a5, b6, c2);
      }
      throw Error(n2(156, b6.tag));
    };
    function Dh(a5, b6) {
      return Fc(a5, b6);
    }
    function Xh(a5, b6, c2, d3) {
      this.tag = a5;
      this.key = c2;
      this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
      this.index = 0;
      this.ref = null;
      this.pendingProps = b6;
      this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
      this.mode = d3;
      this.subtreeFlags = this.flags = 0;
      this.deletions = null;
      this.childLanes = this.lanes = 0;
      this.alternate = null;
    }
    function Yd(a5, b6, c2, d3) {
      return new Xh(a5, b6, c2, d3);
    }
    function ag2(a5) {
      a5 = a5.prototype;
      return !(!a5 || !a5.isReactComponent);
    }
    function Wh(a5) {
      if ("function" === typeof a5) return ag2(a5) ? 1 : 0;
      if (void 0 !== a5 && null !== a5) {
        a5 = a5.$$typeof;
        if (a5 === na) return 11;
        if (a5 === qa) return 14;
      }
      return 2;
    }
    function je(a5, b6) {
      var c2 = a5.alternate;
      null === c2 ? (c2 = Yd(a5.tag, b6, a5.key, a5.mode), c2.elementType = a5.elementType, c2.type = a5.type, c2.stateNode = a5.stateNode, c2.alternate = a5, a5.alternate = c2) : (c2.pendingProps = b6, c2.type = a5.type, c2.flags = 0, c2.subtreeFlags = 0, c2.deletions = null);
      c2.flags = a5.flags & 14680064;
      c2.childLanes = a5.childLanes;
      c2.lanes = a5.lanes;
      c2.child = a5.child;
      c2.memoizedProps = a5.memoizedProps;
      c2.memoizedState = a5.memoizedState;
      c2.updateQueue = a5.updateQueue;
      b6 = a5.dependencies;
      c2.dependencies = null === b6 ? null : { lanes: b6.lanes, firstContext: b6.firstContext };
      c2.sibling = a5.sibling;
      c2.index = a5.index;
      c2.ref = a5.ref;
      return c2;
    }
    function le(a5, b6, c2, d3, e2, f2) {
      var g2 = 2;
      d3 = a5;
      if ("function" === typeof a5) ag2(a5) && (g2 = 1);
      else if ("string" === typeof a5) g2 = 5;
      else a: switch (a5) {
        case ia:
          return ne(c2.children, e2, f2, b6);
        case ja:
          g2 = 8;
          e2 |= 8;
          break;
        case ka:
          return a5 = Yd(12, c2, b6, e2 | 2), a5.elementType = ka, a5.lanes = f2, a5;
        case oa:
          return a5 = Yd(13, c2, b6, e2), a5.elementType = oa, a5.lanes = f2, a5;
        case pa:
          return a5 = Yd(19, c2, b6, e2), a5.elementType = pa, a5.lanes = f2, a5;
        case sa:
          return ng2(c2, e2, f2, b6);
        default:
          if ("object" === typeof a5 && null !== a5) switch (a5.$$typeof) {
            case la:
              g2 = 10;
              break a;
            case ma:
              g2 = 9;
              break a;
            case na:
              g2 = 11;
              break a;
            case qa:
              g2 = 14;
              break a;
            case ra:
              g2 = 16;
              d3 = null;
              break a;
          }
          throw Error(n2(130, null == a5 ? a5 : typeof a5, ""));
      }
      b6 = Yd(g2, c2, b6, e2);
      b6.elementType = a5;
      b6.type = d3;
      b6.lanes = f2;
      return b6;
    }
    function ne(a5, b6, c2, d3) {
      a5 = Yd(7, a5, d3, b6);
      a5.lanes = c2;
      return a5;
    }
    function ng2(a5, b6, c2, d3) {
      a5 = Yd(22, a5, d3, b6);
      a5.elementType = sa;
      a5.lanes = c2;
      a5.stateNode = {};
      return a5;
    }
    function ke(a5, b6, c2) {
      a5 = Yd(6, a5, null, b6);
      a5.lanes = c2;
      return a5;
    }
    function me(a5, b6, c2) {
      b6 = Yd(4, null !== a5.children ? a5.children : [], a5.key, b6);
      b6.lanes = c2;
      b6.stateNode = { containerInfo: a5.containerInfo, pendingChildren: null, implementation: a5.implementation };
      return b6;
    }
    function Yh(a5, b6, c2, d3, e2) {
      this.tag = b6;
      this.containerInfo = a5;
      this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
      this.timeoutHandle = Sa;
      this.callbackNode = this.pendingContext = this.context = null;
      this.callbackPriority = 0;
      this.eventTimes = Ac(0);
      this.expirationTimes = Ac(-1);
      this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
      this.entanglements = Ac(0);
      this.identifierPrefix = d3;
      this.onRecoverableError = e2;
      p3 && (this.mutableSourceEagerHydrationData = null);
    }
    function Zh(a5, b6, c2, d3, e2, f2, g2, h2, k2) {
      a5 = new Yh(a5, b6, c2, h2, k2);
      1 === b6 ? (b6 = 1, true === f2 && (b6 |= 8)) : b6 = 0;
      f2 = Yd(3, null, null, b6);
      a5.current = f2;
      f2.stateNode = a5;
      f2.memoizedState = { element: d3, isDehydrated: c2, cache: null, transitions: null };
      od(f2);
      return a5;
    }
    function $h(a5) {
      if (!a5) return hc;
      a5 = a5._reactInternals;
      a: {
        if (ya(a5) !== a5 || 1 !== a5.tag) throw Error(n2(170));
        var b6 = a5;
        do {
          switch (b6.tag) {
            case 3:
              b6 = b6.stateNode.context;
              break a;
            case 1:
              if (C2(b6.type)) {
                b6 = b6.stateNode.__reactInternalMemoizedMergedChildContext;
                break a;
              }
          }
          b6 = b6.return;
        } while (null !== b6);
        throw Error(n2(171));
      }
      if (1 === a5.tag) {
        var c2 = a5.type;
        if (C2(c2)) return mc(a5, c2, b6);
      }
      return b6;
    }
    function ai(a5) {
      var b6 = a5._reactInternals;
      if (void 0 === b6) {
        if ("function" === typeof a5.render) throw Error(n2(188));
        a5 = Object.keys(a5).join(",");
        throw Error(n2(268, a5));
      }
      a5 = Ba(b6);
      return null === a5 ? null : a5.stateNode;
    }
    function bi(a5, b6) {
      a5 = a5.memoizedState;
      if (null !== a5 && null !== a5.dehydrated) {
        var c2 = a5.retryLane;
        a5.retryLane = 0 !== c2 && c2 < b6 ? c2 : b6;
      }
    }
    function ci(a5, b6) {
      bi(a5, b6);
      (a5 = a5.alternate) && bi(a5, b6);
    }
    function di(a5) {
      a5 = Ba(a5);
      return null === a5 ? null : a5.stateNode;
    }
    function ei() {
      return null;
    }
    exports$1.attemptContinuousHydration = function(a5) {
      if (13 === a5.tag) {
        var b6 = H3();
        Ad(a5, 134217728, b6);
        ci(a5, 134217728);
      }
    };
    exports$1.attemptHydrationAtCurrentPriority = function(a5) {
      if (13 === a5.tag) {
        var b6 = H3(), c2 = zd(a5);
        Ad(a5, c2, b6);
        ci(a5, c2);
      }
    };
    exports$1.attemptSynchronousHydration = function(a5) {
      switch (a5.tag) {
        case 3:
          var b6 = a5.stateNode;
          if (b6.current.memoizedState.isDehydrated) {
            var c2 = vc(b6.pendingLanes);
            0 !== c2 && (Dc(b6, c2 | 1), Z2(b6, E2()), 0 === (G2 & 6) && (sh(), Xc()));
          }
          break;
        case 13:
          var d3 = H3();
          Oh(function() {
            return Ad(a5, 1, d3);
          });
          ci(a5, 1);
      }
    };
    exports$1.batchedUpdates = function(a5, b6) {
      var c2 = G2;
      G2 |= 1;
      try {
        return a5(b6);
      } finally {
        G2 = c2, 0 === G2 && (sh(), Tc && Xc());
      }
    };
    exports$1.createComponentSelector = function(a5) {
      return { $$typeof: ah, value: a5 };
    };
    exports$1.createContainer = function(a5, b6, c2, d3, e2, f2, g2) {
      return Zh(a5, b6, false, null, c2, d3, e2, f2, g2);
    };
    exports$1.createHasPseudoClassSelector = function(a5) {
      return { $$typeof: bh, value: a5 };
    };
    exports$1.createHydrationContainer = function(a5, b6, c2, d3, e2, f2, g2, h2, k2) {
      a5 = Zh(c2, d3, true, a5, e2, f2, g2, h2, k2);
      a5.context = $h(null);
      c2 = a5.current;
      d3 = H3();
      e2 = zd(c2);
      f2 = qd(d3, e2);
      f2.callback = void 0 !== b6 && null !== b6 ? b6 : null;
      rd(c2, f2);
      a5.current.lanes = e2;
      Bc(a5, e2, d3);
      Z2(a5, d3);
      return a5;
    };
    exports$1.createPortal = function(a5, b6, c2) {
      var d3 = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
      return { $$typeof: ha, key: null == d3 ? null : "" + d3, children: a5, containerInfo: b6, implementation: c2 };
    };
    exports$1.createRoleSelector = function(a5) {
      return { $$typeof: ch, value: a5 };
    };
    exports$1.createTestNameSelector = function(a5) {
      return { $$typeof: dh, value: a5 };
    };
    exports$1.createTextSelector = function(a5) {
      return { $$typeof: eh, value: a5 };
    };
    exports$1.deferredUpdates = function(a5) {
      var b6 = D2, c2 = U2.transition;
      try {
        return U2.transition = null, D2 = 16, a5();
      } finally {
        D2 = b6, U2.transition = c2;
      }
    };
    exports$1.discreteUpdates = function(a5, b6, c2, d3, e2) {
      var f2 = D2, g2 = U2.transition;
      try {
        return U2.transition = null, D2 = 1, a5(b6, c2, d3, e2);
      } finally {
        D2 = f2, U2.transition = g2, 0 === G2 && sh();
      }
    };
    exports$1.findAllNodes = kh;
    exports$1.findBoundingRects = function(a5, b6) {
      if (!bb) throw Error(n2(363));
      b6 = kh(a5, b6);
      a5 = [];
      for (var c2 = 0; c2 < b6.length; c2++) a5.push(db(b6[c2]));
      for (b6 = a5.length - 1; 0 < b6; b6--) {
        c2 = a5[b6];
        for (var d3 = c2.x, e2 = d3 + c2.width, f2 = c2.y, g2 = f2 + c2.height, h2 = b6 - 1; 0 <= h2; h2--) if (b6 !== h2) {
          var k2 = a5[h2], l2 = k2.x, m2 = l2 + k2.width, v3 = k2.y, r3 = v3 + k2.height;
          if (d3 >= l2 && f2 >= v3 && e2 <= m2 && g2 <= r3) {
            a5.splice(b6, 1);
            break;
          } else if (!(d3 !== l2 || c2.width !== k2.width || r3 < f2 || v3 > g2)) {
            v3 > f2 && (k2.height += v3 - f2, k2.y = f2);
            r3 < g2 && (k2.height = g2 - v3);
            a5.splice(b6, 1);
            break;
          } else if (!(f2 !== v3 || c2.height !== k2.height || m2 < d3 || l2 > e2)) {
            l2 > d3 && (k2.width += l2 - d3, k2.x = d3);
            m2 < e2 && (k2.width = e2 - l2);
            a5.splice(b6, 1);
            break;
          }
        }
      }
      return a5;
    };
    exports$1.findHostInstance = ai;
    exports$1.findHostInstanceWithNoPortals = function(a5) {
      a5 = Aa(a5);
      a5 = null !== a5 ? Da(a5) : null;
      return null === a5 ? null : a5.stateNode;
    };
    exports$1.findHostInstanceWithWarning = function(a5) {
      return ai(a5);
    };
    exports$1.flushControlled = function(a5) {
      var b6 = G2;
      G2 |= 1;
      var c2 = U2.transition, d3 = D2;
      try {
        U2.transition = null, D2 = 1, a5();
      } finally {
        D2 = d3, U2.transition = c2, G2 = b6, 0 === G2 && (sh(), Xc());
      }
    };
    exports$1.flushPassiveEffects = Fh;
    exports$1.flushSync = Oh;
    exports$1.focusWithin = function(a5, b6) {
      if (!bb) throw Error(n2(363));
      a5 = gh(a5);
      b6 = jh(a5, b6);
      b6 = Array.from(b6);
      for (a5 = 0; a5 < b6.length; ) {
        var c2 = b6[a5++];
        if (!fb(c2)) {
          if (5 === c2.tag && hb(c2.stateNode)) return true;
          for (c2 = c2.child; null !== c2; ) b6.push(c2), c2 = c2.sibling;
        }
      }
      return false;
    };
    exports$1.getCurrentUpdatePriority = function() {
      return D2;
    };
    exports$1.getFindAllNodesFailureDescription = function(a5, b6) {
      if (!bb) throw Error(n2(363));
      var c2 = 0, d3 = [];
      a5 = [gh(a5), 0];
      for (var e2 = 0; e2 < a5.length; ) {
        var f2 = a5[e2++], g2 = a5[e2++], h2 = b6[g2];
        if (5 !== f2.tag || !fb(f2)) {
          if (hh(f2, h2) && (d3.push(ih(h2)), g2++, g2 > c2 && (c2 = g2)), g2 < b6.length) for (f2 = f2.child; null !== f2; ) a5.push(f2, g2), f2 = f2.sibling;
        }
      }
      if (c2 < b6.length) {
        for (a5 = []; c2 < b6.length; c2++) a5.push(ih(b6[c2]));
        return "findAllNodes was able to match part of the selector:\n  " + (d3.join(" > ") + "\n\nNo matching component was found for:\n  ") + a5.join(" > ");
      }
      return null;
    };
    exports$1.getPublicRootInstance = function(a5) {
      a5 = a5.current;
      if (!a5.child) return null;
      switch (a5.child.tag) {
        case 5:
          return Fa(a5.child.stateNode);
        default:
          return a5.child.stateNode;
      }
    };
    exports$1.injectIntoDevTools = function(a5) {
      a5 = { bundleType: a5.bundleType, version: a5.version, rendererPackageName: a5.rendererPackageName, rendererConfig: a5.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ea.ReactCurrentDispatcher, findHostInstanceByFiber: di, findFiberByHostInstance: a5.findFiberByHostInstance || ei, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.0.0-fc46dba67-20220329" };
      if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a5 = false;
      else {
        var b6 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (b6.isDisabled || !b6.supportsFiber) a5 = true;
        else {
          try {
            Nc = b6.inject(a5), Oc = b6;
          } catch (c2) {
          }
          a5 = b6.checkDCE ? true : false;
        }
      }
      return a5;
    };
    exports$1.isAlreadyRendering = function() {
      return false;
    };
    exports$1.observeVisibleRects = function(a5, b6, c2, d3) {
      if (!bb) throw Error(n2(363));
      a5 = kh(a5, b6);
      var e2 = ib(a5, c2, d3).disconnect;
      return { disconnect: function() {
        e2();
      } };
    };
    exports$1.registerMutableSourceForHydration = function(a5, b6) {
      var c2 = b6._getVersion;
      c2 = c2(b6._source);
      null == a5.mutableSourceEagerHydrationData ? a5.mutableSourceEagerHydrationData = [b6, c2] : a5.mutableSourceEagerHydrationData.push(b6, c2);
    };
    exports$1.runWithPriority = function(a5, b6) {
      var c2 = D2;
      try {
        return D2 = a5, b6();
      } finally {
        D2 = c2;
      }
    };
    exports$1.shouldError = function() {
      return null;
    };
    exports$1.shouldSuspend = function() {
      return false;
    };
    exports$1.updateContainer = function(a5, b6, c2, d3) {
      var e2 = b6.current, f2 = H3(), g2 = zd(e2);
      c2 = $h(c2);
      null === b6.context ? b6.context = c2 : b6.pendingContext = c2;
      b6 = qd(f2, g2);
      b6.payload = { element: a5 };
      d3 = void 0 === d3 ? null : d3;
      null !== d3 && (b6.callback = d3);
      rd(e2, b6);
      a5 = Ad(e2, g2, f2);
      null !== a5 && sd(a5, e2, g2);
      return g2;
    };
    return exports$1;
  };
  return reactReconciler_production_min;
}
var hasRequiredReactReconciler;
function requireReactReconciler() {
  if (hasRequiredReactReconciler) return reactReconciler.exports;
  hasRequiredReactReconciler = 1;
  {
    reactReconciler.exports = requireReactReconciler_production_min();
  }
  return reactReconciler.exports;
}
var reactReconcilerExports = requireReactReconciler();
const Reconciler = /* @__PURE__ */ getDefaultExportFromCjs(reactReconcilerExports);
var schedulerExports = requireScheduler();
const catalogue = {};
const extend = (objects) => void Object.assign(catalogue, objects);
function createRenderer(_roots, _getEventPriority) {
  function createInstance(type, {
    args = [],
    attach: attach2,
    ...props
  }, root2) {
    let name = `${type[0].toUpperCase()}${type.slice(1)}`;
    let instance;
    if (type === "primitive") {
      if (props.object === void 0) throw new Error("R3F: Primitives without 'object' are invalid!");
      const object = props.object;
      instance = prepare(object, {
        type,
        root: root2,
        attach: attach2,
        primitive: true
      });
    } else {
      const target = catalogue[name];
      if (!target) {
        throw new Error(`R3F: ${name} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
      }
      if (!Array.isArray(args)) throw new Error("R3F: The args prop must be an array!");
      instance = prepare(new target(...args), {
        type,
        root: root2,
        attach: attach2,
        // Save args in case we need to reconstruct later for HMR
        memoizedProps: {
          args
        }
      });
    }
    if (instance.__r3f.attach === void 0) {
      if (instance.isBufferGeometry) instance.__r3f.attach = "geometry";
      else if (instance.isMaterial) instance.__r3f.attach = "material";
    }
    if (name !== "inject") applyProps$1(instance, props);
    return instance;
  }
  function appendChild(parentInstance, child) {
    let added = false;
    if (child) {
      var _child$__r3f, _parentInstance$__r3f;
      if ((_child$__r3f = child.__r3f) != null && _child$__r3f.attach) {
        attach(parentInstance, child, child.__r3f.attach);
      } else if (child.isObject3D && parentInstance.isObject3D) {
        parentInstance.add(child);
        added = true;
      }
      if (!added) (_parentInstance$__r3f = parentInstance.__r3f) == null ? void 0 : _parentInstance$__r3f.objects.push(child);
      if (!child.__r3f) prepare(child, {});
      child.__r3f.parent = parentInstance;
      updateInstance(child);
      invalidateInstance(child);
    }
  }
  function insertBefore(parentInstance, child, beforeChild) {
    let added = false;
    if (child) {
      var _child$__r3f2, _parentInstance$__r3f2;
      if ((_child$__r3f2 = child.__r3f) != null && _child$__r3f2.attach) {
        attach(parentInstance, child, child.__r3f.attach);
      } else if (child.isObject3D && parentInstance.isObject3D) {
        child.parent = parentInstance;
        child.dispatchEvent({
          type: "added"
        });
        parentInstance.dispatchEvent({
          type: "childadded",
          child
        });
        const restSiblings = parentInstance.children.filter((sibling) => sibling !== child);
        const index = restSiblings.indexOf(beforeChild);
        parentInstance.children = [...restSiblings.slice(0, index), child, ...restSiblings.slice(index)];
        added = true;
      }
      if (!added) (_parentInstance$__r3f2 = parentInstance.__r3f) == null ? void 0 : _parentInstance$__r3f2.objects.push(child);
      if (!child.__r3f) prepare(child, {});
      child.__r3f.parent = parentInstance;
      updateInstance(child);
      invalidateInstance(child);
    }
  }
  function removeRecursive(array, parent, dispose2 = false) {
    if (array) [...array].forEach((child) => removeChild(parent, child, dispose2));
  }
  function removeChild(parentInstance, child, dispose2) {
    if (child) {
      var _parentInstance$__r3f3, _child$__r3f3, _child$__r3f5;
      if (child.__r3f) child.__r3f.parent = null;
      if ((_parentInstance$__r3f3 = parentInstance.__r3f) != null && _parentInstance$__r3f3.objects) parentInstance.__r3f.objects = parentInstance.__r3f.objects.filter((x3) => x3 !== child);
      if ((_child$__r3f3 = child.__r3f) != null && _child$__r3f3.attach) {
        detach(parentInstance, child, child.__r3f.attach);
      } else if (child.isObject3D && parentInstance.isObject3D) {
        var _child$__r3f4;
        parentInstance.remove(child);
        if ((_child$__r3f4 = child.__r3f) != null && _child$__r3f4.root) {
          removeInteractivity(findInitialRoot(child), child);
        }
      }
      const isPrimitive = (_child$__r3f5 = child.__r3f) == null ? void 0 : _child$__r3f5.primitive;
      const shouldDispose = !isPrimitive && (dispose2 === void 0 ? child.dispose !== null : dispose2);
      if (!isPrimitive) {
        var _child$__r3f6;
        removeRecursive((_child$__r3f6 = child.__r3f) == null ? void 0 : _child$__r3f6.objects, child, shouldDispose);
        removeRecursive(child.children, child, shouldDispose);
      }
      delete child.__r3f;
      if (shouldDispose && child.dispose && child.type !== "Scene") {
        const callback = () => {
          try {
            child.dispose();
          } catch (e2) {
          }
        };
        if (typeof IS_REACT_ACT_ENVIRONMENT === "undefined") {
          schedulerExports.unstable_scheduleCallback(schedulerExports.unstable_IdlePriority, callback);
        } else {
          callback();
        }
      }
      invalidateInstance(parentInstance);
    }
  }
  function switchInstance(instance, type, newProps, fiber) {
    var _instance$__r3f;
    const parent = (_instance$__r3f = instance.__r3f) == null ? void 0 : _instance$__r3f.parent;
    if (!parent) return;
    const newInstance = createInstance(type, newProps, instance.__r3f.root);
    if (instance.children) {
      for (const child of instance.children) {
        if (child.__r3f) appendChild(newInstance, child);
      }
      instance.children = instance.children.filter((child) => !child.__r3f);
    }
    instance.__r3f.objects.forEach((child) => appendChild(newInstance, child));
    instance.__r3f.objects = [];
    if (!instance.__r3f.autoRemovedBeforeAppend) {
      removeChild(parent, instance);
    }
    if (newInstance.parent) {
      newInstance.__r3f.autoRemovedBeforeAppend = true;
    }
    appendChild(parent, newInstance);
    if (newInstance.raycast && newInstance.__r3f.eventCount) {
      const rootState = findInitialRoot(newInstance).getState();
      rootState.internal.interaction.push(newInstance);
    }
    [fiber, fiber.alternate].forEach((fiber2) => {
      if (fiber2 !== null) {
        fiber2.stateNode = newInstance;
        if (fiber2.ref) {
          if (typeof fiber2.ref === "function") fiber2.ref(newInstance);
          else fiber2.ref.current = newInstance;
        }
      }
    });
  }
  const handleTextInstance = () => {
  };
  const reconciler2 = Reconciler({
    createInstance,
    removeChild,
    appendChild,
    appendInitialChild: appendChild,
    insertBefore,
    supportsMutation: true,
    isPrimaryRenderer: false,
    supportsPersistence: false,
    supportsHydration: false,
    noTimeout: -1,
    appendChildToContainer: (container, child) => {
      if (!child) return;
      const scene = container.getState().scene;
      if (!scene.__r3f) return;
      scene.__r3f.root = container;
      appendChild(scene, child);
    },
    removeChildFromContainer: (container, child) => {
      if (!child) return;
      removeChild(container.getState().scene, child);
    },
    insertInContainerBefore: (container, child, beforeChild) => {
      if (!child || !beforeChild) return;
      const scene = container.getState().scene;
      if (!scene.__r3f) return;
      insertBefore(scene, child, beforeChild);
    },
    getRootHostContext: () => null,
    getChildHostContext: (parentHostContext) => parentHostContext,
    finalizeInitialChildren(instance) {
      var _instance$__r3f2;
      const localState = (_instance$__r3f2 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f2 : {};
      return Boolean(localState.handlers);
    },
    prepareUpdate(instance, _type, oldProps, newProps) {
      var _instance$__r3f3;
      const localState = (_instance$__r3f3 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f3 : {};
      if (localState.primitive && newProps.object && newProps.object !== instance) {
        return [true];
      } else {
        const {
          args: argsNew = [],
          children: cN,
          ...restNew
        } = newProps;
        const {
          args: argsOld = [],
          children: cO,
          ...restOld
        } = oldProps;
        if (!Array.isArray(argsNew)) throw new Error("R3F: the args prop must be an array!");
        if (argsNew.some((value, index) => value !== argsOld[index])) return [true];
        const diff = diffProps(instance, restNew, restOld, true);
        if (diff.changes.length) return [false, diff];
        return null;
      }
    },
    commitUpdate(instance, [reconstruct, diff], type, _oldProps, newProps, fiber) {
      if (reconstruct) switchInstance(instance, type, newProps, fiber);
      else applyProps$1(instance, diff);
    },
    commitMount(instance, _type, _props, _int) {
      var _instance$__r3f4;
      const localState = (_instance$__r3f4 = instance.__r3f) != null ? _instance$__r3f4 : {};
      if (instance.raycast && localState.handlers && localState.eventCount) {
        findInitialRoot(instance).getState().internal.interaction.push(instance);
      }
    },
    getPublicInstance: (instance) => instance,
    prepareForCommit: () => null,
    preparePortalMount: (container) => prepare(container.getState().scene),
    resetAfterCommit: () => {
    },
    shouldSetTextContent: () => false,
    clearContainer: () => false,
    hideInstance(instance) {
      var _instance$__r3f5;
      const {
        attach: type,
        parent
      } = (_instance$__r3f5 = instance.__r3f) != null ? _instance$__r3f5 : {};
      if (type && parent) detach(parent, instance, type);
      if (instance.isObject3D) instance.visible = false;
      invalidateInstance(instance);
    },
    unhideInstance(instance, props) {
      var _instance$__r3f6;
      const {
        attach: type,
        parent
      } = (_instance$__r3f6 = instance.__r3f) != null ? _instance$__r3f6 : {};
      if (type && parent) attach(parent, instance, type);
      if (instance.isObject3D && props.visible == null || props.visible) instance.visible = true;
      invalidateInstance(instance);
    },
    createTextInstance: handleTextInstance,
    hideTextInstance: handleTextInstance,
    unhideTextInstance: handleTextInstance,
    // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r916356874
    // @ts-expect-error
    getCurrentEventPriority: () => _getEventPriority ? _getEventPriority() : constantsExports.DefaultEventPriority,
    beforeActiveInstanceBlur: () => {
    },
    afterActiveInstanceBlur: () => {
    },
    detachDeletedInstance: () => {
    },
    now: typeof performance !== "undefined" && is$1.fun(performance.now) ? performance.now : is$1.fun(Date.now) ? Date.now : () => 0,
    // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r920883503
    scheduleTimeout: is$1.fun(setTimeout) ? setTimeout : void 0,
    cancelTimeout: is$1.fun(clearTimeout) ? clearTimeout : void 0
  });
  return {
    reconciler: reconciler2,
    applyProps: applyProps$1
  };
}
var _window$document, _window$navigator;
const hasColorSpace$1 = (object) => "colorSpace" in object || "outputColorSpace" in object;
const getColorManagement = () => {
  var _ColorManagement;
  return (_ColorManagement = catalogue.ColorManagement) != null ? _ColorManagement : null;
};
const isOrthographicCamera$2 = (def) => def && def.isOrthographicCamera;
const isRef$1 = (obj) => obj && obj.hasOwnProperty("current");
const useIsomorphicLayoutEffect$2 = typeof window !== "undefined" && ((_window$document = window.document) != null && _window$document.createElement || ((_window$navigator = window.navigator) == null ? void 0 : _window$navigator.product) === "ReactNative") ? reactExports.useLayoutEffect : reactExports.useEffect;
function useMutableCallback(fn) {
  const ref = reactExports.useRef(fn);
  useIsomorphicLayoutEffect$2(() => void (ref.current = fn), [fn]);
  return ref;
}
function Block({
  set
}) {
  useIsomorphicLayoutEffect$2(() => {
    set(new Promise(() => null));
    return () => set(false);
  }, [set]);
  return null;
}
let ErrorBoundary$1 = class ErrorBoundary extends reactExports.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      error: false
    };
  }
  componentDidCatch(err) {
    this.props.set(err);
  }
  render() {
    return this.state.error ? null : this.props.children;
  }
};
ErrorBoundary$1.getDerivedStateFromError = () => ({
  error: true
});
const DEFAULT = "__default";
const DEFAULTS = /* @__PURE__ */ new Map();
const isDiffSet = (def) => def && !!def.memoized && !!def.changes;
function calculateDpr(dpr) {
  var _window$devicePixelRa;
  const target = typeof window !== "undefined" ? (_window$devicePixelRa = window.devicePixelRatio) != null ? _window$devicePixelRa : 2 : 1;
  return Array.isArray(dpr) ? Math.min(Math.max(dpr[0], target), dpr[1]) : dpr;
}
const getRootState = (obj) => {
  var _r3f;
  return (_r3f = obj.__r3f) == null ? void 0 : _r3f.root.getState();
};
function findInitialRoot(child) {
  let root2 = child.__r3f.root;
  while (root2.getState().previousRoot) root2 = root2.getState().previousRoot;
  return root2;
}
const is$1 = {
  obj: (a5) => a5 === Object(a5) && !is$1.arr(a5) && typeof a5 !== "function",
  fun: (a5) => typeof a5 === "function",
  str: (a5) => typeof a5 === "string",
  num: (a5) => typeof a5 === "number",
  boo: (a5) => typeof a5 === "boolean",
  und: (a5) => a5 === void 0,
  arr: (a5) => Array.isArray(a5),
  equ(a5, b6, {
    arrays = "shallow",
    objects = "reference",
    strict = true
  } = {}) {
    if (typeof a5 !== typeof b6 || !!a5 !== !!b6) return false;
    if (is$1.str(a5) || is$1.num(a5) || is$1.boo(a5)) return a5 === b6;
    const isObj = is$1.obj(a5);
    if (isObj && objects === "reference") return a5 === b6;
    const isArr = is$1.arr(a5);
    if (isArr && arrays === "reference") return a5 === b6;
    if ((isArr || isObj) && a5 === b6) return true;
    let i2;
    for (i2 in a5) if (!(i2 in b6)) return false;
    if (isObj && arrays === "shallow" && objects === "shallow") {
      for (i2 in strict ? b6 : a5) if (!is$1.equ(a5[i2], b6[i2], {
        strict,
        objects: "reference"
      })) return false;
    } else {
      for (i2 in strict ? b6 : a5) if (a5[i2] !== b6[i2]) return false;
    }
    if (is$1.und(i2)) {
      if (isArr && a5.length === 0 && b6.length === 0) return true;
      if (isObj && Object.keys(a5).length === 0 && Object.keys(b6).length === 0) return true;
      if (a5 !== b6) return false;
    }
    return true;
  }
};
function buildGraph(object) {
  const data = {
    nodes: {},
    materials: {}
  };
  if (object) {
    object.traverse((obj) => {
      if (obj.name) data.nodes[obj.name] = obj;
      if (obj.material && !data.materials[obj.material.name]) data.materials[obj.material.name] = obj.material;
    });
  }
  return data;
}
function dispose(obj) {
  if (obj.dispose && obj.type !== "Scene") obj.dispose();
  for (const p3 in obj) {
    p3.dispose == null ? void 0 : p3.dispose();
    delete obj[p3];
  }
}
function prepare(object, state) {
  const instance = object;
  instance.__r3f = {
    type: "",
    root: null,
    previousAttach: null,
    memoizedProps: {},
    eventCount: 0,
    handlers: {},
    objects: [],
    parent: null,
    ...state
  };
  return object;
}
function resolve(instance, key) {
  let target = instance;
  if (key.includes("-")) {
    const entries = key.split("-");
    const last = entries.pop();
    target = entries.reduce((acc, key2) => acc[key2], instance);
    return {
      target,
      key: last
    };
  } else return {
    target,
    key
  };
}
const INDEX_REGEX = /-\d+$/;
function attach(parent, child, type) {
  if (is$1.str(type)) {
    if (INDEX_REGEX.test(type)) {
      const root2 = type.replace(INDEX_REGEX, "");
      const {
        target: target2,
        key: key2
      } = resolve(parent, root2);
      if (!Array.isArray(target2[key2])) target2[key2] = [];
    }
    const {
      target,
      key
    } = resolve(parent, type);
    child.__r3f.previousAttach = target[key];
    target[key] = child;
  } else child.__r3f.previousAttach = type(parent, child);
}
function detach(parent, child, type) {
  var _child$__r3f, _child$__r3f2;
  if (is$1.str(type)) {
    const {
      target,
      key
    } = resolve(parent, type);
    const previous = child.__r3f.previousAttach;
    if (previous === void 0) delete target[key];
    else target[key] = previous;
  } else (_child$__r3f = child.__r3f) == null ? void 0 : _child$__r3f.previousAttach == null ? void 0 : _child$__r3f.previousAttach(parent, child);
  (_child$__r3f2 = child.__r3f) == null ? true : delete _child$__r3f2.previousAttach;
}
function diffProps(instance, {
  children: cN,
  key: kN,
  ref: rN,
  ...props
}, {
  children: cP,
  key: kP,
  ref: rP,
  ...previous
} = {}, remove = false) {
  const localState = instance.__r3f;
  const entries = Object.entries(props);
  const changes = [];
  if (remove) {
    const previousKeys = Object.keys(previous);
    for (let i2 = 0; i2 < previousKeys.length; i2++) {
      if (!props.hasOwnProperty(previousKeys[i2])) entries.unshift([previousKeys[i2], DEFAULT + "remove"]);
    }
  }
  entries.forEach(([key, value]) => {
    var _instance$__r3f;
    if ((_instance$__r3f = instance.__r3f) != null && _instance$__r3f.primitive && key === "object") return;
    if (is$1.equ(value, previous[key])) return;
    if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(key)) return changes.push([key, value, true, []]);
    let entries2 = [];
    if (key.includes("-")) entries2 = key.split("-");
    changes.push([key, value, false, entries2]);
    for (const prop in props) {
      const value2 = props[prop];
      if (prop.startsWith(`${key}-`)) changes.push([prop, value2, false, prop.split("-")]);
    }
  });
  const memoized = {
    ...props
  };
  if (localState != null && localState.memoizedProps && localState != null && localState.memoizedProps.args) memoized.args = localState.memoizedProps.args;
  if (localState != null && localState.memoizedProps && localState != null && localState.memoizedProps.attach) memoized.attach = localState.memoizedProps.attach;
  return {
    memoized,
    changes
  };
}
function applyProps$1(instance, data) {
  var _instance$__r3f2;
  const localState = instance.__r3f;
  const root2 = localState == null ? void 0 : localState.root;
  const rootState = root2 == null ? void 0 : root2.getState == null ? void 0 : root2.getState();
  const {
    memoized,
    changes
  } = isDiffSet(data) ? data : diffProps(instance, data);
  const prevHandlers = localState == null ? void 0 : localState.eventCount;
  if (instance.__r3f) instance.__r3f.memoizedProps = memoized;
  for (let i2 = 0; i2 < changes.length; i2++) {
    let [key, value, isEvent, keys] = changes[i2];
    if (hasColorSpace$1(instance)) {
      const sRGBEncoding2 = 3001;
      const SRGBColorSpace2 = "srgb";
      const LinearSRGBColorSpace2 = "srgb-linear";
      if (key === "encoding") {
        key = "colorSpace";
        value = value === sRGBEncoding2 ? SRGBColorSpace2 : LinearSRGBColorSpace2;
      } else if (key === "outputEncoding") {
        key = "outputColorSpace";
        value = value === sRGBEncoding2 ? SRGBColorSpace2 : LinearSRGBColorSpace2;
      }
    }
    let currentInstance = instance;
    let targetProp = currentInstance[key];
    if (keys.length) {
      targetProp = keys.reduce((acc, key2) => acc[key2], instance);
      if (!(targetProp && targetProp.set)) {
        const [name, ...reverseEntries] = keys.reverse();
        currentInstance = reverseEntries.reverse().reduce((acc, key2) => acc[key2], instance);
        key = name;
      }
    }
    if (value === DEFAULT + "remove") {
      if (currentInstance.constructor) {
        let ctor = DEFAULTS.get(currentInstance.constructor);
        if (!ctor) {
          ctor = new currentInstance.constructor();
          DEFAULTS.set(currentInstance.constructor, ctor);
        }
        value = ctor[key];
      } else {
        value = 0;
      }
    }
    if (isEvent && localState) {
      if (value) localState.handlers[key] = value;
      else delete localState.handlers[key];
      localState.eventCount = Object.keys(localState.handlers).length;
    } else if (targetProp && targetProp.set && (targetProp.copy || targetProp instanceof Layers)) {
      if (Array.isArray(value)) {
        if (targetProp.fromArray) targetProp.fromArray(value);
        else targetProp.set(...value);
      } else if (targetProp.copy && value && value.constructor && // Some environments may break strict identity checks by duplicating versions of three.js.
      // Loosen to unminified names, ignoring descendents.
      // https://github.com/pmndrs/react-three-fiber/issues/2856
      // TODO: fix upstream and remove in v9
      targetProp.constructor === value.constructor) {
        targetProp.copy(value);
      } else if (value !== void 0) {
        var _targetProp;
        const isColor = (_targetProp = targetProp) == null ? void 0 : _targetProp.isColor;
        if (!isColor && targetProp.setScalar) targetProp.setScalar(value);
        else if (targetProp instanceof Layers && value instanceof Layers) targetProp.mask = value.mask;
        else targetProp.set(value);
        if (!getColorManagement() && rootState && !rootState.linear && isColor) targetProp.convertSRGBToLinear();
      }
    } else {
      var _currentInstance$key;
      currentInstance[key] = value;
      if ((_currentInstance$key = currentInstance[key]) != null && _currentInstance$key.isTexture && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
      currentInstance[key].format === RGBAFormat && currentInstance[key].type === UnsignedByteType && rootState) {
        const texture = currentInstance[key];
        if (hasColorSpace$1(texture) && hasColorSpace$1(rootState.gl)) texture.colorSpace = rootState.gl.outputColorSpace;
        else texture.encoding = rootState.gl.outputEncoding;
      }
    }
    invalidateInstance(instance);
  }
  if (localState && localState.parent && instance.raycast && prevHandlers !== localState.eventCount) {
    const internal = findInitialRoot(instance).getState().internal;
    const index = internal.interaction.indexOf(instance);
    if (index > -1) internal.interaction.splice(index, 1);
    if (localState.eventCount) internal.interaction.push(instance);
  }
  const isCircular = changes.length === 1 && changes[0][0] === "onUpdate";
  if (!isCircular && changes.length && (_instance$__r3f2 = instance.__r3f) != null && _instance$__r3f2.parent) updateInstance(instance);
  return instance;
}
function invalidateInstance(instance) {
  var _instance$__r3f3, _instance$__r3f3$root;
  const state = (_instance$__r3f3 = instance.__r3f) == null ? void 0 : (_instance$__r3f3$root = _instance$__r3f3.root) == null ? void 0 : _instance$__r3f3$root.getState == null ? void 0 : _instance$__r3f3$root.getState();
  if (state && state.internal.frames === 0) state.invalidate();
}
function updateInstance(instance) {
  instance.onUpdate == null ? void 0 : instance.onUpdate(instance);
}
function updateCamera(camera, size) {
  if (!camera.manual) {
    if (isOrthographicCamera$2(camera)) {
      camera.left = size.width / -2;
      camera.right = size.width / 2;
      camera.top = size.height / 2;
      camera.bottom = size.height / -2;
    } else {
      camera.aspect = size.width / size.height;
    }
    camera.updateProjectionMatrix();
    camera.updateMatrixWorld();
  }
}
function makeId(event) {
  return (event.eventObject || event.object).uuid + "/" + event.index + event.instanceId;
}
function getEventPriority() {
  var _globalScope$event;
  const globalScope = typeof self !== "undefined" && self || typeof window !== "undefined" && window;
  if (!globalScope) return constantsExports.DefaultEventPriority;
  const name = (_globalScope$event = globalScope.event) == null ? void 0 : _globalScope$event.type;
  switch (name) {
    case "click":
    case "contextmenu":
    case "dblclick":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
      return constantsExports.DiscreteEventPriority;
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "pointerenter":
    case "pointerleave":
    case "wheel":
      return constantsExports.ContinuousEventPriority;
    default:
      return constantsExports.DefaultEventPriority;
  }
}
function releaseInternalPointerCapture(capturedMap, obj, captures, pointerId) {
  const captureData = captures.get(obj);
  if (captureData) {
    captures.delete(obj);
    if (captures.size === 0) {
      capturedMap.delete(pointerId);
      captureData.target.releasePointerCapture(pointerId);
    }
  }
}
function removeInteractivity(store, object) {
  const {
    internal
  } = store.getState();
  internal.interaction = internal.interaction.filter((o2) => o2 !== object);
  internal.initialHits = internal.initialHits.filter((o2) => o2 !== object);
  internal.hovered.forEach((value, key) => {
    if (value.eventObject === object || value.object === object) {
      internal.hovered.delete(key);
    }
  });
  internal.capturedMap.forEach((captures, pointerId) => {
    releaseInternalPointerCapture(internal.capturedMap, object, captures, pointerId);
  });
}
function createEvents(store) {
  function calculateDistance(event) {
    const {
      internal
    } = store.getState();
    const dx = event.offsetX - internal.initialClick[0];
    const dy = event.offsetY - internal.initialClick[1];
    return Math.round(Math.sqrt(dx * dx + dy * dy));
  }
  function filterPointerEvents(objects) {
    return objects.filter((obj) => ["Move", "Over", "Enter", "Out", "Leave"].some((name) => {
      var _r3f;
      return (_r3f = obj.__r3f) == null ? void 0 : _r3f.handlers["onPointer" + name];
    }));
  }
  function intersect2(event, filter) {
    const state = store.getState();
    const duplicates = /* @__PURE__ */ new Set();
    const intersections = [];
    const eventsObjects = filter ? filter(state.internal.interaction) : state.internal.interaction;
    for (let i2 = 0; i2 < eventsObjects.length; i2++) {
      const state2 = getRootState(eventsObjects[i2]);
      if (state2) {
        state2.raycaster.camera = void 0;
      }
    }
    if (!state.previousRoot) {
      state.events.compute == null ? void 0 : state.events.compute(event, state);
    }
    function handleRaycast(obj) {
      const state2 = getRootState(obj);
      if (!state2 || !state2.events.enabled || state2.raycaster.camera === null) return [];
      if (state2.raycaster.camera === void 0) {
        var _state$previousRoot;
        state2.events.compute == null ? void 0 : state2.events.compute(event, state2, (_state$previousRoot = state2.previousRoot) == null ? void 0 : _state$previousRoot.getState());
        if (state2.raycaster.camera === void 0) state2.raycaster.camera = null;
      }
      return state2.raycaster.camera ? state2.raycaster.intersectObject(obj, true) : [];
    }
    let hits = eventsObjects.flatMap(handleRaycast).sort((a5, b6) => {
      const aState = getRootState(a5.object);
      const bState = getRootState(b6.object);
      if (!aState || !bState) return a5.distance - b6.distance;
      return bState.events.priority - aState.events.priority || a5.distance - b6.distance;
    }).filter((item) => {
      const id = makeId(item);
      if (duplicates.has(id)) return false;
      duplicates.add(id);
      return true;
    });
    if (state.events.filter) hits = state.events.filter(hits, state);
    for (const hit of hits) {
      let eventObject = hit.object;
      while (eventObject) {
        var _r3f2;
        if ((_r3f2 = eventObject.__r3f) != null && _r3f2.eventCount) intersections.push({
          ...hit,
          eventObject
        });
        eventObject = eventObject.parent;
      }
    }
    if ("pointerId" in event && state.internal.capturedMap.has(event.pointerId)) {
      for (let captureData of state.internal.capturedMap.get(event.pointerId).values()) {
        if (!duplicates.has(makeId(captureData.intersection))) intersections.push(captureData.intersection);
      }
    }
    return intersections;
  }
  function handleIntersects(intersections, event, delta, callback) {
    const rootState = store.getState();
    if (intersections.length) {
      const localState = {
        stopped: false
      };
      for (const hit of intersections) {
        const state = getRootState(hit.object) || rootState;
        const {
          raycaster,
          pointer,
          camera,
          internal
        } = state;
        const unprojectedPoint = new Vector3(pointer.x, pointer.y, 0).unproject(camera);
        const hasPointerCapture = (id) => {
          var _internal$capturedMap, _internal$capturedMap2;
          return (_internal$capturedMap = (_internal$capturedMap2 = internal.capturedMap.get(id)) == null ? void 0 : _internal$capturedMap2.has(hit.eventObject)) != null ? _internal$capturedMap : false;
        };
        const setPointerCapture = (id) => {
          const captureData = {
            intersection: hit,
            target: event.target
          };
          if (internal.capturedMap.has(id)) {
            internal.capturedMap.get(id).set(hit.eventObject, captureData);
          } else {
            internal.capturedMap.set(id, /* @__PURE__ */ new Map([[hit.eventObject, captureData]]));
          }
          event.target.setPointerCapture(id);
        };
        const releasePointerCapture = (id) => {
          const captures = internal.capturedMap.get(id);
          if (captures) {
            releaseInternalPointerCapture(internal.capturedMap, hit.eventObject, captures, id);
          }
        };
        let extractEventProps = {};
        for (let prop in event) {
          let property = event[prop];
          if (typeof property !== "function") extractEventProps[prop] = property;
        }
        let raycastEvent = {
          ...hit,
          ...extractEventProps,
          pointer,
          intersections,
          stopped: localState.stopped,
          delta,
          unprojectedPoint,
          ray: raycaster.ray,
          camera,
          // Hijack stopPropagation, which just sets a flag
          stopPropagation() {
            const capturesForPointer = "pointerId" in event && internal.capturedMap.get(event.pointerId);
            if (
              // ...if this pointer hasn't been captured
              !capturesForPointer || // ... or if the hit object is capturing the pointer
              capturesForPointer.has(hit.eventObject)
            ) {
              raycastEvent.stopped = localState.stopped = true;
              if (internal.hovered.size && Array.from(internal.hovered.values()).find((i2) => i2.eventObject === hit.eventObject)) {
                const higher = intersections.slice(0, intersections.indexOf(hit));
                cancelPointer([...higher, hit]);
              }
            }
          },
          // there should be a distinction between target and currentTarget
          target: {
            hasPointerCapture,
            setPointerCapture,
            releasePointerCapture
          },
          currentTarget: {
            hasPointerCapture,
            setPointerCapture,
            releasePointerCapture
          },
          nativeEvent: event
        };
        callback(raycastEvent);
        if (localState.stopped === true) break;
      }
    }
    return intersections;
  }
  function cancelPointer(intersections) {
    const {
      internal
    } = store.getState();
    for (const hoveredObj of internal.hovered.values()) {
      if (!intersections.length || !intersections.find((hit) => hit.object === hoveredObj.object && hit.index === hoveredObj.index && hit.instanceId === hoveredObj.instanceId)) {
        const eventObject = hoveredObj.eventObject;
        const instance = eventObject.__r3f;
        const handlers = instance == null ? void 0 : instance.handlers;
        internal.hovered.delete(makeId(hoveredObj));
        if (instance != null && instance.eventCount) {
          const data = {
            ...hoveredObj,
            intersections
          };
          handlers.onPointerOut == null ? void 0 : handlers.onPointerOut(data);
          handlers.onPointerLeave == null ? void 0 : handlers.onPointerLeave(data);
        }
      }
    }
  }
  function pointerMissed(event, objects) {
    for (let i2 = 0; i2 < objects.length; i2++) {
      const instance = objects[i2].__r3f;
      instance == null ? void 0 : instance.handlers.onPointerMissed == null ? void 0 : instance.handlers.onPointerMissed(event);
    }
  }
  function handlePointer(name) {
    switch (name) {
      case "onPointerLeave":
      case "onPointerCancel":
        return () => cancelPointer([]);
      case "onLostPointerCapture":
        return (event) => {
          const {
            internal
          } = store.getState();
          if ("pointerId" in event && internal.capturedMap.has(event.pointerId)) {
            requestAnimationFrame(() => {
              if (internal.capturedMap.has(event.pointerId)) {
                internal.capturedMap.delete(event.pointerId);
                cancelPointer([]);
              }
            });
          }
        };
    }
    return function handleEvent(event) {
      const {
        onPointerMissed,
        internal
      } = store.getState();
      internal.lastEvent.current = event;
      const isPointerMove = name === "onPointerMove";
      const isClickEvent = name === "onClick" || name === "onContextMenu" || name === "onDoubleClick";
      const filter = isPointerMove ? filterPointerEvents : void 0;
      const hits = intersect2(event, filter);
      const delta = isClickEvent ? calculateDistance(event) : 0;
      if (name === "onPointerDown") {
        internal.initialClick = [event.offsetX, event.offsetY];
        internal.initialHits = hits.map((hit) => hit.eventObject);
      }
      if (isClickEvent && !hits.length) {
        if (delta <= 2) {
          pointerMissed(event, internal.interaction);
          if (onPointerMissed) onPointerMissed(event);
        }
      }
      if (isPointerMove) cancelPointer(hits);
      function onIntersect(data) {
        const eventObject = data.eventObject;
        const instance = eventObject.__r3f;
        const handlers = instance == null ? void 0 : instance.handlers;
        if (!(instance != null && instance.eventCount)) return;
        if (isPointerMove) {
          if (handlers.onPointerOver || handlers.onPointerEnter || handlers.onPointerOut || handlers.onPointerLeave) {
            const id = makeId(data);
            const hoveredItem = internal.hovered.get(id);
            if (!hoveredItem) {
              internal.hovered.set(id, data);
              handlers.onPointerOver == null ? void 0 : handlers.onPointerOver(data);
              handlers.onPointerEnter == null ? void 0 : handlers.onPointerEnter(data);
            } else if (hoveredItem.stopped) {
              data.stopPropagation();
            }
          }
          handlers.onPointerMove == null ? void 0 : handlers.onPointerMove(data);
        } else {
          const handler = handlers[name];
          if (handler) {
            if (!isClickEvent || internal.initialHits.includes(eventObject)) {
              pointerMissed(event, internal.interaction.filter((object) => !internal.initialHits.includes(object)));
              handler(data);
            }
          } else {
            if (isClickEvent && internal.initialHits.includes(eventObject)) {
              pointerMissed(event, internal.interaction.filter((object) => !internal.initialHits.includes(object)));
            }
          }
        }
      }
      handleIntersects(hits, event, delta, onIntersect);
    };
  }
  return {
    handlePointer
  };
}
const privateKeys = ["set", "get", "setSize", "setFrameloop", "setDpr", "events", "invalidate", "advance", "size", "viewport"];
const isRenderer = (def) => !!(def != null && def.render);
const context$1 = /* @__PURE__ */ reactExports.createContext(null);
const createStore$2 = (invalidate2, advance2) => {
  const rootState = create$1((set, get) => {
    const position = new Vector3();
    const defaultTarget = new Vector3();
    const tempTarget = new Vector3();
    function getCurrentViewport(camera = get().camera, target = defaultTarget, size = get().size) {
      const {
        width,
        height,
        top,
        left
      } = size;
      const aspect2 = width / height;
      if (target.isVector3) tempTarget.copy(target);
      else tempTarget.set(...target);
      const distance = camera.getWorldPosition(position).distanceTo(tempTarget);
      if (isOrthographicCamera$2(camera)) {
        return {
          width: width / camera.zoom,
          height: height / camera.zoom,
          top,
          left,
          factor: 1,
          distance,
          aspect: aspect2
        };
      } else {
        const fov2 = camera.fov * Math.PI / 180;
        const h2 = 2 * Math.tan(fov2 / 2) * distance;
        const w2 = h2 * (width / height);
        return {
          width: w2,
          height: h2,
          top,
          left,
          factor: width / w2,
          distance,
          aspect: aspect2
        };
      }
    }
    let performanceTimeout = void 0;
    const setPerformanceCurrent = (current) => set((state2) => ({
      performance: {
        ...state2.performance,
        current
      }
    }));
    const pointer = new Vector2();
    const rootState2 = {
      set,
      get,
      // Mock objects that have to be configured
      gl: null,
      camera: null,
      raycaster: null,
      events: {
        priority: 1,
        enabled: true,
        connected: false
      },
      xr: null,
      scene: null,
      invalidate: (frames = 1) => invalidate2(get(), frames),
      advance: (timestamp, runGlobalEffects) => advance2(timestamp, runGlobalEffects, get()),
      legacy: false,
      linear: false,
      flat: false,
      controls: null,
      clock: new Clock(),
      pointer,
      mouse: pointer,
      frameloop: "always",
      onPointerMissed: void 0,
      performance: {
        current: 1,
        min: 0.5,
        max: 1,
        debounce: 200,
        regress: () => {
          const state2 = get();
          if (performanceTimeout) clearTimeout(performanceTimeout);
          if (state2.performance.current !== state2.performance.min) setPerformanceCurrent(state2.performance.min);
          performanceTimeout = setTimeout(() => setPerformanceCurrent(get().performance.max), state2.performance.debounce);
        }
      },
      size: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        updateStyle: false
      },
      viewport: {
        initialDpr: 0,
        dpr: 0,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        aspect: 0,
        distance: 0,
        factor: 0,
        getCurrentViewport
      },
      setEvents: (events) => set((state2) => ({
        ...state2,
        events: {
          ...state2.events,
          ...events
        }
      })),
      setSize: (width, height, updateStyle, top, left) => {
        const camera = get().camera;
        const size = {
          width,
          height,
          top: top || 0,
          left: left || 0,
          updateStyle
        };
        set((state2) => ({
          size,
          viewport: {
            ...state2.viewport,
            ...getCurrentViewport(camera, defaultTarget, size)
          }
        }));
      },
      setDpr: (dpr) => set((state2) => {
        const resolved = calculateDpr(dpr);
        return {
          viewport: {
            ...state2.viewport,
            dpr: resolved,
            initialDpr: state2.viewport.initialDpr || resolved
          }
        };
      }),
      setFrameloop: (frameloop = "always") => {
        const clock = get().clock;
        clock.stop();
        clock.elapsedTime = 0;
        if (frameloop !== "never") {
          clock.start();
          clock.elapsedTime = 0;
        }
        set(() => ({
          frameloop
        }));
      },
      previousRoot: void 0,
      internal: {
        active: false,
        priority: 0,
        frames: 0,
        lastEvent: /* @__PURE__ */ reactExports.createRef(),
        interaction: [],
        hovered: /* @__PURE__ */ new Map(),
        subscribers: [],
        initialClick: [0, 0],
        initialHits: [],
        capturedMap: /* @__PURE__ */ new Map(),
        subscribe: (ref, priority2, store) => {
          const internal = get().internal;
          internal.priority = internal.priority + (priority2 > 0 ? 1 : 0);
          internal.subscribers.push({
            ref,
            priority: priority2,
            store
          });
          internal.subscribers = internal.subscribers.sort((a5, b6) => a5.priority - b6.priority);
          return () => {
            const internal2 = get().internal;
            if (internal2 != null && internal2.subscribers) {
              internal2.priority = internal2.priority - (priority2 > 0 ? 1 : 0);
              internal2.subscribers = internal2.subscribers.filter((s2) => s2.ref !== ref);
            }
          };
        }
      }
    };
    return rootState2;
  });
  const state = rootState.getState();
  let oldSize = state.size;
  let oldDpr = state.viewport.dpr;
  let oldCamera = state.camera;
  rootState.subscribe(() => {
    const {
      camera,
      size,
      viewport,
      gl,
      set
    } = rootState.getState();
    if (size.width !== oldSize.width || size.height !== oldSize.height || viewport.dpr !== oldDpr) {
      var _size$updateStyle;
      oldSize = size;
      oldDpr = viewport.dpr;
      updateCamera(camera, size);
      gl.setPixelRatio(viewport.dpr);
      const updateStyle = (_size$updateStyle = size.updateStyle) != null ? _size$updateStyle : typeof HTMLCanvasElement !== "undefined" && gl.domElement instanceof HTMLCanvasElement;
      gl.setSize(size.width, size.height, updateStyle);
    }
    if (camera !== oldCamera) {
      oldCamera = camera;
      set((state2) => ({
        viewport: {
          ...state2.viewport,
          ...state2.viewport.getCurrentViewport(camera)
        }
      }));
    }
  });
  rootState.subscribe((state2) => invalidate2(state2));
  return rootState;
};
function createSubs(callback, subs) {
  const sub = {
    callback
  };
  subs.add(sub);
  return () => void subs.delete(sub);
}
let i$3;
let globalEffects = /* @__PURE__ */ new Set();
let globalAfterEffects = /* @__PURE__ */ new Set();
let globalTailEffects = /* @__PURE__ */ new Set();
const addEffect = (callback) => createSubs(callback, globalEffects);
const addAfterEffect = (callback) => createSubs(callback, globalAfterEffects);
const addTail = (callback) => createSubs(callback, globalTailEffects);
function run(effects, timestamp) {
  if (!effects.size) return;
  for (const {
    callback
  } of effects.values()) {
    callback(timestamp);
  }
}
function flushGlobalEffects(type, timestamp) {
  switch (type) {
    case "before":
      return run(globalEffects, timestamp);
    case "after":
      return run(globalAfterEffects, timestamp);
    case "tail":
      return run(globalTailEffects, timestamp);
  }
}
let subscribers;
let subscription;
function render$1(timestamp, state, frame) {
  let delta = state.clock.getDelta();
  if (state.frameloop === "never" && typeof timestamp === "number") {
    delta = timestamp - state.clock.elapsedTime;
    state.clock.oldTime = state.clock.elapsedTime;
    state.clock.elapsedTime = timestamp;
  }
  subscribers = state.internal.subscribers;
  for (i$3 = 0; i$3 < subscribers.length; i$3++) {
    subscription = subscribers[i$3];
    subscription.ref.current(subscription.store.getState(), delta, frame);
  }
  if (!state.internal.priority && state.gl.render) state.gl.render(state.scene, state.camera);
  state.internal.frames = Math.max(0, state.internal.frames - 1);
  return state.frameloop === "always" ? 1 : state.internal.frames;
}
function createLoop(roots2) {
  let running = false;
  let useFrameInProgress = false;
  let repeat2;
  let frame;
  let state;
  function loop2(timestamp) {
    frame = requestAnimationFrame(loop2);
    running = true;
    repeat2 = 0;
    flushGlobalEffects("before", timestamp);
    useFrameInProgress = true;
    for (const root2 of roots2.values()) {
      var _state$gl$xr;
      state = root2.store.getState();
      if (state.internal.active && (state.frameloop === "always" || state.internal.frames > 0) && !((_state$gl$xr = state.gl.xr) != null && _state$gl$xr.isPresenting)) {
        repeat2 += render$1(timestamp, state);
      }
    }
    useFrameInProgress = false;
    flushGlobalEffects("after", timestamp);
    if (repeat2 === 0) {
      flushGlobalEffects("tail", timestamp);
      running = false;
      return cancelAnimationFrame(frame);
    }
  }
  function invalidate2(state2, frames = 1) {
    var _state$gl$xr2;
    if (!state2) return roots2.forEach((root2) => invalidate2(root2.store.getState(), frames));
    if ((_state$gl$xr2 = state2.gl.xr) != null && _state$gl$xr2.isPresenting || !state2.internal.active || state2.frameloop === "never") return;
    if (frames > 1) {
      state2.internal.frames = Math.min(60, state2.internal.frames + frames);
    } else {
      if (useFrameInProgress) {
        state2.internal.frames = 2;
      } else {
        state2.internal.frames = 1;
      }
    }
    if (!running) {
      running = true;
      requestAnimationFrame(loop2);
    }
  }
  function advance2(timestamp, runGlobalEffects = true, state2, frame2) {
    if (runGlobalEffects) flushGlobalEffects("before", timestamp);
    if (!state2) for (const root2 of roots2.values()) render$1(timestamp, root2.store.getState());
    else render$1(timestamp, state2, frame2);
    if (runGlobalEffects) flushGlobalEffects("after", timestamp);
  }
  return {
    loop: loop2,
    invalidate: invalidate2,
    advance: advance2
  };
}
function useStore$1() {
  const store = reactExports.useContext(context$1);
  if (!store) throw new Error("R3F: Hooks can only be used within the Canvas component!");
  return store;
}
function useThree(selector3 = (state) => state, equalityFn) {
  return useStore$1()(selector3, equalityFn);
}
function useFrame(callback, renderPriority = 0) {
  const store = useStore$1();
  const subscribe = store.getState().internal.subscribe;
  const ref = useMutableCallback(callback);
  useIsomorphicLayoutEffect$2(() => subscribe(ref, renderPriority, store), [renderPriority, subscribe, store]);
  return null;
}
const memoizedLoaders = /* @__PURE__ */ new WeakMap();
function loadingFn(extensions2, onProgress) {
  return function(Proto, ...input) {
    let loader = memoizedLoaders.get(Proto);
    if (!loader) {
      loader = new Proto();
      memoizedLoaders.set(Proto, loader);
    }
    if (extensions2) extensions2(loader);
    return Promise.all(input.map((input2) => new Promise((res, reject) => loader.load(input2, (data) => {
      if (data.scene) Object.assign(data, buildGraph(data.scene));
      res(data);
    }, onProgress, (error2) => reject(new Error(`Could not load ${input2}: ${error2 == null ? void 0 : error2.message}`))))));
  };
}
function useLoader(Proto, input, extensions2, onProgress) {
  const keys = Array.isArray(input) ? input : [input];
  const results = suspend$1(loadingFn(extensions2, onProgress), [Proto, ...keys], {
    equal: is$1.equ
  });
  return Array.isArray(input) ? results : results[0];
}
useLoader.preload = function(Proto, input, extensions2) {
  const keys = Array.isArray(input) ? input : [input];
  return preload(loadingFn(extensions2), [Proto, ...keys]);
};
useLoader.clear = function(Proto, input) {
  const keys = Array.isArray(input) ? input : [input];
  return clear([Proto, ...keys]);
};
const roots = /* @__PURE__ */ new Map();
const {
  invalidate,
  advance: advance$1
} = createLoop(roots);
const {
  reconciler,
  applyProps
} = createRenderer(roots, getEventPriority);
const shallowLoose = {
  objects: "shallow",
  strict: false
};
const createRendererInstance = (gl, canvas) => {
  const customRenderer = typeof gl === "function" ? gl(canvas) : gl;
  if (isRenderer(customRenderer)) return customRenderer;
  else return new WebGLRenderer({
    powerPreference: "high-performance",
    canvas,
    antialias: true,
    alpha: true,
    ...gl
  });
};
function computeInitialSize(canvas, defaultSize) {
  const defaultStyle = typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement;
  if (defaultSize) {
    const {
      width,
      height,
      top,
      left,
      updateStyle = defaultStyle
    } = defaultSize;
    return {
      width,
      height,
      top,
      left,
      updateStyle
    };
  } else if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement && canvas.parentElement) {
    const {
      width,
      height,
      top,
      left
    } = canvas.parentElement.getBoundingClientRect();
    return {
      width,
      height,
      top,
      left,
      updateStyle: defaultStyle
    };
  } else if (typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) {
    return {
      width: canvas.width,
      height: canvas.height,
      top: 0,
      left: 0,
      updateStyle: defaultStyle
    };
  }
  return {
    width: 0,
    height: 0,
    top: 0,
    left: 0
  };
}
function createRoot(canvas) {
  const prevRoot = roots.get(canvas);
  const prevFiber = prevRoot == null ? void 0 : prevRoot.fiber;
  const prevStore = prevRoot == null ? void 0 : prevRoot.store;
  if (prevRoot) console.warn("R3F.createRoot should only be called once!");
  const logRecoverableError = typeof reportError === "function" ? (
    // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError
  ) : (
    // In older browsers and test environments, fallback to console.error.
    console.error
  );
  const store = prevStore || createStore$2(invalidate, advance$1);
  const fiber = prevFiber || reconciler.createContainer(store, constantsExports.ConcurrentRoot, null, false, null, "", logRecoverableError, null);
  if (!prevRoot) roots.set(canvas, {
    fiber,
    store
  });
  let onCreated;
  let configured = false;
  let lastCamera;
  return {
    configure(props = {}) {
      let {
        gl: glConfig,
        size: propsSize,
        scene: sceneOptions,
        events,
        onCreated: onCreatedCallback,
        shadows = false,
        linear: linear3 = false,
        flat = false,
        legacy = false,
        orthographic = false,
        frameloop = "always",
        dpr = [1, 2],
        performance: performance2,
        raycaster: raycastOptions,
        camera: cameraOptions,
        onPointerMissed
      } = props;
      let state = store.getState();
      let gl = state.gl;
      if (!state.gl) state.set({
        gl: gl = createRendererInstance(glConfig, canvas)
      });
      let raycaster = state.raycaster;
      if (!raycaster) state.set({
        raycaster: raycaster = new Raycaster()
      });
      const {
        params,
        ...options
      } = raycastOptions || {};
      if (!is$1.equ(options, raycaster, shallowLoose)) applyProps(raycaster, {
        ...options
      });
      if (!is$1.equ(params, raycaster.params, shallowLoose)) applyProps(raycaster, {
        params: {
          ...raycaster.params,
          ...params
        }
      });
      if (!state.camera || state.camera === lastCamera && !is$1.equ(lastCamera, cameraOptions, shallowLoose)) {
        lastCamera = cameraOptions;
        const isCamera3 = cameraOptions instanceof Camera;
        const camera = isCamera3 ? cameraOptions : orthographic ? new OrthographicCamera(0, 0, 0, 0, 0.1, 1e3) : new PerspectiveCamera(75, 0, 0.1, 1e3);
        if (!isCamera3) {
          camera.position.z = 5;
          if (cameraOptions) {
            applyProps(camera, cameraOptions);
            if ("aspect" in cameraOptions || "left" in cameraOptions || "right" in cameraOptions || "bottom" in cameraOptions || "top" in cameraOptions) {
              camera.manual = true;
              camera.updateProjectionMatrix();
            }
          }
          if (!state.camera && !(cameraOptions != null && cameraOptions.rotation)) camera.lookAt(0, 0, 0);
        }
        state.set({
          camera
        });
        raycaster.camera = camera;
      }
      if (!state.scene) {
        let scene;
        if (sceneOptions != null && sceneOptions.isScene) {
          scene = sceneOptions;
        } else {
          scene = new Scene();
          if (sceneOptions) applyProps(scene, sceneOptions);
        }
        state.set({
          scene: prepare(scene)
        });
      }
      if (!state.xr) {
        var _gl$xr;
        const handleXRFrame = (timestamp, frame) => {
          const state2 = store.getState();
          if (state2.frameloop === "never") return;
          advance$1(timestamp, true, state2, frame);
        };
        const handleSessionChange = () => {
          const state2 = store.getState();
          state2.gl.xr.enabled = state2.gl.xr.isPresenting;
          state2.gl.xr.setAnimationLoop(state2.gl.xr.isPresenting ? handleXRFrame : null);
          if (!state2.gl.xr.isPresenting) invalidate(state2);
        };
        const xr = {
          connect() {
            const gl2 = store.getState().gl;
            gl2.xr.addEventListener("sessionstart", handleSessionChange);
            gl2.xr.addEventListener("sessionend", handleSessionChange);
          },
          disconnect() {
            const gl2 = store.getState().gl;
            gl2.xr.removeEventListener("sessionstart", handleSessionChange);
            gl2.xr.removeEventListener("sessionend", handleSessionChange);
          }
        };
        if (typeof ((_gl$xr = gl.xr) == null ? void 0 : _gl$xr.addEventListener) === "function") xr.connect();
        state.set({
          xr
        });
      }
      if (gl.shadowMap) {
        const oldEnabled = gl.shadowMap.enabled;
        const oldType = gl.shadowMap.type;
        gl.shadowMap.enabled = !!shadows;
        if (is$1.boo(shadows)) {
          gl.shadowMap.type = PCFSoftShadowMap;
        } else if (is$1.str(shadows)) {
          var _types$shadows;
          const types = {
            basic: BasicShadowMap,
            percentage: PCFShadowMap,
            soft: PCFSoftShadowMap,
            variance: VSMShadowMap
          };
          gl.shadowMap.type = (_types$shadows = types[shadows]) != null ? _types$shadows : PCFSoftShadowMap;
        } else if (is$1.obj(shadows)) {
          Object.assign(gl.shadowMap, shadows);
        }
        if (oldEnabled !== gl.shadowMap.enabled || oldType !== gl.shadowMap.type) gl.shadowMap.needsUpdate = true;
      }
      const ColorManagement2 = getColorManagement();
      if (ColorManagement2) {
        if ("enabled" in ColorManagement2) ColorManagement2.enabled = !legacy;
        else if ("legacyMode" in ColorManagement2) ColorManagement2.legacyMode = legacy;
      }
      if (!configured) {
        const LinearEncoding2 = 3e3;
        const sRGBEncoding2 = 3001;
        applyProps(gl, {
          outputEncoding: linear3 ? LinearEncoding2 : sRGBEncoding2,
          toneMapping: flat ? NoToneMapping : ACESFilmicToneMapping
        });
      }
      if (state.legacy !== legacy) state.set(() => ({
        legacy
      }));
      if (state.linear !== linear3) state.set(() => ({
        linear: linear3
      }));
      if (state.flat !== flat) state.set(() => ({
        flat
      }));
      if (glConfig && !is$1.fun(glConfig) && !isRenderer(glConfig) && !is$1.equ(glConfig, gl, shallowLoose)) applyProps(gl, glConfig);
      if (events && !state.events.handlers) state.set({
        events: events(store)
      });
      const size = computeInitialSize(canvas, propsSize);
      if (!is$1.equ(size, state.size, shallowLoose)) {
        state.setSize(size.width, size.height, size.updateStyle, size.top, size.left);
      }
      if (dpr && state.viewport.dpr !== calculateDpr(dpr)) state.setDpr(dpr);
      if (state.frameloop !== frameloop) state.setFrameloop(frameloop);
      if (!state.onPointerMissed) state.set({
        onPointerMissed
      });
      if (performance2 && !is$1.equ(performance2, state.performance, shallowLoose)) state.set((state2) => ({
        performance: {
          ...state2.performance,
          ...performance2
        }
      }));
      onCreated = onCreatedCallback;
      configured = true;
      return this;
    },
    render(children) {
      if (!configured) this.configure();
      reconciler.updateContainer(/* @__PURE__ */ jsxRuntimeExports.jsx(Provider, {
        store,
        children,
        onCreated,
        rootElement: canvas
      }), fiber, null, () => void 0);
      return store;
    },
    unmount() {
      unmountComponentAtNode(canvas);
    }
  };
}
function Provider({
  store,
  children,
  onCreated,
  rootElement
}) {
  useIsomorphicLayoutEffect$2(() => {
    const state = store.getState();
    state.set((state2) => ({
      internal: {
        ...state2.internal,
        active: true
      }
    }));
    if (onCreated) onCreated(state);
    if (!store.getState().events.connected) state.events.connect == null ? void 0 : state.events.connect(rootElement);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(context$1.Provider, {
    value: store,
    children
  });
}
function unmountComponentAtNode(canvas, callback) {
  const root2 = roots.get(canvas);
  const fiber = root2 == null ? void 0 : root2.fiber;
  if (fiber) {
    const state = root2 == null ? void 0 : root2.store.getState();
    if (state) state.internal.active = false;
    reconciler.updateContainer(null, fiber, null, () => {
      if (state) {
        setTimeout(() => {
          try {
            var _state$gl, _state$gl$renderLists, _state$gl2, _state$gl3;
            state.events.disconnect == null ? void 0 : state.events.disconnect();
            (_state$gl = state.gl) == null ? void 0 : (_state$gl$renderLists = _state$gl.renderLists) == null ? void 0 : _state$gl$renderLists.dispose == null ? void 0 : _state$gl$renderLists.dispose();
            (_state$gl2 = state.gl) == null ? void 0 : _state$gl2.forceContextLoss == null ? void 0 : _state$gl2.forceContextLoss();
            if ((_state$gl3 = state.gl) != null && _state$gl3.xr) state.xr.disconnect();
            dispose(state);
            roots.delete(canvas);
            if (callback) ;
          } catch (e2) {
          }
        }, 500);
      }
    });
  }
}
function createPortal(children, container, state) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    children,
    container,
    state
  }, container.uuid);
}
function Portal({
  state = {},
  children,
  container
}) {
  const {
    events,
    size,
    ...rest
  } = state;
  const previousRoot = useStore$1();
  const [raycaster] = reactExports.useState(() => new Raycaster());
  const [pointer] = reactExports.useState(() => new Vector2());
  const inject = reactExports.useCallback(
    (rootState, injectState) => {
      const intersect2 = {
        ...rootState
      };
      Object.keys(rootState).forEach((key) => {
        if (
          // Some props should be off-limits
          privateKeys.includes(key) || // Otherwise filter out the props that are different and let the inject layer take precedence
          // Unless the inject layer props is undefined, then we keep the root layer
          rootState[key] !== injectState[key] && injectState[key]
        ) {
          delete intersect2[key];
        }
      });
      let viewport = void 0;
      if (injectState && size) {
        const camera = injectState.camera;
        viewport = rootState.viewport.getCurrentViewport(camera, new Vector3(), size);
        if (camera !== rootState.camera) updateCamera(camera, size);
      }
      return {
        // The intersect consists of the previous root state
        ...intersect2,
        // Portals have their own scene, which forms the root, a raycaster and a pointer
        scene: container,
        raycaster,
        pointer,
        mouse: pointer,
        // Their previous root is the layer before it
        previousRoot,
        // Events, size and viewport can be overridden by the inject layer
        events: {
          ...rootState.events,
          ...injectState == null ? void 0 : injectState.events,
          ...events
        },
        size: {
          ...rootState.size,
          ...size
        },
        viewport: {
          ...rootState.viewport,
          ...viewport
        },
        ...rest
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );
  const [usePortalStore] = reactExports.useState(() => {
    const previousState = previousRoot.getState();
    const store = create$1((set, get) => ({
      ...previousState,
      scene: container,
      raycaster,
      pointer,
      mouse: pointer,
      previousRoot,
      events: {
        ...previousState.events,
        ...events
      },
      size: {
        ...previousState.size,
        ...size
      },
      ...rest,
      // Set and get refer to this root-state
      set,
      get,
      // Layers are allowed to override events
      setEvents: (events2) => set((state2) => ({
        ...state2,
        events: {
          ...state2.events,
          ...events2
        }
      }))
    }));
    return store;
  });
  reactExports.useEffect(() => {
    const unsub = previousRoot.subscribe((prev) => usePortalStore.setState((state2) => inject(prev, state2)));
    return () => {
      unsub();
    };
  }, [inject]);
  reactExports.useEffect(() => {
    usePortalStore.setState((injectState) => inject(previousRoot.getState(), injectState));
  }, [inject]);
  reactExports.useEffect(() => {
    return () => {
      usePortalStore.destroy();
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children: reconciler.createPortal(/* @__PURE__ */ jsxRuntimeExports.jsx(context$1.Provider, {
      value: usePortalStore,
      children
    }), usePortalStore, null)
  });
}
reconciler.injectIntoDevTools({
  bundleType: 0,
  rendererPackageName: "@react-three/fiber",
  version: reactExports.version
});
const DOM_EVENTS = {
  onClick: ["click", false],
  onContextMenu: ["contextmenu", false],
  onDoubleClick: ["dblclick", false],
  onWheel: ["wheel", true],
  onPointerDown: ["pointerdown", true],
  onPointerUp: ["pointerup", true],
  onPointerLeave: ["pointerleave", true],
  onPointerMove: ["pointermove", true],
  onPointerCancel: ["pointercancel", true],
  onLostPointerCapture: ["lostpointercapture", true]
};
function createPointerEvents(store) {
  const {
    handlePointer
  } = createEvents(store);
  return {
    priority: 1,
    enabled: true,
    compute(event, state, previous) {
      state.pointer.set(event.offsetX / state.size.width * 2 - 1, -(event.offsetY / state.size.height) * 2 + 1);
      state.raycaster.setFromCamera(state.pointer, state.camera);
    },
    connected: void 0,
    handlers: Object.keys(DOM_EVENTS).reduce((acc, key) => ({
      ...acc,
      [key]: handlePointer(key)
    }), {}),
    update: () => {
      var _internal$lastEvent;
      const {
        events,
        internal
      } = store.getState();
      if ((_internal$lastEvent = internal.lastEvent) != null && _internal$lastEvent.current && events.handlers) events.handlers.onPointerMove(internal.lastEvent.current);
    },
    connect: (target) => {
      var _events$handlers;
      const {
        set,
        events
      } = store.getState();
      events.disconnect == null ? void 0 : events.disconnect();
      set((state) => ({
        events: {
          ...state.events,
          connected: target
        }
      }));
      Object.entries((_events$handlers = events.handlers) != null ? _events$handlers : []).forEach(([name, event]) => {
        const [eventName, passive] = DOM_EVENTS[name];
        target.addEventListener(eventName, event, {
          passive
        });
      });
    },
    disconnect: () => {
      const {
        set,
        events
      } = store.getState();
      if (events.connected) {
        var _events$handlers2;
        Object.entries((_events$handlers2 = events.handlers) != null ? _events$handlers2 : []).forEach(([name, event]) => {
          if (events && events.connected instanceof HTMLElement) {
            const [eventName] = DOM_EVENTS[name];
            events.connected.removeEventListener(eventName, event);
          }
        });
        set((state) => ({
          events: {
            ...state.events,
            connected: void 0
          }
        }));
      }
    }
  };
}
function g$2(n2, t2) {
  let o2;
  return (...i2) => {
    window.clearTimeout(o2), o2 = window.setTimeout(() => n2(...i2), t2);
  };
}
function j$2({ debounce: n2, scroll: t2, polyfill: o2, offsetSize: i2 } = { debounce: 0, scroll: false, offsetSize: false }) {
  const a5 = o2 || (typeof window == "undefined" ? class {
  } : window.ResizeObserver);
  if (!a5) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [c2, h2] = reactExports.useState({ left: 0, top: 0, width: 0, height: 0, bottom: 0, right: 0, x: 0, y: 0 }), e2 = reactExports.useRef({ element: null, scrollContainers: null, resizeObserver: null, lastBounds: c2, orientationHandler: null }), d3 = n2 ? typeof n2 == "number" ? n2 : n2.scroll : null, f2 = n2 ? typeof n2 == "number" ? n2 : n2.resize : null, w2 = reactExports.useRef(false);
  reactExports.useEffect(() => (w2.current = true, () => void (w2.current = false)));
  const [z2, m2, s2] = reactExports.useMemo(() => {
    const r3 = () => {
      if (!e2.current.element) return;
      const { left: y2, top: C2, width: H3, height: O3, bottom: S2, right: x3, x: B2, y: R2 } = e2.current.element.getBoundingClientRect(), l2 = { left: y2, top: C2, width: H3, height: O3, bottom: S2, right: x3, x: B2, y: R2 };
      e2.current.element instanceof HTMLElement && i2 && (l2.height = e2.current.element.offsetHeight, l2.width = e2.current.element.offsetWidth), Object.freeze(l2), w2.current && !D$2(e2.current.lastBounds, l2) && h2(e2.current.lastBounds = l2);
    };
    return [r3, f2 ? g$2(r3, f2) : r3, d3 ? g$2(r3, d3) : r3];
  }, [h2, i2, d3, f2]);
  function v3() {
    e2.current.scrollContainers && (e2.current.scrollContainers.forEach((r3) => r3.removeEventListener("scroll", s2, true)), e2.current.scrollContainers = null), e2.current.resizeObserver && (e2.current.resizeObserver.disconnect(), e2.current.resizeObserver = null), e2.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e2.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e2.current.orientationHandler));
  }
  function b6() {
    e2.current.element && (e2.current.resizeObserver = new a5(s2), e2.current.resizeObserver.observe(e2.current.element), t2 && e2.current.scrollContainers && e2.current.scrollContainers.forEach((r3) => r3.addEventListener("scroll", s2, { capture: true, passive: true })), e2.current.orientationHandler = () => {
      s2();
    }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e2.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e2.current.orientationHandler));
  }
  const L2 = (r3) => {
    !r3 || r3 === e2.current.element || (v3(), e2.current.element = r3, e2.current.scrollContainers = E$2(r3), b6());
  };
  return X$2(s2, !!t2), W$2(m2), reactExports.useEffect(() => {
    v3(), b6();
  }, [t2, s2, m2]), reactExports.useEffect(() => v3, []), [L2, c2, z2];
}
function W$2(n2) {
  reactExports.useEffect(() => {
    const t2 = n2;
    return window.addEventListener("resize", t2), () => void window.removeEventListener("resize", t2);
  }, [n2]);
}
function X$2(n2, t2) {
  reactExports.useEffect(() => {
    if (t2) {
      const o2 = n2;
      return window.addEventListener("scroll", o2, { capture: true, passive: true }), () => void window.removeEventListener("scroll", o2, true);
    }
  }, [n2, t2]);
}
function E$2(n2) {
  const t2 = [];
  if (!n2 || n2 === document.body) return t2;
  const { overflow: o2, overflowX: i2, overflowY: a5 } = window.getComputedStyle(n2);
  return [o2, i2, a5].some((c2) => c2 === "auto" || c2 === "scroll") && t2.push(n2), [...t2, ...E$2(n2.parentElement)];
}
const k$2 = ["x", "y", "top", "bottom", "left", "right", "width", "height"], D$2 = (n2, t2) => k$2.every((o2) => n2[o2] === t2[o2]);
var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a5, b6) => {
  for (var prop in b6 || (b6 = {}))
    if (__hasOwnProp.call(b6, prop))
      __defNormalProp(a5, prop, b6[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b6)) {
      if (__propIsEnum.call(b6, prop))
        __defNormalProp(a5, prop, b6[prop]);
    }
  return a5;
};
var __spreadProps = (a5, b6) => __defProps(a5, __getOwnPropDescs(b6));
var _a$3, _b$1;
typeof window !== "undefined" && (((_a$3 = window.document) == null ? void 0 : _a$3.createElement) || ((_b$1 = window.navigator) == null ? void 0 : _b$1.product) === "ReactNative") ? reactExports.useLayoutEffect : reactExports.useEffect;
function traverseFiber(fiber, ascending, selector3) {
  if (!fiber)
    return;
  if (selector3(fiber) === true)
    return fiber;
  let child = fiber.child;
  while (child) {
    const match = traverseFiber(child, ascending, selector3);
    if (match)
      return match;
    child = child.sibling;
  }
}
function wrapContext(context4) {
  try {
    return Object.defineProperties(context4, {
      _currentRenderer: {
        get() {
          return null;
        },
        set() {
        }
      },
      _currentRenderer2: {
        get() {
          return null;
        },
        set() {
        }
      }
    });
  } catch (_2) {
    return context4;
  }
}
const error = console.error;
console.error = function() {
  const message = [...arguments].join("");
  if ((message == null ? void 0 : message.startsWith("Warning:")) && message.includes("useContext")) {
    console.error = error;
    return;
  }
  return error.apply(this, arguments);
};
const FiberContext = wrapContext(reactExports.createContext(null));
class FiberProvider extends reactExports.Component {
  render() {
    return /* @__PURE__ */ reactExports.createElement(FiberContext.Provider, {
      value: this._reactInternals
    }, this.props.children);
  }
}
function useFiber() {
  const root2 = reactExports.useContext(FiberContext);
  if (root2 === null)
    throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
  const id = reactExports.useId();
  const fiber = reactExports.useMemo(() => {
    for (const maybeFiber of [root2, root2 == null ? void 0 : root2.alternate]) {
      if (!maybeFiber)
        continue;
      const fiber2 = traverseFiber(maybeFiber, false, (node) => {
        let state = node.memoizedState;
        while (state) {
          if (state.memoizedState === id)
            return true;
          state = state.next;
        }
      });
      if (fiber2)
        return fiber2;
    }
  }, [root2, id]);
  return fiber;
}
function useContextMap() {
  const fiber = useFiber();
  const [contextMap] = reactExports.useState(() => /* @__PURE__ */ new Map());
  contextMap.clear();
  let node = fiber;
  while (node) {
    if (node.type && typeof node.type === "object") {
      const enableRenderableContext = node.type._context === void 0 && node.type.Provider === node.type;
      const context4 = enableRenderableContext ? node.type : node.type._context;
      if (context4 && context4 !== FiberContext && !contextMap.has(context4)) {
        contextMap.set(context4, reactExports.useContext(wrapContext(context4)));
      }
    }
    node = node.return;
  }
  return contextMap;
}
function useContextBridge$1() {
  const contextMap = useContextMap();
  return reactExports.useMemo(
    () => Array.from(contextMap.keys()).reduce(
      (Prev, context4) => (props) => /* @__PURE__ */ reactExports.createElement(Prev, null, /* @__PURE__ */ reactExports.createElement(context4.Provider, __spreadProps(__spreadValues({}, props), {
        value: contextMap.get(context4)
      }))),
      (props) => /* @__PURE__ */ reactExports.createElement(FiberProvider, __spreadValues({}, props))
    ),
    [contextMap]
  );
}
const CanvasImpl = /* @__PURE__ */ reactExports.forwardRef(function Canvas({
  children,
  fallback,
  resize,
  style,
  gl,
  events = createPointerEvents,
  eventSource,
  eventPrefix,
  shadows,
  linear: linear3,
  flat,
  legacy,
  orthographic,
  frameloop,
  dpr,
  performance: performance2,
  raycaster,
  camera,
  scene,
  onPointerMissed,
  onCreated,
  ...props
}, forwardedRef) {
  reactExports.useMemo(() => extend(THREE$2), []);
  const Bridge = useContextBridge$1();
  const [containerRef, containerRect] = j$2({
    scroll: true,
    debounce: {
      scroll: 50,
      resize: 0
    },
    ...resize
  });
  const canvasRef = reactExports.useRef(null);
  const divRef = reactExports.useRef(null);
  reactExports.useImperativeHandle(forwardedRef, () => canvasRef.current);
  const handlePointerMissed = useMutableCallback(onPointerMissed);
  const [block, setBlock] = reactExports.useState(false);
  const [error2, setError] = reactExports.useState(false);
  if (block) throw block;
  if (error2) throw error2;
  const root2 = reactExports.useRef(null);
  useIsomorphicLayoutEffect$2(() => {
    const canvas = canvasRef.current;
    if (containerRect.width > 0 && containerRect.height > 0 && canvas) {
      if (!root2.current) root2.current = createRoot(canvas);
      root2.current.configure({
        gl,
        events,
        shadows,
        linear: linear3,
        flat,
        legacy,
        orthographic,
        frameloop,
        dpr,
        performance: performance2,
        raycaster,
        camera,
        scene,
        size: containerRect,
        // Pass mutable reference to onPointerMissed so it's free to update
        onPointerMissed: (...args) => handlePointerMissed.current == null ? void 0 : handlePointerMissed.current(...args),
        onCreated: (state) => {
          state.events.connect == null ? void 0 : state.events.connect(eventSource ? isRef$1(eventSource) ? eventSource.current : eventSource : divRef.current);
          if (eventPrefix) {
            state.setEvents({
              compute: (event, state2) => {
                const x3 = event[eventPrefix + "X"];
                const y2 = event[eventPrefix + "Y"];
                state2.pointer.set(x3 / state2.size.width * 2 - 1, -(y2 / state2.size.height) * 2 + 1);
                state2.raycaster.setFromCamera(state2.pointer, state2.camera);
              }
            });
          }
          onCreated == null ? void 0 : onCreated(state);
        }
      });
      root2.current.render(/* @__PURE__ */ jsxRuntimeExports.jsx(Bridge, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary$1, {
          set: setError,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(reactExports.Suspense, {
            fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Block, {
              set: setBlock
            }),
            children: children != null ? children : null
          })
        })
      }));
    }
  });
  reactExports.useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) return () => unmountComponentAtNode(canvas);
  }, []);
  const pointerEvents = eventSource ? "none" : "auto";
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    ref: divRef,
    style: {
      position: "relative",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      pointerEvents,
      ...style
    },
    ...props,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: containerRef,
      style: {
        width: "100%",
        height: "100%"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", {
        ref: canvasRef,
        style: {
          display: "block"
        },
        children: fallback
      })
    })
  });
});
const Canvas2 = /* @__PURE__ */ reactExports.forwardRef(function CanvasWrapper(props, ref) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FiberProvider, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(CanvasImpl, {
      ...props,
      ref
    })
  });
});
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var t2 = arguments[e2];
      for (var r3 in t2) ({}).hasOwnProperty.call(t2, r3) && (n2[r3] = t2[r3]);
    }
    return n2;
  }, _extends$1.apply(null, arguments);
}
const createStoreImpl$1 = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const api = { setState, getState, getInitialState, subscribe };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore$1 = ((createState) => createState ? createStoreImpl$1(createState) : createStoreImpl$1);
const identity$1 = (arg) => arg;
function useStore(api, selector3 = identity$1) {
  const slice = React.useSyncExternalStore(
    api.subscribe,
    React.useCallback(() => selector3(api.getState()), [api, selector3]),
    React.useCallback(() => selector3(api.getInitialState()), [api, selector3])
  );
  React.useDebugValue(slice);
  return slice;
}
const createImpl = (createState) => {
  const api = createStore$1(createState);
  const useBoundStore = (selector3) => useStore(api, selector3);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = ((createState) => createState ? createImpl(createState) : createImpl);
let saveLastTotalLoaded = 0;
const useProgress = /* @__PURE__ */ create((set) => {
  DefaultLoadingManager.onStart = (item, loaded, total) => {
    set({
      active: true,
      item,
      loaded,
      total,
      progress: (loaded - saveLastTotalLoaded) / (total - saveLastTotalLoaded) * 100
    });
  };
  DefaultLoadingManager.onLoad = () => {
    set({
      active: false
    });
  };
  DefaultLoadingManager.onError = (item) => set((state) => ({
    errors: [...state.errors, item]
  }));
  DefaultLoadingManager.onProgress = (item, loaded, total) => {
    if (loaded === total) {
      saveLastTotalLoaded = total;
    }
    set({
      active: true,
      item,
      loaded,
      total,
      progress: (loaded - saveLastTotalLoaded) / (total - saveLastTotalLoaded) * 100 || 100
    });
  };
  return {
    errors: [],
    active: false,
    progress: 0,
    item: "",
    loaded: 0,
    total: 0
  };
});
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) arr2[i2] = arr[i2];
  return arr2;
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
new Vector2();
new Vector2();
function clamp$3(value, min, max2) {
  return Math.max(min, Math.min(max2, value));
}
function repeat(t2, length) {
  return clamp$3(t2 - Math.floor(t2 / length) * length, 0, length);
}
function deltaAngle(current, target) {
  var delta = repeat(target - current, Math.PI * 2);
  if (delta > Math.PI) delta -= Math.PI * 2;
  return delta;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var Grad = function Grad2(x3, y2, z2) {
  var _this = this;
  _classCallCheck(this, Grad2);
  _defineProperty$1(this, "dot2", function(x4, y3) {
    return _this.x * x4 + _this.y * y3;
  });
  _defineProperty$1(this, "dot3", function(x4, y3, z3) {
    return _this.x * x4 + _this.y * y3 + _this.z * z3;
  });
  this.x = x3;
  this.y = y2;
  this.z = z2;
};
var grad3 = [new Grad(1, 1, 0), new Grad(-1, 1, 0), new Grad(1, -1, 0), new Grad(-1, -1, 0), new Grad(1, 0, 1), new Grad(-1, 0, 1), new Grad(1, 0, -1), new Grad(-1, 0, -1), new Grad(0, 1, 1), new Grad(0, -1, 1), new Grad(0, 1, -1), new Grad(0, -1, -1)];
var p$2 = [151, 160, 137, 91, 90, 15, 131, 13, 201, 95, 96, 53, 194, 233, 7, 225, 140, 36, 103, 30, 69, 142, 8, 99, 37, 240, 21, 10, 23, 190, 6, 148, 247, 120, 234, 75, 0, 26, 197, 62, 94, 252, 219, 203, 117, 35, 11, 32, 57, 177, 33, 88, 237, 149, 56, 87, 174, 20, 125, 136, 171, 168, 68, 175, 74, 165, 71, 134, 139, 48, 27, 166, 77, 146, 158, 231, 83, 111, 229, 122, 60, 211, 133, 230, 220, 105, 92, 41, 55, 46, 245, 40, 244, 102, 143, 54, 65, 25, 63, 161, 1, 216, 80, 73, 209, 76, 132, 187, 208, 89, 18, 169, 200, 196, 135, 130, 116, 188, 159, 86, 164, 100, 109, 198, 173, 186, 3, 64, 52, 217, 226, 250, 124, 123, 5, 202, 38, 147, 118, 126, 255, 82, 85, 212, 207, 206, 59, 227, 47, 16, 58, 17, 182, 189, 28, 42, 223, 183, 170, 213, 119, 248, 152, 2, 44, 154, 163, 70, 221, 153, 101, 155, 167, 43, 172, 9, 129, 22, 39, 253, 19, 98, 108, 110, 79, 113, 224, 232, 178, 185, 112, 104, 218, 246, 97, 228, 251, 34, 242, 193, 238, 210, 144, 12, 191, 179, 162, 241, 81, 51, 145, 235, 249, 14, 239, 107, 49, 192, 214, 31, 181, 199, 106, 157, 184, 84, 204, 176, 115, 121, 50, 45, 127, 4, 150, 254, 138, 236, 205, 93, 222, 114, 67, 29, 24, 72, 243, 141, 128, 195, 78, 66, 215, 61, 156, 180];
var perm = new Array(512);
var gradP = new Array(512);
var seed = function seed2(_seed2) {
  if (_seed2 > 0 && _seed2 < 1) {
    _seed2 *= 65536;
  }
  _seed2 = Math.floor(_seed2);
  if (_seed2 < 256) {
    _seed2 |= _seed2 << 8;
  }
  for (var i2 = 0; i2 < 256; i2++) {
    var v3;
    if (i2 & 1) {
      v3 = p$2[i2] ^ _seed2 & 255;
    } else {
      v3 = p$2[i2] ^ _seed2 >> 8 & 255;
    }
    perm[i2] = perm[i2 + 256] = v3;
    gradP[i2] = gradP[i2 + 256] = grad3[v3 % 12];
  }
};
seed(0);
function normalizeSeed(seed3) {
  if (typeof seed3 === "number") {
    seed3 = Math.abs(seed3);
  } else if (typeof seed3 === "string") {
    var string = seed3;
    seed3 = 0;
    for (var i2 = 0; i2 < string.length; i2++) {
      seed3 = (seed3 + (i2 + 1) * (string.charCodeAt(i2) % 96)) % 2147483647;
    }
  }
  if (seed3 === 0) {
    seed3 = 311;
  }
  return seed3;
}
function lcgRandom(seed3) {
  var state = normalizeSeed(seed3);
  return function() {
    var result = state * 48271 % 2147483647;
    state = result;
    return result / 2147483647;
  };
}
var Generator = function Generator2(_seed2) {
  var _this = this;
  _classCallCheck(this, Generator2);
  _defineProperty$1(this, "seed", 0);
  _defineProperty$1(this, "init", function(seed3) {
    _this.seed = seed3;
    _this.value = lcgRandom(seed3);
  });
  _defineProperty$1(this, "value", lcgRandom(this.seed));
  this.init(_seed2);
};
new Generator(Math.random());
var rsqw = function rsqw2(t2) {
  var delta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.01;
  var a5 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  var f2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1 / (2 * Math.PI);
  return a5 / Math.atan(1 / delta) * Math.atan(Math.sin(2 * Math.PI * t2 * f2) / delta);
};
var exp = function exp2(t2) {
  return 1 / (1 + t2 + 0.48 * t2 * t2 + 0.235 * t2 * t2 * t2);
};
var linear = function linear2(t2) {
  return t2;
};
var sine = {
  "in": function _in(x3) {
    return 1 - Math.cos(x3 * Math.PI / 2);
  },
  out: function out(x3) {
    return Math.sin(x3 * Math.PI / 2);
  },
  inOut: function inOut(x3) {
    return -(Math.cos(Math.PI * x3) - 1) / 2;
  }
};
var cubic = {
  "in": function _in2(x3) {
    return x3 * x3 * x3;
  },
  out: function out2(x3) {
    return 1 - Math.pow(1 - x3, 3);
  },
  inOut: function inOut2(x3) {
    return x3 < 0.5 ? 4 * x3 * x3 * x3 : 1 - Math.pow(-2 * x3 + 2, 3) / 2;
  }
};
var quint = {
  "in": function _in3(x3) {
    return x3 * x3 * x3 * x3 * x3;
  },
  out: function out3(x3) {
    return 1 - Math.pow(1 - x3, 5);
  },
  inOut: function inOut3(x3) {
    return x3 < 0.5 ? 16 * x3 * x3 * x3 * x3 * x3 : 1 - Math.pow(-2 * x3 + 2, 5) / 2;
  }
};
var circ = {
  "in": function _in4(x3) {
    return 1 - Math.sqrt(1 - Math.pow(x3, 2));
  },
  out: function out4(x3) {
    return Math.sqrt(1 - Math.pow(x3 - 1, 2));
  },
  inOut: function inOut4(x3) {
    return x3 < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x3, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x3 + 2, 2)) + 1) / 2;
  }
};
var quart = {
  "in": function _in5(t2) {
    return t2 * t2 * t2 * t2;
  },
  out: function out5(t2) {
    return 1 - --t2 * t2 * t2 * t2;
  },
  inOut: function inOut5(t2) {
    return t2 < 0.5 ? 8 * t2 * t2 * t2 * t2 : 1 - 8 * --t2 * t2 * t2 * t2;
  }
};
var expo = {
  "in": function _in6(x3) {
    return x3 === 0 ? 0 : Math.pow(2, 10 * x3 - 10);
  },
  out: function out6(x3) {
    return x3 === 1 ? 1 : 1 - Math.pow(2, -10 * x3);
  },
  inOut: function inOut6(x3) {
    return x3 === 0 ? 0 : x3 === 1 ? 1 : x3 < 0.5 ? Math.pow(2, 20 * x3 - 10) / 2 : (2 - Math.pow(2, -20 * x3 + 10)) / 2;
  }
};
function damp(current, prop, target) {
  var smoothTime = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.25;
  var delta = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.01;
  var maxSpeed = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : Infinity;
  var easing2 = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : exp;
  var eps = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 1e-3;
  var vel = "velocity_" + prop;
  if (current.__damp === void 0) current.__damp = {};
  if (current.__damp[vel] === void 0) current.__damp[vel] = 0;
  if (Math.abs(current[prop] - target) <= eps) {
    current[prop] = target;
    return false;
  }
  smoothTime = Math.max(1e-4, smoothTime);
  var omega = 2 / smoothTime;
  var t2 = easing2(omega * delta);
  var change = current[prop] - target;
  var originalTo = target;
  var maxChange = maxSpeed * smoothTime;
  change = Math.min(Math.max(change, -maxChange), maxChange);
  target = current[prop] - change;
  var temp = (current.__damp[vel] + omega * change) * delta;
  current.__damp[vel] = (current.__damp[vel] - omega * temp) * t2;
  var output = target + (change + temp) * t2;
  if (originalTo - current[prop] > 0 === output > originalTo) {
    output = originalTo;
    current.__damp[vel] = (output - originalTo) / delta;
  }
  current[prop] = output;
  return true;
}
var isCamera = function isCamera2(v3) {
  return v3 && v3.isCamera;
};
var isLight = function isLight2(v3) {
  return v3 && v3.isLight;
};
var vl3d = /* @__PURE__ */ new Vector3();
var _q1 = /* @__PURE__ */ new Quaternion();
var _q2 = /* @__PURE__ */ new Quaternion();
var _m1 = /* @__PURE__ */ new Matrix4();
var _position$1 = /* @__PURE__ */ new Vector3();
function dampLookAt(current, target, smoothTime, delta, maxSpeed, easing2, eps) {
  if (typeof target === "number") vl3d.setScalar(target);
  else if (Array.isArray(target)) vl3d.set(target[0], target[1], target[2]);
  else vl3d.copy(target);
  var parent = current.parent;
  current.updateWorldMatrix(true, false);
  _position$1.setFromMatrixPosition(current.matrixWorld);
  if (isCamera(current) || isLight(current)) _m1.lookAt(_position$1, vl3d, current.up);
  else _m1.lookAt(vl3d, _position$1, current.up);
  dampQ(current.quaternion, _q2.setFromRotationMatrix(_m1), smoothTime, delta, maxSpeed, easing2, eps);
  if (parent) {
    _m1.extractRotation(parent.matrixWorld);
    _q1.setFromRotationMatrix(_m1);
    dampQ(current.quaternion, _q2.copy(current.quaternion).premultiply(_q1.invert()), smoothTime, delta, maxSpeed, easing2, eps);
  }
}
function dampAngle(current, prop, target, smoothTime, delta, maxSpeed, easing2, eps) {
  return damp(current, prop, current[prop] + deltaAngle(current[prop], target), smoothTime, delta, maxSpeed, easing2, eps);
}
var v2d = /* @__PURE__ */ new Vector2();
var a2, b2;
function damp2(current, target, smoothTime, delta, maxSpeed, easing2, eps) {
  if (typeof target === "number") v2d.setScalar(target);
  else if (Array.isArray(target)) v2d.set(target[0], target[1]);
  else v2d.copy(target);
  a2 = damp(current, "x", v2d.x, smoothTime, delta, maxSpeed, easing2, eps);
  b2 = damp(current, "y", v2d.y, smoothTime, delta, maxSpeed, easing2, eps);
  return a2 || b2;
}
var v3d = /* @__PURE__ */ new Vector3();
var a3, b3, c3;
function damp3(current, target, smoothTime, delta, maxSpeed, easing2, eps) {
  if (typeof target === "number") v3d.setScalar(target);
  else if (Array.isArray(target)) v3d.set(target[0], target[1], target[2]);
  else v3d.copy(target);
  a3 = damp(current, "x", v3d.x, smoothTime, delta, maxSpeed, easing2, eps);
  b3 = damp(current, "y", v3d.y, smoothTime, delta, maxSpeed, easing2, eps);
  c3 = damp(current, "z", v3d.z, smoothTime, delta, maxSpeed, easing2, eps);
  return a3 || b3 || c3;
}
var v4d = /* @__PURE__ */ new Vector4();
var a4, b4, c4, d4;
function damp4(current, target, smoothTime, delta, maxSpeed, easing2, eps) {
  if (typeof target === "number") v4d.setScalar(target);
  else if (Array.isArray(target)) v4d.set(target[0], target[1], target[2], target[3]);
  else v4d.copy(target);
  a4 = damp(current, "x", v4d.x, smoothTime, delta, maxSpeed, easing2, eps);
  b4 = damp(current, "y", v4d.y, smoothTime, delta, maxSpeed, easing2, eps);
  c4 = damp(current, "z", v4d.z, smoothTime, delta, maxSpeed, easing2, eps);
  d4 = damp(current, "w", v4d.w, smoothTime, delta, maxSpeed, easing2, eps);
  return a4 || b4 || c4 || d4;
}
var rot = /* @__PURE__ */ new Euler();
var aE, bE, cE;
function dampE(current, target, smoothTime, delta, maxSpeed, easing2, eps) {
  if (Array.isArray(target)) rot.set(target[0], target[1], target[2], target[3]);
  else rot.copy(target);
  aE = dampAngle(current, "x", rot.x, smoothTime, delta, maxSpeed, easing2, eps);
  bE = dampAngle(current, "y", rot.y, smoothTime, delta, maxSpeed, easing2, eps);
  cE = dampAngle(current, "z", rot.z, smoothTime, delta, maxSpeed, easing2, eps);
  return aE || bE || cE;
}
var col = /* @__PURE__ */ new Color();
var aC, bC, cC;
function dampC(current, target, smoothTime, delta, maxSpeed, easing2, eps) {
  if (target instanceof Color) col.copy(target);
  else if (Array.isArray(target)) col.setRGB(target[0], target[1], target[2]);
  else col.set(target);
  aC = damp(current, "r", col.r, smoothTime, delta, maxSpeed, easing2, eps);
  bC = damp(current, "g", col.g, smoothTime, delta, maxSpeed, easing2, eps);
  cC = damp(current, "b", col.b, smoothTime, delta, maxSpeed, easing2, eps);
  return aC || bC || cC;
}
var qt = /* @__PURE__ */ new Quaternion();
var v4result = /* @__PURE__ */ new Vector4();
var v4velocity = /* @__PURE__ */ new Vector4();
var v4error = /* @__PURE__ */ new Vector4();
var aQ, bQ, cQ, dQ;
function dampQ(current, target, smoothTime, delta, maxSpeed, easing2, eps) {
  var cur = current;
  if (Array.isArray(target)) qt.set(target[0], target[1], target[2], target[3]);
  else qt.copy(target);
  var multi = current.dot(qt) > 0 ? 1 : -1;
  qt.x *= multi;
  qt.y *= multi;
  qt.z *= multi;
  qt.w *= multi;
  aQ = damp(current, "x", qt.x, smoothTime, delta, maxSpeed, easing2, eps);
  bQ = damp(current, "y", qt.y, smoothTime, delta, maxSpeed, easing2, eps);
  cQ = damp(current, "z", qt.z, smoothTime, delta, maxSpeed, easing2, eps);
  dQ = damp(current, "w", qt.w, smoothTime, delta, maxSpeed, easing2, eps);
  v4result.set(current.x, current.y, current.z, current.w).normalize();
  v4velocity.set(cur.__damp.velocity_x, cur.__damp.velocity_y, cur.__damp.velocity_z, cur.__damp.velocity_w);
  v4error.copy(v4result).multiplyScalar(v4velocity.dot(v4result) / v4result.dot(v4result));
  cur.__damp.velocity_x -= v4error.x;
  cur.__damp.velocity_y -= v4error.y;
  cur.__damp.velocity_z -= v4error.z;
  cur.__damp.velocity_w -= v4error.w;
  current.set(v4result.x, v4result.y, v4result.z, v4result.w);
  return aQ || bQ || cQ || dQ;
}
var spherical = /* @__PURE__ */ new Spherical();
var aS, bS, cS;
function dampS(current, target, smoothTime, delta, maxSpeed, easing2, eps) {
  if (Array.isArray(target)) spherical.set(target[0], target[1], target[2]);
  else spherical.copy(target);
  aS = damp(current, "radius", spherical.radius, smoothTime, delta, maxSpeed, easing2, eps);
  bS = dampAngle(current, "phi", spherical.phi, smoothTime, delta, maxSpeed, easing2, eps);
  cS = dampAngle(current, "theta", spherical.theta, smoothTime, delta, maxSpeed, easing2, eps);
  return aS || bS || cS;
}
var mat = /* @__PURE__ */ new Matrix4();
var mPos = /* @__PURE__ */ new Vector3();
var mRot = /* @__PURE__ */ new Quaternion();
var mSca = /* @__PURE__ */ new Vector3();
var aM, bM, cM;
function dampM(current, target, smoothTime, delta, maxSpeed, easing2, eps) {
  var cur = current;
  if (cur.__damp === void 0) {
    cur.__damp = {
      position: new Vector3(),
      rotation: new Quaternion(),
      scale: new Vector3()
    };
    current.decompose(cur.__damp.position, cur.__damp.rotation, cur.__damp.scale);
  }
  if (Array.isArray(target)) mat.set.apply(mat, _toConsumableArray(target));
  else mat.copy(target);
  mat.decompose(mPos, mRot, mSca);
  aM = damp3(cur.__damp.position, mPos, smoothTime, delta, maxSpeed, easing2, eps);
  bM = dampQ(cur.__damp.rotation, mRot, smoothTime, delta, maxSpeed, easing2, eps);
  cM = damp3(cur.__damp.scale, mSca, smoothTime, delta, maxSpeed, easing2, eps);
  current.compose(cur.__damp.position, cur.__damp.rotation, cur.__damp.scale);
  return aM || bM || cM;
}
var easing = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  rsqw,
  exp,
  linear,
  sine,
  cubic,
  quint,
  circ,
  quart,
  expo,
  damp,
  dampLookAt,
  dampAngle,
  damp2,
  damp3,
  damp4,
  dampE,
  dampC,
  dampQ,
  dampS,
  dampM
});
const context = /* @__PURE__ */ reactExports.createContext(null);
function useScroll() {
  return reactExports.useContext(context);
}
function ScrollControls({
  eps = 1e-5,
  enabled = true,
  infinite,
  horizontal,
  pages = 1,
  distance = 1,
  damping = 0.25,
  maxSpeed = Infinity,
  prepend = false,
  style = {},
  children
}) {
  const {
    get,
    setEvents,
    gl,
    size,
    invalidate: invalidate2,
    events
  } = useThree();
  const [el] = reactExports.useState(() => document.createElement("div"));
  const [fill2] = reactExports.useState(() => document.createElement("div"));
  const [fixed] = reactExports.useState(() => document.createElement("div"));
  const target = gl.domElement.parentNode;
  const scroll = reactExports.useRef(0);
  const state = reactExports.useMemo(() => {
    const state2 = {
      el,
      eps,
      fill: fill2,
      fixed,
      horizontal,
      damping,
      offset: 0,
      delta: 0,
      scroll,
      pages,
      // 0-1 for a range between from -> from + distance
      range(from, distance2, margin = 0) {
        const start2 = from - margin;
        const end = start2 + distance2 + margin * 2;
        return this.offset < start2 ? 0 : this.offset > end ? 1 : (this.offset - start2) / (end - start2);
      },
      // 0-1-0 for a range between from -> from + distance
      curve(from, distance2, margin = 0) {
        return Math.sin(this.range(from, distance2, margin) * Math.PI);
      },
      // true/false for a range between from -> from + distance
      visible(from, distance2, margin = 0) {
        const start2 = from - margin;
        const end = start2 + distance2 + margin * 2;
        return this.offset >= start2 && this.offset <= end;
      }
    };
    return state2;
  }, [eps, damping, horizontal, pages]);
  reactExports.useEffect(() => {
    el.style.position = "absolute";
    el.style.width = "100%";
    el.style.height = "100%";
    el.style[horizontal ? "overflowX" : "overflowY"] = "auto";
    el.style[horizontal ? "overflowY" : "overflowX"] = "hidden";
    el.style.top = "0px";
    el.style.left = "0px";
    for (const key in style) {
      el.style[key] = style[key];
    }
    fixed.style.position = "sticky";
    fixed.style.top = "0px";
    fixed.style.left = "0px";
    fixed.style.width = "100%";
    fixed.style.height = "100%";
    fixed.style.overflow = "hidden";
    el.appendChild(fixed);
    fill2.style.height = horizontal ? "100%" : `${pages * distance * 100}%`;
    fill2.style.width = horizontal ? `${pages * distance * 100}%` : "100%";
    fill2.style.pointerEvents = "none";
    el.appendChild(fill2);
    if (prepend) target.prepend(el);
    else target.appendChild(el);
    el[horizontal ? "scrollLeft" : "scrollTop"] = 1;
    const oldTarget = events.connected || gl.domElement;
    requestAnimationFrame(() => events.connect == null ? void 0 : events.connect(el));
    const oldCompute = get().events.compute;
    setEvents({
      compute(event, state2) {
        const {
          left,
          top
        } = target.getBoundingClientRect();
        const offsetX = event.clientX - left;
        const offsetY = event.clientY - top;
        state2.pointer.set(offsetX / state2.size.width * 2 - 1, -(offsetY / state2.size.height) * 2 + 1);
        state2.raycaster.setFromCamera(state2.pointer, state2.camera);
      }
    });
    return () => {
      target.removeChild(el);
      setEvents({
        compute: oldCompute
      });
      events.connect == null || events.connect(oldTarget);
    };
  }, [pages, distance, horizontal, el, fill2, fixed, target]);
  reactExports.useEffect(() => {
    if (events.connected === el) {
      const containerLength = size[horizontal ? "width" : "height"];
      const scrollLength = el[horizontal ? "scrollWidth" : "scrollHeight"];
      const scrollThreshold = scrollLength - containerLength;
      let current = 0;
      let disableScroll = true;
      let firstRun = true;
      const onScroll = () => {
        if (!enabled || firstRun) return;
        invalidate2();
        current = el[horizontal ? "scrollLeft" : "scrollTop"];
        scroll.current = current / scrollThreshold;
        if (infinite) {
          if (!disableScroll) {
            if (current >= scrollThreshold) {
              const damp5 = 1 - state.offset;
              el[horizontal ? "scrollLeft" : "scrollTop"] = 1;
              scroll.current = state.offset = -damp5;
              disableScroll = true;
            } else if (current <= 0) {
              const damp5 = 1 + state.offset;
              el[horizontal ? "scrollLeft" : "scrollTop"] = scrollLength;
              scroll.current = state.offset = damp5;
              disableScroll = true;
            }
          }
          if (disableScroll) setTimeout(() => disableScroll = false, 40);
        }
      };
      el.addEventListener("scroll", onScroll, {
        passive: true
      });
      requestAnimationFrame(() => firstRun = false);
      const onWheel = (e2) => el.scrollLeft += e2.deltaY / 2;
      if (horizontal) el.addEventListener("wheel", onWheel, {
        passive: true
      });
      return () => {
        el.removeEventListener("scroll", onScroll);
        if (horizontal) el.removeEventListener("wheel", onWheel);
      };
    }
  }, [el, events, size, infinite, state, invalidate2, horizontal, enabled]);
  let last = 0;
  useFrame((_2, delta) => {
    last = state.offset;
    easing.damp(state, "offset", scroll.current, damping, delta, maxSpeed, void 0, eps);
    easing.damp(state, "delta", Math.abs(last - state.offset), damping, delta, maxSpeed, void 0, eps);
    if (state.delta > eps) invalidate2();
  });
  return /* @__PURE__ */ reactExports.createElement(context.Provider, {
    value: state
  }, children);
}
const ScrollCanvas = /* @__PURE__ */ reactExports.forwardRef(({
  children
}, ref) => {
  const group = reactExports.useRef(null);
  reactExports.useImperativeHandle(ref, () => group.current, []);
  const state = useScroll();
  const {
    width,
    height
  } = useThree((state2) => state2.viewport);
  useFrame(() => {
    group.current.position.x = state.horizontal ? -width * (state.pages - 1) * state.offset : 0;
    group.current.position.y = state.horizontal ? 0 : height * (state.pages - 1) * state.offset;
  });
  return /* @__PURE__ */ reactExports.createElement("group", {
    ref: group
  }, children);
});
const ScrollHtml = /* @__PURE__ */ reactExports.forwardRef(({
  children,
  style,
  ...props
}, ref) => {
  const state = useScroll();
  const group = reactExports.useRef(null);
  reactExports.useImperativeHandle(ref, () => group.current, []);
  const {
    width,
    height
  } = useThree((state2) => state2.size);
  const fiberState = reactExports.useContext(context$1);
  const root2 = reactExports.useMemo(() => clientExports.createRoot(state.fixed), [state.fixed]);
  useFrame(() => {
    if (state.delta > state.eps) {
      group.current.style.transform = `translate3d(${state.horizontal ? -width * (state.pages - 1) * state.offset : 0}px,${state.horizontal ? 0 : height * (state.pages - 1) * -state.offset}px,0)`;
    }
  });
  root2.render(/* @__PURE__ */ reactExports.createElement("div", _extends$1({
    ref: group,
    style: {
      ...style,
      position: "absolute",
      top: 0,
      left: 0,
      willChange: "transform"
    }
  }, props), /* @__PURE__ */ reactExports.createElement(context.Provider, {
    value: state
  }, /* @__PURE__ */ reactExports.createElement(context$1.Provider, {
    value: fiberState
  }, children))));
  return null;
});
const Scroll = /* @__PURE__ */ reactExports.forwardRef(({
  html,
  ...props
}, ref) => {
  const El = html ? ScrollHtml : ScrollCanvas;
  return /* @__PURE__ */ reactExports.createElement(El, _extends$1({
    ref
  }, props));
});
const version = /* @__PURE__ */ (() => parseInt(REVISION.replace(/\D+/g, "")))();
function toTrianglesDrawMode(geometry, drawMode) {
  if (drawMode === TrianglesDrawMode) {
    console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
    return geometry;
  }
  if (drawMode === TriangleFanDrawMode || drawMode === TriangleStripDrawMode) {
    let index = geometry.getIndex();
    if (index === null) {
      const indices = [];
      const position = geometry.getAttribute("position");
      if (position !== void 0) {
        for (let i2 = 0; i2 < position.count; i2++) {
          indices.push(i2);
        }
        geometry.setIndex(indices);
        index = geometry.getIndex();
      } else {
        console.error(
          "THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."
        );
        return geometry;
      }
    }
    const numberOfTriangles = index.count - 2;
    const newIndices = [];
    if (index) {
      if (drawMode === TriangleFanDrawMode) {
        for (let i2 = 1; i2 <= numberOfTriangles; i2++) {
          newIndices.push(index.getX(0));
          newIndices.push(index.getX(i2));
          newIndices.push(index.getX(i2 + 1));
        }
      } else {
        for (let i2 = 0; i2 < numberOfTriangles; i2++) {
          if (i2 % 2 === 0) {
            newIndices.push(index.getX(i2));
            newIndices.push(index.getX(i2 + 1));
            newIndices.push(index.getX(i2 + 2));
          } else {
            newIndices.push(index.getX(i2 + 2));
            newIndices.push(index.getX(i2 + 1));
            newIndices.push(index.getX(i2));
          }
        }
      }
    }
    if (newIndices.length / 3 !== numberOfTriangles) {
      console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
    }
    const newGeometry = geometry.clone();
    newGeometry.setIndex(newIndices);
    newGeometry.clearGroups();
    return newGeometry;
  } else {
    console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
    return geometry;
  }
}
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
var fleb = new u8([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]);
var fdeb = new u8([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]);
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var freb = function(eb, start2) {
  var b6 = new u16(31);
  for (var i2 = 0; i2 < 31; ++i2) {
    b6[i2] = start2 += 1 << eb[i2 - 1];
  }
  var r3 = new u32(b6[30]);
  for (var i2 = 1; i2 < 30; ++i2) {
    for (var j3 = b6[i2]; j3 < b6[i2 + 1]; ++j3) {
      r3[j3] = j3 - b6[i2] << 5 | i2;
    }
  }
  return [b6, r3];
};
var _a$2 = freb(fleb, 2), fl = _a$2[0], revfl = _a$2[1];
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0];
var rev = new u16(32768);
for (var i$2 = 0; i$2 < 32768; ++i$2) {
  var x$2 = (i$2 & 43690) >>> 1 | (i$2 & 21845) << 1;
  x$2 = (x$2 & 52428) >>> 2 | (x$2 & 13107) << 2;
  x$2 = (x$2 & 61680) >>> 4 | (x$2 & 3855) << 4;
  rev[i$2] = ((x$2 & 65280) >>> 8 | (x$2 & 255) << 8) >>> 1;
}
var hMap = (function(cd, mb, r3) {
  var s2 = cd.length;
  var i2 = 0;
  var l2 = new u16(mb);
  for (; i2 < s2; ++i2)
    ++l2[cd[i2] - 1];
  var le = new u16(mb);
  for (i2 = 0; i2 < mb; ++i2) {
    le[i2] = le[i2 - 1] + l2[i2 - 1] << 1;
  }
  var co;
  if (r3) {
    co = new u16(1 << mb);
    var rvb = 15 - mb;
    for (i2 = 0; i2 < s2; ++i2) {
      if (cd[i2]) {
        var sv = i2 << 4 | cd[i2];
        var r_1 = mb - cd[i2];
        var v3 = le[cd[i2] - 1]++ << r_1;
        for (var m2 = v3 | (1 << r_1) - 1; v3 <= m2; ++v3) {
          co[rev[v3] >>> rvb] = sv;
        }
      }
    }
  } else {
    co = new u16(s2);
    for (i2 = 0; i2 < s2; ++i2) {
      if (cd[i2]) {
        co[i2] = rev[le[cd[i2] - 1]++] >>> 15 - cd[i2];
      }
    }
  }
  return co;
});
var flt = new u8(288);
for (var i$2 = 0; i$2 < 144; ++i$2)
  flt[i$2] = 8;
for (var i$2 = 144; i$2 < 256; ++i$2)
  flt[i$2] = 9;
for (var i$2 = 256; i$2 < 280; ++i$2)
  flt[i$2] = 7;
for (var i$2 = 280; i$2 < 288; ++i$2)
  flt[i$2] = 8;
var fdt = new u8(32);
for (var i$2 = 0; i$2 < 32; ++i$2)
  fdt[i$2] = 5;
var flrm = /* @__PURE__ */ hMap(flt, 9, 1);
var fdrm = /* @__PURE__ */ hMap(fdt, 5, 1);
var max = function(a5) {
  var m2 = a5[0];
  for (var i2 = 1; i2 < a5.length; ++i2) {
    if (a5[i2] > m2)
      m2 = a5[i2];
  }
  return m2;
};
var bits = function(d3, p3, m2) {
  var o2 = p3 / 8 | 0;
  return (d3[o2] | d3[o2 + 1] << 8) >> (p3 & 7) & m2;
};
var bits16 = function(d3, p3) {
  var o2 = p3 / 8 | 0;
  return (d3[o2] | d3[o2 + 1] << 8 | d3[o2 + 2] << 16) >> (p3 & 7);
};
var shft = function(p3) {
  return (p3 / 8 | 0) + (p3 & 7 && 1);
};
var slc = function(v3, s2, e2) {
  if (e2 == null || e2 > v3.length)
    e2 = v3.length;
  var n2 = new (v3 instanceof u16 ? u16 : v3 instanceof u32 ? u32 : u8)(e2 - s2);
  n2.set(v3.subarray(s2, e2));
  return n2;
};
var inflt = function(dat, buf, st) {
  var sl = dat.length;
  if (!sl || st && !st.l && sl < 5)
    return buf || new u8(0);
  var noBuf = !buf || st;
  var noSt = !st || st.i;
  if (!st)
    st = {};
  if (!buf)
    buf = new u8(sl * 3);
  var cbuf = function(l3) {
    var bl = buf.length;
    if (l3 > bl) {
      var nbuf = new u8(Math.max(bl * 2, l3));
      nbuf.set(buf);
      buf = nbuf;
    }
  };
  var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
  var tbts = sl * 8;
  do {
    if (!lm) {
      st.f = final = bits(dat, pos, 1);
      var type = bits(dat, pos + 1, 3);
      pos += 3;
      if (!type) {
        var s2 = shft(pos) + 4, l2 = dat[s2 - 4] | dat[s2 - 3] << 8, t2 = s2 + l2;
        if (t2 > sl) {
          if (noSt)
            throw "unexpected EOF";
          break;
        }
        if (noBuf)
          cbuf(bt + l2);
        buf.set(dat.subarray(s2, t2), bt);
        st.b = bt += l2, st.p = pos = t2 * 8;
        continue;
      } else if (type == 1)
        lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
      else if (type == 2) {
        var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
        var tl = hLit + bits(dat, pos + 5, 31) + 1;
        pos += 14;
        var ldt = new u8(tl);
        var clt = new u8(19);
        for (var i2 = 0; i2 < hcLen; ++i2) {
          clt[clim[i2]] = bits(dat, pos + i2 * 3, 7);
        }
        pos += hcLen * 3;
        var clb = max(clt), clbmsk = (1 << clb) - 1;
        var clm = hMap(clt, clb, 1);
        for (var i2 = 0; i2 < tl; ) {
          var r3 = clm[bits(dat, pos, clbmsk)];
          pos += r3 & 15;
          var s2 = r3 >>> 4;
          if (s2 < 16) {
            ldt[i2++] = s2;
          } else {
            var c2 = 0, n2 = 0;
            if (s2 == 16)
              n2 = 3 + bits(dat, pos, 3), pos += 2, c2 = ldt[i2 - 1];
            else if (s2 == 17)
              n2 = 3 + bits(dat, pos, 7), pos += 3;
            else if (s2 == 18)
              n2 = 11 + bits(dat, pos, 127), pos += 7;
            while (n2--)
              ldt[i2++] = c2;
          }
        }
        var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
        lbt = max(lt);
        dbt = max(dt);
        lm = hMap(lt, lbt, 1);
        dm = hMap(dt, dbt, 1);
      } else
        throw "invalid block type";
      if (pos > tbts) {
        if (noSt)
          throw "unexpected EOF";
        break;
      }
    }
    if (noBuf)
      cbuf(bt + 131072);
    var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
    var lpos = pos;
    for (; ; lpos = pos) {
      var c2 = lm[bits16(dat, pos) & lms], sym = c2 >>> 4;
      pos += c2 & 15;
      if (pos > tbts) {
        if (noSt)
          throw "unexpected EOF";
        break;
      }
      if (!c2)
        throw "invalid length/literal";
      if (sym < 256)
        buf[bt++] = sym;
      else if (sym == 256) {
        lpos = pos, lm = null;
        break;
      } else {
        var add = sym - 254;
        if (sym > 264) {
          var i2 = sym - 257, b6 = fleb[i2];
          add = bits(dat, pos, (1 << b6) - 1) + fl[i2];
          pos += b6;
        }
        var d3 = dm[bits16(dat, pos) & dms], dsym = d3 >>> 4;
        if (!d3)
          throw "invalid distance";
        pos += d3 & 15;
        var dt = fd[dsym];
        if (dsym > 3) {
          var b6 = fdeb[dsym];
          dt += bits16(dat, pos) & (1 << b6) - 1, pos += b6;
        }
        if (pos > tbts) {
          if (noSt)
            throw "unexpected EOF";
          break;
        }
        if (noBuf)
          cbuf(bt + 131072);
        var end = bt + add;
        for (; bt < end; bt += 4) {
          buf[bt] = buf[bt - dt];
          buf[bt + 1] = buf[bt + 1 - dt];
          buf[bt + 2] = buf[bt + 2 - dt];
          buf[bt + 3] = buf[bt + 3 - dt];
        }
        bt = end;
      }
    }
    st.l = lm, st.p = lpos, st.b = bt;
    if (lm)
      final = 1, st.m = lbt, st.d = dm, st.n = dbt;
  } while (!final);
  return bt == buf.length ? buf : slc(buf, 0, bt);
};
var et = /* @__PURE__ */ new u8(0);
var zlv = function(d3) {
  if ((d3[0] & 15) != 8 || d3[0] >>> 4 > 7 || (d3[0] << 8 | d3[1]) % 31)
    throw "invalid zlib data";
  if (d3[1] & 32)
    throw "invalid zlib data: preset dictionaries not supported";
};
function unzlibSync(data, out7) {
  return inflt((zlv(data), data.subarray(2, -4)), out7);
}
var td = typeof TextDecoder != "undefined" && /* @__PURE__ */ new TextDecoder();
var tds = 0;
try {
  td.decode(et, { stream: true });
  tds = 1;
} catch (e2) {
}
const isCubeTexture = (def) => def && def.isCubeTexture;
class GroundProjectedEnv extends Mesh {
  constructor(texture, options) {
    var _a2, _b2;
    const isCubeMap = isCubeTexture(texture);
    const w2 = (_b2 = isCubeMap ? (_a2 = texture.image[0]) == null ? void 0 : _a2.width : texture.image.width) != null ? _b2 : 1024;
    const cubeSize = w2 / 4;
    const _lodMax = Math.floor(Math.log2(cubeSize));
    const _cubeSize = Math.pow(2, _lodMax);
    const width = 3 * Math.max(_cubeSize, 16 * 7);
    const height = 4 * _cubeSize;
    const defines = [
      isCubeMap ? "#define ENVMAP_TYPE_CUBE" : "",
      `#define CUBEUV_TEXEL_WIDTH ${1 / width}`,
      `#define CUBEUV_TEXEL_HEIGHT ${1 / height}`,
      `#define CUBEUV_MAX_MIP ${_lodMax}.0`
    ];
    const vertexShader2 = (
      /* glsl */
      `
        varying vec3 vWorldPosition;
        void main() 
        {
            vec4 worldPosition = ( modelMatrix * vec4( position, 1.0 ) );
            vWorldPosition = worldPosition.xyz;
            
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
        `
    );
    const fragmentShader2 = defines.join("\n") + /* glsl */
    `
        #define ENVMAP_TYPE_CUBE_UV
        varying vec3 vWorldPosition;
        uniform float radius;
        uniform float height;
        uniform float angle;
        #ifdef ENVMAP_TYPE_CUBE
            uniform samplerCube map;
        #else
            uniform sampler2D map;
        #endif
        // From: https://www.shadertoy.com/view/4tsBD7
        float diskIntersectWithBackFaceCulling( vec3 ro, vec3 rd, vec3 c, vec3 n, float r ) 
        {
            float d = dot ( rd, n );
            
            if( d > 0.0 ) { return 1e6; }
            
            vec3  o = ro - c;
            float t = - dot( n, o ) / d;
            vec3  q = o + rd * t;
            
            return ( dot( q, q ) < r * r ) ? t : 1e6;
        }
        // From: https://www.iquilezles.org/www/articles/intersectors/intersectors.htm
        float sphereIntersect( vec3 ro, vec3 rd, vec3 ce, float ra ) 
        {
            vec3 oc = ro - ce;
            float b = dot( oc, rd );
            float c = dot( oc, oc ) - ra * ra;
            float h = b * b - c;
            
            if( h < 0.0 ) { return -1.0; }
            
            h = sqrt( h );
            
            return - b + h;
        }
        vec3 project() 
        {
            vec3 p = normalize( vWorldPosition );
            vec3 camPos = cameraPosition;
            camPos.y -= height;
            float intersection = sphereIntersect( camPos, p, vec3( 0.0 ), radius );
            if( intersection > 0.0 ) {
                
                vec3 h = vec3( 0.0, - height, 0.0 );
                float intersection2 = diskIntersectWithBackFaceCulling( camPos, p, h, vec3( 0.0, 1.0, 0.0 ), radius );
                p = ( camPos + min( intersection, intersection2 ) * p ) / radius;
            } else {
                p = vec3( 0.0, 1.0, 0.0 );
            }
            return p;
        }
        #include <common>
        #include <cube_uv_reflection_fragment>
        void main() 
        {
            vec3 projectedWorldPosition = project();
            
            #ifdef ENVMAP_TYPE_CUBE
                vec3 outcolor = textureCube( map, projectedWorldPosition ).rgb;
            #else
                vec3 direction = normalize( projectedWorldPosition );
                vec2 uv = equirectUv( direction );
                vec3 outcolor = texture2D( map, uv ).rgb;
            #endif
            gl_FragColor = vec4( outcolor, 1.0 );
            #include <tonemapping_fragment>
            #include <${version >= 154 ? "colorspace_fragment" : "encodings_fragment"}>
        }
        `;
    const uniforms = {
      map: { value: texture },
      height: { value: (options == null ? void 0 : options.height) || 15 },
      radius: { value: (options == null ? void 0 : options.radius) || 100 }
    };
    const geometry = new IcosahedronGeometry(1, 16);
    const material = new ShaderMaterial({
      uniforms,
      fragmentShader: fragmentShader2,
      vertexShader: vertexShader2,
      side: DoubleSide
    });
    super(geometry, material);
  }
  set radius(radius) {
    this.material.uniforms.radius.value = radius;
  }
  get radius() {
    return this.material.uniforms.radius.value;
  }
  set height(height) {
    this.material.uniforms.height.value = height;
  }
  get height() {
    return this.material.uniforms.height.value;
  }
}
function decodeText(array) {
  if (typeof TextDecoder !== "undefined") {
    return new TextDecoder().decode(array);
  }
  let s2 = "";
  for (let i2 = 0, il = array.length; i2 < il; i2++) {
    s2 += String.fromCharCode(array[i2]);
  }
  try {
    return decodeURIComponent(escape(s2));
  } catch (e2) {
    return s2;
  }
}
const SRGBColorSpace = "srgb";
const LinearSRGBColorSpace = "srgb-linear";
const sRGBEncoding$1 = 3001;
const LinearEncoding$1 = 3e3;
class GLTFLoader extends Loader {
  constructor(manager) {
    super(manager);
    this.dracoLoader = null;
    this.ktx2Loader = null;
    this.meshoptDecoder = null;
    this.pluginCallbacks = [];
    this.register(function(parser) {
      return new GLTFMaterialsClearcoatExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsDispersionExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureBasisUExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureWebPExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureAVIFExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsSheenExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsTransmissionExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsVolumeExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsIorExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsEmissiveStrengthExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsSpecularExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsIridescenceExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsAnisotropyExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsBumpExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFLightsExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMeshoptCompression(parser);
    });
    this.register(function(parser) {
      return new GLTFMeshGpuInstancing(parser);
    });
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    let resourcePath;
    if (this.resourcePath !== "") {
      resourcePath = this.resourcePath;
    } else if (this.path !== "") {
      const relativeUrl = LoaderUtils.extractUrlBase(url);
      resourcePath = LoaderUtils.resolveURL(relativeUrl, this.path);
    } else {
      resourcePath = LoaderUtils.extractUrlBase(url);
    }
    this.manager.itemStart(url);
    const _onError = function(e2) {
      if (onError) {
        onError(e2);
      } else {
        console.error(e2);
      }
      scope.manager.itemError(url);
      scope.manager.itemEnd(url);
    };
    const loader = new FileLoader(this.manager);
    loader.setPath(this.path);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(
      url,
      function(data) {
        try {
          scope.parse(
            data,
            resourcePath,
            function(gltf) {
              onLoad(gltf);
              scope.manager.itemEnd(url);
            },
            _onError
          );
        } catch (e2) {
          _onError(e2);
        }
      },
      onProgress,
      _onError
    );
  }
  setDRACOLoader(dracoLoader2) {
    this.dracoLoader = dracoLoader2;
    return this;
  }
  setDDSLoader() {
    throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
  }
  setKTX2Loader(ktx2Loader) {
    this.ktx2Loader = ktx2Loader;
    return this;
  }
  setMeshoptDecoder(meshoptDecoder) {
    this.meshoptDecoder = meshoptDecoder;
    return this;
  }
  register(callback) {
    if (this.pluginCallbacks.indexOf(callback) === -1) {
      this.pluginCallbacks.push(callback);
    }
    return this;
  }
  unregister(callback) {
    if (this.pluginCallbacks.indexOf(callback) !== -1) {
      this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
    }
    return this;
  }
  parse(data, path, onLoad, onError) {
    let json;
    const extensions2 = {};
    const plugins = {};
    if (typeof data === "string") {
      json = JSON.parse(data);
    } else if (data instanceof ArrayBuffer) {
      const magic = decodeText(new Uint8Array(data.slice(0, 4)));
      if (magic === BINARY_EXTENSION_HEADER_MAGIC) {
        try {
          extensions2[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(data);
        } catch (error2) {
          if (onError)
            onError(error2);
          return;
        }
        json = JSON.parse(extensions2[EXTENSIONS.KHR_BINARY_GLTF].content);
      } else {
        json = JSON.parse(decodeText(new Uint8Array(data)));
      }
    } else {
      json = data;
    }
    if (json.asset === void 0 || json.asset.version[0] < 2) {
      if (onError)
        onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
      return;
    }
    const parser = new GLTFParser(json, {
      path: path || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder
    });
    parser.fileLoader.setRequestHeader(this.requestHeader);
    for (let i2 = 0; i2 < this.pluginCallbacks.length; i2++) {
      const plugin = this.pluginCallbacks[i2](parser);
      if (!plugin.name)
        console.error("THREE.GLTFLoader: Invalid plugin found: missing name");
      plugins[plugin.name] = plugin;
      extensions2[plugin.name] = true;
    }
    if (json.extensionsUsed) {
      for (let i2 = 0; i2 < json.extensionsUsed.length; ++i2) {
        const extensionName = json.extensionsUsed[i2];
        const extensionsRequired = json.extensionsRequired || [];
        switch (extensionName) {
          case EXTENSIONS.KHR_MATERIALS_UNLIT:
            extensions2[extensionName] = new GLTFMaterialsUnlitExtension();
            break;
          case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
            extensions2[extensionName] = new GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
            break;
          case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
            extensions2[extensionName] = new GLTFTextureTransformExtension();
            break;
          case EXTENSIONS.KHR_MESH_QUANTIZATION:
            extensions2[extensionName] = new GLTFMeshQuantizationExtension();
            break;
          default:
            if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === void 0) {
              console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
      }
    }
    parser.setExtensions(extensions2);
    parser.setPlugins(plugins);
    parser.parse(onLoad, onError);
  }
  parseAsync(data, path) {
    const scope = this;
    return new Promise(function(resolve2, reject) {
      scope.parse(data, path, resolve2, reject);
    });
  }
}
function GLTFRegistry() {
  let objects = {};
  return {
    get: function(key) {
      return objects[key];
    },
    add: function(key, object) {
      objects[key] = object;
    },
    remove: function(key) {
      delete objects[key];
    },
    removeAll: function() {
      objects = {};
    }
  };
}
const EXTENSIONS = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
  KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
  EXT_MATERIALS_BUMP: "EXT_materials_bump",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_TEXTURE_AVIF: "EXT_texture_avif",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
  EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class GLTFLightsExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
    this.cache = { refs: {}, uses: {} };
  }
  _markDefs() {
    const parser = this.parser;
    const nodeDefs = this.parser.json.nodes || [];
    for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
      const nodeDef = nodeDefs[nodeIndex];
      if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== void 0) {
        parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
      }
    }
  }
  _loadLight(lightIndex) {
    const parser = this.parser;
    const cacheKey2 = "light:" + lightIndex;
    let dependency = parser.cache.get(cacheKey2);
    if (dependency)
      return dependency;
    const json = parser.json;
    const extensions2 = json.extensions && json.extensions[this.name] || {};
    const lightDefs = extensions2.lights || [];
    const lightDef = lightDefs[lightIndex];
    let lightNode;
    const color = new Color(16777215);
    if (lightDef.color !== void 0)
      color.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], LinearSRGBColorSpace);
    const range = lightDef.range !== void 0 ? lightDef.range : 0;
    switch (lightDef.type) {
      case "directional":
        lightNode = new DirectionalLight(color);
        lightNode.target.position.set(0, 0, -1);
        lightNode.add(lightNode.target);
        break;
      case "point":
        lightNode = new PointLight(color);
        lightNode.distance = range;
        break;
      case "spot":
        lightNode = new SpotLight(color);
        lightNode.distance = range;
        lightDef.spot = lightDef.spot || {};
        lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== void 0 ? lightDef.spot.innerConeAngle : 0;
        lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== void 0 ? lightDef.spot.outerConeAngle : Math.PI / 4;
        lightNode.angle = lightDef.spot.outerConeAngle;
        lightNode.penumbra = 1 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
        lightNode.target.position.set(0, 0, -1);
        lightNode.add(lightNode.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
    }
    lightNode.position.set(0, 0, 0);
    lightNode.decay = 2;
    assignExtrasToUserData(lightNode, lightDef);
    if (lightDef.intensity !== void 0)
      lightNode.intensity = lightDef.intensity;
    lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
    dependency = Promise.resolve(lightNode);
    parser.cache.add(cacheKey2, dependency);
    return dependency;
  }
  getDependency(type, index) {
    if (type !== "light")
      return;
    return this._loadLight(index);
  }
  createNodeAttachment(nodeIndex) {
    const self2 = this;
    const parser = this.parser;
    const json = parser.json;
    const nodeDef = json.nodes[nodeIndex];
    const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
    const lightIndex = lightDef.light;
    if (lightIndex === void 0)
      return null;
    return this._loadLight(lightIndex).then(function(light) {
      return parser._getNodeRef(self2.cache, lightIndex, light);
    });
  }
}
class GLTFMaterialsUnlitExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return MeshBasicMaterial;
  }
  extendParams(materialParams, materialDef, parser) {
    const pending = [];
    materialParams.color = new Color(1, 1, 1);
    materialParams.opacity = 1;
    const metallicRoughness = materialDef.pbrMetallicRoughness;
    if (metallicRoughness) {
      if (Array.isArray(metallicRoughness.baseColorFactor)) {
        const array = metallicRoughness.baseColorFactor;
        materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
        materialParams.opacity = array[3];
      }
      if (metallicRoughness.baseColorTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, SRGBColorSpace));
      }
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsEmissiveStrengthExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
    if (emissiveStrength !== void 0) {
      materialParams.emissiveIntensity = emissiveStrength;
    }
    return Promise.resolve();
  }
}
class GLTFMaterialsClearcoatExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.clearcoatFactor !== void 0) {
      materialParams.clearcoat = extension.clearcoatFactor;
    }
    if (extension.clearcoatTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
    }
    if (extension.clearcoatRoughnessFactor !== void 0) {
      materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
    }
    if (extension.clearcoatRoughnessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
    }
    if (extension.clearcoatNormalTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
      if (extension.clearcoatNormalTexture.scale !== void 0) {
        const scale = extension.clearcoatNormalTexture.scale;
        materialParams.clearcoatNormalScale = new Vector2(scale, scale);
      }
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsDispersionExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_DISPERSION;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const extension = materialDef.extensions[this.name];
    materialParams.dispersion = extension.dispersion !== void 0 ? extension.dispersion : 0;
    return Promise.resolve();
  }
}
class GLTFMaterialsIridescenceExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.iridescenceFactor !== void 0) {
      materialParams.iridescence = extension.iridescenceFactor;
    }
    if (extension.iridescenceTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
    }
    if (extension.iridescenceIor !== void 0) {
      materialParams.iridescenceIOR = extension.iridescenceIor;
    }
    if (materialParams.iridescenceThicknessRange === void 0) {
      materialParams.iridescenceThicknessRange = [100, 400];
    }
    if (extension.iridescenceThicknessMinimum !== void 0) {
      materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
    }
    if (extension.iridescenceThicknessMaximum !== void 0) {
      materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
    }
    if (extension.iridescenceThicknessTexture !== void 0) {
      pending.push(
        parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture)
      );
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsSheenExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    materialParams.sheenColor = new Color(0, 0, 0);
    materialParams.sheenRoughness = 0;
    materialParams.sheen = 1;
    const extension = materialDef.extensions[this.name];
    if (extension.sheenColorFactor !== void 0) {
      const colorFactor = extension.sheenColorFactor;
      materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], LinearSRGBColorSpace);
    }
    if (extension.sheenRoughnessFactor !== void 0) {
      materialParams.sheenRoughness = extension.sheenRoughnessFactor;
    }
    if (extension.sheenColorTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, SRGBColorSpace));
    }
    if (extension.sheenRoughnessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsTransmissionExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.transmissionFactor !== void 0) {
      materialParams.transmission = extension.transmissionFactor;
    }
    if (extension.transmissionTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsVolumeExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    materialParams.thickness = extension.thicknessFactor !== void 0 ? extension.thicknessFactor : 0;
    if (extension.thicknessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
    }
    materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
    const colorArray = extension.attenuationColor || [1, 1, 1];
    materialParams.attenuationColor = new Color().setRGB(
      colorArray[0],
      colorArray[1],
      colorArray[2],
      LinearSRGBColorSpace
    );
    return Promise.all(pending);
  }
}
class GLTFMaterialsIorExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_IOR;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const extension = materialDef.extensions[this.name];
    materialParams.ior = extension.ior !== void 0 ? extension.ior : 1.5;
    return Promise.resolve();
  }
}
class GLTFMaterialsSpecularExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    materialParams.specularIntensity = extension.specularFactor !== void 0 ? extension.specularFactor : 1;
    if (extension.specularTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
    }
    const colorArray = extension.specularColorFactor || [1, 1, 1];
    materialParams.specularColor = new Color().setRGB(colorArray[0], colorArray[1], colorArray[2], LinearSRGBColorSpace);
    if (extension.specularColorTexture !== void 0) {
      pending.push(
        parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, SRGBColorSpace)
      );
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsBumpExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.EXT_MATERIALS_BUMP;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    materialParams.bumpScale = extension.bumpFactor !== void 0 ? extension.bumpFactor : 1;
    if (extension.bumpTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "bumpMap", extension.bumpTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsAnisotropyExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.anisotropyStrength !== void 0) {
      materialParams.anisotropy = extension.anisotropyStrength;
    }
    if (extension.anisotropyRotation !== void 0) {
      materialParams.anisotropyRotation = extension.anisotropyRotation;
    }
    if (extension.anisotropyTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFTextureBasisUExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_TEXTURE_BASISU;
  }
  loadTexture(textureIndex) {
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[this.name]) {
      return null;
    }
    const extension = textureDef.extensions[this.name];
    const loader = parser.options.ktx2Loader;
    if (!loader) {
      if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
        throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
      } else {
        return null;
      }
    }
    return parser.loadTextureImage(textureIndex, extension.source, loader);
  }
}
class GLTFTextureWebPExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
    this.isSupported = null;
  }
  loadTexture(textureIndex) {
    const name = this.name;
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[name]) {
      return null;
    }
    const extension = textureDef.extensions[name];
    const source = json.images[extension.source];
    let loader = parser.textureLoader;
    if (source.uri) {
      const handler = parser.options.manager.getHandler(source.uri);
      if (handler !== null)
        loader = handler;
    }
    return this.detectSupport().then(function(isSupported) {
      if (isSupported)
        return parser.loadTextureImage(textureIndex, extension.source, loader);
      if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
      }
      return parser.loadTexture(textureIndex);
    });
  }
  detectSupport() {
    if (!this.isSupported) {
      this.isSupported = new Promise(function(resolve2) {
        const image = new Image();
        image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
        image.onload = image.onerror = function() {
          resolve2(image.height === 1);
        };
      });
    }
    return this.isSupported;
  }
}
class GLTFTextureAVIFExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.EXT_TEXTURE_AVIF;
    this.isSupported = null;
  }
  loadTexture(textureIndex) {
    const name = this.name;
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[name]) {
      return null;
    }
    const extension = textureDef.extensions[name];
    const source = json.images[extension.source];
    let loader = parser.textureLoader;
    if (source.uri) {
      const handler = parser.options.manager.getHandler(source.uri);
      if (handler !== null)
        loader = handler;
    }
    return this.detectSupport().then(function(isSupported) {
      if (isSupported)
        return parser.loadTextureImage(textureIndex, extension.source, loader);
      if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {
        throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
      }
      return parser.loadTexture(textureIndex);
    });
  }
  detectSupport() {
    if (!this.isSupported) {
      this.isSupported = new Promise(function(resolve2) {
        const image = new Image();
        image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
        image.onload = image.onerror = function() {
          resolve2(image.height === 1);
        };
      });
    }
    return this.isSupported;
  }
}
class GLTFMeshoptCompression {
  constructor(parser) {
    this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
    this.parser = parser;
  }
  loadBufferView(index) {
    const json = this.parser.json;
    const bufferView = json.bufferViews[index];
    if (bufferView.extensions && bufferView.extensions[this.name]) {
      const extensionDef = bufferView.extensions[this.name];
      const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
      const decoder = this.parser.options.meshoptDecoder;
      if (!decoder || !decoder.supported) {
        if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
          throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
        } else {
          return null;
        }
      }
      return buffer.then(function(res) {
        const byteOffset = extensionDef.byteOffset || 0;
        const byteLength = extensionDef.byteLength || 0;
        const count = extensionDef.count;
        const stride = extensionDef.byteStride;
        const source = new Uint8Array(res, byteOffset, byteLength);
        if (decoder.decodeGltfBufferAsync) {
          return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res2) {
            return res2.buffer;
          });
        } else {
          return decoder.ready.then(function() {
            const result = new ArrayBuffer(count * stride);
            decoder.decodeGltfBuffer(
              new Uint8Array(result),
              count,
              stride,
              source,
              extensionDef.mode,
              extensionDef.filter
            );
            return result;
          });
        }
      });
    } else {
      return null;
    }
  }
}
class GLTFMeshGpuInstancing {
  constructor(parser) {
    this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING;
    this.parser = parser;
  }
  createNodeMesh(nodeIndex) {
    const json = this.parser.json;
    const nodeDef = json.nodes[nodeIndex];
    if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === void 0) {
      return null;
    }
    const meshDef = json.meshes[nodeDef.mesh];
    for (const primitive of meshDef.primitives) {
      if (primitive.mode !== WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== void 0) {
        return null;
      }
    }
    const extensionDef = nodeDef.extensions[this.name];
    const attributesDef = extensionDef.attributes;
    const pending = [];
    const attributes = {};
    for (const key in attributesDef) {
      pending.push(
        this.parser.getDependency("accessor", attributesDef[key]).then((accessor) => {
          attributes[key] = accessor;
          return attributes[key];
        })
      );
    }
    if (pending.length < 1) {
      return null;
    }
    pending.push(this.parser.createNodeMesh(nodeIndex));
    return Promise.all(pending).then((results) => {
      const nodeObject = results.pop();
      const meshes = nodeObject.isGroup ? nodeObject.children : [nodeObject];
      const count = results[0].count;
      const instancedMeshes = [];
      for (const mesh of meshes) {
        const m2 = new Matrix4();
        const p3 = new Vector3();
        const q2 = new Quaternion();
        const s2 = new Vector3(1, 1, 1);
        const instancedMesh = new InstancedMesh(mesh.geometry, mesh.material, count);
        for (let i2 = 0; i2 < count; i2++) {
          if (attributes.TRANSLATION) {
            p3.fromBufferAttribute(attributes.TRANSLATION, i2);
          }
          if (attributes.ROTATION) {
            q2.fromBufferAttribute(attributes.ROTATION, i2);
          }
          if (attributes.SCALE) {
            s2.fromBufferAttribute(attributes.SCALE, i2);
          }
          instancedMesh.setMatrixAt(i2, m2.compose(p3, q2, s2));
        }
        for (const attributeName in attributes) {
          if (attributeName === "_COLOR_0") {
            const attr = attributes[attributeName];
            instancedMesh.instanceColor = new InstancedBufferAttribute(attr.array, attr.itemSize, attr.normalized);
          } else if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") {
            mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
          }
        }
        Object3D.prototype.copy.call(instancedMesh, mesh);
        this.parser.assignFinalMaterial(instancedMesh);
        instancedMeshes.push(instancedMesh);
      }
      if (nodeObject.isGroup) {
        nodeObject.clear();
        nodeObject.add(...instancedMeshes);
        return nodeObject;
      }
      return instancedMeshes[0];
    });
  }
}
const BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const BINARY_EXTENSION_HEADER_LENGTH = 12;
const BINARY_EXTENSION_CHUNK_TYPES = { JSON: 1313821514, BIN: 5130562 };
class GLTFBinaryExtension {
  constructor(data) {
    this.name = EXTENSIONS.KHR_BINARY_GLTF;
    this.content = null;
    this.body = null;
    const headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);
    this.header = {
      magic: decodeText(new Uint8Array(data.slice(0, 4))),
      version: headerView.getUint32(4, true),
      length: headerView.getUint32(8, true)
    };
    if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    } else if (this.header.version < 2) {
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    }
    const chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
    const chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
    let chunkIndex = 0;
    while (chunkIndex < chunkContentsLength) {
      const chunkLength = chunkView.getUint32(chunkIndex, true);
      chunkIndex += 4;
      const chunkType = chunkView.getUint32(chunkIndex, true);
      chunkIndex += 4;
      if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
        const contentArray = new Uint8Array(data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
        this.content = decodeText(contentArray);
      } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
        const byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
        this.body = data.slice(byteOffset, byteOffset + chunkLength);
      }
      chunkIndex += chunkLength;
    }
    if (this.content === null) {
      throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
  }
}
class GLTFDracoMeshCompressionExtension {
  constructor(json, dracoLoader2) {
    if (!dracoLoader2) {
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    }
    this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
    this.json = json;
    this.dracoLoader = dracoLoader2;
    this.dracoLoader.preload();
  }
  decodePrimitive(primitive, parser) {
    const json = this.json;
    const dracoLoader2 = this.dracoLoader;
    const bufferViewIndex = primitive.extensions[this.name].bufferView;
    const gltfAttributeMap = primitive.extensions[this.name].attributes;
    const threeAttributeMap = {};
    const attributeNormalizedMap = {};
    const attributeTypeMap = {};
    for (const attributeName in gltfAttributeMap) {
      const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
      threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
    }
    for (const attributeName in primitive.attributes) {
      const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
      if (gltfAttributeMap[attributeName] !== void 0) {
        const accessorDef = json.accessors[primitive.attributes[attributeName]];
        const componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
        attributeTypeMap[threeAttributeName] = componentType.name;
        attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
      }
    }
    return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
      return new Promise(function(resolve2, reject) {
        dracoLoader2.decodeDracoFile(
          bufferView,
          function(geometry) {
            for (const attributeName in geometry.attributes) {
              const attribute = geometry.attributes[attributeName];
              const normalized = attributeNormalizedMap[attributeName];
              if (normalized !== void 0)
                attribute.normalized = normalized;
            }
            resolve2(geometry);
          },
          threeAttributeMap,
          attributeTypeMap,
          LinearSRGBColorSpace,
          reject
        );
      });
    });
  }
}
class GLTFTextureTransformExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(texture, transform) {
    if ((transform.texCoord === void 0 || transform.texCoord === texture.channel) && transform.offset === void 0 && transform.rotation === void 0 && transform.scale === void 0) {
      return texture;
    }
    texture = texture.clone();
    if (transform.texCoord !== void 0) {
      texture.channel = transform.texCoord;
    }
    if (transform.offset !== void 0) {
      texture.offset.fromArray(transform.offset);
    }
    if (transform.rotation !== void 0) {
      texture.rotation = transform.rotation;
    }
    if (transform.scale !== void 0) {
      texture.repeat.fromArray(transform.scale);
    }
    texture.needsUpdate = true;
    return texture;
  }
}
class GLTFMeshQuantizationExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;
  }
}
class GLTFCubicSplineInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  copySampleValue_(index) {
    const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
    for (let i2 = 0; i2 !== valueSize; i2++) {
      result[i2] = values[offset + i2];
    }
    return result;
  }
  interpolate_(i1, t0, t2, t1) {
    const result = this.resultBuffer;
    const values = this.sampleValues;
    const stride = this.valueSize;
    const stride2 = stride * 2;
    const stride3 = stride * 3;
    const td2 = t1 - t0;
    const p3 = (t2 - t0) / td2;
    const pp = p3 * p3;
    const ppp = pp * p3;
    const offset1 = i1 * stride3;
    const offset0 = offset1 - stride3;
    const s2 = -2 * ppp + 3 * pp;
    const s3 = ppp - pp;
    const s0 = 1 - s2;
    const s1 = s3 - pp + p3;
    for (let i2 = 0; i2 !== stride; i2++) {
      const p0 = values[offset0 + i2 + stride];
      const m0 = values[offset0 + i2 + stride2] * td2;
      const p1 = values[offset1 + i2 + stride];
      const m1 = values[offset1 + i2] * td2;
      result[i2] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
    }
    return result;
  }
}
const _q = /* @__PURE__ */ new Quaternion();
class GLTFCubicSplineQuaternionInterpolant extends GLTFCubicSplineInterpolant {
  interpolate_(i1, t0, t2, t1) {
    const result = super.interpolate_(i1, t0, t2, t1);
    _q.fromArray(result).normalize().toArray(result);
    return result;
  }
}
const WEBGL_CONSTANTS = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
};
const WEBGL_COMPONENT_TYPES = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
const WEBGL_FILTERS = {
  9728: NearestFilter,
  9729: LinearFilter,
  9984: NearestMipmapNearestFilter,
  9985: LinearMipmapNearestFilter,
  9986: NearestMipmapLinearFilter,
  9987: LinearMipmapLinearFilter
};
const WEBGL_WRAPPINGS = {
  33071: ClampToEdgeWrapping,
  33648: MirroredRepeatWrapping,
  10497: RepeatWrapping
};
const WEBGL_TYPE_SIZES = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const ATTRIBUTES = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  // uv => uv1, 4 uv channels
  // https://github.com/mrdoob/three.js/pull/25943
  // https://github.com/mrdoob/three.js/pull/25788
  ...version >= 152 ? {
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv1",
    TEXCOORD_2: "uv2",
    TEXCOORD_3: "uv3"
  } : {
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv2"
  },
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
};
const PATH_PROPERTIES = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
};
const INTERPOLATION = {
  CUBICSPLINE: void 0,
  // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
  // keyframe track will be initialized with a default interpolation type, then modified.
  LINEAR: InterpolateLinear,
  STEP: InterpolateDiscrete
};
const ALPHA_MODES = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function createDefaultMaterial(cache) {
  if (cache["DefaultMaterial"] === void 0) {
    cache["DefaultMaterial"] = new MeshStandardMaterial({
      color: 16777215,
      emissive: 0,
      metalness: 1,
      roughness: 1,
      transparent: false,
      depthTest: true,
      side: FrontSide
    });
  }
  return cache["DefaultMaterial"];
}
function addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
  for (const name in objectDef.extensions) {
    if (knownExtensions[name] === void 0) {
      object.userData.gltfExtensions = object.userData.gltfExtensions || {};
      object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
  }
}
function assignExtrasToUserData(object, gltfDef) {
  if (gltfDef.extras !== void 0) {
    if (typeof gltfDef.extras === "object") {
      Object.assign(object.userData, gltfDef.extras);
    } else {
      console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
  }
}
function addMorphTargets(geometry, targets, parser) {
  let hasMorphPosition = false;
  let hasMorphNormal = false;
  let hasMorphColor = false;
  for (let i2 = 0, il = targets.length; i2 < il; i2++) {
    const target = targets[i2];
    if (target.POSITION !== void 0)
      hasMorphPosition = true;
    if (target.NORMAL !== void 0)
      hasMorphNormal = true;
    if (target.COLOR_0 !== void 0)
      hasMorphColor = true;
    if (hasMorphPosition && hasMorphNormal && hasMorphColor)
      break;
  }
  if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor)
    return Promise.resolve(geometry);
  const pendingPositionAccessors = [];
  const pendingNormalAccessors = [];
  const pendingColorAccessors = [];
  for (let i2 = 0, il = targets.length; i2 < il; i2++) {
    const target = targets[i2];
    if (hasMorphPosition) {
      const pendingAccessor = target.POSITION !== void 0 ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
      pendingPositionAccessors.push(pendingAccessor);
    }
    if (hasMorphNormal) {
      const pendingAccessor = target.NORMAL !== void 0 ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
      pendingNormalAccessors.push(pendingAccessor);
    }
    if (hasMorphColor) {
      const pendingAccessor = target.COLOR_0 !== void 0 ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
      pendingColorAccessors.push(pendingAccessor);
    }
  }
  return Promise.all([
    Promise.all(pendingPositionAccessors),
    Promise.all(pendingNormalAccessors),
    Promise.all(pendingColorAccessors)
  ]).then(function(accessors) {
    const morphPositions = accessors[0];
    const morphNormals = accessors[1];
    const morphColors = accessors[2];
    if (hasMorphPosition)
      geometry.morphAttributes.position = morphPositions;
    if (hasMorphNormal)
      geometry.morphAttributes.normal = morphNormals;
    if (hasMorphColor)
      geometry.morphAttributes.color = morphColors;
    geometry.morphTargetsRelative = true;
    return geometry;
  });
}
function updateMorphTargets(mesh, meshDef) {
  mesh.updateMorphTargets();
  if (meshDef.weights !== void 0) {
    for (let i2 = 0, il = meshDef.weights.length; i2 < il; i2++) {
      mesh.morphTargetInfluences[i2] = meshDef.weights[i2];
    }
  }
  if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
    const targetNames = meshDef.extras.targetNames;
    if (mesh.morphTargetInfluences.length === targetNames.length) {
      mesh.morphTargetDictionary = {};
      for (let i2 = 0, il = targetNames.length; i2 < il; i2++) {
        mesh.morphTargetDictionary[targetNames[i2]] = i2;
      }
    } else {
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
  }
}
function createPrimitiveKey(primitiveDef) {
  let geometryKey;
  const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
  if (dracoExtension) {
    geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + createAttributesKey(dracoExtension.attributes);
  } else {
    geometryKey = primitiveDef.indices + ":" + createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
  }
  if (primitiveDef.targets !== void 0) {
    for (let i2 = 0, il = primitiveDef.targets.length; i2 < il; i2++) {
      geometryKey += ":" + createAttributesKey(primitiveDef.targets[i2]);
    }
  }
  return geometryKey;
}
function createAttributesKey(attributes) {
  let attributesKey = "";
  const keys = Object.keys(attributes).sort();
  for (let i2 = 0, il = keys.length; i2 < il; i2++) {
    attributesKey += keys[i2] + ":" + attributes[keys[i2]] + ";";
  }
  return attributesKey;
}
function getNormalizedComponentScale(constructor) {
  switch (constructor) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
function getImageURIMimeType(uri) {
  if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0)
    return "image/jpeg";
  if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0)
    return "image/webp";
  return "image/png";
}
const _identityMatrix = /* @__PURE__ */ new Matrix4();
class GLTFParser {
  constructor(json = {}, options = {}) {
    this.json = json;
    this.extensions = {};
    this.plugins = {};
    this.options = options;
    this.cache = new GLTFRegistry();
    this.associations = /* @__PURE__ */ new Map();
    this.primitiveCache = {};
    this.nodeCache = {};
    this.meshCache = { refs: {}, uses: {} };
    this.cameraCache = { refs: {}, uses: {} };
    this.lightCache = { refs: {}, uses: {} };
    this.sourceCache = {};
    this.textureCache = {};
    this.nodeNamesUsed = {};
    let isSafari = false;
    let isFirefox = false;
    let firefoxVersion = -1;
    if (typeof navigator !== "undefined" && typeof navigator.userAgent !== "undefined") {
      isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
      isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
      firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
    }
    if (typeof createImageBitmap === "undefined" || isSafari || isFirefox && firefoxVersion < 98) {
      this.textureLoader = new TextureLoader(this.options.manager);
    } else {
      this.textureLoader = new ImageBitmapLoader(this.options.manager);
    }
    this.textureLoader.setCrossOrigin(this.options.crossOrigin);
    this.textureLoader.setRequestHeader(this.options.requestHeader);
    this.fileLoader = new FileLoader(this.options.manager);
    this.fileLoader.setResponseType("arraybuffer");
    if (this.options.crossOrigin === "use-credentials") {
      this.fileLoader.setWithCredentials(true);
    }
  }
  setExtensions(extensions2) {
    this.extensions = extensions2;
  }
  setPlugins(plugins) {
    this.plugins = plugins;
  }
  parse(onLoad, onError) {
    const parser = this;
    const json = this.json;
    const extensions2 = this.extensions;
    this.cache.removeAll();
    this.nodeCache = {};
    this._invokeAll(function(ext) {
      return ext._markDefs && ext._markDefs();
    });
    Promise.all(
      this._invokeAll(function(ext) {
        return ext.beforeRoot && ext.beforeRoot();
      })
    ).then(function() {
      return Promise.all([
        parser.getDependencies("scene"),
        parser.getDependencies("animation"),
        parser.getDependencies("camera")
      ]);
    }).then(function(dependencies) {
      const result = {
        scene: dependencies[0][json.scene || 0],
        scenes: dependencies[0],
        animations: dependencies[1],
        cameras: dependencies[2],
        asset: json.asset,
        parser,
        userData: {}
      };
      addUnknownExtensionsToUserData(extensions2, result, json);
      assignExtrasToUserData(result, json);
      return Promise.all(
        parser._invokeAll(function(ext) {
          return ext.afterRoot && ext.afterRoot(result);
        })
      ).then(function() {
        for (const scene of result.scenes) {
          scene.updateMatrixWorld();
        }
        onLoad(result);
      });
    }).catch(onError);
  }
  /**
   * Marks the special nodes/meshes in json for efficient parse.
   */
  _markDefs() {
    const nodeDefs = this.json.nodes || [];
    const skinDefs = this.json.skins || [];
    const meshDefs = this.json.meshes || [];
    for (let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++) {
      const joints = skinDefs[skinIndex].joints;
      for (let i2 = 0, il = joints.length; i2 < il; i2++) {
        nodeDefs[joints[i2]].isBone = true;
      }
    }
    for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
      const nodeDef = nodeDefs[nodeIndex];
      if (nodeDef.mesh !== void 0) {
        this._addNodeRef(this.meshCache, nodeDef.mesh);
        if (nodeDef.skin !== void 0) {
          meshDefs[nodeDef.mesh].isSkinnedMesh = true;
        }
      }
      if (nodeDef.camera !== void 0) {
        this._addNodeRef(this.cameraCache, nodeDef.camera);
      }
    }
  }
  /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */
  _addNodeRef(cache, index) {
    if (index === void 0)
      return;
    if (cache.refs[index] === void 0) {
      cache.refs[index] = cache.uses[index] = 0;
    }
    cache.refs[index]++;
  }
  /** Returns a reference to a shared resource, cloning it if necessary. */
  _getNodeRef(cache, index, object) {
    if (cache.refs[index] <= 1)
      return object;
    const ref = object.clone();
    const updateMappings = (original, clone) => {
      const mappings = this.associations.get(original);
      if (mappings != null) {
        this.associations.set(clone, mappings);
      }
      for (const [i2, child] of original.children.entries()) {
        updateMappings(child, clone.children[i2]);
      }
    };
    updateMappings(object, ref);
    ref.name += "_instance_" + cache.uses[index]++;
    return ref;
  }
  _invokeOne(func) {
    const extensions2 = Object.values(this.plugins);
    extensions2.push(this);
    for (let i2 = 0; i2 < extensions2.length; i2++) {
      const result = func(extensions2[i2]);
      if (result)
        return result;
    }
    return null;
  }
  _invokeAll(func) {
    const extensions2 = Object.values(this.plugins);
    extensions2.unshift(this);
    const pending = [];
    for (let i2 = 0; i2 < extensions2.length; i2++) {
      const result = func(extensions2[i2]);
      if (result)
        pending.push(result);
    }
    return pending;
  }
  /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */
  getDependency(type, index) {
    const cacheKey2 = type + ":" + index;
    let dependency = this.cache.get(cacheKey2);
    if (!dependency) {
      switch (type) {
        case "scene":
          dependency = this.loadScene(index);
          break;
        case "node":
          dependency = this._invokeOne(function(ext) {
            return ext.loadNode && ext.loadNode(index);
          });
          break;
        case "mesh":
          dependency = this._invokeOne(function(ext) {
            return ext.loadMesh && ext.loadMesh(index);
          });
          break;
        case "accessor":
          dependency = this.loadAccessor(index);
          break;
        case "bufferView":
          dependency = this._invokeOne(function(ext) {
            return ext.loadBufferView && ext.loadBufferView(index);
          });
          break;
        case "buffer":
          dependency = this.loadBuffer(index);
          break;
        case "material":
          dependency = this._invokeOne(function(ext) {
            return ext.loadMaterial && ext.loadMaterial(index);
          });
          break;
        case "texture":
          dependency = this._invokeOne(function(ext) {
            return ext.loadTexture && ext.loadTexture(index);
          });
          break;
        case "skin":
          dependency = this.loadSkin(index);
          break;
        case "animation":
          dependency = this._invokeOne(function(ext) {
            return ext.loadAnimation && ext.loadAnimation(index);
          });
          break;
        case "camera":
          dependency = this.loadCamera(index);
          break;
        default:
          dependency = this._invokeOne(function(ext) {
            return ext != this && ext.getDependency && ext.getDependency(type, index);
          });
          if (!dependency) {
            throw new Error("Unknown type: " + type);
          }
          break;
      }
      this.cache.add(cacheKey2, dependency);
    }
    return dependency;
  }
  /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */
  getDependencies(type) {
    let dependencies = this.cache.get(type);
    if (!dependencies) {
      const parser = this;
      const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
      dependencies = Promise.all(
        defs.map(function(def, index) {
          return parser.getDependency(type, index);
        })
      );
      this.cache.add(type, dependencies);
    }
    return dependencies;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBuffer(bufferIndex) {
    const bufferDef = this.json.buffers[bufferIndex];
    const loader = this.fileLoader;
    if (bufferDef.type && bufferDef.type !== "arraybuffer") {
      throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
    }
    if (bufferDef.uri === void 0 && bufferIndex === 0) {
      return Promise.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);
    }
    const options = this.options;
    return new Promise(function(resolve2, reject) {
      loader.load(LoaderUtils.resolveURL(bufferDef.uri, options.path), resolve2, void 0, function() {
        reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
      });
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBufferView(bufferViewIndex) {
    const bufferViewDef = this.json.bufferViews[bufferViewIndex];
    return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
      const byteLength = bufferViewDef.byteLength || 0;
      const byteOffset = bufferViewDef.byteOffset || 0;
      return buffer.slice(byteOffset, byteOffset + byteLength);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */
  loadAccessor(accessorIndex) {
    const parser = this;
    const json = this.json;
    const accessorDef = this.json.accessors[accessorIndex];
    if (accessorDef.bufferView === void 0 && accessorDef.sparse === void 0) {
      const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
      const TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
      const normalized = accessorDef.normalized === true;
      const array = new TypedArray(accessorDef.count * itemSize);
      return Promise.resolve(new BufferAttribute(array, itemSize, normalized));
    }
    const pendingBufferViews = [];
    if (accessorDef.bufferView !== void 0) {
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
    } else {
      pendingBufferViews.push(null);
    }
    if (accessorDef.sparse !== void 0) {
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
    }
    return Promise.all(pendingBufferViews).then(function(bufferViews) {
      const bufferView = bufferViews[0];
      const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
      const TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
      const elementBytes = TypedArray.BYTES_PER_ELEMENT;
      const itemBytes = elementBytes * itemSize;
      const byteOffset = accessorDef.byteOffset || 0;
      const byteStride = accessorDef.bufferView !== void 0 ? json.bufferViews[accessorDef.bufferView].byteStride : void 0;
      const normalized = accessorDef.normalized === true;
      let array, bufferAttribute;
      if (byteStride && byteStride !== itemBytes) {
        const ibSlice = Math.floor(byteOffset / byteStride);
        const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
        let ib = parser.cache.get(ibCacheKey);
        if (!ib) {
          array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
          ib = new InterleavedBuffer(array, byteStride / elementBytes);
          parser.cache.add(ibCacheKey, ib);
        }
        bufferAttribute = new InterleavedBufferAttribute(
          ib,
          itemSize,
          byteOffset % byteStride / elementBytes,
          normalized
        );
      } else {
        if (bufferView === null) {
          array = new TypedArray(accessorDef.count * itemSize);
        } else {
          array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
        }
        bufferAttribute = new BufferAttribute(array, itemSize, normalized);
      }
      if (accessorDef.sparse !== void 0) {
        const itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
        const TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
        const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
        const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
        const sparseIndices = new TypedArrayIndices(
          bufferViews[1],
          byteOffsetIndices,
          accessorDef.sparse.count * itemSizeIndices
        );
        const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
        if (bufferView !== null) {
          bufferAttribute = new BufferAttribute(
            bufferAttribute.array.slice(),
            bufferAttribute.itemSize,
            bufferAttribute.normalized
          );
        }
        for (let i2 = 0, il = sparseIndices.length; i2 < il; i2++) {
          const index = sparseIndices[i2];
          bufferAttribute.setX(index, sparseValues[i2 * itemSize]);
          if (itemSize >= 2)
            bufferAttribute.setY(index, sparseValues[i2 * itemSize + 1]);
          if (itemSize >= 3)
            bufferAttribute.setZ(index, sparseValues[i2 * itemSize + 2]);
          if (itemSize >= 4)
            bufferAttribute.setW(index, sparseValues[i2 * itemSize + 3]);
          if (itemSize >= 5)
            throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
        }
      }
      return bufferAttribute;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */
  loadTexture(textureIndex) {
    const json = this.json;
    const options = this.options;
    const textureDef = json.textures[textureIndex];
    const sourceIndex = textureDef.source;
    const sourceDef = json.images[sourceIndex];
    let loader = this.textureLoader;
    if (sourceDef.uri) {
      const handler = options.manager.getHandler(sourceDef.uri);
      if (handler !== null)
        loader = handler;
    }
    return this.loadTextureImage(textureIndex, sourceIndex, loader);
  }
  loadTextureImage(textureIndex, sourceIndex, loader) {
    const parser = this;
    const json = this.json;
    const textureDef = json.textures[textureIndex];
    const sourceDef = json.images[sourceIndex];
    const cacheKey2 = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
    if (this.textureCache[cacheKey2]) {
      return this.textureCache[cacheKey2];
    }
    const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
      texture.flipY = false;
      texture.name = textureDef.name || sourceDef.name || "";
      if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) {
        texture.name = sourceDef.uri;
      }
      const samplers = json.samplers || {};
      const sampler = samplers[textureDef.sampler] || {};
      texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || LinearFilter;
      texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || LinearMipmapLinearFilter;
      texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || RepeatWrapping;
      texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || RepeatWrapping;
      parser.associations.set(texture, { textures: textureIndex });
      return texture;
    }).catch(function() {
      return null;
    });
    this.textureCache[cacheKey2] = promise;
    return promise;
  }
  loadImageSource(sourceIndex, loader) {
    const parser = this;
    const json = this.json;
    const options = this.options;
    if (this.sourceCache[sourceIndex] !== void 0) {
      return this.sourceCache[sourceIndex].then((texture) => texture.clone());
    }
    const sourceDef = json.images[sourceIndex];
    const URL2 = self.URL || self.webkitURL;
    let sourceURI = sourceDef.uri || "";
    let isObjectURL = false;
    if (sourceDef.bufferView !== void 0) {
      sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
        isObjectURL = true;
        const blob = new Blob([bufferView], { type: sourceDef.mimeType });
        sourceURI = URL2.createObjectURL(blob);
        return sourceURI;
      });
    } else if (sourceDef.uri === void 0) {
      throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
    }
    const promise = Promise.resolve(sourceURI).then(function(sourceURI2) {
      return new Promise(function(resolve2, reject) {
        let onLoad = resolve2;
        if (loader.isImageBitmapLoader === true) {
          onLoad = function(imageBitmap) {
            const texture = new Texture(imageBitmap);
            texture.needsUpdate = true;
            resolve2(texture);
          };
        }
        loader.load(LoaderUtils.resolveURL(sourceURI2, options.path), onLoad, void 0, reject);
      });
    }).then(function(texture) {
      if (isObjectURL === true) {
        URL2.revokeObjectURL(sourceURI);
      }
      assignExtrasToUserData(texture, sourceDef);
      texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType(sourceDef.uri);
      return texture;
    }).catch(function(error2) {
      console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
      throw error2;
    });
    this.sourceCache[sourceIndex] = promise;
    return promise;
  }
  /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */
  assignTexture(materialParams, mapName, mapDef, colorSpace) {
    const parser = this;
    return this.getDependency("texture", mapDef.index).then(function(texture) {
      if (!texture)
        return null;
      if (mapDef.texCoord !== void 0 && mapDef.texCoord > 0) {
        texture = texture.clone();
        texture.channel = mapDef.texCoord;
      }
      if (parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
        const transform = mapDef.extensions !== void 0 ? mapDef.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : void 0;
        if (transform) {
          const gltfReference = parser.associations.get(texture);
          texture = parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
          parser.associations.set(texture, gltfReference);
        }
      }
      if (colorSpace !== void 0) {
        if (typeof colorSpace === "number")
          colorSpace = colorSpace === sRGBEncoding$1 ? SRGBColorSpace : LinearSRGBColorSpace;
        if ("colorSpace" in texture)
          texture.colorSpace = colorSpace;
        else
          texture.encoding = colorSpace === SRGBColorSpace ? sRGBEncoding$1 : LinearEncoding$1;
      }
      materialParams[mapName] = texture;
      return texture;
    });
  }
  /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */
  assignFinalMaterial(mesh) {
    const geometry = mesh.geometry;
    let material = mesh.material;
    const useDerivativeTangents = geometry.attributes.tangent === void 0;
    const useVertexColors = geometry.attributes.color !== void 0;
    const useFlatShading = geometry.attributes.normal === void 0;
    if (mesh.isPoints) {
      const cacheKey2 = "PointsMaterial:" + material.uuid;
      let pointsMaterial = this.cache.get(cacheKey2);
      if (!pointsMaterial) {
        pointsMaterial = new PointsMaterial();
        Material.prototype.copy.call(pointsMaterial, material);
        pointsMaterial.color.copy(material.color);
        pointsMaterial.map = material.map;
        pointsMaterial.sizeAttenuation = false;
        this.cache.add(cacheKey2, pointsMaterial);
      }
      material = pointsMaterial;
    } else if (mesh.isLine) {
      const cacheKey2 = "LineBasicMaterial:" + material.uuid;
      let lineMaterial = this.cache.get(cacheKey2);
      if (!lineMaterial) {
        lineMaterial = new LineBasicMaterial();
        Material.prototype.copy.call(lineMaterial, material);
        lineMaterial.color.copy(material.color);
        lineMaterial.map = material.map;
        this.cache.add(cacheKey2, lineMaterial);
      }
      material = lineMaterial;
    }
    if (useDerivativeTangents || useVertexColors || useFlatShading) {
      let cacheKey2 = "ClonedMaterial:" + material.uuid + ":";
      if (useDerivativeTangents)
        cacheKey2 += "derivative-tangents:";
      if (useVertexColors)
        cacheKey2 += "vertex-colors:";
      if (useFlatShading)
        cacheKey2 += "flat-shading:";
      let cachedMaterial = this.cache.get(cacheKey2);
      if (!cachedMaterial) {
        cachedMaterial = material.clone();
        if (useVertexColors)
          cachedMaterial.vertexColors = true;
        if (useFlatShading)
          cachedMaterial.flatShading = true;
        if (useDerivativeTangents) {
          if (cachedMaterial.normalScale)
            cachedMaterial.normalScale.y *= -1;
          if (cachedMaterial.clearcoatNormalScale)
            cachedMaterial.clearcoatNormalScale.y *= -1;
        }
        this.cache.add(cacheKey2, cachedMaterial);
        this.associations.set(cachedMaterial, this.associations.get(material));
      }
      material = cachedMaterial;
    }
    mesh.material = material;
  }
  getMaterialType() {
    return MeshStandardMaterial;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */
  loadMaterial(materialIndex) {
    const parser = this;
    const json = this.json;
    const extensions2 = this.extensions;
    const materialDef = json.materials[materialIndex];
    let materialType;
    const materialParams = {};
    const materialExtensions = materialDef.extensions || {};
    const pending = [];
    if (materialExtensions[EXTENSIONS.KHR_MATERIALS_UNLIT]) {
      const kmuExtension = extensions2[EXTENSIONS.KHR_MATERIALS_UNLIT];
      materialType = kmuExtension.getMaterialType();
      pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
    } else {
      const metallicRoughness = materialDef.pbrMetallicRoughness || {};
      materialParams.color = new Color(1, 1, 1);
      materialParams.opacity = 1;
      if (Array.isArray(metallicRoughness.baseColorFactor)) {
        const array = metallicRoughness.baseColorFactor;
        materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
        materialParams.opacity = array[3];
      }
      if (metallicRoughness.baseColorTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, SRGBColorSpace));
      }
      materialParams.metalness = metallicRoughness.metallicFactor !== void 0 ? metallicRoughness.metallicFactor : 1;
      materialParams.roughness = metallicRoughness.roughnessFactor !== void 0 ? metallicRoughness.roughnessFactor : 1;
      if (metallicRoughness.metallicRoughnessTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
        pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
      }
      materialType = this._invokeOne(function(ext) {
        return ext.getMaterialType && ext.getMaterialType(materialIndex);
      });
      pending.push(
        Promise.all(
          this._invokeAll(function(ext) {
            return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
          })
        )
      );
    }
    if (materialDef.doubleSided === true) {
      materialParams.side = DoubleSide;
    }
    const alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;
    if (alphaMode === ALPHA_MODES.BLEND) {
      materialParams.transparent = true;
      materialParams.depthWrite = false;
    } else {
      materialParams.transparent = false;
      if (alphaMode === ALPHA_MODES.MASK) {
        materialParams.alphaTest = materialDef.alphaCutoff !== void 0 ? materialDef.alphaCutoff : 0.5;
      }
    }
    if (materialDef.normalTexture !== void 0 && materialType !== MeshBasicMaterial) {
      pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
      materialParams.normalScale = new Vector2(1, 1);
      if (materialDef.normalTexture.scale !== void 0) {
        const scale = materialDef.normalTexture.scale;
        materialParams.normalScale.set(scale, scale);
      }
    }
    if (materialDef.occlusionTexture !== void 0 && materialType !== MeshBasicMaterial) {
      pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
      if (materialDef.occlusionTexture.strength !== void 0) {
        materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
      }
    }
    if (materialDef.emissiveFactor !== void 0 && materialType !== MeshBasicMaterial) {
      const emissiveFactor = materialDef.emissiveFactor;
      materialParams.emissive = new Color().setRGB(
        emissiveFactor[0],
        emissiveFactor[1],
        emissiveFactor[2],
        LinearSRGBColorSpace
      );
    }
    if (materialDef.emissiveTexture !== void 0 && materialType !== MeshBasicMaterial) {
      pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, SRGBColorSpace));
    }
    return Promise.all(pending).then(function() {
      const material = new materialType(materialParams);
      if (materialDef.name)
        material.name = materialDef.name;
      assignExtrasToUserData(material, materialDef);
      parser.associations.set(material, { materials: materialIndex });
      if (materialDef.extensions)
        addUnknownExtensionsToUserData(extensions2, material, materialDef);
      return material;
    });
  }
  /** When Object3D instances are targeted by animation, they need unique names. */
  createUniqueName(originalName) {
    const sanitizedName = PropertyBinding.sanitizeNodeName(originalName || "");
    if (sanitizedName in this.nodeNamesUsed) {
      return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
    } else {
      this.nodeNamesUsed[sanitizedName] = 0;
      return sanitizedName;
    }
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */
  loadGeometries(primitives2) {
    const parser = this;
    const extensions2 = this.extensions;
    const cache = this.primitiveCache;
    function createDracoPrimitive(primitive) {
      return extensions2[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
        return addPrimitiveAttributes(geometry, primitive, parser);
      });
    }
    const pending = [];
    for (let i2 = 0, il = primitives2.length; i2 < il; i2++) {
      const primitive = primitives2[i2];
      const cacheKey2 = createPrimitiveKey(primitive);
      const cached = cache[cacheKey2];
      if (cached) {
        pending.push(cached.promise);
      } else {
        let geometryPromise;
        if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) {
          geometryPromise = createDracoPrimitive(primitive);
        } else {
          geometryPromise = addPrimitiveAttributes(new BufferGeometry(), primitive, parser);
        }
        cache[cacheKey2] = { primitive, promise: geometryPromise };
        pending.push(geometryPromise);
      }
    }
    return Promise.all(pending);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */
  loadMesh(meshIndex) {
    const parser = this;
    const json = this.json;
    const extensions2 = this.extensions;
    const meshDef = json.meshes[meshIndex];
    const primitives2 = meshDef.primitives;
    const pending = [];
    for (let i2 = 0, il = primitives2.length; i2 < il; i2++) {
      const material = primitives2[i2].material === void 0 ? createDefaultMaterial(this.cache) : this.getDependency("material", primitives2[i2].material);
      pending.push(material);
    }
    pending.push(parser.loadGeometries(primitives2));
    return Promise.all(pending).then(function(results) {
      const materials = results.slice(0, results.length - 1);
      const geometries = results[results.length - 1];
      const meshes = [];
      for (let i2 = 0, il = geometries.length; i2 < il; i2++) {
        const geometry = geometries[i2];
        const primitive = primitives2[i2];
        let mesh;
        const material = materials[i2];
        if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === void 0) {
          mesh = meshDef.isSkinnedMesh === true ? new SkinnedMesh(geometry, material) : new Mesh(geometry, material);
          if (mesh.isSkinnedMesh === true) {
            mesh.normalizeSkinWeights();
          }
          if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) {
            mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleStripDrawMode);
          } else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) {
            mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleFanDrawMode);
          }
        } else if (primitive.mode === WEBGL_CONSTANTS.LINES) {
          mesh = new LineSegments(geometry, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) {
          mesh = new Line(geometry, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) {
          mesh = new LineLoop(geometry, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.POINTS) {
          mesh = new Points(geometry, material);
        } else {
          throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
        }
        if (Object.keys(mesh.geometry.morphAttributes).length > 0) {
          updateMorphTargets(mesh, meshDef);
        }
        mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
        assignExtrasToUserData(mesh, meshDef);
        if (primitive.extensions)
          addUnknownExtensionsToUserData(extensions2, mesh, primitive);
        parser.assignFinalMaterial(mesh);
        meshes.push(mesh);
      }
      for (let i2 = 0, il = meshes.length; i2 < il; i2++) {
        parser.associations.set(meshes[i2], {
          meshes: meshIndex,
          primitives: i2
        });
      }
      if (meshes.length === 1) {
        if (meshDef.extensions)
          addUnknownExtensionsToUserData(extensions2, meshes[0], meshDef);
        return meshes[0];
      }
      const group = new Group();
      if (meshDef.extensions)
        addUnknownExtensionsToUserData(extensions2, group, meshDef);
      parser.associations.set(group, { meshes: meshIndex });
      for (let i2 = 0, il = meshes.length; i2 < il; i2++) {
        group.add(meshes[i2]);
      }
      return group;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */
  loadCamera(cameraIndex) {
    let camera;
    const cameraDef = this.json.cameras[cameraIndex];
    const params = cameraDef[cameraDef.type];
    if (!params) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    if (cameraDef.type === "perspective") {
      camera = new PerspectiveCamera(
        MathUtils.radToDeg(params.yfov),
        params.aspectRatio || 1,
        params.znear || 1,
        params.zfar || 2e6
      );
    } else if (cameraDef.type === "orthographic") {
      camera = new OrthographicCamera(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
    }
    if (cameraDef.name)
      camera.name = this.createUniqueName(cameraDef.name);
    assignExtrasToUserData(camera, cameraDef);
    return Promise.resolve(camera);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */
  loadSkin(skinIndex) {
    const skinDef = this.json.skins[skinIndex];
    const pending = [];
    for (let i2 = 0, il = skinDef.joints.length; i2 < il; i2++) {
      pending.push(this._loadNodeShallow(skinDef.joints[i2]));
    }
    if (skinDef.inverseBindMatrices !== void 0) {
      pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
    } else {
      pending.push(null);
    }
    return Promise.all(pending).then(function(results) {
      const inverseBindMatrices = results.pop();
      const jointNodes = results;
      const bones = [];
      const boneInverses = [];
      for (let i2 = 0, il = jointNodes.length; i2 < il; i2++) {
        const jointNode = jointNodes[i2];
        if (jointNode) {
          bones.push(jointNode);
          const mat2 = new Matrix4();
          if (inverseBindMatrices !== null) {
            mat2.fromArray(inverseBindMatrices.array, i2 * 16);
          }
          boneInverses.push(mat2);
        } else {
          console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i2]);
        }
      }
      return new Skeleton(bones, boneInverses);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */
  loadAnimation(animationIndex) {
    const json = this.json;
    const parser = this;
    const animationDef = json.animations[animationIndex];
    const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
    const pendingNodes = [];
    const pendingInputAccessors = [];
    const pendingOutputAccessors = [];
    const pendingSamplers = [];
    const pendingTargets = [];
    for (let i2 = 0, il = animationDef.channels.length; i2 < il; i2++) {
      const channel = animationDef.channels[i2];
      const sampler = animationDef.samplers[channel.sampler];
      const target = channel.target;
      const name = target.node;
      const input = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.input] : sampler.input;
      const output = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.output] : sampler.output;
      if (target.node === void 0)
        continue;
      pendingNodes.push(this.getDependency("node", name));
      pendingInputAccessors.push(this.getDependency("accessor", input));
      pendingOutputAccessors.push(this.getDependency("accessor", output));
      pendingSamplers.push(sampler);
      pendingTargets.push(target);
    }
    return Promise.all([
      Promise.all(pendingNodes),
      Promise.all(pendingInputAccessors),
      Promise.all(pendingOutputAccessors),
      Promise.all(pendingSamplers),
      Promise.all(pendingTargets)
    ]).then(function(dependencies) {
      const nodes = dependencies[0];
      const inputAccessors = dependencies[1];
      const outputAccessors = dependencies[2];
      const samplers = dependencies[3];
      const targets = dependencies[4];
      const tracks = [];
      for (let i2 = 0, il = nodes.length; i2 < il; i2++) {
        const node = nodes[i2];
        const inputAccessor = inputAccessors[i2];
        const outputAccessor = outputAccessors[i2];
        const sampler = samplers[i2];
        const target = targets[i2];
        if (node === void 0)
          continue;
        if (node.updateMatrix) {
          node.updateMatrix();
        }
        const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
        if (createdTracks) {
          for (let k2 = 0; k2 < createdTracks.length; k2++) {
            tracks.push(createdTracks[k2]);
          }
        }
      }
      return new AnimationClip(animationName, void 0, tracks);
    });
  }
  createNodeMesh(nodeIndex) {
    const json = this.json;
    const parser = this;
    const nodeDef = json.nodes[nodeIndex];
    if (nodeDef.mesh === void 0)
      return null;
    return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
      const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
      if (nodeDef.weights !== void 0) {
        node.traverse(function(o2) {
          if (!o2.isMesh)
            return;
          for (let i2 = 0, il = nodeDef.weights.length; i2 < il; i2++) {
            o2.morphTargetInfluences[i2] = nodeDef.weights[i2];
          }
        });
      }
      return node;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */
  loadNode(nodeIndex) {
    const json = this.json;
    const parser = this;
    const nodeDef = json.nodes[nodeIndex];
    const nodePending = parser._loadNodeShallow(nodeIndex);
    const childPending = [];
    const childrenDef = nodeDef.children || [];
    for (let i2 = 0, il = childrenDef.length; i2 < il; i2++) {
      childPending.push(parser.getDependency("node", childrenDef[i2]));
    }
    const skeletonPending = nodeDef.skin === void 0 ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
    return Promise.all([nodePending, Promise.all(childPending), skeletonPending]).then(function(results) {
      const node = results[0];
      const children = results[1];
      const skeleton = results[2];
      if (skeleton !== null) {
        node.traverse(function(mesh) {
          if (!mesh.isSkinnedMesh)
            return;
          mesh.bind(skeleton, _identityMatrix);
        });
      }
      for (let i2 = 0, il = children.length; i2 < il; i2++) {
        node.add(children[i2]);
      }
      return node;
    });
  }
  // ._loadNodeShallow() parses a single node.
  // skin and child nodes are created and added in .loadNode() (no '_' prefix).
  _loadNodeShallow(nodeIndex) {
    const json = this.json;
    const extensions2 = this.extensions;
    const parser = this;
    if (this.nodeCache[nodeIndex] !== void 0) {
      return this.nodeCache[nodeIndex];
    }
    const nodeDef = json.nodes[nodeIndex];
    const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
    const pending = [];
    const meshPromise = parser._invokeOne(function(ext) {
      return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
    });
    if (meshPromise) {
      pending.push(meshPromise);
    }
    if (nodeDef.camera !== void 0) {
      pending.push(
        parser.getDependency("camera", nodeDef.camera).then(function(camera) {
          return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        })
      );
    }
    parser._invokeAll(function(ext) {
      return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
    }).forEach(function(promise) {
      pending.push(promise);
    });
    this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
      let node;
      if (nodeDef.isBone === true) {
        node = new Bone();
      } else if (objects.length > 1) {
        node = new Group();
      } else if (objects.length === 1) {
        node = objects[0];
      } else {
        node = new Object3D();
      }
      if (node !== objects[0]) {
        for (let i2 = 0, il = objects.length; i2 < il; i2++) {
          node.add(objects[i2]);
        }
      }
      if (nodeDef.name) {
        node.userData.name = nodeDef.name;
        node.name = nodeName;
      }
      assignExtrasToUserData(node, nodeDef);
      if (nodeDef.extensions)
        addUnknownExtensionsToUserData(extensions2, node, nodeDef);
      if (nodeDef.matrix !== void 0) {
        const matrix = new Matrix4();
        matrix.fromArray(nodeDef.matrix);
        node.applyMatrix4(matrix);
      } else {
        if (nodeDef.translation !== void 0) {
          node.position.fromArray(nodeDef.translation);
        }
        if (nodeDef.rotation !== void 0) {
          node.quaternion.fromArray(nodeDef.rotation);
        }
        if (nodeDef.scale !== void 0) {
          node.scale.fromArray(nodeDef.scale);
        }
      }
      if (!parser.associations.has(node)) {
        parser.associations.set(node, {});
      }
      parser.associations.get(node).nodes = nodeIndex;
      return node;
    });
    return this.nodeCache[nodeIndex];
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */
  loadScene(sceneIndex) {
    const extensions2 = this.extensions;
    const sceneDef = this.json.scenes[sceneIndex];
    const parser = this;
    const scene = new Group();
    if (sceneDef.name)
      scene.name = parser.createUniqueName(sceneDef.name);
    assignExtrasToUserData(scene, sceneDef);
    if (sceneDef.extensions)
      addUnknownExtensionsToUserData(extensions2, scene, sceneDef);
    const nodeIds = sceneDef.nodes || [];
    const pending = [];
    for (let i2 = 0, il = nodeIds.length; i2 < il; i2++) {
      pending.push(parser.getDependency("node", nodeIds[i2]));
    }
    return Promise.all(pending).then(function(nodes) {
      for (let i2 = 0, il = nodes.length; i2 < il; i2++) {
        scene.add(nodes[i2]);
      }
      const reduceAssociations = (node) => {
        const reducedAssociations = /* @__PURE__ */ new Map();
        for (const [key, value] of parser.associations) {
          if (key instanceof Material || key instanceof Texture) {
            reducedAssociations.set(key, value);
          }
        }
        node.traverse((node2) => {
          const mappings = parser.associations.get(node2);
          if (mappings != null) {
            reducedAssociations.set(node2, mappings);
          }
        });
        return reducedAssociations;
      };
      parser.associations = reduceAssociations(scene);
      return scene;
    });
  }
  _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
    const tracks = [];
    const targetName = node.name ? node.name : node.uuid;
    const targetNames = [];
    if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) {
      node.traverse(function(object) {
        if (object.morphTargetInfluences) {
          targetNames.push(object.name ? object.name : object.uuid);
        }
      });
    } else {
      targetNames.push(targetName);
    }
    let TypedKeyframeTrack;
    switch (PATH_PROPERTIES[target.path]) {
      case PATH_PROPERTIES.weights:
        TypedKeyframeTrack = NumberKeyframeTrack;
        break;
      case PATH_PROPERTIES.rotation:
        TypedKeyframeTrack = QuaternionKeyframeTrack;
        break;
      case PATH_PROPERTIES.position:
      case PATH_PROPERTIES.scale:
        TypedKeyframeTrack = VectorKeyframeTrack;
        break;
      default:
        switch (outputAccessor.itemSize) {
          case 1:
            TypedKeyframeTrack = NumberKeyframeTrack;
            break;
          case 2:
          case 3:
          default:
            TypedKeyframeTrack = VectorKeyframeTrack;
            break;
        }
        break;
    }
    const interpolation = sampler.interpolation !== void 0 ? INTERPOLATION[sampler.interpolation] : InterpolateLinear;
    const outputArray = this._getArrayFromAccessor(outputAccessor);
    for (let j3 = 0, jl = targetNames.length; j3 < jl; j3++) {
      const track = new TypedKeyframeTrack(
        targetNames[j3] + "." + PATH_PROPERTIES[target.path],
        inputAccessor.array,
        outputArray,
        interpolation
      );
      if (sampler.interpolation === "CUBICSPLINE") {
        this._createCubicSplineTrackInterpolant(track);
      }
      tracks.push(track);
    }
    return tracks;
  }
  _getArrayFromAccessor(accessor) {
    let outputArray = accessor.array;
    if (accessor.normalized) {
      const scale = getNormalizedComponentScale(outputArray.constructor);
      const scaled = new Float32Array(outputArray.length);
      for (let j3 = 0, jl = outputArray.length; j3 < jl; j3++) {
        scaled[j3] = outputArray[j3] * scale;
      }
      outputArray = scaled;
    }
    return outputArray;
  }
  _createCubicSplineTrackInterpolant(track) {
    track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
      const interpolantType = this instanceof QuaternionKeyframeTrack ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;
      return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
    };
    track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
  }
}
function computeBounds(geometry, primitiveDef, parser) {
  const attributes = primitiveDef.attributes;
  const box = new Box3();
  if (attributes.POSITION !== void 0) {
    const accessor = parser.json.accessors[attributes.POSITION];
    const min = accessor.min;
    const max2 = accessor.max;
    if (min !== void 0 && max2 !== void 0) {
      box.set(new Vector3(min[0], min[1], min[2]), new Vector3(max2[0], max2[1], max2[2]));
      if (accessor.normalized) {
        const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
        box.min.multiplyScalar(boxScale);
        box.max.multiplyScalar(boxScale);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else {
    return;
  }
  const targets = primitiveDef.targets;
  if (targets !== void 0) {
    const maxDisplacement = new Vector3();
    const vector = new Vector3();
    for (let i2 = 0, il = targets.length; i2 < il; i2++) {
      const target = targets[i2];
      if (target.POSITION !== void 0) {
        const accessor = parser.json.accessors[target.POSITION];
        const min = accessor.min;
        const max2 = accessor.max;
        if (min !== void 0 && max2 !== void 0) {
          vector.setX(Math.max(Math.abs(min[0]), Math.abs(max2[0])));
          vector.setY(Math.max(Math.abs(min[1]), Math.abs(max2[1])));
          vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max2[2])));
          if (accessor.normalized) {
            const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
            vector.multiplyScalar(boxScale);
          }
          maxDisplacement.max(vector);
        } else {
          console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
        }
      }
    }
    box.expandByVector(maxDisplacement);
  }
  geometry.boundingBox = box;
  const sphere = new Sphere();
  box.getCenter(sphere.center);
  sphere.radius = box.min.distanceTo(box.max) / 2;
  geometry.boundingSphere = sphere;
}
function addPrimitiveAttributes(geometry, primitiveDef, parser) {
  const attributes = primitiveDef.attributes;
  const pending = [];
  function assignAttributeAccessor(accessorIndex, attributeName) {
    return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
      geometry.setAttribute(attributeName, accessor);
    });
  }
  for (const gltfAttributeName in attributes) {
    const threeAttributeName = ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
    if (threeAttributeName in geometry.attributes)
      continue;
    pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
  }
  if (primitiveDef.indices !== void 0 && !geometry.index) {
    const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor2) {
      geometry.setIndex(accessor2);
    });
    pending.push(accessor);
  }
  assignExtrasToUserData(geometry, primitiveDef);
  computeBounds(geometry, primitiveDef, parser);
  return Promise.all(pending).then(function() {
    return primitiveDef.targets !== void 0 ? addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
  });
}
class RGBELoader extends DataTextureLoader {
  constructor(manager) {
    super(manager);
    this.type = HalfFloatType;
  }
  // adapted from http://www.graphics.cornell.edu/~bjw/rgbe.html
  parse(buffer) {
    const rgbe_read_error = 1, rgbe_write_error = 2, rgbe_format_error = 3, rgbe_memory_error = 4, rgbe_error = function(rgbe_error_code, msg) {
      switch (rgbe_error_code) {
        case rgbe_read_error:
          throw new Error("THREE.RGBELoader: Read Error: " + (msg || ""));
        case rgbe_write_error:
          throw new Error("THREE.RGBELoader: Write Error: " + (msg || ""));
        case rgbe_format_error:
          throw new Error("THREE.RGBELoader: Bad File Format: " + (msg || ""));
        default:
        case rgbe_memory_error:
          throw new Error("THREE.RGBELoader: Memory Error: " + (msg || ""));
      }
    }, RGBE_VALID_PROGRAMTYPE = 1, RGBE_VALID_FORMAT = 2, RGBE_VALID_DIMENSIONS = 4, NEWLINE = "\n", fgets = function(buffer2, lineLimit, consume) {
      const chunkSize = 128;
      lineLimit = !lineLimit ? 1024 : lineLimit;
      let p3 = buffer2.pos, i2 = -1, len = 0, s2 = "", chunk = String.fromCharCode.apply(null, new Uint16Array(buffer2.subarray(p3, p3 + chunkSize)));
      while (0 > (i2 = chunk.indexOf(NEWLINE)) && len < lineLimit && p3 < buffer2.byteLength) {
        s2 += chunk;
        len += chunk.length;
        p3 += chunkSize;
        chunk += String.fromCharCode.apply(null, new Uint16Array(buffer2.subarray(p3, p3 + chunkSize)));
      }
      if (-1 < i2) {
        buffer2.pos += len + i2 + 1;
        return s2 + chunk.slice(0, i2);
      }
      return false;
    }, RGBE_ReadHeader = function(buffer2) {
      const magic_token_re = /^#\?(\S+)/, gamma_re = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, exposure_re = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, format_re = /^\s*FORMAT=(\S+)\s*$/, dimensions_re = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, header = {
        valid: 0,
        string: "",
        comments: "",
        programtype: "RGBE",
        format: "",
        gamma: 1,
        exposure: 1,
        width: 0,
        height: 0
      };
      let line, match;
      if (buffer2.pos >= buffer2.byteLength || !(line = fgets(buffer2))) {
        rgbe_error(rgbe_read_error, "no header found");
      }
      if (!(match = line.match(magic_token_re))) {
        rgbe_error(rgbe_format_error, "bad initial token");
      }
      header.valid |= RGBE_VALID_PROGRAMTYPE;
      header.programtype = match[1];
      header.string += line + "\n";
      while (true) {
        line = fgets(buffer2);
        if (false === line)
          break;
        header.string += line + "\n";
        if ("#" === line.charAt(0)) {
          header.comments += line + "\n";
          continue;
        }
        if (match = line.match(gamma_re)) {
          header.gamma = parseFloat(match[1]);
        }
        if (match = line.match(exposure_re)) {
          header.exposure = parseFloat(match[1]);
        }
        if (match = line.match(format_re)) {
          header.valid |= RGBE_VALID_FORMAT;
          header.format = match[1];
        }
        if (match = line.match(dimensions_re)) {
          header.valid |= RGBE_VALID_DIMENSIONS;
          header.height = parseInt(match[1], 10);
          header.width = parseInt(match[2], 10);
        }
        if (header.valid & RGBE_VALID_FORMAT && header.valid & RGBE_VALID_DIMENSIONS)
          break;
      }
      if (!(header.valid & RGBE_VALID_FORMAT)) {
        rgbe_error(rgbe_format_error, "missing format specifier");
      }
      if (!(header.valid & RGBE_VALID_DIMENSIONS)) {
        rgbe_error(rgbe_format_error, "missing image size specifier");
      }
      return header;
    }, RGBE_ReadPixels_RLE = function(buffer2, w22, h22) {
      const scanline_width = w22;
      if (
        // run length encoding is not allowed so read flat
        scanline_width < 8 || scanline_width > 32767 || // this file is not run length encoded
        2 !== buffer2[0] || 2 !== buffer2[1] || buffer2[2] & 128
      ) {
        return new Uint8Array(buffer2);
      }
      if (scanline_width !== (buffer2[2] << 8 | buffer2[3])) {
        rgbe_error(rgbe_format_error, "wrong scanline width");
      }
      const data_rgba = new Uint8Array(4 * w22 * h22);
      if (!data_rgba.length) {
        rgbe_error(rgbe_memory_error, "unable to allocate buffer space");
      }
      let offset = 0, pos = 0;
      const ptr_end = 4 * scanline_width;
      const rgbeStart = new Uint8Array(4);
      const scanline_buffer = new Uint8Array(ptr_end);
      let num_scanlines = h22;
      while (num_scanlines > 0 && pos < buffer2.byteLength) {
        if (pos + 4 > buffer2.byteLength) {
          rgbe_error(rgbe_read_error);
        }
        rgbeStart[0] = buffer2[pos++];
        rgbeStart[1] = buffer2[pos++];
        rgbeStart[2] = buffer2[pos++];
        rgbeStart[3] = buffer2[pos++];
        if (2 != rgbeStart[0] || 2 != rgbeStart[1] || (rgbeStart[2] << 8 | rgbeStart[3]) != scanline_width) {
          rgbe_error(rgbe_format_error, "bad rgbe scanline format");
        }
        let ptr = 0, count;
        while (ptr < ptr_end && pos < buffer2.byteLength) {
          count = buffer2[pos++];
          const isEncodedRun = count > 128;
          if (isEncodedRun)
            count -= 128;
          if (0 === count || ptr + count > ptr_end) {
            rgbe_error(rgbe_format_error, "bad scanline data");
          }
          if (isEncodedRun) {
            const byteValue = buffer2[pos++];
            for (let i2 = 0; i2 < count; i2++) {
              scanline_buffer[ptr++] = byteValue;
            }
          } else {
            scanline_buffer.set(buffer2.subarray(pos, pos + count), ptr);
            ptr += count;
            pos += count;
          }
        }
        const l2 = scanline_width;
        for (let i2 = 0; i2 < l2; i2++) {
          let off = 0;
          data_rgba[offset] = scanline_buffer[i2 + off];
          off += scanline_width;
          data_rgba[offset + 1] = scanline_buffer[i2 + off];
          off += scanline_width;
          data_rgba[offset + 2] = scanline_buffer[i2 + off];
          off += scanline_width;
          data_rgba[offset + 3] = scanline_buffer[i2 + off];
          offset += 4;
        }
        num_scanlines--;
      }
      return data_rgba;
    };
    const RGBEByteToRGBFloat = function(sourceArray, sourceOffset, destArray, destOffset) {
      const e2 = sourceArray[sourceOffset + 3];
      const scale = Math.pow(2, e2 - 128) / 255;
      destArray[destOffset + 0] = sourceArray[sourceOffset + 0] * scale;
      destArray[destOffset + 1] = sourceArray[sourceOffset + 1] * scale;
      destArray[destOffset + 2] = sourceArray[sourceOffset + 2] * scale;
      destArray[destOffset + 3] = 1;
    };
    const RGBEByteToRGBHalf = function(sourceArray, sourceOffset, destArray, destOffset) {
      const e2 = sourceArray[sourceOffset + 3];
      const scale = Math.pow(2, e2 - 128) / 255;
      destArray[destOffset + 0] = DataUtils.toHalfFloat(Math.min(sourceArray[sourceOffset + 0] * scale, 65504));
      destArray[destOffset + 1] = DataUtils.toHalfFloat(Math.min(sourceArray[sourceOffset + 1] * scale, 65504));
      destArray[destOffset + 2] = DataUtils.toHalfFloat(Math.min(sourceArray[sourceOffset + 2] * scale, 65504));
      destArray[destOffset + 3] = DataUtils.toHalfFloat(1);
    };
    const byteArray = new Uint8Array(buffer);
    byteArray.pos = 0;
    const rgbe_header_info = RGBE_ReadHeader(byteArray);
    const w2 = rgbe_header_info.width, h2 = rgbe_header_info.height, image_rgba_data = RGBE_ReadPixels_RLE(byteArray.subarray(byteArray.pos), w2, h2);
    let data, type;
    let numElements;
    switch (this.type) {
      case FloatType:
        numElements = image_rgba_data.length / 4;
        const floatArray = new Float32Array(numElements * 4);
        for (let j3 = 0; j3 < numElements; j3++) {
          RGBEByteToRGBFloat(image_rgba_data, j3 * 4, floatArray, j3 * 4);
        }
        data = floatArray;
        type = FloatType;
        break;
      case HalfFloatType:
        numElements = image_rgba_data.length / 4;
        const halfArray = new Uint16Array(numElements * 4);
        for (let j3 = 0; j3 < numElements; j3++) {
          RGBEByteToRGBHalf(image_rgba_data, j3 * 4, halfArray, j3 * 4);
        }
        data = halfArray;
        type = HalfFloatType;
        break;
      default:
        throw new Error("THREE.RGBELoader: Unsupported type: " + this.type);
    }
    return {
      width: w2,
      height: h2,
      data,
      header: rgbe_header_info.string,
      gamma: rgbe_header_info.gamma,
      exposure: rgbe_header_info.exposure,
      type
    };
  }
  setDataType(value) {
    this.type = value;
    return this;
  }
  load(url, onLoad, onProgress, onError) {
    function onLoadCallback(texture, texData) {
      switch (texture.type) {
        case FloatType:
        case HalfFloatType:
          if ("colorSpace" in texture)
            texture.colorSpace = "srgb-linear";
          else
            texture.encoding = 3e3;
          texture.minFilter = LinearFilter;
          texture.magFilter = LinearFilter;
          texture.generateMipmaps = false;
          texture.flipY = true;
          break;
      }
      if (onLoad)
        onLoad(texture, texData);
    }
    return super.load(url, onLoadCallback, onProgress, onError);
  }
}
const hasColorSpace = version >= 152;
class EXRLoader extends DataTextureLoader {
  constructor(manager) {
    super(manager);
    this.type = HalfFloatType;
  }
  parse(buffer) {
    const USHORT_RANGE = 1 << 16;
    const BITMAP_SIZE = USHORT_RANGE >> 3;
    const HUF_ENCBITS = 16;
    const HUF_DECBITS = 14;
    const HUF_ENCSIZE = (1 << HUF_ENCBITS) + 1;
    const HUF_DECSIZE = 1 << HUF_DECBITS;
    const HUF_DECMASK = HUF_DECSIZE - 1;
    const NBITS = 16;
    const A_OFFSET = 1 << NBITS - 1;
    const MOD_MASK = (1 << NBITS) - 1;
    const SHORT_ZEROCODE_RUN = 59;
    const LONG_ZEROCODE_RUN = 63;
    const SHORTEST_LONG_RUN = 2 + LONG_ZEROCODE_RUN - SHORT_ZEROCODE_RUN;
    const ULONG_SIZE = 8;
    const FLOAT32_SIZE = 4;
    const INT32_SIZE = 4;
    const INT16_SIZE = 2;
    const INT8_SIZE = 1;
    const STATIC_HUFFMAN = 0;
    const DEFLATE = 1;
    const UNKNOWN = 0;
    const LOSSY_DCT = 1;
    const RLE = 2;
    const logBase = Math.pow(2.7182818, 2.2);
    function reverseLutFromBitmap(bitmap, lut) {
      var k2 = 0;
      for (var i2 = 0; i2 < USHORT_RANGE; ++i2) {
        if (i2 == 0 || bitmap[i2 >> 3] & 1 << (i2 & 7)) {
          lut[k2++] = i2;
        }
      }
      var n2 = k2 - 1;
      while (k2 < USHORT_RANGE)
        lut[k2++] = 0;
      return n2;
    }
    function hufClearDecTable(hdec) {
      for (var i2 = 0; i2 < HUF_DECSIZE; i2++) {
        hdec[i2] = {};
        hdec[i2].len = 0;
        hdec[i2].lit = 0;
        hdec[i2].p = null;
      }
    }
    const getBitsReturn = { l: 0, c: 0, lc: 0 };
    function getBits(nBits, c2, lc, uInt8Array2, inOffset) {
      while (lc < nBits) {
        c2 = c2 << 8 | parseUint8Array(uInt8Array2, inOffset);
        lc += 8;
      }
      lc -= nBits;
      getBitsReturn.l = c2 >> lc & (1 << nBits) - 1;
      getBitsReturn.c = c2;
      getBitsReturn.lc = lc;
    }
    const hufTableBuffer = new Array(59);
    function hufCanonicalCodeTable(hcode) {
      for (var i2 = 0; i2 <= 58; ++i2)
        hufTableBuffer[i2] = 0;
      for (var i2 = 0; i2 < HUF_ENCSIZE; ++i2)
        hufTableBuffer[hcode[i2]] += 1;
      var c2 = 0;
      for (var i2 = 58; i2 > 0; --i2) {
        var nc = c2 + hufTableBuffer[i2] >> 1;
        hufTableBuffer[i2] = c2;
        c2 = nc;
      }
      for (var i2 = 0; i2 < HUF_ENCSIZE; ++i2) {
        var l2 = hcode[i2];
        if (l2 > 0)
          hcode[i2] = l2 | hufTableBuffer[l2]++ << 6;
      }
    }
    function hufUnpackEncTable(uInt8Array2, inDataView, inOffset, ni, im, iM, hcode) {
      var p3 = inOffset;
      var c2 = 0;
      var lc = 0;
      for (; im <= iM; im++) {
        if (p3.value - inOffset.value > ni)
          return false;
        getBits(6, c2, lc, uInt8Array2, p3);
        var l2 = getBitsReturn.l;
        c2 = getBitsReturn.c;
        lc = getBitsReturn.lc;
        hcode[im] = l2;
        if (l2 == LONG_ZEROCODE_RUN) {
          if (p3.value - inOffset.value > ni) {
            throw "Something wrong with hufUnpackEncTable";
          }
          getBits(8, c2, lc, uInt8Array2, p3);
          var zerun = getBitsReturn.l + SHORTEST_LONG_RUN;
          c2 = getBitsReturn.c;
          lc = getBitsReturn.lc;
          if (im + zerun > iM + 1) {
            throw "Something wrong with hufUnpackEncTable";
          }
          while (zerun--)
            hcode[im++] = 0;
          im--;
        } else if (l2 >= SHORT_ZEROCODE_RUN) {
          var zerun = l2 - SHORT_ZEROCODE_RUN + 2;
          if (im + zerun > iM + 1) {
            throw "Something wrong with hufUnpackEncTable";
          }
          while (zerun--)
            hcode[im++] = 0;
          im--;
        }
      }
      hufCanonicalCodeTable(hcode);
    }
    function hufLength(code) {
      return code & 63;
    }
    function hufCode(code) {
      return code >> 6;
    }
    function hufBuildDecTable(hcode, im, iM, hdecod) {
      for (; im <= iM; im++) {
        var c2 = hufCode(hcode[im]);
        var l2 = hufLength(hcode[im]);
        if (c2 >> l2) {
          throw "Invalid table entry";
        }
        if (l2 > HUF_DECBITS) {
          var pl = hdecod[c2 >> l2 - HUF_DECBITS];
          if (pl.len) {
            throw "Invalid table entry";
          }
          pl.lit++;
          if (pl.p) {
            var p3 = pl.p;
            pl.p = new Array(pl.lit);
            for (var i2 = 0; i2 < pl.lit - 1; ++i2) {
              pl.p[i2] = p3[i2];
            }
          } else {
            pl.p = new Array(1);
          }
          pl.p[pl.lit - 1] = im;
        } else if (l2) {
          var plOffset = 0;
          for (var i2 = 1 << HUF_DECBITS - l2; i2 > 0; i2--) {
            var pl = hdecod[(c2 << HUF_DECBITS - l2) + plOffset];
            if (pl.len || pl.p) {
              throw "Invalid table entry";
            }
            pl.len = l2;
            pl.lit = im;
            plOffset++;
          }
        }
      }
      return true;
    }
    const getCharReturn = { c: 0, lc: 0 };
    function getChar(c2, lc, uInt8Array2, inOffset) {
      c2 = c2 << 8 | parseUint8Array(uInt8Array2, inOffset);
      lc += 8;
      getCharReturn.c = c2;
      getCharReturn.lc = lc;
    }
    const getCodeReturn = { c: 0, lc: 0 };
    function getCode(po, rlc, c2, lc, uInt8Array2, inDataView, inOffset, outBuffer, outBufferOffset, outBufferEndOffset) {
      if (po == rlc) {
        if (lc < 8) {
          getChar(c2, lc, uInt8Array2, inOffset);
          c2 = getCharReturn.c;
          lc = getCharReturn.lc;
        }
        lc -= 8;
        var cs = c2 >> lc;
        var cs = new Uint8Array([cs])[0];
        if (outBufferOffset.value + cs > outBufferEndOffset) {
          return false;
        }
        var s2 = outBuffer[outBufferOffset.value - 1];
        while (cs-- > 0) {
          outBuffer[outBufferOffset.value++] = s2;
        }
      } else if (outBufferOffset.value < outBufferEndOffset) {
        outBuffer[outBufferOffset.value++] = po;
      } else {
        return false;
      }
      getCodeReturn.c = c2;
      getCodeReturn.lc = lc;
    }
    function UInt16(value) {
      return value & 65535;
    }
    function Int16(value) {
      var ref = UInt16(value);
      return ref > 32767 ? ref - 65536 : ref;
    }
    const wdec14Return = { a: 0, b: 0 };
    function wdec14(l2, h2) {
      var ls = Int16(l2);
      var hs = Int16(h2);
      var hi = hs;
      var ai = ls + (hi & 1) + (hi >> 1);
      var as = ai;
      var bs = ai - hi;
      wdec14Return.a = as;
      wdec14Return.b = bs;
    }
    function wdec16(l2, h2) {
      var m2 = UInt16(l2);
      var d3 = UInt16(h2);
      var bb = m2 - (d3 >> 1) & MOD_MASK;
      var aa = d3 + bb - A_OFFSET & MOD_MASK;
      wdec14Return.a = aa;
      wdec14Return.b = bb;
    }
    function wav2Decode(buffer2, j3, nx, ox, ny, oy, mx) {
      var w14 = mx < 1 << 14;
      var n2 = nx > ny ? ny : nx;
      var p3 = 1;
      var p22;
      while (p3 <= n2)
        p3 <<= 1;
      p3 >>= 1;
      p22 = p3;
      p3 >>= 1;
      while (p3 >= 1) {
        var py2 = 0;
        var ey = py2 + oy * (ny - p22);
        var oy1 = oy * p3;
        var oy2 = oy * p22;
        var ox1 = ox * p3;
        var ox2 = ox * p22;
        var i00, i01, i10, i11;
        for (; py2 <= ey; py2 += oy2) {
          var px2 = py2;
          var ex = py2 + ox * (nx - p22);
          for (; px2 <= ex; px2 += ox2) {
            var p01 = px2 + ox1;
            var p10 = px2 + oy1;
            var p11 = p10 + ox1;
            if (w14) {
              wdec14(buffer2[px2 + j3], buffer2[p10 + j3]);
              i00 = wdec14Return.a;
              i10 = wdec14Return.b;
              wdec14(buffer2[p01 + j3], buffer2[p11 + j3]);
              i01 = wdec14Return.a;
              i11 = wdec14Return.b;
              wdec14(i00, i01);
              buffer2[px2 + j3] = wdec14Return.a;
              buffer2[p01 + j3] = wdec14Return.b;
              wdec14(i10, i11);
              buffer2[p10 + j3] = wdec14Return.a;
              buffer2[p11 + j3] = wdec14Return.b;
            } else {
              wdec16(buffer2[px2 + j3], buffer2[p10 + j3]);
              i00 = wdec14Return.a;
              i10 = wdec14Return.b;
              wdec16(buffer2[p01 + j3], buffer2[p11 + j3]);
              i01 = wdec14Return.a;
              i11 = wdec14Return.b;
              wdec16(i00, i01);
              buffer2[px2 + j3] = wdec14Return.a;
              buffer2[p01 + j3] = wdec14Return.b;
              wdec16(i10, i11);
              buffer2[p10 + j3] = wdec14Return.a;
              buffer2[p11 + j3] = wdec14Return.b;
            }
          }
          if (nx & p3) {
            var p10 = px2 + oy1;
            if (w14)
              wdec14(buffer2[px2 + j3], buffer2[p10 + j3]);
            else
              wdec16(buffer2[px2 + j3], buffer2[p10 + j3]);
            i00 = wdec14Return.a;
            buffer2[p10 + j3] = wdec14Return.b;
            buffer2[px2 + j3] = i00;
          }
        }
        if (ny & p3) {
          var px2 = py2;
          var ex = py2 + ox * (nx - p22);
          for (; px2 <= ex; px2 += ox2) {
            var p01 = px2 + ox1;
            if (w14)
              wdec14(buffer2[px2 + j3], buffer2[p01 + j3]);
            else
              wdec16(buffer2[px2 + j3], buffer2[p01 + j3]);
            i00 = wdec14Return.a;
            buffer2[p01 + j3] = wdec14Return.b;
            buffer2[px2 + j3] = i00;
          }
        }
        p22 = p3;
        p3 >>= 1;
      }
      return py2;
    }
    function hufDecode(encodingTable, decodingTable, uInt8Array2, inDataView, inOffset, ni, rlc, no, outBuffer, outOffset) {
      var c2 = 0;
      var lc = 0;
      var outBufferEndOffset = no;
      var inOffsetEnd = Math.trunc(inOffset.value + (ni + 7) / 8);
      while (inOffset.value < inOffsetEnd) {
        getChar(c2, lc, uInt8Array2, inOffset);
        c2 = getCharReturn.c;
        lc = getCharReturn.lc;
        while (lc >= HUF_DECBITS) {
          var index = c2 >> lc - HUF_DECBITS & HUF_DECMASK;
          var pl = decodingTable[index];
          if (pl.len) {
            lc -= pl.len;
            getCode(pl.lit, rlc, c2, lc, uInt8Array2, inDataView, inOffset, outBuffer, outOffset, outBufferEndOffset);
            c2 = getCodeReturn.c;
            lc = getCodeReturn.lc;
          } else {
            if (!pl.p) {
              throw "hufDecode issues";
            }
            var j3;
            for (j3 = 0; j3 < pl.lit; j3++) {
              var l2 = hufLength(encodingTable[pl.p[j3]]);
              while (lc < l2 && inOffset.value < inOffsetEnd) {
                getChar(c2, lc, uInt8Array2, inOffset);
                c2 = getCharReturn.c;
                lc = getCharReturn.lc;
              }
              if (lc >= l2) {
                if (hufCode(encodingTable[pl.p[j3]]) == (c2 >> lc - l2 & (1 << l2) - 1)) {
                  lc -= l2;
                  getCode(
                    pl.p[j3],
                    rlc,
                    c2,
                    lc,
                    uInt8Array2,
                    inDataView,
                    inOffset,
                    outBuffer,
                    outOffset,
                    outBufferEndOffset
                  );
                  c2 = getCodeReturn.c;
                  lc = getCodeReturn.lc;
                  break;
                }
              }
            }
            if (j3 == pl.lit) {
              throw "hufDecode issues";
            }
          }
        }
      }
      var i2 = 8 - ni & 7;
      c2 >>= i2;
      lc -= i2;
      while (lc > 0) {
        var pl = decodingTable[c2 << HUF_DECBITS - lc & HUF_DECMASK];
        if (pl.len) {
          lc -= pl.len;
          getCode(pl.lit, rlc, c2, lc, uInt8Array2, inDataView, inOffset, outBuffer, outOffset, outBufferEndOffset);
          c2 = getCodeReturn.c;
          lc = getCodeReturn.lc;
        } else {
          throw "hufDecode issues";
        }
      }
      return true;
    }
    function hufUncompress(uInt8Array2, inDataView, inOffset, nCompressed, outBuffer, nRaw) {
      var outOffset = { value: 0 };
      var initialInOffset = inOffset.value;
      var im = parseUint32(inDataView, inOffset);
      var iM = parseUint32(inDataView, inOffset);
      inOffset.value += 4;
      var nBits = parseUint32(inDataView, inOffset);
      inOffset.value += 4;
      if (im < 0 || im >= HUF_ENCSIZE || iM < 0 || iM >= HUF_ENCSIZE) {
        throw "Something wrong with HUF_ENCSIZE";
      }
      var freq = new Array(HUF_ENCSIZE);
      var hdec = new Array(HUF_DECSIZE);
      hufClearDecTable(hdec);
      var ni = nCompressed - (inOffset.value - initialInOffset);
      hufUnpackEncTable(uInt8Array2, inDataView, inOffset, ni, im, iM, freq);
      if (nBits > 8 * (nCompressed - (inOffset.value - initialInOffset))) {
        throw "Something wrong with hufUncompress";
      }
      hufBuildDecTable(freq, im, iM, hdec);
      hufDecode(freq, hdec, uInt8Array2, inDataView, inOffset, nBits, iM, nRaw, outBuffer, outOffset);
    }
    function applyLut(lut, data, nData) {
      for (var i2 = 0; i2 < nData; ++i2) {
        data[i2] = lut[data[i2]];
      }
    }
    function predictor(source) {
      for (var t2 = 1; t2 < source.length; t2++) {
        var d3 = source[t2 - 1] + source[t2] - 128;
        source[t2] = d3;
      }
    }
    function interleaveScalar(source, out7) {
      var t1 = 0;
      var t2 = Math.floor((source.length + 1) / 2);
      var s2 = 0;
      var stop2 = source.length - 1;
      while (true) {
        if (s2 > stop2)
          break;
        out7[s2++] = source[t1++];
        if (s2 > stop2)
          break;
        out7[s2++] = source[t2++];
      }
    }
    function decodeRunLength(source) {
      var size = source.byteLength;
      var out7 = new Array();
      var p3 = 0;
      var reader = new DataView(source);
      while (size > 0) {
        var l2 = reader.getInt8(p3++);
        if (l2 < 0) {
          var count = -l2;
          size -= count + 1;
          for (var i2 = 0; i2 < count; i2++) {
            out7.push(reader.getUint8(p3++));
          }
        } else {
          var count = l2;
          size -= 2;
          var value = reader.getUint8(p3++);
          for (var i2 = 0; i2 < count + 1; i2++) {
            out7.push(value);
          }
        }
      }
      return out7;
    }
    function lossyDctDecode(cscSet, rowPtrs, channelData, acBuffer, dcBuffer, outBuffer) {
      var dataView = new DataView(outBuffer.buffer);
      var width = channelData[cscSet.idx[0]].width;
      var height = channelData[cscSet.idx[0]].height;
      var numComp = 3;
      var numFullBlocksX = Math.floor(width / 8);
      var numBlocksX = Math.ceil(width / 8);
      var numBlocksY = Math.ceil(height / 8);
      var leftoverX = width - (numBlocksX - 1) * 8;
      var leftoverY = height - (numBlocksY - 1) * 8;
      var currAcComp = { value: 0 };
      var currDcComp = new Array(numComp);
      var dctData = new Array(numComp);
      var halfZigBlock = new Array(numComp);
      var rowBlock = new Array(numComp);
      var rowOffsets = new Array(numComp);
      for (let comp2 = 0; comp2 < numComp; ++comp2) {
        rowOffsets[comp2] = rowPtrs[cscSet.idx[comp2]];
        currDcComp[comp2] = comp2 < 1 ? 0 : currDcComp[comp2 - 1] + numBlocksX * numBlocksY;
        dctData[comp2] = new Float32Array(64);
        halfZigBlock[comp2] = new Uint16Array(64);
        rowBlock[comp2] = new Uint16Array(numBlocksX * 64);
      }
      for (let blocky = 0; blocky < numBlocksY; ++blocky) {
        var maxY = 8;
        if (blocky == numBlocksY - 1)
          maxY = leftoverY;
        var maxX = 8;
        for (let blockx = 0; blockx < numBlocksX; ++blockx) {
          if (blockx == numBlocksX - 1)
            maxX = leftoverX;
          for (let comp2 = 0; comp2 < numComp; ++comp2) {
            halfZigBlock[comp2].fill(0);
            halfZigBlock[comp2][0] = dcBuffer[currDcComp[comp2]++];
            unRleAC(currAcComp, acBuffer, halfZigBlock[comp2]);
            unZigZag(halfZigBlock[comp2], dctData[comp2]);
            dctInverse(dctData[comp2]);
          }
          {
            csc709Inverse(dctData);
          }
          for (let comp2 = 0; comp2 < numComp; ++comp2) {
            convertToHalf(dctData[comp2], rowBlock[comp2], blockx * 64);
          }
        }
        let offset2 = 0;
        for (let comp2 = 0; comp2 < numComp; ++comp2) {
          const type2 = channelData[cscSet.idx[comp2]].type;
          for (let y22 = 8 * blocky; y22 < 8 * blocky + maxY; ++y22) {
            offset2 = rowOffsets[comp2][y22];
            for (let blockx = 0; blockx < numFullBlocksX; ++blockx) {
              const src = blockx * 64 + (y22 & 7) * 8;
              dataView.setUint16(offset2 + 0 * INT16_SIZE * type2, rowBlock[comp2][src + 0], true);
              dataView.setUint16(offset2 + 1 * INT16_SIZE * type2, rowBlock[comp2][src + 1], true);
              dataView.setUint16(offset2 + 2 * INT16_SIZE * type2, rowBlock[comp2][src + 2], true);
              dataView.setUint16(offset2 + 3 * INT16_SIZE * type2, rowBlock[comp2][src + 3], true);
              dataView.setUint16(offset2 + 4 * INT16_SIZE * type2, rowBlock[comp2][src + 4], true);
              dataView.setUint16(offset2 + 5 * INT16_SIZE * type2, rowBlock[comp2][src + 5], true);
              dataView.setUint16(offset2 + 6 * INT16_SIZE * type2, rowBlock[comp2][src + 6], true);
              dataView.setUint16(offset2 + 7 * INT16_SIZE * type2, rowBlock[comp2][src + 7], true);
              offset2 += 8 * INT16_SIZE * type2;
            }
          }
          if (numFullBlocksX != numBlocksX) {
            for (let y22 = 8 * blocky; y22 < 8 * blocky + maxY; ++y22) {
              const offset3 = rowOffsets[comp2][y22] + 8 * numFullBlocksX * INT16_SIZE * type2;
              const src = numFullBlocksX * 64 + (y22 & 7) * 8;
              for (let x22 = 0; x22 < maxX; ++x22) {
                dataView.setUint16(offset3 + x22 * INT16_SIZE * type2, rowBlock[comp2][src + x22], true);
              }
            }
          }
        }
      }
      var halfRow = new Uint16Array(width);
      var dataView = new DataView(outBuffer.buffer);
      for (var comp = 0; comp < numComp; ++comp) {
        channelData[cscSet.idx[comp]].decoded = true;
        var type = channelData[cscSet.idx[comp]].type;
        if (channelData[comp].type != 2)
          continue;
        for (var y2 = 0; y2 < height; ++y2) {
          const offset2 = rowOffsets[comp][y2];
          for (var x3 = 0; x3 < width; ++x3) {
            halfRow[x3] = dataView.getUint16(offset2 + x3 * INT16_SIZE * type, true);
          }
          for (var x3 = 0; x3 < width; ++x3) {
            dataView.setFloat32(offset2 + x3 * INT16_SIZE * type, decodeFloat16(halfRow[x3]), true);
          }
        }
      }
    }
    function unRleAC(currAcComp, acBuffer, halfZigBlock) {
      var acValue;
      var dctComp = 1;
      while (dctComp < 64) {
        acValue = acBuffer[currAcComp.value];
        if (acValue == 65280) {
          dctComp = 64;
        } else if (acValue >> 8 == 255) {
          dctComp += acValue & 255;
        } else {
          halfZigBlock[dctComp] = acValue;
          dctComp++;
        }
        currAcComp.value++;
      }
    }
    function unZigZag(src, dst) {
      dst[0] = decodeFloat16(src[0]);
      dst[1] = decodeFloat16(src[1]);
      dst[2] = decodeFloat16(src[5]);
      dst[3] = decodeFloat16(src[6]);
      dst[4] = decodeFloat16(src[14]);
      dst[5] = decodeFloat16(src[15]);
      dst[6] = decodeFloat16(src[27]);
      dst[7] = decodeFloat16(src[28]);
      dst[8] = decodeFloat16(src[2]);
      dst[9] = decodeFloat16(src[4]);
      dst[10] = decodeFloat16(src[7]);
      dst[11] = decodeFloat16(src[13]);
      dst[12] = decodeFloat16(src[16]);
      dst[13] = decodeFloat16(src[26]);
      dst[14] = decodeFloat16(src[29]);
      dst[15] = decodeFloat16(src[42]);
      dst[16] = decodeFloat16(src[3]);
      dst[17] = decodeFloat16(src[8]);
      dst[18] = decodeFloat16(src[12]);
      dst[19] = decodeFloat16(src[17]);
      dst[20] = decodeFloat16(src[25]);
      dst[21] = decodeFloat16(src[30]);
      dst[22] = decodeFloat16(src[41]);
      dst[23] = decodeFloat16(src[43]);
      dst[24] = decodeFloat16(src[9]);
      dst[25] = decodeFloat16(src[11]);
      dst[26] = decodeFloat16(src[18]);
      dst[27] = decodeFloat16(src[24]);
      dst[28] = decodeFloat16(src[31]);
      dst[29] = decodeFloat16(src[40]);
      dst[30] = decodeFloat16(src[44]);
      dst[31] = decodeFloat16(src[53]);
      dst[32] = decodeFloat16(src[10]);
      dst[33] = decodeFloat16(src[19]);
      dst[34] = decodeFloat16(src[23]);
      dst[35] = decodeFloat16(src[32]);
      dst[36] = decodeFloat16(src[39]);
      dst[37] = decodeFloat16(src[45]);
      dst[38] = decodeFloat16(src[52]);
      dst[39] = decodeFloat16(src[54]);
      dst[40] = decodeFloat16(src[20]);
      dst[41] = decodeFloat16(src[22]);
      dst[42] = decodeFloat16(src[33]);
      dst[43] = decodeFloat16(src[38]);
      dst[44] = decodeFloat16(src[46]);
      dst[45] = decodeFloat16(src[51]);
      dst[46] = decodeFloat16(src[55]);
      dst[47] = decodeFloat16(src[60]);
      dst[48] = decodeFloat16(src[21]);
      dst[49] = decodeFloat16(src[34]);
      dst[50] = decodeFloat16(src[37]);
      dst[51] = decodeFloat16(src[47]);
      dst[52] = decodeFloat16(src[50]);
      dst[53] = decodeFloat16(src[56]);
      dst[54] = decodeFloat16(src[59]);
      dst[55] = decodeFloat16(src[61]);
      dst[56] = decodeFloat16(src[35]);
      dst[57] = decodeFloat16(src[36]);
      dst[58] = decodeFloat16(src[48]);
      dst[59] = decodeFloat16(src[49]);
      dst[60] = decodeFloat16(src[57]);
      dst[61] = decodeFloat16(src[58]);
      dst[62] = decodeFloat16(src[62]);
      dst[63] = decodeFloat16(src[63]);
    }
    function dctInverse(data) {
      const a5 = 0.5 * Math.cos(3.14159 / 4);
      const b6 = 0.5 * Math.cos(3.14159 / 16);
      const c2 = 0.5 * Math.cos(3.14159 / 8);
      const d3 = 0.5 * Math.cos(3 * 3.14159 / 16);
      const e2 = 0.5 * Math.cos(5 * 3.14159 / 16);
      const f2 = 0.5 * Math.cos(3 * 3.14159 / 8);
      const g2 = 0.5 * Math.cos(7 * 3.14159 / 16);
      var alpha = new Array(4);
      var beta = new Array(4);
      var theta = new Array(4);
      var gamma = new Array(4);
      for (var row = 0; row < 8; ++row) {
        var rowPtr = row * 8;
        alpha[0] = c2 * data[rowPtr + 2];
        alpha[1] = f2 * data[rowPtr + 2];
        alpha[2] = c2 * data[rowPtr + 6];
        alpha[3] = f2 * data[rowPtr + 6];
        beta[0] = b6 * data[rowPtr + 1] + d3 * data[rowPtr + 3] + e2 * data[rowPtr + 5] + g2 * data[rowPtr + 7];
        beta[1] = d3 * data[rowPtr + 1] - g2 * data[rowPtr + 3] - b6 * data[rowPtr + 5] - e2 * data[rowPtr + 7];
        beta[2] = e2 * data[rowPtr + 1] - b6 * data[rowPtr + 3] + g2 * data[rowPtr + 5] + d3 * data[rowPtr + 7];
        beta[3] = g2 * data[rowPtr + 1] - e2 * data[rowPtr + 3] + d3 * data[rowPtr + 5] - b6 * data[rowPtr + 7];
        theta[0] = a5 * (data[rowPtr + 0] + data[rowPtr + 4]);
        theta[3] = a5 * (data[rowPtr + 0] - data[rowPtr + 4]);
        theta[1] = alpha[0] + alpha[3];
        theta[2] = alpha[1] - alpha[2];
        gamma[0] = theta[0] + theta[1];
        gamma[1] = theta[3] + theta[2];
        gamma[2] = theta[3] - theta[2];
        gamma[3] = theta[0] - theta[1];
        data[rowPtr + 0] = gamma[0] + beta[0];
        data[rowPtr + 1] = gamma[1] + beta[1];
        data[rowPtr + 2] = gamma[2] + beta[2];
        data[rowPtr + 3] = gamma[3] + beta[3];
        data[rowPtr + 4] = gamma[3] - beta[3];
        data[rowPtr + 5] = gamma[2] - beta[2];
        data[rowPtr + 6] = gamma[1] - beta[1];
        data[rowPtr + 7] = gamma[0] - beta[0];
      }
      for (var column = 0; column < 8; ++column) {
        alpha[0] = c2 * data[16 + column];
        alpha[1] = f2 * data[16 + column];
        alpha[2] = c2 * data[48 + column];
        alpha[3] = f2 * data[48 + column];
        beta[0] = b6 * data[8 + column] + d3 * data[24 + column] + e2 * data[40 + column] + g2 * data[56 + column];
        beta[1] = d3 * data[8 + column] - g2 * data[24 + column] - b6 * data[40 + column] - e2 * data[56 + column];
        beta[2] = e2 * data[8 + column] - b6 * data[24 + column] + g2 * data[40 + column] + d3 * data[56 + column];
        beta[3] = g2 * data[8 + column] - e2 * data[24 + column] + d3 * data[40 + column] - b6 * data[56 + column];
        theta[0] = a5 * (data[column] + data[32 + column]);
        theta[3] = a5 * (data[column] - data[32 + column]);
        theta[1] = alpha[0] + alpha[3];
        theta[2] = alpha[1] - alpha[2];
        gamma[0] = theta[0] + theta[1];
        gamma[1] = theta[3] + theta[2];
        gamma[2] = theta[3] - theta[2];
        gamma[3] = theta[0] - theta[1];
        data[0 + column] = gamma[0] + beta[0];
        data[8 + column] = gamma[1] + beta[1];
        data[16 + column] = gamma[2] + beta[2];
        data[24 + column] = gamma[3] + beta[3];
        data[32 + column] = gamma[3] - beta[3];
        data[40 + column] = gamma[2] - beta[2];
        data[48 + column] = gamma[1] - beta[1];
        data[56 + column] = gamma[0] - beta[0];
      }
    }
    function csc709Inverse(data) {
      for (var i2 = 0; i2 < 64; ++i2) {
        var y2 = data[0][i2];
        var cb = data[1][i2];
        var cr = data[2][i2];
        data[0][i2] = y2 + 1.5747 * cr;
        data[1][i2] = y2 - 0.1873 * cb - 0.4682 * cr;
        data[2][i2] = y2 + 1.8556 * cb;
      }
    }
    function convertToHalf(src, dst, idx) {
      for (var i2 = 0; i2 < 64; ++i2) {
        dst[idx + i2] = DataUtils.toHalfFloat(toLinear(src[i2]));
      }
    }
    function toLinear(float) {
      if (float <= 1) {
        return Math.sign(float) * Math.pow(Math.abs(float), 2.2);
      } else {
        return Math.sign(float) * Math.pow(logBase, Math.abs(float) - 1);
      }
    }
    function uncompressRAW(info) {
      return new DataView(info.array.buffer, info.offset.value, info.size);
    }
    function uncompressRLE(info) {
      var compressed = info.viewer.buffer.slice(info.offset.value, info.offset.value + info.size);
      var rawBuffer = new Uint8Array(decodeRunLength(compressed));
      var tmpBuffer = new Uint8Array(rawBuffer.length);
      predictor(rawBuffer);
      interleaveScalar(rawBuffer, tmpBuffer);
      return new DataView(tmpBuffer.buffer);
    }
    function uncompressZIP(info) {
      var compressed = info.array.slice(info.offset.value, info.offset.value + info.size);
      var rawBuffer = unzlibSync(compressed);
      var tmpBuffer = new Uint8Array(rawBuffer.length);
      predictor(rawBuffer);
      interleaveScalar(rawBuffer, tmpBuffer);
      return new DataView(tmpBuffer.buffer);
    }
    function uncompressPIZ(info) {
      var inDataView = info.viewer;
      var inOffset = { value: info.offset.value };
      var outBuffer = new Uint16Array(info.width * info.scanlineBlockSize * (info.channels * info.type));
      var bitmap = new Uint8Array(BITMAP_SIZE);
      var outBufferEnd = 0;
      var pizChannelData = new Array(info.channels);
      for (var i2 = 0; i2 < info.channels; i2++) {
        pizChannelData[i2] = {};
        pizChannelData[i2]["start"] = outBufferEnd;
        pizChannelData[i2]["end"] = pizChannelData[i2]["start"];
        pizChannelData[i2]["nx"] = info.width;
        pizChannelData[i2]["ny"] = info.lines;
        pizChannelData[i2]["size"] = info.type;
        outBufferEnd += pizChannelData[i2].nx * pizChannelData[i2].ny * pizChannelData[i2].size;
      }
      var minNonZero = parseUint16(inDataView, inOffset);
      var maxNonZero = parseUint16(inDataView, inOffset);
      if (maxNonZero >= BITMAP_SIZE) {
        throw "Something is wrong with PIZ_COMPRESSION BITMAP_SIZE";
      }
      if (minNonZero <= maxNonZero) {
        for (var i2 = 0; i2 < maxNonZero - minNonZero + 1; i2++) {
          bitmap[i2 + minNonZero] = parseUint8(inDataView, inOffset);
        }
      }
      var lut = new Uint16Array(USHORT_RANGE);
      var maxValue = reverseLutFromBitmap(bitmap, lut);
      var length = parseUint32(inDataView, inOffset);
      hufUncompress(info.array, inDataView, inOffset, length, outBuffer, outBufferEnd);
      for (var i2 = 0; i2 < info.channels; ++i2) {
        var cd = pizChannelData[i2];
        for (var j3 = 0; j3 < pizChannelData[i2].size; ++j3) {
          wav2Decode(outBuffer, cd.start + j3, cd.nx, cd.size, cd.ny, cd.nx * cd.size, maxValue);
        }
      }
      applyLut(lut, outBuffer, outBufferEnd);
      var tmpOffset2 = 0;
      var tmpBuffer = new Uint8Array(outBuffer.buffer.byteLength);
      for (var y2 = 0; y2 < info.lines; y2++) {
        for (var c2 = 0; c2 < info.channels; c2++) {
          var cd = pizChannelData[c2];
          var n2 = cd.nx * cd.size;
          var cp = new Uint8Array(outBuffer.buffer, cd.end * INT16_SIZE, n2 * INT16_SIZE);
          tmpBuffer.set(cp, tmpOffset2);
          tmpOffset2 += n2 * INT16_SIZE;
          cd.end += n2;
        }
      }
      return new DataView(tmpBuffer.buffer);
    }
    function uncompressPXR(info) {
      var compressed = info.array.slice(info.offset.value, info.offset.value + info.size);
      var rawBuffer = unzlibSync(compressed);
      const sz = info.lines * info.channels * info.width;
      const tmpBuffer = info.type == 1 ? new Uint16Array(sz) : new Uint32Array(sz);
      let tmpBufferEnd = 0;
      let writePtr = 0;
      const ptr = new Array(4);
      for (let y2 = 0; y2 < info.lines; y2++) {
        for (let c2 = 0; c2 < info.channels; c2++) {
          let pixel = 0;
          switch (info.type) {
            case 1:
              ptr[0] = tmpBufferEnd;
              ptr[1] = ptr[0] + info.width;
              tmpBufferEnd = ptr[1] + info.width;
              for (let j3 = 0; j3 < info.width; ++j3) {
                const diff = rawBuffer[ptr[0]++] << 8 | rawBuffer[ptr[1]++];
                pixel += diff;
                tmpBuffer[writePtr] = pixel;
                writePtr++;
              }
              break;
            case 2:
              ptr[0] = tmpBufferEnd;
              ptr[1] = ptr[0] + info.width;
              ptr[2] = ptr[1] + info.width;
              tmpBufferEnd = ptr[2] + info.width;
              for (let j3 = 0; j3 < info.width; ++j3) {
                const diff = rawBuffer[ptr[0]++] << 24 | rawBuffer[ptr[1]++] << 16 | rawBuffer[ptr[2]++] << 8;
                pixel += diff;
                tmpBuffer[writePtr] = pixel;
                writePtr++;
              }
              break;
          }
        }
      }
      return new DataView(tmpBuffer.buffer);
    }
    function uncompressDWA(info) {
      var inDataView = info.viewer;
      var inOffset = { value: info.offset.value };
      var outBuffer = new Uint8Array(info.width * info.lines * (info.channels * info.type * INT16_SIZE));
      var dwaHeader = {
        version: parseInt64(inDataView, inOffset),
        unknownUncompressedSize: parseInt64(inDataView, inOffset),
        unknownCompressedSize: parseInt64(inDataView, inOffset),
        acCompressedSize: parseInt64(inDataView, inOffset),
        dcCompressedSize: parseInt64(inDataView, inOffset),
        rleCompressedSize: parseInt64(inDataView, inOffset),
        rleUncompressedSize: parseInt64(inDataView, inOffset),
        rleRawSize: parseInt64(inDataView, inOffset),
        totalAcUncompressedCount: parseInt64(inDataView, inOffset),
        totalDcUncompressedCount: parseInt64(inDataView, inOffset),
        acCompression: parseInt64(inDataView, inOffset)
      };
      if (dwaHeader.version < 2) {
        throw "EXRLoader.parse: " + EXRHeader.compression + " version " + dwaHeader.version + " is unsupported";
      }
      var channelRules = new Array();
      var ruleSize = parseUint16(inDataView, inOffset) - INT16_SIZE;
      while (ruleSize > 0) {
        var name = parseNullTerminatedString(inDataView.buffer, inOffset);
        var value = parseUint8(inDataView, inOffset);
        var compression = value >> 2 & 3;
        var csc = (value >> 4) - 1;
        var index = new Int8Array([csc])[0];
        var type = parseUint8(inDataView, inOffset);
        channelRules.push({
          name,
          index,
          type,
          compression
        });
        ruleSize -= name.length + 3;
      }
      var channels = EXRHeader.channels;
      var channelData = new Array(info.channels);
      for (var i2 = 0; i2 < info.channels; ++i2) {
        var cd = channelData[i2] = {};
        var channel = channels[i2];
        cd.name = channel.name;
        cd.compression = UNKNOWN;
        cd.decoded = false;
        cd.type = channel.pixelType;
        cd.pLinear = channel.pLinear;
        cd.width = info.width;
        cd.height = info.lines;
      }
      var cscSet = {
        idx: new Array(3)
      };
      for (var offset2 = 0; offset2 < info.channels; ++offset2) {
        var cd = channelData[offset2];
        for (var i2 = 0; i2 < channelRules.length; ++i2) {
          var rule = channelRules[i2];
          if (cd.name == rule.name) {
            cd.compression = rule.compression;
            if (rule.index >= 0) {
              cscSet.idx[rule.index] = offset2;
            }
            cd.offset = offset2;
          }
        }
      }
      if (dwaHeader.acCompressedSize > 0) {
        switch (dwaHeader.acCompression) {
          case STATIC_HUFFMAN:
            var acBuffer = new Uint16Array(dwaHeader.totalAcUncompressedCount);
            hufUncompress(
              info.array,
              inDataView,
              inOffset,
              dwaHeader.acCompressedSize,
              acBuffer,
              dwaHeader.totalAcUncompressedCount
            );
            break;
          case DEFLATE:
            var compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.totalAcUncompressedCount);
            var data = unzlibSync(compressed);
            var acBuffer = new Uint16Array(data.buffer);
            inOffset.value += dwaHeader.totalAcUncompressedCount;
            break;
        }
      }
      if (dwaHeader.dcCompressedSize > 0) {
        var zlibInfo = {
          array: info.array,
          offset: inOffset,
          size: dwaHeader.dcCompressedSize
        };
        var dcBuffer = new Uint16Array(uncompressZIP(zlibInfo).buffer);
        inOffset.value += dwaHeader.dcCompressedSize;
      }
      if (dwaHeader.rleRawSize > 0) {
        var compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.rleCompressedSize);
        var data = unzlibSync(compressed);
        var rleBuffer = decodeRunLength(data.buffer);
        inOffset.value += dwaHeader.rleCompressedSize;
      }
      var outBufferEnd = 0;
      var rowOffsets = new Array(channelData.length);
      for (var i2 = 0; i2 < rowOffsets.length; ++i2) {
        rowOffsets[i2] = new Array();
      }
      for (var y2 = 0; y2 < info.lines; ++y2) {
        for (var chan = 0; chan < channelData.length; ++chan) {
          rowOffsets[chan].push(outBufferEnd);
          outBufferEnd += channelData[chan].width * info.type * INT16_SIZE;
        }
      }
      lossyDctDecode(cscSet, rowOffsets, channelData, acBuffer, dcBuffer, outBuffer);
      for (var i2 = 0; i2 < channelData.length; ++i2) {
        var cd = channelData[i2];
        if (cd.decoded)
          continue;
        switch (cd.compression) {
          case RLE:
            var row = 0;
            var rleOffset = 0;
            for (var y2 = 0; y2 < info.lines; ++y2) {
              var rowOffsetBytes = rowOffsets[i2][row];
              for (var x3 = 0; x3 < cd.width; ++x3) {
                for (var byte = 0; byte < INT16_SIZE * cd.type; ++byte) {
                  outBuffer[rowOffsetBytes++] = rleBuffer[rleOffset + byte * cd.width * cd.height];
                }
                rleOffset++;
              }
              row++;
            }
            break;
          case LOSSY_DCT:
          default:
            throw "EXRLoader.parse: unsupported channel compression";
        }
      }
      return new DataView(outBuffer.buffer);
    }
    function parseNullTerminatedString(buffer2, offset2) {
      var uintBuffer = new Uint8Array(buffer2);
      var endOffset = 0;
      while (uintBuffer[offset2.value + endOffset] != 0) {
        endOffset += 1;
      }
      var stringValue = new TextDecoder().decode(uintBuffer.slice(offset2.value, offset2.value + endOffset));
      offset2.value = offset2.value + endOffset + 1;
      return stringValue;
    }
    function parseFixedLengthString(buffer2, offset2, size) {
      var stringValue = new TextDecoder().decode(new Uint8Array(buffer2).slice(offset2.value, offset2.value + size));
      offset2.value = offset2.value + size;
      return stringValue;
    }
    function parseRational(dataView, offset2) {
      var x3 = parseInt32(dataView, offset2);
      var y2 = parseUint32(dataView, offset2);
      return [x3, y2];
    }
    function parseTimecode(dataView, offset2) {
      var x3 = parseUint32(dataView, offset2);
      var y2 = parseUint32(dataView, offset2);
      return [x3, y2];
    }
    function parseInt32(dataView, offset2) {
      var Int32 = dataView.getInt32(offset2.value, true);
      offset2.value = offset2.value + INT32_SIZE;
      return Int32;
    }
    function parseUint32(dataView, offset2) {
      var Uint32 = dataView.getUint32(offset2.value, true);
      offset2.value = offset2.value + INT32_SIZE;
      return Uint32;
    }
    function parseUint8Array(uInt8Array2, offset2) {
      var Uint8 = uInt8Array2[offset2.value];
      offset2.value = offset2.value + INT8_SIZE;
      return Uint8;
    }
    function parseUint8(dataView, offset2) {
      var Uint8 = dataView.getUint8(offset2.value);
      offset2.value = offset2.value + INT8_SIZE;
      return Uint8;
    }
    const parseInt64 = function(dataView, offset2) {
      let int;
      if ("getBigInt64" in DataView.prototype) {
        int = Number(dataView.getBigInt64(offset2.value, true));
      } else {
        int = dataView.getUint32(offset2.value + 4, true) + Number(dataView.getUint32(offset2.value, true) << 32);
      }
      offset2.value += ULONG_SIZE;
      return int;
    };
    function parseFloat32(dataView, offset2) {
      var float = dataView.getFloat32(offset2.value, true);
      offset2.value += FLOAT32_SIZE;
      return float;
    }
    function decodeFloat32(dataView, offset2) {
      return DataUtils.toHalfFloat(parseFloat32(dataView, offset2));
    }
    function decodeFloat16(binary) {
      var exponent = (binary & 31744) >> 10, fraction = binary & 1023;
      return (binary >> 15 ? -1 : 1) * (exponent ? exponent === 31 ? fraction ? NaN : Infinity : Math.pow(2, exponent - 15) * (1 + fraction / 1024) : 6103515625e-14 * (fraction / 1024));
    }
    function parseUint16(dataView, offset2) {
      var Uint16 = dataView.getUint16(offset2.value, true);
      offset2.value += INT16_SIZE;
      return Uint16;
    }
    function parseFloat16(buffer2, offset2) {
      return decodeFloat16(parseUint16(buffer2, offset2));
    }
    function parseChlist(dataView, buffer2, offset2, size) {
      var startOffset = offset2.value;
      var channels = [];
      while (offset2.value < startOffset + size - 1) {
        var name = parseNullTerminatedString(buffer2, offset2);
        var pixelType = parseInt32(dataView, offset2);
        var pLinear = parseUint8(dataView, offset2);
        offset2.value += 3;
        var xSampling = parseInt32(dataView, offset2);
        var ySampling = parseInt32(dataView, offset2);
        channels.push({
          name,
          pixelType,
          pLinear,
          xSampling,
          ySampling
        });
      }
      offset2.value += 1;
      return channels;
    }
    function parseChromaticities(dataView, offset2) {
      var redX = parseFloat32(dataView, offset2);
      var redY = parseFloat32(dataView, offset2);
      var greenX = parseFloat32(dataView, offset2);
      var greenY = parseFloat32(dataView, offset2);
      var blueX = parseFloat32(dataView, offset2);
      var blueY = parseFloat32(dataView, offset2);
      var whiteX = parseFloat32(dataView, offset2);
      var whiteY = parseFloat32(dataView, offset2);
      return {
        redX,
        redY,
        greenX,
        greenY,
        blueX,
        blueY,
        whiteX,
        whiteY
      };
    }
    function parseCompression(dataView, offset2) {
      var compressionCodes = [
        "NO_COMPRESSION",
        "RLE_COMPRESSION",
        "ZIPS_COMPRESSION",
        "ZIP_COMPRESSION",
        "PIZ_COMPRESSION",
        "PXR24_COMPRESSION",
        "B44_COMPRESSION",
        "B44A_COMPRESSION",
        "DWAA_COMPRESSION",
        "DWAB_COMPRESSION"
      ];
      var compression = parseUint8(dataView, offset2);
      return compressionCodes[compression];
    }
    function parseBox2i(dataView, offset2) {
      var xMin = parseUint32(dataView, offset2);
      var yMin = parseUint32(dataView, offset2);
      var xMax = parseUint32(dataView, offset2);
      var yMax = parseUint32(dataView, offset2);
      return { xMin, yMin, xMax, yMax };
    }
    function parseLineOrder(dataView, offset2) {
      var lineOrders = ["INCREASING_Y"];
      var lineOrder = parseUint8(dataView, offset2);
      return lineOrders[lineOrder];
    }
    function parseV2f(dataView, offset2) {
      var x3 = parseFloat32(dataView, offset2);
      var y2 = parseFloat32(dataView, offset2);
      return [x3, y2];
    }
    function parseV3f(dataView, offset2) {
      var x3 = parseFloat32(dataView, offset2);
      var y2 = parseFloat32(dataView, offset2);
      var z2 = parseFloat32(dataView, offset2);
      return [x3, y2, z2];
    }
    function parseValue(dataView, buffer2, offset2, type, size) {
      if (type === "string" || type === "stringvector" || type === "iccProfile") {
        return parseFixedLengthString(buffer2, offset2, size);
      } else if (type === "chlist") {
        return parseChlist(dataView, buffer2, offset2, size);
      } else if (type === "chromaticities") {
        return parseChromaticities(dataView, offset2);
      } else if (type === "compression") {
        return parseCompression(dataView, offset2);
      } else if (type === "box2i") {
        return parseBox2i(dataView, offset2);
      } else if (type === "lineOrder") {
        return parseLineOrder(dataView, offset2);
      } else if (type === "float") {
        return parseFloat32(dataView, offset2);
      } else if (type === "v2f") {
        return parseV2f(dataView, offset2);
      } else if (type === "v3f") {
        return parseV3f(dataView, offset2);
      } else if (type === "int") {
        return parseInt32(dataView, offset2);
      } else if (type === "rational") {
        return parseRational(dataView, offset2);
      } else if (type === "timecode") {
        return parseTimecode(dataView, offset2);
      } else if (type === "preview") {
        offset2.value += size;
        return "skipped";
      } else {
        offset2.value += size;
        return void 0;
      }
    }
    function parseHeader(dataView, buffer2, offset2) {
      const EXRHeader2 = {};
      if (dataView.getUint32(0, true) != 20000630) {
        throw "THREE.EXRLoader: provided file doesn't appear to be in OpenEXR format.";
      }
      EXRHeader2.version = dataView.getUint8(4);
      const spec = dataView.getUint8(5);
      EXRHeader2.spec = {
        singleTile: !!(spec & 2),
        longName: !!(spec & 4),
        deepFormat: !!(spec & 8),
        multiPart: !!(spec & 16)
      };
      offset2.value = 8;
      var keepReading = true;
      while (keepReading) {
        var attributeName = parseNullTerminatedString(buffer2, offset2);
        if (attributeName == 0) {
          keepReading = false;
        } else {
          var attributeType = parseNullTerminatedString(buffer2, offset2);
          var attributeSize = parseUint32(dataView, offset2);
          var attributeValue = parseValue(dataView, buffer2, offset2, attributeType, attributeSize);
          if (attributeValue === void 0) {
            console.warn(`EXRLoader.parse: skipped unknown header attribute type '${attributeType}'.`);
          } else {
            EXRHeader2[attributeName] = attributeValue;
          }
        }
      }
      if ((spec & -5) != 0) {
        console.error("EXRHeader:", EXRHeader2);
        throw "THREE.EXRLoader: provided file is currently unsupported.";
      }
      return EXRHeader2;
    }
    function setupDecoder(EXRHeader2, dataView, uInt8Array2, offset2, outputType) {
      const EXRDecoder2 = {
        size: 0,
        viewer: dataView,
        array: uInt8Array2,
        offset: offset2,
        width: EXRHeader2.dataWindow.xMax - EXRHeader2.dataWindow.xMin + 1,
        height: EXRHeader2.dataWindow.yMax - EXRHeader2.dataWindow.yMin + 1,
        channels: EXRHeader2.channels.length,
        bytesPerLine: null,
        lines: null,
        inputSize: null,
        type: EXRHeader2.channels[0].pixelType,
        uncompress: null,
        getter: null,
        format: null,
        [hasColorSpace ? "colorSpace" : "encoding"]: null
      };
      switch (EXRHeader2.compression) {
        case "NO_COMPRESSION":
          EXRDecoder2.lines = 1;
          EXRDecoder2.uncompress = uncompressRAW;
          break;
        case "RLE_COMPRESSION":
          EXRDecoder2.lines = 1;
          EXRDecoder2.uncompress = uncompressRLE;
          break;
        case "ZIPS_COMPRESSION":
          EXRDecoder2.lines = 1;
          EXRDecoder2.uncompress = uncompressZIP;
          break;
        case "ZIP_COMPRESSION":
          EXRDecoder2.lines = 16;
          EXRDecoder2.uncompress = uncompressZIP;
          break;
        case "PIZ_COMPRESSION":
          EXRDecoder2.lines = 32;
          EXRDecoder2.uncompress = uncompressPIZ;
          break;
        case "PXR24_COMPRESSION":
          EXRDecoder2.lines = 16;
          EXRDecoder2.uncompress = uncompressPXR;
          break;
        case "DWAA_COMPRESSION":
          EXRDecoder2.lines = 32;
          EXRDecoder2.uncompress = uncompressDWA;
          break;
        case "DWAB_COMPRESSION":
          EXRDecoder2.lines = 256;
          EXRDecoder2.uncompress = uncompressDWA;
          break;
        default:
          throw "EXRLoader.parse: " + EXRHeader2.compression + " is unsupported";
      }
      EXRDecoder2.scanlineBlockSize = EXRDecoder2.lines;
      if (EXRDecoder2.type == 1) {
        switch (outputType) {
          case FloatType:
            EXRDecoder2.getter = parseFloat16;
            EXRDecoder2.inputSize = INT16_SIZE;
            break;
          case HalfFloatType:
            EXRDecoder2.getter = parseUint16;
            EXRDecoder2.inputSize = INT16_SIZE;
            break;
        }
      } else if (EXRDecoder2.type == 2) {
        switch (outputType) {
          case FloatType:
            EXRDecoder2.getter = parseFloat32;
            EXRDecoder2.inputSize = FLOAT32_SIZE;
            break;
          case HalfFloatType:
            EXRDecoder2.getter = decodeFloat32;
            EXRDecoder2.inputSize = FLOAT32_SIZE;
        }
      } else {
        throw "EXRLoader.parse: unsupported pixelType " + EXRDecoder2.type + " for " + EXRHeader2.compression + ".";
      }
      EXRDecoder2.blockCount = (EXRHeader2.dataWindow.yMax + 1) / EXRDecoder2.scanlineBlockSize;
      for (var i2 = 0; i2 < EXRDecoder2.blockCount; i2++)
        parseInt64(dataView, offset2);
      EXRDecoder2.outputChannels = EXRDecoder2.channels == 3 ? 4 : EXRDecoder2.channels;
      const size = EXRDecoder2.width * EXRDecoder2.height * EXRDecoder2.outputChannels;
      switch (outputType) {
        case FloatType:
          EXRDecoder2.byteArray = new Float32Array(size);
          if (EXRDecoder2.channels < EXRDecoder2.outputChannels)
            EXRDecoder2.byteArray.fill(1, 0, size);
          break;
        case HalfFloatType:
          EXRDecoder2.byteArray = new Uint16Array(size);
          if (EXRDecoder2.channels < EXRDecoder2.outputChannels)
            EXRDecoder2.byteArray.fill(15360, 0, size);
          break;
        default:
          console.error("THREE.EXRLoader: unsupported type: ", outputType);
          break;
      }
      EXRDecoder2.bytesPerLine = EXRDecoder2.width * EXRDecoder2.inputSize * EXRDecoder2.channels;
      if (EXRDecoder2.outputChannels == 4)
        EXRDecoder2.format = RGBAFormat;
      else
        EXRDecoder2.format = RedFormat;
      if (hasColorSpace)
        EXRDecoder2.colorSpace = "srgb-linear";
      else
        EXRDecoder2.encoding = 3e3;
      return EXRDecoder2;
    }
    const bufferDataView = new DataView(buffer);
    const uInt8Array = new Uint8Array(buffer);
    const offset = { value: 0 };
    const EXRHeader = parseHeader(bufferDataView, buffer, offset);
    const EXRDecoder = setupDecoder(EXRHeader, bufferDataView, uInt8Array, offset, this.type);
    const tmpOffset = { value: 0 };
    const channelOffsets = { R: 0, G: 1, B: 2, A: 3, Y: 0 };
    for (let scanlineBlockIdx = 0; scanlineBlockIdx < EXRDecoder.height / EXRDecoder.scanlineBlockSize; scanlineBlockIdx++) {
      const line = parseUint32(bufferDataView, offset);
      EXRDecoder.size = parseUint32(bufferDataView, offset);
      EXRDecoder.lines = line + EXRDecoder.scanlineBlockSize > EXRDecoder.height ? EXRDecoder.height - line : EXRDecoder.scanlineBlockSize;
      const isCompressed = EXRDecoder.size < EXRDecoder.lines * EXRDecoder.bytesPerLine;
      const viewer = isCompressed ? EXRDecoder.uncompress(EXRDecoder) : uncompressRAW(EXRDecoder);
      offset.value += EXRDecoder.size;
      for (let line_y = 0; line_y < EXRDecoder.scanlineBlockSize; line_y++) {
        const true_y = line_y + scanlineBlockIdx * EXRDecoder.scanlineBlockSize;
        if (true_y >= EXRDecoder.height)
          break;
        for (let channelID = 0; channelID < EXRDecoder.channels; channelID++) {
          const cOff = channelOffsets[EXRHeader.channels[channelID].name];
          for (let x3 = 0; x3 < EXRDecoder.width; x3++) {
            tmpOffset.value = (line_y * (EXRDecoder.channels * EXRDecoder.width) + channelID * EXRDecoder.width + x3) * EXRDecoder.inputSize;
            const outIndex = (EXRDecoder.height - 1 - true_y) * (EXRDecoder.width * EXRDecoder.outputChannels) + x3 * EXRDecoder.outputChannels + cOff;
            EXRDecoder.byteArray[outIndex] = EXRDecoder.getter(viewer, tmpOffset);
          }
        }
      }
    }
    return {
      header: EXRHeader,
      width: EXRDecoder.width,
      height: EXRDecoder.height,
      data: EXRDecoder.byteArray,
      format: EXRDecoder.format,
      [hasColorSpace ? "colorSpace" : "encoding"]: EXRDecoder[hasColorSpace ? "colorSpace" : "encoding"],
      type: this.type
    };
  }
  setDataType(value) {
    this.type = value;
    return this;
  }
  load(url, onLoad, onProgress, onError) {
    function onLoadCallback(texture, texData) {
      if (hasColorSpace)
        texture.colorSpace = texData.colorSpace;
      else
        texture.encoding = texData.encoding;
      texture.minFilter = LinearFilter;
      texture.magFilter = LinearFilter;
      texture.generateMipmaps = false;
      texture.flipY = false;
      if (onLoad)
        onLoad(texture, texData);
    }
    return super.load(url, onLoadCallback, onProgress, onError);
  }
}
const _taskCache = /* @__PURE__ */ new WeakMap();
class DRACOLoader extends Loader {
  constructor(manager) {
    super(manager);
    this.decoderPath = "";
    this.decoderConfig = {};
    this.decoderBinary = null;
    this.decoderPending = null;
    this.workerLimit = 4;
    this.workerPool = [];
    this.workerNextTaskID = 1;
    this.workerSourceURL = "";
    this.defaultAttributeIDs = {
      position: "POSITION",
      normal: "NORMAL",
      color: "COLOR",
      uv: "TEX_COORD"
    };
    this.defaultAttributeTypes = {
      position: "Float32Array",
      normal: "Float32Array",
      color: "Float32Array",
      uv: "Float32Array"
    };
  }
  setDecoderPath(path) {
    this.decoderPath = path;
    return this;
  }
  setDecoderConfig(config3) {
    this.decoderConfig = config3;
    return this;
  }
  setWorkerLimit(workerLimit) {
    this.workerLimit = workerLimit;
    return this;
  }
  load(url, onLoad, onProgress, onError) {
    const loader = new FileLoader(this.manager);
    loader.setPath(this.path);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(
      url,
      (buffer) => {
        const taskConfig = {
          attributeIDs: this.defaultAttributeIDs,
          attributeTypes: this.defaultAttributeTypes,
          useUniqueIDs: false
        };
        this.decodeGeometry(buffer, taskConfig).then(onLoad).catch(onError);
      },
      onProgress,
      onError
    );
  }
  /** @deprecated Kept for backward-compatibility with previous DRACOLoader versions. */
  decodeDracoFile(buffer, callback, attributeIDs, attributeTypes) {
    const taskConfig = {
      attributeIDs: attributeIDs || this.defaultAttributeIDs,
      attributeTypes: attributeTypes || this.defaultAttributeTypes,
      useUniqueIDs: !!attributeIDs
    };
    this.decodeGeometry(buffer, taskConfig).then(callback);
  }
  decodeGeometry(buffer, taskConfig) {
    for (const attribute in taskConfig.attributeTypes) {
      const type = taskConfig.attributeTypes[attribute];
      if (type.BYTES_PER_ELEMENT !== void 0) {
        taskConfig.attributeTypes[attribute] = type.name;
      }
    }
    const taskKey = JSON.stringify(taskConfig);
    if (_taskCache.has(buffer)) {
      const cachedTask = _taskCache.get(buffer);
      if (cachedTask.key === taskKey) {
        return cachedTask.promise;
      } else if (buffer.byteLength === 0) {
        throw new Error(
          "THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred."
        );
      }
    }
    let worker;
    const taskID = this.workerNextTaskID++;
    const taskCost = buffer.byteLength;
    const geometryPending = this._getWorker(taskID, taskCost).then((_worker) => {
      worker = _worker;
      return new Promise((resolve2, reject) => {
        worker._callbacks[taskID] = { resolve: resolve2, reject };
        worker.postMessage({ type: "decode", id: taskID, taskConfig, buffer }, [buffer]);
      });
    }).then((message) => this._createGeometry(message.geometry));
    geometryPending.catch(() => true).then(() => {
      if (worker && taskID) {
        this._releaseTask(worker, taskID);
      }
    });
    _taskCache.set(buffer, {
      key: taskKey,
      promise: geometryPending
    });
    return geometryPending;
  }
  _createGeometry(geometryData) {
    const geometry = new BufferGeometry();
    if (geometryData.index) {
      geometry.setIndex(new BufferAttribute(geometryData.index.array, 1));
    }
    for (let i2 = 0; i2 < geometryData.attributes.length; i2++) {
      const attribute = geometryData.attributes[i2];
      const name = attribute.name;
      const array = attribute.array;
      const itemSize = attribute.itemSize;
      geometry.setAttribute(name, new BufferAttribute(array, itemSize));
    }
    return geometry;
  }
  _loadLibrary(url, responseType) {
    const loader = new FileLoader(this.manager);
    loader.setPath(this.decoderPath);
    loader.setResponseType(responseType);
    loader.setWithCredentials(this.withCredentials);
    return new Promise((resolve2, reject) => {
      loader.load(url, resolve2, void 0, reject);
    });
  }
  preload() {
    this._initDecoder();
    return this;
  }
  _initDecoder() {
    if (this.decoderPending)
      return this.decoderPending;
    const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
    const librariesPending = [];
    if (useJS) {
      librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
    } else {
      librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
      librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
    }
    this.decoderPending = Promise.all(librariesPending).then((libraries) => {
      const jsContent = libraries[0];
      if (!useJS) {
        this.decoderConfig.wasmBinary = libraries[1];
      }
      const fn = DRACOWorker.toString();
      const body = [
        "/* draco decoder */",
        jsContent,
        "",
        "/* worker */",
        fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
      ].join("\n");
      this.workerSourceURL = URL.createObjectURL(new Blob([body]));
    });
    return this.decoderPending;
  }
  _getWorker(taskID, taskCost) {
    return this._initDecoder().then(() => {
      if (this.workerPool.length < this.workerLimit) {
        const worker2 = new Worker(this.workerSourceURL);
        worker2._callbacks = {};
        worker2._taskCosts = {};
        worker2._taskLoad = 0;
        worker2.postMessage({ type: "init", decoderConfig: this.decoderConfig });
        worker2.onmessage = function(e2) {
          const message = e2.data;
          switch (message.type) {
            case "decode":
              worker2._callbacks[message.id].resolve(message);
              break;
            case "error":
              worker2._callbacks[message.id].reject(message);
              break;
            default:
              console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
          }
        };
        this.workerPool.push(worker2);
      } else {
        this.workerPool.sort(function(a5, b6) {
          return a5._taskLoad > b6._taskLoad ? -1 : 1;
        });
      }
      const worker = this.workerPool[this.workerPool.length - 1];
      worker._taskCosts[taskID] = taskCost;
      worker._taskLoad += taskCost;
      return worker;
    });
  }
  _releaseTask(worker, taskID) {
    worker._taskLoad -= worker._taskCosts[taskID];
    delete worker._callbacks[taskID];
    delete worker._taskCosts[taskID];
  }
  debug() {
    console.log(
      "Task load: ",
      this.workerPool.map((worker) => worker._taskLoad)
    );
  }
  dispose() {
    for (let i2 = 0; i2 < this.workerPool.length; ++i2) {
      this.workerPool[i2].terminate();
    }
    this.workerPool.length = 0;
    return this;
  }
}
function DRACOWorker() {
  let decoderConfig;
  let decoderPending;
  onmessage = function(e2) {
    const message = e2.data;
    switch (message.type) {
      case "init":
        decoderConfig = message.decoderConfig;
        decoderPending = new Promise(function(resolve2) {
          decoderConfig.onModuleLoaded = function(draco) {
            resolve2({ draco });
          };
          DracoDecoderModule(decoderConfig);
        });
        break;
      case "decode":
        const buffer = message.buffer;
        const taskConfig = message.taskConfig;
        decoderPending.then((module) => {
          const draco = module.draco;
          const decoder = new draco.Decoder();
          const decoderBuffer = new draco.DecoderBuffer();
          decoderBuffer.Init(new Int8Array(buffer), buffer.byteLength);
          try {
            const geometry = decodeGeometry(draco, decoder, decoderBuffer, taskConfig);
            const buffers = geometry.attributes.map((attr) => attr.array.buffer);
            if (geometry.index)
              buffers.push(geometry.index.array.buffer);
            self.postMessage({ type: "decode", id: message.id, geometry }, buffers);
          } catch (error2) {
            console.error(error2);
            self.postMessage({ type: "error", id: message.id, error: error2.message });
          } finally {
            draco.destroy(decoderBuffer);
            draco.destroy(decoder);
          }
        });
        break;
    }
  };
  function decodeGeometry(draco, decoder, decoderBuffer, taskConfig) {
    const attributeIDs = taskConfig.attributeIDs;
    const attributeTypes = taskConfig.attributeTypes;
    let dracoGeometry;
    let decodingStatus;
    const geometryType = decoder.GetEncodedGeometryType(decoderBuffer);
    if (geometryType === draco.TRIANGULAR_MESH) {
      dracoGeometry = new draco.Mesh();
      decodingStatus = decoder.DecodeBufferToMesh(decoderBuffer, dracoGeometry);
    } else if (geometryType === draco.POINT_CLOUD) {
      dracoGeometry = new draco.PointCloud();
      decodingStatus = decoder.DecodeBufferToPointCloud(decoderBuffer, dracoGeometry);
    } else {
      throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
    }
    if (!decodingStatus.ok() || dracoGeometry.ptr === 0) {
      throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
    }
    const geometry = { index: null, attributes: [] };
    for (const attributeName in attributeIDs) {
      const attributeType = self[attributeTypes[attributeName]];
      let attribute;
      let attributeID;
      if (taskConfig.useUniqueIDs) {
        attributeID = attributeIDs[attributeName];
        attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
      } else {
        attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
        if (attributeID === -1)
          continue;
        attribute = decoder.GetAttribute(dracoGeometry, attributeID);
      }
      geometry.attributes.push(decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute));
    }
    if (geometryType === draco.TRIANGULAR_MESH) {
      geometry.index = decodeIndex(draco, decoder, dracoGeometry);
    }
    draco.destroy(dracoGeometry);
    return geometry;
  }
  function decodeIndex(draco, decoder, dracoGeometry) {
    const numFaces = dracoGeometry.num_faces();
    const numIndices = numFaces * 3;
    const byteLength = numIndices * 4;
    const ptr = draco._malloc(byteLength);
    decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
    const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
    draco._free(ptr);
    return { array: index, itemSize: 1 };
  }
  function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
    const numComponents = attribute.num_components();
    const numPoints = dracoGeometry.num_points();
    const numValues = numPoints * numComponents;
    const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
    const dataType = getDracoDataType(draco, attributeType);
    const ptr = draco._malloc(byteLength);
    decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
    const array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
    draco._free(ptr);
    return {
      name: attributeName,
      array,
      itemSize: numComponents
    };
  }
  function getDracoDataType(draco, attributeType) {
    switch (attributeType) {
      case Float32Array:
        return draco.DT_FLOAT32;
      case Int8Array:
        return draco.DT_INT8;
      case Int16Array:
        return draco.DT_INT16;
      case Int32Array:
        return draco.DT_INT32;
      case Uint8Array:
        return draco.DT_UINT8;
      case Uint16Array:
        return draco.DT_UINT16;
      case Uint32Array:
        return draco.DT_UINT32;
    }
  }
}
let generated;
const MeshoptDecoder = () => {
  if (generated)
    return generated;
  const wasm_base = "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";
  const wasm_simd = "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";
  const detector = new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    4,
    1,
    96,
    0,
    0,
    3,
    3,
    2,
    0,
    0,
    5,
    3,
    1,
    0,
    1,
    12,
    1,
    0,
    10,
    22,
    2,
    12,
    0,
    65,
    0,
    65,
    0,
    65,
    0,
    252,
    10,
    0,
    0,
    11,
    7,
    0,
    65,
    0,
    253,
    15,
    26,
    11
  ]);
  const wasmpack = new Uint8Array([
    32,
    0,
    65,
    253,
    3,
    1,
    2,
    34,
    4,
    106,
    6,
    5,
    11,
    8,
    7,
    20,
    13,
    33,
    12,
    16,
    128,
    9,
    116,
    64,
    19,
    113,
    127,
    15,
    10,
    21,
    22,
    14,
    255,
    66,
    24,
    54,
    136,
    107,
    18,
    23,
    192,
    26,
    114,
    118,
    132,
    17,
    77,
    101,
    130,
    144,
    27,
    87,
    131,
    44,
    45,
    74,
    156,
    154,
    70,
    167
  ]);
  if (typeof WebAssembly !== "object") {
    return {
      supported: false
    };
  }
  let wasm = wasm_base;
  if (WebAssembly.validate(detector)) {
    wasm = wasm_simd;
  }
  let instance;
  const promise = WebAssembly.instantiate(unpack(wasm), {}).then((result) => {
    instance = result.instance;
    instance.exports.__wasm_call_ctors();
  });
  function unpack(data) {
    const result = new Uint8Array(data.length);
    for (let i2 = 0; i2 < data.length; ++i2) {
      const ch = data.charCodeAt(i2);
      result[i2] = ch > 96 ? ch - 71 : ch > 64 ? ch - 65 : ch > 47 ? ch + 4 : ch > 46 ? 63 : 62;
    }
    let write = 0;
    for (let i2 = 0; i2 < data.length; ++i2) {
      result[write++] = result[i2] < 60 ? wasmpack[result[i2]] : (result[i2] - 60) * 64 + result[++i2];
    }
    return result.buffer.slice(0, write);
  }
  function decode(fun, target, count, size, source, filter) {
    const sbrk = instance.exports.sbrk;
    const count4 = count + 3 & -4;
    const tp = sbrk(count4 * size);
    const sp = sbrk(source.length);
    const heap = new Uint8Array(instance.exports.memory.buffer);
    heap.set(source, sp);
    const res = fun(tp, count, size, sp, source.length);
    if (res === 0 && filter) {
      filter(tp, count4, size);
    }
    target.set(heap.subarray(tp, tp + count * size));
    sbrk(tp - sbrk(0));
    if (res !== 0) {
      throw new Error(`Malformed buffer data: ${res}`);
    }
  }
  const filters = {
    // legacy index-based enums for glTF
    0: "",
    1: "meshopt_decodeFilterOct",
    2: "meshopt_decodeFilterQuat",
    3: "meshopt_decodeFilterExp",
    // string-based enums for glTF
    NONE: "",
    OCTAHEDRAL: "meshopt_decodeFilterOct",
    QUATERNION: "meshopt_decodeFilterQuat",
    EXPONENTIAL: "meshopt_decodeFilterExp"
  };
  const decoders = {
    // legacy index-based enums for glTF
    0: "meshopt_decodeVertexBuffer",
    1: "meshopt_decodeIndexBuffer",
    2: "meshopt_decodeIndexSequence",
    // string-based enums for glTF
    ATTRIBUTES: "meshopt_decodeVertexBuffer",
    TRIANGLES: "meshopt_decodeIndexBuffer",
    INDICES: "meshopt_decodeIndexSequence"
  };
  generated = {
    ready: promise,
    supported: true,
    decodeVertexBuffer(target, count, size, source, filter) {
      decode(
        instance.exports.meshopt_decodeVertexBuffer,
        target,
        count,
        size,
        source,
        instance.exports[filters[filter]]
      );
    },
    decodeIndexBuffer(target, count, size, source) {
      decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
    },
    decodeIndexSequence(target, count, size, source) {
      decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
    },
    decodeGltfBuffer(target, count, size, source, mode, filter) {
      decode(
        instance.exports[decoders[mode]],
        target,
        count,
        size,
        source,
        instance.exports[filters[filter]]
      );
    }
  };
  return generated;
};
function workerBootstrap() {
  var modules = /* @__PURE__ */ Object.create(null);
  function registerModule(ref, callback) {
    var id = ref.id;
    var name = ref.name;
    var dependencies = ref.dependencies;
    if (dependencies === void 0) dependencies = [];
    var init4 = ref.init;
    if (init4 === void 0) init4 = function() {
    };
    var getTransferables = ref.getTransferables;
    if (getTransferables === void 0) getTransferables = null;
    if (modules[id]) {
      return;
    }
    try {
      dependencies = dependencies.map(function(dep) {
        if (dep && dep.isWorkerModule) {
          registerModule(dep, function(depResult) {
            if (depResult instanceof Error) {
              throw depResult;
            }
          });
          dep = modules[dep.id].value;
        }
        return dep;
      });
      init4 = rehydrate("<" + name + ">.init", init4);
      if (getTransferables) {
        getTransferables = rehydrate("<" + name + ">.getTransferables", getTransferables);
      }
      var value = null;
      if (typeof init4 === "function") {
        value = init4.apply(void 0, dependencies);
      } else {
        console.error("worker module init function failed to rehydrate");
      }
      modules[id] = {
        id,
        value,
        getTransferables
      };
      callback(value);
    } catch (err) {
      if (!(err && err.noLog)) {
        console.error(err);
      }
      callback(err);
    }
  }
  function callModule(ref, callback) {
    var ref$1;
    var id = ref.id;
    var args = ref.args;
    if (!modules[id] || typeof modules[id].value !== "function") {
      callback(new Error("Worker module " + id + ": not found or its 'init' did not return a function"));
    }
    try {
      var result = (ref$1 = modules[id]).value.apply(ref$1, args);
      if (result && typeof result.then === "function") {
        result.then(handleResult, function(rej) {
          return callback(rej instanceof Error ? rej : new Error("" + rej));
        });
      } else {
        handleResult(result);
      }
    } catch (err) {
      callback(err);
    }
    function handleResult(result2) {
      try {
        var tx = modules[id].getTransferables && modules[id].getTransferables(result2);
        if (!tx || !Array.isArray(tx) || !tx.length) {
          tx = void 0;
        }
        callback(result2, tx);
      } catch (err) {
        console.error(err);
        callback(err);
      }
    }
  }
  function rehydrate(name, str) {
    var result = void 0;
    self.troikaDefine = function(r3) {
      return result = r3;
    };
    var url = URL.createObjectURL(
      new Blob(
        ["/** " + name.replace(/\*/g, "") + " **/\n\ntroikaDefine(\n" + str + "\n)"],
        { type: "application/javascript" }
      )
    );
    try {
      importScripts(url);
    } catch (err) {
      console.error(err);
    }
    URL.revokeObjectURL(url);
    delete self.troikaDefine;
    return result;
  }
  self.addEventListener("message", function(e2) {
    var ref = e2.data;
    var messageId = ref.messageId;
    var action = ref.action;
    var data = ref.data;
    try {
      if (action === "registerModule") {
        registerModule(data, function(result) {
          if (result instanceof Error) {
            postMessage({
              messageId,
              success: false,
              error: result.message
            });
          } else {
            postMessage({
              messageId,
              success: true,
              result: { isCallable: typeof result === "function" }
            });
          }
        });
      }
      if (action === "callModule") {
        callModule(data, function(result, transferables) {
          if (result instanceof Error) {
            postMessage({
              messageId,
              success: false,
              error: result.message
            });
          } else {
            postMessage({
              messageId,
              success: true,
              result
            }, transferables || void 0);
          }
        });
      }
    } catch (err) {
      postMessage({
        messageId,
        success: false,
        error: err.stack
      });
    }
  });
}
function defineMainThreadModule(options) {
  var moduleFunc = function() {
    var args = [], len = arguments.length;
    while (len--) args[len] = arguments[len];
    return moduleFunc._getInitResult().then(function(initResult) {
      if (typeof initResult === "function") {
        return initResult.apply(void 0, args);
      } else {
        throw new Error("Worker module function was called but `init` did not return a callable function");
      }
    });
  };
  moduleFunc._getInitResult = function() {
    var dependencies = options.dependencies;
    var init4 = options.init;
    dependencies = Array.isArray(dependencies) ? dependencies.map(function(dep) {
      if (dep) {
        dep = dep.onMainThread || dep;
        if (dep._getInitResult) {
          dep = dep._getInitResult();
        }
      }
      return dep;
    }) : [];
    var initPromise = Promise.all(dependencies).then(function(deps) {
      return init4.apply(null, deps);
    });
    moduleFunc._getInitResult = function() {
      return initPromise;
    };
    return initPromise;
  };
  return moduleFunc;
}
var supportsWorkers = function() {
  var supported = false;
  if (typeof window !== "undefined" && typeof window.document !== "undefined") {
    try {
      var worker = new Worker(
        URL.createObjectURL(new Blob([""], { type: "application/javascript" }))
      );
      worker.terminate();
      supported = true;
    } catch (err) {
      {
        console.log(
          "Troika createWorkerModule: web workers not allowed; falling back to main thread execution. Cause: [" + err.message + "]"
        );
      }
    }
  }
  supportsWorkers = function() {
    return supported;
  };
  return supported;
};
var _workerModuleId = 0;
var _messageId = 0;
var _allowInitAsString = false;
var workers = /* @__PURE__ */ Object.create(null);
var registeredModules = /* @__PURE__ */ Object.create(null);
var openRequests = /* @__PURE__ */ Object.create(null);
function defineWorkerModule(options) {
  if ((!options || typeof options.init !== "function") && !_allowInitAsString) {
    throw new Error("requires `options.init` function");
  }
  var dependencies = options.dependencies;
  var init4 = options.init;
  var getTransferables = options.getTransferables;
  var workerId = options.workerId;
  var onMainThread = defineMainThreadModule(options);
  if (workerId == null) {
    workerId = "#default";
  }
  var id = "workerModule" + ++_workerModuleId;
  var name = options.name || id;
  var registrationPromise = null;
  dependencies = dependencies && dependencies.map(function(dep) {
    if (typeof dep === "function" && !dep.workerModuleData) {
      _allowInitAsString = true;
      dep = defineWorkerModule({
        workerId,
        name: "<" + name + "> function dependency: " + dep.name,
        init: "function(){return (\n" + stringifyFunction(dep) + "\n)}"
      });
      _allowInitAsString = false;
    }
    if (dep && dep.workerModuleData) {
      dep = dep.workerModuleData;
    }
    return dep;
  });
  function moduleFunc() {
    var args = [], len = arguments.length;
    while (len--) args[len] = arguments[len];
    if (!supportsWorkers()) {
      return onMainThread.apply(void 0, args);
    }
    if (!registrationPromise) {
      registrationPromise = callWorker(workerId, "registerModule", moduleFunc.workerModuleData);
      var unregister = function() {
        registrationPromise = null;
        registeredModules[workerId].delete(unregister);
      };
      (registeredModules[workerId] || (registeredModules[workerId] = /* @__PURE__ */ new Set())).add(unregister);
    }
    return registrationPromise.then(function(ref) {
      var isCallable = ref.isCallable;
      if (isCallable) {
        return callWorker(workerId, "callModule", { id, args });
      } else {
        throw new Error("Worker module function was called but `init` did not return a callable function");
      }
    });
  }
  moduleFunc.workerModuleData = {
    isWorkerModule: true,
    id,
    name,
    dependencies,
    init: stringifyFunction(init4),
    getTransferables: getTransferables && stringifyFunction(getTransferables)
  };
  moduleFunc.onMainThread = onMainThread;
  return moduleFunc;
}
function terminateWorker(workerId) {
  if (registeredModules[workerId]) {
    registeredModules[workerId].forEach(function(unregister) {
      unregister();
    });
  }
  if (workers[workerId]) {
    workers[workerId].terminate();
    delete workers[workerId];
  }
}
function stringifyFunction(fn) {
  var str = fn.toString();
  if (!/^function/.test(str) && /^\w+\s*\(/.test(str)) {
    str = "function " + str;
  }
  return str;
}
function getWorker(workerId) {
  var worker = workers[workerId];
  if (!worker) {
    var bootstrap = stringifyFunction(workerBootstrap);
    worker = workers[workerId] = new Worker(
      URL.createObjectURL(
        new Blob(
          ["/** Worker Module Bootstrap: " + workerId.replace(/\*/g, "") + " **/\n\n;(" + bootstrap + ")()"],
          { type: "application/javascript" }
        )
      )
    );
    worker.onmessage = function(e2) {
      var response = e2.data;
      var msgId = response.messageId;
      var callback = openRequests[msgId];
      if (!callback) {
        throw new Error("WorkerModule response with empty or unknown messageId");
      }
      delete openRequests[msgId];
      callback(response);
    };
  }
  return worker;
}
function callWorker(workerId, action, data) {
  return new Promise(function(resolve2, reject) {
    var messageId = ++_messageId;
    openRequests[messageId] = function(response) {
      if (response.success) {
        resolve2(response.result);
      } else {
        reject(new Error("Error in worker " + action + " call: " + response.error));
      }
    };
    getWorker(workerId).postMessage({
      messageId,
      action,
      data
    });
  });
}
function SDFGenerator() {
  var exports$1 = (function(exports$12) {
    function pointOnQuadraticBezier(x0, y0, x1, y1, x22, y2, t2, pointOut) {
      var t22 = 1 - t2;
      pointOut.x = t22 * t22 * x0 + 2 * t22 * t2 * x1 + t2 * t2 * x22;
      pointOut.y = t22 * t22 * y0 + 2 * t22 * t2 * y1 + t2 * t2 * y2;
    }
    function pointOnCubicBezier(x0, y0, x1, y1, x22, y2, x3, y3, t2, pointOut) {
      var t22 = 1 - t2;
      pointOut.x = t22 * t22 * t22 * x0 + 3 * t22 * t22 * t2 * x1 + 3 * t22 * t2 * t2 * x22 + t2 * t2 * t2 * x3;
      pointOut.y = t22 * t22 * t22 * y0 + 3 * t22 * t22 * t2 * y1 + 3 * t22 * t2 * t2 * y2 + t2 * t2 * t2 * y3;
    }
    function forEachPathCommand(pathString, commandCallback) {
      var segmentRE = /([MLQCZ])([^MLQCZ]*)/g;
      var match, firstX, firstY, prevX, prevY;
      while (match = segmentRE.exec(pathString)) {
        var args = match[2].replace(/^\s*|\s*$/g, "").split(/[,\s]+/).map(function(v3) {
          return parseFloat(v3);
        });
        switch (match[1]) {
          case "M":
            prevX = firstX = args[0];
            prevY = firstY = args[1];
            break;
          case "L":
            if (args[0] !== prevX || args[1] !== prevY) {
              commandCallback("L", prevX, prevY, prevX = args[0], prevY = args[1]);
            }
            break;
          case "Q": {
            commandCallback("Q", prevX, prevY, prevX = args[2], prevY = args[3], args[0], args[1]);
            break;
          }
          case "C": {
            commandCallback("C", prevX, prevY, prevX = args[4], prevY = args[5], args[0], args[1], args[2], args[3]);
            break;
          }
          case "Z":
            if (prevX !== firstX || prevY !== firstY) {
              commandCallback("L", prevX, prevY, firstX, firstY);
            }
            break;
        }
      }
    }
    function pathToLineSegments(pathString, segmentCallback, curvePoints) {
      if (curvePoints === void 0) curvePoints = 16;
      var tempPoint = { x: 0, y: 0 };
      forEachPathCommand(pathString, function(command, startX, startY, endX, endY, ctrl1X, ctrl1Y, ctrl2X, ctrl2Y) {
        switch (command) {
          case "L":
            segmentCallback(startX, startY, endX, endY);
            break;
          case "Q": {
            var prevCurveX = startX;
            var prevCurveY = startY;
            for (var i2 = 1; i2 < curvePoints; i2++) {
              pointOnQuadraticBezier(
                startX,
                startY,
                ctrl1X,
                ctrl1Y,
                endX,
                endY,
                i2 / (curvePoints - 1),
                tempPoint
              );
              segmentCallback(prevCurveX, prevCurveY, tempPoint.x, tempPoint.y);
              prevCurveX = tempPoint.x;
              prevCurveY = tempPoint.y;
            }
            break;
          }
          case "C": {
            var prevCurveX$1 = startX;
            var prevCurveY$1 = startY;
            for (var i$12 = 1; i$12 < curvePoints; i$12++) {
              pointOnCubicBezier(
                startX,
                startY,
                ctrl1X,
                ctrl1Y,
                ctrl2X,
                ctrl2Y,
                endX,
                endY,
                i$12 / (curvePoints - 1),
                tempPoint
              );
              segmentCallback(prevCurveX$1, prevCurveY$1, tempPoint.x, tempPoint.y);
              prevCurveX$1 = tempPoint.x;
              prevCurveY$1 = tempPoint.y;
            }
            break;
          }
        }
      });
    }
    var viewportQuadVertex = "precision highp float;attribute vec2 aUV;varying vec2 vUV;void main(){vUV=aUV;gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}";
    var copyTexFragment = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){gl_FragColor=texture2D(tex,vUV);}";
    var cache = /* @__PURE__ */ new WeakMap();
    var glContextParams = {
      premultipliedAlpha: false,
      preserveDrawingBuffer: true,
      antialias: false,
      depth: false
    };
    function withWebGLContext(glOrCanvas, callback) {
      var gl = glOrCanvas.getContext ? glOrCanvas.getContext("webgl", glContextParams) : glOrCanvas;
      var wrapper = cache.get(gl);
      if (!wrapper) {
        let getExtension3 = function(name) {
          var ext = extensions2[name];
          if (!ext) {
            ext = extensions2[name] = gl.getExtension(name);
            if (!ext) {
              throw new Error(name + " not supported");
            }
          }
          return ext;
        }, compileShader2 = function(src, type) {
          var shader = gl.createShader(type);
          gl.shaderSource(shader, src);
          gl.compileShader(shader);
          return shader;
        }, withProgram2 = function(name, vert, frag, func) {
          if (!programs[name]) {
            var attributes = {};
            var uniforms = {};
            var program = gl.createProgram();
            gl.attachShader(program, compileShader2(vert, gl.VERTEX_SHADER));
            gl.attachShader(program, compileShader2(frag, gl.FRAGMENT_SHADER));
            gl.linkProgram(program);
            programs[name] = {
              program,
              transaction: function transaction(func2) {
                gl.useProgram(program);
                func2({
                  setUniform: function setUniform(type, name2) {
                    var values = [], len = arguments.length - 2;
                    while (len-- > 0) values[len] = arguments[len + 2];
                    var uniformLoc = uniforms[name2] || (uniforms[name2] = gl.getUniformLocation(program, name2));
                    gl["uniform" + type].apply(gl, [uniformLoc].concat(values));
                  },
                  setAttribute: function setAttribute(name2, size, usage, instancingDivisor, data) {
                    var attr = attributes[name2];
                    if (!attr) {
                      attr = attributes[name2] = {
                        buf: gl.createBuffer(),
                        // TODO should we destroy our buffers?
                        loc: gl.getAttribLocation(program, name2),
                        data: null
                      };
                    }
                    gl.bindBuffer(gl.ARRAY_BUFFER, attr.buf);
                    gl.vertexAttribPointer(attr.loc, size, gl.FLOAT, false, 0, 0);
                    gl.enableVertexAttribArray(attr.loc);
                    if (isWebGL2) {
                      gl.vertexAttribDivisor(attr.loc, instancingDivisor);
                    } else {
                      getExtension3("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(attr.loc, instancingDivisor);
                    }
                    if (data !== attr.data) {
                      gl.bufferData(gl.ARRAY_BUFFER, data, usage);
                      attr.data = data;
                    }
                  }
                });
              }
            };
          }
          programs[name].transaction(func);
        }, withTexture2 = function(name, func) {
          textureUnit++;
          try {
            gl.activeTexture(gl.TEXTURE0 + textureUnit);
            var texture = textures[name];
            if (!texture) {
              texture = textures[name] = gl.createTexture();
              gl.bindTexture(gl.TEXTURE_2D, texture);
              gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
              gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            }
            gl.bindTexture(gl.TEXTURE_2D, texture);
            func(texture, textureUnit);
          } finally {
            textureUnit--;
          }
        }, withTextureFramebuffer2 = function(texture, textureUnit2, func) {
          var framebuffer = gl.createFramebuffer();
          framebufferStack.push(framebuffer);
          gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
          gl.activeTexture(gl.TEXTURE0 + textureUnit2);
          gl.bindTexture(gl.TEXTURE_2D, texture);
          gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
          try {
            func(framebuffer);
          } finally {
            gl.deleteFramebuffer(framebuffer);
            gl.bindFramebuffer(gl.FRAMEBUFFER, framebufferStack[--framebufferStack.length - 1] || null);
          }
        }, handleContextLoss2 = function() {
          extensions2 = {};
          programs = {};
          textures = {};
          textureUnit = -1;
          framebufferStack.length = 0;
        };
        var getExtension2 = getExtension3, compileShader = compileShader2, withProgram = withProgram2, withTexture = withTexture2, withTextureFramebuffer = withTextureFramebuffer2, handleContextLoss = handleContextLoss2;
        var isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext;
        var extensions2 = {};
        var programs = {};
        var textures = {};
        var textureUnit = -1;
        var framebufferStack = [];
        gl.canvas.addEventListener("webglcontextlost", function(e2) {
          handleContextLoss2();
          e2.preventDefault();
        }, false);
        cache.set(gl, wrapper = {
          gl,
          isWebGL2,
          getExtension: getExtension3,
          withProgram: withProgram2,
          withTexture: withTexture2,
          withTextureFramebuffer: withTextureFramebuffer2,
          handleContextLoss: handleContextLoss2
        });
      }
      callback(wrapper);
    }
    function renderImageData(glOrCanvas, imageData, x3, y2, width, height, channels, framebuffer) {
      if (channels === void 0) channels = 15;
      if (framebuffer === void 0) framebuffer = null;
      withWebGLContext(glOrCanvas, function(ref) {
        var gl = ref.gl;
        var withProgram = ref.withProgram;
        var withTexture = ref.withTexture;
        withTexture("copy", function(tex, texUnit) {
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, imageData);
          withProgram("copy", viewportQuadVertex, copyTexFragment, function(ref2) {
            var setUniform = ref2.setUniform;
            var setAttribute = ref2.setAttribute;
            setAttribute("aUV", 2, gl.STATIC_DRAW, 0, new Float32Array([0, 0, 2, 0, 0, 2]));
            setUniform("1i", "image", texUnit);
            gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer || null);
            gl.disable(gl.BLEND);
            gl.colorMask(channels & 8, channels & 4, channels & 2, channels & 1);
            gl.viewport(x3, y2, width, height);
            gl.scissor(x3, y2, width, height);
            gl.drawArrays(gl.TRIANGLES, 0, 3);
          });
        });
      });
    }
    function resizeWebGLCanvasWithoutClearing2(canvas, newWidth, newHeight) {
      var width = canvas.width;
      var height = canvas.height;
      withWebGLContext(canvas, function(ref) {
        var gl = ref.gl;
        var data = new Uint8Array(width * height * 4);
        gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, data);
        canvas.width = newWidth;
        canvas.height = newHeight;
        renderImageData(gl, data, 0, 0, width, height);
      });
    }
    var webglUtils = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      withWebGLContext,
      renderImageData,
      resizeWebGLCanvasWithoutClearing: resizeWebGLCanvasWithoutClearing2
    });
    function generate$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent) {
      if (sdfExponent === void 0) sdfExponent = 1;
      var textureData = new Uint8Array(sdfWidth * sdfHeight);
      var viewBoxWidth = viewBox[2] - viewBox[0];
      var viewBoxHeight = viewBox[3] - viewBox[1];
      var segments = [];
      pathToLineSegments(path, function(x1, y1, x22, y2) {
        segments.push({
          x1,
          y1,
          x2: x22,
          y2,
          minX: Math.min(x1, x22),
          minY: Math.min(y1, y2),
          maxX: Math.max(x1, x22),
          maxY: Math.max(y1, y2)
        });
      });
      segments.sort(function(a5, b6) {
        return a5.maxX - b6.maxX;
      });
      for (var sdfX = 0; sdfX < sdfWidth; sdfX++) {
        for (var sdfY = 0; sdfY < sdfHeight; sdfY++) {
          var signedDist = findNearestSignedDistance(
            viewBox[0] + viewBoxWidth * (sdfX + 0.5) / sdfWidth,
            viewBox[1] + viewBoxHeight * (sdfY + 0.5) / sdfHeight
          );
          var alpha = Math.pow(1 - Math.abs(signedDist) / maxDistance, sdfExponent) / 2;
          if (signedDist < 0) {
            alpha = 1 - alpha;
          }
          alpha = Math.max(0, Math.min(255, Math.round(alpha * 255)));
          textureData[sdfY * sdfWidth + sdfX] = alpha;
        }
      }
      return textureData;
      function findNearestSignedDistance(x3, y2) {
        var closestDistSq = Infinity;
        var closestDist = Infinity;
        for (var i2 = segments.length; i2--; ) {
          var seg = segments[i2];
          if (seg.maxX + closestDist <= x3) {
            break;
          }
          if (x3 + closestDist > seg.minX && y2 - closestDist < seg.maxY && y2 + closestDist > seg.minY) {
            var distSq = absSquareDistanceToLineSegment(x3, y2, seg.x1, seg.y1, seg.x2, seg.y2);
            if (distSq < closestDistSq) {
              closestDistSq = distSq;
              closestDist = Math.sqrt(closestDistSq);
            }
          }
        }
        if (isPointInPoly(x3, y2)) {
          closestDist = -closestDist;
        }
        return closestDist;
      }
      function isPointInPoly(x3, y2) {
        var winding = 0;
        for (var i2 = segments.length; i2--; ) {
          var seg = segments[i2];
          if (seg.maxX <= x3) {
            break;
          }
          var intersects2 = seg.y1 > y2 !== seg.y2 > y2 && x3 < (seg.x2 - seg.x1) * (y2 - seg.y1) / (seg.y2 - seg.y1) + seg.x1;
          if (intersects2) {
            winding += seg.y1 < seg.y2 ? 1 : -1;
          }
        }
        return winding !== 0;
      }
    }
    function generateIntoCanvas$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x3, y2, channel) {
      if (sdfExponent === void 0) sdfExponent = 1;
      if (x3 === void 0) x3 = 0;
      if (y2 === void 0) y2 = 0;
      if (channel === void 0) channel = 0;
      generateIntoFramebuffer$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, null, x3, y2, channel);
    }
    function generateIntoFramebuffer$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas, framebuffer, x3, y2, channel) {
      if (sdfExponent === void 0) sdfExponent = 1;
      if (x3 === void 0) x3 = 0;
      if (y2 === void 0) y2 = 0;
      if (channel === void 0) channel = 0;
      var data = generate$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent);
      var rgbaData = new Uint8Array(data.length * 4);
      for (var i2 = 0; i2 < data.length; i2++) {
        rgbaData[i2 * 4 + channel] = data[i2];
      }
      renderImageData(glOrCanvas, rgbaData, x3, y2, sdfWidth, sdfHeight, 1 << 3 - channel, framebuffer);
    }
    function absSquareDistanceToLineSegment(x3, y2, lineX0, lineY0, lineX1, lineY1) {
      var ldx = lineX1 - lineX0;
      var ldy = lineY1 - lineY0;
      var lengthSq = ldx * ldx + ldy * ldy;
      var t2 = lengthSq ? Math.max(0, Math.min(1, ((x3 - lineX0) * ldx + (y2 - lineY0) * ldy) / lengthSq)) : 0;
      var dx = x3 - (lineX0 + t2 * ldx);
      var dy = y2 - (lineY0 + t2 * ldy);
      return dx * dx + dy * dy;
    }
    var javascript = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      generate: generate$2,
      generateIntoCanvas: generateIntoCanvas$2,
      generateIntoFramebuffer: generateIntoFramebuffer$1
    });
    var mainVertex = "precision highp float;uniform vec4 uGlyphBounds;attribute vec2 aUV;attribute vec4 aLineSegment;varying vec4 vLineSegment;varying vec2 vGlyphXY;void main(){vLineSegment=aLineSegment;vGlyphXY=mix(uGlyphBounds.xy,uGlyphBounds.zw,aUV);gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}";
    var mainFragment = "precision highp float;uniform vec4 uGlyphBounds;uniform float uMaxDistance;uniform float uExponent;varying vec4 vLineSegment;varying vec2 vGlyphXY;float absDistToSegment(vec2 point,vec2 lineA,vec2 lineB){vec2 lineDir=lineB-lineA;float lenSq=dot(lineDir,lineDir);float t=lenSq==0.0 ? 0.0 : clamp(dot(point-lineA,lineDir)/lenSq,0.0,1.0);vec2 linePt=lineA+t*lineDir;return distance(point,linePt);}void main(){vec4 seg=vLineSegment;vec2 p=vGlyphXY;float dist=absDistToSegment(p,seg.xy,seg.zw);float val=pow(1.0-clamp(dist/uMaxDistance,0.0,1.0),uExponent)*0.5;bool crossing=(seg.y>p.y!=seg.w>p.y)&&(p.x<(seg.z-seg.x)*(p.y-seg.y)/(seg.w-seg.y)+seg.x);bool crossingUp=crossing&&vLineSegment.y<vLineSegment.w;gl_FragColor=vec4(crossingUp ? 1.0/255.0 : 0.0,crossing&&!crossingUp ? 1.0/255.0 : 0.0,0.0,val);}";
    var postFragment = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){vec4 color=texture2D(tex,vUV);bool inside=color.r!=color.g;float val=inside ? 1.0-color.a : color.a;gl_FragColor=vec4(val);}";
    var viewportUVs = new Float32Array([0, 0, 2, 0, 0, 2]);
    var implicitContext = null;
    var isTestingSupport = false;
    var NULL_OBJECT = {};
    var supportByCanvas = /* @__PURE__ */ new WeakMap();
    function validateSupport(glOrCanvas) {
      if (!isTestingSupport && !isSupported(glOrCanvas)) {
        throw new Error("WebGL generation not supported");
      }
    }
    function generate$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas) {
      if (sdfExponent === void 0) sdfExponent = 1;
      if (glOrCanvas === void 0) glOrCanvas = null;
      if (!glOrCanvas) {
        glOrCanvas = implicitContext;
        if (!glOrCanvas) {
          var canvas = typeof OffscreenCanvas === "function" ? new OffscreenCanvas(1, 1) : typeof document !== "undefined" ? document.createElement("canvas") : null;
          if (!canvas) {
            throw new Error("OffscreenCanvas or DOM canvas not supported");
          }
          glOrCanvas = implicitContext = canvas.getContext("webgl", { depth: false });
        }
      }
      validateSupport(glOrCanvas);
      var rgbaData = new Uint8Array(sdfWidth * sdfHeight * 4);
      withWebGLContext(glOrCanvas, function(ref) {
        var gl = ref.gl;
        var withTexture = ref.withTexture;
        var withTextureFramebuffer = ref.withTextureFramebuffer;
        withTexture("readable", function(texture, textureUnit) {
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, sdfWidth, sdfHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
          withTextureFramebuffer(texture, textureUnit, function(framebuffer) {
            generateIntoFramebuffer(
              sdfWidth,
              sdfHeight,
              path,
              viewBox,
              maxDistance,
              sdfExponent,
              gl,
              framebuffer,
              0,
              0,
              0
              // red channel
            );
            gl.readPixels(0, 0, sdfWidth, sdfHeight, gl.RGBA, gl.UNSIGNED_BYTE, rgbaData);
          });
        });
      });
      var data = new Uint8Array(sdfWidth * sdfHeight);
      for (var i2 = 0, j3 = 0; i2 < rgbaData.length; i2 += 4) {
        data[j3++] = rgbaData[i2];
      }
      return data;
    }
    function generateIntoCanvas$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x3, y2, channel) {
      if (sdfExponent === void 0) sdfExponent = 1;
      if (x3 === void 0) x3 = 0;
      if (y2 === void 0) y2 = 0;
      if (channel === void 0) channel = 0;
      generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, null, x3, y2, channel);
    }
    function generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas, framebuffer, x3, y2, channel) {
      if (sdfExponent === void 0) sdfExponent = 1;
      if (x3 === void 0) x3 = 0;
      if (y2 === void 0) y2 = 0;
      if (channel === void 0) channel = 0;
      validateSupport(glOrCanvas);
      var lineSegmentCoords = [];
      pathToLineSegments(path, function(x1, y1, x22, y22) {
        lineSegmentCoords.push(x1, y1, x22, y22);
      });
      lineSegmentCoords = new Float32Array(lineSegmentCoords);
      withWebGLContext(glOrCanvas, function(ref) {
        var gl = ref.gl;
        var isWebGL2 = ref.isWebGL2;
        var getExtension2 = ref.getExtension;
        var withProgram = ref.withProgram;
        var withTexture = ref.withTexture;
        var withTextureFramebuffer = ref.withTextureFramebuffer;
        var handleContextLoss = ref.handleContextLoss;
        withTexture("rawDistances", function(intermediateTexture, intermediateTextureUnit) {
          if (sdfWidth !== intermediateTexture._lastWidth || sdfHeight !== intermediateTexture._lastHeight) {
            gl.texImage2D(
              gl.TEXTURE_2D,
              0,
              gl.RGBA,
              intermediateTexture._lastWidth = sdfWidth,
              intermediateTexture._lastHeight = sdfHeight,
              0,
              gl.RGBA,
              gl.UNSIGNED_BYTE,
              null
            );
          }
          withProgram("main", mainVertex, mainFragment, function(ref2) {
            var setAttribute = ref2.setAttribute;
            var setUniform = ref2.setUniform;
            var instancingExtension = !isWebGL2 && getExtension2("ANGLE_instanced_arrays");
            var blendMinMaxExtension = !isWebGL2 && getExtension2("EXT_blend_minmax");
            setAttribute("aUV", 2, gl.STATIC_DRAW, 0, viewportUVs);
            setAttribute("aLineSegment", 4, gl.DYNAMIC_DRAW, 1, lineSegmentCoords);
            setUniform.apply(void 0, ["4f", "uGlyphBounds"].concat(viewBox));
            setUniform("1f", "uMaxDistance", maxDistance);
            setUniform("1f", "uExponent", sdfExponent);
            withTextureFramebuffer(intermediateTexture, intermediateTextureUnit, function(framebuffer2) {
              gl.enable(gl.BLEND);
              gl.colorMask(true, true, true, true);
              gl.viewport(0, 0, sdfWidth, sdfHeight);
              gl.scissor(0, 0, sdfWidth, sdfHeight);
              gl.blendFunc(gl.ONE, gl.ONE);
              gl.blendEquationSeparate(gl.FUNC_ADD, isWebGL2 ? gl.MAX : blendMinMaxExtension.MAX_EXT);
              gl.clear(gl.COLOR_BUFFER_BIT);
              if (isWebGL2) {
                gl.drawArraysInstanced(gl.TRIANGLES, 0, 3, lineSegmentCoords.length / 4);
              } else {
                instancingExtension.drawArraysInstancedANGLE(gl.TRIANGLES, 0, 3, lineSegmentCoords.length / 4);
              }
            });
          });
          withProgram("post", viewportQuadVertex, postFragment, function(program) {
            program.setAttribute("aUV", 2, gl.STATIC_DRAW, 0, viewportUVs);
            program.setUniform("1i", "tex", intermediateTextureUnit);
            gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
            gl.disable(gl.BLEND);
            gl.colorMask(channel === 0, channel === 1, channel === 2, channel === 3);
            gl.viewport(x3, y2, sdfWidth, sdfHeight);
            gl.scissor(x3, y2, sdfWidth, sdfHeight);
            gl.drawArrays(gl.TRIANGLES, 0, 3);
          });
        });
        if (gl.isContextLost()) {
          handleContextLoss();
          throw new Error("webgl context lost");
        }
      });
    }
    function isSupported(glOrCanvas) {
      var key = !glOrCanvas || glOrCanvas === implicitContext ? NULL_OBJECT : glOrCanvas.canvas || glOrCanvas;
      var supported = supportByCanvas.get(key);
      if (supported === void 0) {
        isTestingSupport = true;
        var failReason = null;
        try {
          var expectedResult = [
            97,
            106,
            97,
            61,
            99,
            137,
            118,
            80,
            80,
            118,
            137,
            99,
            61,
            97,
            106,
            97
          ];
          var testResult = generate$1(
            4,
            4,
            "M8,8L16,8L24,24L16,24Z",
            [0, 0, 32, 32],
            24,
            1,
            glOrCanvas
          );
          supported = testResult && expectedResult.length === testResult.length && testResult.every(function(val, i2) {
            return val === expectedResult[i2];
          });
          if (!supported) {
            failReason = "bad trial run results";
            console.info(expectedResult, testResult);
          }
        } catch (err) {
          supported = false;
          failReason = err.message;
        }
        if (failReason) {
          console.warn("WebGL SDF generation not supported:", failReason);
        }
        isTestingSupport = false;
        supportByCanvas.set(key, supported);
      }
      return supported;
    }
    var webgl = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      generate: generate$1,
      generateIntoCanvas: generateIntoCanvas$1,
      generateIntoFramebuffer,
      isSupported
    });
    function generate(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent) {
      if (maxDistance === void 0) maxDistance = Math.max(viewBox[2] - viewBox[0], viewBox[3] - viewBox[1]) / 2;
      if (sdfExponent === void 0) sdfExponent = 1;
      try {
        return generate$1.apply(webgl, arguments);
      } catch (e2) {
        console.info("WebGL SDF generation failed, falling back to JS", e2);
        return generate$2.apply(javascript, arguments);
      }
    }
    function generateIntoCanvas(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x3, y2, channel) {
      if (maxDistance === void 0) maxDistance = Math.max(viewBox[2] - viewBox[0], viewBox[3] - viewBox[1]) / 2;
      if (sdfExponent === void 0) sdfExponent = 1;
      if (x3 === void 0) x3 = 0;
      if (y2 === void 0) y2 = 0;
      if (channel === void 0) channel = 0;
      try {
        return generateIntoCanvas$1.apply(webgl, arguments);
      } catch (e2) {
        console.info("WebGL SDF generation failed, falling back to JS", e2);
        return generateIntoCanvas$2.apply(javascript, arguments);
      }
    }
    exports$12.forEachPathCommand = forEachPathCommand;
    exports$12.generate = generate;
    exports$12.generateIntoCanvas = generateIntoCanvas;
    exports$12.javascript = javascript;
    exports$12.pathToLineSegments = pathToLineSegments;
    exports$12.webgl = webgl;
    exports$12.webglUtils = webglUtils;
    Object.defineProperty(exports$12, "__esModule", { value: true });
    return exports$12;
  })({});
  return exports$1;
}
function bidiFactory() {
  var bidi = (function(exports$1) {
    var DATA = {
      "R": "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
      "EN": "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
      "ES": "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
      "ET": "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
      "AN": "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
      "CS": "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
      "B": "a,3,f+2,2v,690",
      "S": "9,2,k",
      "WS": "c,k,4f4,1vk+a,u,1j,335",
      "ON": "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
      "BN": "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
      "NSM": "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
      "AL": "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
      "LRO": "6ct",
      "RLO": "6cu",
      "LRE": "6cq",
      "RLE": "6cr",
      "PDF": "6cs",
      "LRI": "6ee",
      "RLI": "6ef",
      "FSI": "6eg",
      "PDI": "6eh"
    };
    var TYPES = {};
    var TYPES_TO_NAMES = {};
    TYPES.L = 1;
    TYPES_TO_NAMES[1] = "L";
    Object.keys(DATA).forEach(function(type, i2) {
      TYPES[type] = 1 << i2 + 1;
      TYPES_TO_NAMES[TYPES[type]] = type;
    });
    Object.freeze(TYPES);
    var ISOLATE_INIT_TYPES = TYPES.LRI | TYPES.RLI | TYPES.FSI;
    var STRONG_TYPES = TYPES.L | TYPES.R | TYPES.AL;
    var NEUTRAL_ISOLATE_TYPES = TYPES.B | TYPES.S | TYPES.WS | TYPES.ON | TYPES.FSI | TYPES.LRI | TYPES.RLI | TYPES.PDI;
    var BN_LIKE_TYPES = TYPES.BN | TYPES.RLE | TYPES.LRE | TYPES.RLO | TYPES.LRO | TYPES.PDF;
    var TRAILING_TYPES = TYPES.S | TYPES.WS | TYPES.B | ISOLATE_INIT_TYPES | TYPES.PDI | BN_LIKE_TYPES;
    var map = null;
    function parseData() {
      if (!map) {
        map = /* @__PURE__ */ new Map();
        var loop2 = function(type2) {
          if (DATA.hasOwnProperty(type2)) {
            var lastCode = 0;
            DATA[type2].split(",").forEach(function(range) {
              var ref = range.split("+");
              var skip = ref[0];
              var step = ref[1];
              skip = parseInt(skip, 36);
              step = step ? parseInt(step, 36) : 0;
              map.set(lastCode += skip, TYPES[type2]);
              for (var i2 = 0; i2 < step; i2++) {
                map.set(++lastCode, TYPES[type2]);
              }
            });
          }
        };
        for (var type in DATA) loop2(type);
      }
    }
    function getBidiCharType(char) {
      parseData();
      return map.get(char.codePointAt(0)) || TYPES.L;
    }
    function getBidiCharTypeName(char) {
      return TYPES_TO_NAMES[getBidiCharType(char)];
    }
    var data$1 = {
      "pairs": "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
      "canonical": "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye"
    };
    function parseCharacterMap(encodedString, includeReverse) {
      var radix = 36;
      var lastCode = 0;
      var map2 = /* @__PURE__ */ new Map();
      var reverseMap = includeReverse && /* @__PURE__ */ new Map();
      var prevPair;
      encodedString.split(",").forEach(function visit(entry) {
        if (entry.indexOf("+") !== -1) {
          for (var i2 = +entry; i2--; ) {
            visit(prevPair);
          }
        } else {
          prevPair = entry;
          var ref = entry.split(">");
          var a5 = ref[0];
          var b6 = ref[1];
          a5 = String.fromCodePoint(lastCode += parseInt(a5, radix));
          b6 = String.fromCodePoint(lastCode += parseInt(b6, radix));
          map2.set(a5, b6);
          includeReverse && reverseMap.set(b6, a5);
        }
      });
      return { map: map2, reverseMap };
    }
    var openToClose, closeToOpen, canonical;
    function parse$1() {
      if (!openToClose) {
        var ref = parseCharacterMap(data$1.pairs, true);
        var map2 = ref.map;
        var reverseMap = ref.reverseMap;
        openToClose = map2;
        closeToOpen = reverseMap;
        canonical = parseCharacterMap(data$1.canonical, false).map;
      }
    }
    function openingToClosingBracket(char) {
      parse$1();
      return openToClose.get(char) || null;
    }
    function closingToOpeningBracket(char) {
      parse$1();
      return closeToOpen.get(char) || null;
    }
    function getCanonicalBracket(char) {
      parse$1();
      return canonical.get(char) || null;
    }
    var TYPE_L = TYPES.L;
    var TYPE_R = TYPES.R;
    var TYPE_EN = TYPES.EN;
    var TYPE_ES = TYPES.ES;
    var TYPE_ET = TYPES.ET;
    var TYPE_AN = TYPES.AN;
    var TYPE_CS = TYPES.CS;
    var TYPE_B = TYPES.B;
    var TYPE_S = TYPES.S;
    var TYPE_ON = TYPES.ON;
    var TYPE_BN = TYPES.BN;
    var TYPE_NSM = TYPES.NSM;
    var TYPE_AL = TYPES.AL;
    var TYPE_LRO = TYPES.LRO;
    var TYPE_RLO = TYPES.RLO;
    var TYPE_LRE = TYPES.LRE;
    var TYPE_RLE = TYPES.RLE;
    var TYPE_PDF = TYPES.PDF;
    var TYPE_LRI = TYPES.LRI;
    var TYPE_RLI = TYPES.RLI;
    var TYPE_FSI = TYPES.FSI;
    var TYPE_PDI = TYPES.PDI;
    function getEmbeddingLevels(string, baseDirection) {
      var MAX_DEPTH = 125;
      var charTypes = new Uint32Array(string.length);
      for (var i2 = 0; i2 < string.length; i2++) {
        charTypes[i2] = getBidiCharType(string[i2]);
      }
      var charTypeCounts = /* @__PURE__ */ new Map();
      function changeCharType(i3, type2) {
        var oldType = charTypes[i3];
        charTypes[i3] = type2;
        charTypeCounts.set(oldType, charTypeCounts.get(oldType) - 1);
        if (oldType & NEUTRAL_ISOLATE_TYPES) {
          charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) - 1);
        }
        charTypeCounts.set(type2, (charTypeCounts.get(type2) || 0) + 1);
        if (type2 & NEUTRAL_ISOLATE_TYPES) {
          charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) || 0) + 1);
        }
      }
      var embedLevels = new Uint8Array(string.length);
      var isolationPairs = /* @__PURE__ */ new Map();
      var paragraphs = [];
      var paragraph = null;
      for (var i$12 = 0; i$12 < string.length; i$12++) {
        if (!paragraph) {
          paragraphs.push(paragraph = {
            start: i$12,
            end: string.length - 1,
            // 3.3.1 P2-P3: Determine the paragraph level
            level: baseDirection === "rtl" ? 1 : baseDirection === "ltr" ? 0 : determineAutoEmbedLevel(i$12, false)
          });
        }
        if (charTypes[i$12] & TYPE_B) {
          paragraph.end = i$12;
          paragraph = null;
        }
      }
      var FORMATTING_TYPES = TYPE_RLE | TYPE_LRE | TYPE_RLO | TYPE_LRO | ISOLATE_INIT_TYPES | TYPE_PDI | TYPE_PDF | TYPE_B;
      var nextEven = function(n2) {
        return n2 + (n2 & 1 ? 1 : 2);
      };
      var nextOdd = function(n2) {
        return n2 + (n2 & 1 ? 2 : 1);
      };
      for (var paraIdx = 0; paraIdx < paragraphs.length; paraIdx++) {
        paragraph = paragraphs[paraIdx];
        var statusStack = [{
          _level: paragraph.level,
          _override: 0,
          //0=neutral, 1=L, 2=R
          _isolate: 0
          //bool
        }];
        var stackTop = void 0;
        var overflowIsolateCount = 0;
        var overflowEmbeddingCount = 0;
        var validIsolateCount = 0;
        charTypeCounts.clear();
        for (var i$2 = paragraph.start; i$2 <= paragraph.end; i$2++) {
          var charType = charTypes[i$2];
          stackTop = statusStack[statusStack.length - 1];
          charTypeCounts.set(charType, (charTypeCounts.get(charType) || 0) + 1);
          if (charType & NEUTRAL_ISOLATE_TYPES) {
            charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) || 0) + 1);
          }
          if (charType & FORMATTING_TYPES) {
            if (charType & (TYPE_RLE | TYPE_LRE)) {
              embedLevels[i$2] = stackTop._level;
              var level = (charType === TYPE_RLE ? nextOdd : nextEven)(stackTop._level);
              if (level <= MAX_DEPTH && !overflowIsolateCount && !overflowEmbeddingCount) {
                statusStack.push({
                  _level: level,
                  _override: 0,
                  _isolate: 0
                });
              } else if (!overflowIsolateCount) {
                overflowEmbeddingCount++;
              }
            } else if (charType & (TYPE_RLO | TYPE_LRO)) {
              embedLevels[i$2] = stackTop._level;
              var level$1 = (charType === TYPE_RLO ? nextOdd : nextEven)(stackTop._level);
              if (level$1 <= MAX_DEPTH && !overflowIsolateCount && !overflowEmbeddingCount) {
                statusStack.push({
                  _level: level$1,
                  _override: charType & TYPE_RLO ? TYPE_R : TYPE_L,
                  _isolate: 0
                });
              } else if (!overflowIsolateCount) {
                overflowEmbeddingCount++;
              }
            } else if (charType & ISOLATE_INIT_TYPES) {
              if (charType & TYPE_FSI) {
                charType = determineAutoEmbedLevel(i$2 + 1, true) === 1 ? TYPE_RLI : TYPE_LRI;
              }
              embedLevels[i$2] = stackTop._level;
              if (stackTop._override) {
                changeCharType(i$2, stackTop._override);
              }
              var level$2 = (charType === TYPE_RLI ? nextOdd : nextEven)(stackTop._level);
              if (level$2 <= MAX_DEPTH && overflowIsolateCount === 0 && overflowEmbeddingCount === 0) {
                validIsolateCount++;
                statusStack.push({
                  _level: level$2,
                  _override: 0,
                  _isolate: 1,
                  _isolInitIndex: i$2
                });
              } else {
                overflowIsolateCount++;
              }
            } else if (charType & TYPE_PDI) {
              if (overflowIsolateCount > 0) {
                overflowIsolateCount--;
              } else if (validIsolateCount > 0) {
                overflowEmbeddingCount = 0;
                while (!statusStack[statusStack.length - 1]._isolate) {
                  statusStack.pop();
                }
                var isolInitIndex = statusStack[statusStack.length - 1]._isolInitIndex;
                if (isolInitIndex != null) {
                  isolationPairs.set(isolInitIndex, i$2);
                  isolationPairs.set(i$2, isolInitIndex);
                }
                statusStack.pop();
                validIsolateCount--;
              }
              stackTop = statusStack[statusStack.length - 1];
              embedLevels[i$2] = stackTop._level;
              if (stackTop._override) {
                changeCharType(i$2, stackTop._override);
              }
            } else if (charType & TYPE_PDF) {
              if (overflowIsolateCount === 0) {
                if (overflowEmbeddingCount > 0) {
                  overflowEmbeddingCount--;
                } else if (!stackTop._isolate && statusStack.length > 1) {
                  statusStack.pop();
                  stackTop = statusStack[statusStack.length - 1];
                }
              }
              embedLevels[i$2] = stackTop._level;
            } else if (charType & TYPE_B) {
              embedLevels[i$2] = paragraph.level;
            }
          } else {
            embedLevels[i$2] = stackTop._level;
            if (stackTop._override && charType !== TYPE_BN) {
              changeCharType(i$2, stackTop._override);
            }
          }
        }
        var levelRuns = [];
        var currentRun = null;
        for (var i$32 = paragraph.start; i$32 <= paragraph.end; i$32++) {
          var charType$1 = charTypes[i$32];
          if (!(charType$1 & BN_LIKE_TYPES)) {
            var lvl = embedLevels[i$32];
            var isIsolInit = charType$1 & ISOLATE_INIT_TYPES;
            var isPDI = charType$1 === TYPE_PDI;
            if (currentRun && lvl === currentRun._level) {
              currentRun._end = i$32;
              currentRun._endsWithIsolInit = isIsolInit;
            } else {
              levelRuns.push(currentRun = {
                _start: i$32,
                _end: i$32,
                _level: lvl,
                _startsWithPDI: isPDI,
                _endsWithIsolInit: isIsolInit
              });
            }
          }
        }
        var isolatingRunSeqs = [];
        for (var runIdx = 0; runIdx < levelRuns.length; runIdx++) {
          var run2 = levelRuns[runIdx];
          if (!run2._startsWithPDI || run2._startsWithPDI && !isolationPairs.has(run2._start)) {
            var seqRuns = [currentRun = run2];
            for (var pdiIndex = void 0; currentRun && currentRun._endsWithIsolInit && (pdiIndex = isolationPairs.get(currentRun._end)) != null; ) {
              for (var i$4 = runIdx + 1; i$4 < levelRuns.length; i$4++) {
                if (levelRuns[i$4]._start === pdiIndex) {
                  seqRuns.push(currentRun = levelRuns[i$4]);
                  break;
                }
              }
            }
            var seqIndices = [];
            for (var i$5 = 0; i$5 < seqRuns.length; i$5++) {
              var run$1 = seqRuns[i$5];
              for (var j3 = run$1._start; j3 <= run$1._end; j3++) {
                seqIndices.push(j3);
              }
            }
            var firstLevel = embedLevels[seqIndices[0]];
            var prevLevel = paragraph.level;
            for (var i$6 = seqIndices[0] - 1; i$6 >= 0; i$6--) {
              if (!(charTypes[i$6] & BN_LIKE_TYPES)) {
                prevLevel = embedLevels[i$6];
                break;
              }
            }
            var lastIndex = seqIndices[seqIndices.length - 1];
            var lastLevel = embedLevels[lastIndex];
            var nextLevel = paragraph.level;
            if (!(charTypes[lastIndex] & ISOLATE_INIT_TYPES)) {
              for (var i$7 = lastIndex + 1; i$7 <= paragraph.end; i$7++) {
                if (!(charTypes[i$7] & BN_LIKE_TYPES)) {
                  nextLevel = embedLevels[i$7];
                  break;
                }
              }
            }
            isolatingRunSeqs.push({
              _seqIndices: seqIndices,
              _sosType: Math.max(prevLevel, firstLevel) % 2 ? TYPE_R : TYPE_L,
              _eosType: Math.max(nextLevel, lastLevel) % 2 ? TYPE_R : TYPE_L
            });
          }
        }
        for (var seqIdx = 0; seqIdx < isolatingRunSeqs.length; seqIdx++) {
          var ref = isolatingRunSeqs[seqIdx];
          var seqIndices$1 = ref._seqIndices;
          var sosType = ref._sosType;
          var eosType = ref._eosType;
          var embedDirection = embedLevels[seqIndices$1[0]] & 1 ? TYPE_R : TYPE_L;
          if (charTypeCounts.get(TYPE_NSM)) {
            for (var si = 0; si < seqIndices$1.length; si++) {
              var i$8 = seqIndices$1[si];
              if (charTypes[i$8] & TYPE_NSM) {
                var prevType = sosType;
                for (var sj = si - 1; sj >= 0; sj--) {
                  if (!(charTypes[seqIndices$1[sj]] & BN_LIKE_TYPES)) {
                    prevType = charTypes[seqIndices$1[sj]];
                    break;
                  }
                }
                changeCharType(i$8, prevType & (ISOLATE_INIT_TYPES | TYPE_PDI) ? TYPE_ON : prevType);
              }
            }
          }
          if (charTypeCounts.get(TYPE_EN)) {
            for (var si$1 = 0; si$1 < seqIndices$1.length; si$1++) {
              var i$9 = seqIndices$1[si$1];
              if (charTypes[i$9] & TYPE_EN) {
                for (var sj$1 = si$1 - 1; sj$1 >= -1; sj$1--) {
                  var prevCharType = sj$1 === -1 ? sosType : charTypes[seqIndices$1[sj$1]];
                  if (prevCharType & STRONG_TYPES) {
                    if (prevCharType === TYPE_AL) {
                      changeCharType(i$9, TYPE_AN);
                    }
                    break;
                  }
                }
              }
            }
          }
          if (charTypeCounts.get(TYPE_AL)) {
            for (var si$2 = 0; si$2 < seqIndices$1.length; si$2++) {
              var i$10 = seqIndices$1[si$2];
              if (charTypes[i$10] & TYPE_AL) {
                changeCharType(i$10, TYPE_R);
              }
            }
          }
          if (charTypeCounts.get(TYPE_ES) || charTypeCounts.get(TYPE_CS)) {
            for (var si$3 = 1; si$3 < seqIndices$1.length - 1; si$3++) {
              var i$11 = seqIndices$1[si$3];
              if (charTypes[i$11] & (TYPE_ES | TYPE_CS)) {
                var prevType$1 = 0, nextType = 0;
                for (var sj$2 = si$3 - 1; sj$2 >= 0; sj$2--) {
                  prevType$1 = charTypes[seqIndices$1[sj$2]];
                  if (!(prevType$1 & BN_LIKE_TYPES)) {
                    break;
                  }
                }
                for (var sj$3 = si$3 + 1; sj$3 < seqIndices$1.length; sj$3++) {
                  nextType = charTypes[seqIndices$1[sj$3]];
                  if (!(nextType & BN_LIKE_TYPES)) {
                    break;
                  }
                }
                if (prevType$1 === nextType && (charTypes[i$11] === TYPE_ES ? prevType$1 === TYPE_EN : prevType$1 & (TYPE_EN | TYPE_AN))) {
                  changeCharType(i$11, prevType$1);
                }
              }
            }
          }
          if (charTypeCounts.get(TYPE_EN)) {
            for (var si$4 = 0; si$4 < seqIndices$1.length; si$4++) {
              var i$122 = seqIndices$1[si$4];
              if (charTypes[i$122] & TYPE_EN) {
                for (var sj$4 = si$4 - 1; sj$4 >= 0 && charTypes[seqIndices$1[sj$4]] & (TYPE_ET | BN_LIKE_TYPES); sj$4--) {
                  changeCharType(seqIndices$1[sj$4], TYPE_EN);
                }
                for (si$4++; si$4 < seqIndices$1.length && charTypes[seqIndices$1[si$4]] & (TYPE_ET | BN_LIKE_TYPES | TYPE_EN); si$4++) {
                  if (charTypes[seqIndices$1[si$4]] !== TYPE_EN) {
                    changeCharType(seqIndices$1[si$4], TYPE_EN);
                  }
                }
              }
            }
          }
          if (charTypeCounts.get(TYPE_ET) || charTypeCounts.get(TYPE_ES) || charTypeCounts.get(TYPE_CS)) {
            for (var si$5 = 0; si$5 < seqIndices$1.length; si$5++) {
              var i$13 = seqIndices$1[si$5];
              if (charTypes[i$13] & (TYPE_ET | TYPE_ES | TYPE_CS)) {
                changeCharType(i$13, TYPE_ON);
                for (var sj$5 = si$5 - 1; sj$5 >= 0 && charTypes[seqIndices$1[sj$5]] & BN_LIKE_TYPES; sj$5--) {
                  changeCharType(seqIndices$1[sj$5], TYPE_ON);
                }
                for (var sj$6 = si$5 + 1; sj$6 < seqIndices$1.length && charTypes[seqIndices$1[sj$6]] & BN_LIKE_TYPES; sj$6++) {
                  changeCharType(seqIndices$1[sj$6], TYPE_ON);
                }
              }
            }
          }
          if (charTypeCounts.get(TYPE_EN)) {
            for (var si$6 = 0, prevStrongType = sosType; si$6 < seqIndices$1.length; si$6++) {
              var i$14 = seqIndices$1[si$6];
              var type = charTypes[i$14];
              if (type & TYPE_EN) {
                if (prevStrongType === TYPE_L) {
                  changeCharType(i$14, TYPE_L);
                }
              } else if (type & STRONG_TYPES) {
                prevStrongType = type;
              }
            }
          }
          if (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES)) {
            var R_TYPES_FOR_N_STEPS = TYPE_R | TYPE_EN | TYPE_AN;
            var STRONG_TYPES_FOR_N_STEPS = R_TYPES_FOR_N_STEPS | TYPE_L;
            var bracketPairs = [];
            {
              var openerStack = [];
              for (var si$7 = 0; si$7 < seqIndices$1.length; si$7++) {
                if (charTypes[seqIndices$1[si$7]] & NEUTRAL_ISOLATE_TYPES) {
                  var char = string[seqIndices$1[si$7]];
                  var oppositeBracket = void 0;
                  if (openingToClosingBracket(char) !== null) {
                    if (openerStack.length < 63) {
                      openerStack.push({ char, seqIndex: si$7 });
                    } else {
                      break;
                    }
                  } else if ((oppositeBracket = closingToOpeningBracket(char)) !== null) {
                    for (var stackIdx = openerStack.length - 1; stackIdx >= 0; stackIdx--) {
                      var stackChar = openerStack[stackIdx].char;
                      if (stackChar === oppositeBracket || stackChar === closingToOpeningBracket(getCanonicalBracket(char)) || openingToClosingBracket(getCanonicalBracket(stackChar)) === char) {
                        bracketPairs.push([openerStack[stackIdx].seqIndex, si$7]);
                        openerStack.length = stackIdx;
                        break;
                      }
                    }
                  }
                }
              }
              bracketPairs.sort(function(a5, b6) {
                return a5[0] - b6[0];
              });
            }
            for (var pairIdx = 0; pairIdx < bracketPairs.length; pairIdx++) {
              var ref$1 = bracketPairs[pairIdx];
              var openSeqIdx = ref$1[0];
              var closeSeqIdx = ref$1[1];
              var foundStrongType = false;
              var useStrongType = 0;
              for (var si$8 = openSeqIdx + 1; si$8 < closeSeqIdx; si$8++) {
                var i$15 = seqIndices$1[si$8];
                if (charTypes[i$15] & STRONG_TYPES_FOR_N_STEPS) {
                  foundStrongType = true;
                  var lr = charTypes[i$15] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                  if (lr === embedDirection) {
                    useStrongType = lr;
                    break;
                  }
                }
              }
              if (foundStrongType && !useStrongType) {
                useStrongType = sosType;
                for (var si$9 = openSeqIdx - 1; si$9 >= 0; si$9--) {
                  var i$16 = seqIndices$1[si$9];
                  if (charTypes[i$16] & STRONG_TYPES_FOR_N_STEPS) {
                    var lr$1 = charTypes[i$16] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                    if (lr$1 !== embedDirection) {
                      useStrongType = lr$1;
                    } else {
                      useStrongType = embedDirection;
                    }
                    break;
                  }
                }
              }
              if (useStrongType) {
                charTypes[seqIndices$1[openSeqIdx]] = charTypes[seqIndices$1[closeSeqIdx]] = useStrongType;
                if (useStrongType !== embedDirection) {
                  for (var si$10 = openSeqIdx + 1; si$10 < seqIndices$1.length; si$10++) {
                    if (!(charTypes[seqIndices$1[si$10]] & BN_LIKE_TYPES)) {
                      if (getBidiCharType(string[seqIndices$1[si$10]]) & TYPE_NSM) {
                        charTypes[seqIndices$1[si$10]] = useStrongType;
                      }
                      break;
                    }
                  }
                }
                if (useStrongType !== embedDirection) {
                  for (var si$11 = closeSeqIdx + 1; si$11 < seqIndices$1.length; si$11++) {
                    if (!(charTypes[seqIndices$1[si$11]] & BN_LIKE_TYPES)) {
                      if (getBidiCharType(string[seqIndices$1[si$11]]) & TYPE_NSM) {
                        charTypes[seqIndices$1[si$11]] = useStrongType;
                      }
                      break;
                    }
                  }
                }
              }
            }
            for (var si$12 = 0; si$12 < seqIndices$1.length; si$12++) {
              if (charTypes[seqIndices$1[si$12]] & NEUTRAL_ISOLATE_TYPES) {
                var niRunStart = si$12, niRunEnd = si$12;
                var prevType$2 = sosType;
                for (var si2 = si$12 - 1; si2 >= 0; si2--) {
                  if (charTypes[seqIndices$1[si2]] & BN_LIKE_TYPES) {
                    niRunStart = si2;
                  } else {
                    prevType$2 = charTypes[seqIndices$1[si2]] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                    break;
                  }
                }
                var nextType$1 = eosType;
                for (var si2$1 = si$12 + 1; si2$1 < seqIndices$1.length; si2$1++) {
                  if (charTypes[seqIndices$1[si2$1]] & (NEUTRAL_ISOLATE_TYPES | BN_LIKE_TYPES)) {
                    niRunEnd = si2$1;
                  } else {
                    nextType$1 = charTypes[seqIndices$1[si2$1]] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                    break;
                  }
                }
                for (var sj$7 = niRunStart; sj$7 <= niRunEnd; sj$7++) {
                  charTypes[seqIndices$1[sj$7]] = prevType$2 === nextType$1 ? prevType$2 : embedDirection;
                }
                si$12 = niRunEnd;
              }
            }
          }
        }
        for (var i$17 = paragraph.start; i$17 <= paragraph.end; i$17++) {
          var level$3 = embedLevels[i$17];
          var type$1 = charTypes[i$17];
          if (level$3 & 1) {
            if (type$1 & (TYPE_L | TYPE_EN | TYPE_AN)) {
              embedLevels[i$17]++;
            }
          } else {
            if (type$1 & TYPE_R) {
              embedLevels[i$17]++;
            } else if (type$1 & (TYPE_AN | TYPE_EN)) {
              embedLevels[i$17] += 2;
            }
          }
          if (type$1 & BN_LIKE_TYPES) {
            embedLevels[i$17] = i$17 === 0 ? paragraph.level : embedLevels[i$17 - 1];
          }
          if (i$17 === paragraph.end || getBidiCharType(string[i$17]) & (TYPE_S | TYPE_B)) {
            for (var j$12 = i$17; j$12 >= 0 && getBidiCharType(string[j$12]) & TRAILING_TYPES; j$12--) {
              embedLevels[j$12] = paragraph.level;
            }
          }
        }
      }
      return {
        levels: embedLevels,
        paragraphs
      };
      function determineAutoEmbedLevel(start2, isFSI) {
        for (var i3 = start2; i3 < string.length; i3++) {
          var charType2 = charTypes[i3];
          if (charType2 & (TYPE_R | TYPE_AL)) {
            return 1;
          }
          if (charType2 & (TYPE_B | TYPE_L) || isFSI && charType2 === TYPE_PDI) {
            return 0;
          }
          if (charType2 & ISOLATE_INIT_TYPES) {
            var pdi = indexOfMatchingPDI(i3);
            i3 = pdi === -1 ? string.length : pdi;
          }
        }
        return 0;
      }
      function indexOfMatchingPDI(isolateStart) {
        var isolationLevel = 1;
        for (var i3 = isolateStart + 1; i3 < string.length; i3++) {
          var charType2 = charTypes[i3];
          if (charType2 & TYPE_B) {
            break;
          }
          if (charType2 & TYPE_PDI) {
            if (--isolationLevel === 0) {
              return i3;
            }
          } else if (charType2 & ISOLATE_INIT_TYPES) {
            isolationLevel++;
          }
        }
        return -1;
      }
    }
    var data = "14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1";
    var mirrorMap;
    function parse() {
      if (!mirrorMap) {
        var ref = parseCharacterMap(data, true);
        var map2 = ref.map;
        var reverseMap = ref.reverseMap;
        reverseMap.forEach(function(value, key) {
          map2.set(key, value);
        });
        mirrorMap = map2;
      }
    }
    function getMirroredCharacter(char) {
      parse();
      return mirrorMap.get(char) || null;
    }
    function getMirroredCharactersMap(string, embeddingLevels, start2, end) {
      var strLen = string.length;
      start2 = Math.max(0, start2 == null ? 0 : +start2);
      end = Math.min(strLen - 1, end == null ? strLen - 1 : +end);
      var map2 = /* @__PURE__ */ new Map();
      for (var i2 = start2; i2 <= end; i2++) {
        if (embeddingLevels[i2] & 1) {
          var mirror = getMirroredCharacter(string[i2]);
          if (mirror !== null) {
            map2.set(i2, mirror);
          }
        }
      }
      return map2;
    }
    function getReorderSegments(string, embeddingLevelsResult, start2, end) {
      var strLen = string.length;
      start2 = Math.max(0, start2 == null ? 0 : +start2);
      end = Math.min(strLen - 1, end == null ? strLen - 1 : +end);
      var segments = [];
      embeddingLevelsResult.paragraphs.forEach(function(paragraph) {
        var lineStart = Math.max(start2, paragraph.start);
        var lineEnd = Math.min(end, paragraph.end);
        if (lineStart < lineEnd) {
          var lineLevels = embeddingLevelsResult.levels.slice(lineStart, lineEnd + 1);
          for (var i2 = lineEnd; i2 >= lineStart && getBidiCharType(string[i2]) & TRAILING_TYPES; i2--) {
            lineLevels[i2] = paragraph.level;
          }
          var maxLevel = paragraph.level;
          var minOddLevel = Infinity;
          for (var i$12 = 0; i$12 < lineLevels.length; i$12++) {
            var level = lineLevels[i$12];
            if (level > maxLevel) {
              maxLevel = level;
            }
            if (level < minOddLevel) {
              minOddLevel = level | 1;
            }
          }
          for (var lvl = maxLevel; lvl >= minOddLevel; lvl--) {
            for (var i$2 = 0; i$2 < lineLevels.length; i$2++) {
              if (lineLevels[i$2] >= lvl) {
                var segStart = i$2;
                while (i$2 + 1 < lineLevels.length && lineLevels[i$2 + 1] >= lvl) {
                  i$2++;
                }
                if (i$2 > segStart) {
                  segments.push([segStart + lineStart, i$2 + lineStart]);
                }
              }
            }
          }
        }
      });
      return segments;
    }
    function getReorderedString(string, embedLevelsResult, start2, end) {
      var indices = getReorderedIndices(string, embedLevelsResult, start2, end);
      var chars = [].concat(string);
      indices.forEach(function(charIndex, i2) {
        chars[i2] = (embedLevelsResult.levels[charIndex] & 1 ? getMirroredCharacter(string[charIndex]) : null) || string[charIndex];
      });
      return chars.join("");
    }
    function getReorderedIndices(string, embedLevelsResult, start2, end) {
      var segments = getReorderSegments(string, embedLevelsResult, start2, end);
      var indices = [];
      for (var i2 = 0; i2 < string.length; i2++) {
        indices[i2] = i2;
      }
      segments.forEach(function(ref) {
        var start3 = ref[0];
        var end2 = ref[1];
        var slice = indices.slice(start3, end2 + 1);
        for (var i3 = slice.length; i3--; ) {
          indices[end2 - i3] = slice[i3];
        }
      });
      return indices;
    }
    exports$1.closingToOpeningBracket = closingToOpeningBracket;
    exports$1.getBidiCharType = getBidiCharType;
    exports$1.getBidiCharTypeName = getBidiCharTypeName;
    exports$1.getCanonicalBracket = getCanonicalBracket;
    exports$1.getEmbeddingLevels = getEmbeddingLevels;
    exports$1.getMirroredCharacter = getMirroredCharacter;
    exports$1.getMirroredCharactersMap = getMirroredCharactersMap;
    exports$1.getReorderSegments = getReorderSegments;
    exports$1.getReorderedIndices = getReorderedIndices;
    exports$1.getReorderedString = getReorderedString;
    exports$1.openingToClosingBracket = openingToClosingBracket;
    Object.defineProperty(exports$1, "__esModule", { value: true });
    return exports$1;
  })({});
  return bidi;
}
const voidMainRegExp = /\bvoid\s+main\s*\(\s*\)\s*{/g;
function expandShaderIncludes(source) {
  const pattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
  function replace(match, include) {
    let chunk = ShaderChunk[include];
    return chunk ? expandShaderIncludes(chunk) : match;
  }
  return source.replace(pattern, replace);
}
const _lut = [];
for (let i2 = 0; i2 < 256; i2++) {
  _lut[i2] = (i2 < 16 ? "0" : "") + i2.toString(16);
}
function generateUUID() {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d22 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  const uuid = _lut[d0 & 255] + _lut[d0 >> 8 & 255] + _lut[d0 >> 16 & 255] + _lut[d0 >> 24 & 255] + "-" + _lut[d1 & 255] + _lut[d1 >> 8 & 255] + "-" + _lut[d1 >> 16 & 15 | 64] + _lut[d1 >> 24 & 255] + "-" + _lut[d22 & 63 | 128] + _lut[d22 >> 8 & 255] + "-" + _lut[d22 >> 16 & 255] + _lut[d22 >> 24 & 255] + _lut[d3 & 255] + _lut[d3 >> 8 & 255] + _lut[d3 >> 16 & 255] + _lut[d3 >> 24 & 255];
  return uuid.toUpperCase();
}
const assign$2 = Object.assign || function() {
  let target = arguments[0];
  for (let i2 = 1, len = arguments.length; i2 < len; i2++) {
    let source = arguments[i2];
    if (source) {
      for (let prop in source) {
        if (Object.prototype.hasOwnProperty.call(source, prop)) {
          target[prop] = source[prop];
        }
      }
    }
  }
  return target;
};
const epoch = Date.now();
const CONSTRUCTOR_CACHE = /* @__PURE__ */ new WeakMap();
const SHADER_UPGRADE_CACHE = /* @__PURE__ */ new Map();
let materialInstanceId = 1e10;
function createDerivedMaterial(baseMaterial, options) {
  const optionsKey = getKeyForOptions(options);
  let ctorsByDerivation = CONSTRUCTOR_CACHE.get(baseMaterial);
  if (!ctorsByDerivation) {
    CONSTRUCTOR_CACHE.set(baseMaterial, ctorsByDerivation = /* @__PURE__ */ Object.create(null));
  }
  if (ctorsByDerivation[optionsKey]) {
    return new ctorsByDerivation[optionsKey]();
  }
  const privateBeforeCompileProp = `_onBeforeCompile${optionsKey}`;
  const onBeforeCompile = function(shaderInfo, renderer) {
    baseMaterial.onBeforeCompile.call(this, shaderInfo, renderer);
    const cacheKey2 = this.customProgramCacheKey() + "|" + shaderInfo.vertexShader + "|" + shaderInfo.fragmentShader;
    let upgradedShaders = SHADER_UPGRADE_CACHE[cacheKey2];
    if (!upgradedShaders) {
      const upgraded = upgradeShaders(this, shaderInfo, options, optionsKey);
      upgradedShaders = SHADER_UPGRADE_CACHE[cacheKey2] = upgraded;
    }
    shaderInfo.vertexShader = upgradedShaders.vertexShader;
    shaderInfo.fragmentShader = upgradedShaders.fragmentShader;
    assign$2(shaderInfo.uniforms, this.uniforms);
    if (options.timeUniform) {
      shaderInfo.uniforms[options.timeUniform] = {
        get value() {
          return Date.now() - epoch;
        }
      };
    }
    if (this[privateBeforeCompileProp]) {
      this[privateBeforeCompileProp](shaderInfo);
    }
  };
  const DerivedMaterial = function DerivedMaterial2() {
    return derive(options.chained ? baseMaterial : baseMaterial.clone());
  };
  const derive = function(base) {
    const derived = Object.create(base, descriptor);
    Object.defineProperty(derived, "baseMaterial", { value: baseMaterial });
    Object.defineProperty(derived, "id", { value: materialInstanceId++ });
    derived.uuid = generateUUID();
    derived.uniforms = assign$2({}, base.uniforms, options.uniforms);
    derived.defines = assign$2({}, base.defines, options.defines);
    derived.defines[`TROIKA_DERIVED_MATERIAL_${optionsKey}`] = "";
    derived.extensions = assign$2({}, base.extensions, options.extensions);
    derived._listeners = void 0;
    return derived;
  };
  const descriptor = {
    constructor: { value: DerivedMaterial },
    isDerivedMaterial: { value: true },
    type: {
      get: () => baseMaterial.type,
      set: (value) => {
        baseMaterial.type = value;
      }
    },
    isDerivedFrom: {
      writable: true,
      configurable: true,
      value: function(testMaterial) {
        const base = this.baseMaterial;
        return testMaterial === base || base.isDerivedMaterial && base.isDerivedFrom(testMaterial) || false;
      }
    },
    customProgramCacheKey: {
      writable: true,
      configurable: true,
      value: function() {
        return baseMaterial.customProgramCacheKey() + "|" + optionsKey;
      }
    },
    onBeforeCompile: {
      get() {
        return onBeforeCompile;
      },
      set(fn) {
        this[privateBeforeCompileProp] = fn;
      }
    },
    copy: {
      writable: true,
      configurable: true,
      value: function(source) {
        baseMaterial.copy.call(this, source);
        if (!baseMaterial.isShaderMaterial && !baseMaterial.isDerivedMaterial) {
          assign$2(this.extensions, source.extensions);
          assign$2(this.defines, source.defines);
          assign$2(this.uniforms, UniformsUtils.clone(source.uniforms));
        }
        return this;
      }
    },
    clone: {
      writable: true,
      configurable: true,
      value: function() {
        const newBase = new baseMaterial.constructor();
        return derive(newBase).copy(this);
      }
    },
    /**
     * Utility to get a MeshDepthMaterial that will honor this derived material's vertex
     * transformations and discarded fragments.
     */
    getDepthMaterial: {
      writable: true,
      configurable: true,
      value: function() {
        let depthMaterial = this._depthMaterial;
        if (!depthMaterial) {
          depthMaterial = this._depthMaterial = createDerivedMaterial(
            baseMaterial.isDerivedMaterial ? baseMaterial.getDepthMaterial() : new MeshDepthMaterial({ depthPacking: RGBADepthPacking }),
            options
          );
          depthMaterial.defines.IS_DEPTH_MATERIAL = "";
          depthMaterial.uniforms = this.uniforms;
        }
        return depthMaterial;
      }
    },
    /**
     * Utility to get a MeshDistanceMaterial that will honor this derived material's vertex
     * transformations and discarded fragments.
     */
    getDistanceMaterial: {
      writable: true,
      configurable: true,
      value: function() {
        let distanceMaterial = this._distanceMaterial;
        if (!distanceMaterial) {
          distanceMaterial = this._distanceMaterial = createDerivedMaterial(
            baseMaterial.isDerivedMaterial ? baseMaterial.getDistanceMaterial() : new MeshDistanceMaterial(),
            options
          );
          distanceMaterial.defines.IS_DISTANCE_MATERIAL = "";
          distanceMaterial.uniforms = this.uniforms;
        }
        return distanceMaterial;
      }
    },
    dispose: {
      writable: true,
      configurable: true,
      value() {
        const { _depthMaterial, _distanceMaterial } = this;
        if (_depthMaterial) _depthMaterial.dispose();
        if (_distanceMaterial) _distanceMaterial.dispose();
        baseMaterial.dispose.call(this);
      }
    }
  };
  ctorsByDerivation[optionsKey] = DerivedMaterial;
  return new DerivedMaterial();
}
function upgradeShaders(material, { vertexShader: vertexShader2, fragmentShader: fragmentShader2 }, options, key) {
  let {
    vertexDefs,
    vertexMainIntro,
    vertexMainOutro,
    vertexTransform,
    fragmentDefs,
    fragmentMainIntro,
    fragmentMainOutro,
    fragmentColorTransform,
    customRewriter,
    timeUniform
  } = options;
  vertexDefs = vertexDefs || "";
  vertexMainIntro = vertexMainIntro || "";
  vertexMainOutro = vertexMainOutro || "";
  fragmentDefs = fragmentDefs || "";
  fragmentMainIntro = fragmentMainIntro || "";
  fragmentMainOutro = fragmentMainOutro || "";
  if (vertexTransform || customRewriter) {
    vertexShader2 = expandShaderIncludes(vertexShader2);
  }
  if (fragmentColorTransform || customRewriter) {
    fragmentShader2 = fragmentShader2.replace(
      /^[ \t]*#include <((?:tonemapping|encodings|colorspace|fog|premultiplied_alpha|dithering)_fragment)>/gm,
      "\n//!BEGIN_POST_CHUNK $1\n$&\n//!END_POST_CHUNK\n"
    );
    fragmentShader2 = expandShaderIncludes(fragmentShader2);
  }
  if (customRewriter) {
    let res = customRewriter({ vertexShader: vertexShader2, fragmentShader: fragmentShader2 });
    vertexShader2 = res.vertexShader;
    fragmentShader2 = res.fragmentShader;
  }
  if (fragmentColorTransform) {
    let postChunks = [];
    fragmentShader2 = fragmentShader2.replace(
      /^\/\/!BEGIN_POST_CHUNK[^]+?^\/\/!END_POST_CHUNK/gm,
      // [^]+? = non-greedy match of any chars including newlines
      (match) => {
        postChunks.push(match);
        return "";
      }
    );
    fragmentMainOutro = `${fragmentColorTransform}
${postChunks.join("\n")}
${fragmentMainOutro}`;
  }
  if (timeUniform) {
    const code = `
uniform float ${timeUniform};
`;
    vertexDefs = code + vertexDefs;
    fragmentDefs = code + fragmentDefs;
  }
  if (vertexTransform) {
    vertexShader2 = `vec3 troika_position_${key};
vec3 troika_normal_${key};
vec2 troika_uv_${key};
${vertexShader2}
`;
    vertexDefs = `${vertexDefs}
void troikaVertexTransform${key}(inout vec3 position, inout vec3 normal, inout vec2 uv) {
  ${vertexTransform}
}
`;
    vertexMainIntro = `
troika_position_${key} = vec3(position);
troika_normal_${key} = vec3(normal);
troika_uv_${key} = vec2(uv);
troikaVertexTransform${key}(troika_position_${key}, troika_normal_${key}, troika_uv_${key});
${vertexMainIntro}
`;
    vertexShader2 = vertexShader2.replace(/\b(position|normal|uv)\b/g, (match, match1, index, fullStr) => {
      return /\battribute\s+vec[23]\s+$/.test(fullStr.substr(0, index)) ? match1 : `troika_${match1}_${key}`;
    });
    if (!(material.map && material.map.channel > 0)) {
      vertexShader2 = vertexShader2.replace(/\bMAP_UV\b/g, `troika_uv_${key}`);
    }
  }
  vertexShader2 = injectIntoShaderCode(vertexShader2, key, vertexDefs, vertexMainIntro, vertexMainOutro);
  fragmentShader2 = injectIntoShaderCode(fragmentShader2, key, fragmentDefs, fragmentMainIntro, fragmentMainOutro);
  return {
    vertexShader: vertexShader2,
    fragmentShader: fragmentShader2
  };
}
function injectIntoShaderCode(shaderCode, id, defs, intro, outro) {
  if (intro || outro || defs) {
    shaderCode = shaderCode.replace(
      voidMainRegExp,
      `
${defs}
void troikaOrigMain${id}() {`
    );
    shaderCode += `
void main() {
  ${intro}
  troikaOrigMain${id}();
  ${outro}
}`;
  }
  return shaderCode;
}
function optionsJsonReplacer(key, value) {
  return key === "uniforms" ? void 0 : typeof value === "function" ? value.toString() : value;
}
let _idCtr = 0;
const optionsHashesToIds = /* @__PURE__ */ new Map();
function getKeyForOptions(options) {
  const optionsHash = JSON.stringify(options, optionsJsonReplacer);
  let id = optionsHashesToIds.get(optionsHash);
  if (id == null) {
    optionsHashesToIds.set(optionsHash, id = ++_idCtr);
  }
  return id;
}
function typrFactory() {
  return "undefined" == typeof window && (self.window = self), (function(r3) {
    var e2 = { parse: function(r4) {
      var t3 = e2._bin, a6 = new Uint8Array(r4);
      if ("ttcf" == t3.readASCII(a6, 0, 4)) {
        var n2 = 4;
        t3.readUshort(a6, n2), n2 += 2, t3.readUshort(a6, n2), n2 += 2;
        var o2 = t3.readUint(a6, n2);
        n2 += 4;
        for (var s2 = [], i2 = 0; i2 < o2; i2++) {
          var h2 = t3.readUint(a6, n2);
          n2 += 4, s2.push(e2._readFont(a6, h2));
        }
        return s2;
      }
      return [e2._readFont(a6, 0)];
    }, _readFont: function(r4, t3) {
      var a6 = e2._bin, n2 = t3;
      a6.readFixed(r4, t3), t3 += 4;
      var o2 = a6.readUshort(r4, t3);
      t3 += 2, a6.readUshort(r4, t3), t3 += 2, a6.readUshort(r4, t3), t3 += 2, a6.readUshort(r4, t3), t3 += 2;
      for (var s2 = ["cmap", "head", "hhea", "maxp", "hmtx", "name", "OS/2", "post", "loca", "glyf", "kern", "CFF ", "GDEF", "GPOS", "GSUB", "SVG "], i2 = { _data: r4, _offset: n2 }, h2 = {}, d3 = 0; d3 < o2; d3++) {
        var f2 = a6.readASCII(r4, t3, 4);
        t3 += 4, a6.readUint(r4, t3), t3 += 4;
        var u2 = a6.readUint(r4, t3);
        t3 += 4;
        var l2 = a6.readUint(r4, t3);
        t3 += 4, h2[f2] = { offset: u2, length: l2 };
      }
      for (d3 = 0; d3 < s2.length; d3++) {
        var v3 = s2[d3];
        h2[v3] && (i2[v3.trim()] = e2[v3.trim()].parse(r4, h2[v3].offset, h2[v3].length, i2));
      }
      return i2;
    }, _tabOffset: function(r4, t3, a6) {
      for (var n2 = e2._bin, o2 = n2.readUshort(r4, a6 + 4), s2 = a6 + 12, i2 = 0; i2 < o2; i2++) {
        var h2 = n2.readASCII(r4, s2, 4);
        s2 += 4, n2.readUint(r4, s2), s2 += 4;
        var d3 = n2.readUint(r4, s2);
        if (s2 += 4, n2.readUint(r4, s2), s2 += 4, h2 == t3) return d3;
      }
      return 0;
    } };
    e2._bin = { readFixed: function(r4, e3) {
      return (r4[e3] << 8 | r4[e3 + 1]) + (r4[e3 + 2] << 8 | r4[e3 + 3]) / 65540;
    }, readF2dot14: function(r4, t3) {
      return e2._bin.readShort(r4, t3) / 16384;
    }, readInt: function(r4, t3) {
      return e2._bin._view(r4).getInt32(t3);
    }, readInt8: function(r4, t3) {
      return e2._bin._view(r4).getInt8(t3);
    }, readShort: function(r4, t3) {
      return e2._bin._view(r4).getInt16(t3);
    }, readUshort: function(r4, t3) {
      return e2._bin._view(r4).getUint16(t3);
    }, readUshorts: function(r4, t3, a6) {
      for (var n2 = [], o2 = 0; o2 < a6; o2++) n2.push(e2._bin.readUshort(r4, t3 + 2 * o2));
      return n2;
    }, readUint: function(r4, t3) {
      return e2._bin._view(r4).getUint32(t3);
    }, readUint64: function(r4, t3) {
      return 4294967296 * e2._bin.readUint(r4, t3) + e2._bin.readUint(r4, t3 + 4);
    }, readASCII: function(r4, e3, t3) {
      for (var a6 = "", n2 = 0; n2 < t3; n2++) a6 += String.fromCharCode(r4[e3 + n2]);
      return a6;
    }, readUnicode: function(r4, e3, t3) {
      for (var a6 = "", n2 = 0; n2 < t3; n2++) {
        var o2 = r4[e3++] << 8 | r4[e3++];
        a6 += String.fromCharCode(o2);
      }
      return a6;
    }, _tdec: "undefined" != typeof window && window.TextDecoder ? new window.TextDecoder() : null, readUTF8: function(r4, t3, a6) {
      var n2 = e2._bin._tdec;
      return n2 && 0 == t3 && a6 == r4.length ? n2.decode(r4) : e2._bin.readASCII(r4, t3, a6);
    }, readBytes: function(r4, e3, t3) {
      for (var a6 = [], n2 = 0; n2 < t3; n2++) a6.push(r4[e3 + n2]);
      return a6;
    }, readASCIIArray: function(r4, e3, t3) {
      for (var a6 = [], n2 = 0; n2 < t3; n2++) a6.push(String.fromCharCode(r4[e3 + n2]));
      return a6;
    }, _view: function(r4) {
      return r4._dataView || (r4._dataView = r4.buffer ? new DataView(r4.buffer, r4.byteOffset, r4.byteLength) : new DataView(new Uint8Array(r4).buffer));
    } }, e2._lctf = {}, e2._lctf.parse = function(r4, t3, a6, n2, o2) {
      var s2 = e2._bin, i2 = {}, h2 = t3;
      s2.readFixed(r4, t3), t3 += 4;
      var d3 = s2.readUshort(r4, t3);
      t3 += 2;
      var f2 = s2.readUshort(r4, t3);
      t3 += 2;
      var u2 = s2.readUshort(r4, t3);
      return t3 += 2, i2.scriptList = e2._lctf.readScriptList(r4, h2 + d3), i2.featureList = e2._lctf.readFeatureList(r4, h2 + f2), i2.lookupList = e2._lctf.readLookupList(r4, h2 + u2, o2), i2;
    }, e2._lctf.readLookupList = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = t3, s2 = [], i2 = n2.readUshort(r4, t3);
      t3 += 2;
      for (var h2 = 0; h2 < i2; h2++) {
        var d3 = n2.readUshort(r4, t3);
        t3 += 2;
        var f2 = e2._lctf.readLookupTable(r4, o2 + d3, a6);
        s2.push(f2);
      }
      return s2;
    }, e2._lctf.readLookupTable = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = t3, s2 = { tabs: [] };
      s2.ltype = n2.readUshort(r4, t3), t3 += 2, s2.flag = n2.readUshort(r4, t3), t3 += 2;
      var i2 = n2.readUshort(r4, t3);
      t3 += 2;
      for (var h2 = s2.ltype, d3 = 0; d3 < i2; d3++) {
        var f2 = n2.readUshort(r4, t3);
        t3 += 2;
        var u2 = a6(r4, h2, o2 + f2, s2);
        s2.tabs.push(u2);
      }
      return s2;
    }, e2._lctf.numOfOnes = function(r4) {
      for (var e3 = 0, t3 = 0; t3 < 32; t3++) 0 != (r4 >>> t3 & 1) && e3++;
      return e3;
    }, e2._lctf.readClassDef = function(r4, t3) {
      var a6 = e2._bin, n2 = [], o2 = a6.readUshort(r4, t3);
      if (t3 += 2, 1 == o2) {
        var s2 = a6.readUshort(r4, t3);
        t3 += 2;
        var i2 = a6.readUshort(r4, t3);
        t3 += 2;
        for (var h2 = 0; h2 < i2; h2++) n2.push(s2 + h2), n2.push(s2 + h2), n2.push(a6.readUshort(r4, t3)), t3 += 2;
      }
      if (2 == o2) {
        var d3 = a6.readUshort(r4, t3);
        t3 += 2;
        for (h2 = 0; h2 < d3; h2++) n2.push(a6.readUshort(r4, t3)), t3 += 2, n2.push(a6.readUshort(r4, t3)), t3 += 2, n2.push(a6.readUshort(r4, t3)), t3 += 2;
      }
      return n2;
    }, e2._lctf.getInterval = function(r4, e3) {
      for (var t3 = 0; t3 < r4.length; t3 += 3) {
        var a6 = r4[t3], n2 = r4[t3 + 1];
        if (r4[t3 + 2], a6 <= e3 && e3 <= n2) return t3;
      }
      return -1;
    }, e2._lctf.readCoverage = function(r4, t3) {
      var a6 = e2._bin, n2 = {};
      n2.fmt = a6.readUshort(r4, t3), t3 += 2;
      var o2 = a6.readUshort(r4, t3);
      return t3 += 2, 1 == n2.fmt && (n2.tab = a6.readUshorts(r4, t3, o2)), 2 == n2.fmt && (n2.tab = a6.readUshorts(r4, t3, 3 * o2)), n2;
    }, e2._lctf.coverageIndex = function(r4, t3) {
      var a6 = r4.tab;
      if (1 == r4.fmt) return a6.indexOf(t3);
      if (2 == r4.fmt) {
        var n2 = e2._lctf.getInterval(a6, t3);
        if (-1 != n2) return a6[n2 + 2] + (t3 - a6[n2]);
      }
      return -1;
    }, e2._lctf.readFeatureList = function(r4, t3) {
      var a6 = e2._bin, n2 = t3, o2 = [], s2 = a6.readUshort(r4, t3);
      t3 += 2;
      for (var i2 = 0; i2 < s2; i2++) {
        var h2 = a6.readASCII(r4, t3, 4);
        t3 += 4;
        var d3 = a6.readUshort(r4, t3);
        t3 += 2;
        var f2 = e2._lctf.readFeatureTable(r4, n2 + d3);
        f2.tag = h2.trim(), o2.push(f2);
      }
      return o2;
    }, e2._lctf.readFeatureTable = function(r4, t3) {
      var a6 = e2._bin, n2 = t3, o2 = {}, s2 = a6.readUshort(r4, t3);
      t3 += 2, s2 > 0 && (o2.featureParams = n2 + s2);
      var i2 = a6.readUshort(r4, t3);
      t3 += 2, o2.tab = [];
      for (var h2 = 0; h2 < i2; h2++) o2.tab.push(a6.readUshort(r4, t3 + 2 * h2));
      return o2;
    }, e2._lctf.readScriptList = function(r4, t3) {
      var a6 = e2._bin, n2 = t3, o2 = {}, s2 = a6.readUshort(r4, t3);
      t3 += 2;
      for (var i2 = 0; i2 < s2; i2++) {
        var h2 = a6.readASCII(r4, t3, 4);
        t3 += 4;
        var d3 = a6.readUshort(r4, t3);
        t3 += 2, o2[h2.trim()] = e2._lctf.readScriptTable(r4, n2 + d3);
      }
      return o2;
    }, e2._lctf.readScriptTable = function(r4, t3) {
      var a6 = e2._bin, n2 = t3, o2 = {}, s2 = a6.readUshort(r4, t3);
      t3 += 2, s2 > 0 && (o2.default = e2._lctf.readLangSysTable(r4, n2 + s2));
      var i2 = a6.readUshort(r4, t3);
      t3 += 2;
      for (var h2 = 0; h2 < i2; h2++) {
        var d3 = a6.readASCII(r4, t3, 4);
        t3 += 4;
        var f2 = a6.readUshort(r4, t3);
        t3 += 2, o2[d3.trim()] = e2._lctf.readLangSysTable(r4, n2 + f2);
      }
      return o2;
    }, e2._lctf.readLangSysTable = function(r4, t3) {
      var a6 = e2._bin, n2 = {};
      a6.readUshort(r4, t3), t3 += 2, n2.reqFeature = a6.readUshort(r4, t3), t3 += 2;
      var o2 = a6.readUshort(r4, t3);
      return t3 += 2, n2.features = a6.readUshorts(r4, t3, o2), n2;
    }, e2.CFF = {}, e2.CFF.parse = function(r4, t3, a6) {
      var n2 = e2._bin;
      (r4 = new Uint8Array(r4.buffer, t3, a6))[t3 = 0], r4[++t3], r4[++t3], r4[++t3], t3++;
      var o2 = [];
      t3 = e2.CFF.readIndex(r4, t3, o2);
      for (var s2 = [], i2 = 0; i2 < o2.length - 1; i2++) s2.push(n2.readASCII(r4, t3 + o2[i2], o2[i2 + 1] - o2[i2]));
      t3 += o2[o2.length - 1];
      var h2 = [];
      t3 = e2.CFF.readIndex(r4, t3, h2);
      var d3 = [];
      for (i2 = 0; i2 < h2.length - 1; i2++) d3.push(e2.CFF.readDict(r4, t3 + h2[i2], t3 + h2[i2 + 1]));
      t3 += h2[h2.length - 1];
      var f2 = d3[0], u2 = [];
      t3 = e2.CFF.readIndex(r4, t3, u2);
      var l2 = [];
      for (i2 = 0; i2 < u2.length - 1; i2++) l2.push(n2.readASCII(r4, t3 + u2[i2], u2[i2 + 1] - u2[i2]));
      if (t3 += u2[u2.length - 1], e2.CFF.readSubrs(r4, t3, f2), f2.CharStrings) {
        t3 = f2.CharStrings;
        u2 = [];
        t3 = e2.CFF.readIndex(r4, t3, u2);
        var v3 = [];
        for (i2 = 0; i2 < u2.length - 1; i2++) v3.push(n2.readBytes(r4, t3 + u2[i2], u2[i2 + 1] - u2[i2]));
        f2.CharStrings = v3;
      }
      if (f2.ROS) {
        t3 = f2.FDArray;
        var c2 = [];
        t3 = e2.CFF.readIndex(r4, t3, c2), f2.FDArray = [];
        for (i2 = 0; i2 < c2.length - 1; i2++) {
          var p3 = e2.CFF.readDict(r4, t3 + c2[i2], t3 + c2[i2 + 1]);
          e2.CFF._readFDict(r4, p3, l2), f2.FDArray.push(p3);
        }
        t3 += c2[c2.length - 1], t3 = f2.FDSelect, f2.FDSelect = [];
        var U2 = r4[t3];
        if (t3++, 3 != U2) throw U2;
        var g2 = n2.readUshort(r4, t3);
        t3 += 2;
        for (i2 = 0; i2 < g2 + 1; i2++) f2.FDSelect.push(n2.readUshort(r4, t3), r4[t3 + 2]), t3 += 3;
      }
      return f2.Encoding && (f2.Encoding = e2.CFF.readEncoding(r4, f2.Encoding, f2.CharStrings.length)), f2.charset && (f2.charset = e2.CFF.readCharset(r4, f2.charset, f2.CharStrings.length)), e2.CFF._readFDict(r4, f2, l2), f2;
    }, e2.CFF._readFDict = function(r4, t3, a6) {
      var n2;
      for (var o2 in t3.Private && (n2 = t3.Private[1], t3.Private = e2.CFF.readDict(r4, n2, n2 + t3.Private[0]), t3.Private.Subrs && e2.CFF.readSubrs(r4, n2 + t3.Private.Subrs, t3.Private)), t3) -1 != ["FamilyName", "FontName", "FullName", "Notice", "version", "Copyright"].indexOf(o2) && (t3[o2] = a6[t3[o2] - 426 + 35]);
    }, e2.CFF.readSubrs = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = [];
      t3 = e2.CFF.readIndex(r4, t3, o2);
      var s2, i2 = o2.length;
      s2 = i2 < 1240 ? 107 : i2 < 33900 ? 1131 : 32768, a6.Bias = s2, a6.Subrs = [];
      for (var h2 = 0; h2 < o2.length - 1; h2++) a6.Subrs.push(n2.readBytes(r4, t3 + o2[h2], o2[h2 + 1] - o2[h2]));
    }, e2.CFF.tableSE = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 0, 111, 112, 113, 114, 0, 115, 116, 117, 118, 119, 120, 121, 122, 0, 123, 0, 124, 125, 126, 127, 128, 129, 130, 131, 0, 132, 133, 0, 134, 135, 136, 137, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 138, 0, 139, 0, 0, 0, 0, 140, 141, 142, 143, 0, 0, 0, 0, 0, 144, 0, 0, 0, 145, 0, 0, 146, 147, 148, 149, 0, 0, 0, 0], e2.CFF.glyphByUnicode = function(r4, e3) {
      for (var t3 = 0; t3 < r4.charset.length; t3++) if (r4.charset[t3] == e3) return t3;
      return -1;
    }, e2.CFF.glyphBySE = function(r4, t3) {
      return t3 < 0 || t3 > 255 ? -1 : e2.CFF.glyphByUnicode(r4, e2.CFF.tableSE[t3]);
    }, e2.CFF.readEncoding = function(r4, t3, a6) {
      e2._bin;
      var n2 = [".notdef"], o2 = r4[t3];
      if (t3++, 0 != o2) throw "error: unknown encoding format: " + o2;
      var s2 = r4[t3];
      t3++;
      for (var i2 = 0; i2 < s2; i2++) n2.push(r4[t3 + i2]);
      return n2;
    }, e2.CFF.readCharset = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = [".notdef"], s2 = r4[t3];
      if (t3++, 0 == s2) for (var i2 = 0; i2 < a6; i2++) {
        var h2 = n2.readUshort(r4, t3);
        t3 += 2, o2.push(h2);
      }
      else {
        if (1 != s2 && 2 != s2) throw "error: format: " + s2;
        for (; o2.length < a6; ) {
          h2 = n2.readUshort(r4, t3);
          t3 += 2;
          var d3 = 0;
          1 == s2 ? (d3 = r4[t3], t3++) : (d3 = n2.readUshort(r4, t3), t3 += 2);
          for (i2 = 0; i2 <= d3; i2++) o2.push(h2), h2++;
        }
      }
      return o2;
    }, e2.CFF.readIndex = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = n2.readUshort(r4, t3) + 1, s2 = r4[t3 += 2];
      if (t3++, 1 == s2) for (var i2 = 0; i2 < o2; i2++) a6.push(r4[t3 + i2]);
      else if (2 == s2) for (i2 = 0; i2 < o2; i2++) a6.push(n2.readUshort(r4, t3 + 2 * i2));
      else if (3 == s2) for (i2 = 0; i2 < o2; i2++) a6.push(16777215 & n2.readUint(r4, t3 + 3 * i2 - 1));
      else if (1 != o2) throw "unsupported offset size: " + s2 + ", count: " + o2;
      return (t3 += o2 * s2) - 1;
    }, e2.CFF.getCharString = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = r4[t3], s2 = r4[t3 + 1];
      r4[t3 + 2], r4[t3 + 3], r4[t3 + 4];
      var i2 = 1, h2 = null, d3 = null;
      o2 <= 20 && (h2 = o2, i2 = 1), 12 == o2 && (h2 = 100 * o2 + s2, i2 = 2), 21 <= o2 && o2 <= 27 && (h2 = o2, i2 = 1), 28 == o2 && (d3 = n2.readShort(r4, t3 + 1), i2 = 3), 29 <= o2 && o2 <= 31 && (h2 = o2, i2 = 1), 32 <= o2 && o2 <= 246 && (d3 = o2 - 139, i2 = 1), 247 <= o2 && o2 <= 250 && (d3 = 256 * (o2 - 247) + s2 + 108, i2 = 2), 251 <= o2 && o2 <= 254 && (d3 = 256 * -(o2 - 251) - s2 - 108, i2 = 2), 255 == o2 && (d3 = n2.readInt(r4, t3 + 1) / 65535, i2 = 5), a6.val = null != d3 ? d3 : "o" + h2, a6.size = i2;
    }, e2.CFF.readCharString = function(r4, t3, a6) {
      for (var n2 = t3 + a6, o2 = e2._bin, s2 = []; t3 < n2; ) {
        var i2 = r4[t3], h2 = r4[t3 + 1];
        r4[t3 + 2], r4[t3 + 3], r4[t3 + 4];
        var d3 = 1, f2 = null, u2 = null;
        i2 <= 20 && (f2 = i2, d3 = 1), 12 == i2 && (f2 = 100 * i2 + h2, d3 = 2), 19 != i2 && 20 != i2 || (f2 = i2, d3 = 2), 21 <= i2 && i2 <= 27 && (f2 = i2, d3 = 1), 28 == i2 && (u2 = o2.readShort(r4, t3 + 1), d3 = 3), 29 <= i2 && i2 <= 31 && (f2 = i2, d3 = 1), 32 <= i2 && i2 <= 246 && (u2 = i2 - 139, d3 = 1), 247 <= i2 && i2 <= 250 && (u2 = 256 * (i2 - 247) + h2 + 108, d3 = 2), 251 <= i2 && i2 <= 254 && (u2 = 256 * -(i2 - 251) - h2 - 108, d3 = 2), 255 == i2 && (u2 = o2.readInt(r4, t3 + 1) / 65535, d3 = 5), s2.push(null != u2 ? u2 : "o" + f2), t3 += d3;
      }
      return s2;
    }, e2.CFF.readDict = function(r4, t3, a6) {
      for (var n2 = e2._bin, o2 = {}, s2 = []; t3 < a6; ) {
        var i2 = r4[t3], h2 = r4[t3 + 1];
        r4[t3 + 2], r4[t3 + 3], r4[t3 + 4];
        var d3 = 1, f2 = null, u2 = null;
        if (28 == i2 && (u2 = n2.readShort(r4, t3 + 1), d3 = 3), 29 == i2 && (u2 = n2.readInt(r4, t3 + 1), d3 = 5), 32 <= i2 && i2 <= 246 && (u2 = i2 - 139, d3 = 1), 247 <= i2 && i2 <= 250 && (u2 = 256 * (i2 - 247) + h2 + 108, d3 = 2), 251 <= i2 && i2 <= 254 && (u2 = 256 * -(i2 - 251) - h2 - 108, d3 = 2), 255 == i2) throw u2 = n2.readInt(r4, t3 + 1) / 65535, d3 = 5, "unknown number";
        if (30 == i2) {
          var l2 = [];
          for (d3 = 1; ; ) {
            var v3 = r4[t3 + d3];
            d3++;
            var c2 = v3 >> 4, p3 = 15 & v3;
            if (15 != c2 && l2.push(c2), 15 != p3 && l2.push(p3), 15 == p3) break;
          }
          for (var U2 = "", g2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, ".", "e", "e-", "reserved", "-", "endOfNumber"], S2 = 0; S2 < l2.length; S2++) U2 += g2[l2[S2]];
          u2 = parseFloat(U2);
        }
        if (i2 <= 21) {
          if (f2 = ["version", "Notice", "FullName", "FamilyName", "Weight", "FontBBox", "BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StdHW", "StdVW", "escape", "UniqueID", "XUID", "charset", "Encoding", "CharStrings", "Private", "Subrs", "defaultWidthX", "nominalWidthX"][i2], d3 = 1, 12 == i2) f2 = ["Copyright", "isFixedPitch", "ItalicAngle", "UnderlinePosition", "UnderlineThickness", "PaintType", "CharstringType", "FontMatrix", "StrokeWidth", "BlueScale", "BlueShift", "BlueFuzz", "StemSnapH", "StemSnapV", "ForceBold", 0, 0, "LanguageGroup", "ExpansionFactor", "initialRandomSeed", "SyntheticBase", "PostScript", "BaseFontName", "BaseFontBlend", 0, 0, 0, 0, 0, 0, "ROS", "CIDFontVersion", "CIDFontRevision", "CIDFontType", "CIDCount", "UIDBase", "FDArray", "FDSelect", "FontName"][h2], d3 = 2;
        }
        null != f2 ? (o2[f2] = 1 == s2.length ? s2[0] : s2, s2 = []) : s2.push(u2), t3 += d3;
      }
      return o2;
    }, e2.cmap = {}, e2.cmap.parse = function(r4, t3, a6) {
      r4 = new Uint8Array(r4.buffer, t3, a6), t3 = 0;
      var n2 = e2._bin, o2 = {};
      n2.readUshort(r4, t3), t3 += 2;
      var s2 = n2.readUshort(r4, t3);
      t3 += 2;
      var i2 = [];
      o2.tables = [];
      for (var h2 = 0; h2 < s2; h2++) {
        var d3 = n2.readUshort(r4, t3);
        t3 += 2;
        var f2 = n2.readUshort(r4, t3);
        t3 += 2;
        var u2 = n2.readUint(r4, t3);
        t3 += 4;
        var l2 = "p" + d3 + "e" + f2, v3 = i2.indexOf(u2);
        if (-1 == v3) {
          var c2;
          v3 = o2.tables.length, i2.push(u2);
          var p3 = n2.readUshort(r4, u2);
          0 == p3 ? c2 = e2.cmap.parse0(r4, u2) : 4 == p3 ? c2 = e2.cmap.parse4(r4, u2) : 6 == p3 ? c2 = e2.cmap.parse6(r4, u2) : 12 == p3 ? c2 = e2.cmap.parse12(r4, u2) : console.debug("unknown format: " + p3, d3, f2, u2), o2.tables.push(c2);
        }
        if (null != o2[l2]) throw "multiple tables for one platform+encoding";
        o2[l2] = v3;
      }
      return o2;
    }, e2.cmap.parse0 = function(r4, t3) {
      var a6 = e2._bin, n2 = {};
      n2.format = a6.readUshort(r4, t3), t3 += 2;
      var o2 = a6.readUshort(r4, t3);
      t3 += 2, a6.readUshort(r4, t3), t3 += 2, n2.map = [];
      for (var s2 = 0; s2 < o2 - 6; s2++) n2.map.push(r4[t3 + s2]);
      return n2;
    }, e2.cmap.parse4 = function(r4, t3) {
      var a6 = e2._bin, n2 = t3, o2 = {};
      o2.format = a6.readUshort(r4, t3), t3 += 2;
      var s2 = a6.readUshort(r4, t3);
      t3 += 2, a6.readUshort(r4, t3), t3 += 2;
      var i2 = a6.readUshort(r4, t3);
      t3 += 2;
      var h2 = i2 / 2;
      o2.searchRange = a6.readUshort(r4, t3), t3 += 2, o2.entrySelector = a6.readUshort(r4, t3), t3 += 2, o2.rangeShift = a6.readUshort(r4, t3), t3 += 2, o2.endCount = a6.readUshorts(r4, t3, h2), t3 += 2 * h2, t3 += 2, o2.startCount = a6.readUshorts(r4, t3, h2), t3 += 2 * h2, o2.idDelta = [];
      for (var d3 = 0; d3 < h2; d3++) o2.idDelta.push(a6.readShort(r4, t3)), t3 += 2;
      for (o2.idRangeOffset = a6.readUshorts(r4, t3, h2), t3 += 2 * h2, o2.glyphIdArray = []; t3 < n2 + s2; ) o2.glyphIdArray.push(a6.readUshort(r4, t3)), t3 += 2;
      return o2;
    }, e2.cmap.parse6 = function(r4, t3) {
      var a6 = e2._bin, n2 = {};
      n2.format = a6.readUshort(r4, t3), t3 += 2, a6.readUshort(r4, t3), t3 += 2, a6.readUshort(r4, t3), t3 += 2, n2.firstCode = a6.readUshort(r4, t3), t3 += 2;
      var o2 = a6.readUshort(r4, t3);
      t3 += 2, n2.glyphIdArray = [];
      for (var s2 = 0; s2 < o2; s2++) n2.glyphIdArray.push(a6.readUshort(r4, t3)), t3 += 2;
      return n2;
    }, e2.cmap.parse12 = function(r4, t3) {
      var a6 = e2._bin, n2 = {};
      n2.format = a6.readUshort(r4, t3), t3 += 2, t3 += 2, a6.readUint(r4, t3), t3 += 4, a6.readUint(r4, t3), t3 += 4;
      var o2 = a6.readUint(r4, t3);
      t3 += 4, n2.groups = [];
      for (var s2 = 0; s2 < o2; s2++) {
        var i2 = t3 + 12 * s2, h2 = a6.readUint(r4, i2 + 0), d3 = a6.readUint(r4, i2 + 4), f2 = a6.readUint(r4, i2 + 8);
        n2.groups.push([h2, d3, f2]);
      }
      return n2;
    }, e2.glyf = {}, e2.glyf.parse = function(r4, e3, t3, a6) {
      for (var n2 = [], o2 = 0; o2 < a6.maxp.numGlyphs; o2++) n2.push(null);
      return n2;
    }, e2.glyf._parseGlyf = function(r4, t3) {
      var a6 = e2._bin, n2 = r4._data, o2 = e2._tabOffset(n2, "glyf", r4._offset) + r4.loca[t3];
      if (r4.loca[t3] == r4.loca[t3 + 1]) return null;
      var s2 = {};
      if (s2.noc = a6.readShort(n2, o2), o2 += 2, s2.xMin = a6.readShort(n2, o2), o2 += 2, s2.yMin = a6.readShort(n2, o2), o2 += 2, s2.xMax = a6.readShort(n2, o2), o2 += 2, s2.yMax = a6.readShort(n2, o2), o2 += 2, s2.xMin >= s2.xMax || s2.yMin >= s2.yMax) return null;
      if (s2.noc > 0) {
        s2.endPts = [];
        for (var i2 = 0; i2 < s2.noc; i2++) s2.endPts.push(a6.readUshort(n2, o2)), o2 += 2;
        var h2 = a6.readUshort(n2, o2);
        if (o2 += 2, n2.length - o2 < h2) return null;
        s2.instructions = a6.readBytes(n2, o2, h2), o2 += h2;
        var d3 = s2.endPts[s2.noc - 1] + 1;
        s2.flags = [];
        for (i2 = 0; i2 < d3; i2++) {
          var f2 = n2[o2];
          if (o2++, s2.flags.push(f2), 0 != (8 & f2)) {
            var u2 = n2[o2];
            o2++;
            for (var l2 = 0; l2 < u2; l2++) s2.flags.push(f2), i2++;
          }
        }
        s2.xs = [];
        for (i2 = 0; i2 < d3; i2++) {
          var v3 = 0 != (2 & s2.flags[i2]), c2 = 0 != (16 & s2.flags[i2]);
          v3 ? (s2.xs.push(c2 ? n2[o2] : -n2[o2]), o2++) : c2 ? s2.xs.push(0) : (s2.xs.push(a6.readShort(n2, o2)), o2 += 2);
        }
        s2.ys = [];
        for (i2 = 0; i2 < d3; i2++) {
          v3 = 0 != (4 & s2.flags[i2]), c2 = 0 != (32 & s2.flags[i2]);
          v3 ? (s2.ys.push(c2 ? n2[o2] : -n2[o2]), o2++) : c2 ? s2.ys.push(0) : (s2.ys.push(a6.readShort(n2, o2)), o2 += 2);
        }
        var p3 = 0, U2 = 0;
        for (i2 = 0; i2 < d3; i2++) p3 += s2.xs[i2], U2 += s2.ys[i2], s2.xs[i2] = p3, s2.ys[i2] = U2;
      } else {
        var g2;
        s2.parts = [];
        do {
          g2 = a6.readUshort(n2, o2), o2 += 2;
          var S2 = { m: { a: 1, b: 0, c: 0, d: 1, tx: 0, ty: 0 }, p1: -1, p2: -1 };
          if (s2.parts.push(S2), S2.glyphIndex = a6.readUshort(n2, o2), o2 += 2, 1 & g2) {
            var m2 = a6.readShort(n2, o2);
            o2 += 2;
            var b6 = a6.readShort(n2, o2);
            o2 += 2;
          } else {
            m2 = a6.readInt8(n2, o2);
            o2++;
            b6 = a6.readInt8(n2, o2);
            o2++;
          }
          2 & g2 ? (S2.m.tx = m2, S2.m.ty = b6) : (S2.p1 = m2, S2.p2 = b6), 8 & g2 ? (S2.m.a = S2.m.d = a6.readF2dot14(n2, o2), o2 += 2) : 64 & g2 ? (S2.m.a = a6.readF2dot14(n2, o2), o2 += 2, S2.m.d = a6.readF2dot14(n2, o2), o2 += 2) : 128 & g2 && (S2.m.a = a6.readF2dot14(n2, o2), o2 += 2, S2.m.b = a6.readF2dot14(n2, o2), o2 += 2, S2.m.c = a6.readF2dot14(n2, o2), o2 += 2, S2.m.d = a6.readF2dot14(n2, o2), o2 += 2);
        } while (32 & g2);
        if (256 & g2) {
          var y2 = a6.readUshort(n2, o2);
          o2 += 2, s2.instr = [];
          for (i2 = 0; i2 < y2; i2++) s2.instr.push(n2[o2]), o2++;
        }
      }
      return s2;
    }, e2.GDEF = {}, e2.GDEF.parse = function(r4, t3, a6, n2) {
      var o2 = t3;
      t3 += 4;
      var s2 = e2._bin.readUshort(r4, t3);
      return { glyphClassDef: 0 === s2 ? null : e2._lctf.readClassDef(r4, o2 + s2) };
    }, e2.GPOS = {}, e2.GPOS.parse = function(r4, t3, a6, n2) {
      return e2._lctf.parse(r4, t3, a6, n2, e2.GPOS.subt);
    }, e2.GPOS.subt = function(r4, t3, a6, n2) {
      var o2 = e2._bin, s2 = a6, i2 = {};
      if (i2.fmt = o2.readUshort(r4, a6), a6 += 2, 1 == t3 || 2 == t3 || 3 == t3 || 7 == t3 || 8 == t3 && i2.fmt <= 2) {
        var h2 = o2.readUshort(r4, a6);
        a6 += 2, i2.coverage = e2._lctf.readCoverage(r4, h2 + s2);
      }
      if (1 == t3 && 1 == i2.fmt) {
        var d3 = o2.readUshort(r4, a6);
        a6 += 2, 0 != d3 && (i2.pos = e2.GPOS.readValueRecord(r4, a6, d3));
      } else if (2 == t3 && i2.fmt >= 1 && i2.fmt <= 2) {
        d3 = o2.readUshort(r4, a6);
        a6 += 2;
        var f2 = o2.readUshort(r4, a6);
        a6 += 2;
        var u2 = e2._lctf.numOfOnes(d3), l2 = e2._lctf.numOfOnes(f2);
        if (1 == i2.fmt) {
          i2.pairsets = [];
          var v3 = o2.readUshort(r4, a6);
          a6 += 2;
          for (var c2 = 0; c2 < v3; c2++) {
            var p3 = s2 + o2.readUshort(r4, a6);
            a6 += 2;
            var U2 = o2.readUshort(r4, p3);
            p3 += 2;
            for (var g2 = [], S2 = 0; S2 < U2; S2++) {
              var m2 = o2.readUshort(r4, p3);
              p3 += 2, 0 != d3 && (P3 = e2.GPOS.readValueRecord(r4, p3, d3), p3 += 2 * u2), 0 != f2 && (x3 = e2.GPOS.readValueRecord(r4, p3, f2), p3 += 2 * l2), g2.push({ gid2: m2, val1: P3, val2: x3 });
            }
            i2.pairsets.push(g2);
          }
        }
        if (2 == i2.fmt) {
          var b6 = o2.readUshort(r4, a6);
          a6 += 2;
          var y2 = o2.readUshort(r4, a6);
          a6 += 2;
          var F2 = o2.readUshort(r4, a6);
          a6 += 2;
          var C2 = o2.readUshort(r4, a6);
          a6 += 2, i2.classDef1 = e2._lctf.readClassDef(r4, s2 + b6), i2.classDef2 = e2._lctf.readClassDef(r4, s2 + y2), i2.matrix = [];
          for (c2 = 0; c2 < F2; c2++) {
            var _2 = [];
            for (S2 = 0; S2 < C2; S2++) {
              var P3 = null, x3 = null;
              0 != d3 && (P3 = e2.GPOS.readValueRecord(r4, a6, d3), a6 += 2 * u2), 0 != f2 && (x3 = e2.GPOS.readValueRecord(r4, a6, f2), a6 += 2 * l2), _2.push({ val1: P3, val2: x3 });
            }
            i2.matrix.push(_2);
          }
        }
      } else if (4 == t3 && 1 == i2.fmt) i2.markCoverage = e2._lctf.readCoverage(r4, o2.readUshort(r4, a6) + s2), i2.baseCoverage = e2._lctf.readCoverage(r4, o2.readUshort(r4, a6 + 2) + s2), i2.markClassCount = o2.readUshort(r4, a6 + 4), i2.markArray = e2.GPOS.readMarkArray(r4, o2.readUshort(r4, a6 + 6) + s2), i2.baseArray = e2.GPOS.readBaseArray(r4, o2.readUshort(r4, a6 + 8) + s2, i2.markClassCount);
      else if (6 == t3 && 1 == i2.fmt) i2.mark1Coverage = e2._lctf.readCoverage(r4, o2.readUshort(r4, a6) + s2), i2.mark2Coverage = e2._lctf.readCoverage(r4, o2.readUshort(r4, a6 + 2) + s2), i2.markClassCount = o2.readUshort(r4, a6 + 4), i2.mark1Array = e2.GPOS.readMarkArray(r4, o2.readUshort(r4, a6 + 6) + s2), i2.mark2Array = e2.GPOS.readBaseArray(r4, o2.readUshort(r4, a6 + 8) + s2, i2.markClassCount);
      else {
        if (9 == t3 && 1 == i2.fmt) {
          var I2 = o2.readUshort(r4, a6);
          a6 += 2;
          var w2 = o2.readUint(r4, a6);
          if (a6 += 4, 9 == n2.ltype) n2.ltype = I2;
          else if (n2.ltype != I2) throw "invalid extension substitution";
          return e2.GPOS.subt(r4, n2.ltype, s2 + w2);
        }
        console.debug("unsupported GPOS table LookupType", t3, "format", i2.fmt);
      }
      return i2;
    }, e2.GPOS.readValueRecord = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = [];
      return o2.push(1 & a6 ? n2.readShort(r4, t3) : 0), t3 += 1 & a6 ? 2 : 0, o2.push(2 & a6 ? n2.readShort(r4, t3) : 0), t3 += 2 & a6 ? 2 : 0, o2.push(4 & a6 ? n2.readShort(r4, t3) : 0), t3 += 4 & a6 ? 2 : 0, o2.push(8 & a6 ? n2.readShort(r4, t3) : 0), t3 += 8 & a6 ? 2 : 0, o2;
    }, e2.GPOS.readBaseArray = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = [], s2 = t3, i2 = n2.readUshort(r4, t3);
      t3 += 2;
      for (var h2 = 0; h2 < i2; h2++) {
        for (var d3 = [], f2 = 0; f2 < a6; f2++) d3.push(e2.GPOS.readAnchorRecord(r4, s2 + n2.readUshort(r4, t3))), t3 += 2;
        o2.push(d3);
      }
      return o2;
    }, e2.GPOS.readMarkArray = function(r4, t3) {
      var a6 = e2._bin, n2 = [], o2 = t3, s2 = a6.readUshort(r4, t3);
      t3 += 2;
      for (var i2 = 0; i2 < s2; i2++) {
        var h2 = e2.GPOS.readAnchorRecord(r4, a6.readUshort(r4, t3 + 2) + o2);
        h2.markClass = a6.readUshort(r4, t3), n2.push(h2), t3 += 4;
      }
      return n2;
    }, e2.GPOS.readAnchorRecord = function(r4, t3) {
      var a6 = e2._bin, n2 = {};
      return n2.fmt = a6.readUshort(r4, t3), n2.x = a6.readShort(r4, t3 + 2), n2.y = a6.readShort(r4, t3 + 4), n2;
    }, e2.GSUB = {}, e2.GSUB.parse = function(r4, t3, a6, n2) {
      return e2._lctf.parse(r4, t3, a6, n2, e2.GSUB.subt);
    }, e2.GSUB.subt = function(r4, t3, a6, n2) {
      var o2 = e2._bin, s2 = a6, i2 = {};
      if (i2.fmt = o2.readUshort(r4, a6), a6 += 2, 1 != t3 && 2 != t3 && 4 != t3 && 5 != t3 && 6 != t3) return null;
      if (1 == t3 || 2 == t3 || 4 == t3 || 5 == t3 && i2.fmt <= 2 || 6 == t3 && i2.fmt <= 2) {
        var h2 = o2.readUshort(r4, a6);
        a6 += 2, i2.coverage = e2._lctf.readCoverage(r4, s2 + h2);
      }
      if (1 == t3 && i2.fmt >= 1 && i2.fmt <= 2) {
        if (1 == i2.fmt) i2.delta = o2.readShort(r4, a6), a6 += 2;
        else if (2 == i2.fmt) {
          var d3 = o2.readUshort(r4, a6);
          a6 += 2, i2.newg = o2.readUshorts(r4, a6, d3), a6 += 2 * i2.newg.length;
        }
      } else if (2 == t3 && 1 == i2.fmt) {
        d3 = o2.readUshort(r4, a6);
        a6 += 2, i2.seqs = [];
        for (var f2 = 0; f2 < d3; f2++) {
          var u2 = o2.readUshort(r4, a6) + s2;
          a6 += 2;
          var l2 = o2.readUshort(r4, u2);
          i2.seqs.push(o2.readUshorts(r4, u2 + 2, l2));
        }
      } else if (4 == t3) {
        i2.vals = [];
        d3 = o2.readUshort(r4, a6);
        a6 += 2;
        for (f2 = 0; f2 < d3; f2++) {
          var v3 = o2.readUshort(r4, a6);
          a6 += 2, i2.vals.push(e2.GSUB.readLigatureSet(r4, s2 + v3));
        }
      } else if (5 == t3 && 2 == i2.fmt) {
        if (2 == i2.fmt) {
          var c2 = o2.readUshort(r4, a6);
          a6 += 2, i2.cDef = e2._lctf.readClassDef(r4, s2 + c2), i2.scset = [];
          var p3 = o2.readUshort(r4, a6);
          a6 += 2;
          for (f2 = 0; f2 < p3; f2++) {
            var U2 = o2.readUshort(r4, a6);
            a6 += 2, i2.scset.push(0 == U2 ? null : e2.GSUB.readSubClassSet(r4, s2 + U2));
          }
        }
      } else if (6 == t3 && 3 == i2.fmt) {
        if (3 == i2.fmt) {
          for (f2 = 0; f2 < 3; f2++) {
            d3 = o2.readUshort(r4, a6);
            a6 += 2;
            for (var g2 = [], S2 = 0; S2 < d3; S2++) g2.push(e2._lctf.readCoverage(r4, s2 + o2.readUshort(r4, a6 + 2 * S2)));
            a6 += 2 * d3, 0 == f2 && (i2.backCvg = g2), 1 == f2 && (i2.inptCvg = g2), 2 == f2 && (i2.ahedCvg = g2);
          }
          d3 = o2.readUshort(r4, a6);
          a6 += 2, i2.lookupRec = e2.GSUB.readSubstLookupRecords(r4, a6, d3);
        }
      } else {
        if (7 == t3 && 1 == i2.fmt) {
          var m2 = o2.readUshort(r4, a6);
          a6 += 2;
          var b6 = o2.readUint(r4, a6);
          if (a6 += 4, 9 == n2.ltype) n2.ltype = m2;
          else if (n2.ltype != m2) throw "invalid extension substitution";
          return e2.GSUB.subt(r4, n2.ltype, s2 + b6);
        }
        console.debug("unsupported GSUB table LookupType", t3, "format", i2.fmt);
      }
      return i2;
    }, e2.GSUB.readSubClassSet = function(r4, t3) {
      var a6 = e2._bin.readUshort, n2 = t3, o2 = [], s2 = a6(r4, t3);
      t3 += 2;
      for (var i2 = 0; i2 < s2; i2++) {
        var h2 = a6(r4, t3);
        t3 += 2, o2.push(e2.GSUB.readSubClassRule(r4, n2 + h2));
      }
      return o2;
    }, e2.GSUB.readSubClassRule = function(r4, t3) {
      var a6 = e2._bin.readUshort, n2 = {}, o2 = a6(r4, t3), s2 = a6(r4, t3 += 2);
      t3 += 2, n2.input = [];
      for (var i2 = 0; i2 < o2 - 1; i2++) n2.input.push(a6(r4, t3)), t3 += 2;
      return n2.substLookupRecords = e2.GSUB.readSubstLookupRecords(r4, t3, s2), n2;
    }, e2.GSUB.readSubstLookupRecords = function(r4, t3, a6) {
      for (var n2 = e2._bin.readUshort, o2 = [], s2 = 0; s2 < a6; s2++) o2.push(n2(r4, t3), n2(r4, t3 + 2)), t3 += 4;
      return o2;
    }, e2.GSUB.readChainSubClassSet = function(r4, t3) {
      var a6 = e2._bin, n2 = t3, o2 = [], s2 = a6.readUshort(r4, t3);
      t3 += 2;
      for (var i2 = 0; i2 < s2; i2++) {
        var h2 = a6.readUshort(r4, t3);
        t3 += 2, o2.push(e2.GSUB.readChainSubClassRule(r4, n2 + h2));
      }
      return o2;
    }, e2.GSUB.readChainSubClassRule = function(r4, t3) {
      for (var a6 = e2._bin, n2 = {}, o2 = ["backtrack", "input", "lookahead"], s2 = 0; s2 < o2.length; s2++) {
        var i2 = a6.readUshort(r4, t3);
        t3 += 2, 1 == s2 && i2--, n2[o2[s2]] = a6.readUshorts(r4, t3, i2), t3 += 2 * n2[o2[s2]].length;
      }
      i2 = a6.readUshort(r4, t3);
      return t3 += 2, n2.subst = a6.readUshorts(r4, t3, 2 * i2), t3 += 2 * n2.subst.length, n2;
    }, e2.GSUB.readLigatureSet = function(r4, t3) {
      var a6 = e2._bin, n2 = t3, o2 = [], s2 = a6.readUshort(r4, t3);
      t3 += 2;
      for (var i2 = 0; i2 < s2; i2++) {
        var h2 = a6.readUshort(r4, t3);
        t3 += 2, o2.push(e2.GSUB.readLigature(r4, n2 + h2));
      }
      return o2;
    }, e2.GSUB.readLigature = function(r4, t3) {
      var a6 = e2._bin, n2 = { chain: [] };
      n2.nglyph = a6.readUshort(r4, t3), t3 += 2;
      var o2 = a6.readUshort(r4, t3);
      t3 += 2;
      for (var s2 = 0; s2 < o2 - 1; s2++) n2.chain.push(a6.readUshort(r4, t3)), t3 += 2;
      return n2;
    }, e2.head = {}, e2.head.parse = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = {};
      return n2.readFixed(r4, t3), t3 += 4, o2.fontRevision = n2.readFixed(r4, t3), t3 += 4, n2.readUint(r4, t3), t3 += 4, n2.readUint(r4, t3), t3 += 4, o2.flags = n2.readUshort(r4, t3), t3 += 2, o2.unitsPerEm = n2.readUshort(r4, t3), t3 += 2, o2.created = n2.readUint64(r4, t3), t3 += 8, o2.modified = n2.readUint64(r4, t3), t3 += 8, o2.xMin = n2.readShort(r4, t3), t3 += 2, o2.yMin = n2.readShort(r4, t3), t3 += 2, o2.xMax = n2.readShort(r4, t3), t3 += 2, o2.yMax = n2.readShort(r4, t3), t3 += 2, o2.macStyle = n2.readUshort(r4, t3), t3 += 2, o2.lowestRecPPEM = n2.readUshort(r4, t3), t3 += 2, o2.fontDirectionHint = n2.readShort(r4, t3), t3 += 2, o2.indexToLocFormat = n2.readShort(r4, t3), t3 += 2, o2.glyphDataFormat = n2.readShort(r4, t3), t3 += 2, o2;
    }, e2.hhea = {}, e2.hhea.parse = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = {};
      return n2.readFixed(r4, t3), t3 += 4, o2.ascender = n2.readShort(r4, t3), t3 += 2, o2.descender = n2.readShort(r4, t3), t3 += 2, o2.lineGap = n2.readShort(r4, t3), t3 += 2, o2.advanceWidthMax = n2.readUshort(r4, t3), t3 += 2, o2.minLeftSideBearing = n2.readShort(r4, t3), t3 += 2, o2.minRightSideBearing = n2.readShort(r4, t3), t3 += 2, o2.xMaxExtent = n2.readShort(r4, t3), t3 += 2, o2.caretSlopeRise = n2.readShort(r4, t3), t3 += 2, o2.caretSlopeRun = n2.readShort(r4, t3), t3 += 2, o2.caretOffset = n2.readShort(r4, t3), t3 += 2, t3 += 8, o2.metricDataFormat = n2.readShort(r4, t3), t3 += 2, o2.numberOfHMetrics = n2.readUshort(r4, t3), t3 += 2, o2;
    }, e2.hmtx = {}, e2.hmtx.parse = function(r4, t3, a6, n2) {
      for (var o2 = e2._bin, s2 = { aWidth: [], lsBearing: [] }, i2 = 0, h2 = 0, d3 = 0; d3 < n2.maxp.numGlyphs; d3++) d3 < n2.hhea.numberOfHMetrics && (i2 = o2.readUshort(r4, t3), t3 += 2, h2 = o2.readShort(r4, t3), t3 += 2), s2.aWidth.push(i2), s2.lsBearing.push(h2);
      return s2;
    }, e2.kern = {}, e2.kern.parse = function(r4, t3, a6, n2) {
      var o2 = e2._bin, s2 = o2.readUshort(r4, t3);
      if (t3 += 2, 1 == s2) return e2.kern.parseV1(r4, t3 - 2, a6, n2);
      var i2 = o2.readUshort(r4, t3);
      t3 += 2;
      for (var h2 = { glyph1: [], rval: [] }, d3 = 0; d3 < i2; d3++) {
        t3 += 2;
        a6 = o2.readUshort(r4, t3);
        t3 += 2;
        var f2 = o2.readUshort(r4, t3);
        t3 += 2;
        var u2 = f2 >>> 8;
        if (0 != (u2 &= 15)) throw "unknown kern table format: " + u2;
        t3 = e2.kern.readFormat0(r4, t3, h2);
      }
      return h2;
    }, e2.kern.parseV1 = function(r4, t3, a6, n2) {
      var o2 = e2._bin;
      o2.readFixed(r4, t3), t3 += 4;
      var s2 = o2.readUint(r4, t3);
      t3 += 4;
      for (var i2 = { glyph1: [], rval: [] }, h2 = 0; h2 < s2; h2++) {
        o2.readUint(r4, t3), t3 += 4;
        var d3 = o2.readUshort(r4, t3);
        t3 += 2, o2.readUshort(r4, t3), t3 += 2;
        var f2 = d3 >>> 8;
        if (0 != (f2 &= 15)) throw "unknown kern table format: " + f2;
        t3 = e2.kern.readFormat0(r4, t3, i2);
      }
      return i2;
    }, e2.kern.readFormat0 = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = -1, s2 = n2.readUshort(r4, t3);
      t3 += 2, n2.readUshort(r4, t3), t3 += 2, n2.readUshort(r4, t3), t3 += 2, n2.readUshort(r4, t3), t3 += 2;
      for (var i2 = 0; i2 < s2; i2++) {
        var h2 = n2.readUshort(r4, t3);
        t3 += 2;
        var d3 = n2.readUshort(r4, t3);
        t3 += 2;
        var f2 = n2.readShort(r4, t3);
        t3 += 2, h2 != o2 && (a6.glyph1.push(h2), a6.rval.push({ glyph2: [], vals: [] }));
        var u2 = a6.rval[a6.rval.length - 1];
        u2.glyph2.push(d3), u2.vals.push(f2), o2 = h2;
      }
      return t3;
    }, e2.loca = {}, e2.loca.parse = function(r4, t3, a6, n2) {
      var o2 = e2._bin, s2 = [], i2 = n2.head.indexToLocFormat, h2 = n2.maxp.numGlyphs + 1;
      if (0 == i2) for (var d3 = 0; d3 < h2; d3++) s2.push(o2.readUshort(r4, t3 + (d3 << 1)) << 1);
      if (1 == i2) for (d3 = 0; d3 < h2; d3++) s2.push(o2.readUint(r4, t3 + (d3 << 2)));
      return s2;
    }, e2.maxp = {}, e2.maxp.parse = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = {}, s2 = n2.readUint(r4, t3);
      return t3 += 4, o2.numGlyphs = n2.readUshort(r4, t3), t3 += 2, 65536 == s2 && (o2.maxPoints = n2.readUshort(r4, t3), t3 += 2, o2.maxContours = n2.readUshort(r4, t3), t3 += 2, o2.maxCompositePoints = n2.readUshort(r4, t3), t3 += 2, o2.maxCompositeContours = n2.readUshort(r4, t3), t3 += 2, o2.maxZones = n2.readUshort(r4, t3), t3 += 2, o2.maxTwilightPoints = n2.readUshort(r4, t3), t3 += 2, o2.maxStorage = n2.readUshort(r4, t3), t3 += 2, o2.maxFunctionDefs = n2.readUshort(r4, t3), t3 += 2, o2.maxInstructionDefs = n2.readUshort(r4, t3), t3 += 2, o2.maxStackElements = n2.readUshort(r4, t3), t3 += 2, o2.maxSizeOfInstructions = n2.readUshort(r4, t3), t3 += 2, o2.maxComponentElements = n2.readUshort(r4, t3), t3 += 2, o2.maxComponentDepth = n2.readUshort(r4, t3), t3 += 2), o2;
    }, e2.name = {}, e2.name.parse = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = {};
      n2.readUshort(r4, t3), t3 += 2;
      var s2 = n2.readUshort(r4, t3);
      t3 += 2, n2.readUshort(r4, t3);
      for (var i2, h2 = ["copyright", "fontFamily", "fontSubfamily", "ID", "fullName", "version", "postScriptName", "trademark", "manufacturer", "designer", "description", "urlVendor", "urlDesigner", "licence", "licenceURL", "---", "typoFamilyName", "typoSubfamilyName", "compatibleFull", "sampleText", "postScriptCID", "wwsFamilyName", "wwsSubfamilyName", "lightPalette", "darkPalette"], d3 = t3 += 2, f2 = 0; f2 < s2; f2++) {
        var u2 = n2.readUshort(r4, t3);
        t3 += 2;
        var l2 = n2.readUshort(r4, t3);
        t3 += 2;
        var v3 = n2.readUshort(r4, t3);
        t3 += 2;
        var c2 = n2.readUshort(r4, t3);
        t3 += 2;
        var p3 = n2.readUshort(r4, t3);
        t3 += 2;
        var U2 = n2.readUshort(r4, t3);
        t3 += 2;
        var g2, S2 = h2[c2], m2 = d3 + 12 * s2 + U2;
        if (0 == u2) g2 = n2.readUnicode(r4, m2, p3 / 2);
        else if (3 == u2 && 0 == l2) g2 = n2.readUnicode(r4, m2, p3 / 2);
        else if (0 == l2) g2 = n2.readASCII(r4, m2, p3);
        else if (1 == l2) g2 = n2.readUnicode(r4, m2, p3 / 2);
        else if (3 == l2) g2 = n2.readUnicode(r4, m2, p3 / 2);
        else {
          if (1 != u2) throw "unknown encoding " + l2 + ", platformID: " + u2;
          g2 = n2.readASCII(r4, m2, p3), console.debug("reading unknown MAC encoding " + l2 + " as ASCII");
        }
        var b6 = "p" + u2 + "," + v3.toString(16);
        null == o2[b6] && (o2[b6] = {}), o2[b6][void 0 !== S2 ? S2 : c2] = g2, o2[b6]._lang = v3;
      }
      for (var y2 in o2) if (null != o2[y2].postScriptName && 1033 == o2[y2]._lang) return o2[y2];
      for (var y2 in o2) if (null != o2[y2].postScriptName && 0 == o2[y2]._lang) return o2[y2];
      for (var y2 in o2) if (null != o2[y2].postScriptName && 3084 == o2[y2]._lang) return o2[y2];
      for (var y2 in o2) if (null != o2[y2].postScriptName) return o2[y2];
      for (var y2 in o2) {
        i2 = y2;
        break;
      }
      return console.debug("returning name table with languageID " + o2[i2]._lang), o2[i2];
    }, e2["OS/2"] = {}, e2["OS/2"].parse = function(r4, t3, a6) {
      var n2 = e2._bin.readUshort(r4, t3);
      t3 += 2;
      var o2 = {};
      if (0 == n2) e2["OS/2"].version0(r4, t3, o2);
      else if (1 == n2) e2["OS/2"].version1(r4, t3, o2);
      else if (2 == n2 || 3 == n2 || 4 == n2) e2["OS/2"].version2(r4, t3, o2);
      else {
        if (5 != n2) throw "unknown OS/2 table version: " + n2;
        e2["OS/2"].version5(r4, t3, o2);
      }
      return o2;
    }, e2["OS/2"].version0 = function(r4, t3, a6) {
      var n2 = e2._bin;
      return a6.xAvgCharWidth = n2.readShort(r4, t3), t3 += 2, a6.usWeightClass = n2.readUshort(r4, t3), t3 += 2, a6.usWidthClass = n2.readUshort(r4, t3), t3 += 2, a6.fsType = n2.readUshort(r4, t3), t3 += 2, a6.ySubscriptXSize = n2.readShort(r4, t3), t3 += 2, a6.ySubscriptYSize = n2.readShort(r4, t3), t3 += 2, a6.ySubscriptXOffset = n2.readShort(r4, t3), t3 += 2, a6.ySubscriptYOffset = n2.readShort(r4, t3), t3 += 2, a6.ySuperscriptXSize = n2.readShort(r4, t3), t3 += 2, a6.ySuperscriptYSize = n2.readShort(r4, t3), t3 += 2, a6.ySuperscriptXOffset = n2.readShort(r4, t3), t3 += 2, a6.ySuperscriptYOffset = n2.readShort(r4, t3), t3 += 2, a6.yStrikeoutSize = n2.readShort(r4, t3), t3 += 2, a6.yStrikeoutPosition = n2.readShort(r4, t3), t3 += 2, a6.sFamilyClass = n2.readShort(r4, t3), t3 += 2, a6.panose = n2.readBytes(r4, t3, 10), t3 += 10, a6.ulUnicodeRange1 = n2.readUint(r4, t3), t3 += 4, a6.ulUnicodeRange2 = n2.readUint(r4, t3), t3 += 4, a6.ulUnicodeRange3 = n2.readUint(r4, t3), t3 += 4, a6.ulUnicodeRange4 = n2.readUint(r4, t3), t3 += 4, a6.achVendID = [n2.readInt8(r4, t3), n2.readInt8(r4, t3 + 1), n2.readInt8(r4, t3 + 2), n2.readInt8(r4, t3 + 3)], t3 += 4, a6.fsSelection = n2.readUshort(r4, t3), t3 += 2, a6.usFirstCharIndex = n2.readUshort(r4, t3), t3 += 2, a6.usLastCharIndex = n2.readUshort(r4, t3), t3 += 2, a6.sTypoAscender = n2.readShort(r4, t3), t3 += 2, a6.sTypoDescender = n2.readShort(r4, t3), t3 += 2, a6.sTypoLineGap = n2.readShort(r4, t3), t3 += 2, a6.usWinAscent = n2.readUshort(r4, t3), t3 += 2, a6.usWinDescent = n2.readUshort(r4, t3), t3 += 2;
    }, e2["OS/2"].version1 = function(r4, t3, a6) {
      var n2 = e2._bin;
      return t3 = e2["OS/2"].version0(r4, t3, a6), a6.ulCodePageRange1 = n2.readUint(r4, t3), t3 += 4, a6.ulCodePageRange2 = n2.readUint(r4, t3), t3 += 4;
    }, e2["OS/2"].version2 = function(r4, t3, a6) {
      var n2 = e2._bin;
      return t3 = e2["OS/2"].version1(r4, t3, a6), a6.sxHeight = n2.readShort(r4, t3), t3 += 2, a6.sCapHeight = n2.readShort(r4, t3), t3 += 2, a6.usDefault = n2.readUshort(r4, t3), t3 += 2, a6.usBreak = n2.readUshort(r4, t3), t3 += 2, a6.usMaxContext = n2.readUshort(r4, t3), t3 += 2;
    }, e2["OS/2"].version5 = function(r4, t3, a6) {
      var n2 = e2._bin;
      return t3 = e2["OS/2"].version2(r4, t3, a6), a6.usLowerOpticalPointSize = n2.readUshort(r4, t3), t3 += 2, a6.usUpperOpticalPointSize = n2.readUshort(r4, t3), t3 += 2;
    }, e2.post = {}, e2.post.parse = function(r4, t3, a6) {
      var n2 = e2._bin, o2 = {};
      return o2.version = n2.readFixed(r4, t3), t3 += 4, o2.italicAngle = n2.readFixed(r4, t3), t3 += 4, o2.underlinePosition = n2.readShort(r4, t3), t3 += 2, o2.underlineThickness = n2.readShort(r4, t3), t3 += 2, o2;
    }, null == e2 && (e2 = {}), null == e2.U && (e2.U = {}), e2.U.codeToGlyph = function(r4, e3) {
      var t3 = r4.cmap, a6 = -1;
      if (null != t3.p0e4 ? a6 = t3.p0e4 : null != t3.p3e1 ? a6 = t3.p3e1 : null != t3.p1e0 ? a6 = t3.p1e0 : null != t3.p0e3 && (a6 = t3.p0e3), -1 == a6) throw "no familiar platform and encoding!";
      var n2 = t3.tables[a6];
      if (0 == n2.format) return e3 >= n2.map.length ? 0 : n2.map[e3];
      if (4 == n2.format) {
        for (var o2 = -1, s2 = 0; s2 < n2.endCount.length; s2++) if (e3 <= n2.endCount[s2]) {
          o2 = s2;
          break;
        }
        if (-1 == o2) return 0;
        if (n2.startCount[o2] > e3) return 0;
        return 65535 & (0 != n2.idRangeOffset[o2] ? n2.glyphIdArray[e3 - n2.startCount[o2] + (n2.idRangeOffset[o2] >> 1) - (n2.idRangeOffset.length - o2)] : e3 + n2.idDelta[o2]);
      }
      if (12 == n2.format) {
        if (e3 > n2.groups[n2.groups.length - 1][1]) return 0;
        for (s2 = 0; s2 < n2.groups.length; s2++) {
          var i2 = n2.groups[s2];
          if (i2[0] <= e3 && e3 <= i2[1]) return i2[2] + (e3 - i2[0]);
        }
        return 0;
      }
      throw "unknown cmap table format " + n2.format;
    }, e2.U.glyphToPath = function(r4, t3) {
      var a6 = { cmds: [], crds: [] };
      if (r4.SVG && r4.SVG.entries[t3]) {
        var n2 = r4.SVG.entries[t3];
        return null == n2 ? a6 : ("string" == typeof n2 && (n2 = e2.SVG.toPath(n2), r4.SVG.entries[t3] = n2), n2);
      }
      if (r4.CFF) {
        var o2 = { x: 0, y: 0, stack: [], nStems: 0, haveWidth: false, width: r4.CFF.Private ? r4.CFF.Private.defaultWidthX : 0, open: false }, s2 = r4.CFF, i2 = r4.CFF.Private;
        if (s2.ROS) {
          for (var h2 = 0; s2.FDSelect[h2 + 2] <= t3; ) h2 += 2;
          i2 = s2.FDArray[s2.FDSelect[h2 + 1]].Private;
        }
        e2.U._drawCFF(r4.CFF.CharStrings[t3], o2, s2, i2, a6);
      } else r4.glyf && e2.U._drawGlyf(t3, r4, a6);
      return a6;
    }, e2.U._drawGlyf = function(r4, t3, a6) {
      var n2 = t3.glyf[r4];
      null == n2 && (n2 = t3.glyf[r4] = e2.glyf._parseGlyf(t3, r4)), null != n2 && (n2.noc > -1 ? e2.U._simpleGlyph(n2, a6) : e2.U._compoGlyph(n2, t3, a6));
    }, e2.U._simpleGlyph = function(r4, t3) {
      for (var a6 = 0; a6 < r4.noc; a6++) {
        for (var n2 = 0 == a6 ? 0 : r4.endPts[a6 - 1] + 1, o2 = r4.endPts[a6], s2 = n2; s2 <= o2; s2++) {
          var i2 = s2 == n2 ? o2 : s2 - 1, h2 = s2 == o2 ? n2 : s2 + 1, d3 = 1 & r4.flags[s2], f2 = 1 & r4.flags[i2], u2 = 1 & r4.flags[h2], l2 = r4.xs[s2], v3 = r4.ys[s2];
          if (s2 == n2) if (d3) {
            if (!f2) {
              e2.U.P.moveTo(t3, l2, v3);
              continue;
            }
            e2.U.P.moveTo(t3, r4.xs[i2], r4.ys[i2]);
          } else f2 ? e2.U.P.moveTo(t3, r4.xs[i2], r4.ys[i2]) : e2.U.P.moveTo(t3, (r4.xs[i2] + l2) / 2, (r4.ys[i2] + v3) / 2);
          d3 ? f2 && e2.U.P.lineTo(t3, l2, v3) : u2 ? e2.U.P.qcurveTo(t3, l2, v3, r4.xs[h2], r4.ys[h2]) : e2.U.P.qcurveTo(t3, l2, v3, (l2 + r4.xs[h2]) / 2, (v3 + r4.ys[h2]) / 2);
        }
        e2.U.P.closePath(t3);
      }
    }, e2.U._compoGlyph = function(r4, t3, a6) {
      for (var n2 = 0; n2 < r4.parts.length; n2++) {
        var o2 = { cmds: [], crds: [] }, s2 = r4.parts[n2];
        e2.U._drawGlyf(s2.glyphIndex, t3, o2);
        for (var i2 = s2.m, h2 = 0; h2 < o2.crds.length; h2 += 2) {
          var d3 = o2.crds[h2], f2 = o2.crds[h2 + 1];
          a6.crds.push(d3 * i2.a + f2 * i2.b + i2.tx), a6.crds.push(d3 * i2.c + f2 * i2.d + i2.ty);
        }
        for (h2 = 0; h2 < o2.cmds.length; h2++) a6.cmds.push(o2.cmds[h2]);
      }
    }, e2.U._getGlyphClass = function(r4, t3) {
      var a6 = e2._lctf.getInterval(t3, r4);
      return -1 == a6 ? 0 : t3[a6 + 2];
    }, e2.U._applySubs = function(r4, t3, a6, n2) {
      for (var o2 = r4.length - t3 - 1, s2 = 0; s2 < a6.tabs.length; s2++) if (null != a6.tabs[s2]) {
        var i2, h2 = a6.tabs[s2];
        if (!h2.coverage || -1 != (i2 = e2._lctf.coverageIndex(h2.coverage, r4[t3]))) {
          if (1 == a6.ltype) r4[t3], 1 == h2.fmt ? r4[t3] = r4[t3] + h2.delta : r4[t3] = h2.newg[i2];
          else if (4 == a6.ltype) for (var d3 = h2.vals[i2], f2 = 0; f2 < d3.length; f2++) {
            var u2 = d3[f2], l2 = u2.chain.length;
            if (!(l2 > o2)) {
              for (var v3 = true, c2 = 0, p3 = 0; p3 < l2; p3++) {
                for (; -1 == r4[t3 + c2 + (1 + p3)]; ) c2++;
                u2.chain[p3] != r4[t3 + c2 + (1 + p3)] && (v3 = false);
              }
              if (v3) {
                r4[t3] = u2.nglyph;
                for (p3 = 0; p3 < l2 + c2; p3++) r4[t3 + p3 + 1] = -1;
                break;
              }
            }
          }
          else if (5 == a6.ltype && 2 == h2.fmt) for (var U2 = e2._lctf.getInterval(h2.cDef, r4[t3]), g2 = h2.cDef[U2 + 2], S2 = h2.scset[g2], m2 = 0; m2 < S2.length; m2++) {
            var b6 = S2[m2], y2 = b6.input;
            if (!(y2.length > o2)) {
              for (v3 = true, p3 = 0; p3 < y2.length; p3++) {
                var F2 = e2._lctf.getInterval(h2.cDef, r4[t3 + 1 + p3]);
                if (-1 == U2 && h2.cDef[F2 + 2] != y2[p3]) {
                  v3 = false;
                  break;
                }
              }
              if (v3) {
                var C2 = b6.substLookupRecords;
                for (f2 = 0; f2 < C2.length; f2 += 2) C2[f2], C2[f2 + 1];
              }
            }
          }
          else if (6 == a6.ltype && 3 == h2.fmt) {
            if (!e2.U._glsCovered(r4, h2.backCvg, t3 - h2.backCvg.length)) continue;
            if (!e2.U._glsCovered(r4, h2.inptCvg, t3)) continue;
            if (!e2.U._glsCovered(r4, h2.ahedCvg, t3 + h2.inptCvg.length)) continue;
            var _2 = h2.lookupRec;
            for (m2 = 0; m2 < _2.length; m2 += 2) {
              U2 = _2[m2];
              var P3 = n2[_2[m2 + 1]];
              e2.U._applySubs(r4, t3 + U2, P3, n2);
            }
          }
        }
      }
    }, e2.U._glsCovered = function(r4, t3, a6) {
      for (var n2 = 0; n2 < t3.length; n2++) {
        if (-1 == e2._lctf.coverageIndex(t3[n2], r4[a6 + n2])) return false;
      }
      return true;
    }, e2.U.glyphsToPath = function(r4, t3, a6) {
      for (var n2 = { cmds: [], crds: [] }, o2 = 0, s2 = 0; s2 < t3.length; s2++) {
        var i2 = t3[s2];
        if (-1 != i2) {
          for (var h2 = s2 < t3.length - 1 && -1 != t3[s2 + 1] ? t3[s2 + 1] : 0, d3 = e2.U.glyphToPath(r4, i2), f2 = 0; f2 < d3.crds.length; f2 += 2) n2.crds.push(d3.crds[f2] + o2), n2.crds.push(d3.crds[f2 + 1]);
          a6 && n2.cmds.push(a6);
          for (f2 = 0; f2 < d3.cmds.length; f2++) n2.cmds.push(d3.cmds[f2]);
          a6 && n2.cmds.push("X"), o2 += r4.hmtx.aWidth[i2], s2 < t3.length - 1 && (o2 += e2.U.getPairAdjustment(r4, i2, h2));
        }
      }
      return n2;
    }, e2.U.P = {}, e2.U.P.moveTo = function(r4, e3, t3) {
      r4.cmds.push("M"), r4.crds.push(e3, t3);
    }, e2.U.P.lineTo = function(r4, e3, t3) {
      r4.cmds.push("L"), r4.crds.push(e3, t3);
    }, e2.U.P.curveTo = function(r4, e3, t3, a6, n2, o2, s2) {
      r4.cmds.push("C"), r4.crds.push(e3, t3, a6, n2, o2, s2);
    }, e2.U.P.qcurveTo = function(r4, e3, t3, a6, n2) {
      r4.cmds.push("Q"), r4.crds.push(e3, t3, a6, n2);
    }, e2.U.P.closePath = function(r4) {
      r4.cmds.push("Z");
    }, e2.U._drawCFF = function(r4, t3, a6, n2, o2) {
      for (var s2 = t3.stack, i2 = t3.nStems, h2 = t3.haveWidth, d3 = t3.width, f2 = t3.open, u2 = 0, l2 = t3.x, v3 = t3.y, c2 = 0, p3 = 0, U2 = 0, g2 = 0, S2 = 0, m2 = 0, b6 = 0, y2 = 0, F2 = 0, C2 = 0, _2 = { val: 0, size: 0 }; u2 < r4.length; ) {
        e2.CFF.getCharString(r4, u2, _2);
        var P3 = _2.val;
        if (u2 += _2.size, "o1" == P3 || "o18" == P3) s2.length % 2 != 0 && !h2 && (d3 = s2.shift() + n2.nominalWidthX), i2 += s2.length >> 1, s2.length = 0, h2 = true;
        else if ("o3" == P3 || "o23" == P3) {
          s2.length % 2 != 0 && !h2 && (d3 = s2.shift() + n2.nominalWidthX), i2 += s2.length >> 1, s2.length = 0, h2 = true;
        } else if ("o4" == P3) s2.length > 1 && !h2 && (d3 = s2.shift() + n2.nominalWidthX, h2 = true), f2 && e2.U.P.closePath(o2), v3 += s2.pop(), e2.U.P.moveTo(o2, l2, v3), f2 = true;
        else if ("o5" == P3) for (; s2.length > 0; ) l2 += s2.shift(), v3 += s2.shift(), e2.U.P.lineTo(o2, l2, v3);
        else if ("o6" == P3 || "o7" == P3) for (var x3 = s2.length, I2 = "o6" == P3, w2 = 0; w2 < x3; w2++) {
          var k2 = s2.shift();
          I2 ? l2 += k2 : v3 += k2, I2 = !I2, e2.U.P.lineTo(o2, l2, v3);
        }
        else if ("o8" == P3 || "o24" == P3) {
          x3 = s2.length;
          for (var G2 = 0; G2 + 6 <= x3; ) c2 = l2 + s2.shift(), p3 = v3 + s2.shift(), U2 = c2 + s2.shift(), g2 = p3 + s2.shift(), l2 = U2 + s2.shift(), v3 = g2 + s2.shift(), e2.U.P.curveTo(o2, c2, p3, U2, g2, l2, v3), G2 += 6;
          "o24" == P3 && (l2 += s2.shift(), v3 += s2.shift(), e2.U.P.lineTo(o2, l2, v3));
        } else {
          if ("o11" == P3) break;
          if ("o1234" == P3 || "o1235" == P3 || "o1236" == P3 || "o1237" == P3) "o1234" == P3 && (p3 = v3, U2 = (c2 = l2 + s2.shift()) + s2.shift(), C2 = g2 = p3 + s2.shift(), m2 = g2, y2 = v3, l2 = (b6 = (S2 = (F2 = U2 + s2.shift()) + s2.shift()) + s2.shift()) + s2.shift(), e2.U.P.curveTo(o2, c2, p3, U2, g2, F2, C2), e2.U.P.curveTo(o2, S2, m2, b6, y2, l2, v3)), "o1235" == P3 && (c2 = l2 + s2.shift(), p3 = v3 + s2.shift(), U2 = c2 + s2.shift(), g2 = p3 + s2.shift(), F2 = U2 + s2.shift(), C2 = g2 + s2.shift(), S2 = F2 + s2.shift(), m2 = C2 + s2.shift(), b6 = S2 + s2.shift(), y2 = m2 + s2.shift(), l2 = b6 + s2.shift(), v3 = y2 + s2.shift(), s2.shift(), e2.U.P.curveTo(o2, c2, p3, U2, g2, F2, C2), e2.U.P.curveTo(o2, S2, m2, b6, y2, l2, v3)), "o1236" == P3 && (c2 = l2 + s2.shift(), p3 = v3 + s2.shift(), U2 = c2 + s2.shift(), C2 = g2 = p3 + s2.shift(), m2 = g2, b6 = (S2 = (F2 = U2 + s2.shift()) + s2.shift()) + s2.shift(), y2 = m2 + s2.shift(), l2 = b6 + s2.shift(), e2.U.P.curveTo(o2, c2, p3, U2, g2, F2, C2), e2.U.P.curveTo(o2, S2, m2, b6, y2, l2, v3)), "o1237" == P3 && (c2 = l2 + s2.shift(), p3 = v3 + s2.shift(), U2 = c2 + s2.shift(), g2 = p3 + s2.shift(), F2 = U2 + s2.shift(), C2 = g2 + s2.shift(), S2 = F2 + s2.shift(), m2 = C2 + s2.shift(), b6 = S2 + s2.shift(), y2 = m2 + s2.shift(), Math.abs(b6 - l2) > Math.abs(y2 - v3) ? l2 = b6 + s2.shift() : v3 = y2 + s2.shift(), e2.U.P.curveTo(o2, c2, p3, U2, g2, F2, C2), e2.U.P.curveTo(o2, S2, m2, b6, y2, l2, v3));
          else if ("o14" == P3) {
            if (s2.length > 0 && !h2 && (d3 = s2.shift() + a6.nominalWidthX, h2 = true), 4 == s2.length) {
              var O3 = s2.shift(), T2 = s2.shift(), D2 = s2.shift(), B2 = s2.shift(), A2 = e2.CFF.glyphBySE(a6, D2), R2 = e2.CFF.glyphBySE(a6, B2);
              e2.U._drawCFF(a6.CharStrings[A2], t3, a6, n2, o2), t3.x = O3, t3.y = T2, e2.U._drawCFF(a6.CharStrings[R2], t3, a6, n2, o2);
            }
            f2 && (e2.U.P.closePath(o2), f2 = false);
          } else if ("o19" == P3 || "o20" == P3) {
            s2.length % 2 != 0 && !h2 && (d3 = s2.shift() + n2.nominalWidthX), i2 += s2.length >> 1, s2.length = 0, h2 = true, u2 += i2 + 7 >> 3;
          } else if ("o21" == P3) s2.length > 2 && !h2 && (d3 = s2.shift() + n2.nominalWidthX, h2 = true), v3 += s2.pop(), l2 += s2.pop(), f2 && e2.U.P.closePath(o2), e2.U.P.moveTo(o2, l2, v3), f2 = true;
          else if ("o22" == P3) s2.length > 1 && !h2 && (d3 = s2.shift() + n2.nominalWidthX, h2 = true), l2 += s2.pop(), f2 && e2.U.P.closePath(o2), e2.U.P.moveTo(o2, l2, v3), f2 = true;
          else if ("o25" == P3) {
            for (; s2.length > 6; ) l2 += s2.shift(), v3 += s2.shift(), e2.U.P.lineTo(o2, l2, v3);
            c2 = l2 + s2.shift(), p3 = v3 + s2.shift(), U2 = c2 + s2.shift(), g2 = p3 + s2.shift(), l2 = U2 + s2.shift(), v3 = g2 + s2.shift(), e2.U.P.curveTo(o2, c2, p3, U2, g2, l2, v3);
          } else if ("o26" == P3) for (s2.length % 2 && (l2 += s2.shift()); s2.length > 0; ) c2 = l2, p3 = v3 + s2.shift(), l2 = U2 = c2 + s2.shift(), v3 = (g2 = p3 + s2.shift()) + s2.shift(), e2.U.P.curveTo(o2, c2, p3, U2, g2, l2, v3);
          else if ("o27" == P3) for (s2.length % 2 && (v3 += s2.shift()); s2.length > 0; ) p3 = v3, U2 = (c2 = l2 + s2.shift()) + s2.shift(), g2 = p3 + s2.shift(), l2 = U2 + s2.shift(), v3 = g2, e2.U.P.curveTo(o2, c2, p3, U2, g2, l2, v3);
          else if ("o10" == P3 || "o29" == P3) {
            var L2 = "o10" == P3 ? n2 : a6;
            if (0 == s2.length) console.debug("error: empty stack");
            else {
              var W2 = s2.pop(), M2 = L2.Subrs[W2 + L2.Bias];
              t3.x = l2, t3.y = v3, t3.nStems = i2, t3.haveWidth = h2, t3.width = d3, t3.open = f2, e2.U._drawCFF(M2, t3, a6, n2, o2), l2 = t3.x, v3 = t3.y, i2 = t3.nStems, h2 = t3.haveWidth, d3 = t3.width, f2 = t3.open;
            }
          } else if ("o30" == P3 || "o31" == P3) {
            var V3 = s2.length, E2 = (G2 = 0, "o31" == P3);
            for (G2 += V3 - (x3 = -3 & V3); G2 < x3; ) E2 ? (p3 = v3, U2 = (c2 = l2 + s2.shift()) + s2.shift(), v3 = (g2 = p3 + s2.shift()) + s2.shift(), x3 - G2 == 5 ? (l2 = U2 + s2.shift(), G2++) : l2 = U2, E2 = false) : (c2 = l2, p3 = v3 + s2.shift(), U2 = c2 + s2.shift(), g2 = p3 + s2.shift(), l2 = U2 + s2.shift(), x3 - G2 == 5 ? (v3 = g2 + s2.shift(), G2++) : v3 = g2, E2 = true), e2.U.P.curveTo(o2, c2, p3, U2, g2, l2, v3), G2 += 4;
          } else {
            if ("o" == (P3 + "").charAt(0)) throw console.debug("Unknown operation: " + P3, r4), P3;
            s2.push(P3);
          }
        }
      }
      t3.x = l2, t3.y = v3, t3.nStems = i2, t3.haveWidth = h2, t3.width = d3, t3.open = f2;
    };
    var t2 = e2, a5 = { Typr: t2 };
    return r3.Typr = t2, r3.default = a5, Object.defineProperty(r3, "__esModule", { value: true }), r3;
  })({}).Typr;
}
function woff2otfFactory() {
  return (function(r3) {
    var e2 = Uint8Array, n2 = Uint16Array, t2 = Uint32Array, a5 = new e2([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), i2 = new e2([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), o2 = new e2([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), f2 = function(r4, e3) {
      for (var a6 = new n2(31), i3 = 0; i3 < 31; ++i3) a6[i3] = e3 += 1 << r4[i3 - 1];
      var o3 = new t2(a6[30]);
      for (i3 = 1; i3 < 30; ++i3) for (var f3 = a6[i3]; f3 < a6[i3 + 1]; ++f3) o3[f3] = f3 - a6[i3] << 5 | i3;
      return [a6, o3];
    }, u2 = f2(a5, 2), v3 = u2[0], s2 = u2[1];
    v3[28] = 258, s2[258] = 28;
    for (var l2 = f2(i2, 0)[0], c2 = new n2(32768), g2 = 0; g2 < 32768; ++g2) {
      var h2 = (43690 & g2) >>> 1 | (21845 & g2) << 1;
      h2 = (61680 & (h2 = (52428 & h2) >>> 2 | (13107 & h2) << 2)) >>> 4 | (3855 & h2) << 4, c2[g2] = ((65280 & h2) >>> 8 | (255 & h2) << 8) >>> 1;
    }
    var w2 = function(r4, e3, t3) {
      for (var a6 = r4.length, i3 = 0, o3 = new n2(e3); i3 < a6; ++i3) ++o3[r4[i3] - 1];
      var f3, u3 = new n2(e3);
      for (i3 = 0; i3 < e3; ++i3) u3[i3] = u3[i3 - 1] + o3[i3 - 1] << 1;
      {
        f3 = new n2(1 << e3);
        var v4 = 15 - e3;
        for (i3 = 0; i3 < a6; ++i3) if (r4[i3]) for (var s3 = i3 << 4 | r4[i3], l3 = e3 - r4[i3], g3 = u3[r4[i3] - 1]++ << l3, h3 = g3 | (1 << l3) - 1; g3 <= h3; ++g3) f3[c2[g3] >>> v4] = s3;
      }
      return f3;
    }, d3 = new e2(288);
    for (g2 = 0; g2 < 144; ++g2) d3[g2] = 8;
    for (g2 = 144; g2 < 256; ++g2) d3[g2] = 9;
    for (g2 = 256; g2 < 280; ++g2) d3[g2] = 7;
    for (g2 = 280; g2 < 288; ++g2) d3[g2] = 8;
    var m2 = new e2(32);
    for (g2 = 0; g2 < 32; ++g2) m2[g2] = 5;
    var b6 = w2(d3, 9), p3 = w2(m2, 5), y2 = function(r4) {
      for (var e3 = r4[0], n3 = 1; n3 < r4.length; ++n3) r4[n3] > e3 && (e3 = r4[n3]);
      return e3;
    }, L2 = function(r4, e3, n3) {
      var t3 = e3 / 8 | 0;
      return (r4[t3] | r4[t3 + 1] << 8) >> (7 & e3) & n3;
    }, U2 = function(r4, e3) {
      var n3 = e3 / 8 | 0;
      return (r4[n3] | r4[n3 + 1] << 8 | r4[n3 + 2] << 16) >> (7 & e3);
    }, k2 = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler", , "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"], T2 = function(r4, e3, n3) {
      var t3 = new Error(e3 || k2[r4]);
      if (t3.code = r4, Error.captureStackTrace && Error.captureStackTrace(t3, T2), !n3) throw t3;
      return t3;
    }, O3 = function(r4, f3, u3) {
      var s3 = r4.length;
      if (!s3 || u3 && !u3.l && s3 < 5) return f3 || new e2(0);
      var c5 = !f3 || u3, g3 = !u3 || u3.i;
      u3 || (u3 = {}), f3 || (f3 = new e2(3 * s3));
      var h3, d5 = function(r5) {
        var n3 = f3.length;
        if (r5 > n3) {
          var t3 = new e2(Math.max(2 * n3, r5));
          t3.set(f3), f3 = t3;
        }
      }, m3 = u3.f || 0, k3 = u3.p || 0, O4 = u3.b || 0, A3 = u3.l, x4 = u3.d, E2 = u3.m, D2 = u3.n, M2 = 8 * s3;
      do {
        if (!A3) {
          u3.f = m3 = L2(r4, k3, 1);
          var S2 = L2(r4, k3 + 1, 3);
          if (k3 += 3, !S2) {
            var V3 = r4[(I2 = ((h3 = k3) / 8 | 0) + (7 & h3 && 1) + 4) - 4] | r4[I2 - 3] << 8, _2 = I2 + V3;
            if (_2 > s3) {
              g3 && T2(0);
              break;
            }
            c5 && d5(O4 + V3), f3.set(r4.subarray(I2, _2), O4), u3.b = O4 += V3, u3.p = k3 = 8 * _2;
            continue;
          }
          if (1 == S2) A3 = b6, x4 = p3, E2 = 9, D2 = 5;
          else if (2 == S2) {
            var j3 = L2(r4, k3, 31) + 257, z2 = L2(r4, k3 + 10, 15) + 4, C2 = j3 + L2(r4, k3 + 5, 31) + 1;
            k3 += 14;
            for (var F2 = new e2(C2), P3 = new e2(19), q2 = 0; q2 < z2; ++q2) P3[o2[q2]] = L2(r4, k3 + 3 * q2, 7);
            k3 += 3 * z2;
            var B2 = y2(P3), G2 = (1 << B2) - 1, H3 = w2(P3, B2);
            for (q2 = 0; q2 < C2; ) {
              var I2, J2 = H3[L2(r4, k3, G2)];
              if (k3 += 15 & J2, (I2 = J2 >>> 4) < 16) F2[q2++] = I2;
              else {
                var K2 = 0, N2 = 0;
                for (16 == I2 ? (N2 = 3 + L2(r4, k3, 3), k3 += 2, K2 = F2[q2 - 1]) : 17 == I2 ? (N2 = 3 + L2(r4, k3, 7), k3 += 3) : 18 == I2 && (N2 = 11 + L2(r4, k3, 127), k3 += 7); N2--; ) F2[q2++] = K2;
              }
            }
            var Q2 = F2.subarray(0, j3), R2 = F2.subarray(j3);
            E2 = y2(Q2), D2 = y2(R2), A3 = w2(Q2, E2), x4 = w2(R2, D2);
          } else T2(1);
          if (k3 > M2) {
            g3 && T2(0);
            break;
          }
        }
        c5 && d5(O4 + 131072);
        for (var W2 = (1 << E2) - 1, X2 = (1 << D2) - 1, Y2 = k3; ; Y2 = k3) {
          var Z2 = (K2 = A3[U2(r4, k3) & W2]) >>> 4;
          if ((k3 += 15 & K2) > M2) {
            g3 && T2(0);
            break;
          }
          if (K2 || T2(2), Z2 < 256) f3[O4++] = Z2;
          else {
            if (256 == Z2) {
              Y2 = k3, A3 = null;
              break;
            }
            var $2 = Z2 - 254;
            if (Z2 > 264) {
              var rr = a5[q2 = Z2 - 257];
              $2 = L2(r4, k3, (1 << rr) - 1) + v3[q2], k3 += rr;
            }
            var er = x4[U2(r4, k3) & X2], nr = er >>> 4;
            er || T2(3), k3 += 15 & er;
            R2 = l2[nr];
            if (nr > 3) {
              rr = i2[nr];
              R2 += U2(r4, k3) & (1 << rr) - 1, k3 += rr;
            }
            if (k3 > M2) {
              g3 && T2(0);
              break;
            }
            c5 && d5(O4 + 131072);
            for (var tr = O4 + $2; O4 < tr; O4 += 4) f3[O4] = f3[O4 - R2], f3[O4 + 1] = f3[O4 + 1 - R2], f3[O4 + 2] = f3[O4 + 2 - R2], f3[O4 + 3] = f3[O4 + 3 - R2];
            O4 = tr;
          }
        }
        u3.l = A3, u3.p = Y2, u3.b = O4, A3 && (m3 = 1, u3.m = E2, u3.d = x4, u3.n = D2);
      } while (!m3);
      return O4 == f3.length ? f3 : (function(r5, a6, i3) {
        (null == i3 || i3 > r5.length) && (i3 = r5.length);
        var o3 = new (r5 instanceof n2 ? n2 : r5 instanceof t2 ? t2 : e2)(i3 - a6);
        return o3.set(r5.subarray(a6, i3)), o3;
      })(f3, 0, O4);
    }, A2 = new e2(0);
    var x3 = "undefined" != typeof TextDecoder && new TextDecoder();
    try {
      x3.decode(A2, { stream: true }), 1;
    } catch (r4) {
    }
    return r3.convert_streams = function(r4) {
      var e3 = new DataView(r4), n3 = 0;
      function t3() {
        var r5 = e3.getUint16(n3);
        return n3 += 2, r5;
      }
      function a6() {
        var r5 = e3.getUint32(n3);
        return n3 += 4, r5;
      }
      function i3(r5) {
        m3.setUint16(b7, r5), b7 += 2;
      }
      function o3(r5) {
        m3.setUint32(b7, r5), b7 += 4;
      }
      for (var f3 = { signature: a6(), flavor: a6(), length: a6(), numTables: t3(), reserved: t3(), totalSfntSize: a6(), majorVersion: t3(), minorVersion: t3(), metaOffset: a6(), metaLength: a6(), metaOrigLength: a6(), privOffset: a6(), privLength: a6() }, u3 = 0; Math.pow(2, u3) <= f3.numTables; ) u3++;
      u3--;
      for (var v4 = 16 * Math.pow(2, u3), s3 = 16 * f3.numTables - v4, l3 = 12, c5 = [], g3 = 0; g3 < f3.numTables; g3++) c5.push({ tag: a6(), offset: a6(), compLength: a6(), origLength: a6(), origChecksum: a6() }), l3 += 16;
      var h3, w3 = new Uint8Array(12 + 16 * c5.length + c5.reduce((function(r5, e4) {
        return r5 + e4.origLength + 4;
      }), 0)), d5 = w3.buffer, m3 = new DataView(d5), b7 = 0;
      return o3(f3.flavor), i3(f3.numTables), i3(v4), i3(u3), i3(s3), c5.forEach((function(r5) {
        o3(r5.tag), o3(r5.origChecksum), o3(l3), o3(r5.origLength), r5.outOffset = l3, (l3 += r5.origLength) % 4 != 0 && (l3 += 4 - l3 % 4);
      })), c5.forEach((function(e4) {
        var n4, t4 = r4.slice(e4.offset, e4.offset + e4.compLength);
        if (e4.compLength != e4.origLength) {
          var a7 = new Uint8Array(e4.origLength);
          n4 = new Uint8Array(t4, 2), O3(n4, a7);
        } else a7 = new Uint8Array(t4);
        w3.set(a7, e4.outOffset);
        var i4 = 0;
        (l3 = e4.outOffset + e4.origLength) % 4 != 0 && (i4 = 4 - l3 % 4), w3.set(new Uint8Array(i4).buffer, e4.outOffset + e4.origLength), h3 = l3 + i4;
      })), d5.slice(0, h3);
    }, Object.defineProperty(r3, "__esModule", { value: true }), r3;
  })({}).convert_streams;
}
function parserFactory(Typr, woff2otf) {
  const cmdArgLengths = {
    M: 2,
    L: 2,
    Q: 4,
    C: 6,
    Z: 0
  };
  const joiningTypeRawData = { "C": "18g,ca,368,1kz", "D": "17k,6,2,2+4,5+c,2+6,2+1,10+1,9+f,j+11,2+1,a,2,2+1,15+2,3,j+2,6+3,2+8,2,2,2+1,w+a,4+e,3+3,2,3+2,3+5,23+w,2f+4,3,2+9,2,b,2+3,3,1k+9,6+1,3+1,2+2,2+d,30g,p+y,1,1+1g,f+x,2,sd2+1d,jf3+4,f+3,2+4,2+2,b+3,42,2,4+2,2+1,2,3,t+1,9f+w,2,el+2,2+g,d+2,2l,2+1,5,3+1,2+1,2,3,6,16wm+1v", "R": "17m+3,2,2,6+3,m,15+2,2+2,h+h,13,3+8,2,2,3+1,2,p+1,x,5+4,5,a,2,2,3,u,c+2,g+1,5,2+1,4+1,5j,6+1,2,b,2+2,f,2+1,1s+2,2,3+1,7,1ez0,2,2+1,4+4,b,4,3,b,42,2+2,4,3,2+1,2,o+3,ae,ep,x,2o+2,3+1,3,5+1,6", "L": "x9u,jff,a,fd,jv", "T": "4t,gj+33,7o+4,1+1,7c+18,2,2+1,2+1,2,21+a,2,1b+k,h,2u+6,3+5,3+1,2+3,y,2,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,3,7,6+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+d,1,1+1,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,ek,3+1,r+4,1e+4,6+5,2p+c,1+3,1,1+2,1+b,2db+2,3y,2p+v,ff+3,30+1,n9x,1+2,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,5s,6y+2,ea,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+9,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2,2b+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,470+8,at4+4,1o+6,t5,1s+3,2a,f5l+1,2+3,43o+2,a+7,1+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,1,gzau,v+2n,3l+6n" };
  const JT_LEFT = 1, JT_RIGHT = 2, JT_DUAL = 4, JT_TRANSPARENT = 8, JT_JOIN_CAUSING = 16, JT_NON_JOINING = 32;
  let joiningTypeMap;
  function getCharJoiningType(ch) {
    if (!joiningTypeMap) {
      const m2 = {
        R: JT_RIGHT,
        L: JT_LEFT,
        D: JT_DUAL,
        C: JT_JOIN_CAUSING,
        U: JT_NON_JOINING,
        T: JT_TRANSPARENT
      };
      joiningTypeMap = /* @__PURE__ */ new Map();
      for (let type in joiningTypeRawData) {
        let lastCode = 0;
        joiningTypeRawData[type].split(",").forEach((range) => {
          let [skip, step] = range.split("+");
          skip = parseInt(skip, 36);
          step = step ? parseInt(step, 36) : 0;
          joiningTypeMap.set(lastCode += skip, m2[type]);
          for (let i2 = step; i2--; ) {
            joiningTypeMap.set(++lastCode, m2[type]);
          }
        });
      }
    }
    return joiningTypeMap.get(ch) || JT_NON_JOINING;
  }
  const ISOL = 1, INIT = 2, FINA = 3, MEDI = 4;
  const formsToFeatures = [null, "isol", "init", "fina", "medi"];
  function detectJoiningForms(str) {
    const joiningForms = new Uint8Array(str.length);
    let prevJoiningType = JT_NON_JOINING;
    let prevForm = ISOL;
    let prevIndex = -1;
    for (let i2 = 0; i2 < str.length; i2++) {
      const code = str.codePointAt(i2);
      let joiningType = getCharJoiningType(code) | 0;
      let form = ISOL;
      if (joiningType & JT_TRANSPARENT) {
        continue;
      }
      if (prevJoiningType & (JT_LEFT | JT_DUAL | JT_JOIN_CAUSING)) {
        if (joiningType & (JT_RIGHT | JT_DUAL | JT_JOIN_CAUSING)) {
          form = FINA;
          if (prevForm === ISOL || prevForm === FINA) {
            joiningForms[prevIndex]++;
          }
        } else if (joiningType & (JT_LEFT | JT_NON_JOINING)) {
          if (prevForm === INIT || prevForm === MEDI) {
            joiningForms[prevIndex]--;
          }
        }
      } else if (prevJoiningType & (JT_RIGHT | JT_NON_JOINING)) {
        if (prevForm === INIT || prevForm === MEDI) {
          joiningForms[prevIndex]--;
        }
      }
      prevForm = joiningForms[i2] = form;
      prevJoiningType = joiningType;
      prevIndex = i2;
      if (code > 65535) i2++;
    }
    return joiningForms;
  }
  function stringToGlyphs(font, str) {
    const glyphIds = [];
    for (let i2 = 0; i2 < str.length; i2++) {
      const cc = str.codePointAt(i2);
      if (cc > 65535) i2++;
      glyphIds.push(Typr.U.codeToGlyph(font, cc));
    }
    const gsub = font["GSUB"];
    if (gsub) {
      const { lookupList, featureList } = gsub;
      let joiningForms;
      const supportedFeatures = /^(rlig|liga|mset|isol|init|fina|medi|half|pres|blws|ccmp)$/;
      const usedLookups = [];
      featureList.forEach((feature) => {
        if (supportedFeatures.test(feature.tag)) {
          for (let ti = 0; ti < feature.tab.length; ti++) {
            if (usedLookups[feature.tab[ti]]) continue;
            usedLookups[feature.tab[ti]] = true;
            const tab = lookupList[feature.tab[ti]];
            const isJoiningFeature = /^(isol|init|fina|medi)$/.test(feature.tag);
            if (isJoiningFeature && !joiningForms) {
              joiningForms = detectJoiningForms(str);
            }
            for (let ci = 0; ci < glyphIds.length; ci++) {
              if (!joiningForms || !isJoiningFeature || formsToFeatures[joiningForms[ci]] === feature.tag) {
                Typr.U._applySubs(glyphIds, ci, tab, lookupList);
              }
            }
          }
        }
      });
    }
    return glyphIds;
  }
  function calcGlyphPositions(font, glyphIds) {
    const positions = new Int16Array(glyphIds.length * 3);
    let glyphIndex = 0;
    for (; glyphIndex < glyphIds.length; glyphIndex++) {
      const glyphId = glyphIds[glyphIndex];
      if (glyphId === -1) continue;
      positions[glyphIndex * 3 + 2] = font.hmtx.aWidth[glyphId];
      const gpos = font.GPOS;
      if (gpos) {
        const llist = gpos.lookupList;
        for (let i2 = 0; i2 < llist.length; i2++) {
          const lookup = llist[i2];
          for (let j3 = 0; j3 < lookup.tabs.length; j3++) {
            const tab = lookup.tabs[j3];
            if (lookup.ltype === 1) {
              const ind = Typr._lctf.coverageIndex(tab.coverage, glyphId);
              if (ind !== -1 && tab.pos) {
                applyValueRecord(tab.pos, glyphIndex);
                break;
              }
            } else if (lookup.ltype === 2) {
              let adj = null;
              let prevGlyphIndex = getPrevGlyphIndex();
              if (prevGlyphIndex !== -1) {
                const coverageIndex = Typr._lctf.coverageIndex(tab.coverage, glyphIds[prevGlyphIndex]);
                if (coverageIndex !== -1) {
                  if (tab.fmt === 1) {
                    const right = tab.pairsets[coverageIndex];
                    for (let k2 = 0; k2 < right.length; k2++) {
                      if (right[k2].gid2 === glyphId) adj = right[k2];
                    }
                  } else if (tab.fmt === 2) {
                    const c1 = Typr.U._getGlyphClass(glyphIds[prevGlyphIndex], tab.classDef1);
                    const c2 = Typr.U._getGlyphClass(glyphId, tab.classDef2);
                    adj = tab.matrix[c1][c2];
                  }
                  if (adj) {
                    if (adj.val1) applyValueRecord(adj.val1, prevGlyphIndex);
                    if (adj.val2) applyValueRecord(adj.val2, glyphIndex);
                    break;
                  }
                }
              }
            } else if (lookup.ltype === 4) {
              const markArrIndex = Typr._lctf.coverageIndex(tab.markCoverage, glyphId);
              if (markArrIndex !== -1) {
                const baseGlyphIndex = getPrevGlyphIndex(isBaseGlyph);
                const baseArrIndex = baseGlyphIndex === -1 ? -1 : Typr._lctf.coverageIndex(tab.baseCoverage, glyphIds[baseGlyphIndex]);
                if (baseArrIndex !== -1) {
                  const markRecord = tab.markArray[markArrIndex];
                  const baseAnchor = tab.baseArray[baseArrIndex][markRecord.markClass];
                  positions[glyphIndex * 3] = baseAnchor.x - markRecord.x + positions[baseGlyphIndex * 3] - positions[baseGlyphIndex * 3 + 2];
                  positions[glyphIndex * 3 + 1] = baseAnchor.y - markRecord.y + positions[baseGlyphIndex * 3 + 1];
                  break;
                }
              }
            } else if (lookup.ltype === 6) {
              const mark1ArrIndex = Typr._lctf.coverageIndex(tab.mark1Coverage, glyphId);
              if (mark1ArrIndex !== -1) {
                const prevGlyphIndex = getPrevGlyphIndex();
                if (prevGlyphIndex !== -1) {
                  const prevGlyphId = glyphIds[prevGlyphIndex];
                  if (getGlyphClass(font, prevGlyphId) === 3) {
                    const mark2ArrIndex = Typr._lctf.coverageIndex(tab.mark2Coverage, prevGlyphId);
                    if (mark2ArrIndex !== -1) {
                      const mark1Record = tab.mark1Array[mark1ArrIndex];
                      const mark2Anchor = tab.mark2Array[mark2ArrIndex][mark1Record.markClass];
                      positions[glyphIndex * 3] = mark2Anchor.x - mark1Record.x + positions[prevGlyphIndex * 3] - positions[prevGlyphIndex * 3 + 2];
                      positions[glyphIndex * 3 + 1] = mark2Anchor.y - mark1Record.y + positions[prevGlyphIndex * 3 + 1];
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      } else if (font.kern && !font.cff) {
        const prevGlyphIndex = getPrevGlyphIndex();
        if (prevGlyphIndex !== -1) {
          const ind1 = font.kern.glyph1.indexOf(glyphIds[prevGlyphIndex]);
          if (ind1 !== -1) {
            const ind2 = font.kern.rval[ind1].glyph2.indexOf(glyphId);
            if (ind2 !== -1) {
              positions[prevGlyphIndex * 3 + 2] += font.kern.rval[ind1].vals[ind2];
            }
          }
        }
      }
    }
    return positions;
    function getPrevGlyphIndex(filter) {
      for (let i2 = glyphIndex - 1; i2 >= 0; i2--) {
        if (glyphIds[i2] !== -1 && (!filter || filter(glyphIds[i2]))) {
          return i2;
        }
      }
      return -1;
    }
    function isBaseGlyph(glyphId) {
      return getGlyphClass(font, glyphId) === 1;
    }
    function applyValueRecord(source, gi) {
      for (let i2 = 0; i2 < 3; i2++) {
        positions[gi * 3 + i2] += source[i2] || 0;
      }
    }
  }
  function getGlyphClass(font, glyphId) {
    const classDef = font.GDEF && font.GDEF.glyphClassDef;
    return classDef ? Typr.U._getGlyphClass(glyphId, classDef) : 0;
  }
  function firstNum(...args) {
    for (let i2 = 0; i2 < args.length; i2++) {
      if (typeof args[i2] === "number") {
        return args[i2];
      }
    }
  }
  function wrapFontObj(typrFont) {
    const glyphMap = /* @__PURE__ */ Object.create(null);
    const os2 = typrFont["OS/2"];
    const hhea = typrFont.hhea;
    const unitsPerEm = typrFont.head.unitsPerEm;
    const ascender = firstNum(os2 && os2.sTypoAscender, hhea && hhea.ascender, unitsPerEm);
    const fontObj = {
      unitsPerEm,
      ascender,
      descender: firstNum(os2 && os2.sTypoDescender, hhea && hhea.descender, 0),
      capHeight: firstNum(os2 && os2.sCapHeight, ascender),
      xHeight: firstNum(os2 && os2.sxHeight, ascender),
      lineGap: firstNum(os2 && os2.sTypoLineGap, hhea && hhea.lineGap),
      supportsCodePoint(code) {
        return Typr.U.codeToGlyph(typrFont, code) > 0;
      },
      forEachGlyph(text, fontSize, letterSpacing, callback) {
        let penX = 0;
        const fontScale = 1 / fontObj.unitsPerEm * fontSize;
        const glyphIds = stringToGlyphs(typrFont, text);
        let charIndex = 0;
        const positions = calcGlyphPositions(typrFont, glyphIds);
        glyphIds.forEach((glyphId, i2) => {
          if (glyphId !== -1) {
            let glyphObj = glyphMap[glyphId];
            if (!glyphObj) {
              const { cmds, crds } = Typr.U.glyphToPath(typrFont, glyphId);
              let path = "";
              let crdsIdx = 0;
              for (let i3 = 0, len = cmds.length; i3 < len; i3++) {
                const numArgs = cmdArgLengths[cmds[i3]];
                path += cmds[i3];
                for (let j3 = 1; j3 <= numArgs; j3++) {
                  path += (j3 > 1 ? "," : "") + crds[crdsIdx++];
                }
              }
              let xMin, yMin, xMax, yMax;
              if (crds.length) {
                xMin = yMin = Infinity;
                xMax = yMax = -Infinity;
                for (let i3 = 0, len = crds.length; i3 < len; i3 += 2) {
                  let x3 = crds[i3];
                  let y2 = crds[i3 + 1];
                  if (x3 < xMin) xMin = x3;
                  if (y2 < yMin) yMin = y2;
                  if (x3 > xMax) xMax = x3;
                  if (y2 > yMax) yMax = y2;
                }
              } else {
                xMin = xMax = yMin = yMax = 0;
              }
              glyphObj = glyphMap[glyphId] = {
                index: glyphId,
                advanceWidth: typrFont.hmtx.aWidth[glyphId],
                xMin,
                yMin,
                xMax,
                yMax,
                path
              };
            }
            callback.call(
              null,
              glyphObj,
              penX + positions[i2 * 3] * fontScale,
              positions[i2 * 3 + 1] * fontScale,
              charIndex
            );
            penX += positions[i2 * 3 + 2] * fontScale;
            if (letterSpacing) {
              penX += letterSpacing * fontSize;
            }
          }
          charIndex += text.codePointAt(charIndex) > 65535 ? 2 : 1;
        });
        return penX;
      }
    };
    return fontObj;
  }
  return function parse(buffer) {
    const peek = new Uint8Array(buffer, 0, 4);
    const tag = Typr._bin.readASCII(peek, 0, 4);
    if (tag === "wOFF") {
      buffer = woff2otf(buffer);
    } else if (tag === "wOF2") {
      throw new Error("woff2 fonts not supported");
    }
    return wrapFontObj(Typr.parse(buffer)[0]);
  };
}
const workerModule = /* @__PURE__ */ defineWorkerModule({
  name: "Typr Font Parser",
  dependencies: [typrFactory, woff2otfFactory, parserFactory],
  init(typrFactory2, woff2otfFactory2, parserFactory2) {
    const Typr = typrFactory2();
    const woff2otf = woff2otfFactory2();
    return parserFactory2(Typr, woff2otf);
  }
});
function unicodeFontResolverClientFactory() {
  return (function(t2) {
    var n2 = function() {
      this.buckets = /* @__PURE__ */ new Map();
    };
    n2.prototype.add = function(t3) {
      var n3 = t3 >> 5;
      this.buckets.set(n3, (this.buckets.get(n3) || 0) | 1 << (31 & t3));
    }, n2.prototype.has = function(t3) {
      var n3 = this.buckets.get(t3 >> 5);
      return void 0 !== n3 && 0 != (n3 & 1 << (31 & t3));
    }, n2.prototype.serialize = function() {
      var t3 = [];
      return this.buckets.forEach((function(n3, r4) {
        t3.push((+r4).toString(36) + ":" + n3.toString(36));
      })), t3.join(",");
    }, n2.prototype.deserialize = function(t3) {
      var n3 = this;
      this.buckets.clear(), t3.split(",").forEach((function(t4) {
        var r4 = t4.split(":");
        n3.buckets.set(parseInt(r4[0], 36), parseInt(r4[1], 36));
      }));
    };
    var r3 = Math.pow(2, 8), e2 = r3 - 1, o2 = ~e2;
    function a5(t3) {
      var n3 = (function(t4) {
        return t4 & o2;
      })(t3).toString(16), e3 = (function(t4) {
        return (t4 & o2) + r3 - 1;
      })(t3).toString(16);
      return "codepoint-index/plane" + (t3 >> 16) + "/" + n3 + "-" + e3 + ".json";
    }
    function i2(t3, n3) {
      var r4 = t3 & e2, o3 = n3.codePointAt(r4 / 6 | 0);
      return 0 != ((o3 = (o3 || 48) - 48) & 1 << r4 % 6);
    }
    function u2(t3, n3) {
      var r4;
      (r4 = t3, r4.replace(/U\+/gi, "").replace(/^,+|,+$/g, "").split(/,+/).map((function(t4) {
        return t4.split("-").map((function(t5) {
          return parseInt(t5.trim(), 16);
        }));
      }))).forEach((function(t4) {
        var r5 = t4[0], e3 = t4[1];
        void 0 === e3 && (e3 = r5), n3(r5, e3);
      }));
    }
    function c2(t3, n3) {
      u2(t3, (function(t4, r4) {
        for (var e3 = t4; e3 <= r4; e3++) n3(e3);
      }));
    }
    var s2 = {}, f2 = {}, l2 = /* @__PURE__ */ new WeakMap(), v3 = "https://cdn.jsdelivr.net/gh/lojjic/unicode-font-resolver@v1.0.1/packages/data";
    function d3(t3) {
      var r4 = l2.get(t3);
      return r4 || (r4 = new n2(), c2(t3.ranges, (function(t4) {
        return r4.add(t4);
      })), l2.set(t3, r4)), r4;
    }
    var h2, p3 = /* @__PURE__ */ new Map();
    function g2(t3, n3, r4) {
      return t3[n3] ? n3 : t3[r4] ? r4 : (function(t4) {
        for (var n4 in t4) return n4;
      })(t3);
    }
    function w2(t3, n3) {
      var r4 = n3;
      if (!t3.includes(r4)) {
        r4 = 1 / 0;
        for (var e3 = 0; e3 < t3.length; e3++) Math.abs(t3[e3] - n3) < Math.abs(r4 - n3) && (r4 = t3[e3]);
      }
      return r4;
    }
    function k2(t3) {
      return h2 || (h2 = /* @__PURE__ */ new Set(), c2("9-D,20,85,A0,1680,2000-200A,2028-202F,205F,3000", (function(t4) {
        h2.add(t4);
      }))), h2.has(t3);
    }
    return t2.CodePointSet = n2, t2.clearCache = function() {
      s2 = {}, f2 = {};
    }, t2.getFontsForString = function(t3, n3) {
      void 0 === n3 && (n3 = {});
      var r4, e3 = n3.lang;
      void 0 === e3 && (e3 = new RegExp("\\p{Script=Hangul}", "u").test(r4 = t3) ? "ko" : new RegExp("\\p{Script=Hiragana}|\\p{Script=Katakana}", "u").test(r4) ? "ja" : "en");
      var o3 = n3.category;
      void 0 === o3 && (o3 = "sans-serif");
      var u3 = n3.style;
      void 0 === u3 && (u3 = "normal");
      var c5 = n3.weight;
      void 0 === c5 && (c5 = 400);
      var l3 = (n3.dataUrl || v3).replace(/\/$/g, ""), h3 = /* @__PURE__ */ new Map(), y2 = new Uint8Array(t3.length), b6 = {}, m2 = {}, A2 = new Array(t3.length), S2 = /* @__PURE__ */ new Map(), j3 = false;
      function M2(t4) {
        var n4 = p3.get(t4);
        return n4 || (n4 = fetch(l3 + "/" + t4).then((function(t5) {
          if (!t5.ok) throw new Error(t5.statusText);
          return t5.json().then((function(t6) {
            if (!Array.isArray(t6) || 1 !== t6[0]) throw new Error("Incorrect schema version; need 1, got " + t6[0]);
            return t6[1];
          }));
        })).catch((function(n5) {
          if (l3 !== v3) return j3 || (console.error('unicode-font-resolver: Failed loading from dataUrl "' + l3 + '", trying default CDN. ' + n5.message), j3 = true), l3 = v3, p3.delete(t4), M2(t4);
          throw n5;
        })), p3.set(t4, n4)), n4;
      }
      for (var P3 = function(n4) {
        var r5 = t3.codePointAt(n4), e4 = a5(r5);
        A2[n4] = e4, s2[e4] || S2.has(e4) || S2.set(e4, M2(e4).then((function(t4) {
          s2[e4] = t4;
        }))), r5 > 65535 && (n4++, E2 = n4);
      }, E2 = 0; E2 < t3.length; E2++) P3(E2);
      return Promise.all(S2.values()).then((function() {
        S2.clear();
        for (var n4 = function(n5) {
          var o4 = t3.codePointAt(n5), a6 = null, u4 = s2[A2[n5]], c6 = void 0;
          for (var l4 in u4) {
            var v4 = m2[l4];
            if (void 0 === v4 && (v4 = m2[l4] = new RegExp(l4).test(e3 || "en")), v4) {
              for (var d5 in c6 = l4, u4[l4]) if (i2(o4, u4[l4][d5])) {
                a6 = d5;
                break;
              }
              break;
            }
          }
          if (!a6) {
            t: for (var h4 in u4) if (h4 !== c6) {
              for (var p4 in u4[h4]) if (i2(o4, u4[h4][p4])) {
                a6 = p4;
                break t;
              }
            }
          }
          a6 || (console.debug("No font coverage for U+" + o4.toString(16)), a6 = "latin"), A2[n5] = a6, f2[a6] || S2.has(a6) || S2.set(a6, M2("font-meta/" + a6 + ".json").then((function(t4) {
            f2[a6] = t4;
          }))), o4 > 65535 && (n5++, r5 = n5);
        }, r5 = 0; r5 < t3.length; r5++) n4(r5);
        return Promise.all(S2.values());
      })).then((function() {
        for (var n4, r5 = null, e4 = 0; e4 < t3.length; e4++) {
          var a6 = t3.codePointAt(e4);
          if (r5 && (k2(a6) || d3(r5).has(a6))) y2[e4] = y2[e4 - 1];
          else {
            r5 = f2[A2[e4]];
            var i3 = b6[r5.id];
            if (!i3) {
              var s3 = r5.typeforms, v4 = g2(s3, o3, "sans-serif"), p4 = g2(s3[v4], u3, "normal"), m3 = w2(null === (n4 = s3[v4]) || void 0 === n4 ? void 0 : n4[p4], c5);
              i3 = b6[r5.id] = l3 + "/font-files/" + r5.id + "/" + v4 + "." + p4 + "." + m3 + ".woff";
            }
            var S3 = h3.get(i3);
            null == S3 && (S3 = h3.size, h3.set(i3, S3)), y2[e4] = S3;
          }
          a6 > 65535 && (e4++, y2[e4] = y2[e4 - 1]);
        }
        return { fontUrls: Array.from(h3.keys()), chars: y2 };
      }));
    }, Object.defineProperty(t2, "__esModule", { value: true }), t2;
  })({});
}
function createFontResolver(fontParser, unicodeFontResolverClient) {
  const parsedFonts = /* @__PURE__ */ Object.create(null);
  const loadingFonts = /* @__PURE__ */ Object.create(null);
  function doLoadFont(url, callback) {
    const onError = (err) => {
      console.error(`Failure loading font ${url}`, err);
    };
    try {
      const request = new XMLHttpRequest();
      request.open("get", url, true);
      request.responseType = "arraybuffer";
      request.onload = function() {
        if (request.status >= 400) {
          onError(new Error(request.statusText));
        } else if (request.status > 0) {
          try {
            const fontObj = fontParser(request.response);
            fontObj.src = url;
            callback(fontObj);
          } catch (e2) {
            onError(e2);
          }
        }
      };
      request.onerror = onError;
      request.send();
    } catch (err) {
      onError(err);
    }
  }
  function loadFont(fontUrl, callback) {
    let font = parsedFonts[fontUrl];
    if (font) {
      callback(font);
    } else if (loadingFonts[fontUrl]) {
      loadingFonts[fontUrl].push(callback);
    } else {
      loadingFonts[fontUrl] = [callback];
      doLoadFont(fontUrl, (fontObj) => {
        fontObj.src = fontUrl;
        parsedFonts[fontUrl] = fontObj;
        loadingFonts[fontUrl].forEach((cb) => cb(fontObj));
        delete loadingFonts[fontUrl];
      });
    }
  }
  return function(text, callback, {
    lang,
    fonts: userFonts = [],
    style = "normal",
    weight = "normal",
    unicodeFontsURL
  } = {}) {
    const charResolutions = new Uint8Array(text.length);
    const fontResolutions = [];
    if (!text.length) {
      allDone();
    }
    const fontIndices = /* @__PURE__ */ new Map();
    const fallbackRanges = [];
    if (style !== "italic") style = "normal";
    if (typeof weight !== "number") {
      weight = weight === "bold" ? 700 : 400;
    }
    if (userFonts && !Array.isArray(userFonts)) {
      userFonts = [userFonts];
    }
    userFonts = userFonts.slice().filter((def) => !def.lang || def.lang.test(lang)).reverse();
    if (userFonts.length) {
      const UNKNOWN = 0;
      const RESOLVED = 1;
      const NEEDS_FALLBACK = 2;
      let prevCharResult = UNKNOWN;
      (function resolveUserFonts(startIndex = 0) {
        for (let i2 = startIndex, iLen = text.length; i2 < iLen; i2++) {
          const codePoint = text.codePointAt(i2);
          if (prevCharResult === RESOLVED && fontResolutions[charResolutions[i2 - 1]].supportsCodePoint(codePoint) || i2 > 0 && /\s/.test(text[i2])) {
            charResolutions[i2] = charResolutions[i2 - 1];
            if (prevCharResult === NEEDS_FALLBACK) {
              fallbackRanges[fallbackRanges.length - 1][1] = i2;
            }
          } else {
            for (let j3 = charResolutions[i2], jLen = userFonts.length; j3 <= jLen; j3++) {
              if (j3 === jLen) {
                const range = prevCharResult === NEEDS_FALLBACK ? fallbackRanges[fallbackRanges.length - 1] : fallbackRanges[fallbackRanges.length] = [i2, i2];
                range[1] = i2;
                prevCharResult = NEEDS_FALLBACK;
              } else {
                charResolutions[i2] = j3;
                const { src, unicodeRange } = userFonts[j3];
                if (!unicodeRange || isCodeInRanges(codePoint, unicodeRange)) {
                  const fontObj = parsedFonts[src];
                  if (!fontObj) {
                    loadFont(src, () => {
                      resolveUserFonts(i2);
                    });
                    return;
                  }
                  if (fontObj.supportsCodePoint(codePoint)) {
                    let fontIndex = fontIndices.get(fontObj);
                    if (typeof fontIndex !== "number") {
                      fontIndex = fontResolutions.length;
                      fontResolutions.push(fontObj);
                      fontIndices.set(fontObj, fontIndex);
                    }
                    charResolutions[i2] = fontIndex;
                    prevCharResult = RESOLVED;
                    break;
                  }
                }
              }
            }
          }
          if (codePoint > 65535 && i2 + 1 < iLen) {
            charResolutions[i2 + 1] = charResolutions[i2];
            i2++;
            if (prevCharResult === NEEDS_FALLBACK) {
              fallbackRanges[fallbackRanges.length - 1][1] = i2;
            }
          }
        }
        resolveFallbacks();
      })();
    } else {
      fallbackRanges.push([0, text.length - 1]);
      resolveFallbacks();
    }
    function resolveFallbacks() {
      if (fallbackRanges.length) {
        const fallbackString = fallbackRanges.map((range) => text.substring(range[0], range[1] + 1)).join("\n");
        unicodeFontResolverClient.getFontsForString(fallbackString, {
          lang: lang || void 0,
          style,
          weight,
          dataUrl: unicodeFontsURL
        }).then(({ fontUrls, chars }) => {
          const fontIndexOffset = fontResolutions.length;
          let charIdx = 0;
          fallbackRanges.forEach((range) => {
            for (let i2 = 0, endIdx = range[1] - range[0]; i2 <= endIdx; i2++) {
              charResolutions[range[0] + i2] = chars[charIdx++] + fontIndexOffset;
            }
            charIdx++;
          });
          let loadedCount = 0;
          fontUrls.forEach((url, i2) => {
            loadFont(url, (fontObj) => {
              fontResolutions[i2 + fontIndexOffset] = fontObj;
              if (++loadedCount === fontUrls.length) {
                allDone();
              }
            });
          });
        });
      } else {
        allDone();
      }
    }
    function allDone() {
      callback({
        chars: charResolutions,
        fonts: fontResolutions
      });
    }
    function isCodeInRanges(code, ranges) {
      for (let k2 = 0; k2 < ranges.length; k2++) {
        const [start2, end = start2] = ranges[k2];
        if (start2 <= code && code <= end) {
          return true;
        }
      }
      return false;
    }
  };
}
const fontResolverWorkerModule = /* @__PURE__ */ defineWorkerModule({
  name: "FontResolver",
  dependencies: [
    createFontResolver,
    workerModule,
    unicodeFontResolverClientFactory
  ],
  init(createFontResolver2, fontParser, unicodeFontResolverClientFactory2) {
    return createFontResolver2(fontParser, unicodeFontResolverClientFactory2());
  }
});
function createTypesetter(resolveFonts, bidi) {
  const INF = Infinity;
  const DEFAULT_IGNORABLE_CHARS = /[\u00AD\u034F\u061C\u115F-\u1160\u17B4-\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8]/;
  const lineBreakingWhiteSpace = `[^\\S\\u00A0]`;
  const BREAK_AFTER_CHARS = new RegExp(`${lineBreakingWhiteSpace}|[\\-\\u007C\\u00AD\\u2010\\u2012-\\u2014\\u2027\\u2056\\u2E17\\u2E40]`);
  function calculateFontRuns({ text, lang, fonts, style, weight, preResolvedFonts, unicodeFontsURL }, onDone) {
    const onResolved = ({ chars, fonts: parsedFonts }) => {
      let curRun, prevVal;
      const runs = [];
      for (let i2 = 0; i2 < chars.length; i2++) {
        if (chars[i2] !== prevVal) {
          prevVal = chars[i2];
          runs.push(curRun = { start: i2, end: i2, fontObj: parsedFonts[chars[i2]] });
        } else {
          curRun.end = i2;
        }
      }
      onDone(runs);
    };
    if (preResolvedFonts) {
      onResolved(preResolvedFonts);
    } else {
      resolveFonts(
        text,
        onResolved,
        { lang, fonts, style, weight, unicodeFontsURL }
      );
    }
  }
  function typeset({
    text = "",
    font,
    lang,
    sdfGlyphSize = 64,
    fontSize = 400,
    fontWeight = 1,
    fontStyle = "normal",
    letterSpacing = 0,
    lineHeight = "normal",
    maxWidth = INF,
    direction,
    textAlign = "left",
    textIndent = 0,
    whiteSpace = "normal",
    overflowWrap = "normal",
    anchorX = 0,
    anchorY = 0,
    metricsOnly = false,
    unicodeFontsURL,
    preResolvedFonts = null,
    includeCaretPositions = false,
    chunkedBoundsSize = 8192,
    colorRanges = null
  }, callback) {
    const mainStart = now2();
    const timings = { fontLoad: 0, typesetting: 0 };
    if (text.indexOf("\r") > -1) {
      console.info("Typesetter: got text with \\r chars; normalizing to \\n");
      text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    }
    fontSize = +fontSize;
    letterSpacing = +letterSpacing;
    maxWidth = +maxWidth;
    lineHeight = lineHeight || "normal";
    textIndent = +textIndent;
    calculateFontRuns({
      text,
      lang,
      style: fontStyle,
      weight: fontWeight,
      fonts: typeof font === "string" ? [{ src: font }] : font,
      unicodeFontsURL,
      preResolvedFonts
    }, (runs) => {
      timings.fontLoad = now2() - mainStart;
      const hasMaxWidth = isFinite(maxWidth);
      let glyphIds = null;
      let glyphFontIndices = null;
      let glyphPositions = null;
      let glyphData = null;
      let glyphColors = null;
      let caretPositions = null;
      let visibleBounds = null;
      let chunkedBounds = null;
      let maxLineWidth = 0;
      let renderableGlyphCount = 0;
      let canWrap = whiteSpace !== "nowrap";
      const metricsByFont = /* @__PURE__ */ new Map();
      const typesetStart = now2();
      let lineXOffset = textIndent;
      let prevRunEndX = 0;
      let currentLine = new TextLine();
      const lines = [currentLine];
      runs.forEach((run2) => {
        const { fontObj } = run2;
        const { ascender, descender, unitsPerEm, lineGap, capHeight, xHeight } = fontObj;
        let fontData2 = metricsByFont.get(fontObj);
        if (!fontData2) {
          const fontSizeMult2 = fontSize / unitsPerEm;
          const calcLineHeight = lineHeight === "normal" ? (ascender - descender + lineGap) * fontSizeMult2 : lineHeight * fontSize;
          const halfLeading = (calcLineHeight - (ascender - descender) * fontSizeMult2) / 2;
          const caretHeight = Math.min(calcLineHeight, (ascender - descender) * fontSizeMult2);
          const caretTop = (ascender + descender) / 2 * fontSizeMult2 + caretHeight / 2;
          fontData2 = {
            index: metricsByFont.size,
            src: fontObj.src,
            fontObj,
            fontSizeMult: fontSizeMult2,
            unitsPerEm,
            ascender: ascender * fontSizeMult2,
            descender: descender * fontSizeMult2,
            capHeight: capHeight * fontSizeMult2,
            xHeight: xHeight * fontSizeMult2,
            lineHeight: calcLineHeight,
            baseline: -halfLeading - ascender * fontSizeMult2,
            // baseline offset from top of line height
            // cap: -halfLeading - capHeight * fontSizeMult, // cap from top of line height
            // ex: -halfLeading - xHeight * fontSizeMult, // ex from top of line height
            caretTop,
            caretBottom: caretTop - caretHeight
          };
          metricsByFont.set(fontObj, fontData2);
        }
        const { fontSizeMult } = fontData2;
        const runText = text.slice(run2.start, run2.end + 1);
        let prevGlyphX, prevGlyphObj;
        fontObj.forEachGlyph(runText, fontSize, letterSpacing, (glyphObj, glyphX, glyphY, charIndex) => {
          glyphX += prevRunEndX;
          charIndex += run2.start;
          prevGlyphX = glyphX;
          prevGlyphObj = glyphObj;
          const char = text.charAt(charIndex);
          const glyphWidth = glyphObj.advanceWidth * fontSizeMult;
          const curLineCount = currentLine.count;
          let nextLine;
          if (!("isEmpty" in glyphObj)) {
            glyphObj.isWhitespace = !!char && new RegExp(lineBreakingWhiteSpace).test(char);
            glyphObj.canBreakAfter = !!char && BREAK_AFTER_CHARS.test(char);
            glyphObj.isEmpty = glyphObj.xMin === glyphObj.xMax || glyphObj.yMin === glyphObj.yMax || DEFAULT_IGNORABLE_CHARS.test(char);
          }
          if (!glyphObj.isWhitespace && !glyphObj.isEmpty) {
            renderableGlyphCount++;
          }
          if (canWrap && hasMaxWidth && !glyphObj.isWhitespace && glyphX + glyphWidth + lineXOffset > maxWidth && curLineCount) {
            if (currentLine.glyphAt(curLineCount - 1).glyphObj.canBreakAfter) {
              nextLine = new TextLine();
              lineXOffset = -glyphX;
            } else {
              for (let i2 = curLineCount; i2--; ) {
                if (i2 === 0 && overflowWrap === "break-word") {
                  nextLine = new TextLine();
                  lineXOffset = -glyphX;
                  break;
                } else if (currentLine.glyphAt(i2).glyphObj.canBreakAfter) {
                  nextLine = currentLine.splitAt(i2 + 1);
                  const adjustX = nextLine.glyphAt(0).x;
                  lineXOffset -= adjustX;
                  for (let j3 = nextLine.count; j3--; ) {
                    nextLine.glyphAt(j3).x -= adjustX;
                  }
                  break;
                }
              }
            }
            if (nextLine) {
              currentLine.isSoftWrapped = true;
              currentLine = nextLine;
              lines.push(currentLine);
              maxLineWidth = maxWidth;
            }
          }
          let fly = currentLine.glyphAt(currentLine.count);
          fly.glyphObj = glyphObj;
          fly.x = glyphX + lineXOffset;
          fly.y = glyphY;
          fly.width = glyphWidth;
          fly.charIndex = charIndex;
          fly.fontData = fontData2;
          if (char === "\n") {
            currentLine = new TextLine();
            lines.push(currentLine);
            lineXOffset = -(glyphX + glyphWidth + letterSpacing * fontSize) + textIndent;
          }
        });
        prevRunEndX = prevGlyphX + prevGlyphObj.advanceWidth * fontSizeMult + letterSpacing * fontSize;
      });
      let totalHeight = 0;
      lines.forEach((line) => {
        let isTrailingWhitespace = true;
        for (let i2 = line.count; i2--; ) {
          const glyphInfo = line.glyphAt(i2);
          if (isTrailingWhitespace && !glyphInfo.glyphObj.isWhitespace) {
            line.width = glyphInfo.x + glyphInfo.width;
            if (line.width > maxLineWidth) {
              maxLineWidth = line.width;
            }
            isTrailingWhitespace = false;
          }
          let { lineHeight: lineHeight2, capHeight, xHeight, baseline } = glyphInfo.fontData;
          if (lineHeight2 > line.lineHeight) line.lineHeight = lineHeight2;
          const baselineDiff = baseline - line.baseline;
          if (baselineDiff < 0) {
            line.baseline += baselineDiff;
            line.cap += baselineDiff;
            line.ex += baselineDiff;
          }
          line.cap = Math.max(line.cap, line.baseline + capHeight);
          line.ex = Math.max(line.ex, line.baseline + xHeight);
        }
        line.baseline -= totalHeight;
        line.cap -= totalHeight;
        line.ex -= totalHeight;
        totalHeight += line.lineHeight;
      });
      let anchorXOffset = 0;
      let anchorYOffset = 0;
      if (anchorX) {
        if (typeof anchorX === "number") {
          anchorXOffset = -anchorX;
        } else if (typeof anchorX === "string") {
          anchorXOffset = -maxLineWidth * (anchorX === "left" ? 0 : anchorX === "center" ? 0.5 : anchorX === "right" ? 1 : parsePercent(anchorX));
        }
      }
      if (anchorY) {
        if (typeof anchorY === "number") {
          anchorYOffset = -anchorY;
        } else if (typeof anchorY === "string") {
          anchorYOffset = anchorY === "top" ? 0 : anchorY === "top-baseline" ? -lines[0].baseline : anchorY === "top-cap" ? -lines[0].cap : anchorY === "top-ex" ? -lines[0].ex : anchorY === "middle" ? totalHeight / 2 : anchorY === "bottom" ? totalHeight : anchorY === "bottom-baseline" ? -lines[lines.length - 1].baseline : parsePercent(anchorY) * totalHeight;
        }
      }
      if (!metricsOnly) {
        const bidiLevelsResult = bidi.getEmbeddingLevels(text, direction);
        glyphIds = new Uint16Array(renderableGlyphCount);
        glyphFontIndices = new Uint8Array(renderableGlyphCount);
        glyphPositions = new Float32Array(renderableGlyphCount * 2);
        glyphData = {};
        visibleBounds = [INF, INF, -INF, -INF];
        chunkedBounds = [];
        if (includeCaretPositions) {
          caretPositions = new Float32Array(text.length * 4);
        }
        if (colorRanges) {
          glyphColors = new Uint8Array(renderableGlyphCount * 3);
        }
        let renderableGlyphIndex = 0;
        let prevCharIndex = -1;
        let colorCharIndex = -1;
        let chunk;
        let currentColor;
        lines.forEach((line, lineIndex) => {
          let { count: lineGlyphCount, width: lineWidth } = line;
          if (lineGlyphCount > 0) {
            let trailingWhitespaceCount = 0;
            for (let i2 = lineGlyphCount; i2-- && line.glyphAt(i2).glyphObj.isWhitespace; ) {
              trailingWhitespaceCount++;
            }
            let lineXOffset2 = 0;
            let justifyAdjust = 0;
            if (textAlign === "center") {
              lineXOffset2 = (maxLineWidth - lineWidth) / 2;
            } else if (textAlign === "right") {
              lineXOffset2 = maxLineWidth - lineWidth;
            } else if (textAlign === "justify" && line.isSoftWrapped) {
              let whitespaceCount = 0;
              for (let i2 = lineGlyphCount - trailingWhitespaceCount; i2--; ) {
                if (line.glyphAt(i2).glyphObj.isWhitespace) {
                  whitespaceCount++;
                }
              }
              justifyAdjust = (maxLineWidth - lineWidth) / whitespaceCount;
            }
            if (justifyAdjust || lineXOffset2) {
              let justifyOffset = 0;
              for (let i2 = 0; i2 < lineGlyphCount; i2++) {
                let glyphInfo = line.glyphAt(i2);
                const glyphObj2 = glyphInfo.glyphObj;
                glyphInfo.x += lineXOffset2 + justifyOffset;
                if (justifyAdjust !== 0 && glyphObj2.isWhitespace && i2 < lineGlyphCount - trailingWhitespaceCount) {
                  justifyOffset += justifyAdjust;
                  glyphInfo.width += justifyAdjust;
                }
              }
            }
            const flips = bidi.getReorderSegments(
              text,
              bidiLevelsResult,
              line.glyphAt(0).charIndex,
              line.glyphAt(line.count - 1).charIndex
            );
            for (let fi = 0; fi < flips.length; fi++) {
              const [start2, end] = flips[fi];
              let left = Infinity, right = -Infinity;
              for (let i2 = 0; i2 < lineGlyphCount; i2++) {
                if (line.glyphAt(i2).charIndex >= start2) {
                  let startInLine = i2, endInLine = i2;
                  for (; endInLine < lineGlyphCount; endInLine++) {
                    let info = line.glyphAt(endInLine);
                    if (info.charIndex > end) {
                      break;
                    }
                    if (endInLine < lineGlyphCount - trailingWhitespaceCount) {
                      left = Math.min(left, info.x);
                      right = Math.max(right, info.x + info.width);
                    }
                  }
                  for (let j3 = startInLine; j3 < endInLine; j3++) {
                    const glyphInfo = line.glyphAt(j3);
                    glyphInfo.x = right - (glyphInfo.x + glyphInfo.width - left);
                  }
                  break;
                }
              }
            }
            let glyphObj;
            const setGlyphObj = (g2) => glyphObj = g2;
            for (let i2 = 0; i2 < lineGlyphCount; i2++) {
              const glyphInfo = line.glyphAt(i2);
              glyphObj = glyphInfo.glyphObj;
              const glyphId = glyphObj.index;
              const rtl = bidiLevelsResult.levels[glyphInfo.charIndex] & 1;
              if (rtl) {
                const mirrored = bidi.getMirroredCharacter(text[glyphInfo.charIndex]);
                if (mirrored) {
                  glyphInfo.fontData.fontObj.forEachGlyph(mirrored, 0, 0, setGlyphObj);
                }
              }
              if (includeCaretPositions) {
                const { charIndex, fontData: fontData2 } = glyphInfo;
                const caretLeft = glyphInfo.x + anchorXOffset;
                const caretRight = glyphInfo.x + glyphInfo.width + anchorXOffset;
                caretPositions[charIndex * 4] = rtl ? caretRight : caretLeft;
                caretPositions[charIndex * 4 + 1] = rtl ? caretLeft : caretRight;
                caretPositions[charIndex * 4 + 2] = line.baseline + fontData2.caretBottom + anchorYOffset;
                caretPositions[charIndex * 4 + 3] = line.baseline + fontData2.caretTop + anchorYOffset;
                const ligCount = charIndex - prevCharIndex;
                if (ligCount > 1) {
                  fillLigatureCaretPositions(caretPositions, prevCharIndex, ligCount);
                }
                prevCharIndex = charIndex;
              }
              if (colorRanges) {
                const { charIndex } = glyphInfo;
                while (charIndex > colorCharIndex) {
                  colorCharIndex++;
                  if (colorRanges.hasOwnProperty(colorCharIndex)) {
                    currentColor = colorRanges[colorCharIndex];
                  }
                }
              }
              if (!glyphObj.isWhitespace && !glyphObj.isEmpty) {
                const idx = renderableGlyphIndex++;
                const { fontSizeMult, src: fontSrc, index: fontIndex } = glyphInfo.fontData;
                const fontGlyphData = glyphData[fontSrc] || (glyphData[fontSrc] = {});
                if (!fontGlyphData[glyphId]) {
                  fontGlyphData[glyphId] = {
                    path: glyphObj.path,
                    pathBounds: [glyphObj.xMin, glyphObj.yMin, glyphObj.xMax, glyphObj.yMax]
                  };
                }
                const glyphX = glyphInfo.x + anchorXOffset;
                const glyphY = glyphInfo.y + line.baseline + anchorYOffset;
                glyphPositions[idx * 2] = glyphX;
                glyphPositions[idx * 2 + 1] = glyphY;
                const visX0 = glyphX + glyphObj.xMin * fontSizeMult;
                const visY0 = glyphY + glyphObj.yMin * fontSizeMult;
                const visX1 = glyphX + glyphObj.xMax * fontSizeMult;
                const visY1 = glyphY + glyphObj.yMax * fontSizeMult;
                if (visX0 < visibleBounds[0]) visibleBounds[0] = visX0;
                if (visY0 < visibleBounds[1]) visibleBounds[1] = visY0;
                if (visX1 > visibleBounds[2]) visibleBounds[2] = visX1;
                if (visY1 > visibleBounds[3]) visibleBounds[3] = visY1;
                if (idx % chunkedBoundsSize === 0) {
                  chunk = { start: idx, end: idx, rect: [INF, INF, -INF, -INF] };
                  chunkedBounds.push(chunk);
                }
                chunk.end++;
                const chunkRect = chunk.rect;
                if (visX0 < chunkRect[0]) chunkRect[0] = visX0;
                if (visY0 < chunkRect[1]) chunkRect[1] = visY0;
                if (visX1 > chunkRect[2]) chunkRect[2] = visX1;
                if (visY1 > chunkRect[3]) chunkRect[3] = visY1;
                glyphIds[idx] = glyphId;
                glyphFontIndices[idx] = fontIndex;
                if (colorRanges) {
                  const start2 = idx * 3;
                  glyphColors[start2] = currentColor >> 16 & 255;
                  glyphColors[start2 + 1] = currentColor >> 8 & 255;
                  glyphColors[start2 + 2] = currentColor & 255;
                }
              }
            }
          }
        });
        if (caretPositions) {
          const ligCount = text.length - prevCharIndex;
          if (ligCount > 1) {
            fillLigatureCaretPositions(caretPositions, prevCharIndex, ligCount);
          }
        }
      }
      const fontData = [];
      metricsByFont.forEach(({ index, src, unitsPerEm, ascender, descender, lineHeight: lineHeight2, capHeight, xHeight }) => {
        fontData[index] = { src, unitsPerEm, ascender, descender, lineHeight: lineHeight2, capHeight, xHeight };
      });
      timings.typesetting = now2() - typesetStart;
      callback({
        glyphIds,
        //id for each glyph, specific to that glyph's font
        glyphFontIndices,
        //index into fontData for each glyph
        glyphPositions,
        //x,y of each glyph's origin in layout
        glyphData,
        //dict holding data about each glyph appearing in the text
        fontData,
        //data about each font used in the text
        caretPositions,
        //startX,endX,bottomY caret positions for each char
        // caretHeight, //height of cursor from bottom to top - todo per glyph?
        glyphColors,
        //color for each glyph, if color ranges supplied
        chunkedBounds,
        //total rects per (n=chunkedBoundsSize) consecutive glyphs
        fontSize,
        //calculated em height
        topBaseline: anchorYOffset + lines[0].baseline,
        //y coordinate of the top line's baseline
        blockBounds: [
          //bounds for the whole block of text, including vertical padding for lineHeight
          anchorXOffset,
          anchorYOffset - totalHeight,
          anchorXOffset + maxLineWidth,
          anchorYOffset
        ],
        visibleBounds,
        //total bounds of visible text paths, may be larger or smaller than blockBounds
        timings
      });
    });
  }
  function measure(args, callback) {
    typeset({ ...args, metricsOnly: true }, (result) => {
      const [x0, y0, x1, y1] = result.blockBounds;
      callback({
        width: x1 - x0,
        height: y1 - y0
      });
    });
  }
  function parsePercent(str) {
    let match = str.match(/^([\d.]+)%$/);
    let pct = match ? parseFloat(match[1]) : NaN;
    return isNaN(pct) ? 0 : pct / 100;
  }
  function fillLigatureCaretPositions(caretPositions, ligStartIndex, ligCount) {
    const ligStartX = caretPositions[ligStartIndex * 4];
    const ligEndX = caretPositions[ligStartIndex * 4 + 1];
    const ligBottom = caretPositions[ligStartIndex * 4 + 2];
    const ligTop = caretPositions[ligStartIndex * 4 + 3];
    const guessedAdvanceX = (ligEndX - ligStartX) / ligCount;
    for (let i2 = 0; i2 < ligCount; i2++) {
      const startIndex = (ligStartIndex + i2) * 4;
      caretPositions[startIndex] = ligStartX + guessedAdvanceX * i2;
      caretPositions[startIndex + 1] = ligStartX + guessedAdvanceX * (i2 + 1);
      caretPositions[startIndex + 2] = ligBottom;
      caretPositions[startIndex + 3] = ligTop;
    }
  }
  function now2() {
    return (self.performance || Date).now();
  }
  function TextLine() {
    this.data = [];
  }
  const textLineProps = ["glyphObj", "x", "y", "width", "charIndex", "fontData"];
  TextLine.prototype = {
    width: 0,
    lineHeight: 0,
    baseline: 0,
    cap: 0,
    ex: 0,
    isSoftWrapped: false,
    get count() {
      return Math.ceil(this.data.length / textLineProps.length);
    },
    glyphAt(i2) {
      let fly = TextLine.flyweight;
      fly.data = this.data;
      fly.index = i2;
      return fly;
    },
    splitAt(i2) {
      let newLine = new TextLine();
      newLine.data = this.data.splice(i2 * textLineProps.length);
      return newLine;
    }
  };
  TextLine.flyweight = textLineProps.reduce((obj, prop, i2, all) => {
    Object.defineProperty(obj, prop, {
      get() {
        return this.data[this.index * textLineProps.length + i2];
      },
      set(val) {
        this.data[this.index * textLineProps.length + i2] = val;
      }
    });
    return obj;
  }, { data: null, index: 0 });
  return {
    typeset,
    measure
  };
}
const now = () => (self.performance || Date).now();
const mainThreadGenerator = /* @__PURE__ */ SDFGenerator();
let warned;
function generateSDF(width, height, path, viewBox, distance, exponent, canvas, x3, y2, channel, useWebGL = true) {
  if (!useWebGL) {
    return generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x3, y2, channel);
  }
  return generateSDF_GL(width, height, path, viewBox, distance, exponent, canvas, x3, y2, channel).then(
    null,
    (err) => {
      if (!warned) {
        console.warn(`WebGL SDF generation failed, falling back to JS`, err);
        warned = true;
      }
      return generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x3, y2, channel);
    }
  );
}
const queue = [];
const chunkTimeBudget = 5;
let timer = 0;
function nextChunk() {
  const start2 = now();
  while (queue.length && now() - start2 < chunkTimeBudget) {
    queue.shift()();
  }
  timer = queue.length ? setTimeout(nextChunk, 0) : 0;
}
const generateSDF_GL = (...args) => {
  return new Promise((resolve2, reject) => {
    queue.push(() => {
      const start2 = now();
      try {
        mainThreadGenerator.webgl.generateIntoCanvas(...args);
        resolve2({ timing: now() - start2 });
      } catch (err) {
        reject(err);
      }
    });
    if (!timer) {
      timer = setTimeout(nextChunk, 0);
    }
  });
};
const threadCount = 4;
const idleTimeout = 2e3;
const threads = {};
let callNum = 0;
function generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x3, y2, channel) {
  const workerId = "TroikaTextSDFGenerator_JS_" + callNum++ % threadCount;
  let thread = threads[workerId];
  if (!thread) {
    thread = threads[workerId] = {
      workerModule: defineWorkerModule({
        name: workerId,
        workerId,
        dependencies: [
          SDFGenerator,
          now
        ],
        init(_createSDFGenerator, now2) {
          const generate = _createSDFGenerator().javascript.generate;
          return function(...args) {
            const start2 = now2();
            const textureData = generate(...args);
            return {
              textureData,
              timing: now2() - start2
            };
          };
        },
        getTransferables(result) {
          return [result.textureData.buffer];
        }
      }),
      requests: 0,
      idleTimer: null
    };
  }
  thread.requests++;
  clearTimeout(thread.idleTimer);
  return thread.workerModule(width, height, path, viewBox, distance, exponent).then(({ textureData, timing }) => {
    const start2 = now();
    const imageData = new Uint8Array(textureData.length * 4);
    for (let i2 = 0; i2 < textureData.length; i2++) {
      imageData[i2 * 4 + channel] = textureData[i2];
    }
    mainThreadGenerator.webglUtils.renderImageData(canvas, imageData, x3, y2, width, height, 1 << 3 - channel);
    timing += now() - start2;
    if (--thread.requests === 0) {
      thread.idleTimer = setTimeout(() => {
        terminateWorker(workerId);
      }, idleTimeout);
    }
    return { timing };
  });
}
function warmUpSDFCanvas(canvas) {
  if (!canvas._warm) {
    mainThreadGenerator.webgl.isSupported(canvas);
    canvas._warm = true;
  }
}
const resizeWebGLCanvasWithoutClearing = mainThreadGenerator.webglUtils.resizeWebGLCanvasWithoutClearing;
const CONFIG = {
  unicodeFontsURL: null,
  sdfGlyphSize: 64,
  sdfMargin: 1 / 16,
  sdfExponent: 9,
  textureWidth: 2048
};
const tempColor = /* @__PURE__ */ new Color();
function now$1() {
  return (self.performance || Date).now();
}
const atlases = /* @__PURE__ */ Object.create(null);
function getTextRenderInfo(args, callback) {
  args = assign$1({}, args);
  const totalStart = now$1();
  const fonts = [];
  if (args.font) {
    fonts.push({ label: "user", src: toAbsoluteURL(args.font) });
  }
  args.font = fonts;
  args.text = "" + args.text;
  args.sdfGlyphSize = args.sdfGlyphSize || CONFIG.sdfGlyphSize;
  args.unicodeFontsURL = args.unicodeFontsURL || CONFIG.unicodeFontsURL;
  if (args.colorRanges != null) {
    let colors3 = {};
    for (let key in args.colorRanges) {
      if (args.colorRanges.hasOwnProperty(key)) {
        let val = args.colorRanges[key];
        if (typeof val !== "number") {
          val = tempColor.set(val).getHex();
        }
        colors3[key] = val;
      }
    }
    args.colorRanges = colors3;
  }
  Object.freeze(args);
  const { textureWidth, sdfExponent } = CONFIG;
  const { sdfGlyphSize } = args;
  const glyphsPerRow = textureWidth / sdfGlyphSize * 4;
  let atlas = atlases[sdfGlyphSize];
  if (!atlas) {
    const canvas = document.createElement("canvas");
    canvas.width = textureWidth;
    canvas.height = sdfGlyphSize * 256 / glyphsPerRow;
    atlas = atlases[sdfGlyphSize] = {
      glyphCount: 0,
      sdfGlyphSize,
      sdfCanvas: canvas,
      sdfTexture: new Texture(
        canvas,
        void 0,
        void 0,
        void 0,
        LinearFilter,
        LinearFilter
      ),
      contextLost: false,
      glyphsByFont: /* @__PURE__ */ new Map()
    };
    atlas.sdfTexture.generateMipmaps = false;
    initContextLossHandling(atlas);
  }
  const { sdfTexture, sdfCanvas } = atlas;
  const typeset = typesetInWorker;
  typeset(args).then((result) => {
    const { glyphIds, glyphFontIndices, fontData, glyphPositions, fontSize, timings } = result;
    const neededSDFs = [];
    const glyphBounds = new Float32Array(glyphIds.length * 4);
    let boundsIdx = 0;
    let positionsIdx = 0;
    const quadsStart = now$1();
    const fontGlyphMaps = fontData.map((font) => {
      let map = atlas.glyphsByFont.get(font.src);
      if (!map) {
        atlas.glyphsByFont.set(font.src, map = /* @__PURE__ */ new Map());
      }
      return map;
    });
    glyphIds.forEach((glyphId, i2) => {
      const fontIndex = glyphFontIndices[i2];
      const { src: fontSrc, unitsPerEm } = fontData[fontIndex];
      let glyphInfo = fontGlyphMaps[fontIndex].get(glyphId);
      if (!glyphInfo) {
        const { path, pathBounds } = result.glyphData[fontSrc][glyphId];
        const fontUnitsMargin = Math.max(pathBounds[2] - pathBounds[0], pathBounds[3] - pathBounds[1]) / sdfGlyphSize * (CONFIG.sdfMargin * sdfGlyphSize + 0.5);
        const atlasIndex = atlas.glyphCount++;
        const sdfViewBox2 = [
          pathBounds[0] - fontUnitsMargin,
          pathBounds[1] - fontUnitsMargin,
          pathBounds[2] + fontUnitsMargin,
          pathBounds[3] + fontUnitsMargin
        ];
        fontGlyphMaps[fontIndex].set(glyphId, glyphInfo = { path, atlasIndex, sdfViewBox: sdfViewBox2 });
        neededSDFs.push(glyphInfo);
      }
      const { sdfViewBox } = glyphInfo;
      const posX = glyphPositions[positionsIdx++];
      const posY = glyphPositions[positionsIdx++];
      const fontSizeMult = fontSize / unitsPerEm;
      glyphBounds[boundsIdx++] = posX + sdfViewBox[0] * fontSizeMult;
      glyphBounds[boundsIdx++] = posY + sdfViewBox[1] * fontSizeMult;
      glyphBounds[boundsIdx++] = posX + sdfViewBox[2] * fontSizeMult;
      glyphBounds[boundsIdx++] = posY + sdfViewBox[3] * fontSizeMult;
      glyphIds[i2] = glyphInfo.atlasIndex;
    });
    timings.quads = (timings.quads || 0) + (now$1() - quadsStart);
    const sdfStart = now$1();
    timings.sdf = {};
    const currentHeight = sdfCanvas.height;
    const neededRows = Math.ceil(atlas.glyphCount / glyphsPerRow);
    const neededHeight = Math.pow(2, Math.ceil(Math.log2(neededRows * sdfGlyphSize)));
    if (neededHeight > currentHeight) {
      console.info(`Increasing SDF texture size ${currentHeight}->${neededHeight}`);
      resizeWebGLCanvasWithoutClearing(sdfCanvas, textureWidth, neededHeight);
      sdfTexture.dispose();
    }
    Promise.all(neededSDFs.map(
      (glyphInfo) => generateGlyphSDF(glyphInfo, atlas, args.gpuAccelerateSDF).then(({ timing }) => {
        timings.sdf[glyphInfo.atlasIndex] = timing;
      })
    )).then(() => {
      if (neededSDFs.length && !atlas.contextLost) {
        safariPre15Workaround(atlas);
        sdfTexture.needsUpdate = true;
      }
      timings.sdfTotal = now$1() - sdfStart;
      timings.total = now$1() - totalStart;
      callback(Object.freeze({
        parameters: args,
        sdfTexture,
        sdfGlyphSize,
        sdfExponent,
        glyphBounds,
        glyphAtlasIndices: glyphIds,
        glyphColors: result.glyphColors,
        caretPositions: result.caretPositions,
        chunkedBounds: result.chunkedBounds,
        ascender: result.ascender,
        descender: result.descender,
        lineHeight: result.lineHeight,
        capHeight: result.capHeight,
        xHeight: result.xHeight,
        topBaseline: result.topBaseline,
        blockBounds: result.blockBounds,
        visibleBounds: result.visibleBounds,
        timings: result.timings
      }));
    });
  });
  Promise.resolve().then(() => {
    if (!atlas.contextLost) {
      warmUpSDFCanvas(sdfCanvas);
    }
  });
}
function generateGlyphSDF({ path, atlasIndex, sdfViewBox }, { sdfGlyphSize, sdfCanvas, contextLost }, useGPU) {
  if (contextLost) {
    return Promise.resolve({ timing: -1 });
  }
  const { textureWidth, sdfExponent } = CONFIG;
  const maxDist = Math.max(sdfViewBox[2] - sdfViewBox[0], sdfViewBox[3] - sdfViewBox[1]);
  const squareIndex = Math.floor(atlasIndex / 4);
  const x3 = squareIndex % (textureWidth / sdfGlyphSize) * sdfGlyphSize;
  const y2 = Math.floor(squareIndex / (textureWidth / sdfGlyphSize)) * sdfGlyphSize;
  const channel = atlasIndex % 4;
  return generateSDF(sdfGlyphSize, sdfGlyphSize, path, sdfViewBox, maxDist, sdfExponent, sdfCanvas, x3, y2, channel, useGPU);
}
function initContextLossHandling(atlas) {
  const canvas = atlas.sdfCanvas;
  canvas.addEventListener("webglcontextlost", (event) => {
    console.log("Context Lost", event);
    event.preventDefault();
    atlas.contextLost = true;
  });
  canvas.addEventListener("webglcontextrestored", (event) => {
    console.log("Context Restored", event);
    atlas.contextLost = false;
    const promises = [];
    atlas.glyphsByFont.forEach((glyphMap) => {
      glyphMap.forEach((glyph) => {
        promises.push(generateGlyphSDF(glyph, atlas, true));
      });
    });
    Promise.all(promises).then(() => {
      safariPre15Workaround(atlas);
      atlas.sdfTexture.needsUpdate = true;
    });
  });
}
function preloadFont({ font, characters, sdfGlyphSize }, callback) {
  let text = Array.isArray(characters) ? characters.join("\n") : "" + characters;
  getTextRenderInfo({ font, sdfGlyphSize, text }, callback);
}
function assign$1(toObj, fromObj) {
  for (let key in fromObj) {
    if (fromObj.hasOwnProperty(key)) {
      toObj[key] = fromObj[key];
    }
  }
  return toObj;
}
let linkEl;
function toAbsoluteURL(path) {
  if (!linkEl) {
    linkEl = typeof document === "undefined" ? {} : document.createElement("a");
  }
  linkEl.href = path;
  return linkEl.href;
}
function safariPre15Workaround(atlas) {
  if (typeof createImageBitmap !== "function") {
    console.info("Safari<15: applying SDF canvas workaround");
    const { sdfCanvas, sdfTexture } = atlas;
    const { width, height } = sdfCanvas;
    const gl = atlas.sdfCanvas.getContext("webgl");
    let pixels = sdfTexture.image.data;
    if (!pixels || pixels.length !== width * height * 4) {
      pixels = new Uint8Array(width * height * 4);
      sdfTexture.image = { width, height, data: pixels };
      sdfTexture.flipY = false;
      sdfTexture.isDataTexture = true;
    }
    gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
  }
}
const typesetterWorkerModule = /* @__PURE__ */ defineWorkerModule({
  name: "Typesetter",
  dependencies: [
    createTypesetter,
    fontResolverWorkerModule,
    bidiFactory
  ],
  init(createTypesetter2, fontResolver, bidiFactory2) {
    return createTypesetter2(fontResolver, bidiFactory2());
  }
});
const typesetInWorker = /* @__PURE__ */ defineWorkerModule({
  name: "Typesetter",
  dependencies: [
    typesetterWorkerModule
  ],
  init(typesetter) {
    return function(args) {
      return new Promise((resolve2) => {
        typesetter.typeset(args, resolve2);
      });
    };
  },
  getTransferables(result) {
    const transferables = [];
    for (let p3 in result) {
      if (result[p3] && result[p3].buffer) {
        transferables.push(result[p3].buffer);
      }
    }
    return transferables;
  }
});
typesetInWorker.onMainThread;
const templateGeometries = {};
function getTemplateGeometry(detail) {
  let geom = templateGeometries[detail];
  if (!geom) {
    geom = templateGeometries[detail] = new PlaneGeometry(1, 1, detail, detail).translate(0.5, 0.5, 0);
  }
  return geom;
}
const glyphBoundsAttrName = "aTroikaGlyphBounds";
const glyphIndexAttrName = "aTroikaGlyphIndex";
const glyphColorAttrName = "aTroikaGlyphColor";
class GlyphsGeometry extends InstancedBufferGeometry {
  constructor() {
    super();
    this.detail = 1;
    this.curveRadius = 0;
    this.groups = [
      { start: 0, count: Infinity, materialIndex: 0 },
      { start: 0, count: Infinity, materialIndex: 1 }
    ];
    this.boundingSphere = new Sphere();
    this.boundingBox = new Box3();
  }
  computeBoundingSphere() {
  }
  computeBoundingBox() {
  }
  set detail(detail) {
    if (detail !== this._detail) {
      this._detail = detail;
      if (typeof detail !== "number" || detail < 1) {
        detail = 1;
      }
      let tpl = getTemplateGeometry(detail);
      ["position", "normal", "uv"].forEach((attr) => {
        this.attributes[attr] = tpl.attributes[attr].clone();
      });
      this.setIndex(tpl.getIndex().clone());
    }
  }
  get detail() {
    return this._detail;
  }
  set curveRadius(r3) {
    if (r3 !== this._curveRadius) {
      this._curveRadius = r3;
      this._updateBounds();
    }
  }
  get curveRadius() {
    return this._curveRadius;
  }
  /**
   * Update the geometry for a new set of glyphs.
   * @param {Float32Array} glyphBounds - An array holding the planar bounds for all glyphs
   *        to be rendered, 4 entries for each glyph: x1,x2,y1,y1
   * @param {Float32Array} glyphAtlasIndices - An array holding the index of each glyph within
   *        the SDF atlas texture.
   * @param {Array} blockBounds - An array holding the [minX, minY, maxX, maxY] across all glyphs
   * @param {Array} [chunkedBounds] - An array of objects describing bounds for each chunk of N
   *        consecutive glyphs: `{start:N, end:N, rect:[minX, minY, maxX, maxY]}`. This can be
   *        used with `applyClipRect` to choose an optimized `instanceCount`.
   * @param {Uint8Array} [glyphColors] - An array holding r,g,b values for each glyph.
   */
  updateGlyphs(glyphBounds, glyphAtlasIndices, blockBounds, chunkedBounds, glyphColors) {
    this.updateAttributeData(glyphBoundsAttrName, glyphBounds, 4);
    this.updateAttributeData(glyphIndexAttrName, glyphAtlasIndices, 1);
    this.updateAttributeData(glyphColorAttrName, glyphColors, 3);
    this._blockBounds = blockBounds;
    this._chunkedBounds = chunkedBounds;
    this.instanceCount = glyphAtlasIndices.length;
    this._updateBounds();
  }
  _updateBounds() {
    const bounds = this._blockBounds;
    if (bounds) {
      const { curveRadius, boundingBox: bbox } = this;
      if (curveRadius) {
        const { PI: PI2, floor, min, max: max2, sin, cos } = Math;
        const halfPi = PI2 / 2;
        const twoPi = PI2 * 2;
        const absR = Math.abs(curveRadius);
        const leftAngle = bounds[0] / absR;
        const rightAngle = bounds[2] / absR;
        const minX = floor((leftAngle + halfPi) / twoPi) !== floor((rightAngle + halfPi) / twoPi) ? -absR : min(sin(leftAngle) * absR, sin(rightAngle) * absR);
        const maxX = floor((leftAngle - halfPi) / twoPi) !== floor((rightAngle - halfPi) / twoPi) ? absR : max2(sin(leftAngle) * absR, sin(rightAngle) * absR);
        const maxZ = floor((leftAngle + PI2) / twoPi) !== floor((rightAngle + PI2) / twoPi) ? absR * 2 : max2(absR - cos(leftAngle) * absR, absR - cos(rightAngle) * absR);
        bbox.min.set(minX, bounds[1], curveRadius < 0 ? -maxZ : 0);
        bbox.max.set(maxX, bounds[3], curveRadius < 0 ? 0 : maxZ);
      } else {
        bbox.min.set(bounds[0], bounds[1], 0);
        bbox.max.set(bounds[2], bounds[3], 0);
      }
      bbox.getBoundingSphere(this.boundingSphere);
    }
  }
  /**
   * Given a clipping rect, and the chunkedBounds from the last updateGlyphs call, choose the lowest
   * `instanceCount` that will show all glyphs within the clipped view. This is an optimization
   * for long blocks of text that are clipped, to skip vertex shader evaluation for glyphs that would
   * be clipped anyway.
   *
   * Note that since `drawElementsInstanced[ANGLE]` only accepts an instance count and not a starting
   * offset, this optimization becomes less effective as the clipRect moves closer to the end of the
   * text block. We could fix that by switching from instancing to a full geometry with a drawRange,
   * but at the expense of much larger attribute buffers (see classdoc above.)
   *
   * @param {Vector4} clipRect
   */
  applyClipRect(clipRect) {
    let count = this.getAttribute(glyphIndexAttrName).count;
    let chunks = this._chunkedBounds;
    if (chunks) {
      for (let i2 = chunks.length; i2--; ) {
        count = chunks[i2].end;
        let rect = chunks[i2].rect;
        if (rect[1] < clipRect.w && rect[3] > clipRect.y && rect[0] < clipRect.z && rect[2] > clipRect.x) {
          break;
        }
      }
    }
    this.instanceCount = count;
  }
  /**
   * Utility for updating instance attributes with automatic resizing
   */
  updateAttributeData(attrName, newArray, itemSize) {
    const attr = this.getAttribute(attrName);
    if (newArray) {
      if (attr && attr.array.length === newArray.length) {
        attr.array.set(newArray);
        attr.needsUpdate = true;
      } else {
        this.setAttribute(attrName, new InstancedBufferAttribute(newArray, itemSize));
        delete this._maxInstanceCount;
        this.dispose();
      }
    } else if (attr) {
      this.deleteAttribute(attrName);
    }
  }
}
const VERTEX_DEFS = `
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform vec4 uTroikaTotalBounds;
uniform vec4 uTroikaClipRect;
uniform mat3 uTroikaOrient;
uniform bool uTroikaUseGlyphColors;
uniform float uTroikaEdgeOffset;
uniform float uTroikaBlurRadius;
uniform vec2 uTroikaPositionOffset;
uniform float uTroikaCurveRadius;
attribute vec4 aTroikaGlyphBounds;
attribute float aTroikaGlyphIndex;
attribute vec3 aTroikaGlyphColor;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec3 vTroikaGlyphColor;
varying vec2 vTroikaGlyphDimensions;
`;
const VERTEX_TRANSFORM = `
vec4 bounds = aTroikaGlyphBounds;
bounds.xz += uTroikaPositionOffset.x;
bounds.yw -= uTroikaPositionOffset.y;

vec4 outlineBounds = vec4(
  bounds.xy - uTroikaEdgeOffset - uTroikaBlurRadius,
  bounds.zw + uTroikaEdgeOffset + uTroikaBlurRadius
);
vec4 clippedBounds = vec4(
  clamp(outlineBounds.xy, uTroikaClipRect.xy, uTroikaClipRect.zw),
  clamp(outlineBounds.zw, uTroikaClipRect.xy, uTroikaClipRect.zw)
);

vec2 clippedXY = (mix(clippedBounds.xy, clippedBounds.zw, position.xy) - bounds.xy) / (bounds.zw - bounds.xy);

position.xy = mix(bounds.xy, bounds.zw, clippedXY);

uv = (position.xy - uTroikaTotalBounds.xy) / (uTroikaTotalBounds.zw - uTroikaTotalBounds.xy);

float rad = uTroikaCurveRadius;
if (rad != 0.0) {
  float angle = position.x / rad;
  position.xz = vec2(sin(angle) * rad, rad - cos(angle) * rad);
  normal.xz = vec2(sin(angle), cos(angle));
}
  
position = uTroikaOrient * position;
normal = uTroikaOrient * normal;

vTroikaGlyphUV = clippedXY.xy;
vTroikaGlyphDimensions = vec2(bounds[2] - bounds[0], bounds[3] - bounds[1]);

${""}
float txCols = uTroikaSDFTextureSize.x / uTroikaSDFGlyphSize;
vec2 txUvPerSquare = uTroikaSDFGlyphSize / uTroikaSDFTextureSize;
vec2 txStartUV = txUvPerSquare * vec2(
  mod(floor(aTroikaGlyphIndex / 4.0), txCols),
  floor(floor(aTroikaGlyphIndex / 4.0) / txCols)
);
vTroikaTextureUVBounds = vec4(txStartUV, vec2(txStartUV) + txUvPerSquare);
vTroikaTextureChannel = mod(aTroikaGlyphIndex, 4.0);
`;
const FRAGMENT_DEFS = `
uniform sampler2D uTroikaSDFTexture;
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform float uTroikaSDFExponent;
uniform float uTroikaEdgeOffset;
uniform float uTroikaFillOpacity;
uniform float uTroikaBlurRadius;
uniform vec3 uTroikaStrokeColor;
uniform float uTroikaStrokeWidth;
uniform float uTroikaStrokeOpacity;
uniform bool uTroikaSDFDebug;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec2 vTroikaGlyphDimensions;

float troikaSdfValueToSignedDistance(float alpha) {
  // Inverse of exponential encoding in webgl-sdf-generator
  ${""}
  float maxDimension = max(vTroikaGlyphDimensions.x, vTroikaGlyphDimensions.y);
  float absDist = (1.0 - pow(2.0 * (alpha > 0.5 ? 1.0 - alpha : alpha), 1.0 / uTroikaSDFExponent)) * maxDimension;
  float signedDist = absDist * (alpha > 0.5 ? -1.0 : 1.0);
  return signedDist;
}

float troikaGlyphUvToSdfValue(vec2 glyphUV) {
  vec2 textureUV = mix(vTroikaTextureUVBounds.xy, vTroikaTextureUVBounds.zw, glyphUV);
  vec4 rgba = texture2D(uTroikaSDFTexture, textureUV);
  float ch = floor(vTroikaTextureChannel + 0.5); //NOTE: can't use round() in WebGL1
  return ch == 0.0 ? rgba.r : ch == 1.0 ? rgba.g : ch == 2.0 ? rgba.b : rgba.a;
}

float troikaGlyphUvToDistance(vec2 uv) {
  return troikaSdfValueToSignedDistance(troikaGlyphUvToSdfValue(uv));
}

float troikaGetAADist() {
  ${""}
  #if defined(GL_OES_standard_derivatives) || __VERSION__ >= 300
  return length(fwidth(vTroikaGlyphUV * vTroikaGlyphDimensions)) * 0.5;
  #else
  return vTroikaGlyphDimensions.x / 64.0;
  #endif
}

float troikaGetFragDistValue() {
  vec2 clampedGlyphUV = clamp(vTroikaGlyphUV, 0.5 / uTroikaSDFGlyphSize, 1.0 - 0.5 / uTroikaSDFGlyphSize);
  float distance = troikaGlyphUvToDistance(clampedGlyphUV);
 
  // Extrapolate distance when outside bounds:
  distance += clampedGlyphUV == vTroikaGlyphUV ? 0.0 : 
    length((vTroikaGlyphUV - clampedGlyphUV) * vTroikaGlyphDimensions);

  ${""}

  return distance;
}

float troikaGetEdgeAlpha(float distance, float distanceOffset, float aaDist) {
  #if defined(IS_DEPTH_MATERIAL) || defined(IS_DISTANCE_MATERIAL)
  float alpha = step(-distanceOffset, -distance);
  #else

  float alpha = smoothstep(
    distanceOffset + aaDist,
    distanceOffset - aaDist,
    distance
  );
  #endif

  return alpha;
}
`;
const FRAGMENT_TRANSFORM = `
float aaDist = troikaGetAADist();
float fragDistance = troikaGetFragDistValue();
float edgeAlpha = uTroikaSDFDebug ?
  troikaGlyphUvToSdfValue(vTroikaGlyphUV) :
  troikaGetEdgeAlpha(fragDistance, uTroikaEdgeOffset, max(aaDist, uTroikaBlurRadius));

#if !defined(IS_DEPTH_MATERIAL) && !defined(IS_DISTANCE_MATERIAL)
vec4 fillRGBA = gl_FragColor;
fillRGBA.a *= uTroikaFillOpacity;
vec4 strokeRGBA = uTroikaStrokeWidth == 0.0 ? fillRGBA : vec4(uTroikaStrokeColor, uTroikaStrokeOpacity);
if (fillRGBA.a == 0.0) fillRGBA.rgb = strokeRGBA.rgb;
gl_FragColor = mix(fillRGBA, strokeRGBA, smoothstep(
  -uTroikaStrokeWidth - aaDist,
  -uTroikaStrokeWidth + aaDist,
  fragDistance
));
gl_FragColor.a *= edgeAlpha;
#endif

if (edgeAlpha == 0.0) {
  discard;
}
`;
function createTextDerivedMaterial(baseMaterial) {
  const textMaterial = createDerivedMaterial(baseMaterial, {
    chained: true,
    extensions: {
      derivatives: true
    },
    uniforms: {
      uTroikaSDFTexture: { value: null },
      uTroikaSDFTextureSize: { value: new Vector2() },
      uTroikaSDFGlyphSize: { value: 0 },
      uTroikaSDFExponent: { value: 0 },
      uTroikaTotalBounds: { value: new Vector4(0, 0, 0, 0) },
      uTroikaClipRect: { value: new Vector4(0, 0, 0, 0) },
      uTroikaEdgeOffset: { value: 0 },
      uTroikaFillOpacity: { value: 1 },
      uTroikaPositionOffset: { value: new Vector2() },
      uTroikaCurveRadius: { value: 0 },
      uTroikaBlurRadius: { value: 0 },
      uTroikaStrokeWidth: { value: 0 },
      uTroikaStrokeColor: { value: new Color() },
      uTroikaStrokeOpacity: { value: 1 },
      uTroikaOrient: { value: new Matrix3() },
      uTroikaUseGlyphColors: { value: true },
      uTroikaSDFDebug: { value: false }
    },
    vertexDefs: VERTEX_DEFS,
    vertexTransform: VERTEX_TRANSFORM,
    fragmentDefs: FRAGMENT_DEFS,
    fragmentColorTransform: FRAGMENT_TRANSFORM,
    customRewriter({ vertexShader: vertexShader2, fragmentShader: fragmentShader2 }) {
      let uDiffuseRE = /\buniform\s+vec3\s+diffuse\b/;
      if (uDiffuseRE.test(fragmentShader2)) {
        fragmentShader2 = fragmentShader2.replace(uDiffuseRE, "varying vec3 vTroikaGlyphColor").replace(/\bdiffuse\b/g, "vTroikaGlyphColor");
        if (!uDiffuseRE.test(vertexShader2)) {
          vertexShader2 = vertexShader2.replace(
            voidMainRegExp,
            "uniform vec3 diffuse;\n$&\nvTroikaGlyphColor = uTroikaUseGlyphColors ? aTroikaGlyphColor / 255.0 : diffuse;\n"
          );
        }
      }
      return { vertexShader: vertexShader2, fragmentShader: fragmentShader2 };
    }
  });
  textMaterial.transparent = true;
  textMaterial.forceSinglePass = true;
  Object.defineProperties(textMaterial, {
    isTroikaTextMaterial: { value: true },
    // WebGLShadowMap reverses the side of the shadow material by default, which fails
    // for planes, so here we force the `shadowSide` to always match the main side.
    shadowSide: {
      get() {
        return this.side;
      },
      set() {
      }
    }
  });
  return textMaterial;
}
const defaultMaterial = /* @__PURE__ */ new MeshBasicMaterial({
  color: 16777215,
  side: DoubleSide,
  transparent: true
});
const defaultStrokeColor = 8421504;
const tempMat4 = /* @__PURE__ */ new Matrix4();
const tempVec3a = /* @__PURE__ */ new Vector3();
const tempVec3b = /* @__PURE__ */ new Vector3();
const tempArray = [];
const origin = /* @__PURE__ */ new Vector3();
const defaultOrient = "+x+y";
function first(o2) {
  return Array.isArray(o2) ? o2[0] : o2;
}
let getFlatRaycastMesh = () => {
  const mesh = new Mesh(
    new PlaneGeometry(1, 1),
    defaultMaterial
  );
  getFlatRaycastMesh = () => mesh;
  return mesh;
};
let getCurvedRaycastMesh = () => {
  const mesh = new Mesh(
    new PlaneGeometry(1, 1, 32, 1),
    defaultMaterial
  );
  getCurvedRaycastMesh = () => mesh;
  return mesh;
};
const syncStartEvent = { type: "syncstart" };
const syncCompleteEvent = { type: "synccomplete" };
const SYNCABLE_PROPS = [
  "font",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "lang",
  "letterSpacing",
  "lineHeight",
  "maxWidth",
  "overflowWrap",
  "text",
  "direction",
  "textAlign",
  "textIndent",
  "whiteSpace",
  "anchorX",
  "anchorY",
  "colorRanges",
  "sdfGlyphSize"
];
const COPYABLE_PROPS = SYNCABLE_PROPS.concat(
  "material",
  "color",
  "depthOffset",
  "clipRect",
  "curveRadius",
  "orientation",
  "glyphGeometryDetail"
);
let Text$1 = class Text extends Mesh {
  constructor() {
    const geometry = new GlyphsGeometry();
    super(geometry, null);
    this.text = "";
    this.anchorX = 0;
    this.anchorY = 0;
    this.curveRadius = 0;
    this.direction = "auto";
    this.font = null;
    this.unicodeFontsURL = null;
    this.fontSize = 0.1;
    this.fontWeight = "normal";
    this.fontStyle = "normal";
    this.lang = null;
    this.letterSpacing = 0;
    this.lineHeight = "normal";
    this.maxWidth = Infinity;
    this.overflowWrap = "normal";
    this.textAlign = "left";
    this.textIndent = 0;
    this.whiteSpace = "normal";
    this.material = null;
    this.color = null;
    this.colorRanges = null;
    this.outlineWidth = 0;
    this.outlineColor = 0;
    this.outlineOpacity = 1;
    this.outlineBlur = 0;
    this.outlineOffsetX = 0;
    this.outlineOffsetY = 0;
    this.strokeWidth = 0;
    this.strokeColor = defaultStrokeColor;
    this.strokeOpacity = 1;
    this.fillOpacity = 1;
    this.depthOffset = 0;
    this.clipRect = null;
    this.orientation = defaultOrient;
    this.glyphGeometryDetail = 1;
    this.sdfGlyphSize = null;
    this.gpuAccelerateSDF = true;
    this.debugSDF = false;
  }
  /**
   * Updates the text rendering according to the current text-related configuration properties.
   * This is an async process, so you can pass in a callback function to be executed when it
   * finishes.
   * @param {function} [callback]
   */
  sync(callback) {
    if (this._needsSync) {
      this._needsSync = false;
      if (this._isSyncing) {
        (this._queuedSyncs || (this._queuedSyncs = [])).push(callback);
      } else {
        this._isSyncing = true;
        this.dispatchEvent(syncStartEvent);
        getTextRenderInfo({
          text: this.text,
          font: this.font,
          lang: this.lang,
          fontSize: this.fontSize || 0.1,
          fontWeight: this.fontWeight || "normal",
          fontStyle: this.fontStyle || "normal",
          letterSpacing: this.letterSpacing || 0,
          lineHeight: this.lineHeight || "normal",
          maxWidth: this.maxWidth,
          direction: this.direction || "auto",
          textAlign: this.textAlign,
          textIndent: this.textIndent,
          whiteSpace: this.whiteSpace,
          overflowWrap: this.overflowWrap,
          anchorX: this.anchorX,
          anchorY: this.anchorY,
          colorRanges: this.colorRanges,
          includeCaretPositions: true,
          //TODO parameterize
          sdfGlyphSize: this.sdfGlyphSize,
          gpuAccelerateSDF: this.gpuAccelerateSDF,
          unicodeFontsURL: this.unicodeFontsURL
        }, (textRenderInfo) => {
          this._isSyncing = false;
          this._textRenderInfo = textRenderInfo;
          this.geometry.updateGlyphs(
            textRenderInfo.glyphBounds,
            textRenderInfo.glyphAtlasIndices,
            textRenderInfo.blockBounds,
            textRenderInfo.chunkedBounds,
            textRenderInfo.glyphColors
          );
          const queued = this._queuedSyncs;
          if (queued) {
            this._queuedSyncs = null;
            this._needsSync = true;
            this.sync(() => {
              queued.forEach((fn) => fn && fn());
            });
          }
          this.dispatchEvent(syncCompleteEvent);
          if (callback) {
            callback();
          }
        });
      }
    }
  }
  /**
   * Initiate a sync if needed - note it won't complete until next frame at the
   * earliest so if possible it's a good idea to call sync() manually as soon as
   * all the properties have been set.
   * @override
   */
  onBeforeRender(renderer, scene, camera, geometry, material, group) {
    this.sync();
    if (material.isTroikaTextMaterial) {
      this._prepareForRender(material);
    }
  }
  /**
   * Shortcut to dispose the geometry specific to this instance.
   * Note: we don't also dispose the derived material here because if anything else is
   * sharing the same base material it will result in a pause next frame as the program
   * is recompiled. Instead users can dispose the base material manually, like normal,
   * and we'll also dispose the derived material at that time.
   */
  dispose() {
    this.geometry.dispose();
  }
  /**
   * @property {TroikaTextRenderInfo|null} textRenderInfo
   * @readonly
   * The current processed rendering data for this TextMesh, returned by the TextBuilder after
   * a `sync()` call. This will be `null` initially, and may be stale for a short period until
   * the asynchrous `sync()` process completes.
   */
  get textRenderInfo() {
    return this._textRenderInfo || null;
  }
  /**
   * Create the text derived material from the base material. Can be overridden to use a custom
   * derived material.
   */
  createDerivedMaterial(baseMaterial) {
    return createTextDerivedMaterial(baseMaterial);
  }
  // Handler for automatically wrapping the base material with our upgrades. We do the wrapping
  // lazily on _read_ rather than write to avoid unnecessary wrapping on transient values.
  get material() {
    let derivedMaterial = this._derivedMaterial;
    const baseMaterial = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = defaultMaterial.clone());
    if (!derivedMaterial || !derivedMaterial.isDerivedFrom(baseMaterial)) {
      derivedMaterial = this._derivedMaterial = this.createDerivedMaterial(baseMaterial);
      baseMaterial.addEventListener("dispose", function onDispose() {
        baseMaterial.removeEventListener("dispose", onDispose);
        derivedMaterial.dispose();
      });
    }
    if (this.hasOutline()) {
      let outlineMaterial = derivedMaterial._outlineMtl;
      if (!outlineMaterial) {
        outlineMaterial = derivedMaterial._outlineMtl = Object.create(derivedMaterial, {
          id: { value: derivedMaterial.id + 0.1 }
        });
        outlineMaterial.isTextOutlineMaterial = true;
        outlineMaterial.depthWrite = false;
        outlineMaterial.map = null;
        derivedMaterial.addEventListener("dispose", function onDispose() {
          derivedMaterial.removeEventListener("dispose", onDispose);
          outlineMaterial.dispose();
        });
      }
      return [
        outlineMaterial,
        derivedMaterial
      ];
    } else {
      return derivedMaterial;
    }
  }
  set material(baseMaterial) {
    if (baseMaterial && baseMaterial.isTroikaTextMaterial) {
      this._derivedMaterial = baseMaterial;
      this._baseMaterial = baseMaterial.baseMaterial;
    } else {
      this._baseMaterial = baseMaterial;
    }
  }
  hasOutline() {
    return !!(this.outlineWidth || this.outlineBlur || this.outlineOffsetX || this.outlineOffsetY);
  }
  get glyphGeometryDetail() {
    return this.geometry.detail;
  }
  set glyphGeometryDetail(detail) {
    this.geometry.detail = detail;
  }
  get curveRadius() {
    return this.geometry.curveRadius;
  }
  set curveRadius(r3) {
    this.geometry.curveRadius = r3;
  }
  // Create and update material for shadows upon request:
  get customDepthMaterial() {
    return first(this.material).getDepthMaterial();
  }
  set customDepthMaterial(m2) {
  }
  get customDistanceMaterial() {
    return first(this.material).getDistanceMaterial();
  }
  set customDistanceMaterial(m2) {
  }
  _prepareForRender(material) {
    const isOutline = material.isTextOutlineMaterial;
    const uniforms = material.uniforms;
    const textInfo = this.textRenderInfo;
    if (textInfo) {
      const { sdfTexture, blockBounds } = textInfo;
      uniforms.uTroikaSDFTexture.value = sdfTexture;
      uniforms.uTroikaSDFTextureSize.value.set(sdfTexture.image.width, sdfTexture.image.height);
      uniforms.uTroikaSDFGlyphSize.value = textInfo.sdfGlyphSize;
      uniforms.uTroikaSDFExponent.value = textInfo.sdfExponent;
      uniforms.uTroikaTotalBounds.value.fromArray(blockBounds);
      uniforms.uTroikaUseGlyphColors.value = !isOutline && !!textInfo.glyphColors;
      let distanceOffset = 0;
      let blurRadius = 0;
      let strokeWidth = 0;
      let fillOpacity;
      let strokeOpacity;
      let strokeColor;
      let offsetX = 0;
      let offsetY = 0;
      if (isOutline) {
        let { outlineWidth, outlineOffsetX, outlineOffsetY, outlineBlur, outlineOpacity } = this;
        distanceOffset = this._parsePercent(outlineWidth) || 0;
        blurRadius = Math.max(0, this._parsePercent(outlineBlur) || 0);
        fillOpacity = outlineOpacity;
        offsetX = this._parsePercent(outlineOffsetX) || 0;
        offsetY = this._parsePercent(outlineOffsetY) || 0;
      } else {
        strokeWidth = Math.max(0, this._parsePercent(this.strokeWidth) || 0);
        if (strokeWidth) {
          strokeColor = this.strokeColor;
          uniforms.uTroikaStrokeColor.value.set(strokeColor == null ? defaultStrokeColor : strokeColor);
          strokeOpacity = this.strokeOpacity;
          if (strokeOpacity == null) strokeOpacity = 1;
        }
        fillOpacity = this.fillOpacity;
      }
      uniforms.uTroikaEdgeOffset.value = distanceOffset;
      uniforms.uTroikaPositionOffset.value.set(offsetX, offsetY);
      uniforms.uTroikaBlurRadius.value = blurRadius;
      uniforms.uTroikaStrokeWidth.value = strokeWidth;
      uniforms.uTroikaStrokeOpacity.value = strokeOpacity;
      uniforms.uTroikaFillOpacity.value = fillOpacity == null ? 1 : fillOpacity;
      uniforms.uTroikaCurveRadius.value = this.curveRadius || 0;
      let clipRect = this.clipRect;
      if (clipRect && Array.isArray(clipRect) && clipRect.length === 4) {
        uniforms.uTroikaClipRect.value.fromArray(clipRect);
      } else {
        const pad = (this.fontSize || 0.1) * 100;
        uniforms.uTroikaClipRect.value.set(
          blockBounds[0] - pad,
          blockBounds[1] - pad,
          blockBounds[2] + pad,
          blockBounds[3] + pad
        );
      }
      this.geometry.applyClipRect(uniforms.uTroikaClipRect.value);
    }
    uniforms.uTroikaSDFDebug.value = !!this.debugSDF;
    material.polygonOffset = !!this.depthOffset;
    material.polygonOffsetFactor = material.polygonOffsetUnits = this.depthOffset || 0;
    const color = isOutline ? this.outlineColor || 0 : this.color;
    if (color == null) {
      delete material.color;
    } else {
      const colorObj = material.hasOwnProperty("color") ? material.color : material.color = new Color();
      if (color !== colorObj._input || typeof color === "object") {
        colorObj.set(colorObj._input = color);
      }
    }
    let orient = this.orientation || defaultOrient;
    if (orient !== material._orientation) {
      let rotMat = uniforms.uTroikaOrient.value;
      orient = orient.replace(/[^-+xyz]/g, "");
      let match = orient !== defaultOrient && orient.match(/^([-+])([xyz])([-+])([xyz])$/);
      if (match) {
        let [, hSign, hAxis, vSign, vAxis] = match;
        tempVec3a.set(0, 0, 0)[hAxis] = hSign === "-" ? 1 : -1;
        tempVec3b.set(0, 0, 0)[vAxis] = vSign === "-" ? -1 : 1;
        tempMat4.lookAt(origin, tempVec3a.cross(tempVec3b), tempVec3b);
        rotMat.setFromMatrix4(tempMat4);
      } else {
        rotMat.identity();
      }
      material._orientation = orient;
    }
  }
  _parsePercent(value) {
    if (typeof value === "string") {
      let match = value.match(/^(-?[\d.]+)%$/);
      let pct = match ? parseFloat(match[1]) : NaN;
      value = (isNaN(pct) ? 0 : pct / 100) * this.fontSize;
    }
    return value;
  }
  /**
   * Translate a point in local space to an x/y in the text plane.
   */
  localPositionToTextCoords(position, target = new Vector2()) {
    target.copy(position);
    const r3 = this.curveRadius;
    if (r3) {
      target.x = Math.atan2(position.x, Math.abs(r3) - Math.abs(position.z)) * Math.abs(r3);
    }
    return target;
  }
  /**
   * Translate a point in world space to an x/y in the text plane.
   */
  worldPositionToTextCoords(position, target = new Vector2()) {
    tempVec3a.copy(position);
    return this.localPositionToTextCoords(this.worldToLocal(tempVec3a), target);
  }
  /**
   * @override Custom raycasting to test against the whole text block's max rectangular bounds
   * TODO is there any reason to make this more granular, like within individual line or glyph rects?
   */
  raycast(raycaster, intersects2) {
    const { textRenderInfo, curveRadius } = this;
    if (textRenderInfo) {
      const bounds = textRenderInfo.blockBounds;
      const raycastMesh = curveRadius ? getCurvedRaycastMesh() : getFlatRaycastMesh();
      const geom = raycastMesh.geometry;
      const { position, uv } = geom.attributes;
      for (let i2 = 0; i2 < uv.count; i2++) {
        let x3 = bounds[0] + uv.getX(i2) * (bounds[2] - bounds[0]);
        const y2 = bounds[1] + uv.getY(i2) * (bounds[3] - bounds[1]);
        let z2 = 0;
        if (curveRadius) {
          z2 = curveRadius - Math.cos(x3 / curveRadius) * curveRadius;
          x3 = Math.sin(x3 / curveRadius) * curveRadius;
        }
        position.setXYZ(i2, x3, y2, z2);
      }
      geom.boundingSphere = this.geometry.boundingSphere;
      geom.boundingBox = this.geometry.boundingBox;
      raycastMesh.matrixWorld = this.matrixWorld;
      raycastMesh.material.side = this.material.side;
      tempArray.length = 0;
      raycastMesh.raycast(raycaster, tempArray);
      for (let i2 = 0; i2 < tempArray.length; i2++) {
        tempArray[i2].object = this;
        intersects2.push(tempArray[i2]);
      }
    }
  }
  copy(source) {
    const geom = this.geometry;
    super.copy(source);
    this.geometry = geom;
    COPYABLE_PROPS.forEach((prop) => {
      this[prop] = source[prop];
    });
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
SYNCABLE_PROPS.forEach((prop) => {
  const privateKey = "_private_" + prop;
  Object.defineProperty(Text$1.prototype, prop, {
    get() {
      return this[privateKey];
    },
    set(value) {
      if (value !== this[privateKey]) {
        this[privateKey] = value;
        this._needsSync = true;
      }
    }
  });
});
new Box3();
new Color();
const Text2 = /* @__PURE__ */ reactExports.forwardRef(({
  sdfGlyphSize = 64,
  anchorX = "center",
  anchorY = "middle",
  font,
  fontSize = 1,
  children,
  characters,
  onSync,
  ...props
}, ref) => {
  const invalidate2 = useThree(({
    invalidate: invalidate3
  }) => invalidate3);
  const [troikaMesh] = reactExports.useState(() => new Text$1());
  const [nodes, text] = reactExports.useMemo(() => {
    const n2 = [];
    let t2 = "";
    reactExports.Children.forEach(children, (child) => {
      if (typeof child === "string" || typeof child === "number") {
        t2 += child;
      } else {
        n2.push(child);
      }
    });
    return [n2, t2];
  }, [children]);
  suspend$1(() => new Promise((res) => preloadFont({
    font,
    characters
  }, res)), ["troika-text", font, characters]);
  reactExports.useLayoutEffect(() => void troikaMesh.sync(() => {
    invalidate2();
    if (onSync) onSync(troikaMesh);
  }));
  reactExports.useEffect(() => {
    return () => troikaMesh.dispose();
  }, [troikaMesh]);
  return /* @__PURE__ */ reactExports.createElement("primitive", _extends$1({
    object: troikaMesh,
    ref,
    font,
    text,
    anchorX,
    anchorY,
    fontSize,
    sdfGlyphSize
  }, props), nodes);
});
let dracoLoader = null;
let decoderPath = "https://www.gstatic.com/draco/versioned/decoders/1.5.5/";
function extensions(useDraco = true, useMeshopt = true, extendLoader) {
  return (loader) => {
    if (extendLoader) {
      extendLoader(loader);
    }
    if (useDraco) {
      if (!dracoLoader) {
        dracoLoader = new DRACOLoader();
      }
      dracoLoader.setDecoderPath(typeof useDraco === "string" ? useDraco : decoderPath);
      loader.setDRACOLoader(dracoLoader);
    }
    if (useMeshopt) {
      loader.setMeshoptDecoder(typeof MeshoptDecoder === "function" ? MeshoptDecoder() : MeshoptDecoder);
    }
  };
}
const useGLTF = (path, useDraco, useMeshopt, extendLoader) => useLoader(GLTFLoader, path, extensions(useDraco, useMeshopt, extendLoader));
useGLTF.preload = (path, useDraco, useMeshopt, extendLoader) => useLoader.preload(GLTFLoader, path, extensions(useDraco, useMeshopt, extendLoader));
useGLTF.clear = (path) => useLoader.clear(GLTFLoader, path);
useGLTF.setDecoderPath = (path) => {
  decoderPath = path;
};
const MOUSE_BUTTON$1 = {
  LEFT: 1,
  RIGHT: 2,
  MIDDLE: 4
};
const ACTION$1 = Object.freeze({
  NONE: 0,
  ROTATE: 1,
  TRUCK: 2,
  SCREEN_PAN: 4,
  OFFSET: 8,
  DOLLY: 16,
  ZOOM: 32,
  TOUCH_ROTATE: 64,
  TOUCH_TRUCK: 128,
  TOUCH_SCREEN_PAN: 256,
  TOUCH_OFFSET: 512,
  TOUCH_DOLLY: 1024,
  TOUCH_ZOOM: 2048,
  TOUCH_DOLLY_TRUCK: 4096,
  TOUCH_DOLLY_SCREEN_PAN: 8192,
  TOUCH_DOLLY_OFFSET: 16384,
  TOUCH_DOLLY_ROTATE: 32768,
  TOUCH_ZOOM_TRUCK: 65536,
  TOUCH_ZOOM_OFFSET: 131072,
  TOUCH_ZOOM_SCREEN_PAN: 262144,
  TOUCH_ZOOM_ROTATE: 524288
});
const DOLLY_DIRECTION$1 = {
  NONE: 0,
  IN: 1,
  OUT: -1
};
function isPerspectiveCamera$1(camera) {
  return camera.isPerspectiveCamera;
}
function isOrthographicCamera$1(camera) {
  return camera.isOrthographicCamera;
}
const PI_2$1 = Math.PI * 2;
const PI_HALF$1 = Math.PI / 2;
const EPSILON$1 = 1e-5;
const DEG2RAD$1 = Math.PI / 180;
function clamp$2(value, min, max2) {
  return Math.max(min, Math.min(max2, value));
}
function approxZero$1(number, error2 = EPSILON$1) {
  return Math.abs(number) < error2;
}
function approxEquals$1(a5, b6, error2 = EPSILON$1) {
  return approxZero$1(a5 - b6, error2);
}
function roundToStep$1(value, step) {
  return Math.round(value / step) * step;
}
function infinityToMaxNumber$1(value) {
  if (isFinite(value))
    return value;
  if (value < 0)
    return -Number.MAX_VALUE;
  return Number.MAX_VALUE;
}
function maxNumberToInfinity$1(value) {
  if (Math.abs(value) < Number.MAX_VALUE)
    return value;
  return value * Infinity;
}
function smoothDamp$1(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime) {
  smoothTime = Math.max(1e-4, smoothTime);
  const omega = 2 / smoothTime;
  const x3 = omega * deltaTime;
  const exp3 = 1 / (1 + x3 + 0.48 * x3 * x3 + 0.235 * x3 * x3 * x3);
  let change = current - target;
  const originalTo = target;
  const maxChange = maxSpeed * smoothTime;
  change = clamp$2(change, -maxChange, maxChange);
  target = current - change;
  const temp = (currentVelocityRef.value + omega * change) * deltaTime;
  currentVelocityRef.value = (currentVelocityRef.value - omega * temp) * exp3;
  let output = target + (change + temp) * exp3;
  if (originalTo - current > 0 === output > originalTo) {
    output = originalTo;
    currentVelocityRef.value = (output - originalTo) / deltaTime;
  }
  return output;
}
function smoothDampVec3$1(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime, out7) {
  smoothTime = Math.max(1e-4, smoothTime);
  const omega = 2 / smoothTime;
  const x3 = omega * deltaTime;
  const exp3 = 1 / (1 + x3 + 0.48 * x3 * x3 + 0.235 * x3 * x3 * x3);
  let targetX = target.x;
  let targetY = target.y;
  let targetZ = target.z;
  let changeX = current.x - targetX;
  let changeY = current.y - targetY;
  let changeZ = current.z - targetZ;
  const originalToX = targetX;
  const originalToY = targetY;
  const originalToZ = targetZ;
  const maxChange = maxSpeed * smoothTime;
  const maxChangeSq = maxChange * maxChange;
  const magnitudeSq = changeX * changeX + changeY * changeY + changeZ * changeZ;
  if (magnitudeSq > maxChangeSq) {
    const magnitude = Math.sqrt(magnitudeSq);
    changeX = changeX / magnitude * maxChange;
    changeY = changeY / magnitude * maxChange;
    changeZ = changeZ / magnitude * maxChange;
  }
  targetX = current.x - changeX;
  targetY = current.y - changeY;
  targetZ = current.z - changeZ;
  const tempX = (currentVelocityRef.x + omega * changeX) * deltaTime;
  const tempY = (currentVelocityRef.y + omega * changeY) * deltaTime;
  const tempZ = (currentVelocityRef.z + omega * changeZ) * deltaTime;
  currentVelocityRef.x = (currentVelocityRef.x - omega * tempX) * exp3;
  currentVelocityRef.y = (currentVelocityRef.y - omega * tempY) * exp3;
  currentVelocityRef.z = (currentVelocityRef.z - omega * tempZ) * exp3;
  out7.x = targetX + (changeX + tempX) * exp3;
  out7.y = targetY + (changeY + tempY) * exp3;
  out7.z = targetZ + (changeZ + tempZ) * exp3;
  const origMinusCurrentX = originalToX - current.x;
  const origMinusCurrentY = originalToY - current.y;
  const origMinusCurrentZ = originalToZ - current.z;
  const outMinusOrigX = out7.x - originalToX;
  const outMinusOrigY = out7.y - originalToY;
  const outMinusOrigZ = out7.z - originalToZ;
  if (origMinusCurrentX * outMinusOrigX + origMinusCurrentY * outMinusOrigY + origMinusCurrentZ * outMinusOrigZ > 0) {
    out7.x = originalToX;
    out7.y = originalToY;
    out7.z = originalToZ;
    currentVelocityRef.x = (out7.x - originalToX) / deltaTime;
    currentVelocityRef.y = (out7.y - originalToY) / deltaTime;
    currentVelocityRef.z = (out7.z - originalToZ) / deltaTime;
  }
  return out7;
}
function extractClientCoordFromEvent$1(pointers, out7) {
  out7.set(0, 0);
  pointers.forEach((pointer) => {
    out7.x += pointer.clientX;
    out7.y += pointer.clientY;
  });
  out7.x /= pointers.length;
  out7.y /= pointers.length;
}
function notSupportedInOrthographicCamera$1(camera, message) {
  if (isOrthographicCamera$1(camera)) {
    console.warn(`${message} is not supported in OrthographicCamera`);
    return true;
  }
  return false;
}
let EventDispatcher$1 = class EventDispatcher2 {
  constructor() {
    this._listeners = {};
  }
  /**
   * Adds the specified event listener.
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  addEventListener(type, listener) {
    const listeners = this._listeners;
    if (listeners[type] === void 0)
      listeners[type] = [];
    if (listeners[type].indexOf(listener) === -1)
      listeners[type].push(listener);
  }
  /**
   * Presence of the specified event listener.
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  hasEventListener(type, listener) {
    const listeners = this._listeners;
    return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
  }
  /**
   * Removes the specified event listener
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  removeEventListener(type, listener) {
    const listeners = this._listeners;
    const listenerArray = listeners[type];
    if (listenerArray !== void 0) {
      const index = listenerArray.indexOf(listener);
      if (index !== -1)
        listenerArray.splice(index, 1);
    }
  }
  /**
   * Removes all event listeners
   * @param type event name
   * @category Methods
   */
  removeAllEventListeners(type) {
    if (!type) {
      this._listeners = {};
      return;
    }
    if (Array.isArray(this._listeners[type]))
      this._listeners[type].length = 0;
  }
  /**
   * Fire an event type.
   * @param event DispatcherEvent
   * @category Methods
   */
  dispatchEvent(event) {
    const listeners = this._listeners;
    const listenerArray = listeners[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array = listenerArray.slice(0);
      for (let i2 = 0, l2 = array.length; i2 < l2; i2++) {
        array[i2].call(this, event);
      }
    }
  }
};
var _a$1;
const VERSION$1 = "2.10.1";
const TOUCH_DOLLY_FACTOR$1 = 1 / 8;
const isMac$1 = /Mac/.test((_a$1 = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a$1 === void 0 ? void 0 : _a$1.platform);
let THREE$1;
let _ORIGIN$1;
let _AXIS_Y$1;
let _AXIS_Z$1;
let _v2$1;
let _v3A$1;
let _v3B$1;
let _v3C$1;
let _cameraDirection$1;
let _xColumn$1;
let _yColumn$1;
let _zColumn$1;
let _deltaTarget$1;
let _deltaOffset$1;
let _sphericalA$1;
let _sphericalB$1;
let _box3A$1;
let _box3B$1;
let _sphere$1;
let _quaternionA$1;
let _quaternionB$1;
let _rotationMatrix$1;
let _raycaster$1;
let CameraControls$2 = class CameraControls extends EventDispatcher$1 {
  /**
       * Injects THREE as the dependency. You can then proceed to use CameraControls.
       *
       * e.g
       * ```javascript
       * CameraControls.install( { THREE: THREE } );
       * ```
       *
       * Note: If you do not wish to use enter three.js to reduce file size(tree-shaking for example), make a subset to install.
       *
       * ```js
       * import {
       * 	Vector2,
       * 	Vector3,
       * 	Vector4,
       * 	Quaternion,
       * 	Matrix4,
       * 	Spherical,
       * 	Box3,
       * 	Sphere,
       * 	Raycaster,
       * 	MathUtils,
       * } from 'three';
       *
       * const subsetOfTHREE = {
       * 	Vector2   : Vector2,
       * 	Vector3   : Vector3,
       * 	Vector4   : Vector4,
       * 	Quaternion: Quaternion,
       * 	Matrix4   : Matrix4,
       * 	Spherical : Spherical,
       * 	Box3      : Box3,
       * 	Sphere    : Sphere,
       * 	Raycaster : Raycaster,
       * };
  
       * CameraControls.install( { THREE: subsetOfTHREE } );
       * ```
       * @category Statics
       */
  static install(libs) {
    THREE$1 = libs.THREE;
    _ORIGIN$1 = Object.freeze(new THREE$1.Vector3(0, 0, 0));
    _AXIS_Y$1 = Object.freeze(new THREE$1.Vector3(0, 1, 0));
    _AXIS_Z$1 = Object.freeze(new THREE$1.Vector3(0, 0, 1));
    _v2$1 = new THREE$1.Vector2();
    _v3A$1 = new THREE$1.Vector3();
    _v3B$1 = new THREE$1.Vector3();
    _v3C$1 = new THREE$1.Vector3();
    _cameraDirection$1 = new THREE$1.Vector3();
    _xColumn$1 = new THREE$1.Vector3();
    _yColumn$1 = new THREE$1.Vector3();
    _zColumn$1 = new THREE$1.Vector3();
    _deltaTarget$1 = new THREE$1.Vector3();
    _deltaOffset$1 = new THREE$1.Vector3();
    _sphericalA$1 = new THREE$1.Spherical();
    _sphericalB$1 = new THREE$1.Spherical();
    _box3A$1 = new THREE$1.Box3();
    _box3B$1 = new THREE$1.Box3();
    _sphere$1 = new THREE$1.Sphere();
    _quaternionA$1 = new THREE$1.Quaternion();
    _quaternionB$1 = new THREE$1.Quaternion();
    _rotationMatrix$1 = new THREE$1.Matrix4();
    _raycaster$1 = new THREE$1.Raycaster();
  }
  /**
   * list all ACTIONs
   * @category Statics
   */
  static get ACTION() {
    return ACTION$1;
  }
  /**
   * @deprecated Use `cameraControls.mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.
   */
  set verticalDragToForward(_2) {
    console.warn("camera-controls: `verticalDragToForward` was removed. Use `mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.");
  }
  /**
   * Creates a `CameraControls` instance.
   *
   * Note:
   * You **must install** three.js before using camera-controls. see [#install](#install)
   * Not doing so will lead to runtime errors (`undefined` references to THREE).
   *
   * e.g.
   * ```
   * CameraControls.install( { THREE } );
   * const cameraControls = new CameraControls( camera, domElement );
   * ```
   *
   * @param camera A `THREE.PerspectiveCamera` or `THREE.OrthographicCamera` to be controlled.
   * @param domElement A `HTMLElement` for the draggable area, usually `renderer.domElement`.
   * @category Constructor
   */
  constructor(camera, domElement) {
    super();
    this.minPolarAngle = 0;
    this.maxPolarAngle = Math.PI;
    this.minAzimuthAngle = -Infinity;
    this.maxAzimuthAngle = Infinity;
    this.minDistance = Number.EPSILON;
    this.maxDistance = Infinity;
    this.infinityDolly = false;
    this.minZoom = 0.01;
    this.maxZoom = Infinity;
    this.smoothTime = 0.25;
    this.draggingSmoothTime = 0.125;
    this.maxSpeed = Infinity;
    this.azimuthRotateSpeed = 1;
    this.polarRotateSpeed = 1;
    this.dollySpeed = 1;
    this.dollyDragInverted = false;
    this.truckSpeed = 2;
    this.dollyToCursor = false;
    this.dragToOffset = false;
    this.boundaryFriction = 0;
    this.restThreshold = 0.01;
    this.colliderMeshes = [];
    this.cancel = () => {
    };
    this._enabled = true;
    this._state = ACTION$1.NONE;
    this._viewport = null;
    this._changedDolly = 0;
    this._changedZoom = 0;
    this._hasRested = true;
    this._boundaryEnclosesCamera = false;
    this._needsUpdate = true;
    this._updatedLastTime = false;
    this._elementRect = new DOMRect();
    this._isDragging = false;
    this._dragNeedsUpdate = true;
    this._activePointers = [];
    this._lockedPointer = null;
    this._interactiveArea = new DOMRect(0, 0, 1, 1);
    this._isUserControllingRotate = false;
    this._isUserControllingDolly = false;
    this._isUserControllingTruck = false;
    this._isUserControllingOffset = false;
    this._isUserControllingZoom = false;
    this._lastDollyDirection = DOLLY_DIRECTION$1.NONE;
    this._thetaVelocity = { value: 0 };
    this._phiVelocity = { value: 0 };
    this._radiusVelocity = { value: 0 };
    this._targetVelocity = new THREE$1.Vector3();
    this._focalOffsetVelocity = new THREE$1.Vector3();
    this._zoomVelocity = { value: 0 };
    this._truckInternal = (deltaX, deltaY, dragToOffset, screenSpacePanning) => {
      let truckX;
      let pedestalY;
      if (isPerspectiveCamera$1(this._camera)) {
        const offset = _v3A$1.copy(this._camera.position).sub(this._target);
        const fov2 = this._camera.getEffectiveFOV() * DEG2RAD$1;
        const targetDistance = offset.length() * Math.tan(fov2 * 0.5);
        truckX = this.truckSpeed * deltaX * targetDistance / this._elementRect.height;
        pedestalY = this.truckSpeed * deltaY * targetDistance / this._elementRect.height;
      } else if (isOrthographicCamera$1(this._camera)) {
        const camera2 = this._camera;
        truckX = this.truckSpeed * deltaX * (camera2.right - camera2.left) / camera2.zoom / this._elementRect.width;
        pedestalY = this.truckSpeed * deltaY * (camera2.top - camera2.bottom) / camera2.zoom / this._elementRect.height;
      } else {
        return;
      }
      if (screenSpacePanning) {
        dragToOffset ? this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y, this._focalOffsetEnd.z, true) : this.truck(truckX, 0, true);
        this.forward(-pedestalY, true);
      } else {
        dragToOffset ? this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y + pedestalY, this._focalOffsetEnd.z, true) : this.truck(truckX, pedestalY, true);
      }
    };
    this._rotateInternal = (deltaX, deltaY) => {
      const theta = PI_2$1 * this.azimuthRotateSpeed * deltaX / this._elementRect.height;
      const phi = PI_2$1 * this.polarRotateSpeed * deltaY / this._elementRect.height;
      this.rotate(theta, phi, true);
    };
    this._dollyInternal = (delta, x3, y2) => {
      const dollyScale = Math.pow(0.95, -delta * this.dollySpeed);
      const lastDistance = this._sphericalEnd.radius;
      const distance = this._sphericalEnd.radius * dollyScale;
      const clampedDistance = clamp$2(distance, this.minDistance, this.maxDistance);
      const overflowedDistance = clampedDistance - distance;
      if (this.infinityDolly && this.dollyToCursor) {
        this._dollyToNoClamp(distance, true);
      } else if (this.infinityDolly && !this.dollyToCursor) {
        this.dollyInFixed(overflowedDistance, true);
        this._dollyToNoClamp(clampedDistance, true);
      } else {
        this._dollyToNoClamp(clampedDistance, true);
      }
      if (this.dollyToCursor) {
        this._changedDolly += (this.infinityDolly ? distance : clampedDistance) - lastDistance;
        this._dollyControlCoord.set(x3, y2);
      }
      this._lastDollyDirection = Math.sign(-delta);
    };
    this._zoomInternal = (delta, x3, y2) => {
      const zoomScale = Math.pow(0.95, delta * this.dollySpeed);
      const lastZoom = this._zoom;
      const zoom = this._zoom * zoomScale;
      this.zoomTo(zoom, true);
      if (this.dollyToCursor) {
        this._changedZoom += zoom - lastZoom;
        this._dollyControlCoord.set(x3, y2);
      }
    };
    if (typeof THREE$1 === "undefined") {
      console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information.");
    }
    this._camera = camera;
    this._yAxisUpSpace = new THREE$1.Quaternion().setFromUnitVectors(this._camera.up, _AXIS_Y$1);
    this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert();
    this._state = ACTION$1.NONE;
    this._target = new THREE$1.Vector3();
    this._targetEnd = this._target.clone();
    this._focalOffset = new THREE$1.Vector3();
    this._focalOffsetEnd = this._focalOffset.clone();
    this._spherical = new THREE$1.Spherical().setFromVector3(_v3A$1.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace));
    this._sphericalEnd = this._spherical.clone();
    this._lastDistance = this._spherical.radius;
    this._zoom = this._camera.zoom;
    this._zoomEnd = this._zoom;
    this._lastZoom = this._zoom;
    this._nearPlaneCorners = [
      new THREE$1.Vector3(),
      new THREE$1.Vector3(),
      new THREE$1.Vector3(),
      new THREE$1.Vector3()
    ];
    this._updateNearPlaneCorners();
    this._boundary = new THREE$1.Box3(new THREE$1.Vector3(-Infinity, -Infinity, -Infinity), new THREE$1.Vector3(Infinity, Infinity, Infinity));
    this._cameraUp0 = this._camera.up.clone();
    this._target0 = this._target.clone();
    this._position0 = this._camera.position.clone();
    this._zoom0 = this._zoom;
    this._focalOffset0 = this._focalOffset.clone();
    this._dollyControlCoord = new THREE$1.Vector2();
    this.mouseButtons = {
      left: ACTION$1.ROTATE,
      middle: ACTION$1.DOLLY,
      right: ACTION$1.TRUCK,
      wheel: isPerspectiveCamera$1(this._camera) ? ACTION$1.DOLLY : isOrthographicCamera$1(this._camera) ? ACTION$1.ZOOM : ACTION$1.NONE
    };
    this.touches = {
      one: ACTION$1.TOUCH_ROTATE,
      two: isPerspectiveCamera$1(this._camera) ? ACTION$1.TOUCH_DOLLY_TRUCK : isOrthographicCamera$1(this._camera) ? ACTION$1.TOUCH_ZOOM_TRUCK : ACTION$1.NONE,
      three: ACTION$1.TOUCH_TRUCK
    };
    const dragStartPosition = new THREE$1.Vector2();
    const lastDragPosition = new THREE$1.Vector2();
    const dollyStart = new THREE$1.Vector2();
    const onPointerDown = (event) => {
      if (!this._enabled || !this._domElement)
        return;
      if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
        const elRect = this._domElement.getBoundingClientRect();
        const left = event.clientX / elRect.width;
        const top = event.clientY / elRect.height;
        if (left < this._interactiveArea.left || left > this._interactiveArea.right || top < this._interactiveArea.top || top > this._interactiveArea.bottom)
          return;
      }
      const mouseButton = event.pointerType !== "mouse" ? null : (event.buttons & MOUSE_BUTTON$1.LEFT) === MOUSE_BUTTON$1.LEFT ? MOUSE_BUTTON$1.LEFT : (event.buttons & MOUSE_BUTTON$1.MIDDLE) === MOUSE_BUTTON$1.MIDDLE ? MOUSE_BUTTON$1.MIDDLE : (event.buttons & MOUSE_BUTTON$1.RIGHT) === MOUSE_BUTTON$1.RIGHT ? MOUSE_BUTTON$1.RIGHT : null;
      if (mouseButton !== null) {
        const zombiePointer = this._findPointerByMouseButton(mouseButton);
        zombiePointer && this._disposePointer(zombiePointer);
      }
      if ((event.buttons & MOUSE_BUTTON$1.LEFT) === MOUSE_BUTTON$1.LEFT && this._lockedPointer)
        return;
      const pointer = {
        pointerId: event.pointerId,
        clientX: event.clientX,
        clientY: event.clientY,
        deltaX: 0,
        deltaY: 0,
        mouseButton
      };
      this._activePointers.push(pointer);
      this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
      this._domElement.ownerDocument.addEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.addEventListener("pointerup", onPointerUp);
      this._isDragging = true;
      startDragging(event);
    };
    const onPointerMove = (event) => {
      if (event.cancelable)
        event.preventDefault();
      const pointerId = event.pointerId;
      const pointer = this._lockedPointer || this._findPointerById(pointerId);
      if (!pointer)
        return;
      pointer.clientX = event.clientX;
      pointer.clientY = event.clientY;
      pointer.deltaX = event.movementX;
      pointer.deltaY = event.movementY;
      this._state = 0;
      if (event.pointerType === "touch") {
        switch (this._activePointers.length) {
          case 1:
            this._state = this.touches.one;
            break;
          case 2:
            this._state = this.touches.two;
            break;
          case 3:
            this._state = this.touches.three;
            break;
        }
      } else {
        if (!this._isDragging && this._lockedPointer || this._isDragging && (event.buttons & MOUSE_BUTTON$1.LEFT) === MOUSE_BUTTON$1.LEFT) {
          this._state = this._state | this.mouseButtons.left;
        }
        if (this._isDragging && (event.buttons & MOUSE_BUTTON$1.MIDDLE) === MOUSE_BUTTON$1.MIDDLE) {
          this._state = this._state | this.mouseButtons.middle;
        }
        if (this._isDragging && (event.buttons & MOUSE_BUTTON$1.RIGHT) === MOUSE_BUTTON$1.RIGHT) {
          this._state = this._state | this.mouseButtons.right;
        }
      }
      dragging();
    };
    const onPointerUp = (event) => {
      const pointer = this._findPointerById(event.pointerId);
      if (pointer && pointer === this._lockedPointer)
        return;
      pointer && this._disposePointer(pointer);
      if (event.pointerType === "touch") {
        switch (this._activePointers.length) {
          case 0:
            this._state = ACTION$1.NONE;
            break;
          case 1:
            this._state = this.touches.one;
            break;
          case 2:
            this._state = this.touches.two;
            break;
          case 3:
            this._state = this.touches.three;
            break;
        }
      } else {
        this._state = ACTION$1.NONE;
      }
      endDragging();
    };
    let lastScrollTimeStamp = -1;
    const onMouseWheel = (event) => {
      if (!this._domElement)
        return;
      if (!this._enabled || this.mouseButtons.wheel === ACTION$1.NONE)
        return;
      if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
        const elRect = this._domElement.getBoundingClientRect();
        const left = event.clientX / elRect.width;
        const top = event.clientY / elRect.height;
        if (left < this._interactiveArea.left || left > this._interactiveArea.right || top < this._interactiveArea.top || top > this._interactiveArea.bottom)
          return;
      }
      event.preventDefault();
      if (this.dollyToCursor || this.mouseButtons.wheel === ACTION$1.ROTATE || this.mouseButtons.wheel === ACTION$1.TRUCK) {
        const now2 = performance.now();
        if (lastScrollTimeStamp - now2 < 1e3)
          this._getClientRect(this._elementRect);
        lastScrollTimeStamp = now2;
      }
      const deltaYFactor = isMac$1 ? -1 : -3;
      const delta = event.deltaMode === 1 || event.ctrlKey ? event.deltaY / deltaYFactor : event.deltaY / (deltaYFactor * 10);
      const x3 = this.dollyToCursor ? (event.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
      const y2 = this.dollyToCursor ? (event.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
      switch (this.mouseButtons.wheel) {
        case ACTION$1.ROTATE: {
          this._rotateInternal(event.deltaX, event.deltaY);
          this._isUserControllingRotate = true;
          break;
        }
        case ACTION$1.TRUCK: {
          this._truckInternal(event.deltaX, event.deltaY, false, false);
          this._isUserControllingTruck = true;
          break;
        }
        case ACTION$1.SCREEN_PAN: {
          this._truckInternal(event.deltaX, event.deltaY, false, true);
          this._isUserControllingTruck = true;
          break;
        }
        case ACTION$1.OFFSET: {
          this._truckInternal(event.deltaX, event.deltaY, true, false);
          this._isUserControllingOffset = true;
          break;
        }
        case ACTION$1.DOLLY: {
          this._dollyInternal(-delta, x3, y2);
          this._isUserControllingDolly = true;
          break;
        }
        case ACTION$1.ZOOM: {
          this._zoomInternal(-delta, x3, y2);
          this._isUserControllingZoom = true;
          break;
        }
      }
      this.dispatchEvent({ type: "control" });
    };
    const onContextMenu = (event) => {
      if (!this._domElement || !this._enabled)
        return;
      if (this.mouseButtons.right === CameraControls.ACTION.NONE) {
        const pointerId = event instanceof PointerEvent ? event.pointerId : 0;
        const pointer = this._findPointerById(pointerId);
        pointer && this._disposePointer(pointer);
        this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
        this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
        return;
      }
      event.preventDefault();
    };
    const startDragging = (event) => {
      if (!this._enabled)
        return;
      extractClientCoordFromEvent$1(this._activePointers, _v2$1);
      this._getClientRect(this._elementRect);
      dragStartPosition.copy(_v2$1);
      lastDragPosition.copy(_v2$1);
      const isMultiTouch = this._activePointers.length >= 2;
      if (isMultiTouch) {
        const dx = _v2$1.x - this._activePointers[1].clientX;
        const dy = _v2$1.y - this._activePointers[1].clientY;
        const distance = Math.sqrt(dx * dx + dy * dy);
        dollyStart.set(0, distance);
        const x3 = (this._activePointers[0].clientX + this._activePointers[1].clientX) * 0.5;
        const y2 = (this._activePointers[0].clientY + this._activePointers[1].clientY) * 0.5;
        lastDragPosition.set(x3, y2);
      }
      this._state = 0;
      if (!event) {
        if (this._lockedPointer)
          this._state = this._state | this.mouseButtons.left;
      } else if ("pointerType" in event && event.pointerType === "touch") {
        switch (this._activePointers.length) {
          case 1:
            this._state = this.touches.one;
            break;
          case 2:
            this._state = this.touches.two;
            break;
          case 3:
            this._state = this.touches.three;
            break;
        }
      } else {
        if (!this._lockedPointer && (event.buttons & MOUSE_BUTTON$1.LEFT) === MOUSE_BUTTON$1.LEFT) {
          this._state = this._state | this.mouseButtons.left;
        }
        if ((event.buttons & MOUSE_BUTTON$1.MIDDLE) === MOUSE_BUTTON$1.MIDDLE) {
          this._state = this._state | this.mouseButtons.middle;
        }
        if ((event.buttons & MOUSE_BUTTON$1.RIGHT) === MOUSE_BUTTON$1.RIGHT) {
          this._state = this._state | this.mouseButtons.right;
        }
      }
      if ((this._state & ACTION$1.ROTATE) === ACTION$1.ROTATE || (this._state & ACTION$1.TOUCH_ROTATE) === ACTION$1.TOUCH_ROTATE || (this._state & ACTION$1.TOUCH_DOLLY_ROTATE) === ACTION$1.TOUCH_DOLLY_ROTATE || (this._state & ACTION$1.TOUCH_ZOOM_ROTATE) === ACTION$1.TOUCH_ZOOM_ROTATE) {
        this._sphericalEnd.theta = this._spherical.theta;
        this._sphericalEnd.phi = this._spherical.phi;
        this._thetaVelocity.value = 0;
        this._phiVelocity.value = 0;
      }
      if ((this._state & ACTION$1.TRUCK) === ACTION$1.TRUCK || (this._state & ACTION$1.SCREEN_PAN) === ACTION$1.SCREEN_PAN || (this._state & ACTION$1.TOUCH_TRUCK) === ACTION$1.TOUCH_TRUCK || (this._state & ACTION$1.TOUCH_SCREEN_PAN) === ACTION$1.TOUCH_SCREEN_PAN || (this._state & ACTION$1.TOUCH_DOLLY_TRUCK) === ACTION$1.TOUCH_DOLLY_TRUCK || (this._state & ACTION$1.TOUCH_DOLLY_SCREEN_PAN) === ACTION$1.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION$1.TOUCH_ZOOM_TRUCK) === ACTION$1.TOUCH_ZOOM_TRUCK || (this._state & ACTION$1.TOUCH_ZOOM_SCREEN_PAN) === ACTION$1.TOUCH_DOLLY_SCREEN_PAN) {
        this._targetEnd.copy(this._target);
        this._targetVelocity.set(0, 0, 0);
      }
      if ((this._state & ACTION$1.DOLLY) === ACTION$1.DOLLY || (this._state & ACTION$1.TOUCH_DOLLY) === ACTION$1.TOUCH_DOLLY || (this._state & ACTION$1.TOUCH_DOLLY_TRUCK) === ACTION$1.TOUCH_DOLLY_TRUCK || (this._state & ACTION$1.TOUCH_DOLLY_SCREEN_PAN) === ACTION$1.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION$1.TOUCH_DOLLY_OFFSET) === ACTION$1.TOUCH_DOLLY_OFFSET || (this._state & ACTION$1.TOUCH_DOLLY_ROTATE) === ACTION$1.TOUCH_DOLLY_ROTATE) {
        this._sphericalEnd.radius = this._spherical.radius;
        this._radiusVelocity.value = 0;
      }
      if ((this._state & ACTION$1.ZOOM) === ACTION$1.ZOOM || (this._state & ACTION$1.TOUCH_ZOOM) === ACTION$1.TOUCH_ZOOM || (this._state & ACTION$1.TOUCH_ZOOM_TRUCK) === ACTION$1.TOUCH_ZOOM_TRUCK || (this._state & ACTION$1.TOUCH_ZOOM_SCREEN_PAN) === ACTION$1.TOUCH_ZOOM_SCREEN_PAN || (this._state & ACTION$1.TOUCH_ZOOM_OFFSET) === ACTION$1.TOUCH_ZOOM_OFFSET || (this._state & ACTION$1.TOUCH_ZOOM_ROTATE) === ACTION$1.TOUCH_ZOOM_ROTATE) {
        this._zoomEnd = this._zoom;
        this._zoomVelocity.value = 0;
      }
      if ((this._state & ACTION$1.OFFSET) === ACTION$1.OFFSET || (this._state & ACTION$1.TOUCH_OFFSET) === ACTION$1.TOUCH_OFFSET || (this._state & ACTION$1.TOUCH_DOLLY_OFFSET) === ACTION$1.TOUCH_DOLLY_OFFSET || (this._state & ACTION$1.TOUCH_ZOOM_OFFSET) === ACTION$1.TOUCH_ZOOM_OFFSET) {
        this._focalOffsetEnd.copy(this._focalOffset);
        this._focalOffsetVelocity.set(0, 0, 0);
      }
      this.dispatchEvent({ type: "controlstart" });
    };
    const dragging = () => {
      if (!this._enabled || !this._dragNeedsUpdate)
        return;
      this._dragNeedsUpdate = false;
      extractClientCoordFromEvent$1(this._activePointers, _v2$1);
      const isPointerLockActive = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement;
      const lockedPointer = isPointerLockActive ? this._lockedPointer || this._activePointers[0] : null;
      const deltaX = lockedPointer ? -lockedPointer.deltaX : lastDragPosition.x - _v2$1.x;
      const deltaY = lockedPointer ? -lockedPointer.deltaY : lastDragPosition.y - _v2$1.y;
      lastDragPosition.copy(_v2$1);
      if ((this._state & ACTION$1.ROTATE) === ACTION$1.ROTATE || (this._state & ACTION$1.TOUCH_ROTATE) === ACTION$1.TOUCH_ROTATE || (this._state & ACTION$1.TOUCH_DOLLY_ROTATE) === ACTION$1.TOUCH_DOLLY_ROTATE || (this._state & ACTION$1.TOUCH_ZOOM_ROTATE) === ACTION$1.TOUCH_ZOOM_ROTATE) {
        this._rotateInternal(deltaX, deltaY);
        this._isUserControllingRotate = true;
      }
      if ((this._state & ACTION$1.DOLLY) === ACTION$1.DOLLY || (this._state & ACTION$1.ZOOM) === ACTION$1.ZOOM) {
        const dollyX = this.dollyToCursor ? (dragStartPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
        const dollyY = this.dollyToCursor ? (dragStartPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
        const dollyDirection = this.dollyDragInverted ? -1 : 1;
        if ((this._state & ACTION$1.DOLLY) === ACTION$1.DOLLY) {
          this._dollyInternal(dollyDirection * deltaY * TOUCH_DOLLY_FACTOR$1, dollyX, dollyY);
          this._isUserControllingDolly = true;
        } else {
          this._zoomInternal(dollyDirection * deltaY * TOUCH_DOLLY_FACTOR$1, dollyX, dollyY);
          this._isUserControllingZoom = true;
        }
      }
      if ((this._state & ACTION$1.TOUCH_DOLLY) === ACTION$1.TOUCH_DOLLY || (this._state & ACTION$1.TOUCH_ZOOM) === ACTION$1.TOUCH_ZOOM || (this._state & ACTION$1.TOUCH_DOLLY_TRUCK) === ACTION$1.TOUCH_DOLLY_TRUCK || (this._state & ACTION$1.TOUCH_ZOOM_TRUCK) === ACTION$1.TOUCH_ZOOM_TRUCK || (this._state & ACTION$1.TOUCH_DOLLY_SCREEN_PAN) === ACTION$1.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION$1.TOUCH_ZOOM_SCREEN_PAN) === ACTION$1.TOUCH_ZOOM_SCREEN_PAN || (this._state & ACTION$1.TOUCH_DOLLY_OFFSET) === ACTION$1.TOUCH_DOLLY_OFFSET || (this._state & ACTION$1.TOUCH_ZOOM_OFFSET) === ACTION$1.TOUCH_ZOOM_OFFSET || (this._state & ACTION$1.TOUCH_DOLLY_ROTATE) === ACTION$1.TOUCH_DOLLY_ROTATE || (this._state & ACTION$1.TOUCH_ZOOM_ROTATE) === ACTION$1.TOUCH_ZOOM_ROTATE) {
        const dx = _v2$1.x - this._activePointers[1].clientX;
        const dy = _v2$1.y - this._activePointers[1].clientY;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const dollyDelta = dollyStart.y - distance;
        dollyStart.set(0, distance);
        const dollyX = this.dollyToCursor ? (lastDragPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
        const dollyY = this.dollyToCursor ? (lastDragPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
        if ((this._state & ACTION$1.TOUCH_DOLLY) === ACTION$1.TOUCH_DOLLY || (this._state & ACTION$1.TOUCH_DOLLY_ROTATE) === ACTION$1.TOUCH_DOLLY_ROTATE || (this._state & ACTION$1.TOUCH_DOLLY_TRUCK) === ACTION$1.TOUCH_DOLLY_TRUCK || (this._state & ACTION$1.TOUCH_DOLLY_SCREEN_PAN) === ACTION$1.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION$1.TOUCH_DOLLY_OFFSET) === ACTION$1.TOUCH_DOLLY_OFFSET) {
          this._dollyInternal(dollyDelta * TOUCH_DOLLY_FACTOR$1, dollyX, dollyY);
          this._isUserControllingDolly = true;
        } else {
          this._zoomInternal(dollyDelta * TOUCH_DOLLY_FACTOR$1, dollyX, dollyY);
          this._isUserControllingZoom = true;
        }
      }
      if ((this._state & ACTION$1.TRUCK) === ACTION$1.TRUCK || (this._state & ACTION$1.TOUCH_TRUCK) === ACTION$1.TOUCH_TRUCK || (this._state & ACTION$1.TOUCH_DOLLY_TRUCK) === ACTION$1.TOUCH_DOLLY_TRUCK || (this._state & ACTION$1.TOUCH_ZOOM_TRUCK) === ACTION$1.TOUCH_ZOOM_TRUCK) {
        this._truckInternal(deltaX, deltaY, false, false);
        this._isUserControllingTruck = true;
      }
      if ((this._state & ACTION$1.SCREEN_PAN) === ACTION$1.SCREEN_PAN || (this._state & ACTION$1.TOUCH_SCREEN_PAN) === ACTION$1.TOUCH_SCREEN_PAN || (this._state & ACTION$1.TOUCH_DOLLY_SCREEN_PAN) === ACTION$1.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION$1.TOUCH_ZOOM_SCREEN_PAN) === ACTION$1.TOUCH_ZOOM_SCREEN_PAN) {
        this._truckInternal(deltaX, deltaY, false, true);
        this._isUserControllingTruck = true;
      }
      if ((this._state & ACTION$1.OFFSET) === ACTION$1.OFFSET || (this._state & ACTION$1.TOUCH_OFFSET) === ACTION$1.TOUCH_OFFSET || (this._state & ACTION$1.TOUCH_DOLLY_OFFSET) === ACTION$1.TOUCH_DOLLY_OFFSET || (this._state & ACTION$1.TOUCH_ZOOM_OFFSET) === ACTION$1.TOUCH_ZOOM_OFFSET) {
        this._truckInternal(deltaX, deltaY, true, false);
        this._isUserControllingOffset = true;
      }
      this.dispatchEvent({ type: "control" });
    };
    const endDragging = () => {
      extractClientCoordFromEvent$1(this._activePointers, _v2$1);
      lastDragPosition.copy(_v2$1);
      this._dragNeedsUpdate = false;
      if (this._activePointers.length === 0 || this._activePointers.length === 1 && this._activePointers[0] === this._lockedPointer) {
        this._isDragging = false;
      }
      if (this._activePointers.length === 0 && this._domElement) {
        this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
        this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
        this.dispatchEvent({ type: "controlend" });
      }
    };
    this.lockPointer = () => {
      if (!this._enabled || !this._domElement)
        return;
      this.cancel();
      this._lockedPointer = {
        pointerId: -1,
        clientX: 0,
        clientY: 0,
        deltaX: 0,
        deltaY: 0,
        mouseButton: null
      };
      this._activePointers.push(this._lockedPointer);
      this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
      this._domElement.requestPointerLock();
      this._domElement.ownerDocument.addEventListener("pointerlockchange", onPointerLockChange);
      this._domElement.ownerDocument.addEventListener("pointerlockerror", onPointerLockError);
      this._domElement.ownerDocument.addEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.addEventListener("pointerup", onPointerUp);
      startDragging();
    };
    this.unlockPointer = () => {
      var _a2, _b2, _c;
      if (this._lockedPointer !== null) {
        this._disposePointer(this._lockedPointer);
        this._lockedPointer = null;
      }
      (_a2 = this._domElement) === null || _a2 === void 0 ? void 0 : _a2.ownerDocument.exitPointerLock();
      (_b2 = this._domElement) === null || _b2 === void 0 ? void 0 : _b2.ownerDocument.removeEventListener("pointerlockchange", onPointerLockChange);
      (_c = this._domElement) === null || _c === void 0 ? void 0 : _c.ownerDocument.removeEventListener("pointerlockerror", onPointerLockError);
      this.cancel();
    };
    const onPointerLockChange = () => {
      const isPointerLockActive = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement;
      if (!isPointerLockActive)
        this.unlockPointer();
    };
    const onPointerLockError = () => {
      this.unlockPointer();
    };
    this._addAllEventListeners = (domElement2) => {
      this._domElement = domElement2;
      this._domElement.style.touchAction = "none";
      this._domElement.style.userSelect = "none";
      this._domElement.style.webkitUserSelect = "none";
      this._domElement.addEventListener("pointerdown", onPointerDown);
      this._domElement.addEventListener("pointercancel", onPointerUp);
      this._domElement.addEventListener("wheel", onMouseWheel, { passive: false });
      this._domElement.addEventListener("contextmenu", onContextMenu);
    };
    this._removeAllEventListeners = () => {
      if (!this._domElement)
        return;
      this._domElement.style.touchAction = "";
      this._domElement.style.userSelect = "";
      this._domElement.style.webkitUserSelect = "";
      this._domElement.removeEventListener("pointerdown", onPointerDown);
      this._domElement.removeEventListener("pointercancel", onPointerUp);
      this._domElement.removeEventListener("wheel", onMouseWheel, { passive: false });
      this._domElement.removeEventListener("contextmenu", onContextMenu);
      this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
      this._domElement.ownerDocument.removeEventListener("pointerlockchange", onPointerLockChange);
      this._domElement.ownerDocument.removeEventListener("pointerlockerror", onPointerLockError);
    };
    this.cancel = () => {
      if (this._state === ACTION$1.NONE)
        return;
      this._state = ACTION$1.NONE;
      this._activePointers.length = 0;
      endDragging();
    };
    if (domElement)
      this.connect(domElement);
    this.update(0);
  }
  /**
   * The camera to be controlled
   * @category Properties
   */
  get camera() {
    return this._camera;
  }
  set camera(camera) {
    this._camera = camera;
    this.updateCameraUp();
    this._camera.updateProjectionMatrix();
    this._updateNearPlaneCorners();
    this._needsUpdate = true;
  }
  /**
   * Whether or not the controls are enabled.
   * `false` to disable user dragging/touch-move, but all methods works.
   * @category Properties
   */
  get enabled() {
    return this._enabled;
  }
  set enabled(enabled) {
    this._enabled = enabled;
    if (!this._domElement)
      return;
    if (enabled) {
      this._domElement.style.touchAction = "none";
      this._domElement.style.userSelect = "none";
      this._domElement.style.webkitUserSelect = "none";
    } else {
      this.cancel();
      this._domElement.style.touchAction = "";
      this._domElement.style.userSelect = "";
      this._domElement.style.webkitUserSelect = "";
    }
  }
  /**
   * Returns `true` if the controls are active updating.
   * readonly value.
   * @category Properties
   */
  get active() {
    return !this._hasRested;
  }
  /**
   * Getter for the current `ACTION`.
   * readonly value.
   * @category Properties
   */
  get currentAction() {
    return this._state;
  }
  /**
   * get/set Current distance.
   * @category Properties
   */
  get distance() {
    return this._spherical.radius;
  }
  set distance(distance) {
    if (this._spherical.radius === distance && this._sphericalEnd.radius === distance)
      return;
    this._spherical.radius = distance;
    this._sphericalEnd.radius = distance;
    this._needsUpdate = true;
  }
  // horizontal angle
  /**
   * get/set the azimuth angle (horizontal) in radians.
   * Every 360 degrees turn is added to `.azimuthAngle` value, which is accumulative.
   * @category Properties
   */
  get azimuthAngle() {
    return this._spherical.theta;
  }
  set azimuthAngle(azimuthAngle) {
    if (this._spherical.theta === azimuthAngle && this._sphericalEnd.theta === azimuthAngle)
      return;
    this._spherical.theta = azimuthAngle;
    this._sphericalEnd.theta = azimuthAngle;
    this._needsUpdate = true;
  }
  // vertical angle
  /**
   * get/set the polar angle (vertical) in radians.
   * @category Properties
   */
  get polarAngle() {
    return this._spherical.phi;
  }
  set polarAngle(polarAngle) {
    if (this._spherical.phi === polarAngle && this._sphericalEnd.phi === polarAngle)
      return;
    this._spherical.phi = polarAngle;
    this._sphericalEnd.phi = polarAngle;
    this._needsUpdate = true;
  }
  /**
   * Whether camera position should be enclosed in the boundary or not.
   * @category Properties
   */
  get boundaryEnclosesCamera() {
    return this._boundaryEnclosesCamera;
  }
  set boundaryEnclosesCamera(boundaryEnclosesCamera) {
    this._boundaryEnclosesCamera = boundaryEnclosesCamera;
    this._needsUpdate = true;
  }
  /**
   * Set drag-start, touches and wheel enable area in the domElement.
   * each values are between `0` and `1` inclusive, where `0` is left/top and `1` is right/bottom of the screen.
   * e.g. `{ x: 0, y: 0, width: 1, height: 1 }` for entire area.
   * @category Properties
   */
  set interactiveArea(interactiveArea) {
    this._interactiveArea.width = clamp$2(interactiveArea.width, 0, 1);
    this._interactiveArea.height = clamp$2(interactiveArea.height, 0, 1);
    this._interactiveArea.x = clamp$2(interactiveArea.x, 0, 1 - this._interactiveArea.width);
    this._interactiveArea.y = clamp$2(interactiveArea.y, 0, 1 - this._interactiveArea.height);
  }
  /**
   * Adds the specified event listener.
   * Applicable event types (which is `K`) are:
   * | Event name          | Timing |
   * | ------------------- | ------ |
   * | `'controlstart'`    | When the user starts to control the camera via mouse / touches. ¹ |
   * | `'control'`         | When the user controls the camera (dragging). |
   * | `'controlend'`      | When the user ends to control the camera. ¹ |
   * | `'transitionstart'` | When any kind of transition starts, either user control or using a method with `enableTransition = true` |
   * | `'update'`          | When the camera position is updated. |
   * | `'wake'`            | When the camera starts moving. |
   * | `'rest'`            | When the camera movement is below `.restThreshold` ². |
   * | `'sleep'`           | When the camera end moving. |
   *
   * 1. `mouseButtons.wheel` (Mouse wheel control) does not emit `'controlstart'` and `'controlend'`. `mouseButtons.wheel` uses scroll-event internally, and scroll-event happens intermittently. That means "start" and "end" cannot be detected.
   * 2. Due to damping, `sleep` will usually fire a few seconds after the camera _appears_ to have stopped moving. If you want to do something (e.g. enable UI, perform another transition) at the point when the camera has stopped, you probably want the `rest` event. This can be fine tuned using the `.restThreshold` parameter. See the [Rest and Sleep Example](https://yomotsu.github.io/camera-controls/examples/rest-and-sleep.html).
   *
   * e.g.
   * ```
   * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
   * ```
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  addEventListener(type, listener) {
    super.addEventListener(type, listener);
  }
  /**
   * Removes the specified event listener
   * e.g.
   * ```
   * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
   * ```
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  removeEventListener(type, listener) {
    super.removeEventListener(type, listener);
  }
  /**
   * Rotate azimuthal angle(horizontal) and polar angle(vertical).
   * Every value is added to the current value.
   * @param azimuthAngle Azimuth rotate angle. In radian.
   * @param polarAngle Polar rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  rotate(azimuthAngle, polarAngle, enableTransition = false) {
    return this.rotateTo(this._sphericalEnd.theta + azimuthAngle, this._sphericalEnd.phi + polarAngle, enableTransition);
  }
  /**
   * Rotate azimuthal angle(horizontal) to the given angle and keep the same polar angle(vertical) target.
   *
   * e.g.
   * ```
   * cameraControls.rotateAzimuthTo( 30 * THREE.MathUtils.DEG2RAD, true );
   * ```
   * @param azimuthAngle Azimuth rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  rotateAzimuthTo(azimuthAngle, enableTransition = false) {
    return this.rotateTo(azimuthAngle, this._sphericalEnd.phi, enableTransition);
  }
  /**
   * Rotate polar angle(vertical) to the given angle and keep the same azimuthal angle(horizontal) target.
   *
   * e.g.
   * ```
   * cameraControls.rotatePolarTo( 30 * THREE.MathUtils.DEG2RAD, true );
   * ```
   * @param polarAngle Polar rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  rotatePolarTo(polarAngle, enableTransition = false) {
    return this.rotateTo(this._sphericalEnd.theta, polarAngle, enableTransition);
  }
  /**
   * Rotate azimuthal angle(horizontal) and polar angle(vertical) to the given angle.
   * Camera view will rotate over the orbit pivot absolutely:
   *
   * azimuthAngle
   * ```
   *       0º
   *         \
   * 90º -----+----- -90º
   *           \
   *           180º
   * ```
   * | direction | angle                  |
   * | --------- | ---------------------- |
   * | front     | 0º                     |
   * | left      | 90º (`Math.PI / 2`)    |
   * | right     | -90º (`- Math.PI / 2`) |
   * | back      | 180º (`Math.PI`)       |
   *
   * polarAngle
   * ```
   *     180º
   *      |
   *      90º
   *      |
   *      0º
   * ```
   * | direction            | angle                  |
   * | -------------------- | ---------------------- |
   * | top/sky              | 180º (`Math.PI`)       |
   * | horizontal from view | 90º (`Math.PI / 2`)    |
   * | bottom/floor         | 0º                     |
   *
   * @param azimuthAngle Azimuth rotate angle to. In radian.
   * @param polarAngle Polar rotate angle to. In radian.
   * @param enableTransition  Whether to move smoothly or immediately
   * @category Methods
   */
  rotateTo(azimuthAngle, polarAngle, enableTransition = false) {
    this._isUserControllingRotate = false;
    const theta = clamp$2(azimuthAngle, this.minAzimuthAngle, this.maxAzimuthAngle);
    const phi = clamp$2(polarAngle, this.minPolarAngle, this.maxPolarAngle);
    this._sphericalEnd.theta = theta;
    this._sphericalEnd.phi = phi;
    this._sphericalEnd.makeSafe();
    this._needsUpdate = true;
    if (!enableTransition) {
      this._spherical.theta = this._sphericalEnd.theta;
      this._spherical.phi = this._sphericalEnd.phi;
    }
    const resolveImmediately = !enableTransition || approxEquals$1(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && approxEquals$1(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Dolly in/out camera position.
   * @param distance Distance of dollyIn. Negative number for dollyOut.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */
  dolly(distance, enableTransition = false) {
    return this.dollyTo(this._sphericalEnd.radius - distance, enableTransition);
  }
  /**
   * Dolly in/out camera position to given distance.
   * @param distance Distance of dolly.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */
  dollyTo(distance, enableTransition = false) {
    this._isUserControllingDolly = false;
    this._lastDollyDirection = DOLLY_DIRECTION$1.NONE;
    this._changedDolly = 0;
    return this._dollyToNoClamp(clamp$2(distance, this.minDistance, this.maxDistance), enableTransition);
  }
  _dollyToNoClamp(distance, enableTransition = false) {
    const lastRadius = this._sphericalEnd.radius;
    const hasCollider = this.colliderMeshes.length >= 1;
    if (hasCollider) {
      const maxDistanceByCollisionTest = this._collisionTest();
      const isCollided = approxEquals$1(maxDistanceByCollisionTest, this._spherical.radius);
      const isDollyIn = lastRadius > distance;
      if (!isDollyIn && isCollided)
        return Promise.resolve();
      this._sphericalEnd.radius = Math.min(distance, maxDistanceByCollisionTest);
    } else {
      this._sphericalEnd.radius = distance;
    }
    this._needsUpdate = true;
    if (!enableTransition) {
      this._spherical.radius = this._sphericalEnd.radius;
    }
    const resolveImmediately = !enableTransition || approxEquals$1(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Dolly in, but does not change the distance between the target and the camera, and moves the target position instead.
   * Specify a negative value for dolly out.
   * @param distance Distance of dolly.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */
  dollyInFixed(distance, enableTransition = false) {
    this._targetEnd.add(this._getCameraDirection(_cameraDirection$1).multiplyScalar(distance));
    if (!enableTransition) {
      this._target.copy(this._targetEnd);
    }
    const resolveImmediately = !enableTransition || approxEquals$1(this._target.x, this._targetEnd.x, this.restThreshold) && approxEquals$1(this._target.y, this._targetEnd.y, this.restThreshold) && approxEquals$1(this._target.z, this._targetEnd.z, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Zoom in/out camera. The value is added to camera zoom.
   * Limits set with `.minZoom` and `.maxZoom`
   * @param zoomStep zoom scale
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  zoom(zoomStep, enableTransition = false) {
    return this.zoomTo(this._zoomEnd + zoomStep, enableTransition);
  }
  /**
   * Zoom in/out camera to given scale. The value overwrites camera zoom.
   * Limits set with .minZoom and .maxZoom
   * @param zoom
   * @param enableTransition
   * @category Methods
   */
  zoomTo(zoom, enableTransition = false) {
    this._isUserControllingZoom = false;
    this._zoomEnd = clamp$2(zoom, this.minZoom, this.maxZoom);
    this._needsUpdate = true;
    if (!enableTransition) {
      this._zoom = this._zoomEnd;
    }
    const resolveImmediately = !enableTransition || approxEquals$1(this._zoom, this._zoomEnd, this.restThreshold);
    this._changedZoom = 0;
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * @deprecated `pan()` has been renamed to `truck()`
   * @category Methods
   */
  pan(x3, y2, enableTransition = false) {
    console.warn("`pan` has been renamed to `truck`");
    return this.truck(x3, y2, enableTransition);
  }
  /**
   * Truck and pedestal camera using current azimuthal angle
   * @param x Horizontal translate amount
   * @param y Vertical translate amount
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  truck(x3, y2, enableTransition = false) {
    this._camera.updateMatrix();
    _xColumn$1.setFromMatrixColumn(this._camera.matrix, 0);
    _yColumn$1.setFromMatrixColumn(this._camera.matrix, 1);
    _xColumn$1.multiplyScalar(x3);
    _yColumn$1.multiplyScalar(-y2);
    const offset = _v3A$1.copy(_xColumn$1).add(_yColumn$1);
    const to2 = _v3B$1.copy(this._targetEnd).add(offset);
    return this.moveTo(to2.x, to2.y, to2.z, enableTransition);
  }
  /**
   * Move forward / backward.
   * @param distance Amount to move forward / backward. Negative value to move backward
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  forward(distance, enableTransition = false) {
    _v3A$1.setFromMatrixColumn(this._camera.matrix, 0);
    _v3A$1.crossVectors(this._camera.up, _v3A$1);
    _v3A$1.multiplyScalar(distance);
    const to2 = _v3B$1.copy(this._targetEnd).add(_v3A$1);
    return this.moveTo(to2.x, to2.y, to2.z, enableTransition);
  }
  /**
   * Move up / down.
   * @param height Amount to move up / down. Negative value to move down
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  elevate(height, enableTransition = false) {
    _v3A$1.copy(this._camera.up).multiplyScalar(height);
    return this.moveTo(this._targetEnd.x + _v3A$1.x, this._targetEnd.y + _v3A$1.y, this._targetEnd.z + _v3A$1.z, enableTransition);
  }
  /**
   * Move target position to given point.
   * @param x x coord to move center position
   * @param y y coord to move center position
   * @param z z coord to move center position
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  moveTo(x3, y2, z2, enableTransition = false) {
    this._isUserControllingTruck = false;
    const offset = _v3A$1.set(x3, y2, z2).sub(this._targetEnd);
    this._encloseToBoundary(this._targetEnd, offset, this.boundaryFriction);
    this._needsUpdate = true;
    if (!enableTransition) {
      this._target.copy(this._targetEnd);
    }
    const resolveImmediately = !enableTransition || approxEquals$1(this._target.x, this._targetEnd.x, this.restThreshold) && approxEquals$1(this._target.y, this._targetEnd.y, this.restThreshold) && approxEquals$1(this._target.z, this._targetEnd.z, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Look in the given point direction.
   * @param x point x.
   * @param y point y.
   * @param z point z.
   * @param enableTransition Whether to move smoothly or immediately.
   * @returns Transition end promise
   * @category Methods
   */
  lookInDirectionOf(x3, y2, z2, enableTransition = false) {
    const point = _v3A$1.set(x3, y2, z2);
    const direction = point.sub(this._targetEnd).normalize();
    const position = direction.multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
    return this.setPosition(position.x, position.y, position.z, enableTransition);
  }
  /**
   * Fit the viewport to the box or the bounding box of the object, using the nearest axis. paddings are in unit.
   * set `cover: true` to fill enter screen.
   * e.g.
   * ```
   * cameraControls.fitToBox( myMesh );
   * ```
   * @param box3OrObject Axis aligned bounding box to fit the view.
   * @param enableTransition Whether to move smoothly or immediately.
   * @param options | `<object>` { cover: boolean, paddingTop: number, paddingLeft: number, paddingBottom: number, paddingRight: number }
   * @returns Transition end promise
   * @category Methods
   */
  fitToBox(box3OrObject, enableTransition, { cover: cover2 = false, paddingLeft = 0, paddingRight = 0, paddingBottom = 0, paddingTop = 0 } = {}) {
    const promises = [];
    const aabb = box3OrObject.isBox3 ? _box3A$1.copy(box3OrObject) : _box3A$1.setFromObject(box3OrObject);
    if (aabb.isEmpty()) {
      console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting");
      Promise.resolve();
    }
    const theta = roundToStep$1(this._sphericalEnd.theta, PI_HALF$1);
    const phi = roundToStep$1(this._sphericalEnd.phi, PI_HALF$1);
    promises.push(this.rotateTo(theta, phi, enableTransition));
    const normal = _v3A$1.setFromSpherical(this._sphericalEnd).normalize();
    const rotation = _quaternionA$1.setFromUnitVectors(normal, _AXIS_Z$1);
    const viewFromPolar = approxEquals$1(Math.abs(normal.y), 1);
    if (viewFromPolar) {
      rotation.multiply(_quaternionB$1.setFromAxisAngle(_AXIS_Y$1, theta));
    }
    rotation.multiply(this._yAxisUpSpaceInverse);
    const bb = _box3B$1.makeEmpty();
    _v3B$1.copy(aabb.min).applyQuaternion(rotation);
    bb.expandByPoint(_v3B$1);
    _v3B$1.copy(aabb.min).setX(aabb.max.x).applyQuaternion(rotation);
    bb.expandByPoint(_v3B$1);
    _v3B$1.copy(aabb.min).setY(aabb.max.y).applyQuaternion(rotation);
    bb.expandByPoint(_v3B$1);
    _v3B$1.copy(aabb.max).setZ(aabb.min.z).applyQuaternion(rotation);
    bb.expandByPoint(_v3B$1);
    _v3B$1.copy(aabb.min).setZ(aabb.max.z).applyQuaternion(rotation);
    bb.expandByPoint(_v3B$1);
    _v3B$1.copy(aabb.max).setY(aabb.min.y).applyQuaternion(rotation);
    bb.expandByPoint(_v3B$1);
    _v3B$1.copy(aabb.max).setX(aabb.min.x).applyQuaternion(rotation);
    bb.expandByPoint(_v3B$1);
    _v3B$1.copy(aabb.max).applyQuaternion(rotation);
    bb.expandByPoint(_v3B$1);
    bb.min.x -= paddingLeft;
    bb.min.y -= paddingBottom;
    bb.max.x += paddingRight;
    bb.max.y += paddingTop;
    rotation.setFromUnitVectors(_AXIS_Z$1, normal);
    if (viewFromPolar) {
      rotation.premultiply(_quaternionB$1.invert());
    }
    rotation.premultiply(this._yAxisUpSpace);
    const bbSize = bb.getSize(_v3A$1);
    const center = bb.getCenter(_v3B$1).applyQuaternion(rotation);
    if (isPerspectiveCamera$1(this._camera)) {
      const distance = this.getDistanceToFitBox(bbSize.x, bbSize.y, bbSize.z, cover2);
      promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
      promises.push(this.dollyTo(distance, enableTransition));
      promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
    } else if (isOrthographicCamera$1(this._camera)) {
      const camera = this._camera;
      const width = camera.right - camera.left;
      const height = camera.top - camera.bottom;
      const zoom = cover2 ? Math.max(width / bbSize.x, height / bbSize.y) : Math.min(width / bbSize.x, height / bbSize.y);
      promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
      promises.push(this.zoomTo(zoom, enableTransition));
      promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
    }
    return Promise.all(promises);
  }
  /**
   * Fit the viewport to the sphere or the bounding sphere of the object.
   * @param sphereOrMesh
   * @param enableTransition
   * @category Methods
   */
  fitToSphere(sphereOrMesh, enableTransition) {
    const promises = [];
    const isObject3D = "isObject3D" in sphereOrMesh;
    const boundingSphere = isObject3D ? CameraControls.createBoundingSphere(sphereOrMesh, _sphere$1) : _sphere$1.copy(sphereOrMesh);
    promises.push(this.moveTo(boundingSphere.center.x, boundingSphere.center.y, boundingSphere.center.z, enableTransition));
    if (isPerspectiveCamera$1(this._camera)) {
      const distanceToFit = this.getDistanceToFitSphere(boundingSphere.radius);
      promises.push(this.dollyTo(distanceToFit, enableTransition));
    } else if (isOrthographicCamera$1(this._camera)) {
      const width = this._camera.right - this._camera.left;
      const height = this._camera.top - this._camera.bottom;
      const diameter = 2 * boundingSphere.radius;
      const zoom = Math.min(width / diameter, height / diameter);
      promises.push(this.zoomTo(zoom, enableTransition));
    }
    promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
    return Promise.all(promises);
  }
  /**
   * Look at the `target` from the `position`.
   * @param positionX
   * @param positionY
   * @param positionZ
   * @param targetX
   * @param targetY
   * @param targetZ
   * @param enableTransition
   * @category Methods
   */
  setLookAt(positionX, positionY, positionZ, targetX, targetY, targetZ, enableTransition = false) {
    this._isUserControllingRotate = false;
    this._isUserControllingDolly = false;
    this._isUserControllingTruck = false;
    this._lastDollyDirection = DOLLY_DIRECTION$1.NONE;
    this._changedDolly = 0;
    const target = _v3B$1.set(targetX, targetY, targetZ);
    const position = _v3A$1.set(positionX, positionY, positionZ);
    this._targetEnd.copy(target);
    this._sphericalEnd.setFromVector3(position.sub(target).applyQuaternion(this._yAxisUpSpace));
    this.normalizeRotations();
    this._needsUpdate = true;
    if (!enableTransition) {
      this._target.copy(this._targetEnd);
      this._spherical.copy(this._sphericalEnd);
    }
    const resolveImmediately = !enableTransition || approxEquals$1(this._target.x, this._targetEnd.x, this.restThreshold) && approxEquals$1(this._target.y, this._targetEnd.y, this.restThreshold) && approxEquals$1(this._target.z, this._targetEnd.z, this.restThreshold) && approxEquals$1(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && approxEquals$1(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && approxEquals$1(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Similar to setLookAt, but it interpolates between two states.
   * @param positionAX
   * @param positionAY
   * @param positionAZ
   * @param targetAX
   * @param targetAY
   * @param targetAZ
   * @param positionBX
   * @param positionBY
   * @param positionBZ
   * @param targetBX
   * @param targetBY
   * @param targetBZ
   * @param t
   * @param enableTransition
   * @category Methods
   */
  lerpLookAt(positionAX, positionAY, positionAZ, targetAX, targetAY, targetAZ, positionBX, positionBY, positionBZ, targetBX, targetBY, targetBZ, t2, enableTransition = false) {
    this._isUserControllingRotate = false;
    this._isUserControllingDolly = false;
    this._isUserControllingTruck = false;
    this._lastDollyDirection = DOLLY_DIRECTION$1.NONE;
    this._changedDolly = 0;
    const targetA = _v3A$1.set(targetAX, targetAY, targetAZ);
    const positionA = _v3B$1.set(positionAX, positionAY, positionAZ);
    _sphericalA$1.setFromVector3(positionA.sub(targetA).applyQuaternion(this._yAxisUpSpace));
    const targetB = _v3C$1.set(targetBX, targetBY, targetBZ);
    const positionB = _v3B$1.set(positionBX, positionBY, positionBZ);
    _sphericalB$1.setFromVector3(positionB.sub(targetB).applyQuaternion(this._yAxisUpSpace));
    this._targetEnd.copy(targetA.lerp(targetB, t2));
    const deltaTheta = _sphericalB$1.theta - _sphericalA$1.theta;
    const deltaPhi = _sphericalB$1.phi - _sphericalA$1.phi;
    const deltaRadius = _sphericalB$1.radius - _sphericalA$1.radius;
    this._sphericalEnd.set(_sphericalA$1.radius + deltaRadius * t2, _sphericalA$1.phi + deltaPhi * t2, _sphericalA$1.theta + deltaTheta * t2);
    this.normalizeRotations();
    this._needsUpdate = true;
    if (!enableTransition) {
      this._target.copy(this._targetEnd);
      this._spherical.copy(this._sphericalEnd);
    }
    const resolveImmediately = !enableTransition || approxEquals$1(this._target.x, this._targetEnd.x, this.restThreshold) && approxEquals$1(this._target.y, this._targetEnd.y, this.restThreshold) && approxEquals$1(this._target.z, this._targetEnd.z, this.restThreshold) && approxEquals$1(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && approxEquals$1(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && approxEquals$1(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Set angle and distance by given position.
   * An alias of `setLookAt()`, without target change. Thus keep gazing at the current target
   * @param positionX
   * @param positionY
   * @param positionZ
   * @param enableTransition
   * @category Methods
   */
  setPosition(positionX, positionY, positionZ, enableTransition = false) {
    return this.setLookAt(positionX, positionY, positionZ, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, enableTransition);
  }
  /**
   * Set the target position where gaze at.
   * An alias of `setLookAt()`, without position change. Thus keep the same position.
   * @param targetX
   * @param targetY
   * @param targetZ
   * @param enableTransition
   * @category Methods
   */
  setTarget(targetX, targetY, targetZ, enableTransition = false) {
    const pos = this.getPosition(_v3A$1);
    const promise = this.setLookAt(pos.x, pos.y, pos.z, targetX, targetY, targetZ, enableTransition);
    this._sphericalEnd.phi = clamp$2(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle);
    return promise;
  }
  /**
   * Set focal offset using the screen parallel coordinates. z doesn't affect in Orthographic as with Dolly.
   * @param x
   * @param y
   * @param z
   * @param enableTransition
   * @category Methods
   */
  setFocalOffset(x3, y2, z2, enableTransition = false) {
    this._isUserControllingOffset = false;
    this._focalOffsetEnd.set(x3, y2, z2);
    this._needsUpdate = true;
    if (!enableTransition)
      this._focalOffset.copy(this._focalOffsetEnd);
    const resolveImmediately = !enableTransition || approxEquals$1(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && approxEquals$1(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && approxEquals$1(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Set orbit point without moving the camera.
   * SHOULD NOT RUN DURING ANIMATIONS. `setOrbitPoint()` will immediately fix the positions.
   * @param targetX
   * @param targetY
   * @param targetZ
   * @category Methods
   */
  setOrbitPoint(targetX, targetY, targetZ) {
    this._camera.updateMatrixWorld();
    _xColumn$1.setFromMatrixColumn(this._camera.matrixWorldInverse, 0);
    _yColumn$1.setFromMatrixColumn(this._camera.matrixWorldInverse, 1);
    _zColumn$1.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
    const position = _v3A$1.set(targetX, targetY, targetZ);
    const distance = position.distanceTo(this._camera.position);
    const cameraToPoint = position.sub(this._camera.position);
    _xColumn$1.multiplyScalar(cameraToPoint.x);
    _yColumn$1.multiplyScalar(cameraToPoint.y);
    _zColumn$1.multiplyScalar(cameraToPoint.z);
    _v3A$1.copy(_xColumn$1).add(_yColumn$1).add(_zColumn$1);
    _v3A$1.z = _v3A$1.z + distance;
    this.dollyTo(distance, false);
    this.setFocalOffset(-_v3A$1.x, _v3A$1.y, -_v3A$1.z, false);
    this.moveTo(targetX, targetY, targetZ, false);
  }
  /**
   * Set the boundary box that encloses the target of the camera. box3 is in THREE.Box3
   * @param box3
   * @category Methods
   */
  setBoundary(box3) {
    if (!box3) {
      this._boundary.min.set(-Infinity, -Infinity, -Infinity);
      this._boundary.max.set(Infinity, Infinity, Infinity);
      this._needsUpdate = true;
      return;
    }
    this._boundary.copy(box3);
    this._boundary.clampPoint(this._targetEnd, this._targetEnd);
    this._needsUpdate = true;
  }
  /**
   * Set (or unset) the current viewport.
   * Set this when you want to use renderer viewport and .dollyToCursor feature at the same time.
   * @param viewportOrX
   * @param y
   * @param width
   * @param height
   * @category Methods
   */
  setViewport(viewportOrX, y2, width, height) {
    if (viewportOrX === null) {
      this._viewport = null;
      return;
    }
    this._viewport = this._viewport || new THREE$1.Vector4();
    if (typeof viewportOrX === "number") {
      this._viewport.set(viewportOrX, y2, width, height);
    } else {
      this._viewport.copy(viewportOrX);
    }
  }
  /**
   * Calculate the distance to fit the box.
   * @param width box width
   * @param height box height
   * @param depth box depth
   * @returns distance
   * @category Methods
   */
  getDistanceToFitBox(width, height, depth, cover2 = false) {
    if (notSupportedInOrthographicCamera$1(this._camera, "getDistanceToFitBox"))
      return this._spherical.radius;
    const boundingRectAspect = width / height;
    const fov2 = this._camera.getEffectiveFOV() * DEG2RAD$1;
    const aspect2 = this._camera.aspect;
    const heightToFit = (cover2 ? boundingRectAspect > aspect2 : boundingRectAspect < aspect2) ? height : width / aspect2;
    return heightToFit * 0.5 / Math.tan(fov2 * 0.5) + depth * 0.5;
  }
  /**
   * Calculate the distance to fit the sphere.
   * @param radius sphere radius
   * @returns distance
   * @category Methods
   */
  getDistanceToFitSphere(radius) {
    if (notSupportedInOrthographicCamera$1(this._camera, "getDistanceToFitSphere"))
      return this._spherical.radius;
    const vFOV = this._camera.getEffectiveFOV() * DEG2RAD$1;
    const hFOV = Math.atan(Math.tan(vFOV * 0.5) * this._camera.aspect) * 2;
    const fov2 = 1 < this._camera.aspect ? vFOV : hFOV;
    return radius / Math.sin(fov2 * 0.5);
  }
  /**
   * Returns the orbit center position, where the camera looking at.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getTarget(out7, receiveEndValue = true) {
    const _out = !!out7 && out7.isVector3 ? out7 : new THREE$1.Vector3();
    return _out.copy(receiveEndValue ? this._targetEnd : this._target);
  }
  /**
   * Returns the camera position.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getPosition(out7, receiveEndValue = true) {
    const _out = !!out7 && out7.isVector3 ? out7 : new THREE$1.Vector3();
    return _out.setFromSpherical(receiveEndValue ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(receiveEndValue ? this._targetEnd : this._target);
  }
  /**
   * Returns the spherical coordinates of the orbit.
   * @param out The receiving Spherical instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getSpherical(out7, receiveEndValue = true) {
    const _out = out7 || new THREE$1.Spherical();
    return _out.copy(receiveEndValue ? this._sphericalEnd : this._spherical);
  }
  /**
   * Returns the focal offset, which is how much the camera appears to be translated in screen parallel coordinates.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getFocalOffset(out7, receiveEndValue = true) {
    const _out = !!out7 && out7.isVector3 ? out7 : new THREE$1.Vector3();
    return _out.copy(receiveEndValue ? this._focalOffsetEnd : this._focalOffset);
  }
  /**
   * Normalize camera azimuth angle rotation between 0 and 360 degrees.
   * @category Methods
   */
  normalizeRotations() {
    this._sphericalEnd.theta = this._sphericalEnd.theta % PI_2$1;
    if (this._sphericalEnd.theta < 0)
      this._sphericalEnd.theta += PI_2$1;
    this._spherical.theta += PI_2$1 * Math.round((this._sphericalEnd.theta - this._spherical.theta) / PI_2$1);
  }
  /**
   * stop all transitions.
   */
  stop() {
    this._focalOffset.copy(this._focalOffsetEnd);
    this._target.copy(this._targetEnd);
    this._spherical.copy(this._sphericalEnd);
    this._zoom = this._zoomEnd;
  }
  /**
   * Reset all rotation and position to defaults.
   * @param enableTransition
   * @category Methods
   */
  reset(enableTransition = false) {
    if (!approxEquals$1(this._camera.up.x, this._cameraUp0.x) || !approxEquals$1(this._camera.up.y, this._cameraUp0.y) || !approxEquals$1(this._camera.up.z, this._cameraUp0.z)) {
      this._camera.up.copy(this._cameraUp0);
      const position = this.getPosition(_v3A$1);
      this.updateCameraUp();
      this.setPosition(position.x, position.y, position.z);
    }
    const promises = [
      this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, enableTransition),
      this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, enableTransition),
      this.zoomTo(this._zoom0, enableTransition)
    ];
    return Promise.all(promises);
  }
  /**
   * Set current camera position as the default position.
   * @category Methods
   */
  saveState() {
    this._cameraUp0.copy(this._camera.up);
    this.getTarget(this._target0);
    this.getPosition(this._position0);
    this._zoom0 = this._zoom;
    this._focalOffset0.copy(this._focalOffset);
  }
  /**
   * Sync camera-up direction.
   * When camera-up vector is changed, `.updateCameraUp()` must be called.
   * @category Methods
   */
  updateCameraUp() {
    this._yAxisUpSpace.setFromUnitVectors(this._camera.up, _AXIS_Y$1);
    this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
  }
  /**
   * Apply current camera-up direction to the camera.
   * The orbit system will be re-initialized with the current position.
   * @category Methods
   */
  applyCameraUp() {
    const cameraDirection = _v3A$1.subVectors(this._target, this._camera.position).normalize();
    const side = _v3B$1.crossVectors(cameraDirection, this._camera.up);
    this._camera.up.crossVectors(side, cameraDirection).normalize();
    this._camera.updateMatrixWorld();
    const position = this.getPosition(_v3A$1);
    this.updateCameraUp();
    this.setPosition(position.x, position.y, position.z);
  }
  /**
   * Update camera position and directions.
   * This should be called in your tick loop every time, and returns true if re-rendering is needed.
   * @param delta
   * @returns updated
   * @category Methods
   */
  update(delta) {
    const deltaTheta = this._sphericalEnd.theta - this._spherical.theta;
    const deltaPhi = this._sphericalEnd.phi - this._spherical.phi;
    const deltaRadius = this._sphericalEnd.radius - this._spherical.radius;
    const deltaTarget = _deltaTarget$1.subVectors(this._targetEnd, this._target);
    const deltaOffset = _deltaOffset$1.subVectors(this._focalOffsetEnd, this._focalOffset);
    const deltaZoom = this._zoomEnd - this._zoom;
    if (approxZero$1(deltaTheta)) {
      this._thetaVelocity.value = 0;
      this._spherical.theta = this._sphericalEnd.theta;
    } else {
      const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
      this._spherical.theta = smoothDamp$1(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, smoothTime, Infinity, delta);
      this._needsUpdate = true;
    }
    if (approxZero$1(deltaPhi)) {
      this._phiVelocity.value = 0;
      this._spherical.phi = this._sphericalEnd.phi;
    } else {
      const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
      this._spherical.phi = smoothDamp$1(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, smoothTime, Infinity, delta);
      this._needsUpdate = true;
    }
    if (approxZero$1(deltaRadius)) {
      this._radiusVelocity.value = 0;
      this._spherical.radius = this._sphericalEnd.radius;
    } else {
      const smoothTime = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
      this._spherical.radius = smoothDamp$1(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, smoothTime, this.maxSpeed, delta);
      this._needsUpdate = true;
    }
    if (approxZero$1(deltaTarget.x) && approxZero$1(deltaTarget.y) && approxZero$1(deltaTarget.z)) {
      this._targetVelocity.set(0, 0, 0);
      this._target.copy(this._targetEnd);
    } else {
      const smoothTime = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
      smoothDampVec3$1(this._target, this._targetEnd, this._targetVelocity, smoothTime, this.maxSpeed, delta, this._target);
      this._needsUpdate = true;
    }
    if (approxZero$1(deltaOffset.x) && approxZero$1(deltaOffset.y) && approxZero$1(deltaOffset.z)) {
      this._focalOffsetVelocity.set(0, 0, 0);
      this._focalOffset.copy(this._focalOffsetEnd);
    } else {
      const smoothTime = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
      smoothDampVec3$1(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, smoothTime, this.maxSpeed, delta, this._focalOffset);
      this._needsUpdate = true;
    }
    if (approxZero$1(deltaZoom)) {
      this._zoomVelocity.value = 0;
      this._zoom = this._zoomEnd;
    } else {
      const smoothTime = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
      this._zoom = smoothDamp$1(this._zoom, this._zoomEnd, this._zoomVelocity, smoothTime, Infinity, delta);
    }
    if (this.dollyToCursor) {
      if (isPerspectiveCamera$1(this._camera) && this._changedDolly !== 0) {
        const dollyControlAmount = this._spherical.radius - this._lastDistance;
        const camera = this._camera;
        const cameraDirection = this._getCameraDirection(_cameraDirection$1);
        const planeX = _v3A$1.copy(cameraDirection).cross(camera.up).normalize();
        if (planeX.lengthSq() === 0)
          planeX.x = 1;
        const planeY = _v3B$1.crossVectors(planeX, cameraDirection);
        const worldToScreen = this._sphericalEnd.radius * Math.tan(camera.getEffectiveFOV() * DEG2RAD$1 * 0.5);
        const prevRadius = this._sphericalEnd.radius - dollyControlAmount;
        const lerpRatio = (prevRadius - this._sphericalEnd.radius) / this._sphericalEnd.radius;
        const cursor = _v3C$1.copy(this._targetEnd).add(planeX.multiplyScalar(this._dollyControlCoord.x * worldToScreen * camera.aspect)).add(planeY.multiplyScalar(this._dollyControlCoord.y * worldToScreen));
        const newTargetEnd = _v3A$1.copy(this._targetEnd).lerp(cursor, lerpRatio);
        const isMin = this._lastDollyDirection === DOLLY_DIRECTION$1.IN && this._spherical.radius <= this.minDistance;
        const isMax = this._lastDollyDirection === DOLLY_DIRECTION$1.OUT && this.maxDistance <= this._spherical.radius;
        if (this.infinityDolly && (isMin || isMax)) {
          this._sphericalEnd.radius -= dollyControlAmount;
          this._spherical.radius -= dollyControlAmount;
          const dollyAmount = _v3B$1.copy(cameraDirection).multiplyScalar(-dollyControlAmount);
          newTargetEnd.add(dollyAmount);
        }
        this._boundary.clampPoint(newTargetEnd, newTargetEnd);
        const targetEndDiff = _v3B$1.subVectors(newTargetEnd, this._targetEnd);
        this._targetEnd.copy(newTargetEnd);
        this._target.add(targetEndDiff);
        this._changedDolly -= dollyControlAmount;
        if (approxZero$1(this._changedDolly))
          this._changedDolly = 0;
      } else if (isOrthographicCamera$1(this._camera) && this._changedZoom !== 0) {
        const dollyControlAmount = this._zoom - this._lastZoom;
        const camera = this._camera;
        const worldCursorPosition = _v3A$1.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
        const quaternion = _v3B$1.set(0, 0, -1).applyQuaternion(camera.quaternion);
        const cursor = _v3C$1.copy(worldCursorPosition).add(quaternion.multiplyScalar(-worldCursorPosition.dot(camera.up)));
        const prevZoom = this._zoom - dollyControlAmount;
        const lerpRatio = -(prevZoom - this._zoom) / this._zoom;
        const cameraDirection = this._getCameraDirection(_cameraDirection$1);
        const prevPlaneConstant = this._targetEnd.dot(cameraDirection);
        const newTargetEnd = _v3A$1.copy(this._targetEnd).lerp(cursor, lerpRatio);
        const newPlaneConstant = newTargetEnd.dot(cameraDirection);
        const pullBack = cameraDirection.multiplyScalar(newPlaneConstant - prevPlaneConstant);
        newTargetEnd.sub(pullBack);
        this._boundary.clampPoint(newTargetEnd, newTargetEnd);
        const targetEndDiff = _v3B$1.subVectors(newTargetEnd, this._targetEnd);
        this._targetEnd.copy(newTargetEnd);
        this._target.add(targetEndDiff);
        this._changedZoom -= dollyControlAmount;
        if (approxZero$1(this._changedZoom))
          this._changedZoom = 0;
      }
    }
    if (this._camera.zoom !== this._zoom) {
      this._camera.zoom = this._zoom;
      this._camera.updateProjectionMatrix();
      this._updateNearPlaneCorners();
      this._needsUpdate = true;
    }
    this._dragNeedsUpdate = true;
    const maxDistance = this._collisionTest();
    this._spherical.radius = Math.min(this._spherical.radius, maxDistance);
    this._spherical.makeSafe();
    this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target);
    this._camera.lookAt(this._target);
    const affectOffset = !approxZero$1(this._focalOffset.x) || !approxZero$1(this._focalOffset.y) || !approxZero$1(this._focalOffset.z);
    if (affectOffset) {
      _xColumn$1.setFromMatrixColumn(this._camera.matrix, 0);
      _yColumn$1.setFromMatrixColumn(this._camera.matrix, 1);
      _zColumn$1.setFromMatrixColumn(this._camera.matrix, 2);
      _xColumn$1.multiplyScalar(this._focalOffset.x);
      _yColumn$1.multiplyScalar(-this._focalOffset.y);
      _zColumn$1.multiplyScalar(this._focalOffset.z);
      _v3A$1.copy(_xColumn$1).add(_yColumn$1).add(_zColumn$1);
      this._camera.position.add(_v3A$1);
      this._camera.updateMatrixWorld();
    }
    if (this._boundaryEnclosesCamera) {
      this._encloseToBoundary(this._camera.position.copy(this._target), _v3A$1.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1);
    }
    const updated = this._needsUpdate;
    if (updated && !this._updatedLastTime) {
      this._hasRested = false;
      this.dispatchEvent({ type: "wake" });
      this.dispatchEvent({ type: "update" });
    } else if (updated) {
      this.dispatchEvent({ type: "update" });
      if (approxZero$1(deltaTheta, this.restThreshold) && approxZero$1(deltaPhi, this.restThreshold) && approxZero$1(deltaRadius, this.restThreshold) && approxZero$1(deltaTarget.x, this.restThreshold) && approxZero$1(deltaTarget.y, this.restThreshold) && approxZero$1(deltaTarget.z, this.restThreshold) && approxZero$1(deltaOffset.x, this.restThreshold) && approxZero$1(deltaOffset.y, this.restThreshold) && approxZero$1(deltaOffset.z, this.restThreshold) && approxZero$1(deltaZoom, this.restThreshold) && !this._hasRested) {
        this._hasRested = true;
        this.dispatchEvent({ type: "rest" });
      }
    } else if (!updated && this._updatedLastTime) {
      this.dispatchEvent({ type: "sleep" });
    }
    this._lastDistance = this._spherical.radius;
    this._lastZoom = this._zoom;
    this._updatedLastTime = updated;
    this._needsUpdate = false;
    return updated;
  }
  /**
   * Get all state in JSON string
   * @category Methods
   */
  toJSON() {
    return JSON.stringify({
      enabled: this._enabled,
      minDistance: this.minDistance,
      maxDistance: infinityToMaxNumber$1(this.maxDistance),
      minZoom: this.minZoom,
      maxZoom: infinityToMaxNumber$1(this.maxZoom),
      minPolarAngle: this.minPolarAngle,
      maxPolarAngle: infinityToMaxNumber$1(this.maxPolarAngle),
      minAzimuthAngle: infinityToMaxNumber$1(this.minAzimuthAngle),
      maxAzimuthAngle: infinityToMaxNumber$1(this.maxAzimuthAngle),
      smoothTime: this.smoothTime,
      draggingSmoothTime: this.draggingSmoothTime,
      dollySpeed: this.dollySpeed,
      truckSpeed: this.truckSpeed,
      dollyToCursor: this.dollyToCursor,
      target: this._targetEnd.toArray(),
      position: _v3A$1.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
      zoom: this._zoomEnd,
      focalOffset: this._focalOffsetEnd.toArray(),
      target0: this._target0.toArray(),
      position0: this._position0.toArray(),
      zoom0: this._zoom0,
      focalOffset0: this._focalOffset0.toArray()
    });
  }
  /**
   * Reproduce the control state with JSON. enableTransition is where anim or not in a boolean.
   * @param json
   * @param enableTransition
   * @category Methods
   */
  fromJSON(json, enableTransition = false) {
    const obj = JSON.parse(json);
    this.enabled = obj.enabled;
    this.minDistance = obj.minDistance;
    this.maxDistance = maxNumberToInfinity$1(obj.maxDistance);
    this.minZoom = obj.minZoom;
    this.maxZoom = maxNumberToInfinity$1(obj.maxZoom);
    this.minPolarAngle = obj.minPolarAngle;
    this.maxPolarAngle = maxNumberToInfinity$1(obj.maxPolarAngle);
    this.minAzimuthAngle = maxNumberToInfinity$1(obj.minAzimuthAngle);
    this.maxAzimuthAngle = maxNumberToInfinity$1(obj.maxAzimuthAngle);
    this.smoothTime = obj.smoothTime;
    this.draggingSmoothTime = obj.draggingSmoothTime;
    this.dollySpeed = obj.dollySpeed;
    this.truckSpeed = obj.truckSpeed;
    this.dollyToCursor = obj.dollyToCursor;
    this._target0.fromArray(obj.target0);
    this._position0.fromArray(obj.position0);
    this._zoom0 = obj.zoom0;
    this._focalOffset0.fromArray(obj.focalOffset0);
    this.moveTo(obj.target[0], obj.target[1], obj.target[2], enableTransition);
    _sphericalA$1.setFromVector3(_v3A$1.fromArray(obj.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace));
    this.rotateTo(_sphericalA$1.theta, _sphericalA$1.phi, enableTransition);
    this.dollyTo(_sphericalA$1.radius, enableTransition);
    this.zoomTo(obj.zoom, enableTransition);
    this.setFocalOffset(obj.focalOffset[0], obj.focalOffset[1], obj.focalOffset[2], enableTransition);
    this._needsUpdate = true;
  }
  /**
   * Attach all internal event handlers to enable drag control.
   * @category Methods
   */
  connect(domElement) {
    if (this._domElement) {
      console.warn("camera-controls is already connected.");
      return;
    }
    domElement.setAttribute("data-camera-controls-version", VERSION$1);
    this._addAllEventListeners(domElement);
    this._getClientRect(this._elementRect);
  }
  /**
   * Detach all internal event handlers to disable drag control.
   */
  disconnect() {
    this.cancel();
    this._removeAllEventListeners();
    if (this._domElement) {
      this._domElement.removeAttribute("data-camera-controls-version");
      this._domElement = void 0;
    }
  }
  /**
   * Dispose the cameraControls instance itself, remove all eventListeners.
   * @category Methods
   */
  dispose() {
    this.removeAllEventListeners();
    this.disconnect();
  }
  // it's okay to expose public though
  _getTargetDirection(out7) {
    return out7.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
  }
  // it's okay to expose public though
  _getCameraDirection(out7) {
    return this._getTargetDirection(out7).negate();
  }
  _findPointerById(pointerId) {
    return this._activePointers.find((activePointer) => activePointer.pointerId === pointerId);
  }
  _findPointerByMouseButton(mouseButton) {
    return this._activePointers.find((activePointer) => activePointer.mouseButton === mouseButton);
  }
  _disposePointer(pointer) {
    this._activePointers.splice(this._activePointers.indexOf(pointer), 1);
  }
  _encloseToBoundary(position, offset, friction) {
    const offsetLength2 = offset.lengthSq();
    if (offsetLength2 === 0) {
      return position;
    }
    const newTarget = _v3B$1.copy(offset).add(position);
    const clampedTarget = this._boundary.clampPoint(newTarget, _v3C$1);
    const deltaClampedTarget = clampedTarget.sub(newTarget);
    const deltaClampedTargetLength2 = deltaClampedTarget.lengthSq();
    if (deltaClampedTargetLength2 === 0) {
      return position.add(offset);
    } else if (deltaClampedTargetLength2 === offsetLength2) {
      return position;
    } else if (friction === 0) {
      return position.add(offset).add(deltaClampedTarget);
    } else {
      const offsetFactor = 1 + friction * deltaClampedTargetLength2 / offset.dot(deltaClampedTarget);
      return position.add(_v3B$1.copy(offset).multiplyScalar(offsetFactor)).add(deltaClampedTarget.multiplyScalar(1 - friction));
    }
  }
  _updateNearPlaneCorners() {
    if (isPerspectiveCamera$1(this._camera)) {
      const camera = this._camera;
      const near = camera.near;
      const fov2 = camera.getEffectiveFOV() * DEG2RAD$1;
      const heightHalf = Math.tan(fov2 * 0.5) * near;
      const widthHalf = heightHalf * camera.aspect;
      this._nearPlaneCorners[0].set(-widthHalf, -heightHalf, 0);
      this._nearPlaneCorners[1].set(widthHalf, -heightHalf, 0);
      this._nearPlaneCorners[2].set(widthHalf, heightHalf, 0);
      this._nearPlaneCorners[3].set(-widthHalf, heightHalf, 0);
    } else if (isOrthographicCamera$1(this._camera)) {
      const camera = this._camera;
      const zoomInv = 1 / camera.zoom;
      const left = camera.left * zoomInv;
      const right = camera.right * zoomInv;
      const top = camera.top * zoomInv;
      const bottom = camera.bottom * zoomInv;
      this._nearPlaneCorners[0].set(left, top, 0);
      this._nearPlaneCorners[1].set(right, top, 0);
      this._nearPlaneCorners[2].set(right, bottom, 0);
      this._nearPlaneCorners[3].set(left, bottom, 0);
    }
  }
  // lateUpdate
  _collisionTest() {
    let distance = Infinity;
    const hasCollider = this.colliderMeshes.length >= 1;
    if (!hasCollider)
      return distance;
    if (notSupportedInOrthographicCamera$1(this._camera, "_collisionTest"))
      return distance;
    const rayDirection = this._getTargetDirection(_cameraDirection$1);
    _rotationMatrix$1.lookAt(_ORIGIN$1, rayDirection, this._camera.up);
    for (let i2 = 0; i2 < 4; i2++) {
      const nearPlaneCorner = _v3B$1.copy(this._nearPlaneCorners[i2]);
      nearPlaneCorner.applyMatrix4(_rotationMatrix$1);
      const origin2 = _v3C$1.addVectors(this._target, nearPlaneCorner);
      _raycaster$1.set(origin2, rayDirection);
      _raycaster$1.far = this._spherical.radius + 1;
      const intersects2 = _raycaster$1.intersectObjects(this.colliderMeshes);
      if (intersects2.length !== 0 && intersects2[0].distance < distance) {
        distance = intersects2[0].distance;
      }
    }
    return distance;
  }
  /**
   * Get its client rect and package into given `DOMRect` .
   */
  _getClientRect(target) {
    if (!this._domElement)
      return;
    const rect = this._domElement.getBoundingClientRect();
    target.x = rect.left;
    target.y = rect.top;
    if (this._viewport) {
      target.x += this._viewport.x;
      target.y += rect.height - this._viewport.w - this._viewport.y;
      target.width = this._viewport.z;
      target.height = this._viewport.w;
    } else {
      target.width = rect.width;
      target.height = rect.height;
    }
    return target;
  }
  _createOnRestPromise(resolveImmediately) {
    if (resolveImmediately)
      return Promise.resolve();
    this._hasRested = false;
    this.dispatchEvent({ type: "transitionstart" });
    return new Promise((resolve2) => {
      const onResolve = () => {
        this.removeEventListener("rest", onResolve);
        resolve2();
      };
      this.addEventListener("rest", onResolve);
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _addAllEventListeners(_domElement) {
  }
  _removeAllEventListeners() {
  }
  /**
   * backward compatible
   * @deprecated use smoothTime (in seconds) instead
   * @category Properties
   */
  get dampingFactor() {
    console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
    return 0;
  }
  /**
   * backward compatible
   * @deprecated use smoothTime (in seconds) instead
   * @category Properties
   */
  set dampingFactor(_2) {
    console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
  }
  /**
   * backward compatible
   * @deprecated use draggingSmoothTime (in seconds) instead
   * @category Properties
   */
  get draggingDampingFactor() {
    console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
    return 0;
  }
  /**
   * backward compatible
   * @deprecated use draggingSmoothTime (in seconds) instead
   * @category Properties
   */
  set draggingDampingFactor(_2) {
    console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
  }
  static createBoundingSphere(object3d, out7 = new THREE$1.Sphere()) {
    const boundingSphere = out7;
    const center = boundingSphere.center;
    _box3A$1.makeEmpty();
    object3d.traverseVisible((object) => {
      if (!object.isMesh)
        return;
      _box3A$1.expandByObject(object);
    });
    _box3A$1.getCenter(center);
    let maxRadiusSq = 0;
    object3d.traverseVisible((object) => {
      if (!object.isMesh)
        return;
      const mesh = object;
      if (!mesh.geometry)
        return;
      const geometry = mesh.geometry.clone();
      geometry.applyMatrix4(mesh.matrixWorld);
      const bufferGeometry = geometry;
      const position = bufferGeometry.attributes.position;
      for (let i2 = 0, l2 = position.count; i2 < l2; i2++) {
        _v3A$1.fromBufferAttribute(position, i2);
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_v3A$1));
      }
    });
    boundingSphere.radius = Math.sqrt(maxRadiusSq);
    return boundingSphere;
  }
};
const CameraControls$1 = /* @__PURE__ */ reactExports.forwardRef((props, ref) => {
  reactExports.useMemo(() => {
    const subsetOfTHREE = {
      Box3,
      MathUtils: {
        clamp: MathUtils.clamp
      },
      Matrix4,
      Quaternion,
      Raycaster,
      Sphere,
      Spherical,
      Vector2,
      Vector3,
      Vector4
    };
    CameraControls$2.install({
      THREE: subsetOfTHREE
    });
    extend({
      CameraControlsImpl: CameraControls$2
    });
  }, []);
  const {
    camera,
    domElement,
    makeDefault,
    onStart,
    onEnd,
    onChange,
    regress,
    ...restProps
  } = props;
  const defaultCamera = useThree((state) => state.camera);
  const gl = useThree((state) => state.gl);
  const invalidate2 = useThree((state) => state.invalidate);
  const events = useThree((state) => state.events);
  const setEvents = useThree((state) => state.setEvents);
  const set = useThree((state) => state.set);
  const get = useThree((state) => state.get);
  const performance2 = useThree((state) => state.performance);
  const explCamera = camera || defaultCamera;
  const explDomElement = domElement || events.connected || gl.domElement;
  const controls = reactExports.useMemo(() => new CameraControls$2(explCamera), [explCamera]);
  useFrame((state, delta) => {
    if (controls.enabled) controls.update(delta);
  }, -1);
  reactExports.useEffect(() => {
    controls.connect(explDomElement);
    return () => void controls.disconnect();
  }, [explDomElement, controls]);
  reactExports.useEffect(() => {
    const callback = (e2) => {
      invalidate2();
      if (regress) performance2.regress();
      if (onChange) onChange(e2);
    };
    const onStartCb = (e2) => {
      if (onStart) onStart(e2);
    };
    const onEndCb = (e2) => {
      if (onEnd) onEnd(e2);
    };
    controls.addEventListener("update", callback);
    controls.addEventListener("controlstart", onStartCb);
    controls.addEventListener("controlend", onEndCb);
    controls.addEventListener("control", callback);
    controls.addEventListener("transitionstart", callback);
    controls.addEventListener("wake", callback);
    return () => {
      controls.removeEventListener("update", callback);
      controls.removeEventListener("controlstart", onStartCb);
      controls.removeEventListener("controlend", onEndCb);
      controls.removeEventListener("control", callback);
      controls.removeEventListener("transitionstart", callback);
      controls.removeEventListener("wake", callback);
    };
  }, [controls, onStart, onEnd, invalidate2, setEvents, regress, onChange]);
  reactExports.useEffect(() => {
    if (makeDefault) {
      const old = get().controls;
      set({
        controls
      });
      return () => set({
        controls: old
      });
    }
  }, [makeDefault, controls]);
  return /* @__PURE__ */ reactExports.createElement("primitive", _extends$1({
    ref,
    object: controls
  }, restProps));
});
const scriptRel = "modulepreload";
const assetsURL = function(dep) {
  return "/" + dep;
};
const seen = {};
const __vitePreload = function preload2(baseModule, deps, importerUrl) {
  let promise = Promise.resolve();
  if (deps && deps.length > 0) {
    let allSettled2 = function(promises$2) {
      return Promise.all(promises$2.map((p3) => Promise.resolve(p3).then((value$1) => ({
        status: "fulfilled",
        value: value$1
      }), (reason) => ({
        status: "rejected",
        reason
      }))));
    };
    var allSettled = allSettled2;
    document.getElementsByTagName("link");
    const cspNonceMeta = document.querySelector("meta[property=csp-nonce]");
    const cspNonce = cspNonceMeta?.nonce || cspNonceMeta?.getAttribute("nonce");
    promise = allSettled2(deps.map((dep) => {
      dep = assetsURL(dep);
      if (dep in seen) return;
      seen[dep] = true;
      const isCss = dep.endsWith(".css");
      const cssSelector = isCss ? '[rel="stylesheet"]' : "";
      if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) return;
      const link = document.createElement("link");
      link.rel = isCss ? "stylesheet" : scriptRel;
      if (!isCss) link.as = "script";
      link.crossOrigin = "";
      link.href = dep;
      if (cspNonce) link.setAttribute("nonce", cspNonce);
      document.head.appendChild(link);
      if (isCss) return new Promise((res, rej) => {
        link.addEventListener("load", res);
        link.addEventListener("error", () => rej(/* @__PURE__ */ new Error(`Unable to preload CSS for ${dep}`)));
      });
    }));
  }
  function handlePreloadError(err$2) {
    const e$12 = new Event("vite:preloadError", { cancelable: true });
    e$12.payload = err$2;
    window.dispatchEvent(e$12);
    if (!e$12.defaultPrevented) throw err$2;
  }
  return promise.then((res) => {
    for (const item of res || []) {
      if (item.status !== "rejected") continue;
      handlePreloadError(item.reason);
    }
    return baseModule().catch(handlePreloadError);
  });
};
function useContextBridge(...contexts) {
  const cRef = reactExports.useRef([]);
  cRef.current = contexts.map((context4) => reactExports.useContext(context4));
  return reactExports.useMemo(() => ({
    children
  }) => contexts.reduceRight(
    (acc, Context2, i2) => /* @__PURE__ */ reactExports.createElement(Context2.Provider, {
      value: cRef.current[i2],
      children: acc
    }),
    children
    /*
     * done this way in reference to:
     * https://github.com/DefinitelyTyped/DefinitelyTyped/issues/44572#issuecomment-625878049
     * https://github.com/microsoft/TypeScript/issues/14729
     */
  ), []);
}
function useAnimations(clips, root2) {
  const ref = reactExports.useRef();
  const [actualRef] = reactExports.useState(() => root2 ? root2 instanceof Object3D ? {
    current: root2
  } : root2 : ref);
  const [mixer] = reactExports.useState(() => new AnimationMixer(void 0));
  reactExports.useLayoutEffect(() => {
    if (root2) actualRef.current = root2 instanceof Object3D ? root2 : root2.current;
    mixer._root = actualRef.current;
  });
  const lazyActions = reactExports.useRef({});
  const api = reactExports.useMemo(() => {
    const actions = {};
    clips.forEach((clip) => Object.defineProperty(actions, clip.name, {
      enumerable: true,
      get() {
        if (actualRef.current) {
          return lazyActions.current[clip.name] || (lazyActions.current[clip.name] = mixer.clipAction(clip, actualRef.current));
        }
      },
      configurable: true
    }));
    return {
      ref: actualRef,
      clips,
      actions,
      names: clips.map((c2) => c2.name),
      mixer
    };
  }, [clips]);
  useFrame((state, delta) => mixer.update(delta));
  reactExports.useEffect(() => {
    const currentRoot = actualRef.current;
    return () => {
      lazyActions.current = {};
      mixer.stopAllAction();
      Object.values(api.actions).forEach((action) => {
        if (currentRoot) {
          mixer.uncacheAction(action, currentRoot);
        }
      });
    };
  }, [clips]);
  return api;
}
const LinearEncoding = 3e3;
const sRGBEncoding = 3001;
const getBufferForType = (type, width, height) => {
  let out7;
  switch (type) {
    case UnsignedByteType:
      out7 = new Uint8ClampedArray(width * height * 4);
      break;
    case HalfFloatType:
      out7 = new Uint16Array(width * height * 4);
      break;
    case UnsignedIntType:
      out7 = new Uint32Array(width * height * 4);
      break;
    case ByteType:
      out7 = new Int8Array(width * height * 4);
      break;
    case ShortType:
      out7 = new Int16Array(width * height * 4);
      break;
    case IntType:
      out7 = new Int32Array(width * height * 4);
      break;
    case FloatType:
      out7 = new Float32Array(width * height * 4);
      break;
    default:
      throw new Error("Unsupported data type");
  }
  return out7;
};
let _canReadPixelsResult;
const canReadPixels = (type, renderer, camera, renderTargetOptions) => {
  if (_canReadPixelsResult !== void 0)
    return _canReadPixelsResult;
  const testRT = new WebGLRenderTarget(1, 1, renderTargetOptions);
  renderer.setRenderTarget(testRT);
  const mesh = new Mesh(new PlaneGeometry(), new MeshBasicMaterial({ color: 16777215 }));
  renderer.render(mesh, camera);
  renderer.setRenderTarget(null);
  const out7 = getBufferForType(type, testRT.width, testRT.height);
  renderer.readRenderTargetPixels(testRT, 0, 0, testRT.width, testRT.height, out7);
  testRT.dispose();
  mesh.geometry.dispose();
  mesh.material.dispose();
  _canReadPixelsResult = out7[0] !== 0;
  return _canReadPixelsResult;
};
class QuadRenderer {
  _renderer;
  _rendererIsDisposable = false;
  _material;
  _scene;
  _camera;
  _quad;
  _renderTarget;
  _width;
  _height;
  _type;
  _colorSpace;
  _supportsReadPixels = true;
  /**
   * Constructs a new QuadRenderer
   *
   * @param options Parameters for this QuadRenderer
   */
  constructor(options) {
    this._width = options.width;
    this._height = options.height;
    this._type = options.type;
    this._colorSpace = options.colorSpace;
    const rtOptions = {
      // fixed options
      format: RGBAFormat,
      depthBuffer: false,
      stencilBuffer: false,
      // user options
      type: this._type,
      // set in class property
      colorSpace: this._colorSpace,
      // set in class property
      anisotropy: options.renderTargetOptions?.anisotropy !== void 0 ? options.renderTargetOptions?.anisotropy : 1,
      generateMipmaps: options.renderTargetOptions?.generateMipmaps !== void 0 ? options.renderTargetOptions?.generateMipmaps : false,
      magFilter: options.renderTargetOptions?.magFilter !== void 0 ? options.renderTargetOptions?.magFilter : LinearFilter,
      minFilter: options.renderTargetOptions?.minFilter !== void 0 ? options.renderTargetOptions?.minFilter : LinearFilter,
      samples: options.renderTargetOptions?.samples !== void 0 ? options.renderTargetOptions?.samples : void 0,
      wrapS: options.renderTargetOptions?.wrapS !== void 0 ? options.renderTargetOptions?.wrapS : ClampToEdgeWrapping,
      wrapT: options.renderTargetOptions?.wrapT !== void 0 ? options.renderTargetOptions?.wrapT : ClampToEdgeWrapping
    };
    this._material = options.material;
    if (options.renderer) {
      this._renderer = options.renderer;
    } else {
      this._renderer = QuadRenderer.instantiateRenderer();
      this._rendererIsDisposable = true;
    }
    this._scene = new Scene();
    this._camera = new OrthographicCamera();
    this._camera.position.set(0, 0, 10);
    this._camera.left = -0.5;
    this._camera.right = 0.5;
    this._camera.top = 0.5;
    this._camera.bottom = -0.5;
    this._camera.updateProjectionMatrix();
    if (!canReadPixels(this._type, this._renderer, this._camera, rtOptions)) {
      let alternativeType;
      switch (this._type) {
        case HalfFloatType:
          alternativeType = this._renderer.extensions.has("EXT_color_buffer_float") ? FloatType : void 0;
          break;
      }
      if (alternativeType !== void 0) {
        console.warn(`This browser does not support reading pixels from ${this._type} RenderTargets, switching to ${FloatType}`);
        this._type = alternativeType;
      } else {
        this._supportsReadPixels = false;
        console.warn("This browser dos not support toArray or toDataTexture, calls to those methods will result in an error thrown");
      }
    }
    this._quad = new Mesh(new PlaneGeometry(), this._material);
    this._quad.geometry.computeBoundingBox();
    this._scene.add(this._quad);
    this._renderTarget = new WebGLRenderTarget(this.width, this.height, rtOptions);
    this._renderTarget.texture.mapping = options.renderTargetOptions?.mapping !== void 0 ? options.renderTargetOptions?.mapping : UVMapping;
  }
  /**
   * Instantiates a temporary renderer
   *
   * @returns
   */
  static instantiateRenderer() {
    const renderer = new WebGLRenderer();
    renderer.setSize(128, 128);
    return renderer;
  }
  /**
   * Renders the input texture using the specified material
   */
  render = () => {
    this._renderer.setRenderTarget(this._renderTarget);
    try {
      this._renderer.render(this._scene, this._camera);
    } catch (e2) {
      this._renderer.setRenderTarget(null);
      throw e2;
    }
    this._renderer.setRenderTarget(null);
  };
  /**
   * Obtains a Buffer containing the rendered texture.
   *
   * @throws Error if the browser cannot read pixels from this RenderTarget type.
   * @returns a TypedArray containing RGBA values from this renderer
   */
  toArray() {
    if (!this._supportsReadPixels)
      throw new Error("Can't read pixels in this browser");
    const out7 = getBufferForType(this._type, this._width, this._height);
    this._renderer.readRenderTargetPixels(this._renderTarget, 0, 0, this._width, this._height, out7);
    return out7;
  }
  /**
   * Performs a readPixel operation in the renderTarget
   * and returns a DataTexture containing the read data
   *
   * @param options options
   * @returns
   */
  toDataTexture(options) {
    const returnValue = new DataTexture(
      // fixed values
      this.toArray(),
      this.width,
      this.height,
      RGBAFormat,
      this._type,
      // user values
      options?.mapping || UVMapping,
      options?.wrapS || ClampToEdgeWrapping,
      options?.wrapT || ClampToEdgeWrapping,
      options?.magFilter || LinearFilter,
      options?.minFilter || LinearFilter,
      options?.anisotropy || 1,
      // fixed value
      LinearSRGBColorSpace$1
    );
    returnValue.generateMipmaps = options?.generateMipmaps !== void 0 ? options?.generateMipmaps : false;
    return returnValue;
  }
  /**
   * If using a disposable renderer, it will dispose it.
   */
  disposeOnDemandRenderer() {
    this._renderer.setRenderTarget(null);
    if (this._rendererIsDisposable) {
      this._renderer.dispose();
      this._renderer.forceContextLoss();
    }
  }
  /**
   * Will dispose of **all** assets used by this renderer.
   *
   *
   * @param disposeRenderTarget will dispose of the renderTarget which will not be usable later
   * set this to true if you passed the `renderTarget.texture` to a `PMREMGenerator`
   * or are otherwise done with it.
   *
   * @example
   * ```js
   * const loader = new HDRJPGLoader(renderer)
   * const result = await loader.loadAsync('gainmap.jpeg')
   * const mesh = new Mesh(geometry, new MeshBasicMaterial({ map: result.renderTarget.texture }) )
   * // DO NOT dispose the renderTarget here,
   * // it is used directly in the material
   * result.dispose()
   * ```
   *
   * @example
   * ```js
   * const loader = new HDRJPGLoader(renderer)
   * const pmremGenerator = new PMREMGenerator( renderer );
   * const result = await loader.loadAsync('gainmap.jpeg')
   * const envMap = pmremGenerator.fromEquirectangular(result.renderTarget.texture)
   * const mesh = new Mesh(geometry, new MeshStandardMaterial({ envMap }) )
   * // renderTarget can be disposed here
   * // because it was used to generate a PMREM texture
   * result.dispose(true)
   * ```
   */
  dispose(disposeRenderTarget) {
    this.disposeOnDemandRenderer();
    if (disposeRenderTarget) {
      this.renderTarget.dispose();
    }
    if (this.material instanceof ShaderMaterial) {
      Object.values(this.material.uniforms).forEach((v3) => {
        if (v3.value instanceof Texture)
          v3.value.dispose();
      });
    }
    Object.values(this.material).forEach((value) => {
      if (value instanceof Texture)
        value.dispose();
    });
    this.material.dispose();
    this._quad.geometry.dispose();
  }
  /**
   * Width of the texture
   */
  get width() {
    return this._width;
  }
  set width(value) {
    this._width = value;
    this._renderTarget.setSize(this._width, this._height);
  }
  /**
   * Height of the texture
   */
  get height() {
    return this._height;
  }
  set height(value) {
    this._height = value;
    this._renderTarget.setSize(this._width, this._height);
  }
  /**
   * The renderer used
   */
  get renderer() {
    return this._renderer;
  }
  /**
   * The `WebGLRenderTarget` used.
   */
  get renderTarget() {
    return this._renderTarget;
  }
  set renderTarget(value) {
    this._renderTarget = value;
    this._width = value.width;
    this._height = value.height;
  }
  /**
   * The `Material` used.
   */
  get material() {
    return this._material;
  }
  /**
   *
   */
  get type() {
    return this._type;
  }
  get colorSpace() {
    return this._colorSpace;
  }
}
class GainMapNotFoundError extends Error {
}
class XMPMetadataNotFoundError extends Error {
}
const getXMLValue = (xml, tag, defaultValue2) => {
  const attributeMatch = new RegExp(`${tag}="([^"]*)"`, "i").exec(xml);
  if (attributeMatch)
    return attributeMatch[1];
  const tagMatch = new RegExp(`<${tag}[^>]*>([\\s\\S]*?)</${tag}>`, "i").exec(xml);
  if (tagMatch) {
    const liValues = tagMatch[1].match(/<rdf:li>([^<]*)<\/rdf:li>/g);
    if (liValues && liValues.length === 3) {
      return liValues.map((v3) => v3.replace(/<\/?rdf:li>/g, ""));
    }
    return tagMatch[1].trim();
  }
  if (defaultValue2 !== void 0)
    return defaultValue2;
  throw new Error(`Can't find ${tag} in gainmap metadata`);
};
const extractXMP = (input) => {
  let str;
  if (typeof TextDecoder !== "undefined")
    str = new TextDecoder().decode(input);
  else
    str = input.toString();
  let start2 = str.indexOf("<x:xmpmeta");
  while (start2 !== -1) {
    const end = str.indexOf("x:xmpmeta>", start2);
    const xmpBlock = str.slice(start2, end + 10);
    try {
      const gainMapMin = getXMLValue(xmpBlock, "hdrgm:GainMapMin", "0");
      const gainMapMax = getXMLValue(xmpBlock, "hdrgm:GainMapMax");
      const gamma = getXMLValue(xmpBlock, "hdrgm:Gamma", "1");
      const offsetSDR = getXMLValue(xmpBlock, "hdrgm:OffsetSDR", "0.015625");
      const offsetHDR = getXMLValue(xmpBlock, "hdrgm:OffsetHDR", "0.015625");
      const hdrCapacityMinMatch = /hdrgm:HDRCapacityMin="([^"]*)"/.exec(xmpBlock);
      const hdrCapacityMin = hdrCapacityMinMatch ? hdrCapacityMinMatch[1] : "0";
      const hdrCapacityMaxMatch = /hdrgm:HDRCapacityMax="([^"]*)"/.exec(xmpBlock);
      if (!hdrCapacityMaxMatch)
        throw new Error("Incomplete gainmap metadata");
      const hdrCapacityMax = hdrCapacityMaxMatch[1];
      return {
        gainMapMin: Array.isArray(gainMapMin) ? gainMapMin.map((v3) => parseFloat(v3)) : [parseFloat(gainMapMin), parseFloat(gainMapMin), parseFloat(gainMapMin)],
        gainMapMax: Array.isArray(gainMapMax) ? gainMapMax.map((v3) => parseFloat(v3)) : [parseFloat(gainMapMax), parseFloat(gainMapMax), parseFloat(gainMapMax)],
        gamma: Array.isArray(gamma) ? gamma.map((v3) => parseFloat(v3)) : [parseFloat(gamma), parseFloat(gamma), parseFloat(gamma)],
        offsetSdr: Array.isArray(offsetSDR) ? offsetSDR.map((v3) => parseFloat(v3)) : [parseFloat(offsetSDR), parseFloat(offsetSDR), parseFloat(offsetSDR)],
        offsetHdr: Array.isArray(offsetHDR) ? offsetHDR.map((v3) => parseFloat(v3)) : [parseFloat(offsetHDR), parseFloat(offsetHDR), parseFloat(offsetHDR)],
        hdrCapacityMin: parseFloat(hdrCapacityMin),
        hdrCapacityMax: parseFloat(hdrCapacityMax)
      };
    } catch (e2) {
    }
    start2 = str.indexOf("<x:xmpmeta", end);
  }
};
class MPFExtractor {
  options;
  constructor(options) {
    this.options = {
      debug: options && options.debug !== void 0 ? options.debug : false,
      extractFII: options && options.extractFII !== void 0 ? options.extractFII : true,
      extractNonFII: options && options.extractNonFII !== void 0 ? options.extractNonFII : true
    };
  }
  extract(imageArrayBuffer) {
    return new Promise((resolve2, reject) => {
      const debug = this.options.debug;
      const dataView = new DataView(imageArrayBuffer.buffer);
      if (dataView.getUint16(0) !== 65496) {
        reject(new Error("Not a valid jpeg"));
        return;
      }
      const length = dataView.byteLength;
      let offset = 2;
      let loops = 0;
      let marker;
      while (offset < length) {
        if (++loops > 250) {
          reject(new Error(`Found no marker after ${loops} loops 😵`));
          return;
        }
        if (dataView.getUint8(offset) !== 255) {
          reject(new Error(`Not a valid marker at offset 0x${offset.toString(16)}, found: 0x${dataView.getUint8(offset).toString(16)}`));
          return;
        }
        marker = dataView.getUint8(offset + 1);
        if (debug)
          console.log(`Marker: ${marker.toString(16)}`);
        if (marker === 226) {
          if (debug)
            console.log("Found APP2 marker (0xffe2)");
          const formatPt = offset + 4;
          if (dataView.getUint32(formatPt) === 1297106432) {
            const tiffOffset = formatPt + 4;
            let bigEnd;
            if (dataView.getUint16(tiffOffset) === 18761) {
              bigEnd = false;
            } else if (dataView.getUint16(tiffOffset) === 19789) {
              bigEnd = true;
            } else {
              reject(new Error("No valid endianness marker found in TIFF header"));
              return;
            }
            if (dataView.getUint16(tiffOffset + 2, !bigEnd) !== 42) {
              reject(new Error("Not valid TIFF data! (no 0x002A marker)"));
              return;
            }
            const firstIFDOffset = dataView.getUint32(tiffOffset + 4, !bigEnd);
            if (firstIFDOffset < 8) {
              reject(new Error("Not valid TIFF data! (First offset less than 8)"));
              return;
            }
            const dirStart = tiffOffset + firstIFDOffset;
            const count = dataView.getUint16(dirStart, !bigEnd);
            const entriesStart = dirStart + 2;
            let numberOfImages = 0;
            for (let i2 = entriesStart; i2 < entriesStart + 12 * count; i2 += 12) {
              if (dataView.getUint16(i2, !bigEnd) === 45057) {
                numberOfImages = dataView.getUint32(i2 + 8, !bigEnd);
              }
            }
            const nextIFDOffsetLen = 4;
            const MPImageListValPt = dirStart + 2 + count * 12 + nextIFDOffsetLen;
            const images = [];
            for (let i2 = MPImageListValPt; i2 < MPImageListValPt + numberOfImages * 16; i2 += 16) {
              const image = {
                MPType: dataView.getUint32(i2, !bigEnd),
                size: dataView.getUint32(i2 + 4, !bigEnd),
                // This offset is specified relative to the address of the MP Endian
                // field in the MP Header, unless the image is a First Individual Image,
                // in which case the value of the offset shall be NULL (0x00000000).
                dataOffset: dataView.getUint32(i2 + 8, !bigEnd),
                dependantImages: dataView.getUint32(i2 + 12, !bigEnd),
                start: -1,
                end: -1,
                isFII: false
              };
              if (!image.dataOffset) {
                image.start = 0;
                image.isFII = true;
              } else {
                image.start = tiffOffset + image.dataOffset;
                image.isFII = false;
              }
              image.end = image.start + image.size;
              images.push(image);
            }
            if (this.options.extractNonFII && images.length) {
              const bufferBlob = new Blob([dataView]);
              const imgs = [];
              for (const image of images) {
                if (image.isFII && !this.options.extractFII) {
                  continue;
                }
                const imageBlob = bufferBlob.slice(image.start, image.end + 1, "image/jpeg");
                imgs.push(imageBlob);
              }
              resolve2(imgs);
            }
          }
        }
        offset += 2 + dataView.getUint16(offset + 2);
      }
    });
  }
}
const extractGainmapFromJPEG = async (jpegFile) => {
  const metadata = extractXMP(jpegFile);
  if (!metadata)
    throw new XMPMetadataNotFoundError("Gain map XMP metadata not found");
  const mpfExtractor = new MPFExtractor({ extractFII: true, extractNonFII: true });
  const images = await mpfExtractor.extract(jpegFile);
  if (images.length !== 2)
    throw new GainMapNotFoundError("Gain map recovery image not found");
  return {
    sdr: new Uint8Array(await images[0].arrayBuffer()),
    gainMap: new Uint8Array(await images[1].arrayBuffer()),
    metadata
  };
};
const getHTMLImageFromBlob = (blob) => {
  return new Promise((resolve2, reject) => {
    const img = document.createElement("img");
    img.onload = () => {
      resolve2(img);
    };
    img.onerror = (e2) => {
      reject(e2);
    };
    img.src = URL.createObjectURL(blob);
  });
};
class LoaderBaseShared extends Loader {
  _renderer;
  _renderTargetOptions;
  _internalLoadingManager;
  _config;
  constructor(config3, manager) {
    super(manager);
    this._config = config3;
    if (config3.renderer)
      this._renderer = config3.renderer;
    this._internalLoadingManager = new LoadingManager();
  }
  setRenderer(renderer) {
    this._renderer = renderer;
    return this;
  }
  setRenderTargetOptions(options) {
    this._renderTargetOptions = options;
    return this;
  }
  prepareQuadRenderer() {
    if (!this._renderer) {
      console.warn("WARNING: A Renderer was not passed to this Loader constructor or in setRenderer, the result of this Loader will need to be converted to a Data Texture with toDataTexture() before you can use it in your renderer.");
    }
    const material = this._config.createMaterial({
      gainMapMax: [1, 1, 1],
      gainMapMin: [0, 0, 0],
      gamma: [1, 1, 1],
      offsetHdr: [1, 1, 1],
      offsetSdr: [1, 1, 1],
      hdrCapacityMax: 1,
      hdrCapacityMin: 0,
      maxDisplayBoost: 1,
      gainMap: new Texture(),
      sdr: new Texture()
    });
    return this._config.createQuadRenderer({
      width: 16,
      height: 16,
      type: HalfFloatType,
      colorSpace: LinearSRGBColorSpace$1,
      material,
      renderer: this._renderer,
      renderTargetOptions: this._renderTargetOptions
    });
  }
  async processImages(sdrBuffer, gainMapBuffer, imageOrientation) {
    const gainMapBlob = gainMapBuffer ? new Blob([gainMapBuffer], { type: "image/jpeg" }) : void 0;
    const sdrBlob = new Blob([sdrBuffer], { type: "image/jpeg" });
    let sdrImage;
    let gainMapImage;
    let needsFlip = false;
    if (typeof createImageBitmap === "undefined") {
      const res = await Promise.all([
        gainMapBlob ? getHTMLImageFromBlob(gainMapBlob) : Promise.resolve(void 0),
        getHTMLImageFromBlob(sdrBlob)
      ]);
      gainMapImage = res[0];
      sdrImage = res[1];
      needsFlip = imageOrientation === "flipY";
    } else {
      const res = await Promise.all([
        gainMapBlob ? createImageBitmap(gainMapBlob, { imageOrientation: imageOrientation || "flipY" }) : Promise.resolve(void 0),
        createImageBitmap(sdrBlob, { imageOrientation: imageOrientation || "flipY" })
      ]);
      gainMapImage = res[0];
      sdrImage = res[1];
    }
    return { sdrImage, gainMapImage, needsFlip };
  }
  createTextures(sdrImage, gainMapImage, needsFlip) {
    const gainMap = new Texture(gainMapImage || new ImageData(2, 2), UVMapping, ClampToEdgeWrapping, ClampToEdgeWrapping, LinearFilter, LinearMipMapLinearFilter, RGBAFormat, UnsignedByteType, 1, LinearSRGBColorSpace$1);
    gainMap.flipY = needsFlip;
    gainMap.needsUpdate = true;
    const sdr = new Texture(sdrImage, UVMapping, ClampToEdgeWrapping, ClampToEdgeWrapping, LinearFilter, LinearMipMapLinearFilter, RGBAFormat, UnsignedByteType, 1, SRGBColorSpace$1);
    sdr.flipY = needsFlip;
    sdr.needsUpdate = true;
    return { gainMap, sdr };
  }
  updateQuadRenderer(quadRenderer, sdrImage, gainMap, sdr, metadata) {
    quadRenderer.width = sdrImage.width;
    quadRenderer.height = sdrImage.height;
    quadRenderer.material.gainMap = gainMap;
    quadRenderer.material.sdr = sdr;
    quadRenderer.material.gainMapMin = metadata.gainMapMin;
    quadRenderer.material.gainMapMax = metadata.gainMapMax;
    quadRenderer.material.offsetHdr = metadata.offsetHdr;
    quadRenderer.material.offsetSdr = metadata.offsetSdr;
    quadRenderer.material.gamma = metadata.gamma;
    quadRenderer.material.hdrCapacityMin = metadata.hdrCapacityMin;
    quadRenderer.material.hdrCapacityMax = metadata.hdrCapacityMax;
    quadRenderer.material.maxDisplayBoost = Math.pow(2, metadata.hdrCapacityMax);
    quadRenderer.material.needsUpdate = true;
  }
}
const vertexShader = (
  /* glsl */
  `
varying vec2 vUv;

void main() {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`
);
const fragmentShader = (
  /* glsl */
  `
// min half float value
#define HALF_FLOAT_MIN vec3( -65504, -65504, -65504 )
// max half float value
#define HALF_FLOAT_MAX vec3( 65504, 65504, 65504 )

uniform sampler2D sdr;
uniform sampler2D gainMap;
uniform vec3 gamma;
uniform vec3 offsetHdr;
uniform vec3 offsetSdr;
uniform vec3 gainMapMin;
uniform vec3 gainMapMax;
uniform float weightFactor;

varying vec2 vUv;

void main() {
  vec3 rgb = texture2D( sdr, vUv ).rgb;
  vec3 recovery = texture2D( gainMap, vUv ).rgb;
  vec3 logRecovery = pow( recovery, gamma );
  vec3 logBoost = gainMapMin * ( 1.0 - logRecovery ) + gainMapMax * logRecovery;
  vec3 hdrColor = (rgb + offsetSdr) * exp2( logBoost * weightFactor ) - offsetHdr;
  vec3 clampedHdrColor = max( HALF_FLOAT_MIN, min( HALF_FLOAT_MAX, hdrColor ));
  gl_FragColor = vec4( clampedHdrColor , 1.0 );
}
`
);
class GainMapDecoderMaterial extends ShaderMaterial {
  _maxDisplayBoost;
  _hdrCapacityMin;
  _hdrCapacityMax;
  /**
   *
   * @param params
   */
  constructor({ gamma, offsetHdr, offsetSdr, gainMapMin, gainMapMax, maxDisplayBoost, hdrCapacityMin, hdrCapacityMax, sdr, gainMap }) {
    super({
      name: "GainMapDecoderMaterial",
      vertexShader,
      fragmentShader,
      uniforms: {
        sdr: { value: sdr },
        gainMap: { value: gainMap },
        gamma: { value: new Vector3(1 / gamma[0], 1 / gamma[1], 1 / gamma[2]) },
        offsetHdr: { value: new Vector3().fromArray(offsetHdr) },
        offsetSdr: { value: new Vector3().fromArray(offsetSdr) },
        gainMapMin: { value: new Vector3().fromArray(gainMapMin) },
        gainMapMax: { value: new Vector3().fromArray(gainMapMax) },
        weightFactor: {
          value: (Math.log2(maxDisplayBoost) - hdrCapacityMin) / (hdrCapacityMax - hdrCapacityMin)
        }
      },
      blending: NoBlending,
      depthTest: false,
      depthWrite: false
    });
    this._maxDisplayBoost = maxDisplayBoost;
    this._hdrCapacityMin = hdrCapacityMin;
    this._hdrCapacityMax = hdrCapacityMax;
    this.needsUpdate = true;
    this.uniformsNeedUpdate = true;
  }
  get sdr() {
    return this.uniforms.sdr.value;
  }
  set sdr(value) {
    this.uniforms.sdr.value = value;
  }
  get gainMap() {
    return this.uniforms.gainMap.value;
  }
  set gainMap(value) {
    this.uniforms.gainMap.value = value;
  }
  /**
   * @see {@link GainMapMetadata.offsetHdr}
   */
  get offsetHdr() {
    return this.uniforms.offsetHdr.value.toArray();
  }
  set offsetHdr(value) {
    this.uniforms.offsetHdr.value.fromArray(value);
  }
  /**
   * @see {@link GainMapMetadata.offsetSdr}
   */
  get offsetSdr() {
    return this.uniforms.offsetSdr.value.toArray();
  }
  set offsetSdr(value) {
    this.uniforms.offsetSdr.value.fromArray(value);
  }
  /**
   * @see {@link GainMapMetadata.gainMapMin}
   */
  get gainMapMin() {
    return this.uniforms.gainMapMin.value.toArray();
  }
  set gainMapMin(value) {
    this.uniforms.gainMapMin.value.fromArray(value);
  }
  /**
   * @see {@link GainMapMetadata.gainMapMax}
   */
  get gainMapMax() {
    return this.uniforms.gainMapMax.value.toArray();
  }
  set gainMapMax(value) {
    this.uniforms.gainMapMax.value.fromArray(value);
  }
  /**
   * @see {@link GainMapMetadata.gamma}
   */
  get gamma() {
    const g2 = this.uniforms.gamma.value;
    return [1 / g2.x, 1 / g2.y, 1 / g2.z];
  }
  set gamma(value) {
    const g2 = this.uniforms.gamma.value;
    g2.x = 1 / value[0];
    g2.y = 1 / value[1];
    g2.z = 1 / value[2];
  }
  /**
   * @see {@link GainMapMetadata.hdrCapacityMin}
   * @remarks Logarithmic space
   */
  get hdrCapacityMin() {
    return this._hdrCapacityMin;
  }
  set hdrCapacityMin(value) {
    this._hdrCapacityMin = value;
    this.calculateWeight();
  }
  /**
   * @see {@link GainMapMetadata.hdrCapacityMin}
   * @remarks Logarithmic space
   */
  get hdrCapacityMax() {
    return this._hdrCapacityMax;
  }
  set hdrCapacityMax(value) {
    this._hdrCapacityMax = value;
    this.calculateWeight();
  }
  /**
   * @see {@link GainmapDecodingParameters.maxDisplayBoost}
   * @remarks Non Logarithmic space
   */
  get maxDisplayBoost() {
    return this._maxDisplayBoost;
  }
  set maxDisplayBoost(value) {
    this._maxDisplayBoost = Math.max(1, Math.min(65504, value));
    this.calculateWeight();
  }
  calculateWeight() {
    const val = (Math.log2(this._maxDisplayBoost) - this._hdrCapacityMin) / (this._hdrCapacityMax - this._hdrCapacityMin);
    this.uniforms.weightFactor.value = Math.max(0, Math.min(1, val));
  }
}
class LoaderBaseWebGL extends LoaderBaseShared {
  constructor(renderer, manager) {
    super({
      renderer,
      createMaterial: (params) => new GainMapDecoderMaterial(params),
      createQuadRenderer: (params) => new QuadRenderer(params)
    }, manager);
  }
  /**
   * @private
   * @param quadRenderer
   * @param metadata
   * @param sdrBuffer
   * @param gainMapBuffer
   */
  async render(quadRenderer, metadata, sdrBuffer, gainMapBuffer) {
    const { sdrImage, gainMapImage, needsFlip } = await this.processImages(sdrBuffer, gainMapBuffer, "flipY");
    const { gainMap, sdr } = this.createTextures(sdrImage, gainMapImage, needsFlip);
    this.updateQuadRenderer(quadRenderer, sdrImage, gainMap, sdr, metadata);
    quadRenderer.render();
  }
}
class GainMapLoader extends LoaderBaseWebGL {
  /**
   * Loads a gainmap using separate data
   * * sdr image
   * * gain map image
   * * metadata json
   *
   * useful for webp gain maps
   *
   * @param urls An array in the form of [sdr.jpg, gainmap.jpg, metadata.json]
   * @param onLoad Load complete callback, will receive the result
   * @param onProgress Progress callback, will receive a `ProgressEvent`
   * @param onError Error callback
   * @returns
   */
  load([sdrUrl, gainMapUrl, metadataUrl], onLoad, onProgress, onError) {
    const quadRenderer = this.prepareQuadRenderer();
    let sdr;
    let gainMap;
    let metadata;
    const loadCheck = async () => {
      if (sdr && gainMap && metadata) {
        try {
          await this.render(quadRenderer, metadata, sdr, gainMap);
        } catch (error2) {
          this.manager.itemError(sdrUrl);
          this.manager.itemError(gainMapUrl);
          this.manager.itemError(metadataUrl);
          if (typeof onError === "function")
            onError(error2);
          quadRenderer.disposeOnDemandRenderer();
          return;
        }
        if (typeof onLoad === "function")
          onLoad(quadRenderer);
        this.manager.itemEnd(sdrUrl);
        this.manager.itemEnd(gainMapUrl);
        this.manager.itemEnd(metadataUrl);
        quadRenderer.disposeOnDemandRenderer();
      }
    };
    let sdrLengthComputable = true;
    let sdrTotal = 0;
    let sdrLoaded = 0;
    let gainMapLengthComputable = true;
    let gainMapTotal = 0;
    let gainMapLoaded = 0;
    let metadataLengthComputable = true;
    let metadataTotal = 0;
    let metadataLoaded = 0;
    const progressHandler = () => {
      if (typeof onProgress === "function") {
        const total = sdrTotal + gainMapTotal + metadataTotal;
        const loaded = sdrLoaded + gainMapLoaded + metadataLoaded;
        const lengthComputable = sdrLengthComputable && gainMapLengthComputable && metadataLengthComputable;
        onProgress(new ProgressEvent("progress", { lengthComputable, loaded, total }));
      }
    };
    this.manager.itemStart(sdrUrl);
    this.manager.itemStart(gainMapUrl);
    this.manager.itemStart(metadataUrl);
    const sdrLoader = new FileLoader(this._internalLoadingManager);
    sdrLoader.setResponseType("arraybuffer");
    sdrLoader.setRequestHeader(this.requestHeader);
    sdrLoader.setPath(this.path);
    sdrLoader.setWithCredentials(this.withCredentials);
    sdrLoader.load(sdrUrl, async (buffer) => {
      if (typeof buffer === "string")
        throw new Error("Invalid sdr buffer");
      sdr = buffer;
      await loadCheck();
    }, (e2) => {
      sdrLengthComputable = e2.lengthComputable;
      sdrLoaded = e2.loaded;
      sdrTotal = e2.total;
      progressHandler();
    }, (error2) => {
      this.manager.itemError(sdrUrl);
      if (typeof onError === "function")
        onError(error2);
    });
    const gainMapLoader = new FileLoader(this._internalLoadingManager);
    gainMapLoader.setResponseType("arraybuffer");
    gainMapLoader.setRequestHeader(this.requestHeader);
    gainMapLoader.setPath(this.path);
    gainMapLoader.setWithCredentials(this.withCredentials);
    gainMapLoader.load(gainMapUrl, async (buffer) => {
      if (typeof buffer === "string")
        throw new Error("Invalid gainmap buffer");
      gainMap = buffer;
      await loadCheck();
    }, (e2) => {
      gainMapLengthComputable = e2.lengthComputable;
      gainMapLoaded = e2.loaded;
      gainMapTotal = e2.total;
      progressHandler();
    }, (error2) => {
      this.manager.itemError(gainMapUrl);
      if (typeof onError === "function")
        onError(error2);
    });
    const metadataLoader = new FileLoader(this._internalLoadingManager);
    metadataLoader.setRequestHeader(this.requestHeader);
    metadataLoader.setPath(this.path);
    metadataLoader.setWithCredentials(this.withCredentials);
    metadataLoader.load(metadataUrl, async (json) => {
      if (typeof json !== "string")
        throw new Error("Invalid metadata string");
      metadata = JSON.parse(json);
      await loadCheck();
    }, (e2) => {
      metadataLengthComputable = e2.lengthComputable;
      metadataLoaded = e2.loaded;
      metadataTotal = e2.total;
      progressHandler();
    }, (error2) => {
      this.manager.itemError(metadataUrl);
      if (typeof onError === "function")
        onError(error2);
    });
    return quadRenderer;
  }
}
class HDRJPGLoader extends LoaderBaseWebGL {
  /**
   * Loads a JPEG containing gain map metadata
   * Renders a normal SDR image if gainmap data is not found
   *
   * @param url Path to a JPEG file containing embedded gain map metadata
   * @param onLoad Load complete callback, will receive the result
   * @param onProgress Progress callback, will receive a `ProgressEvent`
   * @param onError Error callback
   * @returns
   */
  load(url, onLoad, onProgress, onError) {
    const quadRenderer = this.prepareQuadRenderer();
    const loader = new FileLoader(this._internalLoadingManager);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(this.requestHeader);
    loader.setPath(this.path);
    loader.setWithCredentials(this.withCredentials);
    this.manager.itemStart(url);
    loader.load(url, async (jpeg) => {
      if (typeof jpeg === "string")
        throw new Error("Invalid buffer, received [string], was expecting [ArrayBuffer]");
      const jpegBuffer = new Uint8Array(jpeg);
      let sdrJPEG;
      let gainMapJPEG;
      let metadata;
      try {
        const extractionResult = await extractGainmapFromJPEG(jpegBuffer);
        sdrJPEG = extractionResult.sdr;
        gainMapJPEG = extractionResult.gainMap;
        metadata = extractionResult.metadata;
      } catch (e2) {
        if (e2 instanceof XMPMetadataNotFoundError || e2 instanceof GainMapNotFoundError) {
          console.warn(`Failure to reconstruct an HDR image from ${url}: Gain map metadata not found in the file, HDRJPGLoader will render the SDR jpeg`);
          metadata = {
            gainMapMin: [0, 0, 0],
            gainMapMax: [1, 1, 1],
            gamma: [1, 1, 1],
            hdrCapacityMin: 0,
            hdrCapacityMax: 1,
            offsetHdr: [0, 0, 0],
            offsetSdr: [0, 0, 0]
          };
          sdrJPEG = jpegBuffer;
        } else {
          throw e2;
        }
      }
      try {
        await this.render(quadRenderer, metadata, sdrJPEG.buffer, gainMapJPEG?.buffer);
      } catch (error2) {
        this.manager.itemError(url);
        if (typeof onError === "function")
          onError(error2);
        quadRenderer.disposeOnDemandRenderer();
        return;
      }
      if (typeof onLoad === "function")
        onLoad(quadRenderer);
      this.manager.itemEnd(url);
      quadRenderer.disposeOnDemandRenderer();
    }, onProgress, (error2) => {
      this.manager.itemError(url);
      if (typeof onError === "function")
        onError(error2);
    });
    return quadRenderer;
  }
}
const presetsObj = {
  apartment: "lebombo_1k.hdr",
  city: "potsdamer_platz_1k.hdr",
  dawn: "kiara_1_dawn_1k.hdr",
  forest: "forest_slope_1k.hdr",
  lobby: "st_fagans_interior_1k.hdr",
  night: "dikhololo_night_1k.hdr",
  park: "rooitou_park_1k.hdr",
  studio: "studio_small_03_1k.hdr",
  sunset: "venice_sunset_1k.hdr",
  warehouse: "empty_warehouse_01_1k.hdr"
};
const CUBEMAP_ROOT = "https://raw.githack.com/pmndrs/drei-assets/456060a26bbeb8fdf79326f224b6d99b8bcce736/hdri/";
const isArray = (arr) => Array.isArray(arr);
const defaultFiles = ["/px.png", "/nx.png", "/py.png", "/ny.png", "/pz.png", "/nz.png"];
function useEnvironment({
  files = defaultFiles,
  path = "",
  preset = void 0,
  encoding = void 0,
  extensions: extensions2
} = {}) {
  let loader = null;
  let multiFile = false;
  if (preset) {
    validatePreset(preset);
    files = presetsObj[preset];
    path = CUBEMAP_ROOT;
  }
  multiFile = isArray(files);
  const {
    extension,
    isCubemap
  } = getExtension(files);
  loader = getLoader(extension);
  if (!loader) throw new Error("useEnvironment: Unrecognized file extension: " + files);
  const gl = useThree((state) => state.gl);
  reactExports.useLayoutEffect(() => {
    if (extension !== "webp" && extension !== "jpg" && extension !== "jpeg") return;
    function clearGainmapTexture() {
      useLoader.clear(
        // @ts-expect-error
        loader,
        multiFile ? [files] : files
      );
    }
    gl.domElement.addEventListener("webglcontextlost", clearGainmapTexture, {
      once: true
    });
  }, [files, gl.domElement]);
  const loaderResult = useLoader(
    // @ts-expect-error
    loader,
    multiFile ? [files] : files,
    (loader2) => {
      if (extension === "webp" || extension === "jpg" || extension === "jpeg") {
        loader2.setRenderer(gl);
      }
      loader2.setPath == null || loader2.setPath(path);
      if (extensions2) extensions2(loader2);
    }
  );
  let texture = multiFile ? (
    // @ts-ignore
    loaderResult[0]
  ) : loaderResult;
  if (extension === "jpg" || extension === "jpeg" || extension === "webp") {
    var _renderTarget;
    texture = (_renderTarget = texture.renderTarget) == null ? void 0 : _renderTarget.texture;
  }
  texture.mapping = isCubemap ? CubeReflectionMapping : EquirectangularReflectionMapping;
  if ("colorSpace" in texture) texture.colorSpace = (encoding !== null && encoding !== void 0 ? encoding : isCubemap) ? "srgb" : "srgb-linear";
  else texture.encoding = (encoding !== null && encoding !== void 0 ? encoding : isCubemap) ? sRGBEncoding : LinearEncoding;
  return texture;
}
const preloadDefaultOptions = {
  files: defaultFiles,
  path: "",
  preset: void 0,
  extensions: void 0
};
useEnvironment.preload = (preloadOptions) => {
  const options = {
    ...preloadDefaultOptions,
    ...preloadOptions
  };
  let {
    files,
    path = ""
  } = options;
  const {
    preset,
    extensions: extensions2
  } = options;
  if (preset) {
    validatePreset(preset);
    files = presetsObj[preset];
    path = CUBEMAP_ROOT;
  }
  const {
    extension
  } = getExtension(files);
  if (extension === "webp" || extension === "jpg" || extension === "jpeg") {
    throw new Error("useEnvironment: Preloading gainmaps is not supported");
  }
  const loader = getLoader(extension);
  if (!loader) throw new Error("useEnvironment: Unrecognized file extension: " + files);
  useLoader.preload(
    // @ts-expect-error
    loader,
    isArray(files) ? [files] : files,
    (loader2) => {
      loader2.setPath == null || loader2.setPath(path);
      if (extensions2) extensions2(loader2);
    }
  );
};
const clearDefaultOptins = {
  files: defaultFiles,
  preset: void 0
};
useEnvironment.clear = (clearOptions) => {
  const options = {
    ...clearDefaultOptins,
    ...clearOptions
  };
  let {
    files
  } = options;
  const {
    preset
  } = options;
  if (preset) {
    validatePreset(preset);
    files = presetsObj[preset];
  }
  const {
    extension
  } = getExtension(files);
  const loader = getLoader(extension);
  if (!loader) throw new Error("useEnvironment: Unrecognized file extension: " + files);
  useLoader.clear(
    // @ts-expect-error
    loader,
    isArray(files) ? [files] : files
  );
};
function validatePreset(preset) {
  if (!(preset in presetsObj)) throw new Error("Preset must be one of: " + Object.keys(presetsObj).join(", "));
}
function getExtension(files) {
  var _firstEntry$split$pop;
  const isCubemap = isArray(files) && files.length === 6;
  const isGainmap = isArray(files) && files.length === 3 && files.some((file) => file.endsWith("json"));
  const firstEntry = isArray(files) ? files[0] : files;
  const extension = isCubemap ? "cube" : isGainmap ? "webp" : firstEntry.startsWith("data:application/exr") ? "exr" : firstEntry.startsWith("data:application/hdr") ? "hdr" : firstEntry.startsWith("data:image/jpeg") ? "jpg" : (_firstEntry$split$pop = firstEntry.split(".").pop()) == null || (_firstEntry$split$pop = _firstEntry$split$pop.split("?")) == null || (_firstEntry$split$pop = _firstEntry$split$pop.shift()) == null ? void 0 : _firstEntry$split$pop.toLowerCase();
  return {
    extension,
    isCubemap,
    isGainmap
  };
}
function getLoader(extension) {
  const loader = extension === "cube" ? CubeTextureLoader : extension === "hdr" ? RGBELoader : extension === "exr" ? EXRLoader : extension === "jpg" || extension === "jpeg" ? HDRJPGLoader : extension === "webp" ? GainMapLoader : null;
  return loader;
}
const isRef = (obj) => obj.current && obj.current.isScene;
const resolveScene = (scene) => isRef(scene) ? scene.current : scene;
function setEnvProps(background, scene, defaultScene, texture, sceneProps = {}) {
  var _target$backgroundRot, _target$backgroundRot2, _target$environmentRo, _target$environmentRo2;
  sceneProps = {
    backgroundBlurriness: 0,
    backgroundIntensity: 1,
    backgroundRotation: [0, 0, 0],
    environmentIntensity: 1,
    environmentRotation: [0, 0, 0],
    ...sceneProps
  };
  const target = resolveScene(scene || defaultScene);
  const oldbg = target.background;
  const oldenv = target.environment;
  const oldSceneProps = {
    // @ts-ignore
    backgroundBlurriness: target.backgroundBlurriness,
    // @ts-ignore
    backgroundIntensity: target.backgroundIntensity,
    // @ts-ignore
    backgroundRotation: (_target$backgroundRot = (_target$backgroundRot2 = target.backgroundRotation) == null || _target$backgroundRot2.clone == null ? void 0 : _target$backgroundRot2.clone()) !== null && _target$backgroundRot !== void 0 ? _target$backgroundRot : [0, 0, 0],
    // @ts-ignore
    environmentIntensity: target.environmentIntensity,
    // @ts-ignore
    environmentRotation: (_target$environmentRo = (_target$environmentRo2 = target.environmentRotation) == null || _target$environmentRo2.clone == null ? void 0 : _target$environmentRo2.clone()) !== null && _target$environmentRo !== void 0 ? _target$environmentRo : [0, 0, 0]
  };
  if (background !== "only") target.environment = texture;
  if (background) target.background = texture;
  applyProps(target, sceneProps);
  return () => {
    if (background !== "only") target.environment = oldenv;
    if (background) target.background = oldbg;
    applyProps(target, oldSceneProps);
  };
}
function EnvironmentMap({
  scene,
  background = false,
  map,
  ...config3
}) {
  const defaultScene = useThree((state) => state.scene);
  reactExports.useLayoutEffect(() => {
    if (map) return setEnvProps(background, scene, defaultScene, map, config3);
  });
  return null;
}
function EnvironmentCube({
  background = false,
  scene,
  blur,
  backgroundBlurriness,
  backgroundIntensity,
  backgroundRotation,
  environmentIntensity,
  environmentRotation,
  ...rest
}) {
  const texture = useEnvironment(rest);
  const defaultScene = useThree((state) => state.scene);
  reactExports.useLayoutEffect(() => {
    return setEnvProps(background, scene, defaultScene, texture, {
      backgroundBlurriness: blur !== null && blur !== void 0 ? blur : backgroundBlurriness,
      backgroundIntensity,
      backgroundRotation,
      environmentIntensity,
      environmentRotation
    });
  });
  reactExports.useEffect(() => {
    return () => {
      texture.dispose();
    };
  }, [texture]);
  return null;
}
function EnvironmentPortal({
  children,
  near = 0.1,
  far = 1e3,
  resolution = 256,
  frames = 1,
  map,
  background = false,
  blur,
  backgroundBlurriness,
  backgroundIntensity,
  backgroundRotation,
  environmentIntensity,
  environmentRotation,
  scene,
  files,
  path,
  preset = void 0,
  extensions: extensions2
}) {
  const gl = useThree((state) => state.gl);
  const defaultScene = useThree((state) => state.scene);
  const camera = reactExports.useRef(null);
  const [virtualScene] = reactExports.useState(() => new Scene());
  const fbo = reactExports.useMemo(() => {
    const fbo2 = new WebGLCubeRenderTarget(resolution);
    fbo2.texture.type = HalfFloatType;
    return fbo2;
  }, [resolution]);
  reactExports.useEffect(() => {
    return () => {
      fbo.dispose();
    };
  }, [fbo]);
  reactExports.useLayoutEffect(() => {
    if (frames === 1) {
      const autoClear = gl.autoClear;
      gl.autoClear = true;
      camera.current.update(gl, virtualScene);
      gl.autoClear = autoClear;
    }
    return setEnvProps(background, scene, defaultScene, fbo.texture, {
      backgroundBlurriness: blur !== null && blur !== void 0 ? blur : backgroundBlurriness,
      backgroundIntensity,
      backgroundRotation,
      environmentIntensity,
      environmentRotation
    });
  }, [children, virtualScene, fbo.texture, scene, defaultScene, background, frames, gl]);
  let count = 1;
  useFrame(() => {
    if (frames === Infinity || count < frames) {
      const autoClear = gl.autoClear;
      gl.autoClear = true;
      camera.current.update(gl, virtualScene);
      gl.autoClear = autoClear;
      count++;
    }
  });
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, createPortal(/* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, children, /* @__PURE__ */ reactExports.createElement("cubeCamera", {
    ref: camera,
    args: [near, far, fbo]
  }), files || preset ? /* @__PURE__ */ reactExports.createElement(EnvironmentCube, {
    background: true,
    files,
    preset,
    path,
    extensions: extensions2
  }) : map ? /* @__PURE__ */ reactExports.createElement(EnvironmentMap, {
    background: true,
    map,
    extensions: extensions2
  }) : null), virtualScene));
}
function EnvironmentGround(props) {
  var _props$ground, _props$ground2, _scale2, _props$ground3;
  const textureDefault = useEnvironment(props);
  const texture = props.map || textureDefault;
  reactExports.useMemo(() => extend({
    GroundProjectedEnvImpl: GroundProjectedEnv
  }), []);
  reactExports.useEffect(() => {
    return () => {
      textureDefault.dispose();
    };
  }, [textureDefault]);
  const args = reactExports.useMemo(() => [texture], [texture]);
  const height = (_props$ground = props.ground) == null ? void 0 : _props$ground.height;
  const radius = (_props$ground2 = props.ground) == null ? void 0 : _props$ground2.radius;
  const scale = (_scale2 = (_props$ground3 = props.ground) == null ? void 0 : _props$ground3.scale) !== null && _scale2 !== void 0 ? _scale2 : 1e3;
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(EnvironmentMap, _extends$1({}, props, {
    map: texture
  })), /* @__PURE__ */ reactExports.createElement("groundProjectedEnvImpl", {
    args,
    scale,
    height,
    radius
  }));
}
function Environment(props) {
  return props.ground ? /* @__PURE__ */ reactExports.createElement(EnvironmentGround, props) : props.map ? /* @__PURE__ */ reactExports.createElement(EnvironmentMap, props) : props.children ? /* @__PURE__ */ reactExports.createElement(EnvironmentPortal, props) : /* @__PURE__ */ reactExports.createElement(EnvironmentCube, props);
}
var withSelector = { exports: {} };
var withSelector_production = {};
var shim = { exports: {} };
var useSyncExternalStoreShim_production = {};
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var React2 = requireReact();
  function is2(x3, y2) {
    return x3 === y2 && (0 !== x3 || 1 / x3 === 1 / y2) || x3 !== x3 && y2 !== y2;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useState = React2.useState, useEffect = React2.useEffect, useLayoutEffect = React2.useLayoutEffect, useDebugValue2 = React2.useDebugValue;
  function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({ inst: { value, getSnapshot } }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(
      function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
      },
      [subscribe, value, getSnapshot]
    );
    useEffect(
      function() {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        return subscribe(function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        });
      },
      [subscribe]
    );
    useDebugValue2(value);
    return value;
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error2) {
      return true;
    }
  }
  function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
  }
  var shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
  useSyncExternalStoreShim_production.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
  return useSyncExternalStoreShim_production;
}
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim.exports;
  hasRequiredShim = 1;
  {
    shim.exports = requireUseSyncExternalStoreShim_production();
  }
  return shim.exports;
}
var hasRequiredWithSelector_production;
function requireWithSelector_production() {
  if (hasRequiredWithSelector_production) return withSelector_production;
  hasRequiredWithSelector_production = 1;
  var React2 = requireReact(), shim2 = requireShim();
  function is2(x3, y2) {
    return x3 === y2 && (0 !== x3 || 1 / x3 === 1 / y2) || x3 !== x3 && y2 !== y2;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useSyncExternalStore = shim2.useSyncExternalStore, useRef = React2.useRef, useEffect = React2.useEffect, useMemo = React2.useMemo, useDebugValue2 = React2.useDebugValue;
  withSelector_production.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector3, isEqual2) {
    var instRef = useRef(null);
    if (null === instRef.current) {
      var inst = { hasValue: false, value: null };
      instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(
      function() {
        function memoizedSelector(nextSnapshot) {
          if (!hasMemo) {
            hasMemo = true;
            memoizedSnapshot = nextSnapshot;
            nextSnapshot = selector3(nextSnapshot);
            if (void 0 !== isEqual2 && inst.hasValue) {
              var currentSelection = inst.value;
              if (isEqual2(currentSelection, nextSnapshot))
                return memoizedSelection = currentSelection;
            }
            return memoizedSelection = nextSnapshot;
          }
          currentSelection = memoizedSelection;
          if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
          var nextSelection = selector3(nextSnapshot);
          if (void 0 !== isEqual2 && isEqual2(currentSelection, nextSelection))
            return memoizedSnapshot = nextSnapshot, currentSelection;
          memoizedSnapshot = nextSnapshot;
          return memoizedSelection = nextSelection;
        }
        var hasMemo = false, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
          function() {
            return memoizedSelector(getSnapshot());
          },
          null === maybeGetServerSnapshot ? void 0 : function() {
            return memoizedSelector(maybeGetServerSnapshot());
          }
        ];
      },
      [getSnapshot, getServerSnapshot, selector3, isEqual2]
    );
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(
      function() {
        inst.hasValue = true;
        inst.value = value;
      },
      [value]
    );
    useDebugValue2(value);
    return value;
  };
  return withSelector_production;
}
var hasRequiredWithSelector;
function requireWithSelector() {
  if (hasRequiredWithSelector) return withSelector.exports;
  hasRequiredWithSelector = 1;
  {
    withSelector.exports = requireWithSelector_production();
  }
  return withSelector.exports;
}
var withSelectorExports = requireWithSelector();
const useSyncExternalStoreExports = /* @__PURE__ */ getDefaultExportFromCjs(withSelectorExports);
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var _config = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, _defaults = {
  duration: 0.5,
  overwrite: false,
  delay: 0
}, _suppressOverwrites, _reverting$1, _context, _bigNum$1 = 1e8, _tinyNum = 1 / _bigNum$1, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString2(value) {
  return typeof value === "string";
}, _isFunction = function _isFunction2(value) {
  return typeof value === "function";
}, _isNumber = function _isNumber2(value) {
  return typeof value === "number";
}, _isUndefined = function _isUndefined2(value) {
  return typeof value === "undefined";
}, _isObject = function _isObject2(value) {
  return typeof value === "object";
}, _isNotFalse = function _isNotFalse2(value) {
  return value !== false;
}, _windowExists$1 = function _windowExists() {
  return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString2(value) {
  return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {
}, _isArray = Array.isArray, _randomExp = /random\([^)]+\)/g, _commaDelimExp = /,\s*/g, _strictNumExp = /(?:-?\.?\d|\.)+/gi, _numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, _numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, _relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, _unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win$1, _coreInitted, _doc$1, _globals = {}, _installScope = {}, _coreReady, _install = function _install2(scope) {
  return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin2(property, value) {
  return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn2(message, suppress) {
  return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal2(name, obj) {
  return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc2() {
  return 0;
}, _startAtRevertConfig = {
  suppressEvents: true,
  isStart: true,
  kill: false
}, _revertConfigNoKill = {
  suppressEvents: true,
  kill: false
}, _revertConfig = {
  suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness2(targets) {
  var target = targets[0], harnessPlugin, i2;
  _isObject(target) || _isFunction(target) || (targets = [targets]);
  if (!(harnessPlugin = (target._gsap || {}).harness)) {
    i2 = _harnessPlugins.length;
    while (i2-- && !_harnessPlugins[i2].targetTest(target)) {
    }
    harnessPlugin = _harnessPlugins[i2];
  }
  i2 = targets.length;
  while (i2--) {
    targets[i2] && (targets[i2]._gsap || (targets[i2]._gsap = new GSCache(targets[i2], harnessPlugin))) || targets.splice(i2, 1);
  }
  return targets;
}, _getCache = function _getCache2(target) {
  return target._gsap || _harness(toArray$1(target))[0]._gsap;
}, _getProperty = function _getProperty2(target, property, v3) {
  return (v3 = target[property]) && _isFunction(v3) ? target[property]() : _isUndefined(v3) && target.getAttribute && target.getAttribute(property) || v3;
}, _forEachName = function _forEachName2(names, func) {
  return (names = names.split(",")).forEach(func) || names;
}, _round = function _round2(value) {
  return Math.round(value * 1e5) / 1e5 || 0;
}, _roundPrecise = function _roundPrecise2(value) {
  return Math.round(value * 1e7) / 1e7 || 0;
}, _parseRelative = function _parseRelative2(start2, value) {
  var operator = value.charAt(0), end = parseFloat(value.substr(2));
  start2 = parseFloat(start2);
  return operator === "+" ? start2 + end : operator === "-" ? start2 - end : operator === "*" ? start2 * end : start2 / end;
}, _arrayContainsAny = function _arrayContainsAny2(toSearch, toFind) {
  var l2 = toFind.length, i2 = 0;
  for (; toSearch.indexOf(toFind[i2]) < 0 && ++i2 < l2; ) {
  }
  return i2 < l2;
}, _lazyRender = function _lazyRender2() {
  var l2 = _lazyTweens.length, a5 = _lazyTweens.slice(0), i2, tween;
  _lazyLookup = {};
  _lazyTweens.length = 0;
  for (i2 = 0; i2 < l2; i2++) {
    tween = a5[i2];
    tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
  }
}, _isRevertWorthy = function _isRevertWorthy2(animation) {
  return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender2(animation, time, suppressEvents, force) {
  _lazyTweens.length && !_reverting$1 && _lazyRender();
  animation.render(time, suppressEvents, !!(_reverting$1 && time < 0 && _isRevertWorthy(animation)));
  _lazyTweens.length && !_reverting$1 && _lazyRender();
}, _numericIfPossible = function _numericIfPossible2(value) {
  var n2 = parseFloat(value);
  return (n2 || n2 === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n2 : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough2(p3) {
  return p3;
}, _setDefaults = function _setDefaults2(obj, defaults2) {
  for (var p3 in defaults2) {
    p3 in obj || (obj[p3] = defaults2[p3]);
  }
  return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults2(excludeDuration) {
  return function(obj, defaults2) {
    for (var p3 in defaults2) {
      p3 in obj || p3 === "duration" && excludeDuration || p3 === "ease" || (obj[p3] = defaults2[p3]);
    }
  };
}, _merge = function _merge2(base, toMerge) {
  for (var p3 in toMerge) {
    base[p3] = toMerge[p3];
  }
  return base;
}, _mergeDeep = function _mergeDeep2(base, toMerge) {
  for (var p3 in toMerge) {
    p3 !== "__proto__" && p3 !== "constructor" && p3 !== "prototype" && (base[p3] = _isObject(toMerge[p3]) ? _mergeDeep2(base[p3] || (base[p3] = {}), toMerge[p3]) : toMerge[p3]);
  }
  return base;
}, _copyExcluding = function _copyExcluding2(obj, excluding) {
  var copy = {}, p3;
  for (p3 in obj) {
    p3 in excluding || (copy[p3] = obj[p3]);
  }
  return copy;
}, _inheritDefaults = function _inheritDefaults2(vars) {
  var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
  if (_isNotFalse(vars.inherit)) {
    while (parent) {
      func(vars, parent.vars.defaults);
      parent = parent.parent || parent._dp;
    }
  }
  return vars;
}, _arraysMatch = function _arraysMatch2(a1, a22) {
  var i2 = a1.length, match = i2 === a22.length;
  while (match && i2-- && a1[i2] === a22[i2]) {
  }
  return i2 < 0;
}, _addLinkedListItem = function _addLinkedListItem2(parent, child, firstProp, lastProp, sortBy) {
  var prev = parent[lastProp], t2;
  if (sortBy) {
    t2 = child[sortBy];
    while (prev && prev[sortBy] > t2) {
      prev = prev._prev;
    }
  }
  if (prev) {
    child._next = prev._next;
    prev._next = child;
  } else {
    child._next = parent[firstProp];
    parent[firstProp] = child;
  }
  if (child._next) {
    child._next._prev = child;
  } else {
    parent[lastProp] = child;
  }
  child._prev = prev;
  child.parent = child._dp = parent;
  return child;
}, _removeLinkedListItem = function _removeLinkedListItem2(parent, child, firstProp, lastProp) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }
  if (lastProp === void 0) {
    lastProp = "_last";
  }
  var prev = child._prev, next = child._next;
  if (prev) {
    prev._next = next;
  } else if (parent[firstProp] === child) {
    parent[firstProp] = next;
  }
  if (next) {
    next._prev = prev;
  } else if (parent[lastProp] === child) {
    parent[lastProp] = prev;
  }
  child._next = child._prev = child.parent = null;
}, _removeFromParent = function _removeFromParent2(child, onlyIfParentHasAutoRemove) {
  child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
  child._act = 0;
}, _uncache = function _uncache2(animation, child) {
  if (animation && (!child || child._end > animation._dur || child._start < 0)) {
    var a5 = animation;
    while (a5) {
      a5._dirty = 1;
      a5 = a5.parent;
    }
  }
  return animation;
}, _recacheAncestors = function _recacheAncestors2(animation) {
  var parent = animation.parent;
  while (parent && parent.parent) {
    parent._dirty = 1;
    parent.totalDuration();
    parent = parent.parent;
  }
  return animation;
}, _rewindStartAt = function _rewindStartAt2(tween, totalTime, suppressEvents, force) {
  return tween._startAt && (_reverting$1 ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors2(animation) {
  return !animation || animation._ts && _hasNoPausedAncestors2(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration2(animation) {
  return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, _animationCycle = function _animationCycle2(tTime, cycleDuration) {
  var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
  return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime2(parentTime, child) {
  return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd2(animation) {
  return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead2(animation, totalTime) {
  var parent = animation._dp;
  if (parent && parent.smoothChildTiming && animation._ts) {
    animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
    _setEnd(animation);
    parent._dirty || _uncache(parent, animation);
  }
  return animation;
}, _postAddChecks = function _postAddChecks2(timeline2, child) {
  var t2;
  if (child._time || !child._dur && child._initted || child._start < timeline2._time && (child._dur || !child.add)) {
    t2 = _parentToChildTotalTime(timeline2.rawTime(), child);
    if (!child._dur || _clamp(0, child.totalDuration(), t2) - child._tTime > _tinyNum) {
      child.render(t2, true);
    }
  }
  if (_uncache(timeline2, child)._dp && timeline2._initted && timeline2._time >= timeline2._dur && timeline2._ts) {
    if (timeline2._dur < timeline2.duration()) {
      t2 = timeline2;
      while (t2._dp) {
        t2.rawTime() >= 0 && t2.totalTime(t2._tTime);
        t2 = t2._dp;
      }
    }
    timeline2._zTime = -_tinyNum;
  }
}, _addToTimeline = function _addToTimeline2(timeline2, child, position, skipChecks) {
  child.parent && _removeFromParent(child);
  child._start = _roundPrecise((_isNumber(position) ? position : position || timeline2 !== _globalTimeline ? _parsePosition(timeline2, position, child) : timeline2._time) + child._delay);
  child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
  _addLinkedListItem(timeline2, child, "_first", "_last", timeline2._sort ? "_start" : 0);
  _isFromOrFromStart(child) || (timeline2._recent = child);
  skipChecks || _postAddChecks(timeline2, child);
  timeline2._ts < 0 && _alignPlayhead(timeline2, timeline2._tTime);
  return timeline2;
}, _scrollTrigger = function _scrollTrigger2(animation, trigger) {
  return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween2(tween, time, force, suppressEvents, tTime) {
  _initTween(tween, time, tTime);
  if (!tween._initted) {
    return 1;
  }
  if (!force && tween._pt && !_reverting$1 && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
    _lazyTweens.push(tween);
    tween._lazy = [tTime, suppressEvents];
    return 1;
  }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart2(_ref) {
  var parent = _ref.parent;
  return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart2(parent));
}, _isFromOrFromStart = function _isFromOrFromStart2(_ref2) {
  var data = _ref2.data;
  return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween2(tween, totalTime, suppressEvents, force) {
  var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
  if (repeatDelay && tween._repeat) {
    tTime = _clamp(0, tween._tDur, totalTime);
    iteration = _animationCycle(tTime, repeatDelay);
    tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
    if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
      prevRatio = 1 - ratio;
      tween.vars.repeatRefresh && tween._initted && tween.invalidate();
    }
  }
  if (ratio !== prevRatio || _reverting$1 || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) {
      return;
    }
    prevIteration = tween._zTime;
    tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0);
    suppressEvents || (suppressEvents = totalTime && !prevIteration);
    tween.ratio = ratio;
    tween._from && (ratio = 1 - ratio);
    tween._time = 0;
    tween._tTime = tTime;
    pt = tween._pt;
    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }
    totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
    tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
    tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
    if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
      ratio && _removeFromParent(tween, 1);
      if (!suppressEvents && !_reverting$1) {
        _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
        tween._prom && tween._prom();
      }
    }
  } else if (!tween._zTime) {
    tween._zTime = totalTime;
  }
}, _findNextPauseTween = function _findNextPauseTween2(animation, prevTime, time) {
  var child;
  if (time > prevTime) {
    child = animation._first;
    while (child && child._start <= time) {
      if (child.data === "isPause" && child._start > prevTime) {
        return child;
      }
      child = child._next;
    }
  } else {
    child = animation._last;
    while (child && child._start >= time) {
      if (child.data === "isPause" && child._start < prevTime) {
        return child;
      }
      child = child._prev;
    }
  }
}, _setDuration = function _setDuration2(animation, duration, skipUncache, leavePlayhead) {
  var repeat2 = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
  totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
  animation._dur = dur;
  animation._tDur = !repeat2 ? dur : repeat2 < 0 ? 1e10 : _roundPrecise(dur * (repeat2 + 1) + animation._rDelay * repeat2);
  totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
  animation.parent && _setEnd(animation);
  skipUncache || _uncache(animation.parent, animation);
  return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration2(animation) {
  return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
  _start: 0,
  endTime: _emptyFunc,
  totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition2(animation, position, percentAnimation) {
  var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum$1 ? recent.endTime(false) : animation._dur, i2, offset, isPercent;
  if (_isString(position) && (isNaN(position) || position in labels)) {
    offset = position.charAt(0);
    isPercent = position.substr(-1) === "%";
    i2 = position.indexOf("=");
    if (offset === "<" || offset === ">") {
      i2 >= 0 && (position = position.replace(/=/, ""));
      return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i2 < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
    }
    if (i2 < 0) {
      position in labels || (labels[position] = clippedDuration);
      return labels[position];
    }
    offset = parseFloat(position.charAt(i2 - 1) + position.substr(i2 + 1));
    if (isPercent && percentAnimation) {
      offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
    }
    return i2 > 1 ? _parsePosition2(animation, position.substr(0, i2 - 1), percentAnimation) + offset : clippedDuration + offset;
  }
  return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType2(type, params, timeline2) {
  var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
  isLegacy && (vars.duration = params[1]);
  vars.parent = timeline2;
  if (type) {
    irVars = vars;
    parent = timeline2;
    while (parent && !("immediateRender" in irVars)) {
      irVars = parent.vars.defaults || {};
      parent = _isNotFalse(parent.vars.inherit) && parent.parent;
    }
    vars.immediateRender = _isNotFalse(irVars.immediateRender);
    type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1];
  }
  return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn2(value, func) {
  return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp2(min, max2, value) {
  return value < min ? min : value > max2 ? max2 : value;
}, getUnit = function getUnit2(value, v3) {
  return !_isString(value) || !(v3 = _unitExp.exec(value)) ? "" : v3[1];
}, clamp$1 = function clamp(min, max2, value) {
  return _conditionalReturn(value, function(v3) {
    return _clamp(min, max2, v3);
  });
}, _slice = [].slice, _isArrayLike = function _isArrayLike2(value, nonEmpty) {
  return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win$1;
}, _flatten = function _flatten2(ar, leaveStrings, accumulator) {
  if (accumulator === void 0) {
    accumulator = [];
  }
  return ar.forEach(function(value) {
    var _accumulator;
    return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray$1(value)) : accumulator.push(value);
  }) || accumulator;
}, toArray$1 = function toArray(value, scope, leaveStrings) {
  return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc$1).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
}, selector = function selector2(value) {
  value = toArray$1(value)[0] || _warn("Invalid scope") || {};
  return function(v3) {
    var el = value.current || value.nativeElement || value;
    return toArray$1(v3, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc$1.createElement("div") : value);
  };
}, shuffle = function shuffle2(a5) {
  return a5.sort(function() {
    return 0.5 - Math.random();
  });
}, distribute = function distribute2(v3) {
  if (_isFunction(v3)) {
    return v3;
  }
  var vars = _isObject(v3) ? v3 : {
    each: v3
  }, ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
  if (_isString(from)) {
    ratioX = ratioY = {
      center: 0.5,
      edges: 0.5,
      end: 1
    }[from] || 0;
  } else if (!isDecimal && ratios) {
    ratioX = from[0];
    ratioY = from[1];
  }
  return function(i2, target, a5) {
    var l2 = (a5 || vars).length, distances = cache[l2], originX, originY, x3, y2, d3, j3, max2, min, wrapAt;
    if (!distances) {
      wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum$1])[1];
      if (!wrapAt) {
        max2 = -_bigNum$1;
        while (max2 < (max2 = a5[wrapAt++].getBoundingClientRect().left) && wrapAt < l2) {
        }
        wrapAt < l2 && wrapAt--;
      }
      distances = cache[l2] = [];
      originX = ratios ? Math.min(wrapAt, l2) * ratioX - 0.5 : from % wrapAt;
      originY = wrapAt === _bigNum$1 ? 0 : ratios ? l2 * ratioY / wrapAt - 0.5 : from / wrapAt | 0;
      max2 = 0;
      min = _bigNum$1;
      for (j3 = 0; j3 < l2; j3++) {
        x3 = j3 % wrapAt - originX;
        y2 = originY - (j3 / wrapAt | 0);
        distances[j3] = d3 = !axis ? _sqrt(x3 * x3 + y2 * y2) : Math.abs(axis === "y" ? y2 : x3);
        d3 > max2 && (max2 = d3);
        d3 < min && (min = d3);
      }
      from === "random" && shuffle(distances);
      distances.max = max2 - min;
      distances.min = min;
      distances.v = l2 = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l2 ? l2 - 1 : !axis ? Math.max(wrapAt, l2 / wrapAt) : axis === "y" ? l2 / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
      distances.b = l2 < 0 ? base - l2 : base;
      distances.u = getUnit(vars.amount || vars.each) || 0;
      ease = ease && l2 < 0 ? _invertEase(ease) : ease;
    }
    l2 = (distances[i2] - distances.min) / distances.max || 0;
    return _roundPrecise(distances.b + (ease ? ease(l2) : l2) * distances.v) + distances.u;
  };
}, _roundModifier = function _roundModifier2(v3) {
  var p3 = Math.pow(10, ((v3 + "").split(".")[1] || "").length);
  return function(raw) {
    var n2 = _roundPrecise(Math.round(parseFloat(raw) / v3) * v3 * p3);
    return (n2 - n2 % 1) / p3 + (_isNumber(raw) ? 0 : getUnit(raw));
  };
}, snap = function snap2(snapTo, value) {
  var isArray2 = _isArray(snapTo), radius, is2D;
  if (!isArray2 && _isObject(snapTo)) {
    radius = isArray2 = snapTo.radius || _bigNum$1;
    if (snapTo.values) {
      snapTo = toArray$1(snapTo.values);
      if (is2D = !_isNumber(snapTo[0])) {
        radius *= radius;
      }
    } else {
      snapTo = _roundModifier(snapTo.increment);
    }
  }
  return _conditionalReturn(value, !isArray2 ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
    is2D = snapTo(raw);
    return Math.abs(is2D - raw) <= radius ? is2D : raw;
  } : function(raw) {
    var x3 = parseFloat(is2D ? raw.x : raw), y2 = parseFloat(is2D ? raw.y : 0), min = _bigNum$1, closest = 0, i2 = snapTo.length, dx, dy;
    while (i2--) {
      if (is2D) {
        dx = snapTo[i2].x - x3;
        dy = snapTo[i2].y - y2;
        dx = dx * dx + dy * dy;
      } else {
        dx = Math.abs(snapTo[i2] - x3);
      }
      if (dx < min) {
        min = dx;
        closest = i2;
      }
    }
    closest = !radius || min <= radius ? snapTo[closest] : raw;
    return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
  });
}, random = function random2(min, max2, roundingIncrement, returnFunction) {
  return _conditionalReturn(_isArray(min) ? !max2 : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function() {
    return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max2 - min + roundingIncrement * 0.99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
  });
}, pipe = function pipe2() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }
  return function(value) {
    return functions.reduce(function(v3, f2) {
      return f2(v3);
    }, value);
  };
}, unitize = function unitize2(func, unit) {
  return function(value) {
    return func(parseFloat(value)) + (unit || getUnit(value));
  };
}, normalize = function normalize2(min, max2, value) {
  return mapRange(min, max2, 0, 1, value);
}, _wrapArray = function _wrapArray2(a5, wrapper, value) {
  return _conditionalReturn(value, function(index) {
    return a5[~~wrapper(index)];
  });
}, wrap = function wrap2(min, max2, value) {
  var range = max2 - min;
  return _isArray(min) ? _wrapArray(min, wrap2(0, min.length), max2) : _conditionalReturn(value, function(value2) {
    return (range + (value2 - min) % range) % range + min;
  });
}, wrapYoyo = function wrapYoyo2(min, max2, value) {
  var range = max2 - min, total = range * 2;
  return _isArray(min) ? _wrapArray(min, wrapYoyo2(0, min.length - 1), max2) : _conditionalReturn(value, function(value2) {
    value2 = (total + (value2 - min) % total) % total || 0;
    return min + (value2 > range ? total - value2 : value2);
  });
}, _replaceRandom = function _replaceRandom2(s2) {
  return s2.replace(_randomExp, function(match) {
    var arIndex = match.indexOf("[") + 1, values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
    return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
  });
}, mapRange = function mapRange2(inMin, inMax, outMin, outMax, value) {
  var inRange = inMax - inMin, outRange = outMax - outMin;
  return _conditionalReturn(value, function(value2) {
    return outMin + ((value2 - inMin) / inRange * outRange || 0);
  });
}, interpolate$1 = function interpolate(start2, end, progress, mutate) {
  var func = isNaN(start2 + end) ? 0 : function(p4) {
    return (1 - p4) * start2 + p4 * end;
  };
  if (!func) {
    var isString = _isString(start2), master = {}, p3, i2, interpolators, l2, il;
    progress === true && (mutate = 1) && (progress = null);
    if (isString) {
      start2 = {
        p: start2
      };
      end = {
        p: end
      };
    } else if (_isArray(start2) && !_isArray(end)) {
      interpolators = [];
      l2 = start2.length;
      il = l2 - 2;
      for (i2 = 1; i2 < l2; i2++) {
        interpolators.push(interpolate(start2[i2 - 1], start2[i2]));
      }
      l2--;
      func = function func2(p4) {
        p4 *= l2;
        var i3 = Math.min(il, ~~p4);
        return interpolators[i3](p4 - i3);
      };
      progress = end;
    } else if (!mutate) {
      start2 = _merge(_isArray(start2) ? [] : {}, start2);
    }
    if (!interpolators) {
      for (p3 in end) {
        _addPropTween.call(master, start2, p3, "get", end[p3]);
      }
      func = function func2(p4) {
        return _renderPropTweens(p4, master) || (isString ? start2.p : start2);
      };
    }
  }
  return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection2(timeline2, fromTime, backward) {
  var labels = timeline2.labels, min = _bigNum$1, p3, distance, label;
  for (p3 in labels) {
    distance = labels[p3] - fromTime;
    if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
      label = p3;
      min = distance;
    }
  }
  return label;
}, _callback = function _callback2(animation, type, executeLazyFirst) {
  var v3 = animation.vars, callback = v3[type], prevContext = _context, context4 = animation._ctx, params, scope, result;
  if (!callback) {
    return;
  }
  params = v3[type + "Params"];
  scope = v3.callbackScope || animation;
  executeLazyFirst && _lazyTweens.length && _lazyRender();
  context4 && (_context = context4);
  result = params ? callback.apply(scope, params) : callback.call(scope);
  _context = prevContext;
  return result;
}, _interrupt = function _interrupt2(animation) {
  _removeFromParent(animation);
  animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting$1);
  animation.progress() < 1 && _callback(animation, "onInterrupt");
  return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin2(config3) {
  if (!config3) return;
  config3 = !config3.name && config3["default"] || config3;
  if (_windowExists$1() || config3.headless) {
    var name = config3.name, isFunc = _isFunction(config3), Plugin = name && !isFunc && config3.init ? function() {
      this._props = [];
    } : config3, instanceDefaults = {
      init: _emptyFunc,
      render: _renderPropTweens,
      add: _addPropTween,
      kill: _killPropTweensOf,
      modifier: _addPluginModifier,
      rawVars: 0
    }, statics = {
      targetTest: 0,
      get: 0,
      getSetter: _getSetter,
      aliases: {},
      register: 0
    };
    _wake();
    if (config3 !== Plugin) {
      if (_plugins[name]) {
        return;
      }
      _setDefaults(Plugin, _setDefaults(_copyExcluding(config3, instanceDefaults), statics));
      _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config3, statics)));
      _plugins[Plugin.prop = name] = Plugin;
      if (config3.targetTest) {
        _harnessPlugins.push(Plugin);
        _reservedProps[name] = 1;
      }
      name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin";
    }
    _addGlobal(name, Plugin);
    config3.register && config3.register(gsap, Plugin, PropTween);
  } else {
    _registerPluginQueue.push(config3);
  }
}, _255 = 255, _colorLookup = {
  aqua: [0, _255, _255],
  lime: [0, _255, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, _255],
  navy: [0, 0, 128],
  white: [_255, _255, _255],
  olive: [128, 128, 0],
  yellow: [_255, _255, 0],
  orange: [_255, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [_255, 0, 0],
  pink: [_255, 192, 203],
  cyan: [0, _255, _255],
  transparent: [_255, _255, _255, 0]
}, _hue = function _hue2(h2, m1, m2) {
  h2 += h2 < 0 ? 1 : h2 > 1 ? -1 : 0;
  return (h2 * 6 < 1 ? m1 + (m2 - m1) * h2 * 6 : h2 < 0.5 ? m2 : h2 * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h2) * 6 : m1) * _255 + 0.5 | 0;
}, splitColor = function splitColor2(v3, toHSL, forceAlpha) {
  var a5 = !v3 ? _colorLookup.black : _isNumber(v3) ? [v3 >> 16, v3 >> 8 & _255, v3 & _255] : 0, r3, g2, b6, h2, s2, l2, max2, min, d3, wasHSL;
  if (!a5) {
    if (v3.substr(-1) === ",") {
      v3 = v3.substr(0, v3.length - 1);
    }
    if (_colorLookup[v3]) {
      a5 = _colorLookup[v3];
    } else if (v3.charAt(0) === "#") {
      if (v3.length < 6) {
        r3 = v3.charAt(1);
        g2 = v3.charAt(2);
        b6 = v3.charAt(3);
        v3 = "#" + r3 + r3 + g2 + g2 + b6 + b6 + (v3.length === 5 ? v3.charAt(4) + v3.charAt(4) : "");
      }
      if (v3.length === 9) {
        a5 = parseInt(v3.substr(1, 6), 16);
        return [a5 >> 16, a5 >> 8 & _255, a5 & _255, parseInt(v3.substr(7), 16) / 255];
      }
      v3 = parseInt(v3.substr(1), 16);
      a5 = [v3 >> 16, v3 >> 8 & _255, v3 & _255];
    } else if (v3.substr(0, 3) === "hsl") {
      a5 = wasHSL = v3.match(_strictNumExp);
      if (!toHSL) {
        h2 = +a5[0] % 360 / 360;
        s2 = +a5[1] / 100;
        l2 = +a5[2] / 100;
        g2 = l2 <= 0.5 ? l2 * (s2 + 1) : l2 + s2 - l2 * s2;
        r3 = l2 * 2 - g2;
        a5.length > 3 && (a5[3] *= 1);
        a5[0] = _hue(h2 + 1 / 3, r3, g2);
        a5[1] = _hue(h2, r3, g2);
        a5[2] = _hue(h2 - 1 / 3, r3, g2);
      } else if (~v3.indexOf("=")) {
        a5 = v3.match(_numExp);
        forceAlpha && a5.length < 4 && (a5[3] = 1);
        return a5;
      }
    } else {
      a5 = v3.match(_strictNumExp) || _colorLookup.transparent;
    }
    a5 = a5.map(Number);
  }
  if (toHSL && !wasHSL) {
    r3 = a5[0] / _255;
    g2 = a5[1] / _255;
    b6 = a5[2] / _255;
    max2 = Math.max(r3, g2, b6);
    min = Math.min(r3, g2, b6);
    l2 = (max2 + min) / 2;
    if (max2 === min) {
      h2 = s2 = 0;
    } else {
      d3 = max2 - min;
      s2 = l2 > 0.5 ? d3 / (2 - max2 - min) : d3 / (max2 + min);
      h2 = max2 === r3 ? (g2 - b6) / d3 + (g2 < b6 ? 6 : 0) : max2 === g2 ? (b6 - r3) / d3 + 2 : (r3 - g2) / d3 + 4;
      h2 *= 60;
    }
    a5[0] = ~~(h2 + 0.5);
    a5[1] = ~~(s2 * 100 + 0.5);
    a5[2] = ~~(l2 * 100 + 0.5);
  }
  forceAlpha && a5.length < 4 && (a5[3] = 1);
  return a5;
}, _colorOrderData = function _colorOrderData2(v3) {
  var values = [], c2 = [], i2 = -1;
  v3.split(_colorExp).forEach(function(v4) {
    var a5 = v4.match(_numWithUnitExp) || [];
    values.push.apply(values, a5);
    c2.push(i2 += a5.length + 1);
  });
  values.c = c2;
  return values;
}, _formatColors = function _formatColors2(s2, toHSL, orderMatchData) {
  var result = "", colors3 = (s2 + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i2 = 0, c2, shell, d3, l2;
  if (!colors3) {
    return s2;
  }
  colors3 = colors3.map(function(color) {
    return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
  });
  if (orderMatchData) {
    d3 = _colorOrderData(s2);
    c2 = orderMatchData.c;
    if (c2.join(result) !== d3.c.join(result)) {
      shell = s2.replace(_colorExp, "1").split(_numWithUnitExp);
      l2 = shell.length - 1;
      for (; i2 < l2; i2++) {
        result += shell[i2] + (~c2.indexOf(i2) ? colors3.shift() || type + "0,0,0,0)" : (d3.length ? d3 : colors3.length ? colors3 : orderMatchData).shift());
      }
    }
  }
  if (!shell) {
    shell = s2.split(_colorExp);
    l2 = shell.length - 1;
    for (; i2 < l2; i2++) {
      result += shell[i2] + colors3[i2];
    }
  }
  return result + shell[l2];
}, _colorExp = (function() {
  var s2 = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", p3;
  for (p3 in _colorLookup) {
    s2 += "|" + p3 + "\\b";
  }
  return new RegExp(s2 + ")", "gi");
})(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter2(a5) {
  var combined = a5.join(" "), toHSL;
  _colorExp.lastIndex = 0;
  if (_colorExp.test(combined)) {
    toHSL = _hslExp.test(combined);
    a5[1] = _formatColors(a5[1], toHSL);
    a5[0] = _formatColors(a5[0], toHSL, _colorOrderData(a5[1]));
    return true;
  }
}, _tickerActive, _ticker = (function() {
  var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1e3 / 240, _nextTime = _gap, _listeners2 = [], _id2, _req, _raf, _self, _delta, _i, _tick = function _tick2(v3) {
    var elapsed = _getTime() - _lastUpdate, manual = v3 === true, overlap, dispatch, time, frame;
    (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
    _lastUpdate += elapsed;
    time = _lastUpdate - _startTime;
    overlap = time - _nextTime;
    if (overlap > 0 || manual) {
      frame = ++_self.frame;
      _delta = time - _self.time * 1e3;
      _self.time = time = time / 1e3;
      _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
      dispatch = 1;
    }
    manual || (_id2 = _req(_tick2));
    if (dispatch) {
      for (_i = 0; _i < _listeners2.length; _i++) {
        _listeners2[_i](time, _delta, frame, v3);
      }
    }
  };
  _self = {
    time: 0,
    frame: 0,
    tick: function tick() {
      _tick(true);
    },
    deltaRatio: function deltaRatio(fps) {
      return _delta / (1e3 / (fps || 60));
    },
    wake: function wake() {
      if (_coreReady) {
        if (!_coreInitted && _windowExists$1()) {
          _win$1 = _coreInitted = window;
          _doc$1 = _win$1.document || {};
          _globals.gsap = gsap;
          (_win$1.gsapVersions || (_win$1.gsapVersions = [])).push(gsap.version);
          _install(_installScope || _win$1.GreenSockGlobals || !_win$1.gsap && _win$1 || {});
          _registerPluginQueue.forEach(_createPlugin);
        }
        _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
        _id2 && _self.sleep();
        _req = _raf || function(f2) {
          return setTimeout(f2, _nextTime - _self.time * 1e3 + 1 | 0);
        };
        _tickerActive = 1;
        _tick(2);
      }
    },
    sleep: function sleep() {
      (_raf ? cancelAnimationFrame : clearTimeout)(_id2);
      _tickerActive = 0;
      _req = _emptyFunc;
    },
    lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
      _lagThreshold = threshold || Infinity;
      _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
    },
    fps: function fps(_fps) {
      _gap = 1e3 / (_fps || 240);
      _nextTime = _self.time * 1e3 + _gap;
    },
    add: function add(callback, once2, prioritize) {
      var func = once2 ? function(t2, d3, f2, v3) {
        callback(t2, d3, f2, v3);
        _self.remove(func);
      } : callback;
      _self.remove(callback);
      _listeners2[prioritize ? "unshift" : "push"](func);
      _wake();
      return func;
    },
    remove: function remove(callback, i2) {
      ~(i2 = _listeners2.indexOf(callback)) && _listeners2.splice(i2, 1) && _i >= i2 && _i--;
    },
    _listeners: _listeners2
  };
  return _self;
})(), _wake = function _wake2() {
  return !_tickerActive && _ticker.wake();
}, _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString2(value) {
  var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i2 = 1, l2 = split.length, index, val, parsedVal;
  for (; i2 < l2; i2++) {
    val = split[i2];
    index = i2 !== l2 - 1 ? val.lastIndexOf(",") : val.length;
    parsedVal = val.substr(0, index);
    obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
    key = val.substr(index + 1).trim();
  }
  return obj;
}, _valueInParentheses = function _valueInParentheses2(value) {
  var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
  return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString2(name) {
  var split = (name + "").split("("), ease = _easeMap[split[0]];
  return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase2(ease) {
  return function(p3) {
    return 1 - ease(1 - p3);
  };
}, _propagateYoyoEase = function _propagateYoyoEase2(timeline2, isYoyo) {
  var child = timeline2._first, ease;
  while (child) {
    if (child instanceof Timeline) {
      _propagateYoyoEase2(child, isYoyo);
    } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
      if (child.timeline) {
        _propagateYoyoEase2(child.timeline, isYoyo);
      } else {
        ease = child._ease;
        child._ease = child._yEase;
        child._yEase = ease;
        child._yoyo = isYoyo;
      }
    }
    child = child._next;
  }
}, _parseEase = function _parseEase2(ease, defaultEase) {
  return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase2(names, easeIn, easeOut, easeInOut) {
  if (easeOut === void 0) {
    easeOut = function easeOut2(p3) {
      return 1 - easeIn(1 - p3);
    };
  }
  if (easeInOut === void 0) {
    easeInOut = function easeInOut2(p3) {
      return p3 < 0.5 ? easeIn(p3 * 2) / 2 : 1 - easeIn((1 - p3) * 2) / 2;
    };
  }
  var ease = {
    easeIn,
    easeOut,
    easeInOut
  }, lowercaseName;
  _forEachName(names, function(name) {
    _easeMap[name] = _globals[name] = ease;
    _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
    for (var p3 in ease) {
      _easeMap[lowercaseName + (p3 === "easeIn" ? ".in" : p3 === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p3] = ease[p3];
    }
  });
  return ease;
}, _easeInOutFromOut = function _easeInOutFromOut2(easeOut) {
  return function(p3) {
    return p3 < 0.5 ? (1 - easeOut(1 - p3 * 2)) / 2 : 0.5 + easeOut((p3 - 0.5) * 2) / 2;
  };
}, _configElastic = function _configElastic2(type, amplitude, period) {
  var p1 = amplitude >= 1 ? amplitude : 1, p22 = (period || (type ? 0.3 : 0.45)) / (amplitude < 1 ? amplitude : 1), p3 = p22 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut2(p4) {
    return p4 === 1 ? 1 : p1 * Math.pow(2, -10 * p4) * _sin((p4 - p3) * p22) + 1;
  }, ease = type === "out" ? easeOut : type === "in" ? function(p4) {
    return 1 - easeOut(1 - p4);
  } : _easeInOutFromOut(easeOut);
  p22 = _2PI / p22;
  ease.config = function(amplitude2, period2) {
    return _configElastic2(type, amplitude2, period2);
  };
  return ease;
}, _configBack = function _configBack2(type, overshoot) {
  if (overshoot === void 0) {
    overshoot = 1.70158;
  }
  var easeOut = function easeOut2(p3) {
    return p3 ? --p3 * p3 * ((overshoot + 1) * p3 + overshoot) + 1 : 0;
  }, ease = type === "out" ? easeOut : type === "in" ? function(p3) {
    return 1 - easeOut(1 - p3);
  } : _easeInOutFromOut(easeOut);
  ease.config = function(overshoot2) {
    return _configBack2(type, overshoot2);
  };
  return ease;
};
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i2) {
  var power = i2 < 5 ? i2 + 1 : i2;
  _insertEase(name + ",Power" + (power - 1), i2 ? function(p3) {
    return Math.pow(p3, power);
  } : function(p3) {
    return p3;
  }, function(p3) {
    return 1 - Math.pow(1 - p3, power);
  }, function(p3) {
    return p3 < 0.5 ? Math.pow(p3 * 2, power) / 2 : 1 - Math.pow((1 - p3) * 2, power) / 2;
  });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n2, c2) {
  var n1 = 1 / c2, n22 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut2(p3) {
    return p3 < n1 ? n2 * p3 * p3 : p3 < n22 ? n2 * Math.pow(p3 - 1.5 / c2, 2) + 0.75 : p3 < n3 ? n2 * (p3 -= 2.25 / c2) * p3 + 0.9375 : n2 * Math.pow(p3 - 2.625 / c2, 2) + 0.984375;
  };
  _insertEase("Bounce", function(p3) {
    return 1 - easeOut(1 - p3);
  }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p3) {
  return Math.pow(2, 10 * (p3 - 1)) * p3 + p3 * p3 * p3 * p3 * p3 * p3 * (1 - p3);
});
_insertEase("Circ", function(p3) {
  return -(_sqrt(1 - p3 * p3) - 1);
});
_insertEase("Sine", function(p3) {
  return p3 === 1 ? 1 : -_cos(p3 * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config: function config(steps, immediateStart) {
    if (steps === void 0) {
      steps = 1;
    }
    var p1 = 1 / steps, p22 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max2 = 1 - _tinyNum;
    return function(p4) {
      return ((p22 * _clamp(0, max2, p4) | 0) + p3) * p1;
    };
  }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
  return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache2(target, harness) {
  this.id = _gsID++;
  target._gsap = this;
  this.target = target;
  this.harness = harness;
  this.get = harness ? harness.get : _getProperty;
  this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /* @__PURE__ */ (function() {
  function Animation2(vars) {
    this.vars = vars;
    this._delay = +vars.delay || 0;
    if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
      this._rDelay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }
    this._ts = 1;
    _setDuration(this, +vars.duration, 1, 1);
    this.data = vars.data;
    if (_context) {
      this._ctx = _context;
      _context.data.push(this);
    }
    _tickerActive || _ticker.wake();
  }
  var _proto = Animation2.prototype;
  _proto.delay = function delay(value) {
    if (value || value === 0) {
      this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
      this._delay = value;
      return this;
    }
    return this._delay;
  };
  _proto.duration = function duration(value) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
  };
  _proto.totalDuration = function totalDuration(value) {
    if (!arguments.length) {
      return this._tDur;
    }
    this._dirty = 0;
    return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
  };
  _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
    _wake();
    if (!arguments.length) {
      return this._tTime;
    }
    var parent = this._dp;
    if (parent && parent.smoothChildTiming && this._ts) {
      _alignPlayhead(this, _totalTime);
      !parent._dp || parent.parent || _postAddChecks(parent, this);
      while (parent && parent.parent) {
        if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
          parent.totalTime(parent._tTime, true);
        }
        parent = parent.parent;
      }
      if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
        _addToTimeline(this._dp, this, this._start - this._delay);
      }
    }
    if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
      this._ts || (this._pTime = _totalTime);
      _lazySafeRender(this, _totalTime, suppressEvents);
    }
    return this;
  };
  _proto.time = function time(value, suppressEvents) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time;
  };
  _proto.totalProgress = function totalProgress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  };
  _proto.progress = function progress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  };
  _proto.iteration = function iteration(value, suppressEvents) {
    var cycleDuration = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
  };
  _proto.timeScale = function timeScale(value, suppressEvents) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts;
    }
    if (this._rts === value) {
      return this;
    }
    var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime;
    this._rts = +value || 0;
    this._ts = this._ps || value === -_tinyNum ? 0 : this._rts;
    this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
    _setEnd(this);
    return _recacheAncestors(this);
  };
  _proto.paused = function paused(value) {
    if (!arguments.length) {
      return this._ps;
    }
    if (this._ps !== value) {
      this._ps = value;
      if (value) {
        this._pTime = this._tTime || Math.max(-this._delay, this.rawTime());
        this._ts = this._act = 0;
      } else {
        _wake();
        this._ts = this._rts;
        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum));
      }
    }
    return this;
  };
  _proto.startTime = function startTime(value) {
    if (arguments.length) {
      this._start = _roundPrecise(value);
      var parent = this.parent || this._dp;
      parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
      return this;
    }
    return this._start;
  };
  _proto.endTime = function endTime(includeRepeats) {
    return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  };
  _proto.rawTime = function rawTime(wrapRepeats) {
    var parent = this.parent || this._dp;
    return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
  };
  _proto.revert = function revert(config3) {
    if (config3 === void 0) {
      config3 = _revertConfig;
    }
    var prevIsReverting = _reverting$1;
    _reverting$1 = config3;
    if (_isRevertWorthy(this)) {
      this.timeline && this.timeline.revert(config3);
      this.totalTime(-0.01, config3.suppressEvents);
    }
    this.data !== "nested" && config3.kill !== false && this.kill();
    _reverting$1 = prevIsReverting;
    return this;
  };
  _proto.globalTime = function globalTime(rawTime) {
    var animation = this, time = arguments.length ? rawTime : animation.rawTime();
    while (animation) {
      time = animation._start + time / (Math.abs(animation._ts) || 1);
      animation = animation._dp;
    }
    return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time;
  };
  _proto.repeat = function repeat2(value) {
    if (arguments.length) {
      this._repeat = value === Infinity ? -2 : value;
      return _onUpdateTotalDuration(this);
    }
    return this._repeat === -2 ? Infinity : this._repeat;
  };
  _proto.repeatDelay = function repeatDelay(value) {
    if (arguments.length) {
      var time = this._time;
      this._rDelay = value;
      _onUpdateTotalDuration(this);
      return time ? this.time(time) : this;
    }
    return this._rDelay;
  };
  _proto.yoyo = function yoyo(value) {
    if (arguments.length) {
      this._yoyo = value;
      return this;
    }
    return this._yoyo;
  };
  _proto.seek = function seek(position, suppressEvents) {
    return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
  };
  _proto.restart = function restart(includeDelay, suppressEvents) {
    this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    this._dur || (this._zTime = -_tinyNum);
    return this;
  };
  _proto.play = function play(from, suppressEvents) {
    from != null && this.seek(from, suppressEvents);
    return this.reversed(false).paused(false);
  };
  _proto.reverse = function reverse(from, suppressEvents) {
    from != null && this.seek(from || this.totalDuration(), suppressEvents);
    return this.reversed(true).paused(false);
  };
  _proto.pause = function pause(atTime, suppressEvents) {
    atTime != null && this.seek(atTime, suppressEvents);
    return this.paused(true);
  };
  _proto.resume = function resume() {
    return this.paused(false);
  };
  _proto.reversed = function reversed(value) {
    if (arguments.length) {
      !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0));
      return this;
    }
    return this._rts < 0;
  };
  _proto.invalidate = function invalidate2() {
    this._initted = this._act = 0;
    this._zTime = -_tinyNum;
    return this;
  };
  _proto.isActive = function isActive() {
    var parent = this.parent || this._dp, start2 = this._start, rawTime;
    return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start2 && rawTime < this.endTime(true) - _tinyNum);
  };
  _proto.eventCallback = function eventCallback(type, callback, params) {
    var vars = this.vars;
    if (arguments.length > 1) {
      if (!callback) {
        delete vars[type];
      } else {
        vars[type] = callback;
        params && (vars[type + "Params"] = params);
        type === "onUpdate" && (this._onUpdate = callback);
      }
      return this;
    }
    return vars[type];
  };
  _proto.then = function then(onFulfilled) {
    var self2 = this, prevProm = self2._prom;
    return new Promise(function(resolve2) {
      var f2 = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve2() {
        var _then = self2.then;
        self2.then = null;
        prevProm && prevProm();
        _isFunction(f2) && (f2 = f2(self2)) && (f2.then || f2 === self2) && (self2.then = _then);
        resolve2(f2);
        self2.then = _then;
      };
      if (self2._initted && self2.totalProgress() === 1 && self2._ts >= 0 || !self2._tTime && self2._ts < 0) {
        _resolve();
      } else {
        self2._prom = _resolve;
      }
    });
  };
  _proto.kill = function kill() {
    _interrupt(this);
  };
  return Animation2;
})();
_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1
});
var Timeline = /* @__PURE__ */ (function(_Animation) {
  _inheritsLoose(Timeline2, _Animation);
  function Timeline2(vars, position) {
    var _this;
    if (vars === void 0) {
      vars = {};
    }
    _this = _Animation.call(this, vars) || this;
    _this.labels = {};
    _this.smoothChildTiming = !!vars.smoothChildTiming;
    _this.autoRemoveChildren = !!vars.autoRemoveChildren;
    _this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
    vars.reversed && _this.reverse();
    vars.paused && _this.paused(true);
    vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
    return _this;
  }
  var _proto2 = Timeline2.prototype;
  _proto2.to = function to2(targets, vars, position) {
    _createTweenType(0, arguments, this);
    return this;
  };
  _proto2.from = function from(targets, vars, position) {
    _createTweenType(1, arguments, this);
    return this;
  };
  _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
    _createTweenType(2, arguments, this);
    return this;
  };
  _proto2.set = function set(targets, vars, position) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  };
  _proto2.call = function call2(callback, params, position) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  };
  _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.duration = duration;
    vars.stagger = vars.stagger || stagger;
    vars.onComplete = onCompleteAll;
    vars.onCompleteParams = onCompleteAllParams;
    vars.parent = this;
    new Tween(targets, vars, _parsePosition(this, position));
    return this;
  };
  _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.runBackwards = 1;
    _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
    return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  };
  _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
    toVars.startAt = fromVars;
    _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
    return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  };
  _proto2.render = function render3(totalTime, suppressEvents, force) {
    var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
    this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) {
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }
      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;
      if (crossingStart) {
        dur || (prevTime = this._zTime);
        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }
      if (this._repeat) {
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;
        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }
        time = _roundPrecise(tTime % cycleDuration);
        if (tTime === tDur) {
          iteration = this._repeat;
          time = dur;
        } else {
          prevIteration = _roundPrecise(tTime / cycleDuration);
          iteration = ~~prevIteration;
          if (iteration && iteration === prevIteration) {
            time = dur;
            iteration--;
          }
          time > dur && (time = dur);
        }
        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration);
        if (yoyo && iteration & 1) {
          time = dur - time;
          isYoyo = 1;
        }
        if (iteration !== prevIteration && !this._lock) {
          var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : tTime % dur ? dur : tTime;
          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime;
          !suppressEvents && this.parent && _callback(this, "onRepeat");
          if (this.vars.repeatRefresh && !isYoyo) {
            this.invalidate()._lock = 1;
            prevIteration = iteration;
          }
          if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
            return this;
          }
          dur = this._dur;
          tDur = this._tDur;
          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -1e-4;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }
          this._lock = 0;
          if (!this._ts && !prevPaused) {
            return this;
          }
          _propagateYoyoEase(this, isYoyo);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }
      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale;
      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0;
      }
      if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
        _callback(this, "onStart");
        if (this._tTime !== tTime) {
          return this;
        }
      }
      if (time >= prevTime && totalTime >= 0) {
        child = this._first;
        while (child) {
          next = child._next;
          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              return this.render(totalTime, suppressEvents, force);
            }
            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
            if (time !== this._time || !this._ts && !prevPaused) {
              pauseTween = 0;
              next && (tTime += this._zTime = -_tinyNum);
              break;
            }
          }
          child = next;
        }
      } else {
        child = this._last;
        var adjustedTime = totalTime < 0 ? totalTime : time;
        while (child) {
          next = child._prev;
          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              return this.render(totalTime, suppressEvents, force);
            }
            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting$1 && _isRevertWorthy(child));
            if (time !== this._time || !this._ts && !prevPaused) {
              pauseTween = 0;
              next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum);
              break;
            }
          }
          child = next;
        }
      }
      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
        if (this._ts) {
          this._start = prevStart;
          _setEnd(this);
          return this.render(totalTime, suppressEvents, force);
        }
      }
      this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
      if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
        if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
          if (!this._lock) {
            (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);
            if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
              _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
              this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
            }
          }
        }
      }
    }
    return this;
  };
  _proto2.add = function add(child, position) {
    var _this2 = this;
    _isNumber(position) || (position = _parsePosition(this, position, child));
    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(function(obj) {
          return _this2.add(obj, position);
        });
        return this;
      }
      if (_isString(child)) {
        return this.addLabel(child, position);
      }
      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }
    return this !== child ? _addToTimeline(this, child, position) : this;
  };
  _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
    if (nested === void 0) {
      nested = true;
    }
    if (tweens === void 0) {
      tweens = true;
    }
    if (timelines === void 0) {
      timelines = true;
    }
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = -_bigNum$1;
    }
    var a5 = [], child = this._first;
    while (child) {
      if (child._start >= ignoreBeforeTime) {
        if (child instanceof Tween) {
          tweens && a5.push(child);
        } else {
          timelines && a5.push(child);
          nested && a5.push.apply(a5, child.getChildren(true, tweens, timelines));
        }
      }
      child = child._next;
    }
    return a5;
  };
  _proto2.getById = function getById2(id) {
    var animations = this.getChildren(1, 1, 1), i2 = animations.length;
    while (i2--) {
      if (animations[i2].vars.id === id) {
        return animations[i2];
      }
    }
  };
  _proto2.remove = function remove(child) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }
    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }
    child.parent === this && _removeLinkedListItem(this, child);
    if (child === this._recent) {
      this._recent = this._last;
    }
    return _uncache(this);
  };
  _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
    if (!arguments.length) {
      return this._tTime;
    }
    this._forcing = 1;
    if (!this._dp && this._ts) {
      this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
    }
    _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
    this._forcing = 0;
    return this;
  };
  _proto2.addLabel = function addLabel(label, position) {
    this.labels[label] = _parsePosition(this, position);
    return this;
  };
  _proto2.removeLabel = function removeLabel(label) {
    delete this.labels[label];
    return this;
  };
  _proto2.addPause = function addPause(position, callback, params) {
    var t2 = Tween.delayedCall(0, callback || _emptyFunc, params);
    t2.data = "isPause";
    this._hasPause = 1;
    return _addToTimeline(this, t2, _parsePosition(this, position));
  };
  _proto2.removePause = function removePause(position) {
    var child = this._first;
    position = _parsePosition(this, position);
    while (child) {
      if (child._start === position && child.data === "isPause") {
        _removeFromParent(child);
      }
      child = child._next;
    }
  };
  _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    var tweens = this.getTweensOf(targets, onlyActive), i2 = tweens.length;
    while (i2--) {
      _overwritingTween !== tweens[i2] && tweens[i2].kill(targets, props);
    }
    return this;
  };
  _proto2.getTweensOf = function getTweensOf2(targets, onlyActive) {
    var a5 = [], parsedTargets = toArray$1(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), children;
    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
          a5.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a5.push.apply(a5, children);
      }
      child = child._next;
    }
    return a5;
  };
  _proto2.tweenTo = function tweenTo(position, vars) {
    vars = vars || {};
    var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
      ease: vars.ease || "none",
      lazy: false,
      immediateRender: false,
      time: endTime,
      overwrite: "auto",
      duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
      onStart: function onStart() {
        tl.pause();
        if (!initted) {
          var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
          tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
          initted = 1;
        }
        _onStart && _onStart.apply(tween, onStartParams || []);
      }
    }, vars));
    return immediateRender ? tween.render(0) : tween;
  };
  _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
    return this.tweenTo(toPosition, _setDefaults({
      startAt: {
        time: _parsePosition(this, fromPosition)
      }
    }, vars));
  };
  _proto2.recent = function recent() {
    return this._recent;
  };
  _proto2.nextLabel = function nextLabel(afterTime) {
    if (afterTime === void 0) {
      afterTime = this._time;
    }
    return _getLabelInDirection(this, _parsePosition(this, afterTime));
  };
  _proto2.previousLabel = function previousLabel(beforeTime) {
    if (beforeTime === void 0) {
      beforeTime = this._time;
    }
    return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  };
  _proto2.currentLabel = function currentLabel(value) {
    return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  };
  _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = 0;
    }
    var child = this._first, labels = this.labels, p3;
    amount = _roundPrecise(amount);
    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }
      child = child._next;
    }
    if (adjustLabels) {
      for (p3 in labels) {
        if (labels[p3] >= ignoreBeforeTime) {
          labels[p3] += amount;
        }
      }
    }
    return _uncache(this);
  };
  _proto2.invalidate = function invalidate2(soft) {
    var child = this._first;
    this._lock = 0;
    while (child) {
      child.invalidate(soft);
      child = child._next;
    }
    return _Animation.prototype.invalidate.call(this, soft);
  };
  _proto2.clear = function clear2(includeLabels) {
    if (includeLabels === void 0) {
      includeLabels = true;
    }
    var child = this._first, next;
    while (child) {
      next = child._next;
      this.remove(child);
      child = next;
    }
    this._dp && (this._time = this._tTime = this._pTime = 0);
    includeLabels && (this.labels = {});
    return _uncache(this);
  };
  _proto2.totalDuration = function totalDuration(value) {
    var max2 = 0, self2 = this, child = self2._last, prevStart = _bigNum$1, prev, start2, parent;
    if (arguments.length) {
      return self2.timeScale((self2._repeat < 0 ? self2.duration() : self2.totalDuration()) / (self2.reversed() ? -value : value));
    }
    if (self2._dirty) {
      parent = self2.parent;
      while (child) {
        prev = child._prev;
        child._dirty && child.totalDuration();
        start2 = child._start;
        if (start2 > prevStart && self2._sort && child._ts && !self2._lock) {
          self2._lock = 1;
          _addToTimeline(self2, child, start2 - child._delay, 1)._lock = 0;
        } else {
          prevStart = start2;
        }
        if (start2 < 0 && child._ts) {
          max2 -= start2;
          if (!parent && !self2._dp || parent && parent.smoothChildTiming) {
            self2._start += _roundPrecise(start2 / self2._ts);
            self2._time -= start2;
            self2._tTime -= start2;
          }
          self2.shiftChildren(-start2, false, -Infinity);
          prevStart = 0;
        }
        child._end > max2 && child._ts && (max2 = child._end);
        child = prev;
      }
      _setDuration(self2, self2 === _globalTimeline && self2._time > max2 ? self2._time : max2, 1, 1);
      self2._dirty = 0;
    }
    return self2._tDur;
  };
  Timeline2.updateRoot = function updateRoot(time) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
      _lastRenderedFrame = _ticker.frame;
    }
    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      var child = _globalTimeline._first;
      if (!child || !child._ts) {
        if (_config.autoSleep && _ticker._listeners.length < 2) {
          while (child && !child._ts) {
            child = child._next;
          }
          child || _ticker.sleep();
        }
      }
    }
  };
  return Timeline2;
})(Animation);
_setDefaults(Timeline.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween2(target, prop, start2, end, setter, stringFilter, funcParam) {
  var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a5;
  pt.b = start2;
  pt.e = end;
  start2 += "";
  end += "";
  if (hasRandom = ~end.indexOf("random(")) {
    end = _replaceRandom(end);
  }
  if (stringFilter) {
    a5 = [start2, end];
    stringFilter(a5, target, prop);
    start2 = a5[0];
    end = a5[1];
  }
  startNums = start2.match(_complexStringNumExp) || [];
  while (result = _complexStringNumExp.exec(end)) {
    endNum = result[0];
    chunk = end.substring(index, result.index);
    if (color) {
      color = (color + 1) % 5;
    } else if (chunk.substr(-5) === "rgba(") {
      color = 1;
    }
    if (endNum !== startNums[matchIndex++]) {
      startNum = parseFloat(startNums[matchIndex - 1]) || 0;
      pt._pt = {
        _next: pt._pt,
        p: chunk || matchIndex === 1 ? chunk : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: startNum,
        c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
        m: color && color < 4 ? Math.round : 0
      };
      index = _complexStringNumExp.lastIndex;
    }
  }
  pt.c = index < end.length ? end.substring(index, end.length) : "";
  pt.fp = funcParam;
  if (_relExp.test(end) || hasRandom) {
    pt.e = 0;
  }
  this._pt = pt;
  return pt;
}, _addPropTween = function _addPropTween2(target, prop, start2, end, index, targets, modifier, stringFilter, funcParam, optional) {
  _isFunction(end) && (end = end(index || 0, target, targets));
  var currentValue = target[prop], parsedStart = start2 !== "get" ? start2 : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
  if (_isString(end)) {
    if (~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }
    if (end.charAt(1) === "=") {
      pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
      if (pt || pt === 0) {
        end = pt;
      }
    }
  }
  if (!optional || parsedStart !== end || _forceAllPropTweens) {
    if (!isNaN(parsedStart * end) && end !== "") {
      pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
      funcParam && (pt.fp = funcParam);
      modifier && pt.modifier(modifier, this, target);
      return this._pt = pt;
    }
    !currentValue && !(prop in target) && _missingPlugin(prop, end);
    return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
  }
}, _processVars = function _processVars2(vars, index, target, targets, tween) {
  _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
  if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
    return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
  }
  var copy = {}, p3;
  for (p3 in vars) {
    copy[p3] = _parseFuncOrString(vars[p3], tween, index, target, targets);
  }
  return copy;
}, _checkPlugin = function _checkPlugin2(property, vars, tween, index, target, targets) {
  var plugin, pt, ptLookup, i2;
  if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
    tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
    if (tween !== _quickTween) {
      ptLookup = tween._ptLookup[tween._targets.indexOf(target)];
      i2 = plugin._props.length;
      while (i2--) {
        ptLookup[plugin._props[i2]] = pt;
      }
    }
  }
  return plugin;
}, _overwritingTween, _forceAllPropTweens, _initTween = function _initTween2(tween, time, tTime) {
  var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i2, p3, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
  tl && (!keyframes || !ease) && (ease = "none");
  tween._ease = _parseEase(ease, _defaults.ease);
  tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
  if (yoyoEase && tween._yoyo && !tween._repeat) {
    yoyoEase = tween._yEase;
    tween._yEase = tween._ease;
    tween._ease = yoyoEase;
  }
  tween._from = !tl && !!vars.runBackwards;
  if (!tl || keyframes && !vars.stagger) {
    harness = targets[0] ? _getCache(targets[0]).harness : 0;
    harnessVars = harness && vars[harness.prop];
    cleanVars = _copyExcluding(vars, _reservedProps);
    if (prevStartAt) {
      prevStartAt._zTime < 0 && prevStartAt.progress(1);
      time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig);
      prevStartAt._lazy = 0;
    }
    if (startAt) {
      _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
        data: "isStart",
        overwrite: false,
        parent,
        immediateRender: true,
        lazy: !prevStartAt && _isNotFalse(lazy),
        startAt: null,
        delay: 0,
        onUpdate: onUpdate && function() {
          return _callback(tween, "onUpdate");
        },
        stagger: 0
      }, startAt)));
      tween._startAt._dp = 0;
      tween._startAt._sat = tween;
      time < 0 && (_reverting$1 || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill);
      if (immediateRender) {
        if (dur && time <= 0 && tTime <= 0) {
          time && (tween._zTime = time);
          return;
        }
      }
    } else if (runBackwards && dur) {
      if (!prevStartAt) {
        time && (immediateRender = false);
        p3 = _setDefaults({
          overwrite: false,
          data: "isFromStart",
          //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
          lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
          immediateRender,
          //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
          stagger: 0,
          parent
          //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
        }, cleanVars);
        harnessVars && (p3[harness.prop] = harnessVars);
        _removeFromParent(tween._startAt = Tween.set(targets, p3));
        tween._startAt._dp = 0;
        tween._startAt._sat = tween;
        time < 0 && (_reverting$1 ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
        tween._zTime = time;
        if (!immediateRender) {
          _initTween2(tween._startAt, _tinyNum, _tinyNum);
        } else if (!time) {
          return;
        }
      }
    }
    tween._pt = tween._ptCache = 0;
    lazy = dur && _isNotFalse(lazy) || lazy && !dur;
    for (i2 = 0; i2 < targets.length; i2++) {
      target = targets[i2];
      gsData = target._gsap || _harness(targets)[i2]._gsap;
      tween._ptLookup[i2] = ptLookup = {};
      _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender();
      index = fullTargets === targets ? i2 : fullTargets.indexOf(target);
      if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
        plugin._props.forEach(function(name) {
          ptLookup[name] = pt;
        });
        plugin.priority && (hasPriority = 1);
      }
      if (!harness || harnessVars) {
        for (p3 in cleanVars) {
          if (_plugins[p3] && (plugin = _checkPlugin(p3, cleanVars, tween, index, target, fullTargets))) {
            plugin.priority && (hasPriority = 1);
          } else {
            ptLookup[p3] = pt = _addPropTween.call(tween, target, p3, "get", cleanVars[p3], index, fullTargets, 0, vars.stringFilter);
          }
        }
      }
      tween._op && tween._op[i2] && tween.kill(target, tween._op[i2]);
      if (autoOverwrite && tween._pt) {
        _overwritingTween = tween;
        _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time));
        overwritten = !tween.parent;
        _overwritingTween = 0;
      }
      tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
    }
    hasPriority && _sortPropTweensByPriority(tween);
    tween._onInit && tween._onInit(tween);
  }
  tween._onUpdate = onUpdate;
  tween._initted = (!tween._op || tween._pt) && !overwritten;
  keyframes && time <= 0 && tl.render(_bigNum$1, true, true);
}, _updatePropTweens = function _updatePropTweens2(tween, property, value, start2, startIsRelative, ratio, time, skipRecursion) {
  var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i2;
  if (!ptCache) {
    ptCache = tween._ptCache[property] = [];
    lookup = tween._ptLookup;
    i2 = tween._targets.length;
    while (i2--) {
      pt = lookup[i2][property];
      if (pt && pt.d && pt.d._pt) {
        pt = pt.d._pt;
        while (pt && pt.p !== property && pt.fp !== property) {
          pt = pt._next;
        }
      }
      if (!pt) {
        _forceAllPropTweens = 1;
        tween.vars[property] = "+=0";
        _initTween(tween, time);
        _forceAllPropTweens = 0;
        return skipRecursion ? _warn(property + " not eligible for reset") : 1;
      }
      ptCache.push(pt);
    }
  }
  i2 = ptCache.length;
  while (i2--) {
    rootPT = ptCache[i2];
    pt = rootPT._pt || rootPT;
    pt.s = (start2 || start2 === 0) && !startIsRelative ? start2 : pt.s + (start2 || 0) + ratio * pt.c;
    pt.c = value - pt.s;
    rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e));
    rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b));
  }
}, _addAliasesToVars = function _addAliasesToVars2(targets, vars) {
  var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p3, i2, aliases;
  if (!propertyAliases) {
    return vars;
  }
  copy = _merge({}, vars);
  for (p3 in propertyAliases) {
    if (p3 in copy) {
      aliases = propertyAliases[p3].split(",");
      i2 = aliases.length;
      while (i2--) {
        copy[aliases[i2]] = copy[p3];
      }
    }
  }
  return copy;
}, _parseKeyframe = function _parseKeyframe2(prop, obj, allProps, easeEach) {
  var ease = obj.ease || easeEach || "power1.inOut", p3, a5;
  if (_isArray(obj)) {
    a5 = allProps[prop] || (allProps[prop] = []);
    obj.forEach(function(value, i2) {
      return a5.push({
        t: i2 / (obj.length - 1) * 100,
        v: value,
        e: ease
      });
    });
  } else {
    for (p3 in obj) {
      a5 = allProps[p3] || (allProps[p3] = []);
      p3 === "ease" || a5.push({
        t: parseFloat(prop),
        v: obj[p3],
        e: ease
      });
    }
  }
}, _parseFuncOrString = function _parseFuncOrString2(value, tween, i2, target, targets) {
  return _isFunction(value) ? value.call(tween, i2, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
  return _staggerPropsToSkip[name] = 1;
});
var Tween = /* @__PURE__ */ (function(_Animation2) {
  _inheritsLoose(Tween2, _Animation2);
  function Tween2(targets, vars, position, skipInherit) {
    var _this3;
    if (typeof vars === "number") {
      position.duration = vars;
      vars = position;
      position = null;
    }
    _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
    var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults2 = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray$1(targets), tl, i2, copy, l2, p3, curTarget, staggerFunc, staggerVarsToMerge;
    _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
    _this3._ptLookup = [];
    _this3._overwrite = overwrite;
    if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
      vars = _this3.vars;
      tl = _this3.timeline = new Timeline({
        data: "nested",
        defaults: defaults2 || {},
        targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
      });
      tl.kill();
      tl.parent = tl._dp = _assertThisInitialized(_this3);
      tl._start = 0;
      if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
        l2 = parsedTargets.length;
        staggerFunc = stagger && distribute(stagger);
        if (_isObject(stagger)) {
          for (p3 in stagger) {
            if (~_staggerTweenProps.indexOf(p3)) {
              staggerVarsToMerge || (staggerVarsToMerge = {});
              staggerVarsToMerge[p3] = stagger[p3];
            }
          }
        }
        for (i2 = 0; i2 < l2; i2++) {
          copy = _copyExcluding(vars, _staggerPropsToSkip);
          copy.stagger = 0;
          yoyoEase && (copy.yoyoEase = yoyoEase);
          staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
          curTarget = parsedTargets[i2];
          copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i2, curTarget, parsedTargets);
          copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i2, curTarget, parsedTargets) || 0) - _this3._delay;
          if (!stagger && l2 === 1 && copy.delay) {
            _this3._delay = delay = copy.delay;
            _this3._start += delay;
            copy.delay = 0;
          }
          tl.to(curTarget, copy, staggerFunc ? staggerFunc(i2, curTarget, parsedTargets) : 0);
          tl._ease = _easeMap.none;
        }
        tl.duration() ? duration = delay = 0 : _this3.timeline = 0;
      } else if (keyframes) {
        _inheritDefaults(_setDefaults(tl.vars.defaults, {
          ease: "none"
        }));
        tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
        var time = 0, a5, kf, v3;
        if (_isArray(keyframes)) {
          keyframes.forEach(function(frame) {
            return tl.to(parsedTargets, frame, ">");
          });
          tl.duration();
        } else {
          copy = {};
          for (p3 in keyframes) {
            p3 === "ease" || p3 === "easeEach" || _parseKeyframe(p3, keyframes[p3], copy, keyframes.easeEach);
          }
          for (p3 in copy) {
            a5 = copy[p3].sort(function(a6, b6) {
              return a6.t - b6.t;
            });
            time = 0;
            for (i2 = 0; i2 < a5.length; i2++) {
              kf = a5[i2];
              v3 = {
                ease: kf.e,
                duration: (kf.t - (i2 ? a5[i2 - 1].t : 0)) / 100 * duration
              };
              v3[p3] = kf.v;
              tl.to(parsedTargets, v3, time);
              time += v3.duration;
            }
          }
          tl.duration() < duration && tl.to({}, {
            duration: duration - tl.duration()
          });
        }
      }
      duration || _this3.duration(duration = tl.duration());
    } else {
      _this3.timeline = 0;
    }
    if (overwrite === true && !_suppressOverwrites) {
      _overwritingTween = _assertThisInitialized(_this3);
      _globalTimeline.killTweensOf(parsedTargets);
      _overwritingTween = 0;
    }
    _addToTimeline(parent, _assertThisInitialized(_this3), position);
    vars.reversed && _this3.reverse();
    vars.paused && _this3.paused(true);
    if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
      _this3._tTime = -_tinyNum;
      _this3.render(Math.max(0, -delay) || 0);
    }
    scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
    return _this3;
  }
  var _proto3 = Tween2.prototype;
  _proto3.render = function render3(totalTime, suppressEvents, force) {
    var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline2, yoyoEase;
    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
      time = tTime;
      timeline2 = this.timeline;
      if (this._repeat) {
        cycleDuration = dur + this._rDelay;
        if (this._repeat < -1 && isNegative) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }
        time = _roundPrecise(tTime % cycleDuration);
        if (tTime === tDur) {
          iteration = this._repeat;
          time = dur;
        } else {
          prevIteration = _roundPrecise(tTime / cycleDuration);
          iteration = ~~prevIteration;
          if (iteration && iteration === prevIteration) {
            time = dur;
            iteration--;
          } else if (time > dur) {
            time = dur;
          }
        }
        isYoyo = this._yoyo && iteration & 1;
        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }
        prevIteration = _animationCycle(this._tTime, cycleDuration);
        if (time === prevTime && !force && this._initted && iteration === prevIteration) {
          this._tTime = tTime;
          return this;
        }
        if (iteration !== prevIteration) {
          timeline2 && this._yEase && _propagateYoyoEase(timeline2, isYoyo);
          if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
            this._lock = force = 1;
            this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }
      if (!this._initted) {
        if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
          this._tTime = 0;
          return this;
        }
        if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) {
          return this;
        }
        if (dur !== this._dur) {
          return this.render(totalTime, suppressEvents, force);
        }
      }
      this._tTime = tTime;
      this._time = time;
      if (!this._act && this._ts) {
        this._act = 1;
        this._lazy = 0;
      }
      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }
      if (!prevTime && tTime && !suppressEvents && !prevIteration) {
        _callback(this, "onStart");
        if (this._tTime !== tTime) {
          return this;
        }
      }
      pt = this._pt;
      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }
      timeline2 && timeline2.render(totalTime < 0 ? totalTime : timeline2._dur * timeline2._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
      if (this._onUpdate && !suppressEvents) {
        isNegative && _rewindStartAt(this, totalTime, suppressEvents, force);
        _callback(this, "onUpdate");
      }
      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
        (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);
        if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
          _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }
    return this;
  };
  _proto3.targets = function targets() {
    return this._targets;
  };
  _proto3.invalidate = function invalidate2(soft) {
    (!soft || !this.vars.runBackwards) && (this._startAt = 0);
    this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
    this._ptLookup = [];
    this.timeline && this.timeline.invalidate(soft);
    return _Animation2.prototype.invalidate.call(this, soft);
  };
  _proto3.resetTo = function resetTo(property, value, start2, startIsRelative, skipRecursion) {
    _tickerActive || _ticker.wake();
    this._ts || this.play();
    var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
    this._initted || _initTween(this, time);
    ratio = this._ease(time / this._dur);
    if (_updatePropTweens(this, property, value, start2, startIsRelative, ratio, time, skipRecursion)) {
      return this.resetTo(property, value, start2, startIsRelative, 1);
    }
    _alignPlayhead(this, 0);
    this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
    return this.render(0);
  };
  _proto3.kill = function kill(targets, vars) {
    if (vars === void 0) {
      vars = "all";
    }
    if (!targets && (!vars || vars === "all")) {
      this._lazy = this._pt = 0;
      this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting$1);
      return this;
    }
    if (this.timeline) {
      var tDur = this.timeline.totalDuration();
      this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this);
      this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1);
      return this;
    }
    var parsedTargets = this._targets, killingTargets = targets ? toArray$1(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p3, pt, i2;
    if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
      vars === "all" && (this._pt = 0);
      return _interrupt(this);
    }
    overwrittenProps = this._op = this._op || [];
    if (vars !== "all") {
      if (_isString(vars)) {
        p3 = {};
        _forEachName(vars, function(name) {
          return p3[name] = 1;
        });
        vars = p3;
      }
      vars = _addAliasesToVars(parsedTargets, vars);
    }
    i2 = parsedTargets.length;
    while (i2--) {
      if (~killingTargets.indexOf(parsedTargets[i2])) {
        curLookup = propTweenLookup[i2];
        if (vars === "all") {
          overwrittenProps[i2] = vars;
          props = curLookup;
          curOverwriteProps = {};
        } else {
          curOverwriteProps = overwrittenProps[i2] = overwrittenProps[i2] || {};
          props = vars;
        }
        for (p3 in props) {
          pt = curLookup && curLookup[p3];
          if (pt) {
            if (!("kill" in pt.d) || pt.d.kill(p3) === true) {
              _removeLinkedListItem(this, pt, "_pt");
            }
            delete curLookup[p3];
          }
          if (curOverwriteProps !== "all") {
            curOverwriteProps[p3] = 1;
          }
        }
      }
    }
    this._initted && !this._pt && firstPT && _interrupt(this);
    return this;
  };
  Tween2.to = function to2(targets, vars) {
    return new Tween2(targets, vars, arguments[2]);
  };
  Tween2.from = function from(targets, vars) {
    return _createTweenType(1, arguments);
  };
  Tween2.delayedCall = function delayedCall(delay, callback, params, scope) {
    return new Tween2(callback, 0, {
      immediateRender: false,
      lazy: false,
      overwrite: false,
      delay,
      onComplete: callback,
      onReverseComplete: callback,
      onCompleteParams: params,
      onReverseCompleteParams: params,
      callbackScope: scope
    });
  };
  Tween2.fromTo = function fromTo(targets, fromVars, toVars) {
    return _createTweenType(2, arguments);
  };
  Tween2.set = function set(targets, vars) {
    vars.duration = 0;
    vars.repeatDelay || (vars.repeat = 0);
    return new Tween2(targets, vars);
  };
  Tween2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    return _globalTimeline.killTweensOf(targets, props, onlyActive);
  };
  return Tween2;
})(Animation);
_setDefaults(Tween.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
  Tween[name] = function() {
    var tl = new Timeline(), params = _slice.call(arguments, 0);
    params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
    return tl[name].apply(tl, params);
  };
});
var _setterPlain = function _setterPlain2(target, property, value) {
  return target[property] = value;
}, _setterFunc = function _setterFunc2(target, property, value) {
  return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam2(target, property, value, data) {
  return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute2(target, property, value) {
  return target.setAttribute(property, value);
}, _getSetter = function _getSetter2(target, property) {
  return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain2(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1e6) / 1e6, data);
}, _renderBoolean = function _renderBoolean2(ratio, data) {
  return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString2(ratio, data) {
  var pt = data._pt, s2 = "";
  if (!ratio && data.b) {
    s2 = data.b;
  } else if (ratio === 1 && data.e) {
    s2 = data.e;
  } else {
    while (pt) {
      s2 = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 1e4) / 1e4) + s2;
      pt = pt._next;
    }
    s2 += data.c;
  }
  data.set(data.t, data.p, s2, data);
}, _renderPropTweens = function _renderPropTweens2(ratio, data) {
  var pt = data._pt;
  while (pt) {
    pt.r(ratio, pt.d);
    pt = pt._next;
  }
}, _addPluginModifier = function _addPluginModifier2(modifier, tween, target, property) {
  var pt = this._pt, next;
  while (pt) {
    next = pt._next;
    pt.p === property && pt.modifier(modifier, tween, target);
    pt = next;
  }
}, _killPropTweensOf = function _killPropTweensOf2(property) {
  var pt = this._pt, hasNonDependentRemaining, next;
  while (pt) {
    next = pt._next;
    if (pt.p === property && !pt.op || pt.op === property) {
      _removeLinkedListItem(this, pt, "_pt");
    } else if (!pt.dep) {
      hasNonDependentRemaining = 1;
    }
    pt = next;
  }
  return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier2(target, property, value, data) {
  data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority2(parent) {
  var pt = parent._pt, next, pt2, first2, last;
  while (pt) {
    next = pt._next;
    pt2 = first2;
    while (pt2 && pt2.pr > pt.pr) {
      pt2 = pt2._next;
    }
    if (pt._prev = pt2 ? pt2._prev : last) {
      pt._prev._next = pt;
    } else {
      first2 = pt;
    }
    if (pt._next = pt2) {
      pt2._prev = pt;
    } else {
      last = pt;
    }
    pt = next;
  }
  parent._pt = first2;
};
var PropTween = /* @__PURE__ */ (function() {
  function PropTween2(next, target, prop, start2, change, renderer, data, setter, priority2) {
    this.t = target;
    this.s = start2;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority2 || 0;
    this._next = next;
    if (next) {
      next._prev = this;
    }
  }
  var _proto4 = PropTween2.prototype;
  _proto4.modifier = function modifier(func, tween, target) {
    this.mSet = this.mSet || this.set;
    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target;
    this.tween = tween;
  };
  return PropTween2;
})();
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
  return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: "root",
  smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch2(type) {
  return (_listeners[type] || _emptyArray).map(function(f2) {
    return f2();
  });
}, _onMediaChange = function _onMediaChange2() {
  var time = Date.now(), matches = [];
  if (time - _lastMediaTime > 2) {
    _dispatch("matchMediaInit");
    _media.forEach(function(c2) {
      var queries = c2.queries, conditions = c2.conditions, match, p3, anyMatch, toggled;
      for (p3 in queries) {
        match = _win$1.matchMedia(queries[p3]).matches;
        match && (anyMatch = 1);
        if (match !== conditions[p3]) {
          conditions[p3] = match;
          toggled = 1;
        }
      }
      if (toggled) {
        c2.revert();
        anyMatch && matches.push(c2);
      }
    });
    _dispatch("matchMediaRevert");
    matches.forEach(function(c2) {
      return c2.onMatch(c2, function(func) {
        return c2.add(null, func);
      });
    });
    _lastMediaTime = time;
    _dispatch("matchMedia");
  }
};
var Context$1 = /* @__PURE__ */ (function() {
  function Context2(func, scope) {
    this.selector = scope && selector(scope);
    this.data = [];
    this._r = [];
    this.isReverted = false;
    this.id = _contextID++;
    func && this.add(func);
  }
  var _proto5 = Context2.prototype;
  _proto5.add = function add(name, func, scope) {
    if (_isFunction(name)) {
      scope = func;
      func = name;
      name = _isFunction;
    }
    var self2 = this, f2 = function f3() {
      var prev = _context, prevSelector = self2.selector, result;
      prev && prev !== self2 && prev.data.push(self2);
      scope && (self2.selector = selector(scope));
      _context = self2;
      result = func.apply(self2, arguments);
      _isFunction(result) && self2._r.push(result);
      _context = prev;
      self2.selector = prevSelector;
      self2.isReverted = false;
      return result;
    };
    self2.last = f2;
    return name === _isFunction ? f2(self2, function(func2) {
      return self2.add(null, func2);
    }) : name ? self2[name] = f2 : f2;
  };
  _proto5.ignore = function ignore(func) {
    var prev = _context;
    _context = null;
    func(this);
    _context = prev;
  };
  _proto5.getTweens = function getTweens() {
    var a5 = [];
    this.data.forEach(function(e2) {
      return e2 instanceof Context2 ? a5.push.apply(a5, e2.getTweens()) : e2 instanceof Tween && !(e2.parent && e2.parent.data === "nested") && a5.push(e2);
    });
    return a5;
  };
  _proto5.clear = function clear2() {
    this._r.length = this.data.length = 0;
  };
  _proto5.kill = function kill(revert, matchMedia2) {
    var _this4 = this;
    if (revert) {
      (function() {
        var tweens = _this4.getTweens(), i3 = _this4.data.length, t2;
        while (i3--) {
          t2 = _this4.data[i3];
          if (t2.data === "isFlip") {
            t2.revert();
            t2.getChildren(true, true, false).forEach(function(tween) {
              return tweens.splice(tweens.indexOf(tween), 1);
            });
          }
        }
        tweens.map(function(t3) {
          return {
            g: t3._dur || t3._delay || t3._sat && !t3._sat.vars.immediateRender ? t3.globalTime(0) : -Infinity,
            t: t3
          };
        }).sort(function(a5, b6) {
          return b6.g - a5.g || -Infinity;
        }).forEach(function(o2) {
          return o2.t.revert(revert);
        });
        i3 = _this4.data.length;
        while (i3--) {
          t2 = _this4.data[i3];
          if (t2 instanceof Timeline) {
            if (t2.data !== "nested") {
              t2.scrollTrigger && t2.scrollTrigger.revert();
              t2.kill();
            }
          } else {
            !(t2 instanceof Tween) && t2.revert && t2.revert(revert);
          }
        }
        _this4._r.forEach(function(f2) {
          return f2(revert, _this4);
        });
        _this4.isReverted = true;
      })();
    } else {
      this.data.forEach(function(e2) {
        return e2.kill && e2.kill();
      });
    }
    this.clear();
    if (matchMedia2) {
      var i2 = _media.length;
      while (i2--) {
        _media[i2].id === this.id && _media.splice(i2, 1);
      }
    }
  };
  _proto5.revert = function revert(config3) {
    this.kill(config3 || {});
  };
  return Context2;
})();
var MatchMedia = /* @__PURE__ */ (function() {
  function MatchMedia2(scope) {
    this.contexts = [];
    this.scope = scope;
    _context && _context.data.push(this);
  }
  var _proto6 = MatchMedia2.prototype;
  _proto6.add = function add(conditions, func, scope) {
    _isObject(conditions) || (conditions = {
      matches: conditions
    });
    var context4 = new Context$1(0, scope || this.scope), cond = context4.conditions = {}, mq, p3, active;
    _context && !context4.selector && (context4.selector = _context.selector);
    this.contexts.push(context4);
    func = context4.add("onMatch", func);
    context4.queries = conditions;
    for (p3 in conditions) {
      if (p3 === "all") {
        active = 1;
      } else {
        mq = _win$1.matchMedia(conditions[p3]);
        if (mq) {
          _media.indexOf(context4) < 0 && _media.push(context4);
          (cond[p3] = mq.matches) && (active = 1);
          mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
        }
      }
    }
    active && func(context4, function(f2) {
      return context4.add(null, f2);
    });
    return this;
  };
  _proto6.revert = function revert(config3) {
    this.kill(config3 || {});
  };
  _proto6.kill = function kill(revert) {
    this.contexts.forEach(function(c2) {
      return c2.kill(revert, true);
    });
  };
  return MatchMedia2;
})();
var _gsap$1 = {
  registerPlugin: function registerPlugin() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    args.forEach(function(config3) {
      return _createPlugin(config3);
    });
  },
  timeline: function timeline(vars) {
    return new Timeline(vars);
  },
  getTweensOf: function getTweensOf(targets, onlyActive) {
    return _globalTimeline.getTweensOf(targets, onlyActive);
  },
  getProperty: function getProperty(target, property, unit, uncache) {
    _isString(target) && (target = toArray$1(target)[0]);
    var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
    unit === "native" && (unit = "");
    return !target ? target : !property ? function(property2, unit2, uncache2) {
      return format((_plugins[property2] && _plugins[property2].get || getter)(target, property2, unit2, uncache2));
    } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
  },
  quickSetter: function quickSetter(target, property, unit) {
    target = toArray$1(target);
    if (target.length > 1) {
      var setters = target.map(function(t2) {
        return gsap.quickSetter(t2, property, unit);
      }), l2 = setters.length;
      return function(value) {
        var i2 = l2;
        while (i2--) {
          setters[i2](value);
        }
      };
    }
    target = target[0] || {};
    var Plugin = _plugins[property], cache = _getCache(target), p3 = cache.harness && (cache.harness.aliases || {})[property] || property, setter = Plugin ? function(value) {
      var p4 = new Plugin();
      _quickTween._pt = 0;
      p4.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
      p4.render(1, p4);
      _quickTween._pt && _renderPropTweens(1, _quickTween);
    } : cache.set(target, p3);
    return Plugin ? setter : function(value) {
      return setter(target, p3, unit ? value + unit : value, cache, 1);
    };
  },
  quickTo: function quickTo(target, property, vars) {
    var _setDefaults22;
    var tween = gsap.to(target, _setDefaults((_setDefaults22 = {}, _setDefaults22[property] = "+=0.1", _setDefaults22.paused = true, _setDefaults22.stagger = 0, _setDefaults22), vars || {})), func = function func2(value, start2, startIsRelative) {
      return tween.resetTo(property, value, start2, startIsRelative);
    };
    func.tween = tween;
    return func;
  },
  isTweening: function isTweening(targets) {
    return _globalTimeline.getTweensOf(targets, true).length > 0;
  },
  defaults: function defaults(value) {
    value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
    return _mergeDeep(_defaults, value || {});
  },
  config: function config2(value) {
    return _mergeDeep(_config, value || {});
  },
  registerEffect: function registerEffect(_ref3) {
    var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults2 = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
    (plugins || "").split(",").forEach(function(pluginName) {
      return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
    });
    _effects[name] = function(targets, vars, tl) {
      return effect(toArray$1(targets), _setDefaults(vars || {}, defaults2), tl);
    };
    if (extendTimeline) {
      Timeline.prototype[name] = function(targets, vars, position) {
        return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
      };
    }
  },
  registerEase: function registerEase(name, ease) {
    _easeMap[name] = _parseEase(ease);
  },
  parseEase: function parseEase(ease, defaultEase) {
    return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
  },
  getById: function getById(id) {
    return _globalTimeline.getById(id);
  },
  exportRoot: function exportRoot(vars, includeDelayedCalls) {
    if (vars === void 0) {
      vars = {};
    }
    var tl = new Timeline(vars), child, next;
    tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
    _globalTimeline.remove(tl);
    tl._dp = 0;
    tl._time = tl._tTime = _globalTimeline._time;
    child = _globalTimeline._first;
    while (child) {
      next = child._next;
      if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
        _addToTimeline(tl, child, child._start - child._delay);
      }
      child = next;
    }
    _addToTimeline(_globalTimeline, tl, 0);
    return tl;
  },
  context: function context2(func, scope) {
    return func ? new Context$1(func, scope) : _context;
  },
  matchMedia: function matchMedia(scope) {
    return new MatchMedia(scope);
  },
  matchMediaRefresh: function matchMediaRefresh() {
    return _media.forEach(function(c2) {
      var cond = c2.conditions, found, p3;
      for (p3 in cond) {
        if (cond[p3]) {
          cond[p3] = false;
          found = 1;
        }
      }
      found && c2.revert();
    }) || _onMediaChange();
  },
  addEventListener: function addEventListener(type, callback) {
    var a5 = _listeners[type] || (_listeners[type] = []);
    ~a5.indexOf(callback) || a5.push(callback);
  },
  removeEventListener: function removeEventListener(type, callback) {
    var a5 = _listeners[type], i2 = a5 && a5.indexOf(callback);
    i2 >= 0 && a5.splice(i2, 1);
  },
  utils: {
    wrap,
    wrapYoyo,
    distribute,
    random,
    snap,
    normalize,
    getUnit,
    clamp: clamp$1,
    splitColor,
    toArray: toArray$1,
    selector,
    mapRange,
    pipe,
    unitize,
    interpolate: interpolate$1,
    shuffle
  },
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween,
    globals: _addGlobal,
    Tween,
    Timeline,
    Animation,
    getCache: _getCache,
    _removeLinkedListItem,
    reverting: function reverting() {
      return _reverting$1;
    },
    context: function context3(toAdd) {
      if (toAdd && _context) {
        _context.data.push(toAdd);
        toAdd._ctx = _context;
      }
      return _context;
    },
    suppressOverwrites: function suppressOverwrites(value) {
      return _suppressOverwrites = value;
    }
  }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
  return _gsap$1[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap$1.to({}, {
  duration: 0
});
var _getPluginPropTween = function _getPluginPropTween2(plugin, prop) {
  var pt = plugin._pt;
  while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
    pt = pt._next;
  }
  return pt;
}, _addModifiers = function _addModifiers2(tween, modifiers) {
  var targets = tween._targets, p3, i2, pt;
  for (p3 in modifiers) {
    i2 = targets.length;
    while (i2--) {
      pt = tween._ptLookup[i2][p3];
      if (pt && (pt = pt.d)) {
        if (pt._pt) {
          pt = _getPluginPropTween(pt, p3);
        }
        pt && pt.modifier && pt.modifier(modifiers[p3], tween, targets[i2], p3);
      }
    }
  }
}, _buildModifierPlugin = function _buildModifierPlugin2(name, modifier) {
  return {
    name,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function init4(target, vars, tween) {
      tween._onInit = function(tween2) {
        var temp, p3;
        if (_isString(vars)) {
          temp = {};
          _forEachName(vars, function(name2) {
            return temp[name2] = 1;
          });
          vars = temp;
        }
        if (modifier) {
          temp = {};
          for (p3 in vars) {
            temp[p3] = modifier(vars[p3]);
          }
          vars = temp;
        }
        _addModifiers(tween2, vars);
      };
    }
  };
};
var gsap = _gsap$1.registerPlugin({
  name: "attr",
  init: function init(target, vars, tween, index, targets) {
    var p3, pt, v3;
    this.tween = tween;
    for (p3 in vars) {
      v3 = target.getAttribute(p3) || "";
      pt = this.add(target, "setAttribute", (v3 || 0) + "", vars[p3], index, targets, 0, 0, p3);
      pt.op = p3;
      pt.b = v3;
      this._props.push(p3);
    }
  },
  render: function render(ratio, data) {
    var pt = data._pt;
    while (pt) {
      _reverting$1 ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d);
      pt = pt._next;
    }
  }
}, {
  name: "endArray",
  headless: 1,
  init: function init2(target, value) {
    var i2 = value.length;
    while (i2--) {
      this.add(target, i2, target[i2] || 0, value[i2], 0, 0, 0, 0, 0, 1);
    }
  }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap$1;
Tween.version = Timeline.version = gsap.version = "3.14.2";
_coreReady = 1;
_windowExists$1() && _wake();
_easeMap.Power0;
_easeMap.Power1;
_easeMap.Power2;
_easeMap.Power3;
_easeMap.Power4;
_easeMap.Linear;
_easeMap.Quad;
_easeMap.Cubic;
_easeMap.Quart;
_easeMap.Quint;
_easeMap.Strong;
_easeMap.Elastic;
_easeMap.Back;
_easeMap.SteppedEase;
_easeMap.Bounce;
_easeMap.Sine;
_easeMap.Expo;
_easeMap.Circ;
var _win, _doc, _docElement, _pluginInitted, _tempDiv, _recentSetterPlugin, _reverting, _windowExists2 = function _windowExists3() {
  return typeof window !== "undefined";
}, _transformProps = {}, _RAD2DEG = 180 / Math.PI, _DEG2RAD = Math.PI / 180, _atan2 = Math.atan2, _bigNum = 1e8, _capsExp = /([A-Z])/g, _horizontalExp = /(left|right|width|margin|padding|x)/i, _complexExp = /[\s,\(]\S/, _propertyAliases = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, _renderCSSProp = function _renderCSSProp2(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u, data);
}, _renderPropWithEnd = function _renderPropWithEnd2(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u, data);
}, _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning2(ratio, data) {
  return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u : data.b, data);
}, _renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd2(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u : data.b, data);
}, _renderRoundedCSSProp = function _renderRoundedCSSProp2(ratio, data) {
  var value = data.s + data.c * ratio;
  data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : 0.5)) + data.u, data);
}, _renderNonTweeningValue = function _renderNonTweeningValue2(ratio, data) {
  return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd2(ratio, data) {
  return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, _setterCSSStyle = function _setterCSSStyle2(target, property, value) {
  return target.style[property] = value;
}, _setterCSSProp = function _setterCSSProp2(target, property, value) {
  return target.style.setProperty(property, value);
}, _setterTransform = function _setterTransform2(target, property, value) {
  return target._gsap[property] = value;
}, _setterScale = function _setterScale2(target, property, value) {
  return target._gsap.scaleX = target._gsap.scaleY = value;
}, _setterScaleWithRender = function _setterScaleWithRender2(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache.scaleX = cache.scaleY = value;
  cache.renderTransform(ratio, cache);
}, _setterTransformWithRender = function _setterTransformWithRender2(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache[property] = value;
  cache.renderTransform(ratio, cache);
}, _transformProp = "transform", _transformOriginProp = _transformProp + "Origin", _saveStyle = function _saveStyle2(property, isNotCSS) {
  var _this = this;
  var target = this.target, style = target.style, cache = target._gsap;
  if (property in _transformProps && style) {
    this.tfm = this.tfm || {};
    if (property !== "transform") {
      property = _propertyAliases[property] || property;
      ~property.indexOf(",") ? property.split(",").forEach(function(a5) {
        return _this.tfm[a5] = _get(target, a5);
      }) : this.tfm[property] = cache.x ? cache[property] : _get(target, property);
      property === _transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
    } else {
      return _propertyAliases.transform.split(",").forEach(function(p3) {
        return _saveStyle2.call(_this, p3, isNotCSS);
      });
    }
    if (this.props.indexOf(_transformProp) >= 0) {
      return;
    }
    if (cache.svg) {
      this.svgo = target.getAttribute("data-svg-origin");
      this.props.push(_transformOriginProp, isNotCSS, "");
    }
    property = _transformProp;
  }
  (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, _removeIndependentTransforms = function _removeIndependentTransforms2(style) {
  if (style.translate) {
    style.removeProperty("translate");
    style.removeProperty("scale");
    style.removeProperty("rotate");
  }
}, _revertStyle = function _revertStyle2() {
  var props = this.props, target = this.target, style = target.style, cache = target._gsap, i2, p3;
  for (i2 = 0; i2 < props.length; i2 += 3) {
    if (!props[i2 + 1]) {
      props[i2 + 2] ? style[props[i2]] = props[i2 + 2] : style.removeProperty(props[i2].substr(0, 2) === "--" ? props[i2] : props[i2].replace(_capsExp, "-$1").toLowerCase());
    } else if (props[i2 + 1] === 2) {
      target[props[i2]](props[i2 + 2]);
    } else {
      target[props[i2]] = props[i2 + 2];
    }
  }
  if (this.tfm) {
    for (p3 in this.tfm) {
      cache[p3] = this.tfm[p3];
    }
    if (cache.svg) {
      cache.renderTransform();
      target.setAttribute("data-svg-origin", this.svgo || "");
    }
    i2 = _reverting();
    if ((!i2 || !i2.isStart) && !style[_transformProp]) {
      _removeIndependentTransforms(style);
      if (cache.zOrigin && style[_transformOriginProp]) {
        style[_transformOriginProp] += " " + cache.zOrigin + "px";
        cache.zOrigin = 0;
        cache.renderTransform();
      }
      cache.uncache = 1;
    }
  }
}, _getStyleSaver = function _getStyleSaver2(target, properties) {
  var saver = {
    target,
    props: [],
    revert: _revertStyle,
    save: _saveStyle
  };
  target._gsap || gsap.core.getCache(target);
  properties && target.style && target.nodeType && properties.split(",").forEach(function(p3) {
    return saver.save(p3);
  });
  return saver;
}, _supports3D, _createElement = function _createElement2(type, ns) {
  var e2 = _doc.createElementNS ? _doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc.createElement(type);
  return e2 && e2.style ? e2 : _doc.createElement(type);
}, _getComputedProperty = function _getComputedProperty2(target, property, skipPrefixFallback) {
  var cs = getComputedStyle(target);
  return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty2(target, _checkPropPrefix(property) || property, 1) || "";
}, _prefixes = "O,Moz,ms,Ms,Webkit".split(","), _checkPropPrefix = function _checkPropPrefix2(property, element, preferPrefix) {
  var e2 = element || _tempDiv, s2 = e2.style, i2 = 5;
  if (property in s2 && !preferPrefix) {
    return property;
  }
  property = property.charAt(0).toUpperCase() + property.substr(1);
  while (i2-- && !(_prefixes[i2] + property in s2)) {
  }
  return i2 < 0 ? null : (i2 === 3 ? "ms" : i2 >= 0 ? _prefixes[i2] : "") + property;
}, _initCore = function _initCore2() {
  if (_windowExists2() && window.document) {
    _win = window;
    _doc = _win.document;
    _docElement = _doc.documentElement;
    _tempDiv = _createElement("div") || {
      style: {}
    };
    _createElement("div");
    _transformProp = _checkPropPrefix(_transformProp);
    _transformOriginProp = _transformProp + "Origin";
    _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0";
    _supports3D = !!_checkPropPrefix("perspective");
    _reverting = gsap.core.reverting;
    _pluginInitted = 1;
  }
}, _getReparentedCloneBBox = function _getReparentedCloneBBox2(target) {
  var owner = target.ownerSVGElement, svg = _createElement("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
  clone.style.display = "block";
  svg.appendChild(clone);
  _docElement.appendChild(svg);
  try {
    bbox = clone.getBBox();
  } catch (e2) {
  }
  svg.removeChild(clone);
  _docElement.removeChild(svg);
  return bbox;
}, _getAttributeFallbacks = function _getAttributeFallbacks2(target, attributesArray) {
  var i2 = attributesArray.length;
  while (i2--) {
    if (target.hasAttribute(attributesArray[i2])) {
      return target.getAttribute(attributesArray[i2]);
    }
  }
}, _getBBox = function _getBBox2(target) {
  var bounds, cloned;
  try {
    bounds = target.getBBox();
  } catch (error2) {
    bounds = _getReparentedCloneBBox(target);
    cloned = 1;
  }
  bounds && (bounds.width || bounds.height) || cloned || (bounds = _getReparentedCloneBBox(target));
  return bounds && !bounds.width && !bounds.x && !bounds.y ? {
    x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
    y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : bounds;
}, _isSVG = function _isSVG2(e2) {
  return !!(e2.getCTM && (!e2.parentNode || e2.ownerSVGElement) && _getBBox(e2));
}, _removeProperty = function _removeProperty2(target, property) {
  if (property) {
    var style = target.style, first2Chars;
    if (property in _transformProps && property !== _transformOriginProp) {
      property = _transformProp;
    }
    if (style.removeProperty) {
      first2Chars = property.substr(0, 2);
      if (first2Chars === "ms" || property.substr(0, 6) === "webkit") {
        property = "-" + property;
      }
      style.removeProperty(first2Chars === "--" ? property : property.replace(_capsExp, "-$1").toLowerCase());
    } else {
      style.removeAttribute(property);
    }
  }
}, _addNonTweeningPT = function _addNonTweeningPT2(plugin, target, property, beginning, end, onlySetAtEnd) {
  var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
  plugin._pt = pt;
  pt.b = beginning;
  pt.e = end;
  plugin._props.push(property);
  return pt;
}, _nonConvertibleUnits = {
  deg: 1,
  rad: 1,
  turn: 1
}, _nonStandardLayouts = {
  grid: 1,
  flex: 1
}, _convertToUnit = function _convertToUnit2(target, property, value, unit) {
  var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", style = _tempDiv.style, horizontal = _horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px2, parent, cache, isSVG;
  if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
    return curValue;
  }
  curUnit !== "px" && !toPixels && (curValue = _convertToUnit2(target, property, value, "px"));
  isSVG = target.getCTM && _isSVG(target);
  if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
    px2 = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
    return _round(toPercent ? curValue / px2 * amount : curValue / 100 * px2);
  }
  style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
  parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
  if (isSVG) {
    parent = (target.ownerSVGElement || {}).parentNode;
  }
  if (!parent || parent === _doc || !parent.appendChild) {
    parent = _doc.body;
  }
  cache = parent._gsap;
  if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time && !cache.uncache) {
    return _round(curValue / cache.width * amount);
  } else {
    if (toPercent && (property === "height" || property === "width")) {
      var v3 = target.style[property];
      target.style[property] = amount + unit;
      px2 = target[measureProperty];
      v3 ? target.style[property] = v3 : _removeProperty(target, property);
    } else {
      (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
      parent === target && (style.position = "static");
      parent.appendChild(_tempDiv);
      px2 = _tempDiv[measureProperty];
      parent.removeChild(_tempDiv);
      style.position = "absolute";
    }
    if (horizontal && toPercent) {
      cache = _getCache(parent);
      cache.time = _ticker.time;
      cache.width = parent[measureProperty];
    }
  }
  return _round(toPixels ? px2 * curValue / amount : px2 && curValue ? amount / px2 * curValue : 0);
}, _get = function _get2(target, property, unit, uncache) {
  var value;
  _pluginInitted || _initCore();
  if (property in _propertyAliases && property !== "transform") {
    property = _propertyAliases[property];
    if (~property.indexOf(",")) {
      property = property.split(",")[0];
    }
  }
  if (_transformProps[property] && property !== "transform") {
    value = _parseTransform(target, uncache);
    value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
  } else {
    value = target.style[property];
    if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
      value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0);
    }
  }
  return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
}, _tweenComplexCSSString = function _tweenComplexCSSString2(target, prop, start2, end) {
  if (!start2 || start2 === "none") {
    var p3 = _checkPropPrefix(prop, target, 1), s2 = p3 && _getComputedProperty(target, p3, 1);
    if (s2 && s2 !== start2) {
      prop = p3;
      start2 = s2;
    } else if (prop === "borderColor") {
      start2 = _getComputedProperty(target, "borderTopColor");
    }
  }
  var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString), index = 0, matchIndex = 0, a5, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
  pt.b = start2;
  pt.e = end;
  start2 += "";
  end += "";
  if (end.substring(0, 6) === "var(--") {
    end = _getComputedProperty(target, end.substring(4, end.indexOf(")")));
  }
  if (end === "auto") {
    startValue = target.style[prop];
    target.style[prop] = end;
    end = _getComputedProperty(target, prop) || end;
    startValue ? target.style[prop] = startValue : _removeProperty(target, prop);
  }
  a5 = [start2, end];
  _colorStringFilter(a5);
  start2 = a5[0];
  end = a5[1];
  startValues = start2.match(_numWithUnitExp) || [];
  endValues = end.match(_numWithUnitExp) || [];
  if (endValues.length) {
    while (result = _numWithUnitExp.exec(end)) {
      endValue = result[0];
      chunk = end.substring(index, result.index);
      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
        color = 1;
      }
      if (endValue !== (startValue = startValues[matchIndex++] || "")) {
        startNum = parseFloat(startValue) || 0;
        startUnit = startValue.substr((startNum + "").length);
        endValue.charAt(1) === "=" && (endValue = _parseRelative(startNum, endValue) + startUnit);
        endNum = parseFloat(endValue);
        endUnit = endValue.substr((endNum + "").length);
        index = _numWithUnitExp.lastIndex - endUnit.length;
        if (!endUnit) {
          endUnit = endUnit || _config.units[prop] || startUnit;
          if (index === end.length) {
            end += endUnit;
            pt.e += endUnit;
          }
        }
        if (startUnit !== endUnit) {
          startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
        }
        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: endNum - startNum,
          m: color && color < 4 || prop === "zIndex" ? Math.round : 0
        };
      }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : "";
  } else {
    pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
  }
  _relExp.test(end) && (pt.e = 0);
  this._pt = pt;
  return pt;
}, _keywordToPercent = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, _convertKeywordsToPercentages = function _convertKeywordsToPercentages2(value) {
  var split = value.split(" "), x3 = split[0], y2 = split[1] || "50%";
  if (x3 === "top" || x3 === "bottom" || y2 === "left" || y2 === "right") {
    value = x3;
    x3 = y2;
    y2 = value;
  }
  split[0] = _keywordToPercent[x3] || x3;
  split[1] = _keywordToPercent[y2] || y2;
  return split.join(" ");
}, _renderClearProps = function _renderClearProps2(ratio, data) {
  if (data.tween && data.tween._time === data.tween._dur) {
    var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i2;
    if (props === "all" || props === true) {
      style.cssText = "";
      clearTransforms = 1;
    } else {
      props = props.split(",");
      i2 = props.length;
      while (--i2 > -1) {
        prop = props[i2];
        if (_transformProps[prop]) {
          clearTransforms = 1;
          prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
        }
        _removeProperty(target, prop);
      }
    }
    if (clearTransforms) {
      _removeProperty(target, _transformProp);
      if (cache) {
        cache.svg && target.removeAttribute("transform");
        style.scale = style.rotate = style.translate = "none";
        _parseTransform(target, 1);
        cache.uncache = 1;
        _removeIndependentTransforms(style);
      }
    }
  }
}, _specialProps = {
  clearProps: function clearProps(plugin, target, property, endValue, tween) {
    if (tween.data !== "isFromStart") {
      var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
      pt.u = endValue;
      pt.pr = -10;
      pt.tween = tween;
      plugin._props.push(property);
      return 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, _identity2DMatrix = [1, 0, 0, 1, 0, 0], _rotationalProperties = {}, _isNullTransform = function _isNullTransform2(value) {
  return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray2(target) {
  var matrixString = _getComputedProperty(target, _transformProp);
  return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
}, _getMatrix = function _getMatrix2(target, force2D) {
  var cache = target._gsap || _getCache(target), style = target.style, matrix = _getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
  if (cache.svg && target.getAttribute("transform")) {
    temp = target.transform.baseVal.consolidate().matrix;
    matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
    return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
  } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
    temp = style.display;
    style.display = "block";
    parent = target.parentNode;
    if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
      addedToDOM = 1;
      nextSibling = target.nextElementSibling;
      _docElement.appendChild(target);
    }
    matrix = _getComputedTransformMatrixAsArray(target);
    temp ? style.display = temp : _removeProperty(target, "display");
    if (addedToDOM) {
      nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
  }
  return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
}, _applySVGOrigin = function _applySVGOrigin2(target, origin2, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
  var cache = target._gsap, matrix = matrixArray || _getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a5 = matrix[0], b6 = matrix[1], c2 = matrix[2], d3 = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin2.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x3, y2;
  if (!originIsAbsolute) {
    bounds = _getBBox(target);
    xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
    yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
  } else if (matrix !== _identity2DMatrix && (determinant = a5 * d3 - b6 * c2)) {
    x3 = xOrigin * (d3 / determinant) + yOrigin * (-c2 / determinant) + (c2 * ty - d3 * tx) / determinant;
    y2 = xOrigin * (-b6 / determinant) + yOrigin * (a5 / determinant) - (a5 * ty - b6 * tx) / determinant;
    xOrigin = x3;
    yOrigin = y2;
  }
  if (smooth || smooth !== false && cache.smooth) {
    tx = xOrigin - xOriginOld;
    ty = yOrigin - yOriginOld;
    cache.xOffset = xOffsetOld + (tx * a5 + ty * c2) - tx;
    cache.yOffset = yOffsetOld + (tx * b6 + ty * d3) - ty;
  } else {
    cache.xOffset = cache.yOffset = 0;
  }
  cache.xOrigin = xOrigin;
  cache.yOrigin = yOrigin;
  cache.smooth = !!smooth;
  cache.origin = origin2;
  cache.originIsAbsolute = !!originIsAbsolute;
  target.style[_transformOriginProp] = "0px 0px";
  if (pluginToAddPropTweensTo) {
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
  }
  target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, _parseTransform = function _parseTransform2(target, uncache) {
  var cache = target._gsap || new GSCache(target);
  if ("x" in cache && !uncache && !cache.uncache) {
    return cache;
  }
  var style = target.style, invertedScaleX = cache.scaleX < 0, px2 = "px", deg = "deg", cs = getComputedStyle(target), origin2 = _getComputedProperty(target, _transformOriginProp) || "0", x3, y2, z2, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a5, b6, c2, d3, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
  x3 = y2 = z2 = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
  scaleX = scaleY = 1;
  cache.svg = !!(target.getCTM && _isSVG(target));
  if (cs.translate) {
    if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") {
      style[_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp] !== "none" ? cs[_transformProp] : "");
    }
    style.scale = style.rotate = style.translate = "none";
  }
  matrix = _getMatrix(target, cache.svg);
  if (cache.svg) {
    if (cache.uncache) {
      t2 = target.getBBox();
      origin2 = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
      t1 = "";
    } else {
      t1 = !uncache && target.getAttribute("data-svg-origin");
    }
    _applySVGOrigin(target, t1 || origin2, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
  }
  xOrigin = cache.xOrigin || 0;
  yOrigin = cache.yOrigin || 0;
  if (matrix !== _identity2DMatrix) {
    a5 = matrix[0];
    b6 = matrix[1];
    c2 = matrix[2];
    d3 = matrix[3];
    x3 = a12 = matrix[4];
    y2 = a22 = matrix[5];
    if (matrix.length === 6) {
      scaleX = Math.sqrt(a5 * a5 + b6 * b6);
      scaleY = Math.sqrt(d3 * d3 + c2 * c2);
      rotation = a5 || b6 ? _atan2(b6, a5) * _RAD2DEG : 0;
      skewX = c2 || d3 ? _atan2(c2, d3) * _RAD2DEG + rotation : 0;
      skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));
      if (cache.svg) {
        x3 -= xOrigin - (xOrigin * a5 + yOrigin * c2);
        y2 -= yOrigin - (xOrigin * b6 + yOrigin * d3);
      }
    } else {
      a32 = matrix[6];
      a42 = matrix[7];
      a13 = matrix[8];
      a23 = matrix[9];
      a33 = matrix[10];
      a43 = matrix[11];
      x3 = matrix[12];
      y2 = matrix[13];
      z2 = matrix[14];
      angle = _atan2(a32, a33);
      rotationX = angle * _RAD2DEG;
      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a12 * cos + a13 * sin;
        t2 = a22 * cos + a23 * sin;
        t3 = a32 * cos + a33 * sin;
        a13 = a12 * -sin + a13 * cos;
        a23 = a22 * -sin + a23 * cos;
        a33 = a32 * -sin + a33 * cos;
        a43 = a42 * -sin + a43 * cos;
        a12 = t1;
        a22 = t2;
        a32 = t3;
      }
      angle = _atan2(-c2, a33);
      rotationY = angle * _RAD2DEG;
      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a5 * cos - a13 * sin;
        t2 = b6 * cos - a23 * sin;
        t3 = c2 * cos - a33 * sin;
        a43 = d3 * sin + a43 * cos;
        a5 = t1;
        b6 = t2;
        c2 = t3;
      }
      angle = _atan2(b6, a5);
      rotation = angle * _RAD2DEG;
      if (angle) {
        cos = Math.cos(angle);
        sin = Math.sin(angle);
        t1 = a5 * cos + b6 * sin;
        t2 = a12 * cos + a22 * sin;
        b6 = b6 * cos - a5 * sin;
        a22 = a22 * cos - a12 * sin;
        a5 = t1;
        a12 = t2;
      }
      if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
        rotationX = rotation = 0;
        rotationY = 180 - rotationY;
      }
      scaleX = _round(Math.sqrt(a5 * a5 + b6 * b6 + c2 * c2));
      scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
      angle = _atan2(a12, a22);
      skewX = Math.abs(angle) > 2e-4 ? angle * _RAD2DEG : 0;
      perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
    }
    if (cache.svg) {
      t1 = target.getAttribute("transform");
      cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
      t1 && target.setAttribute("transform", t1);
    }
  }
  if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
    if (invertedScaleX) {
      scaleX *= -1;
      skewX += rotation <= 0 ? 180 : -180;
      rotation += rotation <= 0 ? 180 : -180;
    } else {
      scaleY *= -1;
      skewX += skewX <= 0 ? 180 : -180;
    }
  }
  uncache = uncache || cache.uncache;
  cache.x = x3 - ((cache.xPercent = x3 && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x3) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px2;
  cache.y = y2 - ((cache.yPercent = y2 && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y2) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px2;
  cache.z = z2 + px2;
  cache.scaleX = _round(scaleX);
  cache.scaleY = _round(scaleY);
  cache.rotation = _round(rotation) + deg;
  cache.rotationX = _round(rotationX) + deg;
  cache.rotationY = _round(rotationY) + deg;
  cache.skewX = skewX + deg;
  cache.skewY = skewY + deg;
  cache.transformPerspective = perspective + px2;
  if (cache.zOrigin = parseFloat(origin2.split(" ")[2]) || !uncache && cache.zOrigin || 0) {
    style[_transformOriginProp] = _firstTwoOnly(origin2);
  }
  cache.xOffset = cache.yOffset = 0;
  cache.force3D = _config.force3D;
  cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
  cache.uncache = 0;
  return cache;
}, _firstTwoOnly = function _firstTwoOnly2(value) {
  return (value = value.split(" "))[0] + " " + value[1];
}, _addPxTranslate = function _addPxTranslate2(target, start2, value) {
  var unit = getUnit(start2);
  return _round(parseFloat(start2) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
}, _renderNon3DTransforms = function _renderNon3DTransforms2(ratio, cache) {
  cache.z = "0px";
  cache.rotationY = cache.rotationX = "0deg";
  cache.force3D = 0;
  _renderCSSTransforms(ratio, cache);
}, _zeroDeg = "0deg", _zeroPx = "0px", _endParenthesis = ") ", _renderCSSTransforms = function _renderCSSTransforms2(ratio, cache) {
  var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x3 = _ref.x, y2 = _ref.y, z2 = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true;
  if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
    var angle = parseFloat(rotationY) * _DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
    angle = parseFloat(rotationX) * _DEG2RAD;
    cos = Math.cos(angle);
    x3 = _addPxTranslate(target, x3, a13 * cos * -zOrigin);
    y2 = _addPxTranslate(target, y2, -Math.sin(angle) * -zOrigin);
    z2 = _addPxTranslate(target, z2, a33 * cos * -zOrigin + zOrigin);
  }
  if (transformPerspective !== _zeroPx) {
    transforms += "perspective(" + transformPerspective + _endParenthesis;
  }
  if (xPercent || yPercent) {
    transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
  }
  if (use3D || x3 !== _zeroPx || y2 !== _zeroPx || z2 !== _zeroPx) {
    transforms += z2 !== _zeroPx || use3D ? "translate3d(" + x3 + ", " + y2 + ", " + z2 + ") " : "translate(" + x3 + ", " + y2 + _endParenthesis;
  }
  if (rotation !== _zeroDeg) {
    transforms += "rotate(" + rotation + _endParenthesis;
  }
  if (rotationY !== _zeroDeg) {
    transforms += "rotateY(" + rotationY + _endParenthesis;
  }
  if (rotationX !== _zeroDeg) {
    transforms += "rotateX(" + rotationX + _endParenthesis;
  }
  if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
    transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
  }
  if (scaleX !== 1 || scaleY !== 1) {
    transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
  }
  target.style[_transformProp] = transforms || "translate(0, 0)";
}, _renderSVGTransforms = function _renderSVGTransforms2(ratio, cache) {
  var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x3 = _ref2.x, y2 = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x3), ty = parseFloat(y2), a11, a21, a12, a22, temp;
  rotation = parseFloat(rotation);
  skewX = parseFloat(skewX);
  skewY = parseFloat(skewY);
  if (skewY) {
    skewY = parseFloat(skewY);
    skewX += skewY;
    rotation += skewY;
  }
  if (rotation || skewX) {
    rotation *= _DEG2RAD;
    skewX *= _DEG2RAD;
    a11 = Math.cos(rotation) * scaleX;
    a21 = Math.sin(rotation) * scaleX;
    a12 = Math.sin(rotation - skewX) * -scaleY;
    a22 = Math.cos(rotation - skewX) * scaleY;
    if (skewX) {
      skewY *= _DEG2RAD;
      temp = Math.tan(skewX - skewY);
      temp = Math.sqrt(1 + temp * temp);
      a12 *= temp;
      a22 *= temp;
      if (skewY) {
        temp = Math.tan(skewY);
        temp = Math.sqrt(1 + temp * temp);
        a11 *= temp;
        a21 *= temp;
      }
    }
    a11 = _round(a11);
    a21 = _round(a21);
    a12 = _round(a12);
    a22 = _round(a22);
  } else {
    a11 = scaleX;
    a22 = scaleY;
    a21 = a12 = 0;
  }
  if (tx && !~(x3 + "").indexOf("px") || ty && !~(y2 + "").indexOf("px")) {
    tx = _convertToUnit(target, "x", x3, "px");
    ty = _convertToUnit(target, "y", y2, "px");
  }
  if (xOrigin || yOrigin || xOffset || yOffset) {
    tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
    ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
  }
  if (xPercent || yPercent) {
    temp = target.getBBox();
    tx = _round(tx + xPercent / 100 * temp.width);
    ty = _round(ty + yPercent / 100 * temp.height);
  }
  temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
  target.setAttribute("transform", temp);
  forceCSS && (target.style[_transformProp] = temp);
}, _addRotationalPropTween = function _addRotationalPropTween2(plugin, target, property, startNum, endValue) {
  var cap = 360, isString = _isString(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
  if (isString) {
    direction = endValue.split("_")[1];
    if (direction === "short") {
      change %= cap;
      if (change !== change % (cap / 2)) {
        change += change < 0 ? cap : -cap;
      }
    }
    if (direction === "cw" && change < 0) {
      change = (change + cap * _bigNum) % cap - ~~(change / cap) * cap;
    } else if (direction === "ccw" && change > 0) {
      change = (change - cap * _bigNum) % cap - ~~(change / cap) * cap;
    }
  }
  plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
  pt.e = finalValue;
  pt.u = "deg";
  plugin._props.push(property);
  return pt;
}, _assign = function _assign2(target, source) {
  for (var p3 in source) {
    target[p3] = source[p3];
  }
  return target;
}, _addRawTransformPTs = function _addRawTransformPTs2(plugin, transforms, target) {
  var startCache = _assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p3, startValue, endValue, startNum, endNum, startUnit, endUnit;
  if (startCache.svg) {
    startValue = target.getAttribute("transform");
    target.setAttribute("transform", "");
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    _removeProperty(target, _transformProp);
    target.setAttribute("transform", startValue);
  } else {
    startValue = getComputedStyle(target)[_transformProp];
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    style[_transformProp] = startValue;
  }
  for (p3 in _transformProps) {
    startValue = startCache[p3];
    endValue = endCache[p3];
    if (startValue !== endValue && exclude.indexOf(p3) < 0) {
      startUnit = getUnit(startValue);
      endUnit = getUnit(endValue);
      startNum = startUnit !== endUnit ? _convertToUnit(target, p3, startValue, endUnit) : parseFloat(startValue);
      endNum = parseFloat(endValue);
      plugin._pt = new PropTween(plugin._pt, endCache, p3, startNum, endNum - startNum, _renderCSSProp);
      plugin._pt.u = endUnit || 0;
      plugin._props.push(p3);
    }
  }
  _assign(endCache, startCache);
};
_forEachName("padding,margin,Width,Radius", function(name, index) {
  var t2 = "Top", r3 = "Right", b6 = "Bottom", l2 = "Left", props = (index < 3 ? [t2, r3, b6, l2] : [t2 + l2, t2 + r3, b6 + r3, b6 + l2]).map(function(side) {
    return index < 2 ? name + side : "border" + side + name;
  });
  _specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
    var a5, vars;
    if (arguments.length < 4) {
      a5 = props.map(function(prop) {
        return _get(plugin, prop, property);
      });
      vars = a5.join(" ");
      return vars.split(a5[0]).length === 5 ? a5[0] : vars;
    }
    a5 = (endValue + "").split(" ");
    vars = {};
    props.forEach(function(prop, i2) {
      return vars[prop] = a5[i2] = a5[i2] || a5[(i2 - 1) / 2 | 0];
    });
    plugin.init(target, vars, tween);
  };
});
var CSSPlugin = {
  name: "css",
  register: _initCore,
  targetTest: function targetTest(target) {
    return target.style && target.nodeType;
  },
  init: function init3(target, vars, tween, index, targets) {
    var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p3, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps, finalTransformValue;
    _pluginInitted || _initCore();
    this.styles = this.styles || _getStyleSaver(target);
    inlineProps = this.styles.props;
    this.tween = tween;
    for (p3 in vars) {
      if (p3 === "autoRound") {
        continue;
      }
      endValue = vars[p3];
      if (_plugins[p3] && _checkPlugin(p3, vars, tween, index, target, targets)) {
        continue;
      }
      type = typeof endValue;
      specialProp = _specialProps[p3];
      if (type === "function") {
        endValue = endValue.call(tween, index, target, targets);
        type = typeof endValue;
      }
      if (type === "string" && ~endValue.indexOf("random(")) {
        endValue = _replaceRandom(endValue);
      }
      if (specialProp) {
        specialProp(this, target, p3, endValue, tween) && (hasPriority = 1);
      } else if (p3.substr(0, 2) === "--") {
        startValue = (getComputedStyle(target).getPropertyValue(p3) + "").trim();
        endValue += "";
        _colorExp.lastIndex = 0;
        if (!_colorExp.test(startValue)) {
          startUnit = getUnit(startValue);
          endUnit = getUnit(endValue);
          endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p3, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
        }
        this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p3);
        props.push(p3);
        inlineProps.push(p3, 0, style[p3]);
      } else if (type !== "undefined") {
        if (startAt && p3 in startAt) {
          startValue = typeof startAt[p3] === "function" ? startAt[p3].call(tween, index, target, targets) : startAt[p3];
          _isString(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
          getUnit(startValue + "") || startValue === "auto" || (startValue += _config.units[p3] || getUnit(_get(target, p3)) || "");
          (startValue + "").charAt(1) === "=" && (startValue = _get(target, p3));
        } else {
          startValue = _get(target, p3);
        }
        startNum = parseFloat(startValue);
        relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
        relative && (endValue = endValue.substr(2));
        endNum = parseFloat(endValue);
        if (p3 in _propertyAliases) {
          if (p3 === "autoAlpha") {
            if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
              startNum = 0;
            }
            inlineProps.push("visibility", 0, style.visibility);
            _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
          }
          if (p3 !== "scale" && p3 !== "transform") {
            p3 = _propertyAliases[p3];
            ~p3.indexOf(",") && (p3 = p3.split(",")[0]);
          }
        }
        isTransformRelated = p3 in _transformProps;
        if (isTransformRelated) {
          this.styles.save(p3);
          finalTransformValue = endValue;
          if (type === "string" && endValue.substring(0, 6) === "var(--") {
            endValue = _getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
            if (endValue.substring(0, 5) === "calc(") {
              var origPerspective = target.style.perspective;
              target.style.perspective = endValue;
              endValue = _getComputedProperty(target, "perspective");
              origPerspective ? target.style.perspective = origPerspective : _removeProperty(target, "perspective");
            }
            endNum = parseFloat(endValue);
          }
          if (!transformPropTween) {
            cache = target._gsap;
            cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform);
            smooth = vars.smoothOrigin !== false && cache.smooth;
            transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1);
            transformPropTween.dep = 1;
          }
          if (p3 === "scale") {
            this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? _parseRelative(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
            this._pt.u = 0;
            props.push("scaleY", p3);
            p3 += "X";
          } else if (p3 === "transformOrigin") {
            inlineProps.push(_transformOriginProp, 0, style[_transformOriginProp]);
            endValue = _convertKeywordsToPercentages(endValue);
            if (cache.svg) {
              _applySVGOrigin(target, endValue, 0, smooth, 0, this);
            } else {
              endUnit = parseFloat(endValue.split(" ")[2]) || 0;
              endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
              _addNonTweeningPT(this, style, p3, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
            }
            continue;
          } else if (p3 === "svgOrigin") {
            _applySVGOrigin(target, endValue, 1, smooth, 0, this);
            continue;
          } else if (p3 in _rotationalProperties) {
            _addRotationalPropTween(this, cache, p3, startNum, relative ? _parseRelative(startNum, relative + endValue) : endValue);
            continue;
          } else if (p3 === "smoothOrigin") {
            _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
            continue;
          } else if (p3 === "force3D") {
            cache[p3] = endValue;
            continue;
          } else if (p3 === "transform") {
            _addRawTransformPTs(this, endValue, target);
            continue;
          }
        } else if (!(p3 in style)) {
          p3 = _checkPropPrefix(p3) || p3;
        }
        if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p3 in style) {
          startUnit = (startValue + "").substr((startNum + "").length);
          endNum || (endNum = 0);
          endUnit = getUnit(endValue) || (p3 in _config.units ? _config.units[p3] : startUnit);
          startUnit !== endUnit && (startNum = _convertToUnit(target, p3, startValue, endUnit));
          this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p3, startNum, (relative ? _parseRelative(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p3 === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
          this._pt.u = endUnit || 0;
          if (isTransformRelated && finalTransformValue !== endValue) {
            this._pt.b = startValue;
            this._pt.e = finalTransformValue;
            this._pt.r = _renderCSSPropWithBeginningAndEnd;
          } else if (startUnit !== endUnit && endUnit !== "%") {
            this._pt.b = startValue;
            this._pt.r = _renderCSSPropWithBeginning;
          }
        } else if (!(p3 in style)) {
          if (p3 in target) {
            this.add(target, p3, startValue || target[p3], relative ? relative + endValue : endValue, index, targets);
          } else if (p3 !== "parseTransform") {
            _missingPlugin(p3, endValue);
            continue;
          }
        } else {
          _tweenComplexCSSString.call(this, target, p3, startValue, relative ? relative + endValue : endValue);
        }
        isTransformRelated || (p3 in style ? inlineProps.push(p3, 0, style[p3]) : typeof target[p3] === "function" ? inlineProps.push(p3, 2, target[p3]()) : inlineProps.push(p3, 1, startValue || target[p3]));
        props.push(p3);
      }
    }
    hasPriority && _sortPropTweensByPriority(this);
  },
  render: function render2(ratio, data) {
    if (data.tween._time || !_reverting()) {
      var pt = data._pt;
      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }
    } else {
      data.styles.revert();
    }
  },
  get: _get,
  aliases: _propertyAliases,
  getSetter: function getSetter(target, property, plugin) {
    var p3 = _propertyAliases[property];
    p3 && p3.indexOf(",") < 0 && (property = p3);
    return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
  },
  core: {
    _removeProperty,
    _getMatrix
  }
};
gsap.utils.checkPrefix = _checkPropPrefix;
gsap.core.getStyleSaver = _getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
  var all = _forEachName(positionAndScale + "," + rotation + "," + others, function(name) {
    _transformProps[name] = 1;
  });
  _forEachName(rotation, function(name) {
    _config.units[name] = "deg";
    _rotationalProperties[name] = 1;
  });
  _propertyAliases[all[13]] = positionAndScale + "," + rotation;
  _forEachName(aliases, function(name) {
    var split = name.split(":");
    _propertyAliases[split[1]] = all[split[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
_forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
  _config.units[name] = "px";
});
gsap.registerPlugin(CSSPlugin);
var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap;
gsapWithCSS.core.Tween;
var reactDomExports = requireReactDom();
function HtmlOverlay({ content, showPopup, setShowPopup }) {
  const iframeRef = reactExports.useRef(null);
  const containerRef = reactExports.useRef(null);
  const handleClose = reactExports.useCallback(() => {
    setShowPopup(false);
  }, [setShowPopup]);
  reactExports.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && showPopup) {
        handleClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showPopup, handleClose]);
  if (!showPopup) {
    return null;
  }
  return reactDomExports.createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        ref: containerRef,
        id: "html-overlay-root",
        className: "fixed inset-0 w-screen h-screen z-[9999]",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Content popup",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "absolute inset-0 bg-black/50 backdrop-blur-[20px] cursor-pointer",
              onClick: handleClose
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[80vh] max-w-[1200px] max-h-[800px] flex flex-col", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative w-full h-full bg-black rounded-3xl border-2 border-white/30 shadow-2xl overflow-hidden", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                className: "absolute top-4 right-4 w-12 h-12 flex items-center justify-center text-white bg-black/80 backdrop-blur-sm border-2 border-white/30 rounded-full cursor-pointer z-20 transition-all duration-200 hover:bg-white/20 hover:border-white/50",
                onClick: handleClose,
                "aria-label": "Close popup",
                children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  "svg",
                  {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              reactExports.Suspense,
              {
                fallback: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-full h-full flex items-center justify-center text-white text-xl bg-black", children: "Loading..." }),
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "iframe",
                  {
                    ref: iframeRef,
                    src: content,
                    className: "w-full h-full border-none block",
                    title: "Popup content"
                  }
                )
              }
            )
          ] }) })
        ]
      }
    ),
    document.body
  );
}
const LoadingScreen = ({ progress }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-screen h-screen items-center justify-center flex-col z-[9999] bg-black fixed inset-0", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loader-container mb-8", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "cube", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "face top" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "face front side" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "face right side" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "face back side" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "face left side" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "face bottom side" })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-64 h-1 bg-gray-800 rounded-full overflow-hidden mb-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "h-full bg-white transition-all duration-200 ease-out",
        style: { width: `${progress}%` }
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "text-white text-center font-mono text-sm tracking-widest", children: [
      "LOADING ",
      Math.floor(progress),
      "%"
    ] })
  ] }) });
};
class AnimationManager {
  animations = [];
  actions = {};
  loopingAnimations = [];
  constructor(animations, actions) {
    this.animations = animations;
    this.actions = actions;
    this.loopingAnimations = [];
  }
  playAnimation(name, loopType = LoopOnce) {
    const action = this.actions[name];
    if (!action || action.isRunning()) return null;
    action.setLoop(loopType);
    action.clampWhenFinished = true;
    action.reset();
    action.play();
    const duration = action._clip.duration * 1e3;
    return new Promise((resolve2) => setTimeout(resolve2, duration));
  }
  playLoopingAnimations() {
    this.loopingAnimations.forEach((name) => this.playAnimation(name, LoopRepeat));
  }
  getLoopingAnimations() {
    return this.loopingAnimations;
  }
  getBoundedActions(object) {
    const boundActions = [];
    Object.entries(this.actions).forEach(([key, action]) => {
      const binding = action?._propertyBindings?.[0]?.binding;
      if (binding?.node?.name === object.name) boundActions.push(action);
    });
    return boundActions;
  }
  parseAnimations(object) {
    const userData = object.userData;
    if ("LoopingAnimations" in userData) {
      const loopingAnims = this.normalizeAnimationList(userData.LoopingAnimations);
      this.loopingAnimations.push(...loopingAnims);
      userData.LoopingAnimations = loopingAnims;
    }
    this.parseInteractionAnimations(object);
  }
  /** @private */
  parseInteractionAnimations(object) {
    const userData = object.userData;
    const animationKeys = ["OnPointerEnterAnimations", "OnPointerExitAnimations", "OnSelectAnimations"];
    let hasAnimations = false;
    animationKeys.forEach((key) => {
      if (key in userData) {
        userData[key] = this.normalizeAnimationList(userData[key]);
        hasAnimations = true;
      }
    });
    if (hasAnimations) {
      if (!("zone" in userData)) userData.zone = "_default_animations_zone";
      userData.type = "interactable";
      const userDataCopy = { ...userData };
      object.traverse((node) => {
        node.userData = userDataCopy;
      });
    }
  }
  /** @private */
  normalizeAnimationList(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      return value.split(",").map((s2) => s2.trim()).filter(Boolean);
    }
    return [];
  }
  cloneAnimations(object, animation) {
    const animationClone = animation.clone();
    animationClone.setLoop(LoopOnce);
    animationClone.clampWhenFinished = true;
    if (!object.userData.animationClones) object.userData.animationClones = [];
    object.userData.animationClones.push(animationClone);
  }
}
const urlParams = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
const isDebugMode = urlParams?.get("debug") === "true";
if (isDebugMode && typeof window !== "undefined") {
  let sendLogToServer = function(type, args) {
    const message = args.map((arg) => {
      try {
        return typeof arg === "object" ? JSON.stringify(arg) : String(arg);
      } catch (e2) {
        return "[Circular/Unserializable]";
      }
    }).join(" ");
    fetch("/__log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, message })
    }).catch(() => {
    });
  };
  var sendLogToServer2 = sendLogToServer;
  const originalLog = console.log;
  const originalWarn = console.warn;
  const originalError = console.error;
  console.log = function(...args) {
    sendLogToServer("log", args);
    originalLog.apply(console, args);
  };
  console.warn = function(...args) {
    sendLogToServer("warn", args);
    originalWarn.apply(console, args);
  };
  console.error = function(...args) {
    sendLogToServer("error", args);
    originalError.apply(console, args);
  };
  console.log("%c[WebCrafter Debug] Console.log, console.warn, and console.error have been instrumented to log to server.", "color: #aaa; font-style: italic;");
  fetch("/__log", {
    method: "DELETE"
  }).catch(() => {
  });
}
function debugLog(prefix2, ...args) {
  if (isDebugMode) {
    console.log(prefix2, ...args);
  }
}
function debugWarn(prefix2, ...args) {
  if (isDebugMode) {
    console.warn(prefix2, ...args);
  }
}
function debugError(prefix2, ...args) {
  console.error(prefix2, ...args);
}
if (isDebugMode) {
  console.log("%c[WebCrafter Debug Mode Enabled]", "background: #222; color: #0f0; padding: 4px 8px; border-radius: 4px;");
  console.log("To disable, remove ?debug=true from the URL");
} else {
  console.log("%c[WebCrafter] Add ?debug=true to the URL to see debug statements in the console", "color: #888; font-style: italic;");
}
const DEFAULT_VOLUME = 1;
class AudioManager {
  loopingSounds = [];
  listener = null;
  defaultSound = null;
  audioLoader = null;
  loadedSounds = {};
  constructor(camera) {
    this.loopingSounds = [];
    this.loadedSounds = {};
    this.listener = new AudioListener();
    camera.add(this.listener);
    this.defaultSound = new Audio(this.listener);
    this.audioLoader = new AudioLoader();
  }
  playSound = (parentObject, loop2 = false, audioObj = null) => {
    const userData = parentObject.userData;
    if (!userData?.mediaSrc) return;
    const context4 = this.listener.context;
    if (context4.state === "suspended") context4.resume();
    const audio = audioObj ?? this.defaultSound;
    const source = userData.mediaSrc;
    const volume = userData.mediaVolume ?? DEFAULT_VOLUME;
    audio.setLoop(loop2);
    audio.setVolume(volume);
    if (audio.isPlaying) audio.stop();
    if (source in this.loadedSounds) {
      audio.setBuffer(this.loadedSounds[source]);
      audio.play();
      return;
    }
    this.audioLoader.load(
      source,
      (buffer) => {
        this.loadedSounds[source] = buffer;
        audio.setBuffer(buffer);
        audio.play();
      },
      void 0,
      (err) => debugError("[AudioManager] Error loading sound:", source, err)
    );
  };
  playLoopingSounds() {
    this.loopingSounds.forEach((soundObject) => {
      const audio = new Audio(this.listener);
      this.playSound(soundObject, true, audio);
    });
  }
  getLoopingSounds() {
    return this.loopingSounds;
  }
  parseSounds(object) {
    const userData = object.userData;
    if (!userData) return;
    if (!("Media" in userData)) return;
    if (userData.mediaType !== "Audio") return;
    if (!("mediaTrigger" in userData)) {
      debugWarn("[AudioManager] No media trigger found on Audio object");
      return;
    }
    if (userData.mediaTrigger === "Looping") {
      this.loopingSounds.push(object);
    }
  }
}
const CAMERA_FRAMING_PADDING = 1.15;
const DEFAULT_INTERACTABLE_ZONE = "_default_interactable_zone";
class SceneManager {
  /** @type {THREE.Object3D} */
  scene = null;
  /** @type {Object} */
  controls = null;
  /** @type {SceneZone[]} */
  sceneZones = [];
  /** @type {Waypoint[]} */
  waypoints = [];
  /** @type {SiteData} */
  siteData = {};
  /** @type {THREE.Object3D[]} */
  physicsObjects = [];
  /** @type {MediaObjects} */
  mediaObjects = {
    video: [],
    audio: [],
    positionalAudio: []
  };
  /** @type {AnimationManager} */
  animationManager = null;
  /** @type {AudioManager} */
  audioManager = null;
  /**
   * Create a new SceneManager.
   * @param {THREE.Object3D} scene - The loaded GLB scene
   * @param {Object} controls - Camera controls instance
   * @param {THREE.AnimationClip[]} animations - Animation clips
   * @param {Object} actions - Animation actions map
   * @param {THREE.AnimationMixer} mixer - Animation mixer
   */
  constructor(scene, controls, animations, actions, mixer) {
    this.scene = scene;
    this.controls = controls;
    this.animationManager = new AnimationManager(animations, actions);
    this.audioManager = new AudioManager(controls.camera);
    this.populateSceneZones(scene);
    this.fixWaypoints();
    this.fixZones();
    this.animationManager.playLoopingAnimations();
    this.setupSoundInitialization();
  }
  /**
   * Set up first-click sound initialization.
   * @private
   */
  setupSoundInitialization() {
    const playLoopingSounds = () => {
      this.audioManager.playLoopingSounds();
      window.removeEventListener("mousedown", playLoopingSounds);
    };
    window.addEventListener("mousedown", playLoopingSounds);
  }
  /**
   * Play an animation by name.
   * @param {string} name - Animation name
   * @param {THREE.AnimationLoopMode} loopType - Loop mode (default: LoopOnce)
   * @returns {Promise|null} Promise that resolves when animation completes
   */
  playAnimation = (name, loopType = LoopOnce) => {
    debugLog("[SceneManager] playAnimation:", name, loopType);
    return this.animationManager.playAnimation(name, loopType);
  };
  /**
   * Play a sound.
   * @param {string} name - Sound name
   * @param {boolean} loop - Whether to loop the sound
   * @returns {Object|null} Audio object
   */
  playSound = (name, loop2 = false) => {
    return this.audioManager.playSound(name, loop2);
  };
  /**
   * Get an animation action by name.
   * @param {string} name - Animation name
   * @returns {THREE.AnimationAction|undefined}
   */
  getAnimationAction(name) {
    return this.animationManager.actions[name];
  }
  /**
   * Get all animation actions bound to an object.
   * @param {THREE.Object3D} obj - Target object
   * @returns {THREE.AnimationAction[]}
   */
  getBoundedActions(obj) {
    return this.animationManager.getBoundedActions(obj);
  }
  /**
   * Get all scene zones.
   * @returns {SceneZone[]}
   */
  getSceneZones() {
    return this.sceneZones;
  }
  /**
   * Get a scene zone by name.
   * @param {string} name - Zone name
   * @returns {SceneZone|null}
   */
  getSceneZone(name) {
    return this.sceneZones.find((zone) => zone.name.toLowerCase() === name.toLowerCase()) ?? null;
  }
  /**
   * Get a scene zone by index.
   * @param {number} index - Zone index
   * @returns {SceneZone|null}
   */
  getSceneZoneByIndex(index) {
    return this.sceneZones.find((zone) => zone.index === index) ?? null;
  }
  /**
   * Get all physics objects.
   * @returns {THREE.Object3D[]}
   */
  getPhysicsObjects() {
    return this.physicsObjects;
  }
  /**
   * Get site data.
   * @returns {SiteData}
   */
  getSiteData() {
    return this.siteData;
  }
  /**
   * Get looping animations.
   * @returns {string[]}
   */
  getLoopingAnimations() {
    return this.animationManager.getLoopingAnimations();
  }
  /**
   * Populate scene zones from the loaded scene.
   * @private
   * @param {THREE.Object3D} scene - The scene to parse
   */
  populateSceneZones(scene) {
    scene.environmentIntensity = 1;
    scene.updateMatrixWorld(true);
    let firstCamera = null;
    const nodes = [];
    scene.traverse((node) => {
      if (!nodes.includes(node)) nodes.push(node);
      node.children.forEach((child) => {
        if (!nodes.includes(child)) nodes.push(child);
      });
    });
    nodes.forEach((node) => {
      if (node.isCamera && !firstCamera) {
        debugLog("[SceneManager] Found camera in GLB:", {
          name: node.name,
          type: node.type,
          position: node.position.toArray(),
          quaternion: node.quaternion.toArray(),
          userData: node.userData
        });
        firstCamera = node;
      }
      if (node.isCamera) {
        debugLog("[SceneManager] Camera node:", {
          name: node.name,
          cameraAnchorIndex: node.userData?.cameraAnchorIndex,
          type: node.userData?.type,
          position: node.position.toArray()
        });
      } else if (node.isMesh) {
        node.geometry.computeBoundingBox();
        node.geometry.computeBoundingSphere();
      }
      node.castShadow = node.userData.castShadow !== false;
      node.receiveShadow = node.userData.receiveShadow !== false;
      this.animationManager.parseAnimations(node);
      this.audioManager.parseSounds(node);
      const userDataCopy = { ...node.userData };
      let sceneZone = null;
      if (userDataCopy?.zone) {
        sceneZone = this.getOrCreateSceneZone(userDataCopy.zone);
      }
      this.parseNode(sceneZone, node);
    });
    if (this.waypoints.length === 0 && firstCamera) {
      debugLog("[SceneManager] No waypoints found, using fallback camera:", firstCamera.name);
      firstCamera.userData.cameraAnchorIndex = 1;
      this.addCameraAnchor(null, firstCamera);
    }
    debugLog("[SceneManager] After populateSceneZones:");
    debugLog("[SceneManager] Total waypoints:", this.waypoints.length);
    debugLog("[SceneManager] Total scene zones:", this.sceneZones.length);
    this.waypoints.forEach((wp, i2) => {
      debugLog(`[SceneManager] Waypoint[${i2}]:`, {
        index: wp.index,
        anchorName: wp.camera.anchor?.name,
        anchorPosition: wp.camera.anchor?.position?.toArray?.() || "none"
      });
    });
    this.sceneZones.sort((a5, b6) => a5.index - b6.index);
    this.waypoints.sort((a5, b6) => a5.index - b6.index);
    debugLog("[SceneManager] After sorting:");
    this.waypoints.forEach((wp, i2) => {
      debugLog(`[SceneManager] Waypoint[${i2}] (sorted):`, {
        index: wp.index,
        anchorPosition: wp.camera.anchor?.position?.toArray?.() || "none"
      });
    });
  }
  /**
   * Get or create a scene zone.
   * @private
   * @param {string} name - Zone name
   * @returns {SceneZone}
   */
  getOrCreateSceneZone(name) {
    let zone = this.sceneZones.find((z2) => z2.name.toLowerCase() === name.toLowerCase());
    if (!zone) {
      zone = this.createSceneZone(name);
    }
    return zone;
  }
  /**
   * Create a new scene zone.
   * @private
   * @param {string} name - Zone name
   * @returns {SceneZone}
   */
  createSceneZone(name) {
    const zone = {
      name,
      index: -1,
      camera: {
        anchor: null,
        target: new Box3(),
        targetPosition: new Vector3()
      },
      objects: {
        count: 0,
        interactables: []
      }
    };
    this.sceneZones.push(zone);
    return zone;
  }
  /**
   * Parse a scene node and add to appropriate collections.
   * @private
   * @param {SceneZone|null} sceneZone - Target zone
   * @param {THREE.Object3D} object - Node to parse
   */
  parseNode(sceneZone, object) {
    const { worldPosition, worldRotation } = this.getWorldData(object);
    if ("siteProperties" in object.userData) {
      this.parseSiteProperties(object);
      this.scene.remove(object);
      return;
    }
    if ("Media" in object.userData || "mediaType" in object.userData) {
      debugLog("[SceneManager] Found media object:", {
        name: object.name,
        hasMediaProperty: "Media" in object.userData,
        hasMediaType: "mediaType" in object.userData,
        mediaType: object.userData.mediaType,
        mediaSrc: object.userData.mediaSrc,
        mediaTrigger: object.userData.mediaTrigger
      });
      this.parseMediaObject(object, worldPosition, worldRotation);
      debugLog("[SceneManager] After parseMediaObject, object.userData.type:", object.userData.type);
    }
    if ("Physics" in object.userData) {
      object.userData.worldPosition = worldPosition;
      object.userData.worldRotation = worldRotation;
      this.physicsObjects.push(object);
    } else if (object.userData?.type === "interactable" || object.userData?.OnSelectAnimations || object.userData?.OnPointerEnterAnimations || object.userData?.OnPointerExitAnimations) {
      object.userData.type = "interactable";
      debugLog("[SceneManager] Adding interactable from parseNode:", object.name);
      this.addInteractable(sceneZone, object);
    } else if (object.userData?.type === "cameraAnchor") {
      const anchorIndex = object.userData.cameraAnchorIndex;
      if (object.isCamera && typeof anchorIndex === "number" && anchorIndex >= 1) {
        this.addCameraAnchor(sceneZone, object);
      } else {
        debugWarn("[SceneManager] Skipping invalid camera anchor:", {
          name: object.name,
          isCamera: object.isCamera,
          cameraAnchorIndex: anchorIndex,
          reason: !object.isCamera ? "not a camera" : "invalid index (must be >= 1)"
        });
      }
    }
    if (sceneZone && object.userData?.type !== "cameraAnchor") {
      const target = new Vector3();
      sceneZone.camera.target.expandByObject(object);
      sceneZone.camera.target.getCenter(target);
      sceneZone.camera.targetPosition = target;
      sceneZone.objects.count++;
    }
  }
  /**
   * Parse site properties from object userData.
   * @private
   * @param {THREE.Object3D} object - Object with site properties
   */
  parseSiteProperties(object) {
    const userData = object.userData;
    this.siteData = { ...userData };
    Object.assign(this.siteData, {
      siteTitle: userData.siteTitle || "",
      siteAuthor: userData.siteAuthor || "",
      siteDescription: userData.siteDescription || "",
      siteURL: userData.siteURL || "",
      siteIconURL: userData.siteIconURL || "favicon.ico",
      splashScreenActive: userData.splashActive,
      splashScreenTitle: userData.splashTitle,
      splashScreenBody: userData.splashBody,
      splashScreenButton: userData.splashButton
    });
    if (userData.worldConfig) {
      let bgColor = userData.background_color;
      if (bgColor && typeof bgColor === "object" && "0" in bgColor && "1" in bgColor && "2" in bgColor) {
        bgColor = [bgColor[0], bgColor[1], bgColor[2]];
      }
      this.siteData.worldConfig = {
        environmentTexture: userData.environment_texture,
        background: userData.background,
        backgroundColor: bgColor,
        environmentIntensity: userData.environment_intensity
      };
    }
  }
  /**
   * Parse a media object (video, audio, positional audio).
   * @private
   */
  parseMediaObject(object, worldPosition, worldRotation) {
    const userData = object.userData;
    const mediaData = {
      object,
      worldPosition,
      worldRotation,
      mediaSrc: userData.mediaSrc,
      mediaTrigger: userData.mediaTrigger,
      volume: userData.mediaVolume ?? 1,
      audioPosition: userData.mediaAudioPosition ?? "Global"
    };
    switch (userData.mediaType) {
      case "Audio":
      case "3DPositionalAudio":
        this.mediaObjects.audio.push(mediaData);
        this.markAudioAsInteractable(object, userData);
        break;
      case "Video":
        object.visible = false;
        this.mediaObjects.video.push(mediaData);
        break;
      default:
        debugLog("[SceneManager] Unknown mediaType:", userData.mediaType);
    }
  }
  /**
   * Mark an audio object as interactable if it has a click/hover trigger.
   * @private
   */
  markAudioAsInteractable(object, userData) {
    const isInteractive = userData.mediaTrigger === "OnSelect" || userData.mediaTrigger === "OnPointerEnter";
    if (isInteractive) {
      object.userData.type = object.userData.type || "interactable";
      object.userData.interactableData = object.userData.interactableData || "audio";
    }
  }
  /**
   * Get world position and rotation for an object.
   * @private
   * @param {THREE.Object3D} object - Target object
   * @returns {{ worldPosition: THREE.Vector3, worldRotation: THREE.Quaternion }}
   */
  getWorldData(object) {
    const worldPosition = new Vector3();
    object.getWorldPosition(worldPosition);
    const worldRotation = new Quaternion();
    object.getWorldQuaternion(worldRotation);
    const worldScale = new Vector3();
    object.getWorldScale(worldScale);
    return { worldPosition, worldRotation, worldScale };
  }
  /**
   * Add a camera anchor to a scene zone.
   * @private
   * @param {SceneZone|null} sceneZone - Target zone
   * @param {THREE.Object3D} anchorObject - Camera anchor object
   */
  addCameraAnchor(sceneZone, anchorObject) {
    const cameraAnchorIndex = anchorObject.userData.cameraAnchorIndex;
    const keepContentInFrame = anchorObject.userData.keepContentInFrame || false;
    anchorObject.visible = false;
    debugLog("[SceneManager] addCameraAnchor:", {
      name: anchorObject.name,
      anchorObject,
      cameraAnchorIndex,
      keepContentInFrame,
      position: anchorObject.position.toArray(),
      quaternion: anchorObject.quaternion.toArray(),
      zoneName: sceneZone?.name || "no zone"
    });
    if (sceneZone) {
      sceneZone.index = cameraAnchorIndex;
      sceneZone.camera.anchor = anchorObject;
      sceneZone.keepContentInFrame = keepContentInFrame;
    }
    this.waypoints.push({
      index: cameraAnchorIndex,
      keepContentInFrame,
      camera: {
        anchor: anchorObject,
        target: new Box3(),
        targetPosition: new Vector3()
      }
    });
  }
  /**
   * Add an interactable object to a scene zone.
   * @private
   * @param {SceneZone|null} sceneZone - Target zone
   * @param {THREE.Object3D} object - Interactable object
   */
  addInteractable(sceneZone, object) {
    const { worldPosition, worldRotation, worldScale } = this.getWorldData(object);
    if (!sceneZone) {
      sceneZone = this.getOrCreateSceneZone(DEFAULT_INTERACTABLE_ZONE);
      sceneZone.camera.anchor = object;
      object.userData.zone = DEFAULT_INTERACTABLE_ZONE;
    }
    const ensureArray = (val) => {
      if (Array.isArray(val)) return val;
      if (typeof val === "string") {
        return val.split(",").map((s2) => s2.trim()).filter(Boolean);
      }
      return [];
    };
    object.children.forEach((child) => {
      child.traverse((node) => {
        node.userData.name = node.name;
        node.userData.type = object.userData.type;
        node.userData.interactableType = object.userData.interactableType;
        node.userData.interactableData = object.userData.interactableData;
        node.userData.OnSelectAnimations = ensureArray(object.userData.OnSelectAnimations);
        node.userData.OnPointerEnterAnimations = ensureArray(object.userData.OnPointerEnterAnimations);
        node.userData.OnPointerExitAnimations = ensureArray(object.userData.OnPointerExitAnimations);
        node.userData.mediaTrigger = object.userData.mediaTrigger;
        if (!object.userData.zone) {
          node.userData.zone = DEFAULT_INTERACTABLE_ZONE;
        }
      });
    });
    object.userData.OnSelectAnimations = ensureArray(object.userData.OnSelectAnimations);
    object.userData.OnPointerEnterAnimations = ensureArray(object.userData.OnPointerEnterAnimations);
    object.userData.OnPointerExitAnimations = ensureArray(object.userData.OnPointerExitAnimations);
    const rotation = new Euler().setFromQuaternion(worldRotation);
    sceneZone.objects.interactables.push({
      object,
      worldPosition,
      rotation,
      scale: worldScale
    });
  }
  /**
   * Fix empty scene zones by calculating camera targets from anchors.
   * @private
   */
  fixEmptyZones() {
    this.sceneZones.forEach((zone) => {
      if (zone.objects.count !== 0) return;
      if (!zone.camera.target.isEmpty()) return;
      const anchor = zone.camera.anchor;
      if (!anchor) return;
      const direction = new Vector3(0, 0, -1);
      direction.applyQuaternion(anchor.quaternion);
      const targetPosition = new Vector3();
      targetPosition.copy(direction).add(anchor.position);
      zone.camera.targetPosition = targetPosition;
      zone.camera.target.setFromCenterAndSize(targetPosition, new Vector3(1, 1, 1));
    });
  }
  /**
   * Fix waypoints by updating target positions and bounding boxes.
   * @private
   */
  fixWaypoints() {
    this.waypoints.forEach((waypoint) => {
      const sceneZone = this.getSceneZoneByIndex(waypoint.index);
      if (sceneZone) {
        waypoint.camera.targetPosition = sceneZone.camera.targetPosition;
        waypoint.camera.target = sceneZone.camera.target;
        if (waypoint.camera.target.isEmpty()) {
          debugLog("[SceneManager] fixWaypoints: SceneZone target is empty, calculating from visible meshes...");
          this.calculateFallbackBoundingBox(waypoint);
          if (sceneZone) {
            sceneZone.camera.target.copy(waypoint.camera.target);
            sceneZone.camera.targetPosition.copy(waypoint.camera.targetPosition);
          }
        } else {
          debugLog("[SceneManager] fixWaypoints: Linked waypoint to sceneZone:", {
            waypointIndex: waypoint.index,
            zoneName: sceneZone.name,
            targetPosition: waypoint.camera.targetPosition?.toArray?.() || "none",
            targetBoxEmpty: waypoint.camera.target?.isEmpty?.() ?? true,
            targetBoxMin: waypoint.camera.target?.min?.toArray?.() || "none",
            targetBoxMax: waypoint.camera.target?.max?.toArray?.() || "none"
          });
        }
      } else {
        const anchor = waypoint.camera.anchor;
        if (!anchor) return;
        const direction = new Vector3(0, 0, -1);
        direction.applyQuaternion(anchor.quaternion);
        const targetPosition = new Vector3();
        targetPosition.copy(direction).add(anchor.position);
        waypoint.camera.targetPosition = targetPosition;
        this.calculateFallbackBoundingBox(waypoint);
      }
    });
  }
  /**
   * Calculate a fallback bounding box for a waypoint from visible scene meshes.
   * @private
   * @param {Object} waypoint - The waypoint to calculate bounding box for
   */
  calculateFallbackBoundingBox(waypoint) {
    const allBox = new Box3();
    let meshCount = 0;
    this.scene.traverse((object) => {
      debugLog("[SceneManager] calculateFallbackBoundingBox: Traversing object:", {
        name: object.name,
        type: object.type,
        userData: object.userData,
        visible: object.visible,
        isMesh: object.isMesh
      });
      if (!object.isMesh) return;
      if (!object.visible) return;
      if (object.userData?.type === "cameraAnchor") return;
      if (object.name?.startsWith("_")) return;
      if (object.geometry) {
        object.geometry.computeBoundingBox();
        object.geometry.computeBoundingSphere();
        const localBox = object.geometry.boundingBox.clone();
        localBox.applyMatrix4(object.matrixWorld);
        allBox.union(localBox);
        meshCount++;
      }
    });
    if (!allBox.isEmpty()) {
      waypoint.camera.target = allBox;
      if (!waypoint.camera.targetPosition || waypoint.camera.targetPosition.equals(new Vector3())) {
        const center = new Vector3();
        allBox.getCenter(center);
        waypoint.camera.targetPosition = center;
      }
      waypoint.camera.target.isFallback = true;
      debugLog("[SceneManager] calculateFallbackBoundingBox: Computed from scene meshes:", {
        waypointIndex: waypoint.index,
        meshCount,
        targetBoxMin: allBox.min.toArray().map((v3) => v3.toFixed(2)),
        targetBoxMax: allBox.max.toArray().map((v3) => v3.toFixed(2))
      });
    } else {
      const defaultSize = new Vector3(2, 2, 2);
      const targetPos = waypoint.camera.targetPosition || new Vector3();
      waypoint.camera.target = new Box3();
      waypoint.camera.target.setFromCenterAndSize(targetPos, defaultSize);
      waypoint.camera.target.isFallback = true;
      debugLog("[SceneManager] calculateFallbackBoundingBox: No meshes found, using default box:", {
        waypointIndex: waypoint.index,
        targetPosition: targetPos.toArray(),
        targetBoxMin: waypoint.camera.target.min.toArray(),
        targetBoxMax: waypoint.camera.target.max.toArray()
      });
    }
  }
  /**
   * Fix scene zones by adjusting camera positions.
   * @private
   */
  fixZones() {
    this.fixEmptyZones();
    this.sceneZones.forEach((zone) => {
      if (zone.objects.count === 0 || !zone.camera.anchor) return;
      const { position } = zone.camera.anchor;
      const target = zone.camera.targetPosition;
      const targetBox = zone.camera.target;
      this.controls.camera.fov = zone.camera.anchor.fov;
      this.controls.camera.near = zone.camera.anchor.near;
      this.controls.camera.far = zone.camera.anchor.far;
      this.controls.camera.updateProjectionMatrix();
      this.controls.update(0);
      let camDist = 0;
      if (zone.keepContentInFrame) {
        this.controls.fitToBox(targetBox, false);
        this.controls.update(0);
        camDist = this.controls.camera.position.distanceTo(target) * CAMERA_FRAMING_PADDING;
      }
      this.orbitCameraTo(position, target, camDist);
      this.controls.update(0);
      zone.camera.anchor.position.copy(this.controls.camera.position);
      zone.camera.anchor.fov = this.controls.camera.fov;
      zone.camera.anchor.near = this.controls.camera.near;
      zone.camera.anchor.far = this.controls.camera.far;
      const waypoint = this.waypoints.find((w2) => w2.index === zone.index);
      if (waypoint) {
        waypoint.camera.anchor.position.copy(this.controls.camera.position);
        waypoint.camera.targetPosition = zone.camera.targetPosition;
        waypoint.camera.anchor.fov = zone.camera.anchor.fov;
        waypoint.camera.anchor.near = zone.camera.anchor.near;
        waypoint.camera.anchor.far = zone.camera.anchor.far;
      }
    });
    const firstWaypoint = this.waypoints[0];
    debugLog("[SceneManager] fixZones - Setting initial camera:");
    debugLog("[SceneManager] First waypoint:", firstWaypoint ? {
      index: firstWaypoint.index,
      anchorName: firstWaypoint.camera.anchor?.name,
      anchorPosition: firstWaypoint.camera.anchor?.position?.toArray?.() || "none",
      targetPosition: firstWaypoint.camera.targetPosition?.toArray?.() || "none"
    } : "NO WAYPOINT FOUND");
    if (firstWaypoint) {
      debugLog("[SceneManager] Calling orbitCameraTo with:", {
        position: firstWaypoint.camera.anchor.position.toArray(),
        target: firstWaypoint.camera.targetPosition.toArray()
      });
      this.orbitCameraTo(
        firstWaypoint.camera.anchor.position,
        firstWaypoint.camera.targetPosition,
        1,
        false
      );
      debugLog("[SceneManager] Camera position after orbitCameraTo:", this.controls.camera.position.toArray());
    }
  }
  /**
   * Orbit camera to a position looking at a target.
   * @private
   * @param {THREE.Vector3} positionTarget - Desired camera position
   * @param {THREE.Vector3} lookTarget - Look-at target
   * @param {number} camDist - Camera distance
   * @param {boolean} damp - Enable damping
   */
  orbitCameraTo(positionTarget, lookTarget, camDist = 0, damp5 = false) {
    const camDistThreshold = positionTarget.distanceTo(lookTarget);
    if (camDist < camDistThreshold) {
      camDist = camDistThreshold;
    }
    const newPosition = positionTarget.clone().sub(lookTarget).setLength(camDist).add(lookTarget);
    if (!this.controls) return;
    this.controls.setLookAt(...newPosition.toArray(), ...lookTarget.toArray(), damp5);
  }
}
const basicLerp = (start2, end, t2) => start2 * (1 - t2) + end * t2;
class CameraManager {
  // Pre-allocated reusable objects to avoid GC pressure during scroll
  _slerpTempMatrix = new Matrix4();
  _slerpTempUp = new Vector3(0, 1, 0);
  _slerpTempForward = new Vector3();
  _slerpQStart = new Quaternion();
  _slerpQEnd = new Quaternion();
  _slerpQResult = new Quaternion();
  _slerpInterpolatedPos = new Vector3();
  _slerpInterpolatedTarget = new Vector3();
  constructor(sceneManager, controls, camera, scroll = null) {
    this.scroll = scroll;
    this.sceneManager = sceneManager;
    this.controls = controls;
    this.camera = camera;
    this.busy = false;
    this.hasUserScrolled = false;
    this.scrollOffset = 0;
    this.currentWaypoint = null;
    this.needsAdjustedPositionUpdate = true;
    this._resizeTimeout = null;
    this._handleResize = this._handleResize.bind(this);
    window.addEventListener("resize", this._handleResize);
    this._handleScroll = this._handleScroll.bind(this);
    if (this.scroll && this.scroll.el) {
      this.scroll.el.addEventListener("scroll", this._handleScroll);
    }
    this.goToSceneZoneByIndex(0);
    setTimeout(() => this.recalculateAdjustedPositions(), 100);
  }
  /**
   * Internal scroll event handler
   */
  _handleScroll() {
    if (this.busy || !this.scroll || !this.scroll.el) return;
    this.hasUserScrolled = true;
    this.scrollOffset = this.scroll.el.scrollTop / this.scroll.el.scrollHeight;
  }
  /**
   * Update scroll object reference (Drei ScrollControls may recreate state on resize).
   */
  setScroll(scroll) {
    if (this.scroll !== scroll) {
      if (this.scroll && this.scroll.el) {
        this.scroll.el.removeEventListener("scroll", this._handleScroll);
      }
      this.scroll = scroll;
      if (this.scroll && this.scroll.el) {
        this.scroll.el.addEventListener("scroll", this._handleScroll);
        this._handleScroll();
      }
    }
  }
  /**
   * Set scroll position to a percentage of total scrollable height.
   */
  setScrollPercentage(element, percentage) {
    const totalHeight = element.scrollHeight - element.clientHeight;
    element.scrollTop = percentage * totalHeight;
  }
  /**
   * Navigate to a scene zone by array index.
   */
  goToSceneZoneByIndex(index, block = true) {
    if (block && this.busy) return;
    if (index < 0 || index >= this.sceneManager.waypoints.length) return;
    this.busy = true;
    const sceneZone = this.sceneManager.waypoints[index];
    if (!sceneZone) {
      debugLog("[CameraManager] Scene zone not found, index:", index);
      this.busy = false;
      return;
    }
    this.goToSceneZone(sceneZone);
    this.setCurrentWaypoint(sceneZone);
    if (!block) this.busy = false;
  }
  /**
   * Navigate to a scene zone by name.
   */
  goToSceneZoneByName(name) {
    if (this.busy || !this.camera || !this.sceneManager) return;
    this.busy = true;
    const sceneZone = this.sceneManager.getSceneZone(name);
    if (!sceneZone) {
      debugLog("[CameraManager] Scene zone not found:", name);
      this.busy = false;
      return;
    }
    this.goToSceneZone(sceneZone);
    this.setCurrentWaypoint(sceneZone);
  }
  /**
   * Smoothly navigate camera to a scene zone.
   */
  goToSceneZone(sceneZone) {
    if (!sceneZone) return;
    if (!this.controls) return;
    this.hasUserScrolled = false;
    if (this.scroll) {
      const waypointArrayIndex = this.sceneManager.waypoints.indexOf(sceneZone);
      const waypointCount = this.sceneManager.waypoints.length;
      const scrollTargetOffset = waypointCount > 1 ? waypointArrayIndex / (waypointCount - 1) : 0;
      this.setScrollPercentage(this.scroll.el, scrollTargetOffset);
    }
    let position = sceneZone.camera.anchor?.position;
    if (!position) return;
    const target = sceneZone.camera.targetPosition;
    position = this.getAdjustedPositionForZone(sceneZone, position, target);
    if (isDebugMode) {
      const debugBox = this.calculateZoneBoundingBox(sceneZone);
      this.showDebugBoundingBox(sceneZone, debugBox, true);
    }
    this.updateCameraProperties(sceneZone);
    this.controls.setLookAt(...position, ...target, true).then(() => {
      this.busy = false;
    });
  }
  /**
   * Get adjusted position for a zone, handling keepContentInFrame.
   */
  getAdjustedPositionForZone(sceneZone, position, target) {
    const waypoint = this.sceneManager.waypoints.find((w2) => w2.index === sceneZone.index);
    if (waypoint) {
      return this.getAdjustedPosition(waypoint);
    }
    if (!sceneZone.keepContentInFrame) return position;
    const targetBox = this.calculateZoneBoundingBox(sceneZone);
    if (!targetBox || targetBox.isEmpty()) return position;
    const currentDist = position.distanceTo(target);
    const fittedDist = this.calculateDistanceToFitBox(targetBox, sceneZone.camera.anchor.fov, null, 1.15);
    if (fittedDist > currentDist) {
      const direction = new Vector3().subVectors(position, target).normalize();
      return target.clone().add(direction.multiplyScalar(fittedDist));
    }
    return position;
  }
  /**
   * Update camera FOV, near, and far properties directly.
   */
  updateCameraProperties(sceneZone) {
    if (sceneZone.camera.anchor.fov) this.controls.camera.fov = sceneZone.camera.anchor.fov;
    if (sceneZone.camera.anchor.near) this.controls.camera.near = sceneZone.camera.anchor.near;
    if (sceneZone.camera.anchor.far) this.controls.camera.far = sceneZone.camera.anchor.far || 1e4;
    this.controls.camera.updateProjectionMatrix();
    this.controls.update(0);
  }
  /**
   * Handle scroll-based camera interpolation between waypoints.
   */
  scrollHandler() {
    if (!this.scroll || !this.hasUserScrolled || this.busy) return;
    const scaledScrollOffset = this.scrollOffset * (this.sceneManager.waypoints.length - 1);
    const currentZoneIndex = Math.floor(scaledScrollOffset);
    const nextZoneIndex = Math.ceil(scaledScrollOffset);
    const currentZone = this.sceneManager.waypoints[currentZoneIndex];
    const nextZone = this.sceneManager.waypoints[nextZoneIndex];
    if (!currentZone || !nextZone) return;
    const percent = scaledScrollOffset % 1;
    this.interpolateCameraPosition(currentZone, nextZone, percent);
    this.interpolateCameraProperties(currentZone, nextZone, percent);
  }
  /**
   * Interpolate camera position between two waypoints.
   */
  interpolateCameraPosition(currentZone, nextZone, percent) {
    const currentPos = this.getAdjustedPosition(currentZone);
    const nextPos = this.getAdjustedPosition(nextZone);
    this._slerpInterpolatedPos.copy(currentPos).lerp(nextPos, percent);
    this._slerpQStart.copy(currentZone.camera.anchor.quaternion);
    this._slerpQEnd.copy(nextZone.camera.anchor.quaternion);
    this._slerpQResult.copy(this._slerpQStart).slerp(this._slerpQEnd, percent);
    const currentTarget = currentZone.camera.targetPosition;
    const nextTarget = nextZone.camera.targetPosition;
    const distStart = currentPos.distanceTo(currentTarget);
    const distEnd = nextPos.distanceTo(nextTarget);
    const distResult = basicLerp(distStart, distEnd, percent);
    this._slerpTempForward.set(0, 0, -1).applyQuaternion(this._slerpQResult);
    this._slerpInterpolatedTarget.copy(this._slerpInterpolatedPos).add(
      this._slerpTempForward.multiplyScalar(distResult)
    );
    this.controls.setLookAt(
      this._slerpInterpolatedPos.x,
      this._slerpInterpolatedPos.y,
      this._slerpInterpolatedPos.z,
      this._slerpInterpolatedTarget.x,
      this._slerpInterpolatedTarget.y,
      this._slerpInterpolatedTarget.z,
      true
    );
  }
  /**
   * Interpolate camera FOV, near, far between two waypoints.
   */
  interpolateCameraProperties(currentZone, nextZone, percent) {
    const fov2 = basicLerp(currentZone.camera.anchor.fov || 50, nextZone.camera.anchor.fov || 50, percent);
    const near = basicLerp(currentZone.camera.anchor.near || 0.1, nextZone.camera.anchor.near || 0.1, percent);
    const far = basicLerp(currentZone.camera.anchor.far || 1e4, nextZone.camera.anchor.far || 1e4, percent);
    this.controls.camera.fov = fov2;
    this.controls.camera.near = near;
    this.controls.camera.far = far;
    this.controls.camera.updateProjectionMatrix();
    this.controls.update(0);
  }
  update() {
    let forceUpdate = false;
    if (this.needsAdjustedPositionUpdate) {
      this.recalculateAdjustedPositions();
      forceUpdate = true;
    }
    if (this.scroll) {
      if (this.scroll.delta > 1e-5) {
        this.hasUserScrolled = true;
        this.scrollOffset = this.scroll.offset;
        this.scrollHandler();
        this.updateCurrentWaypointFromScroll();
      } else if (forceUpdate && this.hasUserScrolled) {
        debugLog("[CameraManager] Force updating camera position due to resize");
        this.scrollHandler();
      }
    }
  }
  /**
   * Set the current waypoint.
   * @param {Object} waypoint - The current waypoint/zone
   */
  setCurrentWaypoint(waypoint) {
    this.currentWaypoint = waypoint;
  }
  /**
   * Update current waypoint based on scroll position.
   * @private
   */
  updateCurrentWaypointFromScroll() {
    if (!this.sceneManager.waypoints.length) return;
    const scaledScrollOffset = this.scrollOffset * (this.sceneManager.waypoints.length - 1);
    const currentZoneIndex = Math.round(scaledScrollOffset);
    const waypoint = this.sceneManager.waypoints[currentZoneIndex];
    if (waypoint && waypoint !== this.currentWaypoint) {
      this.setCurrentWaypoint(waypoint);
    }
  }
  /**
   * Adjust camera position to keep current zone's content within the camera frustum.
   * Only runs when keepContentInFrame is enabled for the current waypoint.
   */
  keepContentInFrame() {
    if (this.busy) return;
    if (!this.currentWaypoint) return;
    if (!this.currentWaypoint.keepContentInFrame) return;
    const sceneZone = this.sceneManager.getSceneZoneByIndex(this.currentWaypoint.index);
    if (!sceneZone) return;
    const targetBox = this.calculateZoneBoundingBox(sceneZone);
    if (isDebugMode) {
      this.showDebugBoundingBox(sceneZone, targetBox, true);
    }
    if (!targetBox || targetBox.isEmpty()) return;
    const currentPosition = new Vector3();
    this.controls.getPosition(currentPosition);
    const currentTarget = new Vector3();
    this.controls.getTarget(currentTarget);
    const requiredDistance = this.calculateDistanceToFitBox(
      targetBox,
      this.camera.fov,
      this.camera.aspect,
      1.5
      // 50% padding
    );
    const currentDistance = currentPosition.distanceTo(currentTarget);
    if (requiredDistance > currentDistance) {
      debugLog(
        "[CameraManager] Keep-in-frame: adjusting camera distance from",
        currentDistance.toFixed(2),
        "to",
        requiredDistance.toFixed(2)
      );
      const direction = new Vector3().subVectors(currentPosition, currentTarget).normalize();
      const newPosition = currentTarget.clone().add(direction.multiplyScalar(requiredDistance));
      this.controls.setLookAt(
        newPosition.x,
        newPosition.y,
        newPosition.z,
        currentTarget.x,
        currentTarget.y,
        currentTarget.z,
        true
        // Enable smooth transition
      );
    }
  }
  /**
   * Calculate the bounding box of all visible objects in a scene zone.
   * @param {Object} sceneZone - The scene zone
   * @returns {THREE.Box3} The bounding box of all zone objects
   */
  calculateZoneBoundingBox(sceneZone) {
    if (!this.sceneManager.scene) return new Box3();
    this.sceneManager.scene.updateMatrixWorld(true);
    const zoneBox = this.calculateBoxForZone(sceneZone.name);
    if (!zoneBox.isEmpty()) return zoneBox;
    if (sceneZone.camera?.target && !sceneZone.camera.target.isEmpty()) {
      return sceneZone.camera.target;
    }
    return this.calculateBoxForAllMeshes();
  }
  /**
   * Calculate bounding box for objects belonging to a specific zone.
   * @private
   */
  calculateBoxForZone(zoneName) {
    const box = new Box3();
    this.sceneManager.scene.traverse((object) => {
      if (!object.isMesh || !object.visible) return;
      const objectZone = this.getObjectZone(object);
      if (objectZone === zoneName) {
        this.expandBoxWithWorldGeometry(box, object);
      }
    });
    return box;
  }
  /**
   * Get the zone name for an object, checking ancestors if needed.
   * @private
   */
  getObjectZone(object) {
    let zone = object.userData?.zone;
    if (zone) return zone;
    object.traverseAncestors((ancestor) => {
      if (!zone && ancestor.userData?.zone) {
        zone = ancestor.userData.zone;
      }
    });
    return zone;
  }
  /**
   * Calculate bounding box from all visible meshes in scene.
   * @private
   */
  calculateBoxForAllMeshes() {
    const box = new Box3();
    this.sceneManager.scene.traverse((object) => {
      if (!object.isMesh || !object.visible) return;
      if (object.userData?.type === "cameraAnchor") return;
      if (object.name?.startsWith("_")) return;
      this.expandBoxWithWorldGeometry(box, object);
    });
    return box;
  }
  /**
   * Expand a bounding box using world-space geometry vertices.
   * This is more accurate than expandByObject for animated/skinned meshes.
   * @param {THREE.Box3} box - The box to expand
   * @param {THREE.Mesh} mesh - The mesh to include
   */
  expandBoxWithWorldGeometry(box, mesh) {
    if (!mesh.geometry) {
      box.expandByObject(mesh);
      return;
    }
    const geometry = mesh.geometry;
    geometry.computeBoundingBox();
    geometry.computeBoundingSphere();
    const localBox = geometry.boundingBox.clone();
    const worldMatrix = mesh.matrixWorld;
    localBox.applyMatrix4(worldMatrix);
    box.union(localBox);
  }
  /**
   * Create a debug wireframe box helper for visualizing bounding boxes.
   * @param {THREE.Color|number} color - The color for the wireframe
   * @param {string} name - Unique name for the helper object
   * @returns {THREE.LineSegments} The wireframe box helper
   */
  createDebugBox(color = 65280, name = "debugBox") {
    const geometry = new BoxGeometry(1, 1, 1);
    const edges = new EdgesGeometry(geometry);
    const material = new LineBasicMaterial({
      color,
      linewidth: 2,
      transparent: true,
      opacity: 0.8
    });
    const wireframe = new LineSegments(edges, material);
    wireframe.name = `_CameraManager_${name}`;
    wireframe.visible = false;
    wireframe.raycast = () => {
    };
    wireframe.userData = { ignoreRaycast: true, isDebugBox: true };
    wireframe.renderOrder = 9999;
    return wireframe;
  }
  /**
   * Update debug box to match a bounding box.
   * @param {THREE.LineSegments} debugBox - The debug box mesh
   * @param {THREE.Box3} boundingBox - The bounding box to match
   */
  updateDebugBox(debugBox, boundingBox) {
    if (!debugBox || !boundingBox || boundingBox.isEmpty()) return;
    const center = new Vector3();
    const size = new Vector3();
    boundingBox.getCenter(center);
    boundingBox.getSize(size);
    debugBox.position.copy(center);
    debugBox.scale.copy(size);
  }
  /**
   * Show visual debugging for the current zone's bounding box.
   * Creates or updates a wireframe box in the scene.
   * @param {Object} sceneZone - The scene zone to debug
   * @param {THREE.Box3} boundingBox - The bounding box to visualize
   * @param {boolean} isVisible - Whether to show the debug box
   */
  showDebugBoundingBox(sceneZone, boundingBox, isVisible = true) {
    if (!this.sceneManager?.scene) return;
    if (sceneZone.name?.startsWith("_default")) return;
    if (boundingBox?.isFallback) return;
    const boxName = `keepInFrame_${sceneZone.index || 0}`;
    let debugBox = this.sceneManager.scene.getObjectByName(`_CameraManager_${boxName}`);
    if (!debugBox) {
      let color = 65280;
      sceneZone.name;
      if (sceneZone.color) {
        color = new Color(sceneZone.color[0], sceneZone.color[1], sceneZone.color[2]);
      } else if (sceneZone.camera?.anchor?.userData?.zoneColor) {
        const zc = sceneZone.camera.anchor.userData.zoneColor;
        color = new Color(zc[0], zc[1], zc[2]);
      }
      debugBox = this.createDebugBox(color, boxName);
      this.sceneManager.scene.add(debugBox);
      debugLog("[CameraManager] Created debug box for zone:", {
        zoneName: sceneZone.name,
        zoneIndex: sceneZone.index,
        color
      });
    }
    this.updateDebugBox(debugBox, boundingBox);
    debugBox.visible = isVisible;
    if (boundingBox && !boundingBox.isEmpty()) {
      const size = new Vector3();
      const center = new Vector3();
      boundingBox.getSize(size);
      boundingBox.getCenter(center);
      debugLog("[CameraManager] Bounding box details:", {
        zoneName: sceneZone.name,
        center: center.toArray().map((v3) => v3.toFixed(2)),
        size: size.toArray().map((v3) => v3.toFixed(2)),
        min: boundingBox.min.toArray().map((v3) => v3.toFixed(2)),
        max: boundingBox.max.toArray().map((v3) => v3.toFixed(2))
      });
    } else {
      debugLog("[CameraManager] Bounding box is empty for zone:", sceneZone.name);
    }
  }
  /**
   * Hide all debug bounding boxes.
   */
  hideAllDebugBoxes() {
    if (!this.sceneManager?.scene) return;
    this.sceneManager.scene.traverse((object) => {
      if (object.name?.startsWith("_CameraManager_keepInFrame_")) {
        object.visible = false;
      }
    });
  }
  /**
   * Clean up resources (call when disposing the manager).
   */
  dispose() {
    window.removeEventListener("resize", this._handleResize);
    if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
  }
  /**
   * Handle window resize events.
   * Triggers recalculation of adjusted positions for keepContentInFrame zones.
   * @private
   */
  /**
   * Handle window resize events.
   * Triggers recalculation of adjusted positions for keepContentInFrame zones.
   * @private
   */
  _handleResize() {
    if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
    this._resizeTimeout = setTimeout(() => {
      debugLog("[CameraManager] Window resized (debounced), marking adjusted positions for update");
      this.needsAdjustedPositionUpdate = true;
    }, 2500);
  }
  /**
   * Recalculate adjusted anchor positions for all waypoints.
   * This should be called after resize or when content changes.
   * The adjusted positions account for keepContentInFrame fit-to-box calculations.
   */
  recalculateAdjustedPositions() {
    if (!this.sceneManager?.waypoints?.length) return;
    debugLog("[CameraManager] Recalculating adjusted positions for", this.sceneManager.waypoints.length, "waypoints");
    this.sceneManager.scene?.updateMatrixWorld?.(true);
    this.sceneManager.waypoints.forEach((waypoint, idx) => {
      const originalPosition = waypoint.camera.anchor?.position;
      if (!originalPosition) return;
      let adjustedPosition = originalPosition.clone();
      const target = waypoint.camera.targetPosition;
      if (waypoint.keepContentInFrame) {
        const sceneZone = this.sceneManager.getSceneZoneByIndex(waypoint.index);
        let targetBox = null;
        if (sceneZone) {
          targetBox = this.calculateZoneBoundingBox(sceneZone);
          if (isDebugMode) {
            this.showDebugBoundingBox(sceneZone, targetBox, true);
          }
        } else {
          targetBox = waypoint.camera.target;
          debugLog("[CameraManager] Waypoint", idx, "missing scene zone, using waypoint target box");
        }
        if (targetBox && !targetBox.isEmpty()) {
          const currentDist = originalPosition.distanceTo(target);
          const fittedDist = this.calculateDistanceToFitBox(
            targetBox,
            waypoint.camera.anchor.userData?.fov || waypoint.camera.anchor.fov,
            null,
            // Use current aspect ratio
            1.5
            // 50% padding
          );
          debugLog("[CameraManager] Waypoint", idx, "fit calc:", {
            zoneIndex: waypoint.index,
            currentDist: currentDist.toFixed(2),
            fittedDist: fittedDist.toFixed(2),
            fov: waypoint.camera.anchor.userData?.fov || waypoint.camera.anchor.fov,
            boxSize: new Vector3().copy(targetBox.max).sub(targetBox.min).toArray().map((v3) => v3.toFixed(2))
          });
          if (fittedDist > currentDist) {
            const direction = new Vector3().subVectors(originalPosition, target).normalize();
            adjustedPosition = target.clone().add(direction.multiplyScalar(fittedDist));
            debugLog(
              "[CameraManager] Waypoint",
              idx,
              "adjusted distance from",
              currentDist.toFixed(2),
              "to",
              fittedDist.toFixed(2)
            );
          }
        }
      }
      waypoint.camera.adjustedPosition = adjustedPosition;
      debugLog("[CameraManager] Waypoint", idx, "positions:", {
        zoneIndex: waypoint.index,
        original: originalPosition.toArray().map((v3) => v3.toFixed(2)),
        adjusted: adjustedPosition.toArray().map((v3) => v3.toFixed(2)),
        keepContentInFrame: waypoint.keepContentInFrame,
        targetPos: target.toArray().map((v3) => v3.toFixed(2))
      });
    });
    this.needsAdjustedPositionUpdate = false;
    debugLog("[CameraManager] Adjusted positions calculation complete");
  }
  /**
   * Get the adjusted position for a waypoint.
   * Falls back to original anchor position if no adjustment is needed/available.
   * @param {Object} waypoint - The waypoint
   * @returns {THREE.Vector3} The position to use for camera placement
   */
  getAdjustedPosition(waypoint) {
    if (this.needsAdjustedPositionUpdate) {
      this.recalculateAdjustedPositions();
    }
    return waypoint.camera.adjustedPosition || waypoint.camera.anchor?.position;
  }
  /**
   * Calculates the required camera distance to ensure all content inside
   * the scene zone is within the bounds of the camera frustum.
   * Uses the tangent of the camera's field of view to compute the optimal distance.
   * 
   * @param {Object} sceneZone - The scene zone to fit in the camera view
   * @param {number} padding - Optional padding multiplier (default 1.5 for 50% padding)
   * @param {boolean} enableTransition - Whether to animate the camera movement
   * @returns {Promise} Resolves when the camera has finished moving
   */
  fitCameraToSceneZone(sceneZone, padding = 1.5, enableTransition = true) {
    if (!sceneZone) {
      console.warn("CameraManager: No scene zone provided to fitCameraToSceneZone");
      return Promise.resolve();
    }
    const targetBox = sceneZone.camera?.target;
    if (!targetBox || targetBox.isEmpty()) {
      console.warn("CameraManager: Scene zone has no valid bounding box");
      return Promise.resolve();
    }
    const boxSize = new Vector3();
    targetBox.getSize(boxSize);
    const boxCenter = new Vector3();
    targetBox.getCenter(boxCenter);
    const camera = this.controls.camera;
    const fovRadians = MathUtils.degToRad(camera.fov);
    const aspect2 = camera.aspect;
    const halfFovV = fovRadians / 2;
    const distanceForHeight = boxSize.y / 2 / Math.tan(halfFovV);
    const halfFovH = Math.atan(Math.tan(halfFovV) * aspect2);
    const distanceForWidth = boxSize.x / 2 / Math.tan(halfFovH);
    const distanceForDepth = boxSize.z / 2;
    let requiredDistance = Math.max(distanceForHeight, distanceForWidth, distanceForDepth);
    requiredDistance *= padding;
    const cameraPosition = sceneZone.camera.anchor?.position;
    if (!cameraPosition) {
      console.warn("CameraManager: Scene zone has no camera anchor position");
      return Promise.resolve();
    }
    const targetPosition = sceneZone.camera.targetPosition;
    const direction = new Vector3();
    direction.subVectors(cameraPosition, targetPosition).normalize();
    const newCameraPosition = new Vector3();
    newCameraPosition.copy(targetPosition).add(direction.multiplyScalar(requiredDistance));
    if (this.controls) {
      return this.controls.setLookAt(
        newCameraPosition.x,
        newCameraPosition.y,
        newCameraPosition.z,
        targetPosition.x,
        targetPosition.y,
        targetPosition.z,
        enableTransition
      );
    }
    return Promise.resolve();
  }
  /**
   * Fits the camera to the currently active scene zone (based on scroll position).
   * 
   * @param {number} padding - Optional padding multiplier (default 1.5)
   * @param {boolean} enableTransition - Whether to animate the camera movement
   * @returns {Promise} Resolves when the camera has finished moving
   */
  fitCameraToCurrentSceneZone(padding = 1.5, enableTransition = true) {
    const scaledScrollOffset = this.scrollOffset * (this.sceneManager.waypoints.length - 1);
    const currentZoneIndex = Math.round(scaledScrollOffset);
    const currentZone = this.sceneManager.getSceneZoneByIndex(currentZoneIndex);
    if (!currentZone) {
      console.warn("CameraManager: Could not find current scene zone");
      return Promise.resolve();
    }
    return this.fitCameraToSceneZone(currentZone, padding, enableTransition);
  }
  /**
   * Calculates the optimal camera distance for a given bounding box and FOV.
   * This is a utility method that can be called externally for custom calculations.
   * 
   * @param {THREE.Box3} boundingBox - The bounding box to fit
   * @param {number} fov - Field of view in degrees
   * @param {number} aspect - Camera aspect ratio
   * @param {number} padding - Optional padding multiplier (default 1.0)
   * @returns {number} The required camera distance
   */
  calculateDistanceToFitBox(boundingBox, fov2 = null, aspect2 = null, padding = 1) {
    const camera = this.controls.camera;
    const fovDeg = fov2 ?? camera.fov;
    const aspectRatio = aspect2 ?? camera.aspect;
    const fovRadians = MathUtils.degToRad(fovDeg);
    const boxSize = new Vector3();
    boundingBox.getSize(boxSize);
    const halfFovV = fovRadians / 2;
    const distanceForHeight = boxSize.y / 2 / Math.tan(halfFovV);
    const halfFovH = Math.atan(Math.tan(halfFovV) * aspectRatio);
    const distanceForWidth = boxSize.x / 2 / Math.tan(halfFovH);
    const distanceForDepth = boxSize.z / 2;
    return Math.max(distanceForHeight, distanceForWidth, distanceForDepth) * padding;
  }
  /**
   * Performs a raycast from the camera through a screen position to find intersections.
   * @param {THREE.Vector2} mouse - Normalized mouse coordinates (-1 to 1)
   * @param {Array} objects - Array of objects to test for intersection (optional, defaults to scene children)
   * @returns {Array} Array of intersection results
   */
  raycastFromMouse(mouse, objects = null) {
    if (!this.camera || !this.sceneManager?.scene) return [];
    const raycaster = new Raycaster();
    raycaster.setFromCamera(mouse, this.camera);
    const intersectObjects = objects || this.sceneManager.scene.children;
    return raycaster.intersectObjects(intersectObjects, true);
  }
  /**
   * Moves the camera target to a specific 3D point with smooth animation.
   * @param {THREE.Vector3} targetPoint - The point to move the camera target to
   * @param {boolean} animate - Whether to animate the movement (default: true)
   * @returns {Promise} Promise that resolves when the movement is complete
   */
  moveCameraTargetTo(targetPoint, animate = true) {
    if (!this.controls || this.busy) return Promise.resolve();
    debugLog("[CameraManager] Moving camera target to:", targetPoint.toArray());
    this.busy = true;
    const currentPosition = new Vector3();
    this.controls.getPosition(currentPosition);
    const currentTarget = new Vector3();
    this.controls.getTarget(currentTarget);
    if (animate) {
      return this.controls.setLookAt(
        currentPosition.x,
        currentPosition.y,
        currentPosition.z,
        targetPoint.x,
        targetPoint.y,
        targetPoint.z,
        true
      ).then(() => {
        debugLog("[CameraManager] Camera target movement completed");
        this.busy = false;
      }).catch((error2) => {
        debugLog("[CameraManager] Camera target movement failed:", error2);
        this.busy = false;
      });
    } else {
      this.controls.setLookAt(
        currentPosition.x,
        currentPosition.y,
        currentPosition.z,
        targetPoint.x,
        targetPoint.y,
        targetPoint.z,
        false
      );
      this.busy = false;
      return Promise.resolve();
    }
  }
  /**
   * Handles double-click interaction by raycasting and moving camera target.
   * @param {THREE.Vector2} mouse - Normalized mouse coordinates (-1 to 1)
   */
  handleDoubleClick(mouse) {
    const intersections = this.raycastFromMouse(mouse);
    if (intersections.length > 0) {
      const hitPoint = intersections[0].point;
      debugLog("[CameraManager] Double-click hit at:", hitPoint.toArray());
      this.moveCameraTargetTo(hitPoint);
    }
  }
}
class InteractionManager {
  /** @type {Array} List of interactable objects */
  interactables = [];
  /** @type {Function} Function to show/hide popup */
  setShowPopup = null;
  /** @type {Function} Function to set popup content */
  setPopupContent = null;
  /** @type {Function} Function to navigate to a scene zone */
  goToSceneZone = null;
  /** @type {Function} Function to play an animation */
  playAnimation = null;
  /** @type {Function} Function to play a sound */
  playSound = null;
  constructor(setShowPopup, setPopupContent, goToSceneZone, playAnimation, playSound) {
    this.interactables = [];
    this.setShowPopup = setShowPopup;
    this.setPopupContent = setPopupContent;
    this.goToSceneZone = goToSceneZone;
    this.playAnimation = playAnimation;
    this.playSound = playSound;
    this.videoSubscribers = /* @__PURE__ */ new Set();
    this.audioSubscribers = /* @__PURE__ */ new Set();
  }
  subscribeToVideoTrigger(callback) {
    this.videoSubscribers.add(callback);
    return () => this.videoSubscribers.delete(callback);
  }
  notifyVideoTrigger(name) {
    this.videoSubscribers.forEach((cb) => {
      try {
        cb(name);
      } catch (e2) {
        debugError("[InteractionManager] Video subscriber error:", e2);
      }
    });
  }
  subscribeToAudioTrigger(callback) {
    this.audioSubscribers.add(callback);
    return () => this.audioSubscribers.delete(callback);
  }
  notifyAudioTrigger(name) {
    this.audioSubscribers.forEach((cb) => {
      try {
        cb(name);
      } catch (e2) {
        debugError("[InteractionManager] Audio subscriber error:", e2);
      }
    });
  }
  /**
   * Handle a click/tap interaction on an object.
   */
  handleInteraction = async (event, element) => {
    document.body.style.cursor = "pointer";
    event.stopPropagation();
    const userData = event.object.userData;
    const type = userData.interactableType;
    const data = userData.interactableData;
    const hasSoundTrigger = userData.mediaTrigger === "OnSelect";
    const animationPromises = this.playAnimationActions(userData.OnSelectAnimations);
    if (hasSoundTrigger) {
      const listener = element?.camera?.children?.find((c2) => c2.type === "AudioListener");
      if (listener?.context?.state === "suspended") {
        await listener.context.resume();
      }
      if (userData.mediaType === "Video") {
        this.notifyVideoTrigger(event.object.name);
      } else if (userData.mediaType === "Audio" || userData.mediaType === "3DPositionalAudio") {
        this.notifyAudioTrigger(event.object.name);
      } else {
        this.playSound(event.object);
      }
    }
    await Promise.all(animationPromises);
    this.performInteractionAction(type, data);
  };
  /**
   * Handle pointer enter (hover start).
   */
  handlePointerEnter = (event, element) => {
    const userData = event.object.userData;
    const isClickable = userData.interactableType || userData.OnSelectAnimations && userData.OnSelectAnimations.length > 0;
    if (isClickable) {
      document.body.style.cursor = "pointer";
    }
    this.playAnimationActions(userData.OnPointerEnterAnimations);
    if (userData.mediaTrigger === "OnPointerEnter") this.playSound(event.object);
  };
  /**
   * Handle pointer exit (hover end).
   */
  handlePointerExit = (event, element) => {
    document.body.style.cursor = "auto";
    const userData = event.object.userData;
    this.playAnimationActions(userData.OnPointerExitAnimations);
    if (userData.mediaTrigger === "OnPointerExit") this.playSound(event.object);
  };
  /** @private */
  playAnimationActions(actions) {
    if (!actions || !Array.isArray(actions)) return [];
    return actions.map((actionName) => this.playAnimation(actionName));
  }
  /** @private */
  performInteractionAction(type, data) {
    switch (type) {
      case "Popup HTML":
        this.setShowPopup(true);
        this.setPopupContent(data);
        break;
      case "Open Link":
        window.open(data, "_blank");
        break;
      case "Go To Scene Zone":
        this.goToSceneZone(data);
        break;
    }
  }
}
function DebugOverlay({ onDisable }) {
  reactExports.useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://markknol.github.io/console-log-viewer/console-log-viewer.js";
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 99999,
        border: "1px solid red",
        // distinctive debug border
        boxSizing: "border-box"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          style: {
            position: "absolute",
            top: "20px",
            left: "20px",
            pointerEvents: "auto",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            padding: "12px",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            color: "white",
            fontFamily: "monospace",
            border: "1px solid rgba(255, 255, 255, 0.2)"
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { fontWeight: "bold", color: "#ff4444" }, children: "DEBUG MODE" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "button",
              {
                onClick: onDisable,
                style: {
                  backgroundColor: "#333",
                  color: "white",
                  border: "1px solid #555",
                  padding: "6px 12px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px"
                },
                onMouseOver: (e2) => e2.target.style.backgroundColor = "#444",
                onMouseOut: (e2) => e2.target.style.backgroundColor = "#333",
                children: "Disable debug mode"
              }
            )
          ]
        }
      )
    }
  );
}
const WebCrafterContext = reactExports.createContext(null);
function WebCrafterProvider({ children, isDebugging: initialIsDebugging = false }) {
  const [sceneManager, setSceneManager] = reactExports.useState(null);
  const [cameraManager, setCameraManager] = reactExports.useState(null);
  const [interactionManager, setInteractionManager] = reactExports.useState(null);
  const [siteData, setSiteData] = reactExports.useState(null);
  const [api, setApi] = reactExports.useState(null);
  const [isLoaded, setIsLoaded] = reactExports.useState(false);
  const [loadingProgress, setLoadingProgress] = reactExports.useState(0);
  const [managersReady, setManagersReady] = reactExports.useState(false);
  const [isDebugging, setIsDebugging] = reactExports.useState(() => {
    if (typeof window !== "undefined") {
      const urlParams2 = new URLSearchParams(window.location.search);
      return urlParams2.get("debug") === "true" || initialIsDebugging;
    }
    return initialIsDebugging;
  });
  React.useEffect(() => {
    return () => {
      if (cameraManager && cameraManager.dispose) {
        cameraManager.dispose();
      }
    };
  }, [cameraManager]);
  const setManagers = reactExports.useCallback((newSceneManager, newCameraManager, newInteractionManager) => {
    setSceneManager(newSceneManager);
    setCameraManager(newCameraManager);
    setInteractionManager(newInteractionManager);
    if (newSceneManager) setSiteData(newSceneManager.getSiteData());
    setManagersReady(true);
  }, []);
  const initializeManagers = reactExports.useCallback(({
    scene,
    controls,
    animations,
    actions,
    mixer,
    camera,
    setShowPopup,
    setPopupContent,
    scrollState = null
  }) => {
    if (sceneManager) return;
    const newSceneManager = new SceneManager(scene, controls, animations, actions, mixer);
    const newCameraManager = new CameraManager(newSceneManager, controls, camera, scrollState);
    const newInteractionManager = new InteractionManager(
      setShowPopup,
      setPopupContent,
      newCameraManager.goToSceneZoneByName,
      newSceneManager.playAnimation,
      newSceneManager.playSound
    );
    setManagers(newSceneManager, newCameraManager, newInteractionManager);
    const siteData2 = newSceneManager.getSiteData();
    setApi({
      goToSceneZoneByIndex: newCameraManager.goToSceneZoneByIndex,
      goToSceneZoneByName: newCameraManager.goToSceneZoneByName,
      getSceneManager: () => newSceneManager,
      getCameraManager: () => newCameraManager,
      getInteractionManager: () => newInteractionManager,
      getSiteData: () => siteData2
    });
    setManagersReady(true);
  }, [sceneManager, setManagers]);
  React.useEffect(() => {
    if (!managersReady || !sceneManager || !cameraManager) return;
    const handleRoute = () => {
      let path = window.location.pathname.substring(1);
      if (path.endsWith("/")) path = path.slice(0, -1);
      path = decodeURIComponent(path);
      if (path && path.length > 0) {
        const zone = sceneManager.getSceneZone(path);
        if (zone) cameraManager.goToSceneZoneByName(zone.name);
        else cameraManager.goToSceneZoneByIndex(0);
      } else {
        cameraManager.goToSceneZoneByIndex(0);
      }
    };
    const t2 = setTimeout(handleRoute, 100);
    window.addEventListener("popstate", handleRoute);
    return () => {
      window.removeEventListener("popstate", handleRoute);
      clearTimeout(t2);
    };
  }, [managersReady, sceneManager, cameraManager]);
  const disableDebugMode = reactExports.useCallback(() => {
    setIsDebugging(false);
    if (typeof window !== "undefined") {
      const url = new URL(window.location);
      url.searchParams.delete("debug");
      window.history.replaceState({}, "", url);
    }
  }, []);
  const value = reactExports.useMemo(() => ({
    sceneManager,
    cameraManager,
    interactionManager,
    siteData,
    isDebugging,
    setManagers,
    initializeManagers,
    api,
    setApi,
    disableDebugMode,
    // Loading state
    isLoaded,
    setIsLoaded,
    loadingProgress,
    setLoadingProgress,
    managersReady
  }), [
    sceneManager,
    cameraManager,
    interactionManager,
    siteData,
    isDebugging,
    setManagers,
    initializeManagers,
    api,
    disableDebugMode,
    // Loading state dependencies
    isLoaded,
    loadingProgress,
    managersReady
  ]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(WebCrafterContext.Provider, { value, children: [
    children,
    isDebugging && /* @__PURE__ */ jsxRuntimeExports.jsx(DebugOverlay, { onDisable: disableDebugMode })
  ] });
}
function useWebCrafter() {
  const context4 = reactExports.useContext(WebCrafterContext);
  if (!context4) throw new Error("useWebCrafter must be used within a WebCrafterProvider");
  return context4;
}
function useInteractionManager() {
  return useWebCrafter().interactionManager;
}
function useSiteData() {
  return useWebCrafter().siteData;
}
function ProgressLoader() {
  const { progress } = useProgress();
  const {
    setLoadingProgress,
    setIsLoaded,
    managersReady,
    isLoaded
  } = useWebCrafter();
  reactExports.useEffect(() => {
    setLoadingProgress(Math.floor(progress));
    debugLog("[ProgressLoader] Progress:", progress, "ManagersReady:", managersReady, "IsLoaded:", isLoaded);
    if (progress === 100 && managersReady && !isLoaded) {
      debugLog("[ProgressLoader] Setting isLoaded to true");
      setIsLoaded(true);
    }
  }, [progress, managersReady, isLoaded, setLoadingProgress, setIsLoaded]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingScreen, { progress });
}
var reactFastCompare;
var hasRequiredReactFastCompare;
function requireReactFastCompare() {
  if (hasRequiredReactFastCompare) return reactFastCompare;
  hasRequiredReactFastCompare = 1;
  var hasElementType = typeof Element !== "undefined";
  var hasMap = typeof Map === "function";
  var hasSet = typeof Set === "function";
  var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
  function equal(a5, b6) {
    if (a5 === b6) return true;
    if (a5 && b6 && typeof a5 == "object" && typeof b6 == "object") {
      if (a5.constructor !== b6.constructor) return false;
      var length, i2, keys;
      if (Array.isArray(a5)) {
        length = a5.length;
        if (length != b6.length) return false;
        for (i2 = length; i2-- !== 0; )
          if (!equal(a5[i2], b6[i2])) return false;
        return true;
      }
      var it;
      if (hasMap && a5 instanceof Map && b6 instanceof Map) {
        if (a5.size !== b6.size) return false;
        it = a5.entries();
        while (!(i2 = it.next()).done)
          if (!b6.has(i2.value[0])) return false;
        it = a5.entries();
        while (!(i2 = it.next()).done)
          if (!equal(i2.value[1], b6.get(i2.value[0]))) return false;
        return true;
      }
      if (hasSet && a5 instanceof Set && b6 instanceof Set) {
        if (a5.size !== b6.size) return false;
        it = a5.entries();
        while (!(i2 = it.next()).done)
          if (!b6.has(i2.value[0])) return false;
        return true;
      }
      if (hasArrayBuffer && ArrayBuffer.isView(a5) && ArrayBuffer.isView(b6)) {
        length = a5.length;
        if (length != b6.length) return false;
        for (i2 = length; i2-- !== 0; )
          if (a5[i2] !== b6[i2]) return false;
        return true;
      }
      if (a5.constructor === RegExp) return a5.source === b6.source && a5.flags === b6.flags;
      if (a5.valueOf !== Object.prototype.valueOf && typeof a5.valueOf === "function" && typeof b6.valueOf === "function") return a5.valueOf() === b6.valueOf();
      if (a5.toString !== Object.prototype.toString && typeof a5.toString === "function" && typeof b6.toString === "function") return a5.toString() === b6.toString();
      keys = Object.keys(a5);
      length = keys.length;
      if (length !== Object.keys(b6).length) return false;
      for (i2 = length; i2-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(b6, keys[i2])) return false;
      if (hasElementType && a5 instanceof Element) return false;
      for (i2 = length; i2-- !== 0; ) {
        if ((keys[i2] === "_owner" || keys[i2] === "__v" || keys[i2] === "__o") && a5.$$typeof) {
          continue;
        }
        if (!equal(a5[keys[i2]], b6[keys[i2]])) return false;
      }
      return true;
    }
    return a5 !== a5 && b6 !== b6;
  }
  reactFastCompare = function isEqual2(a5, b6) {
    try {
      return equal(a5, b6);
    } catch (error2) {
      if ((error2.message || "").match(/stack|recursion/i)) {
        console.warn("react-fast-compare cannot handle circular refs");
        return false;
      }
      throw error2;
    }
  };
  return reactFastCompare;
}
var reactFastCompareExports = requireReactFastCompare();
const fastCompare = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompareExports);
var browser;
var hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  var invariant2 = function(condition, format, a5, b6, c2, d3, e2, f2) {
    if (!condition) {
      var error2;
      if (format === void 0) {
        error2 = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      } else {
        var args = [a5, b6, c2, d3, e2, f2];
        var argIndex = 0;
        error2 = new Error(
          format.replace(/%s/g, function() {
            return args[argIndex++];
          })
        );
        error2.name = "Invariant Violation";
      }
      error2.framesToPop = 1;
      throw error2;
    }
  };
  browser = invariant2;
  return browser;
}
var browserExports = requireBrowser();
const invariant = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var shallowequal;
var hasRequiredShallowequal;
function requireShallowequal() {
  if (hasRequiredShallowequal) return shallowequal;
  hasRequiredShallowequal = 1;
  shallowequal = function shallowEqual2(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) {
      return !!ret;
    }
    if (objA === objB) {
      return true;
    }
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
      return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
      return false;
    }
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var idx = 0; idx < keysA.length; idx++) {
      var key = keysA[idx];
      if (!bHasOwnProperty(key)) {
        return false;
      }
      var valueA = objA[key];
      var valueB = objB[key];
      ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
      if (ret === false || ret === void 0 && valueA !== valueB) {
        return false;
      }
    }
    return true;
  };
  return shallowequal;
}
var shallowequalExports = requireShallowequal();
const shallowEqual = /* @__PURE__ */ getDefaultExportFromCjs(shallowequalExports);
var TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2) => {
  TAG_NAMES2["BASE"] = "base";
  TAG_NAMES2["BODY"] = "body";
  TAG_NAMES2["HEAD"] = "head";
  TAG_NAMES2["HTML"] = "html";
  TAG_NAMES2["LINK"] = "link";
  TAG_NAMES2["META"] = "meta";
  TAG_NAMES2["NOSCRIPT"] = "noscript";
  TAG_NAMES2["SCRIPT"] = "script";
  TAG_NAMES2["STYLE"] = "style";
  TAG_NAMES2["TITLE"] = "title";
  TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
  return TAG_NAMES2;
})(TAG_NAMES || {});
var SEO_PRIORITY_TAGS = {
  link: { rel: ["amphtml", "canonical", "alternate"] },
  script: { type: ["application/ld+json"] },
  meta: {
    charset: "",
    name: ["generator", "robots", "description"],
    property: [
      "og:type",
      "og:title",
      "og:url",
      "og:image",
      "og:image:alt",
      "og:description",
      "twitter:url",
      "twitter:title",
      "twitter:description",
      "twitter:image",
      "twitter:image:alt",
      "twitter:card",
      "twitter:site"
    ]
  }
};
var VALID_TAG_NAMES = Object.values(TAG_NAMES);
var REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
};
var HTML_TAG_MAP = Object.entries(REACT_TAG_MAP).reduce(
  (carry, [key, value]) => {
    carry[value] = key;
    return carry;
  },
  {}
);
var HELMET_ATTRIBUTE = "data-rh";
var HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate",
  PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var getInnermostProperty = (propsList, property) => {
  for (let i2 = propsList.length - 1; i2 >= 0; i2 -= 1) {
    const props = propsList[i2];
    if (Object.prototype.hasOwnProperty.call(props, property)) {
      return props[property];
    }
  }
  return null;
};
var getTitleFromPropsList = (propsList) => {
  let innermostTitle = getInnermostProperty(
    propsList,
    "title"
    /* TITLE */
  );
  const innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
  if (Array.isArray(innermostTitle)) {
    innermostTitle = innermostTitle.join("");
  }
  if (innermostTemplate && innermostTitle) {
    return innermostTemplate.replace(/%s/g, () => innermostTitle);
  }
  const innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
  return innermostTitle || innermostDefaultTitle || void 0;
};
var getOnChangeClientState = (propsList) => getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (() => {
});
var getAttributesFromPropsList = (tagType, propsList) => propsList.filter((props) => typeof props[tagType] !== "undefined").map((props) => props[tagType]).reduce((tagAttrs, current) => ({ ...tagAttrs, ...current }), {});
var getBaseTagFromPropsList = (primaryAttributes, propsList) => propsList.filter((props) => typeof props[
  "base"
  /* BASE */
] !== "undefined").map((props) => props[
  "base"
  /* BASE */
]).reverse().reduce((innermostBaseTag, tag) => {
  if (!innermostBaseTag.length) {
    const keys = Object.keys(tag);
    for (let i2 = 0; i2 < keys.length; i2 += 1) {
      const attributeKey = keys[i2];
      const lowerCaseAttributeKey = attributeKey.toLowerCase();
      if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
        return innermostBaseTag.concat(tag);
      }
    }
  }
  return innermostBaseTag;
}, []);
var warn = (msg) => console && typeof console.warn === "function" && console.warn(msg);
var getTagsFromPropsList = (tagName, primaryAttributes, propsList) => {
  const approvedSeenTags = {};
  return propsList.filter((props) => {
    if (Array.isArray(props[tagName])) {
      return true;
    }
    if (typeof props[tagName] !== "undefined") {
      warn(
        `Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`
      );
    }
    return false;
  }).map((props) => props[tagName]).reverse().reduce((approvedTags, instanceTags) => {
    const instanceSeenTags = {};
    instanceTags.filter((tag) => {
      let primaryAttributeKey;
      const keys2 = Object.keys(tag);
      for (let i2 = 0; i2 < keys2.length; i2 += 1) {
        const attributeKey = keys2[i2];
        const lowerCaseAttributeKey = attributeKey.toLowerCase();
        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
          primaryAttributeKey = lowerCaseAttributeKey;
        }
        if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" || attributeKey === "cssText" || attributeKey === "itemprop")) {
          primaryAttributeKey = attributeKey;
        }
      }
      if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
        return false;
      }
      const value = tag[primaryAttributeKey].toLowerCase();
      if (!approvedSeenTags[primaryAttributeKey]) {
        approvedSeenTags[primaryAttributeKey] = {};
      }
      if (!instanceSeenTags[primaryAttributeKey]) {
        instanceSeenTags[primaryAttributeKey] = {};
      }
      if (!approvedSeenTags[primaryAttributeKey][value]) {
        instanceSeenTags[primaryAttributeKey][value] = true;
        return true;
      }
      return false;
    }).reverse().forEach((tag) => approvedTags.push(tag));
    const keys = Object.keys(instanceSeenTags);
    for (let i2 = 0; i2 < keys.length; i2 += 1) {
      const attributeKey = keys[i2];
      const tagUnion = {
        ...approvedSeenTags[attributeKey],
        ...instanceSeenTags[attributeKey]
      };
      approvedSeenTags[attributeKey] = tagUnion;
    }
    return approvedTags;
  }, []).reverse();
};
var getAnyTrueFromPropsList = (propsList, checkedTag) => {
  if (Array.isArray(propsList) && propsList.length) {
    for (let index = 0; index < propsList.length; index += 1) {
      const prop = propsList[index];
      if (prop[checkedTag]) {
        return true;
      }
    }
  }
  return false;
};
var reducePropsToState = (propsList) => ({
  baseTag: getBaseTagFromPropsList([
    "href"
    /* HREF */
  ], propsList),
  bodyAttributes: getAttributesFromPropsList("bodyAttributes", propsList),
  defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
  encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
  htmlAttributes: getAttributesFromPropsList("htmlAttributes", propsList),
  linkTags: getTagsFromPropsList(
    "link",
    [
      "rel",
      "href"
      /* HREF */
    ],
    propsList
  ),
  metaTags: getTagsFromPropsList(
    "meta",
    [
      "name",
      "charset",
      "http-equiv",
      "property",
      "itemprop"
      /* ITEM_PROP */
    ],
    propsList
  ),
  noscriptTags: getTagsFromPropsList("noscript", [
    "innerHTML"
    /* INNER_HTML */
  ], propsList),
  onChangeClientState: getOnChangeClientState(propsList),
  scriptTags: getTagsFromPropsList(
    "script",
    [
      "src",
      "innerHTML"
      /* INNER_HTML */
    ],
    propsList
  ),
  styleTags: getTagsFromPropsList("style", [
    "cssText"
    /* CSS_TEXT */
  ], propsList),
  title: getTitleFromPropsList(propsList),
  titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
  prioritizeSeoTags: getAnyTrueFromPropsList(propsList, HELMET_PROPS.PRIORITIZE_SEO_TAGS)
});
var flattenArray = (possibleArray) => Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var checkIfPropsMatch = (props, toMatch) => {
  const keys = Object.keys(props);
  for (let i2 = 0; i2 < keys.length; i2 += 1) {
    if (toMatch[keys[i2]] && toMatch[keys[i2]].includes(props[keys[i2]])) {
      return true;
    }
  }
  return false;
};
var prioritizer = (elementsList, propsToMatch) => {
  if (Array.isArray(elementsList)) {
    return elementsList.reduce(
      (acc, elementAttrs) => {
        if (checkIfPropsMatch(elementAttrs, propsToMatch)) {
          acc.priority.push(elementAttrs);
        } else {
          acc.default.push(elementAttrs);
        }
        return acc;
      },
      { priority: [], default: [] }
    );
  }
  return { default: elementsList, priority: [] };
};
var without = (obj, key) => {
  return {
    ...obj,
    [key]: void 0
  };
};
var SELF_CLOSING_TAGS = [
  "noscript",
  "script",
  "style"
  /* STYLE */
];
var encodeSpecialCharacters = (str, encode = true) => {
  if (encode === false) {
    return String(str);
  }
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var generateElementAttributesAsString = (attributes) => Object.keys(attributes).reduce((str, key) => {
  const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
  return str ? `${str} ${attr}` : attr;
}, "");
var generateTitleAsString = (type, title, attributes, encode) => {
  const attributeString = generateElementAttributesAsString(attributes);
  const flattenedTitle = flattenArray(title);
  return attributeString ? `<${type} ${HELMET_ATTRIBUTE}="true" ${attributeString}>${encodeSpecialCharacters(
    flattenedTitle,
    encode
  )}</${type}>` : `<${type} ${HELMET_ATTRIBUTE}="true">${encodeSpecialCharacters(
    flattenedTitle,
    encode
  )}</${type}>`;
};
var generateTagsAsString = (type, tags, encode = true) => tags.reduce((str, t2) => {
  const tag = t2;
  const attributeHtml = Object.keys(tag).filter(
    (attribute) => !(attribute === "innerHTML" || attribute === "cssText")
  ).reduce((string, attribute) => {
    const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${encodeSpecialCharacters(tag[attribute], encode)}"`;
    return string ? `${string} ${attr}` : attr;
  }, "");
  const tagContent = tag.innerHTML || tag.cssText || "";
  const isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
  return `${str}<${type} ${HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
}, "");
var convertElementAttributesToReactProps = (attributes, initProps = {}) => Object.keys(attributes).reduce((obj, key) => {
  const mapped = REACT_TAG_MAP[key];
  obj[mapped || key] = attributes[key];
  return obj;
}, initProps);
var generateTitleAsReactComponent = (_type, title, attributes) => {
  const initProps = {
    key: title,
    [HELMET_ATTRIBUTE]: true
  };
  const props = convertElementAttributesToReactProps(attributes, initProps);
  return [React.createElement("title", props, title)];
};
var generateTagsAsReactComponent = (type, tags) => tags.map((tag, i2) => {
  const mappedTag = {
    key: i2,
    [HELMET_ATTRIBUTE]: true
  };
  Object.keys(tag).forEach((attribute) => {
    const mapped = REACT_TAG_MAP[attribute];
    const mappedAttribute = mapped || attribute;
    if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
      const content = tag.innerHTML || tag.cssText;
      mappedTag.dangerouslySetInnerHTML = { __html: content };
    } else {
      mappedTag[mappedAttribute] = tag[attribute];
    }
  });
  return React.createElement(type, mappedTag);
});
var getMethodsForTag = (type, tags, encode = true) => {
  switch (type) {
    case "title":
      return {
        toComponent: () => generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
        toString: () => generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
      };
    case "bodyAttributes":
    case "htmlAttributes":
      return {
        toComponent: () => convertElementAttributesToReactProps(tags),
        toString: () => generateElementAttributesAsString(tags)
      };
    default:
      return {
        toComponent: () => generateTagsAsReactComponent(type, tags),
        toString: () => generateTagsAsString(type, tags, encode)
      };
  }
};
var getPriorityMethods = ({ metaTags, linkTags, scriptTags, encode }) => {
  const meta = prioritizer(metaTags, SEO_PRIORITY_TAGS.meta);
  const link = prioritizer(linkTags, SEO_PRIORITY_TAGS.link);
  const script = prioritizer(scriptTags, SEO_PRIORITY_TAGS.script);
  const priorityMethods = {
    toComponent: () => [
      ...generateTagsAsReactComponent("meta", meta.priority),
      ...generateTagsAsReactComponent("link", link.priority),
      ...generateTagsAsReactComponent("script", script.priority)
    ],
    toString: () => (
      // generate all the tags as strings and concatenate them
      `${getMethodsForTag("meta", meta.priority, encode)} ${getMethodsForTag(
        "link",
        link.priority,
        encode
      )} ${getMethodsForTag("script", script.priority, encode)}`
    )
  };
  return {
    priorityMethods,
    metaTags: meta.default,
    linkTags: link.default,
    scriptTags: script.default
  };
};
var mapStateOnServer = (props) => {
  const {
    baseTag,
    bodyAttributes,
    encode = true,
    htmlAttributes,
    noscriptTags,
    styleTags,
    title = "",
    titleAttributes,
    prioritizeSeoTags
  } = props;
  let { linkTags, metaTags, scriptTags } = props;
  let priorityMethods = {
    toComponent: () => {
    },
    toString: () => ""
  };
  if (prioritizeSeoTags) {
    ({ priorityMethods, linkTags, metaTags, scriptTags } = getPriorityMethods(props));
  }
  return {
    priority: priorityMethods,
    base: getMethodsForTag("base", baseTag, encode),
    bodyAttributes: getMethodsForTag("bodyAttributes", bodyAttributes, encode),
    htmlAttributes: getMethodsForTag("htmlAttributes", htmlAttributes, encode),
    link: getMethodsForTag("link", linkTags, encode),
    meta: getMethodsForTag("meta", metaTags, encode),
    noscript: getMethodsForTag("noscript", noscriptTags, encode),
    script: getMethodsForTag("script", scriptTags, encode),
    style: getMethodsForTag("style", styleTags, encode),
    title: getMethodsForTag("title", { title, titleAttributes }, encode)
  };
};
var server_default = mapStateOnServer;
var instances = [];
var isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var HelmetData = class {
  instances = [];
  canUseDOM = isDocument;
  context;
  value = {
    setHelmet: (serverState) => {
      this.context.helmet = serverState;
    },
    helmetInstances: {
      get: () => this.canUseDOM ? instances : this.instances,
      add: (instance) => {
        (this.canUseDOM ? instances : this.instances).push(instance);
      },
      remove: (instance) => {
        const index = (this.canUseDOM ? instances : this.instances).indexOf(instance);
        (this.canUseDOM ? instances : this.instances).splice(index, 1);
      }
    }
  };
  constructor(context4, canUseDOM) {
    this.context = context4;
    this.canUseDOM = canUseDOM || false;
    if (!canUseDOM) {
      context4.helmet = server_default({
        baseTag: [],
        bodyAttributes: {},
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
      });
    }
  }
};
var defaultValue = {};
var Context = React.createContext(defaultValue);
var HelmetProvider = class _HelmetProvider extends reactExports.Component {
  static canUseDOM = isDocument;
  helmetData;
  constructor(props) {
    super(props);
    this.helmetData = new HelmetData(this.props.context || {}, _HelmetProvider.canUseDOM);
  }
  render() {
    return /* @__PURE__ */ React.createElement(Context.Provider, { value: this.helmetData.value }, this.props.children);
  }
};
var updateTags = (type, tags) => {
  const headElement = document.head || document.querySelector(
    "head"
    /* HEAD */
  );
  const tagNodes = headElement.querySelectorAll(`${type}[${HELMET_ATTRIBUTE}]`);
  const oldTags = [].slice.call(tagNodes);
  const newTags = [];
  let indexToDelete;
  if (tags && tags.length) {
    tags.forEach((tag) => {
      const newElement = document.createElement(type);
      for (const attribute in tag) {
        if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
          if (attribute === "innerHTML") {
            newElement.innerHTML = tag.innerHTML;
          } else if (attribute === "cssText") {
            if (newElement.styleSheet) {
              newElement.styleSheet.cssText = tag.cssText;
            } else {
              newElement.appendChild(document.createTextNode(tag.cssText));
            }
          } else {
            const attr = attribute;
            const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
            newElement.setAttribute(attribute, value);
          }
        }
      }
      newElement.setAttribute(HELMET_ATTRIBUTE, "true");
      if (oldTags.some((existingTag, index) => {
        indexToDelete = index;
        return newElement.isEqualNode(existingTag);
      })) {
        oldTags.splice(indexToDelete, 1);
      } else {
        newTags.push(newElement);
      }
    });
  }
  oldTags.forEach((tag) => tag.parentNode?.removeChild(tag));
  newTags.forEach((tag) => headElement.appendChild(tag));
  return {
    oldTags,
    newTags
  };
};
var updateAttributes = (tagName, attributes) => {
  const elementTag = document.getElementsByTagName(tagName)[0];
  if (!elementTag) {
    return;
  }
  const helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
  const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
  const attributesToRemove = [...helmetAttributes];
  const attributeKeys = Object.keys(attributes);
  for (const attribute of attributeKeys) {
    const value = attributes[attribute] || "";
    if (elementTag.getAttribute(attribute) !== value) {
      elementTag.setAttribute(attribute, value);
    }
    if (helmetAttributes.indexOf(attribute) === -1) {
      helmetAttributes.push(attribute);
    }
    const indexToSave = attributesToRemove.indexOf(attribute);
    if (indexToSave !== -1) {
      attributesToRemove.splice(indexToSave, 1);
    }
  }
  for (let i2 = attributesToRemove.length - 1; i2 >= 0; i2 -= 1) {
    elementTag.removeAttribute(attributesToRemove[i2]);
  }
  if (helmetAttributes.length === attributesToRemove.length) {
    elementTag.removeAttribute(HELMET_ATTRIBUTE);
  } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
    elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
  }
};
var updateTitle = (title, attributes) => {
  if (typeof title !== "undefined" && document.title !== title) {
    document.title = flattenArray(title);
  }
  updateAttributes("title", attributes);
};
var commitTagChanges = (newState, cb) => {
  const {
    baseTag,
    bodyAttributes,
    htmlAttributes,
    linkTags,
    metaTags,
    noscriptTags,
    onChangeClientState,
    scriptTags,
    styleTags,
    title,
    titleAttributes
  } = newState;
  updateAttributes("body", bodyAttributes);
  updateAttributes("html", htmlAttributes);
  updateTitle(title, titleAttributes);
  const tagUpdates = {
    baseTag: updateTags("base", baseTag),
    linkTags: updateTags("link", linkTags),
    metaTags: updateTags("meta", metaTags),
    noscriptTags: updateTags("noscript", noscriptTags),
    scriptTags: updateTags("script", scriptTags),
    styleTags: updateTags("style", styleTags)
  };
  const addedTags = {};
  const removedTags = {};
  Object.keys(tagUpdates).forEach((tagType) => {
    const { newTags, oldTags } = tagUpdates[tagType];
    if (newTags.length) {
      addedTags[tagType] = newTags;
    }
    if (oldTags.length) {
      removedTags[tagType] = tagUpdates[tagType].oldTags;
    }
  });
  if (cb) {
    cb();
  }
  onChangeClientState(newState, addedTags, removedTags);
};
var _helmetCallback = null;
var handleStateChangeOnClient = (newState) => {
  if (_helmetCallback) {
    cancelAnimationFrame(_helmetCallback);
  }
  if (newState.defer) {
    _helmetCallback = requestAnimationFrame(() => {
      commitTagChanges(newState, () => {
        _helmetCallback = null;
      });
    });
  } else {
    commitTagChanges(newState);
    _helmetCallback = null;
  }
};
var client_default = handleStateChangeOnClient;
var HelmetDispatcher = class extends reactExports.Component {
  rendered = false;
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(nextProps, this.props);
  }
  componentDidUpdate() {
    this.emitChange();
  }
  componentWillUnmount() {
    const { helmetInstances } = this.props.context;
    helmetInstances.remove(this);
    this.emitChange();
  }
  emitChange() {
    const { helmetInstances, setHelmet } = this.props.context;
    let serverState = null;
    const state = reducePropsToState(
      helmetInstances.get().map((instance) => {
        const props = { ...instance.props };
        delete props.context;
        return props;
      })
    );
    if (HelmetProvider.canUseDOM) {
      client_default(state);
    } else if (server_default) {
      serverState = server_default(state);
    }
    setHelmet(serverState);
  }
  // componentWillMount will be deprecated
  // for SSR, initialize on first render
  // constructor is also unsafe in StrictMode
  init() {
    if (this.rendered) {
      return;
    }
    this.rendered = true;
    const { helmetInstances } = this.props.context;
    helmetInstances.add(this);
    this.emitChange();
  }
  render() {
    this.init();
    return null;
  }
};
var Helmet = class extends reactExports.Component {
  static defaultProps = {
    defer: true,
    encodeSpecialCharacters: true,
    prioritizeSeoTags: false
  };
  shouldComponentUpdate(nextProps) {
    return !fastCompare(without(this.props, "helmetData"), without(nextProps, "helmetData"));
  }
  mapNestedChildrenToProps(child, nestedChildren) {
    if (!nestedChildren) {
      return null;
    }
    switch (child.type) {
      case "script":
      case "noscript":
        return {
          innerHTML: nestedChildren
        };
      case "style":
        return {
          cssText: nestedChildren
        };
      default:
        throw new Error(
          `<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`
        );
    }
  }
  flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
    return {
      ...arrayTypeChildren,
      [child.type]: [
        ...arrayTypeChildren[child.type] || [],
        {
          ...newChildProps,
          ...this.mapNestedChildrenToProps(child, nestedChildren)
        }
      ]
    };
  }
  mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
    switch (child.type) {
      case "title":
        return {
          ...newProps,
          [child.type]: nestedChildren,
          titleAttributes: { ...newChildProps }
        };
      case "body":
        return {
          ...newProps,
          bodyAttributes: { ...newChildProps }
        };
      case "html":
        return {
          ...newProps,
          htmlAttributes: { ...newChildProps }
        };
      default:
        return {
          ...newProps,
          [child.type]: { ...newChildProps }
        };
    }
  }
  mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
    let newFlattenedProps = { ...newProps };
    Object.keys(arrayTypeChildren).forEach((arrayChildName) => {
      newFlattenedProps = {
        ...newFlattenedProps,
        [arrayChildName]: arrayTypeChildren[arrayChildName]
      };
    });
    return newFlattenedProps;
  }
  warnOnInvalidChildren(child, nestedChildren) {
    invariant(
      VALID_TAG_NAMES.some((name) => child.type === name),
      typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${VALID_TAG_NAMES.join(
        ", "
      )} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`
    );
    invariant(
      !nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild) => typeof nestedChild !== "string"),
      `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`
    );
    return true;
  }
  mapChildrenToProps(children, newProps) {
    let arrayTypeChildren = {};
    React.Children.forEach(children, (child) => {
      if (!child || !child.props) {
        return;
      }
      const { children: nestedChildren, ...childProps } = child.props;
      const newChildProps = Object.keys(childProps).reduce((obj, key) => {
        obj[HTML_TAG_MAP[key] || key] = childProps[key];
        return obj;
      }, {});
      let { type } = child;
      if (typeof type === "symbol") {
        type = type.toString();
      } else {
        this.warnOnInvalidChildren(child, nestedChildren);
      }
      switch (type) {
        case "Symbol(react.fragment)":
          newProps = this.mapChildrenToProps(nestedChildren, newProps);
          break;
        case "link":
        case "meta":
        case "noscript":
        case "script":
        case "style":
          arrayTypeChildren = this.flattenArrayTypeChildren(
            child,
            arrayTypeChildren,
            newChildProps,
            nestedChildren
          );
          break;
        default:
          newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
          break;
      }
    });
    return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
  }
  render() {
    const { children, ...props } = this.props;
    let newProps = { ...props };
    let { helmetData } = props;
    if (children) {
      newProps = this.mapChildrenToProps(children, newProps);
    }
    if (helmetData && !(helmetData instanceof HelmetData)) {
      const data = helmetData;
      helmetData = new HelmetData(data.context, true);
      delete newProps.helmetData;
    }
    return helmetData ? /* @__PURE__ */ React.createElement(HelmetDispatcher, { ...newProps, context: helmetData.value }) : /* @__PURE__ */ React.createElement(Context.Consumer, null, (context4) => /* @__PURE__ */ React.createElement(HelmetDispatcher, { ...newProps, context: context4 }));
  }
};
const Seo = (props) => {
  const [siteData, setSiteData] = reactExports.useState(null);
  const contextSiteData = useSiteData();
  reactExports.useEffect(() => {
    if (!contextSiteData) return;
    const data = { ...contextSiteData };
    const url = data.siteURL ? data.siteURL : window.location.hostname;
    data.siteURL = url;
    setSiteData(data);
  }, [contextSiteData, props]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Helmet, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: siteData?.siteTitle }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("meta", { name: "description", content: siteData?.siteDescription }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("meta", { name: "robots", content: "index,follow" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("link", { rel: "canonical", href: siteData?.siteURL }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("link", { rel: "icon", type: "image/x-icon", href: siteData?.siteURL }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("meta", { property: "og:title", content: props.title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("meta", { property: "og:type", content: "article" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("meta", { property: "og:url", content: siteData?.siteURL }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("meta", { property: "og:description", content: siteData?.siteDescription }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("meta", { property: "og:image", content: siteData?.siteImage }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("meta", { name: "twitter:card", content: "summary" })
  ] });
};
function SplashScreen({
  tutorial = [],
  title,
  body,
  buttonText,
  active
}) {
  const contextSiteData = useSiteData();
  const [dismissed, setDismissed] = reactExports.useState(false);
  const handleDismiss = reactExports.useCallback(() => {
    setDismissed(true);
  }, []);
  const isSplashActive = active !== void 0 ? active : contextSiteData?.splashScreenActive;
  if (!isSplashActive || dismissed) {
    return null;
  }
  const displayTitle = contextSiteData?.splashScreenTitle || title || "Welcome";
  const displayBody = contextSiteData?.splashScreenBody || body || "Explore the 3D experience.";
  const displayButton = contextSiteData?.splashScreenButton || buttonText || "Enter";
  const renderTutorial = () => {
    if (!tutorial || tutorial.length === 0) return null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-8", id: "tutorial", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "text-xs uppercase tracking-widest text-white/60 mb-4 font-medium", children: "How to Interact" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid gap-4 grid-cols-[repeat(auto-fit,minmax(200px,1fr))]", children: tutorial.map((step, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "bg-white/10 border border-white/15 rounded-xl p-4 text-left",
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start gap-3", children: [
            step.icon && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "shrink-0 text-white text-xl", children: typeof step.icon === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: step.icon }) : step.icon }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-white text-sm font-semibold mb-1", children: step.title }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-white/70 text-xs leading-relaxed", children: step.description })
            ] })
          ] })
        },
        index
      )) })
    ] });
  };
  return reactDomExports.createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        id: "splash-screen-root",
        "data-testid": "splash-screen",
        className: "fixed inset-0 w-screen h-screen flex items-center justify-center z-[9999] p-12 box-border",
        "aria-labelledby": "splash-title",
        role: "dialog",
        "aria-modal": "true",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "fixed inset-0 bg-black/70 backdrop-blur-[20px]",
              onClick: handleDismiss
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative z-10 w-full max-w-[600px]", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              className: "bg-neutral-900/95 border-2 border-white/20 rounded-3xl overflow-hidden shadow-2xl",
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "p-12 text-center", children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "h1",
                    {
                      id: "splash-title",
                      className: "text-white text-5xl font-black mb-6 leading-tight tracking-tight",
                      children: displayTitle
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-white/85 text-lg font-light leading-relaxed max-w-[400px] mx-auto mb-8", children: displayBody }),
                  renderTutorial()
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "px-6 pb-6", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "button",
                  {
                    type: "button",
                    className: "w-full bg-white text-black border-2 border-white rounded-2xl py-5 px-8 text-lg font-extrabold uppercase tracking-widest cursor-pointer transition-all duration-200 hover:bg-transparent hover:text-white",
                    onClick: handleDismiss,
                    children: displayButton
                  }
                ) })
              ]
            }
          ) })
        ]
      }
    ),
    document.body
  );
}
function FallbackMessage() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Oops! The 3D canvas failed to render or is very slow. Please try refreshing the page or check back later." });
}
class ErrorBoundary2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error2) {
    return { hasError: true };
  }
  componentDidCatch(error2, errorInfo) {
    debugError("[ErrorBoundary] Error caught:", error2, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FallbackMessage, {});
    }
    return this.props.children;
  }
}
class PositionalAudioHelper extends Line {
  constructor(audio, range = 1, divisionsInnerAngle = 16, divisionsOuterAngle = 2) {
    const geometry = new BufferGeometry();
    const divisions = divisionsInnerAngle + divisionsOuterAngle * 2;
    const positions = new Float32Array((divisions * 3 + 3) * 3);
    geometry.setAttribute("position", new BufferAttribute(positions, 3));
    const materialInnerAngle = new LineBasicMaterial({ color: 65280 });
    const materialOuterAngle = new LineBasicMaterial({ color: 16776960 });
    super(geometry, [materialOuterAngle, materialInnerAngle]);
    this.audio = audio;
    this.range = range;
    this.divisionsInnerAngle = divisionsInnerAngle;
    this.divisionsOuterAngle = divisionsOuterAngle;
    this.type = "PositionalAudioHelper";
    this.update();
  }
  update() {
    const audio = this.audio;
    const range = this.range;
    const divisionsInnerAngle = this.divisionsInnerAngle;
    const divisionsOuterAngle = this.divisionsOuterAngle;
    const coneInnerAngle = MathUtils.degToRad(audio.panner.coneInnerAngle);
    const coneOuterAngle = MathUtils.degToRad(audio.panner.coneOuterAngle);
    const halfConeInnerAngle = coneInnerAngle / 2;
    const halfConeOuterAngle = coneOuterAngle / 2;
    let start2 = 0;
    let count = 0;
    let i2;
    let stride;
    const geometry = this.geometry;
    const positionAttribute = geometry.attributes.position;
    geometry.clearGroups();
    function generateSegment(from, to2, divisions, materialIndex) {
      const step = (to2 - from) / divisions;
      positionAttribute.setXYZ(start2, 0, 0, 0);
      count++;
      for (i2 = from; i2 < to2; i2 += step) {
        stride = start2 + count;
        positionAttribute.setXYZ(stride, Math.sin(i2) * range, 0, Math.cos(i2) * range);
        positionAttribute.setXYZ(stride + 1, Math.sin(Math.min(i2 + step, to2)) * range, 0, Math.cos(Math.min(i2 + step, to2)) * range);
        positionAttribute.setXYZ(stride + 2, 0, 0, 0);
        count += 3;
      }
      geometry.addGroup(start2, count, materialIndex);
      start2 += count;
      count = 0;
    }
    generateSegment(-halfConeOuterAngle, -halfConeInnerAngle, divisionsOuterAngle, 0);
    generateSegment(-halfConeInnerAngle, halfConeInnerAngle, divisionsInnerAngle, 1);
    generateSegment(halfConeInnerAngle, halfConeOuterAngle, divisionsOuterAngle, 0);
    positionAttribute.needsUpdate = true;
    if (coneInnerAngle === coneOuterAngle) this.material[0].visible = false;
  }
  dispose() {
    this.geometry.dispose();
    this.material[0].dispose();
    this.material[1].dispose();
  }
}
function Audio3D(props) {
  const {
    url,
    volume = 1,
    sourceObject = null,
    setAudioAnalyser,
    fftSize = 128,
    ...rest
  } = props;
  const [speaker, setSpeaker] = reactExports.useState();
  const { isDebugMode: isDebugMode2 } = useWebCrafter();
  const camera = useThree((state) => state.camera);
  const interactionManager = useInteractionManager();
  const [callbacks, setCallbacks] = reactExports.useState({});
  const audioRef = reactExports.useRef(document.createElement("audio"));
  const audio = reactExports.useMemo(() => {
    if (!url) return null;
    if (audioRef.current?.src === url) return audioRef.current;
    const a5 = audioRef.current;
    if (!a5) return null;
    a5.src = url;
    a5.preload = "auto";
    a5.crossOrigin = "Anonymous";
    a5.loop = false;
    a5.autoplay = false;
    a5.muted = false;
    a5.volume = volume;
    return a5;
  }, [url, audioRef.current]);
  const toggleAudio = reactExports.useCallback(() => {
    if (!audio) return;
    if (audio.paused) {
      if (speaker?.context?.state === "suspended") {
        speaker.context.resume();
      }
      audio.play().catch((err) => debugError("[Audio3D] Playback failed:", err));
    } else {
      audio.pause();
    }
  }, [audio, speaker]);
  reactExports.useEffect(() => {
    if (!interactionManager) return;
    const handleTrigger = (name) => {
      if (sourceObject && name === sourceObject.name) {
        toggleAudio();
      }
    };
    const unsubscribe = interactionManager.subscribeToAudioTrigger(handleTrigger);
    return () => unsubscribe();
  }, [sourceObject, toggleAudio, interactionManager]);
  reactExports.useEffect(() => {
    if (!speaker) return;
    speaker.setVolume(volume);
  }, [volume, speaker]);
  reactExports.useEffect(() => {
    if (!audio) return;
    if (!speaker) {
      const listener = camera.children.find((c2) => c2.type === "AudioListener");
      if (!listener) return;
      const isPositional = sourceObject?.userData?.mediaAudioPosition === "Positional";
      const speak = isPositional ? new PositionalAudio(listener) : new Audio(listener);
      speak.setMediaElementSource(audio);
      speak.setVolume(volume);
      if (isPositional && isDebugMode2) {
        speak.setRefDistance(1);
        const helper = new PositionalAudioHelper(speak, 1);
        helper.visible = true;
        helper.position.copy(sourceObject.position);
        helper.rotation.copy(sourceObject.rotation);
        helper.scale.set(sourceObject.scale.x * 10, sourceObject.scale.y * 10, sourceObject.scale.z * 10);
        helper.name = "webcrafter-audio-helper";
        helper.renderOrder = -1;
        speak.add(helper);
      }
      if (setAudioAnalyser) {
        setAudioAnalyser(new AudioAnalyser(speak, fftSize));
      }
      setSpeaker(speak);
    }
    const mediaTrigger = sourceObject?.userData?.mediaTrigger;
    const tempCallbacks = {};
    if (mediaTrigger === "Looping") {
      audio.loop = true;
      audio.play().catch((e2) => debugError("[Audio3D] Auto-play failed:", e2));
    } else if (mediaTrigger === "OnSelect") {
      tempCallbacks.onClick = () => toggleAudio();
    } else if (mediaTrigger === "OnPointerExit" || mediaTrigger === "OnPointerEnter") {
      tempCallbacks.onPointerEnter = () => audio.play().catch((e2) => debugError("[Audio3D] Play failed:", e2));
      tempCallbacks.onPointerLeave = () => audio.pause();
    }
    setCallbacks(tempCallbacks);
  }, [speaker, audio, url, sourceObject, camera, volume, toggleAudio, setAudioAnalyser, fftSize, isDebugMode2]);
  reactExports.useEffect(() => {
    return () => {
      if (speaker) {
        if (speaker.isPlaying) speaker.stop();
        speaker.disconnect();
        setSpeaker(void 0);
      }
      if (audio) {
        audio.pause();
        audio.remove();
      }
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("group", { rotation: [-Math.PI / 2, 0, 0], children: /* @__PURE__ */ jsxRuntimeExports.jsx("primitive", { object: sourceObject.clone(), visible: false, ...callbacks, ...rest, children: speaker && /* @__PURE__ */ jsxRuntimeExports.jsx("primitive", { ...rest, object: speaker }) }) });
}
const mergeBufferGeometries = (geometries, useGroups) => {
  const isIndexed = geometries[0].index !== null;
  const attributesUsed = new Set(Object.keys(geometries[0].attributes));
  const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
  const attributes = {};
  const morphAttributes = {};
  const morphTargetsRelative = geometries[0].morphTargetsRelative;
  const mergedGeometry = new BufferGeometry();
  geometries.forEach((geom, i2) => {
    let attributesCount = 0;
    if (isIndexed !== (geom.index !== null)) {
      console.error(
        "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i2 + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."
      );
      return null;
    }
    for (let name in geom.attributes) {
      if (!attributesUsed.has(name)) {
        console.error(
          "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i2 + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.'
        );
        return null;
      }
      if (attributes[name] === void 0) {
        attributes[name] = [];
      }
      attributes[name].push(geom.attributes[name]);
      attributesCount++;
    }
    if (attributesCount !== attributesUsed.size) {
      console.error(
        "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i2 + ". Make sure all geometries have the same number of attributes."
      );
      return null;
    }
    if (morphTargetsRelative !== geom.morphTargetsRelative) {
      console.error(
        "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i2 + ". .morphTargetsRelative must be consistent throughout all geometries."
      );
      return null;
    }
    for (let name in geom.morphAttributes) {
      if (!morphAttributesUsed.has(name)) {
        console.error(
          "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i2 + ".  .morphAttributes must be consistent throughout all geometries."
        );
        return null;
      }
      if (morphAttributes[name] === void 0)
        morphAttributes[name] = [];
      morphAttributes[name].push(geom.morphAttributes[name]);
    }
    mergedGeometry.userData.mergedUserData = mergedGeometry.userData.mergedUserData || [];
    mergedGeometry.userData.mergedUserData.push(geom.userData);
  });
  if (isIndexed) {
    let indexOffset = 0;
    const mergedIndex = [];
    geometries.forEach((geom) => {
      const index = geom.index;
      for (let j3 = 0; j3 < index.count; ++j3) {
        mergedIndex.push(index.getX(j3) + indexOffset);
      }
      indexOffset += geom.attributes.position.count;
    });
    mergedGeometry.setIndex(mergedIndex);
  }
  for (let name in attributes) {
    const mergedAttribute = mergeBufferAttributes(attributes[name]);
    if (!mergedAttribute) {
      console.error(
        "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " attribute."
      );
      return null;
    }
    mergedGeometry.setAttribute(name, mergedAttribute);
  }
  for (let name in morphAttributes) {
    const numMorphTargets = morphAttributes[name][0].length;
    if (numMorphTargets === 0)
      break;
    mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
    mergedGeometry.morphAttributes[name] = [];
    for (let i2 = 0; i2 < numMorphTargets; ++i2) {
      const morphAttributesToMerge = [];
      for (let j3 = 0; j3 < morphAttributes[name].length; ++j3) {
        morphAttributesToMerge.push(morphAttributes[name][j3][i2]);
      }
      const mergedMorphAttribute = mergeBufferAttributes(morphAttributesToMerge);
      if (!mergedMorphAttribute) {
        console.error(
          "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " morphAttribute."
        );
        return null;
      }
      mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
    }
  }
  return mergedGeometry;
};
const mergeBufferAttributes = (attributes) => {
  let TypedArray = void 0;
  let itemSize = void 0;
  let normalized = void 0;
  let arrayLength = 0;
  attributes.forEach((attr) => {
    if (TypedArray === void 0) {
      TypedArray = attr.array.constructor;
    }
    if (TypedArray !== attr.array.constructor) {
      console.error(
        "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."
      );
      return null;
    }
    if (itemSize === void 0)
      itemSize = attr.itemSize;
    if (itemSize !== attr.itemSize) {
      console.error(
        "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."
      );
      return null;
    }
    if (normalized === void 0)
      normalized = attr.normalized;
    if (normalized !== attr.normalized) {
      console.error(
        "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."
      );
      return null;
    }
    arrayLength += attr.array.length;
  });
  if (TypedArray && itemSize) {
    const array = new TypedArray(arrayLength);
    let offset = 0;
    attributes.forEach((attr) => {
      array.set(attr.array, offset);
      offset += attr.array.length;
    });
    return new BufferAttribute(array, itemSize, normalized);
  }
};
function mergeVertices(geometry, tolerance = 1e-4) {
  tolerance = Math.max(tolerance, Number.EPSILON);
  const hashToIndex = {};
  const indices = geometry.getIndex();
  const positions = geometry.getAttribute("position");
  const vertexCount = indices ? indices.count : positions.count;
  let nextIndex = 0;
  const attributeNames = Object.keys(geometry.attributes);
  const attrArrays = {};
  const morphAttrsArrays = {};
  const newIndices = [];
  const getters = ["getX", "getY", "getZ", "getW"];
  for (let i2 = 0, l2 = attributeNames.length; i2 < l2; i2++) {
    const name = attributeNames[i2];
    attrArrays[name] = [];
    const morphAttr = geometry.morphAttributes[name];
    if (morphAttr) {
      morphAttrsArrays[name] = new Array(morphAttr.length).fill(0).map(() => []);
    }
  }
  const decimalShift = Math.log10(1 / tolerance);
  const shiftMultiplier = Math.pow(10, decimalShift);
  for (let i2 = 0; i2 < vertexCount; i2++) {
    const index = indices ? indices.getX(i2) : i2;
    let hash = "";
    for (let j3 = 0, l2 = attributeNames.length; j3 < l2; j3++) {
      const name = attributeNames[j3];
      const attribute = geometry.getAttribute(name);
      const itemSize = attribute.itemSize;
      for (let k2 = 0; k2 < itemSize; k2++) {
        hash += `${~~(attribute[getters[k2]](index) * shiftMultiplier)},`;
      }
    }
    if (hash in hashToIndex) {
      newIndices.push(hashToIndex[hash]);
    } else {
      for (let j3 = 0, l2 = attributeNames.length; j3 < l2; j3++) {
        const name = attributeNames[j3];
        const attribute = geometry.getAttribute(name);
        const morphAttr = geometry.morphAttributes[name];
        const itemSize = attribute.itemSize;
        const newarray = attrArrays[name];
        const newMorphArrays = morphAttrsArrays[name];
        for (let k2 = 0; k2 < itemSize; k2++) {
          const getterFunc = getters[k2];
          newarray.push(attribute[getterFunc](index));
          if (morphAttr) {
            for (let m2 = 0, ml = morphAttr.length; m2 < ml; m2++) {
              newMorphArrays[m2].push(morphAttr[m2][getterFunc](index));
            }
          }
        }
      }
      hashToIndex[hash] = nextIndex;
      newIndices.push(nextIndex);
      nextIndex++;
    }
  }
  const result = geometry.clone();
  for (let i2 = 0, l2 = attributeNames.length; i2 < l2; i2++) {
    const name = attributeNames[i2];
    const oldAttribute = geometry.getAttribute(name);
    const buffer = new oldAttribute.array.constructor(attrArrays[name]);
    const attribute = new BufferAttribute(buffer, oldAttribute.itemSize, oldAttribute.normalized);
    result.setAttribute(name, attribute);
    if (name in morphAttrsArrays) {
      for (let j3 = 0; j3 < morphAttrsArrays[name].length; j3++) {
        const oldMorphAttribute = geometry.morphAttributes[name][j3];
        const buffer2 = new oldMorphAttribute.array.constructor(morphAttrsArrays[name][j3]);
        const morphAttribute = new BufferAttribute(buffer2, oldMorphAttribute.itemSize, oldMorphAttribute.normalized);
        result.morphAttributes[name][j3] = morphAttribute;
      }
    }
  }
  result.setIndex(newIndices);
  return result;
}
function Frame(props) {
  const { width, height, thickness = 1, material: passedMaterial, innerFrameMaterial, rotation } = props;
  const material = reactExports.useMemo(() => {
    return passedMaterial || new MeshStandardMaterial({
      color: 3355443,
      roughness: 0.8,
      metalness: 0.05
    });
  }, [passedMaterial]);
  const frameDepth = 0.075;
  const frameWidth = 0.06;
  const borderDepth = 0.08;
  const borderThickness = 0.05 * thickness;
  const meshOffset = 5e-4;
  const geometry = reactExports.useMemo(() => {
    const backPanel = new BoxGeometry(width + frameWidth, height + frameWidth, frameDepth);
    backPanel.translate(0, 0, -frameDepth - meshOffset);
    const topFrame = new BoxGeometry(width + frameWidth, borderThickness, borderDepth);
    topFrame.translate(0, height / 2 + frameWidth / 2 - borderThickness / 2, 0);
    const bottomFrame = new BoxGeometry(width + frameWidth, borderThickness, borderDepth);
    bottomFrame.translate(0, -height / 2 - frameWidth / 2 + borderThickness / 2, 0);
    const leftFrame = new BoxGeometry(borderThickness, height + frameWidth, borderDepth);
    leftFrame.translate(-width / 2 - frameWidth / 2 + borderThickness / 2, 0, 0);
    const rightFrame = new BoxGeometry(borderThickness, height + frameWidth, borderDepth);
    rightFrame.translate(width / 2 + frameWidth / 2 - borderThickness / 2, 0, 0);
    const geos = [backPanel, topFrame, bottomFrame, leftFrame, rightFrame];
    const geo = mergeBufferGeometries(geos);
    backPanel.dispose();
    topFrame.dispose();
    bottomFrame.dispose();
    leftFrame.dispose();
    rightFrame.dispose();
    return geo;
  }, [innerFrameMaterial, borderThickness, width, height]);
  const backFrameGeometry = reactExports.useMemo(() => {
    if (!innerFrameMaterial) return void 0;
    const backPanel = new BoxGeometry(width + frameWidth, height + frameWidth, frameDepth);
    backPanel.translate(0, 0, -frameDepth - meshOffset);
    return backPanel;
  }, [innerFrameMaterial, width, height]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("group", { name: "spacesvr-frame", rotation, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("mesh", { geometry, material }),
    backFrameGeometry && innerFrameMaterial && /* @__PURE__ */ jsxRuntimeExports.jsx("mesh", { geometry: backFrameGeometry, material: innerFrameMaterial })
  ] }) });
}
function Video(props) {
  const { src, size = 1, framed, muted, volume = 1, frameMaterial, frameWidth = 1, sourceObject = null, ...rest } = props;
  const camera = useThree((state) => state.camera);
  const interactionManager = useInteractionManager();
  const [speaker, setSpeaker] = reactExports.useState();
  const [dims, setDims] = reactExports.useState();
  const [callbacks, setCallbacks] = reactExports.useState({});
  const videoRef = reactExports.useRef(document.createElement("video"));
  const video = reactExports.useMemo(() => {
    if (!src) return null;
    if (videoRef.current?.src === src) return videoRef.current;
    const v3 = videoRef.current;
    if (!v3) return null;
    v3.playsInline = true;
    v3.crossOrigin = "anonymous";
    v3.loop = true;
    v3.src = src;
    v3.autoplay = false;
    v3.muted = muted ?? false;
    v3.volume = volume;
    v3.addEventListener("loadeddata", () => {
      setDims(new Vector2(v3.videoWidth, v3.videoHeight));
    });
    return v3;
  }, [src, videoRef.current]);
  const toggleVideo = reactExports.useCallback(() => {
    if (!video) return;
    if (video.paused) {
      if (speaker?.context?.state === "suspended") {
        speaker.context.resume();
      }
      video.play().catch((err) => debugError("[Video] Playback failed:", err));
    } else {
      video.pause();
    }
  }, [video, speaker]);
  reactExports.useEffect(() => {
    if (!interactionManager) return;
    const handleTrigger = (name) => {
      if (sourceObject && name === sourceObject.name) {
        toggleVideo();
      }
    };
    const unsubscribe = interactionManager.subscribeToVideoTrigger(handleTrigger);
    return () => unsubscribe();
  }, [sourceObject, toggleVideo, interactionManager]);
  reactExports.useEffect(() => {
    if (!speaker) return;
    speaker.setVolume(volume);
  }, [volume, speaker]);
  reactExports.useEffect(() => {
    if (!video) return;
    if (!muted && !video.paused && !speaker) {
      const listener = camera.children.find((c2) => c2.type === "AudioListener");
      if (listener) {
        const speak = new Audio(listener);
        speak.setMediaElementSource(video);
        speak.setVolume(volume);
        setSpeaker(speak);
      }
    }
    const mediaTrigger = sourceObject?.userData?.mediaTrigger;
    const tempCallbacks = {};
    if (mediaTrigger === "Looping") {
      video.play().catch((e2) => debugError("[Video] Auto-play failed:", e2));
    } else if (mediaTrigger === "OnPointerExit" || mediaTrigger === "OnPointerEnter") {
      tempCallbacks.onPointerEnter = (e2) => {
        e2?.stopPropagation();
        video.play().catch((err) => debugError("[Video] Play failed:", err));
      };
      tempCallbacks.onPointerLeave = (e2) => {
        e2?.stopPropagation();
        video.pause();
      };
    } else {
      tempCallbacks.onClick = (e2) => {
        e2?.stopPropagation();
        toggleVideo();
      };
    }
    setCallbacks(tempCallbacks);
  }, [speaker, video, muted, camera, volume, sourceObject, toggleVideo]);
  reactExports.useEffect(() => {
    return () => {
      if (speaker) {
        if (speaker.isPlaying) speaker.stop();
        speaker.disconnect();
        setSpeaker(void 0);
      }
      if (video) {
        video.pause();
        video.remove();
      }
    };
  }, []);
  if (!dims || !video) {
    return null;
  }
  let width = 1;
  let height = 1;
  let scale = 1;
  const rotation = [Math.PI, Math.PI, Math.PI];
  if (sourceObject) {
    const box = new Box3().setFromObject(sourceObject);
    const boxSize = new Vector3();
    box.getSize(boxSize);
    width = boxSize.x;
    height = dims.y / dims.x * boxSize.x;
    const sortedDims = [boxSize.x, boxSize.y, boxSize.z].sort((a5, b6) => b6 - a5);
    scale = sortedDims[0] / width;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("group", { name: "webcrafter-video" + src, ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("mesh", { ...callbacks, rotation, scale: [scale, scale, scale], children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("planeGeometry", { args: [width, height] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("meshBasicMaterial", { side: DoubleSide, children: /* @__PURE__ */ jsxRuntimeExports.jsx("videoTexture", { attach: "map", args: [video], colorSpace: SRGBColorSpace$1 }) })
    ] }),
    framed && /* @__PURE__ */ jsxRuntimeExports.jsx(Frame, { width, height, thickness: frameWidth, material: frameMaterial, rotation })
  ] });
}
function VideoElement({ element, index }) {
  const size = Math.max(...element.object.scale.toArray());
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Video,
    {
      size,
      src: element.mediaSrc,
      position: element.worldPosition,
      quaternion: element.worldRotation,
      sourceObject: element.object,
      muted: false,
      volume: element.volume,
      framed: true
    },
    `video-${index}-${element.mediaSrc}`
  );
}
function AudioElement({ element, index }) {
  const size = Math.max(...element.object.scale.toArray());
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Audio3D,
    {
      size,
      url: element.mediaSrc,
      sourceObject: element.object,
      position: element.worldPosition,
      quaternion: element.worldRotation,
      muted: false,
      volume: element.volume,
      framed: true
    },
    `audio-${index}-${element.mediaSrc}`
  );
}
function Media({ sceneManager, interactionManager }) {
  const [isMediaLoaded, setIsMediaLoaded] = reactExports.useState(false);
  const mediaObjects = reactExports.useMemo(() => {
    return sceneManager?.mediaObjects ?? null;
  }, [sceneManager]);
  const loadMedia = reactExports.useCallback(() => {
    setIsMediaLoaded(true);
  }, []);
  reactExports.useEffect(() => {
    if (!mediaObjects) return;
    document.addEventListener("click", loadMedia, { once: true });
    return () => document.removeEventListener("click", loadMedia);
  }, [mediaObjects, loadMedia]);
  if (!isMediaLoaded || !mediaObjects) return null;
  const { video = [], audio = [], positionalAudio = [] } = mediaObjects;
  const allAudio = [...audio, ...positionalAudio];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("group", { name: "media-container", children: [
    video.map((element, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(VideoElement, { element, index }, `video-${index}`)),
    allAudio.map((element, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(AudioElement, { element, index }, `audio-${index}`))
  ] });
}
let A$1;
const I$1 = new Array(128).fill(void 0);
I$1.push(void 0, null, true, false);
let g$1 = I$1.length;
function C$1(A2) {
  g$1 === I$1.length && I$1.push(I$1.length + 1);
  const C2 = g$1;
  return g$1 = I$1[C2], I$1[C2] = A2, C2;
}
function B$1(A2) {
  return I$1[A2];
}
function Q(A2) {
  const C2 = B$1(A2);
  return (function(A3) {
    A3 < 132 || (I$1[A3] = g$1, g$1 = A3);
  })(A2), C2;
}
function E$1(A2) {
  return null == A2;
}
let i$1 = null;
function D$1() {
  return null !== i$1 && 0 !== i$1.byteLength || (i$1 = new Float64Array(A$1.memory.buffer)), i$1;
}
let o$1 = null;
function S$1() {
  return null !== o$1 && 0 !== o$1.byteLength || (o$1 = new Int32Array(A$1.memory.buffer)), o$1;
}
const w$1 = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8", { ignoreBOM: true, fatal: true }) : { decode: () => {
  throw Error("TextDecoder not available");
} };
"undefined" != typeof TextDecoder && w$1.decode();
let G$1 = null;
function k$1(I2, g2) {
  return I2 >>>= 0, w$1.decode((null !== G$1 && 0 !== G$1.byteLength || (G$1 = new Uint8Array(A$1.memory.buffer)), G$1).subarray(I2, I2 + g2));
}
function K$1(A2, I2) {
  if (!(A2 instanceof I2)) throw new Error(`expected instance of ${I2.name}`);
  return A2.ptr;
}
let J$1 = null;
function U$1() {
  return null !== J$1 && 0 !== J$1.byteLength || (J$1 = new Float32Array(A$1.memory.buffer)), J$1;
}
let h$1 = 128;
function y$1(A2) {
  if (1 == h$1) throw new Error("out of js stack");
  return I$1[--h$1] = A2, h$1;
}
function N$1(A2, I2) {
  return A2 >>>= 0, U$1().subarray(A2 / 4, A2 / 4 + I2);
}
let M$1 = null;
function F$1() {
  return null !== M$1 && 0 !== M$1.byteLength || (M$1 = new Uint32Array(A$1.memory.buffer)), M$1;
}
let a$1 = 0;
function s$1(A2, I2) {
  const g2 = I2(4 * A2.length, 4) >>> 0;
  return U$1().set(A2, g2 / 4), a$1 = A2.length, g2;
}
function R$1(A2, I2) {
  const g2 = I2(4 * A2.length, 4) >>> 0;
  return F$1().set(A2, g2 / 4), a$1 = A2.length, g2;
}
function c$1(I2, g2) {
  try {
    return I2.apply(this, g2);
  } catch (I3) {
    A$1.__wbindgen_exn_store(C$1(I3));
  }
}
const q$1 = Object.freeze({ LinX: 0, 0: "LinX", LinY: 1, 1: "LinY", LinZ: 2, 2: "LinZ", AngX: 3, 3: "AngX", AngY: 4, 4: "AngY", AngZ: 5, 5: "AngZ" });
const Y$1 = Object.freeze({ Revolute: 0, 0: "Revolute", Fixed: 1, 1: "Fixed", Prismatic: 2, 2: "Prismatic", Rope: 3, 3: "Rope", Spring: 4, 4: "Spring", Spherical: 5, 5: "Spherical", Generic: 6, 6: "Generic" });
const l$1 = Object.freeze({ Ball: 0, 0: "Ball", Cuboid: 1, 1: "Cuboid", Capsule: 2, 2: "Capsule", Segment: 3, 3: "Segment", Polyline: 4, 4: "Polyline", Triangle: 5, 5: "Triangle", TriMesh: 6, 6: "TriMesh", HeightField: 7, 7: "HeightField", Compound: 8, 8: "Compound", ConvexPolyhedron: 9, 9: "ConvexPolyhedron", Cylinder: 10, 10: "Cylinder", Cone: 11, 11: "Cone", RoundCuboid: 12, 12: "RoundCuboid", RoundTriangle: 13, 13: "RoundTriangle", RoundCylinder: 14, 14: "RoundCylinder", RoundCone: 15, 15: "RoundCone", RoundConvexPolyhedron: 16, 16: "RoundConvexPolyhedron", HalfSpace: 17, 17: "HalfSpace" }), L$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawbroadphase_free(I2 >>> 0)));
let H$1 = class H {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(H.prototype);
    return I2.__wbg_ptr = A2, L$1.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, L$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawbroadphase_free(I2);
  }
  constructor() {
    const I2 = A$1.rawbroadphase_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
};
const t$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawccdsolver_free(I2 >>> 0)));
let p$1 = class p {
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, t$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawccdsolver_free(I2);
  }
  constructor() {
    const I2 = A$1.rawccdsolver_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
};
const e$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawcharactercollision_free(I2 >>> 0)));
let r$1 = class r {
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, e$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawcharactercollision_free(I2);
  }
  constructor() {
    const I2 = A$1.rawcharactercollision_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  handle() {
    return A$1.rawcharactercollision_handle(this.__wbg_ptr);
  }
  translationDeltaApplied() {
    const I2 = A$1.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  translationDeltaRemaining() {
    const I2 = A$1.rawcharactercollision_translationDeltaRemaining(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  toi() {
    return A$1.rawcharactercollision_toi(this.__wbg_ptr);
  }
  worldWitness1() {
    const I2 = A$1.rawcharactercollision_worldWitness1(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  worldWitness2() {
    const I2 = A$1.rawcharactercollision_worldWitness2(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  worldNormal1() {
    const I2 = A$1.rawcharactercollision_worldNormal1(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  worldNormal2() {
    const I2 = A$1.rawcharactercollision_worldNormal2(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
};
const n$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawcolliderset_free(I2 >>> 0)));
let d$1 = class d {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(d.prototype);
    return I2.__wbg_ptr = A2, n$1.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, n$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawcolliderset_free(I2);
  }
  coTranslation(I2) {
    const g2 = A$1.rawcolliderset_coTranslation(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  coRotation(I2) {
    const g2 = A$1.rawcolliderset_coRotation(this.__wbg_ptr, I2);
    return HA.__wrap(g2);
  }
  coSetTranslation(I2, g2, C2, B2) {
    A$1.rawcolliderset_coSetTranslation(this.__wbg_ptr, I2, g2, C2, B2);
  }
  coSetTranslationWrtParent(I2, g2, C2, B2) {
    A$1.rawcolliderset_coSetTranslationWrtParent(this.__wbg_ptr, I2, g2, C2, B2);
  }
  coSetRotation(I2, g2, C2, B2, Q2) {
    A$1.rawcolliderset_coSetRotation(this.__wbg_ptr, I2, g2, C2, B2, Q2);
  }
  coSetRotationWrtParent(I2, g2, C2, B2, Q2) {
    A$1.rawcolliderset_coSetRotationWrtParent(this.__wbg_ptr, I2, g2, C2, B2, Q2);
  }
  coIsSensor(I2) {
    return 0 !== A$1.rawcolliderset_coIsSensor(this.__wbg_ptr, I2);
  }
  coShapeType(I2) {
    return A$1.rawcolliderset_coShapeType(this.__wbg_ptr, I2);
  }
  coHalfspaceNormal(I2) {
    const g2 = A$1.rawcolliderset_coHalfspaceNormal(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  coHalfExtents(I2) {
    const g2 = A$1.rawcolliderset_coHalfExtents(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  coSetHalfExtents(I2, g2) {
    K$1(g2, xA), A$1.rawcolliderset_coSetHalfExtents(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
  coRadius(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coRadius(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coSetRadius(I2, g2) {
    A$1.rawcolliderset_coSetRadius(this.__wbg_ptr, I2, g2);
  }
  coHalfHeight(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coHalfHeight(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coSetHalfHeight(I2, g2) {
    A$1.rawcolliderset_coSetHalfHeight(this.__wbg_ptr, I2, g2);
  }
  coRoundRadius(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coRoundRadius(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coSetRoundRadius(I2, g2) {
    A$1.rawcolliderset_coSetRoundRadius(this.__wbg_ptr, I2, g2);
  }
  coVertices(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coVertices(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = S$1()[B2 / 4 + 1];
      let Q2;
      return 0 !== g2 && (Q2 = N$1(g2, C2).slice(), A$1.__wbindgen_free(g2, 4 * C2, 4)), Q2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coIndices(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coIndices(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = S$1()[B2 / 4 + 1];
      let Q2;
      return 0 !== g2 && (Q2 = (function(A2, I3) {
        return A2 >>>= 0, F$1().subarray(A2 / 4, A2 / 4 + I3);
      })(g2, C2).slice(), A$1.__wbindgen_free(g2, 4 * C2, 4)), Q2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coTriMeshFlags(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coTriMeshFlags(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = S$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2 >>> 0;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coHeightFieldFlags(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coHeightFieldFlags(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = S$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2 >>> 0;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coHeightfieldHeights(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coHeightfieldHeights(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = S$1()[B2 / 4 + 1];
      let Q2;
      return 0 !== g2 && (Q2 = N$1(g2, C2).slice(), A$1.__wbindgen_free(g2, 4 * C2, 4)), Q2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coHeightfieldScale(I2) {
    const g2 = A$1.rawcolliderset_coHeightfieldScale(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  coHeightfieldNRows(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coHeightfieldNRows(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = S$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2 >>> 0;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coHeightfieldNCols(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coHeightfieldNCols(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = S$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2 >>> 0;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coParent(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawcolliderset_coParent(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = D$1()[B2 / 8 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  coSetEnabled(I2, g2) {
    A$1.rawcolliderset_coSetEnabled(this.__wbg_ptr, I2, g2);
  }
  coIsEnabled(I2) {
    return 0 !== A$1.rawcolliderset_coIsEnabled(this.__wbg_ptr, I2);
  }
  coSetContactSkin(I2, g2) {
    A$1.rawcolliderset_coSetContactSkin(this.__wbg_ptr, I2, g2);
  }
  coContactSkin(I2) {
    return A$1.rawcolliderset_coContactSkin(this.__wbg_ptr, I2);
  }
  coFriction(I2) {
    return A$1.rawcolliderset_coFriction(this.__wbg_ptr, I2);
  }
  coRestitution(I2) {
    return A$1.rawcolliderset_coRestitution(this.__wbg_ptr, I2);
  }
  coDensity(I2) {
    return A$1.rawcolliderset_coDensity(this.__wbg_ptr, I2);
  }
  coMass(I2) {
    return A$1.rawcolliderset_coMass(this.__wbg_ptr, I2);
  }
  coVolume(I2) {
    return A$1.rawcolliderset_coVolume(this.__wbg_ptr, I2);
  }
  coCollisionGroups(I2) {
    return A$1.rawcolliderset_coCollisionGroups(this.__wbg_ptr, I2) >>> 0;
  }
  coSolverGroups(I2) {
    return A$1.rawcolliderset_coSolverGroups(this.__wbg_ptr, I2) >>> 0;
  }
  coActiveHooks(I2) {
    return A$1.rawcolliderset_coActiveHooks(this.__wbg_ptr, I2) >>> 0;
  }
  coActiveCollisionTypes(I2) {
    return A$1.rawcolliderset_coActiveCollisionTypes(this.__wbg_ptr, I2);
  }
  coActiveEvents(I2) {
    return A$1.rawcolliderset_coActiveEvents(this.__wbg_ptr, I2) >>> 0;
  }
  coContactForceEventThreshold(I2) {
    return A$1.rawcolliderset_coContactForceEventThreshold(this.__wbg_ptr, I2);
  }
  coContainsPoint(I2, g2) {
    K$1(g2, xA);
    return 0 !== A$1.rawcolliderset_coContainsPoint(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
  coCastShape(I2, g2, C2, B2, Q2, E2, i2, D2, o2) {
    K$1(g2, xA), K$1(C2, dA), K$1(B2, xA), K$1(Q2, HA), K$1(E2, xA);
    const S2 = A$1.rawcolliderset_coCastShape(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, E2.__wbg_ptr, i2, D2, o2);
    return 0 === S2 ? void 0 : OA.__wrap(S2);
  }
  coCastCollider(I2, g2, C2, B2, Q2, E2, i2) {
    K$1(g2, xA), K$1(B2, xA);
    const D2 = A$1.rawcolliderset_coCastCollider(this.__wbg_ptr, I2, g2.__wbg_ptr, C2, B2.__wbg_ptr, Q2, E2, i2);
    return 0 === D2 ? void 0 : O$1.__wrap(D2);
  }
  coIntersectsShape(I2, g2, C2, B2) {
    K$1(g2, dA), K$1(C2, xA), K$1(B2, HA);
    return 0 !== A$1.rawcolliderset_coIntersectsShape(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr);
  }
  coContactShape(I2, g2, C2, B2, Q2) {
    K$1(g2, dA), K$1(C2, xA), K$1(B2, HA);
    const E2 = A$1.rawcolliderset_coContactShape(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2);
    return 0 === E2 ? void 0 : bA.__wrap(E2);
  }
  coContactCollider(I2, g2, C2) {
    const B2 = A$1.rawcolliderset_coContactCollider(this.__wbg_ptr, I2, g2, C2);
    return 0 === B2 ? void 0 : bA.__wrap(B2);
  }
  coProjectPoint(I2, g2, C2) {
    K$1(g2, xA);
    const B2 = A$1.rawcolliderset_coProjectPoint(this.__wbg_ptr, I2, g2.__wbg_ptr, C2);
    return yA.__wrap(B2);
  }
  coIntersectsRay(I2, g2, C2, B2) {
    K$1(g2, xA), K$1(C2, xA);
    return 0 !== A$1.rawcolliderset_coIntersectsRay(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2);
  }
  coCastRay(I2, g2, C2, B2, Q2) {
    K$1(g2, xA), K$1(C2, xA);
    return A$1.rawcolliderset_coCastRay(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2, Q2);
  }
  coCastRayAndGetNormal(I2, g2, C2, B2, Q2) {
    K$1(g2, xA), K$1(C2, xA);
    const E2 = A$1.rawcolliderset_coCastRayAndGetNormal(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2, Q2);
    return 0 === E2 ? void 0 : qA.__wrap(E2);
  }
  coSetSensor(I2, g2) {
    A$1.rawcolliderset_coSetSensor(this.__wbg_ptr, I2, g2);
  }
  coSetRestitution(I2, g2) {
    A$1.rawcolliderset_coSetRestitution(this.__wbg_ptr, I2, g2);
  }
  coSetFriction(I2, g2) {
    A$1.rawcolliderset_coSetFriction(this.__wbg_ptr, I2, g2);
  }
  coFrictionCombineRule(I2) {
    return A$1.rawcolliderset_coFrictionCombineRule(this.__wbg_ptr, I2) >>> 0;
  }
  coSetFrictionCombineRule(I2, g2) {
    A$1.rawcolliderset_coSetFrictionCombineRule(this.__wbg_ptr, I2, g2);
  }
  coRestitutionCombineRule(I2) {
    return A$1.rawcolliderset_coRestitutionCombineRule(this.__wbg_ptr, I2) >>> 0;
  }
  coSetRestitutionCombineRule(I2, g2) {
    A$1.rawcolliderset_coSetRestitutionCombineRule(this.__wbg_ptr, I2, g2);
  }
  coSetCollisionGroups(I2, g2) {
    A$1.rawcolliderset_coSetCollisionGroups(this.__wbg_ptr, I2, g2);
  }
  coSetSolverGroups(I2, g2) {
    A$1.rawcolliderset_coSetSolverGroups(this.__wbg_ptr, I2, g2);
  }
  coSetActiveHooks(I2, g2) {
    A$1.rawcolliderset_coSetActiveHooks(this.__wbg_ptr, I2, g2);
  }
  coSetActiveEvents(I2, g2) {
    A$1.rawcolliderset_coSetActiveEvents(this.__wbg_ptr, I2, g2);
  }
  coSetActiveCollisionTypes(I2, g2) {
    A$1.rawcolliderset_coSetActiveCollisionTypes(this.__wbg_ptr, I2, g2);
  }
  coSetShape(I2, g2) {
    K$1(g2, dA), A$1.rawcolliderset_coSetShape(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
  coSetContactForceEventThreshold(I2, g2) {
    A$1.rawcolliderset_coSetContactForceEventThreshold(this.__wbg_ptr, I2, g2);
  }
  coSetDensity(I2, g2) {
    A$1.rawcolliderset_coSetDensity(this.__wbg_ptr, I2, g2);
  }
  coSetMass(I2, g2) {
    A$1.rawcolliderset_coSetMass(this.__wbg_ptr, I2, g2);
  }
  coSetMassProperties(I2, g2, C2, B2, Q2) {
    K$1(C2, xA), K$1(B2, xA), K$1(Q2, HA), A$1.rawcolliderset_coSetMassProperties(this.__wbg_ptr, I2, g2, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr);
  }
  constructor() {
    const I2 = A$1.rawcolliderset_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  len() {
    return A$1.rawcolliderset_len(this.__wbg_ptr) >>> 0;
  }
  contains(I2) {
    return 0 !== A$1.rawcolliderset_contains(this.__wbg_ptr, I2);
  }
  createCollider(I2, g2, C2, B2, Q2, E2, i2, o2, w2, G2, k2, J2, U2, h2, y2, N2, M2, F2, a5, s2, R2, c2, q2, Y2, l2) {
    try {
      const t2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      K$1(g2, dA), K$1(C2, xA), K$1(B2, HA), K$1(i2, xA), K$1(o2, xA), K$1(w2, HA), K$1(l2, lA), A$1.rawcolliderset_createCollider(t2, this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2, E2, i2.__wbg_ptr, o2.__wbg_ptr, w2.__wbg_ptr, G2, k2, J2, U2, h2, y2, N2, M2, F2, a5, s2, R2, c2, q2, Y2, l2.__wbg_ptr);
      var L2 = S$1()[t2 / 4 + 0], H3 = D$1()[t2 / 8 + 1];
      return 0 === L2 ? void 0 : H3;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  remove(I2, g2, C2, B2) {
    K$1(g2, EA), K$1(C2, lA), A$1.rawcolliderset_remove(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2);
  }
  isHandleValid(I2) {
    return 0 !== A$1.rawcolliderset_contains(this.__wbg_ptr, I2);
  }
  forEachColliderHandle(g2) {
    try {
      A$1.rawcolliderset_forEachColliderHandle(this.__wbg_ptr, y$1(g2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
};
const T$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawcollidershapecasthit_free(I2 >>> 0)));
let O$1 = class O {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(O.prototype);
    return I2.__wbg_ptr = A2, T$1.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, T$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawcollidershapecasthit_free(I2);
  }
  colliderHandle() {
    return A$1.rawcharactercollision_handle(this.__wbg_ptr);
  }
  time_of_impact() {
    return A$1.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
  }
  witness1() {
    const I2 = A$1.rawcollidershapecasthit_witness1(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  witness2() {
    const I2 = A$1.rawcollidershapecasthit_witness2(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  normal1() {
    const I2 = A$1.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  normal2() {
    const I2 = A$1.rawcharactercollision_translationDeltaRemaining(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
};
const Z = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawcontactforceevent_free(I2 >>> 0)));
let b$1 = class b {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(b.prototype);
    return I2.__wbg_ptr = A2, Z.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, Z.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawcontactforceevent_free(I2);
  }
  collider1() {
    return A$1.rawcharactercollision_handle(this.__wbg_ptr);
  }
  collider2() {
    return A$1.rawcontactforceevent_collider2(this.__wbg_ptr);
  }
  total_force() {
    const I2 = A$1.rawcontactforceevent_total_force(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  total_force_magnitude() {
    return A$1.rawcontactforceevent_total_force_magnitude(this.__wbg_ptr);
  }
  max_force_direction() {
    const I2 = A$1.rawcontactforceevent_max_force_direction(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  max_force_magnitude() {
    return A$1.rawcontactforceevent_max_force_magnitude(this.__wbg_ptr);
  }
};
const W$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawcontactmanifold_free(I2 >>> 0)));
let x$1 = class x {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(x.prototype);
    return I2.__wbg_ptr = A2, W$1.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, W$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawcontactmanifold_free(I2);
  }
  normal() {
    const I2 = A$1.rawcontactmanifold_normal(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  local_n1() {
    const I2 = A$1.rawcontactmanifold_local_n1(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  local_n2() {
    const I2 = A$1.rawcontactmanifold_local_n2(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  subshape1() {
    return A$1.rawcontactmanifold_subshape1(this.__wbg_ptr) >>> 0;
  }
  subshape2() {
    return A$1.rawcontactmanifold_subshape2(this.__wbg_ptr) >>> 0;
  }
  num_contacts() {
    return A$1.rawcontactmanifold_num_contacts(this.__wbg_ptr) >>> 0;
  }
  contact_local_p1(I2) {
    const g2 = A$1.rawcontactmanifold_contact_local_p1(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  contact_local_p2(I2) {
    const g2 = A$1.rawcontactmanifold_contact_local_p2(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  contact_dist(I2) {
    return A$1.rawcontactmanifold_contact_dist(this.__wbg_ptr, I2);
  }
  contact_fid1(I2) {
    return A$1.rawcontactmanifold_contact_fid1(this.__wbg_ptr, I2) >>> 0;
  }
  contact_fid2(I2) {
    return A$1.rawcontactmanifold_contact_fid2(this.__wbg_ptr, I2) >>> 0;
  }
  contact_impulse(I2) {
    return A$1.rawcontactmanifold_contact_impulse(this.__wbg_ptr, I2);
  }
  contact_tangent_impulse_x(I2) {
    return A$1.rawcontactmanifold_contact_tangent_impulse_x(this.__wbg_ptr, I2);
  }
  contact_tangent_impulse_y(I2) {
    return A$1.rawcontactmanifold_contact_tangent_impulse_y(this.__wbg_ptr, I2);
  }
  num_solver_contacts() {
    return A$1.rawcontactmanifold_num_solver_contacts(this.__wbg_ptr) >>> 0;
  }
  solver_contact_point(I2) {
    const g2 = A$1.rawcontactmanifold_solver_contact_point(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  solver_contact_dist(I2) {
    return A$1.rawcontactmanifold_solver_contact_dist(this.__wbg_ptr, I2);
  }
  solver_contact_friction(I2) {
    return A$1.rawcontactmanifold_solver_contact_friction(this.__wbg_ptr, I2);
  }
  solver_contact_restitution(I2) {
    return A$1.rawcontactmanifold_solver_contact_restitution(this.__wbg_ptr, I2);
  }
  solver_contact_tangent_velocity(I2) {
    const g2 = A$1.rawcontactmanifold_solver_contact_tangent_velocity(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
};
const m$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawcontactpair_free(I2 >>> 0)));
let j$1 = class j {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(j.prototype);
    return I2.__wbg_ptr = A2, m$1.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, m$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawcontactpair_free(I2);
  }
  collider1() {
    return A$1.rawcontactpair_collider1(this.__wbg_ptr);
  }
  collider2() {
    return A$1.rawcontactpair_collider2(this.__wbg_ptr);
  }
  numContactManifolds() {
    return A$1.rawcontactpair_numContactManifolds(this.__wbg_ptr) >>> 0;
  }
  contactManifold(I2) {
    const g2 = A$1.rawcontactpair_contactManifold(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : x$1.__wrap(g2);
  }
};
const f$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawdebugrenderpipeline_free(I2 >>> 0)));
let V$1 = class V {
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, f$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawdebugrenderpipeline_free(I2);
  }
  constructor() {
    const I2 = A$1.rawdebugrenderpipeline_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  vertices() {
    return Q(A$1.rawdebugrenderpipeline_vertices(this.__wbg_ptr));
  }
  colors() {
    return Q(A$1.rawdebugrenderpipeline_colors(this.__wbg_ptr));
  }
  render(I2, g2, C2, B2, Q2) {
    K$1(I2, lA), K$1(g2, d$1), K$1(C2, gA), K$1(B2, SA), K$1(Q2, GA), A$1.rawdebugrenderpipeline_render(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr);
  }
};
const X$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawdeserializedworld_free(I2 >>> 0)));
let P$1 = class P {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(P.prototype);
    return I2.__wbg_ptr = A2, X$1.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, X$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawdeserializedworld_free(I2);
  }
  takeGravity() {
    const I2 = A$1.rawdeserializedworld_takeGravity(this.__wbg_ptr);
    return 0 === I2 ? void 0 : xA.__wrap(I2);
  }
  takeIntegrationParameters() {
    const I2 = A$1.rawdeserializedworld_takeIntegrationParameters(this.__wbg_ptr);
    return 0 === I2 ? void 0 : BA.__wrap(I2);
  }
  takeIslandManager() {
    const I2 = A$1.rawdeserializedworld_takeIslandManager(this.__wbg_ptr);
    return 0 === I2 ? void 0 : EA.__wrap(I2);
  }
  takeBroadPhase() {
    const I2 = A$1.rawdeserializedworld_takeBroadPhase(this.__wbg_ptr);
    return 0 === I2 ? void 0 : H$1.__wrap(I2);
  }
  takeNarrowPhase() {
    const I2 = A$1.rawdeserializedworld_takeNarrowPhase(this.__wbg_ptr);
    return 0 === I2 ? void 0 : GA.__wrap(I2);
  }
  takeBodies() {
    const I2 = A$1.rawdeserializedworld_takeBodies(this.__wbg_ptr);
    return 0 === I2 ? void 0 : lA.__wrap(I2);
  }
  takeColliders() {
    const I2 = A$1.rawdeserializedworld_takeColliders(this.__wbg_ptr);
    return 0 === I2 ? void 0 : d$1.__wrap(I2);
  }
  takeImpulseJoints() {
    const I2 = A$1.rawdeserializedworld_takeImpulseJoints(this.__wbg_ptr);
    return 0 === I2 ? void 0 : gA.__wrap(I2);
  }
  takeMultibodyJoints() {
    const I2 = A$1.rawdeserializedworld_takeMultibodyJoints(this.__wbg_ptr);
    return 0 === I2 ? void 0 : SA.__wrap(I2);
  }
};
const u$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawdynamicraycastvehiclecontroller_free(I2 >>> 0)));
let v$1 = class v {
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, u$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawdynamicraycastvehiclecontroller_free(I2);
  }
  constructor(I2) {
    const g2 = A$1.rawdynamicraycastvehiclecontroller_new(I2);
    return this.__wbg_ptr = g2 >>> 0, this;
  }
  current_vehicle_speed() {
    return A$1.rawdynamicraycastvehiclecontroller_current_vehicle_speed(this.__wbg_ptr);
  }
  chassis() {
    return A$1.rawdynamicraycastvehiclecontroller_chassis(this.__wbg_ptr);
  }
  index_up_axis() {
    return A$1.rawdynamicraycastvehiclecontroller_index_up_axis(this.__wbg_ptr) >>> 0;
  }
  set_index_up_axis(I2) {
    A$1.rawdynamicraycastvehiclecontroller_set_index_up_axis(this.__wbg_ptr, I2);
  }
  index_forward_axis() {
    return A$1.rawdynamicraycastvehiclecontroller_index_forward_axis(this.__wbg_ptr) >>> 0;
  }
  set_index_forward_axis(I2) {
    A$1.rawdynamicraycastvehiclecontroller_set_index_forward_axis(this.__wbg_ptr, I2);
  }
  add_wheel(I2, g2, C2, B2, Q2) {
    K$1(I2, xA), K$1(g2, xA), K$1(C2, xA), A$1.rawdynamicraycastvehiclecontroller_add_wheel(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2, Q2);
  }
  num_wheels() {
    return A$1.rawdynamicraycastvehiclecontroller_num_wheels(this.__wbg_ptr) >>> 0;
  }
  update_vehicle(g2, C2, B2, Q2, i2, D2, o2) {
    try {
      K$1(C2, lA), K$1(B2, d$1), K$1(Q2, MA), A$1.rawdynamicraycastvehiclecontroller_update_vehicle(this.__wbg_ptr, g2, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, i2, !E$1(D2), E$1(D2) ? 0 : D2, y$1(o2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  wheel_chassis_connection_point_cs(I2) {
    const g2 = A$1.rawdynamicraycastvehiclecontroller_wheel_chassis_connection_point_cs(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  set_wheel_chassis_connection_point_cs(I2, g2) {
    K$1(g2, xA), A$1.rawdynamicraycastvehiclecontroller_set_wheel_chassis_connection_point_cs(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
  wheel_suspension_rest_length(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_suspension_rest_length(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_suspension_rest_length(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_suspension_rest_length(this.__wbg_ptr, I2, g2);
  }
  wheel_max_suspension_travel(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_max_suspension_travel(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_max_suspension_travel(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_max_suspension_travel(this.__wbg_ptr, I2, g2);
  }
  wheel_radius(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_radius(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_radius(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_radius(this.__wbg_ptr, I2, g2);
  }
  wheel_suspension_stiffness(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_suspension_stiffness(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_suspension_stiffness(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_suspension_stiffness(this.__wbg_ptr, I2, g2);
  }
  wheel_suspension_compression(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_suspension_compression(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_suspension_compression(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_suspension_compression(this.__wbg_ptr, I2, g2);
  }
  wheel_suspension_relaxation(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_suspension_relaxation(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_suspension_relaxation(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_suspension_relaxation(this.__wbg_ptr, I2, g2);
  }
  wheel_max_suspension_force(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_max_suspension_force(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_max_suspension_force(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_max_suspension_force(this.__wbg_ptr, I2, g2);
  }
  wheel_brake(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_brake(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_brake(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_brake(this.__wbg_ptr, I2, g2);
  }
  wheel_steering(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_steering(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_steering(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_steering(this.__wbg_ptr, I2, g2);
  }
  wheel_engine_force(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_engine_force(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_engine_force(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_engine_force(this.__wbg_ptr, I2, g2);
  }
  wheel_direction_cs(I2) {
    const g2 = A$1.rawdynamicraycastvehiclecontroller_wheel_direction_cs(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  set_wheel_direction_cs(I2, g2) {
    K$1(g2, xA), A$1.rawdynamicraycastvehiclecontroller_set_wheel_direction_cs(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
  wheel_axle_cs(I2) {
    const g2 = A$1.rawdynamicraycastvehiclecontroller_wheel_axle_cs(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  set_wheel_axle_cs(I2, g2) {
    K$1(g2, xA), A$1.rawdynamicraycastvehiclecontroller_set_wheel_axle_cs(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
  wheel_friction_slip(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_friction_slip(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_friction_slip(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_friction_slip(this.__wbg_ptr, I2, g2);
  }
  wheel_side_friction_stiffness(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_side_friction_stiffness(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  set_wheel_side_friction_stiffness(I2, g2) {
    A$1.rawdynamicraycastvehiclecontroller_set_wheel_side_friction_stiffness(this.__wbg_ptr, I2, g2);
  }
  wheel_rotation(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_rotation(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  wheel_forward_impulse(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_forward_impulse(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  wheel_side_impulse(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_side_impulse(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  wheel_suspension_force(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_suspension_force(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  wheel_contact_normal_ws(I2) {
    const g2 = A$1.rawdynamicraycastvehiclecontroller_wheel_contact_normal_ws(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  wheel_contact_point_ws(I2) {
    const g2 = A$1.rawdynamicraycastvehiclecontroller_wheel_contact_point_ws(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  wheel_suspension_length(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_suspension_length(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = U$1()[B2 / 4 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  wheel_hard_point_ws(I2) {
    const g2 = A$1.rawdynamicraycastvehiclecontroller_wheel_hard_point_ws(this.__wbg_ptr, I2);
    return 0 === g2 ? void 0 : xA.__wrap(g2);
  }
  wheel_is_in_contact(I2) {
    return 0 !== A$1.rawdynamicraycastvehiclecontroller_wheel_is_in_contact(this.__wbg_ptr, I2);
  }
  wheel_ground_object(I2) {
    try {
      const B2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawdynamicraycastvehiclecontroller_wheel_ground_object(B2, this.__wbg_ptr, I2);
      var g2 = S$1()[B2 / 4 + 0], C2 = D$1()[B2 / 8 + 1];
      return 0 === g2 ? void 0 : C2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
};
const z$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_raweventqueue_free(I2 >>> 0)));
class _ {
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, z$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_raweventqueue_free(I2);
  }
  constructor(I2) {
    const g2 = A$1.raweventqueue_new(I2);
    return this.__wbg_ptr = g2 >>> 0, this;
  }
  drainCollisionEvents(g2) {
    try {
      A$1.raweventqueue_drainCollisionEvents(this.__wbg_ptr, y$1(g2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  drainContactForceEvents(g2) {
    try {
      A$1.raweventqueue_drainContactForceEvents(this.__wbg_ptr, y$1(g2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  clear() {
    A$1.raweventqueue_clear(this.__wbg_ptr);
  }
}
const $$1 = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawgenericjoint_free(I2 >>> 0)));
class AA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(AA.prototype);
    return I2.__wbg_ptr = A2, $$1.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, $$1.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawgenericjoint_free(I2);
  }
  static generic(I2, g2, C2, B2) {
    K$1(I2, xA), K$1(g2, xA), K$1(C2, xA);
    const Q2 = A$1.rawgenericjoint_generic(I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2);
    return 0 === Q2 ? void 0 : AA.__wrap(Q2);
  }
  static spring(I2, g2, C2, B2, Q2) {
    K$1(B2, xA), K$1(Q2, xA);
    const E2 = A$1.rawgenericjoint_spring(I2, g2, C2, B2.__wbg_ptr, Q2.__wbg_ptr);
    return AA.__wrap(E2);
  }
  static rope(I2, g2, C2) {
    K$1(g2, xA), K$1(C2, xA);
    const B2 = A$1.rawgenericjoint_rope(I2, g2.__wbg_ptr, C2.__wbg_ptr);
    return AA.__wrap(B2);
  }
  static spherical(I2, g2) {
    K$1(I2, xA), K$1(g2, xA);
    const C2 = A$1.rawgenericjoint_spherical(I2.__wbg_ptr, g2.__wbg_ptr);
    return AA.__wrap(C2);
  }
  static prismatic(I2, g2, C2, B2, Q2, E2) {
    K$1(I2, xA), K$1(g2, xA), K$1(C2, xA);
    const i2 = A$1.rawgenericjoint_prismatic(I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2, Q2, E2);
    return 0 === i2 ? void 0 : AA.__wrap(i2);
  }
  static fixed(I2, g2, C2, B2) {
    K$1(I2, xA), K$1(g2, HA), K$1(C2, xA), K$1(B2, HA);
    const Q2 = A$1.rawgenericjoint_fixed(I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr);
    return AA.__wrap(Q2);
  }
  static revolute(I2, g2, C2) {
    K$1(I2, xA), K$1(g2, xA), K$1(C2, xA);
    const B2 = A$1.rawgenericjoint_revolute(I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr);
    return 0 === B2 ? void 0 : AA.__wrap(B2);
  }
}
const IA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawimpulsejointset_free(I2 >>> 0)));
class gA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(gA.prototype);
    return I2.__wbg_ptr = A2, IA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, IA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawimpulsejointset_free(I2);
  }
  jointType(I2) {
    return A$1.rawimpulsejointset_jointType(this.__wbg_ptr, I2);
  }
  jointBodyHandle1(I2) {
    return A$1.rawimpulsejointset_jointBodyHandle1(this.__wbg_ptr, I2);
  }
  jointBodyHandle2(I2) {
    return A$1.rawimpulsejointset_jointBodyHandle2(this.__wbg_ptr, I2);
  }
  jointFrameX1(I2) {
    const g2 = A$1.rawimpulsejointset_jointFrameX1(this.__wbg_ptr, I2);
    return HA.__wrap(g2);
  }
  jointFrameX2(I2) {
    const g2 = A$1.rawimpulsejointset_jointFrameX2(this.__wbg_ptr, I2);
    return HA.__wrap(g2);
  }
  jointAnchor1(I2) {
    const g2 = A$1.rawimpulsejointset_jointAnchor1(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  jointAnchor2(I2) {
    const g2 = A$1.rawimpulsejointset_jointAnchor2(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  jointSetAnchor1(I2, g2) {
    K$1(g2, xA), A$1.rawimpulsejointset_jointSetAnchor1(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
  jointSetAnchor2(I2, g2) {
    K$1(g2, xA), A$1.rawimpulsejointset_jointSetAnchor2(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
  jointContactsEnabled(I2) {
    return 0 !== A$1.rawimpulsejointset_jointContactsEnabled(this.__wbg_ptr, I2);
  }
  jointSetContactsEnabled(I2, g2) {
    A$1.rawimpulsejointset_jointSetContactsEnabled(this.__wbg_ptr, I2, g2);
  }
  jointLimitsEnabled(I2, g2) {
    return 0 !== A$1.rawimpulsejointset_jointLimitsEnabled(this.__wbg_ptr, I2, g2);
  }
  jointLimitsMin(I2, g2) {
    return A$1.rawimpulsejointset_jointLimitsMin(this.__wbg_ptr, I2, g2);
  }
  jointLimitsMax(I2, g2) {
    return A$1.rawimpulsejointset_jointLimitsMax(this.__wbg_ptr, I2, g2);
  }
  jointSetLimits(I2, g2, C2, B2) {
    A$1.rawimpulsejointset_jointSetLimits(this.__wbg_ptr, I2, g2, C2, B2);
  }
  jointConfigureMotorModel(I2, g2, C2) {
    A$1.rawimpulsejointset_jointConfigureMotorModel(this.__wbg_ptr, I2, g2, C2);
  }
  jointConfigureMotorVelocity(I2, g2, C2, B2) {
    A$1.rawimpulsejointset_jointConfigureMotorVelocity(this.__wbg_ptr, I2, g2, C2, B2);
  }
  jointConfigureMotorPosition(I2, g2, C2, B2, Q2) {
    A$1.rawimpulsejointset_jointConfigureMotorPosition(this.__wbg_ptr, I2, g2, C2, B2, Q2);
  }
  jointConfigureMotor(I2, g2, C2, B2, Q2, E2) {
    A$1.rawimpulsejointset_jointConfigureMotor(this.__wbg_ptr, I2, g2, C2, B2, Q2, E2);
  }
  constructor() {
    const I2 = A$1.rawimpulsejointset_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  createJoint(I2, g2, C2, B2) {
    K$1(I2, AA);
    return A$1.rawimpulsejointset_createJoint(this.__wbg_ptr, I2.__wbg_ptr, g2, C2, B2);
  }
  remove(I2, g2) {
    A$1.rawimpulsejointset_remove(this.__wbg_ptr, I2, g2);
  }
  len() {
    return A$1.rawimpulsejointset_len(this.__wbg_ptr) >>> 0;
  }
  contains(I2) {
    return 0 !== A$1.rawimpulsejointset_contains(this.__wbg_ptr, I2);
  }
  forEachJointHandle(g2) {
    try {
      A$1.rawimpulsejointset_forEachJointHandle(this.__wbg_ptr, y$1(g2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  forEachJointAttachedToRigidBody(g2, C2) {
    try {
      A$1.rawimpulsejointset_forEachJointAttachedToRigidBody(this.__wbg_ptr, g2, y$1(C2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
}
const CA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawintegrationparameters_free(I2 >>> 0)));
class BA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(BA.prototype);
    return I2.__wbg_ptr = A2, CA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, CA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawintegrationparameters_free(I2);
  }
  constructor() {
    const I2 = A$1.rawintegrationparameters_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  get dt() {
    return A$1.rawintegrationparameters_dt(this.__wbg_ptr);
  }
  get contact_erp() {
    return A$1.rawintegrationparameters_contact_erp(this.__wbg_ptr);
  }
  get normalizedAllowedLinearError() {
    return A$1.rawdynamicraycastvehiclecontroller_current_vehicle_speed(this.__wbg_ptr);
  }
  get normalizedPredictionDistance() {
    return A$1.rawcontactforceevent_max_force_magnitude(this.__wbg_ptr);
  }
  get numSolverIterations() {
    return A$1.rawintegrationparameters_numSolverIterations(this.__wbg_ptr) >>> 0;
  }
  get numAdditionalFrictionIterations() {
    return A$1.rawdynamicraycastvehiclecontroller_index_up_axis(this.__wbg_ptr) >>> 0;
  }
  get numInternalPgsIterations() {
    return A$1.rawdynamicraycastvehiclecontroller_index_forward_axis(this.__wbg_ptr) >>> 0;
  }
  get minIslandSize() {
    return A$1.rawimpulsejointset_len(this.__wbg_ptr) >>> 0;
  }
  get maxCcdSubsteps() {
    return A$1.rawintegrationparameters_maxCcdSubsteps(this.__wbg_ptr) >>> 0;
  }
  get lengthUnit() {
    return A$1.rawintegrationparameters_lengthUnit(this.__wbg_ptr);
  }
  set dt(I2) {
    A$1.rawintegrationparameters_set_dt(this.__wbg_ptr, I2);
  }
  set contact_natural_frequency(I2) {
    A$1.rawintegrationparameters_set_contact_natural_frequency(this.__wbg_ptr, I2);
  }
  set normalizedAllowedLinearError(I2) {
    A$1.rawintegrationparameters_set_normalizedAllowedLinearError(this.__wbg_ptr, I2);
  }
  set normalizedPredictionDistance(I2) {
    A$1.rawintegrationparameters_set_normalizedPredictionDistance(this.__wbg_ptr, I2);
  }
  set numSolverIterations(I2) {
    A$1.rawintegrationparameters_set_numSolverIterations(this.__wbg_ptr, I2);
  }
  set numAdditionalFrictionIterations(I2) {
    A$1.rawdynamicraycastvehiclecontroller_set_index_up_axis(this.__wbg_ptr, I2);
  }
  set numInternalPgsIterations(I2) {
    A$1.rawdynamicraycastvehiclecontroller_set_index_forward_axis(this.__wbg_ptr, I2);
  }
  set minIslandSize(I2) {
    A$1.rawintegrationparameters_set_minIslandSize(this.__wbg_ptr, I2);
  }
  set maxCcdSubsteps(I2) {
    A$1.rawintegrationparameters_set_maxCcdSubsteps(this.__wbg_ptr, I2);
  }
  set lengthUnit(I2) {
    A$1.rawintegrationparameters_set_lengthUnit(this.__wbg_ptr, I2);
  }
  switchToStandardPgsSolver() {
    A$1.rawintegrationparameters_switchToStandardPgsSolver(this.__wbg_ptr);
  }
  switchToSmallStepsPgsSolver() {
    A$1.rawintegrationparameters_switchToSmallStepsPgsSolver(this.__wbg_ptr);
  }
  switchToSmallStepsPgsSolverWithoutWarmstart() {
    A$1.rawintegrationparameters_switchToSmallStepsPgsSolverWithoutWarmstart(this.__wbg_ptr);
  }
}
const QA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawislandmanager_free(I2 >>> 0)));
class EA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(EA.prototype);
    return I2.__wbg_ptr = A2, QA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, QA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawislandmanager_free(I2);
  }
  constructor() {
    const I2 = A$1.rawislandmanager_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  forEachActiveRigidBodyHandle(g2) {
    try {
      A$1.rawislandmanager_forEachActiveRigidBodyHandle(this.__wbg_ptr, y$1(g2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
}
const iA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawkinematiccharactercontroller_free(I2 >>> 0)));
class DA {
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, iA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawkinematiccharactercontroller_free(I2);
  }
  constructor(I2) {
    const g2 = A$1.rawkinematiccharactercontroller_new(I2);
    return this.__wbg_ptr = g2 >>> 0, this;
  }
  up() {
    const I2 = A$1.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  setUp(I2) {
    K$1(I2, xA), A$1.rawkinematiccharactercontroller_setUp(this.__wbg_ptr, I2.__wbg_ptr);
  }
  normalNudgeFactor() {
    return A$1.rawkinematiccharactercontroller_normalNudgeFactor(this.__wbg_ptr);
  }
  setNormalNudgeFactor(I2) {
    A$1.rawkinematiccharactercontroller_setNormalNudgeFactor(this.__wbg_ptr, I2);
  }
  offset() {
    return A$1.rawintegrationparameters_dt(this.__wbg_ptr);
  }
  setOffset(I2) {
    A$1.rawkinematiccharactercontroller_setOffset(this.__wbg_ptr, I2);
  }
  slideEnabled() {
    return 0 !== A$1.rawkinematiccharactercontroller_slideEnabled(this.__wbg_ptr);
  }
  setSlideEnabled(I2) {
    A$1.rawkinematiccharactercontroller_setSlideEnabled(this.__wbg_ptr, I2);
  }
  autostepMaxHeight() {
    try {
      const C2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawkinematiccharactercontroller_autostepMaxHeight(C2, this.__wbg_ptr);
      var I2 = S$1()[C2 / 4 + 0], g2 = U$1()[C2 / 4 + 1];
      return 0 === I2 ? void 0 : g2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  autostepMinWidth() {
    try {
      const C2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawkinematiccharactercontroller_autostepMinWidth(C2, this.__wbg_ptr);
      var I2 = S$1()[C2 / 4 + 0], g2 = U$1()[C2 / 4 + 1];
      return 0 === I2 ? void 0 : g2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  autostepIncludesDynamicBodies() {
    const I2 = A$1.rawkinematiccharactercontroller_autostepIncludesDynamicBodies(this.__wbg_ptr);
    return 16777215 === I2 ? void 0 : 0 !== I2;
  }
  autostepEnabled() {
    return 0 !== A$1.rawkinematiccharactercontroller_autostepEnabled(this.__wbg_ptr);
  }
  enableAutostep(I2, g2, C2) {
    A$1.rawkinematiccharactercontroller_enableAutostep(this.__wbg_ptr, I2, g2, C2);
  }
  disableAutostep() {
    A$1.rawkinematiccharactercontroller_disableAutostep(this.__wbg_ptr);
  }
  maxSlopeClimbAngle() {
    return A$1.rawkinematiccharactercontroller_maxSlopeClimbAngle(this.__wbg_ptr);
  }
  setMaxSlopeClimbAngle(I2) {
    A$1.rawkinematiccharactercontroller_setMaxSlopeClimbAngle(this.__wbg_ptr, I2);
  }
  minSlopeSlideAngle() {
    return A$1.rawkinematiccharactercontroller_minSlopeSlideAngle(this.__wbg_ptr);
  }
  setMinSlopeSlideAngle(I2) {
    A$1.rawkinematiccharactercontroller_setMinSlopeSlideAngle(this.__wbg_ptr, I2);
  }
  snapToGroundDistance() {
    try {
      const C2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawkinematiccharactercontroller_snapToGroundDistance(C2, this.__wbg_ptr);
      var I2 = S$1()[C2 / 4 + 0], g2 = U$1()[C2 / 4 + 1];
      return 0 === I2 ? void 0 : g2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
  enableSnapToGround(I2) {
    A$1.rawkinematiccharactercontroller_enableSnapToGround(this.__wbg_ptr, I2);
  }
  disableSnapToGround() {
    A$1.rawkinematiccharactercontroller_disableSnapToGround(this.__wbg_ptr);
  }
  snapToGroundEnabled() {
    return 0 !== A$1.rawkinematiccharactercontroller_snapToGroundEnabled(this.__wbg_ptr);
  }
  computeColliderMovement(g2, C2, B2, Q2, i2, D2, o2, S2, w2, G2, k2) {
    try {
      K$1(C2, lA), K$1(B2, d$1), K$1(Q2, MA), K$1(D2, xA), A$1.rawkinematiccharactercontroller_computeColliderMovement(this.__wbg_ptr, g2, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, i2, D2.__wbg_ptr, o2, !E$1(S2), E$1(S2) ? 0 : S2, w2, !E$1(G2), E$1(G2) ? 0 : G2, y$1(k2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  computedMovement() {
    const I2 = A$1.rawkinematiccharactercontroller_computedMovement(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  computedGrounded() {
    return 0 !== A$1.rawkinematiccharactercontroller_computedGrounded(this.__wbg_ptr);
  }
  numComputedCollisions() {
    return A$1.rawkinematiccharactercontroller_numComputedCollisions(this.__wbg_ptr) >>> 0;
  }
  computedCollision(I2, g2) {
    K$1(g2, r$1);
    return 0 !== A$1.rawkinematiccharactercontroller_computedCollision(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
}
const oA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawmultibodyjointset_free(I2 >>> 0)));
class SA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(SA.prototype);
    return I2.__wbg_ptr = A2, oA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, oA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawmultibodyjointset_free(I2);
  }
  jointType(I2) {
    return A$1.rawmultibodyjointset_jointType(this.__wbg_ptr, I2);
  }
  jointFrameX1(I2) {
    const g2 = A$1.rawmultibodyjointset_jointFrameX1(this.__wbg_ptr, I2);
    return HA.__wrap(g2);
  }
  jointFrameX2(I2) {
    const g2 = A$1.rawmultibodyjointset_jointFrameX2(this.__wbg_ptr, I2);
    return HA.__wrap(g2);
  }
  jointAnchor1(I2) {
    const g2 = A$1.rawmultibodyjointset_jointAnchor1(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  jointAnchor2(I2) {
    const g2 = A$1.rawmultibodyjointset_jointAnchor2(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  jointContactsEnabled(I2) {
    return 0 !== A$1.rawmultibodyjointset_jointContactsEnabled(this.__wbg_ptr, I2);
  }
  jointSetContactsEnabled(I2, g2) {
    A$1.rawmultibodyjointset_jointSetContactsEnabled(this.__wbg_ptr, I2, g2);
  }
  jointLimitsEnabled(I2, g2) {
    return 0 !== A$1.rawmultibodyjointset_jointLimitsEnabled(this.__wbg_ptr, I2, g2);
  }
  jointLimitsMin(I2, g2) {
    return A$1.rawmultibodyjointset_jointLimitsMin(this.__wbg_ptr, I2, g2);
  }
  jointLimitsMax(I2, g2) {
    return A$1.rawmultibodyjointset_jointLimitsMax(this.__wbg_ptr, I2, g2);
  }
  constructor() {
    const I2 = A$1.rawmultibodyjointset_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  createJoint(I2, g2, C2, B2) {
    K$1(I2, AA);
    return A$1.rawmultibodyjointset_createJoint(this.__wbg_ptr, I2.__wbg_ptr, g2, C2, B2);
  }
  remove(I2, g2) {
    A$1.rawmultibodyjointset_remove(this.__wbg_ptr, I2, g2);
  }
  contains(I2) {
    return 0 !== A$1.rawmultibodyjointset_contains(this.__wbg_ptr, I2);
  }
  forEachJointHandle(g2) {
    try {
      A$1.rawmultibodyjointset_forEachJointHandle(this.__wbg_ptr, y$1(g2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  forEachJointAttachedToRigidBody(g2, C2) {
    try {
      A$1.rawmultibodyjointset_forEachJointAttachedToRigidBody(this.__wbg_ptr, g2, y$1(C2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
}
const wA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawnarrowphase_free(I2 >>> 0)));
class GA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(GA.prototype);
    return I2.__wbg_ptr = A2, wA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, wA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawnarrowphase_free(I2);
  }
  constructor() {
    const I2 = A$1.rawnarrowphase_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  contact_pairs_with(I2, g2) {
    A$1.rawnarrowphase_contact_pairs_with(this.__wbg_ptr, I2, C$1(g2));
  }
  contact_pair(I2, g2) {
    const C2 = A$1.rawnarrowphase_contact_pair(this.__wbg_ptr, I2, g2);
    return 0 === C2 ? void 0 : j$1.__wrap(C2);
  }
  intersection_pairs_with(I2, g2) {
    A$1.rawnarrowphase_intersection_pairs_with(this.__wbg_ptr, I2, C$1(g2));
  }
  intersection_pair(I2, g2) {
    return 0 !== A$1.rawnarrowphase_intersection_pair(this.__wbg_ptr, I2, g2);
  }
}
const kA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawphysicspipeline_free(I2 >>> 0)));
class KA {
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, kA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawphysicspipeline_free(I2);
  }
  constructor() {
    const I2 = A$1.rawphysicspipeline_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  step(I2, g2, C2, B2, Q2, E2, i2, D2, o2, S2) {
    K$1(I2, xA), K$1(g2, BA), K$1(C2, EA), K$1(B2, H$1), K$1(Q2, GA), K$1(E2, lA), K$1(i2, d$1), K$1(D2, gA), K$1(o2, SA), K$1(S2, p$1), A$1.rawphysicspipeline_step(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, E2.__wbg_ptr, i2.__wbg_ptr, D2.__wbg_ptr, o2.__wbg_ptr, S2.__wbg_ptr);
  }
  stepWithEvents(I2, g2, B2, Q2, E2, i2, D2, o2, S2, w2, G2, k2, J2, U2) {
    K$1(I2, xA), K$1(g2, BA), K$1(B2, EA), K$1(Q2, H$1), K$1(E2, GA), K$1(i2, lA), K$1(D2, d$1), K$1(o2, gA), K$1(S2, SA), K$1(w2, p$1), K$1(G2, _), A$1.rawphysicspipeline_stepWithEvents(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, E2.__wbg_ptr, i2.__wbg_ptr, D2.__wbg_ptr, o2.__wbg_ptr, S2.__wbg_ptr, w2.__wbg_ptr, G2.__wbg_ptr, C$1(k2), C$1(J2), C$1(U2));
  }
}
const JA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawpointcolliderprojection_free(I2 >>> 0)));
class UA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(UA.prototype);
    return I2.__wbg_ptr = A2, JA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, JA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawpointcolliderprojection_free(I2);
  }
  colliderHandle() {
    return A$1.rawpointcolliderprojection_colliderHandle(this.__wbg_ptr);
  }
  point() {
    const I2 = A$1.rawpointcolliderprojection_point(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  isInside() {
    return 0 !== A$1.rawpointcolliderprojection_isInside(this.__wbg_ptr);
  }
  featureType() {
    return A$1.rawpointcolliderprojection_featureType(this.__wbg_ptr);
  }
  featureId() {
    try {
      const C2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawpointcolliderprojection_featureId(C2, this.__wbg_ptr);
      var I2 = S$1()[C2 / 4 + 0], g2 = S$1()[C2 / 4 + 1];
      return 0 === I2 ? void 0 : g2 >>> 0;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
const hA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawpointprojection_free(I2 >>> 0)));
class yA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(yA.prototype);
    return I2.__wbg_ptr = A2, hA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, hA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawpointprojection_free(I2);
  }
  point() {
    const I2 = A$1.rawpointprojection_point(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  isInside() {
    return 0 !== A$1.rawpointprojection_isInside(this.__wbg_ptr);
  }
}
const NA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawquerypipeline_free(I2 >>> 0)));
class MA {
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, NA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawquerypipeline_free(I2);
  }
  constructor() {
    const I2 = A$1.rawquerypipeline_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  update(I2) {
    K$1(I2, d$1), A$1.rawquerypipeline_update(this.__wbg_ptr, I2.__wbg_ptr);
  }
  castRay(g2, C2, B2, Q2, i2, D2, o2, S2, w2, G2, k2) {
    try {
      K$1(g2, lA), K$1(C2, d$1), K$1(B2, xA), K$1(Q2, xA);
      const J2 = A$1.rawquerypipeline_castRay(this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, i2, D2, o2, !E$1(S2), E$1(S2) ? 0 : S2, !E$1(w2), E$1(w2) ? 0 : w2, !E$1(G2), E$1(G2) ? 0 : G2, y$1(k2));
      return 0 === J2 ? void 0 : aA.__wrap(J2);
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  castRayAndGetNormal(g2, C2, B2, Q2, i2, D2, o2, S2, w2, G2, k2) {
    try {
      K$1(g2, lA), K$1(C2, d$1), K$1(B2, xA), K$1(Q2, xA);
      const J2 = A$1.rawquerypipeline_castRayAndGetNormal(this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, i2, D2, o2, !E$1(S2), E$1(S2) ? 0 : S2, !E$1(w2), E$1(w2) ? 0 : w2, !E$1(G2), E$1(G2) ? 0 : G2, y$1(k2));
      return 0 === J2 ? void 0 : RA.__wrap(J2);
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  intersectionsWithRay(g2, C2, B2, Q2, i2, D2, o2, S2, w2, G2, k2, J2) {
    try {
      K$1(g2, lA), K$1(C2, d$1), K$1(B2, xA), K$1(Q2, xA), A$1.rawquerypipeline_intersectionsWithRay(this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, i2, D2, y$1(o2), S2, !E$1(w2), E$1(w2) ? 0 : w2, !E$1(G2), E$1(G2) ? 0 : G2, !E$1(k2), E$1(k2) ? 0 : k2, y$1(J2));
    } finally {
      I$1[h$1++] = void 0, I$1[h$1++] = void 0;
    }
  }
  intersectionWithShape(g2, C2, B2, Q2, i2, o2, w2, G2, k2, J2) {
    try {
      const M2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      K$1(g2, lA), K$1(C2, d$1), K$1(B2, xA), K$1(Q2, HA), K$1(i2, dA), A$1.rawquerypipeline_intersectionWithShape(M2, this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, i2.__wbg_ptr, o2, !E$1(w2), E$1(w2) ? 0 : w2, !E$1(G2), E$1(G2) ? 0 : G2, !E$1(k2), E$1(k2) ? 0 : k2, y$1(J2));
      var U2 = S$1()[M2 / 4 + 0], N2 = D$1()[M2 / 8 + 1];
      return 0 === U2 ? void 0 : N2;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16), I$1[h$1++] = void 0;
    }
  }
  projectPoint(g2, C2, B2, Q2, i2, D2, o2, S2, w2) {
    try {
      K$1(g2, lA), K$1(C2, d$1), K$1(B2, xA);
      const G2 = A$1.rawquerypipeline_projectPoint(this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2, i2, !E$1(D2), E$1(D2) ? 0 : D2, !E$1(o2), E$1(o2) ? 0 : o2, !E$1(S2), E$1(S2) ? 0 : S2, y$1(w2));
      return 0 === G2 ? void 0 : UA.__wrap(G2);
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  projectPointAndGetFeature(g2, C2, B2, Q2, i2, D2, o2, S2) {
    try {
      K$1(g2, lA), K$1(C2, d$1), K$1(B2, xA);
      const w2 = A$1.rawquerypipeline_projectPointAndGetFeature(this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2, !E$1(i2), E$1(i2) ? 0 : i2, !E$1(D2), E$1(D2) ? 0 : D2, !E$1(o2), E$1(o2) ? 0 : o2, y$1(S2));
      return 0 === w2 ? void 0 : UA.__wrap(w2);
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  intersectionsWithPoint(g2, C2, B2, Q2, i2, D2, o2, S2, w2) {
    try {
      K$1(g2, lA), K$1(C2, d$1), K$1(B2, xA), A$1.rawquerypipeline_intersectionsWithPoint(this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, y$1(Q2), i2, !E$1(D2), E$1(D2) ? 0 : D2, !E$1(o2), E$1(o2) ? 0 : o2, !E$1(S2), E$1(S2) ? 0 : S2, y$1(w2));
    } finally {
      I$1[h$1++] = void 0, I$1[h$1++] = void 0;
    }
  }
  castShape(g2, C2, B2, Q2, i2, D2, o2, S2, w2, G2, k2, J2, U2, N2) {
    try {
      K$1(g2, lA), K$1(C2, d$1), K$1(B2, xA), K$1(Q2, HA), K$1(i2, xA), K$1(D2, dA);
      const M2 = A$1.rawquerypipeline_castShape(this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, i2.__wbg_ptr, D2.__wbg_ptr, o2, S2, w2, G2, !E$1(k2), E$1(k2) ? 0 : k2, !E$1(J2), E$1(J2) ? 0 : J2, !E$1(U2), E$1(U2) ? 0 : U2, y$1(N2));
      return 0 === M2 ? void 0 : O$1.__wrap(M2);
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  intersectionsWithShape(g2, C2, B2, Q2, i2, D2, o2, S2, w2, G2, k2) {
    try {
      K$1(g2, lA), K$1(C2, d$1), K$1(B2, xA), K$1(Q2, HA), K$1(i2, dA), A$1.rawquerypipeline_intersectionsWithShape(this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, i2.__wbg_ptr, y$1(D2), o2, !E$1(S2), E$1(S2) ? 0 : S2, !E$1(w2), E$1(w2) ? 0 : w2, !E$1(G2), E$1(G2) ? 0 : G2, y$1(k2));
    } finally {
      I$1[h$1++] = void 0, I$1[h$1++] = void 0;
    }
  }
  collidersWithAabbIntersectingAabb(g2, C2, B2) {
    try {
      K$1(g2, xA), K$1(C2, xA), A$1.rawquerypipeline_collidersWithAabbIntersectingAabb(this.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, y$1(B2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
}
const FA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawraycolliderhit_free(I2 >>> 0)));
class aA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(aA.prototype);
    return I2.__wbg_ptr = A2, FA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawraycolliderhit_free(I2);
  }
  colliderHandle() {
    return A$1.rawcharactercollision_handle(this.__wbg_ptr);
  }
  timeOfImpact() {
    return A$1.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
  }
}
const sA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawraycolliderintersection_free(I2 >>> 0)));
class RA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(RA.prototype);
    return I2.__wbg_ptr = A2, sA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, sA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawraycolliderintersection_free(I2);
  }
  colliderHandle() {
    return A$1.rawpointcolliderprojection_colliderHandle(this.__wbg_ptr);
  }
  normal() {
    const I2 = A$1.rawcollidershapecasthit_witness1(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  time_of_impact() {
    return A$1.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
  }
  featureType() {
    return A$1.rawpointcolliderprojection_featureType(this.__wbg_ptr);
  }
  featureId() {
    try {
      const C2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawpointcolliderprojection_featureId(C2, this.__wbg_ptr);
      var I2 = S$1()[C2 / 4 + 0], g2 = S$1()[C2 / 4 + 1];
      return 0 === I2 ? void 0 : g2 >>> 0;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
const cA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawrayintersection_free(I2 >>> 0)));
class qA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(qA.prototype);
    return I2.__wbg_ptr = A2, cA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, cA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawrayintersection_free(I2);
  }
  normal() {
    const I2 = A$1.rawcollidershapecasthit_witness1(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  time_of_impact() {
    return A$1.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
  }
  featureType() {
    return A$1.rawpointcolliderprojection_featureType(this.__wbg_ptr);
  }
  featureId() {
    try {
      const C2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.rawpointcolliderprojection_featureId(C2, this.__wbg_ptr);
      var I2 = S$1()[C2 / 4 + 0], g2 = S$1()[C2 / 4 + 1];
      return 0 === I2 ? void 0 : g2 >>> 0;
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
const YA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawrigidbodyset_free(I2 >>> 0)));
class lA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(lA.prototype);
    return I2.__wbg_ptr = A2, YA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, YA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawrigidbodyset_free(I2);
  }
  rbTranslation(I2) {
    const g2 = A$1.rawrigidbodyset_rbTranslation(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbRotation(I2) {
    const g2 = A$1.rawrigidbodyset_rbRotation(this.__wbg_ptr, I2);
    return HA.__wrap(g2);
  }
  rbSleep(I2) {
    A$1.rawrigidbodyset_rbSleep(this.__wbg_ptr, I2);
  }
  rbIsSleeping(I2) {
    return 0 !== A$1.rawrigidbodyset_rbIsSleeping(this.__wbg_ptr, I2);
  }
  rbIsMoving(I2) {
    return 0 !== A$1.rawrigidbodyset_rbIsMoving(this.__wbg_ptr, I2);
  }
  rbNextTranslation(I2) {
    const g2 = A$1.rawrigidbodyset_rbNextTranslation(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbNextRotation(I2) {
    const g2 = A$1.rawrigidbodyset_rbNextRotation(this.__wbg_ptr, I2);
    return HA.__wrap(g2);
  }
  rbSetTranslation(I2, g2, C2, B2, Q2) {
    A$1.rawrigidbodyset_rbSetTranslation(this.__wbg_ptr, I2, g2, C2, B2, Q2);
  }
  rbSetRotation(I2, g2, C2, B2, Q2, E2) {
    A$1.rawrigidbodyset_rbSetRotation(this.__wbg_ptr, I2, g2, C2, B2, Q2, E2);
  }
  rbSetLinvel(I2, g2, C2) {
    K$1(g2, xA), A$1.rawrigidbodyset_rbSetLinvel(this.__wbg_ptr, I2, g2.__wbg_ptr, C2);
  }
  rbSetAngvel(I2, g2, C2) {
    K$1(g2, xA), A$1.rawrigidbodyset_rbSetAngvel(this.__wbg_ptr, I2, g2.__wbg_ptr, C2);
  }
  rbSetNextKinematicTranslation(I2, g2, C2, B2) {
    A$1.rawrigidbodyset_rbSetNextKinematicTranslation(this.__wbg_ptr, I2, g2, C2, B2);
  }
  rbSetNextKinematicRotation(I2, g2, C2, B2, Q2) {
    A$1.rawrigidbodyset_rbSetNextKinematicRotation(this.__wbg_ptr, I2, g2, C2, B2, Q2);
  }
  rbRecomputeMassPropertiesFromColliders(I2, g2) {
    K$1(g2, d$1), A$1.rawrigidbodyset_rbRecomputeMassPropertiesFromColliders(this.__wbg_ptr, I2, g2.__wbg_ptr);
  }
  rbSetAdditionalMass(I2, g2, C2) {
    A$1.rawrigidbodyset_rbSetAdditionalMass(this.__wbg_ptr, I2, g2, C2);
  }
  rbSetAdditionalMassProperties(I2, g2, C2, B2, Q2, E2) {
    K$1(C2, xA), K$1(B2, xA), K$1(Q2, HA), A$1.rawrigidbodyset_rbSetAdditionalMassProperties(this.__wbg_ptr, I2, g2, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, E2);
  }
  rbLinvel(I2) {
    const g2 = A$1.rawrigidbodyset_rbLinvel(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbAngvel(I2) {
    const g2 = A$1.rawrigidbodyset_rbAngvel(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbLockTranslations(I2, g2, C2) {
    A$1.rawrigidbodyset_rbLockTranslations(this.__wbg_ptr, I2, g2, C2);
  }
  rbSetEnabledTranslations(I2, g2, C2, B2, Q2) {
    A$1.rawrigidbodyset_rbSetEnabledTranslations(this.__wbg_ptr, I2, g2, C2, B2, Q2);
  }
  rbLockRotations(I2, g2, C2) {
    A$1.rawrigidbodyset_rbLockRotations(this.__wbg_ptr, I2, g2, C2);
  }
  rbSetEnabledRotations(I2, g2, C2, B2, Q2) {
    A$1.rawrigidbodyset_rbSetEnabledRotations(this.__wbg_ptr, I2, g2, C2, B2, Q2);
  }
  rbDominanceGroup(I2) {
    return A$1.rawrigidbodyset_rbDominanceGroup(this.__wbg_ptr, I2);
  }
  rbSetDominanceGroup(I2, g2) {
    A$1.rawrigidbodyset_rbSetDominanceGroup(this.__wbg_ptr, I2, g2);
  }
  rbEnableCcd(I2, g2) {
    A$1.rawrigidbodyset_rbEnableCcd(this.__wbg_ptr, I2, g2);
  }
  rbSetSoftCcdPrediction(I2, g2) {
    A$1.rawrigidbodyset_rbSetSoftCcdPrediction(this.__wbg_ptr, I2, g2);
  }
  rbMass(I2) {
    return A$1.rawrigidbodyset_rbMass(this.__wbg_ptr, I2);
  }
  rbInvMass(I2) {
    return A$1.rawrigidbodyset_rbInvMass(this.__wbg_ptr, I2);
  }
  rbEffectiveInvMass(I2) {
    const g2 = A$1.rawrigidbodyset_rbEffectiveInvMass(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbLocalCom(I2) {
    const g2 = A$1.rawrigidbodyset_rbLocalCom(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbWorldCom(I2) {
    const g2 = A$1.rawrigidbodyset_rbWorldCom(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbInvPrincipalInertiaSqrt(I2) {
    const g2 = A$1.rawrigidbodyset_rbInvPrincipalInertiaSqrt(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbPrincipalInertiaLocalFrame(I2) {
    const g2 = A$1.rawrigidbodyset_rbPrincipalInertiaLocalFrame(this.__wbg_ptr, I2);
    return HA.__wrap(g2);
  }
  rbPrincipalInertia(I2) {
    const g2 = A$1.rawrigidbodyset_rbPrincipalInertia(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbEffectiveWorldInvInertiaSqrt(I2) {
    const g2 = A$1.rawrigidbodyset_rbEffectiveWorldInvInertiaSqrt(this.__wbg_ptr, I2);
    return pA.__wrap(g2);
  }
  rbEffectiveAngularInertia(I2) {
    const g2 = A$1.rawrigidbodyset_rbEffectiveAngularInertia(this.__wbg_ptr, I2);
    return pA.__wrap(g2);
  }
  rbWakeUp(I2) {
    A$1.rawrigidbodyset_rbWakeUp(this.__wbg_ptr, I2);
  }
  rbIsCcdEnabled(I2) {
    return 0 !== A$1.rawrigidbodyset_rbIsCcdEnabled(this.__wbg_ptr, I2);
  }
  rbSoftCcdPrediction(I2) {
    return A$1.rawrigidbodyset_rbSoftCcdPrediction(this.__wbg_ptr, I2);
  }
  rbNumColliders(I2) {
    return A$1.rawrigidbodyset_rbNumColliders(this.__wbg_ptr, I2) >>> 0;
  }
  rbCollider(I2, g2) {
    return A$1.rawrigidbodyset_rbCollider(this.__wbg_ptr, I2, g2);
  }
  rbBodyType(I2) {
    return A$1.rawrigidbodyset_rbBodyType(this.__wbg_ptr, I2);
  }
  rbSetBodyType(I2, g2, C2) {
    A$1.rawrigidbodyset_rbSetBodyType(this.__wbg_ptr, I2, g2, C2);
  }
  rbIsFixed(I2) {
    return 0 !== A$1.rawrigidbodyset_rbIsFixed(this.__wbg_ptr, I2);
  }
  rbIsKinematic(I2) {
    return 0 !== A$1.rawrigidbodyset_rbIsKinematic(this.__wbg_ptr, I2);
  }
  rbIsDynamic(I2) {
    return 0 !== A$1.rawrigidbodyset_rbIsDynamic(this.__wbg_ptr, I2);
  }
  rbLinearDamping(I2) {
    return A$1.rawrigidbodyset_rbLinearDamping(this.__wbg_ptr, I2);
  }
  rbAngularDamping(I2) {
    return A$1.rawrigidbodyset_rbAngularDamping(this.__wbg_ptr, I2);
  }
  rbSetLinearDamping(I2, g2) {
    A$1.rawrigidbodyset_rbSetLinearDamping(this.__wbg_ptr, I2, g2);
  }
  rbSetAngularDamping(I2, g2) {
    A$1.rawrigidbodyset_rbSetAngularDamping(this.__wbg_ptr, I2, g2);
  }
  rbSetEnabled(I2, g2) {
    A$1.rawrigidbodyset_rbSetEnabled(this.__wbg_ptr, I2, g2);
  }
  rbIsEnabled(I2) {
    return 0 !== A$1.rawrigidbodyset_rbIsEnabled(this.__wbg_ptr, I2);
  }
  rbGravityScale(I2) {
    return A$1.rawrigidbodyset_rbGravityScale(this.__wbg_ptr, I2);
  }
  rbSetGravityScale(I2, g2, C2) {
    A$1.rawrigidbodyset_rbSetGravityScale(this.__wbg_ptr, I2, g2, C2);
  }
  rbResetForces(I2, g2) {
    A$1.rawrigidbodyset_rbResetForces(this.__wbg_ptr, I2, g2);
  }
  rbResetTorques(I2, g2) {
    A$1.rawrigidbodyset_rbResetTorques(this.__wbg_ptr, I2, g2);
  }
  rbAddForce(I2, g2, C2) {
    K$1(g2, xA), A$1.rawrigidbodyset_rbAddForce(this.__wbg_ptr, I2, g2.__wbg_ptr, C2);
  }
  rbApplyImpulse(I2, g2, C2) {
    K$1(g2, xA), A$1.rawrigidbodyset_rbApplyImpulse(this.__wbg_ptr, I2, g2.__wbg_ptr, C2);
  }
  rbAddTorque(I2, g2, C2) {
    K$1(g2, xA), A$1.rawrigidbodyset_rbAddTorque(this.__wbg_ptr, I2, g2.__wbg_ptr, C2);
  }
  rbApplyTorqueImpulse(I2, g2, C2) {
    K$1(g2, xA), A$1.rawrigidbodyset_rbApplyTorqueImpulse(this.__wbg_ptr, I2, g2.__wbg_ptr, C2);
  }
  rbAddForceAtPoint(I2, g2, C2, B2) {
    K$1(g2, xA), K$1(C2, xA), A$1.rawrigidbodyset_rbAddForceAtPoint(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2);
  }
  rbApplyImpulseAtPoint(I2, g2, C2, B2) {
    K$1(g2, xA), K$1(C2, xA), A$1.rawrigidbodyset_rbApplyImpulseAtPoint(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2);
  }
  rbAdditionalSolverIterations(I2) {
    return A$1.rawrigidbodyset_rbAdditionalSolverIterations(this.__wbg_ptr, I2) >>> 0;
  }
  rbSetAdditionalSolverIterations(I2, g2) {
    A$1.rawrigidbodyset_rbSetAdditionalSolverIterations(this.__wbg_ptr, I2, g2);
  }
  rbUserData(I2) {
    return A$1.rawrigidbodyset_rbUserData(this.__wbg_ptr, I2) >>> 0;
  }
  rbSetUserData(I2, g2) {
    A$1.rawrigidbodyset_rbSetUserData(this.__wbg_ptr, I2, g2);
  }
  rbUserForce(I2) {
    const g2 = A$1.rawrigidbodyset_rbUserForce(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  rbUserTorque(I2) {
    const g2 = A$1.rawrigidbodyset_rbUserTorque(this.__wbg_ptr, I2);
    return xA.__wrap(g2);
  }
  constructor() {
    const I2 = A$1.rawrigidbodyset_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  createRigidBody(I2, g2, C2, B2, Q2, E2, i2, D2, o2, S2, w2, G2, k2, J2, U2, h2, y2, N2, M2, F2, a5, s2, R2, c2, q2, Y2) {
    K$1(g2, xA), K$1(C2, HA), K$1(i2, xA), K$1(D2, xA), K$1(o2, xA), K$1(S2, xA), K$1(w2, HA);
    return A$1.rawrigidbodyset_createRigidBody(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2, Q2, E2, i2.__wbg_ptr, D2.__wbg_ptr, o2.__wbg_ptr, S2.__wbg_ptr, w2.__wbg_ptr, G2, k2, J2, U2, h2, y2, N2, M2, F2, a5, s2, R2, c2, q2, Y2);
  }
  remove(I2, g2, C2, B2, Q2) {
    K$1(g2, EA), K$1(C2, d$1), K$1(B2, gA), K$1(Q2, SA), A$1.rawrigidbodyset_remove(this.__wbg_ptr, I2, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr);
  }
  len() {
    return A$1.rawcolliderset_len(this.__wbg_ptr) >>> 0;
  }
  contains(I2) {
    return 0 !== A$1.rawrigidbodyset_contains(this.__wbg_ptr, I2);
  }
  forEachRigidBodyHandle(g2) {
    try {
      A$1.rawrigidbodyset_forEachRigidBodyHandle(this.__wbg_ptr, y$1(g2));
    } finally {
      I$1[h$1++] = void 0;
    }
  }
  propagateModifiedBodyPositionsToColliders(I2) {
    K$1(I2, d$1), A$1.rawrigidbodyset_propagateModifiedBodyPositionsToColliders(this.__wbg_ptr, I2.__wbg_ptr);
  }
}
const LA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawrotation_free(I2 >>> 0)));
class HA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(HA.prototype);
    return I2.__wbg_ptr = A2, LA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, LA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawrotation_free(I2);
  }
  constructor(I2, g2, C2, B2) {
    const Q2 = A$1.rawrotation_new(I2, g2, C2, B2);
    return this.__wbg_ptr = Q2 >>> 0, this;
  }
  static identity() {
    const I2 = A$1.rawrotation_identity();
    return HA.__wrap(I2);
  }
  get x() {
    return A$1.rawrotation_x(this.__wbg_ptr);
  }
  get y() {
    return A$1.rawintegrationparameters_dt(this.__wbg_ptr);
  }
  get z() {
    return A$1.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
  }
  get w() {
    return A$1.rawrotation_w(this.__wbg_ptr);
  }
}
const tA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawsdpmatrix3_free(I2 >>> 0)));
class pA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(pA.prototype);
    return I2.__wbg_ptr = A2, tA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, tA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawsdpmatrix3_free(I2);
  }
  elements() {
    return Q(A$1.rawsdpmatrix3_elements(this.__wbg_ptr));
  }
}
const eA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawserializationpipeline_free(I2 >>> 0)));
class rA {
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, eA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawserializationpipeline_free(I2);
  }
  constructor() {
    const I2 = A$1.rawserializationpipeline_new();
    return this.__wbg_ptr = I2 >>> 0, this;
  }
  serializeAll(I2, g2, C2, B2, E2, i2, D2, o2, S2) {
    K$1(I2, xA), K$1(g2, BA), K$1(C2, EA), K$1(B2, H$1), K$1(E2, GA), K$1(i2, lA), K$1(D2, d$1), K$1(o2, gA), K$1(S2, SA);
    return Q(A$1.rawserializationpipeline_serializeAll(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, E2.__wbg_ptr, i2.__wbg_ptr, D2.__wbg_ptr, o2.__wbg_ptr, S2.__wbg_ptr));
  }
  deserializeAll(I2) {
    const g2 = A$1.rawserializationpipeline_deserializeAll(this.__wbg_ptr, C$1(I2));
    return 0 === g2 ? void 0 : P$1.__wrap(g2);
  }
}
const nA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawshape_free(I2 >>> 0)));
class dA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(dA.prototype);
    return I2.__wbg_ptr = A2, nA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, nA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawshape_free(I2);
  }
  static cuboid(I2, g2, C2) {
    const B2 = A$1.rawshape_cuboid(I2, g2, C2);
    return dA.__wrap(B2);
  }
  static roundCuboid(I2, g2, C2, B2) {
    const Q2 = A$1.rawshape_roundCuboid(I2, g2, C2, B2);
    return dA.__wrap(Q2);
  }
  static ball(I2) {
    const g2 = A$1.rawshape_ball(I2);
    return dA.__wrap(g2);
  }
  static halfspace(I2) {
    K$1(I2, xA);
    const g2 = A$1.rawshape_halfspace(I2.__wbg_ptr);
    return dA.__wrap(g2);
  }
  static capsule(I2, g2) {
    const C2 = A$1.rawshape_capsule(I2, g2);
    return dA.__wrap(C2);
  }
  static cylinder(I2, g2) {
    const C2 = A$1.rawshape_cylinder(I2, g2);
    return dA.__wrap(C2);
  }
  static roundCylinder(I2, g2, C2) {
    const B2 = A$1.rawshape_roundCylinder(I2, g2, C2);
    return dA.__wrap(B2);
  }
  static cone(I2, g2) {
    const C2 = A$1.rawshape_cone(I2, g2);
    return dA.__wrap(C2);
  }
  static roundCone(I2, g2, C2) {
    const B2 = A$1.rawshape_roundCone(I2, g2, C2);
    return dA.__wrap(B2);
  }
  static polyline(I2, g2) {
    const C2 = s$1(I2, A$1.__wbindgen_malloc), B2 = a$1, Q2 = R$1(g2, A$1.__wbindgen_malloc), E2 = a$1, i2 = A$1.rawshape_polyline(C2, B2, Q2, E2);
    return dA.__wrap(i2);
  }
  static trimesh(I2, g2, C2) {
    const B2 = s$1(I2, A$1.__wbindgen_malloc), Q2 = a$1, E2 = R$1(g2, A$1.__wbindgen_malloc), i2 = a$1, D2 = A$1.rawshape_trimesh(B2, Q2, E2, i2, C2);
    return dA.__wrap(D2);
  }
  static heightfield(I2, g2, C2, B2, Q2) {
    const E2 = s$1(C2, A$1.__wbindgen_malloc), i2 = a$1;
    K$1(B2, xA);
    const D2 = A$1.rawshape_heightfield(I2, g2, E2, i2, B2.__wbg_ptr, Q2);
    return dA.__wrap(D2);
  }
  static segment(I2, g2) {
    K$1(I2, xA), K$1(g2, xA);
    const C2 = A$1.rawshape_segment(I2.__wbg_ptr, g2.__wbg_ptr);
    return dA.__wrap(C2);
  }
  static triangle(I2, g2, C2) {
    K$1(I2, xA), K$1(g2, xA), K$1(C2, xA);
    const B2 = A$1.rawshape_triangle(I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr);
    return dA.__wrap(B2);
  }
  static roundTriangle(I2, g2, C2, B2) {
    K$1(I2, xA), K$1(g2, xA), K$1(C2, xA);
    const Q2 = A$1.rawshape_roundTriangle(I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2);
    return dA.__wrap(Q2);
  }
  static convexHull(I2) {
    const g2 = s$1(I2, A$1.__wbindgen_malloc), C2 = a$1, B2 = A$1.rawshape_convexHull(g2, C2);
    return 0 === B2 ? void 0 : dA.__wrap(B2);
  }
  static roundConvexHull(I2, g2) {
    const C2 = s$1(I2, A$1.__wbindgen_malloc), B2 = a$1, Q2 = A$1.rawshape_roundConvexHull(C2, B2, g2);
    return 0 === Q2 ? void 0 : dA.__wrap(Q2);
  }
  static convexMesh(I2, g2) {
    const C2 = s$1(I2, A$1.__wbindgen_malloc), B2 = a$1, Q2 = R$1(g2, A$1.__wbindgen_malloc), E2 = a$1, i2 = A$1.rawshape_convexMesh(C2, B2, Q2, E2);
    return 0 === i2 ? void 0 : dA.__wrap(i2);
  }
  static roundConvexMesh(I2, g2, C2) {
    const B2 = s$1(I2, A$1.__wbindgen_malloc), Q2 = a$1, E2 = R$1(g2, A$1.__wbindgen_malloc), i2 = a$1, D2 = A$1.rawshape_roundConvexMesh(B2, Q2, E2, i2, C2);
    return 0 === D2 ? void 0 : dA.__wrap(D2);
  }
  castShape(I2, g2, C2, B2, Q2, E2, i2, D2, o2, S2) {
    K$1(I2, xA), K$1(g2, HA), K$1(C2, xA), K$1(B2, dA), K$1(Q2, xA), K$1(E2, HA), K$1(i2, xA);
    const w2 = A$1.rawshape_castShape(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, E2.__wbg_ptr, i2.__wbg_ptr, D2, o2, S2);
    return 0 === w2 ? void 0 : OA.__wrap(w2);
  }
  intersectsShape(I2, g2, C2, B2, Q2) {
    K$1(I2, xA), K$1(g2, HA), K$1(C2, dA), K$1(B2, xA), K$1(Q2, HA);
    return 0 !== A$1.rawshape_intersectsShape(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr);
  }
  contactShape(I2, g2, C2, B2, Q2, E2) {
    K$1(I2, xA), K$1(g2, HA), K$1(C2, dA), K$1(B2, xA), K$1(Q2, HA);
    const i2 = A$1.rawshape_contactShape(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2.__wbg_ptr, E2);
    return 0 === i2 ? void 0 : bA.__wrap(i2);
  }
  containsPoint(I2, g2, C2) {
    K$1(I2, xA), K$1(g2, HA), K$1(C2, xA);
    return 0 !== A$1.rawshape_containsPoint(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr);
  }
  projectPoint(I2, g2, C2, B2) {
    K$1(I2, xA), K$1(g2, HA), K$1(C2, xA);
    const Q2 = A$1.rawshape_projectPoint(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2);
    return yA.__wrap(Q2);
  }
  intersectsRay(I2, g2, C2, B2, Q2) {
    K$1(I2, xA), K$1(g2, HA), K$1(C2, xA), K$1(B2, xA);
    return 0 !== A$1.rawshape_intersectsRay(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2);
  }
  castRay(I2, g2, C2, B2, Q2, E2) {
    K$1(I2, xA), K$1(g2, HA), K$1(C2, xA), K$1(B2, xA);
    return A$1.rawshape_castRay(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2, E2);
  }
  castRayAndGetNormal(I2, g2, C2, B2, Q2, E2) {
    K$1(I2, xA), K$1(g2, HA), K$1(C2, xA), K$1(B2, xA);
    const i2 = A$1.rawshape_castRayAndGetNormal(this.__wbg_ptr, I2.__wbg_ptr, g2.__wbg_ptr, C2.__wbg_ptr, B2.__wbg_ptr, Q2, E2);
    return 0 === i2 ? void 0 : qA.__wrap(i2);
  }
}
const TA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawshapecasthit_free(I2 >>> 0)));
class OA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(OA.prototype);
    return I2.__wbg_ptr = A2, TA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, TA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawshapecasthit_free(I2);
  }
  time_of_impact() {
    return A$1.rawrotation_x(this.__wbg_ptr);
  }
  witness1() {
    const I2 = A$1.rawshapecasthit_witness1(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  witness2() {
    const I2 = A$1.rawcontactforceevent_total_force(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  normal1() {
    const I2 = A$1.rawshapecasthit_normal1(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  normal2() {
    const I2 = A$1.rawshapecasthit_normal2(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
}
const ZA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawshapecontact_free(I2 >>> 0)));
class bA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(bA.prototype);
    return I2.__wbg_ptr = A2, ZA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ZA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawshapecontact_free(I2);
  }
  distance() {
    return A$1.rawkinematiccharactercontroller_maxSlopeClimbAngle(this.__wbg_ptr);
  }
  point1() {
    const I2 = A$1.rawpointprojection_point(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  point2() {
    const I2 = A$1.rawcollidershapecasthit_witness1(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  normal1() {
    const I2 = A$1.rawcollidershapecasthit_witness2(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  normal2() {
    const I2 = A$1.rawcharactercollision_translationDeltaApplied(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
}
const WA = "undefined" == typeof FinalizationRegistry ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry(((I2) => A$1.__wbg_rawvector_free(I2 >>> 0)));
class xA {
  static __wrap(A2) {
    A2 >>>= 0;
    const I2 = Object.create(xA.prototype);
    return I2.__wbg_ptr = A2, WA.register(I2, I2.__wbg_ptr, I2), I2;
  }
  __destroy_into_raw() {
    const A2 = this.__wbg_ptr;
    return this.__wbg_ptr = 0, WA.unregister(this), A2;
  }
  free() {
    const I2 = this.__destroy_into_raw();
    A$1.__wbg_rawvector_free(I2);
  }
  static zero() {
    const I2 = A$1.rawvector_zero();
    return xA.__wrap(I2);
  }
  constructor(I2, g2, C2) {
    const B2 = A$1.rawvector_new(I2, g2, C2);
    return this.__wbg_ptr = B2 >>> 0, this;
  }
  get x() {
    return A$1.rawrotation_x(this.__wbg_ptr);
  }
  set x(I2) {
    A$1.rawvector_set_x(this.__wbg_ptr, I2);
  }
  get y() {
    return A$1.rawintegrationparameters_dt(this.__wbg_ptr);
  }
  set y(I2) {
    A$1.rawintegrationparameters_set_dt(this.__wbg_ptr, I2);
  }
  get z() {
    return A$1.rawcollidershapecasthit_time_of_impact(this.__wbg_ptr);
  }
  set z(I2) {
    A$1.rawvector_set_z(this.__wbg_ptr, I2);
  }
  xyz() {
    const I2 = A$1.rawvector_xyz(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  yxz() {
    const I2 = A$1.rawvector_yxz(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  zxy() {
    const I2 = A$1.rawvector_zxy(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  xzy() {
    const I2 = A$1.rawvector_xzy(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  yzx() {
    const I2 = A$1.rawvector_yzx(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
  zyx() {
    const I2 = A$1.rawvector_zyx(this.__wbg_ptr);
    return xA.__wrap(I2);
  }
}
async function mA(I2) {
  if (void 0 !== A$1) return A$1;
  void 0 === I2 && (I2 = new URL("rapier_wasm3d_bg.wasm", "<deleted>"));
  const g2 = (function() {
    const I3 = { wbg: {} };
    return I3.wbg.__wbindgen_number_new = function(A2) {
      return C$1(A2);
    }, I3.wbg.__wbindgen_boolean_get = function(A2) {
      const I4 = B$1(A2);
      return "boolean" == typeof I4 ? I4 ? 1 : 0 : 2;
    }, I3.wbg.__wbindgen_object_drop_ref = function(A2) {
      Q(A2);
    }, I3.wbg.__wbindgen_number_get = function(A2, I4) {
      const g3 = B$1(I4), C2 = "number" == typeof g3 ? g3 : void 0;
      D$1()[A2 / 8 + 1] = E$1(C2) ? 0 : C2, S$1()[A2 / 4 + 0] = !E$1(C2);
    }, I3.wbg.__wbindgen_is_function = function(A2) {
      return "function" == typeof B$1(A2);
    }, I3.wbg.__wbg_rawraycolliderintersection_new = function(A2) {
      return C$1(RA.__wrap(A2));
    }, I3.wbg.__wbg_rawcontactforceevent_new = function(A2) {
      return C$1(b$1.__wrap(A2));
    }, I3.wbg.__wbg_call_b3ca7c6051f9bec1 = function() {
      return c$1((function(A2, I4, g3) {
        return C$1(B$1(A2).call(B$1(I4), B$1(g3)));
      }), arguments);
    }, I3.wbg.__wbg_call_8e7cb608789c2528 = function() {
      return c$1((function(A2, I4, g3, Q2) {
        return C$1(B$1(A2).call(B$1(I4), B$1(g3), B$1(Q2)));
      }), arguments);
    }, I3.wbg.__wbg_call_938992c832f74314 = function() {
      return c$1((function(A2, I4, g3, Q2, E2) {
        return C$1(B$1(A2).call(B$1(I4), B$1(g3), B$1(Q2), B$1(E2)));
      }), arguments);
    }, I3.wbg.__wbg_bind_4d857b598695205e = function(A2, I4, g3, Q2) {
      return C$1(B$1(A2).bind(B$1(I4), B$1(g3), B$1(Q2)));
    }, I3.wbg.__wbg_buffer_12d079cc21e14bdb = function(A2) {
      return C$1(B$1(A2).buffer);
    }, I3.wbg.__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb = function(A2, I4, g3) {
      return C$1(new Uint8Array(B$1(A2), I4 >>> 0, g3 >>> 0));
    }, I3.wbg.__wbg_new_63b92bc8671ed464 = function(A2) {
      return C$1(new Uint8Array(B$1(A2)));
    }, I3.wbg.__wbg_set_a47bac70306a19a7 = function(A2, I4, g3) {
      B$1(A2).set(B$1(I4), g3 >>> 0);
    }, I3.wbg.__wbg_length_c20a40f15020d68a = function(A2) {
      return B$1(A2).length;
    }, I3.wbg.__wbg_newwithbyteoffsetandlength_4a659d079a1650e0 = function(A2, I4, g3) {
      return C$1(new Float32Array(B$1(A2), I4 >>> 0, g3 >>> 0));
    }, I3.wbg.__wbg_set_bd975934d1b1fddb = function(A2, I4, g3) {
      B$1(A2).set(B$1(I4), g3 >>> 0);
    }, I3.wbg.__wbg_length_d25bbcbc3367f684 = function(A2) {
      return B$1(A2).length;
    }, I3.wbg.__wbg_newwithlength_1e8b839a06de01c5 = function(A2) {
      return C$1(new Float32Array(A2 >>> 0));
    }, I3.wbg.__wbindgen_throw = function(A2, I4) {
      throw new Error(k$1(A2, I4));
    }, I3.wbg.__wbindgen_memory = function() {
      return C$1(A$1.memory);
    }, I3;
  })();
  ("string" == typeof I2 || "function" == typeof Request && I2 instanceof Request || "function" == typeof URL && I2 instanceof URL) && (I2 = fetch(I2));
  const { instance: w2, module: K2 } = await (async function(A2, I3) {
    if ("function" == typeof Response && A2 instanceof Response) {
      if ("function" == typeof WebAssembly.instantiateStreaming) try {
        return await WebAssembly.instantiateStreaming(A2, I3);
      } catch (I4) {
        if ("application/wasm" == A2.headers.get("Content-Type")) throw I4;
        console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", I4);
      }
      const g3 = await A2.arrayBuffer();
      return await WebAssembly.instantiate(g3, I3);
    }
    {
      const g3 = await WebAssembly.instantiate(A2, I3);
      return g3 instanceof WebAssembly.Instance ? { instance: g3, module: A2 } : g3;
    }
  })(await I2, g2);
  return (function(I3, g3) {
    return A$1 = I3.exports, mA.__wbindgen_wasm_module = g3, J$1 = null, i$1 = null, o$1 = null, M$1 = null, G$1 = null, A$1;
  })(w2, K2);
}
class jA {
  constructor(A2, I2, g2) {
    this.x = A2, this.y = I2, this.z = g2;
  }
}
class fA {
  static new(A2, I2, g2) {
    return new jA(A2, I2, g2);
  }
  static intoRaw(A2) {
    return new xA(A2.x, A2.y, A2.z);
  }
  static zeros() {
    return fA.new(0, 0, 0);
  }
  static fromRaw(A2) {
    if (!A2) return null;
    let I2 = fA.new(A2.x, A2.y, A2.z);
    return A2.free(), I2;
  }
  static copy(A2, I2) {
    A2.x = I2.x, A2.y = I2.y, A2.z = I2.z;
  }
}
class VA {
  constructor(A2, I2, g2, C2) {
    this.x = A2, this.y = I2, this.z = g2, this.w = C2;
  }
}
class XA {
  static identity() {
    return new VA(0, 0, 0, 1);
  }
  static fromRaw(A2) {
    if (!A2) return null;
    let I2 = new VA(A2.x, A2.y, A2.z, A2.w);
    return A2.free(), I2;
  }
  static intoRaw(A2) {
    return new HA(A2.x, A2.y, A2.z, A2.w);
  }
  static copy(A2, I2) {
    A2.x = I2.x, A2.y = I2.y, A2.z = I2.z, A2.w = I2.w;
  }
}
class PA {
  constructor(A2) {
    this.elements = A2;
  }
  get m11() {
    return this.elements[0];
  }
  get m12() {
    return this.elements[1];
  }
  get m21() {
    return this.m12;
  }
  get m13() {
    return this.elements[2];
  }
  get m31() {
    return this.m13;
  }
  get m22() {
    return this.elements[3];
  }
  get m23() {
    return this.elements[4];
  }
  get m32() {
    return this.m23;
  }
  get m33() {
    return this.elements[5];
  }
}
class uA {
  static fromRaw(A2) {
    const I2 = new PA(A2.elements());
    return A2.free(), I2;
  }
}
var vA, zA, _A, $A, AI, II, gI, CI, BI, QI, EI, iI, DI, oI, SI;
!(function(A2) {
  A2[A2.Dynamic = 0] = "Dynamic", A2[A2.Fixed = 1] = "Fixed", A2[A2.KinematicPositionBased = 2] = "KinematicPositionBased", A2[A2.KinematicVelocityBased = 3] = "KinematicVelocityBased";
})(vA || (vA = {}));
class wI {
  constructor(A2, I2, g2) {
    this.rawSet = A2, this.colliderSet = I2, this.handle = g2;
  }
  finalizeDeserialization(A2) {
    this.colliderSet = A2;
  }
  isValid() {
    return this.rawSet.contains(this.handle);
  }
  lockTranslations(A2, I2) {
    return this.rawSet.rbLockTranslations(this.handle, A2, I2);
  }
  lockRotations(A2, I2) {
    return this.rawSet.rbLockRotations(this.handle, A2, I2);
  }
  setEnabledTranslations(A2, I2, g2, C2) {
    return this.rawSet.rbSetEnabledTranslations(this.handle, A2, I2, g2, C2);
  }
  restrictTranslations(A2, I2, g2, C2) {
    this.setEnabledTranslations(A2, I2, g2, C2);
  }
  setEnabledRotations(A2, I2, g2, C2) {
    return this.rawSet.rbSetEnabledRotations(this.handle, A2, I2, g2, C2);
  }
  restrictRotations(A2, I2, g2, C2) {
    this.setEnabledRotations(A2, I2, g2, C2);
  }
  dominanceGroup() {
    return this.rawSet.rbDominanceGroup(this.handle);
  }
  setDominanceGroup(A2) {
    this.rawSet.rbSetDominanceGroup(this.handle, A2);
  }
  additionalSolverIterations() {
    return this.rawSet.rbAdditionalSolverIterations(this.handle);
  }
  setAdditionalSolverIterations(A2) {
    this.rawSet.rbSetAdditionalSolverIterations(this.handle, A2);
  }
  enableCcd(A2) {
    this.rawSet.rbEnableCcd(this.handle, A2);
  }
  setSoftCcdPrediction(A2) {
    this.rawSet.rbSetSoftCcdPrediction(this.handle, A2);
  }
  softCcdPrediction() {
    return this.rawSet.rbSoftCcdPrediction(this.handle);
  }
  translation() {
    let A2 = this.rawSet.rbTranslation(this.handle);
    return fA.fromRaw(A2);
  }
  rotation() {
    let A2 = this.rawSet.rbRotation(this.handle);
    return XA.fromRaw(A2);
  }
  nextTranslation() {
    let A2 = this.rawSet.rbNextTranslation(this.handle);
    return fA.fromRaw(A2);
  }
  nextRotation() {
    let A2 = this.rawSet.rbNextRotation(this.handle);
    return XA.fromRaw(A2);
  }
  setTranslation(A2, I2) {
    this.rawSet.rbSetTranslation(this.handle, A2.x, A2.y, A2.z, I2);
  }
  setLinvel(A2, I2) {
    let g2 = fA.intoRaw(A2);
    this.rawSet.rbSetLinvel(this.handle, g2, I2), g2.free();
  }
  gravityScale() {
    return this.rawSet.rbGravityScale(this.handle);
  }
  setGravityScale(A2, I2) {
    this.rawSet.rbSetGravityScale(this.handle, A2, I2);
  }
  setRotation(A2, I2) {
    this.rawSet.rbSetRotation(this.handle, A2.x, A2.y, A2.z, A2.w, I2);
  }
  setAngvel(A2, I2) {
    let g2 = fA.intoRaw(A2);
    this.rawSet.rbSetAngvel(this.handle, g2, I2), g2.free();
  }
  setNextKinematicTranslation(A2) {
    this.rawSet.rbSetNextKinematicTranslation(this.handle, A2.x, A2.y, A2.z);
  }
  setNextKinematicRotation(A2) {
    this.rawSet.rbSetNextKinematicRotation(this.handle, A2.x, A2.y, A2.z, A2.w);
  }
  linvel() {
    return fA.fromRaw(this.rawSet.rbLinvel(this.handle));
  }
  angvel() {
    return fA.fromRaw(this.rawSet.rbAngvel(this.handle));
  }
  mass() {
    return this.rawSet.rbMass(this.handle);
  }
  effectiveInvMass() {
    return fA.fromRaw(this.rawSet.rbEffectiveInvMass(this.handle));
  }
  invMass() {
    return this.rawSet.rbInvMass(this.handle);
  }
  localCom() {
    return fA.fromRaw(this.rawSet.rbLocalCom(this.handle));
  }
  worldCom() {
    return fA.fromRaw(this.rawSet.rbWorldCom(this.handle));
  }
  invPrincipalInertiaSqrt() {
    return fA.fromRaw(this.rawSet.rbInvPrincipalInertiaSqrt(this.handle));
  }
  principalInertia() {
    return fA.fromRaw(this.rawSet.rbPrincipalInertia(this.handle));
  }
  principalInertiaLocalFrame() {
    return XA.fromRaw(this.rawSet.rbPrincipalInertiaLocalFrame(this.handle));
  }
  effectiveWorldInvInertiaSqrt() {
    return uA.fromRaw(this.rawSet.rbEffectiveWorldInvInertiaSqrt(this.handle));
  }
  effectiveAngularInertia() {
    return uA.fromRaw(this.rawSet.rbEffectiveAngularInertia(this.handle));
  }
  sleep() {
    this.rawSet.rbSleep(this.handle);
  }
  wakeUp() {
    this.rawSet.rbWakeUp(this.handle);
  }
  isCcdEnabled() {
    return this.rawSet.rbIsCcdEnabled(this.handle);
  }
  numColliders() {
    return this.rawSet.rbNumColliders(this.handle);
  }
  collider(A2) {
    return this.colliderSet.get(this.rawSet.rbCollider(this.handle, A2));
  }
  setEnabled(A2) {
    this.rawSet.rbSetEnabled(this.handle, A2);
  }
  isEnabled() {
    return this.rawSet.rbIsEnabled(this.handle);
  }
  bodyType() {
    return this.rawSet.rbBodyType(this.handle);
  }
  setBodyType(A2, I2) {
    return this.rawSet.rbSetBodyType(this.handle, A2, I2);
  }
  isSleeping() {
    return this.rawSet.rbIsSleeping(this.handle);
  }
  isMoving() {
    return this.rawSet.rbIsMoving(this.handle);
  }
  isFixed() {
    return this.rawSet.rbIsFixed(this.handle);
  }
  isKinematic() {
    return this.rawSet.rbIsKinematic(this.handle);
  }
  isDynamic() {
    return this.rawSet.rbIsDynamic(this.handle);
  }
  linearDamping() {
    return this.rawSet.rbLinearDamping(this.handle);
  }
  angularDamping() {
    return this.rawSet.rbAngularDamping(this.handle);
  }
  setLinearDamping(A2) {
    this.rawSet.rbSetLinearDamping(this.handle, A2);
  }
  recomputeMassPropertiesFromColliders() {
    this.rawSet.rbRecomputeMassPropertiesFromColliders(this.handle, this.colliderSet.raw);
  }
  setAdditionalMass(A2, I2) {
    this.rawSet.rbSetAdditionalMass(this.handle, A2, I2);
  }
  setAdditionalMassProperties(A2, I2, g2, C2, B2) {
    let Q2 = fA.intoRaw(I2), E2 = fA.intoRaw(g2), i2 = XA.intoRaw(C2);
    this.rawSet.rbSetAdditionalMassProperties(this.handle, A2, Q2, E2, i2, B2), Q2.free(), E2.free(), i2.free();
  }
  setAngularDamping(A2) {
    this.rawSet.rbSetAngularDamping(this.handle, A2);
  }
  resetForces(A2) {
    this.rawSet.rbResetForces(this.handle, A2);
  }
  resetTorques(A2) {
    this.rawSet.rbResetTorques(this.handle, A2);
  }
  addForce(A2, I2) {
    const g2 = fA.intoRaw(A2);
    this.rawSet.rbAddForce(this.handle, g2, I2), g2.free();
  }
  applyImpulse(A2, I2) {
    const g2 = fA.intoRaw(A2);
    this.rawSet.rbApplyImpulse(this.handle, g2, I2), g2.free();
  }
  addTorque(A2, I2) {
    const g2 = fA.intoRaw(A2);
    this.rawSet.rbAddTorque(this.handle, g2, I2), g2.free();
  }
  applyTorqueImpulse(A2, I2) {
    const g2 = fA.intoRaw(A2);
    this.rawSet.rbApplyTorqueImpulse(this.handle, g2, I2), g2.free();
  }
  addForceAtPoint(A2, I2, g2) {
    const C2 = fA.intoRaw(A2), B2 = fA.intoRaw(I2);
    this.rawSet.rbAddForceAtPoint(this.handle, C2, B2, g2), C2.free(), B2.free();
  }
  applyImpulseAtPoint(A2, I2, g2) {
    const C2 = fA.intoRaw(A2), B2 = fA.intoRaw(I2);
    this.rawSet.rbApplyImpulseAtPoint(this.handle, C2, B2, g2), C2.free(), B2.free();
  }
  userForce() {
    return fA.fromRaw(this.rawSet.rbUserForce(this.handle));
  }
  userTorque() {
    return fA.fromRaw(this.rawSet.rbUserTorque(this.handle));
  }
}
class GI {
  constructor(A2) {
    this.enabled = true, this.status = A2, this.translation = fA.zeros(), this.rotation = XA.identity(), this.gravityScale = 1, this.linvel = fA.zeros(), this.mass = 0, this.massOnly = false, this.centerOfMass = fA.zeros(), this.translationsEnabledX = true, this.translationsEnabledY = true, this.angvel = fA.zeros(), this.principalAngularInertia = fA.zeros(), this.angularInertiaLocalFrame = XA.identity(), this.translationsEnabledZ = true, this.rotationsEnabledX = true, this.rotationsEnabledY = true, this.rotationsEnabledZ = true, this.linearDamping = 0, this.angularDamping = 0, this.canSleep = true, this.sleeping = false, this.ccdEnabled = false, this.softCcdPrediction = 0, this.dominanceGroup = 0, this.additionalSolverIterations = 0;
  }
  static dynamic() {
    return new GI(vA.Dynamic);
  }
  static kinematicPositionBased() {
    return new GI(vA.KinematicPositionBased);
  }
  static kinematicVelocityBased() {
    return new GI(vA.KinematicVelocityBased);
  }
  static fixed() {
    return new GI(vA.Fixed);
  }
  static newDynamic() {
    return new GI(vA.Dynamic);
  }
  static newKinematicPositionBased() {
    return new GI(vA.KinematicPositionBased);
  }
  static newKinematicVelocityBased() {
    return new GI(vA.KinematicVelocityBased);
  }
  static newStatic() {
    return new GI(vA.Fixed);
  }
  setDominanceGroup(A2) {
    return this.dominanceGroup = A2, this;
  }
  setAdditionalSolverIterations(A2) {
    return this.additionalSolverIterations = A2, this;
  }
  setEnabled(A2) {
    return this.enabled = A2, this;
  }
  setTranslation(A2, I2, g2) {
    if ("number" != typeof A2 || "number" != typeof I2 || "number" != typeof g2) throw TypeError("The translation components must be numbers.");
    return this.translation = { x: A2, y: I2, z: g2 }, this;
  }
  setRotation(A2) {
    return XA.copy(this.rotation, A2), this;
  }
  setGravityScale(A2) {
    return this.gravityScale = A2, this;
  }
  setAdditionalMass(A2) {
    return this.mass = A2, this.massOnly = true, this;
  }
  setLinvel(A2, I2, g2) {
    if ("number" != typeof A2 || "number" != typeof I2 || "number" != typeof g2) throw TypeError("The linvel components must be numbers.");
    return this.linvel = { x: A2, y: I2, z: g2 }, this;
  }
  setAngvel(A2) {
    return fA.copy(this.angvel, A2), this;
  }
  setAdditionalMassProperties(A2, I2, g2, C2) {
    return this.mass = A2, fA.copy(this.centerOfMass, I2), fA.copy(this.principalAngularInertia, g2), XA.copy(this.angularInertiaLocalFrame, C2), this.massOnly = false, this;
  }
  enabledTranslations(A2, I2, g2) {
    return this.translationsEnabledX = A2, this.translationsEnabledY = I2, this.translationsEnabledZ = g2, this;
  }
  restrictTranslations(A2, I2, g2) {
    return this.enabledTranslations(A2, I2, g2);
  }
  lockTranslations() {
    return this.enabledTranslations(false, false, false);
  }
  enabledRotations(A2, I2, g2) {
    return this.rotationsEnabledX = A2, this.rotationsEnabledY = I2, this.rotationsEnabledZ = g2, this;
  }
  restrictRotations(A2, I2, g2) {
    return this.enabledRotations(A2, I2, g2);
  }
  lockRotations() {
    return this.restrictRotations(false, false, false);
  }
  setLinearDamping(A2) {
    return this.linearDamping = A2, this;
  }
  setAngularDamping(A2) {
    return this.angularDamping = A2, this;
  }
  setCanSleep(A2) {
    return this.canSleep = A2, this;
  }
  setSleeping(A2) {
    return this.sleeping = A2, this;
  }
  setCcdEnabled(A2) {
    return this.ccdEnabled = A2, this;
  }
  setSoftCcdPrediction(A2) {
    return this.softCcdPrediction = A2, this;
  }
  setUserData(A2) {
    return this.userData = A2, this;
  }
}
class kI {
  constructor() {
    this.fconv = new Float64Array(1), this.uconv = new Uint32Array(this.fconv.buffer), this.data = new Array(), this.size = 0;
  }
  set(A2, I2) {
    let g2 = this.index(A2);
    for (; this.data.length <= g2; ) this.data.push(null);
    null == this.data[g2] && (this.size += 1), this.data[g2] = I2;
  }
  len() {
    return this.size;
  }
  delete(A2) {
    let I2 = this.index(A2);
    I2 < this.data.length && (null != this.data[I2] && (this.size -= 1), this.data[I2] = null);
  }
  clear() {
    this.data = new Array();
  }
  get(A2) {
    let I2 = this.index(A2);
    return I2 < this.data.length ? this.data[I2] : null;
  }
  forEach(A2) {
    for (const I2 of this.data) null != I2 && A2(I2);
  }
  getAll() {
    return this.data.filter(((A2) => null != A2));
  }
  index(A2) {
    return this.fconv[0] = A2, this.uconv[0];
  }
}
class KI {
  constructor(A2) {
    this.raw = A2 || new lA(), this.map = new kI(), A2 && A2.forEachRigidBodyHandle(((I2) => {
      this.map.set(I2, new wI(A2, null, I2));
    }));
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
  }
  finalizeDeserialization(A2) {
    this.map.forEach(((I2) => I2.finalizeDeserialization(A2)));
  }
  createRigidBody(A2, I2) {
    let g2 = fA.intoRaw(I2.translation), C2 = XA.intoRaw(I2.rotation), B2 = fA.intoRaw(I2.linvel), Q2 = fA.intoRaw(I2.centerOfMass), E2 = fA.intoRaw(I2.angvel), i2 = fA.intoRaw(I2.principalAngularInertia), D2 = XA.intoRaw(I2.angularInertiaLocalFrame), o2 = this.raw.createRigidBody(I2.enabled, g2, C2, I2.gravityScale, I2.mass, I2.massOnly, Q2, B2, E2, i2, D2, I2.translationsEnabledX, I2.translationsEnabledY, I2.translationsEnabledZ, I2.rotationsEnabledX, I2.rotationsEnabledY, I2.rotationsEnabledZ, I2.linearDamping, I2.angularDamping, I2.status, I2.canSleep, I2.sleeping, I2.softCcdPrediction, I2.ccdEnabled, I2.dominanceGroup, I2.additionalSolverIterations);
    g2.free(), C2.free(), B2.free(), Q2.free(), E2.free(), i2.free(), D2.free();
    const S2 = new wI(this.raw, A2, o2);
    return S2.userData = I2.userData, this.map.set(o2, S2), S2;
  }
  remove(A2, I2, g2, C2, B2) {
    for (let I3 = 0; I3 < this.raw.rbNumColliders(A2); I3 += 1) g2.unmap(this.raw.rbCollider(A2, I3));
    C2.forEachJointHandleAttachedToRigidBody(A2, ((A3) => C2.unmap(A3))), B2.forEachJointHandleAttachedToRigidBody(A2, ((A3) => B2.unmap(A3))), this.raw.remove(A2, I2.raw, g2.raw, C2.raw, B2.raw), this.map.delete(A2);
  }
  len() {
    return this.map.len();
  }
  contains(A2) {
    return null != this.get(A2);
  }
  get(A2) {
    return this.map.get(A2);
  }
  forEach(A2) {
    this.map.forEach(A2);
  }
  forEachActiveRigidBody(A2, I2) {
    A2.forEachActiveRigidBodyHandle(((A3) => {
      I2(this.get(A3));
    }));
  }
  getAll() {
    return this.map.getAll();
  }
}
class JI {
  constructor(A2) {
    this.raw = A2 || new BA();
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  get dt() {
    return this.raw.dt;
  }
  get contact_erp() {
    return this.raw.contact_erp;
  }
  get lengthUnit() {
    return this.raw.lengthUnit;
  }
  get normalizedAllowedLinearError() {
    return this.raw.normalizedAllowedLinearError;
  }
  get normalizedPredictionDistance() {
    return this.raw.normalizedPredictionDistance;
  }
  get numSolverIterations() {
    return this.raw.numSolverIterations;
  }
  get numAdditionalFrictionIterations() {
    return this.raw.numAdditionalFrictionIterations;
  }
  get numInternalPgsIterations() {
    return this.raw.numInternalPgsIterations;
  }
  get minIslandSize() {
    return this.raw.minIslandSize;
  }
  get maxCcdSubsteps() {
    return this.raw.maxCcdSubsteps;
  }
  set dt(A2) {
    this.raw.dt = A2;
  }
  set contact_natural_frequency(A2) {
    this.raw.contact_natural_frequency = A2;
  }
  set lengthUnit(A2) {
    this.raw.lengthUnit = A2;
  }
  set normalizedAllowedLinearError(A2) {
    this.raw.normalizedAllowedLinearError = A2;
  }
  set normalizedPredictionDistance(A2) {
    this.raw.normalizedPredictionDistance = A2;
  }
  set numSolverIterations(A2) {
    this.raw.numSolverIterations = A2;
  }
  set numAdditionalFrictionIterations(A2) {
    this.raw.numAdditionalFrictionIterations = A2;
  }
  set numInternalPgsIterations(A2) {
    this.raw.numInternalPgsIterations = A2;
  }
  set minIslandSize(A2) {
    this.raw.minIslandSize = A2;
  }
  set maxCcdSubsteps(A2) {
    this.raw.maxCcdSubsteps = A2;
  }
  switchToStandardPgsSolver() {
    this.raw.switchToStandardPgsSolver();
  }
  switchToSmallStepsPgsSolver() {
    this.raw.switchToSmallStepsPgsSolver();
  }
  switchToSmallStepsPgsSolverWithoutWarmstart() {
    this.raw.switchToSmallStepsPgsSolverWithoutWarmstart();
  }
}
!(function(A2) {
  A2[A2.Revolute = 0] = "Revolute", A2[A2.Fixed = 1] = "Fixed", A2[A2.Prismatic = 2] = "Prismatic", A2[A2.Rope = 3] = "Rope", A2[A2.Spring = 4] = "Spring", A2[A2.Spherical = 5] = "Spherical", A2[A2.Generic = 6] = "Generic";
})(zA || (zA = {})), (function(A2) {
  A2[A2.AccelerationBased = 0] = "AccelerationBased", A2[A2.ForceBased = 1] = "ForceBased";
})(_A || (_A = {})), (function(A2) {
  A2[A2.LinX = 1] = "LinX", A2[A2.LinY = 2] = "LinY", A2[A2.LinZ = 4] = "LinZ", A2[A2.AngX = 8] = "AngX", A2[A2.AngY = 16] = "AngY", A2[A2.AngZ = 32] = "AngZ";
})($A || ($A = {}));
class UI {
  constructor(A2, I2, g2) {
    this.rawSet = A2, this.bodySet = I2, this.handle = g2;
  }
  static newTyped(A2, I2, g2) {
    switch (A2.jointType(g2)) {
      case Y$1.Revolute:
        return new aI(A2, I2, g2);
      case Y$1.Prismatic:
        return new FI(A2, I2, g2);
      case Y$1.Fixed:
        return new yI(A2, I2, g2);
      case Y$1.Spring:
        return new MI(A2, I2, g2);
      case Y$1.Rope:
        return new NI(A2, I2, g2);
      case Y$1.Spherical:
        return new RI(A2, I2, g2);
      case Y$1.Generic:
        return new sI(A2, I2, g2);
      default:
        return new UI(A2, I2, g2);
    }
  }
  finalizeDeserialization(A2) {
    this.bodySet = A2;
  }
  isValid() {
    return this.rawSet.contains(this.handle);
  }
  body1() {
    return this.bodySet.get(this.rawSet.jointBodyHandle1(this.handle));
  }
  body2() {
    return this.bodySet.get(this.rawSet.jointBodyHandle2(this.handle));
  }
  type() {
    return this.rawSet.jointType(this.handle);
  }
  frameX1() {
    return XA.fromRaw(this.rawSet.jointFrameX1(this.handle));
  }
  frameX2() {
    return XA.fromRaw(this.rawSet.jointFrameX2(this.handle));
  }
  anchor1() {
    return fA.fromRaw(this.rawSet.jointAnchor1(this.handle));
  }
  anchor2() {
    return fA.fromRaw(this.rawSet.jointAnchor2(this.handle));
  }
  setAnchor1(A2) {
    const I2 = fA.intoRaw(A2);
    this.rawSet.jointSetAnchor1(this.handle, I2), I2.free();
  }
  setAnchor2(A2) {
    const I2 = fA.intoRaw(A2);
    this.rawSet.jointSetAnchor2(this.handle, I2), I2.free();
  }
  setContactsEnabled(A2) {
    this.rawSet.jointSetContactsEnabled(this.handle, A2);
  }
  contactsEnabled() {
    return this.rawSet.jointContactsEnabled(this.handle);
  }
}
class hI extends UI {
  limitsEnabled() {
    return this.rawSet.jointLimitsEnabled(this.handle, this.rawAxis());
  }
  limitsMin() {
    return this.rawSet.jointLimitsMin(this.handle, this.rawAxis());
  }
  limitsMax() {
    return this.rawSet.jointLimitsMax(this.handle, this.rawAxis());
  }
  setLimits(A2, I2) {
    this.rawSet.jointSetLimits(this.handle, this.rawAxis(), A2, I2);
  }
  configureMotorModel(A2) {
    this.rawSet.jointConfigureMotorModel(this.handle, this.rawAxis(), A2);
  }
  configureMotorVelocity(A2, I2) {
    this.rawSet.jointConfigureMotorVelocity(this.handle, this.rawAxis(), A2, I2);
  }
  configureMotorPosition(A2, I2, g2) {
    this.rawSet.jointConfigureMotorPosition(this.handle, this.rawAxis(), A2, I2, g2);
  }
  configureMotor(A2, I2, g2, C2) {
    this.rawSet.jointConfigureMotor(this.handle, this.rawAxis(), A2, I2, g2, C2);
  }
}
class yI extends UI {
}
class NI extends UI {
}
class MI extends UI {
}
class FI extends hI {
  rawAxis() {
    return q$1.LinX;
  }
}
class aI extends hI {
  rawAxis() {
    return q$1.AngX;
  }
}
class sI extends UI {
}
class RI extends UI {
}
class cI {
  constructor() {
  }
  static fixed(A2, I2, g2, C2) {
    let B2 = new cI();
    return B2.anchor1 = A2, B2.anchor2 = g2, B2.frame1 = I2, B2.frame2 = C2, B2.jointType = zA.Fixed, B2;
  }
  static spring(A2, I2, g2, C2, B2) {
    let Q2 = new cI();
    return Q2.anchor1 = C2, Q2.anchor2 = B2, Q2.length = A2, Q2.stiffness = I2, Q2.damping = g2, Q2.jointType = zA.Spring, Q2;
  }
  static rope(A2, I2, g2) {
    let C2 = new cI();
    return C2.anchor1 = I2, C2.anchor2 = g2, C2.length = A2, C2.jointType = zA.Rope, C2;
  }
  static generic(A2, I2, g2, C2) {
    let B2 = new cI();
    return B2.anchor1 = A2, B2.anchor2 = I2, B2.axis = g2, B2.axesMask = C2, B2.jointType = zA.Generic, B2;
  }
  static spherical(A2, I2) {
    let g2 = new cI();
    return g2.anchor1 = A2, g2.anchor2 = I2, g2.jointType = zA.Spherical, g2;
  }
  static prismatic(A2, I2, g2) {
    let C2 = new cI();
    return C2.anchor1 = A2, C2.anchor2 = I2, C2.axis = g2, C2.jointType = zA.Prismatic, C2;
  }
  static revolute(A2, I2, g2) {
    let C2 = new cI();
    return C2.anchor1 = A2, C2.anchor2 = I2, C2.axis = g2, C2.jointType = zA.Revolute, C2;
  }
  intoRaw() {
    let A2, I2, g2 = fA.intoRaw(this.anchor1), C2 = fA.intoRaw(this.anchor2), B2 = false, Q2 = 0, E2 = 0;
    switch (this.jointType) {
      case zA.Fixed:
        let i2 = XA.intoRaw(this.frame1), D2 = XA.intoRaw(this.frame2);
        I2 = AA.fixed(g2, i2, C2, D2), i2.free(), D2.free();
        break;
      case zA.Spring:
        I2 = AA.spring(this.length, this.stiffness, this.damping, g2, C2);
        break;
      case zA.Rope:
        I2 = AA.rope(this.length, g2, C2);
        break;
      case zA.Prismatic:
        A2 = fA.intoRaw(this.axis), this.limitsEnabled && (B2 = true, Q2 = this.limits[0], E2 = this.limits[1]), I2 = AA.prismatic(g2, C2, A2, B2, Q2, E2), A2.free();
        break;
      case zA.Generic:
        A2 = fA.intoRaw(this.axis);
        let o2 = this.axesMask;
        I2 = AA.generic(g2, C2, A2, o2);
        break;
      case zA.Spherical:
        I2 = AA.spherical(g2, C2);
        break;
      case zA.Revolute:
        A2 = fA.intoRaw(this.axis), I2 = AA.revolute(g2, C2, A2), A2.free();
    }
    return g2.free(), C2.free(), I2;
  }
}
class qI {
  constructor(A2) {
    this.raw = A2 || new gA(), this.map = new kI(), A2 && A2.forEachJointHandle(((I2) => {
      this.map.set(I2, UI.newTyped(A2, null, I2));
    }));
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
  }
  finalizeDeserialization(A2) {
    this.map.forEach(((I2) => I2.finalizeDeserialization(A2)));
  }
  createJoint(A2, I2, g2, C2, B2) {
    const Q2 = I2.intoRaw(), E2 = this.raw.createJoint(Q2, g2, C2, B2);
    Q2.free();
    let i2 = UI.newTyped(this.raw, A2, E2);
    return this.map.set(E2, i2), i2;
  }
  remove(A2, I2) {
    this.raw.remove(A2, I2), this.unmap(A2);
  }
  forEachJointHandleAttachedToRigidBody(A2, I2) {
    this.raw.forEachJointAttachedToRigidBody(A2, I2);
  }
  unmap(A2) {
    this.map.delete(A2);
  }
  len() {
    return this.map.len();
  }
  contains(A2) {
    return null != this.get(A2);
  }
  get(A2) {
    return this.map.get(A2);
  }
  forEach(A2) {
    this.map.forEach(A2);
  }
  getAll() {
    return this.map.getAll();
  }
}
class YI {
  constructor(A2, I2) {
    this.rawSet = A2, this.handle = I2;
  }
  static newTyped(A2, I2) {
    switch (A2.jointType(I2)) {
      case Y$1.Revolute:
        return new tI(A2, I2);
      case Y$1.Prismatic:
        return new HI(A2, I2);
      case Y$1.Fixed:
        return new LI(A2, I2);
      case Y$1.Spherical:
        return new pI(A2, I2);
      default:
        return new YI(A2, I2);
    }
  }
  isValid() {
    return this.rawSet.contains(this.handle);
  }
  setContactsEnabled(A2) {
    this.rawSet.jointSetContactsEnabled(this.handle, A2);
  }
  contactsEnabled() {
    return this.rawSet.jointContactsEnabled(this.handle);
  }
}
class lI extends YI {
}
class LI extends YI {
}
class HI extends lI {
  rawAxis() {
    return q$1.LinX;
  }
}
class tI extends lI {
  rawAxis() {
    return q$1.AngX;
  }
}
class pI extends YI {
}
class eI {
  constructor(A2) {
    this.raw = A2 || new SA(), this.map = new kI(), A2 && A2.forEachJointHandle(((A3) => {
      this.map.set(A3, YI.newTyped(this.raw, A3));
    }));
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
  }
  createJoint(A2, I2, g2, C2) {
    const B2 = A2.intoRaw(), Q2 = this.raw.createJoint(B2, I2, g2, C2);
    B2.free();
    let E2 = YI.newTyped(this.raw, Q2);
    return this.map.set(Q2, E2), E2;
  }
  remove(A2, I2) {
    this.raw.remove(A2, I2), this.map.delete(A2);
  }
  unmap(A2) {
    this.map.delete(A2);
  }
  len() {
    return this.map.len();
  }
  contains(A2) {
    return null != this.get(A2);
  }
  get(A2) {
    return this.map.get(A2);
  }
  forEach(A2) {
    this.map.forEach(A2);
  }
  forEachJointHandleAttachedToRigidBody(A2, I2) {
    this.raw.forEachJointAttachedToRigidBody(A2, I2);
  }
  getAll() {
    return this.map.getAll();
  }
}
!(function(A2) {
  A2[A2.Average = 0] = "Average", A2[A2.Min = 1] = "Min", A2[A2.Multiply = 2] = "Multiply", A2[A2.Max = 3] = "Max";
})(AI || (AI = {}));
class rI {
  constructor(A2) {
    this.raw = A2 || new p$1();
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
}
class nI {
  constructor(A2) {
    this.raw = A2 || new EA();
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  forEachActiveRigidBodyHandle(A2) {
    this.raw.forEachActiveRigidBodyHandle(A2);
  }
}
class dI {
  constructor(A2) {
    this.raw = A2 || new H$1();
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
}
class TI {
  constructor(A2) {
    this.raw = A2 || new GA(), this.tempManifold = new OI(null);
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  contactPairsWith(A2, I2) {
    this.raw.contact_pairs_with(A2, I2);
  }
  intersectionPairsWith(A2, I2) {
    this.raw.intersection_pairs_with(A2, I2);
  }
  contactPair(A2, I2, g2) {
    const C2 = this.raw.contact_pair(A2, I2);
    if (C2) {
      const I3 = C2.collider1() != A2;
      let B2;
      for (B2 = 0; B2 < C2.numContactManifolds(); ++B2) this.tempManifold.raw = C2.contactManifold(B2), this.tempManifold.raw && g2(this.tempManifold, I3), this.tempManifold.free();
      C2.free();
    }
  }
  intersectionPair(A2, I2) {
    return this.raw.intersection_pair(A2, I2);
  }
}
class OI {
  constructor(A2) {
    this.raw = A2;
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  normal() {
    return fA.fromRaw(this.raw.normal());
  }
  localNormal1() {
    return fA.fromRaw(this.raw.local_n1());
  }
  localNormal2() {
    return fA.fromRaw(this.raw.local_n2());
  }
  subshape1() {
    return this.raw.subshape1();
  }
  subshape2() {
    return this.raw.subshape2();
  }
  numContacts() {
    return this.raw.num_contacts();
  }
  localContactPoint1(A2) {
    return fA.fromRaw(this.raw.contact_local_p1(A2));
  }
  localContactPoint2(A2) {
    return fA.fromRaw(this.raw.contact_local_p2(A2));
  }
  contactDist(A2) {
    return this.raw.contact_dist(A2);
  }
  contactFid1(A2) {
    return this.raw.contact_fid1(A2);
  }
  contactFid2(A2) {
    return this.raw.contact_fid2(A2);
  }
  contactImpulse(A2) {
    return this.raw.contact_impulse(A2);
  }
  contactTangentImpulseX(A2) {
    return this.raw.contact_tangent_impulse_x(A2);
  }
  contactTangentImpulseY(A2) {
    return this.raw.contact_tangent_impulse_y(A2);
  }
  numSolverContacts() {
    return this.raw.num_solver_contacts();
  }
  solverContactPoint(A2) {
    return fA.fromRaw(this.raw.solver_contact_point(A2));
  }
  solverContactDist(A2) {
    return this.raw.solver_contact_dist(A2);
  }
  solverContactFriction(A2) {
    return this.raw.solver_contact_friction(A2);
  }
  solverContactRestitution(A2) {
    return this.raw.solver_contact_restitution(A2);
  }
  solverContactTangentVelocity(A2) {
    return fA.fromRaw(this.raw.solver_contact_tangent_velocity(A2));
  }
}
class ZI {
  constructor(A2, I2, g2, C2, B2) {
    this.distance = A2, this.point1 = I2, this.point2 = g2, this.normal1 = C2, this.normal2 = B2;
  }
  static fromRaw(A2) {
    if (!A2) return null;
    const I2 = new ZI(A2.distance(), fA.fromRaw(A2.point1()), fA.fromRaw(A2.point2()), fA.fromRaw(A2.normal1()), fA.fromRaw(A2.normal2()));
    return A2.free(), I2;
  }
}
!(function(A2) {
  A2[A2.Vertex = 0] = "Vertex", A2[A2.Edge = 1] = "Edge", A2[A2.Face = 2] = "Face", A2[A2.Unknown = 3] = "Unknown";
})(II || (II = {}));
class bI {
  constructor(A2, I2) {
    this.point = A2, this.isInside = I2;
  }
  static fromRaw(A2) {
    if (!A2) return null;
    const I2 = new bI(fA.fromRaw(A2.point()), A2.isInside());
    return A2.free(), I2;
  }
}
class WI {
  constructor(A2, I2, g2, C2, B2) {
    this.featureType = II.Unknown, this.featureId = void 0, this.collider = A2, this.point = I2, this.isInside = g2, void 0 !== B2 && (this.featureId = B2), void 0 !== C2 && (this.featureType = C2);
  }
  static fromRaw(A2, I2) {
    if (!I2) return null;
    const g2 = new WI(A2.get(I2.colliderHandle()), fA.fromRaw(I2.point()), I2.isInside(), I2.featureType(), I2.featureId());
    return I2.free(), g2;
  }
}
class xI {
  constructor(A2, I2) {
    this.origin = A2, this.dir = I2;
  }
  pointAt(A2) {
    return { x: this.origin.x + this.dir.x * A2, y: this.origin.y + this.dir.y * A2, z: this.origin.z + this.dir.z * A2 };
  }
}
class mI {
  constructor(A2, I2, g2, C2) {
    this.featureType = II.Unknown, this.featureId = void 0, this.timeOfImpact = A2, this.normal = I2, void 0 !== C2 && (this.featureId = C2), void 0 !== g2 && (this.featureType = g2);
  }
  static fromRaw(A2) {
    if (!A2) return null;
    const I2 = new mI(A2.time_of_impact(), fA.fromRaw(A2.normal()), A2.featureType(), A2.featureId());
    return A2.free(), I2;
  }
}
class jI {
  constructor(A2, I2, g2, C2, B2) {
    this.featureType = II.Unknown, this.featureId = void 0, this.collider = A2, this.timeOfImpact = I2, this.normal = g2, void 0 !== B2 && (this.featureId = B2), void 0 !== C2 && (this.featureType = C2);
  }
  static fromRaw(A2, I2) {
    if (!I2) return null;
    const g2 = new jI(A2.get(I2.colliderHandle()), I2.time_of_impact(), fA.fromRaw(I2.normal()), I2.featureType(), I2.featureId());
    return I2.free(), g2;
  }
}
class fI {
  constructor(A2, I2) {
    this.collider = A2, this.timeOfImpact = I2;
  }
  static fromRaw(A2, I2) {
    if (!I2) return null;
    const g2 = new fI(A2.get(I2.colliderHandle()), I2.timeOfImpact());
    return I2.free(), g2;
  }
}
class VI {
  constructor(A2, I2, g2, C2, B2) {
    this.time_of_impact = A2, this.witness1 = I2, this.witness2 = g2, this.normal1 = C2, this.normal2 = B2;
  }
  static fromRaw(A2, I2) {
    if (!I2) return null;
    const g2 = new VI(I2.time_of_impact(), fA.fromRaw(I2.witness1()), fA.fromRaw(I2.witness2()), fA.fromRaw(I2.normal1()), fA.fromRaw(I2.normal2()));
    return I2.free(), g2;
  }
}
class XI extends VI {
  constructor(A2, I2, g2, C2, B2, Q2) {
    super(I2, g2, C2, B2, Q2), this.collider = A2;
  }
  static fromRaw(A2, I2) {
    if (!I2) return null;
    const g2 = new XI(A2.get(I2.colliderHandle()), I2.time_of_impact(), fA.fromRaw(I2.witness1()), fA.fromRaw(I2.witness2()), fA.fromRaw(I2.normal1()), fA.fromRaw(I2.normal2()));
    return I2.free(), g2;
  }
}
class PI {
  static fromRaw(A2, I2) {
    const g2 = A2.coShapeType(I2);
    let C2, B2, Q2, E2, i2, D2, o2;
    switch (g2) {
      case l$1.Ball:
        return new uI(A2.coRadius(I2));
      case l$1.Cuboid:
        return C2 = A2.coHalfExtents(I2), new zI(C2.x, C2.y, C2.z);
      case l$1.RoundCuboid:
        return C2 = A2.coHalfExtents(I2), B2 = A2.coRoundRadius(I2), new _I(C2.x, C2.y, C2.z, B2);
      case l$1.Capsule:
        return i2 = A2.coHalfHeight(I2), D2 = A2.coRadius(I2), new $I(i2, D2);
      case l$1.Segment:
        return Q2 = A2.coVertices(I2), new Ag(fA.new(Q2[0], Q2[1], Q2[2]), fA.new(Q2[3], Q2[4], Q2[5]));
      case l$1.Polyline:
        return Q2 = A2.coVertices(I2), E2 = A2.coIndices(I2), new Cg(Q2, E2);
      case l$1.Triangle:
        return Q2 = A2.coVertices(I2), new Ig(fA.new(Q2[0], Q2[1], Q2[2]), fA.new(Q2[3], Q2[4], Q2[5]), fA.new(Q2[6], Q2[7], Q2[8]));
      case l$1.RoundTriangle:
        return Q2 = A2.coVertices(I2), B2 = A2.coRoundRadius(I2), new gg(fA.new(Q2[0], Q2[1], Q2[2]), fA.new(Q2[3], Q2[4], Q2[5]), fA.new(Q2[6], Q2[7], Q2[8]), B2);
      case l$1.HalfSpace:
        return o2 = fA.fromRaw(A2.coHalfspaceNormal(I2)), new vI(o2);
      case l$1.TriMesh:
        Q2 = A2.coVertices(I2), E2 = A2.coIndices(I2);
        const S2 = A2.coTriMeshFlags(I2);
        return new Bg(Q2, E2, S2);
      case l$1.HeightField:
        const w2 = A2.coHeightfieldScale(I2), G2 = A2.coHeightfieldHeights(I2), k2 = A2.coHeightfieldNRows(I2), K2 = A2.coHeightfieldNCols(I2), J2 = A2.coHeightFieldFlags(I2);
        return new ig(k2, K2, G2, w2, J2);
      case l$1.ConvexPolyhedron:
        return Q2 = A2.coVertices(I2), E2 = A2.coIndices(I2), new Qg(Q2, E2);
      case l$1.RoundConvexPolyhedron:
        return Q2 = A2.coVertices(I2), E2 = A2.coIndices(I2), B2 = A2.coRoundRadius(I2), new Eg(Q2, E2, B2);
      case l$1.Cylinder:
        return i2 = A2.coHalfHeight(I2), D2 = A2.coRadius(I2), new Dg(i2, D2);
      case l$1.RoundCylinder:
        return i2 = A2.coHalfHeight(I2), D2 = A2.coRadius(I2), B2 = A2.coRoundRadius(I2), new og(i2, D2, B2);
      case l$1.Cone:
        return i2 = A2.coHalfHeight(I2), D2 = A2.coRadius(I2), new Sg(i2, D2);
      case l$1.RoundCone:
        return i2 = A2.coHalfHeight(I2), D2 = A2.coRadius(I2), B2 = A2.coRoundRadius(I2), new wg(i2, D2, B2);
      default:
        throw new Error("unknown shape type: " + g2);
    }
  }
  castShape(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2) {
    let S2 = fA.intoRaw(A2), w2 = XA.intoRaw(I2), G2 = fA.intoRaw(g2), k2 = fA.intoRaw(B2), K2 = XA.intoRaw(Q2), J2 = fA.intoRaw(E2), U2 = this.intoRaw(), h2 = C2.intoRaw(), y2 = VI.fromRaw(null, U2.castShape(S2, w2, G2, h2, k2, K2, J2, i2, D2, o2));
    return S2.free(), w2.free(), G2.free(), k2.free(), K2.free(), J2.free(), U2.free(), h2.free(), y2;
  }
  intersectsShape(A2, I2, g2, C2, B2) {
    let Q2 = fA.intoRaw(A2), E2 = XA.intoRaw(I2), i2 = fA.intoRaw(C2), D2 = XA.intoRaw(B2), o2 = this.intoRaw(), S2 = g2.intoRaw(), w2 = o2.intersectsShape(Q2, E2, S2, i2, D2);
    return Q2.free(), E2.free(), i2.free(), D2.free(), o2.free(), S2.free(), w2;
  }
  contactShape(A2, I2, g2, C2, B2, Q2) {
    let E2 = fA.intoRaw(A2), i2 = XA.intoRaw(I2), D2 = fA.intoRaw(C2), o2 = XA.intoRaw(B2), S2 = this.intoRaw(), w2 = g2.intoRaw(), G2 = ZI.fromRaw(S2.contactShape(E2, i2, w2, D2, o2, Q2));
    return E2.free(), i2.free(), D2.free(), o2.free(), S2.free(), w2.free(), G2;
  }
  containsPoint(A2, I2, g2) {
    let C2 = fA.intoRaw(A2), B2 = XA.intoRaw(I2), Q2 = fA.intoRaw(g2), E2 = this.intoRaw(), i2 = E2.containsPoint(C2, B2, Q2);
    return C2.free(), B2.free(), Q2.free(), E2.free(), i2;
  }
  projectPoint(A2, I2, g2, C2) {
    let B2 = fA.intoRaw(A2), Q2 = XA.intoRaw(I2), E2 = fA.intoRaw(g2), i2 = this.intoRaw(), D2 = bI.fromRaw(i2.projectPoint(B2, Q2, E2, C2));
    return B2.free(), Q2.free(), E2.free(), i2.free(), D2;
  }
  intersectsRay(A2, I2, g2, C2) {
    let B2 = fA.intoRaw(I2), Q2 = XA.intoRaw(g2), E2 = fA.intoRaw(A2.origin), i2 = fA.intoRaw(A2.dir), D2 = this.intoRaw(), o2 = D2.intersectsRay(B2, Q2, E2, i2, C2);
    return B2.free(), Q2.free(), E2.free(), i2.free(), D2.free(), o2;
  }
  castRay(A2, I2, g2, C2, B2) {
    let Q2 = fA.intoRaw(I2), E2 = XA.intoRaw(g2), i2 = fA.intoRaw(A2.origin), D2 = fA.intoRaw(A2.dir), o2 = this.intoRaw(), S2 = o2.castRay(Q2, E2, i2, D2, C2, B2);
    return Q2.free(), E2.free(), i2.free(), D2.free(), o2.free(), S2;
  }
  castRayAndGetNormal(A2, I2, g2, C2, B2) {
    let Q2 = fA.intoRaw(I2), E2 = XA.intoRaw(g2), i2 = fA.intoRaw(A2.origin), D2 = fA.intoRaw(A2.dir), o2 = this.intoRaw(), S2 = mI.fromRaw(o2.castRayAndGetNormal(Q2, E2, i2, D2, C2, B2));
    return Q2.free(), E2.free(), i2.free(), D2.free(), o2.free(), S2;
  }
}
!(function(A2) {
  A2[A2.Ball = 0] = "Ball", A2[A2.Cuboid = 1] = "Cuboid", A2[A2.Capsule = 2] = "Capsule", A2[A2.Segment = 3] = "Segment", A2[A2.Polyline = 4] = "Polyline", A2[A2.Triangle = 5] = "Triangle", A2[A2.TriMesh = 6] = "TriMesh", A2[A2.HeightField = 7] = "HeightField", A2[A2.ConvexPolyhedron = 9] = "ConvexPolyhedron", A2[A2.Cylinder = 10] = "Cylinder", A2[A2.Cone = 11] = "Cone", A2[A2.RoundCuboid = 12] = "RoundCuboid", A2[A2.RoundTriangle = 13] = "RoundTriangle", A2[A2.RoundCylinder = 14] = "RoundCylinder", A2[A2.RoundCone = 15] = "RoundCone", A2[A2.RoundConvexPolyhedron = 16] = "RoundConvexPolyhedron", A2[A2.HalfSpace = 17] = "HalfSpace";
})(gI || (gI = {})), (function(A2) {
  A2[A2.FIX_INTERNAL_EDGES = 1] = "FIX_INTERNAL_EDGES";
})(CI || (CI = {})), (function(A2) {
  A2[A2.DELETE_BAD_TOPOLOGY_TRIANGLES = 4] = "DELETE_BAD_TOPOLOGY_TRIANGLES", A2[A2.ORIENTED = 8] = "ORIENTED", A2[A2.MERGE_DUPLICATE_VERTICES = 16] = "MERGE_DUPLICATE_VERTICES", A2[A2.DELETE_DEGENERATE_TRIANGLES = 32] = "DELETE_DEGENERATE_TRIANGLES", A2[A2.DELETE_DUPLICATE_TRIANGLES = 64] = "DELETE_DUPLICATE_TRIANGLES", A2[A2.FIX_INTERNAL_EDGES = 152] = "FIX_INTERNAL_EDGES";
})(BI || (BI = {}));
class uI extends PI {
  constructor(A2) {
    super(), this.type = gI.Ball, this.radius = A2;
  }
  intoRaw() {
    return dA.ball(this.radius);
  }
}
class vI extends PI {
  constructor(A2) {
    super(), this.type = gI.HalfSpace, this.normal = A2;
  }
  intoRaw() {
    let A2 = fA.intoRaw(this.normal), I2 = dA.halfspace(A2);
    return A2.free(), I2;
  }
}
class zI extends PI {
  constructor(A2, I2, g2) {
    super(), this.type = gI.Cuboid, this.halfExtents = fA.new(A2, I2, g2);
  }
  intoRaw() {
    return dA.cuboid(this.halfExtents.x, this.halfExtents.y, this.halfExtents.z);
  }
}
class _I extends PI {
  constructor(A2, I2, g2, C2) {
    super(), this.type = gI.RoundCuboid, this.halfExtents = fA.new(A2, I2, g2), this.borderRadius = C2;
  }
  intoRaw() {
    return dA.roundCuboid(this.halfExtents.x, this.halfExtents.y, this.halfExtents.z, this.borderRadius);
  }
}
class $I extends PI {
  constructor(A2, I2) {
    super(), this.type = gI.Capsule, this.halfHeight = A2, this.radius = I2;
  }
  intoRaw() {
    return dA.capsule(this.halfHeight, this.radius);
  }
}
class Ag extends PI {
  constructor(A2, I2) {
    super(), this.type = gI.Segment, this.a = A2, this.b = I2;
  }
  intoRaw() {
    let A2 = fA.intoRaw(this.a), I2 = fA.intoRaw(this.b), g2 = dA.segment(A2, I2);
    return A2.free(), I2.free(), g2;
  }
}
class Ig extends PI {
  constructor(A2, I2, g2) {
    super(), this.type = gI.Triangle, this.a = A2, this.b = I2, this.c = g2;
  }
  intoRaw() {
    let A2 = fA.intoRaw(this.a), I2 = fA.intoRaw(this.b), g2 = fA.intoRaw(this.c), C2 = dA.triangle(A2, I2, g2);
    return A2.free(), I2.free(), g2.free(), C2;
  }
}
class gg extends PI {
  constructor(A2, I2, g2, C2) {
    super(), this.type = gI.RoundTriangle, this.a = A2, this.b = I2, this.c = g2, this.borderRadius = C2;
  }
  intoRaw() {
    let A2 = fA.intoRaw(this.a), I2 = fA.intoRaw(this.b), g2 = fA.intoRaw(this.c), C2 = dA.roundTriangle(A2, I2, g2, this.borderRadius);
    return A2.free(), I2.free(), g2.free(), C2;
  }
}
class Cg extends PI {
  constructor(A2, I2) {
    super(), this.type = gI.Polyline, this.vertices = A2, this.indices = null != I2 ? I2 : new Uint32Array(0);
  }
  intoRaw() {
    return dA.polyline(this.vertices, this.indices);
  }
}
class Bg extends PI {
  constructor(A2, I2, g2) {
    super(), this.type = gI.TriMesh, this.vertices = A2, this.indices = I2, this.flags = g2;
  }
  intoRaw() {
    return dA.trimesh(this.vertices, this.indices, this.flags);
  }
}
class Qg extends PI {
  constructor(A2, I2) {
    super(), this.type = gI.ConvexPolyhedron, this.vertices = A2, this.indices = I2;
  }
  intoRaw() {
    return this.indices ? dA.convexMesh(this.vertices, this.indices) : dA.convexHull(this.vertices);
  }
}
class Eg extends PI {
  constructor(A2, I2, g2) {
    super(), this.type = gI.RoundConvexPolyhedron, this.vertices = A2, this.indices = I2, this.borderRadius = g2;
  }
  intoRaw() {
    return this.indices ? dA.roundConvexMesh(this.vertices, this.indices, this.borderRadius) : dA.roundConvexHull(this.vertices, this.borderRadius);
  }
}
class ig extends PI {
  constructor(A2, I2, g2, C2, B2) {
    super(), this.type = gI.HeightField, this.nrows = A2, this.ncols = I2, this.heights = g2, this.scale = C2, this.flags = B2;
  }
  intoRaw() {
    let A2 = fA.intoRaw(this.scale), I2 = dA.heightfield(this.nrows, this.ncols, this.heights, A2, this.flags);
    return A2.free(), I2;
  }
}
class Dg extends PI {
  constructor(A2, I2) {
    super(), this.type = gI.Cylinder, this.halfHeight = A2, this.radius = I2;
  }
  intoRaw() {
    return dA.cylinder(this.halfHeight, this.radius);
  }
}
class og extends PI {
  constructor(A2, I2, g2) {
    super(), this.type = gI.RoundCylinder, this.borderRadius = g2, this.halfHeight = A2, this.radius = I2;
  }
  intoRaw() {
    return dA.roundCylinder(this.halfHeight, this.radius, this.borderRadius);
  }
}
class Sg extends PI {
  constructor(A2, I2) {
    super(), this.type = gI.Cone, this.halfHeight = A2, this.radius = I2;
  }
  intoRaw() {
    return dA.cone(this.halfHeight, this.radius);
  }
}
class wg extends PI {
  constructor(A2, I2, g2) {
    super(), this.type = gI.RoundCone, this.halfHeight = A2, this.radius = I2, this.borderRadius = g2;
  }
  intoRaw() {
    return dA.roundCone(this.halfHeight, this.radius, this.borderRadius);
  }
}
class Gg {
  constructor(A2) {
    this.raw = A2 || new KA();
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  step(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2, S2, w2) {
    let G2 = fA.intoRaw(A2);
    S2 ? this.raw.stepWithEvents(G2, I2.raw, g2.raw, C2.raw, B2.raw, Q2.raw, E2.raw, i2.raw, D2.raw, o2.raw, S2.raw, w2, w2 ? w2.filterContactPair : null, w2 ? w2.filterIntersectionPair : null) : this.raw.step(G2, I2.raw, g2.raw, C2.raw, B2.raw, Q2.raw, E2.raw, i2.raw, D2.raw, o2.raw), G2.free();
  }
}
!(function(A2) {
  A2[A2.EXCLUDE_FIXED = 1] = "EXCLUDE_FIXED", A2[A2.EXCLUDE_KINEMATIC = 2] = "EXCLUDE_KINEMATIC", A2[A2.EXCLUDE_DYNAMIC = 4] = "EXCLUDE_DYNAMIC", A2[A2.EXCLUDE_SENSORS = 8] = "EXCLUDE_SENSORS", A2[A2.EXCLUDE_SOLIDS = 16] = "EXCLUDE_SOLIDS", A2[A2.ONLY_DYNAMIC = 3] = "ONLY_DYNAMIC", A2[A2.ONLY_KINEMATIC = 5] = "ONLY_KINEMATIC", A2[A2.ONLY_FIXED = 6] = "ONLY_FIXED";
})(QI || (QI = {}));
class kg {
  constructor(A2) {
    this.raw = A2 || new MA();
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  update(A2) {
    this.raw.update(A2.raw);
  }
  castRay(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2) {
    let S2 = fA.intoRaw(g2.origin), w2 = fA.intoRaw(g2.dir), G2 = fI.fromRaw(I2, this.raw.castRay(A2.raw, I2.raw, S2, w2, C2, B2, Q2, E2, i2, D2, o2));
    return S2.free(), w2.free(), G2;
  }
  castRayAndGetNormal(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2) {
    let S2 = fA.intoRaw(g2.origin), w2 = fA.intoRaw(g2.dir), G2 = jI.fromRaw(I2, this.raw.castRayAndGetNormal(A2.raw, I2.raw, S2, w2, C2, B2, Q2, E2, i2, D2, o2));
    return S2.free(), w2.free(), G2;
  }
  intersectionsWithRay(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2, S2) {
    let w2 = fA.intoRaw(g2.origin), G2 = fA.intoRaw(g2.dir);
    this.raw.intersectionsWithRay(A2.raw, I2.raw, w2, G2, C2, B2, ((A3) => Q2(jI.fromRaw(I2, A3))), E2, i2, D2, o2, S2), w2.free(), G2.free();
  }
  intersectionWithShape(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2) {
    let S2 = fA.intoRaw(g2), w2 = XA.intoRaw(C2), G2 = B2.intoRaw(), k2 = this.raw.intersectionWithShape(A2.raw, I2.raw, S2, w2, G2, Q2, E2, i2, D2, o2);
    return S2.free(), w2.free(), G2.free(), k2;
  }
  projectPoint(A2, I2, g2, C2, B2, Q2, E2, i2, D2) {
    let o2 = fA.intoRaw(g2), S2 = WI.fromRaw(I2, this.raw.projectPoint(A2.raw, I2.raw, o2, C2, B2, Q2, E2, i2, D2));
    return o2.free(), S2;
  }
  projectPointAndGetFeature(A2, I2, g2, C2, B2, Q2, E2, i2) {
    let D2 = fA.intoRaw(g2), o2 = WI.fromRaw(I2, this.raw.projectPointAndGetFeature(A2.raw, I2.raw, D2, C2, B2, Q2, E2, i2));
    return D2.free(), o2;
  }
  intersectionsWithPoint(A2, I2, g2, C2, B2, Q2, E2, i2, D2) {
    let o2 = fA.intoRaw(g2);
    this.raw.intersectionsWithPoint(A2.raw, I2.raw, o2, C2, B2, Q2, E2, i2, D2), o2.free();
  }
  castShape(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2, S2, w2, G2, k2) {
    let K2 = fA.intoRaw(g2), J2 = XA.intoRaw(C2), U2 = fA.intoRaw(B2), h2 = Q2.intoRaw(), y2 = XI.fromRaw(I2, this.raw.castShape(A2.raw, I2.raw, K2, J2, U2, h2, E2, i2, D2, o2, S2, w2, G2, k2));
    return K2.free(), J2.free(), U2.free(), h2.free(), y2;
  }
  intersectionsWithShape(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2, S2) {
    let w2 = fA.intoRaw(g2), G2 = XA.intoRaw(C2), k2 = B2.intoRaw();
    this.raw.intersectionsWithShape(A2.raw, I2.raw, w2, G2, k2, Q2, E2, i2, D2, o2, S2), w2.free(), G2.free(), k2.free();
  }
  collidersWithAabbIntersectingAabb(A2, I2, g2) {
    let C2 = fA.intoRaw(A2), B2 = fA.intoRaw(I2);
    this.raw.collidersWithAabbIntersectingAabb(C2, B2, g2), C2.free(), B2.free();
  }
}
class Kg {
  constructor(A2) {
    this.raw = A2 || new rA();
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  serializeAll(A2, I2, g2, C2, B2, Q2, E2, i2, D2) {
    let o2 = fA.intoRaw(A2);
    const S2 = this.raw.serializeAll(o2, I2.raw, g2.raw, C2.raw, B2.raw, Q2.raw, E2.raw, i2.raw, D2.raw);
    return o2.free(), S2;
  }
  deserializeAll(A2) {
    return Mg.fromRaw(this.raw.deserializeAll(A2));
  }
}
class Jg {
  constructor(A2, I2) {
    this.vertices = A2, this.colors = I2;
  }
}
class Ug {
  constructor(A2) {
    this.raw = A2 || new V$1();
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0, this.vertices = void 0, this.colors = void 0;
  }
  render(A2, I2, g2, C2, B2) {
    this.raw.render(A2.raw, I2.raw, g2.raw, C2.raw, B2.raw), this.vertices = this.raw.vertices(), this.colors = this.raw.colors();
  }
}
class hg {
}
class yg {
  constructor(A2, I2, g2, C2, B2) {
    this.params = I2, this.bodies = g2, this.colliders = C2, this.queries = B2, this.raw = new DA(A2), this.rawCharacterCollision = new r$1(), this._applyImpulsesToDynamicBodies = false, this._characterMass = null;
  }
  free() {
    this.raw && (this.raw.free(), this.rawCharacterCollision.free()), this.raw = void 0, this.rawCharacterCollision = void 0;
  }
  up() {
    return this.raw.up();
  }
  setUp(A2) {
    let I2 = fA.intoRaw(A2);
    return this.raw.setUp(I2);
  }
  applyImpulsesToDynamicBodies() {
    return this._applyImpulsesToDynamicBodies;
  }
  setApplyImpulsesToDynamicBodies(A2) {
    this._applyImpulsesToDynamicBodies = A2;
  }
  characterMass() {
    return this._characterMass;
  }
  setCharacterMass(A2) {
    this._characterMass = A2;
  }
  offset() {
    return this.raw.offset();
  }
  setOffset(A2) {
    this.raw.setOffset(A2);
  }
  normalNudgeFactor() {
    return this.raw.normalNudgeFactor();
  }
  setNormalNudgeFactor(A2) {
    this.raw.setNormalNudgeFactor(A2);
  }
  slideEnabled() {
    return this.raw.slideEnabled();
  }
  setSlideEnabled(A2) {
    this.raw.setSlideEnabled(A2);
  }
  autostepMaxHeight() {
    return this.raw.autostepMaxHeight();
  }
  autostepMinWidth() {
    return this.raw.autostepMinWidth();
  }
  autostepIncludesDynamicBodies() {
    return this.raw.autostepIncludesDynamicBodies();
  }
  autostepEnabled() {
    return this.raw.autostepEnabled();
  }
  enableAutostep(A2, I2, g2) {
    this.raw.enableAutostep(A2, I2, g2);
  }
  disableAutostep() {
    return this.raw.disableAutostep();
  }
  maxSlopeClimbAngle() {
    return this.raw.maxSlopeClimbAngle();
  }
  setMaxSlopeClimbAngle(A2) {
    this.raw.setMaxSlopeClimbAngle(A2);
  }
  minSlopeSlideAngle() {
    return this.raw.minSlopeSlideAngle();
  }
  setMinSlopeSlideAngle(A2) {
    this.raw.setMinSlopeSlideAngle(A2);
  }
  snapToGroundDistance() {
    return this.raw.snapToGroundDistance();
  }
  enableSnapToGround(A2) {
    this.raw.enableSnapToGround(A2);
  }
  disableSnapToGround() {
    this.raw.disableSnapToGround();
  }
  snapToGroundEnabled() {
    return this.raw.snapToGroundEnabled();
  }
  computeColliderMovement(A2, I2, g2, C2, B2) {
    let Q2 = fA.intoRaw(I2);
    this.raw.computeColliderMovement(this.params.dt, this.bodies.raw, this.colliders.raw, this.queries.raw, A2.handle, Q2, this._applyImpulsesToDynamicBodies, this._characterMass, g2, C2, this.colliders.castClosure(B2)), Q2.free();
  }
  computedMovement() {
    return fA.fromRaw(this.raw.computedMovement());
  }
  computedGrounded() {
    return this.raw.computedGrounded();
  }
  numComputedCollisions() {
    return this.raw.numComputedCollisions();
  }
  computedCollision(A2, I2) {
    if (this.raw.computedCollision(A2, this.rawCharacterCollision)) {
      let A3 = this.rawCharacterCollision;
      return (I2 = null != I2 ? I2 : new hg()).translationDeltaApplied = fA.fromRaw(A3.translationDeltaApplied()), I2.translationDeltaRemaining = fA.fromRaw(A3.translationDeltaRemaining()), I2.toi = A3.toi(), I2.witness1 = fA.fromRaw(A3.worldWitness1()), I2.witness2 = fA.fromRaw(A3.worldWitness2()), I2.normal1 = fA.fromRaw(A3.worldNormal1()), I2.normal2 = fA.fromRaw(A3.worldNormal2()), I2.collider = this.colliders.get(A3.handle()), I2;
    }
    return null;
  }
}
class Ng {
  constructor(A2, I2, g2, C2) {
    this.raw = new v$1(A2.handle), this.bodies = I2, this.colliders = g2, this.queries = C2, this._chassis = A2;
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  updateVehicle(A2, I2, g2, C2) {
    this.raw.update_vehicle(A2, this.bodies.raw, this.colliders.raw, this.queries.raw, I2, g2, this.colliders.castClosure(C2));
  }
  currentVehicleSpeed() {
    return this.raw.current_vehicle_speed();
  }
  chassis() {
    return this._chassis;
  }
  get indexUpAxis() {
    return this.raw.index_up_axis();
  }
  set indexUpAxis(A2) {
    this.raw.set_index_up_axis(A2);
  }
  get indexForwardAxis() {
    return this.raw.index_forward_axis();
  }
  set setIndexForwardAxis(A2) {
    this.raw.set_index_forward_axis(A2);
  }
  addWheel(A2, I2, g2, C2, B2) {
    let Q2 = fA.intoRaw(A2), E2 = fA.intoRaw(I2), i2 = fA.intoRaw(g2);
    this.raw.add_wheel(Q2, E2, i2, C2, B2), Q2.free(), E2.free(), i2.free();
  }
  numWheels() {
    return this.raw.num_wheels();
  }
  wheelChassisConnectionPointCs(A2) {
    return fA.fromRaw(this.raw.wheel_chassis_connection_point_cs(A2));
  }
  setWheelChassisConnectionPointCs(A2, I2) {
    let g2 = fA.intoRaw(I2);
    this.raw.set_wheel_chassis_connection_point_cs(A2, g2), g2.free();
  }
  wheelSuspensionRestLength(A2) {
    return this.raw.wheel_suspension_rest_length(A2);
  }
  setWheelSuspensionRestLength(A2, I2) {
    this.raw.set_wheel_suspension_rest_length(A2, I2);
  }
  wheelMaxSuspensionTravel(A2) {
    return this.raw.wheel_max_suspension_travel(A2);
  }
  setWheelMaxSuspensionTravel(A2, I2) {
    this.raw.set_wheel_max_suspension_travel(A2, I2);
  }
  wheelRadius(A2) {
    return this.raw.wheel_radius(A2);
  }
  setWheelRadius(A2, I2) {
    this.raw.set_wheel_radius(A2, I2);
  }
  wheelSuspensionStiffness(A2) {
    return this.raw.wheel_suspension_stiffness(A2);
  }
  setWheelSuspensionStiffness(A2, I2) {
    this.raw.set_wheel_suspension_stiffness(A2, I2);
  }
  wheelSuspensionCompression(A2) {
    return this.raw.wheel_suspension_compression(A2);
  }
  setWheelSuspensionCompression(A2, I2) {
    this.raw.set_wheel_suspension_compression(A2, I2);
  }
  wheelSuspensionRelaxation(A2) {
    return this.raw.wheel_suspension_relaxation(A2);
  }
  setWheelSuspensionRelaxation(A2, I2) {
    this.raw.set_wheel_suspension_relaxation(A2, I2);
  }
  wheelMaxSuspensionForce(A2) {
    return this.raw.wheel_max_suspension_force(A2);
  }
  setWheelMaxSuspensionForce(A2, I2) {
    this.raw.set_wheel_max_suspension_force(A2, I2);
  }
  wheelBrake(A2) {
    return this.raw.wheel_brake(A2);
  }
  setWheelBrake(A2, I2) {
    this.raw.set_wheel_brake(A2, I2);
  }
  wheelSteering(A2) {
    return this.raw.wheel_steering(A2);
  }
  setWheelSteering(A2, I2) {
    this.raw.set_wheel_steering(A2, I2);
  }
  wheelEngineForce(A2) {
    return this.raw.wheel_engine_force(A2);
  }
  setWheelEngineForce(A2, I2) {
    this.raw.set_wheel_engine_force(A2, I2);
  }
  wheelDirectionCs(A2) {
    return fA.fromRaw(this.raw.wheel_direction_cs(A2));
  }
  setWheelDirectionCs(A2, I2) {
    let g2 = fA.intoRaw(I2);
    this.raw.set_wheel_direction_cs(A2, g2), g2.free();
  }
  wheelAxleCs(A2) {
    return fA.fromRaw(this.raw.wheel_axle_cs(A2));
  }
  setWheelAxleCs(A2, I2) {
    let g2 = fA.intoRaw(I2);
    this.raw.set_wheel_axle_cs(A2, g2), g2.free();
  }
  wheelFrictionSlip(A2) {
    return this.raw.wheel_friction_slip(A2);
  }
  setWheelFrictionSlip(A2, I2) {
    this.raw.set_wheel_friction_slip(A2, I2);
  }
  wheelSideFrictionStiffness(A2) {
    return this.raw.wheel_side_friction_stiffness(A2);
  }
  setWheelSideFrictionStiffness(A2, I2) {
    this.raw.set_wheel_side_friction_stiffness(A2, I2);
  }
  wheelRotation(A2) {
    return this.raw.wheel_rotation(A2);
  }
  wheelForwardImpulse(A2) {
    return this.raw.wheel_forward_impulse(A2);
  }
  wheelSideImpulse(A2) {
    return this.raw.wheel_side_impulse(A2);
  }
  wheelSuspensionForce(A2) {
    return this.raw.wheel_suspension_force(A2);
  }
  wheelContactNormal(A2) {
    return fA.fromRaw(this.raw.wheel_contact_normal_ws(A2));
  }
  wheelContactPoint(A2) {
    return fA.fromRaw(this.raw.wheel_contact_point_ws(A2));
  }
  wheelSuspensionLength(A2) {
    return this.raw.wheel_suspension_length(A2);
  }
  wheelHardPoint(A2) {
    return fA.fromRaw(this.raw.wheel_hard_point_ws(A2));
  }
  wheelIsInContact(A2) {
    return this.raw.wheel_is_in_contact(A2);
  }
  wheelGroundObject(A2) {
    return this.colliders.get(this.raw.wheel_ground_object(A2));
  }
}
class Mg {
  constructor(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2, S2, w2, G2, k2) {
    this.gravity = A2, this.integrationParameters = new JI(I2), this.islands = new nI(g2), this.broadPhase = new dI(C2), this.narrowPhase = new TI(B2), this.bodies = new KI(Q2), this.colliders = new cg(E2), this.impulseJoints = new qI(i2), this.multibodyJoints = new eI(D2), this.ccdSolver = new rI(o2), this.queryPipeline = new kg(S2), this.physicsPipeline = new Gg(w2), this.serializationPipeline = new Kg(G2), this.debugRenderPipeline = new Ug(k2), this.characterControllers = /* @__PURE__ */ new Set(), this.vehicleControllers = /* @__PURE__ */ new Set(), this.impulseJoints.finalizeDeserialization(this.bodies), this.bodies.finalizeDeserialization(this.colliders), this.colliders.finalizeDeserialization(this.bodies);
  }
  free() {
    this.integrationParameters.free(), this.islands.free(), this.broadPhase.free(), this.narrowPhase.free(), this.bodies.free(), this.colliders.free(), this.impulseJoints.free(), this.multibodyJoints.free(), this.ccdSolver.free(), this.queryPipeline.free(), this.physicsPipeline.free(), this.serializationPipeline.free(), this.debugRenderPipeline.free(), this.characterControllers.forEach(((A2) => A2.free())), this.vehicleControllers.forEach(((A2) => A2.free())), this.integrationParameters = void 0, this.islands = void 0, this.broadPhase = void 0, this.narrowPhase = void 0, this.bodies = void 0, this.colliders = void 0, this.ccdSolver = void 0, this.impulseJoints = void 0, this.multibodyJoints = void 0, this.queryPipeline = void 0, this.physicsPipeline = void 0, this.serializationPipeline = void 0, this.debugRenderPipeline = void 0, this.characterControllers = void 0, this.vehicleControllers = void 0;
  }
  static fromRaw(A2) {
    return A2 ? new Mg(fA.fromRaw(A2.takeGravity()), A2.takeIntegrationParameters(), A2.takeIslandManager(), A2.takeBroadPhase(), A2.takeNarrowPhase(), A2.takeBodies(), A2.takeColliders(), A2.takeImpulseJoints(), A2.takeMultibodyJoints()) : null;
  }
  takeSnapshot() {
    return this.serializationPipeline.serializeAll(this.gravity, this.integrationParameters, this.islands, this.broadPhase, this.narrowPhase, this.bodies, this.colliders, this.impulseJoints, this.multibodyJoints);
  }
  static restoreSnapshot(A2) {
    return new Kg().deserializeAll(A2);
  }
  debugRender() {
    return this.debugRenderPipeline.render(this.bodies, this.colliders, this.impulseJoints, this.multibodyJoints, this.narrowPhase), new Jg(this.debugRenderPipeline.vertices, this.debugRenderPipeline.colors);
  }
  step(A2, I2) {
    this.physicsPipeline.step(this.gravity, this.integrationParameters, this.islands, this.broadPhase, this.narrowPhase, this.bodies, this.colliders, this.impulseJoints, this.multibodyJoints, this.ccdSolver, A2, I2), this.queryPipeline.update(this.colliders);
  }
  propagateModifiedBodyPositionsToColliders() {
    this.bodies.raw.propagateModifiedBodyPositionsToColliders(this.colliders.raw);
  }
  updateSceneQueries() {
    this.propagateModifiedBodyPositionsToColliders(), this.queryPipeline.update(this.colliders);
  }
  get timestep() {
    return this.integrationParameters.dt;
  }
  set timestep(A2) {
    this.integrationParameters.dt = A2;
  }
  get lengthUnit() {
    return this.integrationParameters.lengthUnit;
  }
  set lengthUnit(A2) {
    this.integrationParameters.lengthUnit = A2;
  }
  get numSolverIterations() {
    return this.integrationParameters.numSolverIterations;
  }
  set numSolverIterations(A2) {
    this.integrationParameters.numSolverIterations = A2;
  }
  get numAdditionalFrictionIterations() {
    return this.integrationParameters.numAdditionalFrictionIterations;
  }
  set numAdditionalFrictionIterations(A2) {
    this.integrationParameters.numAdditionalFrictionIterations = A2;
  }
  get numInternalPgsIterations() {
    return this.integrationParameters.numInternalPgsIterations;
  }
  set numInternalPgsIterations(A2) {
    this.integrationParameters.numInternalPgsIterations = A2;
  }
  switchToStandardPgsSolver() {
    this.integrationParameters.switchToStandardPgsSolver();
  }
  switchToSmallStepsPgsSolver() {
    this.integrationParameters.switchToSmallStepsPgsSolver();
  }
  switchToSmallStepsPgsSolverWithoutWarmstart() {
    this.integrationParameters.switchToSmallStepsPgsSolverWithoutWarmstart();
  }
  createRigidBody(A2) {
    return this.bodies.createRigidBody(this.colliders, A2);
  }
  createCharacterController(A2) {
    let I2 = new yg(A2, this.integrationParameters, this.bodies, this.colliders, this.queryPipeline);
    return this.characterControllers.add(I2), I2;
  }
  removeCharacterController(A2) {
    this.characterControllers.delete(A2), A2.free();
  }
  createVehicleController(A2) {
    let I2 = new Ng(A2, this.bodies, this.colliders, this.queryPipeline);
    return this.vehicleControllers.add(I2), I2;
  }
  removeVehicleController(A2) {
    this.vehicleControllers.delete(A2), A2.free();
  }
  createCollider(A2, I2) {
    let g2 = I2 ? I2.handle : void 0;
    return this.colliders.createCollider(this.bodies, A2, g2);
  }
  createImpulseJoint(A2, I2, g2, C2) {
    return this.impulseJoints.createJoint(this.bodies, A2, I2.handle, g2.handle, C2);
  }
  createMultibodyJoint(A2, I2, g2, C2) {
    return this.multibodyJoints.createJoint(A2, I2.handle, g2.handle, C2);
  }
  getRigidBody(A2) {
    return this.bodies.get(A2);
  }
  getCollider(A2) {
    return this.colliders.get(A2);
  }
  getImpulseJoint(A2) {
    return this.impulseJoints.get(A2);
  }
  getMultibodyJoint(A2) {
    return this.multibodyJoints.get(A2);
  }
  removeRigidBody(A2) {
    this.bodies && this.bodies.remove(A2.handle, this.islands, this.colliders, this.impulseJoints, this.multibodyJoints);
  }
  removeCollider(A2, I2) {
    this.colliders && this.colliders.remove(A2.handle, this.islands, this.bodies, I2);
  }
  removeImpulseJoint(A2, I2) {
    this.impulseJoints && this.impulseJoints.remove(A2.handle, I2);
  }
  removeMultibodyJoint(A2, I2) {
    this.impulseJoints && this.multibodyJoints.remove(A2.handle, I2);
  }
  forEachCollider(A2) {
    this.colliders.forEach(A2);
  }
  forEachRigidBody(A2) {
    this.bodies.forEach(A2);
  }
  forEachActiveRigidBody(A2) {
    this.bodies.forEachActiveRigidBody(this.islands, A2);
  }
  castRay(A2, I2, g2, C2, B2, Q2, E2, i2) {
    return this.queryPipeline.castRay(this.bodies, this.colliders, A2, I2, g2, C2, B2, Q2 ? Q2.handle : null, E2 ? E2.handle : null, this.colliders.castClosure(i2));
  }
  castRayAndGetNormal(A2, I2, g2, C2, B2, Q2, E2, i2) {
    return this.queryPipeline.castRayAndGetNormal(this.bodies, this.colliders, A2, I2, g2, C2, B2, Q2 ? Q2.handle : null, E2 ? E2.handle : null, this.colliders.castClosure(i2));
  }
  intersectionsWithRay(A2, I2, g2, C2, B2, Q2, E2, i2, D2) {
    this.queryPipeline.intersectionsWithRay(this.bodies, this.colliders, A2, I2, g2, C2, B2, Q2, E2 ? E2.handle : null, i2 ? i2.handle : null, this.colliders.castClosure(D2));
  }
  intersectionWithShape(A2, I2, g2, C2, B2, Q2, E2, i2) {
    let D2 = this.queryPipeline.intersectionWithShape(this.bodies, this.colliders, A2, I2, g2, C2, B2, Q2 ? Q2.handle : null, E2 ? E2.handle : null, this.colliders.castClosure(i2));
    return null != D2 ? this.colliders.get(D2) : null;
  }
  projectPoint(A2, I2, g2, C2, B2, Q2, E2) {
    return this.queryPipeline.projectPoint(this.bodies, this.colliders, A2, I2, g2, C2, B2 ? B2.handle : null, Q2 ? Q2.handle : null, this.colliders.castClosure(E2));
  }
  projectPointAndGetFeature(A2, I2, g2, C2, B2, Q2) {
    return this.queryPipeline.projectPointAndGetFeature(this.bodies, this.colliders, A2, I2, g2, C2 ? C2.handle : null, B2 ? B2.handle : null, this.colliders.castClosure(Q2));
  }
  intersectionsWithPoint(A2, I2, g2, C2, B2, Q2, E2) {
    this.queryPipeline.intersectionsWithPoint(this.bodies, this.colliders, A2, this.colliders.castClosure(I2), g2, C2, B2 ? B2.handle : null, Q2 ? Q2.handle : null, this.colliders.castClosure(E2));
  }
  castShape(A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2, S2, w2) {
    return this.queryPipeline.castShape(this.bodies, this.colliders, A2, I2, g2, C2, B2, Q2, E2, i2, D2, o2 ? o2.handle : null, S2 ? S2.handle : null, this.colliders.castClosure(w2));
  }
  intersectionsWithShape(A2, I2, g2, C2, B2, Q2, E2, i2, D2) {
    this.queryPipeline.intersectionsWithShape(this.bodies, this.colliders, A2, I2, g2, this.colliders.castClosure(C2), B2, Q2, E2 ? E2.handle : null, i2 ? i2.handle : null, this.colliders.castClosure(D2));
  }
  collidersWithAabbIntersectingAabb(A2, I2, g2) {
    this.queryPipeline.collidersWithAabbIntersectingAabb(A2, I2, this.colliders.castClosure(g2));
  }
  contactPairsWith(A2, I2) {
    this.narrowPhase.contactPairsWith(A2.handle, this.colliders.castClosure(I2));
  }
  intersectionPairsWith(A2, I2) {
    this.narrowPhase.intersectionPairsWith(A2.handle, this.colliders.castClosure(I2));
  }
  contactPair(A2, I2, g2) {
    this.narrowPhase.contactPair(A2.handle, I2.handle, g2);
  }
  intersectionPair(A2, I2) {
    return this.narrowPhase.intersectionPair(A2.handle, I2.handle);
  }
}
!(function(A2) {
  A2[A2.NONE = 0] = "NONE", A2[A2.COLLISION_EVENTS = 1] = "COLLISION_EVENTS", A2[A2.CONTACT_FORCE_EVENTS = 2] = "CONTACT_FORCE_EVENTS";
})(EI || (EI = {}));
class Fg {
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  collider1() {
    return this.raw.collider1();
  }
  collider2() {
    return this.raw.collider2();
  }
  totalForce() {
    return fA.fromRaw(this.raw.total_force());
  }
  totalForceMagnitude() {
    return this.raw.total_force_magnitude();
  }
  maxForceDirection() {
    return fA.fromRaw(this.raw.max_force_direction());
  }
  maxForceMagnitude() {
    return this.raw.max_force_magnitude();
  }
}
class ag {
  constructor(A2, I2) {
    this.raw = I2 || new _(A2);
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0;
  }
  drainCollisionEvents(A2) {
    this.raw.drainCollisionEvents(A2);
  }
  drainContactForceEvents(A2) {
    let I2 = new Fg();
    this.raw.drainContactForceEvents(((g2) => {
      I2.raw = g2, A2(I2), I2.free();
    }));
  }
  clear() {
    this.raw.clear();
  }
}
!(function(A2) {
  A2[A2.NONE = 0] = "NONE", A2[A2.FILTER_CONTACT_PAIRS = 1] = "FILTER_CONTACT_PAIRS", A2[A2.FILTER_INTERSECTION_PAIRS = 2] = "FILTER_INTERSECTION_PAIRS";
})(iI || (iI = {})), (function(A2) {
  A2[A2.EMPTY = 0] = "EMPTY", A2[A2.COMPUTE_IMPULSE = 1] = "COMPUTE_IMPULSE";
})(DI || (DI = {})), (function(A2) {
  A2[A2.DYNAMIC_DYNAMIC = 1] = "DYNAMIC_DYNAMIC", A2[A2.DYNAMIC_KINEMATIC = 12] = "DYNAMIC_KINEMATIC", A2[A2.DYNAMIC_FIXED = 2] = "DYNAMIC_FIXED", A2[A2.KINEMATIC_KINEMATIC = 52224] = "KINEMATIC_KINEMATIC", A2[A2.KINEMATIC_FIXED = 8704] = "KINEMATIC_FIXED", A2[A2.FIXED_FIXED = 32] = "FIXED_FIXED", A2[A2.DEFAULT = 15] = "DEFAULT", A2[A2.ALL = 60943] = "ALL";
})(oI || (oI = {}));
class sg {
  constructor(A2, I2, g2, C2) {
    this.colliderSet = A2, this.handle = I2, this._parent = g2, this._shape = C2;
  }
  finalizeDeserialization(A2) {
    null != this.handle && (this._parent = A2.get(this.colliderSet.raw.coParent(this.handle)));
  }
  ensureShapeIsCached() {
    this._shape || (this._shape = PI.fromRaw(this.colliderSet.raw, this.handle));
  }
  get shape() {
    return this.ensureShapeIsCached(), this._shape;
  }
  isValid() {
    return this.colliderSet.raw.contains(this.handle);
  }
  translation() {
    return fA.fromRaw(this.colliderSet.raw.coTranslation(this.handle));
  }
  rotation() {
    return XA.fromRaw(this.colliderSet.raw.coRotation(this.handle));
  }
  isSensor() {
    return this.colliderSet.raw.coIsSensor(this.handle);
  }
  setSensor(A2) {
    this.colliderSet.raw.coSetSensor(this.handle, A2);
  }
  setShape(A2) {
    let I2 = A2.intoRaw();
    this.colliderSet.raw.coSetShape(this.handle, I2), I2.free(), this._shape = A2;
  }
  setEnabled(A2) {
    this.colliderSet.raw.coSetEnabled(this.handle, A2);
  }
  isEnabled() {
    return this.colliderSet.raw.coIsEnabled(this.handle);
  }
  setRestitution(A2) {
    this.colliderSet.raw.coSetRestitution(this.handle, A2);
  }
  setFriction(A2) {
    this.colliderSet.raw.coSetFriction(this.handle, A2);
  }
  frictionCombineRule() {
    return this.colliderSet.raw.coFrictionCombineRule(this.handle);
  }
  setFrictionCombineRule(A2) {
    this.colliderSet.raw.coSetFrictionCombineRule(this.handle, A2);
  }
  restitutionCombineRule() {
    return this.colliderSet.raw.coRestitutionCombineRule(this.handle);
  }
  setRestitutionCombineRule(A2) {
    this.colliderSet.raw.coSetRestitutionCombineRule(this.handle, A2);
  }
  setCollisionGroups(A2) {
    this.colliderSet.raw.coSetCollisionGroups(this.handle, A2);
  }
  setSolverGroups(A2) {
    this.colliderSet.raw.coSetSolverGroups(this.handle, A2);
  }
  contactSkin() {
    return this.colliderSet.raw.coContactSkin(this.handle);
  }
  setContactSkin(A2) {
    return this.colliderSet.raw.coSetContactSkin(this.handle, A2);
  }
  activeHooks() {
    return this.colliderSet.raw.coActiveHooks(this.handle);
  }
  setActiveHooks(A2) {
    this.colliderSet.raw.coSetActiveHooks(this.handle, A2);
  }
  activeEvents() {
    return this.colliderSet.raw.coActiveEvents(this.handle);
  }
  setActiveEvents(A2) {
    this.colliderSet.raw.coSetActiveEvents(this.handle, A2);
  }
  activeCollisionTypes() {
    return this.colliderSet.raw.coActiveCollisionTypes(this.handle);
  }
  setContactForceEventThreshold(A2) {
    return this.colliderSet.raw.coSetContactForceEventThreshold(this.handle, A2);
  }
  contactForceEventThreshold() {
    return this.colliderSet.raw.coContactForceEventThreshold(this.handle);
  }
  setActiveCollisionTypes(A2) {
    this.colliderSet.raw.coSetActiveCollisionTypes(this.handle, A2);
  }
  setDensity(A2) {
    this.colliderSet.raw.coSetDensity(this.handle, A2);
  }
  setMass(A2) {
    this.colliderSet.raw.coSetMass(this.handle, A2);
  }
  setMassProperties(A2, I2, g2, C2) {
    let B2 = fA.intoRaw(I2), Q2 = fA.intoRaw(g2), E2 = XA.intoRaw(C2);
    this.colliderSet.raw.coSetMassProperties(this.handle, A2, B2, Q2, E2), B2.free(), Q2.free(), E2.free();
  }
  setTranslation(A2) {
    this.colliderSet.raw.coSetTranslation(this.handle, A2.x, A2.y, A2.z);
  }
  setTranslationWrtParent(A2) {
    this.colliderSet.raw.coSetTranslationWrtParent(this.handle, A2.x, A2.y, A2.z);
  }
  setRotation(A2) {
    this.colliderSet.raw.coSetRotation(this.handle, A2.x, A2.y, A2.z, A2.w);
  }
  setRotationWrtParent(A2) {
    this.colliderSet.raw.coSetRotationWrtParent(this.handle, A2.x, A2.y, A2.z, A2.w);
  }
  shapeType() {
    return this.colliderSet.raw.coShapeType(this.handle);
  }
  halfExtents() {
    return fA.fromRaw(this.colliderSet.raw.coHalfExtents(this.handle));
  }
  setHalfExtents(A2) {
    const I2 = fA.intoRaw(A2);
    this.colliderSet.raw.coSetHalfExtents(this.handle, I2);
  }
  radius() {
    return this.colliderSet.raw.coRadius(this.handle);
  }
  setRadius(A2) {
    this.colliderSet.raw.coSetRadius(this.handle, A2);
  }
  roundRadius() {
    return this.colliderSet.raw.coRoundRadius(this.handle);
  }
  setRoundRadius(A2) {
    this.colliderSet.raw.coSetRoundRadius(this.handle, A2);
  }
  halfHeight() {
    return this.colliderSet.raw.coHalfHeight(this.handle);
  }
  setHalfHeight(A2) {
    this.colliderSet.raw.coSetHalfHeight(this.handle, A2);
  }
  vertices() {
    return this.colliderSet.raw.coVertices(this.handle);
  }
  indices() {
    return this.colliderSet.raw.coIndices(this.handle);
  }
  heightfieldHeights() {
    return this.colliderSet.raw.coHeightfieldHeights(this.handle);
  }
  heightfieldScale() {
    let A2 = this.colliderSet.raw.coHeightfieldScale(this.handle);
    return fA.fromRaw(A2);
  }
  heightfieldNRows() {
    return this.colliderSet.raw.coHeightfieldNRows(this.handle);
  }
  heightfieldNCols() {
    return this.colliderSet.raw.coHeightfieldNCols(this.handle);
  }
  parent() {
    return this._parent;
  }
  friction() {
    return this.colliderSet.raw.coFriction(this.handle);
  }
  restitution() {
    return this.colliderSet.raw.coRestitution(this.handle);
  }
  density() {
    return this.colliderSet.raw.coDensity(this.handle);
  }
  mass() {
    return this.colliderSet.raw.coMass(this.handle);
  }
  volume() {
    return this.colliderSet.raw.coVolume(this.handle);
  }
  collisionGroups() {
    return this.colliderSet.raw.coCollisionGroups(this.handle);
  }
  solverGroups() {
    return this.colliderSet.raw.coSolverGroups(this.handle);
  }
  containsPoint(A2) {
    let I2 = fA.intoRaw(A2), g2 = this.colliderSet.raw.coContainsPoint(this.handle, I2);
    return I2.free(), g2;
  }
  projectPoint(A2, I2) {
    let g2 = fA.intoRaw(A2), C2 = bI.fromRaw(this.colliderSet.raw.coProjectPoint(this.handle, g2, I2));
    return g2.free(), C2;
  }
  intersectsRay(A2, I2) {
    let g2 = fA.intoRaw(A2.origin), C2 = fA.intoRaw(A2.dir), B2 = this.colliderSet.raw.coIntersectsRay(this.handle, g2, C2, I2);
    return g2.free(), C2.free(), B2;
  }
  castShape(A2, I2, g2, C2, B2, Q2, E2, i2) {
    let D2 = fA.intoRaw(A2), o2 = fA.intoRaw(g2), S2 = XA.intoRaw(C2), w2 = fA.intoRaw(B2), G2 = I2.intoRaw(), k2 = VI.fromRaw(this.colliderSet, this.colliderSet.raw.coCastShape(this.handle, D2, G2, o2, S2, w2, Q2, E2, i2));
    return D2.free(), o2.free(), S2.free(), w2.free(), G2.free(), k2;
  }
  castCollider(A2, I2, g2, C2, B2, Q2) {
    let E2 = fA.intoRaw(A2), i2 = fA.intoRaw(g2), D2 = XI.fromRaw(this.colliderSet, this.colliderSet.raw.coCastCollider(this.handle, E2, I2.handle, i2, C2, B2, Q2));
    return E2.free(), i2.free(), D2;
  }
  intersectsShape(A2, I2, g2) {
    let C2 = fA.intoRaw(I2), B2 = XA.intoRaw(g2), Q2 = A2.intoRaw(), E2 = this.colliderSet.raw.coIntersectsShape(this.handle, Q2, C2, B2);
    return C2.free(), B2.free(), Q2.free(), E2;
  }
  contactShape(A2, I2, g2, C2) {
    let B2 = fA.intoRaw(I2), Q2 = XA.intoRaw(g2), E2 = A2.intoRaw(), i2 = ZI.fromRaw(this.colliderSet.raw.coContactShape(this.handle, E2, B2, Q2, C2));
    return B2.free(), Q2.free(), E2.free(), i2;
  }
  contactCollider(A2, I2) {
    return ZI.fromRaw(this.colliderSet.raw.coContactCollider(this.handle, A2.handle, I2));
  }
  castRay(A2, I2, g2) {
    let C2 = fA.intoRaw(A2.origin), B2 = fA.intoRaw(A2.dir), Q2 = this.colliderSet.raw.coCastRay(this.handle, C2, B2, I2, g2);
    return C2.free(), B2.free(), Q2;
  }
  castRayAndGetNormal(A2, I2, g2) {
    let C2 = fA.intoRaw(A2.origin), B2 = fA.intoRaw(A2.dir), Q2 = mI.fromRaw(this.colliderSet.raw.coCastRayAndGetNormal(this.handle, C2, B2, I2, g2));
    return C2.free(), B2.free(), Q2;
  }
}
!(function(A2) {
  A2[A2.Density = 0] = "Density", A2[A2.Mass = 1] = "Mass", A2[A2.MassProps = 2] = "MassProps";
})(SI || (SI = {}));
class Rg {
  constructor(A2) {
    this.enabled = true, this.shape = A2, this.massPropsMode = SI.Density, this.density = 1, this.friction = 0.5, this.restitution = 0, this.rotation = XA.identity(), this.translation = fA.zeros(), this.isSensor = false, this.collisionGroups = 4294967295, this.solverGroups = 4294967295, this.frictionCombineRule = AI.Average, this.restitutionCombineRule = AI.Average, this.activeCollisionTypes = oI.DEFAULT, this.activeEvents = EI.NONE, this.activeHooks = iI.NONE, this.mass = 0, this.centerOfMass = fA.zeros(), this.contactForceEventThreshold = 0, this.contactSkin = 0, this.principalAngularInertia = fA.zeros(), this.angularInertiaLocalFrame = XA.identity();
  }
  static ball(A2) {
    const I2 = new uI(A2);
    return new Rg(I2);
  }
  static capsule(A2, I2) {
    const g2 = new $I(A2, I2);
    return new Rg(g2);
  }
  static segment(A2, I2) {
    const g2 = new Ag(A2, I2);
    return new Rg(g2);
  }
  static triangle(A2, I2, g2) {
    const C2 = new Ig(A2, I2, g2);
    return new Rg(C2);
  }
  static roundTriangle(A2, I2, g2, C2) {
    const B2 = new gg(A2, I2, g2, C2);
    return new Rg(B2);
  }
  static polyline(A2, I2) {
    const g2 = new Cg(A2, I2);
    return new Rg(g2);
  }
  static trimesh(A2, I2, g2) {
    const C2 = new Bg(A2, I2, g2);
    return new Rg(C2);
  }
  static cuboid(A2, I2, g2) {
    const C2 = new zI(A2, I2, g2);
    return new Rg(C2);
  }
  static roundCuboid(A2, I2, g2, C2) {
    const B2 = new _I(A2, I2, g2, C2);
    return new Rg(B2);
  }
  static heightfield(A2, I2, g2, C2, B2) {
    const Q2 = new ig(A2, I2, g2, C2, B2);
    return new Rg(Q2);
  }
  static cylinder(A2, I2) {
    const g2 = new Dg(A2, I2);
    return new Rg(g2);
  }
  static roundCylinder(A2, I2, g2) {
    const C2 = new og(A2, I2, g2);
    return new Rg(C2);
  }
  static cone(A2, I2) {
    const g2 = new Sg(A2, I2);
    return new Rg(g2);
  }
  static roundCone(A2, I2, g2) {
    const C2 = new wg(A2, I2, g2);
    return new Rg(C2);
  }
  static convexHull(A2) {
    const I2 = new Qg(A2, null);
    return new Rg(I2);
  }
  static convexMesh(A2, I2) {
    const g2 = new Qg(A2, I2);
    return new Rg(g2);
  }
  static roundConvexHull(A2, I2) {
    const g2 = new Eg(A2, null, I2);
    return new Rg(g2);
  }
  static roundConvexMesh(A2, I2, g2) {
    const C2 = new Eg(A2, I2, g2);
    return new Rg(C2);
  }
  setTranslation(A2, I2, g2) {
    if ("number" != typeof A2 || "number" != typeof I2 || "number" != typeof g2) throw TypeError("The translation components must be numbers.");
    return this.translation = { x: A2, y: I2, z: g2 }, this;
  }
  setRotation(A2) {
    return XA.copy(this.rotation, A2), this;
  }
  setSensor(A2) {
    return this.isSensor = A2, this;
  }
  setEnabled(A2) {
    return this.enabled = A2, this;
  }
  setContactSkin(A2) {
    return this.contactSkin = A2, this;
  }
  setDensity(A2) {
    return this.massPropsMode = SI.Density, this.density = A2, this;
  }
  setMass(A2) {
    return this.massPropsMode = SI.Mass, this.mass = A2, this;
  }
  setMassProperties(A2, I2, g2, C2) {
    return this.massPropsMode = SI.MassProps, this.mass = A2, fA.copy(this.centerOfMass, I2), fA.copy(this.principalAngularInertia, g2), XA.copy(this.angularInertiaLocalFrame, C2), this;
  }
  setRestitution(A2) {
    return this.restitution = A2, this;
  }
  setFriction(A2) {
    return this.friction = A2, this;
  }
  setFrictionCombineRule(A2) {
    return this.frictionCombineRule = A2, this;
  }
  setRestitutionCombineRule(A2) {
    return this.restitutionCombineRule = A2, this;
  }
  setCollisionGroups(A2) {
    return this.collisionGroups = A2, this;
  }
  setSolverGroups(A2) {
    return this.solverGroups = A2, this;
  }
  setActiveHooks(A2) {
    return this.activeHooks = A2, this;
  }
  setActiveEvents(A2) {
    return this.activeEvents = A2, this;
  }
  setActiveCollisionTypes(A2) {
    return this.activeCollisionTypes = A2, this;
  }
  setContactForceEventThreshold(A2) {
    return this.contactForceEventThreshold = A2, this;
  }
}
class cg {
  constructor(A2) {
    this.raw = A2 || new d$1(), this.map = new kI(), A2 && A2.forEachColliderHandle(((A3) => {
      this.map.set(A3, new sg(this, A3, null));
    }));
  }
  free() {
    this.raw && this.raw.free(), this.raw = void 0, this.map && this.map.clear(), this.map = void 0;
  }
  castClosure(A2) {
    return (I2) => A2 ? A2(this.get(I2)) : void 0;
  }
  finalizeDeserialization(A2) {
    this.map.forEach(((I2) => I2.finalizeDeserialization(A2)));
  }
  createCollider(A2, I2, g2) {
    let C2 = null != g2 && null != g2;
    if (C2 && isNaN(g2)) throw Error("Cannot create a collider with a parent rigid-body handle that is not a number.");
    let B2 = I2.shape.intoRaw(), Q2 = fA.intoRaw(I2.translation), E2 = XA.intoRaw(I2.rotation), i2 = fA.intoRaw(I2.centerOfMass), D2 = fA.intoRaw(I2.principalAngularInertia), o2 = XA.intoRaw(I2.angularInertiaLocalFrame), S2 = this.raw.createCollider(I2.enabled, B2, Q2, E2, I2.massPropsMode, I2.mass, i2, D2, o2, I2.density, I2.friction, I2.restitution, I2.frictionCombineRule, I2.restitutionCombineRule, I2.isSensor, I2.collisionGroups, I2.solverGroups, I2.activeCollisionTypes, I2.activeHooks, I2.activeEvents, I2.contactForceEventThreshold, I2.contactSkin, C2, C2 ? g2 : 0, A2.raw);
    B2.free(), Q2.free(), E2.free(), i2.free(), D2.free(), o2.free();
    let w2 = C2 ? A2.get(g2) : null, G2 = new sg(this, S2, w2, I2.shape);
    return this.map.set(S2, G2), G2;
  }
  remove(A2, I2, g2, C2) {
    this.raw.remove(A2, I2.raw, g2.raw, C2), this.unmap(A2);
  }
  unmap(A2) {
    this.map.delete(A2);
  }
  get(A2) {
    return this.map.get(A2);
  }
  len() {
    return this.map.len();
  }
  contains(A2) {
    return null != this.get(A2);
  }
  forEach(A2) {
    this.map.forEach(A2);
  }
  getAll() {
    return this.map.getAll();
  }
}
function qg(A2, I2, g2, C2) {
  return new (g2 || (g2 = Promise))((function(B2, Q2) {
    function E2(A3) {
      try {
        D2(C2.next(A3));
      } catch (A4) {
        Q2(A4);
      }
    }
    function i2(A3) {
      try {
        D2(C2.throw(A3));
      } catch (A4) {
        Q2(A4);
      }
    }
    function D2(A3) {
      var I3;
      A3.done ? B2(A3.value) : (I3 = A3.value, I3 instanceof g2 ? I3 : new g2((function(A4) {
        A4(I3);
      }))).then(E2, i2);
    }
    D2((C2 = C2.apply(A2, [])).next());
  }));
}
for (var Yg = { byteLength: function(A2) {
  var I2 = rg(A2), g2 = I2[0], C2 = I2[1];
  return 3 * (g2 + C2) / 4 - C2;
}, toByteArray: function(A2) {
  var I2, g2, C2 = rg(A2), B2 = C2[0], Q2 = C2[1], E2 = new Hg((function(A3, I3, g3) {
    return 3 * (I3 + g3) / 4 - g3;
  })(0, B2, Q2)), i2 = 0, D2 = Q2 > 0 ? B2 - 4 : B2;
  for (g2 = 0; g2 < D2; g2 += 4) I2 = Lg[A2.charCodeAt(g2)] << 18 | Lg[A2.charCodeAt(g2 + 1)] << 12 | Lg[A2.charCodeAt(g2 + 2)] << 6 | Lg[A2.charCodeAt(g2 + 3)], E2[i2++] = I2 >> 16 & 255, E2[i2++] = I2 >> 8 & 255, E2[i2++] = 255 & I2;
  2 === Q2 && (I2 = Lg[A2.charCodeAt(g2)] << 2 | Lg[A2.charCodeAt(g2 + 1)] >> 4, E2[i2++] = 255 & I2);
  1 === Q2 && (I2 = Lg[A2.charCodeAt(g2)] << 10 | Lg[A2.charCodeAt(g2 + 1)] << 4 | Lg[A2.charCodeAt(g2 + 2)] >> 2, E2[i2++] = I2 >> 8 & 255, E2[i2++] = 255 & I2);
  return E2;
}, fromByteArray: function(A2) {
  for (var I2, g2 = A2.length, C2 = g2 % 3, B2 = [], Q2 = 16383, E2 = 0, i2 = g2 - C2; E2 < i2; E2 += Q2) B2.push(ng(A2, E2, E2 + Q2 > i2 ? i2 : E2 + Q2));
  1 === C2 ? (I2 = A2[g2 - 1], B2.push(lg[I2 >> 2] + lg[I2 << 4 & 63] + "==")) : 2 === C2 && (I2 = (A2[g2 - 2] << 8) + A2[g2 - 1], B2.push(lg[I2 >> 10] + lg[I2 >> 4 & 63] + lg[I2 << 2 & 63] + "="));
  return B2.join("");
} }, lg = [], Lg = [], Hg = "undefined" != typeof Uint8Array ? Uint8Array : Array, tg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", pg = 0, eg = tg.length; pg < eg; ++pg) lg[pg] = tg[pg], Lg[tg.charCodeAt(pg)] = pg;
function rg(A2) {
  var I2 = A2.length;
  if (I2 % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var g2 = A2.indexOf("=");
  return -1 === g2 && (g2 = I2), [g2, g2 === I2 ? 0 : 4 - g2 % 4];
}
function ng(A2, I2, g2) {
  for (var C2, B2, Q2 = [], E2 = I2; E2 < g2; E2 += 3) C2 = (A2[E2] << 16 & 16711680) + (A2[E2 + 1] << 8 & 65280) + (255 & A2[E2 + 2]), Q2.push(lg[(B2 = C2) >> 18 & 63] + lg[B2 >> 12 & 63] + lg[B2 >> 6 & 63] + lg[63 & B2]);
  return Q2.join("");
}
function dg() {
  return qg(this, void 0, void 0, (function* () {
    yield mA(Yg.toByteArray("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").buffer);
  }));
}
function Tg() {
  return (function() {
    let I2, g2;
    try {
      const Q2 = A$1.__wbindgen_add_to_stack_pointer(-16);
      A$1.version(Q2);
      var C2 = S$1()[Q2 / 4 + 0], B2 = S$1()[Q2 / 4 + 1];
      return I2 = C2, g2 = B2, k$1(C2, B2);
    } finally {
      A$1.__wbindgen_add_to_stack_pointer(16), A$1.__wbindgen_free(I2, g2, 1);
    }
  })();
}
Lg["-".charCodeAt(0)] = 62, Lg["_".charCodeAt(0)] = 63;
var Og = Object.freeze({ __proto__: null, version: Tg, Vector3: jA, VectorOps: fA, Quaternion: VA, RotationOps: XA, SdpMatrix3: PA, SdpMatrix3Ops: uA, get RigidBodyType() {
  return vA;
}, RigidBody: wI, RigidBodyDesc: GI, RigidBodySet: KI, IntegrationParameters: JI, get JointType() {
  return zA;
}, get MotorModel() {
  return _A;
}, get JointAxesMask() {
  return $A;
}, ImpulseJoint: UI, UnitImpulseJoint: hI, FixedImpulseJoint: yI, RopeImpulseJoint: NI, SpringImpulseJoint: MI, PrismaticImpulseJoint: FI, RevoluteImpulseJoint: aI, GenericImpulseJoint: sI, SphericalImpulseJoint: RI, JointData: cI, ImpulseJointSet: qI, MultibodyJoint: YI, UnitMultibodyJoint: lI, FixedMultibodyJoint: LI, PrismaticMultibodyJoint: HI, RevoluteMultibodyJoint: tI, SphericalMultibodyJoint: pI, MultibodyJointSet: eI, get CoefficientCombineRule() {
  return AI;
}, CCDSolver: rI, IslandManager: nI, BroadPhase: dI, NarrowPhase: TI, TempContactManifold: OI, Shape: PI, get ShapeType() {
  return gI;
}, get HeightFieldFlags() {
  return CI;
}, get TriMeshFlags() {
  return BI;
}, Ball: uI, HalfSpace: vI, Cuboid: zI, RoundCuboid: _I, Capsule: $I, Segment: Ag, Triangle: Ig, RoundTriangle: gg, Polyline: Cg, TriMesh: Bg, ConvexPolyhedron: Qg, RoundConvexPolyhedron: Eg, Heightfield: ig, Cylinder: Dg, RoundCylinder: og, Cone: Sg, RoundCone: wg, get ActiveCollisionTypes() {
  return oI;
}, Collider: sg, get MassPropsMode() {
  return SI;
}, ColliderDesc: Rg, ColliderSet: cg, get FeatureType() {
  return II;
}, Ray: xI, RayIntersection: mI, RayColliderIntersection: jI, RayColliderHit: fI, PointProjection: bI, PointColliderProjection: WI, ShapeCastHit: VI, ColliderShapeCastHit: XI, ShapeContact: ZI, World: Mg, PhysicsPipeline: Gg, SerializationPipeline: Kg, get ActiveEvents() {
  return EI;
}, TempContactForceEvent: Fg, EventQueue: ag, get ActiveHooks() {
  return iI;
}, get SolverFlags() {
  return DI;
}, DebugRenderBuffers: Jg, DebugRenderPipeline: Ug, get QueryFilterFlags() {
  return QI;
}, QueryPipeline: kg, init: dg, CharacterCollision: hg, KinematicCharacterController: yg, DynamicRayCastVehicleController: Ng });
const rapier_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ActiveCollisionTypes() {
    return oI;
  },
  get ActiveEvents() {
    return EI;
  },
  get ActiveHooks() {
    return iI;
  },
  Ball: uI,
  BroadPhase: dI,
  CCDSolver: rI,
  Capsule: $I,
  CharacterCollision: hg,
  get CoefficientCombineRule() {
    return AI;
  },
  Collider: sg,
  ColliderDesc: Rg,
  ColliderSet: cg,
  ColliderShapeCastHit: XI,
  Cone: Sg,
  ConvexPolyhedron: Qg,
  Cuboid: zI,
  Cylinder: Dg,
  DebugRenderBuffers: Jg,
  DebugRenderPipeline: Ug,
  DynamicRayCastVehicleController: Ng,
  EventQueue: ag,
  get FeatureType() {
    return II;
  },
  FixedImpulseJoint: yI,
  FixedMultibodyJoint: LI,
  GenericImpulseJoint: sI,
  HalfSpace: vI,
  get HeightFieldFlags() {
    return CI;
  },
  Heightfield: ig,
  ImpulseJoint: UI,
  ImpulseJointSet: qI,
  IntegrationParameters: JI,
  IslandManager: nI,
  get JointAxesMask() {
    return $A;
  },
  JointData: cI,
  get JointType() {
    return zA;
  },
  KinematicCharacterController: yg,
  get MassPropsMode() {
    return SI;
  },
  get MotorModel() {
    return _A;
  },
  MultibodyJoint: YI,
  MultibodyJointSet: eI,
  NarrowPhase: TI,
  PhysicsPipeline: Gg,
  PointColliderProjection: WI,
  PointProjection: bI,
  Polyline: Cg,
  PrismaticImpulseJoint: FI,
  PrismaticMultibodyJoint: HI,
  Quaternion: VA,
  get QueryFilterFlags() {
    return QI;
  },
  QueryPipeline: kg,
  Ray: xI,
  RayColliderHit: fI,
  RayColliderIntersection: jI,
  RayIntersection: mI,
  RevoluteImpulseJoint: aI,
  RevoluteMultibodyJoint: tI,
  RigidBody: wI,
  RigidBodyDesc: GI,
  RigidBodySet: KI,
  get RigidBodyType() {
    return vA;
  },
  RopeImpulseJoint: NI,
  RotationOps: XA,
  RoundCone: wg,
  RoundConvexPolyhedron: Eg,
  RoundCuboid: _I,
  RoundCylinder: og,
  RoundTriangle: gg,
  SdpMatrix3: PA,
  SdpMatrix3Ops: uA,
  Segment: Ag,
  SerializationPipeline: Kg,
  Shape: PI,
  ShapeCastHit: VI,
  ShapeContact: ZI,
  get ShapeType() {
    return gI;
  },
  get SolverFlags() {
    return DI;
  },
  SphericalImpulseJoint: RI,
  SphericalMultibodyJoint: pI,
  SpringImpulseJoint: MI,
  TempContactForceEvent: Fg,
  TempContactManifold: OI,
  TriMesh: Bg,
  get TriMeshFlags() {
    return BI;
  },
  Triangle: Ig,
  UnitImpulseJoint: hI,
  UnitMultibodyJoint: lI,
  Vector3: jA,
  VectorOps: fA,
  World: Mg,
  default: Og,
  init: dg,
  version: Tg
}, Symbol.toStringTag, { value: "Module" }));
const isPromise = (promise) => typeof promise === "object" && typeof promise.then === "function";
const globalCache = [];
function shallowEqualArrays(arrA, arrB, equal = (a5, b6) => a5 === b6) {
  if (arrA === arrB) return true;
  if (!arrA || !arrB) return false;
  const len = arrA.length;
  if (arrB.length !== len) return false;
  for (let i2 = 0; i2 < len; i2++) if (!equal(arrA[i2], arrB[i2])) return false;
  return true;
}
function query(fn, keys = null, preload3 = false, config3 = {}) {
  if (keys === null) keys = [fn];
  for (const entry2 of globalCache) {
    if (shallowEqualArrays(keys, entry2.keys, entry2.equal)) {
      if (preload3) return void 0;
      if (Object.prototype.hasOwnProperty.call(entry2, "error")) throw entry2.error;
      if (Object.prototype.hasOwnProperty.call(entry2, "response")) {
        if (config3.lifespan && config3.lifespan > 0) {
          if (entry2.timeout) clearTimeout(entry2.timeout);
          entry2.timeout = setTimeout(entry2.remove, config3.lifespan);
        }
        return entry2.response;
      }
      if (!preload3) throw entry2.promise;
    }
  }
  const entry = {
    keys,
    equal: config3.equal,
    remove: () => {
      const index = globalCache.indexOf(entry);
      if (index !== -1) globalCache.splice(index, 1);
    },
    promise: (
      // Execute the promise
      (isPromise(fn) ? fn : fn(...keys)).then((response) => {
        entry.response = response;
        if (config3.lifespan && config3.lifespan > 0) {
          entry.timeout = setTimeout(entry.remove, config3.lifespan);
        }
      }).catch((error2) => entry.error = error2)
    )
  };
  globalCache.push(entry);
  if (!preload3) throw entry.promise;
  return void 0;
}
const suspend = (fn, keys, config3) => query(fn, keys, false, config3);
function _toPrimitive(t2, r3) {
  if ("object" != typeof t2 || !t2) return t2;
  var e2 = t2[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i2 = e2.call(t2, r3);
    if ("object" != typeof i2) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t2);
}
function _toPropertyKey(t2) {
  var i2 = _toPrimitive(t2, "string");
  return "symbol" == typeof i2 ? i2 : i2 + "";
}
function _defineProperty(e2, r3, t2) {
  return (r3 = _toPropertyKey(r3)) in e2 ? Object.defineProperty(e2, r3, {
    value: t2,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e2[r3] = t2, e2;
}
function ownKeys(e2, r3) {
  var t2 = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e2);
    r3 && (o2 = o2.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e2, r4).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread2(e2) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t2 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys(Object(t2), true).forEach(function(r4) {
      _defineProperty(e2, r4, t2[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2)) : ownKeys(Object(t2)).forEach(function(r4) {
      Object.defineProperty(e2, r4, Object.getOwnPropertyDescriptor(t2, r4));
    });
  }
  return e2;
}
const _quaternion = new Quaternion();
new Euler();
const _vector3 = new Vector3();
new Object3D();
const _matrix4 = new Matrix4();
const _position = new Vector3();
const _rotation = new Quaternion();
const _scale = new Vector3();
const vectorArrayToVector3 = (arr) => {
  const [x3, y2, z2] = arr;
  return new Vector3(x3, y2, z2);
};
const rapierQuaternionToQuaternion = ({
  x: x3,
  y: y2,
  z: z2,
  w: w2
}) => _quaternion.set(x3, y2, z2, w2);
const vector3ToRapierVector = (v3) => {
  if (Array.isArray(v3)) {
    return new jA(v3[0], v3[1], v3[2]);
  } else if (typeof v3 === "number") {
    return new jA(v3, v3, v3);
  } else {
    const threeVector3 = v3;
    return new jA(threeVector3.x, threeVector3.y, threeVector3.z);
  }
};
const rigidBodyTypeMap = {
  fixed: 1,
  dynamic: 0,
  kinematicPosition: 2,
  kinematicVelocity: 3
};
const rigidBodyTypeFromString = (type) => rigidBodyTypeMap[type];
const scaleVertices = (vertices, scale) => {
  const scaledVerts = Array.from(vertices);
  for (let i2 = 0; i2 < vertices.length / 3; i2++) {
    scaledVerts[i2 * 3] *= scale.x;
    scaledVerts[i2 * 3 + 1] *= scale.y;
    scaledVerts[i2 * 3 + 2] *= scale.z;
  }
  return scaledVerts;
};
const vectorToTuple = (v3) => {
  if (!v3) return [0];
  if (v3 instanceof Quaternion) {
    return [v3.x, v3.y, v3.z, v3.w];
  }
  if (v3 instanceof Vector3 || v3 instanceof Euler) {
    return [v3.x, v3.y, v3.z];
  }
  if (Array.isArray(v3)) {
    return v3;
  }
  return [v3];
};
function useConst(initialValue) {
  const ref = reactExports.useRef();
  if (ref.current === void 0) {
    ref.current = {
      value: typeof initialValue === "function" ? initialValue() : initialValue
    };
  }
  return ref.current.value;
}
const useRaf = (callback) => {
  const cb = reactExports.useRef(callback);
  const raf2 = reactExports.useRef(0);
  const lastFrame = reactExports.useRef(0);
  reactExports.useEffect(() => {
    cb.current = callback;
  }, [callback]);
  reactExports.useEffect(() => {
    const loop2 = () => {
      const now2 = performance.now();
      const delta = now2 - lastFrame.current;
      raf2.current = requestAnimationFrame(loop2);
      cb.current(delta / 1e3);
      lastFrame.current = now2;
    };
    raf2.current = requestAnimationFrame(loop2);
    return () => cancelAnimationFrame(raf2.current);
  }, []);
};
const UseFrameStepper = ({
  onStep,
  updatePriority
}) => {
  useFrame((_2, dt) => {
    onStep(dt);
  }, updatePriority);
  return null;
};
const RafStepper = ({
  onStep
}) => {
  useRaf((dt) => {
    onStep(dt);
  });
  return null;
};
const FrameStepper = ({
  onStep,
  type,
  updatePriority
}) => {
  return type === "independent" ? /* @__PURE__ */ React.createElement(RafStepper, {
    onStep
  }) : /* @__PURE__ */ React.createElement(UseFrameStepper, {
    onStep,
    updatePriority
  });
};
var FrameStepper$1 = /* @__PURE__ */ reactExports.memo(FrameStepper);
function _objectWithoutPropertiesLoose$1(r3, e2) {
  if (null == r3) return {};
  var t2 = {};
  for (var n2 in r3) if ({}.hasOwnProperty.call(r3, n2)) {
    if (e2.includes(n2)) continue;
    t2[n2] = r3[n2];
  }
  return t2;
}
function _objectWithoutProperties(e2, t2) {
  if (null == e2) return {};
  var o2, r3, i2 = _objectWithoutPropertiesLoose$1(e2, t2);
  if (Object.getOwnPropertySymbols) {
    var s2 = Object.getOwnPropertySymbols(e2);
    for (r3 = 0; r3 < s2.length; r3++) o2 = s2[r3], t2.includes(o2) || {}.propertyIsEnumerable.call(e2, o2) && (i2[o2] = e2[o2]);
  }
  return i2;
}
const _excluded$2 = ["mass", "linearDamping", "angularDamping", "type", "onCollisionEnter", "onCollisionExit", "onIntersectionEnter", "onIntersectionExit", "onContactForce", "children", "canSleep", "ccd", "gravityScale", "softCcdPrediction"];
const scaleColliderArgs = (shape, args, scale) => {
  const newArgs = args.slice();
  if (shape === "heightfield") {
    const s2 = newArgs[3];
    s2.x *= scale.x;
    s2.x *= scale.y;
    s2.x *= scale.z;
    return newArgs;
  }
  if (shape === "trimesh" || shape === "convexHull") {
    newArgs[0] = scaleVertices(newArgs[0], scale);
    return newArgs;
  }
  const scaleArray = [scale.x, scale.y, scale.z, scale.x, scale.x];
  return newArgs.map((arg, index) => scaleArray[index] * arg);
};
const createColliderFromOptions = (options, world, scale, getRigidBody) => {
  const scaledArgs = scaleColliderArgs(options.shape, options.args, scale);
  const desc = Rg[options.shape](...scaledArgs);
  return world.createCollider(desc, getRigidBody === null || getRigidBody === void 0 ? void 0 : getRigidBody());
};
const immutableColliderOptions = ["shape", "args"];
const massPropertiesConflictError = "Please pick ONLY ONE of the `density`, `mass` and `massProperties` options.";
const setColliderMassOptions = (collider, options) => {
  if (options.density !== void 0) {
    if (options.mass !== void 0 || options.massProperties !== void 0) {
      throw new Error(massPropertiesConflictError);
    }
    collider.setDensity(options.density);
    return;
  }
  if (options.mass !== void 0) {
    if (options.massProperties !== void 0) {
      throw new Error(massPropertiesConflictError);
    }
    collider.setMass(options.mass);
    return;
  }
  if (options.massProperties !== void 0) {
    collider.setMassProperties(options.massProperties.mass, options.massProperties.centerOfMass, options.massProperties.principalAngularInertia, options.massProperties.angularInertiaLocalFrame);
  }
};
const mutableColliderOptions = {
  sensor: (collider, value) => {
    collider.setSensor(value);
  },
  collisionGroups: (collider, value) => {
    collider.setCollisionGroups(value);
  },
  solverGroups: (collider, value) => {
    collider.setSolverGroups(value);
  },
  friction: (collider, value) => {
    collider.setFriction(value);
  },
  frictionCombineRule: (collider, value) => {
    collider.setFrictionCombineRule(value);
  },
  restitution: (collider, value) => {
    collider.setRestitution(value);
  },
  restitutionCombineRule: (collider, value) => {
    collider.setRestitutionCombineRule(value);
  },
  activeCollisionTypes: (collider, value) => {
    collider.setActiveCollisionTypes(value);
  },
  contactSkin: (collider, value) => {
    collider.setContactSkin(value);
  },
  // To make sure the options all mutable options are listed
  quaternion: () => {
  },
  position: () => {
  },
  rotation: () => {
  },
  scale: () => {
  }
};
const mutableColliderOptionKeys = Object.keys(mutableColliderOptions);
const setColliderOptions = (collider, options, states) => {
  const state = states.get(collider.handle);
  if (state) {
    var _state$worldParent;
    const parentWorldScale = state.object.parent.getWorldScale(_vector3);
    const parentInvertedWorldMatrix = (_state$worldParent = state.worldParent) === null || _state$worldParent === void 0 ? void 0 : _state$worldParent.matrixWorld.clone().invert();
    state.object.updateWorldMatrix(true, false);
    _matrix4.copy(state.object.matrixWorld);
    if (parentInvertedWorldMatrix) {
      _matrix4.premultiply(parentInvertedWorldMatrix);
    }
    _matrix4.decompose(_position, _rotation, _scale);
    if (collider.parent()) {
      collider.setTranslationWrtParent({
        x: _position.x * parentWorldScale.x,
        y: _position.y * parentWorldScale.y,
        z: _position.z * parentWorldScale.z
      });
      collider.setRotationWrtParent(_rotation);
    } else {
      collider.setTranslation({
        x: _position.x * parentWorldScale.x,
        y: _position.y * parentWorldScale.y,
        z: _position.z * parentWorldScale.z
      });
      collider.setRotation(_rotation);
    }
    mutableColliderOptionKeys.forEach((key) => {
      if (key in options) {
        const option = options[key];
        mutableColliderOptions[key](
          collider,
          // @ts-ignore Option does not want to fit into the function, but it will
          option,
          options
        );
      }
    });
    setColliderMassOptions(collider, options);
  }
};
const useUpdateColliderOptions = (getCollider, props, states) => {
  const mutablePropsAsFlatArray = reactExports.useMemo(() => mutableColliderOptionKeys.flatMap((key) => {
    return vectorToTuple(props[key]);
  }), [props]);
  reactExports.useEffect(() => {
    const collider = getCollider();
    setColliderOptions(collider, props, states);
  }, [...mutablePropsAsFlatArray, getCollider]);
};
const isChildOfMeshCollider = (child) => {
  let flag = false;
  child.traverseAncestors((a5) => {
    if (a5.userData.r3RapierType === "MeshCollider") flag = true;
  });
  return flag;
};
const createColliderState = (collider, object, rigidBodyObject) => {
  return {
    collider,
    worldParent: rigidBodyObject || void 0,
    object
  };
};
const autoColliderMap = {
  cuboid: "cuboid",
  ball: "ball",
  hull: "convexHull",
  trimesh: "trimesh"
};
const createColliderPropsFromChildren = ({
  object,
  ignoreMeshColliders: _ignoreMeshColliders = true,
  options
}) => {
  const childColliderProps = [];
  object.updateWorldMatrix(true, false);
  const invertedParentMatrixWorld = object.matrixWorld.clone().invert();
  const colliderFromChild = (child) => {
    if ("isMesh" in child) {
      if (_ignoreMeshColliders && isChildOfMeshCollider(child)) return;
      const worldScale = child.getWorldScale(_scale);
      const shape = autoColliderMap[options.colliders || "cuboid"];
      child.updateWorldMatrix(true, false);
      _matrix4.copy(child.matrixWorld).premultiply(invertedParentMatrixWorld).decompose(_position, _rotation, _scale);
      const rotationEuler = new Euler().setFromQuaternion(_rotation, "XYZ");
      const {
        geometry
      } = child;
      const {
        args,
        offset
      } = getColliderArgsFromGeometry(geometry, options.colliders || "cuboid");
      const colliderProps = _objectSpread2(_objectSpread2({}, cleanRigidBodyPropsForCollider(options)), {}, {
        args,
        shape,
        rotation: [rotationEuler.x, rotationEuler.y, rotationEuler.z],
        position: [_position.x + offset.x * worldScale.x, _position.y + offset.y * worldScale.y, _position.z + offset.z * worldScale.z],
        scale: [worldScale.x, worldScale.y, worldScale.z]
      });
      childColliderProps.push(colliderProps);
    }
  };
  if (options.includeInvisible) {
    object.traverse(colliderFromChild);
  } else {
    object.traverseVisible(colliderFromChild);
  }
  return childColliderProps;
};
const getColliderArgsFromGeometry = (geometry, colliders) => {
  switch (colliders) {
    case "cuboid": {
      geometry.computeBoundingBox();
      const {
        boundingBox
      } = geometry;
      const size = boundingBox.getSize(new Vector3());
      return {
        args: [size.x / 2, size.y / 2, size.z / 2],
        offset: boundingBox.getCenter(new Vector3())
      };
    }
    case "ball": {
      geometry.computeBoundingSphere();
      const {
        boundingSphere
      } = geometry;
      const radius = boundingSphere.radius;
      return {
        args: [radius],
        offset: boundingSphere.center
      };
    }
    case "trimesh": {
      var _clonedGeometry$index;
      const clonedGeometry = geometry.index ? geometry.clone() : mergeVertices(geometry);
      return {
        args: [clonedGeometry.attributes.position.array, (_clonedGeometry$index = clonedGeometry.index) === null || _clonedGeometry$index === void 0 ? void 0 : _clonedGeometry$index.array],
        offset: new Vector3()
      };
    }
    case "hull": {
      const g2 = geometry.clone();
      return {
        args: [g2.attributes.position.array],
        offset: new Vector3()
      };
    }
  }
  return {
    args: [],
    offset: new Vector3()
  };
};
const getActiveCollisionEventsFromProps = (props) => {
  return {
    collision: !!(props !== null && props !== void 0 && props.onCollisionEnter || props !== null && props !== void 0 && props.onCollisionExit || props !== null && props !== void 0 && props.onIntersectionEnter || props !== null && props !== void 0 && props.onIntersectionExit),
    contactForce: !!(props !== null && props !== void 0 && props.onContactForce)
  };
};
const useColliderEvents = (getCollider, props, events, activeEvents = {}) => {
  const {
    onCollisionEnter,
    onCollisionExit,
    onIntersectionEnter,
    onIntersectionExit,
    onContactForce
  } = props;
  reactExports.useEffect(() => {
    const collider = getCollider();
    if (collider) {
      const {
        collision: collisionEventsActive,
        contactForce: contactForceEventsActive
      } = getActiveCollisionEventsFromProps(props);
      const hasCollisionEvent = collisionEventsActive || activeEvents.collision;
      const hasContactForceEvent = contactForceEventsActive || activeEvents.contactForce;
      if (hasCollisionEvent && hasContactForceEvent) {
        collider.setActiveEvents(EI.COLLISION_EVENTS | EI.CONTACT_FORCE_EVENTS);
      } else if (hasCollisionEvent) {
        collider.setActiveEvents(EI.COLLISION_EVENTS);
      } else if (hasContactForceEvent) {
        collider.setActiveEvents(EI.CONTACT_FORCE_EVENTS);
      }
      events.set(collider.handle, {
        onCollisionEnter,
        onCollisionExit,
        onIntersectionEnter,
        onIntersectionExit,
        onContactForce
      });
    }
    return () => {
      if (collider) {
        events.delete(collider.handle);
      }
    };
  }, [onCollisionEnter, onCollisionExit, onIntersectionEnter, onIntersectionExit, onContactForce, activeEvents]);
};
const cleanRigidBodyPropsForCollider = (props = {}) => {
  const rest = _objectWithoutProperties(props, _excluded$2);
  return rest;
};
const useRapier = () => {
  const rapier = reactExports.useContext(rapierContext);
  if (!rapier) throw new Error("react-three-rapier: useRapier must be used within <Physics />!");
  return rapier;
};
const useChildColliderProps = (ref, options, ignoreMeshColliders = true) => {
  const [colliderProps, setColliderProps] = reactExports.useState([]);
  reactExports.useEffect(() => {
    const object = ref.current;
    if (object && options.colliders !== false) {
      setColliderProps(createColliderPropsFromChildren({
        object: ref.current,
        options,
        ignoreMeshColliders
      }));
    }
  }, [options.colliders]);
  return colliderProps;
};
const Debug = /* @__PURE__ */ reactExports.memo(() => {
  const {
    world
  } = useRapier();
  const ref = reactExports.useRef(null);
  useFrame(() => {
    const mesh = ref.current;
    if (!mesh) return;
    const buffers = world.debugRender();
    mesh.geometry.setAttribute("position", new BufferAttribute(buffers.vertices, 3));
    mesh.geometry.setAttribute("color", new BufferAttribute(buffers.colors, 4));
  });
  return /* @__PURE__ */ React.createElement("group", null, /* @__PURE__ */ React.createElement("lineSegments", {
    ref,
    frustumCulled: false
  }, /* @__PURE__ */ React.createElement("lineBasicMaterial", {
    color: 16777215,
    vertexColors: true
  }), /* @__PURE__ */ React.createElement("bufferGeometry", null)));
});
const createSingletonProxy = (createInstance) => {
  let instance;
  const handler = {
    get(target, prop) {
      if (!instance) {
        instance = createInstance();
      }
      return Reflect.get(instance, prop);
    },
    set(target, prop, value) {
      if (!instance) {
        instance = createInstance();
      }
      return Reflect.set(instance, prop, value);
    }
  };
  const proxy = new Proxy({}, handler);
  const reset = () => {
    instance = void 0;
  };
  const set = (newInstance) => {
    instance = newInstance;
  };
  return {
    proxy,
    reset,
    set
  };
};
const rapierContext = /* @__PURE__ */ reactExports.createContext(void 0);
const getCollisionPayloadFromSource = (target, other) => {
  var _target$collider$stat, _target$rigidBody$sta, _other$collider$state, _other$rigidBody$stat, _other$collider$state2, _other$rigidBody$stat2;
  return {
    target: {
      rigidBody: target.rigidBody.object,
      collider: target.collider.object,
      colliderObject: (_target$collider$stat = target.collider.state) === null || _target$collider$stat === void 0 ? void 0 : _target$collider$stat.object,
      rigidBodyObject: (_target$rigidBody$sta = target.rigidBody.state) === null || _target$rigidBody$sta === void 0 ? void 0 : _target$rigidBody$sta.object
    },
    other: {
      rigidBody: other.rigidBody.object,
      collider: other.collider.object,
      colliderObject: (_other$collider$state = other.collider.state) === null || _other$collider$state === void 0 ? void 0 : _other$collider$state.object,
      rigidBodyObject: (_other$rigidBody$stat = other.rigidBody.state) === null || _other$rigidBody$stat === void 0 ? void 0 : _other$rigidBody$stat.object
    },
    rigidBody: other.rigidBody.object,
    collider: other.collider.object,
    colliderObject: (_other$collider$state2 = other.collider.state) === null || _other$collider$state2 === void 0 ? void 0 : _other$collider$state2.object,
    rigidBodyObject: (_other$rigidBody$stat2 = other.rigidBody.state) === null || _other$rigidBody$stat2 === void 0 ? void 0 : _other$rigidBody$stat2.object
  };
};
const importRapier = async () => {
  let r3 = await __vitePreload(() => Promise.resolve().then(() => rapier_es), true ? void 0 : void 0);
  await r3.init();
  return r3;
};
const Physics = (props) => {
  const {
    colliders = "cuboid",
    children,
    timeStep = 1 / 60,
    paused = false,
    interpolate: interpolate3 = true,
    updatePriority,
    updateLoop = "follow",
    debug = false,
    gravity = [0, -9.81, 0],
    allowedLinearError = 1e-3,
    predictionDistance = 2e-3,
    numSolverIterations = 4,
    numAdditionalFrictionIterations = 4,
    numInternalPgsIterations = 1,
    minIslandSize = 128,
    maxCcdSubsteps = 1,
    contactNaturalFrequency = 30,
    lengthUnit = 1
  } = props;
  const rapier = suspend(importRapier, ["@react-thee/rapier", importRapier]);
  const {
    invalidate: invalidate2
  } = useThree();
  const rigidBodyStates = useConst(() => /* @__PURE__ */ new Map());
  const colliderStates = useConst(() => /* @__PURE__ */ new Map());
  const rigidBodyEvents = useConst(() => /* @__PURE__ */ new Map());
  const colliderEvents = useConst(() => /* @__PURE__ */ new Map());
  const eventQueue = useConst(() => new ag(false));
  const beforeStepCallbacks = useConst(() => /* @__PURE__ */ new Set());
  const afterStepCallbacks = useConst(() => /* @__PURE__ */ new Set());
  const {
    proxy: worldProxy,
    reset: resetWorldProxy,
    set: setWorldProxy
  } = useConst(() => createSingletonProxy(() => new rapier.World(vectorArrayToVector3(gravity))));
  reactExports.useEffect(() => {
    return () => {
      worldProxy.free();
      resetWorldProxy();
    };
  }, []);
  reactExports.useEffect(() => {
    worldProxy.gravity = vector3ToRapierVector(gravity);
    worldProxy.integrationParameters.numSolverIterations = numSolverIterations;
    worldProxy.integrationParameters.numAdditionalFrictionIterations = numAdditionalFrictionIterations;
    worldProxy.integrationParameters.numInternalPgsIterations = numInternalPgsIterations;
    worldProxy.integrationParameters.normalizedAllowedLinearError = allowedLinearError;
    worldProxy.integrationParameters.minIslandSize = minIslandSize;
    worldProxy.integrationParameters.maxCcdSubsteps = maxCcdSubsteps;
    worldProxy.integrationParameters.normalizedPredictionDistance = predictionDistance;
    worldProxy.lengthUnit = lengthUnit;
    worldProxy.integrationParameters.contact_natural_frequency = contactNaturalFrequency;
  }, [worldProxy, ...gravity, numSolverIterations, numAdditionalFrictionIterations, numInternalPgsIterations, allowedLinearError, minIslandSize, maxCcdSubsteps, predictionDistance, lengthUnit, contactNaturalFrequency]);
  const getSourceFromColliderHandle = reactExports.useCallback((handle) => {
    var _collider$parent;
    const collider = worldProxy.getCollider(handle);
    const colEvents = colliderEvents.get(handle);
    const colliderState = colliderStates.get(handle);
    const rigidBodyHandle = collider === null || collider === void 0 ? void 0 : (_collider$parent = collider.parent()) === null || _collider$parent === void 0 ? void 0 : _collider$parent.handle;
    const rigidBody = rigidBodyHandle !== void 0 ? worldProxy.getRigidBody(rigidBodyHandle) : void 0;
    const rbEvents = rigidBody && rigidBodyHandle !== void 0 ? rigidBodyEvents.get(rigidBodyHandle) : void 0;
    const rigidBodyState = rigidBodyHandle !== void 0 ? rigidBodyStates.get(rigidBodyHandle) : void 0;
    const source = {
      collider: {
        object: collider,
        events: colEvents,
        state: colliderState
      },
      rigidBody: {
        object: rigidBody,
        events: rbEvents,
        state: rigidBodyState
      }
    };
    return source;
  }, []);
  const [steppingState] = reactExports.useState({
    previousState: {},
    accumulator: 0
  });
  const step = reactExports.useCallback((dt) => {
    const world = worldProxy;
    const timeStepVariable = timeStep === "vary";
    const clampedDelta = MathUtils.clamp(dt, 0, 0.5);
    const stepWorld = (delta) => {
      beforeStepCallbacks.forEach((callback) => {
        callback.current(world);
      });
      world.timestep = delta;
      world.step(eventQueue);
      afterStepCallbacks.forEach((callback) => {
        callback.current(world);
      });
    };
    if (timeStepVariable) {
      stepWorld(clampedDelta);
    } else {
      steppingState.accumulator += clampedDelta;
      while (steppingState.accumulator >= timeStep) {
        if (interpolate3) {
          steppingState.previousState = {};
          world.forEachRigidBody((body) => {
            steppingState.previousState[body.handle] = {
              position: body.translation(),
              rotation: body.rotation()
            };
          });
        }
        stepWorld(timeStep);
        steppingState.accumulator -= timeStep;
      }
    }
    const interpolationAlpha = timeStepVariable || !interpolate3 || paused ? 1 : steppingState.accumulator / timeStep;
    rigidBodyStates.forEach((state, handle) => {
      const rigidBody = world.getRigidBody(handle);
      const events = rigidBodyEvents.get(handle);
      if (events !== null && events !== void 0 && events.onSleep || events !== null && events !== void 0 && events.onWake) {
        if (rigidBody.isSleeping() && !state.isSleeping) {
          var _events$onSleep;
          events === null || events === void 0 ? void 0 : (_events$onSleep = events.onSleep) === null || _events$onSleep === void 0 ? void 0 : _events$onSleep.call(events);
        }
        if (!rigidBody.isSleeping() && state.isSleeping) {
          var _events$onWake;
          events === null || events === void 0 ? void 0 : (_events$onWake = events.onWake) === null || _events$onWake === void 0 ? void 0 : _events$onWake.call(events);
        }
        state.isSleeping = rigidBody.isSleeping();
      }
      if (!rigidBody || rigidBody.isSleeping() && !("isInstancedMesh" in state.object) || !state.setMatrix) {
        return;
      }
      let t2 = rigidBody.translation();
      let r3 = rigidBody.rotation();
      let previousState = steppingState.previousState[handle];
      if (previousState) {
        _matrix4.compose(previousState.position, rapierQuaternionToQuaternion(previousState.rotation), state.scale).premultiply(state.invertedWorldMatrix).decompose(_position, _rotation, _scale);
        if (state.meshType == "mesh") {
          state.object.position.copy(_position);
          state.object.quaternion.copy(_rotation);
        }
      }
      _matrix4.compose(t2, rapierQuaternionToQuaternion(r3), state.scale).premultiply(state.invertedWorldMatrix).decompose(_position, _rotation, _scale);
      if (state.meshType == "instancedMesh") {
        state.setMatrix(_matrix4);
      } else {
        state.object.position.lerp(_position, interpolationAlpha);
        state.object.quaternion.slerp(_rotation, interpolationAlpha);
      }
    });
    eventQueue.drainCollisionEvents((handle1, handle2, started) => {
      const source1 = getSourceFromColliderHandle(handle1);
      const source2 = getSourceFromColliderHandle(handle2);
      if (!(source1 !== null && source1 !== void 0 && source1.collider.object) || !(source2 !== null && source2 !== void 0 && source2.collider.object)) {
        return;
      }
      const collisionPayload1 = getCollisionPayloadFromSource(source1, source2);
      const collisionPayload2 = getCollisionPayloadFromSource(source2, source1);
      if (started) {
        world.contactPair(source1.collider.object, source2.collider.object, (manifold, flipped) => {
          var _source1$rigidBody$ev, _source1$rigidBody$ev2, _source2$rigidBody$ev, _source2$rigidBody$ev2, _source1$collider$eve, _source1$collider$eve2, _source2$collider$eve, _source2$collider$eve2;
          (_source1$rigidBody$ev = source1.rigidBody.events) === null || _source1$rigidBody$ev === void 0 ? void 0 : (_source1$rigidBody$ev2 = _source1$rigidBody$ev.onCollisionEnter) === null || _source1$rigidBody$ev2 === void 0 ? void 0 : _source1$rigidBody$ev2.call(_source1$rigidBody$ev, _objectSpread2(_objectSpread2({}, collisionPayload1), {}, {
            manifold,
            flipped
          }));
          (_source2$rigidBody$ev = source2.rigidBody.events) === null || _source2$rigidBody$ev === void 0 ? void 0 : (_source2$rigidBody$ev2 = _source2$rigidBody$ev.onCollisionEnter) === null || _source2$rigidBody$ev2 === void 0 ? void 0 : _source2$rigidBody$ev2.call(_source2$rigidBody$ev, _objectSpread2(_objectSpread2({}, collisionPayload2), {}, {
            manifold,
            flipped
          }));
          (_source1$collider$eve = source1.collider.events) === null || _source1$collider$eve === void 0 ? void 0 : (_source1$collider$eve2 = _source1$collider$eve.onCollisionEnter) === null || _source1$collider$eve2 === void 0 ? void 0 : _source1$collider$eve2.call(_source1$collider$eve, _objectSpread2(_objectSpread2({}, collisionPayload1), {}, {
            manifold,
            flipped
          }));
          (_source2$collider$eve = source2.collider.events) === null || _source2$collider$eve === void 0 ? void 0 : (_source2$collider$eve2 = _source2$collider$eve.onCollisionEnter) === null || _source2$collider$eve2 === void 0 ? void 0 : _source2$collider$eve2.call(_source2$collider$eve, _objectSpread2(_objectSpread2({}, collisionPayload2), {}, {
            manifold,
            flipped
          }));
        });
      } else {
        var _source1$rigidBody$ev3, _source1$rigidBody$ev4, _source2$rigidBody$ev3, _source2$rigidBody$ev4, _source1$collider$eve3, _source1$collider$eve4, _source2$collider$eve3, _source2$collider$eve4;
        (_source1$rigidBody$ev3 = source1.rigidBody.events) === null || _source1$rigidBody$ev3 === void 0 ? void 0 : (_source1$rigidBody$ev4 = _source1$rigidBody$ev3.onCollisionExit) === null || _source1$rigidBody$ev4 === void 0 ? void 0 : _source1$rigidBody$ev4.call(_source1$rigidBody$ev3, collisionPayload1);
        (_source2$rigidBody$ev3 = source2.rigidBody.events) === null || _source2$rigidBody$ev3 === void 0 ? void 0 : (_source2$rigidBody$ev4 = _source2$rigidBody$ev3.onCollisionExit) === null || _source2$rigidBody$ev4 === void 0 ? void 0 : _source2$rigidBody$ev4.call(_source2$rigidBody$ev3, collisionPayload2);
        (_source1$collider$eve3 = source1.collider.events) === null || _source1$collider$eve3 === void 0 ? void 0 : (_source1$collider$eve4 = _source1$collider$eve3.onCollisionExit) === null || _source1$collider$eve4 === void 0 ? void 0 : _source1$collider$eve4.call(_source1$collider$eve3, collisionPayload1);
        (_source2$collider$eve3 = source2.collider.events) === null || _source2$collider$eve3 === void 0 ? void 0 : (_source2$collider$eve4 = _source2$collider$eve3.onCollisionExit) === null || _source2$collider$eve4 === void 0 ? void 0 : _source2$collider$eve4.call(_source2$collider$eve3, collisionPayload2);
      }
      if (started) {
        if (world.intersectionPair(source1.collider.object, source2.collider.object)) {
          var _source1$rigidBody$ev5, _source1$rigidBody$ev6, _source2$rigidBody$ev5, _source2$rigidBody$ev6, _source1$collider$eve5, _source1$collider$eve6, _source2$collider$eve5, _source2$collider$eve6;
          (_source1$rigidBody$ev5 = source1.rigidBody.events) === null || _source1$rigidBody$ev5 === void 0 ? void 0 : (_source1$rigidBody$ev6 = _source1$rigidBody$ev5.onIntersectionEnter) === null || _source1$rigidBody$ev6 === void 0 ? void 0 : _source1$rigidBody$ev6.call(_source1$rigidBody$ev5, collisionPayload1);
          (_source2$rigidBody$ev5 = source2.rigidBody.events) === null || _source2$rigidBody$ev5 === void 0 ? void 0 : (_source2$rigidBody$ev6 = _source2$rigidBody$ev5.onIntersectionEnter) === null || _source2$rigidBody$ev6 === void 0 ? void 0 : _source2$rigidBody$ev6.call(_source2$rigidBody$ev5, collisionPayload2);
          (_source1$collider$eve5 = source1.collider.events) === null || _source1$collider$eve5 === void 0 ? void 0 : (_source1$collider$eve6 = _source1$collider$eve5.onIntersectionEnter) === null || _source1$collider$eve6 === void 0 ? void 0 : _source1$collider$eve6.call(_source1$collider$eve5, collisionPayload1);
          (_source2$collider$eve5 = source2.collider.events) === null || _source2$collider$eve5 === void 0 ? void 0 : (_source2$collider$eve6 = _source2$collider$eve5.onIntersectionEnter) === null || _source2$collider$eve6 === void 0 ? void 0 : _source2$collider$eve6.call(_source2$collider$eve5, collisionPayload2);
        }
      } else {
        var _source1$rigidBody$ev7, _source1$rigidBody$ev8, _source2$rigidBody$ev7, _source2$rigidBody$ev8, _source1$collider$eve7, _source1$collider$eve8, _source2$collider$eve7, _source2$collider$eve8;
        (_source1$rigidBody$ev7 = source1.rigidBody.events) === null || _source1$rigidBody$ev7 === void 0 ? void 0 : (_source1$rigidBody$ev8 = _source1$rigidBody$ev7.onIntersectionExit) === null || _source1$rigidBody$ev8 === void 0 ? void 0 : _source1$rigidBody$ev8.call(_source1$rigidBody$ev7, collisionPayload1);
        (_source2$rigidBody$ev7 = source2.rigidBody.events) === null || _source2$rigidBody$ev7 === void 0 ? void 0 : (_source2$rigidBody$ev8 = _source2$rigidBody$ev7.onIntersectionExit) === null || _source2$rigidBody$ev8 === void 0 ? void 0 : _source2$rigidBody$ev8.call(_source2$rigidBody$ev7, collisionPayload2);
        (_source1$collider$eve7 = source1.collider.events) === null || _source1$collider$eve7 === void 0 ? void 0 : (_source1$collider$eve8 = _source1$collider$eve7.onIntersectionExit) === null || _source1$collider$eve8 === void 0 ? void 0 : _source1$collider$eve8.call(_source1$collider$eve7, collisionPayload1);
        (_source2$collider$eve7 = source2.collider.events) === null || _source2$collider$eve7 === void 0 ? void 0 : (_source2$collider$eve8 = _source2$collider$eve7.onIntersectionExit) === null || _source2$collider$eve8 === void 0 ? void 0 : _source2$collider$eve8.call(_source2$collider$eve7, collisionPayload2);
      }
    });
    eventQueue.drainContactForceEvents((event) => {
      var _source1$rigidBody$ev9, _source1$rigidBody$ev10, _source2$rigidBody$ev9, _source2$rigidBody$ev10, _source1$collider$eve9, _source1$collider$eve10, _source2$collider$eve9, _source2$collider$eve10;
      const source1 = getSourceFromColliderHandle(event.collider1());
      const source2 = getSourceFromColliderHandle(event.collider2());
      if (!(source1 !== null && source1 !== void 0 && source1.collider.object) || !(source2 !== null && source2 !== void 0 && source2.collider.object)) {
        return;
      }
      const collisionPayload1 = getCollisionPayloadFromSource(source1, source2);
      const collisionPayload2 = getCollisionPayloadFromSource(source2, source1);
      (_source1$rigidBody$ev9 = source1.rigidBody.events) === null || _source1$rigidBody$ev9 === void 0 ? void 0 : (_source1$rigidBody$ev10 = _source1$rigidBody$ev9.onContactForce) === null || _source1$rigidBody$ev10 === void 0 ? void 0 : _source1$rigidBody$ev10.call(_source1$rigidBody$ev9, _objectSpread2(_objectSpread2({}, collisionPayload1), {}, {
        totalForce: event.totalForce(),
        totalForceMagnitude: event.totalForceMagnitude(),
        maxForceDirection: event.maxForceDirection(),
        maxForceMagnitude: event.maxForceMagnitude()
      }));
      (_source2$rigidBody$ev9 = source2.rigidBody.events) === null || _source2$rigidBody$ev9 === void 0 ? void 0 : (_source2$rigidBody$ev10 = _source2$rigidBody$ev9.onContactForce) === null || _source2$rigidBody$ev10 === void 0 ? void 0 : _source2$rigidBody$ev10.call(_source2$rigidBody$ev9, _objectSpread2(_objectSpread2({}, collisionPayload2), {}, {
        totalForce: event.totalForce(),
        totalForceMagnitude: event.totalForceMagnitude(),
        maxForceDirection: event.maxForceDirection(),
        maxForceMagnitude: event.maxForceMagnitude()
      }));
      (_source1$collider$eve9 = source1.collider.events) === null || _source1$collider$eve9 === void 0 ? void 0 : (_source1$collider$eve10 = _source1$collider$eve9.onContactForce) === null || _source1$collider$eve10 === void 0 ? void 0 : _source1$collider$eve10.call(_source1$collider$eve9, _objectSpread2(_objectSpread2({}, collisionPayload1), {}, {
        totalForce: event.totalForce(),
        totalForceMagnitude: event.totalForceMagnitude(),
        maxForceDirection: event.maxForceDirection(),
        maxForceMagnitude: event.maxForceMagnitude()
      }));
      (_source2$collider$eve9 = source2.collider.events) === null || _source2$collider$eve9 === void 0 ? void 0 : (_source2$collider$eve10 = _source2$collider$eve9.onContactForce) === null || _source2$collider$eve10 === void 0 ? void 0 : _source2$collider$eve10.call(_source2$collider$eve9, _objectSpread2(_objectSpread2({}, collisionPayload2), {}, {
        totalForce: event.totalForce(),
        totalForceMagnitude: event.totalForceMagnitude(),
        maxForceDirection: event.maxForceDirection(),
        maxForceMagnitude: event.maxForceMagnitude()
      }));
    });
    world.forEachActiveRigidBody(() => {
      invalidate2();
    });
  }, [paused, timeStep, interpolate3, worldProxy]);
  const context4 = reactExports.useMemo(() => ({
    rapier,
    world: worldProxy,
    setWorld: (world) => {
      setWorldProxy(world);
    },
    physicsOptions: {
      colliders,
      gravity
    },
    rigidBodyStates,
    colliderStates,
    rigidBodyEvents,
    colliderEvents,
    beforeStepCallbacks,
    afterStepCallbacks,
    isPaused: paused,
    isDebug: debug,
    step
  }), [paused, step, debug, colliders, gravity]);
  const stepCallback = reactExports.useCallback((delta) => {
    if (!paused) {
      step(delta);
    }
  }, [paused, step]);
  return /* @__PURE__ */ React.createElement(rapierContext.Provider, {
    value: context4
  }, /* @__PURE__ */ React.createElement(FrameStepper$1, {
    onStep: stepCallback,
    type: updateLoop,
    updatePriority
  }), debug && /* @__PURE__ */ React.createElement(Debug, null), children);
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var t2 = arguments[e2];
      for (var r3 in t2) ({}).hasOwnProperty.call(t2, r3) && (n2[r3] = t2[r3]);
    }
    return n2;
  }, _extends.apply(null, arguments);
}
const useImperativeInstance = (createFn, destroyFn, dependencyList) => {
  const ref = reactExports.useRef();
  const getInstance = reactExports.useCallback(() => {
    if (!ref.current) {
      ref.current = createFn();
    }
    return ref.current;
  }, dependencyList);
  reactExports.useEffect(() => {
    const instance = getInstance();
    const destroy = () => destroyFn(instance);
    return () => {
      destroy();
      ref.current = void 0;
    };
  }, [getInstance]);
  return getInstance;
};
const vec3 = ({
  x: x3,
  y: y2,
  z: z2
} = {
  x: 0,
  y: 0,
  z: 0
}) => {
  return new Vector3(x3, y2, z2);
};
const useForwardedRef = (forwardedRef, defaultValue2 = null) => {
  const innerRef = reactExports.useRef(defaultValue2);
  if (forwardedRef && typeof forwardedRef !== "function") {
    if (!forwardedRef.current) {
      forwardedRef.current = innerRef.current;
    }
    return forwardedRef;
  }
  return innerRef;
};
const AnyCollider = /* @__PURE__ */ reactExports.memo(/* @__PURE__ */ reactExports.forwardRef((props, forwardedRef) => {
  const {
    children,
    position,
    rotation,
    quaternion,
    scale,
    name
  } = props;
  const {
    world,
    colliderEvents,
    colliderStates
  } = useRapier();
  const rigidBodyContext = useRigidBodyContext();
  const colliderRef = useForwardedRef(forwardedRef);
  const objectRef = reactExports.useRef(null);
  const immutablePropArray = immutableColliderOptions.flatMap((key) => Array.isArray(props[key]) ? [...props[key]] : props[key]);
  const getInstance = useImperativeInstance(() => {
    const worldScale = objectRef.current.getWorldScale(vec3());
    const collider = createColliderFromOptions(props, world, worldScale, rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.getRigidBody);
    if (typeof forwardedRef == "function") {
      forwardedRef(collider);
    }
    colliderRef.current = collider;
    return collider;
  }, (collider) => {
    if (world.getCollider(collider.handle)) {
      world.removeCollider(collider, true);
    }
  }, [...immutablePropArray, rigidBodyContext]);
  reactExports.useEffect(() => {
    const collider = getInstance();
    colliderStates.set(collider.handle, createColliderState(collider, objectRef.current, rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.ref.current));
    return () => {
      colliderStates.delete(collider.handle);
    };
  }, [getInstance]);
  const mergedProps = reactExports.useMemo(() => {
    return _objectSpread2(_objectSpread2({}, cleanRigidBodyPropsForCollider(rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.options)), props);
  }, [props, rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.options]);
  useUpdateColliderOptions(getInstance, mergedProps, colliderStates);
  useColliderEvents(getInstance, mergedProps, colliderEvents, getActiveCollisionEventsFromProps(rigidBodyContext === null || rigidBodyContext === void 0 ? void 0 : rigidBodyContext.options));
  return /* @__PURE__ */ React.createElement("object3D", {
    position,
    rotation,
    quaternion,
    scale,
    ref: objectRef,
    name
  }, children);
}));
const CuboidCollider = /* @__PURE__ */ React.forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
    shape: "cuboid",
    ref
  }));
});
CuboidCollider.displayName = "CuboidCollider";
const RoundCuboidCollider = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
  shape: "roundCuboid",
  ref
})));
RoundCuboidCollider.displayName = "RoundCuboidCollider";
const BallCollider = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
  shape: "ball",
  ref
})));
BallCollider.displayName = "BallCollider";
const CapsuleCollider = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
  shape: "capsule",
  ref
})));
CapsuleCollider.displayName = "CapsuleCollider";
const HeightfieldCollider = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
  shape: "heightfield",
  ref
})));
HeightfieldCollider.displayName = "HeightfieldCollider";
const TrimeshCollider = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
  shape: "trimesh",
  ref
})));
TrimeshCollider.displayName = "TrimeshCollider";
const ConeCollider = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
  shape: "cone",
  ref
})));
ConeCollider.displayName = "ConeCollider";
const RoundConeCollider = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
  shape: "roundCone",
  ref
})));
RoundConeCollider.displayName = "RoundConeCollider";
const CylinderCollider = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
  shape: "cylinder",
  ref
})));
CylinderCollider.displayName = "CylinderCollider";
CylinderCollider.displayName = "RoundCylinderCollider";
const ConvexHullCollider = /* @__PURE__ */ React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({}, props, {
  shape: "convexHull",
  ref
})));
ConvexHullCollider.displayName = "ConvexHullCollider";
const rigidBodyDescFromOptions = (options) => {
  var _options$canSleep;
  const type = rigidBodyTypeFromString((options === null || options === void 0 ? void 0 : options.type) || "dynamic");
  const desc = new GI(type);
  desc.canSleep = (_options$canSleep = options === null || options === void 0 ? void 0 : options.canSleep) !== null && _options$canSleep !== void 0 ? _options$canSleep : true;
  return desc;
};
const createRigidBodyState = ({
  rigidBody,
  object,
  setMatrix,
  getMatrix,
  worldScale,
  meshType: _meshType = "mesh"
}) => {
  object.updateWorldMatrix(true, false);
  const invertedWorldMatrix = object.parent.matrixWorld.clone().invert();
  return {
    object,
    rigidBody,
    invertedWorldMatrix,
    setMatrix: setMatrix ? setMatrix : (matrix) => {
      object.matrix.copy(matrix);
    },
    getMatrix: getMatrix ? getMatrix : (matrix) => matrix.copy(object.matrix),
    scale: worldScale || object.getWorldScale(_scale).clone(),
    isSleeping: false,
    meshType: _meshType
  };
};
const immutableRigidBodyOptions = ["args", "colliders", "canSleep"];
const mutableRigidBodyOptions = {
  gravityScale: (rb, value) => {
    rb.setGravityScale(value, true);
  },
  additionalSolverIterations(rb, value) {
    rb.setAdditionalSolverIterations(value);
  },
  linearDamping: (rb, value) => {
    rb.setLinearDamping(value);
  },
  angularDamping: (rb, value) => {
    rb.setAngularDamping(value);
  },
  dominanceGroup: (rb, value) => {
    rb.setDominanceGroup(value);
  },
  enabledRotations: (rb, [x3, y2, z2]) => {
    rb.setEnabledRotations(x3, y2, z2, true);
  },
  enabledTranslations: (rb, [x3, y2, z2]) => {
    rb.setEnabledTranslations(x3, y2, z2, true);
  },
  lockRotations: (rb, value) => {
    rb.lockRotations(value, true);
  },
  lockTranslations: (rb, value) => {
    rb.lockTranslations(value, true);
  },
  angularVelocity: (rb, [x3, y2, z2]) => {
    rb.setAngvel({
      x: x3,
      y: y2,
      z: z2
    }, true);
  },
  linearVelocity: (rb, [x3, y2, z2]) => {
    rb.setLinvel({
      x: x3,
      y: y2,
      z: z2
    }, true);
  },
  ccd: (rb, value) => {
    rb.enableCcd(value);
  },
  softCcdPrediction: (rb, value) => {
    rb.setSoftCcdPrediction(value);
  },
  userData: (rb, value) => {
    rb.userData = value;
  },
  type(rb, value) {
    rb.setBodyType(rigidBodyTypeFromString(value), true);
  },
  position: () => {
  },
  rotation: () => {
  },
  quaternion: () => {
  },
  scale: () => {
  }
};
const mutableRigidBodyOptionKeys = Object.keys(mutableRigidBodyOptions);
const setRigidBodyOptions = (rigidBody, options, states, updateTranslations = true) => {
  if (!rigidBody) {
    return;
  }
  const state = states.get(rigidBody.handle);
  if (state) {
    if (updateTranslations) {
      state.object.updateWorldMatrix(true, false);
      _matrix4.copy(state.object.matrixWorld).decompose(_position, _rotation, _scale);
      rigidBody.setTranslation(_position, false);
      rigidBody.setRotation(_rotation, false);
    }
    mutableRigidBodyOptionKeys.forEach((key) => {
      if (key in options) {
        mutableRigidBodyOptions[key](rigidBody, options[key]);
      }
    });
  }
};
const useUpdateRigidBodyOptions = (getRigidBody, props, states, updateTranslations = true) => {
  const mutablePropsAsFlatArray = reactExports.useMemo(() => mutableRigidBodyOptionKeys.flatMap((key) => {
    return vectorToTuple(props[key]);
  }), [props]);
  reactExports.useEffect(() => {
    const rigidBody = getRigidBody();
    setRigidBodyOptions(rigidBody, props, states, updateTranslations);
  }, mutablePropsAsFlatArray);
};
const useRigidBodyEvents = (getRigidBody, props, events) => {
  const {
    onWake,
    onSleep,
    onCollisionEnter,
    onCollisionExit,
    onIntersectionEnter,
    onIntersectionExit,
    onContactForce
  } = props;
  const eventHandlers = {
    onWake,
    onSleep,
    onCollisionEnter,
    onCollisionExit,
    onIntersectionEnter,
    onIntersectionExit,
    onContactForce
  };
  reactExports.useEffect(() => {
    const rigidBody = getRigidBody();
    events.set(rigidBody.handle, eventHandlers);
    return () => {
      events.delete(rigidBody.handle);
    };
  }, [onWake, onSleep, onCollisionEnter, onCollisionExit, onIntersectionEnter, onIntersectionExit, onContactForce]);
};
const _excluded$1$1 = ["children", "type", "position", "rotation", "scale", "quaternion", "transformState"];
const RigidBodyContext = /* @__PURE__ */ reactExports.createContext(void 0);
const useRigidBodyContext = () => reactExports.useContext(RigidBodyContext);
const RigidBody = /* @__PURE__ */ reactExports.memo(/* @__PURE__ */ reactExports.forwardRef((props, forwardedRef) => {
  const {
    children,
    type,
    position,
    rotation,
    scale,
    quaternion,
    transformState
  } = props, objectProps = _objectWithoutProperties(props, _excluded$1$1);
  const objectRef = reactExports.useRef(null);
  const rigidBodyRef = useForwardedRef(forwardedRef);
  const {
    world,
    rigidBodyStates,
    physicsOptions,
    rigidBodyEvents
  } = useRapier();
  const mergedOptions = reactExports.useMemo(() => {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, physicsOptions), props), {}, {
      children: void 0
    });
  }, [physicsOptions, props]);
  const immutablePropArray = immutableRigidBodyOptions.flatMap((key) => {
    return Array.isArray(mergedOptions[key]) ? [...mergedOptions[key]] : mergedOptions[key];
  });
  const childColliderProps = useChildColliderProps(objectRef, mergedOptions);
  const getRigidBody = useImperativeInstance(() => {
    const desc = rigidBodyDescFromOptions(mergedOptions);
    const rigidBody = world.createRigidBody(desc);
    if (typeof forwardedRef === "function") {
      forwardedRef(rigidBody);
    }
    rigidBodyRef.current = rigidBody;
    return rigidBody;
  }, (rigidBody) => {
    if (world.getRigidBody(rigidBody.handle)) {
      world.removeRigidBody(rigidBody);
    }
  }, immutablePropArray);
  reactExports.useEffect(() => {
    const rigidBody = getRigidBody();
    const state = createRigidBodyState({
      rigidBody,
      object: objectRef.current
    });
    rigidBodyStates.set(rigidBody.handle, props.transformState ? props.transformState(state) : state);
    return () => {
      rigidBodyStates.delete(rigidBody.handle);
    };
  }, [getRigidBody]);
  useUpdateRigidBodyOptions(getRigidBody, mergedOptions, rigidBodyStates);
  useRigidBodyEvents(getRigidBody, mergedOptions, rigidBodyEvents);
  const contextValue = reactExports.useMemo(() => {
    return {
      ref: objectRef,
      getRigidBody,
      options: mergedOptions
    };
  }, [getRigidBody]);
  return /* @__PURE__ */ React.createElement(RigidBodyContext.Provider, {
    value: contextValue
  }, /* @__PURE__ */ React.createElement("object3D", _extends({
    ref: objectRef
  }, objectProps, {
    position,
    rotation,
    quaternion,
    scale
  }), children, childColliderProps.map((colliderProps, index) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({
    key: index
  }, colliderProps)))));
}));
RigidBody.displayName = "RigidBody";
const MeshCollider = /* @__PURE__ */ reactExports.memo((props) => {
  const {
    children,
    type
  } = props;
  const {
    physicsOptions
  } = useRapier();
  const object = reactExports.useRef(null);
  const {
    options
  } = useRigidBodyContext();
  const mergedOptions = reactExports.useMemo(() => {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, physicsOptions), options), {}, {
      children: void 0,
      colliders: type
    });
  }, [physicsOptions, options]);
  const childColliderProps = useChildColliderProps(object, mergedOptions, false);
  return /* @__PURE__ */ React.createElement("object3D", {
    ref: object,
    userData: {
      r3RapierType: "MeshCollider"
    }
  }, children, childColliderProps.map((colliderProps, index) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({
    key: index
  }, colliderProps))));
});
MeshCollider.displayName = "MeshCollider";
const _excluded = ["children", "instances", "colliderNodes", "position", "rotation", "quaternion", "scale"];
const InstancedRigidBodies = /* @__PURE__ */ reactExports.memo(/* @__PURE__ */ reactExports.forwardRef((props, forwardedRef) => {
  const rigidBodiesRef = useForwardedRef(forwardedRef, []);
  const objectRef = reactExports.useRef(null);
  const instanceWrapperRef = reactExports.useRef(null);
  const {
    // instanced props
    children,
    instances: instances2,
    colliderNodes = [],
    // wrapper object props
    position,
    rotation,
    quaternion,
    scale
    // rigid body specific props, and r3f-object props
  } = props, rigidBodyProps = _objectWithoutProperties(props, _excluded);
  const childColliderProps = useChildColliderProps(objectRef, _objectSpread2(_objectSpread2({}, props), {}, {
    children: void 0
  }));
  const getInstancedMesh = () => {
    const firstChild = instanceWrapperRef.current.children[0];
    if (firstChild && "isInstancedMesh" in firstChild) {
      return firstChild;
    }
    return void 0;
  };
  reactExports.useEffect(() => {
    const instancedMesh = getInstancedMesh();
    if (instancedMesh) {
      instancedMesh.instanceMatrix.setUsage(DynamicDrawUsage);
    } else {
      console.warn("InstancedRigidBodies expects exactly one child, which must be an InstancedMesh");
    }
  }, []);
  const applyInstancedState = (state, index) => {
    const instancedMesh = getInstancedMesh();
    if (instancedMesh) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        getMatrix: (matrix) => {
          instancedMesh.getMatrixAt(index, matrix);
          return matrix;
        },
        setMatrix: (matrix) => {
          instancedMesh.setMatrixAt(index, matrix);
          instancedMesh.instanceMatrix.needsUpdate = true;
        },
        meshType: "instancedMesh"
      });
    }
    return state;
  };
  return /* @__PURE__ */ React.createElement("object3D", _extends({
    ref: objectRef
  }, rigidBodyProps, {
    position,
    rotation,
    quaternion,
    scale
  }), /* @__PURE__ */ React.createElement("object3D", {
    ref: instanceWrapperRef
  }, children), instances2 === null || instances2 === void 0 ? void 0 : instances2.map((instance, index) => /* @__PURE__ */ React.createElement(RigidBody, _extends({}, rigidBodyProps, instance, {
    ref: (body) => rigidBodiesRef.current[index] = body,
    transformState: (state) => applyInstancedState(state, index)
  }), /* @__PURE__ */ React.createElement(React.Fragment, null, colliderNodes.map((node, index2) => /* @__PURE__ */ React.createElement(reactExports.Fragment, {
    key: index2
  }, node)), childColliderProps.map((colliderProps, colliderIndex) => /* @__PURE__ */ React.createElement(AnyCollider, _extends({
    key: colliderIndex
  }, colliderProps)))))));
}));
InstancedRigidBodies.displayName = "InstancedRigidBodies";
const PHYSICS_CONFIG = {
  defaultMass: 0
};
function parsePhysicsType(userData) {
  const dynamicMass = parseInt(userData.Dynamic, 10) || PHYSICS_CONFIG.defaultMass;
  return {
    type: dynamicMass > 0 ? "dynamic" : "fixed",
    mass: dynamicMass
  };
}
function isInvisible(userData) {
  return userData.Invisible === "true";
}
function isStatic(userData) {
  return userData.Static === "true";
}
function getAnimationNames(userData) {
  return [
    ...userData.OnSelectAnimations || [],
    ...userData.OnPointerEnterAnimations || [],
    ...userData.OnPointerExitAnimations || [],
    ...userData.LoopingAnimations || []
  ];
}
function PhysicsRigidBody({
  obj,
  physicsType,
  mass,
  invisible,
  callbacks,
  actions,
  rigidBodyRef
}) {
  useFrame(() => {
    if (!rigidBodyRef.current) return;
    const { obj: sourceObj, actions: boundActions } = rigidBodyRef.current.userData || {};
    if (!sourceObj || !boundActions?.length) return;
    boundActions.forEach((action) => {
      if (action?.isRunning()) {
        rigidBodyRef.current.setTranslation(sourceObj.position, true);
        rigidBodyRef.current.setRotation(sourceObj.quaternion, true);
      }
    });
  });
  const userData = reactExports.useMemo(() => ({
    obj,
    actions
  }), [obj, actions]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RigidBody,
    {
      type: physicsType,
      mass,
      ...callbacks,
      userData,
      ref: rigidBodyRef,
      position: obj.position,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "primitive",
        {
          object: obj.clone(),
          position: [0, 0, 0],
          visible: !invisible
        }
      )
    }
  );
}
function PhysicsObjects({ sceneManager, interactionManager, isDebugging }) {
  const [physicsData, setPhysicsData] = reactExports.useState(null);
  const rigidBodyRefs = reactExports.useRef({});
  const getActions = reactExports.useCallback((obj) => {
    const boundActions = sceneManager.getBoundedActions(obj);
    const animationNames = getAnimationNames(obj.userData);
    if (boundActions.length > 0 || animationNames.length > 0) {
      const actions = [...boundActions];
      animationNames.forEach((name) => {
        const action = sceneManager.getAnimationAction(name);
        if (action) {
          actions.push(action);
        }
      });
      return actions;
    }
    return null;
  }, [sceneManager]);
  const getCallbacks = reactExports.useCallback((obj) => {
    const callbacks = {};
    const userData = obj.userData || {};
    const hasSelectTrigger = userData.OnSelectAnimations || userData.mediaTrigger === "OnSelect" || userData.type === "interactable";
    const hasEnterTrigger = userData.OnPointerEnterAnimations || userData.mediaTrigger === "OnPointerEnter" || userData.type === "interactable";
    const hasExitTrigger = userData.OnPointerExitAnimations || userData.mediaTrigger === "OnPointerExit" || userData.type === "interactable";
    if (hasSelectTrigger) {
      callbacks.onClick = (event) => {
        event.object = obj;
        interactionManager?.handleInteraction(event);
      };
    }
    if (hasEnterTrigger) {
      callbacks.onPointerEnter = (event) => {
        event.object = obj;
        interactionManager?.handlePointerEnter(event);
      };
    }
    if (hasExitTrigger) {
      callbacks.onPointerLeave = (event) => {
        event.object = obj;
        interactionManager?.handlePointerExit(event);
      };
    }
    return callbacks;
  }, [interactionManager]);
  reactExports.useEffect(() => {
    if (!sceneManager) return;
    const physicsObjects = sceneManager.getPhysicsObjects();
    if (physicsObjects.length === 0) {
      setPhysicsData(null);
      return;
    }
    let hasInvisible = false;
    const processedObjects = [];
    physicsObjects.forEach((obj, index) => {
      const userData = obj.userData || {};
      const { type: physicsType, mass } = parsePhysicsType(userData);
      const invisible = isInvisible(userData);
      const staticObj = isStatic(userData);
      hasInvisible = hasInvisible || invisible;
      obj.visible = false;
      const actions = getActions(obj);
      const callbacks = getCallbacks(obj);
      if (!rigidBodyRefs.current[index]) {
        rigidBodyRefs.current[index] = React.createRef();
      }
      if (mass > 0 || staticObj) {
        processedObjects.push({
          obj,
          physicsType,
          mass,
          invisible,
          callbacks,
          actions,
          refIndex: index
        });
      }
    });
    setPhysicsData({
      objects: processedObjects,
      includeInvisible: hasInvisible
    });
  }, [sceneManager, getActions, getCallbacks]);
  if (!physicsData || physicsData.objects.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Physics, { debug: isDebugging, includeInvisible: physicsData.includeInvisible, children: physicsData.objects.map((item, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    PhysicsRigidBody,
    {
      obj: item.obj,
      physicsType: item.physicsType,
      mass: item.mass,
      invisible: item.invisible,
      callbacks: item.callbacks,
      actions: item.actions,
      rigidBodyRef: rigidBodyRefs.current[item.refIndex]
    },
    `physics-${item.obj.name || index}`
  )) });
}
const MOUSE_BUTTON = {
  LEFT: 1,
  RIGHT: 2,
  MIDDLE: 4
};
const ACTION = Object.freeze({
  NONE: 0,
  ROTATE: 1,
  TRUCK: 2,
  SCREEN_PAN: 4,
  OFFSET: 8,
  DOLLY: 16,
  ZOOM: 32,
  TOUCH_ROTATE: 64,
  TOUCH_TRUCK: 128,
  TOUCH_SCREEN_PAN: 256,
  TOUCH_OFFSET: 512,
  TOUCH_DOLLY: 1024,
  TOUCH_ZOOM: 2048,
  TOUCH_DOLLY_TRUCK: 4096,
  TOUCH_DOLLY_SCREEN_PAN: 8192,
  TOUCH_DOLLY_OFFSET: 16384,
  TOUCH_DOLLY_ROTATE: 32768,
  TOUCH_ZOOM_TRUCK: 65536,
  TOUCH_ZOOM_OFFSET: 131072,
  TOUCH_ZOOM_SCREEN_PAN: 262144,
  TOUCH_ZOOM_ROTATE: 524288
});
const DOLLY_DIRECTION = {
  NONE: 0,
  IN: 1,
  OUT: -1
};
function isPerspectiveCamera(camera) {
  return camera.isPerspectiveCamera;
}
function isOrthographicCamera(camera) {
  return camera.isOrthographicCamera;
}
const PI_2 = Math.PI * 2;
const PI_HALF = Math.PI / 2;
const EPSILON = 1e-5;
const DEG2RAD = Math.PI / 180;
function clamp2(value, min, max2) {
  return Math.max(min, Math.min(max2, value));
}
function approxZero(number, error2 = EPSILON) {
  return Math.abs(number) < error2;
}
function approxEquals(a5, b6, error2 = EPSILON) {
  return approxZero(a5 - b6, error2);
}
function roundToStep(value, step) {
  return Math.round(value / step) * step;
}
function infinityToMaxNumber(value) {
  if (isFinite(value))
    return value;
  if (value < 0)
    return -Number.MAX_VALUE;
  return Number.MAX_VALUE;
}
function maxNumberToInfinity(value) {
  if (Math.abs(value) < Number.MAX_VALUE)
    return value;
  return value * Infinity;
}
function smoothDamp(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime) {
  smoothTime = Math.max(1e-4, smoothTime);
  const omega = 2 / smoothTime;
  const x3 = omega * deltaTime;
  const exp3 = 1 / (1 + x3 + 0.48 * x3 * x3 + 0.235 * x3 * x3 * x3);
  let change = current - target;
  const originalTo = target;
  const maxChange = maxSpeed * smoothTime;
  change = clamp2(change, -maxChange, maxChange);
  target = current - change;
  const temp = (currentVelocityRef.value + omega * change) * deltaTime;
  currentVelocityRef.value = (currentVelocityRef.value - omega * temp) * exp3;
  let output = target + (change + temp) * exp3;
  if (originalTo - current > 0 === output > originalTo) {
    output = originalTo;
    currentVelocityRef.value = (output - originalTo) / deltaTime;
  }
  return output;
}
function smoothDampVec3(current, target, currentVelocityRef, smoothTime, maxSpeed = Infinity, deltaTime, out7) {
  smoothTime = Math.max(1e-4, smoothTime);
  const omega = 2 / smoothTime;
  const x3 = omega * deltaTime;
  const exp3 = 1 / (1 + x3 + 0.48 * x3 * x3 + 0.235 * x3 * x3 * x3);
  let targetX = target.x;
  let targetY = target.y;
  let targetZ = target.z;
  let changeX = current.x - targetX;
  let changeY = current.y - targetY;
  let changeZ = current.z - targetZ;
  const originalToX = targetX;
  const originalToY = targetY;
  const originalToZ = targetZ;
  const maxChange = maxSpeed * smoothTime;
  const maxChangeSq = maxChange * maxChange;
  const magnitudeSq = changeX * changeX + changeY * changeY + changeZ * changeZ;
  if (magnitudeSq > maxChangeSq) {
    const magnitude = Math.sqrt(magnitudeSq);
    changeX = changeX / magnitude * maxChange;
    changeY = changeY / magnitude * maxChange;
    changeZ = changeZ / magnitude * maxChange;
  }
  targetX = current.x - changeX;
  targetY = current.y - changeY;
  targetZ = current.z - changeZ;
  const tempX = (currentVelocityRef.x + omega * changeX) * deltaTime;
  const tempY = (currentVelocityRef.y + omega * changeY) * deltaTime;
  const tempZ = (currentVelocityRef.z + omega * changeZ) * deltaTime;
  currentVelocityRef.x = (currentVelocityRef.x - omega * tempX) * exp3;
  currentVelocityRef.y = (currentVelocityRef.y - omega * tempY) * exp3;
  currentVelocityRef.z = (currentVelocityRef.z - omega * tempZ) * exp3;
  out7.x = targetX + (changeX + tempX) * exp3;
  out7.y = targetY + (changeY + tempY) * exp3;
  out7.z = targetZ + (changeZ + tempZ) * exp3;
  const origMinusCurrentX = originalToX - current.x;
  const origMinusCurrentY = originalToY - current.y;
  const origMinusCurrentZ = originalToZ - current.z;
  const outMinusOrigX = out7.x - originalToX;
  const outMinusOrigY = out7.y - originalToY;
  const outMinusOrigZ = out7.z - originalToZ;
  if (origMinusCurrentX * outMinusOrigX + origMinusCurrentY * outMinusOrigY + origMinusCurrentZ * outMinusOrigZ > 0) {
    out7.x = originalToX;
    out7.y = originalToY;
    out7.z = originalToZ;
    currentVelocityRef.x = (out7.x - originalToX) / deltaTime;
    currentVelocityRef.y = (out7.y - originalToY) / deltaTime;
    currentVelocityRef.z = (out7.z - originalToZ) / deltaTime;
  }
  return out7;
}
function extractClientCoordFromEvent(pointers, out7) {
  out7.set(0, 0);
  pointers.forEach((pointer) => {
    out7.x += pointer.clientX;
    out7.y += pointer.clientY;
  });
  out7.x /= pointers.length;
  out7.y /= pointers.length;
}
function notSupportedInOrthographicCamera(camera, message) {
  if (isOrthographicCamera(camera)) {
    console.warn(`${message} is not supported in OrthographicCamera`);
    return true;
  }
  return false;
}
class EventDispatcher3 {
  constructor() {
    this._listeners = {};
  }
  /**
   * Adds the specified event listener.
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  addEventListener(type, listener) {
    const listeners = this._listeners;
    if (listeners[type] === void 0)
      listeners[type] = [];
    if (listeners[type].indexOf(listener) === -1)
      listeners[type].push(listener);
  }
  /**
   * Presence of the specified event listener.
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  hasEventListener(type, listener) {
    const listeners = this._listeners;
    return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
  }
  /**
   * Removes the specified event listener
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  removeEventListener(type, listener) {
    const listeners = this._listeners;
    const listenerArray = listeners[type];
    if (listenerArray !== void 0) {
      const index = listenerArray.indexOf(listener);
      if (index !== -1)
        listenerArray.splice(index, 1);
    }
  }
  /**
   * Removes all event listeners
   * @param type event name
   * @category Methods
   */
  removeAllEventListeners(type) {
    if (!type) {
      this._listeners = {};
      return;
    }
    if (Array.isArray(this._listeners[type]))
      this._listeners[type].length = 0;
  }
  /**
   * Fire an event type.
   * @param event DispatcherEvent
   * @category Methods
   */
  dispatchEvent(event) {
    const listeners = this._listeners;
    const listenerArray = listeners[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array = listenerArray.slice(0);
      for (let i2 = 0, l2 = array.length; i2 < l2; i2++) {
        array[i2].call(this, event);
      }
    }
  }
}
var _a;
const VERSION = "2.10.1";
const TOUCH_DOLLY_FACTOR = 1 / 8;
const isMac = /Mac/.test((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.platform);
let THREE;
let _ORIGIN;
let _AXIS_Y;
let _AXIS_Z;
let _v2;
let _v3A;
let _v3B;
let _v3C;
let _cameraDirection;
let _xColumn;
let _yColumn;
let _zColumn;
let _deltaTarget;
let _deltaOffset;
let _sphericalA;
let _sphericalB;
let _box3A;
let _box3B;
let _sphere;
let _quaternionA;
let _quaternionB;
let _rotationMatrix;
let _raycaster;
class CameraControls2 extends EventDispatcher3 {
  /**
       * Injects THREE as the dependency. You can then proceed to use CameraControls.
       *
       * e.g
       * ```javascript
       * CameraControls.install( { THREE: THREE } );
       * ```
       *
       * Note: If you do not wish to use enter three.js to reduce file size(tree-shaking for example), make a subset to install.
       *
       * ```js
       * import {
       * 	Vector2,
       * 	Vector3,
       * 	Vector4,
       * 	Quaternion,
       * 	Matrix4,
       * 	Spherical,
       * 	Box3,
       * 	Sphere,
       * 	Raycaster,
       * 	MathUtils,
       * } from 'three';
       *
       * const subsetOfTHREE = {
       * 	Vector2   : Vector2,
       * 	Vector3   : Vector3,
       * 	Vector4   : Vector4,
       * 	Quaternion: Quaternion,
       * 	Matrix4   : Matrix4,
       * 	Spherical : Spherical,
       * 	Box3      : Box3,
       * 	Sphere    : Sphere,
       * 	Raycaster : Raycaster,
       * };
  
       * CameraControls.install( { THREE: subsetOfTHREE } );
       * ```
       * @category Statics
       */
  static install(libs) {
    THREE = libs.THREE;
    _ORIGIN = Object.freeze(new THREE.Vector3(0, 0, 0));
    _AXIS_Y = Object.freeze(new THREE.Vector3(0, 1, 0));
    _AXIS_Z = Object.freeze(new THREE.Vector3(0, 0, 1));
    _v2 = new THREE.Vector2();
    _v3A = new THREE.Vector3();
    _v3B = new THREE.Vector3();
    _v3C = new THREE.Vector3();
    _cameraDirection = new THREE.Vector3();
    _xColumn = new THREE.Vector3();
    _yColumn = new THREE.Vector3();
    _zColumn = new THREE.Vector3();
    _deltaTarget = new THREE.Vector3();
    _deltaOffset = new THREE.Vector3();
    _sphericalA = new THREE.Spherical();
    _sphericalB = new THREE.Spherical();
    _box3A = new THREE.Box3();
    _box3B = new THREE.Box3();
    _sphere = new THREE.Sphere();
    _quaternionA = new THREE.Quaternion();
    _quaternionB = new THREE.Quaternion();
    _rotationMatrix = new THREE.Matrix4();
    _raycaster = new THREE.Raycaster();
  }
  /**
   * list all ACTIONs
   * @category Statics
   */
  static get ACTION() {
    return ACTION;
  }
  /**
   * @deprecated Use `cameraControls.mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.
   */
  set verticalDragToForward(_2) {
    console.warn("camera-controls: `verticalDragToForward` was removed. Use `mouseButtons.left = CameraControls.ACTION.SCREEN_PAN` instead.");
  }
  /**
   * Creates a `CameraControls` instance.
   *
   * Note:
   * You **must install** three.js before using camera-controls. see [#install](#install)
   * Not doing so will lead to runtime errors (`undefined` references to THREE).
   *
   * e.g.
   * ```
   * CameraControls.install( { THREE } );
   * const cameraControls = new CameraControls( camera, domElement );
   * ```
   *
   * @param camera A `THREE.PerspectiveCamera` or `THREE.OrthographicCamera` to be controlled.
   * @param domElement A `HTMLElement` for the draggable area, usually `renderer.domElement`.
   * @category Constructor
   */
  constructor(camera, domElement) {
    super();
    this.minPolarAngle = 0;
    this.maxPolarAngle = Math.PI;
    this.minAzimuthAngle = -Infinity;
    this.maxAzimuthAngle = Infinity;
    this.minDistance = Number.EPSILON;
    this.maxDistance = Infinity;
    this.infinityDolly = false;
    this.minZoom = 0.01;
    this.maxZoom = Infinity;
    this.smoothTime = 0.25;
    this.draggingSmoothTime = 0.125;
    this.maxSpeed = Infinity;
    this.azimuthRotateSpeed = 1;
    this.polarRotateSpeed = 1;
    this.dollySpeed = 1;
    this.dollyDragInverted = false;
    this.truckSpeed = 2;
    this.dollyToCursor = false;
    this.dragToOffset = false;
    this.boundaryFriction = 0;
    this.restThreshold = 0.01;
    this.colliderMeshes = [];
    this.cancel = () => {
    };
    this._enabled = true;
    this._state = ACTION.NONE;
    this._viewport = null;
    this._changedDolly = 0;
    this._changedZoom = 0;
    this._hasRested = true;
    this._boundaryEnclosesCamera = false;
    this._needsUpdate = true;
    this._updatedLastTime = false;
    this._elementRect = new DOMRect();
    this._isDragging = false;
    this._dragNeedsUpdate = true;
    this._activePointers = [];
    this._lockedPointer = null;
    this._interactiveArea = new DOMRect(0, 0, 1, 1);
    this._isUserControllingRotate = false;
    this._isUserControllingDolly = false;
    this._isUserControllingTruck = false;
    this._isUserControllingOffset = false;
    this._isUserControllingZoom = false;
    this._lastDollyDirection = DOLLY_DIRECTION.NONE;
    this._thetaVelocity = { value: 0 };
    this._phiVelocity = { value: 0 };
    this._radiusVelocity = { value: 0 };
    this._targetVelocity = new THREE.Vector3();
    this._focalOffsetVelocity = new THREE.Vector3();
    this._zoomVelocity = { value: 0 };
    this._truckInternal = (deltaX, deltaY, dragToOffset, screenSpacePanning) => {
      let truckX;
      let pedestalY;
      if (isPerspectiveCamera(this._camera)) {
        const offset = _v3A.copy(this._camera.position).sub(this._target);
        const fov2 = this._camera.getEffectiveFOV() * DEG2RAD;
        const targetDistance = offset.length() * Math.tan(fov2 * 0.5);
        truckX = this.truckSpeed * deltaX * targetDistance / this._elementRect.height;
        pedestalY = this.truckSpeed * deltaY * targetDistance / this._elementRect.height;
      } else if (isOrthographicCamera(this._camera)) {
        const camera2 = this._camera;
        truckX = this.truckSpeed * deltaX * (camera2.right - camera2.left) / camera2.zoom / this._elementRect.width;
        pedestalY = this.truckSpeed * deltaY * (camera2.top - camera2.bottom) / camera2.zoom / this._elementRect.height;
      } else {
        return;
      }
      if (screenSpacePanning) {
        dragToOffset ? this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y, this._focalOffsetEnd.z, true) : this.truck(truckX, 0, true);
        this.forward(-pedestalY, true);
      } else {
        dragToOffset ? this.setFocalOffset(this._focalOffsetEnd.x + truckX, this._focalOffsetEnd.y + pedestalY, this._focalOffsetEnd.z, true) : this.truck(truckX, pedestalY, true);
      }
    };
    this._rotateInternal = (deltaX, deltaY) => {
      const theta = PI_2 * this.azimuthRotateSpeed * deltaX / this._elementRect.height;
      const phi = PI_2 * this.polarRotateSpeed * deltaY / this._elementRect.height;
      this.rotate(theta, phi, true);
    };
    this._dollyInternal = (delta, x3, y2) => {
      const dollyScale = Math.pow(0.95, -delta * this.dollySpeed);
      const lastDistance = this._sphericalEnd.radius;
      const distance = this._sphericalEnd.radius * dollyScale;
      const clampedDistance = clamp2(distance, this.minDistance, this.maxDistance);
      const overflowedDistance = clampedDistance - distance;
      if (this.infinityDolly && this.dollyToCursor) {
        this._dollyToNoClamp(distance, true);
      } else if (this.infinityDolly && !this.dollyToCursor) {
        this.dollyInFixed(overflowedDistance, true);
        this._dollyToNoClamp(clampedDistance, true);
      } else {
        this._dollyToNoClamp(clampedDistance, true);
      }
      if (this.dollyToCursor) {
        this._changedDolly += (this.infinityDolly ? distance : clampedDistance) - lastDistance;
        this._dollyControlCoord.set(x3, y2);
      }
      this._lastDollyDirection = Math.sign(-delta);
    };
    this._zoomInternal = (delta, x3, y2) => {
      const zoomScale = Math.pow(0.95, delta * this.dollySpeed);
      const lastZoom = this._zoom;
      const zoom = this._zoom * zoomScale;
      this.zoomTo(zoom, true);
      if (this.dollyToCursor) {
        this._changedZoom += zoom - lastZoom;
        this._dollyControlCoord.set(x3, y2);
      }
    };
    if (typeof THREE === "undefined") {
      console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information.");
    }
    this._camera = camera;
    this._yAxisUpSpace = new THREE.Quaternion().setFromUnitVectors(this._camera.up, _AXIS_Y);
    this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert();
    this._state = ACTION.NONE;
    this._target = new THREE.Vector3();
    this._targetEnd = this._target.clone();
    this._focalOffset = new THREE.Vector3();
    this._focalOffsetEnd = this._focalOffset.clone();
    this._spherical = new THREE.Spherical().setFromVector3(_v3A.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace));
    this._sphericalEnd = this._spherical.clone();
    this._lastDistance = this._spherical.radius;
    this._zoom = this._camera.zoom;
    this._zoomEnd = this._zoom;
    this._lastZoom = this._zoom;
    this._nearPlaneCorners = [
      new THREE.Vector3(),
      new THREE.Vector3(),
      new THREE.Vector3(),
      new THREE.Vector3()
    ];
    this._updateNearPlaneCorners();
    this._boundary = new THREE.Box3(new THREE.Vector3(-Infinity, -Infinity, -Infinity), new THREE.Vector3(Infinity, Infinity, Infinity));
    this._cameraUp0 = this._camera.up.clone();
    this._target0 = this._target.clone();
    this._position0 = this._camera.position.clone();
    this._zoom0 = this._zoom;
    this._focalOffset0 = this._focalOffset.clone();
    this._dollyControlCoord = new THREE.Vector2();
    this.mouseButtons = {
      left: ACTION.ROTATE,
      middle: ACTION.DOLLY,
      right: ACTION.TRUCK,
      wheel: isPerspectiveCamera(this._camera) ? ACTION.DOLLY : isOrthographicCamera(this._camera) ? ACTION.ZOOM : ACTION.NONE
    };
    this.touches = {
      one: ACTION.TOUCH_ROTATE,
      two: isPerspectiveCamera(this._camera) ? ACTION.TOUCH_DOLLY_TRUCK : isOrthographicCamera(this._camera) ? ACTION.TOUCH_ZOOM_TRUCK : ACTION.NONE,
      three: ACTION.TOUCH_TRUCK
    };
    const dragStartPosition = new THREE.Vector2();
    const lastDragPosition = new THREE.Vector2();
    const dollyStart = new THREE.Vector2();
    const onPointerDown = (event) => {
      if (!this._enabled || !this._domElement)
        return;
      if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
        const elRect = this._domElement.getBoundingClientRect();
        const left = event.clientX / elRect.width;
        const top = event.clientY / elRect.height;
        if (left < this._interactiveArea.left || left > this._interactiveArea.right || top < this._interactiveArea.top || top > this._interactiveArea.bottom)
          return;
      }
      const mouseButton = event.pointerType !== "mouse" ? null : (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT ? MOUSE_BUTTON.LEFT : (event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.MIDDLE ? MOUSE_BUTTON.MIDDLE : (event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.RIGHT ? MOUSE_BUTTON.RIGHT : null;
      if (mouseButton !== null) {
        const zombiePointer = this._findPointerByMouseButton(mouseButton);
        zombiePointer && this._disposePointer(zombiePointer);
      }
      if ((event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT && this._lockedPointer)
        return;
      const pointer = {
        pointerId: event.pointerId,
        clientX: event.clientX,
        clientY: event.clientY,
        deltaX: 0,
        deltaY: 0,
        mouseButton
      };
      this._activePointers.push(pointer);
      this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
      this._domElement.ownerDocument.addEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.addEventListener("pointerup", onPointerUp);
      this._isDragging = true;
      startDragging(event);
    };
    const onPointerMove = (event) => {
      if (event.cancelable)
        event.preventDefault();
      const pointerId = event.pointerId;
      const pointer = this._lockedPointer || this._findPointerById(pointerId);
      if (!pointer)
        return;
      pointer.clientX = event.clientX;
      pointer.clientY = event.clientY;
      pointer.deltaX = event.movementX;
      pointer.deltaY = event.movementY;
      this._state = 0;
      if (event.pointerType === "touch") {
        switch (this._activePointers.length) {
          case 1:
            this._state = this.touches.one;
            break;
          case 2:
            this._state = this.touches.two;
            break;
          case 3:
            this._state = this.touches.three;
            break;
        }
      } else {
        if (!this._isDragging && this._lockedPointer || this._isDragging && (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT) {
          this._state = this._state | this.mouseButtons.left;
        }
        if (this._isDragging && (event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.MIDDLE) {
          this._state = this._state | this.mouseButtons.middle;
        }
        if (this._isDragging && (event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.RIGHT) {
          this._state = this._state | this.mouseButtons.right;
        }
      }
      dragging();
    };
    const onPointerUp = (event) => {
      const pointer = this._findPointerById(event.pointerId);
      if (pointer && pointer === this._lockedPointer)
        return;
      pointer && this._disposePointer(pointer);
      if (event.pointerType === "touch") {
        switch (this._activePointers.length) {
          case 0:
            this._state = ACTION.NONE;
            break;
          case 1:
            this._state = this.touches.one;
            break;
          case 2:
            this._state = this.touches.two;
            break;
          case 3:
            this._state = this.touches.three;
            break;
        }
      } else {
        this._state = ACTION.NONE;
      }
      endDragging();
    };
    let lastScrollTimeStamp = -1;
    const onMouseWheel = (event) => {
      if (!this._domElement)
        return;
      if (!this._enabled || this.mouseButtons.wheel === ACTION.NONE)
        return;
      if (this._interactiveArea.left !== 0 || this._interactiveArea.top !== 0 || this._interactiveArea.width !== 1 || this._interactiveArea.height !== 1) {
        const elRect = this._domElement.getBoundingClientRect();
        const left = event.clientX / elRect.width;
        const top = event.clientY / elRect.height;
        if (left < this._interactiveArea.left || left > this._interactiveArea.right || top < this._interactiveArea.top || top > this._interactiveArea.bottom)
          return;
      }
      event.preventDefault();
      if (this.dollyToCursor || this.mouseButtons.wheel === ACTION.ROTATE || this.mouseButtons.wheel === ACTION.TRUCK) {
        const now2 = performance.now();
        if (lastScrollTimeStamp - now2 < 1e3)
          this._getClientRect(this._elementRect);
        lastScrollTimeStamp = now2;
      }
      const deltaYFactor = isMac ? -1 : -3;
      const delta = event.deltaMode === 1 || event.ctrlKey ? event.deltaY / deltaYFactor : event.deltaY / (deltaYFactor * 10);
      const x3 = this.dollyToCursor ? (event.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
      const y2 = this.dollyToCursor ? (event.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
      switch (this.mouseButtons.wheel) {
        case ACTION.ROTATE: {
          this._rotateInternal(event.deltaX, event.deltaY);
          this._isUserControllingRotate = true;
          break;
        }
        case ACTION.TRUCK: {
          this._truckInternal(event.deltaX, event.deltaY, false, false);
          this._isUserControllingTruck = true;
          break;
        }
        case ACTION.SCREEN_PAN: {
          this._truckInternal(event.deltaX, event.deltaY, false, true);
          this._isUserControllingTruck = true;
          break;
        }
        case ACTION.OFFSET: {
          this._truckInternal(event.deltaX, event.deltaY, true, false);
          this._isUserControllingOffset = true;
          break;
        }
        case ACTION.DOLLY: {
          this._dollyInternal(-delta, x3, y2);
          this._isUserControllingDolly = true;
          break;
        }
        case ACTION.ZOOM: {
          this._zoomInternal(-delta, x3, y2);
          this._isUserControllingZoom = true;
          break;
        }
      }
      this.dispatchEvent({ type: "control" });
    };
    const onContextMenu = (event) => {
      if (!this._domElement || !this._enabled)
        return;
      if (this.mouseButtons.right === CameraControls2.ACTION.NONE) {
        const pointerId = event instanceof PointerEvent ? event.pointerId : 0;
        const pointer = this._findPointerById(pointerId);
        pointer && this._disposePointer(pointer);
        this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
        this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
        return;
      }
      event.preventDefault();
    };
    const startDragging = (event) => {
      if (!this._enabled)
        return;
      extractClientCoordFromEvent(this._activePointers, _v2);
      this._getClientRect(this._elementRect);
      dragStartPosition.copy(_v2);
      lastDragPosition.copy(_v2);
      const isMultiTouch = this._activePointers.length >= 2;
      if (isMultiTouch) {
        const dx = _v2.x - this._activePointers[1].clientX;
        const dy = _v2.y - this._activePointers[1].clientY;
        const distance = Math.sqrt(dx * dx + dy * dy);
        dollyStart.set(0, distance);
        const x3 = (this._activePointers[0].clientX + this._activePointers[1].clientX) * 0.5;
        const y2 = (this._activePointers[0].clientY + this._activePointers[1].clientY) * 0.5;
        lastDragPosition.set(x3, y2);
      }
      this._state = 0;
      if (!event) {
        if (this._lockedPointer)
          this._state = this._state | this.mouseButtons.left;
      } else if ("pointerType" in event && event.pointerType === "touch") {
        switch (this._activePointers.length) {
          case 1:
            this._state = this.touches.one;
            break;
          case 2:
            this._state = this.touches.two;
            break;
          case 3:
            this._state = this.touches.three;
            break;
        }
      } else {
        if (!this._lockedPointer && (event.buttons & MOUSE_BUTTON.LEFT) === MOUSE_BUTTON.LEFT) {
          this._state = this._state | this.mouseButtons.left;
        }
        if ((event.buttons & MOUSE_BUTTON.MIDDLE) === MOUSE_BUTTON.MIDDLE) {
          this._state = this._state | this.mouseButtons.middle;
        }
        if ((event.buttons & MOUSE_BUTTON.RIGHT) === MOUSE_BUTTON.RIGHT) {
          this._state = this._state | this.mouseButtons.right;
        }
      }
      if ((this._state & ACTION.ROTATE) === ACTION.ROTATE || (this._state & ACTION.TOUCH_ROTATE) === ACTION.TOUCH_ROTATE || (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE || (this._state & ACTION.TOUCH_ZOOM_ROTATE) === ACTION.TOUCH_ZOOM_ROTATE) {
        this._sphericalEnd.theta = this._spherical.theta;
        this._sphericalEnd.phi = this._spherical.phi;
        this._thetaVelocity.value = 0;
        this._phiVelocity.value = 0;
      }
      if ((this._state & ACTION.TRUCK) === ACTION.TRUCK || (this._state & ACTION.SCREEN_PAN) === ACTION.SCREEN_PAN || (this._state & ACTION.TOUCH_TRUCK) === ACTION.TOUCH_TRUCK || (this._state & ACTION.TOUCH_SCREEN_PAN) === ACTION.TOUCH_SCREEN_PAN || (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK || (this._state & ACTION.TOUCH_DOLLY_SCREEN_PAN) === ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION.TOUCH_ZOOM_TRUCK) === ACTION.TOUCH_ZOOM_TRUCK || (this._state & ACTION.TOUCH_ZOOM_SCREEN_PAN) === ACTION.TOUCH_DOLLY_SCREEN_PAN) {
        this._targetEnd.copy(this._target);
        this._targetVelocity.set(0, 0, 0);
      }
      if ((this._state & ACTION.DOLLY) === ACTION.DOLLY || (this._state & ACTION.TOUCH_DOLLY) === ACTION.TOUCH_DOLLY || (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK || (this._state & ACTION.TOUCH_DOLLY_SCREEN_PAN) === ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET || (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE) {
        this._sphericalEnd.radius = this._spherical.radius;
        this._radiusVelocity.value = 0;
      }
      if ((this._state & ACTION.ZOOM) === ACTION.ZOOM || (this._state & ACTION.TOUCH_ZOOM) === ACTION.TOUCH_ZOOM || (this._state & ACTION.TOUCH_ZOOM_TRUCK) === ACTION.TOUCH_ZOOM_TRUCK || (this._state & ACTION.TOUCH_ZOOM_SCREEN_PAN) === ACTION.TOUCH_ZOOM_SCREEN_PAN || (this._state & ACTION.TOUCH_ZOOM_OFFSET) === ACTION.TOUCH_ZOOM_OFFSET || (this._state & ACTION.TOUCH_ZOOM_ROTATE) === ACTION.TOUCH_ZOOM_ROTATE) {
        this._zoomEnd = this._zoom;
        this._zoomVelocity.value = 0;
      }
      if ((this._state & ACTION.OFFSET) === ACTION.OFFSET || (this._state & ACTION.TOUCH_OFFSET) === ACTION.TOUCH_OFFSET || (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET || (this._state & ACTION.TOUCH_ZOOM_OFFSET) === ACTION.TOUCH_ZOOM_OFFSET) {
        this._focalOffsetEnd.copy(this._focalOffset);
        this._focalOffsetVelocity.set(0, 0, 0);
      }
      this.dispatchEvent({ type: "controlstart" });
    };
    const dragging = () => {
      if (!this._enabled || !this._dragNeedsUpdate)
        return;
      this._dragNeedsUpdate = false;
      extractClientCoordFromEvent(this._activePointers, _v2);
      const isPointerLockActive = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement;
      const lockedPointer = isPointerLockActive ? this._lockedPointer || this._activePointers[0] : null;
      const deltaX = lockedPointer ? -lockedPointer.deltaX : lastDragPosition.x - _v2.x;
      const deltaY = lockedPointer ? -lockedPointer.deltaY : lastDragPosition.y - _v2.y;
      lastDragPosition.copy(_v2);
      if ((this._state & ACTION.ROTATE) === ACTION.ROTATE || (this._state & ACTION.TOUCH_ROTATE) === ACTION.TOUCH_ROTATE || (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE || (this._state & ACTION.TOUCH_ZOOM_ROTATE) === ACTION.TOUCH_ZOOM_ROTATE) {
        this._rotateInternal(deltaX, deltaY);
        this._isUserControllingRotate = true;
      }
      if ((this._state & ACTION.DOLLY) === ACTION.DOLLY || (this._state & ACTION.ZOOM) === ACTION.ZOOM) {
        const dollyX = this.dollyToCursor ? (dragStartPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
        const dollyY = this.dollyToCursor ? (dragStartPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
        const dollyDirection = this.dollyDragInverted ? -1 : 1;
        if ((this._state & ACTION.DOLLY) === ACTION.DOLLY) {
          this._dollyInternal(dollyDirection * deltaY * TOUCH_DOLLY_FACTOR, dollyX, dollyY);
          this._isUserControllingDolly = true;
        } else {
          this._zoomInternal(dollyDirection * deltaY * TOUCH_DOLLY_FACTOR, dollyX, dollyY);
          this._isUserControllingZoom = true;
        }
      }
      if ((this._state & ACTION.TOUCH_DOLLY) === ACTION.TOUCH_DOLLY || (this._state & ACTION.TOUCH_ZOOM) === ACTION.TOUCH_ZOOM || (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK || (this._state & ACTION.TOUCH_ZOOM_TRUCK) === ACTION.TOUCH_ZOOM_TRUCK || (this._state & ACTION.TOUCH_DOLLY_SCREEN_PAN) === ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION.TOUCH_ZOOM_SCREEN_PAN) === ACTION.TOUCH_ZOOM_SCREEN_PAN || (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET || (this._state & ACTION.TOUCH_ZOOM_OFFSET) === ACTION.TOUCH_ZOOM_OFFSET || (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE || (this._state & ACTION.TOUCH_ZOOM_ROTATE) === ACTION.TOUCH_ZOOM_ROTATE) {
        const dx = _v2.x - this._activePointers[1].clientX;
        const dy = _v2.y - this._activePointers[1].clientY;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const dollyDelta = dollyStart.y - distance;
        dollyStart.set(0, distance);
        const dollyX = this.dollyToCursor ? (lastDragPosition.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0;
        const dollyY = this.dollyToCursor ? (lastDragPosition.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
        if ((this._state & ACTION.TOUCH_DOLLY) === ACTION.TOUCH_DOLLY || (this._state & ACTION.TOUCH_DOLLY_ROTATE) === ACTION.TOUCH_DOLLY_ROTATE || (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK || (this._state & ACTION.TOUCH_DOLLY_SCREEN_PAN) === ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET) {
          this._dollyInternal(dollyDelta * TOUCH_DOLLY_FACTOR, dollyX, dollyY);
          this._isUserControllingDolly = true;
        } else {
          this._zoomInternal(dollyDelta * TOUCH_DOLLY_FACTOR, dollyX, dollyY);
          this._isUserControllingZoom = true;
        }
      }
      if ((this._state & ACTION.TRUCK) === ACTION.TRUCK || (this._state & ACTION.TOUCH_TRUCK) === ACTION.TOUCH_TRUCK || (this._state & ACTION.TOUCH_DOLLY_TRUCK) === ACTION.TOUCH_DOLLY_TRUCK || (this._state & ACTION.TOUCH_ZOOM_TRUCK) === ACTION.TOUCH_ZOOM_TRUCK) {
        this._truckInternal(deltaX, deltaY, false, false);
        this._isUserControllingTruck = true;
      }
      if ((this._state & ACTION.SCREEN_PAN) === ACTION.SCREEN_PAN || (this._state & ACTION.TOUCH_SCREEN_PAN) === ACTION.TOUCH_SCREEN_PAN || (this._state & ACTION.TOUCH_DOLLY_SCREEN_PAN) === ACTION.TOUCH_DOLLY_SCREEN_PAN || (this._state & ACTION.TOUCH_ZOOM_SCREEN_PAN) === ACTION.TOUCH_ZOOM_SCREEN_PAN) {
        this._truckInternal(deltaX, deltaY, false, true);
        this._isUserControllingTruck = true;
      }
      if ((this._state & ACTION.OFFSET) === ACTION.OFFSET || (this._state & ACTION.TOUCH_OFFSET) === ACTION.TOUCH_OFFSET || (this._state & ACTION.TOUCH_DOLLY_OFFSET) === ACTION.TOUCH_DOLLY_OFFSET || (this._state & ACTION.TOUCH_ZOOM_OFFSET) === ACTION.TOUCH_ZOOM_OFFSET) {
        this._truckInternal(deltaX, deltaY, true, false);
        this._isUserControllingOffset = true;
      }
      this.dispatchEvent({ type: "control" });
    };
    const endDragging = () => {
      extractClientCoordFromEvent(this._activePointers, _v2);
      lastDragPosition.copy(_v2);
      this._dragNeedsUpdate = false;
      if (this._activePointers.length === 0 || this._activePointers.length === 1 && this._activePointers[0] === this._lockedPointer) {
        this._isDragging = false;
      }
      if (this._activePointers.length === 0 && this._domElement) {
        this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
        this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
        this.dispatchEvent({ type: "controlend" });
      }
    };
    this.lockPointer = () => {
      if (!this._enabled || !this._domElement)
        return;
      this.cancel();
      this._lockedPointer = {
        pointerId: -1,
        clientX: 0,
        clientY: 0,
        deltaX: 0,
        deltaY: 0,
        mouseButton: null
      };
      this._activePointers.push(this._lockedPointer);
      this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
      this._domElement.requestPointerLock();
      this._domElement.ownerDocument.addEventListener("pointerlockchange", onPointerLockChange);
      this._domElement.ownerDocument.addEventListener("pointerlockerror", onPointerLockError);
      this._domElement.ownerDocument.addEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.addEventListener("pointerup", onPointerUp);
      startDragging();
    };
    this.unlockPointer = () => {
      var _a2, _b2, _c;
      if (this._lockedPointer !== null) {
        this._disposePointer(this._lockedPointer);
        this._lockedPointer = null;
      }
      (_a2 = this._domElement) === null || _a2 === void 0 ? void 0 : _a2.ownerDocument.exitPointerLock();
      (_b2 = this._domElement) === null || _b2 === void 0 ? void 0 : _b2.ownerDocument.removeEventListener("pointerlockchange", onPointerLockChange);
      (_c = this._domElement) === null || _c === void 0 ? void 0 : _c.ownerDocument.removeEventListener("pointerlockerror", onPointerLockError);
      this.cancel();
    };
    const onPointerLockChange = () => {
      const isPointerLockActive = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement;
      if (!isPointerLockActive)
        this.unlockPointer();
    };
    const onPointerLockError = () => {
      this.unlockPointer();
    };
    this._addAllEventListeners = (domElement2) => {
      this._domElement = domElement2;
      this._domElement.style.touchAction = "none";
      this._domElement.style.userSelect = "none";
      this._domElement.style.webkitUserSelect = "none";
      this._domElement.addEventListener("pointerdown", onPointerDown);
      this._domElement.addEventListener("pointercancel", onPointerUp);
      this._domElement.addEventListener("wheel", onMouseWheel, { passive: false });
      this._domElement.addEventListener("contextmenu", onContextMenu);
    };
    this._removeAllEventListeners = () => {
      if (!this._domElement)
        return;
      this._domElement.style.touchAction = "";
      this._domElement.style.userSelect = "";
      this._domElement.style.webkitUserSelect = "";
      this._domElement.removeEventListener("pointerdown", onPointerDown);
      this._domElement.removeEventListener("pointercancel", onPointerUp);
      this._domElement.removeEventListener("wheel", onMouseWheel, { passive: false });
      this._domElement.removeEventListener("contextmenu", onContextMenu);
      this._domElement.ownerDocument.removeEventListener("pointermove", onPointerMove, { passive: false });
      this._domElement.ownerDocument.removeEventListener("pointerup", onPointerUp);
      this._domElement.ownerDocument.removeEventListener("pointerlockchange", onPointerLockChange);
      this._domElement.ownerDocument.removeEventListener("pointerlockerror", onPointerLockError);
    };
    this.cancel = () => {
      if (this._state === ACTION.NONE)
        return;
      this._state = ACTION.NONE;
      this._activePointers.length = 0;
      endDragging();
    };
    if (domElement)
      this.connect(domElement);
    this.update(0);
  }
  /**
   * The camera to be controlled
   * @category Properties
   */
  get camera() {
    return this._camera;
  }
  set camera(camera) {
    this._camera = camera;
    this.updateCameraUp();
    this._camera.updateProjectionMatrix();
    this._updateNearPlaneCorners();
    this._needsUpdate = true;
  }
  /**
   * Whether or not the controls are enabled.
   * `false` to disable user dragging/touch-move, but all methods works.
   * @category Properties
   */
  get enabled() {
    return this._enabled;
  }
  set enabled(enabled) {
    this._enabled = enabled;
    if (!this._domElement)
      return;
    if (enabled) {
      this._domElement.style.touchAction = "none";
      this._domElement.style.userSelect = "none";
      this._domElement.style.webkitUserSelect = "none";
    } else {
      this.cancel();
      this._domElement.style.touchAction = "";
      this._domElement.style.userSelect = "";
      this._domElement.style.webkitUserSelect = "";
    }
  }
  /**
   * Returns `true` if the controls are active updating.
   * readonly value.
   * @category Properties
   */
  get active() {
    return !this._hasRested;
  }
  /**
   * Getter for the current `ACTION`.
   * readonly value.
   * @category Properties
   */
  get currentAction() {
    return this._state;
  }
  /**
   * get/set Current distance.
   * @category Properties
   */
  get distance() {
    return this._spherical.radius;
  }
  set distance(distance) {
    if (this._spherical.radius === distance && this._sphericalEnd.radius === distance)
      return;
    this._spherical.radius = distance;
    this._sphericalEnd.radius = distance;
    this._needsUpdate = true;
  }
  // horizontal angle
  /**
   * get/set the azimuth angle (horizontal) in radians.
   * Every 360 degrees turn is added to `.azimuthAngle` value, which is accumulative.
   * @category Properties
   */
  get azimuthAngle() {
    return this._spherical.theta;
  }
  set azimuthAngle(azimuthAngle) {
    if (this._spherical.theta === azimuthAngle && this._sphericalEnd.theta === azimuthAngle)
      return;
    this._spherical.theta = azimuthAngle;
    this._sphericalEnd.theta = azimuthAngle;
    this._needsUpdate = true;
  }
  // vertical angle
  /**
   * get/set the polar angle (vertical) in radians.
   * @category Properties
   */
  get polarAngle() {
    return this._spherical.phi;
  }
  set polarAngle(polarAngle) {
    if (this._spherical.phi === polarAngle && this._sphericalEnd.phi === polarAngle)
      return;
    this._spherical.phi = polarAngle;
    this._sphericalEnd.phi = polarAngle;
    this._needsUpdate = true;
  }
  /**
   * Whether camera position should be enclosed in the boundary or not.
   * @category Properties
   */
  get boundaryEnclosesCamera() {
    return this._boundaryEnclosesCamera;
  }
  set boundaryEnclosesCamera(boundaryEnclosesCamera) {
    this._boundaryEnclosesCamera = boundaryEnclosesCamera;
    this._needsUpdate = true;
  }
  /**
   * Set drag-start, touches and wheel enable area in the domElement.
   * each values are between `0` and `1` inclusive, where `0` is left/top and `1` is right/bottom of the screen.
   * e.g. `{ x: 0, y: 0, width: 1, height: 1 }` for entire area.
   * @category Properties
   */
  set interactiveArea(interactiveArea) {
    this._interactiveArea.width = clamp2(interactiveArea.width, 0, 1);
    this._interactiveArea.height = clamp2(interactiveArea.height, 0, 1);
    this._interactiveArea.x = clamp2(interactiveArea.x, 0, 1 - this._interactiveArea.width);
    this._interactiveArea.y = clamp2(interactiveArea.y, 0, 1 - this._interactiveArea.height);
  }
  /**
   * Adds the specified event listener.
   * Applicable event types (which is `K`) are:
   * | Event name          | Timing |
   * | ------------------- | ------ |
   * | `'controlstart'`    | When the user starts to control the camera via mouse / touches. ¹ |
   * | `'control'`         | When the user controls the camera (dragging). |
   * | `'controlend'`      | When the user ends to control the camera. ¹ |
   * | `'transitionstart'` | When any kind of transition starts, either user control or using a method with `enableTransition = true` |
   * | `'update'`          | When the camera position is updated. |
   * | `'wake'`            | When the camera starts moving. |
   * | `'rest'`            | When the camera movement is below `.restThreshold` ². |
   * | `'sleep'`           | When the camera end moving. |
   *
   * 1. `mouseButtons.wheel` (Mouse wheel control) does not emit `'controlstart'` and `'controlend'`. `mouseButtons.wheel` uses scroll-event internally, and scroll-event happens intermittently. That means "start" and "end" cannot be detected.
   * 2. Due to damping, `sleep` will usually fire a few seconds after the camera _appears_ to have stopped moving. If you want to do something (e.g. enable UI, perform another transition) at the point when the camera has stopped, you probably want the `rest` event. This can be fine tuned using the `.restThreshold` parameter. See the [Rest and Sleep Example](https://yomotsu.github.io/camera-controls/examples/rest-and-sleep.html).
   *
   * e.g.
   * ```
   * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
   * ```
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  addEventListener(type, listener) {
    super.addEventListener(type, listener);
  }
  /**
   * Removes the specified event listener
   * e.g.
   * ```
   * cameraControl.addEventListener( 'controlstart', myCallbackFunction );
   * ```
   * @param type event name
   * @param listener handler function
   * @category Methods
   */
  removeEventListener(type, listener) {
    super.removeEventListener(type, listener);
  }
  /**
   * Rotate azimuthal angle(horizontal) and polar angle(vertical).
   * Every value is added to the current value.
   * @param azimuthAngle Azimuth rotate angle. In radian.
   * @param polarAngle Polar rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  rotate(azimuthAngle, polarAngle, enableTransition = false) {
    return this.rotateTo(this._sphericalEnd.theta + azimuthAngle, this._sphericalEnd.phi + polarAngle, enableTransition);
  }
  /**
   * Rotate azimuthal angle(horizontal) to the given angle and keep the same polar angle(vertical) target.
   *
   * e.g.
   * ```
   * cameraControls.rotateAzimuthTo( 30 * THREE.MathUtils.DEG2RAD, true );
   * ```
   * @param azimuthAngle Azimuth rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  rotateAzimuthTo(azimuthAngle, enableTransition = false) {
    return this.rotateTo(azimuthAngle, this._sphericalEnd.phi, enableTransition);
  }
  /**
   * Rotate polar angle(vertical) to the given angle and keep the same azimuthal angle(horizontal) target.
   *
   * e.g.
   * ```
   * cameraControls.rotatePolarTo( 30 * THREE.MathUtils.DEG2RAD, true );
   * ```
   * @param polarAngle Polar rotate angle. In radian.
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  rotatePolarTo(polarAngle, enableTransition = false) {
    return this.rotateTo(this._sphericalEnd.theta, polarAngle, enableTransition);
  }
  /**
   * Rotate azimuthal angle(horizontal) and polar angle(vertical) to the given angle.
   * Camera view will rotate over the orbit pivot absolutely:
   *
   * azimuthAngle
   * ```
   *       0º
   *         \
   * 90º -----+----- -90º
   *           \
   *           180º
   * ```
   * | direction | angle                  |
   * | --------- | ---------------------- |
   * | front     | 0º                     |
   * | left      | 90º (`Math.PI / 2`)    |
   * | right     | -90º (`- Math.PI / 2`) |
   * | back      | 180º (`Math.PI`)       |
   *
   * polarAngle
   * ```
   *     180º
   *      |
   *      90º
   *      |
   *      0º
   * ```
   * | direction            | angle                  |
   * | -------------------- | ---------------------- |
   * | top/sky              | 180º (`Math.PI`)       |
   * | horizontal from view | 90º (`Math.PI / 2`)    |
   * | bottom/floor         | 0º                     |
   *
   * @param azimuthAngle Azimuth rotate angle to. In radian.
   * @param polarAngle Polar rotate angle to. In radian.
   * @param enableTransition  Whether to move smoothly or immediately
   * @category Methods
   */
  rotateTo(azimuthAngle, polarAngle, enableTransition = false) {
    this._isUserControllingRotate = false;
    const theta = clamp2(azimuthAngle, this.minAzimuthAngle, this.maxAzimuthAngle);
    const phi = clamp2(polarAngle, this.minPolarAngle, this.maxPolarAngle);
    this._sphericalEnd.theta = theta;
    this._sphericalEnd.phi = phi;
    this._sphericalEnd.makeSafe();
    this._needsUpdate = true;
    if (!enableTransition) {
      this._spherical.theta = this._sphericalEnd.theta;
      this._spherical.phi = this._sphericalEnd.phi;
    }
    const resolveImmediately = !enableTransition || approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Dolly in/out camera position.
   * @param distance Distance of dollyIn. Negative number for dollyOut.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */
  dolly(distance, enableTransition = false) {
    return this.dollyTo(this._sphericalEnd.radius - distance, enableTransition);
  }
  /**
   * Dolly in/out camera position to given distance.
   * @param distance Distance of dolly.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */
  dollyTo(distance, enableTransition = false) {
    this._isUserControllingDolly = false;
    this._lastDollyDirection = DOLLY_DIRECTION.NONE;
    this._changedDolly = 0;
    return this._dollyToNoClamp(clamp2(distance, this.minDistance, this.maxDistance), enableTransition);
  }
  _dollyToNoClamp(distance, enableTransition = false) {
    const lastRadius = this._sphericalEnd.radius;
    const hasCollider = this.colliderMeshes.length >= 1;
    if (hasCollider) {
      const maxDistanceByCollisionTest = this._collisionTest();
      const isCollided = approxEquals(maxDistanceByCollisionTest, this._spherical.radius);
      const isDollyIn = lastRadius > distance;
      if (!isDollyIn && isCollided)
        return Promise.resolve();
      this._sphericalEnd.radius = Math.min(distance, maxDistanceByCollisionTest);
    } else {
      this._sphericalEnd.radius = distance;
    }
    this._needsUpdate = true;
    if (!enableTransition) {
      this._spherical.radius = this._sphericalEnd.radius;
    }
    const resolveImmediately = !enableTransition || approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Dolly in, but does not change the distance between the target and the camera, and moves the target position instead.
   * Specify a negative value for dolly out.
   * @param distance Distance of dolly.
   * @param enableTransition Whether to move smoothly or immediately.
   * @category Methods
   */
  dollyInFixed(distance, enableTransition = false) {
    this._targetEnd.add(this._getCameraDirection(_cameraDirection).multiplyScalar(distance));
    if (!enableTransition) {
      this._target.copy(this._targetEnd);
    }
    const resolveImmediately = !enableTransition || approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && approxEquals(this._target.z, this._targetEnd.z, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Zoom in/out camera. The value is added to camera zoom.
   * Limits set with `.minZoom` and `.maxZoom`
   * @param zoomStep zoom scale
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  zoom(zoomStep, enableTransition = false) {
    return this.zoomTo(this._zoomEnd + zoomStep, enableTransition);
  }
  /**
   * Zoom in/out camera to given scale. The value overwrites camera zoom.
   * Limits set with .minZoom and .maxZoom
   * @param zoom
   * @param enableTransition
   * @category Methods
   */
  zoomTo(zoom, enableTransition = false) {
    this._isUserControllingZoom = false;
    this._zoomEnd = clamp2(zoom, this.minZoom, this.maxZoom);
    this._needsUpdate = true;
    if (!enableTransition) {
      this._zoom = this._zoomEnd;
    }
    const resolveImmediately = !enableTransition || approxEquals(this._zoom, this._zoomEnd, this.restThreshold);
    this._changedZoom = 0;
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * @deprecated `pan()` has been renamed to `truck()`
   * @category Methods
   */
  pan(x3, y2, enableTransition = false) {
    console.warn("`pan` has been renamed to `truck`");
    return this.truck(x3, y2, enableTransition);
  }
  /**
   * Truck and pedestal camera using current azimuthal angle
   * @param x Horizontal translate amount
   * @param y Vertical translate amount
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  truck(x3, y2, enableTransition = false) {
    this._camera.updateMatrix();
    _xColumn.setFromMatrixColumn(this._camera.matrix, 0);
    _yColumn.setFromMatrixColumn(this._camera.matrix, 1);
    _xColumn.multiplyScalar(x3);
    _yColumn.multiplyScalar(-y2);
    const offset = _v3A.copy(_xColumn).add(_yColumn);
    const to2 = _v3B.copy(this._targetEnd).add(offset);
    return this.moveTo(to2.x, to2.y, to2.z, enableTransition);
  }
  /**
   * Move forward / backward.
   * @param distance Amount to move forward / backward. Negative value to move backward
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  forward(distance, enableTransition = false) {
    _v3A.setFromMatrixColumn(this._camera.matrix, 0);
    _v3A.crossVectors(this._camera.up, _v3A);
    _v3A.multiplyScalar(distance);
    const to2 = _v3B.copy(this._targetEnd).add(_v3A);
    return this.moveTo(to2.x, to2.y, to2.z, enableTransition);
  }
  /**
   * Move up / down.
   * @param height Amount to move up / down. Negative value to move down
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  elevate(height, enableTransition = false) {
    _v3A.copy(this._camera.up).multiplyScalar(height);
    return this.moveTo(this._targetEnd.x + _v3A.x, this._targetEnd.y + _v3A.y, this._targetEnd.z + _v3A.z, enableTransition);
  }
  /**
   * Move target position to given point.
   * @param x x coord to move center position
   * @param y y coord to move center position
   * @param z z coord to move center position
   * @param enableTransition Whether to move smoothly or immediately
   * @category Methods
   */
  moveTo(x3, y2, z2, enableTransition = false) {
    this._isUserControllingTruck = false;
    const offset = _v3A.set(x3, y2, z2).sub(this._targetEnd);
    this._encloseToBoundary(this._targetEnd, offset, this.boundaryFriction);
    this._needsUpdate = true;
    if (!enableTransition) {
      this._target.copy(this._targetEnd);
    }
    const resolveImmediately = !enableTransition || approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && approxEquals(this._target.z, this._targetEnd.z, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Look in the given point direction.
   * @param x point x.
   * @param y point y.
   * @param z point z.
   * @param enableTransition Whether to move smoothly or immediately.
   * @returns Transition end promise
   * @category Methods
   */
  lookInDirectionOf(x3, y2, z2, enableTransition = false) {
    const point = _v3A.set(x3, y2, z2);
    const direction = point.sub(this._targetEnd).normalize();
    const position = direction.multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
    return this.setPosition(position.x, position.y, position.z, enableTransition);
  }
  /**
   * Fit the viewport to the box or the bounding box of the object, using the nearest axis. paddings are in unit.
   * set `cover: true` to fill enter screen.
   * e.g.
   * ```
   * cameraControls.fitToBox( myMesh );
   * ```
   * @param box3OrObject Axis aligned bounding box to fit the view.
   * @param enableTransition Whether to move smoothly or immediately.
   * @param options | `<object>` { cover: boolean, paddingTop: number, paddingLeft: number, paddingBottom: number, paddingRight: number }
   * @returns Transition end promise
   * @category Methods
   */
  fitToBox(box3OrObject, enableTransition, { cover: cover2 = false, paddingLeft = 0, paddingRight = 0, paddingBottom = 0, paddingTop = 0 } = {}) {
    const promises = [];
    const aabb = box3OrObject.isBox3 ? _box3A.copy(box3OrObject) : _box3A.setFromObject(box3OrObject);
    if (aabb.isEmpty()) {
      console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting");
      Promise.resolve();
    }
    const theta = roundToStep(this._sphericalEnd.theta, PI_HALF);
    const phi = roundToStep(this._sphericalEnd.phi, PI_HALF);
    promises.push(this.rotateTo(theta, phi, enableTransition));
    const normal = _v3A.setFromSpherical(this._sphericalEnd).normalize();
    const rotation = _quaternionA.setFromUnitVectors(normal, _AXIS_Z);
    const viewFromPolar = approxEquals(Math.abs(normal.y), 1);
    if (viewFromPolar) {
      rotation.multiply(_quaternionB.setFromAxisAngle(_AXIS_Y, theta));
    }
    rotation.multiply(this._yAxisUpSpaceInverse);
    const bb = _box3B.makeEmpty();
    _v3B.copy(aabb.min).applyQuaternion(rotation);
    bb.expandByPoint(_v3B);
    _v3B.copy(aabb.min).setX(aabb.max.x).applyQuaternion(rotation);
    bb.expandByPoint(_v3B);
    _v3B.copy(aabb.min).setY(aabb.max.y).applyQuaternion(rotation);
    bb.expandByPoint(_v3B);
    _v3B.copy(aabb.max).setZ(aabb.min.z).applyQuaternion(rotation);
    bb.expandByPoint(_v3B);
    _v3B.copy(aabb.min).setZ(aabb.max.z).applyQuaternion(rotation);
    bb.expandByPoint(_v3B);
    _v3B.copy(aabb.max).setY(aabb.min.y).applyQuaternion(rotation);
    bb.expandByPoint(_v3B);
    _v3B.copy(aabb.max).setX(aabb.min.x).applyQuaternion(rotation);
    bb.expandByPoint(_v3B);
    _v3B.copy(aabb.max).applyQuaternion(rotation);
    bb.expandByPoint(_v3B);
    bb.min.x -= paddingLeft;
    bb.min.y -= paddingBottom;
    bb.max.x += paddingRight;
    bb.max.y += paddingTop;
    rotation.setFromUnitVectors(_AXIS_Z, normal);
    if (viewFromPolar) {
      rotation.premultiply(_quaternionB.invert());
    }
    rotation.premultiply(this._yAxisUpSpace);
    const bbSize = bb.getSize(_v3A);
    const center = bb.getCenter(_v3B).applyQuaternion(rotation);
    if (isPerspectiveCamera(this._camera)) {
      const distance = this.getDistanceToFitBox(bbSize.x, bbSize.y, bbSize.z, cover2);
      promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
      promises.push(this.dollyTo(distance, enableTransition));
      promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
    } else if (isOrthographicCamera(this._camera)) {
      const camera = this._camera;
      const width = camera.right - camera.left;
      const height = camera.top - camera.bottom;
      const zoom = cover2 ? Math.max(width / bbSize.x, height / bbSize.y) : Math.min(width / bbSize.x, height / bbSize.y);
      promises.push(this.moveTo(center.x, center.y, center.z, enableTransition));
      promises.push(this.zoomTo(zoom, enableTransition));
      promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
    }
    return Promise.all(promises);
  }
  /**
   * Fit the viewport to the sphere or the bounding sphere of the object.
   * @param sphereOrMesh
   * @param enableTransition
   * @category Methods
   */
  fitToSphere(sphereOrMesh, enableTransition) {
    const promises = [];
    const isObject3D = "isObject3D" in sphereOrMesh;
    const boundingSphere = isObject3D ? CameraControls2.createBoundingSphere(sphereOrMesh, _sphere) : _sphere.copy(sphereOrMesh);
    promises.push(this.moveTo(boundingSphere.center.x, boundingSphere.center.y, boundingSphere.center.z, enableTransition));
    if (isPerspectiveCamera(this._camera)) {
      const distanceToFit = this.getDistanceToFitSphere(boundingSphere.radius);
      promises.push(this.dollyTo(distanceToFit, enableTransition));
    } else if (isOrthographicCamera(this._camera)) {
      const width = this._camera.right - this._camera.left;
      const height = this._camera.top - this._camera.bottom;
      const diameter = 2 * boundingSphere.radius;
      const zoom = Math.min(width / diameter, height / diameter);
      promises.push(this.zoomTo(zoom, enableTransition));
    }
    promises.push(this.setFocalOffset(0, 0, 0, enableTransition));
    return Promise.all(promises);
  }
  /**
   * Look at the `target` from the `position`.
   * @param positionX
   * @param positionY
   * @param positionZ
   * @param targetX
   * @param targetY
   * @param targetZ
   * @param enableTransition
   * @category Methods
   */
  setLookAt(positionX, positionY, positionZ, targetX, targetY, targetZ, enableTransition = false) {
    this._isUserControllingRotate = false;
    this._isUserControllingDolly = false;
    this._isUserControllingTruck = false;
    this._lastDollyDirection = DOLLY_DIRECTION.NONE;
    this._changedDolly = 0;
    const target = _v3B.set(targetX, targetY, targetZ);
    const position = _v3A.set(positionX, positionY, positionZ);
    this._targetEnd.copy(target);
    this._sphericalEnd.setFromVector3(position.sub(target).applyQuaternion(this._yAxisUpSpace));
    this.normalizeRotations();
    this._needsUpdate = true;
    if (!enableTransition) {
      this._target.copy(this._targetEnd);
      this._spherical.copy(this._sphericalEnd);
    }
    const resolveImmediately = !enableTransition || approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && approxEquals(this._target.z, this._targetEnd.z, this.restThreshold) && approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Similar to setLookAt, but it interpolates between two states.
   * @param positionAX
   * @param positionAY
   * @param positionAZ
   * @param targetAX
   * @param targetAY
   * @param targetAZ
   * @param positionBX
   * @param positionBY
   * @param positionBZ
   * @param targetBX
   * @param targetBY
   * @param targetBZ
   * @param t
   * @param enableTransition
   * @category Methods
   */
  lerpLookAt(positionAX, positionAY, positionAZ, targetAX, targetAY, targetAZ, positionBX, positionBY, positionBZ, targetBX, targetBY, targetBZ, t2, enableTransition = false) {
    this._isUserControllingRotate = false;
    this._isUserControllingDolly = false;
    this._isUserControllingTruck = false;
    this._lastDollyDirection = DOLLY_DIRECTION.NONE;
    this._changedDolly = 0;
    const targetA = _v3A.set(targetAX, targetAY, targetAZ);
    const positionA = _v3B.set(positionAX, positionAY, positionAZ);
    _sphericalA.setFromVector3(positionA.sub(targetA).applyQuaternion(this._yAxisUpSpace));
    const targetB = _v3C.set(targetBX, targetBY, targetBZ);
    const positionB = _v3B.set(positionBX, positionBY, positionBZ);
    _sphericalB.setFromVector3(positionB.sub(targetB).applyQuaternion(this._yAxisUpSpace));
    this._targetEnd.copy(targetA.lerp(targetB, t2));
    const deltaTheta = _sphericalB.theta - _sphericalA.theta;
    const deltaPhi = _sphericalB.phi - _sphericalA.phi;
    const deltaRadius = _sphericalB.radius - _sphericalA.radius;
    this._sphericalEnd.set(_sphericalA.radius + deltaRadius * t2, _sphericalA.phi + deltaPhi * t2, _sphericalA.theta + deltaTheta * t2);
    this.normalizeRotations();
    this._needsUpdate = true;
    if (!enableTransition) {
      this._target.copy(this._targetEnd);
      this._spherical.copy(this._sphericalEnd);
    }
    const resolveImmediately = !enableTransition || approxEquals(this._target.x, this._targetEnd.x, this.restThreshold) && approxEquals(this._target.y, this._targetEnd.y, this.restThreshold) && approxEquals(this._target.z, this._targetEnd.z, this.restThreshold) && approxEquals(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && approxEquals(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && approxEquals(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Set angle and distance by given position.
   * An alias of `setLookAt()`, without target change. Thus keep gazing at the current target
   * @param positionX
   * @param positionY
   * @param positionZ
   * @param enableTransition
   * @category Methods
   */
  setPosition(positionX, positionY, positionZ, enableTransition = false) {
    return this.setLookAt(positionX, positionY, positionZ, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, enableTransition);
  }
  /**
   * Set the target position where gaze at.
   * An alias of `setLookAt()`, without position change. Thus keep the same position.
   * @param targetX
   * @param targetY
   * @param targetZ
   * @param enableTransition
   * @category Methods
   */
  setTarget(targetX, targetY, targetZ, enableTransition = false) {
    const pos = this.getPosition(_v3A);
    const promise = this.setLookAt(pos.x, pos.y, pos.z, targetX, targetY, targetZ, enableTransition);
    this._sphericalEnd.phi = clamp2(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle);
    return promise;
  }
  /**
   * Set focal offset using the screen parallel coordinates. z doesn't affect in Orthographic as with Dolly.
   * @param x
   * @param y
   * @param z
   * @param enableTransition
   * @category Methods
   */
  setFocalOffset(x3, y2, z2, enableTransition = false) {
    this._isUserControllingOffset = false;
    this._focalOffsetEnd.set(x3, y2, z2);
    this._needsUpdate = true;
    if (!enableTransition)
      this._focalOffset.copy(this._focalOffsetEnd);
    const resolveImmediately = !enableTransition || approxEquals(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && approxEquals(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && approxEquals(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
    return this._createOnRestPromise(resolveImmediately);
  }
  /**
   * Set orbit point without moving the camera.
   * SHOULD NOT RUN DURING ANIMATIONS. `setOrbitPoint()` will immediately fix the positions.
   * @param targetX
   * @param targetY
   * @param targetZ
   * @category Methods
   */
  setOrbitPoint(targetX, targetY, targetZ) {
    this._camera.updateMatrixWorld();
    _xColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 0);
    _yColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 1);
    _zColumn.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
    const position = _v3A.set(targetX, targetY, targetZ);
    const distance = position.distanceTo(this._camera.position);
    const cameraToPoint = position.sub(this._camera.position);
    _xColumn.multiplyScalar(cameraToPoint.x);
    _yColumn.multiplyScalar(cameraToPoint.y);
    _zColumn.multiplyScalar(cameraToPoint.z);
    _v3A.copy(_xColumn).add(_yColumn).add(_zColumn);
    _v3A.z = _v3A.z + distance;
    this.dollyTo(distance, false);
    this.setFocalOffset(-_v3A.x, _v3A.y, -_v3A.z, false);
    this.moveTo(targetX, targetY, targetZ, false);
  }
  /**
   * Set the boundary box that encloses the target of the camera. box3 is in THREE.Box3
   * @param box3
   * @category Methods
   */
  setBoundary(box3) {
    if (!box3) {
      this._boundary.min.set(-Infinity, -Infinity, -Infinity);
      this._boundary.max.set(Infinity, Infinity, Infinity);
      this._needsUpdate = true;
      return;
    }
    this._boundary.copy(box3);
    this._boundary.clampPoint(this._targetEnd, this._targetEnd);
    this._needsUpdate = true;
  }
  /**
   * Set (or unset) the current viewport.
   * Set this when you want to use renderer viewport and .dollyToCursor feature at the same time.
   * @param viewportOrX
   * @param y
   * @param width
   * @param height
   * @category Methods
   */
  setViewport(viewportOrX, y2, width, height) {
    if (viewportOrX === null) {
      this._viewport = null;
      return;
    }
    this._viewport = this._viewport || new THREE.Vector4();
    if (typeof viewportOrX === "number") {
      this._viewport.set(viewportOrX, y2, width, height);
    } else {
      this._viewport.copy(viewportOrX);
    }
  }
  /**
   * Calculate the distance to fit the box.
   * @param width box width
   * @param height box height
   * @param depth box depth
   * @returns distance
   * @category Methods
   */
  getDistanceToFitBox(width, height, depth, cover2 = false) {
    if (notSupportedInOrthographicCamera(this._camera, "getDistanceToFitBox"))
      return this._spherical.radius;
    const boundingRectAspect = width / height;
    const fov2 = this._camera.getEffectiveFOV() * DEG2RAD;
    const aspect2 = this._camera.aspect;
    const heightToFit = (cover2 ? boundingRectAspect > aspect2 : boundingRectAspect < aspect2) ? height : width / aspect2;
    return heightToFit * 0.5 / Math.tan(fov2 * 0.5) + depth * 0.5;
  }
  /**
   * Calculate the distance to fit the sphere.
   * @param radius sphere radius
   * @returns distance
   * @category Methods
   */
  getDistanceToFitSphere(radius) {
    if (notSupportedInOrthographicCamera(this._camera, "getDistanceToFitSphere"))
      return this._spherical.radius;
    const vFOV = this._camera.getEffectiveFOV() * DEG2RAD;
    const hFOV = Math.atan(Math.tan(vFOV * 0.5) * this._camera.aspect) * 2;
    const fov2 = 1 < this._camera.aspect ? vFOV : hFOV;
    return radius / Math.sin(fov2 * 0.5);
  }
  /**
   * Returns the orbit center position, where the camera looking at.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getTarget(out7, receiveEndValue = true) {
    const _out = !!out7 && out7.isVector3 ? out7 : new THREE.Vector3();
    return _out.copy(receiveEndValue ? this._targetEnd : this._target);
  }
  /**
   * Returns the camera position.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getPosition(out7, receiveEndValue = true) {
    const _out = !!out7 && out7.isVector3 ? out7 : new THREE.Vector3();
    return _out.setFromSpherical(receiveEndValue ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(receiveEndValue ? this._targetEnd : this._target);
  }
  /**
   * Returns the spherical coordinates of the orbit.
   * @param out The receiving Spherical instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getSpherical(out7, receiveEndValue = true) {
    const _out = out7 || new THREE.Spherical();
    return _out.copy(receiveEndValue ? this._sphericalEnd : this._spherical);
  }
  /**
   * Returns the focal offset, which is how much the camera appears to be translated in screen parallel coordinates.
   * @param out The receiving Vector3 instance to copy the result
   * @param receiveEndValue Whether receive the transition end coords or current. default is `true`
   * @category Methods
   */
  getFocalOffset(out7, receiveEndValue = true) {
    const _out = !!out7 && out7.isVector3 ? out7 : new THREE.Vector3();
    return _out.copy(receiveEndValue ? this._focalOffsetEnd : this._focalOffset);
  }
  /**
   * Normalize camera azimuth angle rotation between 0 and 360 degrees.
   * @category Methods
   */
  normalizeRotations() {
    this._sphericalEnd.theta = this._sphericalEnd.theta % PI_2;
    if (this._sphericalEnd.theta < 0)
      this._sphericalEnd.theta += PI_2;
    this._spherical.theta += PI_2 * Math.round((this._sphericalEnd.theta - this._spherical.theta) / PI_2);
  }
  /**
   * stop all transitions.
   */
  stop() {
    this._focalOffset.copy(this._focalOffsetEnd);
    this._target.copy(this._targetEnd);
    this._spherical.copy(this._sphericalEnd);
    this._zoom = this._zoomEnd;
  }
  /**
   * Reset all rotation and position to defaults.
   * @param enableTransition
   * @category Methods
   */
  reset(enableTransition = false) {
    if (!approxEquals(this._camera.up.x, this._cameraUp0.x) || !approxEquals(this._camera.up.y, this._cameraUp0.y) || !approxEquals(this._camera.up.z, this._cameraUp0.z)) {
      this._camera.up.copy(this._cameraUp0);
      const position = this.getPosition(_v3A);
      this.updateCameraUp();
      this.setPosition(position.x, position.y, position.z);
    }
    const promises = [
      this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, enableTransition),
      this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, enableTransition),
      this.zoomTo(this._zoom0, enableTransition)
    ];
    return Promise.all(promises);
  }
  /**
   * Set current camera position as the default position.
   * @category Methods
   */
  saveState() {
    this._cameraUp0.copy(this._camera.up);
    this.getTarget(this._target0);
    this.getPosition(this._position0);
    this._zoom0 = this._zoom;
    this._focalOffset0.copy(this._focalOffset);
  }
  /**
   * Sync camera-up direction.
   * When camera-up vector is changed, `.updateCameraUp()` must be called.
   * @category Methods
   */
  updateCameraUp() {
    this._yAxisUpSpace.setFromUnitVectors(this._camera.up, _AXIS_Y);
    this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
  }
  /**
   * Apply current camera-up direction to the camera.
   * The orbit system will be re-initialized with the current position.
   * @category Methods
   */
  applyCameraUp() {
    const cameraDirection = _v3A.subVectors(this._target, this._camera.position).normalize();
    const side = _v3B.crossVectors(cameraDirection, this._camera.up);
    this._camera.up.crossVectors(side, cameraDirection).normalize();
    this._camera.updateMatrixWorld();
    const position = this.getPosition(_v3A);
    this.updateCameraUp();
    this.setPosition(position.x, position.y, position.z);
  }
  /**
   * Update camera position and directions.
   * This should be called in your tick loop every time, and returns true if re-rendering is needed.
   * @param delta
   * @returns updated
   * @category Methods
   */
  update(delta) {
    const deltaTheta = this._sphericalEnd.theta - this._spherical.theta;
    const deltaPhi = this._sphericalEnd.phi - this._spherical.phi;
    const deltaRadius = this._sphericalEnd.radius - this._spherical.radius;
    const deltaTarget = _deltaTarget.subVectors(this._targetEnd, this._target);
    const deltaOffset = _deltaOffset.subVectors(this._focalOffsetEnd, this._focalOffset);
    const deltaZoom = this._zoomEnd - this._zoom;
    if (approxZero(deltaTheta)) {
      this._thetaVelocity.value = 0;
      this._spherical.theta = this._sphericalEnd.theta;
    } else {
      const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
      this._spherical.theta = smoothDamp(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, smoothTime, Infinity, delta);
      this._needsUpdate = true;
    }
    if (approxZero(deltaPhi)) {
      this._phiVelocity.value = 0;
      this._spherical.phi = this._sphericalEnd.phi;
    } else {
      const smoothTime = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
      this._spherical.phi = smoothDamp(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, smoothTime, Infinity, delta);
      this._needsUpdate = true;
    }
    if (approxZero(deltaRadius)) {
      this._radiusVelocity.value = 0;
      this._spherical.radius = this._sphericalEnd.radius;
    } else {
      const smoothTime = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
      this._spherical.radius = smoothDamp(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, smoothTime, this.maxSpeed, delta);
      this._needsUpdate = true;
    }
    if (approxZero(deltaTarget.x) && approxZero(deltaTarget.y) && approxZero(deltaTarget.z)) {
      this._targetVelocity.set(0, 0, 0);
      this._target.copy(this._targetEnd);
    } else {
      const smoothTime = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
      smoothDampVec3(this._target, this._targetEnd, this._targetVelocity, smoothTime, this.maxSpeed, delta, this._target);
      this._needsUpdate = true;
    }
    if (approxZero(deltaOffset.x) && approxZero(deltaOffset.y) && approxZero(deltaOffset.z)) {
      this._focalOffsetVelocity.set(0, 0, 0);
      this._focalOffset.copy(this._focalOffsetEnd);
    } else {
      const smoothTime = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
      smoothDampVec3(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, smoothTime, this.maxSpeed, delta, this._focalOffset);
      this._needsUpdate = true;
    }
    if (approxZero(deltaZoom)) {
      this._zoomVelocity.value = 0;
      this._zoom = this._zoomEnd;
    } else {
      const smoothTime = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
      this._zoom = smoothDamp(this._zoom, this._zoomEnd, this._zoomVelocity, smoothTime, Infinity, delta);
    }
    if (this.dollyToCursor) {
      if (isPerspectiveCamera(this._camera) && this._changedDolly !== 0) {
        const dollyControlAmount = this._spherical.radius - this._lastDistance;
        const camera = this._camera;
        const cameraDirection = this._getCameraDirection(_cameraDirection);
        const planeX = _v3A.copy(cameraDirection).cross(camera.up).normalize();
        if (planeX.lengthSq() === 0)
          planeX.x = 1;
        const planeY = _v3B.crossVectors(planeX, cameraDirection);
        const worldToScreen = this._sphericalEnd.radius * Math.tan(camera.getEffectiveFOV() * DEG2RAD * 0.5);
        const prevRadius = this._sphericalEnd.radius - dollyControlAmount;
        const lerpRatio = (prevRadius - this._sphericalEnd.radius) / this._sphericalEnd.radius;
        const cursor = _v3C.copy(this._targetEnd).add(planeX.multiplyScalar(this._dollyControlCoord.x * worldToScreen * camera.aspect)).add(planeY.multiplyScalar(this._dollyControlCoord.y * worldToScreen));
        const newTargetEnd = _v3A.copy(this._targetEnd).lerp(cursor, lerpRatio);
        const isMin = this._lastDollyDirection === DOLLY_DIRECTION.IN && this._spherical.radius <= this.minDistance;
        const isMax = this._lastDollyDirection === DOLLY_DIRECTION.OUT && this.maxDistance <= this._spherical.radius;
        if (this.infinityDolly && (isMin || isMax)) {
          this._sphericalEnd.radius -= dollyControlAmount;
          this._spherical.radius -= dollyControlAmount;
          const dollyAmount = _v3B.copy(cameraDirection).multiplyScalar(-dollyControlAmount);
          newTargetEnd.add(dollyAmount);
        }
        this._boundary.clampPoint(newTargetEnd, newTargetEnd);
        const targetEndDiff = _v3B.subVectors(newTargetEnd, this._targetEnd);
        this._targetEnd.copy(newTargetEnd);
        this._target.add(targetEndDiff);
        this._changedDolly -= dollyControlAmount;
        if (approxZero(this._changedDolly))
          this._changedDolly = 0;
      } else if (isOrthographicCamera(this._camera) && this._changedZoom !== 0) {
        const dollyControlAmount = this._zoom - this._lastZoom;
        const camera = this._camera;
        const worldCursorPosition = _v3A.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
        const quaternion = _v3B.set(0, 0, -1).applyQuaternion(camera.quaternion);
        const cursor = _v3C.copy(worldCursorPosition).add(quaternion.multiplyScalar(-worldCursorPosition.dot(camera.up)));
        const prevZoom = this._zoom - dollyControlAmount;
        const lerpRatio = -(prevZoom - this._zoom) / this._zoom;
        const cameraDirection = this._getCameraDirection(_cameraDirection);
        const prevPlaneConstant = this._targetEnd.dot(cameraDirection);
        const newTargetEnd = _v3A.copy(this._targetEnd).lerp(cursor, lerpRatio);
        const newPlaneConstant = newTargetEnd.dot(cameraDirection);
        const pullBack = cameraDirection.multiplyScalar(newPlaneConstant - prevPlaneConstant);
        newTargetEnd.sub(pullBack);
        this._boundary.clampPoint(newTargetEnd, newTargetEnd);
        const targetEndDiff = _v3B.subVectors(newTargetEnd, this._targetEnd);
        this._targetEnd.copy(newTargetEnd);
        this._target.add(targetEndDiff);
        this._changedZoom -= dollyControlAmount;
        if (approxZero(this._changedZoom))
          this._changedZoom = 0;
      }
    }
    if (this._camera.zoom !== this._zoom) {
      this._camera.zoom = this._zoom;
      this._camera.updateProjectionMatrix();
      this._updateNearPlaneCorners();
      this._needsUpdate = true;
    }
    this._dragNeedsUpdate = true;
    const maxDistance = this._collisionTest();
    this._spherical.radius = Math.min(this._spherical.radius, maxDistance);
    this._spherical.makeSafe();
    this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target);
    this._camera.lookAt(this._target);
    const affectOffset = !approxZero(this._focalOffset.x) || !approxZero(this._focalOffset.y) || !approxZero(this._focalOffset.z);
    if (affectOffset) {
      _xColumn.setFromMatrixColumn(this._camera.matrix, 0);
      _yColumn.setFromMatrixColumn(this._camera.matrix, 1);
      _zColumn.setFromMatrixColumn(this._camera.matrix, 2);
      _xColumn.multiplyScalar(this._focalOffset.x);
      _yColumn.multiplyScalar(-this._focalOffset.y);
      _zColumn.multiplyScalar(this._focalOffset.z);
      _v3A.copy(_xColumn).add(_yColumn).add(_zColumn);
      this._camera.position.add(_v3A);
      this._camera.updateMatrixWorld();
    }
    if (this._boundaryEnclosesCamera) {
      this._encloseToBoundary(this._camera.position.copy(this._target), _v3A.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1);
    }
    const updated = this._needsUpdate;
    if (updated && !this._updatedLastTime) {
      this._hasRested = false;
      this.dispatchEvent({ type: "wake" });
      this.dispatchEvent({ type: "update" });
    } else if (updated) {
      this.dispatchEvent({ type: "update" });
      if (approxZero(deltaTheta, this.restThreshold) && approxZero(deltaPhi, this.restThreshold) && approxZero(deltaRadius, this.restThreshold) && approxZero(deltaTarget.x, this.restThreshold) && approxZero(deltaTarget.y, this.restThreshold) && approxZero(deltaTarget.z, this.restThreshold) && approxZero(deltaOffset.x, this.restThreshold) && approxZero(deltaOffset.y, this.restThreshold) && approxZero(deltaOffset.z, this.restThreshold) && approxZero(deltaZoom, this.restThreshold) && !this._hasRested) {
        this._hasRested = true;
        this.dispatchEvent({ type: "rest" });
      }
    } else if (!updated && this._updatedLastTime) {
      this.dispatchEvent({ type: "sleep" });
    }
    this._lastDistance = this._spherical.radius;
    this._lastZoom = this._zoom;
    this._updatedLastTime = updated;
    this._needsUpdate = false;
    return updated;
  }
  /**
   * Get all state in JSON string
   * @category Methods
   */
  toJSON() {
    return JSON.stringify({
      enabled: this._enabled,
      minDistance: this.minDistance,
      maxDistance: infinityToMaxNumber(this.maxDistance),
      minZoom: this.minZoom,
      maxZoom: infinityToMaxNumber(this.maxZoom),
      minPolarAngle: this.minPolarAngle,
      maxPolarAngle: infinityToMaxNumber(this.maxPolarAngle),
      minAzimuthAngle: infinityToMaxNumber(this.minAzimuthAngle),
      maxAzimuthAngle: infinityToMaxNumber(this.maxAzimuthAngle),
      smoothTime: this.smoothTime,
      draggingSmoothTime: this.draggingSmoothTime,
      dollySpeed: this.dollySpeed,
      truckSpeed: this.truckSpeed,
      dollyToCursor: this.dollyToCursor,
      target: this._targetEnd.toArray(),
      position: _v3A.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
      zoom: this._zoomEnd,
      focalOffset: this._focalOffsetEnd.toArray(),
      target0: this._target0.toArray(),
      position0: this._position0.toArray(),
      zoom0: this._zoom0,
      focalOffset0: this._focalOffset0.toArray()
    });
  }
  /**
   * Reproduce the control state with JSON. enableTransition is where anim or not in a boolean.
   * @param json
   * @param enableTransition
   * @category Methods
   */
  fromJSON(json, enableTransition = false) {
    const obj = JSON.parse(json);
    this.enabled = obj.enabled;
    this.minDistance = obj.minDistance;
    this.maxDistance = maxNumberToInfinity(obj.maxDistance);
    this.minZoom = obj.minZoom;
    this.maxZoom = maxNumberToInfinity(obj.maxZoom);
    this.minPolarAngle = obj.minPolarAngle;
    this.maxPolarAngle = maxNumberToInfinity(obj.maxPolarAngle);
    this.minAzimuthAngle = maxNumberToInfinity(obj.minAzimuthAngle);
    this.maxAzimuthAngle = maxNumberToInfinity(obj.maxAzimuthAngle);
    this.smoothTime = obj.smoothTime;
    this.draggingSmoothTime = obj.draggingSmoothTime;
    this.dollySpeed = obj.dollySpeed;
    this.truckSpeed = obj.truckSpeed;
    this.dollyToCursor = obj.dollyToCursor;
    this._target0.fromArray(obj.target0);
    this._position0.fromArray(obj.position0);
    this._zoom0 = obj.zoom0;
    this._focalOffset0.fromArray(obj.focalOffset0);
    this.moveTo(obj.target[0], obj.target[1], obj.target[2], enableTransition);
    _sphericalA.setFromVector3(_v3A.fromArray(obj.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace));
    this.rotateTo(_sphericalA.theta, _sphericalA.phi, enableTransition);
    this.dollyTo(_sphericalA.radius, enableTransition);
    this.zoomTo(obj.zoom, enableTransition);
    this.setFocalOffset(obj.focalOffset[0], obj.focalOffset[1], obj.focalOffset[2], enableTransition);
    this._needsUpdate = true;
  }
  /**
   * Attach all internal event handlers to enable drag control.
   * @category Methods
   */
  connect(domElement) {
    if (this._domElement) {
      console.warn("camera-controls is already connected.");
      return;
    }
    domElement.setAttribute("data-camera-controls-version", VERSION);
    this._addAllEventListeners(domElement);
    this._getClientRect(this._elementRect);
  }
  /**
   * Detach all internal event handlers to disable drag control.
   */
  disconnect() {
    this.cancel();
    this._removeAllEventListeners();
    if (this._domElement) {
      this._domElement.removeAttribute("data-camera-controls-version");
      this._domElement = void 0;
    }
  }
  /**
   * Dispose the cameraControls instance itself, remove all eventListeners.
   * @category Methods
   */
  dispose() {
    this.removeAllEventListeners();
    this.disconnect();
  }
  // it's okay to expose public though
  _getTargetDirection(out7) {
    return out7.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
  }
  // it's okay to expose public though
  _getCameraDirection(out7) {
    return this._getTargetDirection(out7).negate();
  }
  _findPointerById(pointerId) {
    return this._activePointers.find((activePointer) => activePointer.pointerId === pointerId);
  }
  _findPointerByMouseButton(mouseButton) {
    return this._activePointers.find((activePointer) => activePointer.mouseButton === mouseButton);
  }
  _disposePointer(pointer) {
    this._activePointers.splice(this._activePointers.indexOf(pointer), 1);
  }
  _encloseToBoundary(position, offset, friction) {
    const offsetLength2 = offset.lengthSq();
    if (offsetLength2 === 0) {
      return position;
    }
    const newTarget = _v3B.copy(offset).add(position);
    const clampedTarget = this._boundary.clampPoint(newTarget, _v3C);
    const deltaClampedTarget = clampedTarget.sub(newTarget);
    const deltaClampedTargetLength2 = deltaClampedTarget.lengthSq();
    if (deltaClampedTargetLength2 === 0) {
      return position.add(offset);
    } else if (deltaClampedTargetLength2 === offsetLength2) {
      return position;
    } else if (friction === 0) {
      return position.add(offset).add(deltaClampedTarget);
    } else {
      const offsetFactor = 1 + friction * deltaClampedTargetLength2 / offset.dot(deltaClampedTarget);
      return position.add(_v3B.copy(offset).multiplyScalar(offsetFactor)).add(deltaClampedTarget.multiplyScalar(1 - friction));
    }
  }
  _updateNearPlaneCorners() {
    if (isPerspectiveCamera(this._camera)) {
      const camera = this._camera;
      const near = camera.near;
      const fov2 = camera.getEffectiveFOV() * DEG2RAD;
      const heightHalf = Math.tan(fov2 * 0.5) * near;
      const widthHalf = heightHalf * camera.aspect;
      this._nearPlaneCorners[0].set(-widthHalf, -heightHalf, 0);
      this._nearPlaneCorners[1].set(widthHalf, -heightHalf, 0);
      this._nearPlaneCorners[2].set(widthHalf, heightHalf, 0);
      this._nearPlaneCorners[3].set(-widthHalf, heightHalf, 0);
    } else if (isOrthographicCamera(this._camera)) {
      const camera = this._camera;
      const zoomInv = 1 / camera.zoom;
      const left = camera.left * zoomInv;
      const right = camera.right * zoomInv;
      const top = camera.top * zoomInv;
      const bottom = camera.bottom * zoomInv;
      this._nearPlaneCorners[0].set(left, top, 0);
      this._nearPlaneCorners[1].set(right, top, 0);
      this._nearPlaneCorners[2].set(right, bottom, 0);
      this._nearPlaneCorners[3].set(left, bottom, 0);
    }
  }
  // lateUpdate
  _collisionTest() {
    let distance = Infinity;
    const hasCollider = this.colliderMeshes.length >= 1;
    if (!hasCollider)
      return distance;
    if (notSupportedInOrthographicCamera(this._camera, "_collisionTest"))
      return distance;
    const rayDirection = this._getTargetDirection(_cameraDirection);
    _rotationMatrix.lookAt(_ORIGIN, rayDirection, this._camera.up);
    for (let i2 = 0; i2 < 4; i2++) {
      const nearPlaneCorner = _v3B.copy(this._nearPlaneCorners[i2]);
      nearPlaneCorner.applyMatrix4(_rotationMatrix);
      const origin2 = _v3C.addVectors(this._target, nearPlaneCorner);
      _raycaster.set(origin2, rayDirection);
      _raycaster.far = this._spherical.radius + 1;
      const intersects2 = _raycaster.intersectObjects(this.colliderMeshes);
      if (intersects2.length !== 0 && intersects2[0].distance < distance) {
        distance = intersects2[0].distance;
      }
    }
    return distance;
  }
  /**
   * Get its client rect and package into given `DOMRect` .
   */
  _getClientRect(target) {
    if (!this._domElement)
      return;
    const rect = this._domElement.getBoundingClientRect();
    target.x = rect.left;
    target.y = rect.top;
    if (this._viewport) {
      target.x += this._viewport.x;
      target.y += rect.height - this._viewport.w - this._viewport.y;
      target.width = this._viewport.z;
      target.height = this._viewport.w;
    } else {
      target.width = rect.width;
      target.height = rect.height;
    }
    return target;
  }
  _createOnRestPromise(resolveImmediately) {
    if (resolveImmediately)
      return Promise.resolve();
    this._hasRested = false;
    this.dispatchEvent({ type: "transitionstart" });
    return new Promise((resolve2) => {
      const onResolve = () => {
        this.removeEventListener("rest", onResolve);
        resolve2();
      };
      this.addEventListener("rest", onResolve);
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _addAllEventListeners(_domElement) {
  }
  _removeAllEventListeners() {
  }
  /**
   * backward compatible
   * @deprecated use smoothTime (in seconds) instead
   * @category Properties
   */
  get dampingFactor() {
    console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
    return 0;
  }
  /**
   * backward compatible
   * @deprecated use smoothTime (in seconds) instead
   * @category Properties
   */
  set dampingFactor(_2) {
    console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
  }
  /**
   * backward compatible
   * @deprecated use draggingSmoothTime (in seconds) instead
   * @category Properties
   */
  get draggingDampingFactor() {
    console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
    return 0;
  }
  /**
   * backward compatible
   * @deprecated use draggingSmoothTime (in seconds) instead
   * @category Properties
   */
  set draggingDampingFactor(_2) {
    console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
  }
  static createBoundingSphere(object3d, out7 = new THREE.Sphere()) {
    const boundingSphere = out7;
    const center = boundingSphere.center;
    _box3A.makeEmpty();
    object3d.traverseVisible((object) => {
      if (!object.isMesh)
        return;
      _box3A.expandByObject(object);
    });
    _box3A.getCenter(center);
    let maxRadiusSq = 0;
    object3d.traverseVisible((object) => {
      if (!object.isMesh)
        return;
      const mesh = object;
      if (!mesh.geometry)
        return;
      const geometry = mesh.geometry.clone();
      geometry.applyMatrix4(mesh.matrixWorld);
      const bufferGeometry = geometry;
      const position = bufferGeometry.attributes.position;
      for (let i2 = 0, l2 = position.count; i2 < l2; i2++) {
        _v3A.fromBufferAttribute(position, i2);
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_v3A));
      }
    });
    boundingSphere.radius = Math.sqrt(maxRadiusSq);
    return boundingSphere;
  }
}
CameraControls2.install({ THREE: THREE$2 });
extend({ CameraControls: CameraControls2 });
var propTypes = { exports: {} };
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim2(props, propName, componentName, location2, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim2.isRequired = shim2;
    function getShim() {
      return shim2;
    }
    var ReactPropTypes = {
      array: shim2,
      bigint: shim2,
      bool: shim2,
      func: shim2,
      number: shim2,
      object: shim2,
      string: shim2,
      symbol: shim2,
      any: shim2,
      arrayOf: getShim,
      element: shim2,
      elementType: shim2,
      instanceOf: getShim,
      node: shim2,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
({
  xyzAPI: PropTypes.object
});
({
  orbitRadius: PropTypes.number,
  mouseSensitivity: PropTypes.number,
  gyroSensitivity: PropTypes.number,
  enabled: PropTypes.bool
});
var updateQueue = makeQueue();
var raf = (fn) => schedule(fn, updateQueue);
var writeQueue = makeQueue();
raf.write = (fn) => schedule(fn, writeQueue);
var onStartQueue = makeQueue();
raf.onStart = (fn) => schedule(fn, onStartQueue);
var onFrameQueue = makeQueue();
raf.onFrame = (fn) => schedule(fn, onFrameQueue);
var onFinishQueue = makeQueue();
raf.onFinish = (fn) => schedule(fn, onFinishQueue);
var timeouts = [];
raf.setTimeout = (handler, ms) => {
  const time = raf.now() + ms;
  const cancel = () => {
    const i2 = timeouts.findIndex((t2) => t2.cancel == cancel);
    if (~i2)
      timeouts.splice(i2, 1);
    pendingCount -= ~i2 ? 1 : 0;
  };
  const timeout = { time, handler, cancel };
  timeouts.splice(findTimeout(time), 0, timeout);
  pendingCount += 1;
  start();
  return timeout;
};
var findTimeout = (time) => ~(~timeouts.findIndex((t2) => t2.time > time) || ~timeouts.length);
raf.cancel = (fn) => {
  onStartQueue.delete(fn);
  onFrameQueue.delete(fn);
  onFinishQueue.delete(fn);
  updateQueue.delete(fn);
  writeQueue.delete(fn);
};
raf.sync = (fn) => {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};
raf.throttle = (fn) => {
  let lastArgs;
  function queuedFn() {
    try {
      fn(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }
  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }
  throttled.handler = fn;
  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };
  return throttled;
};
var nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (() => {
  })
);
raf.use = (impl) => nativeRaf = impl;
raf.now = typeof performance != "undefined" ? () => performance.now() : Date.now;
raf.batchedUpdates = (fn) => fn();
raf.catch = console.error;
raf.frameLoop = "always";
raf.advance = () => {
  if (raf.frameLoop !== "demand") {
    console.warn(
      "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
    );
  } else {
    update();
  }
};
var ts = -1;
var pendingCount = 0;
var sync = false;
function schedule(fn, queue2) {
  if (sync) {
    queue2.delete(fn);
    fn(0);
  } else {
    queue2.add(fn);
    start();
  }
}
function start() {
  if (ts < 0) {
    ts = 0;
    if (raf.frameLoop !== "demand") {
      nativeRaf(loop);
    }
  }
}
function stop() {
  ts = -1;
}
function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}
function update() {
  const prevTs = ts;
  ts = raf.now();
  const count = findTimeout(ts);
  if (count) {
    eachSafely(timeouts.splice(0, count), (t2) => t2.handler());
    pendingCount -= count;
  }
  if (!pendingCount) {
    stop();
    return;
  }
  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();
}
function makeQueue() {
  let next = /* @__PURE__ */ new Set();
  let current = next;
  return {
    add(fn) {
      pendingCount += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },
    delete(fn) {
      pendingCount -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },
    flush(arg) {
      if (current.size) {
        next = /* @__PURE__ */ new Set();
        pendingCount -= current.size;
        eachSafely(current, (fn) => fn(arg) && next.add(fn));
        pendingCount += next.size;
        current = next;
      }
    }
  };
}
function eachSafely(values, each2) {
  values.forEach((value) => {
    try {
      each2(value);
    } catch (e2) {
      raf.catch(e2);
    }
  });
}
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var globals_exports = {};
__export(globals_exports, {
  assign: () => assign,
  colors: () => colors,
  createStringInterpolator: () => createStringInterpolator,
  skipAnimation: () => skipAnimation,
  to: () => to,
  willAdvance: () => willAdvance
});
function noop() {
}
var defineHidden = (obj, key, value) => Object.defineProperty(obj, key, { value, writable: true, configurable: true });
var is = {
  arr: Array.isArray,
  obj: (a5) => !!a5 && a5.constructor.name === "Object",
  fun: (a5) => typeof a5 === "function",
  str: (a5) => typeof a5 === "string",
  num: (a5) => typeof a5 === "number",
  und: (a5) => a5 === void 0
};
function isEqual(a5, b6) {
  if (is.arr(a5)) {
    if (!is.arr(b6) || a5.length !== b6.length)
      return false;
    for (let i2 = 0; i2 < a5.length; i2++) {
      if (a5[i2] !== b6[i2])
        return false;
    }
    return true;
  }
  return a5 === b6;
}
var each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx2) {
  if (is.arr(obj)) {
    for (let i2 = 0; i2 < obj.length; i2++) {
      fn.call(ctx2, obj[i2], `${i2}`);
    }
    return;
  }
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn.call(ctx2, obj[key], key);
    }
  }
}
var toArray2 = (a5) => is.und(a5) ? [] : is.arr(a5) ? a5 : [a5];
var isSSR = () => typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var createStringInterpolator;
var to;
var colors = null;
var skipAnimation = false;
var willAdvance = noop;
var assign = (globals) => {
  if (globals.to)
    to = globals.to;
  if (globals.now)
    raf.now = globals.now;
  if (globals.colors !== void 0)
    colors = globals.colors;
  if (globals.skipAnimation != null)
    skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator)
    createStringInterpolator = globals.createStringInterpolator;
  if (globals.requestAnimationFrame)
    raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates)
    raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance)
    willAdvance = globals.willAdvance;
  if (globals.frameLoop)
    raf.frameLoop = globals.frameLoop;
};
var startQueue = /* @__PURE__ */ new Set();
var currentFrame = [];
var prevFrame = [];
var priority = 0;
var frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },
  /** Advance all animations by the given time. */
  advance,
  /** Call this when an animation's priority changes. */
  sort(animation) {
    if (priority) {
      raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);
      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    currentFrame = [];
    startQueue.clear();
  }
};
function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}
function startSafely(animation) {
  if (!currentFrame.includes(animation))
    startUnsafely(animation);
}
function startUnsafely(animation) {
  currentFrame.splice(
    findIndex(currentFrame, (other) => other.priority > animation.priority),
    0,
    animation
  );
}
function advance(dt) {
  const nextFrame = prevFrame;
  for (let i2 = 0; i2 < currentFrame.length; i2++) {
    const animation = currentFrame[i2];
    priority = animation.priority;
    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);
      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }
  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}
function findIndex(arr, test) {
  const index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}
var colors2 = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call(...parts) {
  return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rgb = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp(
  "hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)
);
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;
function normalizeColor(color) {
  let match;
  if (typeof color === "number") {
    return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
  }
  if (match = hex6.exec(color))
    return parseInt(match[1] + "ff", 16) >>> 0;
  if (colors && colors[color] !== void 0) {
    return colors[color];
  }
  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
  }
  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }
  if (match = hex3.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      "ff",
      // a
      16
    ) >>> 0;
  }
  if (match = hex8.exec(color))
    return parseInt(match[1], 16) >>> 0;
  if (match = hex4.exec(color)) {
    return parseInt(
      match[1] + match[1] + // r
      match[2] + match[2] + // g
      match[3] + match[3] + // b
      match[4] + match[4],
      // a
      16
    ) >>> 0;
  }
  if (match = hsl.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | 255) >>> // a
    0;
  }
  if (match = hsla.exec(color)) {
    return (hslToRgb(
      parse360(match[1]),
      // h
      parsePercentage(match[2]),
      // s
      parsePercentage(match[3])
      // l
    ) | parse1(match[4])) >>> // a
    0;
  }
  return null;
}
function hue2rgb(p3, q2, t2) {
  if (t2 < 0)
    t2 += 1;
  if (t2 > 1)
    t2 -= 1;
  if (t2 < 1 / 6)
    return p3 + (q2 - p3) * 6 * t2;
  if (t2 < 1 / 2)
    return q2;
  if (t2 < 2 / 3)
    return p3 + (q2 - p3) * (2 / 3 - t2) * 6;
  return p3;
}
function hslToRgb(h2, s2, l2) {
  const q2 = l2 < 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
  const p3 = 2 * l2 - q2;
  const r3 = hue2rgb(p3, q2, h2 + 1 / 3);
  const g2 = hue2rgb(p3, q2, h2);
  const b6 = hue2rgb(p3, q2, h2 - 1 / 3);
  return Math.round(r3 * 255) << 24 | Math.round(g2 * 255) << 16 | Math.round(b6 * 255) << 8;
}
function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0)
    return 0;
  if (int > 255)
    return 255;
  return int;
}
function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
  const num = parseFloat(str);
  if (num < 0)
    return 0;
  if (num > 1)
    return 255;
  return Math.round(num * 255);
}
function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0)
    return 0;
  if (int > 100)
    return 1;
  return int / 100;
}
function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null)
    return input;
  int32Color = int32Color || 0;
  const r3 = (int32Color & 4278190080) >>> 24;
  const g2 = (int32Color & 16711680) >>> 16;
  const b6 = (int32Color & 65280) >>> 8;
  const a5 = (int32Color & 255) / 255;
  return `rgba(${r3}, ${g2}, ${b6}, ${a5})`;
}
var createInterpolator = (range, output, extrapolate) => {
  if (is.fun(range)) {
    return range;
  }
  if (is.arr(range)) {
    return createInterpolator({
      range,
      output,
      extrapolate
    });
  }
  if (is.str(range.output[0])) {
    return createStringInterpolator(range);
  }
  const config3 = range;
  const outputRange = config3.output;
  const inputRange = config3.range || [0, 1];
  const extrapolateLeft = config3.extrapolateLeft || config3.extrapolate || "extend";
  const extrapolateRight = config3.extrapolateRight || config3.extrapolate || "extend";
  const easing2 = config3.easing || ((t2) => t2);
  return (input) => {
    const range2 = findRange(input, inputRange);
    return interpolate2(
      input,
      inputRange[range2],
      inputRange[range2 + 1],
      outputRange[range2],
      outputRange[range2 + 1],
      easing2,
      extrapolateLeft,
      extrapolateRight,
      config3.map
    );
  };
};
function interpolate2(input, inputMin, inputMax, outputMin, outputMax, easing2, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input;
  if (result < inputMin) {
    if (extrapolateLeft === "identity")
      return result;
    else if (extrapolateLeft === "clamp")
      result = inputMin;
  }
  if (result > inputMax) {
    if (extrapolateRight === "identity")
      return result;
    else if (extrapolateRight === "clamp")
      result = inputMax;
  }
  if (outputMin === outputMax)
    return outputMin;
  if (inputMin === inputMax)
    return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity)
    result = -result;
  else if (inputMax === Infinity)
    result = result - inputMin;
  else
    result = (result - inputMin) / (inputMax - inputMin);
  result = easing2(result);
  if (outputMin === -Infinity)
    result = -result;
  else if (outputMax === Infinity)
    result = result + outputMin;
  else
    result = result * (outputMax - outputMin) + outputMin;
  return result;
}
function findRange(input, inputRange) {
  for (var i2 = 1; i2 < inputRange.length - 1; ++i2)
    if (inputRange[i2] >= input)
      break;
  return i2 - 1;
}
var $get = /* @__PURE__ */ Symbol.for("FluidValue.get");
var $observers = /* @__PURE__ */ Symbol.for("FluidValue.observers");
var hasFluidValue = (arg) => Boolean(arg && arg[$get]);
var getFluidValue = (arg) => arg && arg[$get] ? arg[$get]() : arg;
function callFluidObserver(observer2, event) {
  if (observer2.eventObserved) {
    observer2.eventObserved(event);
  } else {
    observer2(event);
  }
}
function callFluidObservers(target, event) {
  const observers = target[$observers];
  if (observers) {
    observers.forEach((observer2) => {
      callFluidObserver(observer2, event);
    });
  }
}
var FluidValue = class {
  constructor(get) {
    if (!get && !(get = this.get)) {
      throw Error("Unknown getter");
    }
    setFluidGetter(this, get);
  }
};
var setFluidGetter = (target, get) => setHidden(target, $get, get);
function addFluidObserver(target, observer2) {
  if (target[$get]) {
    let observers = target[$observers];
    if (!observers) {
      setHidden(target, $observers, observers = /* @__PURE__ */ new Set());
    }
    if (!observers.has(observer2)) {
      observers.add(observer2);
      if (target.observerAdded) {
        target.observerAdded(observers.size, observer2);
      }
    }
  }
  return observer2;
}
function removeFluidObserver(target, observer2) {
  const observers = target[$observers];
  if (observers && observers.has(observer2)) {
    const count = observers.size - 1;
    if (count) {
      observers.delete(observer2);
    } else {
      target[$observers] = null;
    }
    if (target.observerRemoved) {
      target.observerRemoved(count, observer2);
    }
  }
}
var setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, "i");
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
var variableToRgba = (input) => {
  const [token, fallback] = parseCSSVariable(input);
  if (!token || isSSR()) {
    return input;
  }
  const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith("--")) {
    const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
    if (value2) {
      return value2;
    } else {
      return input;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }
  return input;
};
var parseCSSVariable = (current) => {
  const match = cssVariableRegex.exec(current);
  if (!match)
    return [,];
  const [, token, fallback] = match;
  return [token, fallback];
};
var namedColorRegex;
var rgbaRound = (_2, p1, p22, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p22)}, ${Math.round(p3)}, ${p4})`;
var createStringInterpolator2 = (config3) => {
  if (!namedColorRegex)
    namedColorRegex = colors ? (
      // match color names, ignore partial matches
      new RegExp(`(${Object.keys(colors).join("|")})(?!\\w)`, "g")
    ) : (
      // never match
      /^\b$/
    );
  const output = config3.output.map((value) => {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  const keyframes = output.map((value) => value.match(numberRegex).map(Number));
  const outputRanges = keyframes[0].map(
    (_2, i2) => keyframes.map((values) => {
      if (!(i2 in values)) {
        throw Error('The arity of each "output" value must be equal');
      }
      return values[i2];
    })
  );
  const interpolators = outputRanges.map(
    (output2) => createInterpolator({ ...config3, output: output2 })
  );
  return (input) => {
    const missingUnit = !unitRegex.test(output[0]) && output.find((value) => unitRegex.test(value))?.replace(numberRegex, "");
    let i2 = 0;
    return output[0].replace(
      numberRegex,
      () => `${interpolators[i2++](input)}${missingUnit || ""}`
    ).replace(rgbaRegex, rgbaRound);
  };
};
var prefix = "react-spring: ";
var once = (fn) => {
  const func = fn;
  let called = false;
  if (typeof func != "function") {
    throw new TypeError(`${prefix}once requires a function parameter`);
  }
  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};
var warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate(
    `${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
once(console.warn);
function isAnimatedString(value) {
  return is.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !isSSR() && cssVariableRegex.test(value) || value in (colors || {}));
}
var useIsomorphicLayoutEffect$1 = isSSR() ? reactExports.useEffect : reactExports.useLayoutEffect;
var useIsMounted = () => {
  const isMounted = reactExports.useRef(false);
  useIsomorphicLayoutEffect$1(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};
function useForceUpdate() {
  const update2 = reactExports.useState()[1];
  const isMounted = useIsMounted();
  return () => {
    if (isMounted.current) {
      update2(Math.random());
    }
  };
}
function useMemoOne(getResult, inputs) {
  const [initial] = reactExports.useState(
    () => ({
      inputs,
      result: getResult()
    })
  );
  const committed = reactExports.useRef();
  const prevCache = committed.current;
  let cache = prevCache;
  if (cache) {
    const useCache = Boolean(
      inputs && cache.inputs && areInputsEqual(inputs, cache.inputs)
    );
    if (!useCache) {
      cache = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }
  reactExports.useEffect(() => {
    committed.current = cache;
    if (prevCache == initial) {
      initial.inputs = initial.result = void 0;
    }
  }, [cache]);
  return cache.result;
}
function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }
  for (let i2 = 0; i2 < next.length; i2++) {
    if (next[i2] !== prev[i2]) {
      return false;
    }
  }
  return true;
}
var useOnce = (effect) => reactExports.useEffect(effect, emptyDeps);
var emptyDeps = [];
var $node = /* @__PURE__ */ Symbol.for("Animated:node");
var isAnimated = (value) => !!value && value[$node] === value;
var getAnimated = (owner) => owner && owner[$node];
var setAnimated = (owner, node) => defineHidden(owner, $node, node);
var getPayload = (owner) => owner && owner[$node] && owner[$node].getPayload();
var Animated = class {
  constructor() {
    setAnimated(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
};
var AnimatedValue = class extends Animated {
  constructor(_value) {
    super();
    this._value = _value;
    this.done = true;
    this.durationProgress = 0;
    if (is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }
  /** @internal */
  static create(value) {
    return new AnimatedValue(value);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(value, step) {
    if (is.num(value)) {
      this.lastPosition = value;
      if (step) {
        value = Math.round(value / step) * step;
        if (this.done) {
          this.lastPosition = value;
        }
      }
    }
    if (this._value === value) {
      return false;
    }
    this._value = value;
    return true;
  }
  reset() {
    const { done } = this;
    this.done = false;
    if (is.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done)
        this.lastVelocity = null;
      this.v0 = null;
    }
  }
};
var AnimatedString = class extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = createInterpolator({
      output: [value, value]
    });
  }
  /** @internal */
  static create(value) {
    return new AnimatedString(value);
  }
  getValue() {
    const value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }
  setValue(value) {
    if (is.str(value)) {
      if (value == this._string) {
        return false;
      }
      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }
    return true;
  }
  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }
    this._value = 0;
    super.reset();
  }
};
var TreeContext = { dependencies: null };
var AnimatedObject = class extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }
  getValue(animated) {
    const values = {};
    eachProp(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else if (hasFluidValue(source)) {
        values[key] = getFluidValue(source);
      } else if (!animated) {
        values[key] = source;
      }
    });
    return values;
  }
  /** Replace the raw object data */
  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }
  reset() {
    if (this.payload) {
      each(this.payload, (node) => node.reset());
    }
  }
  /** Create a payload set. */
  _makePayload(source) {
    if (source) {
      const payload = /* @__PURE__ */ new Set();
      eachProp(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }
  /** Add to a payload set. */
  _addToPayload(source) {
    if (TreeContext.dependencies && hasFluidValue(source)) {
      TreeContext.dependencies.add(source);
    }
    const payload = getPayload(source);
    if (payload) {
      each(payload, (node) => this.add(node));
    }
  }
};
var AnimatedArray = class extends AnimatedObject {
  constructor(source) {
    super(source);
  }
  /** @internal */
  static create(source) {
    return new AnimatedArray(source);
  }
  getValue() {
    return this.source.map((node) => node.getValue());
  }
  setValue(source) {
    const payload = this.getPayload();
    if (source.length == payload.length) {
      return payload.map((node, i2) => node.setValue(source[i2])).some(Boolean);
    }
    super.setValue(source.map(makeAnimated));
    return true;
  }
};
function makeAnimated(value) {
  const nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}
function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}
var withAnimated = (Component, host) => {
  const hasInstance = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !is.fun(Component) || Component.prototype && Component.prototype.isReactComponent
  );
  return reactExports.forwardRef((givenProps, givenRef) => {
    const instanceRef = reactExports.useRef(null);
    const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
    reactExports.useCallback(
      (value) => {
        instanceRef.current = updateRef(givenRef, value);
      },
      [givenRef]
    );
    const [props, deps] = getAnimatedState(givenProps, host);
    const forceUpdate = useForceUpdate();
    const callback = () => {
      const instance = instanceRef.current;
      if (hasInstance && !instance) {
        return;
      }
      const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
      if (didUpdate === false) {
        forceUpdate();
      }
    };
    const observer = new PropsObserver(callback, deps);
    const observerRef = reactExports.useRef();
    useIsomorphicLayoutEffect$1(() => {
      observerRef.current = observer;
      each(deps, (dep) => addFluidObserver(dep, observer));
      return () => {
        if (observerRef.current) {
          each(
            observerRef.current.deps,
            (dep) => removeFluidObserver(dep, observerRef.current)
          );
          raf.cancel(observerRef.current.update);
        }
      };
    });
    reactExports.useEffect(callback, []);
    useOnce(() => () => {
      const observer2 = observerRef.current;
      each(observer2.deps, (dep) => removeFluidObserver(dep, observer2));
    });
    const usedProps = host.getComponentProps(props.getValue());
    return /* @__PURE__ */ reactExports.createElement(Component, { ...usedProps, ref });
  });
};
var PropsObserver = class {
  constructor(update2, deps) {
    this.update = update2;
    this.deps = deps;
  }
  eventObserved(event) {
    if (event.type == "change") {
      raf.write(this.update);
    }
  }
};
function getAnimatedState(props, host) {
  const dependencies = /* @__PURE__ */ new Set();
  TreeContext.dependencies = dependencies;
  if (props.style)
    props = {
      ...props,
      style: host.createAnimatedStyle(props.style)
    };
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}
function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref))
      ref(value);
    else
      ref.current = value;
  }
  return value;
}
var cacheKey = /* @__PURE__ */ Symbol.for("AnimatedComponent");
var createHost = (components, {
  applyAnimatedValues = () => false,
  createAnimatedStyle = (style) => new AnimatedObject(style),
  getComponentProps = (props) => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues,
    createAnimatedStyle,
    getComponentProps
  };
  const animated = (Component) => {
    const displayName = getDisplayName(Component) || "Anonymous";
    if (is.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }
    Component.displayName = `Animated(${displayName})`;
    return Component;
  };
  eachProp(components, (Component, key) => {
    if (is.arr(components)) {
      key = getDisplayName(Component);
    }
    animated[key] = animated(Component);
  });
  return {
    animated
  };
};
var getDisplayName = (arg) => is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;
var isFrameValue = (value) => value instanceof FrameValue;
var nextId = 1;
var FrameValue = class extends FluidValue {
  constructor() {
    super(...arguments);
    this.id = nextId++;
    this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(priority2) {
    if (this._priority != priority2) {
      this._priority = priority2;
      this._onPriorityChange(priority2);
    }
  }
  /** Get the current value */
  get() {
    const node = getAnimated(this);
    return node && node.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...args) {
    return globals_exports.to(this, args);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...args) {
    deprecateInterpolate();
    return globals_exports.to(this, args);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(count) {
    if (count == 1)
      this._attach();
  }
  observerRemoved(count) {
    if (count == 0)
      this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(value, idle = false) {
    callFluidObservers(this, {
      type: "change",
      parent: this,
      value,
      idle
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(priority2) {
    if (!this.idle) {
      frameLoop.sort(this);
    }
    callFluidObservers(this, {
      type: "priority",
      parent: this,
      priority: priority2
    });
  }
};
var SpringContext = ({
  children,
  ...props
}) => {
  const inherited = reactExports.useContext(ctx);
  const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(() => ({ pause, immediate }), [pause, immediate]);
  const { Provider: Provider2 } = ctx;
  return /* @__PURE__ */ reactExports.createElement(Provider2, { value: props }, children);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init4) {
  Object.assign(target, reactExports.createContext(init4));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}
var Interpolation = class extends FrameValue {
  constructor(source, args) {
    super();
    this.source = source;
    this.idle = true;
    this._active = /* @__PURE__ */ new Set();
    this.calc = createInterpolator(...args);
    const value = this._get();
    const nodeType = getAnimatedType(value);
    setAnimated(this, nodeType.create(value));
  }
  advance(_dt) {
    const value = this._get();
    const oldValue = this.get();
    if (!isEqual(value, oldValue)) {
      getAnimated(this).setValue(value);
      this._onChange(value, this.idle);
    }
    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }
  _get() {
    const inputs = is.arr(this.source) ? this.source.map(getFluidValue) : toArray2(getFluidValue(this.source));
    return this.calc(...inputs);
  }
  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      each(getPayload(this), (node) => {
        node.done = false;
      });
      if (globals_exports.skipAnimation) {
        raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop.start(this);
      }
    }
  }
  // Observe our sources only when we're observed.
  _attach() {
    let priority2 = 1;
    each(toArray2(this.source), (source) => {
      if (hasFluidValue(source)) {
        addFluidObserver(source, this);
      }
      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }
        priority2 = Math.max(priority2, source.priority + 1);
      }
    });
    this.priority = priority2;
    this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    each(toArray2(this.source), (source) => {
      if (hasFluidValue(source)) {
        removeFluidObserver(source, this);
      }
    });
    this._active.clear();
    becomeIdle(this);
  }
  /** @internal */
  eventObserved(event) {
    if (event.type == "change") {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);
        this._start();
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else if (event.type == "priority") {
      this.priority = toArray2(this.source).reduce(
        (highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1),
        0
      );
    }
  }
};
function isIdle(source) {
  return source.idle !== false;
}
function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self2) {
  if (!self2.idle) {
    self2.idle = true;
    each(getPayload(self2), (node) => {
      node.done = true;
    });
    callFluidObservers(self2, {
      type: "idle",
      parent: self2
    });
  }
}
globals_exports.assign({
  createStringInterpolator: createStringInterpolator2,
  to: (source, args) => new Interpolation(source, args)
});
var primitives = ["primitive"].concat(
  Object.keys(THREE$2).filter((key) => /^[A-Z]/.test(key)).map((key) => key[0].toLowerCase() + key.slice(1))
);
globals_exports.assign({
  createStringInterpolator: createStringInterpolator2,
  colors: colors2,
  frameLoop: "demand"
});
addEffect(() => {
  raf.advance();
});
createHost(primitives, {
  // @ts-expect-error r3f related
  applyAnimatedValues: applyProps
});
new Vector2();
const SHADOW_CONFIG = {
  bias: -1e-4,
  normalBias: 0.05,
  mapSize: 2048
};
const LIGHT_INTENSITY_FACTOR_DIRECTIONAL = Math.PI * 0.025;
const LIGHT_INTENSITY_FACTOR_POINT = Math.PI * 0.01;
function processSceneLights(scene) {
  let hasLights = false;
  scene.traverse((obj) => {
    if (obj.isLight) {
      debugLog("[useSceneLighting] Processing light: " + obj.name);
      hasLights = true;
      if (obj.userData.originalIntensity === void 0) {
        obj.userData.originalIntensity = obj.intensity;
      }
      if (obj.shadow) {
        obj.castShadow = true;
        obj.shadow.bias = SHADOW_CONFIG.bias;
        obj.shadow.normalBias = SHADOW_CONFIG.normalBias;
        obj.shadow.mapSize.width = SHADOW_CONFIG.mapSize;
        obj.shadow.mapSize.height = SHADOW_CONFIG.mapSize;
      }
      if (obj.type === "DIRECTIONAL") {
        obj.intensity = obj.userData.originalIntensity * LIGHT_INTENSITY_FACTOR_DIRECTIONAL;
      } else if (obj.type === "POINT") {
        obj.intensity = obj.userData.originalIntensity * LIGHT_INTENSITY_FACTOR_POINT;
      }
    }
  });
  return hasLights;
}
function createEnvironmentElement(worldConfig, hasSceneBackground, hasLights) {
  let intensity = worldConfig?.environmentIntensity ?? 1;
  if (worldConfig?.environmentTexture) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Environment,
      {
        files: "/assets/" + worldConfig.environmentTexture,
        background: worldConfig.background !== void 0 ? worldConfig.background : true,
        environmentIntensity: intensity
      }
    ) });
  }
  if (worldConfig?.backgroundColor) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("color", { attach: "background", args: worldConfig.backgroundColor }) });
  }
  return null;
}
function useSceneLighting(scene, sceneManager, overrideWorldConfig = null) {
  const worldConfig = reactExports.useMemo(() => {
    let config3 = overrideWorldConfig;
    if (!config3 && !sceneManager && scene) {
      scene.traverse((obj) => {
        if (config3) return;
        if (obj.userData?.siteProperties && obj.userData.worldConfig) {
          const userData = obj.userData;
          let bgColor = userData.background_color;
          if (bgColor && typeof bgColor === "object" && "0" in bgColor) {
            bgColor = [bgColor[0], bgColor[1], bgColor[2]];
          }
          config3 = {
            environmentTexture: userData.environment_texture,
            background: userData.background,
            backgroundColor: bgColor,
            environmentIntensity: userData.environment_intensity
          };
        }
      });
    }
    if (!config3 && sceneManager) {
      config3 = sceneManager.getSiteData()?.worldConfig ?? null;
    }
    return config3;
  }, [scene, sceneManager, overrideWorldConfig]);
  reactExports.useEffect(() => {
    if (scene) {
      scene.backgroundIntensity = worldConfig?.environmentIntensity ?? 1;
    }
  }, [scene, worldConfig]);
  return reactExports.useMemo(() => {
    processSceneLights(scene);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary2, { FallbackComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}), children: createEnvironmentElement(worldConfig, Boolean(scene.background)) });
  }, [scene, worldConfig]);
}
function SceneLighting({ scene, sceneManager, worldConfig }) {
  return useSceneLighting(scene, sceneManager, worldConfig);
}
function SceneXyz3D({ path, setShowPopup, setPopupContent, children, sections, ...props }) {
  const { scene, animations } = useGLTF(path);
  const { mixer, actions } = useAnimations(animations, scene);
  const { camera } = useThree();
  const scroll = useScroll();
  const modelRef = reactExports.useRef();
  const tl = reactExports.useRef();
  const [worldConfig, setWorldConfig] = reactExports.useState(null);
  const cameraControlsRef = reactExports.useRef();
  const { sceneManager, initializeManagers, interactionManager, isDebugging, setManualCameraMode } = useWebCrafter();
  reactExports.useRef({ pos: new Vector3(), rot: new Quaternion(), target: new Vector3() });
  reactExports.useEffect(() => {
    if (!scene || !initializeManagers || !cameraControlsRef.current) return;
    if (setManualCameraMode) setManualCameraMode(true);
    const controlsWrapper = {
      camera,
      setLookAt: (x3, y2, z2, tx, ty, tz, transition) => cameraControlsRef.current.setLookAt(x3, y2, z2, tx, ty, tz, transition),
      update: (delta) => cameraControlsRef.current.update(delta),
      fitToBox: (box, enableTransition) => cameraControlsRef.current.fitToBox(box, enableTransition),
      getPosition: (vec) => cameraControlsRef.current.getPosition(vec),
      getTarget: (vec) => cameraControlsRef.current.getTarget(vec),
      smoothTime: 0.1
    };
    initializeManagers({
      scene,
      controls: controlsWrapper,
      animations,
      actions,
      mixer,
      camera,
      setShowPopup,
      setPopupContent,
      scrollState: scroll
    });
  }, [scene, initializeManagers, camera, animations, actions, mixer, setShowPopup, setPopupContent, scroll]);
  reactExports.useLayoutEffect(() => {
    if (modelRef.current) {
      modelRef.current.position.set(0, 0, 0);
      modelRef.current.rotation.set(0, 0, 0);
    }
    if ((!sceneManager || !sceneManager.siteData) && scene) {
      scene.traverse((obj) => {
        if (obj.userData && "siteProperties" in obj.userData) {
          const userData = obj.userData;
          let bgColor = userData.background_color;
          if (bgColor && typeof bgColor === "object" && "0" in bgColor && "1" in bgColor && "2" in bgColor) {
            bgColor = [bgColor[0], bgColor[1], bgColor[2]];
          }
          setWorldConfig({
            environmentTexture: userData.environment_texture,
            background: userData.background,
            backgroundColor: bgColor,
            environmentIntensity: userData.environment_intensity
          });
        }
      });
    }
    if (!sceneManager || !sceneManager.waypoints || sceneManager.waypoints.length === 0) return;
    const sortedWaypoints = [...sceneManager.waypoints].sort((a5, b6) => a5.index - b6.index);
    const startWp = sortedWaypoints[0];
    if (startWp && startWp.camera.anchor) {
      camera.position.copy(startWp.camera.anchor.position);
      camera.quaternion.copy(startWp.camera.anchor.quaternion);
    }
    if (tl.current) tl.current.kill();
    tl.current = gsapWithCSS.timeline({ paused: true });
  }, [scene, sceneManager, sections, camera]);
  useFrame((state, delta) => {
    if (sceneManager && sceneManager.waypoints && sceneManager.waypoints.length > 1) {
      const sortedWaypoints = [...sceneManager.waypoints].sort((a5, b6) => a5.index - b6.index);
      const totalWaypoints = sortedWaypoints.length;
      const progress = scroll.offset * (totalWaypoints - 1);
      const currentIndex = Math.floor(progress);
      const nextIndex = Math.min(currentIndex + 1, totalWaypoints - 1);
      const alpha = progress - currentIndex;
      const currentWp = sortedWaypoints[Math.max(0, Math.min(currentIndex, totalWaypoints - 1))];
      const nextWp = sortedWaypoints[nextIndex];
      if (currentWp && nextWp && currentWp.camera.anchor && nextWp.camera.anchor) {
        camera.position.lerpVectors(currentWp.camera.anchor.position, nextWp.camera.anchor.position, alpha);
        camera.quaternion.slerpQuaternions(currentWp.camera.anchor.quaternion, nextWp.camera.anchor.quaternion, alpha);
      }
    } else if (tl.current) {
      const duration = tl.current.duration();
      if (duration > 0) tl.current.seek(scroll.offset * duration);
    }
    if (modelRef.current) ;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("group", { ...props, dispose: null, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "primitive",
      {
        ref: modelRef,
        object: scene,
        scale: 1
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SceneLighting,
      {
        scene,
        sceneManager,
        worldConfig
      }
    ),
    sceneManager && /* @__PURE__ */ jsxRuntimeExports.jsx(
      PhysicsObjects,
      {
        debug: isDebugging,
        sceneManager,
        interactionManager,
        isDebugging
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Media,
      {
        sceneManager,
        interactionManager
      }
    ),
    children,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CameraControls$1,
      {
        ref: cameraControlsRef,
        enabled: false,
        minDistance: 0.1,
        maxDistance: 100
      }
    )
  ] });
}
useGLTF.preload("assets/scene.glb");
let useIsomorphicLayoutEffect = typeof document !== "undefined" ? reactExports.useLayoutEffect : reactExports.useEffect, isConfig = (value) => value && !Array.isArray(value) && typeof value === "object", emptyArray = [], defaultConfig = {}, _gsap = gsapWithCSS;
const useGSAP = (callback, dependencies = emptyArray) => {
  let config3 = defaultConfig;
  if (isConfig(callback)) {
    config3 = callback;
    callback = null;
    dependencies = "dependencies" in config3 ? config3.dependencies : emptyArray;
  } else if (isConfig(dependencies)) {
    config3 = dependencies;
    dependencies = "dependencies" in config3 ? config3.dependencies : emptyArray;
  }
  callback && typeof callback !== "function" && console.warn("First parameter must be a function or config object");
  const { scope, revertOnUpdate } = config3, mounted = reactExports.useRef(false), context4 = reactExports.useRef(_gsap.context(() => {
  }, scope)), contextSafe = reactExports.useRef((func) => context4.current.add(null, func)), deferCleanup = dependencies && dependencies.length && !revertOnUpdate;
  deferCleanup && useIsomorphicLayoutEffect(() => {
    mounted.current = true;
    return () => context4.current.revert();
  }, emptyArray);
  useIsomorphicLayoutEffect(() => {
    callback && context4.current.add(callback, scope);
    if (!deferCleanup || !mounted.current) {
      return () => context4.current.revert();
    }
  }, dependencies);
  return { context: context4.current, contextSafe: contextSafe.current };
};
useGSAP.register = (core) => {
  _gsap = core;
};
useGSAP.headless = true;
const Section = ({ children, align = "left", className = "", stagger = false }) => {
  const containerRef = reactExports.useRef(null);
  useGSAP(() => {
    const el = containerRef.current;
    if (!el) return;
    const xOff = align === "left" ? -200 : align === "right" ? 200 : 0;
    const yOff = align === "center" ? 100 : 0;
    const targets = stagger ? Array.from(el.children[0].children) : el.children;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gsapWithCSS.to(stagger ? targets : el.children, {
              x: 0,
              y: 0,
              duration: 1.2,
              stagger: 0.2,
              // Stagger effect
              ease: "power4.out",
              overwrite: "auto"
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    gsapWithCSS.set(stagger ? targets : el.children, {
      x: xOff,
      y: yOff
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, { scope: containerRef, dependencies: [align, stagger] });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: containerRef,
      className: `min-h-screen w-full flex flex-col justify-center px-8 md:px-20 ${align === "left" ? "items-start" : align === "right" ? "items-end text-right" : "items-center text-center"} ${className}`,
      children
    }
  );
};
const StudioOverlay = ({ sections, fontSize }) => {
  const displaySections = sections && sections.length > 0 ? sections : [
    {
      card_type: "hero",
      title: "WEBCRAFTER",
      subheader: "The future of 3D web experiences.",
      button_text: "Get Started",
      button_link: "#"
    }
  ];
  const baseSize = fontSize || 16;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-full text-base-content pointer-events-none", style: { fontSize: `${baseSize}px` }, children: displaySections.map((section, i2) => {
    const { card_type } = section;
    if (card_type === "hero") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Section, { align: "center", className: "bg-transparent", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "backdrop-blur-md shadow-xl", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "text-6xl md:text-8xl font-black mb-4 text-primary tracking-tighter ", children: section.title }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-2xl md:text-3xl font-bold mb-8 max-w-2xl", children: section.subheader }),
        section.subsubheader && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-xl font-bold mb-6", children: section.subsubheader }),
        section.button_text && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: section.button_link || "#",
            target: "_blank",
            rel: "noopener noreferrer",
            className: "btn btn-primary btn-lg border-2 border-primary-content/20 bg-primary hover:bg-primary-focus text-primary-content rounded-full px-12 pointer-events-auto shadow-lg",
            children: section.button_text
          }
        )
      ] }) }, i2);
    }
    if (card_type === "left") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Section, { align: "left", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "card w-full md:w-1/2 bg-base-100/80 backdrop-blur-md shadow-xl border border-base-300", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "card-body p-10", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "card-title text-4xl mb-4 text-secondary", children: section.title }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-lg", children: section.body_text }),
        section.button_text && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "card-actions justify-end mt-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: section.button_link || "#",
            target: "_blank",
            rel: "noopener noreferrer",
            className: "btn btn-secondary btn-outline pointer-events-auto",
            children: section.button_text
          }
        ) })
      ] }) }) }, i2);
    }
    if (card_type === "right") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Section, { align: "right", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "card w-full md:w-1/2 bg-neutral/80 text-neutral-content backdrop-blur-md shadow-xl", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "card-body p-10", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "card-title text-4xl mb-4 text-accent", children: section.title }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-lg", children: section.body_text }),
        section.button_text && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "card-actions justify-end mt-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "a",
          {
            href: section.button_link || "#",
            target: "_blank",
            rel: "noopener noreferrer",
            className: "btn btn-accent btn-outline pointer-events-auto",
            children: section.button_text
          }
        ) })
      ] }) }) }, i2);
    }
    if (card_type === "small") {
      const stats = [];
      if (section.stat1_title) stats.push({ title: section.stat1_title, value: section.stat1_value, desc: section.stat1_desc });
      if (section.stat2_title) stats.push({ title: section.stat2_title, value: section.stat2_value, desc: section.stat2_desc });
      if (section.stat3_title) stats.push({ title: section.stat3_title, value: section.stat3_value, desc: section.stat3_desc });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Section, { align: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-6xl", children: stats.map((stat, idx) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stats shadow bg-base-200/90 backdrop-blur p-4", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "stat place-items-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stat-title", children: stat.title }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stat-value text-primary", children: stat.value }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stat-desc", children: stat.desc })
      ] }) }, idx)) }) }, i2);
    }
    return null;
  }) });
};
const __vite_import_meta_env__ = {};
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if ((__vite_import_meta_env__ ? "production" : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, getInitialState, subscribe, destroy };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
const { useDebugValue } = React;
const { useSyncExternalStoreWithSelector } = useSyncExternalStoreExports;
const identity = (arg) => arg;
function useStoreWithEqualityFn(api, selector3 = identity, equalityFn) {
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getInitialState,
    selector3,
    equalityFn
  );
  useDebugValue(slice);
  return slice;
}
const createWithEqualityFnImpl = (createState, defaultEqualityFn) => {
  const api = createStore(createState);
  const useBoundStoreWithEqualityFn = (selector3, equalityFn = defaultEqualityFn) => useStoreWithEqualityFn(api, selector3, equalityFn);
  Object.assign(useBoundStoreWithEqualityFn, api);
  return useBoundStoreWithEqualityFn;
};
const createWithEqualityFn = (createState, defaultEqualityFn) => createState ? createWithEqualityFnImpl(createState, defaultEqualityFn) : createWithEqualityFnImpl;
function shallow$1(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  if (objA instanceof Map && objB instanceof Map) {
    if (objA.size !== objB.size) return false;
    for (const [key, value] of objA) {
      if (!Object.is(value, objB.get(key))) {
        return false;
      }
    }
    return true;
  }
  if (objA instanceof Set && objB instanceof Set) {
    if (objA.size !== objB.size) return false;
    for (const value of objA) {
      if (!objB.has(value)) {
        return false;
      }
    }
    return true;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (const keyA of keysA) {
    if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) {
      return false;
    }
  }
  return true;
}
const usePerfImpl = createWithEqualityFn((set, get) => {
  function getReport() {
    var _a2;
    const { accumulated, startTime, infos } = get();
    const maxMemory = (_a2 = get().log) == null ? void 0 : _a2.maxMemory;
    const { totalFrames, log, gl, max: max2 } = accumulated;
    const glAverage = {
      calls: gl.calls / totalFrames,
      triangles: gl.triangles / totalFrames,
      points: gl.points / totalFrames,
      lines: gl.lines / totalFrames
    };
    const logAverage = {
      gpu: log.gpu / totalFrames,
      cpu: log.cpu / totalFrames,
      mem: log.mem / totalFrames,
      fps: log.fps / totalFrames
    };
    const sessionTime = (window.performance.now() - startTime) / 1e3;
    return {
      sessionTime,
      infos,
      log: logAverage,
      gl: glAverage,
      max: max2,
      maxMemory,
      totalFrames
    };
  }
  return {
    log: null,
    paused: false,
    triggerProgramsUpdate: 0,
    startTime: 0,
    customData: 0,
    fpsLimit: 60,
    overclockingFps: false,
    accumulated: {
      totalFrames: 0,
      gl: {
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0,
        counts: 0
      },
      log: {
        gpu: 0,
        cpu: 0,
        mem: 0,
        fps: 0
      },
      max: {
        gl: {
          calls: 0,
          triangles: 0,
          points: 0,
          lines: 0,
          counts: 0
        },
        log: {
          gpu: 0,
          cpu: 0,
          mem: 0,
          fps: 0
        }
      }
    },
    chart: {
      data: {
        fps: [],
        cpu: [],
        gpu: [],
        mem: []
      },
      circularId: 0
    },
    gl: void 0,
    objectWithMaterials: null,
    scene: void 0,
    programs: /* @__PURE__ */ new Map(),
    sceneLength: void 0,
    tab: "infos",
    getReport
  };
});
const usePerf = (sel) => usePerfImpl(sel, shallow$1);
Object.assign(usePerf, usePerfImpl);
const { getState: getPerf, setState: setPerf } = usePerfImpl;
const overLimitFps = {
  value: 0,
  fpsLimit: 60,
  isOverLimit: 0
};
const average = (arr) => (arr == null ? void 0 : arr.reduce((a5, b6) => a5 + b6, 0)) / arr.length;
class GLPerf {
  constructor(settings = {}) {
    this.names = [""];
    this.finished = [];
    this.paused = false;
    this.overClock = false;
    this.queryHasResult = false;
    this.queryCreated = false;
    this.isWebGL2 = true;
    this.memAccums = [];
    this.gpuAccums = [];
    this.activeAccums = [];
    this.logsAccums = {
      mem: [],
      gpu: [],
      cpu: [],
      fps: [],
      fpsFixed: []
    };
    this.fpsChart = [];
    this.gpuChart = [];
    this.cpuChart = [];
    this.memChart = [];
    this.paramLogger = () => {
    };
    this.glFinish = () => {
    };
    this.chartLogger = () => {
    };
    this.chartLen = 60;
    this.logsPerSecond = 10;
    this.maxMemory = 1500;
    this.chartHz = 10;
    this.startCpuProfiling = false;
    this.lastCalculateFixed = 0;
    this.chartFrame = 0;
    this.gpuTimeProcess = 0;
    this.chartTime = 0;
    this.activeQueries = 0;
    this.circularId = 0;
    this.detected = 0;
    this.frameId = 0;
    this.rafId = 0;
    this.idleCbId = 0;
    this.checkQueryId = 0;
    this.uuid = void 0;
    this.currentCpu = 0;
    this.currentMem = 0;
    this.paramFrame = 0;
    this.paramTime = 0;
    this.now = () => {
    };
    this.t0 = 0;
    window.GLPerf = window.GLPerf || {};
    Object.assign(this, settings);
    this.fpsChart = new Array(this.chartLen).fill(0);
    this.gpuChart = new Array(this.chartLen).fill(0);
    this.cpuChart = new Array(this.chartLen).fill(0);
    this.memChart = new Array(this.chartLen).fill(0);
    this.now = () => window.performance && window.performance.now ? window.performance.now() : Date.now();
    this.initGpu();
    this.is120hz();
  }
  initGpu() {
    this.uuid = MathUtils.generateUUID();
    if (this.gl) {
      this.isWebGL2 = true;
      if (!this.extension) {
        this.extension = this.gl.getExtension("EXT_disjoint_timer_query_webgl2");
      }
      if (this.extension === null) {
        this.isWebGL2 = false;
      }
    }
  }
  /**
   * 120hz device detection
   */
  is120hz() {
    let n2 = 0;
    const loop2 = (t2) => {
      if (++n2 < 20) {
        this.rafId = window.requestAnimationFrame(loop2);
      } else {
        this.detected = Math.ceil(1e3 * n2 / (t2 - this.t0) / 70);
        window.cancelAnimationFrame(this.rafId);
      }
      if (!this.t0) this.t0 = t2;
    };
    this.rafId = window.requestAnimationFrame(loop2);
  }
  /**
   * Explicit UI add
   * @param { string | undefined } name
   */
  addUI(name) {
    if (this.names.indexOf(name) === -1) {
      this.names.push(name);
      this.gpuAccums.push(0);
      this.activeAccums.push(false);
    }
  }
  nextFps(d3) {
    const goal = 1e3 / 60;
    const elapsed = goal - d3.timeRemaining();
    const fps = goal * overLimitFps.fpsLimit / 10 / elapsed;
    if (fps < 0) return;
    overLimitFps.value = fps;
    if (overLimitFps.isOverLimit < 25) {
      overLimitFps.isOverLimit++;
    } else {
      setPerf({ overclockingFps: true });
    }
  }
  /**
   * Increase frameID
   * @param { any | undefined } now
   */
  nextFrame(now2) {
    this.frameId++;
    const t2 = now2 || this.now();
    let duration = t2 - this.paramTime;
    let gpu = 0;
    if (this.frameId <= 1) {
      this.paramFrame = this.frameId;
      this.paramTime = t2;
    } else {
      if (t2 >= this.paramTime) {
        this.maxMemory = window.performance.memory ? window.performance.memory.jsHeapSizeLimit / 1048576 : 0;
        const frameCount = this.frameId - this.paramFrame;
        const fpsFixed = frameCount * 1e3 / duration;
        const fps = getPerf().overclockingFps ? overLimitFps.value : fpsFixed;
        gpu = this.isWebGL2 ? this.gpuAccums[0] : this.gpuAccums[0] / duration;
        if (this.isWebGL2) {
          this.gpuAccums[0] = 0;
        } else {
          Promise.all(this.finished).then(() => {
            this.gpuAccums[0] = 0;
            this.finished = [];
          });
        }
        this.currentMem = Math.round(
          window.performance && window.performance.memory ? window.performance.memory.usedJSHeapSize / 1048576 : 0
        );
        if (window.performance && this.startCpuProfiling) {
          window.performance.mark("cpu-finished");
          const cpuMeasure = performance.measure("cpu-duration", "cpu-started", "cpu-finished");
          this.currentCpu = (cpuMeasure == null ? void 0 : cpuMeasure.duration) || 0;
          this.logsAccums.cpu.push(this.currentCpu);
          this.startCpuProfiling = false;
        }
        this.logsAccums.mem.push(this.currentMem);
        this.logsAccums.fpsFixed.push(fpsFixed);
        this.logsAccums.fps.push(fps);
        this.logsAccums.gpu.push(gpu);
        if (this.overClock && typeof window.requestIdleCallback !== "undefined") {
          if (overLimitFps.isOverLimit > 0 && fps > fpsFixed) {
            overLimitFps.isOverLimit--;
          } else if (getPerf().overclockingFps) {
            setPerf({ overclockingFps: false });
          }
        }
        if (t2 >= this.paramTime + 1e3 / this.logsPerSecond) {
          this.paramLogger({
            cpu: average(this.logsAccums.cpu),
            gpu: average(this.logsAccums.gpu),
            mem: average(this.logsAccums.mem),
            fps: average(this.logsAccums.fps),
            duration: Math.round(duration),
            maxMemory: this.maxMemory,
            frameCount
          });
          this.logsAccums.mem = [];
          this.logsAccums.fps = [];
          this.logsAccums.gpu = [];
          this.logsAccums.cpu = [];
          this.paramFrame = this.frameId;
          this.paramTime = t2;
        }
        if (this.overClock) {
          if (t2 - this.lastCalculateFixed >= 2 * 1e3) {
            this.lastCalculateFixed = now2;
            overLimitFps.fpsLimit = Math.round(average(this.logsAccums.fpsFixed) / 10) * 100;
            setPerf({ fpsLimit: overLimitFps.fpsLimit / 10 });
            this.logsAccums.fpsFixed = [];
            this.paramFrame = this.frameId;
            this.paramTime = t2;
          }
        }
      }
    }
    if (!this.detected || !this.chartFrame) {
      this.chartFrame = this.frameId;
      this.chartTime = t2;
      this.circularId = 0;
    } else {
      const timespan = t2 - this.chartTime;
      let hz = this.chartHz * timespan / 1e3;
      while (--hz > 0 && this.detected) {
        const frameCount = this.frameId - this.chartFrame;
        const fpsFixed = frameCount / timespan * 1e3;
        const fps = getPerf().overclockingFps ? overLimitFps.value : fpsFixed;
        this.fpsChart[this.circularId % this.chartLen] = fps;
        const memS = 1e3 / this.currentMem;
        const cpuS = this.currentCpu;
        const gpuS = (this.isWebGL2 ? this.gpuAccums[1] * 2 : Math.round(this.gpuAccums[1] / duration * 100)) + 4;
        if (gpuS > 0) {
          this.gpuChart[this.circularId % this.chartLen] = gpuS;
        }
        if (cpuS > 0) {
          this.cpuChart[this.circularId % this.chartLen] = cpuS;
        }
        if (memS > 0) {
          this.memChart[this.circularId % this.chartLen] = memS;
        }
        for (let i2 = 0; i2 < this.names.length; i2++) {
          this.chartLogger({
            i: i2,
            data: {
              fps: this.fpsChart,
              gpu: this.gpuChart,
              cpu: this.cpuChart,
              mem: this.memChart
            },
            circularId: this.circularId
          });
        }
        this.circularId++;
        this.chartFrame = this.frameId;
        this.chartTime = t2;
      }
    }
  }
  startGpu() {
    const gl = this.gl;
    const ext = this.extension;
    if (!gl || !ext) return;
    if (this.isWebGL2) {
      let available = false;
      let disjoint, ns;
      if (this.query) {
        this.queryHasResult = false;
        let query2 = this.query;
        available = gl.getQueryParameter(query2, gl.QUERY_RESULT_AVAILABLE);
        disjoint = gl.getParameter(ext.GPU_DISJOINT_EXT);
        if (available && !disjoint) {
          ns = gl.getQueryParameter(this.query, gl.QUERY_RESULT);
          const ms = ns * 1e-6;
          if (available || disjoint) {
            gl.deleteQuery(this.query);
            query2 = null;
          }
          if (available && ms > 0) {
            if (!disjoint) {
              this.activeAccums.forEach((_active, i2) => {
                this.gpuAccums[i2] = ms;
              });
            }
          }
        }
      }
      if (available || !this.query) {
        this.queryCreated = true;
        this.query = gl.createQuery();
        gl.beginQuery(ext.TIME_ELAPSED_EXT, this.query);
      }
    }
  }
  endGpu() {
    const ext = this.extension;
    const gl = this.gl;
    if (this.isWebGL2 && this.queryCreated && gl.getQuery(ext.TIME_ELAPSED_EXT, gl.CURRENT_QUERY)) {
      gl.endQuery(ext.TIME_ELAPSED_EXT);
    }
  }
  /**
   * Begin named measurement
   * @param { string | undefined } name
   */
  begin(name) {
    this.startGpu();
    this.updateAccums(name);
  }
  /**
   * End named measure
   * @param { string | undefined } name
   */
  end(name) {
    this.endGpu();
    this.updateAccums(name);
  }
  updateAccums(name) {
    let nameId = this.names.indexOf(name);
    if (nameId === -1) {
      nameId = this.names.length;
      this.addUI(name);
    }
    const t2 = this.now();
    this.activeAccums[nameId] = !this.activeAccums[nameId];
    this.t0 = t2;
  }
}
const countGeoDrawCalls = (programs) => {
  programs.forEach((program, _pkey) => {
    const { meshes } = program;
    if (!meshes) {
      return;
    }
    let drawCounts = {
      total: 0,
      type: "Triangle",
      data: []
    };
    Object.keys(meshes).forEach((key) => {
      const mesh = meshes[key];
      const { geometry, material } = mesh;
      let index = geometry.index;
      const position = geometry.attributes.position;
      if (!position) return;
      let rangeFactor = 1;
      if (material.wireframe === true) {
        rangeFactor = 0;
      }
      const dataCount = index !== null ? index.count : position.count;
      const rangeStart = geometry.drawRange.start * rangeFactor;
      const rangeCount = geometry.drawRange.count * rangeFactor;
      const drawStart = rangeStart;
      const drawEnd = Math.min(dataCount, rangeStart + rangeCount) - 1;
      let countInstanceRatio = 1;
      const instanceCount = mesh.count || 1;
      let type = "Triangle";
      let mostDrawCalls = 0;
      if (mesh.isMesh) {
        if (material.wireframe === true) {
          type = "Line";
          countInstanceRatio = countInstanceRatio / 2;
        } else {
          type = "Triangle";
          countInstanceRatio = countInstanceRatio / 3;
        }
      } else if (mesh.isLine) {
        type = "Line";
        if (mesh.isLineSegments) {
          countInstanceRatio = countInstanceRatio / 2;
        } else if (mesh.isLineLoop) {
          countInstanceRatio = countInstanceRatio;
        } else {
          countInstanceRatio = countInstanceRatio - 1;
        }
      } else if (mesh.isPoints) {
        type = "Point";
        countInstanceRatio = countInstanceRatio;
      } else if (mesh.isSprite) {
        type = "Triangle";
        countInstanceRatio = countInstanceRatio / 3;
      }
      const drawCount = Math.round(Math.max(0, drawEnd - drawStart + 1) * (countInstanceRatio * instanceCount));
      if (drawCount > mostDrawCalls) {
        mostDrawCalls = drawCount;
        drawCounts.type = type;
      }
      drawCounts.total += drawCount;
      drawCounts.data.push({ drawCount, type });
      mesh.userData.drawCount = {
        type,
        count: drawCount
      };
    });
    program.drawCounts = drawCounts;
  });
};
var eventemitter3 = { exports: {} };
var hasRequiredEventemitter3;
function requireEventemitter3() {
  if (hasRequiredEventemitter3) return eventemitter3.exports;
  hasRequiredEventemitter3 = 1;
  (function(module) {
    var has = Object.prototype.hasOwnProperty, prefix2 = "~";
    function Events() {
    }
    if (Object.create) {
      Events.prototype = /* @__PURE__ */ Object.create(null);
      if (!new Events().__proto__) prefix2 = false;
    }
    function EE(fn, context4, once2) {
      this.fn = fn;
      this.context = context4;
      this.once = once2 || false;
    }
    function addListener(emitter, event, fn, context4, once2) {
      if (typeof fn !== "function") {
        throw new TypeError("The listener must be a function");
      }
      var listener = new EE(fn, context4 || emitter, once2), evt = prefix2 ? prefix2 + event : event;
      if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
      else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
      else emitter._events[evt] = [emitter._events[evt], listener];
      return emitter;
    }
    function clearEvent(emitter, evt) {
      if (--emitter._eventsCount === 0) emitter._events = new Events();
      else delete emitter._events[evt];
    }
    function EventEmitter2() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    EventEmitter2.prototype.eventNames = function eventNames() {
      var names = [], events, name;
      if (this._eventsCount === 0) return names;
      for (name in events = this._events) {
        if (has.call(events, name)) names.push(prefix2 ? name.slice(1) : name);
      }
      if (Object.getOwnPropertySymbols) {
        return names.concat(Object.getOwnPropertySymbols(events));
      }
      return names;
    };
    EventEmitter2.prototype.listeners = function listeners(event) {
      var evt = prefix2 ? prefix2 + event : event, handlers = this._events[evt];
      if (!handlers) return [];
      if (handlers.fn) return [handlers.fn];
      for (var i2 = 0, l2 = handlers.length, ee = new Array(l2); i2 < l2; i2++) {
        ee[i2] = handlers[i2].fn;
      }
      return ee;
    };
    EventEmitter2.prototype.listenerCount = function listenerCount(event) {
      var evt = prefix2 ? prefix2 + event : event, listeners = this._events[evt];
      if (!listeners) return 0;
      if (listeners.fn) return 1;
      return listeners.length;
    };
    EventEmitter2.prototype.emit = function emit(event, a1, a22, a32, a42, a5) {
      var evt = prefix2 ? prefix2 + event : event;
      if (!this._events[evt]) return false;
      var listeners = this._events[evt], len = arguments.length, args, i2;
      if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);
        switch (len) {
          case 1:
            return listeners.fn.call(listeners.context), true;
          case 2:
            return listeners.fn.call(listeners.context, a1), true;
          case 3:
            return listeners.fn.call(listeners.context, a1, a22), true;
          case 4:
            return listeners.fn.call(listeners.context, a1, a22, a32), true;
          case 5:
            return listeners.fn.call(listeners.context, a1, a22, a32, a42), true;
          case 6:
            return listeners.fn.call(listeners.context, a1, a22, a32, a42, a5), true;
        }
        for (i2 = 1, args = new Array(len - 1); i2 < len; i2++) {
          args[i2 - 1] = arguments[i2];
        }
        listeners.fn.apply(listeners.context, args);
      } else {
        var length = listeners.length, j3;
        for (i2 = 0; i2 < length; i2++) {
          if (listeners[i2].once) this.removeListener(event, listeners[i2].fn, void 0, true);
          switch (len) {
            case 1:
              listeners[i2].fn.call(listeners[i2].context);
              break;
            case 2:
              listeners[i2].fn.call(listeners[i2].context, a1);
              break;
            case 3:
              listeners[i2].fn.call(listeners[i2].context, a1, a22);
              break;
            case 4:
              listeners[i2].fn.call(listeners[i2].context, a1, a22, a32);
              break;
            default:
              if (!args) for (j3 = 1, args = new Array(len - 1); j3 < len; j3++) {
                args[j3 - 1] = arguments[j3];
              }
              listeners[i2].fn.apply(listeners[i2].context, args);
          }
        }
      }
      return true;
    };
    EventEmitter2.prototype.on = function on(event, fn, context4) {
      return addListener(this, event, fn, context4, false);
    };
    EventEmitter2.prototype.once = function once2(event, fn, context4) {
      return addListener(this, event, fn, context4, true);
    };
    EventEmitter2.prototype.removeListener = function removeListener(event, fn, context4, once2) {
      var evt = prefix2 ? prefix2 + event : event;
      if (!this._events[evt]) return this;
      if (!fn) {
        clearEvent(this, evt);
        return this;
      }
      var listeners = this._events[evt];
      if (listeners.fn) {
        if (listeners.fn === fn && (!once2 || listeners.once) && (!context4 || listeners.context === context4)) {
          clearEvent(this, evt);
        }
      } else {
        for (var i2 = 0, events = [], length = listeners.length; i2 < length; i2++) {
          if (listeners[i2].fn !== fn || once2 && !listeners[i2].once || context4 && listeners[i2].context !== context4) {
            events.push(listeners[i2]);
          }
        }
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
      }
      return this;
    };
    EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
      if (event) {
        evt = prefix2 ? prefix2 + event : event;
        if (this._events[evt]) clearEvent(this, evt);
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
      return this;
    };
    EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
    EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
    EventEmitter2.prefixed = prefix2;
    EventEmitter2.EventEmitter = EventEmitter2;
    {
      module.exports = EventEmitter2;
    }
  })(eventemitter3);
  return eventemitter3.exports;
}
var eventemitter3Exports = requireEventemitter3();
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
const eventEmitter = /* @__PURE__ */ new EventEmitter();
function onEvent(eventName, handler, options) {
  return eventEmitter.on(eventName, handler);
}
function offEvent(eventName, handler, options) {
  var _a2;
  eventEmitter.removeListener(eventName, handler, (_a2 = options == null ? void 0 : options.context) != null ? _a2 : null, options == null ? void 0 : options.once);
}
function emitEvent(eventName, payload) {
  eventEmitter.emit(eventName, payload);
}
function useEvent(eventName, handler, deps = [], options) {
  const handlerRef = reactExports.useRef(handler);
  reactExports.useEffect(() => void (handlerRef.current = handler), [handler]);
  reactExports.useEffect(() => {
    const handler2 = (event) => {
      var _a2;
      return (_a2 = handlerRef.current) == null ? void 0 : _a2.call(handlerRef, event);
    };
    const context4 = onEvent(eventName, handler2);
    return () => offEvent(eventName, handler2, { ...options, context: context4 });
  }, [eventName, void 0, ...deps]);
}
const updateMatrixWorldTemp = Object3D.prototype.updateMatrixWorld;
const updateWorldMatrixTemp = Object3D.prototype.updateWorldMatrix;
const updateMatrixTemp = Object3D.prototype.updateMatrix;
const maxGl = ["calls", "triangles", "points", "lines"];
const maxLog = ["gpu", "cpu", "mem", "fps"];
let matriceWorldCount = {
  value: 0
};
let matriceCount = {
  value: 0
};
const isUUID = (uuid) => {
  let s2 = "" + uuid;
  s2 = s2.match("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$");
  if (s2 === null) {
    return false;
  }
  return true;
};
const addMuiPerfID = (material, currentObjectWithMaterials) => {
  if (!material.defines) {
    material.defines = {};
  }
  if (material.defines && !material.defines.muiPerf) {
    material.defines = Object.assign(material.defines || {}, {
      muiPerf: material.uuid
    });
  }
  const uuid = material.uuid;
  if (!currentObjectWithMaterials[uuid]) {
    currentObjectWithMaterials[uuid] = {
      meshes: {},
      material
    };
    material.needsUpdate = true;
  }
  material.needsUpdate = false;
  return uuid;
};
const getMUIIndex = (muid) => muid === "muiPerf";
const PerfHeadless = ({ overClock, logsPerSecond, chart, deepAnalyze, matrixUpdate }) => {
  const { gl, scene } = useThree();
  setPerf({ gl, scene });
  const PerfLib = reactExports.useMemo(() => {
    const PerfLib2 = new GLPerf({
      trackGPU: true,
      overClock,
      chartLen: chart ? chart.length : 120,
      chartHz: chart ? chart.hz : 60,
      logsPerSecond: logsPerSecond || 10,
      gl: gl.getContext(),
      chartLogger: (chart2) => {
        setPerf({ chart: chart2 });
      },
      paramLogger: (logger) => {
        const log = {
          maxMemory: logger.maxMemory,
          gpu: logger.gpu,
          cpu: logger.cpu,
          mem: logger.mem,
          fps: logger.fps,
          totalTime: logger.duration,
          frameCount: logger.frameCount
        };
        setPerf({
          log
        });
        const { accumulated } = getPerf();
        const glRender = gl.info.render;
        accumulated.totalFrames++;
        accumulated.gl.calls += glRender.calls;
        accumulated.gl.triangles += glRender.triangles;
        accumulated.gl.points += glRender.points;
        accumulated.gl.lines += glRender.lines;
        accumulated.log.gpu += logger.gpu;
        accumulated.log.cpu += logger.cpu;
        accumulated.log.mem += logger.mem;
        accumulated.log.fps += logger.fps;
        for (let i2 = 0; i2 < maxGl.length; i2++) {
          const key = maxGl[i2];
          const value = glRender[key];
          if (value > accumulated.max.gl[key]) {
            accumulated.max.gl[key] = value;
          }
        }
        for (let i2 = 0; i2 < maxLog.length; i2++) {
          const key = maxLog[i2];
          const value = logger[key];
          if (value > accumulated.max.log[key]) {
            accumulated.max.log[key] = value;
          }
        }
        setPerf({ accumulated });
        emitEvent("log", [log, gl]);
      }
    });
    const ctx2 = gl.getContext();
    let glRenderer = null;
    let glVendor = null;
    const rendererInfo = ctx2.getExtension("WEBGL_debug_renderer_info");
    const glVersion = ctx2.getParameter(ctx2.VERSION);
    if (rendererInfo != null) {
      glRenderer = ctx2.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL);
      glVendor = ctx2.getParameter(rendererInfo.UNMASKED_VENDOR_WEBGL);
    }
    if (!glVendor) {
      glVendor = "Unknown vendor";
    }
    if (!glRenderer) {
      glRenderer = ctx2.getParameter(ctx2.RENDERER);
    }
    setPerf({
      startTime: window.performance.now(),
      infos: {
        version: glVersion,
        renderer: glRenderer,
        vendor: glVendor
      }
    });
    const callbacks = /* @__PURE__ */ new Map();
    const callbacksAfter = /* @__PURE__ */ new Map();
    Object.defineProperty(Scene.prototype, "onBeforeRender", {
      get() {
        return (...args) => {
          var _a2;
          if (PerfLib2) {
            PerfLib2.begin("profiler");
          }
          (_a2 = callbacks.get(this)) == null ? void 0 : _a2(...args);
        };
      },
      set(callback) {
        callbacks.set(this, callback);
      },
      configurable: true
    });
    Object.defineProperty(Scene.prototype, "onAfterRender", {
      get() {
        return (...args) => {
          var _a2;
          if (PerfLib2) {
            PerfLib2.end("profiler");
          }
          (_a2 = callbacksAfter.get(this)) == null ? void 0 : _a2(...args);
        };
      },
      set(callback) {
        callbacksAfter.set(this, callback);
      },
      configurable: true
    });
    return PerfLib2;
  }, []);
  reactExports.useEffect(() => {
    if (PerfLib) {
      PerfLib.overClock = overClock || false;
      if (overClock === false) {
        setPerf({ overclockingFps: false });
        overLimitFps.value = 0;
        overLimitFps.isOverLimit = 0;
      }
      PerfLib.chartHz = (chart == null ? void 0 : chart.hz) || 60;
      PerfLib.chartLen = (chart == null ? void 0 : chart.length) || 120;
    }
  }, [overClock, PerfLib, chart == null ? void 0 : chart.length, chart == null ? void 0 : chart.hz]);
  reactExports.useEffect(() => {
    if (matrixUpdate) {
      Object3D.prototype.updateMatrixWorld = function() {
        if (this.matrixWorldNeedsUpdate || arguments[0]) {
          matriceWorldCount.value++;
        }
        updateMatrixWorldTemp.apply(this, arguments);
      };
      Object3D.prototype.updateWorldMatrix = function() {
        matriceWorldCount.value++;
        updateWorldMatrixTemp.apply(this, arguments);
      };
      Object3D.prototype.updateMatrix = function() {
        matriceCount.value++;
        updateMatrixTemp.apply(this, arguments);
      };
    }
    gl.info.autoReset = false;
    let effectSub = null;
    let afterEffectSub = null;
    if (!gl.info) return;
    effectSub = addEffect(function preRafR3FPerf() {
      if (getPerf().paused) {
        setPerf({ paused: false });
      }
      if (window.performance) {
        window.performance.mark("cpu-started");
        PerfLib.startCpuProfiling = true;
      }
      matriceCount.value -= 1;
      matriceWorldCount.value = 0;
      matriceCount.value = 0;
      if (gl.info) {
        gl.info.reset();
      }
    });
    afterEffectSub = addAfterEffect(function postRafR3FPerf() {
      var _a2, _b2;
      if (PerfLib && !PerfLib.paused) {
        PerfLib.nextFrame(window.performance.now());
        if (overClock && typeof window.requestIdleCallback !== "undefined") {
          PerfLib.idleCbId = requestIdleCallback(PerfLib.nextFps);
        }
      }
      if (deepAnalyze) {
        const currentObjectWithMaterials = {};
        const programs = /* @__PURE__ */ new Map();
        scene.traverse(function deepAnalyzeR3FPerf(object) {
          if (object instanceof Mesh || object instanceof Points) {
            if (object.material) {
              let uuid = object.material.uuid;
              const isTroika = Array.isArray(object.material) && object.material.length > 1;
              if (isTroika) {
                uuid = addMuiPerfID(object.material[1], currentObjectWithMaterials);
              } else {
                uuid = addMuiPerfID(object.material, currentObjectWithMaterials);
              }
              currentObjectWithMaterials[uuid].meshes[object.uuid] = object;
            }
          }
        });
        (_b2 = (_a2 = gl == null ? void 0 : gl.info) == null ? void 0 : _a2.programs) == null ? void 0 : _b2.forEach((program) => {
          const cacheKeySplited = program.cacheKey.split(",");
          const muiPerfTracker = cacheKeySplited[cacheKeySplited.findIndex(getMUIIndex) + 1];
          if (isUUID(muiPerfTracker) && currentObjectWithMaterials[muiPerfTracker]) {
            const { material, meshes } = currentObjectWithMaterials[muiPerfTracker];
            programs.set(muiPerfTracker, {
              program,
              material,
              meshes,
              drawCounts: {
                total: 0,
                type: "triangle",
                data: []
              },
              expand: false,
              visible: true
            });
          }
        });
        if (programs.size !== getPerf().programs.size) {
          countGeoDrawCalls(programs);
          setPerf({
            programs,
            triggerProgramsUpdate: getPerf().triggerProgramsUpdate++
          });
        }
      }
    });
    return () => {
      if (PerfLib) {
        if (typeof window.cancelIdleCallback !== "undefined") {
          window.cancelIdleCallback(PerfLib.idleCbId);
        }
        window.cancelAnimationFrame(PerfLib.rafId);
        window.cancelAnimationFrame(PerfLib.checkQueryId);
      }
      if (matrixUpdate) {
        Object3D.prototype.updateMatrixWorld = updateMatrixTemp;
      }
      effectSub();
      afterEffectSub();
    };
  }, [PerfLib, gl, chart, matrixUpdate]);
  reactExports.useEffect(() => {
    const unsub = addTail(function postRafTailR3FPerf() {
      if (PerfLib) {
        PerfLib.paused = true;
        matriceCount.value = 0;
        matriceWorldCount.value = 0;
        setPerf({
          paused: true,
          log: {
            maxMemory: 0,
            gpu: 0,
            mem: 0,
            cpu: 0,
            fps: 0,
            totalTime: 0,
            frameCount: 0
          }
        });
      }
      return false;
    });
    return () => {
      unsub();
    };
  }, []);
  return null;
};
var e = "colors", t = "sizes", r2 = "space", n = { gap: r2, gridGap: r2, columnGap: r2, gridColumnGap: r2, rowGap: r2, gridRowGap: r2, inset: r2, insetBlock: r2, insetBlockEnd: r2, insetBlockStart: r2, insetInline: r2, insetInlineEnd: r2, insetInlineStart: r2, margin: r2, marginTop: r2, marginRight: r2, marginBottom: r2, marginLeft: r2, marginBlock: r2, marginBlockEnd: r2, marginBlockStart: r2, marginInline: r2, marginInlineEnd: r2, marginInlineStart: r2, padding: r2, paddingTop: r2, paddingRight: r2, paddingBottom: r2, paddingLeft: r2, paddingBlock: r2, paddingBlockEnd: r2, paddingBlockStart: r2, paddingInline: r2, paddingInlineEnd: r2, paddingInlineStart: r2, top: r2, right: r2, bottom: r2, left: r2, scrollMargin: r2, scrollMarginTop: r2, scrollMarginRight: r2, scrollMarginBottom: r2, scrollMarginLeft: r2, scrollMarginX: r2, scrollMarginY: r2, scrollMarginBlock: r2, scrollMarginBlockEnd: r2, scrollMarginBlockStart: r2, scrollMarginInline: r2, scrollMarginInlineEnd: r2, scrollMarginInlineStart: r2, scrollPadding: r2, scrollPaddingTop: r2, scrollPaddingRight: r2, scrollPaddingBottom: r2, scrollPaddingLeft: r2, scrollPaddingX: r2, scrollPaddingY: r2, scrollPaddingBlock: r2, scrollPaddingBlockEnd: r2, scrollPaddingBlockStart: r2, scrollPaddingInline: r2, scrollPaddingInlineEnd: r2, scrollPaddingInlineStart: r2, fontSize: "fontSizes", background: e, backgroundColor: e, backgroundImage: e, borderImage: e, border: e, borderBlock: e, borderBlockEnd: e, borderBlockStart: e, borderBottom: e, borderBottomColor: e, borderColor: e, borderInline: e, borderInlineEnd: e, borderInlineStart: e, borderLeft: e, borderLeftColor: e, borderRight: e, borderRightColor: e, borderTop: e, borderTopColor: e, caretColor: e, color: e, columnRuleColor: e, fill: e, outline: e, outlineColor: e, stroke: e, textDecorationColor: e, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: t, minBlockSize: t, maxBlockSize: t, inlineSize: t, minInlineSize: t, maxInlineSize: t, width: t, minWidth: t, maxWidth: t, height: t, minHeight: t, maxHeight: t, flexBasis: t, gridTemplateColumns: t, gridTemplateRows: t, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" }, i = (e2, t2) => "function" == typeof t2 ? { "()": Function.prototype.toString.call(t2) } : t2, o = () => {
  const e2 = /* @__PURE__ */ Object.create(null);
  return (t2, r3, ...n2) => {
    const o2 = ((e3) => JSON.stringify(e3, i))(t2);
    return o2 in e2 ? e2[o2] : e2[o2] = r3(t2, ...n2);
  };
}, l = /* @__PURE__ */ Symbol.for("sxs.internal"), s = (e2, t2) => Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2)), a = (e2) => {
  for (const t2 in e2) return true;
  return false;
}, { hasOwnProperty: c } = Object.prototype, d2 = (e2) => e2.includes("-") ? e2 : e2.replace(/[A-Z]/g, ((e3) => "-" + e3.toLowerCase())), g = /\s+(?![^()]*\))/, p2 = (e2) => (t2) => e2(..."string" == typeof t2 ? String(t2).split(g) : [t2]), u = { appearance: (e2) => ({ WebkitAppearance: e2, appearance: e2 }), backfaceVisibility: (e2) => ({ WebkitBackfaceVisibility: e2, backfaceVisibility: e2 }), backdropFilter: (e2) => ({ WebkitBackdropFilter: e2, backdropFilter: e2 }), backgroundClip: (e2) => ({ WebkitBackgroundClip: e2, backgroundClip: e2 }), boxDecorationBreak: (e2) => ({ WebkitBoxDecorationBreak: e2, boxDecorationBreak: e2 }), clipPath: (e2) => ({ WebkitClipPath: e2, clipPath: e2 }), content: (e2) => ({ content: e2.includes('"') || e2.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e2) ? e2 : `"${e2}"` }), hyphens: (e2) => ({ WebkitHyphens: e2, hyphens: e2 }), maskImage: (e2) => ({ WebkitMaskImage: e2, maskImage: e2 }), maskSize: (e2) => ({ WebkitMaskSize: e2, maskSize: e2 }), tabSize: (e2) => ({ MozTabSize: e2, tabSize: e2 }), textSizeAdjust: (e2) => ({ WebkitTextSizeAdjust: e2, textSizeAdjust: e2 }), userSelect: (e2) => ({ WebkitUserSelect: e2, userSelect: e2 }), marginBlock: p2(((e2, t2) => ({ marginBlockStart: e2, marginBlockEnd: t2 || e2 }))), marginInline: p2(((e2, t2) => ({ marginInlineStart: e2, marginInlineEnd: t2 || e2 }))), maxSize: p2(((e2, t2) => ({ maxBlockSize: e2, maxInlineSize: t2 || e2 }))), minSize: p2(((e2, t2) => ({ minBlockSize: e2, minInlineSize: t2 || e2 }))), paddingBlock: p2(((e2, t2) => ({ paddingBlockStart: e2, paddingBlockEnd: t2 || e2 }))), paddingInline: p2(((e2, t2) => ({ paddingInlineStart: e2, paddingInlineEnd: t2 || e2 }))) }, h = /([\d.]+)([^]*)/, f = (e2, t2) => e2.length ? e2.reduce(((e3, r3) => (e3.push(...t2.map(((e4) => e4.includes("&") ? e4.replace(/&/g, /[ +>|~]/.test(r3) && /&.*&/.test(e4) ? `:is(${r3})` : r3) : r3 + " " + e4))), e3)), []) : t2, m = (e2, t2) => e2 in b5 && "string" == typeof t2 ? t2.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, ((t3, r3, n2, i2) => r3 + ("stretch" === n2 ? `-moz-available${i2};${d2(e2)}:${r3}-webkit-fill-available` : `-moz-fit-content${i2};${d2(e2)}:${r3}fit-content`) + i2)) : String(t2), b5 = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 }, S = (e2) => e2 ? e2 + "-" : "", k = (e2, t2, r3) => e2.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, ((e3, n2, i2, o2, l2) => "$" == o2 == !!i2 ? e3 : (n2 || "--" == o2 ? "calc(" : "") + "var(--" + ("$" === o2 ? S(t2) + (l2.includes("$") ? "" : S(r3)) + l2.replace(/\$/g, "-") : l2) + ")" + (n2 || "--" == o2 ? "*" + (n2 || "") + (i2 || "1") + ")" : ""))), y = /\s*,\s*(?![^()]*\))/, B = Object.prototype.toString, $ = (e2, t2, r3, n2, i2) => {
  let o2, l2, s2;
  const a5 = (e3, t3, r4) => {
    let c2, g2;
    const p3 = (e4) => {
      for (c2 in e4) {
        const R2 = 64 === c2.charCodeAt(0), z2 = R2 && Array.isArray(e4[c2]) ? e4[c2] : [e4[c2]];
        for (g2 of z2) {
          const e5 = /[A-Z]/.test($2 = c2) ? $2 : $2.replace(/-[^]/g, ((e6) => e6[1].toUpperCase())), z3 = "object" == typeof g2 && g2 && g2.toString === B && (!n2.utils[e5] || !t3.length);
          if (e5 in n2.utils && !z3) {
            const t4 = n2.utils[e5];
            if (t4 !== l2) {
              l2 = t4, p3(t4(g2)), l2 = null;
              continue;
            }
          } else if (e5 in u) {
            const t4 = u[e5];
            if (t4 !== s2) {
              s2 = t4, p3(t4(g2)), s2 = null;
              continue;
            }
          }
          if (R2 && (b6 = c2.slice(1) in n2.media ? "@media " + n2.media[c2.slice(1)] : c2, c2 = b6.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, ((e6, t4, r5, n3, i3, o3) => {
            const l3 = h.test(t4), s3 = 0.0625 * (l3 ? -1 : 1), [a6, c5] = l3 ? [n3, t4] : [t4, n3];
            return "(" + ("=" === r5[0] ? "" : ">" === r5[0] === l3 ? "max-" : "min-") + a6 + ":" + ("=" !== r5[0] && 1 === r5.length ? c5.replace(h, ((e7, t5, n4) => Number(t5) + s3 * (">" === r5 ? 1 : -1) + n4)) : c5) + (i3 ? ") and (" + (">" === i3[0] ? "min-" : "max-") + a6 + ":" + (1 === i3.length ? o3.replace(h, ((e7, t5, r6) => Number(t5) + s3 * (">" === i3 ? -1 : 1) + r6)) : o3) : "") + ")";
          }))), z3) {
            const e6 = R2 ? r4.concat(c2) : [...r4], n3 = R2 ? [...t3] : f(t3, c2.split(y));
            void 0 !== o2 && i2(x2(...o2)), o2 = void 0, a5(g2, n3, e6);
          } else void 0 === o2 && (o2 = [[], t3, r4]), c2 = R2 || 36 !== c2.charCodeAt(0) ? c2 : `--${S(n2.prefix)}${c2.slice(1).replace(/\$/g, "-")}`, g2 = z3 ? g2 : "number" == typeof g2 ? g2 && e5 in I ? String(g2) + "px" : String(g2) : k(m(e5, null == g2 ? "" : g2), n2.prefix, n2.themeMap[e5]), o2[0].push(`${R2 ? `${c2} ` : `${d2(c2)}:`}${g2}`);
        }
      }
      var b6, $2;
    };
    p3(e3), void 0 !== o2 && i2(x2(...o2)), o2 = void 0;
  };
  a5(e2, t2, r3);
}, x2 = (e2, t2, r3) => `${r3.map(((e3) => `${e3}{`)).join("")}${t2.length ? `${t2.join(",")}{` : ""}${e2.join(";")}${t2.length ? "}" : ""}${Array(r3.length ? r3.length + 1 : 0).join("}")}`, I = { animationDelay: 1, animationDuration: 1, backgroundSize: 1, blockSize: 1, border: 1, borderBlock: 1, borderBlockEnd: 1, borderBlockEndWidth: 1, borderBlockStart: 1, borderBlockStartWidth: 1, borderBlockWidth: 1, borderBottom: 1, borderBottomLeftRadius: 1, borderBottomRightRadius: 1, borderBottomWidth: 1, borderEndEndRadius: 1, borderEndStartRadius: 1, borderInlineEnd: 1, borderInlineEndWidth: 1, borderInlineStart: 1, borderInlineStartWidth: 1, borderInlineWidth: 1, borderLeft: 1, borderLeftWidth: 1, borderRadius: 1, borderRight: 1, borderRightWidth: 1, borderSpacing: 1, borderStartEndRadius: 1, borderStartStartRadius: 1, borderTop: 1, borderTopLeftRadius: 1, borderTopRightRadius: 1, borderTopWidth: 1, borderWidth: 1, bottom: 1, columnGap: 1, columnRule: 1, columnRuleWidth: 1, columnWidth: 1, containIntrinsicSize: 1, flexBasis: 1, fontSize: 1, gap: 1, gridAutoColumns: 1, gridAutoRows: 1, gridTemplateColumns: 1, gridTemplateRows: 1, height: 1, inlineSize: 1, inset: 1, insetBlock: 1, insetBlockEnd: 1, insetBlockStart: 1, insetInline: 1, insetInlineEnd: 1, insetInlineStart: 1, left: 1, letterSpacing: 1, margin: 1, marginBlock: 1, marginBlockEnd: 1, marginBlockStart: 1, marginBottom: 1, marginInline: 1, marginInlineEnd: 1, marginInlineStart: 1, marginLeft: 1, marginRight: 1, marginTop: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, offsetDistance: 1, offsetRotate: 1, outline: 1, outlineOffset: 1, outlineWidth: 1, overflowClipMargin: 1, padding: 1, paddingBlock: 1, paddingBlockEnd: 1, paddingBlockStart: 1, paddingBottom: 1, paddingInline: 1, paddingInlineEnd: 1, paddingInlineStart: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1, perspective: 1, right: 1, rowGap: 1, scrollMargin: 1, scrollMarginBlock: 1, scrollMarginBlockEnd: 1, scrollMarginBlockStart: 1, scrollMarginBottom: 1, scrollMarginInline: 1, scrollMarginInlineEnd: 1, scrollMarginInlineStart: 1, scrollMarginLeft: 1, scrollMarginRight: 1, scrollMarginTop: 1, scrollPadding: 1, scrollPaddingBlock: 1, scrollPaddingBlockEnd: 1, scrollPaddingBlockStart: 1, scrollPaddingBottom: 1, scrollPaddingInline: 1, scrollPaddingInlineEnd: 1, scrollPaddingInlineStart: 1, scrollPaddingLeft: 1, scrollPaddingRight: 1, scrollPaddingTop: 1, shapeMargin: 1, textDecoration: 1, textDecorationThickness: 1, textIndent: 1, textUnderlineOffset: 1, top: 1, transitionDelay: 1, transitionDuration: 1, verticalAlign: 1, width: 1, wordSpacing: 1 }, R = (e2) => String.fromCharCode(e2 + (e2 > 25 ? 39 : 97)), z = (e2) => ((e3) => {
  let t2, r3 = "";
  for (t2 = Math.abs(e3); t2 > 52; t2 = t2 / 52 | 0) r3 = R(t2 % 52) + r3;
  return R(t2 % 52) + r3;
})(((e3, t2) => {
  let r3 = t2.length;
  for (; r3; ) e3 = 33 * e3 ^ t2.charCodeAt(--r3);
  return e3;
})(5381, JSON.stringify(e2)) >>> 0), W = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"], j2 = (e2) => {
  if (e2.href && !e2.href.startsWith(location.origin)) return false;
  try {
    return !!e2.cssRules;
  } catch (e3) {
    return false;
  }
}, E = (e2) => {
  let t2;
  const r3 = () => {
    const { cssRules: e3 } = t2.sheet;
    return [].map.call(e3, ((r4, n3) => {
      const { cssText: i2 } = r4;
      let o2 = "";
      if (i2.startsWith("--sxs")) return "";
      if (e3[n3 - 1] && (o2 = e3[n3 - 1].cssText).startsWith("--sxs")) {
        if (!r4.cssRules.length) return "";
        for (const e4 in t2.rules) if (t2.rules[e4].group === r4) return `--sxs{--sxs:${[...t2.rules[e4].cache].join(" ")}}${i2}`;
        return r4.cssRules.length ? `${o2}${i2}` : "";
      }
      return i2;
    })).join("");
  }, n2 = () => {
    if (t2) {
      const { rules: e3, sheet: r4 } = t2;
      if (!r4.deleteRule) {
        for (; 3 === Object(Object(r4.cssRules)[0]).type; ) r4.cssRules.splice(0, 1);
        r4.cssRules = [];
      }
      for (const t3 in e3) delete e3[t3];
    }
    const i2 = Object(e2).styleSheets || [];
    for (const e3 of i2) if (j2(e3)) {
      for (let i3 = 0, o3 = e3.cssRules; o3[i3]; ++i3) {
        const l3 = Object(o3[i3]);
        if (1 !== l3.type) continue;
        const s2 = Object(o3[i3 + 1]);
        if (4 !== s2.type) continue;
        ++i3;
        const { cssText: a5 } = l3;
        if (!a5.startsWith("--sxs")) continue;
        const c2 = a5.slice(14, -3).trim().split(/\s+/), d3 = W[c2[0]];
        d3 && (t2 || (t2 = { sheet: e3, reset: n2, rules: {}, toString: r3 }), t2.rules[d3] = { group: s2, index: i3, cache: new Set(c2) });
      }
      if (t2) break;
    }
    if (!t2) {
      const i3 = (e3, t3) => ({ type: t3, cssRules: [], insertRule(e4, t4) {
        this.cssRules.splice(t4, 0, i3(e4, { import: 3, undefined: 1 }[(e4.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return "@media{}" === e3 ? `@media{${[].map.call(this.cssRules, ((e4) => e4.cssText)).join("")}}` : e3;
      } });
      t2 = { sheet: e2 ? (e2.head || e2).appendChild(document.createElement("style")).sheet : i3("", "text/css"), rules: {}, reset: n2, toString: r3 };
    }
    const { sheet: o2, rules: l2 } = t2;
    for (let e3 = W.length - 1; e3 >= 0; --e3) {
      const t3 = W[e3];
      if (!l2[t3]) {
        const r4 = W[e3 + 1], n3 = l2[r4] ? l2[r4].index : o2.cssRules.length;
        o2.insertRule("@media{}", n3), o2.insertRule(`--sxs{--sxs:${e3}}`, n3), l2[t3] = { group: o2.cssRules[n3 + 1], index: n3, cache: /* @__PURE__ */ new Set([e3]) };
      }
      v2(l2[t3]);
    }
  };
  return n2(), t2;
}, v2 = (e2) => {
  const t2 = e2.group;
  let r3 = t2.cssRules.length;
  e2.apply = (e3) => {
    try {
      t2.insertRule(e3, r3), ++r3;
    } catch (e4) {
    }
  };
}, T = /* @__PURE__ */ Symbol(), w = o(), M = (e2, t2) => w(e2, (() => (...r3) => {
  let n2 = { type: null, composers: /* @__PURE__ */ new Set() };
  for (const t3 of r3) if (null != t3) if (t3[l]) {
    null == n2.type && (n2.type = t3[l].type);
    for (const e3 of t3[l].composers) n2.composers.add(e3);
  } else t3.constructor !== Object || t3.$$typeof ? null == n2.type && (n2.type = t3) : n2.composers.add(C(t3, e2));
  return null == n2.type && (n2.type = "span"), n2.composers.size || n2.composers.add(["PJLV", {}, [], [], {}, []]), P2(e2, n2, t2);
})), C = ({ variants: e2, compoundVariants: t2, defaultVariants: r3, ...n2 }, i2) => {
  const o2 = `${S(i2.prefix)}c-${z(n2)}`, l2 = [], s2 = [], d3 = /* @__PURE__ */ Object.create(null), g2 = [];
  for (const e3 in r3) d3[e3] = String(r3[e3]);
  if ("object" == typeof e2 && e2) for (const t3 in e2) {
    p3 = d3, u2 = t3, c.call(p3, u2) || (d3[t3] = "undefined");
    const r4 = e2[t3];
    for (const e3 in r4) {
      const n3 = { [t3]: String(e3) };
      "undefined" === String(e3) && g2.push(t3);
      const i3 = r4[e3], o3 = [n3, i3, !a(i3)];
      l2.push(o3);
    }
  }
  var p3, u2;
  if ("object" == typeof t2 && t2) for (const e3 of t2) {
    let { css: t3, ...r4 } = e3;
    t3 = "object" == typeof t3 && t3 || {};
    for (const e4 in r4) r4[e4] = String(r4[e4]);
    const n3 = [r4, t3, !a(t3)];
    s2.push(n3);
  }
  return [o2, n2, l2, s2, d3, g2];
}, P2 = (e2, t2, r3) => {
  const [n2, i2, o2, a5] = L(t2.composers), c2 = "function" == typeof t2.type || t2.type.$$typeof ? ((e3) => {
    function t3() {
      for (let r4 = 0; r4 < t3[T].length; r4++) {
        const [n3, i3] = t3[T][r4];
        e3.rules[n3].apply(i3);
      }
      return t3[T] = [], null;
    }
    return t3[T] = [], t3.rules = {}, W.forEach(((e4) => t3.rules[e4] = { apply: (r4) => t3[T].push([e4, r4]) })), t3;
  })(r3) : null, d3 = (c2 || r3).rules, g2 = `.${n2}${i2.length > 1 ? `:where(.${i2.slice(1).join(".")})` : ""}`, p3 = (l2) => {
    l2 = "object" == typeof l2 && l2 || A;
    const { css: s2, ...p4 } = l2, u2 = {};
    for (const e3 in o2) if (delete p4[e3], e3 in l2) {
      let t3 = l2[e3];
      "object" == typeof t3 && t3 ? u2[e3] = { "@initial": o2[e3], ...t3 } : (t3 = String(t3), u2[e3] = "undefined" !== t3 || a5.has(e3) ? t3 : o2[e3]);
    } else u2[e3] = o2[e3];
    const h2 = /* @__PURE__ */ new Set([...i2]);
    for (const [n3, i3, o3, l3] of t2.composers) {
      r3.rules.styled.cache.has(n3) || (r3.rules.styled.cache.add(n3), $(i3, [`.${n3}`], [], e2, ((e3) => {
        d3.styled.apply(e3);
      })));
      const t3 = O2(o3, u2, e2.media), s3 = O2(l3, u2, e2.media, true);
      for (const i4 of t3) if (void 0 !== i4) for (const [t4, o4, l4] of i4) {
        const i5 = `${n3}-${z(o4)}-${t4}`;
        h2.add(i5);
        const s4 = (l4 ? r3.rules.resonevar : r3.rules.onevar).cache, a6 = l4 ? d3.resonevar : d3.onevar;
        s4.has(i5) || (s4.add(i5), $(o4, [`.${i5}`], [], e2, ((e3) => {
          a6.apply(e3);
        })));
      }
      for (const t4 of s3) if (void 0 !== t4) for (const [i4, o4] of t4) {
        const t5 = `${n3}-${z(o4)}-${i4}`;
        h2.add(t5), r3.rules.allvar.cache.has(t5) || (r3.rules.allvar.cache.add(t5), $(o4, [`.${t5}`], [], e2, ((e3) => {
          d3.allvar.apply(e3);
        })));
      }
    }
    if ("object" == typeof s2 && s2) {
      const t3 = `${n2}-i${z(s2)}-css`;
      h2.add(t3), r3.rules.inline.cache.has(t3) || (r3.rules.inline.cache.add(t3), $(s2, [`.${t3}`], [], e2, ((e3) => {
        d3.inline.apply(e3);
      })));
    }
    for (const e3 of String(l2.className || "").trim().split(/\s+/)) e3 && h2.add(e3);
    const f2 = p4.className = [...h2].join(" ");
    return { type: t2.type, className: f2, selector: g2, props: p4, toString: () => f2, deferredInjector: c2 };
  };
  return s(p3, { className: n2, selector: g2, [l]: t2, toString: () => (r3.rules.styled.cache.has(n2) || p3(), n2) });
}, L = (e2) => {
  let t2 = "";
  const r3 = [], n2 = {}, i2 = [];
  for (const [o2, , , , l2, s2] of e2) {
    "" === t2 && (t2 = o2), r3.push(o2), i2.push(...s2);
    for (const e3 in l2) {
      const t3 = l2[e3];
      (void 0 === n2[e3] || "undefined" !== t3 || s2.includes(t3)) && (n2[e3] = t3);
    }
  }
  return [t2, r3, n2, new Set(i2)];
}, O2 = (e2, t2, r3, n2) => {
  const i2 = [];
  e: for (let [o2, l2, s2] of e2) {
    if (s2) continue;
    let e3, a5 = 0, c2 = false;
    for (e3 in o2) {
      const n3 = o2[e3];
      let i3 = t2[e3];
      if (i3 !== n3) {
        if ("object" != typeof i3 || !i3) continue e;
        {
          let e4, t3, o3 = 0;
          for (const l3 in i3) {
            if (n3 === String(i3[l3])) {
              if ("@initial" !== l3) {
                const e5 = l3.slice(1);
                (t3 = t3 || []).push(e5 in r3 ? r3[e5] : l3.replace(/^@media ?/, "")), c2 = true;
              }
              a5 += o3, e4 = true;
            }
            ++o3;
          }
          if (t3 && t3.length && (l2 = { ["@media " + t3.join(", ")]: l2 }), !e4) continue e;
        }
      }
    }
    (i2[a5] = i2[a5] || []).push([n2 ? "cv" : `${e3}-${o2[e3]}`, l2, c2]);
  }
  return i2;
}, A = {}, N = o(), D = (e2, t2) => N(e2, (() => (...r3) => {
  const n2 = () => {
    for (let n3 of r3) {
      n3 = "object" == typeof n3 && n3 || {};
      let r4 = z(n3);
      if (!t2.rules.global.cache.has(r4)) {
        if (t2.rules.global.cache.add(r4), "@import" in n3) {
          let e3 = [].indexOf.call(t2.sheet.cssRules, t2.rules.themed.group) - 1;
          for (let r5 of [].concat(n3["@import"])) r5 = r5.includes('"') || r5.includes("'") ? r5 : `"${r5}"`, t2.sheet.insertRule(`@import ${r5};`, e3++);
          delete n3["@import"];
        }
        $(n3, [], [], e2, ((e3) => {
          t2.rules.global.apply(e3);
        }));
      }
    }
    return "";
  };
  return s(n2, { toString: n2 });
})), H2 = o(), V2 = (e2, t2) => H2(e2, (() => (r3) => {
  const n2 = `${S(e2.prefix)}k-${z(r3)}`, i2 = () => {
    if (!t2.rules.global.cache.has(n2)) {
      t2.rules.global.cache.add(n2);
      const i3 = [];
      $(r3, [], [], e2, ((e3) => i3.push(e3)));
      const o2 = `@keyframes ${n2}{${i3.join("")}}`;
      t2.rules.global.apply(o2);
    }
    return n2;
  };
  return s(i2, { get name() {
    return i2();
  }, toString: i2 });
})), G = class {
  constructor(e2, t2, r3, n2) {
    this.token = null == e2 ? "" : String(e2), this.value = null == t2 ? "" : String(t2), this.scale = null == r3 ? "" : String(r3), this.prefix = null == n2 ? "" : String(n2);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + S(this.prefix) + S(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
}, F = o(), J = (e2, t2) => F(e2, (() => (r3, n2) => {
  n2 = "object" == typeof r3 && r3 || Object(n2);
  const i2 = `.${r3 = (r3 = "string" == typeof r3 ? r3 : "") || `${S(e2.prefix)}t-${z(n2)}`}`, o2 = {}, l2 = [];
  for (const t3 in n2) {
    o2[t3] = {};
    for (const r4 in n2[t3]) {
      const i3 = `--${S(e2.prefix)}${t3}-${r4}`, s3 = k(String(n2[t3][r4]), e2.prefix, t3);
      o2[t3][r4] = new G(r4, s3, t3, e2.prefix), l2.push(`${i3}:${s3}`);
    }
  }
  const s2 = () => {
    if (l2.length && !t2.rules.themed.cache.has(r3)) {
      t2.rules.themed.cache.add(r3);
      const i3 = `${n2 === e2.theme ? ":root," : ""}.${r3}{${l2.join(";")}}`;
      t2.rules.themed.apply(i3);
    }
    return r3;
  };
  return { ...o2, get className() {
    return s2();
  }, selector: i2, toString: s2 };
})), U = o();
var X, Y = o(), q = (e2) => {
  const t2 = ((e3) => {
    let t3 = false;
    const r3 = U(e3, ((e4) => {
      t3 = true;
      const r4 = "prefix" in (e4 = "object" == typeof e4 && e4 || {}) ? String(e4.prefix) : "", i2 = "object" == typeof e4.media && e4.media || {}, o2 = "object" == typeof e4.root ? e4.root || null : globalThis.document || null, l2 = "object" == typeof e4.theme && e4.theme || {}, s2 = { prefix: r4, media: i2, theme: l2, themeMap: "object" == typeof e4.themeMap && e4.themeMap || { ...n }, utils: "object" == typeof e4.utils && e4.utils || {} }, a5 = E(o2), c2 = { css: M(s2, a5), globalCss: D(s2, a5), keyframes: V2(s2, a5), createTheme: J(s2, a5), reset() {
        a5.reset(), c2.theme.toString();
      }, theme: {}, sheet: a5, config: s2, prefix: r4, getCssText: a5.toString, toString: a5.toString };
      return String(c2.theme = c2.createTheme(l2)), c2;
    }));
    return t3 || r3.reset(), r3;
  })(e2);
  return t2.styled = (({ config: e3, sheet: t3 }) => Y(e3, (() => {
    const r3 = M(e3, t3);
    return (...e4) => {
      const t4 = r3(...e4), n2 = t4[l].type, i2 = React.forwardRef(((e5, r4) => {
        const i3 = e5 && e5.as || n2, { props: o2, deferredInjector: l2 } = t4(e5);
        return delete o2.as, o2.ref = r4, l2 ? React.createElement(React.Fragment, null, React.createElement(i3, o2), React.createElement(l2, null)) : React.createElement(i3, o2);
      }));
      return i2.className = t4.className, i2.displayName = `Styled.${n2.displayName || n2.name || n2}`, i2.selector = t4.selector, i2.toString = () => t4.selector, i2[l] = t4[l], i2;
    };
  })))(t2), t2;
}, K = () => X || (X = q()), re = (...e2) => K().styled(...e2);
const PerfS = re("div", {
  position: "fixed",
  top: 0,
  right: 0,
  zIndex: 9999,
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif`,
  backgroundColor: "rgba(36, 36, 36, .9)",
  color: "#fff",
  margin: 0,
  minHeight: "100px",
  padding: "4px 0",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  userSelect: "none",
  "&.top-left": {
    right: "initial",
    left: 0
  },
  "&.bottom-left": {
    right: "initial",
    top: "initial",
    bottom: 0,
    left: 0,
    ".__perf_toggle": {
      top: "-20px",
      bottom: "initial"
    }
  },
  "&.bottom-right": {
    top: "initial",
    bottom: 0,
    ".__perf_toggle": {
      top: "-20px",
      bottom: "initial"
    }
  },
  "&.minimal": {
    backgroundColor: "rgba(36, 36, 36, .75)"
  },
  "*": {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    lineHeight: "1",
    verticalAlign: "baseline"
  }
});
const PerfSmallI = re("small", {
  position: "absolute",
  right: 0,
  fontSize: "10px"
});
const PerfI = re("div", {
  display: "inline-flex",
  fontStyle: "normal",
  padding: 0,
  lineHeight: "13px",
  fontSize: "14px",
  width: "62px",
  position: "relative",
  pointerEvents: "auto",
  cursor: "default",
  fontWeight: 500,
  letterSpacing: "0px",
  textAlign: "left",
  height: "29px",
  whiteSpace: "nowrap",
  justifyContent: "space-evenly",
  fontVariantNumeric: "tabular-nums",
  small: {
    paddingLeft: "12px"
  },
  svg: {
    padding: 0,
    color: "rgba(145, 145, 145, 0.3)",
    fontSize: "40px",
    position: "absolute",
    zIndex: 1,
    maxHeight: "20px",
    left: " 50%",
    marginLeft: "-23px",
    top: "4px"
  }
});
const PerfB = re("span", {
  verticalAlign: "bottom",
  position: "absolute",
  bottom: "5px",
  color: "rgba(101, 197, 188, 1)",
  textAlign: "right",
  letterSpacing: "1px",
  fontSize: "8px",
  fontWeight: "500",
  width: "60px"
});
const PerfIContainer = re("div", {
  display: "flex"
  // justifyContent: 'space-between',
});
const ProgramHeader = re("div", {
  backgroundColor: "#404040",
  padding: "6px",
  display: "block",
  fontSize: "12px",
  marginBottom: "6px",
  cursor: "pointer",
  "*": {
    cursor: "pointer !important"
  },
  "> span": {},
  small: {
    fontSize: "9px"
  },
  "> b": {
    marginRight: "4px",
    cursor: "pointer"
  }
});
const Graph = re("div", {
  height: "66px",
  overflow: "hidden",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  top: "0px",
  justifyContent: "center",
  width: "100%",
  minWidth: "310px",
  margin: "0 auto",
  canvas: {
    background: "transparent !important",
    position: "absolute !important"
  }
});
const Graphpc = re("div", {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "12px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  verticalAlign: "middle",
  color: "#f1f1f1",
  padding: "7px",
  width: "100%",
  backgroundColor: "rgba(36, 36, 37, 0.8)",
  zIndex: 1,
  position: "absolute",
  height: "100%"
});
const Toggle = re("div", {
  pointerEvents: "auto",
  justifyContent: "center",
  cursor: "pointer",
  fontSize: "12px",
  backgroundColor: "rgb(41, 43, 45)",
  marginTop: "6px",
  width: "auto",
  margin: "0",
  color: "rgba(145, 145, 145, 1)",
  textAlign: "center",
  display: "inline-block",
  verticalAlign: "middle",
  padding: "4px 6px",
  "&.__perf_toggle_tab_active": {
    backgroundColor: "rgb(31 31 31)"
  },
  svg: {
    width: "12px",
    height: "12px",
    float: "left"
  }
});
const ToggleVisible = re("div", {
  pointerEvents: "auto",
  justifyContent: "center",
  cursor: "pointer",
  fontSize: "12px",
  float: "right",
  backgroundColor: "rgb(41, 43, 45)",
  width: "auto",
  margin: "0",
  color: "rgba(145, 145, 145, 1)",
  textAlign: "center",
  display: "inline-block",
  verticalAlign: "middle",
  padding: "4px 6px",
  "&.__perf_toggle_tab_active": {
    backgroundColor: "rgb(31 31 31)"
  },
  svg: {
    width: "12px",
    height: "12px",
    float: "left"
  }
});
const ProgramGeo = re("div", {
  padding: "4px 6px",
  fontSize: "12px",
  pointerEvents: "auto"
});
const ProgramTitle = re("span", {
  fontWeight: "bold",
  letterSpacing: "0.08em",
  maxWidth: "145px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "inline-block",
  verticalAlign: "middle",
  fontSize: "11px",
  marginRight: "10px"
});
const ContainerScroll = re("div", {
  maxHeight: "50vh",
  overflowY: "auto",
  marginTop: "38px"
});
const ProgramsContainer = re("div", {
  marginTop: "0"
});
const ProgramsULHeader = re("div", {
  display: "flex",
  position: "relative",
  fontWeight: "bold",
  color: "#fff",
  lineHeight: "14px",
  svg: {
    marginRight: "4px",
    display: "inline-block"
  }
});
const ProgramsUL = re("ul", {
  display: "block",
  position: "relative",
  paddingLeft: "10px",
  margin: "6px 6px",
  img: {
    maxHeight: "60px",
    maxWidth: "100%",
    margin: "6px auto",
    display: "block"
  },
  "&:after": {
    content: "",
    position: "absolute",
    left: "0px",
    top: "0px",
    width: "1px",
    height: "100%",
    backgroundColor: "grey",
    transform: "translateX(-50%)",
    maxHeight: "50vh",
    overflowY: "auto"
  },
  li: {
    borderBottom: "1px solid #313131",
    display: "block",
    padding: "4px",
    margin: 0,
    lineHeight: 1,
    verticalAlign: "middle",
    height: "24px"
  },
  b: {
    fontWeight: "bold"
  },
  small: {
    textAlign: "revert",
    letterSpacing: "1px",
    fontSize: "10px",
    fontWeight: "500",
    marginLeft: "2px",
    color: "rgb(101, 197, 188)"
  }
});
const ProgramConsole = re("button", {
  fontWeight: "bold",
  letterSpacing: "0.02em",
  backgroundColor: "rgb(41, 43, 45)",
  color: "rgb(211, 211, 211)",
  overflow: "hidden",
  textOverflow: "ellipsis",
  cursor: "pointer",
  display: "block",
  verticalAlign: "middle",
  fontSize: "11px",
  padding: "5px",
  margin: "4px auto"
});
const ToggleContainer = re("div", {
  display: "flex",
  justifyContent: "center",
  cursor: "pointer",
  fontSize: "12px",
  backgroundColor: "rgb(41, 43, 45)",
  marginTop: "6px",
  width: "auto",
  margin: "0 auto",
  color: "rgba(145, 145, 145, 1)",
  textAlign: "center",
  position: "absolute",
  right: 0,
  bottom: " -20px",
  svg: {
    width: "12px",
    height: "12px",
    float: "left"
  }
});
const ProgramsGeoLi = re("li", {
  display: "flex !important",
  height: "auto !important",
  span: {
    height: "40px",
    display: "block",
    position: "relative"
  },
  b: {
    paddingLeft: "12px"
  }
});
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var _excluded$1 = ["color"];
var ActivityLogIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M0 1.5C0 1.22386 0.223858 1 0.5 1H2.5C2.77614 1 3 1.22386 3 1.5C3 1.77614 2.77614 2 2.5 2H0.5C0.223858 2 0 1.77614 0 1.5ZM4 1.5C4 1.22386 4.22386 1 4.5 1H14.5C14.7761 1 15 1.22386 15 1.5C15 1.77614 14.7761 2 14.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.77614 11.7761 5 11.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM0 7.5C0 7.22386 0.223858 7 0.5 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H0.5C0.223858 8 0 7.77614 0 7.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H4.5C4.22386 11 4 10.7761 4 10.5ZM0 13.5C0 13.2239 0.223858 13 0.5 13H2.5C2.77614 13 3 13.2239 3 13.5C3 13.7761 2.77614 14 2.5 14H0.5C0.223858 14 0 13.7761 0 13.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H14.5C14.7761 13 15 13.2239 15 13.5C15 13.7761 14.7761 14 14.5 14H4.5C4.22386 14 4 13.7761 4 13.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$o = ["color"];
var BarChartIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M11.5 1C11.7761 1 12 1.22386 12 1.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V1.5C11 1.22386 11.2239 1 11.5 1ZM9.5 3C9.77614 3 10 3.22386 10 3.5V13.5C10 13.7761 9.77614 14 9.5 14C9.22386 14 9 13.7761 9 13.5V3.5C9 3.22386 9.22386 3 9.5 3ZM13.5 3C13.7761 3 14 3.22386 14 3.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2239 14 13 13.7761 13 13.5V3.5C13 3.22386 13.2239 3 13.5 3ZM5.5 4C5.77614 4 6 4.22386 6 4.5V13.5C6 13.7761 5.77614 14 5.5 14C5.22386 14 5 13.7761 5 13.5V4.5C5 4.22386 5.22386 4 5.5 4ZM1.5 5C1.77614 5 2 5.22386 2 5.5V13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5V5.5C1 5.22386 1.22386 5 1.5 5ZM7.5 5C7.77614 5 8 5.22386 8 5.5V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.5C7 5.22386 7.22386 5 7.5 5ZM3.5 7C3.77614 7 4 7.22386 4 7.5V13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V7.5C3 7.22386 3.22386 7 3.5 7Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$H = ["color"];
var ButtonIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$H);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M2 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V6C1 5.44772 1.44772 5 2 5ZM0 6C0 4.89543 0.895431 4 2 4H13C14.1046 4 15 4.89543 15 6V9C15 10.1046 14.1046 11 13 11H2C0.89543 11 0 10.1046 0 9V6ZM4.5 6.75C4.08579 6.75 3.75 7.08579 3.75 7.5C3.75 7.91421 4.08579 8.25 4.5 8.25C4.91421 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 4.91421 6.75 4.5 6.75ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 7.91421 8.25 7.5 8.25C7.08579 8.25 6.75 7.91421 6.75 7.5ZM10.5 6.75C10.0858 6.75 9.75 7.08579 9.75 7.5C9.75 7.91421 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 10.9142 6.75 10.5 6.75Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$1w = ["color"];
var CubeIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$1w);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$1H = ["color"];
var DotIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$1H);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M7.5 9.125C8.39746 9.125 9.125 8.39746 9.125 7.5C9.125 6.60254 8.39746 5.875 7.5 5.875C6.60254 5.875 5.875 6.60254 5.875 7.5C5.875 8.39746 6.60254 9.125 7.5 9.125ZM7.5 10.125C8.94975 10.125 10.125 8.94975 10.125 7.5C10.125 6.05025 8.94975 4.875 7.5 4.875C6.05025 4.875 4.875 6.05025 4.875 7.5C4.875 8.94975 6.05025 10.125 7.5 10.125Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$1W = ["color"];
var DropdownMenuIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$1W);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M7.49999 3.09998C7.27907 3.09998 7.09999 3.27906 7.09999 3.49998C7.09999 3.72089 7.27907 3.89998 7.49999 3.89998H14.5C14.7209 3.89998 14.9 3.72089 14.9 3.49998C14.9 3.27906 14.7209 3.09998 14.5 3.09998H7.49999ZM7.49998 5.1C7.27907 5.1 7.09998 5.27908 7.09998 5.5C7.09998 5.72091 7.27907 5.9 7.49998 5.9H14.5C14.7209 5.9 14.9 5.72091 14.9 5.5C14.9 5.27908 14.7209 5.1 14.5 5.1H7.49998ZM7.1 7.5C7.1 7.27908 7.27909 7.1 7.5 7.1H14.5C14.7209 7.1 14.9 7.27908 14.9 7.5C14.9 7.72091 14.7209 7.9 14.5 7.9H7.5C7.27909 7.9 7.1 7.72091 7.1 7.5ZM7.49998 9.1C7.27907 9.1 7.09998 9.27908 7.09998 9.5C7.09998 9.72091 7.27907 9.9 7.49998 9.9H14.5C14.7209 9.9 14.9 9.72091 14.9 9.5C14.9 9.27908 14.7209 9.1 14.5 9.1H7.49998ZM7.09998 11.5C7.09998 11.2791 7.27907 11.1 7.49998 11.1H14.5C14.7209 11.1 14.9 11.2791 14.9 11.5C14.9 11.7209 14.7209 11.9 14.5 11.9H7.49998C7.27907 11.9 7.09998 11.7209 7.09998 11.5ZM2.5 9.25003L5 6.00003H0L2.5 9.25003Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$25 = ["color"];
var EyeNoneIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$25);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$26 = ["color"];
var EyeOpenIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$26);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$2C = ["color"];
var ImageIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$2C);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$2H = ["color"];
var LapTimerIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$2H);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$2J = ["color"];
var LayersIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$2J);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M7.75432 0.819537C7.59742 0.726821 7.4025 0.726821 7.24559 0.819537L1.74559 4.06954C1.59336 4.15949 1.49996 4.32317 1.49996 4.5C1.49996 4.67683 1.59336 4.84051 1.74559 4.93046L7.24559 8.18046C7.4025 8.27318 7.59742 8.27318 7.75432 8.18046L13.2543 4.93046C13.4066 4.84051 13.5 4.67683 13.5 4.5C13.5 4.32317 13.4066 4.15949 13.2543 4.06954L7.75432 0.819537ZM7.49996 7.16923L2.9828 4.5L7.49996 1.83077L12.0171 4.5L7.49996 7.16923ZM1.5695 7.49564C1.70998 7.2579 2.01659 7.17906 2.25432 7.31954L7.49996 10.4192L12.7456 7.31954C12.9833 7.17906 13.2899 7.2579 13.4304 7.49564C13.5709 7.73337 13.4921 8.03998 13.2543 8.18046L7.75432 11.4305C7.59742 11.5232 7.4025 11.5232 7.24559 11.4305L1.74559 8.18046C1.50786 8.03998 1.42901 7.73337 1.5695 7.49564ZM1.56949 10.4956C1.70998 10.2579 2.01658 10.1791 2.25432 10.3195L7.49996 13.4192L12.7456 10.3195C12.9833 10.1791 13.2899 10.2579 13.4304 10.4956C13.5709 10.7334 13.4921 11.04 13.2543 11.1805L7.75432 14.4305C7.59742 14.5232 7.4025 14.5232 7.24559 14.4305L1.74559 11.1805C1.50785 11.04 1.42901 10.7334 1.56949 10.4956Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$2Q = ["color"];
var LightningBoltIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$2Q);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M8.69667 0.0403541C8.90859 0.131038 9.03106 0.354857 8.99316 0.582235L8.0902 6.00001H12.5C12.6893 6.00001 12.8625 6.10701 12.9472 6.27641C13.0319 6.4458 13.0136 6.6485 12.8999 6.80001L6.89997 14.8C6.76167 14.9844 6.51521 15.0503 6.30328 14.9597C6.09135 14.869 5.96888 14.6452 6.00678 14.4178L6.90974 9H2.49999C2.31061 9 2.13748 8.893 2.05278 8.72361C1.96809 8.55422 1.98636 8.35151 2.09999 8.2L8.09997 0.200038C8.23828 0.0156255 8.48474 -0.0503301 8.69667 0.0403541ZM3.49999 8.00001H7.49997C7.64695 8.00001 7.78648 8.06467 7.88148 8.17682C7.97648 8.28896 8.01733 8.43723 7.99317 8.5822L7.33027 12.5596L11.5 7.00001H7.49997C7.353 7.00001 7.21347 6.93534 7.11846 6.8232C7.02346 6.71105 6.98261 6.56279 7.00678 6.41781L7.66968 2.44042L3.49999 8.00001Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$34 = ["color"];
var MarginIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$34);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M1.49988 2.00012C1.77602 2.00012 1.99988 1.77626 1.99988 1.50012C1.99988 1.22398 1.77602 1.00012 1.49988 1.00012C1.22374 1.00012 0.999878 1.22398 0.999878 1.50012C0.999878 1.77626 1.22374 2.00012 1.49988 2.00012ZM4.49988 2.00012C4.77602 2.00012 4.99988 1.77626 4.99988 1.50012C4.99988 1.22398 4.77602 1.00012 4.49988 1.00012C4.22374 1.00012 3.99988 1.22398 3.99988 1.50012C3.99988 1.77626 4.22374 2.00012 4.49988 2.00012ZM7.99988 1.50012C7.99988 1.77626 7.77602 2.00012 7.49988 2.00012C7.22374 2.00012 6.99988 1.77626 6.99988 1.50012C6.99988 1.22398 7.22374 1.00012 7.49988 1.00012C7.77602 1.00012 7.99988 1.22398 7.99988 1.50012ZM10.4999 2.00012C10.776 2.00012 10.9999 1.77626 10.9999 1.50012C10.9999 1.22398 10.776 1.00012 10.4999 1.00012C10.2237 1.00012 9.99988 1.22398 9.99988 1.50012C9.99988 1.77626 10.2237 2.00012 10.4999 2.00012ZM13.9999 1.50012C13.9999 1.77626 13.776 2.00012 13.4999 2.00012C13.2237 2.00012 12.9999 1.77626 12.9999 1.50012C12.9999 1.22398 13.2237 1.00012 13.4999 1.00012C13.776 1.00012 13.9999 1.22398 13.9999 1.50012ZM1.49988 14.0001C1.77602 14.0001 1.99988 13.7763 1.99988 13.5001C1.99988 13.224 1.77602 13.0001 1.49988 13.0001C1.22374 13.0001 0.999878 13.224 0.999878 13.5001C0.999878 13.7763 1.22374 14.0001 1.49988 14.0001ZM1.99988 10.5001C1.99988 10.7763 1.77602 11.0001 1.49988 11.0001C1.22374 11.0001 0.999878 10.7763 0.999878 10.5001C0.999878 10.224 1.22374 10.0001 1.49988 10.0001C1.77602 10.0001 1.99988 10.224 1.99988 10.5001ZM1.49988 8.00012C1.77602 8.00012 1.99988 7.77626 1.99988 7.50012C1.99988 7.22398 1.77602 7.00012 1.49988 7.00012C1.22374 7.00012 0.999878 7.22398 0.999878 7.50012C0.999878 7.77626 1.22374 8.00012 1.49988 8.00012ZM1.99988 4.50012C1.99988 4.77626 1.77602 5.00012 1.49988 5.00012C1.22374 5.00012 0.999878 4.77626 0.999878 4.50012C0.999878 4.22398 1.22374 4.00012 1.49988 4.00012C1.77602 4.00012 1.99988 4.22398 1.99988 4.50012ZM13.4999 11.0001C13.776 11.0001 13.9999 10.7763 13.9999 10.5001C13.9999 10.224 13.776 10.0001 13.4999 10.0001C13.2237 10.0001 12.9999 10.224 12.9999 10.5001C12.9999 10.7763 13.2237 11.0001 13.4999 11.0001ZM13.9999 7.50012C13.9999 7.77626 13.776 8.00012 13.4999 8.00012C13.2237 8.00012 12.9999 7.77626 12.9999 7.50012C12.9999 7.22398 13.2237 7.00012 13.4999 7.00012C13.776 7.00012 13.9999 7.22398 13.9999 7.50012ZM13.4999 5.00012C13.776 5.00012 13.9999 4.77626 13.9999 4.50012C13.9999 4.22398 13.776 4.00012 13.4999 4.00012C13.2237 4.00012 12.9999 4.22398 12.9999 4.50012C12.9999 4.77626 13.2237 5.00012 13.4999 5.00012ZM4.99988 13.5001C4.99988 13.7763 4.77602 14.0001 4.49988 14.0001C4.22374 14.0001 3.99988 13.7763 3.99988 13.5001C3.99988 13.224 4.22374 13.0001 4.49988 13.0001C4.77602 13.0001 4.99988 13.224 4.99988 13.5001ZM7.49988 14.0001C7.77602 14.0001 7.99988 13.7763 7.99988 13.5001C7.99988 13.224 7.77602 13.0001 7.49988 13.0001C7.22374 13.0001 6.99988 13.224 6.99988 13.5001C6.99988 13.7763 7.22374 14.0001 7.49988 14.0001ZM10.9999 13.5001C10.9999 13.7763 10.776 14.0001 10.4999 14.0001C10.2237 14.0001 9.99988 13.7763 9.99988 13.5001C9.99988 13.224 10.2237 13.0001 10.4999 13.0001C10.776 13.0001 10.9999 13.224 10.9999 13.5001ZM13.4999 14.0001C13.776 14.0001 13.9999 13.7763 13.9999 13.5001C13.9999 13.224 13.776 13.0001 13.4999 13.0001C13.2237 13.0001 12.9999 13.224 12.9999 13.5001C12.9999 13.7763 13.2237 14.0001 13.4999 14.0001ZM3.99988 5.00012C3.99988 4.44784 4.44759 4.00012 4.99988 4.00012H9.99988C10.5522 4.00012 10.9999 4.44784 10.9999 5.00012V10.0001C10.9999 10.5524 10.5522 11.0001 9.99988 11.0001H4.99988C4.44759 11.0001 3.99988 10.5524 3.99988 10.0001V5.00012ZM4.99988 5.00012H9.99988V10.0001H4.99988V5.00012Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$37 = ["color"];
var MinusIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$37);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$3m = ["color"];
var PauseIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$3m);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M6.04995 2.74998C6.04995 2.44623 5.80371 2.19998 5.49995 2.19998C5.19619 2.19998 4.94995 2.44623 4.94995 2.74998V12.25C4.94995 12.5537 5.19619 12.8 5.49995 12.8C5.80371 12.8 6.04995 12.5537 6.04995 12.25V2.74998ZM10.05 2.74998C10.05 2.44623 9.80371 2.19998 9.49995 2.19998C9.19619 2.19998 8.94995 2.44623 8.94995 2.74998V12.25C8.94995 12.5537 9.19619 12.8 9.49995 12.8C9.80371 12.8 10.05 12.5537 10.05 12.25V2.74998Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$3H = ["color"];
var RocketIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$3H);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M6.85357 3.85355L7.65355 3.05353C8.2981 2.40901 9.42858 1.96172 10.552 1.80125C11.1056 1.72217 11.6291 1.71725 12.0564 1.78124C12.4987 1.84748 12.7698 1.97696 12.8965 2.10357C13.0231 2.23018 13.1526 2.50125 13.2188 2.94357C13.2828 3.37086 13.2779 3.89439 13.1988 4.44801C13.0383 5.57139 12.591 6.70188 11.9464 7.34645L7.49999 11.7929L6.35354 10.6465C6.15827 10.4512 5.84169 10.4512 5.64643 10.6465C5.45117 10.8417 5.45117 11.1583 5.64643 11.3536L7.14644 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L8.40073 12.3064L9.57124 14.2572C9.65046 14.3893 9.78608 14.4774 9.9389 14.4963C10.0917 14.5151 10.2447 14.4624 10.3535 14.3536L12.3535 12.3536C12.4648 12.2423 12.5172 12.0851 12.495 11.9293L12.0303 8.67679L12.6536 8.05355C13.509 7.19808 14.0117 5.82855 14.1887 4.58943C14.2784 3.9618 14.2891 3.33847 14.2078 2.79546C14.1287 2.26748 13.9519 1.74482 13.6035 1.39645C13.2552 1.04809 12.7325 0.871332 12.2045 0.792264C11.6615 0.710945 11.0382 0.721644 10.4105 0.8113C9.17143 0.988306 7.80189 1.491 6.94644 2.34642L6.32322 2.96968L3.07071 2.50504C2.91492 2.48278 2.75773 2.53517 2.64645 2.64646L0.646451 4.64645C0.537579 4.75533 0.484938 4.90829 0.50375 5.0611C0.522563 5.21391 0.61073 5.34954 0.742757 5.42876L2.69364 6.59928L2.14646 7.14645C2.0527 7.24022 2.00002 7.3674 2.00002 7.50001C2.00002 7.63261 2.0527 7.75979 2.14646 7.85356L3.64647 9.35356C3.84173 9.54883 4.15831 9.54883 4.35357 9.35356C4.54884 9.1583 4.54884 8.84172 4.35357 8.64646L3.20712 7.50001L3.85357 6.85356L6.85357 3.85355ZM10.0993 13.1936L9.12959 11.5775L11.1464 9.56067L11.4697 11.8232L10.0993 13.1936ZM3.42251 5.87041L5.43935 3.85356L3.17678 3.53034L1.80638 4.90074L3.42251 5.87041ZM2.35356 10.3535C2.54882 10.1583 2.54882 9.8417 2.35356 9.64644C2.1583 9.45118 1.84171 9.45118 1.64645 9.64644L0.646451 10.6464C0.451188 10.8417 0.451188 11.1583 0.646451 11.3535C0.841713 11.5488 1.1583 11.5488 1.35356 11.3535L2.35356 10.3535ZM3.85358 11.8536C4.04884 11.6583 4.04885 11.3417 3.85359 11.1465C3.65833 10.9512 3.34175 10.9512 3.14648 11.1465L1.14645 13.1464C0.95119 13.3417 0.951187 13.6583 1.14645 13.8535C1.34171 14.0488 1.65829 14.0488 1.85355 13.8536L3.85358 11.8536ZM5.35356 13.3535C5.54882 13.1583 5.54882 12.8417 5.35356 12.6464C5.1583 12.4512 4.84171 12.4512 4.64645 12.6464L3.64645 13.6464C3.45119 13.8417 3.45119 14.1583 3.64645 14.3535C3.84171 14.5488 4.1583 14.5488 4.35356 14.3535L5.35356 13.3535ZM9.49997 6.74881C10.1897 6.74881 10.7488 6.1897 10.7488 5.5C10.7488 4.8103 10.1897 4.25118 9.49997 4.25118C8.81026 4.25118 8.25115 4.8103 8.25115 5.5C8.25115 6.1897 8.81026 6.74881 9.49997 6.74881Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$3L = ["color"];
var RulerHorizontalIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$3L);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M0.5 4C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H14.5C14.7761 11 15 10.7761 15 10.5V4.5C15 4.22386 14.7761 4 14.5 4H0.5ZM1 10V5H2.075V7.5C2.075 7.73472 2.26528 7.925 2.5 7.925C2.73472 7.925 2.925 7.73472 2.925 7.5V5H4.075V6.5C4.075 6.73472 4.26528 6.925 4.5 6.925C4.73472 6.925 4.925 6.73472 4.925 6.5V5H6.075V6.5C6.075 6.73472 6.26528 6.925 6.5 6.925C6.73472 6.925 6.925 6.73472 6.925 6.5V5H8.075V7.5C8.075 7.73472 8.26528 7.925 8.5 7.925C8.73472 7.925 8.925 7.73472 8.925 7.5V5H10.075V6.5C10.075 6.73472 10.2653 6.925 10.5 6.925C10.7347 6.925 10.925 6.73472 10.925 6.5V5H12.075V6.5C12.075 6.73472 12.2653 6.925 12.5 6.925C12.7347 6.925 12.925 6.73472 12.925 6.5V5H14V10H1Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$4q = ["color"];
var TextAlignJustifyIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$4q);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H12.5C12.7761 5 13 4.77614 13 4.5C13 4.22386 12.7761 4 12.5 4H2.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
var _excluded$4H = ["color"];
var TriangleDownIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$4H);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M4 6H11L7.5 10.5L4 6Z",
    fill: color
  }));
});
var _excluded$4K = ["color"];
var TriangleUpIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$4K);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M4 9H11L7.5 4.5L4 9Z",
    fill: color
  }));
});
var _excluded$4R = ["color"];
var VercelLogoIcon = /* @__PURE__ */ reactExports.forwardRef(function(_ref, forwardedRef) {
  var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = _objectWithoutPropertiesLoose(_ref, _excluded$4R);
  return reactExports.createElement("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: forwardedRef
  }), reactExports.createElement("path", {
    d: "M7.49998 1L6.92321 2.00307L1.17498 12L0.599976 13H1.7535H13.2464H14.4L13.825 12L8.07674 2.00307L7.49998 1ZM7.49998 3.00613L2.3285 12H12.6714L7.49998 3.00613Z",
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
const localFont = "data:font/woff;base64,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";
const TextHighHZ = reactExports.memo(
  ({
    isPerf,
    color,
    colorBlind,
    customData,
    isMemory,
    isShadersInfo,
    metric,
    fontSize,
    offsetY = 0,
    offsetX,
    round,
    hasInstance
  }) => {
    const { width: w2, height: h2 } = useThree((s2) => s2.viewport);
    const fpsRef = reactExports.useRef(null);
    const fpsInstanceRef = reactExports.useRef(null);
    useEvent("log", function updateR3FPerfText([log, gl]) {
      var _a2;
      if (!log || !fpsRef.current) return;
      if (customData) {
        fpsRef.current.text = (Math.round(getPerf().customData * Math.pow(10, round)) / Math.pow(10, round)).toFixed(
          round
        );
      }
      if (!metric) return;
      let info = log[metric];
      if (isShadersInfo) {
        info = (_a2 = gl.info.programs) == null ? void 0 : _a2.length;
      } else if (metric === "matriceCount") {
        info = matriceCount.value;
      } else if (!isPerf && gl.info.render) {
        const infos = isMemory ? gl.info.memory : gl.info.render;
        info = infos[metric];
      }
      if (metric === "fps") {
        fpsRef.current.color = getPerf().overclockingFps ? colorsGraph(colorBlind).overClock.toString() : `rgb(${colorsGraph(colorBlind).fps.toString()})`;
      }
      fpsRef.current.text = (Math.round(info * Math.pow(10, round)) / Math.pow(10, round)).toFixed(round);
      if (hasInstance) {
        const infosInstance = gl.info.instance;
        if (typeof infosInstance === "undefined" && metric !== "matriceCount") {
          return;
        }
        let infoInstance;
        if (metric === "matriceCount") {
          infoInstance = matriceWorldCount.value;
        } else {
          infoInstance = infosInstance[metric];
        }
        if (infoInstance > 0) {
          fpsRef.current.fontSize = fontSize / 1.15;
          fpsInstanceRef.current.fontSize = info > 0 ? fontSize / 1.4 : fontSize;
          fpsRef.current.position.y = h2 / 2 - offsetY - fontSize / 1.9;
          fpsInstanceRef.current.text = " ±	" + (Math.round(infoInstance * Math.pow(10, round)) / Math.pow(10, round)).toFixed(round);
        } else {
          if (fpsInstanceRef.current.text) fpsInstanceRef.current.text = "";
          fpsRef.current.position.y = h2 / 2 - offsetY - fontSize;
          fpsRef.current.fontSize = fontSize;
        }
      }
      matriceCount.value -= 1;
      fpsRef.current.updateMatrix();
      fpsRef.current.matrixWorld.copy(fpsRef.current.matrix);
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(reactExports.Suspense, { fallback: null, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Text2,
        {
          textAlign: "justify",
          matrixAutoUpdate: false,
          ref: fpsRef,
          font: localFont,
          fontSize,
          position: [-w2 / 2 + offsetX + fontSize, h2 / 2 - offsetY - fontSize, 0],
          color,
          characters: "0123456789",
          onUpdate: (self2) => {
            self2.updateMatrix();
            matriceCount.value -= 1;
            self2.matrixWorld.copy(self2.matrix);
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("meshBasicMaterial", { blending: NormalBlending }),
            "0"
          ]
        }
      ),
      hasInstance && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Text2,
        {
          textAlign: "justify",
          matrixAutoUpdate: false,
          ref: fpsInstanceRef,
          font: localFont,
          fontSize: 8,
          position: [-w2 / 2 + offsetX + fontSize, h2 / 2 - offsetY - fontSize * 1.15, 0],
          color: "lightgrey",
          characters: "0123456789",
          onUpdate: (self2) => {
            self2.updateMatrix();
            matriceCount.value -= 1;
            self2.matrixWorld.copy(self2.matrix);
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("meshBasicMaterial", { blending: NormalBlending })
        }
      )
    ] });
  }
);
const TextsHighHZ = ({ colorBlind, customData, minimal, matrixUpdate }) => {
  const fontSize = 14;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextHighHZ,
      {
        colorBlind,
        color: `rgb(${colorsGraph(colorBlind).fps.toString()})`,
        isPerf: true,
        metric: "fps",
        fontSize,
        offsetX: 140,
        round: 0
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextHighHZ,
      {
        color: `rgb(${colorsGraph(colorBlind).cpu.toString()})`,
        isPerf: true,
        metric: "cpu",
        fontSize,
        offsetX: 72,
        round: 3
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextHighHZ,
      {
        color: `rgb(${colorsGraph(colorBlind).gpu.toString()})`,
        isPerf: true,
        metric: "gpu",
        fontSize,
        offsetX: 10,
        round: 3
      }
    ),
    !minimal ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextHighHZ, { metric: "calls", fontSize, offsetX: 200, round: 0, hasInstance: true }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextHighHZ, { metric: "triangles", fontSize, offsetX: 260, round: 0, hasInstance: true }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextHighHZ, { isMemory: true, metric: "geometries", fontSize, offsetY: 30, offsetX: 0, round: 0 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextHighHZ, { isMemory: true, metric: "textures", fontSize, offsetY: 30, offsetX: 80, round: 0 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextHighHZ, { isShadersInfo: true, metric: "programs", fontSize, offsetY: 30, offsetX: 140, round: 0 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextHighHZ, { metric: "lines", fontSize, offsetY: 30, offsetX: 200, round: 0, hasInstance: true }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextHighHZ, { metric: "points", fontSize, offsetY: 30, offsetX: 260, round: 0, hasInstance: true }),
      matrixUpdate && /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextHighHZ,
        {
          isPerf: true,
          metric: "matriceCount",
          fontSize,
          offsetY: 30,
          offsetX: 320,
          round: 0,
          hasInstance: true
        }
      )
    ] }) : null,
    customData && /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextHighHZ,
      {
        color: `rgb(${colorsGraph(colorBlind).custom.toString()})`,
        customData,
        fontSize,
        offsetY: 0,
        offsetX: minimal ? 200 : 320,
        round: customData.round || 2
      }
    )
  ] });
};
const ChartCurve = ({ colorBlind, minimal, chart = { length: 120, hz: 60 } }) => {
  const curves = reactExports.useMemo(() => {
    return {
      fps: new Float32Array(chart.length * 3),
      cpu: new Float32Array(chart.length * 3),
      // mem: new Float32Array(chart.length * 3),
      gpu: new Float32Array(chart.length * 3)
    };
  }, [chart]);
  const fpsRef = reactExports.useRef(null);
  const fpsMatRef = reactExports.useRef(null);
  const gpuRef = reactExports.useRef(null);
  const cpuRef = reactExports.useRef(null);
  const dummyVec3 = reactExports.useMemo(() => new Vector3(0, 0, 0), []);
  const updatePoints = (element, factor = 1, ref, viewport) => {
    let maxVal = 0;
    const { width: w2, height: h2 } = viewport;
    const chart2 = getPerf().chart.data[element];
    if (!chart2 || chart2.length === 0) {
      return;
    }
    const padding = minimal ? 2 : 6;
    const paddingTop = minimal ? 12 : 50;
    let len = chart2.length;
    for (let i2 = 0; i2 < len; i2++) {
      let id = (getPerf().chart.circularId + i2 + 1) % len;
      if (chart2[id] !== void 0) {
        if (chart2[id] > maxVal) {
          maxVal = chart2[id] * factor;
        }
        dummyVec3.set(padding + i2 / (len - 1) * (w2 - padding * 2) - w2 / 2, Math.min(100, chart2[id]) * factor / 100 * (h2 - padding * 2 - paddingTop) - h2 / 2, 0);
        dummyVec3.toArray(ref.attributes.position.array, i2 * 3);
      }
    }
    ref.attributes.position.needsUpdate = true;
  };
  useFrame(function updateChartCurve({ viewport }) {
    updatePoints("fps", 1, fpsRef.current, viewport);
    if (fpsMatRef.current) {
      fpsMatRef.current.color.set(getPerf().overclockingFps ? colorsGraph(colorBlind).overClock.toString() : `rgb(${colorsGraph(colorBlind).fps.toString()})`);
    }
    updatePoints("gpu", 5, gpuRef.current, viewport);
    updatePoints("cpu", 5, cpuRef.current, viewport);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("line", { onUpdate: (self2) => {
      self2.updateMatrix();
      matriceCount.value -= 1;
      self2.matrixWorld.copy(self2.matrix);
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("bufferGeometry", { ref: fpsRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "bufferAttribute",
        {
          attach: "attributes-position",
          count: chart.length,
          array: curves.fps,
          itemSize: 3,
          usage: DynamicDrawUsage,
          needsUpdate: true
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("lineBasicMaterial", { ref: fpsMatRef, color: `rgb(${colorsGraph(colorBlind).fps.toString()})`, transparent: true, opacity: 0.5 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("line", { onUpdate: (self2) => {
      self2.updateMatrix();
      matriceCount.value -= 1;
      self2.matrixWorld.copy(self2.matrix);
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("bufferGeometry", { ref: gpuRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "bufferAttribute",
        {
          attach: "attributes-position",
          count: chart.length,
          array: curves.gpu,
          itemSize: 3,
          usage: DynamicDrawUsage,
          needsUpdate: true
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("lineBasicMaterial", { color: `rgb(${colorsGraph(colorBlind).gpu.toString()})`, transparent: true, opacity: 0.5 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("line", { onUpdate: (self2) => {
      self2.updateMatrix();
      matriceCount.value -= 1;
      self2.matrixWorld.copy(self2.matrix);
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("bufferGeometry", { ref: cpuRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "bufferAttribute",
        {
          attach: "attributes-position",
          count: chart.length,
          array: curves.cpu,
          itemSize: 3,
          usage: DynamicDrawUsage,
          needsUpdate: true
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("lineBasicMaterial", { color: `rgb(${colorsGraph(colorBlind).cpu.toString()})`, transparent: true, opacity: 0.5 })
    ] })
  ] });
};
const ChartUI = ({
  colorBlind,
  chart,
  customData,
  matrixUpdate,
  showGraph = true,
  antialias = true,
  minimal
}) => {
  const canvas = reactExports.useRef(void 0);
  const paused = usePerf((state) => state.paused);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Graph,
    {
      style: {
        display: "flex",
        position: "absolute",
        height: `${minimal ? 37 : showGraph ? 100 : 60}px`,
        minWidth: `${minimal ? "100px" : customData ? "370px" : "310px"}`
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Canvas2,
          {
            ref: canvas,
            orthographic: true,
            camera: { rotation: [0, 0, 0] },
            dpr: antialias ? [1, 2] : 1,
            gl: {
              antialias: true,
              alpha: true,
              stencil: false,
              depth: false
            },
            onCreated: ({ scene }) => {
              scene.traverse((obj) => {
                obj.matrixWorldAutoUpdate = false;
                obj.matrixAutoUpdate = false;
              });
            },
            flat: true,
            style: {
              marginBottom: `-42px`,
              position: "relative",
              pointerEvents: "none",
              background: "transparent !important",
              height: `${minimal ? 37 : showGraph ? 100 : 60}px`
            },
            children: !paused ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Renderer, {}),
              /* @__PURE__ */ jsxRuntimeExports.jsx(TextsHighHZ, { customData, minimal, matrixUpdate }),
              showGraph && /* @__PURE__ */ jsxRuntimeExports.jsx(
                ChartCurve,
                {
                  colorBlind,
                  minimal,
                  chart
                }
              )
            ] }) : null
          }
        ),
        paused && /* @__PURE__ */ jsxRuntimeExports.jsxs(Graphpc, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(PauseIcon, {}),
          " PAUSED"
        ] })
      ]
    }
  );
};
const Renderer = () => {
  useFrame(function updateR3FPerf({ gl, scene, camera }) {
    camera.updateMatrix();
    matriceCount.value -= 1;
    camera.matrixWorld.copy(camera.matrix);
    camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    gl.render(scene, camera);
    matriceWorldCount.value = 0;
    matriceCount.value = 0;
  }, Infinity);
  return null;
};
const HtmlMinimal = reactExports.forwardRef(({ portal, className, children, name, ...props }, ref) => {
  const gl = useThree((state) => state.gl);
  const group = reactExports.useRef(null);
  const rootRef = reactExports.useRef(null);
  const target = (portal == null ? void 0 : portal.current) != null ? portal.current : gl.domElement.parentNode;
  reactExports.useLayoutEffect(() => {
    if (!group.current || !target) return;
    const el = document.createElement("div");
    const root2 = rootRef.current = clientExports.createRoot(el);
    target.appendChild(el);
    return () => {
      root2.unmount();
      rootRef.current = null;
      target.removeChild(el);
    };
  }, [target]);
  reactExports.useLayoutEffect(() => {
    const root2 = rootRef.current;
    if (!root2) return;
    root2.render(
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref, className, children })
    );
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("group", { name, ...props, ref: group });
});
function estimateBytesUsed(geometry) {
  let mem = 0;
  for (let name in geometry.attributes) {
    const attr = geometry.getAttribute(name);
    mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
  }
  const indices = geometry.getIndex();
  mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
  return mem;
}
const addTextureUniforms = (id, texture) => {
  const repeatType = (wrap3) => {
    switch (wrap3) {
      case 1e3:
        return "RepeatWrapping";
      case 1001:
        return "ClampToEdgeWrapping";
      case 1002:
        return "MirroredRepeatWrapping";
      default:
        return "ClampToEdgeWrapping";
    }
  };
  const encodingType = (encoding) => {
    switch (encoding) {
      case 3e3:
        return "LinearEncoding";
      case 3001:
        return "sRGBEncoding";
      case 3002:
        return "RGBEEncoding";
      case 3003:
        return "LogLuvEncoding";
      case 3004:
        return "RGBM7Encoding";
      case 3005:
        return "RGBM16Encoding";
      case 3006:
        return "RGBDEncoding";
      case 3007:
        return "GammaEncoding";
      default:
        return "ClampToEdgeWrapping";
    }
  };
  return {
    name: id,
    url: texture.image.currentSrc,
    encoding: encodingType(texture.encoding),
    wrapT: repeatType(texture.wrapT),
    flipY: texture.flipY.toString()
  };
};
const UniformsGL = ({ program, material, setTexNumber }) => {
  const gl = usePerf((state) => state.gl);
  const [uniforms, set] = reactExports.useState(null);
  reactExports.useEffect(() => {
    if (gl) {
      const data = program == null ? void 0 : program.getUniforms();
      let TexCount = 0;
      const format = /* @__PURE__ */ new Map();
      data.seq.forEach((e2) => {
        if (!e2.id.includes("uTroika") && e2.id !== "isOrthographic" && e2.id !== "uvTransform" && e2.id !== "lightProbe" && e2.id !== "projectionMatrix" && e2.id !== "viewMatrix" && e2.id !== "normalMatrix" && e2.id !== "modelMatrix" && e2.id !== "modelViewMatrix") {
          let values = [];
          let data2 = {
            name: e2.id
          };
          if (e2.cache) {
            e2.cache.forEach((v3) => {
              if (typeof v3 !== "undefined") {
                values.push(v3.toString().substring(0, 4));
              }
            });
            data2.value = values.join();
            if (material[e2.id] && material[e2.id].image) {
              if (material[e2.id].image) {
                TexCount++;
                data2.value = addTextureUniforms(e2.id, material[e2.id]);
              }
            }
            if (!data2.value) {
              data2.value = "empty";
            }
            format.set(e2.id, data2);
          }
        }
      });
      if (material.uniforms) {
        Object.keys(material.uniforms).forEach((key) => {
          const uniform = material.uniforms[key];
          if (uniform.value) {
            const { value } = uniform;
            let data2 = {
              name: key
            };
            if (key.includes("uTroika")) {
              return;
            }
            if (value.isTexture) {
              TexCount++;
              data2.value = addTextureUniforms(key, value);
            } else {
              let sb = JSON.stringify(value);
              try {
                sb = JSON.stringify(value);
              } catch (_err) {
                sb = value.toString();
              }
              data2.value = sb;
            }
            format.set(key, data2);
          }
        });
      }
      if (TexCount > 0) {
        setTexNumber(TexCount);
      }
      set(format);
    }
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ProgramsUL, { children: uniforms && Array.from(uniforms.values()).map((uniform) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: typeof uniform.value === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
      uniform.name,
      " :",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsxs("b", { children: [
        uniform.value.substring(0, 30),
        uniform.value.length > 30 ? "..." : ""
      ] })
    ] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("b", { children: [
        uniform.value.name,
        ":"
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        Object.keys(uniform.value).map((key) => {
          return key !== "name" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: key === "url" ? /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: uniform.value[key], target: "_blank", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: uniform.value[key] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
            key,
            ": ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: uniform.value[key] })
          ] }) }, key) : null;
        }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          ProgramConsole,
          {
            onClick: () => {
              var _a2;
              console.info(
                material[uniform.value.name] || ((_a2 = material == null ? void 0 : material.uniforms[uniform.value.name]) == null ? void 0 : _a2.value)
              );
            },
            children: [
              "console.info(",
              uniform.value.name,
              ");"
            ]
          }
        )
      ] })
    ] }) }, uniform.name);
  }) });
};
const DynamicDrawCallInfo = ({ el }) => {
  usePerf((state) => state.log);
  const gl = usePerf((state) => state.gl);
  const getVal = (el2) => {
    if (!gl) return 0;
    const res = Math.round(
      el2.drawCounts.total / (gl.info.render.triangles + gl.info.render.lines + gl.info.render.points) * 100 * 10
    ) / 10;
    return isFinite(res) && res || 0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: el.drawCounts.total > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { style: { height: "auto", width: "auto", margin: "0 4px" }, children: [
    el.drawCounts.type === "Triangle" ? /* @__PURE__ */ jsxRuntimeExports.jsx(VercelLogoIcon, { style: { top: "-1px" } }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ActivityLogIcon, { style: { top: "-1px" } }),
    el.drawCounts.total,
    /* @__PURE__ */ jsxRuntimeExports.jsxs("small", { children: [
      el.drawCounts.type,
      "s"
    ] }),
    gl && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      PerfB,
      {
        style: { bottom: "-10px", width: "40px", fontWeight: "bold" },
        children: [
          el.visible && !el.material.wireframe ? getVal(el) : 0,
          "%"
        ]
      }
    )
  ] }) });
};
const ProgramUI = ({ el }) => {
  const [showProgram, setShowProgram] = reactExports.useState(el.visible);
  const [toggleProgram, set] = reactExports.useState(el.expand);
  const [texNumber, setTexNumber] = reactExports.useState(0);
  const { meshes, program, material } = el;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ProgramGeo, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ProgramHeader,
      {
        onClick: () => {
          el.expand = !toggleProgram;
          Object.keys(meshes).forEach((key) => {
            const mesh = meshes[key];
            mesh.material.wireframe = false;
          });
          set(!toggleProgram);
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Toggle, { style: { marginRight: "6px" }, children: toggleProgram ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TriangleDownIcon, {}) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TriangleUpIcon, {}) }) }),
          program && /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ProgramTitle, { children: program.name }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { style: { height: "auto", width: "auto", margin: "0 4px" }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(LayersIcon, { style: { top: "-1px" } }),
              Object.keys(meshes).length,
              /* @__PURE__ */ jsxRuntimeExports.jsx("small", { children: Object.keys(meshes).length > 1 ? "users" : "user" })
            ] }),
            texNumber > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { style: { height: "auto", width: "auto", margin: "0 4px" }, children: [
              texNumber > 1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ImageIcon, { style: { top: "-1px" } }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ImageIcon, { style: { top: "-1px" } }),
              texNumber,
              /* @__PURE__ */ jsxRuntimeExports.jsx("small", { children: "tex" })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicDrawCallInfo, { el }),
            material.glslVersion === "300 es" && /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { style: { height: "auto", width: "auto", margin: "0 4px" }, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(RocketIcon, { style: { top: "-1px" } }),
              "300",
              /* @__PURE__ */ jsxRuntimeExports.jsx("small", { children: "es" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { style: { bottom: "-10px", width: "40px" }, children: "glsl" })
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ToggleVisible,
            {
              onPointerEnter: () => {
                Object.keys(meshes).forEach((key) => {
                  const mesh = meshes[key];
                  mesh.material.wireframe = true;
                });
              },
              onPointerLeave: () => {
                Object.keys(meshes).forEach((key) => {
                  const mesh = meshes[key];
                  mesh.material.wireframe = false;
                });
              },
              onClick: (e2) => {
                e2.stopPropagation();
                Object.keys(meshes).forEach((key) => {
                  const mesh = meshes[key];
                  const invert = !showProgram;
                  mesh.visible = invert;
                  el.visible = invert;
                  setShowProgram(invert);
                });
              },
              children: showProgram ? /* @__PURE__ */ jsxRuntimeExports.jsx(EyeOpenIcon, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(EyeNoneIcon, {})
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        style: { maxHeight: toggleProgram ? "9999px" : 0, overflow: "hidden" },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ProgramsULHeader, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonIcon, {}),
            " Uniforms:"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            UniformsGL,
            {
              program,
              material,
              setTexNumber
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(ProgramsULHeader, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(CubeIcon, {}),
            " Geometries:"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ProgramsUL, { children: meshes && Object.keys(meshes).map(
            (key) => meshes[key] && meshes[key].geometry && /* @__PURE__ */ jsxRuntimeExports.jsxs(ProgramsGeoLi, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
                meshes[key].geometry.type,
                ": "
              ] }),
              meshes[key].userData && meshes[key].userData.drawCount && /* @__PURE__ */ jsxRuntimeExports.jsxs("b", { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                  meshes[key].userData.drawCount.count,
                  /* @__PURE__ */ jsxRuntimeExports.jsxs("small", { children: [
                    " ",
                    meshes[key].userData.drawCount.type,
                    "s"
                  ] })
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
                /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                  Math.round(
                    estimateBytesUsed(meshes[key].geometry) / 1024 * 1e3
                  ) / 1e3,
                  "Kb",
                  /* @__PURE__ */ jsxRuntimeExports.jsx("small", { children: " memory used" })
                ] })
              ] })
            ] }, key)
          ) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            ProgramConsole,
            {
              onClick: () => {
                console.info(material);
              },
              children: [
                "console.info(",
                material.type,
                ")"
              ]
            }
          )
        ]
      }
    )
  ] });
};
const ProgramsUI = () => {
  usePerf((state) => state.triggerProgramsUpdate);
  const programs = usePerf((state) => state.programs);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ProgramsContainer, { children: programs && Array.from(programs.values()).map((el) => {
    if (!el) {
      return null;
    }
    return el ? /* @__PURE__ */ jsxRuntimeExports.jsx(ProgramUI, { el }, el.material.uuid) : null;
  }) });
};
const colorsGraph = (colorBlind) => {
  const colors3 = {
    overClock: `#ff6eff`,
    fps: colorBlind ? "100, 143, 255" : "238,38,110",
    cpu: colorBlind ? "254, 254, 98" : "66,226,46",
    gpu: colorBlind ? "254,254,254" : "253,151,31",
    custom: colorBlind ? "86,180,233" : "40,255,255"
  };
  return colors3;
};
const DynamicUIPerf = ({ showGraph, colorBlind }) => {
  const overclockingFps = usePerf((s2) => s2.overclockingFps);
  const fpsLimit = usePerf((s2) => s2.fpsLimit);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    PerfB,
    {
      style: showGraph ? {
        color: overclockingFps ? colorsGraph(colorBlind).overClock.toString() : `rgb(${colorsGraph(colorBlind).fps})`
      } : {},
      children: [
        "FPS ",
        overclockingFps ? `${fpsLimit}🚀` : ""
      ]
    }
  );
};
const DynamicUI = ({ showGraph, colorBlind, customData, minimal }) => {
  const gl = usePerf((state) => state.gl);
  return gl ? /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfIContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LightningBoltIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        PerfB,
        {
          style: showGraph ? {
            color: `rgb(${colorsGraph(colorBlind).gpu.toString()})`
          } : {},
          children: "GPU"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfSmallI, { children: "ms" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(RulerHorizontalIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        PerfB,
        {
          style: showGraph ? {
            color: `rgb(${colorsGraph(colorBlind).cpu.toString()})`
          } : {},
          children: "CPU"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfSmallI, { children: "ms" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LapTimerIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicUIPerf, { showGraph, colorBlind })
    ] }),
    !minimal && gl && /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextAlignJustifyIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { children: gl.info.render.calls === 1 ? "call" : "calls" })
    ] }),
    !minimal && gl && /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VercelLogoIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { children: "Triangles" })
    ] }),
    customData && /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BarChartIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { style: showGraph ? { color: `rgb(${colorsGraph(colorBlind).custom})` } : {}, children: customData.name }),
      customData.info && /* @__PURE__ */ jsxRuntimeExports.jsx(PerfSmallI, { children: customData.info })
    ] })
  ] }) : null;
};
const PerfUI = ({
  showGraph,
  colorBlind,
  deepAnalyze,
  customData,
  matrixUpdate,
  openByDefault,
  minimal
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicUI, { showGraph, colorBlind, customData, minimal }),
    !minimal && /* @__PURE__ */ jsxRuntimeExports.jsx(
      PerfThree,
      {
        matrixUpdate,
        openByDefault,
        deepAnalyze,
        showGraph
      }
    )
  ] });
};
const InfoUI = ({ matrixUpdate }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(MarginIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { children: "Geometries" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ImageIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { children: "Textures" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ActivityLogIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { children: "shaders" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(MinusIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { children: "Lines" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DotIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { children: "Points" })
    ] }),
    matrixUpdate && /* @__PURE__ */ jsxRuntimeExports.jsxs(PerfI, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownMenuIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PerfB, { children: "Matrices" })
    ] })
  ] });
};
const ToggleEl = ({ tab, title, set }) => {
  const tabStore = usePerf((s2) => s2.tab);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Toggle,
    {
      className: `${tabStore === tab ? " __perf_toggle_tab_active" : ""}`,
      onClick: () => {
        set(true);
        setPerf({ tab });
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: title })
    }
  );
};
const PerfThree = ({ openByDefault, showGraph, deepAnalyze, matrixUpdate }) => {
  const [show, set] = React.useState(openByDefault);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TabContainers, { show, showGraph, matrixUpdate }),
    openByDefault && !deepAnalyze ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(ToggleContainer, { className: "__perf_toggle", children: [
      deepAnalyze && /* @__PURE__ */ jsxRuntimeExports.jsx(ToggleEl, { tab: "programs", title: "Programs", set }),
      deepAnalyze && /* @__PURE__ */ jsxRuntimeExports.jsx(ToggleEl, { tab: "infos", title: "Infos", set }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Toggle,
        {
          onClick: () => {
            set(!show);
          },
          children: show ? /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(TriangleDownIcon, {}),
            " Minimize"
          ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(TriangleUpIcon, {}),
            " More"
          ] })
        }
      )
    ] })
  ] });
};
const TabContainers = ({ show, showGraph, matrixUpdate }) => {
  const tab = usePerf((state) => state.tab);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InfoUI, { matrixUpdate }),
    show && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerScroll, { style: { marginTop: showGraph ? "38px" : 0 }, children: tab === "programs" && /* @__PURE__ */ jsxRuntimeExports.jsx(ProgramsUI, {}) }) })
  ] });
};
const Perf = ({
  showGraph = true,
  colorBlind = false,
  openByDefault = true,
  className,
  overClock = false,
  style,
  position = "top-right",
  chart,
  logsPerSecond,
  deepAnalyze = false,
  antialias = true,
  customData,
  matrixUpdate,
  minimal
}) => {
  const perfContainerRef = reactExports.useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PerfHeadless,
      {
        logsPerSecond,
        chart,
        overClock,
        deepAnalyze,
        matrixUpdate
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlMinimal, { name: "r3f-perf", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      PerfS,
      {
        className: (className ? " ".concat(className) : " ") + ` ${position ? position : ""} ${minimal ? "minimal" : ""}`,
        style: { minHeight: minimal ? "37px" : showGraph ? "100px" : "60px", ...style },
        ref: perfContainerRef,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            ChartUI,
            {
              perfContainerRef,
              colorBlind,
              chart,
              showGraph,
              antialias,
              customData,
              minimal,
              matrixUpdate
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            PerfUI,
            {
              colorBlind,
              showGraph,
              deepAnalyze,
              openByDefault,
              customData,
              matrixUpdate,
              minimal
            }
          )
        ]
      }
    ) })
  ] });
};
const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string) => string.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (match, p1, p22) => p22 ? p22.toUpperCase() : p1.toLowerCase()
);
const toPascalCase = (string) => {
  const camelCase = toCamelCase(string);
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();
const hasA11yProp = (props) => {
  for (const prop in props) {
    if (prop.startsWith("aria-") || prop === "role" || prop === "title") {
      return true;
    }
  }
};
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const Icon = reactExports.forwardRef(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => reactExports.createElement(
    "svg",
    {
      ref,
      ...defaultAttributes,
      width: size,
      height: size,
      stroke: color,
      strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
      className: mergeClasses("lucide", className),
      ...!children && !hasA11yProp(rest) && { "aria-hidden": "true" },
      ...rest
    },
    [
      ...iconNode.map(([tag, attrs]) => reactExports.createElement(tag, attrs)),
      ...Array.isArray(children) ? children : [children]
    ]
  )
);
const createLucideIcon = (iconName, iconNode) => {
  const Component = reactExports.forwardRef(
    ({ className, ...props }, ref) => reactExports.createElement(Icon, {
      ref,
      iconNode,
      className: mergeClasses(
        `lucide-${toKebabCase(toPascalCase(iconName))}`,
        `lucide-${iconName}`,
        className
      ),
      ...props
    })
  );
  Component.displayName = toPascalCase(iconName);
  return Component;
};
const __iconNode$1 = [
  [
    "path",
    {
      d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
      key: "edeuup"
    }
  ]
];
const MousePointer2 = createLucideIcon("mouse-pointer-2", __iconNode$1);
const __iconNode = [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
];
const Mouse = createLucideIcon("mouse", __iconNode);
const TUTORIAL_STEPS = [
  {
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Mouse, { className: "text-blue-400 animate-pulse" }),
    title: "Scroll to Move",
    description: "Scroll your page to move through the experience."
  },
  {
    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(MousePointer2, { className: "text-green-400" }),
    title: "Interact with Items",
    description: "Click on highlighted items to view more details or play media."
  }
];
function Xyz3D() {
  const isDebugging = isDebugMode;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(HelmetProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(WebCrafterProvider, { isDebugging, children: /* @__PURE__ */ jsxRuntimeExports.jsx(WebCrafterApp, {}) }) });
}
function WebCrafterApp() {
  const { isLoaded, isDebugging, siteData } = useWebCrafter();
  const sections = siteData?.sections;
  const fontSize = siteData?.fontSize;
  const ContextBridge = useContextBridge(WebCrafterContext);
  const [showPopup, setShowPopup] = reactExports.useState(false);
  const popupContent = "https://google.com";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "absolute inset-0 bg-base-300", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Canvas2, { shadows: true, dpr: [1, 2], gl: { alpha: false }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ContextBridge, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(reactExports.Suspense, { fallback: null, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ScrollControls, { pages: sections?.length || 5, damping: 0.3, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SceneXyz3D,
          {
            path: "assets/scene.glb",
            isDebugging,
            setShowPopup,
            sections
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Scroll, { html: true, className: "w-full pointer-events-none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StudioOverlay, { sections, fontSize }) })
      ] }) }),
      isDebugging && /* @__PURE__ */ jsxRuntimeExports.jsx(Perf, {})
    ] }) }),
    !isLoaded && /* @__PURE__ */ jsxRuntimeExports.jsx(ProgressLoader, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      HtmlOverlay,
      {
        content: popupContent,
        showPopup,
        setShowPopup
      }
    ),
    isLoaded && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SplashScreen,
        {
          tutorial: TUTORIAL_STEPS,
          title: "Welcome",
          body: "Explore your 3D Link in Bio.",
          buttonText: "Enter"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Seo, {})
    ] })
  ] });
}
function App() {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    false,
    /* @__PURE__ */ jsxRuntimeExports.jsx(Xyz3D, {})
  ] });
}
const root = clientExports.createRoot(document.getElementById("root"));
root.render(/* @__PURE__ */ jsxRuntimeExports.jsx(App, {}));
//# sourceMappingURL=index.js.map
